export default `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" viewBox="0 0 630 630" enable-background="new 0 0 630 630" xml:space="preserve">
<path fill="#F6FBFB" opacity="1.000000" stroke="none" 
	d="
M630.645752,92.776672 
	C631.000000,262.354218 631.000000,431.708466 631.000000,601.531372 
	C629.221008,605.079102 629.878174,608.280701 630.761597,611.740845 
	C631.000000,613.388916 631.000000,614.777771 631.000000,616.583374 
	C626.247925,622.766724 620.063965,624.923462 612.681641,625.662476 
	C604.077759,626.523804 595.447998,626.400757 586.845642,627.057922 
	C580.333069,627.555420 573.656799,627.368835 567.053162,627.394470 
	C552.401001,627.451294 537.746887,627.553711 523.096558,627.380066 
	C499.496368,627.100342 475.899078,627.746521 452.299713,627.424011 
	C438.512756,627.235657 424.807373,625.450684 411.014526,625.406250 
	C409.505402,625.401367 407.872192,625.167969 406.727295,624.237671 
	C402.037781,620.427185 396.769318,621.362183 391.470459,622.030762 
	C388.210266,622.442139 384.853790,623.351440 381.671692,620.611938 
	C381.236115,619.034607 381.558289,618.081726 383.005402,617.354614 
	C384.408783,617.071350 385.539215,617.326355 386.810425,616.578491 
	C387.687836,616.197754 388.311127,616.113953 389.259705,616.119263 
	C390.183990,616.144470 390.785400,616.092773 391.626831,615.686462 
	C392.288788,615.404419 392.684631,615.303467 393.391907,615.230957 
	C394.275879,615.169861 394.850067,615.084290 395.644226,614.680481 
	C396.279785,614.404114 396.664398,614.309448 397.358276,614.239075 
	C398.722412,614.256165 399.590515,613.716370 400.800842,613.130371 
	C402.296173,612.707642 403.501099,612.648376 405.099487,612.599854 
	C413.503784,612.188171 420.888580,608.750183 428.925171,608.060486 
	C439.266296,607.173035 449.043732,608.163696 458.618195,612.273132 
	C463.756836,614.478760 468.841431,611.834106 473.552826,610.283936 
	C478.397369,608.689819 482.853241,606.686157 487.956940,608.810974 
	C488.726593,609.131409 489.766449,609.267029 490.392700,608.798035 
	C494.816040,605.485718 499.066437,607.868774 503.193054,609.291321 
	C507.340698,610.721130 511.465515,611.687927 515.870300,611.618530 
	C519.204285,611.566040 522.751953,611.744690 525.739014,612.849792 
	C537.222412,617.098022 548.825989,613.796570 560.352234,614.203186 
	C569.963806,614.542297 579.633911,613.155212 589.196716,615.163940 
	C593.722351,616.114624 598.129395,614.783813 602.550354,614.050049 
	C605.126648,613.622375 605.894897,612.203491 604.831055,609.770752 
	C604.090881,608.078247 603.611145,606.295776 603.800903,604.428406 
	C604.120728,601.282043 605.342163,599.218079 609.031677,599.033691 
	C614.487244,598.760986 614.805542,598.163391 614.709290,592.695435 
	C614.545532,583.396118 615.804504,574.259155 617.570618,565.137756 
	C619.346802,555.964905 617.656860,546.360962 619.730652,537.347961 
	C622.170837,526.742981 620.098633,516.531677 619.442627,506.151428 
	C619.336060,504.465942 619.113159,502.649506 617.930237,501.474792 
	C614.307129,497.876617 614.740906,493.907471 615.932617,489.449005 
	C616.957886,485.613617 617.231750,481.551910 616.291870,477.575500 
	C615.779297,475.406952 615.989990,473.283936 616.298645,471.132172 
	C616.855286,467.252686 616.633423,463.348541 614.806458,459.904877 
	C612.222351,455.033905 612.367798,449.925201 614.421509,445.415039 
	C617.591919,438.452942 616.262146,431.322510 616.151733,424.371277 
	C616.004456,415.095886 614.899170,405.809326 614.354248,396.123657 
	C613.954102,394.168701 614.345581,392.651245 614.637939,390.753723 
	C614.754150,389.900024 614.843140,389.419403 615.039307,388.595398 
	C615.302429,387.566101 615.548706,386.901794 615.686890,385.849182 
	C615.803467,384.788239 615.927307,384.085144 616.129150,383.025269 
	C616.770691,380.274475 617.691895,377.954132 617.717163,375.057007 
	C617.788086,374.141846 617.865356,373.618011 618.061890,372.698364 
	C620.422852,362.446350 620.903870,352.371429 621.993896,341.963501 
	C622.953247,339.944366 623.930420,338.356598 623.530396,335.993256 
	C622.360596,331.050140 622.476074,326.440521 622.874268,321.443787 
	C623.747620,319.537323 624.296448,317.999023 622.998535,316.025940 
	C622.389954,309.478088 622.539062,303.295776 622.711548,296.716553 
	C623.075317,294.648773 623.969910,292.954895 622.394653,291.018066 
	C621.526184,288.756226 621.632019,286.772186 621.853210,284.436157 
	C622.171753,282.829803 622.665833,281.556091 621.503174,280.088013 
	C620.993286,278.954041 620.933411,278.074188 621.057190,276.851929 
	C621.313904,275.497833 621.719238,274.481415 621.211670,273.103943 
	C620.745422,271.541138 620.324402,270.297333 620.256226,268.654541 
	C620.418701,267.134583 620.861877,265.910156 619.793213,264.540100 
	C619.463501,263.897400 619.346191,263.503540 619.256897,262.788879 
	C619.231140,261.656158 619.020020,260.884552 618.491333,259.862793 
	C618.268250,259.118439 618.230103,258.670074 618.278687,257.863831 
	C618.697693,256.077209 618.748535,254.595535 619.017273,252.748810 
	C618.700806,245.071136 617.920105,237.857285 616.544189,230.658371 
	C615.411072,224.729675 617.345764,218.780884 618.354614,212.956558 
	C619.195801,208.099686 619.617310,203.342941 618.545532,198.651199 
	C617.538086,194.240616 618.410645,190.504166 620.575195,186.742279 
	C626.086365,177.164291 626.903748,167.348740 623.478027,156.629242 
	C621.439575,150.250778 621.001343,143.021530 622.017151,136.409729 
	C622.899841,130.664917 622.035095,125.591499 620.565491,120.334717 
	C618.495117,112.928818 619.398682,105.775803 622.712280,98.989471 
	C624.223572,95.894562 626.207642,92.854744 630.645752,92.776672 
z"/>
<path fill="#F7FCFC" opacity="1.000000" stroke="none" 
	d="
M136.344223,630.742188 
	C114.312439,631.000000 92.624878,631.000000 70.468658,631.000000 
	C63.884415,629.672119 57.768219,628.365906 51.277962,630.741028 
	C50.250000,631.000000 49.500000,631.000000 48.375000,631.000000 
	C47.575691,630.483215 47.056206,630.316589 46.211121,630.785583 
	C34.645771,631.000000 23.291544,631.000000 11.468657,631.000000 
	C7.355248,626.646729 6.736292,621.346191 6.445067,615.999878 
	C5.258169,594.210815 5.415731,572.398132 5.394957,550.588867 
	C5.382743,537.767334 5.241000,524.962830 4.543978,512.139893 
	C3.804937,498.543915 5.624106,484.900116 4.436333,471.254486 
	C3.047265,455.296295 4.077931,439.359467 4.897034,423.395294 
	C5.193921,417.609009 5.132306,411.875702 6.100931,406.093964 
	C6.948722,401.033417 6.511789,395.808472 5.856837,390.650452 
	C5.336719,386.554352 4.618474,382.369812 6.916455,378.078674 
	C11.820112,378.333954 10.857786,381.951569 11.156105,385.284637 
	C9.584988,392.148193 12.731682,398.126923 12.931180,404.412079 
	C13.020767,407.234467 13.351576,410.011230 12.860987,412.829407 
	C9.273765,433.435852 8.549459,454.137512 10.265780,474.993256 
	C10.891229,482.593292 10.899891,490.288391 9.750516,497.919708 
	C8.520676,506.085205 10.021174,514.238708 10.686735,522.312500 
	C11.922055,537.298035 10.956072,552.268372 11.520252,567.227234 
	C11.952576,578.690063 12.253288,590.153320 12.564055,601.618591 
	C12.716407,607.239380 16.019838,611.952515 17.964386,617.022949 
	C19.132427,620.068604 25.188118,620.498474 30.352062,618.396179 
	C33.935024,616.937622 37.597469,615.183228 41.411411,616.062134 
	C45.372017,616.974731 49.321548,616.891479 53.276955,617.235718 
	C56.759388,617.538696 60.380108,618.676880 63.675766,618.184082 
	C72.143051,616.917786 80.666550,616.985962 89.110062,616.155029 
	C95.619362,615.514465 101.869270,612.410767 108.695305,613.624268 
	C109.177376,613.709961 109.781960,613.655151 110.153885,613.381287 
	C115.284882,609.603210 120.901192,611.997864 125.987663,612.851440 
	C131.790558,613.825256 136.790146,612.626221 141.896332,610.617737 
	C143.448318,610.007080 144.927200,609.089050 146.634109,609.227844 
	C151.104660,609.591125 154.354279,607.961487 156.442383,603.889832 
	C157.216553,602.380310 158.766586,600.882263 160.468140,601.674133 
	C163.531937,603.099915 165.768967,601.657837 168.402130,600.580688 
	C172.713745,598.817017 177.456848,598.770996 181.588470,600.651428 
	C193.533051,606.087769 206.380096,608.128052 219.325195,611.396301 
	C220.773468,611.586670 221.833527,611.630676 223.204742,612.073730 
	C226.400223,614.188538 229.156906,616.430176 233.351608,615.379761 
	C234.126236,615.239014 234.571304,615.222046 235.336121,615.327087 
	C236.427933,615.688904 237.132568,616.180786 238.314285,616.215637 
	C240.098480,616.127258 241.617477,616.998047 243.321167,615.801270 
	C243.812820,615.525696 244.018158,615.428162 244.552368,615.232727 
	C245.108627,615.105042 245.336044,615.075256 245.907776,615.058777 
	C246.704803,615.157654 247.132996,615.311340 247.783707,615.766235 
	C248.537766,617.908752 250.184662,618.242065 251.748413,618.752380 
	C253.150879,619.210083 254.680328,619.650879 254.076385,622.024292 
	C251.336685,624.494873 248.388962,624.392151 245.366180,623.919434 
	C240.017090,623.082764 234.772430,623.416321 229.671204,625.342834 
	C227.629288,626.113953 225.490784,626.289734 223.331177,626.499817 
	C206.184525,628.167908 188.884750,627.071655 171.772552,629.384705 
	C169.644653,629.672302 167.429901,629.691895 165.310303,629.313538 
	C155.672974,627.593201 146.249634,630.663757 136.344223,630.742188 
z"/>
<path fill="#F5FAFA" opacity="1.000000" stroke="none" 
	d="
M631.000000,92.531342 
	C623.716248,95.574898 622.370239,102.219620 621.151123,108.438698 
	C619.855530,115.048126 622.014832,121.490608 624.232117,127.716225 
	C624.699829,129.029541 625.280579,130.256119 624.646423,131.507095 
	C620.622925,139.444153 622.960205,148.178391 624.770325,155.365112 
	C626.670288,162.908813 626.670410,169.711639 626.100952,177.033508 
	C625.840088,180.387054 624.615173,183.093307 622.821960,185.727905 
	C619.920959,189.989883 618.582458,194.241531 620.156982,199.683746 
	C621.376160,203.897644 620.874756,208.460632 619.734680,213.102097 
	C617.633240,221.657654 617.030823,230.555969 619.290039,239.298553 
	C620.417175,243.660583 619.696411,248.141449 620.277100,252.747925 
	C618.409119,253.467896 617.669922,252.227722 616.530090,251.032928 
	C615.891418,249.669739 615.854187,248.603104 616.029968,247.118622 
	C616.697937,244.763321 617.133057,242.584793 616.208923,240.840622 
	C612.265686,233.398819 612.846130,224.993607 610.858704,217.149506 
	C610.408081,215.370728 610.077759,213.557846 609.185852,211.935074 
	C607.655151,209.149948 607.603271,206.574020 610.008484,204.200058 
	C611.614807,202.614548 612.245422,200.576111 612.665466,198.397415 
	C614.415527,189.319824 617.511841,180.447647 617.157043,171.047760 
	C616.827515,162.315689 618.114136,153.472260 614.603149,144.958954 
	C612.791626,140.566223 613.031555,135.832733 615.062622,131.335693 
	C617.058289,126.917107 617.219788,122.695107 615.404541,117.882126 
	C612.294250,109.635353 613.664856,101.237175 616.858826,93.187325 
	C617.530396,91.494759 618.553162,89.916588 618.779602,88.082443 
	C620.096741,77.414284 622.615051,66.964920 621.407349,55.926224 
	C620.708557,49.538963 620.585571,42.581223 623.418518,36.246349 
	C624.051697,34.830547 624.275085,33.273167 623.521179,31.884193 
	C621.006226,27.250885 620.265625,22.118011 619.189514,17.079432 
	C618.339966,13.101881 616.168701,10.460507 612.021118,9.765779 
	C599.201965,7.618541 586.395935,5.579762 574.145630,12.269279 
	C570.452087,14.286212 566.614380,14.857253 562.659363,12.885386 
	C561.916321,12.514909 560.822815,12.021029 560.274963,12.452508 
	C556.002075,15.818140 550.398315,14.466842 545.883850,16.634306 
	C543.561401,17.749359 541.585754,17.850840 539.220093,17.121487 
	C522.600159,11.997323 505.898987,12.675326 488.893921,15.448035 
	C482.006042,16.571114 474.695465,16.380789 467.568329,16.399509 
	C463.707031,16.409651 459.925507,16.584372 456.302917,18.123959 
	C454.435333,18.917688 452.430664,19.159153 450.416412,18.793365 
	C443.010101,17.448366 435.475037,19.869766 428.057922,17.943012 
	C426.058014,17.423492 424.538239,18.652727 424.222809,20.888834 
	C424.015869,22.355898 424.165527,23.916340 422.742065,25.382126 
	C417.685486,26.534149 413.380524,24.562027 409.016388,23.445269 
	C404.270203,22.230755 399.571594,20.789175 394.413208,19.518345 
	C393.187378,19.428320 392.381866,19.273985 391.173767,19.013000 
	C386.265137,16.934052 380.576904,17.929682 376.868256,13.073145 
	C374.764343,7.564568 375.378754,6.199663 380.900818,5.323871 
	C396.878906,2.789762 412.978912,2.104467 429.140564,2.556899 
	C456.045532,3.310083 482.933258,3.766347 509.867004,2.877679 
	C523.888000,2.415062 537.984802,1.984627 552.123474,3.657317 
	C559.948547,4.583063 568.251038,2.813164 576.632690,1.269996 
	C593.782715,1.000000 610.567017,1.118662 627.346863,0.899435 
	C630.685120,0.855821 631.074707,1.920219 631.064148,4.825906 
	C630.958679,33.904530 631.000000,62.983681 631.000000,92.531342 
z"/>
<path fill="#F8FCFD" opacity="1.000000" stroke="none" 
	d="
M1.354063,310.260742 
	C1.000000,208.428833 1.020940,106.857635 0.911413,5.286585 
	C0.907647,1.793524 1.489529,0.879625 5.205872,0.891469 
	C55.824409,1.052787 106.443634,1.000000 157.531342,1.000000 
	C158.859085,4.456332 156.147125,4.812103 154.007645,5.240886 
	C151.078720,5.827885 148.016769,6.438141 145.091034,6.222528 
	C131.293060,5.205674 117.562828,7.076496 103.747932,6.698061 
	C74.691368,5.902109 45.615665,6.981668 16.554279,7.690479 
	C10.288271,7.843307 8.735229,9.607351 8.635796,16.011673 
	C8.527197,23.006224 8.805856,30.014212 8.446434,36.996632 
	C7.763448,50.264881 8.709260,63.528358 8.370273,76.783470 
	C7.515962,110.188728 8.576879,143.588745 8.751905,176.986603 
	C8.808869,187.856094 8.665001,198.928787 10.866121,210.196106 
	C13.457614,220.312729 12.332808,229.995636 10.884364,239.656082 
	C10.537767,241.967728 10.327714,244.234360 10.744530,246.948029 
	C11.141088,248.417404 11.171085,249.496140 10.938780,250.948608 
	C9.932267,253.147705 8.820557,254.943512 9.799847,257.462372 
	C10.167033,258.442963 10.391676,259.107239 10.670685,260.128967 
	C10.698271,262.855377 10.264538,265.194702 9.980224,267.887207 
	C9.638477,269.030579 9.033236,269.715149 9.059271,270.925232 
	C9.286263,271.860321 9.508212,272.470917 9.834089,273.410645 
	C10.338785,275.672424 10.062260,277.508667 8.991963,279.559509 
	C7.732158,281.095978 7.088570,282.432404 7.950286,284.439911 
	C8.217349,285.530853 8.294614,286.286224 8.400253,287.449890 
	C8.639054,292.410248 8.316475,296.962433 8.391218,301.946381 
	C8.366209,303.239990 8.338735,304.102875 8.104252,305.381165 
	C7.554559,307.167786 7.278466,308.600372 6.216076,310.168518 
	C4.514851,311.249084 3.115415,311.289703 1.354063,310.260742 
z"/>
<path fill="#F8FCFD" opacity="1.000000" stroke="none" 
	d="
M136.468658,631.000000 
	C136.266479,628.887146 137.851852,629.021118 139.371475,628.998230 
	C144.476822,628.921387 149.568344,629.410583 154.540131,627.232910 
	C156.491531,626.378296 159.295105,626.541443 161.423859,627.186829 
	C168.921112,629.459961 176.241058,626.761414 183.643707,626.814697 
	C190.332047,626.862915 197.039139,626.491089 203.712006,625.971130 
	C212.876160,625.257202 222.187592,626.235962 231.167221,623.199341 
	C236.079010,621.538330 241.267838,621.286682 246.359070,622.677429 
	C249.000488,623.398987 251.244781,622.488037 253.778564,621.222412 
	C258.606415,619.195557 263.053162,620.944275 267.940430,621.530518 
	C268.839050,621.606506 269.345917,621.656250 270.213379,621.774170 
	C272.151459,622.149536 273.676239,622.929993 275.695740,622.283325 
	C276.510895,622.120605 276.985626,622.084045 277.824524,622.123535 
	C278.419556,622.226135 278.653564,622.290588 279.218445,622.505676 
	C281.702606,624.220154 284.200867,623.522522 286.943085,623.739014 
	C287.845856,623.792969 288.363770,623.860352 289.276733,624.032837 
	C293.525116,624.986389 297.436127,624.307129 301.734558,624.566284 
	C308.142303,624.252686 314.163269,625.070374 320.529053,623.964233 
	C323.677826,624.276733 326.435822,625.367920 329.465942,623.584351 
	C330.505859,623.084351 331.249023,622.912537 332.381714,622.762451 
	C333.735046,622.678040 334.706970,622.763062 336.017761,622.960388 
	C337.856262,623.473755 339.347565,623.874023 340.993011,622.448120 
	C341.753967,622.099792 342.220245,621.966125 343.076111,621.815613 
	C344.510681,621.696411 345.557709,621.787903 347.006866,621.997864 
	C351.227478,623.039673 354.839172,621.400330 358.558502,621.122925 
	C360.690674,620.963989 362.769501,620.557129 365.290955,621.330078 
	C369.479584,623.523865 373.579559,622.484009 377.462372,622.392395 
	C386.025665,622.190002 394.381592,623.890015 402.793579,624.792664 
	C410.439301,625.613098 418.086060,625.629883 425.693787,625.822449 
	C441.278534,626.216919 456.810272,627.653564 472.457916,627.277893 
	C482.881195,627.027649 493.357544,626.892517 503.813232,626.943115 
	C525.740540,627.049194 547.672302,627.257141 569.596741,626.939026 
	C586.303467,626.696716 603.042053,626.827026 619.674316,624.604980 
	C623.179993,624.136597 626.462463,621.301941 630.626099,623.720337 
	C631.000000,631.000000 631.000000,631.000000 624.012207,631.000000 
	C461.653900,631.000000 299.295624,631.000000 136.468658,631.000000 
z"/>
<path fill="#F8FCFD" opacity="1.000000" stroke="none" 
	d="
M576.531372,1.000000 
	C575.966370,4.081980 573.204834,3.922128 570.852356,3.933824 
	C565.850525,3.958690 560.926514,4.084130 556.116028,5.756135 
	C554.221924,6.414453 552.237854,5.801909 550.256409,5.282633 
	C543.592712,3.536239 536.837585,3.330372 530.073303,4.809673 
	C526.374451,5.618593 522.937805,3.689867 519.225769,3.941170 
	C498.041199,5.375360 476.817505,5.094226 455.605621,4.954173 
	C443.249969,4.872594 430.897308,4.334602 418.543365,3.999630 
	C405.418854,3.643764 392.473236,5.557183 379.478851,6.956590 
	C373.639496,7.585450 378.378174,10.607554 377.953796,12.820202 
	C373.099304,16.074266 368.289734,13.315258 363.485626,12.995518 
	C361.373047,12.854911 359.241821,12.430385 356.712280,12.188705 
	C355.129883,11.838185 354.113464,10.983095 352.452332,11.086190 
	C350.346954,11.328986 348.597412,11.328320 346.462585,11.299313 
	C345.562500,11.254287 345.051147,11.188720 344.163300,11.013208 
	C341.314026,9.979405 338.652222,10.649860 335.779358,9.914444 
	C333.904694,8.851435 332.350067,8.179770 330.162292,9.110484 
	C325.255737,9.473193 320.740723,9.595555 315.828125,9.003824 
	C310.329651,6.502543 305.120026,6.957269 299.503906,8.457956 
	C298.325500,8.946441 297.488129,9.037265 296.205627,8.972967 
	C292.097534,8.039910 288.311981,8.719780 284.172729,8.099765 
	C273.623535,6.941134 263.607880,8.890633 253.532349,8.995481 
	C242.902695,9.106098 232.433395,11.621996 221.820938,11.448156 
	C212.055756,11.288196 202.337296,10.008300 192.732544,8.126892 
	C187.996094,7.199105 183.264771,6.362597 178.412476,6.542370 
	C174.226074,6.697473 170.120560,6.101599 166.096558,5.023737 
	C164.248627,4.528752 162.028336,4.357339 161.793823,1.402920 
	C300.020905,1.000000 438.041779,1.000000 576.531372,1.000000 
z"/>
<path fill="#F5FAFA" opacity="1.000000" stroke="none" 
	d="
M161.600006,1.000000 
	C164.918091,5.034998 169.857803,4.876378 173.541351,4.704364 
	C183.994858,4.216208 193.874557,7.282183 204.050583,8.310082 
	C215.694687,9.486272 227.084641,10.566562 238.859238,8.317060 
	C247.713516,6.625482 257.028992,7.107166 266.140167,7.088303 
	C271.920502,7.076336 277.596924,4.789297 283.708832,6.708063 
	C284.373352,7.412492 284.534668,7.896040 284.329926,8.814580 
	C283.349487,9.921290 282.342285,10.057674 280.922058,9.992281 
	C278.770325,9.497805 276.974365,8.936905 275.030579,10.554841 
	C273.792023,11.073102 272.836029,11.114511 271.509399,10.979991 
	C267.371582,9.682114 263.789307,10.672626 259.935486,12.084328 
	C259.233337,12.465586 258.806946,12.613171 258.031616,12.724383 
	C256.442596,12.613531 255.196213,12.607951 253.712952,13.258362 
	C253.206848,13.380448 253.000641,13.408853 252.487366,13.405478 
	C251.225540,13.018050 250.300217,12.807625 249.404663,14.088591 
	C248.798386,14.466166 248.406082,14.574378 247.687653,14.581903 
	C246.192596,14.301359 245.511108,15.116351 244.473694,16.008553 
	C241.416000,17.621996 238.523132,17.544447 235.191742,16.847046 
	C227.770859,15.436818 220.933533,16.841829 214.174301,18.439377 
	C210.439514,19.322094 206.978088,20.095285 204.027039,16.824633 
	C202.800034,15.464764 201.921783,16.031837 200.722916,17.063189 
	C196.176239,20.974583 192.571579,21.039595 188.717422,16.833088 
	C187.006042,14.965262 186.190598,14.989870 184.426041,16.518936 
	C181.951935,18.662868 178.602722,19.561712 176.575043,22.511509 
	C175.103790,24.651867 172.754257,24.119810 170.752625,22.834702 
	C168.757965,21.554081 167.295731,19.737930 165.939529,17.821251 
	C162.478745,12.930186 159.056595,12.071058 153.826416,14.916134 
	C152.419708,15.681342 151.030945,16.207172 149.565140,15.588456 
	C142.986679,12.811707 135.429993,14.191972 129.151199,11.740116 
	C119.888435,8.123034 110.687546,10.675114 101.595161,10.179848 
	C78.775887,8.936877 55.856564,10.561324 32.970844,10.540628 
	C28.487915,10.536574 24.054365,11.653046 19.537357,11.572663 
	C17.325985,11.533312 15.799190,12.662771 14.802515,14.640527 
	C13.590890,17.044821 12.569696,19.500652 12.542543,22.233658 
	C12.402369,36.342155 11.129619,50.395092 10.979628,64.535507 
	C10.820782,79.510704 12.094202,94.437157 11.528542,109.400024 
	C11.147105,119.489761 10.575243,129.719772 11.015297,139.665482 
	C11.787958,157.128525 10.323085,174.609161 12.044288,192.038025 
	C12.530149,196.957825 11.829381,201.981888 12.334738,206.959900 
	C12.484241,208.432571 12.176355,209.971497 10.419037,211.004517 
	C8.486988,207.121490 8.293970,202.985809 8.058925,198.940216 
	C6.590839,173.671753 7.129250,148.369537 6.956473,123.078125 
	C6.908379,116.038116 6.021714,108.999565 6.070063,101.964119 
	C6.153936,89.759315 7.280246,77.535873 6.851635,65.359589 
	C6.255548,48.425594 7.593873,31.530668 7.043832,14.613206 
	C6.834167,8.164596 8.836235,6.299848 15.239111,6.003793 
	C15.405434,5.996103 15.572468,5.997442 15.739000,6.001499 
	C37.707825,6.536746 59.651936,3.943360 81.597610,5.149285 
	C91.316284,5.683331 101.081352,5.656751 110.713646,5.488706 
	C118.541389,5.352143 126.564552,5.678297 134.509232,4.328561 
	C140.221466,3.358097 146.280731,5.113256 152.214676,4.056742 
	C154.328003,3.680472 156.596863,4.057199 157.930832,1.373495 
	C159.066666,1.000000 160.133347,1.000000 161.600006,1.000000 
z"/>
<path fill="#F8FCFD" opacity="1.000000" stroke="none" 
	d="
M8.260102,377.707428 
	C5.998368,381.760742 6.788832,385.838470 7.241008,389.652863 
	C8.165404,397.450653 8.958284,405.132202 6.278226,412.749664 
	C5.959013,413.656952 5.926089,414.736084 6.025343,415.708557 
	C7.104449,426.281616 5.284964,436.776367 5.217214,447.282501 
	C5.139507,459.332489 5.393595,471.465027 6.926712,483.477783 
	C7.632921,489.011261 5.767164,494.368073 6.031798,499.824951 
	C7.280339,525.570312 6.846772,551.333008 7.041475,577.090271 
	C7.142497,590.454468 7.697372,603.814819 7.984100,617.178284 
	C8.082176,621.749207 10.169077,625.824768 10.992537,630.604858 
	C7.671272,631.000000 3.061601,632.297119 1.376362,630.632874 
	C-0.287880,628.989380 1.000605,624.351746 1.000581,621.027649 
	C0.999868,522.330872 1.000000,423.634094 1.000000,324.468658 
	C4.256647,322.514465 4.608406,325.705658 6.251232,327.462341 
	C6.642851,328.254517 6.757894,328.740967 6.786698,329.615509 
	C6.065895,334.466644 5.955317,338.924774 7.464246,343.651489 
	C7.879511,344.671753 7.967605,345.391235 7.915007,346.486145 
	C7.414886,349.342896 6.551979,351.868408 8.633100,354.487061 
	C10.141962,356.512115 10.354217,358.483521 10.062880,360.920593 
	C9.853814,362.001648 9.632584,362.694946 9.346024,363.732117 
	C9.016537,365.182617 8.604284,366.239838 8.102156,367.610962 
	C7.307150,369.323425 8.220923,370.375702 8.903033,371.843750 
	C9.399449,373.978851 9.486099,375.747467 8.260102,377.707428 
z"/>
<path fill="#F7FCFC" opacity="1.000000" stroke="none" 
	d="
M631.000000,623.562500 
	C626.203613,623.033691 621.960510,625.656128 617.427612,626.369324 
	C610.995789,627.381348 604.455688,627.488159 598.154419,627.612793 
	C588.113281,627.811462 578.034485,628.320740 567.955383,628.088135 
	C553.147766,627.746338 538.326355,628.023132 523.510925,627.992859 
	C511.135040,627.967590 498.768921,628.405396 486.407562,628.689209 
	C470.192810,629.061646 453.873383,629.105774 437.652222,627.133606 
	C432.073883,626.455383 426.344818,626.939575 420.686218,627.014404 
	C408.896362,627.170410 397.240417,626.021545 385.587311,624.236206 
	C380.541443,623.463257 375.287018,624.109741 370.131775,623.959045 
	C368.439636,623.909546 366.391632,624.829346 365.069397,622.332336 
	C364.392426,621.289307 364.496887,620.630737 365.224304,619.752991 
	C365.746826,619.474976 365.976379,619.408752 366.560608,619.323975 
	C369.663361,619.851440 372.382019,619.080444 375.452545,619.160767 
	C377.072327,619.532959 378.345032,619.744019 379.795837,618.650146 
	C380.548096,618.399292 380.995300,618.407532 381.713104,618.720825 
	C383.977905,623.045227 387.664246,621.125488 390.236298,620.555664 
	C393.841797,619.757019 397.591675,620.772400 401.058136,619.214905 
	C402.042480,618.772644 403.060059,619.457947 403.687958,620.254211 
	C406.646179,624.005737 410.755341,623.738464 414.981323,624.091858 
	C443.670929,626.491211 472.412933,625.968811 501.146576,625.995728 
	C523.539673,626.016724 545.934631,626.177612 568.325195,625.939636 
	C584.149597,625.771484 599.988220,625.393433 615.757202,623.903259 
	C619.499329,623.549683 623.353821,622.799377 626.024170,619.518982 
	C627.099487,618.197998 628.665283,617.534241 630.645874,617.036072 
	C631.000000,619.041687 631.000000,621.083313 631.000000,623.562500 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M6.378265,327.622803 
	C3.344300,328.091949 4.294846,324.121368 1.353945,324.040833 
	C1.000000,319.643097 1.000000,315.286194 1.000000,310.464630 
	C2.411563,310.001343 3.823125,310.002716 5.658198,310.006958 
	C8.417277,315.680603 7.593168,321.464905 6.378265,327.622803 
z"/>
<path fill="#F8FCFD" opacity="1.000000" stroke="none" 
	d="
M51.468269,631.000000 
	C51.098312,629.542786 51.735554,628.282227 53.228146,628.159912 
	C58.888248,627.695923 64.467155,628.142578 69.912460,630.613892 
	C63.978848,631.000000 57.957695,631.000000 51.468269,631.000000 
z"/>
<path fill="#F7FCFC" opacity="1.000000" stroke="none" 
	d="
M631.000000,611.545898 
	C627.353027,608.992798 628.601746,605.599976 630.613098,602.088745 
	C631.000000,605.030579 631.000000,608.061218 631.000000,611.545898 
z"/>
<path fill="#F8FCFD" opacity="1.000000" stroke="none" 
	d="
M46.333328,631.000000 
	C46.234020,630.484924 46.337605,629.716370 46.732224,629.513245 
	C47.344398,629.198120 47.749355,629.787964 47.960426,630.702881 
	C47.555553,631.000000 47.111111,631.000000 46.333328,631.000000 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M614.649292,394.812256 
	C617.450439,398.763763 615.952698,403.102417 616.305237,407.103973 
	C616.995850,414.943176 616.804993,423.060150 617.736816,430.714081 
	C618.750000,439.035797 614.488953,445.588287 614.110168,453.138611 
	C614.037964,454.579498 614.596741,455.626038 615.191650,456.843658 
	C617.728699,462.035919 619.253906,467.537567 617.305176,473.198059 
	C616.233032,476.312286 619.160461,478.354645 618.466431,481.343536 
	C617.500793,485.502136 618.085327,489.924957 616.246521,494.017975 
	C615.498840,495.682190 615.721741,497.777740 617.733154,498.812103 
	C620.201111,500.081177 620.765503,502.536346 620.837280,504.709930 
	C621.051270,511.193176 622.055969,517.558960 623.001648,523.941589 
	C623.782959,529.215027 620.605713,533.860962 620.839478,539.144653 
	C621.068665,544.325623 620.366577,549.553345 619.988708,554.754395 
	C619.462891,561.990295 618.863525,569.097290 616.776123,576.243103 
	C615.142944,581.833618 616.058350,588.260071 616.353943,594.289978 
	C616.547241,598.231873 614.612244,601.019165 610.709961,600.936707 
	C605.466187,600.826050 603.841125,602.897827 605.402588,607.703308 
	C607.806763,615.102173 607.637146,614.392883 600.094055,616.196838 
	C592.338562,618.051697 585.062439,615.016541 577.521606,615.664795 
	C566.622192,616.601929 555.626221,614.448486 544.723206,616.783997 
	C540.665649,617.653137 536.421326,617.193970 532.398376,615.900696 
	C525.701416,613.747803 518.822571,613.012268 511.826843,612.989441 
	C506.735382,612.972778 502.425507,610.057800 497.603149,608.982666 
	C496.535553,608.744690 495.078888,607.448608 494.435211,608.244019 
	C491.081390,612.388550 487.591187,610.558289 483.828857,609.119507 
	C482.392212,608.570068 480.356384,608.546265 478.984009,609.601562 
	C474.402191,613.124878 468.482330,612.357422 463.521301,614.629089 
	C461.956848,615.345459 460.251495,615.153503 458.695770,614.312805 
	C444.968475,606.894531 430.780975,608.286743 416.423126,611.980347 
	C412.916595,612.882446 409.289368,613.315186 405.290924,613.940735 
	C404.025146,610.630859 406.889374,610.624817 408.629364,609.952576 
	C415.667450,607.233704 423.148682,605.708618 430.153931,601.861450 
	C431.087708,601.281189 431.775116,601.064941 432.812500,600.815308 
	C434.050934,600.644897 434.845673,600.293823 435.822266,599.535034 
	C437.287903,598.737732 438.571594,598.392639 440.161896,597.938599 
	C441.990326,597.615112 443.319977,597.015625 444.620056,595.652100 
	C447.404907,593.548218 450.741302,593.093201 453.355408,590.640137 
	C454.226929,590.057251 454.855377,589.748840 455.808960,589.300049 
	C473.676086,581.936890 488.951630,571.065735 504.043121,559.273926 
	C504.746826,558.526489 505.308258,558.151733 506.165222,557.636230 
	C507.361847,556.989441 508.285461,556.514771 509.304260,555.619934 
	C510.326477,554.767334 511.227356,554.274536 512.280518,553.465393 
	C513.478333,552.479553 514.366577,551.613159 515.426758,550.464355 
	C517.256897,548.435730 519.338135,547.196899 521.357361,545.370300 
	C525.907959,540.205322 530.624390,535.677856 535.715332,531.048401 
	C536.282715,530.504883 536.609924,530.198059 537.174561,529.653320 
	C537.726929,529.093933 538.043945,528.774780 538.591187,528.205200 
	C542.818115,523.555054 547.153931,519.458679 550.897095,514.383057 
	C551.610657,513.385742 552.230591,512.749573 553.014404,511.825836 
	C553.492249,511.238739 553.763733,510.903168 554.231079,510.310852 
	C555.846436,508.455200 557.240540,506.835297 558.689758,504.847168 
	C559.225525,504.046417 559.619263,503.538971 560.205688,502.773682 
	C561.100159,501.700714 561.759644,500.855042 562.451599,499.623596 
	C564.255066,496.624298 566.743164,494.463684 567.903442,491.039062 
	C568.141052,490.510864 568.248962,490.305359 568.560730,489.817993 
	C574.052124,483.807983 577.797119,477.025787 581.974792,470.138184 
	C582.916870,468.541229 583.531372,467.157288 584.214600,465.456116 
	C584.744263,464.461365 585.371399,463.893433 585.676331,462.795898 
	C585.860596,461.903168 586.005310,461.311829 586.315613,460.450104 
	C586.766479,459.646484 587.232056,459.257019 587.910156,458.665039 
	C588.528442,458.042969 588.890381,457.590607 589.277954,456.797119 
	C589.700378,455.770416 589.962402,455.001892 590.269165,453.909363 
	C590.634094,452.762512 590.953552,451.942017 591.511353,450.852448 
	C596.255005,444.082794 598.649292,436.664764 600.952698,428.855286 
	C600.983521,427.802094 601.088684,427.111176 601.484985,426.132690 
	C604.449951,423.811951 605.191650,420.674316 606.260681,417.326538 
	C607.419434,415.726929 607.796082,414.201996 608.106812,412.284607 
	C609.186035,409.317993 609.710083,406.542816 610.795349,403.580994 
	C611.170898,402.630432 611.470154,402.018555 611.635437,401.009796 
	C611.767029,399.765961 611.873718,398.859985 612.119812,397.621460 
	C612.427856,396.605255 612.763977,395.987488 613.430664,395.157898 
	C613.898926,394.814575 614.119019,394.726318 614.649292,394.812256 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M616.957764,246.644501 
	C616.977295,248.088928 617.012329,249.148560 617.081909,250.604218 
	C618.746155,252.784927 619.178406,254.928482 618.989990,257.631470 
	C618.993896,258.448486 618.999634,258.891571 619.026306,259.666351 
	C619.458313,260.408630 619.796814,260.863373 619.943237,261.731476 
	C619.965942,262.458832 619.972656,262.899384 619.999023,263.669891 
	C620.987183,264.912842 620.993774,266.105316 620.972839,267.659851 
	C621.276367,269.422424 621.585999,270.829193 621.905945,272.599396 
	C621.974976,273.773834 621.992371,274.585999 621.983643,275.703552 
	C621.989685,277.072662 621.997314,278.137085 622.030396,279.599915 
	C622.734985,280.643616 622.978516,281.455658 622.957642,282.694244 
	C622.976379,285.385651 622.999878,287.749847 623.049805,290.556488 
	C623.969055,291.945770 624.007507,293.121979 623.954834,294.673096 
	C623.964294,302.038818 623.986877,309.050629 624.028198,316.530579 
	C624.584351,317.695465 624.751038,318.462158 624.257812,319.655884 
	C624.112488,325.012726 623.406555,330.068298 624.883972,335.411560 
	C623.634705,337.112488 624.318542,338.985931 623.334351,340.710541 
	C622.615234,351.589355 621.853455,362.150848 619.096680,372.740417 
	C618.265686,373.002106 617.853333,372.808319 617.369141,372.090637 
	C617.098022,371.287415 617.040894,370.807312 617.071899,369.960999 
	C617.524475,367.998627 617.774963,366.372162 617.778931,364.353943 
	C617.838013,363.523895 617.906311,363.053589 618.067017,362.237854 
	C618.770996,360.058868 618.757263,358.217316 618.146118,356.012024 
	C617.878601,354.666870 617.895264,353.681671 618.252197,352.346191 
	C619.976440,349.784088 619.866699,347.409393 618.966675,344.583679 
	C618.154968,339.226379 618.562805,334.315277 619.771484,329.051453 
	C620.597046,325.675171 621.257385,322.694031 619.594910,319.373260 
	C619.309143,318.494781 619.275818,317.970581 619.441040,317.055664 
	C621.300659,312.350464 620.698181,307.925476 620.023987,303.106567 
	C619.492310,300.512268 619.559631,298.284271 619.545776,295.646667 
	C619.552185,292.494629 619.875244,289.737305 618.961792,286.650696 
	C618.638672,284.908691 618.630310,283.552551 618.611450,281.802063 
	C618.603577,279.865540 618.737183,278.312805 618.151611,276.437012 
	C617.668335,274.570221 617.485413,273.029633 616.927979,271.177002 
	C616.541687,266.971405 616.700195,263.090576 615.370239,259.018982 
	C615.117798,258.199677 615.014465,257.727142 614.890503,256.906189 
	C614.679260,255.284027 614.833252,253.929596 613.789185,252.543915 
	C613.445984,251.866653 613.340027,251.445496 613.297729,250.674026 
	C613.423584,249.465515 613.692017,248.601334 613.378540,247.401947 
	C613.184570,246.700562 613.080078,246.302917 612.895630,245.619659 
	C612.597046,244.554932 612.160339,243.894226 611.549561,242.968903 
	C611.276123,242.275375 611.198914,241.852295 611.152466,241.088379 
	C610.762024,236.430283 610.030029,232.202225 607.557495,228.090210 
	C601.314514,208.123413 594.412842,188.837952 584.174988,170.858398 
	C579.744751,163.078171 575.324524,155.300552 570.477051,147.321045 
	C570.123413,146.182266 570.149841,145.412262 570.656372,144.332428 
	C574.377319,142.786545 575.187256,145.903549 576.346252,147.762497 
	C587.019226,164.881134 596.387085,182.669830 603.434631,201.621841 
	C606.101929,208.794678 609.353088,215.838913 611.238098,223.189957 
	C613.202820,230.851883 616.662964,238.185959 616.957764,246.644501 
z"/>
<path fill="#D5D6D6" opacity="1.000000" stroke="none" 
	d="
M430.855225,601.882935 
	C429.400208,604.890320 426.286255,605.068970 423.692413,606.197021 
	C417.599609,608.846436 410.774445,609.556335 404.965363,613.572266 
	C403.515137,613.940735 402.166077,613.963806 400.409424,614.008545 
	C399.598419,614.451843 399.143921,614.792175 398.277496,614.955994 
	C397.548309,614.985962 397.106354,614.994141 396.333466,615.023193 
	C395.593506,615.456299 395.139648,615.795837 394.274292,615.952148 
	C393.546448,615.983826 393.105072,615.995789 392.333374,616.031738 
	C391.589264,616.460449 391.135498,616.798950 390.270203,616.946594 
	C389.232208,616.986755 388.480194,617.009949 387.353516,617.067627 
	C386.628204,616.736572 386.390900,616.310364 386.296509,615.443787 
	C386.434631,614.613037 386.648224,614.195496 387.253601,613.652344 
	C388.935699,612.951782 390.447784,613.734863 392.116943,612.989624 
	C393.464020,612.637268 393.963287,611.738831 394.828735,610.777588 
	C395.477448,610.405273 395.899628,610.320740 396.669495,610.338013 
	C401.067810,611.197021 404.370514,608.978333 408.212036,607.529297 
	C408.750183,607.381042 408.970886,607.346802 409.523254,607.310974 
	C410.732300,607.375244 411.600525,607.360107 412.757385,606.896973 
	C419.046967,605.485718 424.269165,601.677612 430.855225,601.882935 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M618.380798,374.714264 
	C619.369568,377.584900 618.122131,380.010651 617.173462,382.768066 
	C616.458069,383.386902 615.969360,383.526947 615.064331,383.221558 
	C614.254761,382.328094 614.135559,381.559967 614.319397,380.368347 
	C616.010620,378.447632 615.185120,375.289734 618.380798,374.714264 
z"/>
<path fill="#D5D6D6" opacity="1.000000" stroke="none" 
	d="
M382.201416,618.682617 
	C381.543121,618.942261 381.102020,618.955261 380.330322,618.986572 
	C379.223999,619.617737 378.494202,619.468567 377.589203,618.507202 
	C377.253906,617.590820 377.260132,617.040222 377.610260,616.125366 
	C378.724884,615.001099 379.820587,614.819031 381.368683,614.735901 
	C382.344604,614.747070 382.894745,614.824280 383.826050,615.106018 
	C384.979980,615.703064 385.437836,616.332214 385.186188,617.618774 
	C384.131165,618.130920 383.274902,618.283386 382.201416,618.682617 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M618.779419,374.537842 
	C615.834229,375.428162 618.064514,378.968536 615.457214,379.998962 
	C612.932617,377.714752 614.388000,375.318024 615.262024,372.565857 
	C615.889771,371.765900 616.390930,371.551819 617.374023,371.734497 
	C617.956055,372.177429 618.151672,372.447815 618.562683,372.842346 
	C618.793274,373.386383 618.808472,373.806305 618.779419,374.537842 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M615.005493,394.608032 
	C614.768982,394.990295 614.578552,394.994141 614.102539,394.989227 
	C610.907898,394.180756 611.401550,392.290344 612.562256,389.983459 
	C613.508179,389.284637 614.243469,389.192413 615.340393,389.595032 
	C616.252014,391.386353 615.427917,392.777130 615.005493,394.608032 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M619.267578,257.755585 
	C617.362488,256.220215 618.243774,253.690811 617.124268,251.376633 
	C618.314514,250.969421 618.872375,251.855957 619.745117,252.828644 
	C619.848938,254.502319 619.697937,256.004028 619.267578,257.755585 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M623.494751,340.911804 
	C623.251099,339.305603 622.272095,337.376434 624.549561,335.946106 
	C624.721069,337.523285 625.836365,339.498505 623.494751,340.911804 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M385.154175,618.205444 
	C384.863800,617.424927 384.740204,616.871399 384.369385,616.167725 
	C383.993011,615.765686 383.863831,615.513855 384.007690,614.935791 
	C385.105255,614.206909 385.922028,614.215942 386.853149,615.065186 
	C386.969391,615.835388 386.963165,616.196045 386.967896,616.829468 
	C386.813995,618.028870 386.759521,619.093140 385.154175,618.205444 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M614.535156,382.988037 
	C615.351379,383.002197 615.787842,383.004852 616.550415,383.004578 
	C616.831360,383.694061 616.786194,384.386444 616.670288,385.419189 
	C616.185913,386.560760 615.477478,386.693634 614.319702,386.459045 
	C613.599609,385.931488 613.372314,385.483368 613.298035,384.582275 
	C613.442627,383.688599 613.723694,383.280609 614.535156,382.988037 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M624.213745,294.809235 
	C622.818970,294.153778 623.040894,292.905884 623.049072,291.362000 
	C625.417419,291.462341 625.245483,292.911591 624.213745,294.809235 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M621.235657,267.795166 
	C619.766602,267.180695 620.037964,265.908447 620.004761,264.365356 
	C622.388733,264.412323 622.252014,265.866577 621.235657,267.795166 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M615.727417,389.510193 
	C615.038879,389.900024 614.416382,389.999298 613.477173,390.133698 
	C612.466187,389.510315 612.479187,388.778107 613.265869,387.764221 
	C614.130005,387.364471 614.662598,387.364563 615.516846,387.777954 
	C615.823547,388.424500 615.808533,388.822052 615.727417,389.510193 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M616.114929,387.838440 
	C615.448364,388.013580 615.058289,388.000214 614.374634,387.978210 
	C613.684448,387.629822 613.552673,387.200684 613.891968,386.419739 
	C614.755493,386.061218 615.377747,385.977020 616.299805,385.826172 
	C616.530212,386.389648 616.460754,387.019806 616.114929,387.838440 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M624.360596,319.948395 
	C624.020752,319.250031 624.009216,318.499207 624.022339,317.373535 
	C626.142883,317.547455 626.777649,318.419922 624.360596,319.948395 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M623.212402,282.825317 
	C622.098755,282.453430 621.999634,281.584991 622.036499,280.334229 
	C623.719421,280.233917 624.386230,281.006012 623.212402,282.825317 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M622.235840,275.819916 
	C620.945618,275.299438 620.841919,274.405182 621.686646,273.165405 
	C623.013672,273.657745 623.210693,274.546051 622.235840,275.819916 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M398.159943,615.206909 
	C398.462921,614.668274 398.935577,614.358826 399.705048,614.039856 
	C399.813660,614.938110 399.829102,616.088196 398.159943,615.206909 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M390.151794,617.194580 
	C390.460022,616.662842 390.935852,616.362061 391.707367,616.058594 
	C391.811462,616.966675 391.800781,618.100037 390.151794,617.194580 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M394.156494,616.201721 
	C394.461792,615.666199 394.935699,615.360474 395.706116,615.049438 
	C395.812714,615.953064 395.814514,617.093750 394.156494,616.201721 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M620.191284,261.850586 
	C619.654907,261.542694 619.350525,261.067139 619.046631,260.294861 
	C619.960205,260.188599 621.101135,260.192993 620.191284,261.850586 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M220.307388,612.586060 
	C207.169144,609.670532 193.890045,607.755554 181.475281,602.207153 
	C176.519089,599.992126 170.483002,598.987366 165.776733,604.104431 
	C164.546371,605.442200 162.879974,605.310181 161.811508,604.038452 
	C158.981812,600.670471 157.899155,603.133667 157.125854,605.453430 
	C155.811691,609.395691 152.633163,611.233521 149.186371,610.759460 
	C145.810059,610.295166 143.602097,612.339294 140.970505,612.716797 
	C136.027206,613.425964 131.080429,618.264221 125.827812,613.583374 
	C121.086082,616.601074 115.358932,609.180786 110.803932,615.020752 
	C110.109947,615.910461 108.773247,615.783813 107.538330,615.352722 
	C102.172478,613.479492 97.275345,615.857056 92.244102,617.144653 
	C89.388420,617.875427 86.039780,619.527039 83.656700,618.677734 
	C78.342354,616.783630 73.956009,618.037720 68.952812,619.635498 
	C63.713734,621.308655 58.142166,618.306335 52.702339,618.813110 
	C46.418194,619.398560 40.107475,615.251160 34.119511,618.318542 
	C30.216595,620.317810 26.464558,620.891663 22.267038,621.120422 
	C18.476494,621.326965 16.148115,619.377075 15.542679,616.508728 
	C14.068463,609.524292 10.515005,603.308350 10.709400,595.571777 
	C11.145617,578.211121 9.545929,560.818054 10.017579,543.419189 
	C10.382532,529.956299 7.892135,516.617188 8.156159,503.207367 
	C8.328933,494.432281 9.678088,485.604309 8.860054,476.865173 
	C7.911595,466.732727 8.039189,456.626099 8.024756,446.503052 
	C8.007958,434.720551 9.652081,423.103607 11.602888,411.500763 
	C12.689531,405.037720 10.646417,398.707947 9.571718,392.379333 
	C9.234285,390.392303 8.672123,388.511505 9.714729,386.269379 
	C11.980253,385.605164 12.183616,387.541046 13.365102,388.759613 
	C13.714459,389.563904 13.808527,390.055908 13.814209,390.942261 
	C13.481449,399.269867 16.716417,406.567078 18.068819,414.211548 
	C19.108570,420.088745 20.487204,425.926788 21.921991,431.741791 
	C22.863764,435.558655 23.857786,439.506439 22.252260,443.511810 
	C21.360905,445.735504 22.728884,447.711365 23.469669,449.711945 
	C25.129488,454.194519 25.676926,458.100464 22.814014,462.882202 
	C20.516479,466.719604 20.392630,472.071960 20.414236,476.856537 
	C20.442890,483.202423 19.365084,489.432587 18.915781,495.724579 
	C18.467875,501.996918 20.088123,507.212433 23.258089,512.973999 
	C27.520630,520.721436 34.466988,526.946289 36.556034,535.897583 
	C37.011383,537.848755 38.301216,538.469055 39.840256,537.269714 
	C43.186440,534.662109 47.259281,532.629333 47.875706,527.649658 
	C48.165535,525.308411 49.185505,523.123779 50.709881,521.344788 
	C53.235050,518.397766 55.164310,515.167725 56.446815,511.509003 
	C56.943520,510.091980 57.889095,508.893280 58.937084,507.805725 
	C61.955074,504.673676 63.760208,504.640472 66.790344,507.863617 
	C69.772964,511.036224 73.033104,513.804016 77.377182,515.751160 
	C80.920074,517.843201 83.046524,520.861389 85.556602,523.971680 
	C86.163765,525.272522 86.342598,526.435791 87.763824,527.166138 
	C93.211105,531.327087 97.418633,536.293823 102.062866,540.804138 
	C121.133926,559.325317 142.643631,574.470154 165.750015,587.523376 
	C181.745758,596.559692 198.458832,603.736206 216.070816,608.902405 
	C217.855576,609.425842 220.173447,609.625732 220.307388,612.586060 
z"/>
<path fill="#D5D6D6" opacity="1.000000" stroke="none" 
	d="
M220.522064,612.919312 
	C219.659454,610.528381 217.430771,610.581970 215.834396,610.138550 
	C192.426773,603.637390 170.865921,593.006653 150.504440,580.053162 
	C136.820572,571.347717 123.549492,561.986511 111.372780,551.089722 
	C103.178185,543.756409 95.773148,535.663330 87.379303,528.115784 
	C86.191116,527.358826 85.867638,526.366760 85.194466,525.247070 
	C82.832085,522.471985 80.670914,519.925537 78.236237,517.195496 
	C77.607697,516.585571 77.456970,516.096069 77.666672,515.178223 
	C78.457237,514.276672 79.205521,514.070190 80.405174,514.095581 
	C81.287056,514.284973 81.731705,514.520691 82.354172,515.139160 
	C85.714386,521.633362 90.757729,526.254883 95.827690,531.285522 
	C97.261780,532.764832 98.212036,534.286621 100.264221,535.038818 
	C101.849960,535.803772 102.829918,536.752808 103.742233,538.261108 
	C104.999413,541.256470 107.013779,543.012817 109.899780,544.372803 
	C110.956551,545.121521 111.602165,545.810120 112.528549,546.725098 
	C118.387253,554.272461 126.535706,558.436951 133.668320,563.823853 
	C152.877747,578.331970 173.803436,589.934631 195.858246,599.486938 
	C207.008560,604.316406 218.752182,607.537048 230.589111,611.547607 
	C231.423309,611.722473 231.896164,611.840393 232.714523,612.088379 
	C234.209976,612.647888 235.375717,613.063904 236.326599,614.409302 
	C236.448608,614.997620 236.434662,615.242981 236.221283,615.798340 
	C235.574753,616.070984 235.127640,616.033630 234.343994,615.989380 
	C230.607544,616.148315 227.443161,615.410767 224.288010,613.276367 
	C222.966934,612.994568 221.936295,612.960449 220.522064,612.919312 
z"/>
<path fill="#D5D6D6" opacity="1.000000" stroke="none" 
	d="
M269.315002,622.380493 
	C264.394287,622.122925 259.627625,621.533691 254.437958,620.937500 
	C252.127151,619.544983 249.802979,619.547546 247.668594,618.954407 
	C245.985489,618.486633 245.861237,617.794983 247.463043,616.579102 
	C247.739456,616.204895 247.769653,616.003235 248.096085,615.739624 
	C249.139740,615.834717 249.817856,616.289917 250.914627,616.168091 
	C251.599930,616.126038 251.992828,616.142090 252.676590,616.244568 
	C253.926697,616.570374 254.890839,616.655273 256.169800,616.345215 
	C256.888977,616.276001 257.300232,616.312866 258.000793,616.514221 
	C259.505981,617.490662 260.933105,617.796814 262.621307,618.304199 
	C263.658539,618.797913 264.250610,619.457703 265.444580,619.644287 
	C266.679169,619.810730 267.584503,619.945435 268.740326,620.502197 
	C269.337921,621.100647 269.471588,621.553223 269.315002,622.380493 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M13.267765,389.185547 
	C11.147093,389.070923 11.150927,387.431152 10.254310,386.199493 
	C10.236732,383.354797 9.689946,380.861603 8.277163,378.240601 
	C7.998716,375.958344 7.998272,373.916656 7.996479,371.437500 
	C7.863393,370.414062 8.045340,369.953339 8.929251,369.500305 
	C11.480594,369.386597 12.003709,370.984222 12.252251,372.632843 
	C12.713673,375.693512 13.660204,378.661407 13.952239,382.115997 
	C13.903765,383.597870 13.780428,384.724518 14.530746,386.070129 
	C14.849474,387.081360 14.834347,387.771912 14.421604,388.764618 
	C14.012087,389.174683 13.793066,389.277405 13.267765,389.185547 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M224.057831,613.379639 
	C227.167038,613.833801 230.336487,614.638916 233.756714,615.713257 
	C230.001282,618.348694 226.950760,616.517944 224.057831,613.379639 
z"/>
<path fill="#D5D6D6" opacity="1.000000" stroke="none" 
	d="
M244.243774,616.191772 
	C242.552155,619.431519 240.540100,617.268860 238.372894,617.006958 
	C237.600983,616.642639 237.316528,616.226807 237.112152,615.339233 
	C236.973907,613.900635 237.090195,612.902222 238.242004,611.952942 
	C239.107910,611.843018 239.593155,611.978699 240.370193,612.408325 
	C241.805008,613.855957 244.027023,613.840637 244.243774,616.191772 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M244.289795,616.428833 
	C243.484436,614.417053 240.766510,615.713867 239.961884,613.574646 
	C240.075317,612.836853 240.361008,612.576172 241.076172,612.469727 
	C241.844940,612.319763 241.893997,613.570923 242.796143,612.668823 
	C243.426956,612.382874 243.816315,612.317749 244.512421,612.345154 
	C245.386124,612.525879 245.941559,612.738953 246.789154,613.012573 
	C247.251038,613.187256 247.430939,613.269531 247.982697,613.790405 
	C248.349655,614.422241 248.344772,614.615601 248.171570,615.042114 
	C247.647095,615.406372 247.280106,615.479004 246.624649,615.483765 
	C245.979401,615.479370 245.635178,615.566711 245.185013,615.999878 
	C244.879822,616.276062 244.710846,616.318176 244.289795,616.428833 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M237.740189,614.929199 
	C237.997253,615.621704 237.995071,616.006714 238.005142,616.679932 
	C237.195160,618.014221 236.545929,617.935303 236.050507,616.389282 
	C236.022842,615.919006 236.023788,615.729553 236.010651,615.256409 
	C236.429199,614.592773 236.923965,614.475708 237.740189,614.929199 
z"/>
<path fill="#D5D6D6" opacity="1.000000" stroke="none" 
	d="
M246.036804,615.547424 
	C246.597748,615.298706 246.906540,615.304626 247.446991,615.307983 
	C247.875565,615.358948 248.072464,615.410461 248.130829,615.734009 
	C247.992279,616.006042 247.842606,616.198120 247.775940,616.302368 
	C247.421127,616.366150 247.135727,616.311462 246.657898,616.143921 
	C246.236710,615.964844 246.010666,615.884460 246.036804,615.547424 
z"/>
<path fill="#BDB9B4" opacity="1.000000" stroke="none" 
	d="
M245.998413,615.308594 
	C246.289001,615.290710 246.276474,615.690735 246.369614,615.868042 
	C246.231506,616.110352 246.000275,616.175415 245.408920,616.237183 
	C245.268478,615.931396 245.488144,615.628906 245.998413,615.308594 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M617.236267,246.761414 
	C612.276489,229.950760 606.640442,213.205231 600.093018,196.749435 
	C593.259521,179.574860 584.471863,163.433090 574.803772,147.738281 
	C573.967285,146.380432 573.312805,144.722366 570.974609,143.912903 
	C569.316956,141.628723 568.629517,139.291550 566.195374,137.786011 
	C565.813721,137.417267 565.674500,137.257721 565.365784,136.833176 
	C564.811646,135.843903 564.433533,135.115723 563.734009,134.225296 
	C562.994934,133.109894 562.510681,132.193771 561.652161,131.129242 
	C560.046387,128.214111 558.689819,125.524742 555.855469,123.508934 
	C555.461792,123.068497 555.321289,122.876587 555.003174,122.374580 
	C552.331543,117.293297 548.712708,113.304558 545.079407,109.498779 
	C519.675842,82.888939 491.666901,59.694721 458.355957,43.356792 
	C448.057983,38.305973 438.038361,32.745865 426.991791,29.411041 
	C424.915802,28.784315 422.922119,27.892130 421.867188,25.421150 
	C423.251587,24.108002 422.896667,22.835833 422.728943,21.471533 
	C422.275085,17.779377 424.856171,14.847142 428.166931,16.236933 
	C432.658630,18.122467 436.931152,16.640249 441.263733,17.022854 
	C453.508850,18.104216 465.350555,14.377555 477.475647,14.096947 
	C477.641205,14.093115 477.807281,14.040021 477.971313,14.047710 
	C492.285431,14.718613 506.353851,10.430989 520.721375,11.977362 
	C527.543701,12.711644 534.340271,13.450491 540.730225,16.184963 
	C541.183411,16.378910 541.952820,16.864811 542.022339,16.777098 
	C545.757385,12.061042 552.007507,15.737462 556.177490,12.500675 
	C558.610291,10.612281 560.931763,9.199495 564.022949,11.891098 
	C566.640564,14.170345 569.726990,12.711629 572.525208,11.611643 
	C573.899780,11.071310 575.192566,10.325907 576.533752,9.697588 
	C582.462830,6.919938 588.322998,5.820451 595.185242,6.638216 
	C601.294434,7.366256 607.514526,7.100553 613.667908,8.611792 
	C617.313782,9.507213 619.063110,11.368604 620.056580,14.647536 
	C621.864197,20.613867 621.716248,27.179802 625.612244,32.532536 
	C626.075745,33.169281 626.005859,34.591625 625.626587,35.382973 
	C621.826294,43.310661 622.846802,51.432304 623.526123,59.846596 
	C624.080505,66.712990 622.548279,73.799377 621.519531,80.725594 
	C620.708069,86.188881 618.305847,91.399170 616.937378,96.546074 
	C614.996094,103.847260 612.847717,112.284271 617.848694,120.112190 
	C620.065247,123.581657 618.570435,128.015991 616.618225,131.388000 
	C614.195312,135.573181 614.326782,139.902481 615.658936,143.853455 
	C617.806519,150.223251 618.345276,156.431381 618.504028,163.156708 
	C618.638428,168.851334 616.655579,174.630234 618.526428,180.332993 
	C618.838806,181.285019 618.425293,182.695328 617.911011,183.661743 
	C615.159973,188.831100 615.315735,194.664047 613.971130,200.147659 
	C613.892273,200.469162 613.978699,200.941299 613.785156,201.108688 
	C605.747498,208.061310 613.122498,215.364914 613.376160,222.470093 
	C613.600281,228.746613 614.805481,234.886429 617.640503,240.653229 
	C618.487610,242.376190 618.323975,244.557373 617.236267,246.761414 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M421.502014,25.054502 
	C427.279327,29.648741 434.457092,30.026865 440.540955,33.005394 
	C463.053894,44.027256 485.240540,55.482613 504.961945,71.304596 
	C518.861084,82.455528 532.256165,94.081757 544.453186,107.055489 
	C548.635376,111.503983 552.812012,116.014366 555.886597,121.726112 
	C555.304871,122.582901 554.632751,122.873810 553.494507,122.905853 
	C552.895508,122.811310 552.664062,122.741531 552.128174,122.482819 
	C550.589722,119.358002 549.108643,116.607552 546.017700,114.655502 
	C544.838013,113.255455 544.448486,111.693626 542.928711,110.545174 
	C540.616699,108.376633 538.973816,106.028885 536.649658,103.861694 
	C534.227234,101.397659 532.097290,99.110352 529.481323,96.835999 
	C526.214050,93.198723 522.405762,90.685791 518.837646,87.411972 
	C518.206482,86.689651 517.785095,86.217384 517.081848,85.592140 
	C516.259460,84.847748 515.688354,84.280052 514.708984,83.743713 
	C513.675415,83.252419 512.905823,82.914978 511.942719,82.241013 
	C510.484528,79.974518 508.587555,78.725006 506.261871,77.485321 
	C505.723663,77.299232 505.507050,77.226875 504.674164,76.846886 
	C503.883118,76.388176 503.708374,76.237099 503.318298,75.814949 
	C499.805420,72.882729 497.032776,69.582855 492.944641,67.425697 
	C488.976898,67.766350 487.154022,64.565544 484.048828,63.164253 
	C482.781738,62.830891 481.967560,62.413956 481.402771,61.173531 
	C480.068726,57.316528 477.070465,56.158691 473.535583,55.367832 
	C472.992767,55.481121 472.772247,55.514023 472.216370,55.535934 
	C470.992004,55.381176 470.153961,55.086525 469.089722,54.476112 
	C468.567413,53.922840 468.368561,53.537491 468.148865,52.814613 
	C467.650909,51.058521 466.343689,50.856815 464.875092,50.341377 
	C463.943939,49.991081 463.367920,49.667236 462.577454,49.061264 
	C461.449646,47.800133 460.332672,47.224426 458.628296,47.067535 
	C457.333862,46.777058 456.502136,46.310528 455.466797,45.447887 
	C450.678558,41.304722 444.903961,39.943768 439.701874,37.431923 
	C426.043549,30.836971 411.566895,26.529591 397.148041,22.050329 
	C395.551544,21.554377 393.912598,21.044725 393.726959,18.663902 
	C402.945374,20.553808 412.027374,22.801937 421.502014,25.054502 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M393.506989,18.251274 
	C395.566772,22.329508 399.953766,21.613976 402.854156,22.468288 
	C416.816650,26.580948 430.412872,31.509108 443.563629,37.711601 
	C447.800964,39.710110 452.665344,40.545067 455.951843,44.707191 
	C455.530945,45.431057 455.035400,45.639488 454.068634,45.681358 
	C444.927246,41.168854 435.647247,37.935806 426.608276,34.163147 
	C416.645905,30.005085 406.216278,27.141258 395.809937,24.197163 
	C385.856506,21.381205 375.572052,20.276449 365.648773,17.463779 
	C364.219269,17.058609 362.644501,17.084301 361.661530,15.230186 
	C363.204498,11.776203 365.839294,13.113136 368.117767,13.403634 
	C375.584106,14.355569 382.770050,16.680618 390.569336,18.099281 
	C391.705963,18.166203 392.428253,18.181536 393.506989,18.251274 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M390.767151,17.838053 
	C384.818207,19.012617 379.195404,16.160088 373.241547,15.551631 
	C369.673401,15.186987 366.272003,13.299539 362.266479,14.662659 
	C361.586273,15.355694 361.093964,15.565880 360.106262,15.492193 
	C356.554871,13.941073 353.079468,14.066220 349.773407,13.372617 
	C348.080475,13.017447 346.067749,13.289063 345.756470,10.528852 
	C347.982300,10.112271 350.044342,10.071315 352.548401,10.028066 
	C353.569244,10.031073 354.102783,10.178822 354.794983,10.701696 
	C362.470917,10.558247 369.590820,13.516850 377.498596,13.156556 
	C381.504730,16.508257 386.520691,15.581271 390.767151,17.838053 
z"/>
<path fill="#F4F9FA" opacity="1.000000" stroke="none" 
	d="
M10.000233,211.439667 
	C11.086513,210.174347 11.062448,208.974228 10.988562,207.815567 
	C9.649075,186.809814 10.330230,165.770905 9.849014,144.754837 
	C9.689993,137.809891 11.115571,130.875641 10.530791,124.155350 
	C9.405578,111.224388 11.208151,98.255539 9.311831,85.393661 
	C9.070806,83.758904 8.984186,82.082382 9.017695,80.429100 
	C9.322307,65.400169 8.986776,50.312351 10.294510,35.369183 
	C10.940821,27.983946 9.184328,20.017626 13.723372,13.004972 
	C14.975203,11.070943 15.889852,10.078346 18.163288,9.963938 
	C30.272970,9.354534 42.374931,8.841220 54.511932,8.925365 
	C62.901821,8.983532 71.316292,8.590891 79.683342,7.934960 
	C87.299309,7.337910 94.727219,9.197895 102.499535,8.573499 
	C108.391151,8.100191 114.690071,8.820909 120.815071,8.032647 
	C121.791191,7.907025 123.029427,7.723143 123.768913,8.178865 
	C130.936218,12.595922 139.242523,10.808301 146.897507,12.505114 
	C147.662750,12.674737 148.356537,12.386889 148.946304,13.265833 
	C150.952148,16.255154 152.717514,15.307000 153.912216,12.628255 
	C154.881378,10.455198 155.678238,9.281373 157.576080,11.833309 
	C157.906631,12.277782 158.967422,12.769305 159.235214,12.583236 
	C164.641205,8.826880 165.115509,14.162278 166.846649,16.790909 
	C168.158218,18.782446 169.784576,20.427406 171.546051,21.914598 
	C173.287308,23.384714 175.175598,23.869076 176.131973,20.927107 
	C176.739685,19.057764 177.895157,17.469343 179.835419,17.257065 
	C182.671539,16.946772 184.396027,15.563441 185.499207,13.066354 
	C185.812546,12.357089 186.122116,11.385900 187.156036,11.456236 
	C188.360474,11.538170 188.932266,12.503648 188.893341,13.522054 
	C188.713547,18.227112 192.635544,18.135386 195.430298,18.791409 
	C198.191116,19.439465 199.210938,17.252380 200.159714,14.814008 
	C201.439972,11.523761 203.869370,12.664203 204.702896,14.970766 
	C206.233887,19.207434 209.676620,18.671112 212.071609,17.615114 
	C219.141907,14.497676 226.739029,15.863174 233.940399,14.283311 
	C234.163452,14.234380 234.556656,14.961159 234.934357,15.696816 
	C234.880753,16.223843 234.763321,16.380352 234.416199,16.719025 
	C233.530762,17.324310 232.898468,17.779724 232.040192,18.428185 
	C231.225494,18.807957 230.640198,18.883337 229.750656,18.862083 
	C228.678711,18.770807 227.948868,18.930782 226.993179,19.453815 
	C226.310623,19.692677 225.897263,19.747446 225.153656,19.739958 
	C222.108063,19.127235 220.288651,20.799488 218.103546,22.464218 
	C216.965561,23.044106 216.053055,23.152849 214.798645,23.283361 
	C213.308487,23.334715 212.252014,23.608446 211.115295,24.650337 
	C206.228882,27.203657 201.380432,28.854847 196.014206,30.116203 
	C192.480850,30.846264 189.383545,31.694462 186.647858,34.218147 
	C185.060150,35.425072 183.734604,36.401989 181.722534,36.762081 
	C176.928162,37.043781 173.438797,39.400112 169.818924,42.220016 
	C168.627060,43.492458 167.596710,44.409134 165.815933,44.714760 
	C163.808746,44.499908 162.498901,45.181911 161.087311,46.544159 
	C160.594910,46.874126 160.385529,46.992855 159.837936,47.251328 
	C145.179718,53.617931 133.059021,63.317787 120.350220,72.101334 
	C115.140038,75.702293 110.199173,79.636391 105.224609,83.535057 
	C102.533585,85.644066 100.000404,86.509537 97.535332,83.224274 
	C96.588905,81.962936 95.120163,81.510910 93.657356,81.109985 
	C91.291084,80.461441 89.986443,78.928452 89.862511,76.453575 
	C89.751343,74.233429 90.480186,72.558922 92.783264,71.822762 
	C94.105057,71.400253 95.319099,70.786201 94.917381,69.015778 
	C94.764198,68.340691 94.419510,67.726738 93.758095,67.490898 
	C91.915771,66.833992 91.521568,68.492874 90.832275,69.499977 
	C88.883438,72.347374 86.539497,72.250336 83.929695,70.581268 
	C82.535645,69.689720 81.307892,68.438309 79.556160,68.294914 
	C77.480392,68.125000 75.472282,68.170296 74.961662,70.887199 
	C74.708832,72.232437 74.342041,73.633530 72.502800,73.360695 
	C71.041298,73.143883 70.266792,72.012299 69.666344,70.784637 
	C68.896217,69.210037 68.863541,67.550514 69.351021,65.909241 
	C70.495064,62.057518 70.022896,58.686180 66.739624,55.990658 
	C65.975243,55.363113 65.256714,54.515324 65.001122,53.576824 
	C63.207535,46.991234 58.182259,46.786377 52.511364,46.172523 
	C44.140018,45.266365 35.891632,46.253483 27.810354,47.352116 
	C23.073929,47.996017 19.300632,52.687023 17.459795,57.654324 
	C14.877870,64.621368 14.600793,72.037216 14.558735,79.321945 
	C14.523116,85.491669 14.408424,91.607300 13.640660,97.728630 
	C13.013759,102.726883 14.283096,107.661781 14.481076,112.647758 
	C15.100416,128.245239 13.991526,143.828003 14.617588,159.455093 
	C14.949110,167.730194 17.617525,175.341690 18.082937,183.406128 
	C18.164526,184.819809 18.749998,186.603104 20.417551,186.938187 
	C21.997017,187.255539 22.422169,185.471527 23.244692,184.513733 
	C25.306679,182.112656 27.024471,179.431946 29.165493,177.095749 
	C30.081678,176.096054 31.230801,175.085419 32.637409,175.879105 
	C34.039974,176.670486 33.720520,178.130096 33.388748,179.466721 
	C31.370985,187.595871 27.998589,195.133621 23.664652,202.286911 
	C17.734924,212.074097 15.513848,222.824219 15.791901,234.535767 
	C16.009821,235.693237 15.987282,236.470078 15.720108,237.615463 
	C13.170848,240.967590 13.044534,245.054916 10.375300,248.052124 
	C7.351648,243.669235 9.596206,239.270172 10.119417,235.021896 
	C11.075279,227.260696 11.305789,219.588806 10.000233,211.439667 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M6.981010,306.436798 
	C6.969296,305.246124 6.967115,304.501862 7.008220,303.387634 
	C8.481033,301.288239 7.706892,299.169708 8.091379,297.260956 
	C8.530766,295.079620 8.496721,292.323242 12.324200,293.093872 
	C14.281267,299.983643 13.025080,306.661621 13.389581,313.720398 
	C13.360309,314.742950 13.319533,315.320618 13.188976,316.310883 
	C12.140681,320.919006 11.687212,325.104889 13.496044,329.632874 
	C13.961504,330.820770 14.037459,331.660980 13.950146,332.945038 
	C13.130122,338.545044 13.067368,343.718262 13.936854,348.880341 
	C14.183488,350.344604 14.356297,351.774780 13.590664,353.571411 
	C10.728323,355.287994 10.456277,353.183685 9.643965,351.547394 
	C7.625850,347.482239 8.508341,342.766083 6.432971,338.297882 
	C5.896163,335.557617 5.897166,333.214325 6.385090,330.453369 
	C7.548460,322.335571 6.751784,314.599304 6.981010,306.436798 
z"/>
<path fill="#A7A6AB" opacity="1.000000" stroke="none" 
	d="
M12.162600,292.667786 
	C9.185026,293.898193 9.488463,296.407715 9.021828,298.497742 
	C8.693128,299.969940 9.657942,301.796021 7.424076,302.927155 
	C7.081157,297.989227 7.110807,292.960724 7.226686,287.474121 
	C8.025023,286.023346 8.047559,284.977631 7.419732,283.578674 
	C7.011307,282.345520 7.008735,281.445068 7.671144,280.286194 
	C8.235565,277.929108 8.604274,275.863403 8.997021,273.397705 
	C8.682825,270.087921 10.044368,267.447632 10.547630,264.357727 
	C10.816395,263.498108 12.215611,264.243500 11.687525,262.752136 
	C11.766946,262.188446 11.875084,261.975372 12.317399,261.617096 
	C13.157743,261.431732 13.636743,261.533569 14.350574,262.037170 
	C14.989098,263.022369 15.175012,263.776855 15.310629,264.947998 
	C15.437529,267.412384 15.462042,269.483765 15.007581,271.897949 
	C14.348680,273.712128 12.964480,274.964905 13.881541,277.108215 
	C14.256495,278.864655 14.302047,280.283081 13.935200,282.045776 
	C13.414723,283.423920 12.754516,284.405060 13.104379,285.981934 
	C13.360698,288.417145 13.609841,290.497620 12.162600,292.667786 
z"/>
<path fill="#A7A6AB" opacity="1.000000" stroke="none" 
	d="
M6.734263,306.247009 
	C8.992606,313.737366 7.860026,321.575134 7.360325,329.689819 
	C6.905849,330.129395 6.736243,330.265564 6.348170,330.159424 
	C6.134926,329.488495 6.140150,329.059937 6.100282,328.312622 
	C6.089712,322.309753 6.124234,316.625549 6.120233,310.475616 
	C6.220156,308.841125 6.358603,307.672363 6.734263,306.247009 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M9.998373,248.400299 
	C11.759125,244.859116 11.245111,240.740112 14.588877,238.061218 
	C16.611309,241.101852 14.706483,244.015121 14.428855,247.404404 
	C14.410594,248.568054 14.349546,249.342163 14.254428,250.507553 
	C14.133847,251.421814 13.986932,251.926254 13.561966,252.746674 
	C12.934875,253.431351 12.460806,253.645920 11.531799,253.701813 
	C10.614647,253.532745 10.204631,253.231293 9.952778,252.385834 
	C9.996968,250.931778 9.997795,249.865875 9.998373,248.400299 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M12.221180,261.681152 
	C11.986229,262.166870 11.974039,262.333740 11.960238,262.751587 
	C12.086154,263.172211 12.213681,263.341827 12.101685,263.721130 
	C10.343559,266.583801 10.398420,269.658051 9.295164,272.746643 
	C8.709638,272.532959 8.398208,272.068268 8.063025,271.309021 
	C8.036850,270.433167 8.181536,269.897583 8.709354,269.204773 
	C9.177486,266.253204 8.682983,263.422241 9.981522,260.414978 
	C10.438194,259.653687 10.914007,259.497498 11.809990,259.710632 
	C12.445744,260.335114 12.539496,260.830841 12.221180,261.681152 
z"/>
<path fill="#F4F9FA" opacity="1.000000" stroke="none" 
	d="
M9.633789,252.071381 
	C10.196263,252.263962 10.396380,252.530273 10.824213,252.906998 
	C12.079847,254.255997 12.305264,255.641556 11.590774,257.541412 
	C10.905240,258.325470 10.366126,258.498962 9.375329,258.221375 
	C7.631805,255.980164 7.200260,254.004044 9.633789,252.071381 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M7.534097,280.065796 
	C7.893020,281.056793 7.919182,282.118805 7.952099,283.580139 
	C7.831770,284.099670 7.704686,284.219849 7.359727,284.193848 
	C5.677844,282.721497 5.400518,281.413361 7.534097,280.065796 
z"/>
<path fill="#AFAEB1" opacity="1.000000" stroke="none" 
	d="
M7.129706,284.421143 
	C7.141851,284.047699 7.551716,284.027924 7.755285,284.003723 
	C9.166957,284.971039 9.388496,285.941162 7.604424,286.945007 
	C7.247797,286.275543 7.182680,285.535034 7.129706,284.421143 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M9.020576,258.300873 
	C9.417079,258.001831 9.836844,258.003662 10.571340,258.012177 
	C11.091969,257.877472 11.297867,257.736115 11.840907,257.758392 
	C12.397375,258.386414 12.444369,258.867645 12.032255,259.606964 
	C11.364654,259.892609 10.983792,259.936981 10.316349,259.998169 
	C9.701124,259.543884 9.372482,259.072815 9.020576,258.300873 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M8.604671,269.024353 
	C8.758739,269.541504 8.631574,270.099609 8.271841,270.836090 
	C6.970211,270.195068 7.080241,269.547607 8.604671,269.024353 
z"/>
<path fill="#BDB9B4" opacity="1.000000" stroke="none" 
	d="
M322.215668,624.648254 
	C315.739288,626.203247 309.412323,625.835571 302.643890,625.712708 
	C301.334412,624.954041 301.323578,624.068909 301.994568,622.771484 
	C308.493195,620.679199 314.708618,621.242859 321.343933,622.294495 
	C322.247437,622.985718 322.467682,623.550537 322.215668,624.648254 
z"/>
<path fill="#D5D6D6" opacity="1.000000" stroke="none" 
	d="
M366.129883,619.410461 
	C365.849762,620.259949 365.472443,620.777710 365.035370,621.613953 
	C360.708282,622.426636 356.427124,622.828247 352.180573,623.461670 
	C350.534058,623.707214 348.966431,624.317200 347.139526,623.067261 
	C346.786072,622.544983 346.661621,622.350647 346.529419,621.811401 
	C346.610718,621.255798 346.699707,621.045105 347.053589,620.618591 
	C348.944489,619.708191 350.801941,619.690247 352.634583,618.556885 
	C353.384155,618.305054 353.830780,618.244080 354.622375,618.269287 
	C356.683472,618.721497 358.407410,619.142273 360.525757,619.194275 
	C361.289612,619.119080 361.715576,618.992371 362.461121,618.744507 
	C363.917206,618.431396 365.061096,618.106934 366.129883,619.410461 
z"/>
<path fill="#D5D6D6" opacity="1.000000" stroke="none" 
	d="
M301.694611,622.713257 
	C302.019714,623.692261 302.050171,624.356750 302.136230,625.342896 
	C297.945068,625.986511 293.694458,626.474976 289.232910,625.025696 
	C288.390167,621.190552 291.235657,622.127747 293.380249,621.604492 
	C295.809998,621.558594 297.808105,621.514221 300.212830,621.905029 
	C300.886810,622.140137 301.143372,622.269409 301.694611,622.713257 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M343.149902,621.865723 
	C342.452576,622.299561 342.055389,622.532349 341.325256,622.873413 
	C340.313660,623.589478 339.529083,623.818848 338.240601,623.464233 
	C337.464233,622.851501 337.189606,622.355652 336.955017,621.376465 
	C336.869720,619.464661 337.238831,618.157837 338.997375,617.178833 
	C340.433624,616.743896 341.494476,616.769226 342.924377,617.087280 
	C343.505310,617.333862 343.720032,617.466309 344.144409,617.909424 
	C344.591339,619.509766 344.159119,620.623596 343.149902,621.865723 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M294.291443,622.591309 
	C292.449951,623.442383 290.497894,622.326599 289.074280,624.347656 
	C288.598541,624.706787 288.212463,624.729614 287.536255,624.731262 
	C287.039886,624.576904 286.833649,624.443726 286.452698,623.984924 
	C286.167633,623.172913 286.145172,622.682434 286.327087,621.834106 
	C287.419922,619.858887 289.368011,619.679016 291.070007,618.452271 
	C292.233124,618.113037 293.014435,618.175903 294.091217,618.771851 
	C295.029327,620.084106 295.047821,621.155457 294.291443,622.591309 
z"/>
<path fill="#D5D6D6" opacity="1.000000" stroke="none" 
	d="
M322.293610,625.339355 
	C322.022766,624.623657 322.033356,624.170898 322.030457,623.379150 
	C323.694031,621.308594 325.795105,621.610107 328.305664,621.941895 
	C329.292969,622.309875 329.738495,622.687195 330.035248,623.640747 
	C328.137238,627.581543 325.129791,625.485840 322.293610,625.339355 
z"/>
<path fill="#928C87" opacity="1.000000" stroke="none" 
	d="
M330.359711,624.024048 
	C329.789886,623.712463 329.579773,623.341919 329.136292,622.745422 
	C328.157501,621.448120 328.331268,620.487366 329.621704,619.432007 
	C331.132355,618.966614 332.181061,619.125671 333.333221,620.244629 
	C333.855865,621.402710 333.828613,622.204834 333.158997,623.267944 
	C332.141449,623.683716 331.430420,623.824402 330.359711,624.024048 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M279.296509,623.328491 
	C278.919952,623.120117 278.465698,623.026489 278.243591,622.959961 
	C277.365509,622.240112 276.436951,621.934875 275.752899,620.845215 
	C275.731323,620.264160 275.807312,620.030762 276.179199,619.568359 
	C277.429596,618.883972 278.448914,618.798767 279.886353,618.850769 
	C280.828003,618.998230 281.335449,619.194214 282.110168,619.767578 
	C282.820831,620.857910 282.864655,621.681641 282.363403,622.890747 
	C281.361176,623.771057 280.539917,623.851257 279.296509,623.328491 
z"/>
<path fill="#D5D6D6" opacity="1.000000" stroke="none" 
	d="
M279.033875,623.490295 
	C279.746246,623.005920 280.572571,622.891663 281.797546,622.658691 
	C282.803375,622.152954 283.473541,622.091370 284.502441,622.229370 
	C285.493286,622.524292 286.021057,622.947083 286.804504,623.592346 
	C287.078735,623.786133 287.169006,624.249207 287.207581,624.479614 
	C284.511047,624.766479 281.656799,625.959167 279.033875,623.490295 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M333.243103,623.711914 
	C332.893677,622.861328 332.934845,622.179626 332.975433,621.151367 
	C334.231415,619.688232 335.668060,619.656128 337.589661,620.296387 
	C338.041901,620.942200 338.089142,621.397583 338.137329,622.196411 
	C338.214813,623.034912 338.057159,623.438538 337.331177,623.860535 
	C335.875641,623.940308 334.754669,623.910583 333.243103,623.711914 
z"/>
<path fill="#928C87" opacity="1.000000" stroke="none" 
	d="
M343.187927,622.341370 
	C343.085297,621.150391 343.320801,620.234009 343.800781,619.135498 
	C344.492615,618.798889 344.899963,618.879761 345.482971,619.422363 
	C346.027985,620.266418 346.076721,620.948242 346.478973,621.854858 
	C346.625061,622.150269 346.693573,622.482666 346.802063,622.610962 
	C345.782379,622.698181 344.654236,622.657104 343.187927,622.341370 
z"/>
<path fill="#D5D6D6" opacity="1.000000" stroke="none" 
	d="
M276.134766,622.740479 
	C274.527832,624.539185 273.016602,623.933777 271.190247,622.971436 
	C270.851990,622.539307 270.827728,622.281006 271.078644,621.745056 
	C272.060486,621.080566 272.824707,620.935486 274.013824,620.969727 
	C275.196259,621.220581 275.839600,621.629211 276.134766,622.740479 
z"/>
<path fill="#D5D6D6" opacity="1.000000" stroke="none" 
	d="
M337.213562,624.238770 
	C337.237122,623.645081 337.477600,623.320007 337.928162,622.767456 
	C338.860535,622.610474 339.582825,622.680969 340.648712,622.866577 
	C340.649048,625.460632 339.088318,625.097412 337.213562,624.238770 
z"/>
<path fill="#BDB9B4" opacity="1.000000" stroke="none" 
	d="
M276.361328,623.100525 
	C275.545380,622.754150 275.064209,622.391113 274.272614,621.972900 
	C273.867706,621.713379 273.773224,621.508911 273.856628,621.016968 
	C274.447662,620.525208 274.882050,620.457581 275.617371,620.716553 
	C276.770050,621.057251 277.620056,621.242615 277.968292,622.575256 
	C277.579681,622.956909 277.137909,623.020386 276.361328,623.100525 
z"/>
<path fill="#BDB9B4" opacity="1.000000" stroke="none" 
	d="
M271.175781,621.361694 
	C270.980255,621.905884 270.959534,622.085083 270.907532,622.531006 
	C270.492462,622.808105 270.108643,622.818604 269.442871,622.770630 
	C269.119080,622.326111 269.077271,621.940002 269.023682,621.260620 
	C268.932526,620.295471 269.163849,619.782227 269.873260,619.706421 
	C270.778595,619.609619 271.207428,620.165344 271.175781,621.361694 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M345.598022,10.124118 
	C348.452576,13.731782 352.652252,11.413818 355.813568,12.919825 
	C357.037781,13.503034 358.836578,12.496463 359.977844,14.462526 
	C358.434357,16.813040 356.175018,16.449497 354.075409,16.175093 
	C341.907501,14.584817 329.711487,13.466221 317.427521,13.360898 
	C315.251221,13.342237 312.572083,13.984550 311.661041,10.456030 
	C315.438049,7.915203 319.427185,9.400222 323.258728,9.035367 
	C325.207642,8.849786 327.188782,9.003634 329.606842,9.000946 
	C330.647888,8.994931 331.236664,8.971304 332.251526,8.960862 
	C336.038574,10.701519 339.670319,9.724507 343.575562,10.097298 
	C344.412933,10.124000 344.844360,10.109504 345.598022,10.124118 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M331.292297,9.572851 
	C325.005920,9.935915 318.896790,9.999866 312.313843,10.133375 
	C307.844330,13.327969 303.417389,11.825542 298.675201,11.338468 
	C297.703003,11.199435 297.168213,11.037957 296.309448,10.561234 
	C295.625061,9.841254 295.496796,9.311532 295.791077,8.368129 
	C296.751495,8.004403 297.499908,8.003499 298.622162,7.985821 
	C304.000549,6.167950 309.102203,7.040435 314.597107,7.670115 
	C320.023743,7.960201 325.039154,7.997279 330.520508,8.029619 
	C331.308105,8.379047 331.469086,8.795341 331.292297,9.572851 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M314.906616,7.537488 
	C309.982178,7.951945 304.955963,7.980766 299.462891,7.989315 
	C299.312958,7.423688 299.610168,6.416811 299.949768,6.402317 
	C304.919342,6.190195 309.961700,4.892000 314.906616,7.537488 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M295.712891,7.711359 
	C295.968079,8.393156 295.933014,8.781004 295.866821,9.459558 
	C294.086334,12.004029 291.641785,11.188091 288.961792,11.146091 
	C287.186920,10.662513 285.800140,10.343824 284.282440,9.296922 
	C283.998047,8.542829 283.998474,8.101822 283.999451,7.330045 
	C287.803986,7.236183 291.643677,6.497494 295.712891,7.711359 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M343.724304,9.821960 
	C340.552002,11.755124 337.044312,11.051382 333.280029,10.177149 
	C332.936951,8.890696 333.530426,8.597606 334.684387,8.711269 
	C337.815948,9.301989 340.708252,8.494495 343.724304,9.821960 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M334.944702,8.556491 
	C334.465485,9.059837 333.917419,9.234767 333.194000,9.636885 
	C332.594635,9.877121 332.170654,9.890170 331.430908,9.887590 
	C331.079742,9.462202 331.044403,9.052444 330.997772,8.333784 
	C332.356567,6.683196 333.670746,6.411607 334.944702,8.556491 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M354.976196,10.595741 
	C354.458282,10.750532 353.898865,10.625850 353.164978,10.263470 
	C353.811188,8.967123 354.455994,9.085840 354.976196,10.595741 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M233.904602,16.231415 
	C234.136337,16.067820 234.567307,16.081707 234.782745,16.074520 
	C238.085342,15.942805 241.240250,16.444857 244.593643,14.992001 
	C244.994629,14.910499 245.325165,14.593689 245.505463,14.450776 
	C245.685760,14.307863 246.104630,14.113104 246.560791,14.069500 
	C247.457474,14.020961 247.897995,14.016026 248.668137,13.987462 
	C249.448654,13.601274 249.958374,13.472739 250.876678,13.792822 
	C251.945389,16.365236 250.247208,16.855295 248.611877,17.253210 
	C245.737000,17.952740 242.859253,18.632057 239.668961,19.703096 
	C238.519562,20.087608 237.726471,20.228756 236.532379,20.390575 
	C230.832458,20.771793 226.098190,23.819670 220.338013,23.478130 
	C218.743057,19.233072 222.237106,19.898548 224.611816,19.042852 
	C225.459991,19.035503 225.899918,19.028219 226.669144,18.999008 
	C227.399704,18.548857 227.856842,18.210011 228.730011,18.058558 
	C229.763626,18.022327 230.508575,18.002470 231.625061,17.953634 
	C232.566833,17.427357 233.113785,16.904530 233.904602,16.231415 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M270.587463,10.000393 
	C272.066345,9.989951 273.132660,9.980445 274.598022,9.943872 
	C275.236694,9.842800 275.476349,9.768795 276.004822,9.935792 
	C276.777618,13.686547 273.268372,12.739005 271.545563,14.328268 
	C270.544067,14.808237 269.829285,14.925662 268.741516,14.893028 
	C266.878632,14.509921 265.368835,14.094362 263.491455,14.683481 
	C262.553925,14.929565 261.918427,15.026980 260.977173,15.191586 
	C259.825653,15.355615 259.093262,15.720267 258.131592,16.373047 
	C257.416046,16.659369 256.976807,16.717480 256.186676,16.671165 
	C254.704041,16.296196 253.602264,15.897952 252.672318,14.611090 
	C252.541565,14.042938 252.549255,13.804637 252.786896,13.292435 
	C253.016861,13.018533 253.001724,12.998872 253.004028,13.010319 
	C253.995865,12.304817 255.207367,12.353312 256.670654,12.056709 
	C257.461060,12.043036 257.900787,12.033463 258.669891,12.004360 
	C262.565063,10.425558 266.306610,9.856232 270.587463,10.000393 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M270.725891,9.714586 
	C267.442047,11.545813 263.608887,11.564027 259.425720,11.995882 
	C262.294220,8.791031 266.267700,8.638436 270.725891,9.714586 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M283.599976,8.999983 
	C285.167450,9.116847 286.337250,9.249857 287.757874,9.630557 
	C288.129608,10.124999 288.250580,10.371751 288.165741,10.977125 
	C286.780731,12.216671 285.393188,12.258886 283.596497,12.306817 
	C282.064880,12.223615 281.000580,11.992414 279.889771,10.901867 
	C279.649994,10.286096 279.633148,10.013997 279.817261,9.385754 
	C281.079590,9.025117 282.140930,9.020624 283.599976,8.999983 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M252.739944,12.817667 
	C253.019348,13.212689 253.021820,13.406846 253.035553,13.892044 
	C252.659927,14.485938 252.219757,14.601431 251.422333,14.386486 
	C250.642395,14.151006 250.174072,14.085464 249.351776,13.991878 
	C249.108551,12.911557 248.745407,11.604959 250.220520,11.213635 
	C251.391663,10.902941 251.839584,11.944968 252.739944,12.817667 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M279.781311,8.755654 
	C280.019287,9.214253 280.020386,9.398897 280.028229,9.860430 
	C279.099121,11.042513 278.002106,11.061914 276.481812,10.480979 
	C275.937012,10.187863 275.749481,10.132384 275.279480,9.996855 
	C275.764282,7.066456 277.712097,7.957090 279.781311,8.755654 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M256.842468,11.805347 
	C256.170563,13.200099 254.912430,12.981618 253.370514,13.027272 
	C253.993469,11.954272 254.979462,10.883911 256.842468,11.805347 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M246.294220,14.659023 
	C245.873444,14.888940 245.698105,14.904660 245.258698,14.915440 
	C245.173447,14.139627 245.121719,13.149022 245.591827,12.655783 
	C246.129929,12.091209 246.697784,12.716466 246.967407,13.714025 
	C247.016968,14.025895 247.003876,14.001592 247.012970,14.004280 
	C246.861252,14.152922 246.700439,14.298876 246.294220,14.659023 
z"/>
<path fill="#A7A6AB" opacity="1.000000" stroke="none" 
	d="
M6.899667,338.269897 
	C9.524450,338.530487 9.082199,340.453278 8.956760,341.970093 
	C8.596111,346.331146 10.851661,349.949829 12.411614,353.987610 
	C15.022276,357.109955 13.745188,360.716949 14.465805,364.373169 
	C15.691625,368.184601 14.591321,372.018433 16.549339,375.687866 
	C18.302084,379.518097 18.210531,383.313110 18.894258,387.362854 
	C21.371811,398.613434 24.099630,409.380096 28.554033,420.031433 
	C29.245350,421.521637 29.668566,422.705719 30.148529,424.258850 
	C31.787647,430.086700 33.537041,435.469910 37.246143,440.372437 
	C38.825001,442.652863 39.793030,444.855896 40.934925,447.370270 
	C42.379665,453.297424 46.024124,457.754730 48.578430,463.125366 
	C49.894604,466.599274 51.967136,469.262054 53.772232,472.444214 
	C54.100685,472.880066 54.229691,473.055756 54.551128,473.494385 
	C55.250042,474.473328 55.834427,475.122467 56.675552,476.002838 
	C58.373653,478.650482 60.477905,480.763641 59.995670,484.180908 
	C59.078869,484.857880 58.346073,484.993195 57.195808,484.900757 
	C55.280624,484.359161 54.348671,483.202637 53.545303,481.909149 
	C36.507759,454.477264 22.723690,425.604218 14.715608,394.177094 
	C14.347550,392.732697 13.889677,391.289124 13.990738,389.379486 
	C13.923018,388.282654 13.866872,387.567291 13.752302,386.497925 
	C13.475888,385.616425 13.144567,385.138519 12.963469,384.292694 
	C11.983586,379.391113 11.047634,374.772430 9.783463,369.991913 
	C8.950044,369.787415 8.558088,369.561737 8.189697,368.778687 
	C7.989306,367.509552 8.135428,366.607330 8.454733,365.399597 
	C8.483725,364.224091 8.917266,363.457123 8.974957,362.309753 
	C8.759104,359.898193 9.158772,357.721619 8.062906,355.350769 
	C6.382401,352.747131 7.228543,350.210266 7.034102,347.388916 
	C7.017905,346.232849 6.988046,345.487213 6.884345,344.375366 
	C5.725587,342.250977 6.357534,340.418121 6.899667,338.269897 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M7.159717,337.500793 
	C7.130407,339.674011 7.036804,341.411469 6.876852,343.579041 
	C3.344372,343.189758 5.706220,340.407349 5.266359,338.670380 
	C4.615733,336.101105 4.505237,333.178619 5.817661,330.196350 
	C6.129703,329.917084 6.601945,329.960175 6.838700,329.976685 
	C7.082112,332.350464 7.088768,334.707764 7.159717,337.500793 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M6.754559,347.245544 
	C8.572800,349.211975 7.661411,351.763519 7.932913,354.578827 
	C4.349940,353.086365 6.394687,350.112000 6.754559,347.245544 
z"/>
<path fill="#F7FCFC" opacity="1.000000" stroke="none" 
	d="
M8.853318,367.756470 
	C9.260016,368.380798 9.314415,368.795471 9.412031,369.520081 
	C9.084229,370.040649 8.713208,370.251221 8.168658,370.730896 
	C6.349794,370.796936 5.618696,370.064484 6.742732,368.201660 
	C7.426243,367.615906 7.928592,367.464844 8.853318,367.756470 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M9.226962,367.567596 
	C8.713477,367.977875 8.221334,367.989563 7.361581,368.000641 
	C7.308611,366.888275 7.623254,365.776581 7.976739,364.317688 
	C8.223707,363.856293 8.431833,363.742065 8.952005,363.799408 
	C9.258802,365.037018 9.253553,366.103027 9.226962,367.567596 
z"/>
<path fill="#D5D6D6" opacity="1.000000" stroke="none" 
	d="
M9.439092,363.799011 
	C9.055908,363.975586 8.847767,363.980164 8.327604,363.977600 
	C8.178623,363.426147 8.341661,362.881775 8.740936,362.170197 
	C9.685642,362.349701 9.939077,362.874908 9.439092,363.799011 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M366.394897,619.663208 
	C365.299042,618.553833 363.903961,619.325256 362.479919,618.728760 
	C360.637024,617.303284 361.043640,616.016907 362.361267,614.517212 
	C363.301208,614.042664 363.981781,613.921326 364.990875,613.769592 
	C366.203430,613.665710 366.938354,613.240540 367.945007,612.611694 
	C368.681335,612.374268 369.120575,612.375427 369.860291,612.613770 
	C370.441833,613.119812 370.643494,613.511230 370.769012,614.278381 
	C370.726990,615.029419 370.598724,615.430054 370.166321,616.009766 
	C369.413300,616.456848 368.839508,616.474121 368.028442,616.610840 
	C367.451080,616.770935 367.340942,616.806274 367.457977,616.821472 
	C367.486938,616.825195 367.601044,616.828369 368.030640,616.702026 
	C368.437683,616.557495 368.614746,616.539307 369.063904,616.520020 
	C369.519043,616.543518 369.702148,616.568176 370.086060,616.790405 
	C370.335175,617.172180 370.383392,617.356506 370.386078,617.826111 
	C370.167236,618.462891 369.940430,618.776367 369.434875,619.238037 
	C368.662903,619.694824 368.095612,619.813843 367.211975,619.643494 
	C366.932434,619.553162 366.562744,619.584167 366.394897,619.663208 
z"/>
<path fill="#D5D6D6" opacity="1.000000" stroke="none" 
	d="
M367.060425,619.887573 
	C367.373016,619.235718 367.813599,618.918335 368.530579,618.533936 
	C369.156036,618.564575 369.501434,618.546997 369.731506,618.202942 
	C369.689392,617.813049 369.759583,617.654358 369.902130,617.245483 
	C371.862762,615.390198 373.832367,615.457642 376.137451,617.069092 
	C376.622772,618.014954 376.646820,618.608215 376.225830,619.578369 
	C373.036255,619.933167 370.161011,621.635925 367.060425,619.887573 
z"/>
<path fill="#F6FBFB" opacity="1.000000" stroke="none" 
	d="
M376.187836,620.218994 
	C375.988495,619.485291 376.011902,619.022644 376.013550,618.212769 
	C376.354126,617.541443 376.775177,617.366821 377.592590,617.499268 
	C378.391449,618.056458 378.862061,618.480286 379.666260,618.954468 
	C379.586395,621.392334 378.130249,621.259644 376.187836,620.218994 
z"/>
<path fill="#928C87" opacity="1.000000" stroke="none" 
	d="
M456.278137,589.777710 
	C455.543640,590.335327 455.063385,590.638733 454.296021,590.993164 
	C440.084198,597.769531 425.721100,603.357544 410.500122,607.618164 
	C409.182526,607.378906 408.170166,607.732300 407.040955,606.947021 
	C406.325317,605.639465 408.072937,606.042480 407.756653,604.812378 
	C409.109772,601.925964 412.192261,602.478333 414.426025,600.778809 
	C414.931732,600.526367 415.143738,600.447693 415.688171,600.313843 
	C418.753387,600.617554 421.197662,600.217285 423.114960,597.481445 
	C424.732025,596.678894 426.160492,596.721252 427.917511,596.640625 
	C429.943024,596.779358 431.257324,596.051575 432.668152,594.704346 
	C433.734650,594.049744 434.618744,593.911743 435.826599,593.738403 
	C437.004791,593.626343 437.791687,593.378296 438.718201,592.626831 
	C439.365143,592.262268 439.757690,592.101440 440.469208,591.886963 
	C442.420349,591.469604 444.021545,591.032715 445.590515,589.712036 
	C446.224335,589.326599 446.613373,589.160706 447.319275,588.942993 
	C449.072968,588.619507 450.345276,588.029175 451.617432,586.758179 
	C452.228638,586.355957 452.609924,586.184875 453.309113,585.968750 
	C455.062134,585.652344 456.324677,585.048889 457.594238,583.772095 
	C458.030823,583.466980 458.219055,583.362854 458.709167,583.140503 
	C461.826782,582.382080 464.077667,580.631104 466.766266,579.027954 
	C467.218811,578.727661 467.404022,578.614807 467.878174,578.356018 
	C469.379974,577.778931 470.508362,577.223145 471.495972,575.884766 
	C471.912170,575.533325 472.093719,575.410400 472.569336,575.139771 
	C474.086700,574.539062 475.269958,574.017334 476.433899,572.828613 
	C477.714203,571.817383 478.927704,571.333740 480.327271,570.531616 
	C481.532166,569.875732 482.443634,569.354492 483.419464,568.369629 
	C485.593414,566.422729 487.147736,564.226868 489.946960,563.062134 
	C491.060516,562.690918 491.738525,562.244141 492.423584,561.260742 
	C497.181793,558.165161 501.031342,554.365723 505.945129,551.421692 
	C507.046173,551.124390 507.784729,551.180359 508.821075,551.682495 
	C509.854614,552.733032 510.017639,553.705444 509.722473,555.107544 
	C509.184723,556.430908 508.239838,556.824219 507.185913,557.628052 
	C506.462799,558.196655 506.031616,558.551941 505.320068,558.971252 
	C492.185120,567.670959 480.159058,577.558777 466.279633,584.646423 
	C463.043549,586.298950 459.676178,587.687927 456.278137,589.777710 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M592.220581,450.715881 
	C591.904480,451.870819 591.637268,452.687836 591.119751,453.708191 
	C590.681641,454.224426 590.454407,454.504791 589.982910,454.929321 
	C589.552002,455.390320 589.364685,455.697266 589.127075,456.293152 
	C588.961731,456.933807 588.866638,457.304596 588.638000,457.944641 
	C588.178955,458.711517 587.813904,459.187408 587.268372,459.905029 
	C586.994019,460.800659 586.889160,461.446259 586.671448,462.400635 
	C586.416992,463.146912 586.155334,463.493500 585.462158,463.872070 
	C583.009399,465.251251 582.800110,467.621490 581.798340,469.931030 
	C579.441589,474.198456 577.605713,478.413574 573.679321,481.570190 
	C573.089661,481.743347 572.843689,481.778076 572.227356,481.774139 
	C571.627136,481.644348 571.397278,481.553223 570.895813,481.211517 
	C569.455872,478.592316 571.032715,476.870026 572.062927,475.053192 
	C576.194641,467.766296 581.401306,461.099701 584.684265,452.941742 
	C584.806030,452.375214 584.862854,452.151947 585.020020,451.601807 
	C585.332886,450.639618 585.566406,450.010498 585.738586,449.020874 
	C585.817993,448.473633 585.851318,448.254944 585.953735,447.711456 
	C586.732666,445.191986 589.061340,443.521820 588.191162,440.474304 
	C588.344604,439.720520 588.525574,439.325989 589.013855,438.745117 
	C589.753357,438.165741 590.310730,437.885620 591.024109,437.308380 
	C591.752563,436.463409 592.075745,435.718781 592.599487,434.723328 
	C594.005127,432.876892 594.660522,431.096069 594.659668,428.741730 
	C594.712402,426.995575 594.780579,425.593536 595.680908,424.038605 
	C596.610107,422.977722 597.659302,422.416565 597.715332,420.812195 
	C597.925171,419.087250 598.285278,417.755096 599.149780,416.223999 
	C600.811340,414.379822 601.429626,412.403900 602.203369,410.104492 
	C602.949585,408.670776 603.640442,407.665955 605.400879,407.551178 
	C605.967834,407.765656 606.166260,407.916229 606.538635,408.397278 
	C606.835938,409.207092 606.898193,409.693726 606.846924,410.548950 
	C606.525024,412.048950 606.249268,413.190430 606.054199,414.701355 
	C605.745728,416.157684 605.355591,417.226593 604.785645,418.584473 
	C604.245850,419.645752 603.555664,420.245392 603.367126,421.467194 
	C603.213623,422.681824 603.089478,423.568756 602.601257,424.714050 
	C600.202576,426.710266 600.169861,429.395172 599.361572,432.098511 
	C598.692993,435.487854 597.238037,438.232880 596.051758,441.435364 
	C595.416077,442.488678 594.713928,443.086090 594.353638,444.280640 
	C593.986694,446.660919 592.721863,448.377808 592.220581,450.715881 
z"/>
<path fill="#928C87" opacity="1.000000" stroke="none" 
	d="
M551.719360,513.695068 
	C548.759766,519.677490 543.835144,523.755554 539.324646,528.561646 
	C539.038086,528.698547 538.627686,528.512695 538.568726,528.301147 
	C538.509827,528.089661 538.087646,528.208191 538.087646,528.208191 
	C538.087646,528.208191 538.466919,528.449341 538.400635,528.688293 
	C538.228760,529.061157 538.123047,529.195068 537.801697,529.475586 
	C537.308594,529.846130 537.083008,530.114502 536.794556,530.667908 
	C531.985535,535.682312 527.282715,540.448975 522.284912,545.260437 
	C520.842285,545.366699 519.833801,544.985413 518.697876,544.076172 
	C518.184998,543.187073 518.105957,542.523132 518.237915,541.500977 
	C518.525574,540.510071 518.867188,539.918762 519.470276,539.086060 
	C520.463257,538.005127 521.411865,537.377869 522.427795,536.318787 
	C528.681763,530.200928 534.405273,524.014648 540.955139,518.705017 
	C542.882507,517.142700 543.685547,515.050903 544.317688,512.432617 
	C544.874390,511.522766 545.446716,511.136841 546.410889,510.724884 
	C547.625854,510.488098 548.512817,510.651550 549.716797,510.707825 
	C550.886963,511.452606 551.246094,512.439514 551.719360,513.695068 
z"/>
<path fill="#BDB9B4" opacity="1.000000" stroke="none" 
	d="
M456.402466,590.057983 
	C455.997620,588.052063 457.677277,587.673950 458.964691,587.075806 
	C471.074921,581.448853 481.955353,573.922241 492.791046,566.185913 
	C496.386871,563.618591 499.110687,559.159546 504.658691,558.993896 
	C503.046387,564.168152 497.786438,565.547668 493.895691,568.348267 
	C482.229614,576.745544 470.420990,585.011230 456.402466,590.057983 
z"/>
<path fill="#BDB9B4" opacity="1.000000" stroke="none" 
	d="
M409.773438,607.317383 
	C423.830505,603.103943 437.039337,597.635437 450.011536,591.550903 
	C451.140930,591.021179 452.153198,589.880127 453.823029,590.777710 
	C452.294373,594.383728 448.516663,594.292419 445.455719,596.052368 
	C443.928253,596.999023 442.602325,597.632263 441.130188,598.620972 
	C439.513275,599.204163 438.164062,599.625122 436.462311,600.090576 
	C435.533081,600.530945 435.004303,600.988647 434.164917,601.614807 
	C433.185120,601.893677 432.493561,601.975220 431.458710,602.103149 
	C424.998810,604.097961 418.882202,606.046448 412.373657,607.998657 
	C411.595673,608.376587 411.138184,608.515503 410.285522,608.226440 
	C409.961761,608.033447 409.998596,608.047180 409.979279,608.053833 
	C409.806580,607.885254 409.653229,607.709961 409.773438,607.317383 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M601.769897,425.335571 
	C601.915161,423.854004 601.985046,422.838470 602.087585,421.442627 
	C602.557434,420.453217 603.092957,419.928009 603.743774,419.133240 
	C604.180054,417.814209 604.447388,416.718842 604.849243,415.308594 
	C605.766663,413.996948 605.708740,412.748474 606.011230,411.303284 
	C606.038391,410.569031 606.053162,410.135681 606.090088,409.377808 
	C607.093872,406.609100 607.519165,404.048767 607.719604,401.060272 
	C607.861450,399.350830 608.217346,398.110138 609.464661,396.841125 
	C610.554260,396.221619 611.346741,396.182556 612.486328,396.693481 
	C612.827637,397.974854 612.839355,399.012604 612.794800,400.437775 
	C612.494568,401.357544 612.136841,401.836609 611.947021,402.706177 
	C611.101685,405.828033 610.302063,408.659576 609.269409,411.761169 
	C607.988342,413.350372 608.320984,415.127502 607.363770,416.831726 
	C606.569641,420.513519 606.087769,423.959137 602.755981,426.360535 
	C602.166565,426.218170 601.930481,426.009918 601.769897,425.335571 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M594.733887,442.128113 
	C595.946228,438.869263 596.992859,435.839783 598.078979,432.435272 
	C599.482239,431.094635 598.972656,428.289703 601.901306,428.742554 
	C600.237793,436.768951 597.271729,444.176239 592.504456,451.005432 
	C589.068726,448.513367 593.750305,446.990540 593.013062,444.388062 
	C593.549316,443.470612 594.074890,442.928955 594.733887,442.128113 
z"/>
<path fill="#BDB9B4" opacity="1.000000" stroke="none" 
	d="
M572.753906,481.214050 
	C576.306580,478.039337 578.071777,474.015594 580.614990,470.138184 
	C581.290344,469.622833 581.743835,469.491974 582.564697,469.764648 
	C579.679565,477.389557 574.972595,483.846100 569.608582,490.179871 
	C567.193787,488.442810 568.572754,486.757141 569.659119,484.741791 
	C570.088745,484.043945 570.361511,483.669098 570.865479,483.047638 
	C571.500183,482.273529 572.052612,481.901520 572.753906,481.214050 
z"/>
<path fill="#928C87" opacity="1.000000" stroke="none" 
	d="
M568.448486,490.776917 
	C568.149841,494.640442 565.277100,496.810028 563.108521,499.747253 
	C562.239624,500.565033 561.503540,500.746399 560.299500,500.466278 
	C559.358459,499.699005 559.151672,498.952240 559.139038,497.753845 
	C559.723755,494.448395 561.394714,492.304016 564.150879,490.497681 
	C564.730042,490.234741 564.973022,490.154785 565.596191,490.017700 
	C566.761230,489.935669 567.500610,490.092743 568.448486,490.776917 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M552.126465,513.902588 
	C550.217651,513.965088 550.042542,512.888306 550.016235,511.337219 
	C549.882996,510.790894 549.773621,510.588806 549.799194,510.070068 
	C551.095337,508.826935 552.853760,508.453003 553.021301,506.186462 
	C553.455627,504.939758 554.020569,504.209137 555.197021,503.571289 
	C556.790161,503.225739 557.895264,503.625366 559.176880,504.558411 
	C558.729004,507.384369 556.741272,509.000061 554.565186,511.208801 
	C553.556702,512.336060 553.013489,513.072998 552.126465,513.902588 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M613.065796,396.783600 
	C612.122192,396.961639 611.428528,396.986176 610.385803,397.017090 
	C607.563599,393.554962 610.565979,390.119904 610.098389,386.271362 
	C610.134705,385.346802 610.255432,384.833923 610.696350,384.016724 
	C611.668213,383.253326 612.444885,383.181793 613.581482,383.657074 
	C613.945435,384.398499 613.985962,384.897675 614.079773,385.771149 
	C614.115723,386.550476 614.098328,386.955536 614.080994,387.665070 
	C613.752563,388.485596 613.424072,389.001587 613.127930,389.843201 
	C612.808960,391.673920 612.232056,393.189362 613.591064,394.803345 
	C613.649841,395.530334 613.482727,396.080200 613.065796,396.783600 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M518.548340,543.759888 
	C519.867065,544.117737 521.062500,543.697937 521.911011,545.017761 
	C521.172546,548.086609 518.243713,548.748779 515.991150,550.620972 
	C513.044800,547.687378 515.531677,546.153015 517.352539,544.143433 
	C517.812988,543.833618 518.019958,543.745850 518.548340,543.759888 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M583.148193,469.769684 
	C582.435120,469.966064 581.993164,469.969238 581.217773,469.952087 
	C581.107178,467.190277 582.027405,464.792786 584.626770,462.993469 
	C585.370544,463.383026 585.542786,463.903748 585.330811,464.892120 
	C585.080261,466.918030 584.343079,468.285339 583.148193,469.769684 
z"/>
<path fill="#928C87" opacity="1.000000" stroke="none" 
	d="
M559.659546,504.605957 
	C558.461731,504.630676 557.501709,504.440765 556.262634,504.118347 
	C554.938171,502.875031 554.923706,501.648865 555.847412,500.068420 
	C557.128113,499.246674 558.086731,499.438354 559.327515,500.197906 
	C560.328918,500.743958 560.806885,501.260590 560.862305,502.379028 
	C560.466675,503.280212 560.181946,503.835754 559.659546,504.605957 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M568.895874,490.874390 
	C568.007629,491.032074 567.293091,491.020447 566.218140,490.989655 
	C565.065369,489.975525 565.460693,488.968719 565.953125,487.671967 
	C566.177917,487.196594 566.277161,487.011414 566.546326,486.562134 
	C567.074951,485.785645 567.460938,485.293182 568.012329,484.530701 
	C568.351746,484.128815 568.501404,483.979218 568.930420,483.676636 
	C569.630127,483.432343 570.048035,483.438538 570.711792,483.754944 
	C571.198608,486.090942 568.520569,487.248657 569.186646,489.883423 
	C569.277832,490.266754 569.069702,490.705078 568.895874,490.874390 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M602.249634,428.628204 
	C599.981445,428.651428 600.312683,431.364960 598.448364,431.981049 
	C598.736328,429.549927 598.845337,426.816284 601.517151,424.966431 
	C601.926208,425.131989 602.007080,425.394501 602.245239,426.041687 
	C602.358826,427.054657 602.315125,427.682922 602.249634,428.628204 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M509.038269,556.080872 
	C508.885712,554.798462 508.972290,553.814026 509.273041,552.204407 
	C510.094147,551.256287 510.737946,551.197144 511.716858,551.426758 
	C512.602051,551.933105 512.952942,552.470215 512.967957,553.461548 
	C512.069092,554.420593 511.285095,555.070190 510.207886,555.838623 
	C509.702271,556.097961 509.489807,556.238403 509.038269,556.080872 
z"/>
<path fill="#BDB9B4" opacity="1.000000" stroke="none" 
	d="
M513.162292,553.711914 
	C512.632446,553.337341 512.411743,552.903687 512.098572,552.241577 
	C512.030884,549.951599 513.523254,550.151794 515.264282,550.302246 
	C515.646179,550.457825 515.813660,550.680725 515.886047,550.799072 
	C515.519653,552.183960 514.537964,552.956970 513.162292,553.711914 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M607.526306,417.006165 
	C606.752563,415.327881 607.460144,413.834198 608.742798,412.223633 
	C608.826050,413.692322 609.648621,415.602234 607.526306,417.006165 
z"/>
<path fill="#D5D6D6" opacity="1.000000" stroke="none" 
	d="
M441.214722,598.819641 
	C441.310913,596.923340 442.863525,596.521179 444.753723,596.114746 
	C444.704193,598.047302 443.156525,598.478882 441.214722,598.819641 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M561.085571,502.694031 
	C560.495972,502.269043 560.240540,501.813416 559.870972,501.118683 
	C559.710754,500.705078 559.664612,500.530548 559.788391,500.145203 
	C560.671692,499.922852 561.385071,499.911316 562.452209,499.895081 
	C563.050781,501.168121 562.441772,502.019012 561.085571,502.694031 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M588.832397,454.203400 
	C589.401917,453.949829 589.821655,453.913818 590.555420,453.894684 
	C591.090393,454.847717 591.059143,455.725525 589.955383,456.488708 
	C589.277161,456.440369 588.996094,456.241455 588.681274,455.703430 
	C588.530823,455.104340 588.564636,454.758514 588.832397,454.203400 
z"/>
<path fill="#BDB9B4" opacity="1.000000" stroke="none" 
	d="
M508.503967,555.874023 
	C508.983429,555.823792 509.167755,555.864685 509.633392,555.931519 
	C509.532410,557.102051 508.709076,557.715820 507.221130,557.882446 
	C506.957764,556.953552 507.326111,556.279114 508.503967,555.874023 
z"/>
<path fill="#BDB9B4" opacity="1.000000" stroke="none" 
	d="
M585.473267,465.142639 
	C585.116882,464.764465 585.064758,464.242676 584.994324,463.328369 
	C585.328308,462.877228 585.680664,462.818634 586.295776,462.734741 
	C586.998474,463.711517 586.638367,464.440704 585.473267,465.142639 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M536.973755,530.884888 
	C535.692383,529.909180 536.319397,529.376709 537.541931,528.876831 
	C538.028381,528.990356 538.239014,529.164734 538.237549,529.690186 
	C537.770020,530.312195 537.514526,530.583191 536.973755,530.884888 
z"/>
<path fill="#D5D6D6" opacity="1.000000" stroke="none" 
	d="
M434.200867,601.838989 
	C434.073151,600.934021 434.449127,600.223511 435.787567,600.123047 
	C435.925629,601.027100 435.573700,601.765503 434.200867,601.838989 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M612.170044,402.821289 
	C610.944275,402.156067 611.189148,401.507721 612.480591,400.905273 
	C612.638672,401.432159 612.538818,402.039154 612.170044,402.821289 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M587.449097,460.073578 
	C587.155640,459.562927 587.212463,458.970764 587.474121,458.153564 
	C587.852295,457.793396 588.025635,457.658325 588.623962,457.924866 
	C588.632446,458.881653 588.215881,459.436859 587.449097,460.073578 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M589.230103,458.165222 
	C589.048950,458.326385 589.058594,458.362610 589.043091,458.357239 
	C588.755554,457.998199 588.597717,457.597717 588.811401,456.611053 
	C589.084839,456.065033 589.447327,456.394165 589.535889,456.469940 
	C589.553406,457.031830 589.482300,457.517975 589.230103,458.165222 
z"/>
<path fill="#BDB9B4" opacity="1.000000" stroke="none" 
	d="
M538.284851,529.898621 
	C537.999146,529.836243 537.972778,529.631287 537.882141,529.121216 
	C537.817810,528.816040 537.888489,528.394714 537.922729,528.183838 
	C538.136169,527.884094 538.315369,527.795227 538.777039,527.807861 
	C539.059448,527.909424 539.124939,528.308289 539.081543,528.503418 
	C538.873474,529.051025 538.708862,529.403503 538.284851,529.898621 
z"/>
<path fill="#928C87" opacity="1.000000" stroke="none" 
	d="
M554.203491,511.615906 
	C554.099915,511.599060 554.397339,511.439728 554.455627,511.385925 
	C554.513916,511.332153 554.307007,511.632782 554.203491,511.615906 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M570.576294,146.982605 
	C575.660706,151.201462 577.881958,157.079193 580.956604,162.286118 
	C591.614197,180.335220 599.946655,199.469452 606.173096,219.516571 
	C606.952271,222.025360 608.275085,224.351135 607.943604,227.730896 
	C604.185913,228.427216 604.530823,225.371033 604.055969,223.389664 
	C601.642029,213.317093 596.770874,204.213806 593.021667,194.671753 
	C592.776917,194.048889 592.200317,193.642838 591.263184,193.182800 
	C590.326660,192.643066 589.831116,192.160141 589.489136,191.162018 
	C589.424683,190.042328 589.895569,189.267624 589.393311,188.188354 
	C588.921570,187.375961 588.634277,186.810745 588.213501,185.937225 
	C585.752686,178.892700 583.354065,172.193237 578.087708,166.612000 
	C577.539612,166.018951 577.308472,165.624435 577.045410,164.872375 
	C576.709412,162.861679 576.476440,161.169037 574.903320,159.684174 
	C574.552124,159.281174 574.416870,159.114517 574.086426,158.691910 
	C573.184875,157.182999 571.671875,157.077026 570.474243,155.916046 
	C569.231140,153.803421 568.780273,151.832733 568.852600,149.347992 
	C569.089905,148.140198 569.452087,147.438599 570.576294,146.982605 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M620.446655,327.833801 
	C620.507874,333.400024 620.231262,338.736755 619.941650,344.534729 
	C619.932312,346.887695 620.243469,348.797729 619.326660,350.966980 
	C618.315186,351.724670 617.517456,351.853333 616.291992,351.502686 
	C614.396545,349.798248 614.875244,347.683105 614.210205,345.474762 
	C613.977661,344.252197 614.006042,343.433289 614.281677,342.227020 
	C615.910339,339.814209 615.629517,337.449890 615.648499,335.152618 
	C615.669312,332.630737 615.787903,330.157867 618.201416,328.072449 
	C619.028992,327.575378 619.556396,327.501160 620.446655,327.833801 
z"/>
<path fill="#685E5C" opacity="1.000000" stroke="none" 
	d="
M620.122925,316.593567 
	C620.017456,317.446991 620.000122,317.891602 620.027344,318.667542 
	C620.235535,319.969238 620.052124,320.887421 619.467407,322.087036 
	C618.441467,323.337677 617.540588,324.182770 615.863342,324.406555 
	C614.398071,323.849457 614.066772,322.858856 613.802368,321.391663 
	C613.734497,320.437683 613.753235,319.890503 613.866577,318.933472 
	C615.118408,315.343658 613.992126,311.854156 615.468994,308.324646 
	C616.803467,307.179138 617.842896,307.445587 619.150330,308.465729 
	C620.622070,311.149536 620.523193,313.656128 620.122925,316.593567 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M619.167725,308.982941 
	C618.119019,308.715149 617.412964,308.352051 616.409485,307.951904 
	C615.405212,307.364014 615.180420,306.591370 615.130737,305.335083 
	C616.490479,301.452881 614.241333,297.171295 617.941711,293.959167 
	C619.163818,293.512299 619.915894,293.630920 620.583801,294.781494 
	C620.715393,297.478485 620.753845,299.775848 620.761475,302.504150 
	C620.404602,304.935822 621.706299,307.270294 619.167725,308.982941 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M613.682251,244.832336 
	C613.878540,245.493546 613.912354,245.924469 613.943726,246.679779 
	C613.854553,247.518753 613.619507,247.953384 612.902710,248.488403 
	C611.814392,248.879532 611.071289,248.846054 610.026245,248.366333 
	C609.250183,247.557297 609.020569,246.860321 608.824219,245.773773 
	C608.667419,244.499481 608.676819,243.562775 608.283203,242.339569 
	C608.072632,241.566422 607.974670,241.119690 607.836670,240.332306 
	C607.502869,237.736771 607.064941,235.528320 605.634766,233.254028 
	C605.357178,232.446930 605.336121,231.958664 605.529663,231.108459 
	C606.140564,230.102203 606.770630,229.689224 607.944275,229.537521 
	C611.037048,232.616196 610.528809,236.764816 612.018555,240.631195 
	C612.091309,241.413177 612.117493,241.812881 612.152588,242.512878 
	C612.494751,243.500153 613.041992,244.024689 613.682251,244.832336 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M618.866577,309.500854 
	C620.997864,307.451904 618.404663,304.789459 620.431396,303.000702 
	C622.759399,307.560333 622.655273,312.199738 620.428955,316.926453 
	C617.976196,314.910583 619.397156,312.265015 618.866577,309.500854 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M615.691162,257.819702 
	C618.359863,261.748566 617.990540,265.960266 618.025024,270.549866 
	C617.040649,271.541138 616.384766,270.777679 615.331909,270.278503 
	C614.636841,269.911011 614.263245,269.657745 613.696899,269.098907 
	C613.173828,268.178558 613.085266,267.491608 613.160522,266.434998 
	C614.119995,263.666351 613.951172,261.075867 614.562134,258.273499 
	C614.957397,257.859863 615.169189,257.751465 615.691162,257.819702 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M618.629761,322.266846 
	C619.054260,321.043793 619.265869,320.182129 619.774658,319.159668 
	C623.679749,321.344940 621.697754,324.584198 621.111145,327.805786 
	C620.361328,328.070892 619.938232,328.078491 619.198364,328.121216 
	C618.470581,327.754822 618.172729,327.281952 617.898193,326.323822 
	C617.720520,324.761810 617.963135,323.675476 618.629761,322.266846 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M609.795654,248.239716 
	C610.794434,247.971146 611.474609,248.019882 612.494873,248.092972 
	C613.466614,248.323608 613.763184,248.811111 613.942993,249.710785 
	C613.991760,250.433319 614.020386,250.858597 614.078125,251.602264 
	C614.848145,252.952957 615.030457,254.085571 614.497070,255.699860 
	C613.789673,256.467041 613.237427,256.672943 612.176636,256.643311 
	C608.992188,254.461227 608.612305,251.684021 609.795654,248.239716 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M612.300598,240.770660 
	C609.603516,237.924042 609.979797,233.872482 608.189209,230.227814 
	C607.583557,229.611572 607.453186,229.169846 607.670288,228.357239 
	C607.838745,228.039200 608.065430,227.972153 608.181274,227.937622 
	C611.865112,231.387772 611.610474,236.155930 612.300598,240.770660 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M620.786377,294.744202 
	C620.177917,294.910645 619.678894,294.640198 618.893311,294.362976 
	C618.447266,294.161224 618.287720,293.966217 617.965149,293.429626 
	C617.330139,291.379974 616.716003,289.690155 617.263062,287.505005 
	C617.805542,286.438385 618.414062,286.002136 619.580811,285.900299 
	C621.521179,288.619812 620.919556,291.496124 620.786377,294.744202 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M619.969238,285.578247 
	C619.492371,286.256805 619.027100,286.526062 618.319336,286.914612 
	C617.344543,287.078644 616.674988,286.895477 615.829590,286.213684 
	C615.395691,285.498718 615.297180,285.030212 615.320190,284.180573 
	C615.692688,282.618378 616.131409,281.481445 617.502563,280.539185 
	C618.338745,280.330017 618.820496,280.387512 619.552979,280.822662 
	C619.872437,282.442474 619.926636,283.805695 619.969238,285.578247 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M618.838562,355.750732 
	C620.468994,357.750275 620.105469,359.627014 619.221069,361.749573 
	C617.581482,362.272675 617.076782,361.254028 616.327942,359.994629 
	C615.881409,358.522064 615.914429,357.448242 616.638672,356.078308 
	C617.399292,355.495178 617.930847,355.422607 618.838562,355.750732 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M615.754395,269.337036 
	C616.519714,269.556152 617.018494,270.126862 617.763428,270.847961 
	C618.687073,272.335938 619.112000,273.730408 618.957886,275.623901 
	C618.467346,276.370972 617.923523,276.528625 616.909058,276.302826 
	C614.503662,274.247070 614.329651,272.072571 615.754395,269.337036 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M619.162842,355.587769 
	C618.736145,355.989105 618.282959,356.012939 617.491333,356.049683 
	C616.609924,355.987000 616.144470,355.755341 615.544312,355.029785 
	C614.960388,353.631989 614.982117,352.600677 615.850708,351.351868 
	C616.832947,351.044403 617.508484,350.991364 618.521606,350.910248 
	C619.038452,351.067780 619.217651,351.253387 619.284790,351.809387 
	C619.160645,353.189972 619.148499,354.200104 619.162842,355.587769 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M619.517395,352.039459 
	C619.119263,351.964325 619.065796,351.748810 618.935730,351.207764 
	C619.029968,349.092468 619.200745,347.302795 619.650024,345.254517 
	C621.583008,347.313202 621.608887,349.614685 619.517395,352.039459 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M616.759521,276.328278 
	C617.454956,276.006531 617.881775,275.999237 618.627991,275.993378 
	C620.467468,277.152893 619.846313,278.804474 619.877991,280.685547 
	C619.393616,281.059235 618.968994,281.039154 618.223938,281.013855 
	C616.403015,279.886475 615.883423,278.446930 616.759521,276.328278 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M618.442871,363.736328 
	C619.004395,365.775970 619.260620,367.636993 618.039429,369.708862 
	C617.588013,370.104614 617.318970,370.149963 616.753845,369.910706 
	C615.632202,368.067261 615.665039,366.460144 616.390625,364.467224 
	C617.008362,363.710205 617.502991,363.523956 618.442871,363.736328 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M570.972778,146.642761 
	C570.641541,147.523636 570.299805,148.046295 569.896851,148.889069 
	C569.394043,149.474762 568.917297,149.556244 568.080200,149.299362 
	C567.446228,148.703918 567.255554,148.243057 567.168518,147.356293 
	C567.284241,145.944000 567.699890,145.034164 568.603149,143.958374 
	C569.357666,143.499847 569.845520,143.463165 570.611084,143.859161 
	C570.876099,144.122238 570.906494,144.131439 570.886597,144.139908 
	C570.898560,144.860428 570.930420,145.572495 570.972778,146.642761 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M618.859558,363.601013 
	C618.398071,363.943237 617.988342,363.965118 617.269165,363.992432 
	C616.426086,364.157776 615.976624,364.026031 615.429993,363.270721 
	C615.032593,362.173889 615.059998,361.419739 615.495239,360.340027 
	C615.913757,359.886810 616.137451,359.763885 616.698975,359.821106 
	C617.516479,360.559814 617.996155,361.118439 618.709351,361.829437 
	C618.932373,362.414795 618.921814,362.847717 618.859558,363.601013 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M614.281921,256.203339 
	C613.975586,254.909027 613.978271,253.820770 614.044067,252.326599 
	C616.180359,252.232285 615.908752,253.853973 615.967285,255.654358 
	C615.556030,256.365601 615.100220,256.482452 614.281921,256.203339 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M613.651733,255.999481 
	C614.412781,256.002930 614.852539,256.008575 615.620972,256.020813 
	C615.966309,256.464722 615.982910,256.902069 616.000488,257.667877 
	C615.803345,258.000427 615.605286,258.004517 615.110352,258.022156 
	C614.161133,258.612823 613.404968,258.767151 612.214233,258.389374 
	C611.564758,257.716248 611.462524,257.202545 611.800415,256.329590 
	C612.473816,256.006683 612.902161,256.004181 613.651733,255.999481 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M616.364136,369.788635 
	C616.920227,369.965881 617.108154,369.984741 617.576538,370.031433 
	C617.862793,370.472107 617.868469,370.885010 617.817261,371.602478 
	C617.352234,371.930847 616.944092,371.954620 616.227295,371.985229 
	C615.252991,372.034851 614.755493,371.783234 614.697144,371.082886 
	C614.622742,370.189209 615.172119,369.765961 616.364136,369.788635 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M614.227051,249.835358 
	C613.627319,249.567184 613.291443,249.126312 612.895264,248.401398 
	C613.048462,247.832016 613.261902,247.546677 613.708374,247.132751 
	C615.055664,247.697876 615.174561,248.597321 614.227051,249.835358 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M613.854858,244.743408 
	C612.926208,244.907288 612.197144,244.545578 612.139526,243.144882 
	C613.005127,243.058487 613.760437,243.397186 613.854858,244.743408 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M409.705811,607.067749 
	C410.046997,607.100037 410.011200,607.580566 409.985596,607.820557 
	C405.880493,609.780396 402.055511,612.375427 397.152893,611.472473 
	C396.546936,610.646423 395.912262,610.213562 395.870483,609.094421 
	C396.377014,608.430542 396.801300,608.188965 397.621948,607.930298 
	C400.940918,608.021179 403.233704,605.428101 406.551147,606.038452 
	C407.687836,606.507141 408.526245,606.771301 409.705811,607.067749 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M387.067200,615.177917 
	C386.309998,615.391052 385.644409,615.307495 384.654480,615.132935 
	C383.860321,615.370178 383.324921,615.481323 382.514801,615.628967 
	C381.139099,615.858032 380.014526,615.972229 378.465271,616.064575 
	C377.932739,615.834656 377.824829,615.626526 377.814819,615.080444 
	C380.851532,613.361938 383.422394,611.241516 386.963196,610.470093 
	C388.533386,611.180359 388.278442,612.352966 388.156982,613.708374 
	C387.721588,614.288635 387.440186,614.584900 387.067200,615.177917 
z"/>
<path fill="#928C87" opacity="1.000000" stroke="none" 
	d="
M388.302979,614.003174 
	C387.819397,613.236938 386.975189,612.570923 388.005341,611.173645 
	C389.135590,610.042114 390.072113,609.944214 391.394287,610.089722 
	C393.180023,610.658447 393.322388,611.697510 392.747162,613.271484 
	C391.316559,614.272461 389.989960,614.417175 388.302979,614.003174 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M392.924683,613.662964 
	C391.225067,612.922668 392.044617,612.072388 392.225830,611.128479 
	C391.957520,610.752502 391.836304,610.514832 391.955688,609.955505 
	C392.684448,609.377441 393.203827,609.267273 394.144226,609.417969 
	C395.009644,609.840820 395.328857,610.264343 395.260681,611.141357 
	C395.104950,612.749634 394.853149,613.767090 392.924683,613.662964 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M395.349365,611.372803 
	C394.849731,611.105652 394.670990,610.733582 394.242401,610.171875 
	C393.622162,609.582642 393.463959,609.111511 393.675659,608.214417 
	C394.277466,607.555542 394.766937,607.425720 395.662994,607.616333 
	C396.148529,607.990295 396.273590,608.217468 396.208801,608.784180 
	C396.283356,609.633789 396.547760,610.143982 396.912781,610.927307 
	C396.565643,611.222961 396.117920,611.245361 395.349365,611.372803 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M410.115479,608.242859 
	C410.410858,608.027893 410.859924,608.022278 411.645355,608.009583 
	C411.542480,608.653442 411.005035,608.930481 410.115479,608.242859 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M616.790649,369.526337 
	C615.820557,370.153564 614.951843,370.390961 615.714478,371.821747 
	C615.607178,374.412415 615.295776,376.832794 615.045044,379.665741 
	C615.058472,380.808075 615.011230,381.537872 614.939453,382.633606 
	C614.590942,383.061371 614.334045,383.227173 614.024536,383.698120 
	C613.221924,383.954865 612.538879,384.010406 611.512451,384.084229 
	C610.267151,383.484558 609.812927,382.528778 609.917908,381.540558 
	C610.562683,375.471497 612.509583,369.651581 613.451294,363.632935 
	C613.550842,362.996735 614.330627,362.705841 615.439758,362.746948 
	C616.074707,363.175842 616.285950,363.457428 616.728516,363.868469 
	C616.922852,365.700500 616.885925,367.403076 616.790649,369.526337 
z"/>
<path fill="#928C87" opacity="1.000000" stroke="none" 
	d="
M377.639404,614.423645 
	C377.840393,614.951050 377.878967,615.169434 377.979126,615.715332 
	C377.979187,616.396790 377.917755,616.750793 377.888550,617.368774 
	C377.492920,617.688721 377.065063,617.744812 376.314453,617.833252 
	C374.451202,616.272644 372.507935,617.415405 370.377014,617.046814 
	C369.727722,616.985352 369.481018,616.975342 368.768372,616.622437 
	C368.724091,616.029663 369.145691,615.779724 369.785645,615.231445 
	C370.683960,614.322754 371.416260,613.796509 372.619446,613.391296 
	C373.613617,613.084412 374.298920,613.010132 375.341675,613.056030 
	C376.389862,613.249451 376.993500,613.577026 377.639404,614.423645 
z"/>
<path fill="#928C87" opacity="1.000000" stroke="none" 
	d="
M382.572205,615.786316 
	C382.756104,615.526306 383.248505,615.308777 384.035522,615.066650 
	C384.278625,615.200928 384.227051,615.359863 384.148804,615.768188 
	C383.708344,615.954651 383.294525,615.891724 382.572205,615.786316 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M77.880112,514.738220 
	C77.939354,515.538818 77.949745,515.959534 77.961433,516.696045 
	C72.767853,516.056885 69.041534,512.703430 66.041748,508.802094 
	C63.682953,505.734375 62.047215,505.871368 59.912827,508.596344 
	C59.199535,509.506989 58.224998,510.351562 57.887897,511.393921 
	C56.542614,515.553467 54.764011,519.365295 51.435196,522.386963 
	C50.514412,523.222717 49.607220,524.748291 49.681149,525.893616 
	C50.100292,532.387146 44.848728,534.801575 41.149258,538.367554 
	C39.846004,539.623718 38.446766,540.427307 36.679604,539.674805 
	C35.011032,538.964233 34.766930,537.327698 35.046028,535.841919 
	C35.835598,531.638489 32.556183,529.495483 30.379456,527.091675 
	C27.950628,524.409424 26.186640,521.589844 25.148695,518.188660 
	C24.817505,517.103455 24.423748,515.824463 23.627186,515.126587 
	C14.457232,507.092224 17.785246,496.675385 18.250050,486.881531 
	C18.598146,479.546783 19.404718,472.233246 20.048779,464.913910 
	C20.133345,463.952820 20.141653,462.540802 20.732210,462.136414 
	C27.318954,457.626526 22.798443,452.604492 21.190754,448.024597 
	C20.407608,445.793640 20.042698,444.330719 21.151957,442.086212 
	C23.146082,438.051361 20.915924,434.020172 20.103384,430.070679 
	C17.575592,417.783936 14.827342,405.542664 12.210419,393.273956 
	C12.086643,392.693634 12.403012,392.019440 12.776692,391.191162 
	C15.785716,391.548340 15.027559,394.091797 15.436749,395.713226 
	C23.734955,428.594940 38.200916,458.681580 56.878567,486.800873 
	C62.842979,495.780396 69.128532,504.591827 76.651611,512.891113 
	C77.328583,513.475220 77.621162,513.887451 77.880112,514.738220 
z"/>
<path fill="#D5D6D6" opacity="1.000000" stroke="none" 
	d="
M77.186340,513.747192 
	C75.052750,513.928406 74.155098,512.525940 73.098656,511.206543 
	C55.060455,488.678375 40.130005,464.201233 28.584133,437.807587 
	C22.081459,422.942535 16.910248,407.486115 13.307604,391.253906 
	C13.028652,390.548187 13.018317,390.102966 12.984735,389.324341 
	C13.131169,388.988861 13.300853,388.986847 13.724850,388.991425 
	C17.367586,399.340454 20.568878,409.748749 24.182690,420.011841 
	C32.143120,442.618988 43.580940,463.499939 56.635864,483.864319 
	C61.835346,489.032623 65.378395,495.073456 69.570206,500.619415 
	C71.571136,503.266846 73.493408,505.970978 75.619728,508.525391 
	C76.787056,509.927734 77.905708,511.423767 77.186340,513.747192 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M85.001404,525.374146 
	C86.046829,525.453796 86.735657,526.202942 87.035217,527.646484 
	C85.593491,527.963257 84.987877,527.138489 85.001404,525.374146 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M231.527359,612.347900 
	C218.645721,609.539795 206.523422,605.154541 194.581528,600.263916 
	C177.937820,593.447693 162.285309,584.669067 147.237961,574.935791 
	C136.413849,567.934265 126.241821,559.918213 115.865997,552.237061 
	C114.317162,551.090454 112.698952,549.763306 111.948425,547.429199 
	C112.385704,546.419373 113.082008,546.167664 114.236481,546.097839 
	C115.086319,546.229675 115.534111,546.411194 116.204704,546.912231 
	C117.326569,548.462463 118.426765,549.507629 120.178955,550.308838 
	C122.628609,552.143311 124.885284,553.683350 127.144775,555.743408 
	C128.034225,556.780273 128.746979,557.527649 129.934906,558.190735 
	C130.901474,558.753723 131.563995,559.220032 132.389648,559.968018 
	C133.136017,560.758728 133.642548,561.365967 134.566956,561.964172 
	C134.994034,562.238098 135.165726,562.350159 135.593750,562.638672 
	C136.711777,563.454529 137.626495,564.005005 138.913055,564.606079 
	C156.541290,576.531555 174.626190,586.953369 193.774673,595.458313 
	C201.790146,599.018433 209.756607,602.781921 218.565521,604.138855 
	C220.192825,604.389587 221.764084,605.017578 223.541107,605.983093 
	C224.884262,606.966492 225.902145,607.825134 227.676910,607.766235 
	C229.374741,607.880066 230.703125,608.128723 232.233337,608.930298 
	C232.695572,609.265747 232.863754,609.422241 233.188385,609.885254 
	C233.337738,610.420410 233.330627,610.649109 233.146637,611.170898 
	C232.622742,611.760193 232.240067,611.999390 231.527359,612.347900 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M77.083252,514.240967 
	C74.794029,507.209808 68.928627,502.897369 65.380692,496.987518 
	C62.844341,492.762634 59.337578,489.144501 56.985847,484.375061 
	C57.701694,484.019531 58.470078,484.011047 59.621758,484.002563 
	C62.210094,484.625916 61.768051,487.225891 63.560791,488.502441 
	C64.261032,488.779236 64.663612,488.944122 65.359665,489.282410 
	C68.105003,493.285522 71.647842,496.380890 73.486588,501.031677 
	C73.988449,502.328522 74.248215,503.381226 75.337914,504.337769 
	C76.244347,505.156067 76.854164,505.807739 77.624771,506.782715 
	C78.736984,509.696930 81.667686,511.351990 81.199249,514.794922 
	C80.200233,515.046936 79.442520,515.037231 78.306885,515.072876 
	C77.652138,514.936096 77.412598,514.713806 77.083252,514.240967 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M96.204819,531.577515 
	C89.752495,528.347778 85.729980,522.657898 81.918343,516.409668 
	C85.321381,515.380371 86.218697,519.053162 88.997231,520.170166 
	C90.595665,521.368713 91.714066,522.546326 92.736092,524.267517 
	C93.527000,527.051819 96.334236,528.297363 96.204819,531.577515 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M89.226517,520.652344 
	C85.876450,520.765198 84.893723,517.584900 82.233856,516.158875 
	C81.798553,515.746521 81.613335,515.498474 81.157997,515.179688 
	C80.847275,511.975800 77.250977,510.736023 77.046021,507.338226 
	C77.941551,506.234924 79.081848,506.291138 79.728714,507.030182 
	C83.353409,511.171417 87.769478,514.756897 89.226517,520.652344 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M110.268295,545.111694 
	C106.243805,545.009949 104.715492,542.266296 102.972076,539.400024 
	C103.733276,538.172363 104.758965,537.934814 106.303810,538.127502 
	C108.720924,539.124695 110.549988,540.257385 111.650925,542.742249 
	C111.715530,544.001282 111.430763,544.720764 110.268295,545.111694 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M238.015823,614.905640 
	C237.556137,615.163940 237.112839,615.091125 236.333069,614.995483 
	C235.095474,614.401733 234.194382,613.830811 233.143250,612.967896 
	C232.654663,612.350586 232.523544,611.951721 232.792740,611.237915 
	C233.012939,610.986755 233.034988,610.963867 233.046051,610.952393 
	C233.387283,610.643311 233.751877,610.395508 234.466583,610.098755 
	C235.229248,609.942322 235.673264,609.908142 236.454803,609.913391 
	C237.237656,609.966370 237.677933,610.049561 238.417572,610.317017 
	C238.889679,610.612854 239.054016,610.768127 239.284683,611.256836 
	C239.262558,611.799744 239.174088,612.009338 238.763947,612.105042 
	C238.305588,612.852295 238.168900,613.713379 238.015823,614.905640 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M107.067719,538.719360 
	C105.853035,539.068115 104.790581,539.040100 103.327888,539.034058 
	C102.107964,538.164185 101.288277,537.272156 100.209442,536.220459 
	C99.601227,535.622681 99.457405,535.125122 99.687531,534.202454 
	C103.858948,532.811646 105.901978,534.984863 107.067719,538.719360 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M109.949760,545.341187 
	C110.206474,544.579529 110.541710,544.125732 110.900497,543.374207 
	C114.033363,541.812744 115.039734,543.594421 115.247871,546.587708 
	C114.247208,546.977112 113.466187,546.992737 112.294220,547.047852 
	C111.023796,546.939636 110.293686,546.597290 109.949760,545.341187 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M100.178284,533.619629 
	C100.058159,534.414551 100.031822,534.884521 99.977890,535.707642 
	C97.917595,535.840027 96.767181,534.558105 95.940903,532.468323 
	C95.862915,532.144226 95.978905,532.013977 96.034454,531.946777 
	C96.467293,531.327271 96.830666,530.758240 97.907822,530.692566 
	C99.308800,531.282043 100.025940,532.101257 100.178284,533.619629 
z"/>
<path fill="#928C87" opacity="1.000000" stroke="none" 
	d="
M232.735779,611.017090 
	C232.993393,611.364441 232.973846,611.742065 232.973755,612.397827 
	C232.593155,612.696594 232.193085,612.717346 231.513214,612.626526 
	C231.246887,611.696106 231.646805,611.199829 232.735779,611.017090 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M271.367065,621.798828 
	C270.825226,620.797058 270.600403,619.936340 269.172668,620.753662 
	C267.964172,620.939514 266.916351,620.911682 265.477936,620.842163 
	C264.453979,620.254272 264.154877,619.554199 264.193970,618.338928 
	C264.537170,617.186218 265.053558,616.638367 266.148926,616.186401 
	C266.997131,616.028503 267.483307,616.032410 268.304871,616.201172 
	C269.644165,616.775269 270.649658,617.245728 272.156372,617.124573 
	C272.975464,617.189819 273.423828,617.332458 274.121338,617.790161 
	C274.749298,618.738464 274.785736,619.453857 274.279266,620.485107 
	C274.038025,620.973267 274.022278,621.162476 273.984344,621.634766 
	C273.219177,621.902100 272.476196,621.886475 271.367065,621.798828 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M253.364944,616.750488 
	C252.588470,616.864319 252.184921,616.835999 251.480621,616.767212 
	C250.445648,616.258118 250.118576,615.544739 249.957779,614.313843 
	C249.994446,613.358032 250.139954,612.835571 250.629791,612.016113 
	C251.610306,611.238770 252.397446,611.126404 253.604309,611.452942 
	C254.610016,612.198120 254.875671,612.946350 254.946335,614.179810 
	C254.775650,615.400818 254.396011,616.086609 253.364944,616.750488 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M263.159393,618.945190 
	C261.345795,618.762756 259.386383,619.718506 257.978699,617.682983 
	C257.898071,616.837891 258.068085,616.393066 258.643921,615.759521 
	C259.157349,615.438354 259.386536,615.350220 259.982513,615.221680 
	C261.731018,615.252319 262.609711,616.027710 263.305847,617.564026 
	C263.401886,618.158203 263.386993,618.402283 263.159393,618.945190 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M259.228210,615.587219 
	C258.764496,616.215149 258.539642,616.553833 258.092865,617.113647 
	C257.444702,617.276611 257.018463,617.218384 256.268982,617.163452 
	C255.469772,616.452148 255.788651,615.626709 255.642838,614.552734 
	C255.866318,613.582458 256.264893,613.069763 257.144409,612.543701 
	C257.960968,612.375122 258.428497,612.453918 259.148621,612.887451 
	C259.761810,613.853882 259.778870,614.572083 259.228210,615.587219 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M255.722687,614.804321 
	C256.678467,615.561462 256.406281,616.139832 256.042847,616.942261 
	C255.167038,618.251404 254.262955,618.155884 253.142914,617.170532 
	C253.263611,616.412903 253.535233,615.933105 253.899994,615.191406 
	C254.414688,614.588318 254.892578,614.464600 255.722687,614.804321 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M250.740509,613.898926 
	C251.023880,614.822815 251.078262,615.460999 251.156250,616.412903 
	C250.112228,617.668518 249.200623,617.500122 248.210358,616.172974 
	C247.992279,616.006042 247.831421,615.657471 247.755035,615.482483 
	C247.678650,615.307495 247.910522,615.057556 248.015839,614.923462 
	C248.655899,613.864807 249.361389,613.287170 250.740509,613.898926 
z"/>
<path fill="#BDB9B4" opacity="1.000000" stroke="none" 
	d="
M263.013947,619.538452 
	C262.963074,619.041687 262.979431,618.839417 263.001892,618.332886 
	C263.422760,617.664917 263.903076,617.523254 264.724060,617.881348 
	C265.011688,618.822449 265.024109,619.485413 265.061920,620.474365 
	C264.210144,620.910156 263.466187,620.743652 263.013947,619.538452 
z"/>
<path fill="#D5D6D6" opacity="1.000000" stroke="none" 
	d="
M12.713055,384.177429 
	C13.225714,384.514648 13.531881,385.019501 13.765965,385.834167 
	C12.834175,385.850525 11.938197,385.581055 12.713055,384.177429 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M239.166779,611.222534 
	C238.514145,611.124756 238.083908,611.089905 237.332001,611.018188 
	C236.243164,610.152588 235.947220,609.186768 236.300247,607.710938 
	C236.897736,606.641052 237.580780,606.455383 238.709000,606.637451 
	C240.553421,607.669678 242.074158,608.559021 244.306519,608.273560 
	C245.134705,608.316528 245.587219,608.461914 246.274017,608.956360 
	C247.037674,610.203735 247.068893,611.210327 246.566879,612.594116 
	C246.156418,613.091980 245.934250,613.238464 245.371170,613.177307 
	C244.539459,612.959961 244.048645,612.950317 242.906586,612.905518 
	C241.722656,612.899231 241.189987,612.928040 240.277588,613.090210 
	C239.557541,612.968262 239.217239,612.713013 238.659607,612.224487 
	C238.442276,611.991150 238.840851,612.063232 239.042526,612.081787 
	C239.573624,611.878296 239.621948,611.606689 239.166779,611.222534 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M250.986786,613.831909 
	C250.201996,614.319580 249.434509,614.454468 248.394073,614.689453 
	C248.028336,614.637390 247.935532,614.485291 247.673431,614.126343 
	C247.423965,613.708313 247.343765,613.497131 247.203293,612.950928 
	C247.157364,612.155334 247.254578,611.712830 247.642883,611.014038 
	C248.258179,610.504395 248.696625,610.382874 249.504227,610.426758 
	C250.265320,610.706787 250.603363,611.012756 250.957428,611.734619 
	C251.030746,612.539978 251.017426,613.009521 250.986786,613.831909 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M245.243652,613.250244 
	C245.226898,612.911072 245.423508,612.852600 245.913818,612.702515 
	C246.394180,612.594788 246.580826,612.578796 247.006348,612.711670 
	C247.314789,613.034973 247.384369,613.209290 247.472412,613.664673 
	C246.812927,613.807434 246.134979,613.669189 245.243652,613.250244 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M242.253632,613.043457 
	C242.255325,612.870422 242.540970,612.887390 242.681931,612.890137 
	C242.760147,613.225769 242.754227,613.658875 242.253632,613.043457 
z"/>
<path fill="#BDB9B4" opacity="1.000000" stroke="none" 
	d="
M247.491760,613.937500 
	C247.490875,613.945679 247.276810,613.531738 247.183289,613.318298 
	C247.252289,612.942932 247.414825,612.781067 247.771042,612.903564 
	C247.964737,613.187988 247.733948,613.552246 247.619049,613.735840 
	C247.504166,613.919495 247.492661,613.929382 247.491760,613.937500 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M569.221313,143.786255 
	C568.742004,144.863739 568.494324,145.633621 568.124878,146.687683 
	C567.833069,147.111633 567.663147,147.251404 567.176636,147.301910 
	C565.765869,145.859528 564.346985,144.976562 562.468262,144.183014 
	C562.036987,143.849106 561.876831,143.699142 561.514893,143.288010 
	C560.521545,141.678879 560.009460,140.251236 560.111450,138.344574 
	C560.219971,137.830170 560.286743,137.631805 560.523926,137.176727 
	C560.864136,136.811996 561.033936,136.703964 561.487427,136.514328 
	C562.147339,136.351669 562.517944,136.250305 563.134766,135.989532 
	C563.559875,135.766861 563.731873,135.678558 564.185059,135.510620 
	C564.864746,135.405396 565.238770,135.492004 565.680786,135.955597 
	C565.769775,136.235931 565.852722,136.631821 565.915894,136.823959 
	C567.720947,138.856384 569.905029,140.458969 569.221313,143.786255 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M555.804199,123.195641 
	C559.752258,123.933517 560.820740,127.114502 561.803223,130.702454 
	C561.044861,131.258759 560.569763,131.174393 559.787476,130.829163 
	C557.547363,129.435638 556.470886,127.542084 555.361328,125.248451 
	C555.258850,124.393166 555.353638,123.916183 555.804199,123.195641 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M569.304993,144.094666 
	C569.027527,141.484741 566.727722,139.972870 565.989258,137.369705 
	C569.544617,137.635864 570.466797,140.342712 570.933472,143.743042 
	C570.457520,144.113312 570.038879,144.104370 569.304993,144.094666 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M556.026855,122.718895 
	C556.034729,123.414314 556.004456,123.894363 555.943726,124.733421 
	C553.487122,126.197983 552.291931,125.521584 552.788574,122.366333 
	C553.753174,121.997391 554.466248,122.022240 555.533142,122.062607 
	C555.886963,122.078110 555.988770,122.503525 556.026855,122.718895 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M562.093750,130.905090 
	C563.419983,131.100113 564.014771,131.915604 563.807861,133.701721 
	C562.094971,133.966110 561.412231,133.115494 561.734863,131.345337 
	C561.945374,131.043060 562.045288,130.952164 562.093750,130.905090 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M565.821533,135.901428 
	C565.376526,136.187927 564.983337,136.139908 564.293823,136.055389 
	C563.675537,135.619308 563.525024,135.163116 563.753174,134.339630 
	C563.960449,134.028900 564.058044,133.939606 564.106262,133.891220 
	C565.047363,134.098541 565.821716,134.472427 565.821533,135.901428 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M518.687744,85.865601 
	C522.204895,89.529579 526.634399,91.657211 529.714661,95.795517 
	C531.643127,98.697319 533.490906,101.214523 536.707031,102.839432 
	C539.476624,104.652641 541.081604,107.089035 542.690308,110.010452 
	C541.838867,111.275429 540.986877,111.620491 539.694702,111.769028 
	C536.559937,110.851830 534.360840,108.836975 532.776550,106.687241 
	C528.642944,101.078201 522.763550,97.594284 517.351685,93.002640 
	C516.897583,92.647629 516.723022,92.496307 516.302551,92.100891 
	C515.031311,90.458084 512.879883,89.463982 514.572021,86.878586 
	C514.929138,86.423393 515.084045,86.251228 515.510498,85.863770 
	C515.996216,85.565285 516.210449,85.482109 516.767212,85.412796 
	C517.561523,85.481255 518.012634,85.542282 518.687744,85.865601 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M552.820068,121.915741 
	C552.881470,123.606400 553.135010,124.952393 555.549194,125.067963 
	C557.111084,126.583305 558.308899,128.074173 559.689392,129.832260 
	C560.827087,132.044662 561.802185,133.983932 561.511108,136.532913 
	C561.341736,136.819931 561.135803,136.947937 561.028564,137.004349 
	C560.325745,138.110291 559.526062,138.573273 558.086182,137.790863 
	C557.505310,137.359192 557.218506,137.063904 556.812805,136.471664 
	C556.606750,136.014206 556.555176,135.819626 556.502563,135.326721 
	C556.554199,134.644592 556.599487,134.259903 556.610962,133.595932 
	C556.508667,132.944321 556.326660,132.627258 555.822388,132.180786 
	C555.416626,131.891205 555.250793,131.775879 554.839233,131.477295 
	C554.108948,130.917450 553.650940,130.499359 552.749146,130.204773 
	C552.040771,129.975494 551.644653,129.817505 550.990234,129.451569 
	C550.260986,128.813797 549.914856,128.272354 549.429016,127.443604 
	C548.651489,125.854614 547.924133,124.610725 546.704773,123.317558 
	C545.876343,122.029655 545.765137,120.670410 544.364929,119.724754 
	C543.251709,118.680382 542.806641,117.609039 542.257935,116.181488 
	C541.937866,115.108910 541.841125,114.366928 541.787720,113.231812 
	C541.838745,112.058159 542.043701,111.318413 542.725342,110.347351 
	C542.962646,110.039070 542.971680,110.027069 542.958435,110.038460 
	C544.881653,110.235100 545.777954,111.413490 546.041504,113.591034 
	C548.263000,116.171646 550.303467,118.501747 551.881287,121.557648 
	C552.163574,121.732124 552.599976,121.858948 552.820068,121.915741 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M468.888580,53.638161 
	C469.977692,54.055458 470.757263,54.290627 471.705078,54.783951 
	C473.114380,56.896645 475.479553,58.330776 473.841217,61.333977 
	C472.688446,61.738174 471.840210,61.695210 471.093353,61.297863 
	C461.130280,55.997486 451.313354,50.416245 440.982605,45.826313 
	C439.619904,45.220886 438.334961,44.305416 438.723999,42.101772 
	C441.255096,40.359005 443.319824,41.515175 445.283234,42.635456 
	C447.987885,44.178665 450.790558,45.399734 454.203918,46.140099 
	C455.248260,46.565269 455.801880,47.063370 456.658020,47.757339 
	C460.849701,49.745403 464.769257,51.484261 468.888580,53.638161 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M483.690582,62.239162 
	C485.336395,62.085148 487.156769,61.356064 487.648956,63.314613 
	C488.293610,65.879768 490.325287,65.690277 492.515503,66.079491 
	C495.400299,68.557938 497.532562,71.446526 500.910431,72.905983 
	C501.734467,73.262016 501.747650,74.218307 501.582581,75.397842 
	C499.257019,77.818985 497.545715,74.907013 495.172913,75.065796 
	C494.601837,74.899452 494.378204,74.818253 493.840942,74.568832 
	C490.632141,71.764442 487.669189,69.214470 483.998962,67.017227 
	C483.481781,66.753960 483.283295,66.632027 482.842957,66.257362 
	C482.252808,65.373383 482.151123,64.696693 482.325012,63.655952 
	C482.656189,62.921539 482.982758,62.620491 483.690582,62.239162 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M493.845001,74.273956 
	C496.456055,73.623283 498.480896,74.455536 500.672668,75.935013 
	C501.725739,75.408127 502.483887,75.279411 503.625916,75.818344 
	C503.938965,76.076630 504.004852,76.041420 503.970642,76.050339 
	C504.200745,76.280228 504.505005,76.383575 505.097931,76.338188 
	C505.346680,76.306831 505.404633,76.344719 505.432953,76.364609 
	C508.057648,77.841797 506.375092,79.679352 505.658997,81.746750 
	C501.336975,82.872147 496.076813,79.538460 493.845001,74.273956 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M503.981079,75.685150 
	C503.213165,76.070023 502.487335,76.063423 501.400543,76.004974 
	C501.262573,72.118568 497.264832,72.393646 495.479248,70.493919 
	C494.396484,69.341972 492.744873,68.855370 492.896149,66.490189 
	C497.405182,68.186981 501.186493,71.166443 503.981079,75.685150 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M469.220642,53.506042 
	C464.240295,54.537415 461.065704,50.011322 456.273682,49.257122 
	C456.564240,48.008167 457.475403,47.520565 458.893250,47.136459 
	C460.341766,47.002865 461.369263,47.118782 462.638306,47.839432 
	C463.416504,48.385624 463.893616,48.682289 464.661560,49.005051 
	C465.665131,50.725704 467.274261,50.993946 469.012329,51.680847 
	C469.247223,52.349106 469.245209,52.770451 469.220642,53.506042 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M505.457153,82.021561 
	C505.396973,80.134720 505.473358,78.579208 505.505493,76.704102 
	C508.212402,77.115471 511.148102,77.582947 511.866455,81.665848 
	C510.679565,83.108147 509.480499,83.121338 507.925903,83.128326 
	C507.332581,83.074158 507.096832,83.035187 506.522827,82.877335 
	C505.987610,82.623276 505.790649,82.488083 505.457153,82.021561 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M472.771423,54.989441 
	C473.051392,53.966499 473.580994,53.057880 474.040649,53.363899 
	C476.964478,55.310223 480.722534,56.167389 482.261292,59.818153 
	C481.393555,60.548359 480.670929,60.813164 479.454315,60.728432 
	C476.518219,59.350639 474.025085,57.974651 472.771423,54.989441 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M472.688446,54.742191 
	C474.276367,56.966919 477.136383,57.408199 478.846252,59.712170 
	C478.802917,60.717823 478.342316,61.182323 477.428345,61.655849 
	C476.668457,61.869492 476.219727,61.896645 475.437592,61.793427 
	C474.911072,61.608936 474.714172,61.499405 474.341492,61.101280 
	C474.298218,58.455841 471.423584,57.640423 471.625793,55.208424 
	C472.053192,54.971966 472.233093,54.901829 472.688446,54.742191 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M552.136353,121.376984 
	C548.556702,120.728943 548.097961,117.016998 546.081055,114.296516 
	C549.470886,115.132118 551.788818,117.228035 552.136353,121.376984 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M536.840332,102.756012 
	C533.009094,102.766312 531.010437,100.293892 529.927673,96.423332 
	C532.746033,97.589073 534.620300,100.140121 536.840332,102.756012 
z"/>
<path fill="#777171" opacity="1.000000" stroke="none" 
	d="
M476.855591,61.261616 
	C477.507996,60.725117 477.994568,60.481552 478.730438,60.129719 
	C479.738861,60.045219 480.498047,60.068993 481.634277,60.045578 
	C482.111481,60.877682 482.510193,61.532982 483.675293,61.934494 
	C483.695343,62.304192 483.425842,62.569904 482.891998,62.945976 
	C481.784607,64.008774 480.664978,64.023598 479.190796,63.918663 
	C478.641479,63.793388 478.426941,63.721016 477.921021,63.473289 
	C477.109558,62.828297 476.768158,62.262318 476.855591,61.261616 
z"/>
<path fill="#777171" opacity="1.000000" stroke="none" 
	d="
M459.095825,47.732773 
	C458.081146,48.328232 457.353333,48.654224 456.325165,48.992523 
	C455.690613,48.624264 455.356354,48.243702 455.003540,47.596275 
	C454.703461,46.798836 454.124603,46.487442 454.034576,45.612698 
	C454.547943,45.281136 454.954285,45.231537 455.661987,45.127209 
	C456.684509,45.425697 457.405640,45.778912 458.427795,46.167099 
	C459.264343,46.457874 459.482269,46.878284 459.095825,47.732773 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M512.000244,81.900154 
	C512.842224,81.991013 513.671692,82.279884 514.709351,82.822235 
	C515.821228,83.914749 515.922913,84.918785 515.438843,86.419983 
	C513.954834,88.133118 512.946289,87.308762 511.789459,85.850540 
	C511.280518,84.726288 511.220398,83.940384 511.700989,82.815033 
	C511.937286,82.491730 511.987793,82.098160 512.000244,81.900154 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M469.441650,51.707340 
	C467.533142,51.808159 465.286407,52.759354 464.962830,49.419956 
	C466.211884,50.423737 469.042236,48.821609 469.441650,51.707340 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M459.226227,48.000343 
	C458.800232,47.600739 458.791443,47.199238 458.755737,46.499908 
	C460.278107,45.847023 461.687256,45.951740 462.812073,47.748207 
	C461.840729,48.058796 460.742065,48.028625 459.226227,48.000343 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M515.217529,87.185402 
	C515.008728,85.911247 514.973083,84.878601 514.927368,83.460846 
	C515.856567,83.031540 516.624268,83.278305 516.929565,84.845352 
	C516.748230,85.499985 516.588196,85.583115 516.217896,85.836594 
	C515.985596,86.203026 515.963501,86.399101 515.937988,86.891129 
	C515.753235,87.267036 515.571960,87.346977 515.217529,87.185402 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M518.796875,85.847641 
	C518.468750,86.106873 518.024536,86.093369 517.246887,86.062622 
	C516.826660,85.876900 516.739868,85.708427 516.804199,85.299202 
	C516.955322,85.058441 517.019775,84.982353 517.054199,84.944115 
	C517.619324,85.128883 518.150085,85.351891 518.796875,85.847641 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M505.004639,76.184975 
	C504.993652,76.755623 504.591248,76.942398 504.007690,76.302460 
	C504.178497,76.060547 504.420563,76.061829 505.004639,76.184975 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M453.937378,45.013443 
	C454.395752,45.808861 454.649811,46.287003 454.944427,47.047276 
	C449.197449,47.558800 445.160126,42.849209 439.388428,41.969772 
	C437.958160,41.761501 437.081390,41.120827 435.765808,40.674103 
	C430.090668,36.757008 423.260895,36.516987 417.364319,33.087994 
	C416.411530,32.622440 415.784271,32.290359 414.779236,31.903019 
	C413.728027,31.481064 412.982941,31.340704 411.826660,31.163271 
	C397.535767,27.121647 383.472504,23.836208 369.346832,20.877541 
	C358.294830,18.562677 347.015259,17.609617 335.787628,16.445766 
	C323.033722,15.123706 310.229767,15.088678 297.440887,15.517939 
	C286.335663,15.890685 275.318787,17.347271 264.295837,18.794228 
	C248.917862,20.812853 234.338516,25.902775 219.434799,29.748529 
	C217.628937,30.214518 215.853928,30.486782 213.634827,29.725031 
	C212.760757,29.149990 212.457153,28.662216 212.323364,27.628798 
	C212.586700,25.905815 213.512604,25.304094 215.061401,24.842728 
	C222.430267,24.132435 228.882294,21.487988 235.858780,19.413239 
	C236.887589,19.174576 237.589539,19.138794 238.643005,19.098913 
	C244.405289,18.022991 249.654449,16.123966 255.609299,15.864523 
	C256.398102,15.797028 256.812683,15.786488 257.534790,15.726472 
	C258.460205,15.363211 259.033752,14.977209 259.915710,14.434622 
	C260.915710,14.241079 261.608368,14.205798 262.647888,14.180971 
	C264.442047,13.917383 265.910980,14.063152 267.679199,13.938818 
	C268.720520,13.906490 269.449982,13.900587 270.543121,13.865053 
	C274.666107,12.570223 278.506012,11.724822 282.834045,11.415342 
	C284.526672,11.186913 285.871857,11.155270 287.621155,11.129064 
	C291.182587,10.675923 294.413116,11.501830 297.865234,10.410316 
	C302.472870,10.167657 306.768280,11.543555 311.443909,10.178854 
	C312.164307,11.252822 312.824982,11.931762 313.968933,11.906882 
	C329.135284,11.577047 344.126556,13.829497 359.644287,14.895012 
	C360.515106,14.870000 360.935486,14.908327 361.672913,14.942418 
	C370.326813,18.142015 379.276031,18.617540 387.861481,20.745598 
	C410.675781,26.400526 432.777100,33.958221 453.937378,45.013443 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M15.434471,235.035980 
	C12.302314,229.944321 15.022000,224.985519 15.591233,220.068542 
	C16.793051,209.687393 22.285524,200.883179 27.645943,192.289932 
	C30.491461,187.728317 29.248074,182.063278 32.762814,177.959946 
	C32.938389,177.754974 32.708828,176.860458 32.413906,176.659210 
	C31.527140,176.054062 30.817944,176.650665 30.396593,177.390549 
	C28.262636,181.137787 24.725956,183.857239 22.878950,187.826538 
	C21.455034,190.886581 19.799088,190.600388 18.419012,187.782272 
	C17.135469,185.161285 15.466450,182.814194 16.522665,179.360718 
	C17.346745,176.666229 14.203285,174.630646 13.823148,171.614410 
	C12.816009,163.623154 14.080958,155.620132 13.031379,147.661392 
	C11.923974,139.264191 13.296417,130.917984 13.651493,122.543808 
	C13.842628,118.036049 13.624838,113.223503 12.856338,108.709785 
	C11.748177,102.201103 12.793503,95.858620 13.004678,89.446358 
	C13.318956,79.903336 12.754983,70.268005 15.081332,60.908630 
	C16.114527,56.751877 16.289951,51.735813 21.901779,50.307331 
	C22.499266,50.155243 23.064039,49.072395 23.268688,48.319344 
	C24.115736,45.202423 25.797762,44.402554 28.811995,45.703129 
	C29.954576,46.196125 31.642185,46.378441 32.727226,45.899712 
	C40.510101,42.465828 48.475338,45.483593 56.330692,45.109966 
	C60.596260,44.907078 64.593201,46.133438 65.394318,51.545040 
	C65.664658,53.371189 66.996742,54.902805 68.509552,55.954777 
	C72.483368,58.718079 72.079025,62.350056 70.531975,66.058479 
	C69.611183,68.265701 70.345375,69.952286 71.455666,71.641357 
	C71.752991,72.093666 72.537506,72.500778 73.064713,72.462715 
	C73.863220,72.405045 73.895409,71.600739 73.794731,70.915833 
	C73.600220,69.592491 72.093773,67.492271 74.424911,67.308472 
	C76.764282,67.124016 79.196388,65.294212 81.581894,67.093086 
	C82.770981,67.989769 83.817261,69.090691 85.057411,69.901505 
	C87.226112,71.319420 89.293983,71.537605 89.905922,68.353554 
	C90.312431,66.238426 91.119400,64.779221 93.421364,65.127480 
	C96.072762,65.528618 96.600067,67.797966 96.932220,69.966003 
	C97.321251,72.505295 95.761040,73.107460 93.604225,73.024345 
	C91.245987,72.933479 90.967918,74.492447 91.003471,76.344040 
	C91.039185,78.204765 91.583199,79.865257 93.664268,79.873367 
	C96.249611,79.883461 98.026665,80.512238 99.144066,83.116783 
	C100.285149,85.776558 101.812805,84.459785 103.400856,83.170410 
	C113.899612,74.646271 125.004288,66.933304 136.181152,59.350876 
	C143.552338,54.350243 150.848602,49.099915 159.761444,46.087551 
	C161.124268,48.916458 158.628937,49.359196 157.093933,50.307152 
	C143.795639,58.519707 130.881393,67.296089 118.716255,77.107727 
	C112.783867,81.892418 106.747665,86.636345 101.720589,92.956902 
	C101.286629,93.375137 101.097809,93.525986 100.600494,93.864914 
	C92.961876,98.419395 88.349785,105.569923 82.851189,111.694336 
	C66.008842,130.453537 52.175365,151.376114 40.521187,173.723099 
	C38.298626,177.984879 36.638020,182.526550 34.415604,187.175705 
	C34.303288,188.512909 34.141796,189.474670 33.684296,190.747772 
	C30.333900,194.958771 28.853188,199.573380 27.658421,204.714722 
	C24.992514,211.408905 20.925117,217.182159 20.278561,224.625870 
	C20.162489,225.495605 20.042137,225.981781 19.736168,226.805511 
	C17.563728,229.422134 18.191431,232.962952 15.434471,235.035980 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M101.143845,93.867935 
	C101.974136,88.359550 106.500954,85.860115 109.968719,82.843475 
	C125.179108,69.611839 141.632950,58.053268 159.049271,47.878395 
	C159.438660,47.650909 159.655121,47.127419 160.042252,46.409332 
	C160.132248,46.076653 160.568420,46.072445 160.785980,46.057312 
	C161.928726,45.056637 163.051346,44.406971 164.687149,44.053406 
	C166.460999,44.079288 167.381485,43.078110 168.713882,42.173485 
	C172.449219,39.429707 176.421692,37.837887 180.670151,36.076092 
	C182.458984,35.406364 183.891159,34.752682 185.661377,34.043736 
	C188.435638,31.682182 191.800003,31.143383 194.854538,29.275469 
	C200.397537,28.091406 205.241730,25.832396 210.630859,24.050264 
	C211.691360,23.181273 212.671097,22.834223 213.843292,22.216343 
	C215.151749,22.032852 216.197403,22.007727 217.633331,21.942364 
	C218.155716,22.078791 218.287857,22.255457 218.470123,22.759979 
	C218.391891,24.371828 217.356598,24.877123 216.194672,25.698589 
	C215.088760,26.088634 214.241165,26.275579 213.181854,26.713043 
	C212.500641,27.450657 212.112473,27.992779 211.641449,28.889328 
	C211.250793,29.295252 211.068649,29.431749 210.574005,29.706226 
	C209.169830,30.176136 208.038910,30.161493 206.589569,30.243616 
	C204.483215,30.227608 202.934845,30.817131 201.322510,32.164398 
	C200.641739,32.534332 200.218781,32.662621 199.447144,32.768272 
	C195.331894,33.211910 191.882416,34.434105 188.750809,37.222271 
	C187.373871,38.560116 186.047821,39.331039 184.177063,39.714806 
	C183.070084,39.796219 182.319275,39.955250 181.538788,40.797760 
	C180.707932,41.616787 179.925888,41.896690 178.813660,42.211903 
	C177.207657,42.469986 176.261627,43.433823 174.768799,43.943924 
	C173.672501,44.264206 172.949997,44.593548 172.376495,45.646015 
	C171.297516,47.022942 169.996155,47.070946 168.412552,47.210850 
	C167.321960,47.317959 166.529755,47.374039 165.645233,48.097458 
	C165.235779,48.393307 165.065857,48.505672 164.622406,48.759010 
	C162.994202,49.411743 161.665649,49.965229 160.516663,51.399429 
	C158.251862,53.426582 155.873306,54.746517 153.421600,56.556282 
	C142.684753,62.745823 133.248917,70.226212 123.111786,77.267883 
	C121.928970,77.982185 120.932106,78.392128 120.121078,79.555840 
	C119.806488,79.969589 119.676880,80.132034 119.335449,80.522308 
	C118.373451,81.442001 117.548447,82.051086 116.633392,83.014748 
	C116.251266,83.347450 116.088135,83.468262 115.664139,83.743385 
	C114.680214,84.269447 114.006302,84.709251 113.227440,85.543060 
	C111.535446,87.169830 110.411545,88.897171 108.517914,90.346405 
	C106.104240,91.292068 104.448135,92.802780 102.317986,94.179321 
	C101.774551,94.241371 101.552879,94.196129 101.143845,93.867935 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M15.052493,235.383759 
	C17.017353,232.737076 15.897099,229.238876 18.559799,227.013184 
	C21.206131,229.136047 19.224489,231.659058 19.413399,234.435974 
	C19.539162,237.305161 18.940676,239.668274 18.431847,242.446228 
	C18.359621,244.193726 18.188295,245.512451 17.232178,247.009460 
	C16.102110,247.997192 15.107352,248.300400 13.627469,248.183960 
	C13.233377,244.880035 14.094122,241.834335 14.911020,238.384949 
	C14.972862,237.248123 15.007808,236.502518 15.052493,235.383759 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M180.825653,35.802258 
	C177.587448,38.653580 173.594360,40.184082 169.362198,41.985275 
	C171.785294,37.906525 176.190414,36.699543 180.825653,35.802258 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M194.751297,29.078388 
	C193.273743,32.319920 189.496429,32.254265 186.361389,33.957367 
	C187.513321,30.174864 191.381241,30.384060 194.751297,29.078388 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M218.301239,23.188232 
	C218.014328,22.785505 218.020065,22.609322 218.024689,22.167629 
	C219.306229,19.017891 221.557648,18.005421 224.805389,18.772976 
	C223.706848,20.638672 221.008118,20.037788 219.956070,22.510509 
	C219.538040,23.235970 219.107773,23.417988 218.301239,23.188232 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M102.221497,75.456429 
	C104.942665,76.865097 102.972099,77.854645 101.963341,78.678429 
	C101.547638,79.017914 100.004189,78.831276 99.831917,78.472191 
	C98.872810,76.473015 100.818901,76.287148 102.221497,75.456429 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M164.823547,43.787712 
	C164.178833,45.164482 162.936295,45.593754 161.335541,46.009995 
	C161.344620,43.950039 162.552460,43.113846 164.823547,43.787712 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M213.742676,22.042725 
	C213.566132,23.053297 212.819153,23.779720 211.322571,23.970392 
	C211.087296,22.478888 211.991592,21.959904 213.742676,22.042725 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M228.849762,17.809486 
	C228.542786,18.347185 228.066895,18.652185 227.294739,18.967133 
	C227.188232,18.064531 227.169693,16.901680 228.849762,17.809486 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M233.805511,16.079033 
	C233.954239,16.936983 233.672394,17.724127 232.316681,17.908024 
	C232.094849,16.995371 232.403183,16.235352 233.805511,16.079033 
z"/>
<path fill="#F1F6F7" opacity="1.000000" stroke="none" 
	d="
M87.385231,64.459442 
	C86.583870,64.686913 86.295593,64.405220 86.417572,63.784367 
	C86.442947,63.655148 86.625580,63.480835 86.755959,63.461132 
	C87.383667,63.366268 87.647232,63.671150 87.385231,64.459442 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M12.065603,317.448151 
	C12.080648,316.569397 12.066385,316.132385 12.054707,315.367493 
	C13.421520,313.472626 13.020735,311.558746 12.982471,309.773499 
	C12.468330,285.784821 16.918005,262.610107 22.990427,239.472610 
	C28.436550,218.721466 35.994576,198.859268 45.498932,179.831329 
	C52.159370,166.496979 59.974899,153.648178 68.367783,140.796661 
	C68.634621,140.238663 68.731758,140.015213 69.015411,139.486511 
	C70.170624,137.979721 71.600334,137.164398 72.339409,135.354843 
	C73.119240,134.221649 73.769630,133.388153 74.322342,132.115906 
	C74.710182,131.470337 74.981964,131.136124 75.528458,130.611176 
	C77.555183,129.421600 78.646217,127.841042 79.754662,125.819038 
	C81.606422,124.225830 82.937531,122.359398 85.724480,122.592270 
	C86.387611,123.091347 86.616623,123.506500 86.746063,124.339424 
	C86.641922,125.688148 86.045952,126.392830 85.105415,127.260277 
	C83.709076,128.415878 82.602425,129.385727 81.957062,131.135071 
	C81.554665,132.026886 81.184654,132.562973 80.509003,133.293488 
	C78.458786,134.640015 77.089989,136.134415 76.106003,138.404175 
	C75.835884,138.900620 75.720070,139.093948 75.408554,139.560608 
	C73.238068,141.951538 71.772392,144.409256 70.248734,147.241302 
	C64.870621,153.858749 61.318867,161.212814 57.320217,168.265991 
	C54.873489,172.581772 52.046341,176.732437 50.227104,181.787415 
	C50.011456,182.332291 49.913563,182.544968 49.640015,183.059906 
	C47.166294,186.770172 45.167698,190.315094 44.346222,194.759476 
	C44.177902,195.527863 44.043678,195.954132 43.737850,196.667969 
	C42.829212,197.992294 42.151867,199.064468 41.813515,200.664490 
	C41.478447,201.592834 41.163334,202.170776 40.619167,203.002914 
	C39.542160,204.252487 38.576138,205.179810 38.411850,206.936798 
	C38.459831,208.691040 38.496674,210.101379 37.413841,211.633774 
	C32.743980,221.846191 29.363123,232.105972 27.361893,243.175720 
	C27.312416,244.515060 27.232811,245.483612 27.003506,246.793091 
	C26.850147,247.360626 26.772261,247.580292 26.537088,248.105484 
	C25.241688,250.245636 24.028778,252.065125 25.326859,254.658142 
	C25.607939,255.383255 25.651966,255.821701 25.523529,256.587341 
	C24.866419,257.785645 23.838903,258.407440 23.905651,259.969421 
	C23.861134,260.518250 23.832428,260.737671 23.716290,261.278656 
	C22.144001,264.322479 20.937725,267.108826 21.680225,270.661499 
	C21.780939,271.444183 21.765411,271.893585 21.607615,272.666382 
	C20.010624,274.679962 21.036791,276.271118 21.745892,278.231384 
	C21.759949,279.081329 21.642817,279.555603 21.244789,280.331909 
	C18.254154,284.280548 18.356947,288.553406 18.383589,292.786774 
	C18.399031,295.240387 18.105192,297.717743 18.865376,300.524292 
	C19.329231,302.498505 19.337492,304.102844 19.081408,306.109558 
	C18.787924,307.534546 18.464537,308.540466 18.172626,309.958008 
	C16.743227,314.577209 17.197847,318.956512 17.391052,323.239044 
	C18.515345,348.159698 20.281551,373.054504 27.611429,397.070709 
	C35.747082,423.727020 46.957279,449.033813 61.903580,472.679779 
	C70.279503,485.930969 79.653694,498.394531 89.381271,510.634674 
	C90.117310,511.560791 90.951279,512.348450 92.216980,513.241211 
	C92.689636,513.646790 92.868126,513.816711 93.287003,514.259399 
	C98.416695,520.557983 103.856377,526.078308 109.541641,531.824951 
	C110.029152,532.136230 110.220222,532.267944 110.685623,532.615295 
	C121.250977,542.166626 130.839874,552.331848 143.083221,559.893250 
	C143.615067,560.163513 143.822205,560.284851 144.314178,560.629333 
	C151.294266,566.666443 159.374191,570.346802 166.665955,575.233643 
	C169.412277,577.074158 173.575378,577.276489 174.351379,581.797363 
	C173.841415,582.473694 173.417053,582.716980 172.577316,582.934570 
	C170.956421,583.056763 169.817505,582.659363 168.414825,581.924133 
	C167.339279,581.268433 166.734970,580.528381 165.484024,580.175537 
	C145.081955,569.652344 127.731407,555.507080 111.152031,540.367859 
	C88.466209,519.652649 69.222763,496.106934 53.786209,469.501740 
	C53.031040,468.200195 52.094177,467.038483 50.840820,465.658081 
	C50.473106,465.172455 50.340576,464.966583 50.044006,464.431335 
	C47.734970,458.590759 44.212936,453.779816 41.741859,448.001373 
	C31.389845,425.604340 22.705864,402.984436 18.419731,379.023529 
	C15.749549,364.096344 12.245331,349.178986 12.876779,333.401733 
	C12.840120,332.277832 12.857514,331.559174 12.865669,330.480896 
	C11.148090,326.140411 12.353302,321.964142 12.065603,317.448151 
z"/>
<path fill="#6D676B" opacity="1.000000" stroke="none" 
	d="
M69.655670,139.748596 
	C64.851906,148.865829 59.970776,157.897018 54.577389,166.611176 
	C42.272362,186.492523 33.660522,207.988068 26.919443,230.220291 
	C23.036961,243.024765 19.427240,256.053589 17.415628,269.243896 
	C15.403643,282.436615 12.974883,295.745117 13.910543,309.277802 
	C14.036598,311.100952 14.851969,313.314026 12.444156,314.933380 
	C12.026837,307.981415 11.996383,300.923279 11.909651,293.390381 
	C11.895467,290.571381 11.937560,288.227142 11.987490,285.441010 
	C12.018326,284.412628 12.177026,283.870117 12.669214,283.142456 
	C12.864597,281.212219 12.908507,279.526093 12.949732,277.417786 
	C13.060470,275.825623 12.871504,274.610870 13.656149,273.212646 
	C13.940544,270.614441 14.032265,268.315491 14.153568,265.587341 
	C15.246392,263.750305 15.032453,262.175354 14.738373,260.267761 
	C14.591115,259.080200 14.429730,258.227997 14.352452,257.043396 
	C14.421094,256.513702 14.478284,256.306366 14.695177,255.819855 
	C15.369215,254.866455 15.947711,254.235764 16.403885,253.132538 
	C17.715502,248.149612 19.251114,243.570312 20.479004,238.548706 
	C20.510414,237.250427 20.255161,236.331345 20.137901,235.024628 
	C20.153870,234.158844 20.265377,233.677597 20.633121,232.888275 
	C24.015646,228.872971 24.082489,223.992004 25.697029,219.700531 
	C30.246462,207.608078 34.314011,195.319321 40.749863,183.644470 
	C41.959293,182.075378 43.545937,181.112442 43.298447,178.808533 
	C43.515469,176.475204 44.944576,175.061646 46.042595,173.135406 
	C46.796360,172.274536 47.467392,171.760391 48.003815,170.723846 
	C48.264626,170.262726 48.374969,170.080200 48.677002,169.639267 
	C50.249161,167.970795 51.166031,166.290390 51.863174,164.113831 
	C52.262325,162.993942 52.645714,162.223434 53.242001,161.207367 
	C54.056885,160.153198 54.744198,159.389969 55.042686,158.041122 
	C55.218941,157.545242 55.302834,157.350082 55.558456,156.883514 
	C56.906925,155.356628 58.007015,154.041946 59.042912,152.269958 
	C59.461487,151.641403 59.720745,151.297409 60.191452,150.711685 
	C61.086849,149.639984 61.678715,148.769180 61.796524,147.307434 
	C62.306576,143.882172 64.212685,141.716766 66.777069,139.576584 
	C67.870789,139.155548 68.616905,139.181259 69.655670,139.748596 
z"/>
<path fill="#6D676B" opacity="1.000000" stroke="none" 
	d="
M12.558013,333.310608 
	C13.813482,333.585358 14.045086,334.548920 13.971873,335.576660 
	C13.318511,344.748566 15.741670,353.554138 17.011324,362.511688 
	C19.437014,379.625214 23.047380,396.402069 28.975416,412.683533 
	C33.234619,424.381531 37.350506,436.120453 42.978809,447.633240 
	C42.347633,448.610260 41.579872,448.729370 40.400696,448.222076 
	C39.025513,445.915985 37.982628,443.853821 36.876492,441.446411 
	C34.064236,436.161163 31.655455,431.075836 30.135746,425.241638 
	C29.964518,422.946533 29.178112,421.317444 27.605106,419.659546 
	C24.111629,409.195190 21.326180,398.902863 18.211239,388.349915 
	C16.424206,384.499939 17.056067,380.541016 15.908908,376.481110 
	C13.919872,372.826904 16.148388,368.656647 13.290766,365.264343 
	C13.433849,361.588989 11.818606,358.245453 12.815743,354.483246 
	C12.604194,347.281250 11.219138,340.481354 12.558013,333.310608 
z"/>
<path fill="#6D676B" opacity="1.000000" stroke="none" 
	d="
M11.781876,317.281799 
	C14.004881,320.947205 12.607329,325.127930 12.917187,329.650879 
	C9.084595,326.298798 11.530522,321.789551 11.781876,317.281799 
z"/>
<path fill="#AFAEB1" opacity="1.000000" stroke="none" 
	d="
M14.677279,255.886108 
	C15.312843,256.827972 15.578811,257.620819 15.934166,258.715057 
	C15.206158,259.725189 15.189899,260.898560 14.213944,261.827698 
	C13.511925,261.988892 13.079526,261.994049 12.322773,261.999573 
	C11.967539,261.519073 11.936657,261.038116 11.825644,260.202698 
	C11.781228,259.457855 11.816942,259.067505 11.854256,258.382141 
	C11.590711,256.174438 12.966472,255.973785 14.677279,255.886108 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M13.967194,262.380188 
	C13.987055,260.832367 14.432584,259.901184 15.725628,259.143494 
	C15.741220,260.996643 16.885077,263.252716 14.534205,265.029419 
	C14.118789,264.364319 14.054426,263.570465 13.967194,262.380188 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M13.525434,272.997681 
	C13.995652,274.145752 14.217850,275.384857 13.235213,276.768677 
	C11.655936,275.601379 11.480877,274.279877 13.525434,272.997681 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M12.546261,282.958435 
	C12.716241,283.484528 12.611794,284.070709 12.251335,284.828003 
	C10.926115,284.176758 11.124294,283.531372 12.546261,282.958435 
z"/>
<path fill="#AFAEB1" opacity="1.000000" stroke="none" 
	d="
M12.051922,263.878479 
	C11.862163,263.930817 11.917098,263.467377 11.937866,263.234985 
	C12.133929,263.176239 12.319348,263.341919 12.471069,263.534241 
	C12.489046,263.557007 12.322627,263.725311 12.051922,263.878479 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M15.035366,256.038513 
	C14.115717,256.546906 13.184566,257.058685 12.054636,257.828796 
	C11.855856,258.087097 11.372511,258.048492 11.129290,258.033661 
	C10.936171,256.629089 10.986273,255.239349 11.044151,253.433502 
	C11.434375,253.002182 11.816821,252.986938 12.486753,252.978790 
	C13.369172,252.500931 14.027890,252.186600 15.179394,252.310852 
	C15.746217,252.538712 15.951018,252.677750 16.291941,253.160797 
	C16.270124,254.233398 15.963906,254.893402 15.278580,255.766357 
	C15.045873,256.047089 15.023866,256.041870 15.035366,256.038513 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M13.188420,248.443726 
	C13.948011,247.724167 14.649785,247.368790 15.651962,246.989655 
	C16.869150,247.889038 17.067751,248.987701 16.544191,250.605728 
	C15.625752,251.654709 14.799088,251.780106 13.525629,251.260452 
	C13.151272,250.279572 13.140937,249.543747 13.188420,248.443726 
z"/>
<path fill="#AFAEB1" opacity="1.000000" stroke="none" 
	d="
M13.081108,251.340500 
	C13.846797,251.007919 14.531987,251.000443 15.561697,250.988647 
	C16.307381,251.447891 16.439301,251.978363 15.982834,252.864868 
	C14.943605,253.112259 14.223468,253.070587 13.138784,253.007401 
	C12.849696,252.545792 12.925154,252.105682 13.081108,251.340500 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M330.123016,619.506592 
	C329.285950,620.399109 328.989075,621.104675 328.917969,622.232056 
	C326.895569,622.668335 324.888184,622.817139 322.448883,623.003113 
	C315.651123,622.987183 309.285339,622.934143 302.454407,622.954468 
	C301.989258,623.027832 301.536865,622.841125 301.313934,622.740234 
	C299.966248,621.715332 298.515106,621.181213 297.757812,619.443665 
	C297.950287,618.848999 298.128082,618.646729 298.667969,618.245850 
	C303.005432,617.064697 307.047363,617.691650 311.494507,617.550598 
	C314.280884,617.436401 316.630981,617.466797 319.424316,617.532898 
	C322.835632,617.634583 325.830200,617.210632 329.166931,618.213440 
	C329.782379,618.628113 329.991577,618.844849 330.123016,619.506592 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M363.159973,614.583130 
	C361.824646,615.757202 361.835358,616.967651 362.068604,618.376160 
	C361.842651,618.679382 361.514130,618.824097 360.907776,618.831177 
	C358.983429,618.705688 357.239227,617.662354 355.420410,619.013000 
	C354.647186,618.953003 354.182587,619.027344 353.365997,619.057861 
	C352.007843,619.251343 351.570038,618.618042 351.143524,617.447021 
	C351.050293,616.503967 351.138092,615.975769 351.540039,615.124146 
	C352.378448,614.262329 353.120239,614.007446 354.284851,613.797363 
	C355.903870,613.630127 357.168304,613.736633 358.738678,613.221802 
	C360.123627,612.927368 361.136078,612.907837 362.479004,613.406982 
	C362.972473,613.798157 363.124878,614.006287 363.159973,614.583130 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M351.656311,616.609497 
	C352.168579,617.409180 352.357849,617.999329 352.780579,618.801758 
	C351.933746,621.447083 349.679291,620.744080 347.387115,620.993896 
	C346.850250,620.806030 346.701080,620.600098 346.486755,620.016541 
	C346.564575,618.277344 347.185150,617.205139 348.707581,616.318970 
	C349.846497,616.011841 350.602692,616.076233 351.656311,616.609497 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M355.263184,619.175720 
	C356.595428,615.994263 358.220764,614.596741 360.484924,618.536987 
	C359.271332,621.495605 357.196075,619.501221 355.263184,619.175720 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M346.750153,619.434631 
	C347.100616,619.801636 347.089935,620.044434 347.039368,620.649597 
	C346.977478,621.213745 346.955505,621.415527 346.779297,621.883789 
	C345.712738,621.947998 345.100006,621.465088 345.018066,620.136841 
	C345.392792,619.463196 345.858185,619.295837 346.750153,619.434631 
z"/>
<path fill="#928C87" opacity="1.000000" stroke="none" 
	d="
M297.647034,619.650818 
	C299.347992,620.047852 300.890137,619.945435 301.066162,622.302979 
	C299.033234,622.754089 296.975494,622.868835 294.480713,622.959106 
	C293.995178,621.995178 293.946655,621.055786 293.892609,619.762329 
	C295.018585,617.652161 296.184875,618.576172 297.647034,619.650818 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M330.369019,619.957031 
	C330.034210,619.761475 330.023163,619.571289 329.995544,619.095825 
	C329.614380,618.384155 329.487610,617.895752 329.801300,617.005005 
	C330.654388,616.171265 331.404785,615.936462 332.585175,615.759644 
	C334.270233,615.628418 335.565033,615.700256 337.249023,615.749451 
	C338.158264,615.839417 338.661987,615.968506 339.485291,616.361572 
	C339.972534,616.773682 340.123840,616.985596 340.161072,617.571045 
	C338.868073,618.069214 338.036041,618.564514 337.984802,620.185242 
	C336.602509,620.611633 335.210358,620.736389 333.396545,620.833008 
	C332.413605,619.983704 331.551971,619.976379 330.369019,619.957031 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M347.226013,619.318726 
	C346.643738,619.652649 346.176147,619.746521 345.350677,619.826355 
	C344.899384,619.516541 344.717712,619.292297 344.246460,619.046448 
	C344.033875,618.762573 344.022583,618.571777 343.994141,618.094849 
	C343.608612,617.418152 343.467041,616.957520 343.718628,616.086548 
	C344.500824,615.246460 345.223419,615.029724 346.373077,614.915161 
	C347.265625,614.933289 347.760651,615.039978 348.564636,615.415283 
	C349.026764,615.821167 349.163971,616.032349 349.171204,616.598267 
	C348.474396,617.661499 347.907562,618.370117 347.226013,619.318726 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M343.976471,615.483521 
	C343.979553,616.299072 343.975769,616.732361 343.974487,617.487122 
	C342.928650,617.856995 341.880280,617.905334 340.439484,617.949158 
	C340.038666,617.761780 340.030334,617.578979 340.007202,617.122131 
	C339.614258,616.462952 339.462250,616.002686 339.695374,615.121155 
	C340.262177,614.445129 340.719574,614.226868 341.613892,614.093567 
	C342.791718,614.152466 343.478973,614.439087 343.976471,615.483521 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M291.251953,618.963989 
	C290.726837,621.602051 288.603912,620.570068 287.185547,621.509033 
	C286.723785,622.246704 286.334747,622.512390 285.405853,622.417236 
	C284.120361,621.652832 283.825714,620.659119 283.542847,619.246582 
	C283.573120,618.594788 283.636414,618.337097 283.973694,617.788330 
	C285.198547,616.917725 286.261322,616.792847 287.748230,616.735229 
	C288.985168,616.776428 289.780121,616.958252 290.856934,617.571350 
	C291.272125,618.084290 291.361755,618.343933 291.251953,618.963989 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M291.405884,619.277710 
	C291.042664,619.055664 291.032776,618.786865 291.020813,618.114746 
	C292.366638,614.774536 294.786041,615.834656 297.379089,616.310303 
	C298.223816,616.914124 298.442902,617.420959 298.222107,618.415405 
	C298.011963,618.988586 297.998962,619.178894 297.965302,619.653748 
	C296.816467,619.693848 295.688263,619.449280 294.223572,619.306519 
	C293.177795,619.349121 292.468506,619.289978 291.405884,619.277710 
z"/>
<path fill="#BDB9B4" opacity="1.000000" stroke="none" 
	d="
M284.866058,621.738892 
	C285.453674,621.532532 285.872528,621.636169 286.614990,621.733887 
	C286.969116,622.187927 286.999634,622.648071 287.054443,623.447144 
	C286.473724,623.619141 285.868683,623.452148 285.109863,622.995361 
	C284.869781,622.486694 284.783539,622.267822 284.866058,621.738892 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M284.229797,617.462646 
	C284.009857,617.991211 283.996124,618.178589 283.968079,618.647522 
	C283.673676,619.493286 283.176788,619.741760 282.306885,619.827209 
	C281.601807,619.774353 281.182556,619.757568 280.453827,619.682495 
	C279.430878,619.139404 279.180145,618.423401 279.189606,617.209656 
	C279.351959,616.570984 279.460358,616.327148 279.855469,615.802124 
	C281.142303,614.973511 282.184631,614.931580 283.608215,615.455566 
	C284.324371,616.074036 284.483978,616.564087 284.229797,617.462646 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M279.688965,616.654114 
	C280.014038,617.554321 280.048035,618.251160 280.113159,619.286133 
	C279.042236,619.703003 277.940125,619.781677 276.426880,619.808960 
	C275.419830,619.253113 275.252167,618.592346 275.430969,617.506287 
	C275.697113,616.982605 275.850433,616.798950 276.318390,616.442688 
	C276.863983,616.208313 277.094940,616.146667 277.683594,616.064575 
	C278.518097,616.097534 278.971558,616.228882 279.688965,616.654114 
z"/>
<path fill="#928C87" opacity="1.000000" stroke="none" 
	d="
M282.018402,620.142456 
	C282.479248,619.521667 282.937469,619.252075 283.674744,618.955750 
	C284.317932,619.578064 284.682068,620.227112 285.040527,621.152466 
	C285.009125,621.641724 284.983459,621.854614 284.956909,622.386597 
	C284.258820,622.717773 283.561646,622.729980 282.530334,622.641052 
	C282.136108,621.857849 282.075958,621.175781 282.018402,620.142456 
z"/>
<path fill="#928C87" opacity="1.000000" stroke="none" 
	d="
M275.562439,616.908508 
	C275.950562,617.797791 275.985260,618.454773 276.017822,619.434692 
	C275.998291,619.949646 275.980896,620.141663 275.930237,620.619934 
	C275.486176,620.896301 275.075348,620.886353 274.359161,620.830200 
	C274.023163,620.143616 273.992523,619.503113 273.969543,618.539185 
	C273.531616,617.017395 274.242767,616.744690 275.562439,616.908508 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M297.795837,10.139436 
	C295.411682,13.491638 291.860077,11.568101 288.318237,11.399360 
	C288.017883,10.925522 288.010498,10.716543 288.005859,10.192905 
	C290.332947,9.861396 292.657257,9.844545 295.408630,9.788980 
	C296.359100,9.850198 296.882477,9.950129 297.795837,10.139436 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M217.844284,23.229540 
	C218.423691,22.942516 218.838760,22.923346 219.562347,22.871147 
	C225.037170,21.606195 230.203491,20.374273 235.777740,19.176353 
	C235.899918,20.256659 235.233109,20.807781 234.163757,21.101217 
	C228.347916,22.697111 222.549225,24.355602 216.340515,25.947121 
	C215.932571,24.676018 216.878906,24.139385 217.844284,23.229540 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M255.790314,15.590864 
	C250.698669,18.016628 244.982681,18.334501 239.235321,19.332886 
	C242.382202,16.078218 247.285202,17.350784 250.991486,14.557558 
	C251.540085,14.184358 251.969482,14.152164 252.722839,14.151528 
	C253.896912,14.580109 254.747040,14.977134 255.790314,15.590864 
z"/>
<path fill="#F5FAFA" opacity="1.000000" stroke="none" 
	d="
M246.261505,14.795040 
	C246.158463,14.582207 246.344864,14.353786 246.815033,14.097464 
	C246.922241,14.307549 246.739609,14.544181 246.261505,14.795040 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M282.837769,11.144199 
	C279.894440,14.278374 275.616302,13.206313 271.340820,13.895068 
	C271.344635,10.777243 274.919128,13.041207 276.009644,10.569506 
	C277.165558,10.190985 278.206635,10.138626 279.641357,10.111793 
	C280.641907,11.009247 281.592194,10.975651 282.837769,11.144199 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M267.748352,13.655893 
	C266.715210,15.488430 265.104248,15.050112 263.247986,14.425385 
	C264.240021,12.455822 265.870728,12.915565 267.748352,13.655893 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M259.902161,14.212933 
	C259.929718,15.116889 259.508087,15.811513 258.159241,15.744410 
	C258.098694,14.799852 258.541229,14.134623 259.902161,14.212933 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M167.850754,580.732910 
	C169.146576,581.250427 170.217667,581.597534 171.624390,581.996704 
	C173.251144,583.255493 174.989349,583.443420 176.848923,584.146851 
	C178.185760,584.572449 179.236938,584.823669 180.602814,585.171143 
	C181.944946,585.660889 182.869492,586.231567 183.970245,587.115662 
	C184.908951,588.063110 185.639221,588.758362 186.994537,589.057983 
	C187.492722,589.236694 187.689316,589.322144 188.160492,589.581543 
	C189.561752,590.837036 190.863007,591.589844 192.737854,591.954590 
	C193.268204,592.116211 193.476028,592.193481 193.976517,592.425781 
	C195.645004,593.672607 197.160706,594.461670 199.249405,594.798950 
	C200.029175,594.990417 200.465500,595.145081 201.210144,595.493347 
	C208.243103,599.872437 216.160324,600.973999 223.618423,604.290771 
	C224.087296,604.709961 224.243027,604.912720 224.483337,605.491211 
	C224.524811,606.120544 224.481705,606.374084 224.202866,606.933105 
	C192.504135,599.367920 164.953735,583.459961 138.166748,565.302002 
	C137.325424,564.198059 136.403168,563.785278 135.230774,563.201965 
	C134.983521,563.027161 134.995270,563.000000 134.984299,563.011780 
	C134.328232,562.197449 133.407288,561.785522 132.263214,561.168518 
	C131.470184,560.461914 130.903259,559.955872 130.179596,559.208313 
	C129.310287,558.220459 128.411133,557.773132 127.255157,557.175293 
	C124.800209,555.171814 122.568695,553.372437 120.178436,551.272827 
	C118.991898,549.896545 117.597626,549.338745 116.209930,548.231812 
	C115.868965,547.706421 115.688408,547.441345 115.232147,547.093384 
	C114.792366,544.881775 113.590080,543.653625 111.274078,543.087463 
	C110.381226,541.202087 108.186623,541.096008 107.082397,539.370117 
	C105.672676,536.427246 103.448074,534.952454 100.423714,533.991211 
	C99.475975,533.148621 98.867455,532.352722 98.122818,531.288147 
	C96.157913,529.161255 94.331779,527.300415 92.294327,525.191650 
	C91.154259,523.807983 90.222794,522.674988 89.156006,521.257385 
	C86.112572,515.635315 82.265480,511.061157 77.367798,507.022247 
	C76.442345,506.482605 75.861229,505.981842 75.159393,505.214569 
	C74.109756,504.359650 74.065956,503.205109 73.216209,502.213989 
	C71.226433,497.681915 67.085915,494.911621 65.215408,490.267822 
	C64.571533,489.510803 64.068855,489.265350 63.131454,489.551605 
	C60.567024,488.715759 61.541553,486.117065 60.165977,484.306702 
	C58.687168,481.585052 57.369282,479.167542 55.990456,476.408569 
	C55.465317,475.470581 54.934082,474.936462 54.177773,474.227783 
	C53.964836,474.041931 53.999168,474.014648 53.978653,474.019348 
	C53.008595,471.126984 50.532558,468.839722 50.810905,465.240723 
	C55.767113,467.574615 56.808422,472.839539 59.343044,476.956848 
	C67.811096,490.712494 78.021439,503.165344 88.279533,515.506958 
	C101.544373,531.466003 117.214050,545.080750 133.517731,557.869263 
	C142.087967,564.591675 150.763245,571.267761 160.732315,575.954773 
	C162.356567,576.718445 163.779160,577.911011 165.643616,578.956055 
	C166.520660,579.542358 167.061966,580.064331 167.850754,580.732910 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M17.957060,388.474518 
	C18.509344,388.342010 19.457855,388.504181 19.571287,388.903564 
	C22.433701,398.980347 25.208382,409.082092 28.016878,419.582458 
	C28.143751,420.179047 28.252230,420.372589 28.141151,420.816315 
	C23.158714,412.870636 21.823841,403.525513 19.104242,394.647156 
	C18.533264,392.783173 18.334484,390.805176 17.957060,388.474518 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M40.067955,448.351257 
	C40.803894,447.985352 41.539387,447.992584 42.643768,447.997131 
	C45.646137,453.100555 48.279617,458.206604 50.918232,463.675110 
	C50.246895,464.593414 49.491161,464.735504 48.323643,464.241180 
	C45.034027,459.078613 41.595387,454.396606 40.067955,448.351257 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M30.686840,424.789612 
	C31.920580,430.521637 35.420780,435.043121 36.845158,440.725830 
	C31.832567,437.183441 31.490189,430.932037 29.057249,425.348175 
	C29.428392,424.633789 29.882530,424.506592 30.686840,424.789612 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M48.023827,464.365967 
	C48.724079,464.017242 49.458527,464.023590 50.558167,464.033691 
	C50.923367,464.037506 51.006939,464.483429 51.028458,464.708649 
	C52.026646,467.711914 53.003311,470.489929 53.969055,473.646027 
	C51.219898,471.412384 49.600773,468.090912 48.023827,464.365967 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M13.052571,365.377808 
	C17.112677,367.476440 15.593292,371.600403 15.932070,375.619080 
	C13.525517,375.561401 14.040379,373.648193 14.020285,372.090851 
	C13.992485,369.936127 13.920754,367.810059 13.052571,365.377808 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M30.982918,424.648071 
	C30.549215,425.010864 30.117176,425.006134 29.361820,424.987366 
	C28.704508,423.895050 28.370510,422.816772 27.979053,421.402466 
	C27.942211,420.886505 27.962830,420.706573 28.009361,420.256042 
	C30.474140,420.417542 30.724558,422.352325 30.982918,424.648071 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M54.008999,474.357635 
	C54.902767,474.081085 55.696545,474.324219 55.913132,475.737183 
	C55.043964,475.952667 54.268696,475.689789 54.008999,474.357635 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M370.319580,612.825562 
	C369.546631,612.922974 369.107971,612.943237 368.341370,612.994751 
	C367.595734,613.380127 367.113922,613.583435 366.167053,613.592407 
	C364.970642,613.282349 364.290222,612.844543 363.545105,611.853271 
	C362.935852,609.156250 364.270447,608.218628 366.256714,607.731567 
	C368.804199,607.106995 371.398590,606.712463 374.362244,606.029846 
	C375.623779,605.851135 376.453461,605.937012 377.629028,606.411865 
	C378.598419,607.239502 378.808563,608.003967 378.665161,609.237671 
	C378.320709,610.082458 377.967133,610.432678 377.152832,610.768921 
	C375.749298,611.130920 374.618256,610.525513 373.316711,611.326416 
	C372.286987,611.997803 371.481018,612.393738 370.319580,612.825562 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M369.984436,613.241943 
	C370.059113,611.414062 371.030334,611.030151 372.652100,611.009399 
	C373.597443,611.605103 373.704773,612.322144 373.240906,613.412598 
	C372.568085,614.739868 371.680389,614.916199 370.356812,614.935303 
	C369.997162,614.482483 369.990356,614.031860 369.984436,613.241943 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M363.573547,611.712036 
	C364.461792,611.976685 365.039490,612.175232 365.816772,612.607361 
	C366.393036,613.252258 366.524750,613.731018 366.151550,614.569702 
	C365.178955,614.891846 364.466309,614.921509 363.398132,614.951477 
	C363.027924,614.745789 363.013214,614.539795 362.973145,614.025146 
	C362.635864,613.404846 362.488129,613.028748 362.618378,612.291992 
	C362.909607,611.879150 363.086304,611.762573 363.573547,611.712036 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M366.222473,614.868713 
	C365.924225,614.415161 365.956848,613.968018 366.002930,613.180908 
	C366.461029,612.872498 366.905640,612.904053 367.681854,612.980835 
	C367.945740,613.973267 367.635498,614.729004 366.222473,614.868713 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M368.145050,616.287292 
	C368.302490,616.279602 368.469574,616.540039 368.486389,616.692871 
	C368.503235,616.845764 368.525757,616.903259 368.530426,616.933716 
	C368.205597,617.098022 367.876007,617.231750 367.266296,616.911621 
	C367.319946,616.403442 367.653778,616.349243 368.145050,616.287292 
z"/>
<path fill="#ACA9A6" opacity="1.000000" stroke="none" 
	d="
M369.459351,618.007446 
	C369.804779,618.123535 369.990356,618.275330 370.175964,618.427063 
	C369.870941,618.534668 369.565918,618.642212 369.033936,618.608398 
	C368.937897,618.286926 369.102051,618.145630 369.459351,618.007446 
z"/>
<path fill="#BDB9B4" opacity="1.000000" stroke="none" 
	d="
M367.061005,616.733887 
	C367.246582,616.534546 367.507080,616.611450 368.151306,616.826294 
	C368.077026,617.233582 367.625336,617.696716 367.061005,616.733887 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M506.295471,551.818359 
	C502.107666,555.540955 498.317322,559.241455 493.240723,561.773926 
	C492.454559,562.526001 491.928040,563.065063 491.177399,563.778015 
	C487.967834,564.355713 486.853790,567.318420 484.259735,568.812622 
	C483.256683,569.717041 482.146942,569.832947 481.188141,570.751831 
	C480.150543,572.091431 478.923798,572.537964 477.335876,572.970825 
	C475.986420,574.093567 474.534302,574.570435 473.215820,575.769165 
	C472.992065,575.988953 472.514526,576.021851 472.275604,576.036011 
	C471.017548,577.140137 469.731720,577.844543 468.204651,578.748108 
	C467.970306,578.957153 468.001312,578.988098 467.984009,578.978455 
	C467.369019,579.491821 466.664032,579.690491 465.532928,579.535767 
	C463.190155,576.264038 465.993896,575.097107 467.784821,574.109253 
	C475.528748,569.838013 482.603577,564.571106 489.918304,559.663269 
	C494.194672,556.794128 498.418976,553.839050 501.989685,549.578369 
	C502.335297,549.115295 502.487000,548.942444 502.908142,548.560730 
	C503.931580,547.884644 504.743134,547.513367 505.760925,546.839600 
	C506.778046,546.623352 507.370483,546.895020 508.104126,547.623413 
	C508.509583,548.304626 508.616241,548.740479 508.573761,549.532288 
	C508.173920,550.807678 507.329498,551.168152 506.295471,551.818359 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M448.177734,589.714355 
	C447.506744,589.935425 447.081299,589.962402 446.336853,590.009888 
	C444.785400,591.391052 442.811981,591.388855 441.199188,592.722778 
	C440.524384,592.962585 440.101532,592.993103 439.361450,593.044678 
	C438.468597,593.544495 437.925201,594.059143 437.148254,594.732422 
	C435.901215,594.969299 434.877319,595.036011 433.470154,595.136475 
	C432.563812,595.278748 432.133331,595.116455 431.675049,594.364502 
	C431.763855,592.219360 433.428864,591.789368 434.826599,590.616272 
	C441.771332,588.203369 447.812744,584.683716 454.189392,581.915344 
	C455.844452,581.196899 457.416290,580.137878 459.720154,580.623169 
	C460.740997,581.830200 460.659698,582.755127 459.322571,583.760071 
	C458.993500,583.981750 458.517883,584.025879 458.279846,584.045044 
	C456.955841,585.060486 455.553070,585.591980 454.185852,586.728943 
	C453.521912,586.958008 453.098328,586.986450 452.357117,587.037231 
	C450.957703,588.061401 449.556000,588.593262 448.177734,589.714355 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M423.045013,597.921021 
	C422.419220,602.121582 419.686890,602.016602 416.372498,601.235352 
	C415.550659,600.721558 415.533997,600.159546 415.400787,599.346130 
	C415.305908,598.883545 415.268066,598.696472 415.195435,598.219849 
	C415.162079,597.732239 415.163483,597.534241 415.331665,596.755737 
	C415.630341,596.016846 415.762238,595.858459 416.172546,595.560181 
	C416.862396,595.330444 417.277557,595.312378 418.002533,595.428467 
	C418.904907,595.705200 419.476685,595.969421 420.357513,596.313965 
	C421.448242,596.743103 422.241791,597.062073 423.045013,597.921021 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M423.587250,598.167908 
	C422.272095,598.027344 421.354462,597.845093 420.174866,597.433044 
	C420.732391,594.452942 423.925964,594.700439 425.768188,592.631714 
	C426.855804,592.160339 427.625214,592.136963 428.764679,592.527954 
	C429.293701,592.929260 429.462128,593.144104 429.782959,593.741699 
	C430.179810,595.248047 430.081238,596.317383 429.132751,597.583801 
	C427.216553,597.953918 425.600647,598.040039 423.587250,598.167908 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M407.085938,606.162231 
	C404.025238,606.806458 401.854156,609.262634 398.371552,609.002625 
	C397.446045,608.342834 397.214111,607.621033 397.450745,606.435852 
	C398.253021,605.226135 399.222076,605.004089 400.550873,604.761475 
	C401.783264,604.620544 402.651642,604.471619 403.659302,603.712219 
	C404.369476,603.391174 404.806885,603.314148 405.591858,603.347900 
	C406.591919,603.599854 407.153015,603.960693 407.822235,604.751587 
	C408.792969,606.024048 407.801178,605.879944 407.085938,606.162231 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M459.362823,583.986328 
	C459.320679,583.211792 459.647858,582.441833 460.002441,581.357544 
	C460.134094,580.878479 460.238403,580.713867 460.567261,580.362549 
	C461.440460,579.742310 462.068573,579.280762 462.943481,578.652710 
	C463.606171,578.412659 464.002472,578.422485 464.640594,578.705688 
	C465.654388,578.916809 466.425262,578.946899 467.581421,578.972900 
	C465.839020,581.654785 462.888763,582.992004 459.362823,583.986328 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M408.286438,604.741943 
	C407.485016,604.852783 406.918701,604.705505 406.169495,604.325073 
	C406.595856,600.358276 410.056274,601.440186 412.652588,600.321045 
	C413.607300,600.247437 414.134125,600.357910 414.908508,600.892639 
	C413.901642,604.194885 410.527130,602.953369 408.286438,604.741943 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M429.206238,597.911621 
	C428.913330,596.920593 428.994232,595.973389 429.075989,594.667358 
	C429.605103,593.377747 430.422607,593.334106 431.655701,593.864990 
	C432.200317,594.407959 432.421570,594.659119 432.864868,595.040283 
	C432.770660,597.172302 431.578949,598.072021 429.206238,597.911621 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M468.335541,578.968872 
	C468.182892,576.933777 469.810059,576.563293 471.686890,576.062988 
	C471.855194,578.086243 470.690216,579.002747 468.335541,578.968872 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M441.310150,592.916931 
	C441.377686,590.424805 443.785065,590.933411 445.658508,590.054810 
	C445.637787,592.603882 443.212555,592.082703 441.310150,592.916931 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M473.339539,575.963074 
	C473.160950,573.949341 474.803162,573.580444 476.659424,573.035217 
	C476.852356,575.065430 475.198151,575.420227 473.339539,575.963074 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M448.283966,589.908264 
	C448.221680,587.943726 449.821472,587.561157 451.691132,587.071655 
	C451.798309,589.076538 450.186829,589.456177 448.283966,589.908264 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M454.296143,586.923584 
	C454.206390,584.940247 455.816925,584.561951 457.692505,584.073608 
	C457.797821,586.071472 456.187714,586.453369 454.296143,586.923584 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M415.398407,601.167053 
	C414.690247,601.134705 414.198883,601.074463 413.337036,601.003174 
	C412.482574,601.236023 412.101166,601.108765 411.803528,600.311035 
	C412.373199,599.095947 413.232788,598.688477 414.541565,598.387878 
	C415.133728,598.417358 415.366028,598.478821 415.891907,598.749390 
	C416.887238,599.523376 416.408478,600.069580 416.104248,600.854309 
	C416.049408,601.089233 415.615173,601.139099 415.398407,601.167053 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M506.431274,552.037292 
	C506.577545,551.444458 507.099609,550.838684 507.914429,550.135437 
	C509.171844,550.012024 509.427551,550.619080 509.264954,551.749390 
	C509.077789,552.066406 509.058929,552.068054 509.064697,552.077881 
	C508.316010,552.066650 507.561523,552.045532 506.431274,552.037292 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M481.285065,570.941040 
	C481.067841,569.520630 481.929779,568.972534 483.612976,568.967102 
	C483.551697,570.059326 482.811340,570.769043 481.285065,570.941040 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M437.250427,594.897644 
	C437.068573,594.015381 437.373718,593.260559 438.723206,593.081787 
	C438.923401,593.971069 438.636353,594.742798 437.250427,594.897644 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M491.293091,563.942627 
	C491.060364,563.057617 491.336243,562.284973 492.706360,562.065430 
	C492.933441,562.946716 492.658630,563.720276 491.293091,563.942627 
z"/>
<path fill="#685E5C" opacity="1.000000" stroke="none" 
	d="
M615.885010,362.531738 
	C615.344971,363.251831 614.373047,363.612396 614.375366,363.966644 
	C614.418213,370.599243 611.222656,376.664368 611.109863,383.673584 
	C611.134033,384.523834 611.099060,384.945160 611.057129,385.684265 
	C610.342041,391.174225 608.159302,396.051727 607.980225,401.686707 
	C607.958801,402.273163 607.944519,402.503876 607.870422,403.069611 
	C607.572998,404.226105 606.828247,404.820923 606.747742,406.034912 
	C606.664307,406.762115 606.536804,407.156036 606.078735,407.699463 
	C604.639221,407.936371 604.130127,408.855469 603.287964,409.840210 
	C602.642456,410.384735 602.174377,410.522705 601.298767,410.258484 
	C599.773499,408.716827 600.244202,407.255554 600.838745,405.451721 
	C601.446838,404.034760 601.772095,402.910187 602.084961,401.421814 
	C602.415649,400.214172 602.674683,399.343658 602.869019,398.107117 
	C603.928711,395.987244 605.416199,394.368744 604.905518,391.729126 
	C605.001465,391.181610 605.056274,390.967010 605.237732,390.448547 
	C605.744568,389.391327 606.425476,388.804932 606.629028,387.616791 
	C606.743286,386.438721 606.781250,385.575653 606.737244,384.375366 
	C606.719788,383.592072 606.724487,383.143860 606.745544,382.357849 
	C606.788696,381.351105 606.898315,380.693817 607.159790,379.739380 
	C607.577698,378.691864 608.095093,378.032593 608.203369,376.898102 
	C608.231384,376.193298 608.287598,375.793732 608.493042,375.114441 
	C609.004150,374.134613 609.559998,373.513824 609.653503,372.347809 
	C609.739746,370.938995 609.742493,369.844971 609.699036,368.409271 
	C609.684875,367.382111 609.717041,366.697235 609.764343,365.670349 
	C609.837708,364.882324 609.923340,364.442474 610.152832,363.702454 
	C610.746582,362.489746 611.382263,361.626923 611.022095,360.167480 
	C610.781494,358.632721 610.837036,357.433807 611.105469,355.855957 
	C612.863892,352.104095 611.526184,347.840424 614.746887,344.886871 
	C616.643250,346.538483 615.729370,348.513275 616.098816,350.690216 
	C616.129700,352.136139 616.101929,353.174866 616.082275,354.604767 
	C615.935486,356.447479 616.030945,357.906830 615.930847,359.672028 
	C615.907654,360.711945 615.907166,361.440582 615.885010,362.531738 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M565.128540,490.623657 
	C563.458557,492.769714 560.964844,493.889862 560.221558,496.759308 
	C559.415283,497.543060 558.737000,497.766327 557.601746,497.597931 
	C557.057739,497.337891 556.866943,497.185791 556.515442,496.708313 
	C556.608582,492.565796 559.321045,489.917938 561.013489,486.804932 
	C562.503845,484.063690 564.510620,481.608978 566.029419,478.470062 
	C566.370056,478.020050 566.520508,477.854218 566.928223,477.482910 
	C567.881714,476.815552 568.575867,476.351746 568.922119,475.186707 
	C569.263306,474.091064 569.548279,473.304474 569.900391,472.206451 
	C570.086548,471.712616 570.171509,471.519012 570.418091,471.053040 
	C571.088501,470.117188 571.663391,469.499573 572.144348,468.428467 
	C573.026733,466.766846 573.670776,465.344299 574.717285,463.750977 
	C577.688538,461.692596 579.074402,458.869232 580.641785,456.147003 
	C581.752808,454.217468 582.477478,451.771210 585.616882,451.735687 
	C584.975647,458.996674 579.792358,463.892914 576.685486,469.852570 
	C574.859741,473.354706 572.054626,476.320404 570.887695,480.585907 
	C570.663574,481.981476 570.142334,482.825989 569.202393,483.767822 
	C568.984680,483.975586 569.000000,483.998779 568.988037,483.992676 
	C568.211731,484.682831 567.777893,485.589111 567.174316,486.741760 
	C566.977722,486.971039 566.995605,487.001404 566.980774,486.990723 
	C565.987610,487.922455 565.536987,489.106293 565.128540,490.623657 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M585.930786,451.651367 
	C581.569519,453.768921 581.617615,458.843079 578.711670,461.780151 
	C577.829285,462.671936 577.465698,464.080383 575.522217,464.106873 
	C574.193726,463.368988 574.187439,462.281067 574.701416,461.433807 
	C578.571594,455.054047 580.852844,447.831451 585.555054,441.603241 
	C586.158325,441.526550 586.403809,441.555817 586.955200,441.792542 
	C588.319153,443.805389 586.793213,445.207794 586.500671,447.157837 
	C586.488953,447.746368 586.488098,447.981323 586.486816,448.567810 
	C586.487732,449.387878 586.468384,449.855438 586.181519,450.574097 
	C585.939270,451.009613 585.940979,451.193024 585.930786,451.651367 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M597.203491,423.773376 
	C595.770020,425.154358 596.168945,426.721100 595.932617,428.509460 
	C595.697021,429.029602 595.485840,429.176453 594.899048,429.227051 
	C593.121887,428.413269 591.941589,427.385834 592.122192,425.720398 
	C592.590393,421.404480 594.177734,417.465790 596.780518,413.992706 
	C597.399414,413.166779 598.514709,413.154846 599.861084,413.650757 
	C600.464600,414.330933 600.556030,414.834137 600.270020,415.710419 
	C599.700989,417.432770 599.329712,418.814758 598.933533,420.556641 
	C598.153625,421.651154 598.033508,422.743500 597.203491,423.773376 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M593.292175,434.691742 
	C592.859741,435.875885 592.670288,436.714996 592.240356,437.772217 
	C591.415283,438.009857 590.905334,438.204712 590.374695,438.887543 
	C589.958374,439.246429 589.697632,439.407806 589.322998,439.803528 
	C588.299377,440.446136 588.660583,441.755035 587.351196,442.082001 
	C587.013062,442.009430 586.980103,441.981110 586.964111,441.966431 
	C585.374878,436.894714 588.777344,429.666718 593.677002,428.648499 
	C595.555664,430.809662 594.095276,432.534576 593.292175,434.691742 
z"/>
<path fill="#4A4546" opacity="1.000000" stroke="none" 
	d="
M586.965210,442.387329 
	C587.550232,441.424530 588.087402,440.839600 588.898926,440.117432 
	C590.491150,442.974976 588.964417,445.199036 587.090210,447.678284 
	C586.835815,448.169250 586.667114,448.334106 586.248657,448.248230 
	C585.807495,446.166077 586.252258,444.446320 586.965210,442.387329 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M605.898315,408.164948 
	C605.844666,407.456635 605.872070,407.042053 605.903198,406.314941 
	C605.984741,405.408691 606.173889,404.856873 606.672241,404.110718 
	C606.821350,403.856079 606.861084,403.400421 606.894409,403.174133 
	C607.727722,402.446198 607.356445,401.178101 608.661499,400.890594 
	C608.967834,403.809113 608.738892,406.573334 606.461792,408.961060 
	C606.067932,408.855072 606.023621,408.656860 605.898315,408.164948 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M593.400513,434.970825 
	C593.323120,433.238678 593.596985,431.440552 593.819641,429.251831 
	C593.903442,428.746429 594.038452,428.631683 594.437073,428.483887 
	C594.900391,428.528625 595.100098,428.606384 595.604004,428.783447 
	C595.994446,431.178406 595.673889,433.328369 593.400513,434.970825 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M600.418701,415.978882 
	C599.988770,415.547943 599.905212,415.045135 599.731079,414.171448 
	C599.417358,412.737152 599.840149,411.804474 600.659912,410.444519 
	C601.520081,410.018341 601.954895,410.013641 602.716675,410.014038 
	C602.859497,412.204437 602.687073,414.394226 600.418701,415.978882 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M569.314270,483.984497 
	C569.021423,482.861633 568.817444,481.645691 570.526489,481.028229 
	C571.021118,480.965942 571.191040,480.978058 571.616333,480.992615 
	C572.353210,481.322815 572.541077,481.772949 572.203369,482.665741 
	C571.827759,483.274963 571.628784,483.519073 571.167603,483.835510 
	C570.521729,483.966309 570.082764,483.979858 569.314270,483.984497 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M597.337830,423.938171 
	C596.994080,422.836884 596.765442,421.585297 598.568970,420.982880 
	C598.988159,422.106384 599.238708,423.366486 597.337830,423.938171 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M605.747314,411.230408 
	C607.674744,412.478607 606.021240,413.483093 605.243408,414.821655 
	C605.146179,413.815247 605.308594,412.636841 605.747314,411.230408 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M590.528748,439.097351 
	C590.188293,438.134857 590.021118,437.039429 591.833008,437.754028 
	C591.600952,438.344177 591.201843,438.698029 590.528748,439.097351 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M594.592102,441.974701 
	C594.935059,442.840271 594.724182,443.631561 593.351929,443.964569 
	C593.047119,443.107117 593.314148,442.354980 594.592102,441.974701 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M603.601807,418.981995 
	C603.941040,419.826233 603.752014,420.616852 602.430481,420.996460 
	C602.065186,420.133453 602.294006,419.370056 603.601807,418.981995 
z"/>
<path fill="#4A4546" opacity="1.000000" stroke="none" 
	d="
M586.203247,450.715393 
	C585.951721,450.422241 585.965759,450.018311 585.989014,449.309875 
	C586.164429,448.873566 586.330750,448.741730 586.749084,448.804535 
	C586.823608,449.534332 586.646240,450.069489 586.203247,450.715393 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M588.736450,454.150635 
	C588.996521,454.448029 589.010803,454.910187 589.054932,455.718689 
	C589.084839,456.065033 589.059692,456.043793 589.052979,456.043884 
	C588.854919,456.194519 588.663513,456.345093 588.218628,456.232605 
	C588.140259,455.418182 588.315491,454.866821 588.736450,454.150635 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M587.942017,456.299744 
	C588.145264,455.982025 588.325439,455.994446 588.776001,456.025391 
	C589.088318,456.555298 589.130310,457.066620 589.099976,457.964905 
	C588.810120,458.261505 588.592712,458.171173 588.027100,458.004669 
	C587.758972,457.495605 587.838928,457.062744 587.942017,456.299744 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M572.237793,482.838287 
	C571.957947,482.543091 571.944397,482.100372 571.901306,481.326355 
	C572.055359,480.989410 572.238892,480.983734 572.697510,480.976532 
	C572.816467,481.546936 572.660278,482.118835 572.237793,482.838287 
z"/>
<path fill="#685E5C" opacity="1.000000" stroke="none" 
	d="
M587.002808,448.750458 
	C586.833984,448.999939 586.666992,449.000763 586.249084,449.003479 
	C585.998474,448.837616 585.998718,448.669830 585.999023,448.249786 
	C586.166199,447.998138 586.333435,447.998749 586.752563,448.001892 
	C587.004517,448.004395 587.004639,448.501770 587.002808,448.750458 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M544.843994,511.922485 
	C545.685181,515.907837 543.552856,518.327271 540.842346,520.441650 
	C534.581055,525.325867 529.456238,531.411377 523.317078,536.895325 
	C522.633972,537.347656 522.196716,537.509155 521.375732,537.390137 
	C520.563965,536.598328 520.720642,535.927795 521.178955,534.955200 
	C522.781250,532.976318 524.443542,531.467834 525.442688,529.058838 
	C527.056274,527.422241 528.663940,526.267029 530.340332,524.700317 
	C531.955383,523.570679 533.501831,522.798950 533.746582,520.547729 
	C534.181824,515.791321 538.984741,515.544861 541.212036,512.397583 
	C542.401367,511.376923 543.515869,511.753052 544.843994,511.922485 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M545.389648,512.043701 
	C544.243713,512.149841 543.378174,512.193054 542.265015,512.127075 
	C540.339355,507.831421 542.480042,506.517761 546.627319,506.637329 
	C547.933838,507.869904 548.014709,509.002502 547.230347,510.568909 
	C546.520935,511.272064 546.095520,511.626434 545.389648,512.043701 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M547.190125,511.044189 
	C546.953430,509.853821 546.960571,508.789917 547.246460,507.093384 
	C548.617310,506.117554 549.572571,506.298126 550.501465,507.550903 
	C550.758423,508.427063 550.717407,508.937012 550.347412,509.773376 
	C550.156311,510.110962 550.071838,510.551575 550.032104,510.772278 
	C549.151245,511.220428 548.336121,511.822601 547.190125,511.044189 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M518.887085,543.503174 
	C518.869873,543.861572 518.434937,543.940247 518.215515,543.966431 
	C517.514099,544.179260 517.084473,544.084167 516.506958,543.445129 
	C516.063965,542.438965 516.036133,541.725525 516.316895,540.664917 
	C516.606262,540.147705 516.764709,539.967041 517.274170,539.705322 
	C518.104248,539.729187 518.508972,539.963013 518.973145,540.658447 
	C519.039673,541.708740 518.971985,542.426819 518.887085,543.503174 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M520.605225,536.763916 
	C521.337585,536.930664 521.819275,536.974915 522.663757,537.039185 
	C522.581238,538.060730 521.863037,538.752991 520.231934,538.969116 
	C519.598694,538.732727 519.518616,538.564941 519.412476,538.118835 
	C519.428345,537.658875 519.470215,537.477234 519.671875,537.066345 
	C520.005981,536.771912 520.180237,536.706726 520.605225,536.763916 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M519.333374,540.832703 
	C518.767395,540.918457 518.490967,540.745056 518.154419,540.255127 
	C517.879761,539.886169 517.728760,539.732361 517.662598,539.265991 
	C517.918274,538.820984 518.089233,538.688599 518.577820,538.490173 
	C519.106262,538.471497 519.317200,538.518860 519.766602,538.785706 
	C520.005188,539.005188 520.086182,539.080627 520.129211,539.118713 
	C519.967957,539.662781 519.763733,540.168701 519.333374,540.832703 
z"/>
<path fill="#B4ADA6" opacity="1.000000" stroke="none" 
	d="
M538.957031,527.737793 
	C538.876343,527.929260 538.693237,527.949036 538.233521,527.970886 
	C538.256104,527.837341 538.555359,527.701721 538.957031,527.737793 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M608.997437,400.639404 
	C608.472839,401.552094 607.959412,402.117432 607.186768,402.815308 
	C606.602844,397.129883 608.880310,391.870575 610.758362,386.232483 
	C612.325317,389.567719 609.831299,392.746765 610.020508,396.611389 
	C609.694092,398.112976 609.351379,399.202484 608.997437,400.639404 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M556.830933,497.409424 
	C557.820190,497.060913 558.535767,497.024170 559.608643,496.979065 
	C559.966919,497.712677 559.967896,498.454651 559.963623,499.565491 
	C559.958374,499.934357 559.901855,500.416840 559.829346,500.648193 
	C559.025269,500.667297 558.293640,500.455048 557.289551,500.127380 
	C556.390076,499.343475 556.283020,498.570618 556.830933,497.409424 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M565.114258,490.870178 
	C565.152466,489.513947 564.488525,487.850830 566.617981,487.045898 
	C566.649170,488.084015 566.332458,489.187958 565.936646,490.631195 
	C565.691589,490.954071 565.525452,490.937653 565.114258,490.870178 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M557.069092,497.065674 
	C557.072144,497.825134 557.039734,498.552643 557.012207,499.646057 
	C555.829956,500.821289 556.004517,502.077728 555.967163,503.622498 
	C555.412598,504.489960 554.841614,504.994080 554.146484,505.760437 
	C553.060303,507.521271 551.943237,507.481079 550.501892,506.011688 
	C549.757385,500.520874 550.808960,498.927887 556.574829,496.849823 
	C556.961548,496.971039 557.033691,497.033661 557.069092,497.065674 
z"/>
<path fill="#928C87" opacity="1.000000" stroke="none" 
	d="
M550.772339,506.145660 
	C551.792908,506.416565 552.613220,506.743835 553.759521,506.086945 
	C554.178345,508.288910 553.902954,510.224854 550.534790,510.096313 
	C550.096069,509.573822 550.035828,509.036652 549.950012,508.095551 
	C550.419800,507.363037 550.300964,506.749329 550.772339,506.145660 
z"/>
<path fill="#928C87" opacity="1.000000" stroke="none" 
	d="
M516.607056,542.476562 
	C517.140747,542.882263 517.331299,543.240906 517.758972,543.796143 
	C518.572388,546.479065 513.972595,546.963867 515.678955,550.178833 
	C514.574646,550.798218 513.503174,551.138672 512.218872,551.746094 
	C511.273010,552.026367 510.539978,552.039612 509.442383,552.059631 
	C508.927826,551.515381 508.777863,550.964355 508.417542,550.225586 
	C508.192200,549.638428 508.177185,549.239014 508.263428,548.228638 
	C510.542389,546.021423 512.973755,544.789734 515.307617,542.814331 
	C515.823120,542.566589 516.043579,542.498108 516.607056,542.476562 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M567.276245,486.845520 
	C567.022278,485.831146 566.819519,484.578400 568.634033,484.038269 
	C569.037292,485.168610 568.564392,486.076782 567.276245,486.845520 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M607.491821,227.948822 
	C607.863342,228.474625 607.888000,228.910065 607.902710,229.673035 
	C607.443726,230.269333 606.994751,230.538101 606.302002,230.908386 
	C601.540527,229.993347 602.585022,225.313507 600.358521,222.381500 
	C600.028625,221.918289 599.897156,221.730820 599.608154,221.234619 
	C599.386353,220.702576 599.321960,220.479248 599.213440,219.907806 
	C599.163086,219.324738 599.156738,219.089783 599.158569,218.502319 
	C597.820374,210.060867 593.674255,202.939697 591.223206,195.231293 
	C590.925842,194.296341 590.291260,193.466156 590.862183,192.160553 
	C593.150391,191.765976 594.123047,192.952377 594.741028,194.678619 
	C598.626587,205.532227 604.139587,215.802780 606.414062,227.237640 
	C606.462891,227.483307 606.892822,227.653198 607.491821,227.948822 
z"/>
<path fill="#685E5C" opacity="1.000000" stroke="none" 
	d="
M590.894043,191.766052 
	C594.382751,200.748444 598.870544,209.145981 600.328369,218.774902 
	C597.525208,219.560516 597.000366,217.485306 596.488647,215.885742 
	C593.677429,207.098663 589.465820,198.897247 585.990784,190.390091 
	C585.303589,188.707779 585.098633,187.209946 587.165771,185.854904 
	C587.786194,185.662048 588.048157,185.634888 588.647888,185.812775 
	C589.289673,186.493164 589.593628,186.968521 589.932617,187.736420 
	C590.363220,188.403152 590.535217,188.861359 590.314453,189.748322 
	C590.317139,190.601395 590.489136,191.109665 590.894043,191.766052 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M588.994995,185.626709 
	C588.760193,186.060196 588.534790,186.102554 587.972229,186.213013 
	C586.994324,186.017639 586.320618,185.819290 585.567566,185.070648 
	C583.873840,181.389328 582.155457,178.097794 580.402954,174.434967 
	C579.803467,172.286179 578.973328,170.654648 577.526306,168.935028 
	C577.162170,167.855377 577.218933,167.128754 577.845093,166.173096 
	C579.541870,165.885620 580.688843,166.264206 581.331848,167.701462 
	C583.937378,173.525330 587.973572,178.721878 588.994995,185.626709 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M578.084595,165.605316 
	C578.088928,166.692612 578.053040,167.467972 577.995850,168.630127 
	C575.855042,170.208267 574.937866,168.491043 574.068604,167.213791 
	C572.316711,164.639618 570.649109,161.983963 570.185425,158.434509 
	C570.299255,157.830673 570.382385,157.598312 570.706299,157.087845 
	C572.176453,156.726303 573.338623,156.943985 574.637451,157.856522 
	C574.867737,158.131897 574.902039,158.582321 574.932800,158.806091 
	C576.254639,160.288437 576.547546,162.113922 577.747803,163.792084 
	C577.992126,164.455246 578.018250,164.874313 578.084595,165.605316 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M567.641907,148.789612 
	C568.399780,149.045471 568.812744,149.081619 569.530701,149.163483 
	C570.294067,151.155685 570.752441,153.102188 571.301025,155.418121 
	C571.459167,156.003967 571.527161,156.220367 571.354919,156.677704 
	C571.114624,156.918640 571.008850,157.002579 570.956970,157.045776 
	C566.063721,156.937698 565.540222,153.512802 565.591614,149.452667 
	C566.225769,148.716873 566.725342,148.540909 567.641907,148.789612 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M577.983765,163.665070 
	C575.526184,163.621033 575.264648,161.675873 574.962830,159.394684 
	C577.501221,159.364731 577.722778,161.349747 577.983765,163.665070 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M571.408447,157.078400 
	C571.135254,156.724976 571.155823,156.531311 571.283752,156.062607 
	C572.651978,156.107346 574.341187,155.511688 574.865051,157.771942 
	C573.812561,157.833984 572.757446,157.536072 571.408447,157.078400 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M590.429688,190.029633 
	C590.084167,189.635437 590.023132,189.177734 589.964783,188.374496 
	C591.261475,188.271912 592.591919,188.500793 590.429688,190.029633 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M615.122681,344.609406 
	C613.072571,348.184143 614.320312,352.201385 612.331177,355.761597 
	C608.877930,355.412720 609.775757,352.936829 609.956482,351.037476 
	C610.154785,348.953583 610.921997,346.919800 610.149841,344.375610 
	C609.933105,343.074249 609.998352,342.205353 610.347900,340.925171 
	C612.654907,335.925049 611.100525,331.049957 611.623413,326.341125 
	C611.862305,324.189789 610.985901,321.500458 614.534790,320.780151 
	C615.157471,321.843231 615.374573,322.722870 615.881958,323.785339 
	C616.573120,324.436737 616.825256,324.974915 616.960266,326.031860 
	C615.302429,331.316681 616.560913,336.432709 615.359802,341.718079 
	C615.124817,342.817596 615.110046,343.534851 615.122681,344.609406 
z"/>
<path fill="#685E5C" opacity="1.000000" stroke="none" 
	d="
M615.511292,341.971680 
	C615.159485,336.949463 614.337524,331.766235 615.922852,326.288361 
	C616.781189,325.387848 617.514099,325.276672 618.608154,325.810913 
	C618.911255,326.527832 618.915955,326.991638 618.901123,327.805908 
	C617.188171,330.661499 616.862732,333.430481 616.933899,336.402740 
	C616.977417,338.215118 617.776794,340.342194 615.511292,341.971680 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M565.710449,148.420990 
	C565.967224,152.434540 567.939209,154.769196 570.576660,157.005310 
	C571.788330,161.706665 573.791138,165.720169 577.633545,168.971008 
	C580.466309,169.386627 580.888245,171.180786 580.910034,173.631256 
	C581.824463,177.783279 583.844299,181.075928 585.738525,184.777222 
	C586.468811,185.265961 586.974304,185.498917 587.557373,186.006500 
	C587.127686,187.048660 585.785889,187.548050 586.418030,188.714005 
	C591.631775,198.331070 594.783508,208.838715 599.762634,218.856400 
	C600.091309,219.188034 600.088989,219.360672 600.072144,219.791870 
	C599.912476,220.198624 599.767334,220.346817 599.847412,220.709656 
	C600.072693,220.924332 600.023193,221.004852 600.055420,220.969223 
	C604.221985,229.663162 605.746155,239.173889 608.340698,248.367432 
	C612.492065,263.077393 613.985229,278.243866 616.189880,293.284546 
	C616.714294,296.862305 615.829163,300.537354 616.113464,304.583557 
	C616.137085,305.723145 616.110352,306.454834 616.097900,307.550690 
	C615.503601,311.348389 616.716003,314.926025 615.110840,318.668213 
	C611.217041,319.856079 611.687683,316.831543 611.678040,315.016357 
	C611.643799,308.553345 611.068237,302.134033 610.727356,295.693970 
	C609.626587,274.898468 605.113892,254.786362 599.422852,234.873215 
	C598.558594,231.849258 598.251282,228.686401 596.864258,225.392990 
	C596.401855,224.569199 596.204956,224.076874 595.981323,223.194061 
	C595.627014,221.452972 595.860535,219.950607 594.663940,218.465607 
	C594.367249,217.951233 594.263123,217.736298 594.037598,217.182861 
	C591.614807,207.271576 587.165588,198.532700 583.017944,189.723907 
	C575.300659,173.334091 566.779419,157.348862 556.150635,142.616333 
	C544.058777,125.855911 530.332458,110.479851 515.102356,96.542847 
	C509.011780,90.969383 502.796631,85.394730 495.432037,80.760498 
	C493.999969,79.705498 493.210114,78.448547 491.589264,77.607536 
	C489.325806,76.154663 487.570587,74.603104 485.582489,73.404686 
	C484.030151,72.468925 482.881439,71.450371 483.641541,69.119492 
	C488.336731,67.769035 490.165344,72.068497 493.719604,73.751961 
	C494.047638,73.934181 494.046936,73.951782 494.057404,73.942963 
	C496.729248,77.681572 500.189667,80.381165 504.928894,81.803772 
	C505.320618,81.690224 505.711060,81.710197 505.893921,81.779366 
	C508.764008,85.646515 512.523682,88.184067 516.628662,90.854935 
	C516.880859,91.097733 516.976074,91.516426 517.013916,91.727753 
	C524.660950,99.175369 531.562500,107.145752 540.031494,113.969986 
	C540.707947,114.397446 541.048462,114.696465 541.524902,115.326118 
	C542.479065,117.306488 542.537781,119.517883 545.205322,120.201111 
	C546.094421,120.705254 546.368286,121.270348 546.481445,122.261978 
	C547.032043,124.283600 548.437500,125.306587 549.814392,126.745102 
	C550.389587,127.387886 550.723755,127.824715 551.114624,128.539581 
	C551.445190,129.429428 551.944153,129.801331 552.791504,130.271088 
	C553.207764,130.618469 553.356567,130.781769 553.682007,131.230484 
	C554.434082,133.054169 555.481873,134.272934 556.805908,135.712158 
	C557.377686,136.067856 557.625183,136.269012 557.917480,136.762177 
	C559.293335,138.761307 560.512268,140.576172 561.866028,142.665466 
	C562.141724,142.848541 562.056091,142.895767 562.104980,142.896576 
	C562.795715,144.840149 564.392090,146.144714 565.710449,148.420990 
z"/>
<path fill="#2C2528" opacity="1.000000" stroke="none" 
	d="
M596.647583,223.938782 
	C600.877808,227.914093 600.536194,233.417038 601.829651,238.146545 
	C607.138672,257.559204 611.460449,277.171906 612.238281,297.463623 
	C612.458740,303.214783 612.825684,309.001587 613.037170,314.778198 
	C613.088745,316.187714 612.498230,317.836700 614.546265,318.931580 
	C614.941162,319.468689 614.951233,319.895966 614.950928,320.643433 
	C612.000977,321.703644 613.279358,324.113953 613.025452,325.885803 
	C612.315186,330.843445 614.393799,336.021667 611.463135,340.952820 
	C609.514954,339.800781 609.746155,337.992737 609.618286,335.869385 
	C609.607117,334.343842 609.554993,333.239929 609.604004,331.733246 
	C609.615723,330.803741 609.620972,330.276642 609.624512,329.364655 
	C609.612854,327.232574 609.655212,325.487274 609.854614,323.392761 
	C610.125183,321.868896 609.940125,320.773102 609.174561,319.416718 
	C608.557800,317.319458 608.665527,315.543610 608.939026,313.379089 
	C610.329285,307.006012 609.696228,301.123444 607.853821,294.955688 
	C607.436707,294.133759 607.297668,293.629395 607.228394,292.710754 
	C607.270325,291.541077 607.525391,290.795288 607.586914,289.632874 
	C607.879395,279.644379 604.920959,270.515076 603.339600,260.827942 
	C603.064880,260.293518 602.934143,260.093933 602.642944,259.580322 
	C602.232178,258.627533 602.128662,257.962219 602.135986,256.968231 
	C602.241760,255.863693 602.183167,255.098495 601.571655,254.147552 
	C601.336121,253.697845 601.256165,253.508240 601.093323,253.017349 
	C600.934998,252.303452 600.883240,251.887802 600.830688,251.154388 
	C600.786865,250.215759 600.806946,249.592010 600.781616,248.666107 
	C600.727234,247.371841 600.595520,246.408920 599.743713,245.366592 
	C599.424316,244.736313 599.328064,244.345215 599.284546,243.636871 
	C599.367981,242.533478 599.427246,241.734756 599.109741,240.646652 
	C598.657166,238.406525 597.108887,236.882187 597.060547,234.481201 
	C597.305420,230.680313 593.967834,227.486740 596.647583,223.938782 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M618.966797,325.650421 
	C618.207520,326.026825 617.508362,325.989624 616.461487,325.930481 
	C616.110352,325.477509 616.107056,325.046387 616.138000,324.291748 
	C616.871094,323.316742 617.569824,322.665314 618.555603,321.959656 
	C618.904114,323.015900 618.965576,324.126343 618.966797,325.650421 
z"/>
<path fill="#685E5C" opacity="1.000000" stroke="none" 
	d="
M616.420044,304.690002 
	C615.118225,304.435516 615.041626,303.450958 615.019348,302.433014 
	C614.610901,283.771393 611.245483,265.556091 606.698547,247.522751 
	C604.529053,238.918396 602.304260,230.327957 600.096130,221.332397 
	C603.678528,223.164917 602.819336,227.867599 605.763245,230.815948 
	C606.061707,231.437561 606.065186,231.865204 606.082703,232.613464 
	C607.332764,234.975067 607.276917,237.475540 608.642456,239.835175 
	C608.861450,240.545273 608.884460,240.960342 608.916687,241.687103 
	C609.002563,242.877289 608.970520,243.780197 609.693970,244.827026 
	C609.939514,245.804413 609.990784,246.511978 610.078186,247.570984 
	C609.633057,250.625656 610.858337,253.027817 611.751831,255.774750 
	C612.055359,256.434479 612.065308,256.859802 612.088989,257.604034 
	C614.160217,259.984009 613.982178,262.652313 614.158447,265.625671 
	C614.215027,266.701813 614.204285,267.394989 614.211792,268.434448 
	C615.069153,273.537170 616.629761,278.201385 616.112854,283.565399 
	C616.155151,284.413666 616.148682,284.833771 616.159180,285.568604 
	C617.740784,287.849396 616.157349,290.778656 618.401489,292.905640 
	C618.601318,293.408691 618.627869,293.596008 618.630615,294.069763 
	C615.338867,297.195312 618.007507,301.176758 616.420044,304.690002 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M608.886475,239.733658 
	C605.997742,238.834137 606.336426,236.137527 606.057861,233.332001 
	C609.064453,234.172394 608.140503,237.135452 608.886475,239.733658 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M609.928467,244.745331 
	C608.307983,244.791550 607.695679,243.969131 608.690552,242.206360 
	C609.899597,242.524521 610.011414,243.425522 609.928467,244.745331 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M616.385010,283.796967 
	C614.476746,279.374298 614.168457,274.552582 614.144958,269.241150 
	C614.627136,268.825958 615.024231,268.871124 615.721191,268.950867 
	C616.102905,271.105377 615.581482,273.288971 616.857666,275.657349 
	C617.305420,277.435608 617.582703,278.857391 617.881836,280.643921 
	C617.471863,281.872559 617.040161,282.736450 616.385010,283.796967 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M614.458618,265.766663 
	C612.169861,263.981506 612.929626,261.104584 612.065735,258.325928 
	C612.781860,257.957336 613.460999,257.991699 614.476807,258.030884 
	C615.315735,260.540833 615.537842,263.041473 614.458618,265.766663 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M618.679077,292.835144 
	C614.283203,292.410767 616.620728,289.016205 616.114990,286.318542 
	C616.697815,286.106354 617.219543,286.329376 617.909058,286.793152 
	C618.312317,288.838928 618.547852,290.643890 618.679077,292.835144 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M616.190308,359.989410 
	C614.558411,358.567902 614.845093,357.013153 615.805176,355.210663 
	C616.352783,355.205658 616.615234,355.415314 617.015259,355.843781 
	C617.111511,357.112152 617.070129,358.161774 617.032837,359.606293 
	C616.848755,359.999329 616.660645,359.997437 616.190308,359.989410 
z"/>
<path fill="#777171" opacity="1.000000" stroke="none" 
	d="
M567.994751,148.670013 
	C567.541016,149.008011 567.095154,149.006699 566.314331,149.016220 
	C565.979248,149.027039 565.975281,149.020294 565.967529,149.023712 
	C565.398254,148.285141 565.545837,147.618729 566.561218,147.009674 
	C567.122864,147.005814 567.298767,146.995987 567.738892,146.979004 
	C568.002930,147.424820 568.002808,147.877762 567.994751,148.670013 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M398.214661,605.867859 
	C397.991608,606.879333 397.984863,607.576599 397.982086,608.621887 
	C397.548981,609.005432 397.111969,609.041016 396.346924,609.100098 
	C396.014984,608.905640 396.011017,608.687622 395.992004,608.142883 
	C395.426270,607.240723 395.150848,606.554932 395.224457,605.381836 
	C395.822601,603.820923 396.637115,603.567749 397.999634,604.529541 
	C398.315979,605.058350 398.373474,605.306030 398.214661,605.867859 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M375.793762,610.364075 
	C376.481171,610.051025 376.914978,610.032715 377.674408,610.007202 
	C379.109406,610.255249 379.322876,609.232117 380.162964,608.488647 
	C382.545685,607.526489 384.750549,607.454346 387.308167,607.271484 
	C390.528809,608.802185 390.656860,609.241760 388.305481,610.757690 
	C387.983002,610.967957 387.982727,611.131470 387.992889,611.215881 
	C384.453369,611.350464 382.084351,614.662964 378.170410,614.729004 
	C377.310303,614.443176 376.818817,614.153748 376.081665,613.708984 
	C375.066772,612.657227 375.051056,611.683838 375.793762,610.364075 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M388.391266,610.981567 
	C388.012146,610.151611 390.650879,609.805298 388.245270,608.399292 
	C388.207581,608.014404 388.337616,607.810974 388.787445,607.434753 
	C389.580322,607.133301 390.062073,607.084961 390.910034,607.179932 
	C391.486786,607.365173 391.704803,607.475403 392.160248,607.864258 
	C392.553619,608.612976 392.579315,609.088135 392.238495,609.862305 
	C392.023499,610.155334 392.075439,610.571289 392.077087,610.780762 
	C390.985687,610.991821 389.892609,610.993469 388.391266,610.981567 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M392.351715,610.127075 
	C392.013489,609.649048 392.003510,609.142761 391.996521,608.257935 
	C391.860321,606.941040 392.427185,606.638489 393.557617,606.630859 
	C394.040466,606.924988 394.178101,607.120789 394.159576,607.639771 
	C393.995880,608.411865 393.988312,608.860779 393.986633,609.646057 
	C393.555054,610.021240 393.117493,610.060059 392.351715,610.127075 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M394.333679,607.957947 
	C394.001434,607.767090 393.999420,607.571167 393.988068,607.081604 
	C393.289795,605.303284 393.963928,604.702087 395.735962,604.855957 
	C396.041809,605.793945 396.011810,606.470886 395.979401,607.481934 
	C395.539276,607.861755 395.101624,607.907349 394.333679,607.957947 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M375.750916,610.020874 
	C376.001465,611.006348 375.955597,611.943359 375.872864,613.216980 
	C375.128021,613.645691 374.420074,613.737793 373.355530,613.770325 
	C372.998962,613.035156 372.999023,612.359497 372.999573,611.341919 
	C373.072968,608.877441 374.461456,609.897095 375.750916,610.020874 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M235.173309,610.567505 
	C234.501450,610.829529 234.087570,610.856140 233.365402,610.911865 
	C233.058533,610.774231 233.059952,610.607483 233.046692,610.191040 
	C231.504288,608.441284 229.474945,608.183960 227.240021,607.536255 
	C226.819183,607.165222 226.687347,606.977966 226.479523,606.456726 
	C226.429901,605.897339 226.456268,605.671875 226.643677,605.148071 
	C228.449966,603.953186 230.237274,604.274780 232.295395,604.341919 
	C233.370697,604.858276 233.763855,605.685913 234.753586,606.346313 
	C235.167801,606.711914 235.317490,606.879333 235.613052,607.355225 
	C235.967560,608.592224 235.975067,609.496033 235.173309,610.567505 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M226.607773,606.973511 
	C229.171600,607.118530 231.360107,607.314087 232.964722,609.592285 
	C231.596268,609.649902 230.160492,609.358521 228.355438,609.044312 
	C227.696945,608.091858 225.222229,608.967224 226.607773,606.973511 
z"/>
<path fill="#928C87" opacity="1.000000" stroke="none" 
	d="
M226.952576,606.770630 
	C226.004166,608.170654 227.647583,607.986816 227.879150,608.806641 
	C226.638748,608.869080 225.061981,609.502502 224.052734,607.568481 
	C223.979538,607.020508 223.991928,606.802490 224.008286,606.256958 
	C224.723221,605.405762 225.496078,605.262878 226.666351,605.803345 
	C226.993637,606.055420 226.954605,606.531677 226.952576,606.770630 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M116.026886,548.357422 
	C117.630936,548.193176 119.140266,548.614319 119.967896,550.637207 
	C118.364830,550.802307 116.858421,550.375000 116.026886,548.357422 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M135.120758,563.316650 
	C136.132767,563.060364 137.415833,562.797058 137.925110,564.685791 
	C136.817795,565.022461 135.901321,564.573059 135.120758,563.316650 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M132.154953,561.268066 
	C133.170624,561.041321 134.444946,560.819946 134.932251,562.677612 
	C133.818207,563.011475 132.901398,562.557129 132.154953,561.268066 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M127.157349,557.270447 
	C128.157532,557.044739 129.410263,556.841797 129.963837,558.628540 
	C128.843079,559.023682 127.921257,558.574707 127.157349,557.270447 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M73.003029,502.352966 
	C74.445816,502.061127 75.015778,502.903778 75.028992,504.600342 
	C73.522026,504.963257 72.995003,504.078583 73.003029,502.352966 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M63.198715,489.796234 
	C63.392586,488.242798 64.015030,487.591583 64.937294,489.751190 
	C64.483002,490.002075 64.010803,489.955048 63.198715,489.796234 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M92.087601,525.291138 
	C95.000458,525.687927 96.685722,527.769897 97.960335,530.672974 
	C97.519485,531.255554 97.052284,531.491699 96.337540,531.803711 
	C95.898277,529.067932 92.591225,528.254028 92.087601,525.291138 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M235.257690,610.893921 
	C234.947876,609.839111 234.980438,608.875244 234.985443,607.546875 
	C235.333939,606.745483 235.804306,606.584900 236.643463,606.988037 
	C236.950729,608.264099 236.983475,609.252563 237.013290,610.611206 
	C236.540268,610.982544 236.070175,610.983704 235.257690,610.893921 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M238.980682,611.407104 
	C239.272903,610.560303 239.787521,610.003845 240.377441,610.612061 
	C240.978531,611.231873 240.430359,611.718933 239.507782,612.042419 
	C239.168457,611.951843 239.092712,611.803284 238.980682,611.407104 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M265.171448,617.885254 
	C264.557861,618.108337 264.116455,618.057251 263.341492,618.017334 
	C262.204254,617.399414 261.400604,616.770264 260.295898,616.061646 
	C259.797302,615.493347 259.889587,615.056091 260.541321,614.467773 
	C261.550018,614.005310 262.275879,613.929688 263.378296,613.977661 
	C264.707458,614.174622 265.588898,614.551514 266.681702,615.313721 
	C267.069580,615.756104 267.185181,615.964966 267.206970,616.519470 
	C266.523315,617.113708 265.933472,617.362366 265.171448,617.885254 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M267.426941,616.896729 
	C267.120392,616.697876 267.127594,616.530762 267.110229,616.113953 
	C266.674225,615.512817 266.431335,615.068909 266.396027,614.143250 
	C266.755463,612.963562 267.345703,612.503357 268.562836,612.331177 
	C269.777771,612.547913 270.333557,613.053284 270.688477,614.232910 
	C270.689972,615.444214 270.351349,616.123108 269.362854,616.809326 
	C268.583130,616.951538 268.161957,616.939941 267.426941,616.896729 
z"/>
<path fill="#7D7777" opacity="1.000000" stroke="none" 
	d="
M269.017120,617.272522 
	C269.264374,616.457397 269.524414,615.951721 269.885254,615.177734 
	C270.438171,614.576538 270.937042,614.477051 271.818054,614.825317 
	C272.659149,615.736023 272.750824,616.491028 272.252838,617.625427 
	C270.961975,618.352295 269.799988,619.551086 269.017120,617.272522 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M272.351410,617.989990 
	C272.011902,617.254028 271.998688,616.555664 272.202087,615.228027 
	C273.049500,614.236267 273.730499,614.158875 274.779480,614.329285 
	C275.993591,614.800110 276.753448,615.313171 277.093567,616.576599 
	C276.850098,616.950562 276.662170,616.980957 276.195068,617.076111 
	C275.362091,617.316345 274.808319,617.491760 274.115845,617.941406 
	C273.544006,618.152954 273.110840,618.090271 272.351410,617.989990 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M256.113251,614.777588 
	C255.567566,615.037598 255.116486,615.024353 254.329285,614.970337 
	C253.985413,614.259399 253.977692,613.589294 253.969269,612.583130 
	C253.831985,612.027039 253.695389,611.807068 253.707108,611.227051 
	C255.404694,610.079224 256.316193,610.773438 256.954041,612.576538 
	C256.728729,613.479919 256.468292,613.992188 256.113251,614.777588 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M253.816223,610.725037 
	C254.028168,611.247925 254.022476,611.447021 253.992691,611.946533 
	C253.237900,612.184692 252.507202,612.122437 251.410294,612.065308 
	C250.771057,611.834351 250.498047,611.598328 250.122955,611.109680 
	C250.899384,608.240540 252.298126,609.706665 253.816223,610.725037 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M261.293030,614.519287 
	C260.816925,615.066223 260.528809,615.281799 260.117767,615.739746 
	C259.825897,615.978210 259.656982,615.974304 259.238739,615.923401 
	C258.981781,615.174133 258.974182,614.471924 258.968811,613.416687 
	C259.342804,612.679810 259.795898,612.496887 260.688049,612.644104 
	C261.378815,613.187805 261.523804,613.658936 261.293030,614.519287 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M261.343628,612.931824 
	C260.559814,612.896057 260.103943,612.923279 259.309570,613.007141 
	C258.531281,613.030029 258.091553,612.996277 257.320496,612.965149 
	C256.207031,612.347900 255.424896,611.728088 254.338318,611.078491 
	C252.831390,610.837097 251.628906,610.625366 250.223633,610.635376 
	C249.578537,610.844543 249.136230,610.831970 248.365128,610.773376 
	C247.344391,610.535645 246.925232,609.992981 246.206558,609.286255 
	C245.516342,609.045105 245.083359,609.022339 244.325500,608.985229 
	C242.518799,608.948730 241.111008,608.356995 239.340164,608.159912 
	C238.544388,607.652100 238.028946,607.386108 237.215729,607.197876 
	C236.483597,607.217896 236.049210,607.160156 235.286346,607.142334 
	C234.957870,607.182251 235.044678,607.005310 235.062851,606.908447 
	C234.135468,605.900879 233.948868,604.813782 234.557129,603.223145 
	C235.837570,602.131653 236.970505,602.225159 238.121063,602.546143 
	C247.532257,605.172119 257.047150,607.319702 266.711334,608.790710 
	C267.888245,608.969910 268.940063,609.445679 269.573792,611.037598 
	C269.594818,611.734375 269.540710,612.012573 269.235046,612.633545 
	C268.436829,613.115662 267.890137,613.255066 267.163330,613.617676 
	C266.573425,614.487061 265.970825,614.710754 264.899475,614.569275 
	C263.494720,614.201660 262.847900,613.088989 261.343628,612.931824 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M245.961517,609.427551 
	C246.816284,609.042297 247.572037,609.221680 247.981445,610.434021 
	C248.007324,611.273682 247.978287,611.820007 247.957001,612.777100 
	C247.964737,613.187988 247.526474,613.145813 247.308105,613.125366 
	C246.942886,613.022400 246.796036,612.940002 246.428360,612.734253 
	C246.129593,611.669617 246.051666,610.728455 245.961517,609.427551 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M239.234650,608.195557 
	C240.542267,608.084717 242.024673,608.251404 243.753845,608.694580 
	C242.266891,610.679932 240.927521,608.752625 239.234650,608.195557 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M566.935059,146.654419 
	C566.642334,147.488922 566.337646,147.962204 565.996399,148.731293 
	C563.469421,148.092957 562.297058,146.197952 562.093506,143.269073 
	C563.603271,144.226440 566.707336,143.231613 566.935059,146.654419 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M561.468872,136.836456 
	C561.469360,134.634033 558.818176,133.132462 559.856567,130.412781 
	C560.392212,130.330170 560.912292,130.560852 561.688843,130.917297 
	C562.009766,132.166336 562.471985,133.072968 563.682617,133.876099 
	C563.976135,134.470779 563.991760,134.912659 564.002441,135.686722 
	C563.997498,136.018906 563.973022,136.197723 563.938416,136.281067 
	C563.440247,136.657547 562.956970,136.896805 562.121948,136.899475 
	C561.850525,136.882614 561.595947,136.852966 561.468872,136.836456 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M562.111755,142.479919 
	C559.309326,142.312149 558.902527,139.810165 558.004395,137.350494 
	C558.819580,137.189896 559.569885,137.809296 560.687622,137.159332 
	C561.308105,138.744278 561.694946,140.427795 562.111755,142.479919 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M562.019653,137.109009 
	C562.352600,136.649307 562.854675,136.416016 563.630249,136.273575 
	C563.719788,137.372757 563.385132,138.115112 562.019653,137.109009 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M540.224487,114.770935 
	C537.313171,114.804512 536.074524,112.588577 534.543274,110.948364 
	C528.783447,104.778496 521.968811,99.615356 517.052002,92.291801 
	C522.353760,94.350349 526.704163,98.176559 530.521790,102.341690 
	C533.306519,105.379829 536.212891,108.209213 539.608337,110.972389 
	C540.343689,111.357101 540.632202,111.772614 540.865479,112.646896 
	C540.897766,113.552238 540.754456,114.040016 540.224487,114.770935 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M516.784546,90.822662 
	C511.920227,89.979454 508.146149,87.333923 506.025940,82.236763 
	C506.076752,81.848534 506.549988,81.722038 506.792053,81.759506 
	C507.636902,82.834419 509.061951,82.445152 509.962524,83.559113 
	C510.474518,84.026230 510.753998,84.297882 511.522827,84.811615 
	C512.817139,85.685280 513.613098,86.326149 514.726685,86.955452 
	C515.044373,86.943886 515.492859,87.054611 515.713684,87.120850 
	C513.291809,88.956276 515.728821,89.586235 516.784546,90.822662 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M540.391113,113.150696 
	C540.060913,112.463852 540.026733,112.050949 539.968140,111.328537 
	C540.735840,110.694633 541.527832,110.370247 542.641235,110.042465 
	C542.973267,110.815773 542.983887,111.592468 542.981445,112.757713 
	C542.257812,113.647820 541.496887,113.736168 540.391113,113.150696 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M516.745911,85.158234 
	C516.955322,85.058441 516.955627,85.552223 516.934509,85.798798 
	C516.913391,86.045372 516.460388,86.027481 516.234009,86.017212 
	C516.098511,85.696930 516.274780,85.447289 516.745911,85.158234 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M545.199341,120.740791 
	C542.520020,120.658676 541.212036,119.208618 540.945190,116.415009 
	C541.313660,115.631607 541.781372,115.467445 542.662537,115.786926 
	C543.503418,116.871849 544.021545,117.731392 544.782898,118.781151 
	C545.391357,119.392647 545.530029,119.878571 545.199341,120.740791 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M557.077454,135.638962 
	C554.457581,135.773254 553.272461,134.203094 552.962830,131.403107 
	C553.428955,130.622803 553.941772,130.686554 554.732300,130.971039 
	C555.164185,131.033264 555.332153,131.034424 555.751221,131.017029 
	C556.630493,131.550018 556.931702,132.265793 557.121521,133.363770 
	C557.246765,133.844849 557.296692,134.037521 557.187988,134.483063 
	C557.047791,134.936340 557.066345,135.136749 557.077454,135.638962 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M550.036011,126.610504 
	C547.860596,126.908707 546.731262,125.577682 546.061462,123.319717 
	C546.207092,122.798775 546.373596,122.623863 546.863037,122.613052 
	C549.004028,123.232697 549.505615,124.755135 550.036011,126.610504 
z"/>
<path fill="#777171" opacity="1.000000" stroke="none" 
	d="
M542.991943,115.652283 
	C542.530457,116.014076 542.075623,116.015839 541.278687,116.035820 
	C540.833130,115.737900 540.649231,115.478844 540.171936,115.163284 
	C539.979858,114.566956 540.000793,114.084206 540.058472,113.239113 
	C540.814392,112.931389 541.533691,112.986008 542.610596,113.093445 
	C542.978394,113.861588 542.988464,114.576920 542.991943,115.652283 
z"/>
<path fill="#A39B95" opacity="1.000000" stroke="none" 
	d="
M557.334961,134.347687 
	C556.769592,133.455719 556.398499,132.590668 556.014893,131.362045 
	C557.536865,131.136734 558.041687,132.068054 557.903442,133.851913 
	C557.889648,134.219650 557.529236,134.374573 557.334961,134.347687 
z"/>
<path fill="#777171" opacity="1.000000" stroke="none" 
	d="
M547.145752,122.424973 
	C546.996826,122.820969 546.807617,122.864777 546.329529,122.941147 
	C545.837097,122.443329 545.633606,121.912964 545.193359,121.217529 
	C544.971436,120.589996 544.986267,120.127541 545.013672,119.318222 
	C547.028320,119.127541 547.018860,120.632401 547.145752,122.424973 
z"/>
<path fill="#777171" opacity="1.000000" stroke="none" 
	d="
M554.962646,130.708160 
	C554.535461,131.847687 553.969849,131.419327 553.187988,131.102112 
	C552.957153,131.039200 552.970459,131.036530 552.962036,131.038300 
	C552.598694,130.618515 552.469971,130.136459 552.798462,129.279846 
	C553.953125,129.050064 554.715698,129.349472 554.962646,130.708160 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M552.719360,128.939438 
	C553.017639,129.426636 553.005188,129.887650 552.973206,130.694366 
	C552.001099,130.928802 551.229126,130.601974 551.140808,129.156662 
	C551.583801,128.849503 551.996216,128.881378 552.719360,128.939438 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M557.130737,134.429382 
	C557.140686,134.320786 557.510681,134.225754 557.700195,134.222702 
	C557.712463,134.365799 557.536316,134.513214 557.195190,134.698914 
	C557.029236,134.735947 557.120728,134.537964 557.130737,134.429382 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M435.688873,40.324165 
	C437.124664,40.219803 438.268372,40.012985 438.907776,41.684486 
	C439.037079,43.113678 439.616486,43.848969 440.615936,44.271225 
	C451.935516,49.053673 462.424072,55.476009 473.793884,60.852757 
	C474.165649,60.812691 474.600952,60.882240 474.818604,60.916969 
	C475.658051,61.814129 476.598358,62.207451 477.741028,62.838688 
	C477.966522,63.042461 477.992432,63.001614 477.976166,63.022804 
	C479.227844,64.350418 481.272064,64.227081 482.791748,65.745071 
	C483.042358,65.958748 483.000000,66.000000 483.020508,65.978615 
	C483.542419,66.550362 483.792542,67.225975 483.581024,68.352585 
	C480.540436,71.033325 478.668396,67.974121 476.014099,67.181503 
	C475.493988,66.916771 475.292633,66.801979 474.811768,66.487915 
	C473.561707,65.381256 472.521667,64.581375 470.935791,64.033615 
	C470.441193,63.809143 470.248932,63.709099 469.788086,63.430054 
	C468.858368,62.727371 468.200684,62.198215 467.104126,61.777924 
	C466.237518,61.386185 465.692169,61.065224 464.909027,60.529922 
	C463.633057,59.295528 462.509918,58.421421 460.677490,58.151299 
	C459.926300,57.962646 459.507294,57.806992 458.797363,57.448494 
	C451.257935,52.824791 443.915588,48.589081 435.338531,46.074112 
	C434.750275,45.913727 434.518951,45.832203 433.960999,45.578621 
	C429.227936,41.804062 423.905853,40.157242 418.647766,38.361866 
	C416.507507,37.631081 414.156189,37.266914 412.523071,34.898491 
	C412.212311,34.073212 412.168640,33.575272 412.327820,32.704903 
	C412.835541,31.608543 413.489746,31.310617 414.659271,31.336189 
	C415.534790,31.551056 416.040985,31.694162 416.690308,32.069168 
	C422.285980,36.638893 429.346619,37.274406 435.688873,40.324165 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M483.271057,69.150253 
	C483.039154,68.193214 483.014862,67.448189 483.015808,66.330200 
	C487.954407,66.457687 490.571350,70.307999 493.908234,73.622833 
	C490.024933,74.056778 488.304565,69.745171 484.333160,69.055855 
	C483.808746,69.144066 483.643707,69.253174 483.271057,69.150253 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M483.045349,65.590240 
	C481.003418,66.081886 479.193542,65.695137 478.025421,63.389076 
	C479.265564,63.049923 480.571228,63.055855 482.252258,63.059063 
	C482.767853,63.778137 482.908081,64.499939 483.045349,65.590240 
z"/>
<path fill="#777171" opacity="1.000000" stroke="none" 
	d="
M510.431519,85.225945 
	C509.192627,84.147232 508.244507,83.277290 507.165283,82.102158 
	C508.409271,81.926262 509.784393,82.055542 511.548401,82.338272 
	C511.948761,83.126274 511.960236,83.760818 511.996490,84.719894 
	C512.021240,85.044418 512.003052,85.009804 512.020142,85.010185 
	C511.653809,85.322159 511.212982,85.455666 510.431519,85.225945 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M477.875183,62.771305 
	C476.814270,62.979816 475.542114,63.165714 475.062469,61.302990 
	C475.477173,60.946236 475.918091,60.940773 476.690216,60.951996 
	C477.275543,61.479168 477.529694,61.989658 477.875183,62.771305 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M413.230347,31.780960 
	C413.004578,32.504475 412.993286,32.910976 412.982483,33.622559 
	C412.490326,34.555996 411.812164,34.790787 410.681458,34.819267 
	C408.679779,34.430347 407.131805,33.831039 405.372925,32.839825 
	C404.341064,32.192772 403.719574,31.516357 402.472229,31.313683 
	C400.173798,30.862366 398.228577,30.339067 395.924561,29.929615 
	C394.822235,29.538155 394.147125,28.973818 392.969055,28.838211 
	C392.232269,28.788868 391.815308,28.723665 391.108490,28.504902 
	C390.103729,27.991365 389.444702,27.447769 388.232788,27.646168 
	C387.505096,27.698681 387.091431,27.672047 386.391174,27.486393 
	C385.388062,27.023451 384.771301,26.472094 383.658508,26.265450 
	C382.739838,26.122486 382.125854,26.002148 381.196960,25.770754 
	C379.214294,25.028805 377.631500,24.000099 375.377960,24.633190 
	C374.614349,24.747906 374.178619,24.750452 373.437683,24.607693 
	C372.385254,24.197678 371.806549,23.555185 370.679504,23.338020 
	C369.571533,23.186844 368.761475,23.092205 367.656128,22.899410 
	C366.385010,22.579813 365.416321,22.292898 364.104370,22.715271 
	C363.190216,22.942833 362.566254,23.007128 361.622375,22.986168 
	C361.108154,22.917471 360.906799,22.872202 360.421783,22.714701 
	C359.464630,22.227526 358.820831,21.771910 357.697205,21.855047 
	C356.783722,21.987547 356.164124,22.010836 355.220947,21.927832 
	C354.691620,21.818354 354.483368,21.755442 353.980164,21.552498 
	C352.630798,20.556396 351.414917,20.219103 349.730621,20.294359 
	C348.202972,20.304005 347.023285,20.224031 345.489136,19.985746 
	C343.713135,19.441952 342.250305,19.292374 340.387115,19.272329 
	C339.497406,19.214361 338.990845,19.143921 338.107483,18.965973 
	C335.962311,18.226051 334.120728,18.387489 331.886108,18.389530 
	C329.497620,18.498619 327.524536,18.440842 325.132690,18.080021 
	C316.518433,16.909130 308.315369,17.334463 299.695862,17.867153 
	C297.281647,18.480902 295.248932,18.463333 292.793030,18.429344 
	C290.183258,18.470726 287.975067,18.124401 285.428101,18.879391 
	C283.193085,19.388071 281.319794,19.376352 279.063232,19.389799 
	C277.434479,19.387341 276.185059,19.289612 274.610626,19.716854 
	C273.788940,19.937710 273.313690,20.030558 272.479309,20.148924 
	C270.963715,20.318459 269.779633,20.259993 268.314545,20.741837 
	C267.290955,21.009964 266.592804,21.104780 265.543274,21.228645 
	C264.262543,21.349419 263.330109,21.422215 262.086365,21.801188 
	C261.039307,22.071213 260.323730,22.165071 259.242249,22.271332 
	C256.153137,22.211048 253.572250,22.637859 251.034546,24.588177 
	C249.234604,25.354021 247.685745,25.347456 245.764343,25.408875 
	C239.390442,26.151999 233.632401,27.768887 227.737518,30.249023 
	C226.982361,30.678005 226.524200,30.861488 225.695038,31.084690 
	C222.797379,31.564264 220.251663,31.954882 217.651581,33.416546 
	C216.909729,33.749802 216.469788,33.891651 215.684113,34.061958 
	C214.477661,34.264858 213.584991,34.291584 212.438492,34.722931 
	C211.111694,35.252914 210.087158,35.653271 208.705444,36.035686 
	C207.740036,36.278790 207.088364,36.409523 206.123352,36.681358 
	C205.116928,36.898762 204.441956,36.887070 203.468155,36.543598 
	C201.968277,34.349854 203.988205,33.654079 205.042084,32.216686 
	C205.458328,31.840172 205.635284,31.702629 206.107727,31.409460 
	C207.794144,30.676662 209.377792,30.564709 210.838837,29.335304 
	C211.100662,29.145859 211.030273,29.020544 210.984314,28.965305 
	C211.405640,28.575659 211.920670,28.466568 212.793884,28.850018 
	C220.671066,29.004021 227.796997,26.255022 234.790222,24.151630 
	C245.317276,20.985342 255.900635,18.673008 266.697723,16.985456 
	C285.649292,14.023391 304.770905,12.969509 323.838684,14.222720 
	C340.479279,15.316406 357.151855,16.603867 373.558990,20.480675 
	C386.461548,23.529398 399.431976,26.266930 412.551819,30.038202 
	C413.347900,30.468586 413.519745,30.919210 413.230347,31.780960 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M435.872528,39.972469 
	C435.888184,41.219589 435.352783,42.074959 434.453888,41.583439 
	C429.266815,38.747074 423.555756,37.238163 418.167175,34.930019 
	C417.581268,34.679031 417.326050,33.656006 416.875427,32.646076 
	C423.230011,34.485287 430.090424,35.476078 435.872528,39.972469 
z"/>
<path fill="#777171" opacity="1.000000" stroke="none" 
	d="
M413.293976,32.080967 
	C413.000305,31.655256 412.984772,31.212536 412.949249,30.440947 
	C413.543884,30.328278 414.158478,30.544479 414.900879,31.084316 
	C414.543121,31.626621 414.057648,31.845289 413.293976,32.080967 
z"/>
<path fill="#A7A6AB" opacity="1.000000" stroke="none" 
	d="
M213.070343,28.758781 
	C212.616287,29.119545 212.128204,29.121843 211.289230,29.017105 
	C210.932190,27.938814 211.281189,27.225906 212.644104,26.988480 
	C212.992218,27.442478 213.014267,27.921396 213.070343,28.758781 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M33.461624,187.319275 
	C39.322765,171.813538 47.501183,157.617569 56.667801,143.967133 
	C65.838036,130.311279 75.480087,117.044907 87.072624,105.258171 
	C90.077591,102.202850 92.732239,98.744858 95.840355,95.742989 
	C96.992111,94.630608 97.900261,92.997650 100.281731,93.470795 
	C100.760445,94.273048 100.924515,94.925423 100.829895,95.936684 
	C100.471642,97.386040 99.787064,98.249428 98.688065,99.201874 
	C97.364639,99.997017 96.313133,100.616669 95.520309,102.002068 
	C93.972038,103.545418 92.357079,104.564354 90.990250,106.310745 
	C89.866867,107.679436 89.278587,109.045998 88.033813,110.307808 
	C87.172737,110.969231 86.482635,111.362900 85.874451,112.286621 
	C85.588997,112.690987 85.467323,112.848518 85.130951,113.214996 
	C84.307854,113.925629 83.568405,114.266853 82.917999,115.173141 
	C82.452942,115.972717 82.193214,116.537613 81.845505,117.424889 
	C77.924591,123.947304 72.200470,128.665390 68.178589,135.139679 
	C67.684044,135.766342 67.408951,136.130905 66.952225,136.791565 
	C59.504036,146.836563 53.539909,157.417862 46.965279,168.007736 
	C45.700336,169.160156 45.180897,170.318619 44.965626,171.996124 
	C44.498318,173.669479 43.835880,174.871582 42.743378,176.226395 
	C40.077286,178.277878 40.207699,181.267609 39.010666,184.027206 
	C38.281670,185.420074 37.463089,186.295609 36.250969,187.304688 
	C35.219517,187.792969 34.494499,187.810944 33.461624,187.319275 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M19.381332,225.267410 
	C18.948915,220.471191 20.721498,216.468460 22.743853,212.511536 
	C23.982269,210.088470 25.020237,207.562943 26.797733,205.198608 
	C28.051338,206.233627 28.140839,207.266129 28.074352,208.705536 
	C27.597834,210.994873 27.397572,212.971786 26.269451,215.029175 
	C25.029070,216.162933 24.148376,217.102722 24.190243,218.915131 
	C24.108366,219.713654 24.032955,220.171600 23.864094,220.981400 
	C23.452330,222.537582 23.162632,223.755692 22.240376,225.119476 
	C21.227556,225.764847 20.472925,225.792068 19.381332,225.267410 
z"/>
<path fill="#D1D2D1" opacity="1.000000" stroke="none" 
	d="
M26.871571,204.883667 
	C27.094728,199.723953 28.788097,195.143967 32.298214,191.043915 
	C32.832329,190.804062 33.045006,190.646774 33.634331,190.610565 
	C35.407902,192.718506 34.331112,194.726929 33.948727,197.083832 
	C33.372757,198.552551 32.425812,199.381119 31.880066,200.853485 
	C31.097324,202.455902 30.511728,203.764771 29.323866,205.120697 
	C28.578215,205.523758 28.102484,205.550003 27.322281,205.239288 
	C27.026436,205.026031 26.924131,204.930084 26.871571,204.883667 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M19.023643,225.354828 
	C19.783484,225.023163 20.508703,225.003525 21.597408,224.975677 
	C23.133312,225.933838 23.150723,227.220444 22.895359,228.941772 
	C22.159307,231.182159 20.255852,232.313751 19.635628,234.632385 
	C19.213099,235.050888 19.001951,235.171799 18.447556,235.168686 
	C17.482275,232.502991 19.242819,230.249146 18.947792,227.335144 
	C18.936483,226.501480 18.962753,226.084167 19.023643,225.354828 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M34.330978,191.105103 
	C33.723251,191.007339 33.503662,191.004990 32.951859,190.981995 
	C32.764893,189.931366 32.910133,188.901413 33.106392,187.487274 
	C33.876911,187.069244 34.596416,187.035385 35.678230,187.004395 
	C39.307976,189.573502 35.988342,190.063934 34.330978,191.105103 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M101.432602,96.276398 
	C100.948868,95.508141 100.754105,94.884895 100.596848,93.938828 
	C100.634346,93.615990 100.786797,93.528168 100.871643,93.556572 
	C101.032928,93.922691 101.231148,94.157982 101.777954,94.374420 
	C102.219261,94.462334 102.433762,94.466698 102.899651,94.672745 
	C103.387199,96.048622 102.730652,96.397903 101.432602,96.276398 
z"/>
<path fill="#959398" opacity="1.000000" stroke="none" 
	d="
M121.857254,77.377289 
	C131.645782,69.368614 141.517715,62.061172 152.623962,55.984039 
	C153.147034,56.117077 153.312836,56.284077 153.603821,56.781879 
	C153.747131,57.348156 153.765244,57.583622 153.721466,58.166656 
	C153.559448,58.725609 153.459320,58.936989 153.121521,59.403564 
	C149.559586,61.124119 146.630035,63.162979 143.812286,65.955078 
	C143.378204,66.310646 143.195068,66.440102 142.719116,66.730484 
	C141.395340,67.299423 140.486664,67.876236 139.585251,69.019753 
	C139.176529,69.388008 138.999039,69.518730 138.535370,69.811363 
	C137.226013,70.363853 136.366074,70.983482 135.425766,72.037773 
	C134.360275,72.904938 133.386429,73.341888 132.323303,74.210663 
	C130.807053,75.138115 129.437653,75.757812 128.672409,77.550560 
	C128.150726,78.180466 127.774048,78.464897 127.008667,78.835007 
	C125.368736,79.280685 124.095589,79.239151 122.498322,78.596291 
	C122.006744,78.180206 121.857803,77.962288 121.857254,77.377289 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M177.822647,41.442455 
	C178.934509,40.947620 179.779572,40.746922 180.822083,40.284084 
	C181.406082,39.577843 181.851349,39.216743 182.707169,38.983498 
	C184.429749,38.338509 185.865646,37.740715 187.598694,36.981186 
	C191.069824,34.599415 194.758224,33.498348 198.639557,31.994743 
	C199.429810,31.903648 199.864594,31.861549 200.903519,32.020687 
	C202.039261,33.166290 202.073898,34.173347 201.773239,35.571800 
	C200.577759,37.632599 199.483002,39.314987 196.762115,38.896759 
	C192.010895,37.145779 189.096939,40.263557 185.542603,42.444946 
	C183.686234,44.014538 181.825500,44.673504 179.390411,44.823860 
	C178.755188,44.700867 178.508453,44.612633 177.959351,44.270035 
	C177.259674,43.272125 177.223251,42.512550 177.822647,41.442455 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M153.366760,57.289154 
	C153.059021,56.891354 153.043579,56.703236 153.004684,56.232597 
	C154.520615,53.595081 157.231552,52.807507 159.622803,51.028755 
	C161.313675,49.806828 162.891129,49.091152 164.722870,48.186825 
	C164.958633,47.963455 165.002213,47.987244 164.983795,47.968769 
	C165.540039,47.458664 166.087708,46.936489 166.912689,46.309631 
	C168.527267,45.931328 169.894302,45.691383 171.472382,45.191212 
	C172.058395,44.245403 172.680420,43.883404 173.750153,43.586403 
	C174.355530,43.578838 174.596802,43.615765 175.119171,43.887024 
	C175.755264,44.791191 175.812073,45.494869 175.488190,46.543194 
	C174.474625,48.025005 172.930161,48.108044 171.643219,49.230358 
	C170.818390,49.828091 170.221741,50.150623 169.307983,50.602280 
	C165.751236,51.801243 162.720306,53.249027 159.947571,55.860497 
	C159.509506,56.247227 159.322906,56.391186 158.826157,56.710175 
	C156.942413,57.449081 155.394836,58.218750 153.366760,57.289154 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M121.874512,78.152557 
	C123.510536,78.078972 124.827263,78.015076 126.539581,77.943535 
	C127.793900,79.262032 126.676514,80.036163 125.857941,81.211365 
	C125.291740,81.773094 124.941360,82.061417 124.290070,82.507942 
	C122.368546,83.440155 121.175316,84.712791 119.824860,86.325409 
	C118.923721,87.246429 118.206909,87.854843 117.038963,88.458458 
	C116.192566,88.649689 115.703484,88.594208 114.919884,88.213753 
	C114.174629,87.332138 113.983635,86.601501 113.993629,85.441971 
	C114.102310,84.546768 114.272758,84.070595 114.816879,83.358582 
	C115.083557,83.084427 115.580788,83.064095 115.829437,83.054626 
	C116.779175,82.055893 118.247063,81.850449 118.865601,80.341125 
	C119.094894,80.139816 119.054413,80.077660 119.035767,80.045593 
	C119.769226,79.267647 120.452049,78.426796 121.874512,78.152557 
z"/>
<path fill="#959398" opacity="1.000000" stroke="none" 
	d="
M114.704620,84.794670 
	C115.003677,85.750542 114.978561,86.474449 114.946045,87.560486 
	C115.244995,88.406136 115.202911,88.857979 114.517624,89.512405 
	C112.322327,90.303719 110.687805,91.702606 108.219116,91.348938 
	C107.771217,90.955917 107.661934,90.729515 107.693077,90.153137 
	C109.304962,88.218552 110.776428,86.633934 112.564476,84.978165 
	C113.331375,84.576775 113.831177,84.462021 114.704620,84.794670 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M198.781647,31.704302 
	C195.997726,34.546612 192.068344,35.198483 188.267914,36.858700 
	C190.430496,32.996037 194.679871,32.589050 198.781647,31.704302 
z"/>
<path fill="#A7A6AB" opacity="1.000000" stroke="none" 
	d="
M107.486588,89.852219 
	C107.880135,90.011696 107.926781,90.220222 108.017471,90.746231 
	C108.163216,91.714371 108.063179,92.344231 107.740677,93.257721 
	C107.497940,93.727089 107.380035,93.902763 107.040077,94.301994 
	C106.652367,94.652161 106.486717,94.778778 105.781769,95.211212 
	C105.048431,95.585716 104.854385,95.654396 104.356926,95.776245 
	C103.848640,95.820381 103.643776,95.811348 103.155624,95.682434 
	C102.623131,95.360130 102.401611,95.130951 102.106262,94.666504 
	C102.893623,92.011894 104.480087,90.351929 107.486588,89.852219 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M210.688217,29.030706 
	C210.813232,31.867325 208.825150,32.020691 206.361969,32.003521 
	C205.375137,31.308306 205.276474,30.543404 205.791351,29.382954 
	C207.451355,29.010509 208.863571,28.963032 210.688217,29.030706 
z"/>
<path fill="#A7A6AB" opacity="1.000000" stroke="none" 
	d="
M205.673950,29.024736 
	C206.018600,29.787102 205.998047,30.516214 205.979294,31.610321 
	C205.981110,31.975313 206.024109,32.024879 206.039612,32.053795 
	C204.744583,32.989429 203.354919,33.390476 201.420898,32.506706 
	C201.039780,32.265202 200.981796,31.986219 200.962524,31.842306 
	C201.574890,29.467958 203.414978,29.186434 205.673950,29.024736 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M164.597992,47.968872 
	C164.168823,49.917084 162.389877,50.411537 160.263321,50.881737 
	C160.485703,48.589497 162.334747,48.241688 164.597992,47.968872 
z"/>
<path fill="#A7A6AB" opacity="1.000000" stroke="none" 
	d="
M175.433868,44.369270 
	C174.909561,44.136147 174.726883,44.106667 174.269775,44.035946 
	C173.824844,43.825432 173.654373,43.656158 173.723816,43.217995 
	C175.111725,42.334274 176.259720,41.719448 177.748596,41.126472 
	C178.044128,41.836765 177.998810,42.525215 177.936096,43.560013 
	C177.345551,44.582661 176.606735,44.726353 175.433868,44.369270 
z"/>
<path fill="#959398" opacity="1.000000" stroke="none" 
	d="
M118.761238,80.181580 
	C119.115738,81.728943 118.780090,83.036545 116.439110,83.045380 
	C115.896912,81.301620 117.279091,80.859772 118.761238,80.181580 
z"/>
<path fill="#A7A6AB" opacity="1.000000" stroke="none" 
	d="
M122.134506,77.861740 
	C121.562576,79.054619 120.855690,79.865173 119.342270,80.022736 
	C118.967224,78.394104 119.717529,77.397400 121.660507,77.035233 
	C122.028824,77.200340 122.052010,77.390480 122.134506,77.861740 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M173.645493,42.957096 
	C173.971313,43.123318 173.978912,43.297535 173.990906,43.733231 
	C173.435608,44.276169 172.875900,44.557629 171.999817,44.885036 
	C170.666855,42.967472 172.209274,43.143730 173.645493,42.957096 
z"/>
<path fill="#A7A6AB" opacity="1.000000" stroke="none" 
	d="
M115.052872,84.702698 
	C114.551521,85.011497 114.074242,84.996361 113.239014,84.944107 
	C113.037971,83.993645 113.332542,83.193611 114.749641,83.063606 
	C115.081352,83.515869 115.079155,83.947311 115.052872,84.702698 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M182.816986,38.715172 
	C182.538773,39.285538 182.083679,39.634769 181.324081,40.002975 
	C181.126816,39.053471 181.143402,37.988827 182.816986,38.715172 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M166.826416,46.148018 
	C166.963959,47.040283 166.635727,47.792377 165.286240,47.937012 
	C165.063828,46.998264 165.400574,46.245602 166.826416,46.148018 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M15.638264,253.388123 
	C15.760052,252.675446 15.856363,252.196976 15.929445,251.351425 
	C15.934548,249.913239 15.962879,248.842102 15.971786,247.368423 
	C17.136351,246.143997 16.797375,244.856354 16.970181,243.357147 
	C18.784315,241.492096 17.993168,238.011063 21.481049,237.728790 
	C20.358086,243.128525 18.912329,248.359375 17.155941,253.799942 
	C16.632212,254.125320 16.419119,254.240982 15.868397,254.221436 
	C15.530768,254.086227 15.612786,253.622299 15.638264,253.388123 
z"/>
<path fill="#A7A6AB" opacity="1.000000" stroke="none" 
	d="
M21.825247,237.594055 
	C18.906742,238.300415 19.874048,241.901886 17.335621,242.940170 
	C17.339067,240.616348 17.683531,238.236130 18.066151,235.450287 
	C18.104305,235.044662 18.557959,235.025360 18.784861,235.017639 
	C19.397150,234.623581 19.859138,234.474319 20.709938,234.783524 
	C21.296993,235.766800 21.571821,236.528610 21.825247,237.594055 
z"/>
<path fill="#201B1D" opacity="1.000000" stroke="none" 
	d="
M269.255707,612.148438 
	C267.359253,608.362488 263.735413,609.685364 261.189606,609.243958 
	C252.546173,607.745056 244.095200,605.623535 235.330582,603.104126 
	C234.560059,603.384399 234.125427,603.576233 233.289825,603.671997 
	C229.288818,602.951538 226.020538,600.771912 221.803223,600.962463 
	C220.470261,601.110596 219.505081,601.071655 218.236618,600.589722 
	C214.678864,596.745361 210.094696,596.226624 205.363266,595.145630 
	C203.793564,594.803711 202.630264,594.391846 201.169403,593.714233 
	C198.122742,591.291931 194.956711,589.689087 191.731018,588.530334 
	C180.882538,584.633484 171.517670,578.031494 161.662720,572.357178 
	C155.814789,568.990051 150.068069,565.380188 144.219910,561.292358 
	C143.940659,561.055359 143.479340,561.020447 143.249207,560.997131 
	C131.763824,552.303955 121.605286,542.343384 110.298706,533.192993 
	C110.021118,532.978821 110.000305,532.997559 110.010605,532.985474 
	C104.362717,527.284119 99.611488,520.737854 93.250740,515.238342 
	C93.007195,514.994446 93.000000,515.000000 93.002876,514.997192 
	C84.087662,504.127747 75.193695,493.248199 67.451302,481.478943 
	C59.986820,470.132111 53.111984,458.450836 46.975224,446.334595 
	C46.205811,444.815491 45.667255,443.278137 46.502853,441.256592 
	C49.299335,439.629059 49.841835,441.791748 50.616840,443.354675 
	C60.628559,463.545074 72.836319,482.361664 87.199509,499.666901 
	C99.367538,514.327271 111.413414,529.130493 126.712173,540.930298 
	C134.580078,546.998779 141.394836,554.504272 149.950470,559.682800 
	C160.729416,566.207031 170.840500,573.918579 183.037994,578.696777 
	C183.877762,578.909729 184.340622,579.088684 185.112854,579.497314 
	C190.297119,583.945740 196.466385,585.560913 202.263092,587.849548 
	C211.028412,591.310303 219.643631,595.209351 229.200058,597.643982 
	C230.126190,597.800110 230.651855,597.937134 231.566589,598.257446 
	C245.183655,602.386353 258.526550,605.927063 272.267670,607.461182 
	C286.954742,609.100952 301.665192,610.817566 316.482483,610.572998 
	C333.788971,610.287292 350.917084,608.202393 367.946014,605.140076 
	C370.377960,604.702759 373.364319,602.598999 375.214783,606.540894 
	C372.247009,607.626648 369.480194,608.415894 366.664551,608.945618 
	C365.291504,609.203918 364.104309,609.343506 363.927887,611.408569 
	C363.713745,611.794617 363.543335,611.811157 363.116180,611.830566 
	C361.067596,612.367249 359.351196,610.750732 357.221313,611.741211 
	C356.461243,611.945190 356.022003,612.032227 355.250031,612.142639 
	C353.408691,612.300964 351.859924,612.270020 350.268616,613.427185 
	C349.329346,613.842896 348.660339,613.933533 347.639313,613.884766 
	C345.616425,613.537170 343.906982,613.037781 342.146637,614.598206 
	C341.465454,614.809021 341.048370,614.832275 340.317871,614.856079 
	C339.310486,615.004578 338.617828,614.978394 337.584625,614.776855 
	C334.289978,614.230347 331.287048,613.516541 328.733704,616.647583 
	C326.027802,617.666077 323.600372,617.449585 320.766174,617.154541 
	C317.700531,616.430542 315.031311,616.237122 311.938232,617.032288 
	C308.443176,617.550049 305.356201,617.694885 301.892578,616.932129 
	C298.763000,613.688904 295.275940,614.189270 291.394409,614.881836 
	C290.014648,615.143616 289.007294,615.153259 287.646118,614.845825 
	C285.233612,613.270203 282.981384,613.092285 280.261108,613.820923 
	C278.981628,614.088867 278.044556,614.120117 276.775024,613.846313 
	C275.110138,613.053284 273.808502,612.215759 271.845947,612.766113 
	C270.800262,612.867981 270.149353,612.630127 269.255707,612.148438 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M47.155769,440.646393 
	C46.677494,443.457153 47.717815,445.516357 48.804741,447.599274 
	C60.625793,470.251801 74.368904,491.609894 91.323036,510.806183 
	C92.225121,511.827545 93.085762,512.798096 93.006363,514.629272 
	C86.764748,511.596436 83.801018,505.250366 79.523422,500.074188 
	C68.276215,486.464294 59.288086,471.359619 50.626335,456.078796 
	C42.027020,440.908142 35.664040,424.716614 29.900465,408.273956 
	C23.129919,388.958466 19.360771,369.108795 17.849890,348.707428 
	C17.043751,337.822144 15.909777,326.971558 16.003361,316.042053 
	C16.018850,314.232910 15.708916,312.362701 16.914656,310.300262 
	C17.406067,309.889099 17.707722,309.858734 18.322239,310.158325 
	C20.187210,315.860077 19.066372,321.357361 19.391672,326.787231 
	C19.510376,328.768646 19.269711,330.768280 19.821756,333.157410 
	C20.203314,334.433441 20.304264,335.310486 20.381451,336.626099 
	C20.486692,350.381775 22.855368,363.434662 25.278198,376.861603 
	C25.841923,377.960999 26.034401,378.750824 26.225506,379.945404 
	C26.372564,381.344696 26.331585,382.373260 26.783758,383.713470 
	C27.009275,384.566315 27.108458,385.060455 27.236687,385.933960 
	C27.730125,390.787872 28.854513,395.103210 30.311037,399.352448 
	C33.857792,409.699799 37.641537,419.959839 41.663860,430.130005 
	C42.447960,432.112518 43.226845,434.175812 45.259449,435.864288 
	C46.799866,437.222260 47.436810,438.596680 47.155769,440.646393 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M24.629255,257.201538 
	C24.727297,256.430939 24.754131,256.066254 24.779087,255.427170 
	C23.430006,252.823364 24.916924,250.787430 25.686321,248.299042 
	C25.922356,247.945328 25.964497,247.945419 25.971046,247.965454 
	C27.396513,246.766052 26.949903,245.024124 27.230427,243.161224 
	C27.222721,242.408203 27.257502,241.984940 27.432236,241.274506 
	C27.943415,240.307892 28.323961,239.622360 28.119144,238.473206 
	C27.970547,236.839096 28.481920,235.663071 29.121439,234.200012 
	C29.712740,233.236389 30.429768,232.730637 30.624454,231.558777 
	C30.779732,230.217514 30.818146,229.173355 31.117605,227.852112 
	C31.556280,226.645493 32.417042,225.919876 32.181259,224.492767 
	C32.268009,223.101578 32.669502,222.114960 33.287399,220.868149 
	C34.743080,219.495621 34.706451,217.913162 35.012283,216.113312 
	C35.079956,214.602737 35.824402,213.665146 36.312439,212.291412 
	C38.389191,211.031921 38.525387,209.225067 38.728828,207.093719 
	C39.049381,205.685852 39.379372,204.636581 40.294685,203.503098 
	C40.824883,202.497879 41.536594,201.929047 41.535908,200.709885 
	C41.523079,199.297028 41.912560,198.331009 42.735020,197.196747 
	C42.963146,196.527649 42.987816,196.104904 43.032730,195.365234 
	C45.412144,191.448044 46.430008,187.213135 48.751965,183.235107 
	C48.980412,182.983002 49.029701,182.519363 49.047813,182.286942 
	C50.816700,180.696671 50.648788,177.484070 54.019489,177.412430 
	C56.854656,179.461716 55.216820,181.511978 54.303391,183.290054 
	C44.509674,202.354095 38.591339,222.857040 31.932650,243.088181 
	C30.375519,247.819214 30.613262,253.052872 27.610210,257.755371 
	C26.895208,258.396362 26.384968,258.550507 25.431831,258.404724 
	C24.879923,258.052765 24.718985,257.830109 24.629255,257.201538 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M143.989594,561.399841 
	C149.630386,561.890442 153.590149,566.068726 158.087738,568.929810 
	C171.206635,577.275024 184.882141,584.431946 199.105637,590.626221 
	C199.807770,590.931946 200.323380,591.665955 201.009659,592.540771 
	C200.807297,593.293640 200.432251,593.595825 199.609573,593.868286 
	C198.007095,594.059021 196.871506,593.669556 195.443512,593.031494 
	C194.575882,592.483337 194.021606,592.088501 193.016266,591.861938 
	C191.667313,591.418823 190.602722,591.172363 189.298248,590.628113 
	C188.390442,589.494690 187.552383,588.907166 186.019318,588.955078 
	C185.256866,588.845947 184.853134,588.684265 184.246002,588.209961 
	C183.134140,587.477600 182.257614,586.977905 181.204315,586.234680 
	C180.101196,584.717468 178.477066,584.727234 176.982315,583.838745 
	C175.896072,583.376953 175.110870,583.021912 174.240997,582.212280 
	C173.827362,579.851868 171.926620,579.624939 170.558197,578.799866 
	C162.625763,574.017029 154.696655,569.228760 146.764420,564.445679 
	C145.634979,563.764587 144.343933,563.253784 143.989594,561.399841 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M54.228737,177.806030 
	C51.341640,177.963120 51.813545,181.336258 49.398884,181.993286 
	C52.123390,173.208023 57.544590,165.598938 62.094624,157.550125 
	C64.161095,153.894653 65.516273,149.621307 69.850494,147.236420 
	C70.804596,148.094955 70.875664,148.801178 70.691986,149.874237 
	C68.576729,153.203674 67.247917,156.566162 65.452713,160.040207 
	C65.260635,161.012085 65.077919,161.643829 64.720795,162.559418 
	C63.750351,164.045853 62.408119,164.836823 61.711021,166.529602 
	C61.153156,167.243210 60.586830,167.490921 60.049652,168.190826 
	C59.587646,169.158859 59.332840,169.898636 59.035652,170.944855 
	C58.879608,171.426819 58.808495,171.617477 58.602386,172.083038 
	C57.937904,173.227036 57.311081,174.029083 56.558132,175.109924 
	C55.715805,176.087509 55.169880,176.922806 54.228737,177.806030 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M83.845787,127.289406 
	C84.624931,126.555809 85.176598,126.040428 85.895279,125.290115 
	C86.617447,124.476562 87.296371,124.166901 88.473465,124.158806 
	C91.510735,125.359108 91.176659,127.421692 89.802170,129.062653 
	C84.270828,135.666306 79.850632,143.145813 73.415237,149.410339 
	C72.806015,149.473236 72.558479,149.438873 72.005096,149.186676 
	C71.466202,148.523132 71.324203,148.051254 71.319054,147.180191 
	C71.910835,144.176544 73.417259,141.966019 74.825867,139.333374 
	C75.057816,139.059845 75.043114,139.002777 75.058899,139.030792 
	C76.995079,137.538376 77.601761,134.973022 79.752426,133.217880 
	C80.253235,132.498947 80.530914,132.020401 80.927788,131.291504 
	C82.044525,129.965515 83.108940,128.938522 83.845787,127.289406 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M110.150017,533.287354 
	C114.870438,532.906494 116.888832,537.325623 119.847740,539.806580 
	C126.885719,545.707642 133.382492,552.253418 140.958344,557.545593 
	C141.832153,558.156006 142.293564,559.356750 142.982635,560.628784 
	C137.453796,558.705200 133.137299,554.529602 128.630402,550.847656 
	C122.144226,545.548767 116.361732,539.388550 110.150017,533.287354 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M30.221680,233.811157 
	C29.270765,235.328827 28.880381,236.729874 29.004257,238.627045 
	C28.978035,239.591324 28.800608,240.129242 28.233074,240.809067 
	C28.027201,241.460114 28.018616,241.900131 28.008713,242.670258 
	C27.731291,243.630051 27.278231,244.065933 26.315914,244.138306 
	C27.626698,232.476517 31.354658,221.604843 36.577293,211.007034 
	C37.075470,211.095520 37.221634,211.264496 37.212746,211.730591 
	C36.730446,213.125137 36.403206,214.222549 36.040928,215.663742 
	C35.037010,217.346283 35.759399,219.255844 34.263741,220.756332 
	C33.701309,222.113739 33.366951,223.208618 33.030910,224.652664 
	C32.988594,225.591553 32.805813,226.128555 32.245331,226.812225 
	C32.023502,228.394897 31.993917,229.762100 31.957836,231.539520 
	C31.463957,232.524536 30.927172,233.053528 30.221680,233.811157 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M93.033768,515.340393 
	C96.491272,516.037415 98.643913,518.765564 100.865799,521.342590 
	C103.960823,524.932373 106.928558,528.631958 109.985840,532.628967 
	C108.313271,533.062012 107.306282,531.894592 106.333054,530.797180 
	C101.884995,525.781311 97.480492,520.726929 93.033768,515.340393 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M18.273417,301.177979 
	C15.841242,294.096680 17.115887,287.284973 18.633633,280.496155 
	C18.694160,280.225433 19.478952,280.116638 20.313438,279.890137 
	C21.229309,280.099915 21.608154,280.495453 21.955109,281.438843 
	C22.205879,282.681244 22.120005,283.506104 21.793343,284.710144 
	C19.739201,287.657562 20.616682,290.647797 20.395473,293.875977 
	C20.470213,296.252655 20.520494,298.220398 19.616104,300.487000 
	C19.154968,301.016693 18.915239,301.176086 18.273417,301.177979 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M21.196642,271.243866 
	C19.065069,267.489716 20.500841,264.510406 22.700935,261.353760 
	C23.121696,260.917969 23.312016,260.749512 23.880028,260.533386 
	C24.497774,260.566650 24.737829,260.647583 25.201633,261.035706 
	C24.782648,264.675598 26.249094,268.367126 23.362858,271.520172 
	C22.489788,271.737396 21.989939,271.673126 21.196642,271.243866 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M48.631950,183.041290 
	C47.904804,187.301804 46.472599,191.464035 43.371094,195.040619 
	C43.738876,190.602417 45.575230,186.660156 48.631950,183.041290 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M89.446114,124.878441 
	C88.346649,125.033913 87.584129,125.038025 86.441940,125.048660 
	C86.035492,124.585327 86.008698,124.115463 85.958221,123.293900 
	C85.844711,122.713654 85.754898,122.485123 85.812927,121.917740 
	C87.407982,120.258369 88.717323,118.691124 91.230293,119.044304 
	C92.172844,120.462936 92.203293,121.695595 91.773682,123.314972 
	C91.211220,124.356926 90.584488,124.694481 89.446114,124.878441 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M74.736717,139.180603 
	C75.186203,141.876373 73.236465,143.988815 72.263924,146.747253 
	C71.474731,147.050278 71.004707,147.360870 70.237938,147.171997 
	C70.020393,147.015793 69.976028,146.976410 69.953560,146.955231 
	C70.139252,143.633835 72.169868,141.404388 74.736717,139.180603 
z"/>
<path fill="#6D676B" opacity="1.000000" stroke="none" 
	d="
M86.256851,121.732811 
	C86.051643,122.042404 86.000168,122.493690 85.967346,122.717941 
	C83.601700,122.914520 82.801674,125.504761 80.172012,125.757019 
	C79.431496,125.066673 79.403831,124.582855 79.621170,123.747223 
	C81.343437,121.535484 82.653763,119.250511 85.961197,119.772415 
	C86.477730,120.444557 86.550484,120.922951 86.256851,121.732811 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M79.628746,133.012878 
	C79.088921,135.344666 78.762947,138.099289 75.434578,139.043304 
	C75.410873,136.308960 76.559296,134.127655 79.628746,133.012878 
z"/>
<path fill="#6D676B" opacity="1.000000" stroke="none" 
	d="
M80.057022,126.054443 
	C80.109772,128.482620 79.024361,130.128159 76.402908,131.015121 
	C75.660965,130.713181 75.426743,130.275909 75.351151,129.370911 
	C75.619843,127.701797 76.090042,126.528130 77.509064,125.525269 
	C78.377075,125.280991 78.878166,125.332710 79.672409,125.753571 
	C79.980316,125.980370 80.031227,126.029984 80.057022,126.054443 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M25.575163,248.030991 
	C25.590225,250.073273 25.258093,252.201218 24.851585,254.740967 
	C21.261724,252.572571 24.321354,250.413574 25.575163,248.030991 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M173.704926,581.968933 
	C174.889099,582.140686 175.724716,582.337097 176.763672,582.787964 
	C177.365082,583.414124 177.508545,583.866516 177.185516,584.712280 
	C175.008514,584.981140 173.149536,584.711426 172.026917,582.390442 
	C172.425491,582.030334 172.890945,582.011963 173.704926,581.968933 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M21.237759,278.081604 
	C19.353258,276.449493 17.758961,275.089264 20.488068,273.035461 
	C21.073101,272.847107 21.334606,272.730225 21.968832,272.830353 
	C23.236559,274.349823 23.255436,275.744934 22.557570,277.562622 
	C22.082750,278.070496 21.830542,278.208069 21.237759,278.081604 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M17.892391,301.445648 
	C18.068901,301.016968 18.266479,301.013367 18.760477,301.010254 
	C22.062290,301.865234 21.159163,304.087616 20.616009,306.494507 
	C19.923834,307.302704 19.377380,307.479584 18.360556,307.199677 
	C17.950434,305.281555 17.931950,303.576172 17.892391,301.445648 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M17.726246,307.199463 
	C18.421812,306.992279 18.874702,306.997620 19.667030,307.002197 
	C22.229643,307.330658 21.735298,308.644592 20.748699,310.247894 
	C19.847580,310.648224 19.296696,310.641785 18.408604,310.217468 
	C18.069370,309.969543 17.585999,309.938141 17.345203,309.928772 
	C17.230797,309.083618 17.357183,308.247803 17.726246,307.199463 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M40.772591,202.799042 
	C40.721619,204.098969 40.390957,205.197952 40.024799,206.641495 
	C39.348251,207.567657 38.609962,207.729462 37.446484,207.278656 
	C37.195320,205.395569 37.605999,203.908661 39.591927,203.041489 
	C40.115856,202.860229 40.304379,202.729172 40.772591,202.799042 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M37.101288,207.347687 
	C37.830894,207.038208 38.549335,207.016769 39.628540,206.990707 
	C39.507389,208.746536 39.532433,210.740295 37.394371,211.960663 
	C37.038506,211.844208 37.019325,211.660706 36.964729,211.201874 
	C37.674408,209.863403 37.336693,208.747345 37.101288,207.347687 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M26.002914,244.403076 
	C26.508135,243.741608 26.999393,243.478149 27.749025,243.107513 
	C28.235477,244.821289 28.660349,246.697128 26.310192,247.938507 
	C25.981382,246.924011 25.985167,245.862534 26.002914,244.403076 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M75.631073,128.776978 
	C75.992928,129.442413 76.002388,129.905716 76.032623,130.717163 
	C75.938667,131.368881 75.755867,131.623581 75.298370,131.946533 
	C74.557053,132.650757 74.038536,133.272736 72.828354,132.691864 
	C71.982880,130.065964 72.776077,128.711502 75.631073,128.776978 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M20.879206,278.158691 
	C21.072273,277.854279 21.247364,277.891022 21.689510,277.953979 
	C24.976456,279.528625 24.379477,280.988464 21.421722,282.199524 
	C20.960087,281.516144 20.925121,281.034241 20.795372,280.200073 
	C20.754135,279.398499 20.807682,278.949188 20.879206,278.158691 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M69.991028,139.747269 
	C69.239304,139.993927 68.512962,140.009232 67.422882,140.030380 
	C65.910858,137.789444 67.127510,136.914337 69.526909,136.613068 
	C70.335983,137.185211 70.508766,137.706909 70.248428,138.677551 
	C70.042854,139.051254 70.016418,139.515930 69.991028,139.747269 
z"/>
<path fill="#6D676B" opacity="1.000000" stroke="none" 
	d="
M70.389816,138.999496 
	C70.024437,138.585449 70.006027,138.119629 69.975136,137.304840 
	C70.030441,136.540558 70.189919,136.162613 70.641830,135.589233 
	C71.190956,135.107697 71.558090,134.914917 72.521896,134.932556 
	C73.052719,136.831192 72.758003,138.415955 70.389816,138.999496 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M83.758469,127.182808 
	C84.081680,128.833969 83.796227,130.420715 81.397766,130.996475 
	C80.951241,129.219971 82.161224,128.234024 83.758469,127.182808 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M24.396561,256.842377 
	C24.763023,256.992004 24.825586,257.188385 24.938856,257.689789 
	C25.339945,258.324432 25.517920,258.733276 25.449852,259.545258 
	C25.182070,260.040009 25.012236,260.199677 24.496222,260.410980 
	C23.917303,260.441864 23.684568,260.421051 23.194637,260.162170 
	C22.150549,258.466309 21.682327,257.129852 24.396561,256.842377 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M42.589417,197.028778 
	C42.654636,198.069946 42.370796,199.189499 42.054581,200.657196 
	C41.840549,201.089615 41.658894,201.173904 41.216022,201.109894 
	C41.141750,199.596207 40.476246,197.946533 42.589417,197.028778 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M40.722809,201.146057 
	C41.132504,200.971786 41.310200,200.982010 41.755051,200.998779 
	C43.078846,201.896133 42.838203,202.518143 41.337021,202.968979 
	C40.865063,202.998322 40.677837,202.996658 40.208973,202.993134 
	C40.115162,202.437698 40.302990,201.884125 40.722809,201.146057 
z"/>
<path fill="#6D676B" opacity="1.000000" stroke="none" 
	d="
M72.704895,133.482880 
	C73.491714,132.720673 74.011749,132.470932 74.811783,132.142426 
	C74.978127,133.174896 75.129631,134.410706 73.418396,135.007446 
	C73.089935,135.089401 73.039215,135.039124 73.013199,135.014648 
	C72.656105,134.740280 72.480698,134.404449 72.704895,133.482880 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M168.010208,580.593384 
	C167.133179,580.929504 166.347427,580.706238 166.037476,579.329773 
	C166.891937,579.051819 167.664948,579.290588 168.010208,580.593384 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M22.408802,273.008545 
	C21.809761,272.997131 21.610809,272.995300 21.111725,272.978760 
	C20.844662,272.532043 20.877729,272.100067 20.898060,271.343170 
	C21.344103,271.003815 21.802887,270.989349 22.604811,270.969116 
	C23.622137,271.697052 23.463995,272.374390 22.408802,273.008545 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M22.936716,260.214630 
	C23.114107,259.943207 23.290771,259.962372 23.733829,259.990631 
	C24.166447,260.166504 24.332666,260.333252 24.249611,260.750214 
	C23.821873,261.007477 23.643410,261.014496 23.198162,261.053955 
	C22.932915,260.892670 22.934452,260.698944 22.936716,260.214630 
z"/>
<path fill="#959398" opacity="1.000000" stroke="none" 
	d="
M71.159760,135.747772 
	C70.834572,136.275513 70.647705,136.530945 70.175339,136.844452 
	C68.449387,137.088562 67.391556,137.768311 67.072403,139.693695 
	C66.100945,142.656464 62.959045,144.030609 62.948448,147.564682 
	C62.228920,148.685532 61.771324,149.589081 61.166348,150.752151 
	C60.845173,151.285065 60.657341,151.539597 60.184597,151.854156 
	C58.540329,153.285126 57.488899,154.891479 56.308270,156.802490 
	C56.117199,157.060135 56.062134,157.533981 56.034256,157.770859 
	C55.273262,158.734283 55.116585,159.811768 54.238983,160.797546 
	C53.754055,161.798645 53.473618,162.577042 53.060928,163.640854 
	C51.535126,165.643616 50.467392,167.562729 49.240974,169.765533 
	C49.017921,170.009399 48.981918,170.478729 48.967075,170.713623 
	C48.465698,171.521912 47.931084,172.051086 47.238731,172.818024 
	C46.080849,174.798187 45.110161,176.567657 44.088310,178.671143 
	C43.971024,180.378693 43.204910,181.445755 42.287666,182.789978 
	C35.024387,198.752441 27.812336,214.404358 23.926319,231.304459 
	C23.654644,232.485977 22.934103,232.922104 21.469250,233.071503 
	C20.378990,232.133728 21.066538,231.361496 21.674587,230.265228 
	C21.924240,228.591476 21.959661,227.198532 21.977987,225.386520 
	C22.153496,223.816223 22.346098,222.665009 22.785818,221.269165 
	C23.628389,220.455460 23.953836,219.799606 23.679127,218.657379 
	C23.996019,217.401733 23.917345,216.313110 24.816345,215.254425 
	C26.743155,213.613205 25.369238,211.222397 26.871162,209.348999 
	C28.212708,208.122253 27.785915,206.540985 28.745733,205.206604 
	C29.426853,203.740570 29.896519,202.527435 30.608814,201.094177 
	C31.815510,200.311935 31.863310,199.143234 32.654774,198.101425 
	C32.830330,195.755356 33.009716,193.704269 33.899414,191.389465 
	C34.895332,189.870316 36.734856,189.351425 36.263771,187.189865 
	C36.009449,185.805786 36.850140,185.175293 37.841965,184.271179 
	C40.062447,181.911560 39.923027,178.799789 41.708305,176.200500 
	C42.511440,174.799362 43.106857,173.679230 43.849060,172.277832 
	C44.835106,170.956223 44.583889,169.456375 45.675701,168.174500 
	C51.981846,157.159470 58.161514,146.451080 65.825829,136.282990 
	C66.161270,135.830551 66.329597,135.670486 66.696648,135.224228 
	C71.493713,129.156662 76.092049,123.375290 80.854370,117.301620 
	C81.440575,116.586342 81.862549,116.163193 82.115730,115.289192 
	C82.214561,113.589638 83.066376,113.072350 84.934509,113.265083 
	C86.206100,114.711655 86.169563,116.109138 86.568748,117.747452 
	C86.635956,118.547050 86.547218,118.990295 86.109840,119.638657 
	C83.335373,120.090675 82.409630,122.518860 80.275940,123.829147 
	C79.478745,124.541481 78.924614,125.054359 78.209564,125.805466 
	C77.501907,126.874550 76.986435,127.736076 76.227203,128.788361 
	C73.948769,129.120422 73.034111,130.288574 72.978226,132.610229 
	C72.971680,132.970428 72.985695,132.983215 72.978554,132.978745 
	C72.207054,133.681122 71.778297,134.598251 71.159760,135.747772 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M49.358185,169.955643 
	C48.844212,167.346237 50.315731,165.581024 52.593369,163.999512 
	C52.529060,166.284164 51.848568,168.490250 49.358185,169.955643 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M56.440945,156.990692 
	C56.331451,154.859314 56.932713,152.903015 59.627991,152.010071 
	C59.727509,154.153290 58.428215,155.655289 56.440945,156.990692 
z"/>
<path fill="#AFAEB1" opacity="1.000000" stroke="none" 
	d="
M21.557602,230.053131 
	C21.668076,230.811859 21.447327,231.639297 21.154716,232.788757 
	C21.074890,233.531555 21.066923,233.952332 21.040560,234.689056 
	C20.575228,235.004745 20.128294,235.004517 19.346561,235.007111 
	C19.492329,233.263824 19.479582,231.294235 21.557602,230.053131 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M42.398495,182.984436 
	C41.992100,181.607224 42.727077,180.485657 43.760796,179.188904 
	C45.565079,180.976990 44.049282,181.920532 42.398495,182.984436 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M54.375160,160.962875 
	C53.989426,159.850006 54.440079,158.929764 55.712433,158.141693 
	C55.947464,159.139008 56.189968,160.404526 54.375160,160.962875 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M61.259338,150.844254 
	C61.020691,149.842957 60.811680,148.588989 62.591957,148.000305 
	C63.033501,149.130539 62.571861,150.056686 61.259338,150.844254 
z"/>
<path fill="#AFAEB1" opacity="1.000000" stroke="none" 
	d="
M15.349731,254.278229 
	C15.750422,254.074570 15.970074,254.062912 16.517517,254.030457 
	C16.843431,254.903168 16.655998,255.688583 15.361880,256.030212 
	C15.086812,255.521469 15.127753,254.995865 15.349731,254.278229 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M47.369572,172.977844 
	C47.064865,172.108734 47.303894,171.334564 48.636757,171.005875 
	C48.938553,171.868698 48.722961,172.659821 47.369572,172.977844 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M300.748047,615.600220 
	C304.443909,615.818298 307.767181,615.855530 311.546265,615.881592 
	C312.608307,616.480286 312.726654,617.211121 312.309509,618.337219 
	C307.705109,618.735352 303.326508,618.815063 298.486389,618.846558 
	C298.022736,618.371033 298.020508,617.943726 298.019409,617.194092 
	C298.098969,615.242188 299.229095,615.317566 300.748047,615.600220 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M312.511292,618.740417 
	C312.057922,617.963562 312.032104,617.271545 312.004150,616.224976 
	C314.384308,614.276550 316.929840,614.965393 319.742004,615.597046 
	C320.572723,616.523193 320.717682,617.265442 320.182861,618.376221 
	C317.586243,618.719849 315.262543,618.772522 312.511292,618.740417 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M320.364502,618.768250 
	C319.940918,617.968811 319.971893,617.270508 320.017059,616.214294 
	C322.686523,615.854248 325.341736,615.852051 328.437012,615.816895 
	C329.038971,615.690735 329.200897,615.597473 329.631500,615.584717 
	C330.012482,615.814575 330.124786,615.963989 330.164246,616.384277 
	C330.058685,617.135254 330.026001,617.615356 329.986145,618.453003 
	C326.925690,618.830139 323.872375,618.849731 320.364502,618.768250 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M356.778564,611.317139 
	C358.905640,609.373779 360.685455,609.504211 362.600128,611.631470 
	C362.884277,612.254517 362.909119,612.675659 362.940857,613.406616 
	C361.898102,613.779663 360.848419,613.842896 359.402985,613.899048 
	C358.311371,613.932312 357.650452,613.825684 356.837708,613.168213 
	C356.466949,612.468994 356.446564,612.024780 356.778564,611.317139 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M349.771362,613.140869 
	C350.504272,610.209595 352.651062,611.234680 354.650452,611.047607 
	C355.541565,611.624390 355.853851,612.259949 355.814575,613.379639 
	C355.645355,613.951843 355.531708,614.165344 355.143188,614.615356 
	C354.147461,614.869263 353.426697,614.886597 352.345459,614.893494 
	C351.313507,615.002075 350.705902,614.825134 349.911682,614.248413 
	C349.645294,613.802734 349.601044,613.592285 349.771362,613.140869 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M349.629272,613.910400 
	C350.556946,614.130310 351.100342,614.279541 351.814331,614.655884 
	C351.981689,615.315063 351.978424,615.747192 351.977234,616.499207 
	C351.244812,616.864502 350.510284,616.909790 349.408508,616.954041 
	C349.034576,616.770142 349.027924,616.587280 349.008911,616.130310 
	C348.418915,615.102661 348.568146,614.438721 349.629272,613.910400 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M355.250427,614.901855 
	C354.868256,614.851868 354.913879,614.394958 354.936523,614.166504 
	C355.413788,613.575195 355.819519,613.136658 356.711090,612.990234 
	C357.554199,613.135437 358.103699,613.286194 358.830231,613.664429 
	C358.195007,615.240540 356.868652,614.952454 355.250427,614.901855 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M330.537354,615.871277 
	C329.987274,615.824402 329.765350,615.839355 329.210236,615.819092 
	C330.453949,610.432129 334.462585,613.778320 337.716644,613.671204 
	C338.570099,614.596985 338.711334,615.329529 338.172180,616.431458 
	C336.471313,616.712708 335.041992,616.706238 333.203857,616.565186 
	C332.183136,616.143250 331.530243,616.015076 330.537354,615.871277 
z"/>
<path fill="#201B1D" opacity="1.000000" stroke="none" 
	d="
M330.183716,616.021362 
	C331.100800,614.905579 331.946289,614.764404 332.752930,616.195557 
	C332.121735,616.541748 331.448517,616.653076 330.433350,616.709717 
	C330.091400,616.655090 330.158234,616.233337 330.183716,616.021362 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M338.244263,616.799744 
	C337.931366,616.029541 337.962128,615.340027 337.999054,614.299805 
	C338.552979,614.102539 339.100739,614.255981 339.826477,614.633057 
	C339.999023,615.300964 339.993622,615.745300 339.990295,616.518799 
	C339.524200,616.858826 339.056061,616.869629 338.244263,616.799744 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M342.181824,614.865601 
	C342.075134,611.363037 344.212952,611.747253 346.752808,612.690796 
	C347.570709,613.607361 347.712982,614.343628 347.176666,615.454895 
	C346.177887,615.801270 345.447632,615.854614 344.350403,615.886902 
	C343.482605,615.559021 342.981842,615.252197 342.181824,614.865601 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M347.252136,615.820923 
	C346.936676,615.052490 346.965271,614.357117 346.999146,613.308716 
	C347.750275,612.953186 348.496094,612.950623 349.613953,612.924011 
	C349.991364,613.080200 349.996735,613.260498 350.007874,613.710938 
	C349.689667,614.419495 349.365784,614.857910 349.019226,615.576294 
	C348.529816,615.868774 348.062988,615.881348 347.252136,615.820923 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M301.071106,615.395569 
	C300.236694,615.979675 299.352783,616.178345 298.244690,616.624451 
	C295.880402,616.989319 293.740265,617.106750 291.309418,617.467773 
	C290.314240,617.703796 289.609772,617.696350 288.560547,617.615723 
	C287.803467,617.323853 287.578033,616.988525 287.671631,616.202637 
	C288.465454,614.953491 289.754395,615.135925 290.779755,614.179199 
	C294.475555,613.004089 298.048920,611.174683 301.071106,615.395569 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M288.187592,615.698425 
	C288.147583,616.418884 288.151367,616.745300 288.188538,617.307129 
	C287.096954,617.661804 285.978119,617.781006 284.441467,617.852051 
	C284.021332,617.376465 284.019104,616.949097 284.017944,616.199463 
	C283.994476,614.346130 285.099457,614.299805 286.561951,614.355713 
	C287.488617,614.566406 287.917816,614.840088 288.187592,615.698425 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M287.260742,614.717651 
	C286.137848,615.118469 285.289978,615.255676 284.230591,615.635010 
	C282.946533,615.854004 281.873962,615.830811 280.405701,615.737427 
	C279.408752,615.067688 279.298767,614.358276 279.768463,613.262939 
	C282.323975,611.566956 284.619049,611.222046 286.927734,613.535522 
	C287.187988,614.083679 287.361908,614.268860 287.260742,614.717651 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M279.597412,612.961548 
	C280.007233,613.638184 280.018646,614.320740 280.020020,615.335205 
	C279.997375,615.865906 279.984741,616.064636 279.976074,616.560425 
	C279.556213,616.839417 279.132355,616.821289 278.395264,616.743408 
	C277.306519,616.053040 276.911163,615.061462 275.868530,614.269409 
	C275.692963,613.806824 275.682831,613.602478 275.842773,613.142700 
	C277.074890,612.913940 278.136963,612.940613 279.597412,612.961548 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M275.673523,613.898438 
	C277.273560,614.060608 277.991455,614.716064 278.055725,616.364746 
	C277.912781,616.744690 277.743591,616.805725 277.306183,616.893494 
	C276.453339,616.413513 275.868683,615.906860 275.145874,615.141174 
	C274.880554,614.443726 275.000885,614.089355 275.673523,613.898438 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M217.748520,599.675293 
	C219.082108,599.964111 220.107681,600.062866 221.517914,600.197998 
	C222.697495,600.617615 223.029388,601.416077 223.739929,602.297363 
	C224.436523,603.371643 225.752762,603.988159 224.357574,605.115417 
	C216.145599,602.968689 208.184708,601.083679 201.033112,596.404419 
	C202.197693,594.512817 203.890900,594.992737 205.867233,595.049683 
	C210.335678,595.645264 212.881470,600.117676 217.748520,599.675293 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M207.070984,595.789429 
	C205.237732,596.083557 203.529831,596.051147 201.393524,596.037109 
	C200.559555,596.007812 200.153976,595.960022 199.442261,595.895508 
	C198.441635,595.313416 198.297440,594.582764 198.702545,593.408569 
	C199.394073,593.034180 199.879501,593.000183 200.729187,592.923584 
	C202.189240,593.154419 203.285004,593.427917 204.695816,593.841248 
	C205.574387,594.718323 206.902313,594.328125 207.070984,595.789429 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M198.572327,593.029175 
	C198.962082,593.771912 199.015518,594.475708 199.102524,595.529175 
	C197.261063,595.632507 195.332809,595.513000 194.021210,593.417358 
	C194.014847,592.708618 194.195938,592.410645 194.739075,592.100220 
	C196.078461,592.349060 197.157227,592.669678 198.572327,593.029175 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M188.770706,589.755371 
	C190.233231,590.098999 191.376709,590.302795 192.747498,590.769165 
	C193.369034,591.403625 193.522980,591.856995 193.215179,592.699280 
	C191.022980,592.994446 189.170670,592.722351 188.010513,590.426758 
	C188.108170,589.928101 188.279922,589.771851 188.770706,589.755371 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M177.223083,585.283813 
	C176.975739,584.584045 176.977905,584.143127 176.973526,583.372314 
	C178.742645,583.388489 180.625793,583.548035 181.220764,585.798828 
	C179.842560,585.841553 178.657593,585.692078 177.223083,585.283813 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M224.055054,605.224548 
	C224.989670,603.855286 223.371002,603.984131 223.162109,603.149170 
	C224.803574,601.833740 226.346420,601.607971 227.187988,604.287842 
	C227.025681,604.927490 227.014145,605.152710 226.998123,605.716614 
	C226.248077,606.026367 225.502533,605.997375 224.384613,605.948975 
	C224.012253,605.929504 224.052185,605.460083 224.055054,605.224548 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M189.007172,589.563354 
	C188.897964,589.927917 188.706192,589.960632 188.225418,590.038818 
	C187.936417,590.084412 187.462082,590.042603 187.224335,590.029785 
	C186.511841,589.588013 185.942062,589.242676 185.864700,588.291382 
	C187.133606,588.036316 188.375732,587.812927 189.007172,589.563354 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M185.670486,587.975098 
	C186.262634,588.495422 186.523087,588.993286 186.885071,589.754028 
	C185.837952,589.966431 184.559677,590.195374 184.051758,588.326050 
	C184.453369,587.968994 184.896088,587.960754 185.670486,587.975098 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M193.233429,593.020508 
	C192.990585,592.567505 192.987381,592.128357 192.979492,591.360535 
	C193.542343,591.192871 194.109879,591.353943 194.838562,591.771729 
	C194.798294,592.293579 194.596893,592.558655 194.173462,592.949524 
	C193.951431,593.075256 193.473083,593.034363 193.233429,593.020508 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M375.412689,606.953003 
	C374.814575,605.369324 374.019836,605.323914 372.571838,605.621521 
	C357.017517,608.817688 341.276886,610.823547 325.450745,611.778442 
	C317.377106,612.265564 309.251709,612.155823 301.093964,611.384888 
	C292.049774,610.530273 282.962280,609.990479 273.914612,609.015564 
	C259.400146,607.451538 245.314545,604.004761 231.222565,599.282471 
	C232.333694,595.533752 234.885788,597.464722 236.810837,597.897705 
	C250.446289,600.964783 263.980835,604.385254 277.926910,606.029175 
	C300.997559,608.748718 323.980713,609.183105 347.058411,606.021912 
	C369.708954,602.919250 391.985901,598.349854 413.680542,591.075867 
	C415.559967,590.445740 417.459473,589.658813 419.811523,590.815308 
	C420.936493,593.627502 419.378967,594.486084 416.989746,595.099365 
	C415.188812,595.869263 413.619019,596.358032 412.460785,598.065308 
	C411.839203,598.563660 411.429260,598.757263 410.653870,598.938843 
	C408.997925,599.112793 407.711853,598.552063 406.064453,598.852112 
	C403.958466,599.434204 401.852997,599.235229 400.643982,601.483032 
	C400.456848,602.458435 400.155975,603.011230 399.265167,603.478271 
	C398.738434,603.562866 398.523285,603.555359 398.003601,603.447021 
	C397.337616,603.135010 396.986755,602.907776 396.392822,602.505859 
	C394.871643,601.748901 393.894409,602.186768 392.871826,603.444092 
	C392.208344,604.186157 391.657196,604.539429 390.681305,604.819946 
	C390.119110,604.900330 389.891937,604.913757 389.325897,604.926147 
	C386.091827,605.280029 383.583710,607.031311 380.326355,607.365234 
	C379.547607,607.592834 379.091064,607.586853 378.349060,607.279724 
	C377.305298,607.042908 376.548370,607.002319 375.412689,606.953003 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M378.056335,607.447144 
	C378.492035,607.064087 378.921814,607.044678 379.674927,607.025208 
	C380.357391,607.443359 380.505096,607.926270 380.221619,608.799683 
	C379.884247,610.145569 380.462524,611.521851 379.412384,612.066833 
	C378.631775,612.471985 378.269104,611.358337 378.024658,610.309448 
	C378.016815,609.270264 378.033630,608.540527 378.056335,607.447144 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M415.853760,595.382446 
	C417.232819,594.186584 418.469330,593.380432 419.849548,592.277100 
	C420.336151,591.619812 420.722931,591.314575 421.487732,590.912354 
	C447.185852,580.525879 471.278076,568.093628 492.936127,551.128113 
	C504.075317,542.402344 514.658264,533.085327 525.136780,523.617004 
	C526.497131,522.387817 527.827026,521.075500 530.266052,521.450684 
	C531.626465,522.283447 531.828796,523.228333 531.222290,524.666504 
	C529.867920,526.624329 528.609558,528.110718 526.439331,529.047180 
	C524.453979,530.643738 522.869080,532.226746 521.785950,534.630493 
	C521.456726,535.428223 521.245911,535.909180 520.945557,536.638306 
	C520.855957,536.886414 520.390076,536.816223 520.156738,536.784058 
	C519.585266,536.879761 519.361084,537.119751 519.257263,537.715942 
	C519.282166,538.155823 519.281921,538.333435 519.018555,538.552307 
	C518.755371,538.593628 518.304260,538.752869 518.075806,538.823608 
	C517.616089,539.273499 517.288269,539.512756 516.578552,539.758118 
	C515.576172,540.684143 514.748718,541.333191 513.706421,542.197266 
	C513.301880,542.493896 513.136963,542.603760 512.729736,542.872070 
	C511.769257,543.437866 511.471375,544.068176 511.473267,545.174927 
	C510.941650,546.841492 509.553528,546.988586 508.350159,547.881104 
	C508.187744,548.151245 508.117279,548.171204 508.104980,548.208130 
	C507.611023,547.932739 507.129395,547.620422 506.378540,547.214233 
	C505.466278,547.530334 504.940582,548.074280 504.228516,548.829956 
	C504.048187,549.048645 503.600220,549.114014 503.375427,549.140564 
	C483.315247,566.150085 461.105835,579.292175 436.965607,589.909790 
	C435.493988,589.981262 434.428589,590.172791 433.389496,591.293945 
	C432.011993,592.088440 430.770630,592.372986 429.300842,592.934021 
	C428.271881,593.035522 427.542511,593.045715 426.448425,593.064575 
	C423.884155,594.914673 421.171631,595.589417 418.144379,596.339966 
	C417.449188,596.331909 417.126129,596.357361 416.557922,596.349365 
	C416.113678,596.151855 415.912476,595.962036 415.853760,595.382446 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M435.737427,589.213989 
	C449.218170,584.706787 460.351562,576.412109 472.491577,570.049988 
	C483.377594,564.344971 492.214874,555.756042 502.788544,549.140137 
	C500.898376,554.766968 495.536591,557.158264 491.110291,560.318665 
	C483.294891,565.898865 475.417664,571.445435 466.939789,576.033813 
	C466.030182,576.526062 465.325287,577.192810 464.952667,578.551025 
	C464.481720,578.942261 464.079926,578.997864 463.376038,579.095093 
	C462.447540,579.553894 461.915039,580.082336 461.138824,580.757080 
	C460.918793,580.931519 460.471741,580.968872 460.250793,581.005981 
	C453.325836,582.998779 447.497375,586.919556 441.070221,589.503357 
	C439.377655,590.183777 437.812531,591.187378 435.336121,590.807617 
	C434.878418,590.077209 435.107239,589.706116 435.737427,589.213989 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M504.365295,549.015259 
	C504.054749,548.075867 504.329834,547.295105 505.772644,547.114624 
	C505.986847,548.011536 505.675720,548.758179 504.365295,549.015259 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M429.012146,593.346619 
	C429.171509,590.921448 430.745514,591.026978 432.594666,590.968750 
	C433.370758,590.603394 433.838593,590.463379 434.679871,590.761902 
	C434.988983,590.985352 435.050293,591.049500 435.083282,591.082092 
	C435.014130,592.863220 433.341309,592.845154 432.159698,593.869751 
	C431.250793,594.161865 430.522552,594.166992 429.435577,594.240356 
	C429.058960,594.095093 429.041016,593.881531 429.012146,593.346619 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M417.987488,596.486450 
	C420.293213,595.215637 422.816223,594.150635 425.711487,593.079468 
	C425.468536,596.141663 422.333954,595.483643 420.229431,597.010254 
	C419.343567,597.032959 418.774170,596.862610 417.987488,596.486450 
z"/>
<path fill="#201B1D" opacity="1.000000" stroke="none" 
	d="
M415.612244,594.993774 
	C416.031952,595.220520 416.067535,595.448364 416.208984,596.009033 
	C416.314850,596.341736 416.298920,596.443054 416.257935,596.473877 
	C415.778870,596.471558 415.340698,596.467468 414.902344,596.498596 
	C415.133392,596.577820 415.375977,596.515198 415.915588,596.597412 
	C416.217499,596.888428 416.213959,597.137939 416.157715,597.758179 
	C415.878296,598.235718 415.651611,598.342712 415.049927,598.479187 
	C413.932709,598.639221 413.189911,598.786377 412.201355,598.166138 
	C411.782196,595.505005 413.115143,594.807434 415.612244,594.993774 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M416.219208,596.605347 
	C415.769714,596.723877 415.254517,597.182556 414.947968,596.421143 
	C415.208374,596.367737 415.468811,596.314331 415.973083,596.382812 
	C416.216919,596.504639 416.217407,596.571838 416.219208,596.605347 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M414.730225,598.232361 
	C415.164673,597.984741 415.354492,597.996582 415.824646,598.068604 
	C416.104980,598.128784 416.129913,598.545288 416.157715,598.751831 
	C415.986877,598.968689 415.788269,598.979004 415.291260,598.991333 
	C414.823792,598.826111 414.654663,598.658997 414.730225,598.232361 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M397.794464,603.250732 
	C398.542328,602.772949 399.052216,602.599915 399.703308,602.192505 
	C400.603943,598.574585 403.338593,599.910889 405.777344,599.619019 
	C407.922363,599.731079 409.664948,598.679321 411.729889,599.759216 
	C412.111725,600.329102 412.288452,600.584106 412.756104,600.887817 
	C410.780334,601.829956 408.594055,602.667603 406.197205,603.798584 
	C405.568848,604.114624 405.151123,604.137512 404.422058,604.202881 
	C403.519714,604.610657 402.969971,605.031982 402.160706,605.685425 
	C400.844940,605.947266 399.807098,606.001953 398.383789,606.119324 
	C397.997711,605.980164 397.997101,605.778259 397.999817,605.273621 
	C397.635742,604.567993 397.486786,604.096252 397.794464,603.250732 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M402.202240,605.901001 
	C402.069153,605.005737 402.377747,604.230530 403.786407,604.204712 
	C403.905487,605.109863 403.534668,605.816284 402.202240,605.901001 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M461.241638,580.923523 
	C461.058258,580.026917 461.370850,579.265686 462.748169,579.126831 
	C462.929596,580.034241 462.588715,580.764832 461.241638,580.923523 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M412.332703,599.989990 
	C410.251404,600.334045 408.487366,600.649780 406.335266,600.955688 
	C405.602570,600.544128 405.453552,600.079773 405.645874,599.203857 
	C406.906891,597.935669 408.196594,598.539124 409.692444,598.204102 
	C410.414856,597.955994 410.851532,597.947266 411.614075,597.916016 
	C412.699249,597.919800 413.458557,597.946045 414.596344,597.972534 
	C414.980499,598.142944 414.986115,598.312988 414.992310,598.738159 
	C414.211945,599.316040 413.431000,599.638794 412.332703,599.989990 
z"/>
<path fill="#2C2528" opacity="1.000000" stroke="none" 
	d="
M610.674316,343.921997 
	C612.720520,346.023071 611.974792,348.178619 611.389832,350.339325 
	C610.924622,352.057953 610.718262,353.787384 611.748901,355.756775 
	C612.009277,357.399048 611.970947,358.783142 611.905396,360.582153 
	C611.927124,361.589294 611.790894,362.130219 611.238647,362.821472 
	C611.022522,363.462036 610.998962,363.890289 610.957153,364.639740 
	C610.187195,365.743042 609.860596,366.591766 610.702515,367.833618 
	C610.850281,369.386230 610.821472,370.701172 610.756287,372.408875 
	C610.480774,373.543121 609.894409,374.037445 609.245911,374.831421 
	C609.034790,375.479584 609.005615,375.913391 608.952881,376.672485 
	C608.948853,377.590607 608.798157,378.131744 608.253418,378.828918 
	C608.037659,379.777130 608.007935,380.506104 607.961792,381.599548 
	C607.489014,382.420105 607.272400,382.940552 607.678711,383.835022 
	C607.831421,385.078522 607.816833,386.070190 607.763733,387.432068 
	C607.481201,388.545135 606.891846,389.037781 606.220459,389.816223 
	C606.026672,390.021027 605.992493,390.495911 605.976746,390.733459 
	C605.291748,391.602325 604.506226,391.744659 603.271729,391.318115 
	C601.508179,389.492554 601.693420,387.557709 601.877319,385.242279 
	C602.087463,384.092773 602.314026,383.355347 602.612915,382.253906 
	C602.768677,381.406769 602.876038,380.929321 603.087341,380.106079 
	C603.790283,377.488983 604.607361,375.266541 604.738525,372.531982 
	C604.812561,371.710693 604.885132,371.246002 605.054321,370.442383 
	C605.479492,368.998413 605.736511,367.879211 605.787231,366.369934 
	C605.857605,365.560822 605.927917,365.102203 606.092896,364.307098 
	C606.512512,362.865479 606.741333,361.743958 606.739868,360.231262 
	C606.779053,359.168335 606.878845,358.464966 607.070068,357.410828 
	C607.374695,356.124939 607.681091,355.205200 607.650452,353.851349 
	C607.649292,352.198151 607.753418,350.926086 608.006897,349.270203 
	C608.794678,347.202545 608.452515,345.060547 610.674316,343.921997 
z"/>
<path fill="#2C2528" opacity="1.000000" stroke="none" 
	d="
M602.948120,400.680786 
	C602.790894,402.136047 602.652832,403.269501 602.258423,404.627319 
	C601.169250,404.730988 600.368225,404.501587 599.344849,403.947937 
	C598.094971,402.650299 597.876038,401.361694 598.235779,399.632294 
	C599.856445,397.622223 600.390625,395.571655 600.699829,393.079956 
	C601.091858,392.686066 601.300842,392.583618 601.860962,392.455627 
	C602.438354,392.496521 602.664673,392.562927 603.156128,392.864929 
	C604.128723,394.200226 603.908813,395.334778 603.520813,396.809662 
	C603.328125,398.217743 602.915771,399.250366 602.948120,400.680786 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M603.224854,398.182739 
	C602.975830,396.586243 602.989380,395.191864 602.981689,393.379578 
	C602.826965,392.823212 602.693420,392.684723 602.796265,391.786560 
	C603.765198,391.010895 604.497742,390.994995 605.595703,390.975037 
	C606.062195,393.330139 606.543884,395.797638 604.079346,397.727844 
	C603.854980,398.140167 603.671143,398.262482 603.224854,398.182739 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M599.649536,404.208282 
	C600.686707,403.896729 601.564819,402.896637 601.998901,404.599854 
	C601.688477,406.324097 601.375061,407.796570 601.073425,409.646057 
	C601.085205,410.023071 600.879150,410.026794 600.776123,410.023743 
	C598.722290,410.866516 598.437866,409.429504 598.053772,407.714966 
	C598.160645,406.217224 598.593933,405.261200 599.649536,404.208282 
z"/>
<path fill="#4A4546" opacity="1.000000" stroke="none" 
	d="
M602.718018,398.169098 
	C603.141479,397.987274 603.320740,397.993927 603.769470,398.009216 
	C603.857971,398.887299 603.677063,399.756805 603.212524,400.814423 
	C601.867859,400.277344 601.841553,399.374115 602.718018,398.169098 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M610.933044,367.684418 
	C608.831787,367.438110 608.265381,366.513336 610.614258,365.019653 
	C610.954834,365.739777 610.970886,366.518677 610.933044,367.684418 
z"/>
<path fill="#897F7A" opacity="1.000000" stroke="none" 
	d="
M606.550903,403.925720 
	C606.697754,404.458984 606.574219,405.061890 606.178772,405.833618 
	C604.903748,405.123383 605.198853,404.486145 606.550903,403.925720 
z"/>
<path fill="#4A4546" opacity="1.000000" stroke="none" 
	d="
M611.337769,362.997375 
	C611.168762,362.472900 611.291565,361.912079 611.646362,361.174164 
	C613.081848,361.814606 612.873657,362.453400 611.337769,362.997375 
z"/>
<path fill="#4A4546" opacity="1.000000" stroke="none" 
	d="
M609.388550,374.986542 
	C609.007996,374.147003 609.201050,373.378998 610.428711,372.901489 
	C610.934937,373.771027 610.773315,374.562042 609.388550,374.986542 
z"/>
<path fill="#4A4546" opacity="1.000000" stroke="none" 
	d="
M608.356506,379.007935 
	C608.192444,378.479248 608.317505,377.910339 608.685913,377.169617 
	C610.096985,377.836182 609.867126,378.473389 608.356506,379.007935 
z"/>
<path fill="#4A4546" opacity="1.000000" stroke="none" 
	d="
M606.355713,389.970642 
	C606.008057,389.131165 606.207458,388.361633 607.433960,387.900146 
	C607.933105,388.780762 607.766968,389.575439 606.355713,389.970642 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M607.909790,383.736206 
	C606.424255,383.704498 605.579407,383.186371 607.655884,382.006409 
	C607.954834,382.437836 607.964233,382.911682 607.909790,383.736206 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M598.657227,406.738464 
	C599.099976,408.032135 598.759277,409.268219 600.361450,409.956024 
	C600.887268,411.179199 600.767761,412.271851 599.838928,413.522339 
	C595.263184,415.935486 592.049927,425.114227 594.681396,428.236145 
	C594.557068,428.544067 594.413391,428.637207 594.019043,428.795776 
	C588.949341,431.556213 588.259827,436.532227 586.957397,441.563324 
	C583.506165,444.513672 582.997009,448.803619 580.970093,452.201447 
	C578.817932,455.809296 577.047852,459.645081 575.136475,463.754303 
	C575.181641,465.823761 574.416809,467.186432 573.179810,468.718079 
	C572.451477,469.518890 571.938782,470.073090 571.302734,470.892456 
	C571.155151,471.134369 571.108765,471.587372 571.074402,471.812439 
	C570.177246,472.685608 569.763123,473.598938 569.487549,474.923523 
	C569.274963,476.071503 568.981750,476.857178 568.162598,477.718597 
	C567.913940,477.921417 567.475586,477.980774 567.255981,478.007324 
	C561.211548,487.981659 553.515259,496.637482 547.185608,506.660309 
	C546.927673,506.905762 546.926392,506.925415 546.914673,506.926392 
	C544.002991,506.946045 542.277588,508.293945 542.003784,511.643433 
	C542.174316,514.438477 540.343262,515.214233 538.654724,516.156738 
	C537.001038,517.079712 535.093628,517.818848 534.943909,520.533569 
	C534.589111,521.282715 534.193237,521.551880 533.356018,521.751709 
	C532.740845,521.739441 532.495605,521.695007 531.911865,521.487732 
	C531.174194,521.012817 530.850220,520.636230 530.491821,519.838318 
	C530.238220,517.816895 531.266479,516.714844 532.214111,515.543335 
	C543.801270,501.218201 555.409851,486.907959 565.303650,471.315948 
	C573.150757,458.949341 579.746887,445.941193 585.717712,432.569061 
	C589.247559,424.663727 592.562012,416.723602 595.010986,408.028168 
	C595.280945,407.462128 595.415222,407.247406 595.842285,406.787476 
	C596.870361,406.218445 597.611694,406.201508 598.657227,406.738464 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M547.255066,506.940857 
	C546.436584,501.514709 551.294006,499.094452 553.625549,495.334900 
	C557.374573,489.289703 562.044861,483.815826 566.681152,478.067200 
	C565.075134,484.863770 559.874573,489.906067 556.978516,496.600220 
	C553.874817,498.914673 550.481445,500.633850 550.965576,505.579651 
	C550.794434,506.478577 550.608643,506.978882 550.173584,507.585388 
	C549.312866,506.899628 548.428223,507.001404 547.255066,506.940857 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M569.205139,475.244324 
	C569.030640,473.835602 568.825623,472.548523 570.690125,472.067871 
	C570.794495,472.836578 570.548950,473.635620 570.171204,474.725281 
	C569.849792,475.180695 569.660583,475.345551 569.205139,475.244324 
z"/>
<path fill="#4A4546" opacity="1.000000" stroke="none" 
	d="
M568.811279,475.267517 
	C569.122070,474.984833 569.305298,474.991425 569.763733,475.006958 
	C569.954346,476.163147 570.175842,477.461670 568.268188,477.902405 
	C568.170532,477.133209 568.427124,476.345032 568.811279,475.267517 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M571.464478,471.067505 
	C571.044250,470.150208 571.275696,469.366180 572.689575,469.049805 
	C572.999084,469.928650 572.747253,470.692230 571.464478,471.067505 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M522.020386,534.852173 
	C520.267883,531.309082 523.083679,530.361267 525.761047,529.111389 
	C526.236023,531.911865 524.313477,533.340454 522.020386,534.852173 
z"/>
<path fill="#4A4546" opacity="1.000000" stroke="none" 
	d="
M530.597412,519.969543 
	C531.298828,520.105408 531.562134,520.293213 531.895142,520.759949 
	C532.173279,521.110962 532.336487,521.246460 532.749512,521.184753 
	C533.422180,520.962036 533.845154,520.936523 534.584045,520.901978 
	C534.937012,523.124939 533.598267,524.264404 531.333496,524.966553 
	C530.823608,524.120667 530.661804,523.253052 530.223206,522.195190 
	C529.388550,521.241455 529.539490,520.567444 530.597412,519.969543 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M513.186218,542.263916 
	C513.790955,541.059814 514.593689,540.134705 515.677124,539.075134 
	C516.179688,539.195923 516.448303,539.384521 516.846313,539.741333 
	C516.918396,540.618286 516.907959,541.260559 516.923828,542.213196 
	C516.780579,542.595398 516.611023,542.667175 516.172607,542.802124 
	C514.978149,543.428101 514.168030,543.088623 513.186218,542.263916 
z"/>
<path fill="#4A4546" opacity="1.000000" stroke="none" 
	d="
M517.204590,539.987244 
	C516.609497,539.864319 516.357849,539.666443 516.065796,539.161621 
	C516.378967,538.921509 516.800110,538.902283 517.534302,538.888672 
	C517.896606,539.082092 517.945923,539.269836 518.013000,539.748779 
	C517.847290,540.026062 517.663818,540.012268 517.204590,539.987244 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M518.971436,538.296631 
	C517.867004,536.949402 517.806763,536.143066 519.766968,536.551086 
	C519.936646,536.958313 519.949951,537.164612 519.920654,537.678101 
	C519.687378,538.140808 519.496826,538.296326 518.971436,538.296631 
z"/>
<path fill="#4A4546" opacity="1.000000" stroke="none" 
	d="
M518.678589,538.251343 
	C518.843201,538.108643 519.049744,538.075806 519.567139,538.014160 
	C519.906372,538.154358 519.934814,538.323425 519.984192,538.748840 
	C519.790466,538.960205 519.575806,538.915283 519.058289,538.731995 
	C518.755371,538.593628 518.720520,538.361145 518.678589,538.251343 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M512.772217,542.025330 
	C513.772339,542.202698 514.556580,542.420471 515.622314,542.751831 
	C514.434875,545.780823 511.825684,547.180908 508.537964,548.147949 
	C508.118866,546.616089 509.516327,546.264526 510.497986,545.207642 
	C510.961029,544.143738 511.008911,543.227661 511.858826,542.325806 
	C512.121155,542.127075 512.556274,542.065674 512.772217,542.025330 
z"/>
<path fill="#685E5C" opacity="1.000000" stroke="none" 
	d="
M600.074463,220.705750 
	C599.670959,220.816589 599.257568,220.714966 599.869568,220.113098 
	C600.057678,220.050430 600.076294,220.487183 600.074463,220.705750 
z"/>
<path fill="#685E5C" opacity="1.000000" stroke="none" 
	d="
M585.976929,184.652969 
	C581.951355,182.637085 581.367065,178.443771 580.667969,174.223618 
	C583.429749,177.022934 585.072144,180.469391 585.976929,184.652969 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M611.063110,343.613831 
	C609.296021,345.067719 610.538940,347.183105 609.257751,348.764160 
	C607.885376,349.205139 607.463074,348.443451 606.935059,347.236694 
	C606.265381,343.034729 606.925598,339.392181 608.372742,335.450623 
	C609.062744,334.684967 609.593323,334.507507 610.574036,334.768860 
	C610.971252,336.720978 610.992798,338.457184 611.044495,340.629700 
	C611.066772,341.793854 611.058899,342.521667 611.063110,343.613831 
z"/>
<path fill="#2C2528" opacity="1.000000" stroke="none" 
	d="
M494.933716,80.591316 
	C498.180023,79.561600 500.039978,82.019562 501.819916,83.660278 
	C508.405609,89.730972 515.608459,95.051903 522.026855,101.354111 
	C543.230957,122.174454 561.566223,145.097397 575.242004,171.570801 
	C580.320374,181.401474 585.837585,191.016281 589.444092,201.576218 
	C591.125061,206.498108 594.691467,210.728516 594.999146,216.600906 
	C592.139038,218.176132 591.618713,215.793381 590.916809,214.115265 
	C588.809448,209.076782 586.551453,204.082199 584.934570,198.863968 
	C584.124817,196.250580 582.887207,194.012802 580.869995,191.714020 
	C580.386536,190.984772 580.181824,190.532455 579.938721,189.704590 
	C577.273193,181.345886 572.885620,174.268707 568.236633,166.962097 
	C567.834412,166.555359 567.685974,166.381958 567.348755,165.926193 
	C566.746521,164.855331 566.278381,164.101898 565.548401,163.122650 
	C564.549622,160.605011 564.007507,158.256210 562.550537,155.937531 
	C561.857117,154.720612 560.992432,154.139725 559.874146,153.356461 
	C559.385803,152.781754 559.177246,152.402145 558.887024,151.698196 
	C558.311401,149.847534 557.176270,148.883804 555.622437,147.859283 
	C554.640320,147.102966 554.253296,146.334427 553.917603,145.182007 
	C553.662781,144.099686 553.464050,143.329361 552.748779,142.463531 
	C552.046753,141.403595 551.626831,140.507736 550.684814,139.614746 
	C550.179993,139.118271 549.914429,138.811340 549.489258,138.238266 
	C548.796265,137.094955 548.151611,136.321732 547.001404,135.589905 
	C546.069397,134.842514 545.465820,134.209839 544.623779,133.339630 
	C542.641235,129.677353 540.241150,126.683815 537.961487,123.228882 
	C536.946167,122.029175 536.298218,120.945732 535.115479,119.920815 
	C534.585144,119.461830 534.300415,119.183846 533.844360,118.666382 
	C533.330505,117.976692 533.059326,117.473946 532.529297,116.813042 
	C531.909363,116.235092 531.445740,115.907921 530.703064,115.453720 
	C529.777405,114.799088 529.178589,114.221336 528.311401,113.451523 
	C524.684692,109.878677 521.349976,106.478065 517.696228,102.910568 
	C516.800476,102.022659 516.207397,101.323418 515.381714,100.374588 
	C511.826508,96.129547 506.918121,94.010330 503.179321,89.992142 
	C502.314392,89.166565 501.769806,88.484016 500.776550,87.809418 
	C498.497650,86.543465 497.111053,84.823563 495.598633,82.751511 
	C495.146515,82.092018 494.954193,81.678139 494.933716,80.591316 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M580.788452,191.235168 
	C584.150513,192.182373 584.972534,195.014084 586.002747,197.780212 
	C588.226990,203.752579 590.555237,209.686707 592.908630,215.609619 
	C593.117737,216.135956 593.820679,216.466080 594.645874,216.944855 
	C594.997559,217.002396 595.020752,217.483597 595.028992,217.724335 
	C596.179016,218.888504 595.765564,220.452850 596.714905,221.796753 
	C596.940369,222.485687 596.961304,222.917770 596.993408,223.674042 
	C595.500305,227.464661 598.330261,230.295242 598.212158,233.769165 
	C597.161072,234.374084 596.470703,234.019684 595.577271,233.173340 
	C590.215454,220.468796 587.086365,207.313416 580.864746,195.348740 
	C580.240540,194.148361 579.934265,192.858673 580.788452,191.235168 
z"/>
<path fill="#2C2528" opacity="1.000000" stroke="none" 
	d="
M482.696198,68.930107 
	C483.063446,68.938240 483.519257,68.982491 483.746521,69.008720 
	C484.777618,73.346436 489.520172,73.514076 491.695587,76.948578 
	C491.222168,77.961250 490.674194,78.276100 489.763855,78.588081 
	C489.010040,78.686348 488.580353,78.629143 487.864746,78.350914 
	C486.858368,77.649506 486.240143,76.998833 485.322510,76.163193 
	C482.850494,73.547554 479.726440,72.588989 477.094666,70.856445 
	C475.543915,69.835571 473.827789,68.970276 474.729462,66.331741 
	C478.008759,65.472878 479.617889,68.612686 482.696198,68.930107 
z"/>
<path fill="#2C2528" opacity="1.000000" stroke="none" 
	d="
M491.994873,77.005791 
	C493.524902,77.072708 494.577454,77.743828 495.008057,79.608307 
	C495.059692,79.940094 495.023132,79.976868 495.005676,79.996071 
	C494.309540,80.654282 493.508148,80.813469 492.237000,80.424446 
	C491.284607,79.491577 491.186066,78.680046 491.695374,77.444473 
	C491.920502,77.081596 491.970032,77.031013 491.994873,77.005791 
z"/>
<path fill="#2C2528" opacity="1.000000" stroke="none" 
	d="
M596.947144,221.674774 
	C594.844116,221.767487 595.006714,220.195038 595.019836,218.341766 
	C597.165649,218.212906 596.977905,219.808167 596.947144,221.674774 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M487.821167,77.779694 
	C488.463348,77.992958 488.898407,78.013634 489.659424,78.056961 
	C491.014282,78.532341 490.892242,79.925766 492.188843,80.488068 
	C493.496765,80.895622 494.522064,81.166618 495.720093,81.831635 
	C497.502167,83.533501 499.050537,85.016434 500.785889,86.766548 
	C501.619629,87.496620 501.884857,88.279961 502.726135,88.917389 
	C507.681580,91.964279 512.131042,95.197205 515.922058,99.657257 
	C516.098694,100.920631 516.810120,101.278534 517.760803,101.818642 
	C521.986816,105.037621 525.243225,108.826126 528.839966,112.714111 
	C529.549866,113.571571 529.709412,114.438850 530.707336,114.961441 
	C531.526855,115.201355 532.057983,115.366096 532.743286,115.769547 
	C532.974060,116.600060 533.182068,117.135452 533.775635,117.805145 
	C534.290222,118.122734 534.544800,118.309441 534.840820,118.796707 
	C535.213379,120.440689 536.256653,121.113998 537.714355,121.827774 
	C541.062805,124.904419 543.384521,128.309158 544.993225,132.597458 
	C545.537781,133.529007 546.065186,134.068268 546.819519,134.781342 
	C548.594727,134.985275 549.987183,135.220230 549.966431,137.637314 
	C550.019897,138.371460 550.176758,138.677933 550.733398,138.964844 
	C552.426086,139.112732 552.985168,139.960953 552.990051,141.649872 
	C553.213440,142.841064 554.002502,143.115005 554.775574,143.810715 
	C555.153198,144.869705 555.331238,145.718643 555.766846,146.772247 
	C557.005981,148.348602 557.698181,150.001480 559.733276,150.800049 
	C559.973450,151.465683 559.992004,151.895752 560.023621,152.648407 
	C560.637390,153.881104 561.772888,153.957687 562.753052,154.815491 
	C564.843445,157.058517 565.991150,159.390213 566.020508,162.587097 
	C566.539978,163.524857 567.058044,164.072052 567.781799,164.813660 
	C567.977417,165.017624 568.001221,165.497604 568.011841,165.737656 
	C572.728271,173.176270 576.320190,180.992538 580.743713,188.746490 
	C580.998840,189.442780 581.012634,189.874054 581.040527,190.627747 
	C581.098022,195.795807 584.827454,199.122559 586.189331,203.518204 
	C589.176819,213.160782 593.371155,222.413315 595.993774,232.601105 
	C597.194458,235.443848 597.846802,238.082443 598.935181,240.913712 
	C599.420044,241.543167 599.666504,241.922974 599.937195,242.664841 
	C600.009888,243.437729 600.017395,243.875443 600.028198,244.641495 
	C600.860718,245.651154 600.943909,246.764557 601.741577,247.809738 
	C601.953796,248.777145 601.967041,249.514236 601.976624,250.619934 
	C601.478882,251.428635 601.311157,251.950287 601.792542,252.787720 
	C602.009766,252.995590 602.034180,253.477249 602.038940,253.718338 
	C602.338501,254.271362 602.536011,254.634140 602.563843,255.365280 
	C602.138916,256.646362 601.814758,257.618744 602.794312,258.777954 
	C603.014038,258.988800 603.017090,258.982910 603.024109,258.979675 
	C604.557617,261.455566 603.973389,264.308472 604.447754,267.369171 
	C604.433899,268.530090 604.439636,269.294434 604.712585,270.400513 
	C604.985901,271.456940 605.081238,272.172913 605.237610,273.233032 
	C605.375427,274.259979 605.470825,274.939301 605.781189,275.919098 
	C606.261597,277.972321 606.763916,279.678589 606.904602,281.771545 
	C606.767395,283.101624 606.854858,284.070404 607.616455,285.205048 
	C608.057739,286.488495 607.960266,287.523346 607.946289,288.851715 
	C607.905212,289.919281 607.623474,290.677521 607.931641,291.727142 
	C608.020447,292.437012 608.027771,292.873566 608.036743,293.637543 
	C609.219360,295.321228 608.943359,296.972809 608.957703,298.947266 
	C608.520081,302.180573 607.611084,305.038239 609.315918,308.149475 
	C610.894470,310.208649 609.593262,311.715637 609.042236,313.679016 
	C608.727356,318.511566 609.593445,322.917694 609.591919,327.735748 
	C609.773376,328.594879 609.848755,329.084412 609.856689,329.939667 
	C609.584656,331.640717 609.349182,332.988617 609.048584,334.667542 
	C608.654968,338.701477 608.320007,342.403259 607.984009,346.543640 
	C606.341858,349.003906 607.551880,351.176544 607.731445,353.612366 
	C607.926147,354.590149 607.939697,355.248169 607.777100,356.219849 
	C607.462891,357.748322 606.574097,358.815460 606.900024,360.473083 
	C606.961975,361.675140 606.996033,362.556305 606.505615,363.701416 
	C604.941650,366.363495 603.799805,368.779663 604.807190,371.989349 
	C604.940735,373.072784 604.918091,373.801636 604.636414,374.875641 
	C601.017334,382.543671 600.362122,390.571594 598.609863,398.716553 
	C598.475281,401.701172 598.088501,404.221344 596.259521,406.711517 
	C596.015076,407.012299 596.005066,407.005951 596.002563,407.002991 
	C591.557190,417.012512 588.033142,427.394409 583.412354,437.350342 
	C576.957397,451.258179 569.967285,464.826141 561.192200,477.425964 
	C549.982605,493.521393 538.786621,509.737122 524.660767,523.391479 
	C509.248779,538.289185 493.286835,552.766235 475.004395,564.157532 
	C460.204041,573.379150 444.717865,581.455505 428.526215,588.066956 
	C426.377960,588.944153 424.106659,589.610901 422.243134,591.714233 
	C421.541534,591.976196 421.099274,591.982056 420.325134,591.983887 
	C418.469299,590.079895 416.864319,591.549072 415.476501,592.054565 
	C395.783997,599.227905 375.316650,603.448730 354.740265,606.644287 
	C338.078217,609.231934 321.138611,610.951233 304.203735,609.907959 
	C280.395813,608.441101 256.784180,605.420044 233.854721,598.416809 
	C233.027420,598.164124 232.259079,597.988403 231.236343,598.724121 
	C230.560043,598.990173 230.118149,598.987732 229.344864,598.982239 
	C220.053253,595.030884 210.968185,591.394104 201.822037,587.897400 
	C196.254410,585.768799 190.707413,583.552429 185.254654,580.276978 
	C184.536896,580.016235 184.101166,580.005676 183.338638,579.988708 
	C176.336823,575.945251 169.739182,571.750427 162.952911,567.933350 
	C148.480820,559.793213 136.142029,548.888977 123.864021,538.017212 
	C99.834160,516.739624 79.932022,491.843597 62.564835,464.933716 
	C53.819351,451.382904 46.889553,436.872620 40.709538,421.956940 
	C34.183323,406.205750 29.337313,390.088867 26.246267,373.289795 
	C25.295496,368.122559 25.721203,362.728607 23.595451,357.416351 
	C23.241417,356.611328 23.126175,356.125000 23.064417,355.251160 
	C23.326704,350.130371 23.088518,345.395142 22.513615,340.341614 
	C21.638412,338.166595 21.433117,336.221313 21.304382,333.914703 
	C22.374891,331.872528 22.589123,330.206085 21.084606,328.223450 
	C20.445492,325.414673 20.614651,322.952179 20.915314,320.063354 
	C22.423731,311.686066 21.322750,303.688507 21.451618,295.275299 
	C21.493492,292.826385 20.537815,290.880371 21.188972,288.428162 
	C23.172331,284.475311 24.373747,280.905762 23.759510,276.693146 
	C23.184118,272.747040 25.171305,268.992676 25.747946,265.094421 
	C26.056728,263.006927 26.405888,260.885315 26.908009,258.396545 
	C29.989929,244.981918 33.804676,232.251404 38.299225,219.636734 
	C41.740566,209.978027 45.591099,200.468964 48.866077,190.755692 
	C50.326103,186.425369 54.339626,183.298874 54.256554,178.204590 
	C54.100338,176.887451 53.904053,175.639999 55.657249,175.063812 
	C56.793602,174.318527 57.219425,173.402328 57.790085,172.218597 
	C57.967007,171.971664 57.988289,171.491760 58.002346,171.251999 
	C58.765488,170.331848 59.207684,169.484344 59.248932,168.236267 
	C59.118607,167.062088 59.216351,166.250854 60.719257,166.887650 
	C62.116760,165.999756 62.356750,164.369797 63.719360,163.163727 
	C63.950539,162.197968 63.990726,161.483505 64.053131,160.411911 
	C67.735794,157.344315 68.546471,152.653259 71.749008,149.230148 
	C77.984070,144.201218 81.324455,137.250580 86.150444,131.498444 
	C87.583099,129.790833 90.695541,128.715607 89.354614,125.243752 
	C89.540184,124.700562 89.971184,124.371315 90.688202,124.010239 
	C92.490860,121.399834 96.473595,120.385384 95.700226,116.062256 
	C95.679184,114.290695 96.524559,113.261940 97.472862,112.350533 
	C102.294922,107.716057 106.777367,102.715454 112.502899,98.648941 
	C114.185631,99.128029 115.530434,99.182098 116.534744,98.070908 
	C122.180000,91.824898 129.279800,87.139114 135.081085,80.593704 
	C135.392456,80.135078 135.533020,79.965149 135.939331,79.605530 
	C137.124329,78.932304 138.221344,78.844467 139.288239,77.945816 
	C139.707779,77.628311 139.880905,77.506172 140.328247,77.220932 
	C141.944016,76.544106 142.698761,75.641205 142.610672,73.790001 
	C142.919220,73.014893 143.266251,72.693909 144.839905,72.323532 
	C150.328079,70.841057 154.011108,68.176315 157.729050,65.768410 
	C185.079041,48.055344 214.554062,35.607979 246.315002,28.153893 
	C274.237030,21.600777 302.465027,19.353233 330.958710,20.836643 
	C345.709930,21.604609 360.343048,24.209785 374.866913,27.083963 
	C376.347992,27.377068 377.805664,27.620424 379.698364,27.620991 
	C380.835022,27.654516 381.578796,27.715164 382.656647,27.892462 
	C383.839355,28.129141 384.665100,28.432772 385.861389,28.249313 
	C386.590851,28.118856 387.012573,28.073603 387.758789,28.043179 
	C388.512207,28.022558 388.939697,28.060301 389.669922,28.248539 
	C390.533386,28.655836 391.085236,28.973722 391.953918,29.347958 
	C392.735565,29.814228 393.261108,30.097134 394.172668,30.196663 
	C394.899017,30.233532 395.312805,30.307320 396.023499,30.554928 
	C397.594543,31.701790 399.024628,32.361675 400.947906,32.740128 
	C401.717438,32.913803 402.145813,33.048771 402.869507,33.348091 
	C404.893188,34.666698 406.993408,34.520454 409.214935,35.210175 
	C417.890137,37.411991 425.699615,40.900810 433.740112,44.739769 
	C434.019104,44.965328 434.498932,45.003048 434.739258,45.015167 
	C437.255554,45.990414 439.707062,46.647354 441.565002,48.943539 
	C442.401398,50.472233 443.527435,50.807255 445.157532,50.818199 
	C447.739105,50.927086 449.107544,52.537632 450.910645,54.067459 
	C451.866089,54.834084 452.488525,55.512306 453.813629,55.579605 
	C455.632782,55.683853 457.099976,55.774158 458.697937,56.783333 
	C459.389526,57.062160 459.800629,57.096493 460.520477,57.151474 
	C461.796326,57.712135 462.490173,58.568310 463.502136,59.553123 
	C464.586670,61.251606 466.005585,61.744835 467.893066,62.037140 
	C468.680267,62.143875 469.096466,62.310413 469.728424,62.791260 
	C469.973877,63.028934 469.998779,62.999542 469.984131,63.013725 
	C470.106476,63.156536 470.243500,63.285168 470.469543,63.671669 
	C470.700287,64.449516 470.955475,64.863594 471.824066,64.980270 
	C472.957031,64.988060 473.778137,65.080788 474.727112,65.812775 
	C474.956024,66.046440 474.974518,66.041069 474.963501,66.045639 
	C475.050598,70.544090 479.581848,70.004013 481.865479,72.016319 
	C483.147949,73.146393 485.342010,73.202065 485.940277,75.659729 
	C486.542175,76.526016 487.059692,77.075562 487.821167,77.779694 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M604.219543,274.197876 
	C604.010315,273.244354 604.005920,272.496246 604.002014,271.374084 
	C603.989197,270.403870 603.813293,269.866241 603.225891,269.196411 
	C603.015564,265.955536 603.007690,262.922119 603.015503,259.432556 
	C604.445679,259.134033 604.854736,260.018616 605.023621,261.339050 
	C606.209412,270.612885 609.268250,279.618591 608.978760,289.557129 
	C608.575806,290.346100 608.126831,290.488831 607.301331,290.204742 
	C606.987061,288.618256 606.983948,287.236389 606.977783,285.439941 
	C606.555176,284.614258 606.210083,284.155762 606.025024,283.287781 
	C605.663391,280.932037 605.331421,278.865265 604.998535,276.399780 
	C604.987122,275.403656 604.811096,274.865723 604.219543,274.197876 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M607.993164,300.418030 
	C607.992920,298.274658 607.996704,296.551758 608.019470,294.396912 
	C611.815002,295.677521 610.029480,299.470062 610.735840,302.176605 
	C611.564758,305.353027 611.443237,309.001251 610.336182,312.711060 
	C609.652893,313.387238 609.182800,313.528931 608.328613,313.216003 
	C607.551636,311.560028 609.985046,311.098053 609.073425,309.284576 
	C607.218140,306.465912 608.323181,303.566498 607.993164,300.418030 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M608.008667,313.459839 
	C608.466919,312.995941 608.919495,312.999237 609.712769,313.008484 
	C610.044495,315.043121 610.035645,317.071777 610.022827,319.535461 
	C610.441895,320.377441 610.783386,320.835999 610.954956,321.705292 
	C610.984985,324.037292 610.992004,326.080353 610.997925,328.561157 
	C610.611023,329.377777 610.151123,329.525299 609.307373,329.221008 
	C606.800171,324.099182 608.568665,318.936096 608.008667,313.459839 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M599.240356,241.939453 
	C595.490479,240.193939 596.921997,236.577179 595.998657,233.410568 
	C596.497314,233.264786 596.997070,233.528320 597.759094,233.899948 
	C597.494019,236.458862 600.651001,237.740250 599.998352,240.615692 
	C599.936707,241.352081 599.761353,241.638458 599.240356,241.939453 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M609.316956,334.998657 
	C607.701904,333.967316 607.803162,332.735687 608.736206,331.210571 
	C609.381714,330.619324 609.842041,330.473114 610.686584,330.780762 
	C610.990173,332.063812 610.983704,333.126495 610.963501,334.586975 
	C610.514465,334.989014 610.079224,334.993286 609.316956,334.998657 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M606.765991,290.174988 
	C607.430115,290.002075 607.869934,290.003998 608.638977,290.008240 
	C608.811584,290.563171 608.654968,291.115784 608.255737,291.834442 
	C607.102478,291.824829 605.941528,291.872253 606.765991,290.174988 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M603.021851,258.615723 
	C601.344971,258.812439 600.629639,258.072815 601.738464,256.201111 
	C602.165833,255.871307 602.342224,255.744476 602.781372,255.810333 
	C603.039246,256.749573 603.034424,257.496124 603.021851,258.615723 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M601.957397,247.684021 
	C600.483704,247.918900 599.955322,247.038300 600.020874,245.325104 
	C601.495972,245.082794 602.035828,245.957672 601.957397,247.684021 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M603.262939,255.825836 
	C602.868408,256.002258 602.692688,256.001526 602.253174,255.999451 
	C601.994690,255.545227 601.999817,255.092316 602.024292,254.299408 
	C602.954407,254.155212 604.063538,254.182159 603.262939,255.825836 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M599.101440,242.228088 
	C599.097961,241.687744 599.287903,241.424759 599.780029,241.110565 
	C600.702393,241.424515 601.016663,241.951782 600.227783,242.855743 
	C599.676025,242.905487 599.412781,242.720840 599.101440,242.228088 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M602.015747,252.661011 
	C601.492859,252.766815 600.728149,252.671432 600.516479,252.278305 
	C600.190918,251.673630 600.765991,251.253632 601.677979,251.030273 
	C601.989258,251.434509 602.005493,251.880478 602.015747,252.661011 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M611.207275,321.826904 
	C610.666321,321.519501 610.354797,321.044739 610.031006,320.270203 
	C610.911743,320.180634 612.075806,320.163239 611.207275,321.826904 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M610.999451,330.667236 
	C610.552368,331.000732 610.108032,331.000366 609.329590,330.999573 
	C608.996399,330.555145 608.997253,330.111084 608.997925,329.333801 
	C609.442078,329.000214 609.886353,328.999847 610.663635,328.999207 
	C610.998535,329.443726 611.000366,329.888550 610.999451,330.667236 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M398.022583,602.964722 
	C398.020172,603.396362 398.007904,603.846680 397.999390,604.633911 
	C397.438416,604.896423 396.873627,604.822083 396.190308,604.932373 
	C395.179962,605.048523 394.429352,605.242065 394.031342,606.487915 
	C393.429688,606.991333 392.880707,607.194824 392.165619,607.638794 
	C391.999542,607.879395 391.504974,607.925720 391.258881,607.959229 
	C390.597198,607.485901 390.090881,607.332764 389.310150,607.839783 
	C388.963989,608.091125 388.784729,608.101379 388.341492,608.164795 
	C385.662659,608.495422 383.247833,608.772949 380.417480,609.088013 
	C379.993347,608.658020 379.984741,608.190552 379.987183,607.374146 
	C382.885101,605.888611 385.771973,604.752014 388.840851,603.874878 
	C389.186768,604.224609 389.350708,604.314941 389.735046,604.231323 
	C390.514069,603.859558 391.072723,603.661743 391.807800,603.221069 
	C392.833221,602.128967 393.873962,601.666748 395.388672,601.486511 
	C396.350372,601.818298 396.790222,602.399780 397.754150,602.800720 
	C398.046417,602.980896 398.012726,602.983459 398.022583,602.964722 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M389.454620,608.078491 
	C389.096161,607.404968 389.140472,606.681335 389.946625,606.590881 
	C390.244019,606.557495 390.608582,607.122559 390.977661,607.703674 
	C390.597198,608.020447 390.181580,608.048218 389.454620,608.078491 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M227.359680,604.799316 
	C226.707977,602.725037 225.141174,603.025208 223.427277,602.932739 
	C222.177948,602.520508 221.972183,601.728943 221.906677,600.545532 
	C225.926300,598.726562 229.021774,601.628601 232.774628,602.754028 
	C233.381546,603.438049 233.515656,603.913513 233.182953,604.781860 
	C231.211868,604.819824 229.407608,605.856873 227.359680,604.799316 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M232.860046,605.362305 
	C232.976242,604.643616 232.988495,604.182495 233.000061,603.376953 
	C233.432831,603.035889 233.866287,603.039246 234.623199,603.064697 
	C234.978348,604.082764 235.010010,605.078735 235.061340,606.443237 
	C234.151352,606.716187 232.616409,607.801514 232.860046,605.362305 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M261.016815,613.201172 
	C262.103912,612.098816 263.302551,610.116211 264.041321,613.436401 
	C264.218811,613.942444 264.399841,614.156738 264.270233,614.654907 
	C263.244141,614.929932 262.528687,614.921143 261.459167,614.881592 
	C261.076050,614.411621 261.046997,613.972534 261.016815,613.201172 
z"/>
<path fill="#69625F" opacity="1.000000" stroke="none" 
	d="
M264.259125,615.085754 
	C263.970795,614.737793 263.981995,614.536865 264.015442,614.032104 
	C264.773712,613.784058 265.509705,613.839844 266.614441,613.868286 
	C267.003754,614.292419 267.024292,614.743896 267.065247,615.529907 
	C266.243317,615.653809 265.401001,615.443298 264.259125,615.085754 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M269.006104,612.163818 
	C269.762543,611.917358 270.509796,611.941772 271.631104,611.965698 
	C272.598785,612.569336 272.706573,613.285461 272.251343,614.374023 
	C272.010742,614.672180 271.993896,614.913086 271.999420,615.035339 
	C271.556183,615.105103 271.107391,615.052612 270.322357,614.954834 
	C269.811615,614.375366 269.637146,613.841248 269.223114,613.141724 
	C268.988007,612.795715 268.992462,612.615173 269.006104,612.163818 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M272.378418,614.758789 
	C272.009491,613.998413 272.008270,613.324585 272.006104,612.307983 
	C273.392792,610.692444 274.709656,610.441895 275.949097,612.560425 
	C276.006836,613.069092 276.000854,613.250977 275.986572,613.705322 
	C275.677368,614.072205 275.425079,614.239624 275.114563,614.681213 
	C274.253845,614.869995 273.500000,614.857727 272.378418,614.758789 
z"/>
<path fill="#908D8E" opacity="1.000000" stroke="none" 
	d="
M510.274048,85.227585 
	C510.561493,85.018402 510.982208,85.019638 511.720062,85.015717 
	C511.629883,85.671562 511.122284,85.950027 510.274048,85.227585 
z"/>
<path fill="#2C2528" opacity="1.000000" stroke="none" 
	d="
M441.242859,50.221706 
	C439.681030,47.798767 437.145142,47.155392 435.160217,45.301056 
	C438.790924,44.482330 441.692444,46.776962 444.684509,48.418011 
	C449.438019,51.025143 454.908417,52.367764 458.941528,56.677750 
	C457.285065,57.006454 455.591705,56.985073 453.474731,56.954109 
	C452.471222,56.461426 451.943939,55.921776 451.197754,55.202847 
	C448.509094,55.304241 448.174591,51.780201 445.358521,52.011909 
	C444.137512,50.778172 442.541718,51.220139 441.242859,50.221706 
z"/>
<path fill="#2C2528" opacity="1.000000" stroke="none" 
	d="
M433.966492,44.621574 
	C429.730530,45.117210 426.201324,42.885052 422.700989,40.973625 
	C418.500580,38.679905 413.778809,38.301262 409.186340,36.335487 
	C408.800537,35.900757 408.675720,35.735352 408.586273,35.259884 
	C408.820862,34.576477 409.098907,34.273899 409.742126,33.935204 
	C410.775177,33.867588 411.511230,33.897297 412.615173,33.927326 
	C413.993927,36.352806 416.484650,36.207249 418.408997,36.937309 
	C423.778381,38.974358 429.547791,40.129181 433.966492,44.621574 
z"/>
<path fill="#2C2528" opacity="1.000000" stroke="none" 
	d="
M474.923096,65.690720 
	C473.902985,66.031700 472.849915,66.016960 471.401276,65.989830 
	C470.442871,65.680649 470.135895,65.195374 469.930542,64.302536 
	C469.874695,64.011032 469.908417,63.517799 469.938965,63.272854 
	C471.993500,62.978348 473.864014,63.256222 474.923096,65.690720 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M468.127319,62.748581 
	C465.997314,62.999939 464.138306,62.727173 463.009644,60.406784 
	C463.340027,59.676662 463.814301,59.507416 464.701355,59.758942 
	C465.583710,60.140285 466.130524,60.317085 466.851501,60.729218 
	C467.511963,61.407108 468.083710,61.777370 468.127319,62.748581 
z"/>
<path fill="#2C2528" opacity="1.000000" stroke="none" 
	d="
M464.976166,59.625412 
	C464.571716,59.981106 464.106537,59.998714 463.292114,60.039253 
	C461.969788,59.570942 461.221497,58.883564 460.890198,57.475624 
	C462.599854,57.087883 464.055511,57.612156 464.976166,59.625412 
z"/>
<path fill="#2C2528" opacity="1.000000" stroke="none" 
	d="
M468.300537,63.045830 
	C467.715576,62.527756 467.465698,62.015968 467.120728,61.234367 
	C468.164124,61.042694 469.446228,60.818687 469.938049,62.680569 
	C469.527802,63.036659 469.081726,63.044388 468.300537,63.045830 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M381.291016,28.593430 
	C370.963776,28.430122 361.192688,25.639072 351.170441,24.566221 
	C343.284424,23.722042 335.416138,22.360165 327.511871,22.107449 
	C307.596039,21.470692 287.621948,21.538574 267.964722,25.148243 
	C246.154068,29.153345 224.592331,34.229244 204.015381,42.921722 
	C185.319412,50.819603 167.748550,60.701477 150.656677,71.546181 
	C149.126801,72.516884 147.848038,74.698402 145.186615,73.363060 
	C144.999161,70.261230 147.341995,69.274498 149.253174,68.066757 
	C168.265686,56.052029 187.873978,45.169670 208.756134,36.681171 
	C211.656891,35.502029 214.958878,35.351604 217.727921,32.981937 
	C219.471207,31.826420 221.244125,31.772488 223.190369,31.091480 
	C224.914932,30.854656 226.449631,31.399445 227.802948,29.850491 
	C228.478577,29.361687 228.943436,29.233759 229.795776,29.187214 
	C237.350876,28.045786 244.451645,26.515926 251.610687,23.996983 
	C252.445374,23.251650 253.154602,23.106083 254.256104,23.086494 
	C256.992035,23.837942 259.173981,22.856358 261.744873,22.232243 
	C262.767181,21.961300 263.464478,21.862867 264.516113,21.759842 
	C266.463165,21.611181 268.138245,21.851538 269.841492,20.557547 
	C270.646973,20.260235 271.134979,20.190510 272.008331,20.214989 
	C277.467682,20.554903 282.453522,19.960421 287.720581,18.464615 
	C289.137726,17.984623 290.221222,18.036509 291.712006,18.096239 
	C297.265564,18.418728 302.445221,19.625725 307.890411,17.377127 
	C311.439636,16.835398 314.604431,17.021709 318.184265,17.135651 
	C322.325012,19.518963 326.457092,18.274441 330.802979,18.549158 
	C332.702393,18.671335 334.142609,18.035536 336.001129,18.182838 
	C337.542969,18.688480 338.552612,19.851189 340.365356,19.131390 
	C341.838989,19.022686 342.980957,18.938822 344.419891,19.366692 
	C346.102417,20.412289 347.619659,20.730288 349.585754,20.619400 
	C351.102722,20.582487 352.265045,20.089369 353.736633,20.745129 
	C354.028992,20.953739 354.497559,21.003822 354.731384,21.032940 
	C355.754395,21.870768 356.672760,22.115189 358.035339,21.592810 
	C358.741241,21.374945 359.147095,21.402788 359.787720,21.753334 
	C360.028778,21.955677 360.499298,22.002855 360.734192,22.029961 
	C366.564240,24.206127 372.404419,25.013252 378.737183,25.200966 
	C379.651031,25.185606 380.154236,25.307438 380.971436,25.742710 
	C381.741547,26.688480 381.793121,27.458174 381.291016,28.593430 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M217.869446,32.845772 
	C217.853882,34.834518 216.783203,35.485153 215.173172,36.030823 
	C190.962143,44.236313 169.108322,57.065132 147.659668,70.668396 
	C146.840103,71.188187 146.205841,72.000160 145.217773,72.897888 
	C144.950317,73.119804 144.947891,73.080490 144.933044,73.071510 
	C144.781647,72.909576 144.645111,72.756622 144.233490,72.462746 
	C143.813293,72.174294 143.668152,72.026756 143.400330,71.592987 
	C143.143417,70.686378 143.176254,70.073265 143.496368,69.193863 
	C143.778244,68.778664 143.921387,68.636223 144.313812,68.328079 
	C145.250183,67.787338 145.917221,67.383080 146.716309,66.647171 
	C147.603729,65.987190 148.338547,65.659912 149.338440,65.187332 
	C150.145981,64.779594 150.688400,64.515381 151.381561,63.919777 
	C151.783905,63.611488 151.951111,63.496906 152.380234,63.231464 
	C153.162598,62.788330 153.697723,62.519291 154.384369,61.932289 
	C154.780029,61.624386 154.944702,61.508846 155.368759,61.239502 
	C156.150848,60.782627 156.691574,60.507431 157.390091,59.904030 
	C157.807068,59.587814 157.982269,59.469978 158.441162,59.205917 
	C160.738342,58.314857 162.747986,57.563129 164.541870,55.748417 
	C164.989609,55.414944 165.180466,55.295872 165.676056,55.028481 
	C170.781860,52.358227 175.759796,50.155544 180.479401,46.787117 
	C181.143723,46.350002 181.553238,46.158054 182.299713,45.908066 
	C185.001022,45.333710 187.147964,44.482311 188.617126,41.942146 
	C189.239548,41.472179 189.659515,41.320587 190.439972,41.201271 
	C195.808228,41.016075 199.775452,37.467190 204.962189,36.722099 
	C206.140152,36.489433 206.869095,36.064186 207.800201,35.345039 
	C209.140839,34.797550 210.229355,34.439651 211.660721,34.046654 
	C212.878891,33.988098 213.768234,34.029457 214.765396,33.238815 
	C215.430496,32.988712 215.856659,32.965004 216.602783,32.932053 
	C217.152069,32.799686 217.381378,32.676563 217.869446,32.845772 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M319.319763,18.308237 
	C315.612762,18.066534 312.298920,18.068281 308.533752,18.072309 
	C305.077545,19.401144 302.085999,19.583815 299.063721,17.501150 
	C302.539307,14.884023 306.407135,16.196711 310.094269,16.101109 
	C314.852203,15.977741 319.653534,15.534095 324.699097,16.718752 
	C324.023468,20.225060 321.680939,18.746511 319.319763,18.308237 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M251.824432,23.852188 
	C251.786697,26.351675 249.722794,26.338509 248.277435,26.687441 
	C242.372375,28.112999 236.408188,29.293621 230.224396,30.303085 
	C230.255463,27.562860 232.536957,27.939566 233.999786,27.456530 
	C237.416809,26.328222 241.038651,25.874958 244.717896,24.301159 
	C246.695679,24.013302 248.365524,23.959784 250.452438,23.896099 
	C251.096252,23.793417 251.322968,23.700899 251.824432,23.852188 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M379.137848,25.725063 
	C372.818207,26.335970 366.667450,26.157806 361.040100,22.417761 
	C361.722076,22.008291 362.475067,21.959518 363.605286,21.907438 
	C364.780792,21.995663 365.583405,22.003359 366.685669,22.042892 
	C368.042999,22.070662 369.099731,22.085585 370.551331,22.135811 
	C371.490875,22.599443 372.025787,23.039558 372.815674,23.714645 
	C373.509552,23.927843 373.932098,23.925737 374.671509,23.927307 
	C376.483276,24.158976 378.230988,23.626759 379.137848,25.725063 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M287.869324,18.801388 
	C287.890350,19.909800 287.479675,20.899796 286.629822,20.812065 
	C281.884155,20.322176 277.312042,22.528721 272.271667,21.369022 
	C271.610199,20.699511 271.471863,20.227764 271.800659,19.379566 
	C272.471069,19.052549 272.908081,19.033426 273.673157,19.012775 
	C275.200439,18.929434 276.455872,19.233362 277.801544,18.307922 
	C280.072083,18.081121 282.100281,18.039394 284.563599,17.999954 
	C285.913055,18.035454 286.845551,17.976665 287.869324,18.801388 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M298.575684,17.019924 
	C301.541718,18.984377 304.481598,17.532301 307.635254,18.045918 
	C307.768677,19.699259 306.616211,20.020420 305.188599,19.978571 
	C300.994049,19.855616 296.798920,19.754009 292.295044,19.365244 
	C291.612122,18.692715 291.473816,18.228691 291.807220,17.395126 
	C294.075470,17.066471 296.107391,17.037136 298.575684,17.019924 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M206.174011,36.726780 
	C201.022079,38.570129 196.596481,41.599842 191.166885,42.137661 
	C190.638763,37.821491 193.774368,37.991398 196.702042,37.614147 
	C198.968460,38.791996 199.184418,36.432034 200.668579,35.964951 
	C201.355682,35.556683 201.821503,35.449947 202.628021,35.708282 
	C203.696884,35.935955 204.459320,35.960125 205.603302,35.983528 
	C206.112473,36.148487 206.240067,36.314213 206.174011,36.726780 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M319.043884,18.448338 
	C320.772675,17.900360 322.618774,17.735931 324.730713,17.290817 
	C327.025452,17.028524 329.054291,17.046917 331.516632,17.090946 
	C332.574860,17.727407 332.711456,18.457888 332.257446,19.605293 
	C327.751740,19.469242 323.271820,21.310951 319.043884,18.448338 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M244.624054,24.049114 
	C244.567108,26.898409 241.917755,26.033192 240.295532,26.655573 
	C237.121918,27.873177 233.744644,28.559984 230.217346,29.754116 
	C229.568970,30.058939 229.154907,30.076166 228.430069,30.105862 
	C227.891479,30.207516 227.663666,30.296696 227.161987,30.141651 
	C228.559982,26.799675 232.002930,27.416653 234.610992,26.398678 
	C237.658447,25.209187 241.005295,24.786673 244.624054,24.049114 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M403.267883,33.761631 
	C402.564331,34.013256 402.127045,33.997257 401.361572,33.974545 
	C399.807861,32.591656 397.889099,32.505623 396.192169,31.320034 
	C395.495178,31.116344 395.065094,31.102604 394.312317,31.098652 
	C393.407227,31.020500 392.869202,30.822866 392.162659,30.291933 
	C391.384064,29.928816 390.839478,29.737148 390.137390,29.297464 
	C389.813660,28.532986 389.946014,28.109869 390.747192,27.824783 
	C391.533112,27.881775 391.948608,27.894024 392.675751,27.914680 
	C393.590973,27.992067 394.148132,28.184566 394.890808,28.710495 
	C397.488312,29.249842 399.837128,29.623787 402.581421,30.029476 
	C403.328339,30.422682 403.596832,30.838932 403.853821,31.673847 
	C403.894318,32.557079 403.768097,33.039623 403.267883,33.761631 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M252.459473,24.082794 
	C251.894516,24.062098 251.689865,24.028204 251.177368,23.940123 
	C252.558929,20.991625 255.392273,21.028259 258.618469,21.047226 
	C260.018921,24.339252 257.246460,23.444773 255.389679,24.026430 
	C254.267380,24.056219 253.543579,24.062906 252.459473,24.082794 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M255.225555,24.305056 
	C255.757889,22.379667 258.285034,23.681093 258.959412,21.406073 
	C259.770721,21.048752 260.513153,21.024574 261.627380,21.004234 
	C262.316498,21.408689 262.469604,21.861523 262.215820,22.676657 
	C259.986725,24.200392 257.872070,24.995281 255.225555,24.305056 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M350.269562,21.570671 
	C348.383179,21.731171 346.474915,22.751453 345.054840,20.540665 
	C344.826691,19.987047 344.694489,19.789156 344.782043,19.309940 
	C346.375549,19.044928 347.749298,19.061243 349.534180,19.106049 
	C350.572510,19.724983 350.707672,20.441605 350.269562,21.570671 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M203.098480,35.632988 
	C202.485275,35.916164 202.036087,35.920551 201.253113,35.863560 
	C200.956009,34.856201 200.992722,33.910221 201.034607,32.614716 
	C202.431732,32.175690 203.823700,32.086178 205.635376,32.039688 
	C206.047577,33.961376 204.035950,34.129318 203.098480,35.632988 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M332.388977,19.913464 
	C332.015472,19.227106 331.996246,18.522198 331.963562,17.466934 
	C333.799164,17.072273 335.669006,16.692858 337.730194,17.742657 
	C338.136200,18.515589 338.020355,18.921583 337.253174,19.170197 
	C335.516846,19.372036 334.130035,19.633474 332.388977,19.913464 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M291.622253,17.059198 
	C292.029968,17.537024 292.016388,17.978239 291.994446,18.752949 
	C290.943634,19.077974 289.901184,19.069502 288.470215,19.067350 
	C287.196350,18.892757 286.310944,18.711843 285.212158,18.266586 
	C286.834717,16.210432 289.125244,17.296612 291.622253,17.059198 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M218.500595,33.104675 
	C217.928207,33.098866 217.728180,33.059628 217.225464,32.971596 
	C218.659256,30.216005 221.766846,30.911200 224.604248,29.977097 
	C225.475281,30.703962 225.026520,31.158886 224.258148,31.806585 
	C222.295822,32.370209 220.584396,32.720726 218.500595,33.104675 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M269.933350,20.829193 
	C269.503082,23.714891 267.395020,22.803612 265.350952,22.936838 
	C264.406769,22.253191 264.282379,21.515287 264.793030,20.395176 
	C265.779327,20.059978 266.519836,20.034710 267.630798,20.012039 
	C268.641052,20.031540 269.246979,20.157560 269.933350,20.829193 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M379.362762,26.101852 
	C378.276520,24.569727 376.465759,25.364952 375.196747,24.206369 
	C377.048431,22.066422 378.804901,23.438528 380.797302,24.736713 
	C381.117676,25.213320 381.235321,25.410032 381.153809,25.887026 
	C380.530182,26.143372 380.105713,26.119438 379.362762,26.101852 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M380.963074,26.511894 
	C380.967163,25.975655 380.979614,25.784004 380.996033,25.304480 
	C381.738159,25.032867 382.476349,25.049129 383.582458,25.096523 
	C384.313354,25.465481 384.586639,25.865965 384.839722,26.685513 
	C384.867401,27.549534 384.738556,28.021605 384.261230,28.732168 
	C383.265289,28.980610 382.532013,28.968067 381.434021,28.942690 
	C381.036743,28.238731 381.004089,27.547606 380.963074,26.511894 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M350.392334,21.889038 
	C350.025696,21.201679 349.999939,20.511337 349.959717,19.477766 
	C351.363007,19.139677 352.973389,18.458401 353.960419,20.597988 
	C352.930389,21.264507 351.831787,21.575279 350.392334,21.889038 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M344.751312,18.746464 
	C344.999084,19.220827 344.996338,19.413042 344.976257,19.895098 
	C343.581360,20.140751 342.203827,20.096561 340.411865,20.051651 
	C339.672821,19.655298 339.533630,19.199381 339.761017,18.382500 
	C341.488922,18.077972 343.043091,17.711180 344.751312,18.746464 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M409.816467,33.588177 
	C409.848816,34.139103 409.658539,34.440342 409.233124,34.873703 
	C407.290161,35.395855 405.874664,34.839664 404.568359,33.324059 
	C404.528534,32.757015 404.571350,32.528603 404.849182,32.042728 
	C406.587402,32.303009 408.090607,32.820747 409.816467,33.588177 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M264.697571,20.054361 
	C265.018982,20.792507 264.999146,21.499767 264.968201,22.559509 
	C264.217804,22.937065 263.478577,22.962135 262.368744,22.983000 
	C261.998077,22.540886 261.997955,22.102980 261.998474,21.336571 
	C262.545013,20.105665 263.422424,19.996986 264.697571,20.054361 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M339.638428,18.049931 
	C339.976105,18.512459 339.985504,18.951067 339.996155,19.720303 
	C338.871094,21.258032 337.872314,21.308130 336.978516,19.418470 
	C337.184875,18.903294 337.466095,18.695992 337.870056,18.257153 
	C338.431915,18.025747 338.871063,18.025879 339.638428,18.049931 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M391.038330,27.566311 
	C390.821869,28.095448 390.526154,28.321381 390.105133,28.798380 
	C389.543488,29.036398 389.107147,29.023348 388.344482,28.980747 
	C387.627167,28.555389 387.470978,28.082096 387.761841,27.202059 
	C389.128632,25.782562 390.148865,25.719475 391.038330,27.566311 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M277.675232,18.082409 
	C277.535156,20.362955 276.097839,20.228811 274.220886,19.271694 
	C274.835724,17.776722 276.113129,18.052473 277.675232,18.082409 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M270.413300,21.085613 
	C269.519928,20.902805 268.939880,20.708765 268.180603,20.264679 
	C268.822968,18.771265 270.108459,19.055380 271.664642,19.043045 
	C272.023102,19.521852 272.012146,19.972031 271.991791,20.762436 
	C271.563812,21.093235 271.145233,21.083807 270.413300,21.085613 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M224.379456,32.023018 
	C224.266632,31.514698 224.526016,31.009703 224.887085,30.238503 
	C225.411697,29.955984 225.834610,29.939676 226.572815,29.910397 
	C227.092911,29.933828 227.297729,29.970236 227.810913,30.062489 
	C227.758072,32.098057 226.229187,32.016838 224.379456,32.023018 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M214.665131,32.999786 
	C214.798660,34.659336 214.047836,35.361668 212.203033,34.262756 
	C212.525299,33.097946 213.402084,32.989235 214.665131,32.999786 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M366.817810,21.796993 
	C366.227997,23.085697 365.337128,23.180189 364.154724,22.168396 
	C364.755737,20.938589 365.646912,20.832794 366.817810,21.796993 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M358.218079,21.818922 
	C356.852448,23.251600 355.831085,23.334032 355.010193,21.378111 
	C355.724121,21.019316 356.483032,20.976576 357.621948,20.936182 
	C358.138824,21.132532 358.275635,21.326536 358.218079,21.818922 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M395.070190,28.601021 
	C394.538605,28.736059 393.937744,28.596226 393.162140,28.189741 
	C393.885651,26.923065 394.526459,27.209030 395.070190,28.601021 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M358.358429,22.098026 
	C358.017700,21.921089 358.011688,21.724873 358.003845,21.233593 
	C358.925049,19.905018 359.549255,20.201624 360.001831,21.668758 
	C359.583557,21.996698 359.138336,22.037724 358.358429,22.098026 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M373.019226,23.616901 
	C372.184326,23.954256 371.400452,23.771513 371.013672,22.475048 
	C371.883911,22.071909 372.640839,22.292812 373.019226,23.616901 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M403.316223,32.277374 
	C403.010254,31.634773 403.000397,31.184565 402.983704,30.397789 
	C403.858887,30.045828 404.597260,30.279699 405.013611,31.489967 
	C405.084198,31.785263 405.012421,31.971684 404.976074,32.064713 
	C404.537170,32.431370 404.092712,32.526981 403.316223,32.277374 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M206.293884,36.946781 
	C205.980362,36.973618 205.990234,36.478416 205.987549,36.230591 
	C206.473801,35.688339 206.962708,35.393921 207.751984,35.127480 
	C207.918030,36.028057 207.572067,36.727329 206.293884,36.946781 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M387.659607,26.876289 
	C387.988861,27.335510 388.003632,27.798223 388.018280,28.606068 
	C387.565186,28.990248 387.112244,29.029297 386.318665,29.083925 
	C385.679962,28.858696 385.494537,28.547829 385.412598,27.897758 
	C385.491730,27.445658 385.563019,27.273268 385.862549,26.939034 
	C386.508942,26.811390 386.927032,26.845587 387.659607,26.876289 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M384.309082,27.262592 
	C384.001556,26.632050 383.989532,26.200846 383.963928,25.448650 
	C384.834595,25.068274 385.575562,25.277296 386.015991,26.483498 
	C386.090820,26.777193 386.016022,26.958910 385.977966,27.049488 
	C385.534973,27.414133 385.091949,27.530109 384.309082,27.262592 
z"/>
<path fill="#6D676B" opacity="1.000000" stroke="none" 
	d="
M102.722931,95.688210 
	C103.032127,95.482140 103.191902,95.401726 103.604607,95.231773 
	C104.060822,95.226234 104.264114,95.310219 104.732567,95.197868 
	C104.997726,95.001526 105.000221,95.000305 105.001083,94.999237 
	C105.158073,94.880753 105.314186,94.763336 105.759621,94.582382 
	C106.247276,94.491821 106.445610,94.464783 106.926247,94.324120 
	C107.548477,93.958946 107.923111,93.776016 108.650879,93.707474 
	C109.128372,93.938225 109.279480,94.107506 109.527100,94.610176 
	C107.677216,101.001442 103.374130,104.861595 97.509048,107.478165 
	C95.762085,106.004974 96.634537,104.759018 97.451698,103.575371 
	C98.270058,102.389999 99.213821,101.285080 98.835205,99.363541 
	C98.520706,97.646393 99.719963,97.189125 100.794319,96.281815 
	C101.620255,96.025543 102.096878,95.919708 102.722931,95.688210 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M98.369186,99.051544 
	C101.508690,99.048378 101.329933,100.454735 100.233582,102.155968 
	C99.289101,103.621544 97.471909,104.440048 97.060089,106.689804 
	C97.888466,109.097771 96.693649,109.574692 94.595016,109.547386 
	C93.410408,108.896385 93.111595,108.101524 92.890717,106.815735 
	C92.860847,104.915665 93.388748,103.664413 94.777580,102.371078 
	C95.152000,100.244629 95.959541,99.099579 98.369186,99.051544 
z"/>
<path fill="#959398" opacity="1.000000" stroke="none" 
	d="
M93.697151,105.766312 
	C93.973488,106.739258 93.972565,107.495094 93.987526,108.628578 
	C93.614952,110.491386 92.290718,111.397110 91.490707,113.012924 
	C90.637947,113.918251 89.832481,114.287514 88.631386,114.606140 
	C87.345436,114.683571 86.502365,114.402489 85.539413,113.533661 
	C85.293953,113.297958 85.161049,113.163795 85.094604,113.097290 
	C85.102272,112.783997 85.176384,112.537216 85.414864,111.940628 
	C85.680077,111.222198 85.873016,110.910583 86.419067,110.552170 
	C87.605675,109.126274 88.531113,107.804092 89.742233,106.297447 
	C91.158104,105.922272 92.176796,105.060677 93.697151,105.766312 
z"/>
<path fill="#AFAEB1" opacity="1.000000" stroke="none" 
	d="
M41.566509,175.997833 
	C41.934330,179.012756 40.680748,181.595596 38.367752,183.953918 
	C39.041309,181.350845 38.313892,177.982300 41.566509,175.997833 
z"/>
<path fill="#A7A6AB" opacity="1.000000" stroke="none" 
	d="
M94.033127,105.646957 
	C92.788071,106.178772 91.601730,106.374138 90.221642,106.341240 
	C90.977821,104.218971 92.253952,102.673714 94.729988,102.062187 
	C94.748917,103.159882 94.420380,104.235191 94.033127,105.646957 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M45.518009,168.003296 
	C46.108780,169.386520 45.265717,170.490829 44.279911,171.820328 
	C44.133564,170.621002 43.483631,169.006500 45.518009,168.003296 
z"/>
<path fill="#A7A6AB" opacity="1.000000" stroke="none" 
	d="
M81.868866,115.130249 
	C82.550758,115.197792 83.290062,115.418236 83.281235,115.602951 
	C83.234680,116.577759 82.409203,116.791306 81.315262,116.985092 
	C81.205940,116.428429 81.393517,115.847549 81.868866,115.130249 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M86.475723,110.423340 
	C86.395546,110.773293 86.110870,111.098137 85.702713,111.506897 
	C85.298180,110.896370 85.678909,110.585922 86.475723,110.423340 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M66.695389,135.066620 
	C66.896439,135.300812 66.749557,135.587860 66.223831,135.894897 
	C66.078926,135.673981 66.246414,135.408844 66.695389,135.066620 
z"/>
<path fill="#AFAEB1" opacity="1.000000" stroke="none" 
	d="
M28.635235,204.961761 
	C28.843346,206.349503 29.565712,208.007095 27.377338,208.940125 
	C27.014471,207.951035 27.007059,206.886520 27.013042,205.424011 
	C27.455383,205.007278 27.884333,204.988541 28.635235,204.961761 
z"/>
<path fill="#B5B5B5" opacity="1.000000" stroke="none" 
	d="
M24.682316,215.090240 
	C24.795019,216.150284 24.543982,217.255417 24.158133,218.679245 
	C23.852863,219.124969 23.682404,219.252014 23.255716,219.189224 
	C23.198799,217.629303 22.405499,215.920364 24.682316,215.090240 
z"/>
<path fill="#AFAEB1" opacity="1.000000" stroke="none" 
	d="
M22.983479,219.336975 
	C23.170053,219.000015 23.340616,219.000626 23.767252,218.999603 
	C25.046848,219.900360 24.813709,220.535934 23.319340,220.994537 
	C23.011114,220.574570 22.989292,220.124573 22.983479,219.336975 
z"/>
<path fill="#AFAEB1" opacity="1.000000" stroke="none" 
	d="
M32.479061,197.926147 
	C33.060989,199.099655 32.602737,200.043610 31.180691,200.788101 
	C30.960846,199.773453 30.819668,198.558212 32.479061,197.926147 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M145.186157,68.774948 
	C144.980591,68.968605 144.496719,69.000801 144.254318,69.005943 
	C143.570541,69.386597 143.062866,69.533272 142.123322,69.260574 
	C141.281204,68.319931 141.224045,67.533302 141.805862,66.392036 
	C142.066238,66.071457 142.520935,66.024261 142.748016,65.998268 
	C146.184296,63.850384 148.943146,61.065399 152.777786,59.262463 
	C153.033096,59.036366 153.126312,58.598591 153.168915,58.378891 
	C154.775360,57.052006 156.846970,57.479034 158.701263,56.202843 
	C158.971848,55.973831 159.000854,55.991287 158.987946,55.977310 
	C159.376572,55.632668 159.837509,55.513401 160.676453,55.760059 
	C162.359039,58.573818 159.914536,58.691891 158.324066,59.802200 
	C158.038452,60.040981 158.002365,60.010567 158.020920,60.029648 
	C157.462967,60.531265 156.930771,61.061394 156.186600,61.777119 
	C155.982224,61.970879 155.514191,62.012379 155.279755,62.027725 
	C154.478119,62.537022 153.932678,63.054516 153.179932,63.763092 
	C152.970245,63.951614 152.503143,63.999249 152.268982,64.016022 
	C151.480545,64.537865 150.932526,65.049660 150.171509,65.744812 
	C149.196411,66.273964 148.436783,66.622414 147.364670,67.010483 
	C146.476532,67.536446 145.932922,68.057556 145.186157,68.774948 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M152.666382,59.055573 
	C150.620453,62.283455 147.356430,64.378326 143.335281,65.954124 
	C145.070343,62.303738 148.258148,60.112221 152.666382,59.055573 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M125.294205,81.274910 
	C125.576988,80.169518 126.156227,79.341904 126.835320,78.225082 
	C127.256599,77.831345 127.518204,77.643501 127.837036,77.157631 
	C128.387070,76.594292 128.876373,76.476135 129.766632,76.780472 
	C130.658646,77.629585 130.821747,78.390808 130.632324,79.609352 
	C130.105453,80.733788 129.490768,81.249741 128.360703,81.754105 
	C127.144936,82.014885 126.349571,81.916260 125.294205,81.274910 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M137.802109,69.351181 
	C138.051575,69.054375 138.502151,69.001534 138.727051,68.972015 
	C139.346970,68.622047 139.801987,68.466591 140.662827,68.567474 
	C141.499939,69.293533 141.810577,69.964996 141.707092,71.136749 
	C141.495193,71.734383 141.362717,71.955666 140.899902,72.381378 
	C139.789734,72.819580 139.033554,72.761208 138.012360,72.140038 
	C137.302307,71.162399 137.245636,70.419090 137.802109,69.351181 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M158.591965,55.980488 
	C158.005966,58.361095 155.864990,57.972977 153.577423,58.131050 
	C153.173416,57.980843 153.135330,57.802502 153.085846,57.351814 
	C154.787003,56.715363 156.499542,56.351254 158.591965,55.980488 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M137.711487,69.062805 
	C138.022751,69.776062 137.993912,70.497749 137.705017,71.836922 
	C136.993256,72.641731 136.522888,72.709091 135.460876,72.274994 
	C135.095367,70.392899 135.806152,69.353401 137.711487,69.062805 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M130.593964,76.792633 
	C129.564819,77.020897 129.104675,77.006119 128.299316,76.967125 
	C128.123230,74.970444 129.279037,74.058067 131.717346,74.166046 
	C132.283279,75.307053 131.793121,75.963791 130.593964,76.792633 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M141.256897,69.195328 
	C140.550720,69.003922 140.093979,68.996819 139.294601,68.966110 
	C139.074310,67.408615 139.792236,66.379242 141.720551,66.076912 
	C142.039795,66.800598 142.013367,67.529739 141.988159,68.624672 
	C141.828369,69.120178 141.667358,69.249893 141.256897,69.195328 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M131.917389,73.918297 
	C132.094177,72.560287 132.912857,71.965477 134.548920,71.911850 
	C134.885239,71.876160 134.949249,71.946510 134.981140,71.981796 
	C135.269379,72.399200 135.309555,72.808304 134.999695,73.523819 
	C134.675995,73.959717 134.518372,74.112183 134.064392,74.407455 
	C133.331497,74.628075 132.901596,74.605270 132.244202,74.238770 
	C132.008987,74.012054 131.948441,73.949036 131.917389,73.918297 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M196.993896,37.456139 
	C194.956100,38.698273 192.530624,39.094486 191.034882,41.533131 
	C190.569458,41.937878 190.152039,42.012993 189.422775,42.150299 
	C188.686447,42.488735 188.234238,42.707901 187.376770,42.911736 
	C186.485077,42.921898 186.000504,42.786537 185.275757,42.278351 
	C187.406891,38.698727 193.622833,36.151428 196.993896,37.456139 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M184.688629,42.151497 
	C185.462631,42.025841 185.918808,42.041874 186.716385,42.083706 
	C188.179230,45.451275 184.614624,44.936424 183.218445,46.663452 
	C182.515289,46.925610 182.090988,46.960018 181.347885,47.011398 
	C180.582916,47.393559 180.074066,47.537189 179.136047,47.272217 
	C178.290970,46.336636 178.240417,45.551979 178.841965,44.429565 
	C180.869507,43.514011 182.620163,42.903599 184.688629,42.151497 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M178.819077,44.068619 
	C179.063339,44.819427 179.007812,45.514431 178.932907,46.559227 
	C178.668625,47.288715 178.331802,47.557064 177.593170,47.803719 
	C176.823364,47.899303 176.384827,47.851814 175.445374,47.339584 
	C174.973267,46.240551 175.008163,45.545761 175.067642,44.508293 
	C175.798737,44.096230 176.505234,44.026840 177.565231,43.931904 
	C178.118896,43.941845 178.319092,43.977329 178.819077,44.068619 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M161.652786,55.889893 
	C160.571136,56.027805 160.115219,56.013199 159.317169,55.980965 
	C160.868683,52.134003 164.541092,51.054077 168.593079,49.977188 
	C169.404724,50.624599 169.266708,51.291676 168.851715,52.267723 
	C168.269318,53.141617 167.720627,53.541306 166.767578,53.938789 
	C164.966171,54.375481 163.589432,54.974709 161.652786,55.889893 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M168.366516,52.269184 
	C168.276901,51.513111 168.528809,51.009453 168.873901,50.238720 
	C169.439835,49.657955 169.912613,49.344261 170.676926,48.990822 
	C171.447037,48.588314 171.972580,48.498386 172.866684,48.952862 
	C173.318359,52.531693 171.023041,52.540028 168.366516,52.269184 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M173.690277,48.899117 
	C172.579926,49.049355 172.119537,49.026047 171.313812,48.976906 
	C171.185150,46.883217 172.750397,47.016254 174.571503,46.951744 
	C174.938370,46.935341 174.979675,46.980217 174.999161,47.003666 
	C175.353897,47.817493 174.899887,48.292629 173.690277,48.899117 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M116.750580,88.309486 
	C117.504349,87.436409 117.990768,86.845253 118.740944,86.128204 
	C119.639816,85.494110 120.364655,85.285530 121.534927,85.497238 
	C123.486313,87.584991 121.872917,89.016968 120.878082,90.904953 
	C120.114861,91.826347 119.474350,92.278900 118.354187,92.695038 
	C117.436623,92.830551 116.918762,92.758804 116.093506,92.350204 
	C115.011223,90.745941 115.526543,89.624168 116.750580,88.309486 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M116.671341,88.015701 
	C116.693481,89.112282 116.369026,90.196999 116.010666,91.623260 
	C115.467377,93.126579 114.436142,93.739876 113.102898,94.532150 
	C112.049988,94.884651 111.329971,94.880569 110.293198,94.478867 
	C109.216385,91.335625 111.663292,90.635429 113.665253,89.182701 
	C114.247398,88.816452 114.509262,88.626602 114.827553,88.141983 
	C115.400688,87.949692 115.862717,87.976761 116.671341,88.015701 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M124.779800,81.110771 
	C125.757851,81.002594 126.517967,81.008049 127.657967,81.024353 
	C129.062378,82.305428 128.452240,83.473343 127.551552,84.938812 
	C127.059418,85.369171 126.827972,85.500092 126.205711,85.717575 
	C125.271523,85.820564 124.751587,85.717903 123.949615,85.235535 
	C123.248459,84.221214 123.212776,83.450981 123.776894,82.347122 
	C124.116280,81.704857 124.296532,81.436096 124.779800,81.110771 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M123.668518,82.027298 
	C124.007393,82.762932 123.993668,83.495171 123.977364,84.594040 
	C123.792572,85.656944 123.318932,86.054924 122.342834,86.142990 
	C121.277107,86.025871 120.519562,86.019821 119.383354,86.008034 
	C120.236275,84.453476 120.746384,82.122826 123.668518,82.027298 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M113.573532,88.946030 
	C112.708710,90.424347 111.486542,91.917793 110.136429,93.708221 
	C109.865669,94.123177 109.722862,94.241158 109.336792,94.224846 
	C108.898880,94.075539 108.704208,94.060516 107.725571,93.991905 
	C107.140625,93.108360 107.339638,92.278397 107.800095,91.256073 
	C110.076103,91.089424 111.130096,88.760147 113.573532,88.946030 
z"/>
<path fill="#959398" opacity="1.000000" stroke="none" 
	d="
M104.709824,95.013557 
	C104.848282,95.430847 104.637093,95.740463 103.988205,95.298569 
	C104.045662,95.103355 104.233788,95.064476 104.709824,95.013557 
z"/>
<path fill="#959398" opacity="1.000000" stroke="none" 
	d="
M106.274246,94.739883 
	C105.884682,95.038315 105.707787,95.039612 105.266418,95.019531 
	C105.074829,94.668274 105.243996,94.398842 105.723320,94.075546 
	C106.120430,94.121719 106.303673,94.282227 106.274246,94.739883 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M106.309525,95.020241 
	C106.041199,94.857849 106.020828,94.678665 105.968811,94.230347 
	C106.104790,93.955948 106.272392,93.950684 106.690796,93.941879 
	C106.941605,93.938324 106.971474,93.970322 106.986404,93.985809 
	C107.114799,94.153816 107.228264,94.306328 107.196663,94.704330 
	C107.051590,94.949814 106.557465,95.003456 106.309525,95.020241 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M23.559669,357.003479 
	C25.735209,357.194092 25.926907,358.407837 26.007086,359.864288 
	C26.913462,376.328735 31.086878,392.130859 36.412125,407.593109 
	C46.489174,436.852692 61.380474,463.621185 79.950752,488.304108 
	C90.797081,502.720612 103.289452,515.820374 115.337868,529.187317 
	C121.593796,536.127869 130.043732,541.501221 137.261719,547.793823 
	C150.998962,559.769836 166.548874,568.853394 182.036530,578.128845 
	C182.419510,578.358215 182.614716,578.901062 182.954681,579.640015 
	C173.542953,576.951416 165.940048,570.533081 157.367538,565.877380 
	C140.138443,556.520264 126.931221,542.049255 111.855324,529.972839 
	C106.146835,525.400146 102.209435,518.679871 97.099319,513.284546 
	C83.378487,498.798065 72.225830,482.398987 61.524071,465.696686 
	C56.460411,457.793854 52.276527,449.327271 47.344437,441.060944 
	C46.492641,439.806549 45.990456,438.607330 45.233566,437.211090 
	C37.175117,420.802185 31.021223,403.986694 26.287315,386.259827 
	C26.051558,385.519897 26.049477,385.086243 26.049057,384.327332 
	C25.993761,383.124634 26.029114,382.226501 25.269016,381.204346 
	C25.048313,380.212067 25.039154,379.474640 25.028893,378.368530 
	C23.287764,371.998474 23.242241,365.724091 22.087759,359.626587 
	C21.902348,358.647339 22.247286,357.662018 23.559669,357.003479 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M185.022308,580.383057 
	C196.250183,584.514954 207.804474,588.345154 218.648621,593.863403 
	C221.979568,595.558472 226.065552,595.435913 228.945343,598.626221 
	C214.558609,594.755859 200.776535,588.778015 186.968796,582.865845 
	C185.986877,582.445312 185.320404,581.790710 185.022308,580.383057 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M207.167297,596.369934 
	C206.402557,595.572388 205.859482,595.028870 205.163635,594.233154 
	C209.685638,594.847656 214.728714,594.784119 218.040314,599.499756 
	C213.598190,601.754944 210.721237,598.440186 207.167297,596.369934 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M287.224396,615.113281 
	C286.989655,614.801208 286.993561,614.621155 287.005768,614.169800 
	C288.075806,613.920654 289.137573,613.942749 290.597778,613.955933 
	C290.964813,615.358276 290.227600,616.040710 288.490814,616.067688 
	C287.920929,615.810059 287.692017,615.527649 287.224396,615.113281 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M357.002197,612.663574 
	C356.525391,613.301147 356.046082,613.617676 355.263000,613.936096 
	C354.979675,613.219971 355.000183,612.501892 355.031921,611.425720 
	C355.477814,611.057251 355.912537,611.046875 356.673615,611.047974 
	C356.999908,611.487122 356.999817,611.914795 357.002197,612.663574 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M26.034336,386.372253 
	C27.136032,386.141846 27.712250,386.702576 27.991169,387.852234 
	C31.498022,402.307343 36.851753,416.108978 42.823383,429.696106 
	C43.743313,431.789215 44.274544,434.053192 44.982201,436.626099 
	C39.899696,433.993011 39.561264,428.170135 37.549732,423.540039 
	C33.941212,415.233978 31.426542,406.452911 28.451225,397.871521 
	C27.203625,394.273224 26.451290,390.567108 26.034336,386.372253 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M23.980412,356.670654 
	C21.658026,360.998749 24.645884,364.876892 24.290785,368.900269 
	C24.042675,371.711456 25.069702,374.635132 25.277489,377.754211 
	C21.607944,376.282501 23.213667,372.923492 22.743999,370.367554 
	C20.773085,359.641693 19.023674,348.865326 19.014191,337.446106 
	C22.720720,335.941925 21.501986,339.096863 22.235435,341.065948 
	C22.225370,345.806274 23.292246,350.015472 23.802160,354.658386 
	C23.981167,355.457977 23.981243,355.898956 23.980412,356.670654 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M21.401310,342.214478 
	C20.654610,340.373627 21.856489,338.331757 19.387907,337.067444 
	C19.019526,336.240204 19.016079,335.492462 19.017368,334.370728 
	C19.091185,329.640076 18.777988,325.277802 19.415150,320.533386 
	C20.066580,319.710022 20.602369,319.526459 21.614855,319.793823 
	C22.008381,322.696014 22.009527,325.392853 22.011906,328.538940 
	C22.819090,329.989227 23.067478,331.074860 22.267466,332.650269 
	C22.394056,335.069550 23.335676,337.030334 23.003719,339.594971 
	C23.857025,341.434967 23.283367,342.157715 21.401310,342.214478 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M20.309025,319.602783 
	C19.875090,324.460510 19.736835,328.932007 19.310345,333.700134 
	C16.881334,329.590179 18.396875,324.910858 18.051912,320.369995 
	C17.813749,317.234985 18.017021,314.066467 18.046196,310.441223 
	C18.501019,309.977570 18.932667,309.985626 19.688797,309.995483 
	C22.228069,312.940948 21.777452,316.055573 20.309025,319.602783 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M25.037674,381.295654 
	C26.654963,381.211853 27.359682,381.973724 26.293066,383.796570 
	C25.106556,383.477844 24.997061,382.588348 25.037674,381.295654 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M26.668411,258.000732 
	C29.293522,260.884674 27.658249,263.753357 26.673651,266.404663 
	C24.380531,272.579498 25.854664,279.201691 24.097227,285.410370 
	C23.830709,286.351898 23.915266,287.418610 22.396839,287.938751 
	C21.181870,287.459503 20.953659,286.602875 20.931608,285.324371 
	C20.969809,284.238770 20.976063,283.491882 20.988686,282.371521 
	C23.387369,281.601013 23.247791,280.138885 22.228199,278.200562 
	C21.971832,276.596924 21.987097,275.213593 22.005539,273.414612 
	C22.321344,272.521881 22.633968,272.044861 22.947271,271.265564 
	C25.709930,268.305237 21.766027,264.267548 24.927843,261.339600 
	C24.844971,260.834503 24.692593,260.667206 24.769150,260.249268 
	C24.992296,259.553375 24.986507,259.108124 24.985138,258.328827 
	C25.437271,257.997009 25.884983,257.999268 26.668411,258.000732 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M34.399193,220.938202 
	C34.514530,219.489136 34.993393,217.959427 35.739075,216.218597 
	C35.683723,217.647827 36.845509,219.668503 34.399193,220.938202 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M30.347010,233.967041 
	C30.069702,233.107422 30.305395,232.327179 31.636980,232.007874 
	C31.932257,232.872894 31.710131,233.663513 30.347010,233.967041 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M28.323145,240.982330 
	C28.194874,240.459839 28.353962,239.899597 28.758263,239.169159 
	C30.081285,239.891632 29.835701,240.517029 28.323145,240.982330 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M32.337769,226.987976 
	C32.211826,226.464157 32.370567,225.900635 32.779266,225.169464 
	C34.080017,225.898575 33.827946,226.523056 32.337769,226.987976 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M72.024429,149.023834 
	C70.498802,153.273331 68.965446,157.514008 64.436630,160.036926 
	C65.897125,156.856506 66.724823,153.107880 69.696655,150.187256 
	C70.400032,149.508759 70.749741,148.945862 71.697556,148.862488 
	C71.992523,148.994293 72.013519,149.012924 72.024429,149.023834 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M63.562428,162.971039 
	C63.830452,164.623886 63.404594,166.138947 61.302292,166.930725 
	C60.912582,165.194595 61.175034,163.602173 63.562428,162.971039 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M71.994812,148.657471 
	C71.495033,149.257477 70.997536,149.520676 70.235031,149.881699 
	C69.982841,149.238541 69.995682,148.497528 70.014458,147.386169 
	C70.589256,146.881134 71.158112,146.746460 71.862686,146.791992 
	C71.997971,147.421692 71.997536,147.871170 71.994812,148.657471 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M57.677505,172.113037 
	C57.955166,173.128510 58.204193,174.399612 56.338425,174.944733 
	C55.966122,173.829803 56.418045,172.909958 57.677505,172.113037 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M58.946419,168.264893 
	C60.263454,169.159607 60.352699,170.178589 58.338768,170.969208 
	C58.271774,170.191910 58.527145,169.371582 58.946419,168.264893 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M20.345528,319.992645 
	C20.010975,316.961334 20.008608,313.933685 20.009758,310.451660 
	C21.046083,309.282928 21.188604,308.403778 20.252886,307.186096 
	C19.871538,305.182129 19.736612,303.362823 19.329292,301.277100 
	C19.062088,298.977234 19.067282,296.943787 19.095047,294.476013 
	C20.052601,293.172424 21.104824,292.984436 22.630753,293.742432 
	C22.768690,302.458282 23.514734,310.944427 22.299992,319.702026 
	C21.564060,319.998199 21.120886,319.997253 20.345528,319.992645 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M22.943279,293.610046 
	C21.950684,293.998322 20.917610,294.009705 19.501080,294.031433 
	C19.427109,291.079865 17.898352,287.892914 20.583439,285.080566 
	C21.891731,285.511627 21.991512,286.403870 22.014200,287.678802 
	C21.827480,289.841797 22.262625,291.554718 22.943279,293.610046 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M24.748619,259.998932 
	C24.998686,260.165558 24.999289,260.332458 24.998619,260.750549 
	C24.997351,261.001801 24.498676,261.000854 24.249506,261.000641 
	C24.000166,260.833710 23.999998,260.666962 24.000027,260.249969 
	C24.000225,259.999725 24.499155,259.999237 24.748619,259.998932 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M109.034607,94.433182 
	C109.093544,94.090553 109.549873,94.036667 109.779175,94.020935 
	C110.764488,94.007019 111.520500,94.008835 112.654541,94.019699 
	C114.413902,96.537292 112.234367,97.589951 110.975349,98.989517 
	C105.862305,104.673363 99.767952,109.410843 94.964569,115.825676 
	C94.231415,117.532738 93.107635,118.362907 91.427643,119.029541 
	C89.622887,120.053856 88.166794,121.011719 86.381172,122.005997 
	C86.022446,121.556602 85.993240,121.070793 85.906151,120.222626 
	C85.903580,119.453094 85.958893,119.045929 86.039261,118.330765 
	C86.354568,117.396523 86.860825,116.969559 87.670151,116.385117 
	C89.049614,115.512024 90.053947,114.711082 90.886154,113.303001 
	C90.866394,111.160217 91.897453,110.087799 93.708191,109.171402 
	C95.165268,109.022308 96.362526,109.117294 96.961594,107.377762 
	C102.301041,104.204460 106.244492,100.080055 109.034607,94.433182 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M91.067917,119.500748 
	C91.484352,117.771507 92.708969,117.287148 93.875534,116.304398 
	C94.480499,115.641777 94.982025,115.469154 95.919479,115.760773 
	C98.999458,116.779160 98.039131,118.334908 96.825073,119.571800 
	C95.253944,121.172470 94.020370,123.231689 91.324455,123.957016 
	C91.001762,122.620766 91.029305,121.263138 91.067917,119.500748 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M78.344666,126.012154 
	C78.062805,125.093399 78.320732,124.319298 79.666702,124.027176 
	C79.988693,124.427116 79.990990,124.871239 79.986801,125.647873 
	C79.544189,125.990677 79.108063,126.000977 78.344666,126.012154 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M71.217484,135.875397 
	C71.026756,134.835815 70.843102,133.582382 72.632111,133.033600 
	C72.979485,133.422394 72.987556,133.870514 72.991409,134.654419 
	C72.486908,135.254791 71.986633,135.519379 71.217484,135.875397 
z"/>
<path fill="#7B797D" opacity="1.000000" stroke="none" 
	d="
M88.265457,116.704544 
	C87.580307,117.373573 87.115631,117.693733 86.357643,118.018326 
	C84.510437,116.967529 85.179344,115.404572 85.219948,113.649994 
	C86.027260,113.474953 86.760559,113.651955 87.767403,113.947174 
	C88.666649,114.736076 88.746117,115.512886 88.265457,116.704544 
z"/>
<path fill="#201B1D" opacity="1.000000" stroke="none" 
	d="
M406.194031,598.749634 
	C405.994232,599.440552 405.982666,599.871277 405.959167,600.623962 
	C404.161591,601.575439 402.024689,599.685913 400.139404,601.836426 
	C399.584259,598.883667 399.743378,598.765808 405.594604,597.985840 
	C406.120789,598.150574 406.251526,598.320007 406.194031,598.749634 
z"/>
<path fill="#201B1D" opacity="1.000000" stroke="none" 
	d="
M396.398315,602.297241 
	C395.000488,602.408508 393.850861,602.670959 392.342773,602.955811 
	C393.039886,600.667664 394.518585,599.629456 396.958008,601.665283 
	C396.885315,602.143250 396.765930,602.295837 396.398315,602.297241 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M406.371368,599.009460 
	C406.003510,598.838379 406.001251,598.666992 405.994507,598.238342 
	C407.072876,596.394714 408.222076,597.877502 409.659058,597.936707 
	C409.191528,599.224609 407.912384,598.955994 406.371368,599.009460 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M396.313049,602.361694 
	C396.150116,602.146057 396.576477,602.063599 396.790588,602.027100 
	C397.323151,602.103577 397.590790,602.289551 397.927032,602.764771 
	C397.522949,602.846375 396.999451,602.711853 396.313049,602.361694 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M389.720886,604.059326 
	C389.955444,604.057373 389.660309,604.428101 389.660309,604.428101 
	C389.660309,604.428101 389.227264,604.384094 389.125061,604.259155 
	C389.022858,604.134277 389.486298,604.061340 389.720886,604.059326 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M422.348785,591.944702 
	C422.181732,589.892334 423.450378,588.749878 425.304840,588.044434 
	C441.437225,581.907410 456.572418,573.714355 471.484497,565.149780 
	C483.144989,558.452698 493.332306,549.643005 503.489471,540.909973 
	C511.654816,533.889404 519.960999,526.903076 527.240356,519.012024 
	C538.105469,507.233887 547.782898,494.441650 557.041626,481.299622 
	C565.587708,469.169037 573.026672,456.492432 579.374634,443.148071 
	C584.412598,432.557617 589.125977,421.812134 592.942078,410.701996 
	C593.424072,409.298767 593.677795,407.764923 595.647034,407.056702 
	C595.854675,412.625305 593.665466,417.805786 591.434326,422.692535 
	C586.755920,432.939606 582.240417,443.260803 577.089355,453.323608 
	C567.323303,472.401672 554.460693,489.217926 541.560486,506.114960 
	C538.146484,510.586731 534.250793,514.656128 531.029175,519.638428 
	C530.660461,520.454651 530.330566,520.928406 529.973511,521.703491 
	C524.032776,524.649109 520.389587,530.055847 515.672363,534.108948 
	C502.972137,545.021057 490.385651,556.221863 476.131714,564.876648 
	C462.784149,572.981140 449.362061,581.294922 434.525482,586.752869 
	C430.499603,588.233887 426.646301,590.184204 422.348785,591.944702 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M511.793457,542.118042 
	C511.848083,542.982788 511.574982,543.838440 510.970398,544.822876 
	C509.704559,543.652161 509.759766,542.640503 511.793457,542.118042 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M435.102844,590.731445 
	C434.539886,590.985596 434.090820,590.985901 433.304504,590.972351 
	C433.088959,589.520935 433.950653,588.972534 435.655640,589.013245 
	C435.744141,589.500671 435.480408,589.989136 435.102844,590.731445 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M399.525513,604.531555 
	C399.481110,604.555115 399.569946,604.507996 399.525513,604.531555 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M598.243347,399.262512 
	C596.326965,395.608612 598.446899,392.560364 599.131531,389.507843 
	C600.218689,384.660461 600.023682,379.373322 603.613525,375.049561 
	C605.237244,376.423462 603.576416,377.889038 604.000244,379.671448 
	C603.998474,380.443359 603.997009,380.886688 603.989258,381.662537 
	C603.555725,382.395172 603.197205,382.840515 603.021729,383.710388 
	C602.994568,386.048065 602.991638,388.097290 603.010620,390.586670 
	C603.032593,391.026825 602.980652,391.005280 602.958801,390.987610 
	C602.485352,391.610199 601.715759,391.885345 601.111328,392.736450 
	C601.385376,395.151123 602.589355,397.483276 599.359375,398.958374 
	C598.850464,399.188782 598.673462,399.360596 598.243347,399.262512 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M607.295044,354.221832 
	C605.563110,351.662018 605.131104,349.359009 607.614624,347.067078 
	C608.155640,347.539398 608.328369,348.096527 608.743896,348.824158 
	C608.984863,350.381744 608.983093,351.768890 608.971558,353.571899 
	C608.586365,354.372833 608.132996,354.523987 607.295044,354.221832 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M604.293518,372.222168 
	C602.010010,368.994415 603.232117,366.497894 605.601196,364.057861 
	C606.130371,363.858765 606.304138,363.729858 606.733643,363.800659 
	C606.988586,364.443298 606.987732,364.886169 606.979492,365.661133 
	C605.872192,366.901184 606.006409,368.164246 605.996887,369.692566 
	C605.994019,370.441833 605.990540,370.884277 605.977905,371.658386 
	C605.590149,372.373993 605.134460,372.524475 604.293518,372.222168 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M603.986938,372.374512 
	C604.426453,372.000122 604.867554,371.997467 605.638672,371.992462 
	C606.247986,374.637238 605.141113,377.022766 604.275269,379.752869 
	C602.099243,378.591461 603.759155,377.120300 603.949951,375.324890 
	C603.980164,374.231628 603.984314,373.488922 603.986938,372.374512 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M606.268433,369.765961 
	C604.686768,368.595123 604.393677,367.269653 606.635254,366.053772 
	C606.827881,367.172974 606.683655,368.352722 606.268433,369.765961 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M607.261169,363.766785 
	C606.817444,363.999847 606.645447,363.999298 606.214966,363.993225 
	C605.967896,362.924469 605.979248,361.861267 605.991516,360.399048 
	C606.391602,359.678131 606.847046,359.532990 607.664429,359.777466 
	C607.824341,361.171204 607.678650,362.352142 607.261169,363.766785 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M607.981201,359.616699 
	C607.530762,359.992889 607.091492,359.995575 606.322327,359.999146 
	C604.308838,358.654449 606.030945,358.220459 606.825439,357.252869 
	C607.156128,356.878967 607.324463,356.746948 607.749390,356.807617 
	C608.001465,357.747925 607.996948,358.495544 607.981201,359.616699 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M608.265503,356.791199 
	C607.836304,357.001556 607.666626,357.002838 607.242371,357.007568 
	C606.988831,356.258728 606.989929,355.506470 606.989746,354.378326 
	C607.427368,353.999634 607.866272,353.996796 608.633484,353.990875 
	C608.816284,354.852539 608.670715,355.717346 608.265503,356.791199 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M603.242920,383.831055 
	C601.913879,383.096771 602.168762,382.475922 603.693848,382.028107 
	C603.818115,382.551117 603.653198,383.107208 603.242920,383.831055 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M597.982910,399.375244 
	C598.162964,398.995789 598.335754,398.998901 598.768066,399.009521 
	C599.037598,400.480408 598.852417,401.973572 599.828735,403.645935 
	C599.728455,404.786316 599.481079,405.592957 599.094604,406.688995 
	C598.220459,406.988129 597.485474,406.997864 596.382812,407.009949 
	C595.146790,404.182892 597.825745,402.312103 597.982910,399.375244 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M601.266235,392.988708 
	C599.448792,391.059448 601.136047,391.194275 602.616455,390.980652 
	C602.941040,391.150818 602.945190,391.331665 602.918030,391.782104 
	C602.762634,392.213837 602.638489,392.376007 602.278076,392.733398 
	C601.869629,392.943756 601.697388,392.958893 601.266235,392.988708 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M602.271423,392.939362 
	C602.130310,392.652374 602.289490,392.425995 602.703125,392.150513 
	C602.886780,392.051666 602.949890,392.505005 602.955200,392.733337 
	C602.960449,392.961670 602.500977,392.950134 602.271423,392.939362 
z"/>
<path fill="#443D3F" opacity="1.000000" stroke="none" 
	d="
M532.751953,520.984375 
	C532.820068,521.334534 532.651917,521.708740 532.092773,521.148193 
	C532.010071,520.975525 532.504639,520.981140 532.751953,520.984375 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M580.987915,188.633698 
	C580.122375,188.915466 579.387207,188.624313 578.955566,187.792740 
	C575.310486,180.770599 571.659668,173.751450 568.016479,166.354553 
	C569.051086,166.043930 570.089722,166.319458 570.525818,167.279999 
	C573.758667,174.400635 578.426208,180.804688 580.987915,188.633698 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M559.924194,150.699158 
	C557.664551,151.100159 556.013550,150.401428 556.018433,147.354980 
	C557.981567,147.342743 558.965820,148.820404 559.924194,150.699158 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M537.839233,121.729362 
	C536.450989,121.631004 533.628235,123.026825 534.689331,119.240021 
	C536.618713,118.949623 537.094788,120.274109 537.839233,121.729362 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M495.865173,81.781784 
	C494.845978,81.798561 493.738159,81.546570 492.313324,81.152863 
	C491.872314,80.833977 491.748260,80.656807 491.822632,80.222961 
	C492.763000,79.979393 493.504913,79.992508 494.617554,80.010452 
	C495.250977,80.514526 495.513733,81.013763 495.865173,81.781784 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M554.945007,143.697266 
	C553.963806,143.769272 552.224609,144.604126 552.767700,142.191406 
	C553.922668,142.064621 554.702026,142.325348 554.945007,143.697266 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M562.916748,154.697144 
	C561.820068,154.964279 560.545044,155.178787 560.073181,153.317719 
	C561.171753,153.045212 562.450867,152.822021 562.916748,154.697144 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M502.956360,88.705414 
	C501.013306,90.531006 501.188202,88.823441 500.978088,87.357430 
	C501.909241,87.066643 502.691467,87.322540 502.956360,88.705414 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M530.884033,114.761719 
	C528.993469,116.524933 529.191345,114.805077 528.990479,113.337265 
	C529.582825,113.503189 530.177673,113.995003 530.884033,114.761719 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M517.876221,101.737595 
	C516.973511,101.765976 515.253296,102.605255 515.737610,100.202301 
	C516.564453,100.491241 517.163452,100.977982 517.876221,101.737595 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M533.962036,117.711472 
	C533.059998,117.848038 531.954224,117.850586 532.686768,116.190414 
	C533.248230,116.473244 533.599060,116.938232 533.962036,117.711472 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M546.982605,134.657196 
	C546.092529,134.931168 545.303162,134.682877 545.068726,133.284836 
	C545.940674,133.055099 546.715271,133.319916 546.982605,134.657196 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M550.893555,138.790741 
	C550.648743,139.571381 550.169678,139.970734 549.584961,139.470444 
	C549.387085,139.301071 549.549316,138.710754 549.763428,138.157471 
	C550.249634,138.189255 550.519409,138.376343 550.893555,138.790741 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M567.946838,164.695862 
	C567.064514,164.932495 566.285156,164.666779 566.056885,163.294373 
	C566.936096,163.065048 567.710571,163.337250 567.946838,164.695862 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M492.013672,79.604828 
	C492.015778,80.140366 492.010468,80.314438 492.000763,80.749832 
	C490.576385,80.936203 489.971588,80.132530 489.988892,78.424583 
	C490.436157,77.751251 490.886993,77.422897 491.629150,77.088066 
	C491.949097,77.802185 491.977692,78.522781 492.013672,79.604828 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M487.981689,77.652855 
	C487.104340,77.937813 486.320435,77.696198 486.034058,76.332886 
	C486.903809,76.062088 487.693481,76.294487 487.981689,77.652855 
z"/>
<path fill="#02ECFE" opacity="1.000000" stroke="none" 
	d="
M503.201904,531.096313 
	C495.618500,538.725403 487.313202,545.047729 478.403015,551.129272 
	C475.792694,543.784729 472.265717,536.666260 472.435944,528.312256 
	C473.405670,526.585022 475.153381,526.653076 476.344147,525.714661 
	C474.378693,523.991577 472.470673,522.393066 469.623688,523.265747 
	C468.660767,523.560974 467.568176,523.752991 466.894684,522.762939 
	C466.094208,521.586182 466.589142,520.238586 467.543030,519.662659 
	C471.136322,517.493164 469.366577,514.469299 469.133789,511.307190 
	C470.072540,508.785980 472.007660,507.719513 474.131195,506.365112 
	C476.408234,505.645233 478.436859,505.164581 478.929810,502.347900 
	C479.320435,501.188416 479.808685,500.480316 480.734558,499.720795 
	C481.335602,499.357025 481.694153,499.191803 482.318970,498.948120 
	C482.735382,498.769958 482.897675,498.697144 483.289520,498.502747 
	C483.660980,498.288239 483.802887,498.195343 484.329163,497.784851 
	C484.713562,497.467224 485.071533,497.128876 485.419983,496.786407 
	C485.768433,496.443939 486.111786,496.100891 486.452759,495.759155 
	C486.793701,495.417450 487.132080,495.076874 487.466919,494.736877 
	C487.801788,494.396881 488.126617,494.050507 488.423431,493.681335 
	C488.896210,493.046661 489.063843,492.776001 489.344482,492.289062 
	C489.465790,492.077911 489.754700,491.683777 489.923096,491.507324 
	C490.326324,491.108185 490.558044,490.882263 490.944458,490.468628 
	C491.102295,490.284180 491.413208,489.909241 491.571411,489.723206 
	C491.729614,489.537170 492.057098,489.173676 492.396729,488.820862 
	C492.736389,488.468079 493.081848,488.120087 493.429138,487.772339 
	C493.776428,487.424561 494.124023,487.073578 494.468262,486.714966 
	C494.922516,486.228668 495.032501,486.100922 495.424011,485.537598 
	C495.860168,484.768677 496.008270,484.432434 496.274078,483.821747 
	C496.721985,482.992981 497.186462,482.591309 498.082397,482.223572 
	C501.051666,481.709320 501.936401,483.901459 503.210297,485.097198 
	C502.704041,483.901672 500.983551,482.983704 501.013306,480.802826 
	C501.040924,480.240082 501.071869,480.016876 501.193909,479.469727 
	C501.448761,478.732452 501.631409,478.327637 501.978027,477.636353 
	C502.636658,476.372223 503.186279,475.427490 504.216492,474.420410 
	C504.651733,474.074554 504.835693,473.947479 505.314240,473.658508 
	C505.816406,473.413116 506.024048,473.329620 506.556396,473.163391 
	C509.412903,472.583160 511.995728,474.519165 514.761108,472.737915 
	C515.179932,472.423737 515.342041,472.292511 515.959717,471.742218 
	C516.997803,470.752472 517.545227,470.151764 518.173462,469.218384 
	C518.585632,468.628357 518.839172,468.303284 519.302002,467.745789 
	C520.212036,466.727173 520.863220,465.899353 521.749634,464.834534 
	C522.163269,464.459534 522.344910,464.324219 522.831726,464.026947 
	C523.358643,463.791595 523.580322,463.718140 524.495972,463.723724 
	C528.908386,467.501587 532.161987,472.102478 532.804504,476.890381 
	C533.416870,481.454346 534.296021,486.995758 530.796875,491.374756 
	C529.059998,493.548279 528.226562,495.984955 528.124634,499.079529 
	C527.723816,501.362793 526.338318,502.693909 525.075378,504.492065 
	C524.707275,504.929260 524.548462,505.092804 524.111694,505.451172 
	C522.654602,506.255096 521.342957,506.527161 519.854126,507.236420 
	C519.144165,507.618256 518.356506,508.056854 518.403809,508.131256 
	C520.240417,511.018188 518.040527,513.529480 517.644592,516.526978 
	C517.524109,517.070862 517.462952,517.285645 517.202087,517.769470 
	C517.002380,518.038452 516.993530,517.990295 517.018005,517.990723 
	C516.786560,518.203003 516.545227,518.430237 516.159851,518.864502 
	C516.001099,519.055969 515.987671,519.035828 515.995483,519.026611 
	C515.766968,519.222046 515.541138,519.437622 515.170105,519.839233 
	C515.014404,520.014160 515.000000,520.000000 515.007141,520.007080 
	C514.772644,520.217224 514.543518,520.433594 514.169617,520.839905 
	C514.012451,521.016602 514.000000,521.000000 514.008423,521.006104 
	C513.775513,521.214722 513.546631,521.430298 513.170776,521.833008 
	C513.011414,522.006958 513.000000,522.000000 513.003418,522.005737 
	C512.837463,522.170776 512.668152,522.330078 512.255127,522.738892 
	C512.011414,522.988342 512.005554,523.005554 511.996948,523.008484 
	C511.824249,523.171692 511.660126,523.332031 511.250732,523.733826 
	C511.005463,523.975220 511.005951,524.007751 510.989777,524.006226 
	C510.815002,524.166809 510.656372,524.328918 510.245239,524.718994 
	C509.992737,524.947021 510.000885,525.003479 509.973145,524.996887 
	C509.795959,525.157349 509.646545,525.324463 509.239685,525.707886 
	C508.982300,525.924194 508.990784,525.992615 508.956726,525.987061 
	C508.780731,526.151917 508.638763,526.322205 508.236938,526.700195 
	C507.977142,526.907776 507.982208,526.981812 507.945190,526.979126 
	C507.771179,527.148376 507.634155,527.320251 507.233337,527.690063 
	C506.969513,527.887939 506.970551,527.967102 506.931396,527.961182 
	C506.513062,528.460266 505.856934,528.462524 505.341675,529.079407 
	C505.304230,529.370239 505.169281,529.208557 505.260864,529.260559 
	C504.924652,529.235413 504.572266,529.357178 504.283264,530.014038 
	C504.259491,530.319275 504.205566,530.204102 504.267334,530.219238 
	C503.884735,530.238403 503.532043,530.414368 503.201904,531.096313 
z"/>
<path fill="#F6FCFD" opacity="1.000000" stroke="none" 
	d="
M348.729248,34.172356 
	C350.814758,34.071671 352.600250,34.245789 354.697937,34.641861 
	C356.722717,36.768082 356.625916,39.344971 357.762146,41.752022 
	C368.135162,43.139313 378.267700,42.988297 388.405701,42.424603 
	C391.264832,42.265621 394.017822,42.746338 396.752502,43.553131 
	C432.195526,54.009701 464.483582,70.595482 493.506958,93.470673 
	C498.730774,97.587898 503.666992,102.070000 508.868530,106.692673 
	C509.620911,107.727707 509.736420,108.675896 508.990112,109.152588 
	C506.149445,110.967003 505.536072,114.180275 503.668152,117.021019 
	C501.321411,118.243477 499.973877,116.875168 498.523041,115.797836 
	C494.813629,113.043373 491.520111,109.775139 487.458374,106.865097 
	C454.157349,80.317291 416.731903,63.012218 375.740662,52.133324 
	C368.928650,50.466995 362.462952,49.039989 355.493652,48.073311 
	C352.007721,47.041306 348.776672,46.685314 345.321472,45.585213 
	C343.593994,43.630039 344.235474,41.964657 345.354187,40.488388 
	C346.752411,38.643242 347.415710,36.464748 348.729248,34.172356 
z"/>
<path fill="#03D1FB" opacity="1.000000" stroke="none" 
	d="
M469.625519,510.863037 
	C470.088623,511.778687 469.904999,512.838562 470.350983,513.359802 
	C472.949982,516.397461 471.755127,518.289917 468.728760,519.916077 
	C467.931671,520.344360 467.187958,521.144287 467.620209,522.754150 
	C472.810211,519.316589 475.429840,523.105835 478.725769,526.418884 
	C476.763824,527.010559 475.242065,527.469421 473.363220,527.966614 
	C471.170898,530.939270 467.661469,531.147827 465.078796,532.867737 
	C463.409973,533.979065 461.284058,534.842163 463.417572,537.376282 
	C464.985443,539.238464 462.982605,539.907288 462.125061,540.946106 
	C460.770477,542.586975 459.008484,544.042419 462.968628,544.856323 
	C465.361847,545.348145 467.483887,546.840210 466.759857,550.147461 
	C466.204041,552.686279 469.358582,554.984375 467.279297,558.020386 
	C459.468872,563.683044 451.054840,567.673340 442.465393,572.011536 
	C439.147369,573.016357 436.012451,573.013550 432.973053,573.577820 
	C428.956360,574.323547 425.585358,571.952393 423.389252,567.236328 
	C423.503601,566.400024 423.804565,566.111267 424.250305,565.959351 
	C423.914001,565.883728 423.592133,565.914001 423.276184,566.026001 
	C422.495270,566.302734 421.728058,566.618408 420.572357,566.949707 
	C418.197601,567.401001 416.184021,567.471436 413.829834,566.871582 
	C411.662354,563.274597 409.240662,562.439880 405.914825,564.875061 
	C405.021484,565.529175 403.863434,565.789551 402.354309,565.847412 
	C396.149536,564.402100 392.909607,560.271362 390.673279,554.644775 
	C390.495819,553.518616 390.729126,552.844421 391.441559,551.987732 
	C393.045410,550.805542 394.746216,550.735291 396.471069,549.812805 
	C397.024445,549.669861 397.252716,549.640015 397.819305,549.681946 
	C398.963745,550.220703 399.595917,550.883240 400.393402,551.855347 
	C401.164825,553.384949 401.173553,554.707886 401.069397,556.343445 
	C401.007812,556.833557 400.975677,557.022034 400.905823,557.466980 
	C400.998535,558.483276 401.484436,558.284241 402.245331,557.985718 
	C409.835541,555.249329 416.949005,552.174316 424.508240,549.267212 
	C425.046448,549.017212 425.263733,548.920227 425.810791,548.683350 
	C426.364655,548.459045 426.588776,548.374695 427.158081,548.188599 
	C428.203491,547.924255 428.916229,547.852661 429.983887,547.767761 
	C435.644653,547.930542 440.911896,547.780762 445.839691,545.468994 
	C446.548035,545.136658 448.260345,545.476074 447.651093,543.877930 
	C445.928467,539.359497 449.336670,538.133789 452.182892,536.496582 
	C453.310516,535.847961 454.607391,535.463745 455.642456,534.238953 
	C454.409576,533.799072 453.456909,534.693359 452.074829,534.613220 
	C451.496979,534.494507 451.276337,534.401733 450.835999,534.024231 
	C450.169312,531.955994 451.359406,530.907043 452.555359,530.143250 
	C456.461823,527.648254 457.908600,523.777893 458.945801,519.213013 
	C461.557800,515.027527 465.262329,512.702148 469.625519,510.863037 
z"/>
<path fill="#F4FCFC" opacity="1.000000" stroke="none" 
	d="
M118.348419,476.099915 
	C117.547577,474.590454 116.697693,473.417755 115.585068,472.078430 
	C113.152306,469.999054 111.077744,468.001190 109.405640,465.205627 
	C108.754845,464.192535 108.297409,463.448181 107.573624,462.487305 
	C106.785240,461.298981 106.219688,460.356079 105.331375,459.220856 
	C103.776505,456.782562 101.777428,454.998810 101.211929,451.991882 
	C102.229683,448.232300 105.292427,447.037598 108.332092,445.431152 
	C112.729134,447.650360 114.240211,451.947754 116.641617,455.412842 
	C125.937088,468.825775 136.801331,480.882812 147.958267,492.711334 
	C149.785095,494.648163 151.782410,496.393219 154.177795,498.218201 
	C161.901291,505.906464 170.049423,512.549011 178.790619,519.007202 
	C180.596939,520.418518 182.047058,521.741638 183.949677,523.001099 
	C185.134201,523.992554 185.938507,524.939819 187.251709,525.757812 
	C187.688217,526.020752 187.863617,526.125977 188.304108,526.388672 
	C188.929688,526.755798 189.287811,526.969543 189.917969,527.357666 
	C190.366745,527.659790 190.541122,527.791626 190.963531,528.142517 
	C195.859161,532.400452 201.472015,535.027405 206.519501,539.040344 
	C207.157059,541.366516 206.344406,542.743225 204.240189,543.781433 
	C203.400513,543.979004 202.912048,544.011963 202.063049,543.935303 
	C201.011154,543.718079 200.363647,543.428162 199.411713,542.967651 
	C198.901031,542.700439 198.701447,542.586426 198.214020,542.286194 
	C196.099518,540.795349 194.276917,539.484436 191.967438,538.327271 
	C191.478424,538.083008 191.285706,537.982361 190.810822,537.723999 
	C189.795334,537.140015 189.072021,536.695312 187.999390,536.226013 
	C187.516220,535.997559 187.324905,535.900085 186.855209,535.638062 
	C186.214355,535.233765 185.856781,534.987000 185.226746,534.553955 
	C181.230759,531.903687 177.319748,529.738586 173.330963,527.084656 
	C172.143814,526.356201 171.228836,525.803894 170.287872,524.776367 
	C170.030746,524.595459 170.130722,524.335205 170.045837,524.224609 
	C169.777603,523.806458 169.553787,523.532654 169.015747,523.301636 
	C168.748962,523.304932 168.906006,523.011719 168.815186,523.151184 
	C168.740936,522.878296 168.595825,522.541138 168.006042,522.441101 
	C167.751953,522.589539 167.592575,522.518066 167.528168,522.459106 
	C167.764465,521.447205 166.947205,521.569824 166.202560,521.213379 
	C165.936035,521.060547 165.996735,520.999695 165.972565,521.035034 
	C165.788498,520.781128 165.579620,520.533203 165.093384,520.239746 
	C164.865005,520.153015 165.012833,520.027527 164.944183,520.096802 
	C164.604660,519.544128 163.995972,519.502563 163.236389,519.152954 
	C163.015472,518.965149 162.998550,519.000000 163.012985,518.987427 
	C161.145752,517.835876 159.051880,517.099670 156.918045,515.724731 
	C153.305862,512.913696 150.806686,509.377319 147.000854,506.765259 
	C145.299454,505.402130 143.785782,504.307495 143.124817,502.077454 
	C142.483414,501.272003 141.999664,500.773590 141.275833,500.167114 
	C140.841064,499.791351 140.613983,499.554688 140.157700,499.200562 
	C139.960907,499.051971 140.000000,499.000000 139.978210,499.024170 
	C135.552505,496.150909 131.734131,492.641541 129.059662,488.179688 
	C128.916229,487.465240 128.430542,486.865448 127.684113,486.131897 
	C125.628387,485.022125 124.290276,483.545593 122.860336,481.695099 
	C121.453621,479.549072 118.825218,478.922577 118.348419,476.099915 
z"/>
<path fill="#044371" opacity="1.000000" stroke="none" 
	d="
M599.457703,330.516144 
	C599.818848,332.542786 599.916260,334.322784 599.968018,336.547699 
	C598.073486,338.744324 595.884583,338.179535 593.769958,337.825928 
	C591.478943,337.442810 589.450684,337.665009 587.741211,339.992859 
	C583.511841,343.730774 579.208191,345.901306 573.468994,343.563843 
	C572.678284,343.393036 572.275330,343.200745 571.698486,342.681763 
	C571.111755,342.286285 571.040649,341.734070 570.555176,341.743317 
	C570.433655,341.745636 570.400024,341.893524 570.450745,342.001434 
	C570.734314,342.604797 570.259644,342.032043 571.103760,342.078003 
	C571.609375,342.620453 571.930420,342.909790 572.577759,343.339050 
	C576.819275,345.625641 581.204407,343.534210 585.468323,345.139832 
	C586.606384,347.575409 586.473389,349.738953 585.826904,352.283813 
	C583.101257,355.256256 579.502319,354.394562 576.144165,355.430420 
	C575.607910,355.754639 575.248962,355.071625 575.345154,355.533875 
	C576.720032,355.554504 577.724976,355.001465 579.179199,355.083679 
	C582.601746,355.972809 582.163208,358.645508 582.587280,361.298096 
	C582.641907,363.119995 582.086182,364.306793 580.807007,365.569946 
	C578.302002,366.767273 576.846436,368.626862 575.131409,370.171326 
	C571.146484,373.760040 568.771667,373.311340 566.420288,368.369476 
	C565.070435,365.532593 564.095703,362.517090 562.191101,359.489471 
	C561.530457,353.085571 563.397583,347.354950 564.254211,341.509613 
	C565.354065,334.004974 565.575562,326.397278 567.212769,318.546082 
	C573.918640,313.222260 583.390991,313.383942 588.557678,318.763336 
	C590.217163,324.686584 594.464539,327.699463 599.457703,330.516144 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M33.166000,363.283875 
	C31.034397,356.793488 30.926899,350.258972 30.074980,343.407959 
	C32.895901,340.897675 35.618889,342.337891 37.282536,344.155365 
	C44.023499,351.519775 54.656120,354.063721 60.140865,362.951630 
	C61.513943,365.176697 64.425354,365.313080 66.985107,366.543823 
	C68.318214,367.982178 68.655746,369.496674 69.209991,371.326874 
	C70.129646,375.632629 71.295082,379.470947 72.766411,383.612976 
	C73.766678,388.138519 75.257034,392.118835 76.763245,396.488586 
	C78.297066,402.238617 81.009560,407.158295 82.638016,412.881226 
	C82.680321,413.811981 82.548851,414.320374 82.015411,415.085938 
	C77.379639,416.540070 73.399284,414.273315 68.852997,413.863892 
	C68.077263,413.444305 67.463287,412.850311 67.627739,412.631775 
	C70.475471,408.847656 66.783348,404.640930 68.528893,400.623566 
	C69.470367,398.456787 64.975739,392.275055 62.435364,391.279358 
	C61.187737,390.790344 59.758701,390.543640 59.304398,389.108368 
	C56.615974,380.614624 49.244743,376.689972 42.527950,372.346039 
	C38.804729,369.938141 35.506779,367.444244 33.166000,363.283875 
z"/>
<path fill="#02E6FD" opacity="1.000000" stroke="none" 
	d="
M349.339569,599.759460 
	C346.115784,601.040161 343.067932,600.915222 339.658508,601.147583 
	C339.080475,601.182617 338.919464,601.267700 338.494751,601.281860 
	C337.720184,601.359924 337.209412,601.509033 336.297119,601.610657 
	C333.625397,601.014771 329.875244,602.966858 330.239990,597.767578 
	C331.275146,595.634094 333.196930,595.288147 334.987793,594.122314 
	C336.356812,593.328674 337.658722,592.822754 338.587616,593.611084 
	C342.292267,596.754700 344.503876,594.198242 346.898071,591.736145 
	C353.559998,584.885193 359.432648,577.163208 368.172821,572.592834 
	C369.568359,571.863098 371.490540,570.788635 370.839447,568.875366 
	C370.119995,566.761292 368.044403,567.797363 366.492615,567.940674 
	C362.530243,568.306580 358.573914,568.696838 354.319214,567.545532 
	C353.011627,566.188843 353.376923,564.983887 354.092102,563.440613 
	C354.461273,562.912292 354.631958,562.717712 355.108276,562.284668 
	C355.846313,561.769653 356.299011,561.531799 357.126953,561.203613 
	C360.369904,560.543274 363.216980,559.758667 366.528778,559.613037 
	C367.348236,559.536255 367.809296,559.469238 368.600525,559.289673 
	C369.602722,559.090393 370.274200,559.060791 371.267517,559.142456 
	C372.562653,559.352600 373.525970,559.793030 374.772369,559.141418 
	C375.166504,558.810059 375.324341,558.672058 375.726501,558.323853 
	C376.324097,557.837952 376.704681,557.605957 377.441345,557.297729 
	C378.498749,557.051025 379.222870,557.069336 380.321289,557.223511 
	C383.935303,557.961182 387.711578,558.204163 389.051361,561.762634 
	C390.900757,566.674438 392.683960,571.734802 391.852173,577.181519 
	C391.727814,577.995728 391.280731,578.798584 390.641022,579.313538 
	C385.508057,583.445557 382.610046,589.366577 378.265472,594.624817 
	C377.421417,595.091492 376.847290,595.275757 375.986267,595.358704 
	C371.478821,595.431030 367.261230,595.543945 363.094025,594.636719 
	C359.757690,593.910461 357.329712,594.778320 356.234894,598.697144 
	C355.997864,598.988403 355.654572,599.204346 355.459534,599.148743 
	C353.451843,599.867188 351.531006,599.283569 349.339569,599.759460 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M378.392273,594.940430 
	C379.604095,588.794312 383.616058,584.155823 388.084137,580.143738 
	C390.587555,577.895813 391.377655,575.803406 390.786163,572.841309 
	C390.206390,569.937927 389.433594,567.071838 388.895782,564.161621 
	C387.983917,559.227051 383.500885,559.566467 380.016785,557.777161 
	C380.620483,555.658447 382.466187,555.584534 384.262695,554.766602 
	C386.407593,554.120850 388.046356,552.829834 390.398621,553.629150 
	C393.889435,557.815002 395.946503,562.913513 401.687958,564.846436 
	C401.161133,568.506958 396.771973,568.327576 395.317596,571.559570 
	C399.110229,571.927002 402.838806,571.117798 406.729675,569.377197 
	C408.644470,568.662170 410.326935,568.422424 412.289368,567.814087 
	C415.011932,567.058777 417.500488,567.131226 420.246399,566.509521 
	C421.546570,566.220764 422.304077,565.421326 423.686157,565.784546 
	C425.896973,571.226196 429.740112,573.582275 434.558258,571.878784 
	C437.002625,571.014465 439.078156,571.612671 441.713867,572.025635 
	C423.451477,582.026001 403.685791,589.036133 383.147797,593.968811 
	C381.698059,594.317017 380.242096,594.639221 378.392273,594.940430 
z"/>
<path fill="#011B36" opacity="1.000000" stroke="none" 
	d="
M32.914566,363.507935 
	C33.526497,363.221283 34.520039,363.170990 34.737354,363.557343 
	C38.540401,370.318451 46.536575,371.800140 51.495300,376.926422 
	C54.717030,380.257019 60.039047,382.221710 60.083103,388.083954 
	C60.089859,388.983215 60.590199,389.854401 61.512741,389.819763 
	C68.048225,389.574188 67.284676,395.933685 69.882851,399.195190 
	C70.523079,399.998932 71.925873,402.307465 69.133492,403.174408 
	C68.443123,403.388794 67.987732,404.398773 68.604195,404.706635 
	C74.548584,407.675140 69.166908,409.829559 68.080063,412.617645 
	C65.138321,414.440063 62.217590,413.238800 59.365246,412.863220 
	C57.400631,412.604553 55.856785,411.132599 56.868130,408.950989 
	C58.131676,406.225372 56.818748,405.702209 54.601173,404.862000 
	C52.430809,404.039642 45.919659,404.460419 52.228725,399.500549 
	C53.428471,398.557343 51.985092,397.362915 51.425922,396.484192 
	C49.198177,392.983337 45.642941,391.070709 42.064610,389.387604 
	C39.339108,388.105652 37.359982,386.413483 36.272648,383.246765 
	C34.739403,376.682800 32.778397,370.488251 32.914566,363.507935 
z"/>
<path fill="#61D6F8" opacity="1.000000" stroke="none" 
	d="
M129.670776,99.947433 
	C143.685257,86.925041 158.961517,76.254944 175.560638,66.868011 
	C179.918381,67.715355 182.994766,69.589432 183.475906,74.526421 
	C182.961227,77.448822 180.648727,78.176140 178.541229,79.622215 
	C165.211639,86.787277 152.961655,94.895241 141.736664,104.512482 
	C139.724655,106.236320 137.799835,108.069855 134.737427,108.752823 
	C130.673767,107.130653 129.785889,103.896637 129.670776,99.947433 
z"/>
<path fill="#022D4E" opacity="1.000000" stroke="none" 
	d="
M67.039124,366.740570 
	C62.563141,366.781677 60.270508,364.237366 57.192890,361.451416 
	C49.284252,354.292358 41.215267,346.869843 30.483570,342.985718 
	C30.060400,341.268860 30.015934,339.561035 29.991806,337.426086 
	C32.141182,335.692902 34.215714,334.352203 33.615044,330.951721 
	C33.553524,328.788788 33.535423,326.993408 34.132759,324.872803 
	C37.958725,323.033997 43.388783,324.815552 46.226780,329.453003 
	C50.585098,336.574707 57.763660,341.296753 61.830601,348.594116 
	C62.304855,349.445068 63.299961,349.906860 64.318756,350.829468 
	C66.492691,355.512543 66.695732,360.261322 67.479591,365.291656 
	C67.447594,365.949219 67.389793,366.209106 67.039124,366.740570 
z"/>
<path fill="#70E1F9" opacity="1.000000" stroke="none" 
	d="
M222.246170,52.423347 
	C225.610825,52.547359 225.903015,50.305229 226.628159,48.709698 
	C229.414291,42.579388 232.429581,41.033688 238.852432,42.792927 
	C239.301880,42.916031 239.706024,43.076050 239.996185,42.860195 
	C248.056686,36.864399 257.948273,37.045364 267.534729,34.816742 
	C270.238617,36.246101 271.944061,38.325268 273.971466,40.030216 
	C275.748138,41.524284 276.518738,43.496975 275.232422,46.144093 
	C271.845551,48.369026 268.212463,48.116009 264.414307,48.924355 
	C257.703644,49.990479 251.510529,51.536327 244.944138,53.220497 
	C238.434784,54.444202 232.691544,56.975433 226.213165,58.306660 
	C225.041351,58.468353 224.266357,58.663921 223.071609,58.580853 
	C220.867249,57.627209 220.867020,56.011547 221.092285,53.952667 
	C221.318237,53.319904 221.443268,53.080036 222.246170,52.423347 
z"/>
<path fill="#69DBF7" opacity="1.000000" stroke="none" 
	d="
M222.069839,53.248226 
	C222.160278,54.906872 221.647858,56.350109 222.788239,57.810757 
	C222.999496,60.368927 220.898117,60.262371 219.504501,60.787457 
	C211.591507,63.768951 203.738098,66.887192 195.706680,70.566513 
	C191.218933,71.578186 188.078278,74.881676 183.501587,75.271713 
	C182.132965,71.380959 179.521103,69.106247 176.068893,67.125458 
	C189.337173,58.308853 204.121429,52.788593 218.862076,47.175541 
	C223.130753,45.550079 223.276093,48.052258 222.854568,51.579689 
	C222.924026,52.006527 222.966675,51.938454 223.006821,51.937359 
	C222.721680,52.237953 222.430389,52.569218 222.069839,53.248226 
z"/>
<path fill="#11547D" opacity="1.000000" stroke="none" 
	d="
M593.441162,255.742706 
	C596.349854,267.200714 598.708923,278.466187 599.279114,290.474060 
	C596.310913,294.193054 593.110168,297.103607 588.047974,297.303223 
	C587.183105,296.480682 586.903564,295.742737 586.629639,294.575562 
	C585.782227,290.312195 584.632446,286.527222 583.769165,282.264618 
	C583.495117,276.482697 582.651611,271.200684 581.011658,265.634796 
	C580.741821,264.134613 580.786011,263.044800 581.219482,261.585022 
	C584.473145,257.636230 588.126465,255.198395 593.441162,255.742706 
z"/>
<path fill="#021429" opacity="1.000000" stroke="none" 
	d="
M36.038940,383.379028 
	C38.752827,386.602814 42.773674,388.393677 46.629471,390.287323 
	C50.903419,392.386414 52.804596,396.438446 55.437435,400.044495 
	C54.380013,402.000183 51.910748,400.150787 50.415470,401.999603 
	C52.290745,403.380280 54.476929,403.661865 56.628929,404.002380 
	C59.597271,404.472107 61.243320,405.774445 58.705013,408.494843 
	C55.906445,411.494110 58.230331,411.755463 60.368042,411.925201 
	C62.679916,412.108734 65.021484,411.912018 67.624924,412.918610 
	C72.590881,412.677429 76.865952,414.282806 81.743820,415.280945 
	C80.591377,417.881897 78.372719,416.973602 76.319489,416.675812 
	C73.873550,416.321045 71.413010,416.211151 68.887115,415.947327 
	C68.931267,417.073364 69.950119,418.048920 68.874886,419.394775 
	C66.040558,420.699768 63.757198,420.101929 61.302982,418.288696 
	C57.708763,417.636505 54.442265,417.133606 51.156555,416.890991 
	C44.926552,416.430878 44.797501,410.770660 43.293915,406.957611 
	C40.330849,399.443451 38.392857,391.525085 36.038940,383.379028 
z"/>
<path fill="#0CA3DE" opacity="1.000000" stroke="none" 
	d="
M275.061829,590.825806 
	C275.678375,591.553650 276.483154,591.974060 276.515259,592.446899 
	C276.576416,593.346802 275.613495,593.075806 275.112274,593.033081 
	C262.711456,591.974976 250.230774,592.235352 237.859589,590.561707 
	C229.467468,589.426331 221.073685,588.423401 212.559341,585.880127 
	C211.743027,585.544495 211.564209,585.170715 212.024902,584.566895 
	C216.936356,584.704407 221.510162,584.941223 226.546204,585.167053 
	C229.946320,584.629761 232.768677,585.302856 235.974487,586.005005 
	C238.793777,586.633362 241.275925,586.525696 244.052155,586.513550 
	C244.652390,586.502930 244.802322,586.497681 244.802322,586.497681 
	C245.280838,586.532166 245.310242,586.531555 244.611176,586.489990 
	C241.680359,586.492188 239.021820,586.618774 236.015106,585.987061 
	C233.036789,585.084045 230.277771,585.174683 227.301880,584.318909 
	C219.553284,583.070068 212.156754,581.994446 204.743576,581.049500 
	C202.597626,580.776001 200.733231,580.475281 200.851990,577.338745 
	C206.146439,574.080933 211.449005,576.212402 217.145630,576.571289 
	C220.737076,576.289001 223.716995,577.600342 227.255463,577.595947 
	C236.202759,577.656128 243.850021,581.262573 252.116272,583.822510 
	C252.963104,584.461243 253.327408,584.991577 253.236511,585.984131 
	C255.654800,587.309265 258.420105,586.660278 261.224182,587.644775 
	C262.201416,587.724304 262.849792,587.803711 263.826111,587.873901 
	C264.365723,587.925598 264.580383,587.953491 265.111328,588.044800 
	C265.633392,588.163513 265.839233,588.218811 266.348206,588.365723 
	C267.448792,588.703918 268.261322,588.876465 269.404816,588.993896 
	C269.918793,589.088318 270.121460,589.140686 270.609589,589.321167 
	C271.349335,589.279114 271.250000,590.736084 272.260712,589.714111 
	C273.463165,589.615540 274.230652,589.956116 275.061829,590.825806 
z"/>
<path fill="#03D7FC" opacity="1.000000" stroke="none" 
	d="
M527.169006,500.260803 
	C526.747864,496.335052 527.301636,493.122620 530.000427,490.302185 
	C531.638184,488.590576 533.284363,486.266907 530.748413,483.764099 
	C530.104614,483.128723 529.772827,482.038696 530.544006,481.576385 
	C534.476807,479.218903 531.877136,476.706085 530.675598,474.455322 
	C528.813049,470.966400 526.614441,467.656830 524.249878,464.109680 
	C523.839355,463.728210 523.737183,463.508270 523.656006,462.924255 
	C524.739441,460.098969 525.843933,457.671051 528.862427,456.442230 
	C532.319092,457.266266 534.413696,459.511322 535.567871,462.206787 
	C536.804077,465.093628 538.725830,467.105957 541.277954,469.186462 
	C542.318298,471.037903 538.272156,472.970612 542.143311,474.399292 
	C543.117859,474.881439 543.474548,475.436920 543.487915,476.517334 
	C543.086609,477.589722 542.462830,478.099762 541.958862,478.707611 
	C541.262329,479.547607 539.993225,480.434143 540.452759,481.486603 
	C541.044800,482.842682 542.737183,482.024872 544.232422,482.490784 
	C545.230774,483.031860 545.491272,483.650635 545.213684,484.727936 
	C542.027649,490.476257 537.626282,494.843292 533.577759,499.857300 
	C532.932495,500.188049 532.600464,500.406616 532.230469,500.981018 
	C532.147766,501.270172 532.128479,501.114960 532.205078,501.130615 
	C531.878174,501.216309 531.546387,501.409546 531.260193,502.023560 
	C531.233459,502.320496 531.233032,502.172668 531.273926,502.234253 
	C530.608643,502.586365 529.898560,502.857758 528.750305,502.616547 
	C527.712341,502.039001 527.366394,501.405060 527.169006,500.260803 
z"/>
<path fill="#020711" opacity="1.000000" stroke="none" 
	d="
M68.213364,434.807861 
	C64.476616,435.554993 61.183548,434.172882 57.769478,433.865997 
	C54.299042,433.554138 53.306103,430.446228 52.141315,427.318848 
	C52.927444,424.838440 54.832481,424.690277 56.620850,425.152130 
	C63.862850,427.022491 71.462090,426.655090 78.652504,428.774902 
	C80.617088,429.354065 82.887146,429.388306 84.434120,432.254028 
	C77.825630,433.160004 72.171249,430.496552 67.232651,430.262848 
	C74.506645,431.620514 82.790474,432.896149 91.350357,434.816803 
	C94.561203,436.368164 95.847855,438.901093 96.542267,442.184601 
	C95.756691,443.824921 94.776428,443.789795 93.626152,443.266998 
	C94.665947,443.837189 95.884155,443.866913 97.371536,444.278595 
	C98.847862,445.271576 99.409760,446.373993 99.008194,448.122192 
	C97.564857,449.195343 96.295990,449.270416 94.975937,448.849762 
	C89.034866,446.956787 82.928978,445.760284 76.475830,444.752258 
	C74.224747,444.388580 72.054413,444.209290 70.513237,443.130859 
	C69.403214,442.354126 64.659737,444.262726 67.450668,439.837830 
	C66.906815,439.554413 66.373283,439.248657 65.817177,438.991791 
	C64.030960,438.166687 62.236412,437.359680 60.223465,436.271393 
	C64.014328,435.064056 67.283424,437.431366 70.858376,438.441528 
	C72.623466,438.940247 74.556747,439.860779 74.966141,436.467651 
	C74.926727,434.828369 73.823563,435.800873 73.168243,435.170288 
	C72.935707,435.000000 72.494896,435.012726 72.274414,435.014343 
	C70.940758,434.114899 69.676338,434.541718 68.213364,434.807861 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M586.523438,340.644562 
	C587.011475,336.309418 589.709656,335.577209 592.883362,336.234436 
	C594.950745,336.662537 596.964111,337.084534 599.497009,336.995178 
	C599.957336,347.250244 598.402832,357.344727 596.610962,367.772278 
	C591.125183,370.110596 590.115784,369.673523 585.156372,363.041199 
	C584.609619,362.300842 584.413025,361.823242 584.289551,360.925659 
	C584.313049,359.799103 584.475830,359.068604 584.610229,357.964447 
	C584.691711,356.863647 584.735474,356.127533 584.810791,355.016632 
	C584.959412,354.147064 585.124451,353.670502 585.421265,352.837341 
	C585.527344,350.393982 585.508423,348.325409 585.505615,345.864136 
	C585.070618,343.846802 585.214478,342.317322 586.523438,340.644562 
z"/>
<path fill="#55CFFB" opacity="1.000000" stroke="none" 
	d="
M129.520996,99.720627 
	C131.159958,102.485329 131.658127,105.845520 134.811249,108.004982 
	C135.336945,110.850174 133.174728,112.200180 131.435333,113.562630 
	C125.253914,118.404472 120.057144,124.203979 114.620575,130.297882 
	C112.604141,131.985992 111.179825,133.862396 108.555649,134.711639 
	C103.371666,132.658829 104.281013,128.550919 104.763405,124.298935 
	C112.261971,115.115456 120.704239,107.458824 129.520996,99.720627 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M467.373962,558.247070 
	C466.776794,556.299316 467.714325,553.869934 465.244751,552.517395 
	C464.972015,552.368042 464.563385,551.958191 464.615326,551.798645 
	C466.108765,547.213074 465.072601,545.349731 459.776703,546.215027 
	C458.732330,546.385681 458.607025,542.722534 459.799347,541.050415 
	C460.514221,540.047852 461.898712,539.522827 462.993286,538.775574 
	C459.842987,536.966797 459.678955,534.472229 462.865845,532.664673 
	C465.882751,530.953552 469.173950,529.726074 472.675293,528.145386 
	C473.485107,531.374023 476.272278,534.300720 474.322205,538.283997 
	C473.893066,539.160522 476.132935,543.370728 476.992218,543.835876 
	C480.848053,545.923462 478.040283,548.294678 478.051208,550.855347 
	C475.310425,553.128601 472.553375,555.034363 469.458282,556.994690 
	C468.940430,557.176758 468.760559,557.304199 468.304565,557.613403 
	C467.897156,557.920166 467.765930,558.045166 467.373962,558.247070 
z"/>
<path fill="#77DCF6" opacity="1.000000" stroke="none" 
	d="
M275.255920,46.054256 
	C275.279266,43.211296 274.432800,41.327038 272.166565,40.065228 
	C270.316284,39.035007 268.666351,37.744633 267.996887,35.201023 
	C278.207153,32.405716 288.686829,31.871386 299.575928,31.199448 
	C301.786041,35.015705 300.161133,38.762951 299.880615,42.921745 
	C297.531250,46.196678 294.367126,45.297943 291.052948,45.487041 
	C286.765930,46.503067 282.769958,46.267696 278.437317,46.877739 
	C277.128937,46.991661 276.287537,46.856091 275.255920,46.054256 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M104.658249,124.061966 
	C106.428619,127.140999 104.312386,131.543488 108.676224,133.969864 
	C109.600594,136.105209 108.224388,137.494400 107.123222,138.855484 
	C101.930862,145.273453 97.196587,152.037125 92.120529,158.540070 
	C90.756393,160.287659 89.627861,162.603760 86.424026,161.809830 
	C83.680405,157.985703 84.948853,154.319733 85.885696,150.701965 
	C86.333275,148.973557 87.038040,147.311035 87.752747,145.227264 
	C92.632278,137.350708 98.510635,130.789093 104.658249,124.061966 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M331.150085,596.598083 
	C330.358215,600.473877 332.414764,601.242798 335.590027,601.376221 
	C323.626007,603.205139 311.290924,603.068848 298.492859,602.857666 
	C295.998627,600.446960 297.701324,598.019897 297.977905,595.260315 
	C298.192535,594.664062 298.302460,594.433960 298.657166,593.908325 
	C299.520447,593.144592 300.220276,592.834229 301.297119,592.422058 
	C301.899139,592.205872 302.144135,592.130310 302.764771,591.970215 
	C307.242584,591.885925 311.173920,590.242798 315.684998,590.732910 
	C318.304626,593.019531 320.996338,593.846741 324.105225,593.720947 
	C326.241394,593.634460 328.346283,594.019653 330.573608,595.324097 
	C331.019440,595.784485 331.154236,596.008118 331.150085,596.598083 
z"/>
<path fill="#08AFF3" opacity="1.000000" stroke="none" 
	d="
M543.301636,477.813110 
	C542.944763,476.823578 542.737183,476.142212 542.257019,475.227234 
	C541.132629,473.560120 541.887756,472.052429 541.727051,470.262146 
	C541.534729,469.031891 541.739258,468.181519 542.253662,467.058350 
	C543.493713,465.101318 544.615662,463.466217 546.160828,461.752686 
	C546.509766,461.361694 546.648804,461.207825 546.983948,460.820007 
	C547.416321,460.256409 547.622131,459.908630 547.905396,459.254333 
	C548.145081,458.561981 548.298218,458.167053 548.606812,457.478149 
	C549.764954,455.674957 550.197266,453.775116 552.128967,452.508240 
	C554.263794,451.834167 555.892517,452.416870 557.797791,453.402710 
	C558.614929,454.212219 558.833496,454.906677 558.767822,456.033966 
	C558.368713,457.596832 557.271423,458.207672 556.385498,459.411926 
	C555.582825,460.623505 554.931641,461.528717 554.174561,462.761292 
	C553.250854,464.124359 552.334229,465.100433 551.758057,466.650970 
	C551.791199,467.252350 551.077454,467.233185 551.492493,467.332642 
	C552.043518,465.875977 552.690979,464.816223 553.637329,463.563385 
	C554.392822,462.419373 554.992188,461.551605 555.737549,460.402100 
	C556.298279,459.639008 556.601807,459.076843 557.294434,458.416260 
	C558.752869,457.373352 558.976318,456.079712 559.240662,454.414917 
	C560.172607,452.487152 561.102966,450.997009 563.248169,450.181519 
	C564.786926,450.083435 565.812561,450.313812 566.265381,451.864380 
	C560.220825,463.652435 552.974121,474.206360 545.293823,484.847168 
	C544.656677,484.348419 544.301880,483.666687 543.606812,482.781464 
	C543.523560,481.100464 544.643982,479.658691 543.301636,477.813110 
z"/>
<path fill="#021429" opacity="1.000000" stroke="none" 
	d="
M92.426758,435.612305 
	C82.178917,433.917389 72.119835,431.888245 62.060753,429.859131 
	C69.217346,428.840759 75.935150,432.016815 83.009964,431.622284 
	C76.650169,429.974548 70.374557,427.674438 63.725521,428.075378 
	C59.887936,428.306793 56.660282,424.677795 52.349747,426.835785 
	C49.644638,425.314606 49.958370,422.272156 48.524216,420.019684 
	C47.263294,418.039276 49.940685,417.782440 51.232388,418.135956 
	C54.171535,418.940430 57.117191,419.075623 60.557770,419.011963 
	C63.305111,419.117737 65.575722,419.480072 68.150589,420.013245 
	C69.041840,420.793335 69.323578,422.119507 69.986160,422.042297 
	C76.464455,421.287476 81.066780,427.236420 87.747955,426.944824 
	C90.517288,428.337769 91.222687,430.838409 92.479179,433.395447 
	C92.712875,434.262878 92.716400,434.770111 92.426758,435.612305 
z"/>
<path fill="#1D98D1" opacity="1.000000" stroke="none" 
	d="
M212.154236,571.320923 
	C211.870850,571.114746 211.431046,571.033142 211.224869,570.946533 
	C210.404694,570.166565 210.551834,569.482239 211.344666,568.571045 
	C212.765381,567.743835 214.053391,567.762146 215.576050,567.253906 
	C217.091644,566.823853 218.308975,566.719604 219.807831,566.211548 
	C221.593323,565.708008 223.114853,565.761169 224.899841,565.158020 
	C225.785782,564.965332 226.303162,564.915771 227.221283,564.936035 
	C236.358307,568.651978 245.357956,569.672974 255.029846,567.534424 
	C257.759430,567.777466 258.515778,569.742004 256.997437,570.839783 
	C253.322800,573.496460 256.320557,573.833130 258.095673,575.149292 
	C256.599670,578.178650 253.943756,578.145752 250.916351,578.087524 
	C248.385666,577.374878 246.212494,577.091431 243.638626,577.746338 
	C242.344376,578.161255 241.370026,578.353394 240.071899,578.787109 
	C238.701447,579.138916 237.700562,579.008606 236.345367,578.724243 
	C233.048004,576.039551 229.089294,576.647034 225.413528,575.202576 
	C223.360291,574.165405 221.457474,574.302185 219.260437,574.076172 
	C218.679733,573.985107 218.449219,573.938110 217.878357,573.800476 
	C215.800110,573.070374 213.811569,573.016785 212.154236,571.320923 
z"/>
<path fill="#01BEE9" opacity="1.000000" stroke="none" 
	d="
M298.596619,593.659546 
	C299.524628,596.723022 298.022064,599.269531 298.023499,602.390625 
	C282.046173,603.008301 266.478058,599.844055 250.476135,596.944336 
	C249.935287,596.763916 249.790146,596.628906 249.823517,596.256104 
	C264.740906,596.246399 279.501984,596.959045 294.508850,593.939941 
	C295.916931,592.953918 297.045074,592.923706 298.596619,593.659546 
z"/>
<path fill="#0A4271" opacity="1.000000" stroke="none" 
	d="
M587.881348,297.302734 
	C592.340149,296.242676 594.665833,292.293335 598.945923,291.054657 
	C599.929321,299.769440 601.626770,308.586884 599.715332,317.760620 
	C594.567261,318.375427 592.090515,314.428497 588.499329,311.699310 
	C587.749084,310.755005 587.376953,310.043274 586.978943,308.884705 
	C586.544373,306.542114 586.678406,304.578979 586.609253,302.194977 
	C586.571289,300.291443 586.676025,298.847137 587.881348,297.302734 
z"/>
<path fill="#37AFE9" opacity="1.000000" stroke="none" 
	d="
M87.647614,145.025070 
	C88.460121,147.744263 87.546616,150.494583 86.712257,153.117630 
	C85.739632,156.175369 85.967583,158.952499 87.211693,162.235931 
	C87.729362,163.443512 87.889130,164.335815 87.414696,165.030411 
	C83.635590,170.563507 80.611595,176.630280 75.456833,181.535629 
	C71.787750,180.904251 71.811188,178.256195 71.587875,175.753586 
	C71.408821,173.746918 71.721375,171.768158 71.883957,169.363220 
	C76.143112,160.458069 81.870323,152.905930 87.647614,145.025070 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M593.045959,382.718628 
	C592.646729,389.067993 590.686401,394.784180 588.633911,400.820251 
	C588.283081,401.176422 588.106689,401.209229 587.987610,401.309875 
	C581.896179,406.461395 580.739746,406.197205 577.652771,398.643036 
	C577.007507,397.311523 576.893311,396.272278 577.033997,394.815552 
	C577.260132,393.671234 577.519592,392.940613 577.876038,391.837921 
	C579.354309,388.945190 579.633850,386.120331 580.404114,383.018158 
	C580.918213,382.207886 581.320801,381.834503 582.182190,381.366913 
	C586.034546,381.014374 589.443176,381.251129 593.045959,382.718628 
z"/>
<path fill="#2EA1DD" opacity="1.000000" stroke="none" 
	d="
M71.563576,169.128174 
	C73.976944,170.956299 72.684334,173.544022 72.972603,175.859726 
	C73.204475,177.722382 72.509857,179.889175 75.344391,180.894836 
	C76.867935,182.206467 75.633583,183.158371 75.151718,184.548004 
	C72.132584,189.366302 69.875786,194.227798 66.294998,198.645752 
	C62.002136,199.320831 60.358795,196.714325 58.910885,193.323059 
	C62.127396,184.625183 66.814407,177.027039 71.563576,169.128174 
z"/>
<path fill="#197AAB" opacity="1.000000" stroke="none" 
	d="
M37.101521,255.285843 
	C38.024960,246.902390 40.604473,239.195679 43.265923,231.162033 
	C45.645481,229.579391 47.984501,229.234161 50.875610,230.005829 
	C53.520760,231.533829 52.981949,233.594299 52.379742,235.464249 
	C50.859325,240.185287 49.700493,245.032822 47.543674,249.973755 
	C47.329491,252.393188 46.925434,254.314423 45.281132,256.207397 
	C42.286247,257.444733 39.827946,256.662933 37.101521,255.285843 
z"/>
<path fill="#0B5794" opacity="1.000000" stroke="none" 
	d="
M577.640503,398.140656 
	C578.476685,398.161133 579.325256,398.284485 579.346252,398.491882 
	C580.095581,405.871063 583.790466,403.711761 588.036743,401.103577 
	C587.514771,403.914581 586.596802,406.717163 585.418030,409.766479 
	C584.605896,410.380371 584.493713,410.976624 584.202576,411.818909 
	C584.053467,412.080475 584.021301,412.014282 584.057800,412.009644 
	C583.223511,412.653046 583.599792,413.655792 583.219360,414.785095 
	C583.051575,415.079193 583.055969,415.003662 583.091919,415.015411 
	C581.024841,417.766846 580.429626,421.293213 578.085144,424.285614 
	C574.371887,425.071564 572.257507,423.289429 570.456421,420.261597 
	C569.669250,417.859589 570.247131,415.887177 571.147766,414.189697 
	C573.836609,409.121979 573.738525,403.004242 577.640503,398.140656 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M252.322723,587.180237 
	C252.266205,586.517700 252.521271,586.088928 252.900085,585.441895 
	C254.071304,583.789917 255.610870,583.840271 257.084442,584.033569 
	C262.369904,584.726746 267.679871,584.334717 273.394897,584.515015 
	C275.937103,584.590881 278.030762,584.972351 280.530945,585.087769 
	C281.426239,585.042419 281.935852,585.058533 282.818542,585.156067 
	C286.594635,585.716980 289.955627,586.669434 293.836426,586.189941 
	C296.266205,586.786255 298.406494,586.544434 300.870972,587.040222 
	C302.818237,587.623291 304.357605,588.141541 305.888214,588.683777 
	C307.117981,589.119446 308.590668,589.559448 308.304749,591.216003 
	C307.981842,593.086792 306.277344,592.329651 305.104431,592.468140 
	C304.302948,592.562683 303.481201,592.477539 302.327332,592.782959 
	C301.984589,593.024292 302.008911,593.050781 301.994995,593.062134 
	C301.305115,593.552429 300.525940,593.475769 299.379486,593.486328 
	C297.432343,593.612122 295.945831,593.399475 294.246552,592.404663 
	C293.458405,592.275024 293.042969,592.227295 292.313416,592.151611 
	C291.557709,592.069641 291.114594,592.037048 290.336609,592.034668 
	C285.352203,591.439819 280.570801,592.661804 275.607361,591.076294 
	C274.357819,590.833313 273.493134,590.557129 272.309692,590.151733 
	C271.791138,590.135681 271.591309,590.248718 271.114380,590.157288 
	C270.837280,589.952820 270.546570,589.958130 270.402954,589.980713 
	C269.143677,589.189941 267.823883,589.628601 266.303009,589.191772 
	C265.994537,588.975037 265.999023,589.005493 266.012268,588.997559 
	C265.846649,588.870178 265.667816,588.750671 265.226257,588.818420 
	C264.131287,588.988037 263.298981,588.970520 262.052094,588.915894 
	C258.907227,586.726074 255.654205,587.786499 252.322723,587.180237 
z"/>
<path fill="#2478A2" opacity="1.000000" stroke="none" 
	d="
M581.844971,217.698608 
	C584.797974,222.656204 586.049133,228.065536 587.927856,233.627350 
	C583.536133,234.582764 579.023071,233.454483 574.282104,234.785400 
	C569.653259,231.861832 569.734314,226.977264 568.321655,222.389252 
	C568.408997,221.722290 568.487122,221.462097 568.816711,220.880646 
	C572.954895,218.574951 576.987671,217.217224 581.844971,217.698608 
z"/>
<path fill="#30A0CE" opacity="1.000000" stroke="none" 
	d="
M573.928162,198.740540 
	C575.536194,201.439926 576.823242,204.223770 578.163818,207.361679 
	C578.424805,210.435410 576.080261,210.310745 574.540771,210.752289 
	C571.861816,211.520660 569.128540,212.267746 565.854187,211.904480 
	C563.471924,210.830338 562.516724,209.212097 562.483337,206.668884 
	C563.303711,205.207703 564.498413,205.677078 565.764465,205.171249 
	C567.404297,204.139404 568.906250,204.714386 570.592346,204.263336 
	C571.733521,203.501892 572.614136,203.206161 572.536377,203.155212 
	C572.752197,203.268311 571.941833,203.483551 570.859924,204.081360 
	C569.231873,204.736954 567.796875,204.271866 566.149597,204.863403 
	C565.218323,205.548996 564.471619,205.476868 563.360962,205.493073 
	C562.159546,205.530579 561.494934,205.173645 560.640625,204.356339 
	C559.362061,201.403641 557.430603,199.041626 558.053955,195.647064 
	C561.735779,193.198639 565.497437,193.519180 569.624390,193.887970 
	C572.409424,194.685501 572.763489,196.937302 573.928162,198.740540 
z"/>
<path fill="#1D98D1" opacity="1.000000" stroke="none" 
	d="
M58.541561,193.158035 
	C61.498173,193.945557 61.596249,198.271210 65.651276,198.001923 
	C66.465195,198.531235 66.817383,199.189743 66.546669,199.805283 
	C63.863689,205.905838 62.145470,212.503235 57.093750,217.740204 
	C53.701061,218.069412 50.996574,217.624969 49.657337,214.053314 
	C51.754620,206.531281 55.223179,200.039001 58.541561,193.158035 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M593.563599,382.734680 
	C589.699036,383.051819 586.038940,383.166565 582.091553,381.809662 
	C581.522095,381.509491 581.385864,381.290405 581.143005,380.697693 
	C580.930603,379.541504 580.989197,378.763916 581.183716,377.601562 
	C582.584229,372.371552 582.518799,367.226532 584.752258,362.250610 
	C586.407043,362.012665 587.081604,362.975006 587.571899,364.002930 
	C589.196350,367.408844 591.904663,368.583130 595.967041,368.078857 
	C595.541687,372.887665 594.659668,377.664825 593.563599,382.734680 
z"/>
<path fill="#12628E" opacity="1.000000" stroke="none" 
	d="
M593.766724,255.590897 
	C589.633423,256.635132 585.997253,258.417816 582.326172,260.956482 
	C579.848450,260.994904 579.810303,259.195892 579.554321,257.886047 
	C578.834290,254.201385 577.014893,250.755188 577.274902,246.485352 
	C581.416382,242.062683 584.911194,241.363495 590.505493,243.759796 
	C591.822449,247.731613 592.793518,251.471176 593.766724,255.590897 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M299.345428,43.366749 
	C299.007019,39.356148 298.678894,35.644230 299.998230,31.678707 
	C304.703674,31.181675 309.396179,31.084869 314.546692,31.082260 
	C317.479614,34.715275 316.649719,38.508579 315.611145,42.708588 
	C311.589111,45.536488 307.387299,44.243782 302.895813,44.454060 
	C301.474884,44.314911 300.539581,44.168915 299.345428,43.366749 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M540.897278,141.796570 
	C543.426514,145.015244 545.727661,148.081497 547.882507,151.755554 
	C542.192383,151.296005 539.265625,154.173660 537.355225,159.252213 
	C536.564392,159.628082 536.068481,159.673981 535.196167,159.468704 
	C532.131348,155.846634 528.638245,152.833710 528.106934,147.649139 
	C530.280090,140.306152 532.765259,138.807465 539.872253,140.591217 
	C540.252197,140.796600 540.146851,140.837906 540.158203,140.782471 
	C540.202332,141.105652 540.368835,141.411377 540.897278,141.796570 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M224.563721,573.770386 
	C228.387054,575.583801 232.767792,574.060974 235.913208,577.467773 
	C233.966507,579.902710 231.527359,577.868469 228.918121,578.453735 
	C225.111298,577.837158 221.685455,577.616577 217.875992,577.015137 
	C212.186356,576.580383 206.897583,576.565735 201.271332,575.530884 
	C193.014771,574.305359 185.247147,572.899048 177.454102,569.903931 
	C176.684647,569.519287 176.527954,569.146667 176.843689,568.468506 
	C188.482483,569.268372 199.671005,571.923767 211.591049,572.188477 
	C213.820053,572.136597 215.549667,572.683655 217.650421,572.773499 
	C217.973312,572.975037 217.991760,572.987122 217.986298,572.986816 
	C219.971832,574.119385 222.156067,573.188660 224.563721,573.770386 
z"/>
<path fill="#1A6D97" opacity="1.000000" stroke="none" 
	d="
M590.798706,243.626160 
	C586.614990,243.356369 582.447021,243.206711 578.320984,245.861572 
	C577.437012,246.162857 576.962646,246.032043 576.339722,245.298248 
	C575.334900,241.501373 572.815369,238.466232 573.742126,234.319672 
	C578.379578,232.695786 582.773438,231.330475 587.569336,233.959518 
	C588.875916,237.089554 589.810974,240.174911 590.798706,243.626160 
z"/>
<path fill="#AEF6FB" opacity="1.000000" stroke="none" 
	d="
M523.765503,121.927017 
	C528.186279,124.962799 530.848877,129.458908 534.599182,133.435028 
	C531.178589,136.108444 526.483093,136.286423 523.033386,139.692627 
	C519.983582,139.761856 518.763672,137.606628 516.893677,135.758301 
	C516.035217,134.648224 515.660828,133.729660 515.554321,132.343231 
	C517.132202,127.831223 519.973206,124.704605 523.765503,121.927017 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M158.693939,555.128174 
	C154.784378,552.609009 150.505692,551.507568 147.055527,548.344604 
	C147.527344,547.207520 148.392014,547.087402 149.611298,547.060608 
	C150.144745,547.118408 150.354584,547.157898 150.867996,547.287476 
	C151.755646,547.580872 152.331497,547.808167 153.217072,548.060303 
	C153.699890,548.195312 153.891403,548.251953 154.367462,548.393005 
	C155.611954,548.778625 156.580826,548.759949 157.860077,548.518066 
	C158.794205,548.463135 159.411255,548.563599 160.341278,548.723511 
	C161.494400,548.949341 162.300262,549.215515 163.325745,549.789429 
	C164.840195,550.869080 166.321274,550.832397 168.075714,551.031372 
	C168.611069,551.122009 168.825516,551.167053 169.361847,551.290588 
	C171.270126,551.890564 172.832504,551.553528 174.769150,551.202026 
	C178.546036,551.397217 181.924255,551.850708 185.170807,552.901123 
	C187.617905,553.692871 188.304855,555.127319 185.830673,557.323120 
	C184.768661,557.839722 184.012878,557.944885 182.877014,557.807556 
	C180.839920,557.009827 180.106247,554.563904 177.935364,555.501587 
	C178.298340,555.997742 179.642395,555.164734 180.230530,556.524292 
	C180.171982,557.341125 179.937393,557.756653 179.331467,558.366882 
	C178.153778,559.131775 177.170517,559.399170 175.801819,559.728638 
	C169.596359,559.570007 164.317200,557.286621 158.693939,555.128174 
z"/>
<path fill="#F3F8F8" opacity="1.000000" stroke="none" 
	d="
M502.642639,117.895737 
	C504.071777,113.824432 504.696075,109.656311 508.938873,107.351913 
	C512.315430,109.315559 515.044495,112.264015 517.972046,115.443466 
	C517.683838,119.901627 513.094788,121.223328 511.604004,125.083344 
	C508.302094,126.361671 506.986420,123.838623 504.905701,122.129807 
	C503.709747,120.801003 502.666016,119.785164 502.642639,117.895737 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M36.565853,255.259338 
	C39.304966,254.687500 41.667122,255.447769 44.461910,255.962936 
	C46.807961,259.073914 44.746059,261.920929 44.165108,264.815430 
	C43.624611,267.508392 42.863953,270.190186 41.405949,273.043274 
	C38.797604,274.685394 36.391613,275.563263 33.339470,274.251038 
	C33.420849,267.724701 35.005611,261.659271 36.565853,255.259338 
z"/>
<path fill="#2A8AB5" opacity="1.000000" stroke="none" 
	d="
M564.844727,211.324387 
	C569.364929,210.680359 573.589111,209.763412 577.962524,208.026978 
	C580.315735,210.479370 580.690796,213.964142 582.177124,217.367249 
	C578.101807,218.813583 573.957397,219.905502 569.407104,220.993896 
	C565.430725,218.872665 565.161316,215.223206 564.844727,211.324387 
z"/>
<path fill="#E6F1F4" opacity="1.000000" stroke="none" 
	d="
M348.703735,33.673325 
	C350.411621,38.327961 345.904541,40.420277 345.034363,44.308922 
	C343.757965,46.440807 342.013397,45.418240 340.019440,45.407585 
	C338.428040,45.366356 337.309662,45.135788 335.924377,44.311668 
	C334.267426,40.389267 333.319366,36.710644 334.723083,32.475739 
	C339.529327,31.877394 343.918488,33.021217 348.703735,33.673325 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M49.474472,213.896637 
	C51.113941,216.381897 53.899174,216.411621 56.765892,217.083542 
	C58.473549,218.819412 57.528885,220.512695 57.037136,222.567581 
	C55.763988,225.656387 55.184669,228.696426 52.399220,230.876343 
	C49.506397,230.982712 46.964283,230.957794 43.930840,230.896240 
	C44.825016,225.105942 47.116673,219.666107 49.474472,213.896637 
z"/>
<path fill="#8CF2FB" opacity="1.000000" stroke="none" 
	d="
M521.677002,139.424408 
	C525.336975,136.196198 528.881958,133.421631 534.298340,133.819473 
	C536.525330,135.895355 538.293335,138.026199 540.156799,140.476807 
	C535.106567,140.644043 530.263672,140.988373 529.052856,147.879303 
	C528.157471,148.402603 527.500488,148.148911 526.579041,147.568756 
	C524.397461,145.000916 521.897766,143.024933 521.677002,139.424408 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M81.333755,463.285828 
	C77.282806,462.260651 73.426682,461.907166 69.897575,460.641693 
	C67.578171,459.809967 63.723099,458.723663 66.745956,454.306702 
	C73.248581,453.079010 78.966934,455.776825 84.950134,457.432404 
	C81.848366,460.671021 78.514061,457.655701 75.926834,458.431152 
	C83.200882,459.203003 91.031197,460.662781 99.351105,461.643311 
	C100.322304,461.811737 100.852974,462.002594 101.694115,462.543457 
	C102.482613,464.325592 101.346458,464.892426 99.996567,465.752991 
	C93.411949,466.701172 87.402817,466.173828 81.333755,463.285828 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M100.226089,465.303955 
	C100.531090,464.539825 101.101364,464.030731 101.831009,463.277771 
	C104.532555,461.073547 106.786720,462.905273 109.440720,463.859680 
	C111.538200,466.509369 113.324005,468.875488 115.216080,471.576721 
	C113.328712,471.911774 111.335091,471.911774 109.202461,471.911774 
	C109.708572,470.383728 111.268417,471.595703 112.013008,470.411133 
	C97.797775,468.546021 83.406456,468.362488 69.722603,463.893860 
	C73.367958,462.965698 76.694588,464.536835 80.566139,464.891235 
	C83.216225,463.303741 85.446289,464.973602 87.625015,465.129547 
	C93.510345,465.550629 99.401527,466.016693 104.579369,466.321747 
	C103.730492,466.005310 102.027153,466.185791 100.226089,465.303955 
z"/>
<path fill="#12628E" opacity="1.000000" stroke="none" 
	d="
M32.858463,274.387390 
	C35.360718,273.662292 37.735863,273.325989 40.513592,272.979187 
	C41.353004,273.331024 41.643093,273.786743 41.838943,274.744385 
	C41.345833,279.732300 40.318291,284.199677 38.547012,288.893036 
	C36.280411,290.679230 34.287945,292.263885 31.180458,291.268707 
	C30.919788,285.542969 31.828608,280.159973 32.858463,274.387390 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M30.674541,291.395813 
	C33.374565,291.633728 34.856411,288.935547 37.591446,288.996094 
	C40.315533,292.146912 37.968498,295.481842 38.282043,299.127014 
	C37.882198,301.390350 37.481228,303.233185 36.804016,305.417847 
	C34.799023,307.608490 33.241127,309.947845 29.801443,309.188965 
	C29.838634,303.207886 30.171076,297.488342 30.674541,291.395813 
z"/>
<path fill="#CFF3F8" opacity="1.000000" stroke="none" 
	d="
M510.702576,125.976379 
	C511.494659,121.307556 514.608582,118.816704 517.958130,116.063980 
	C520.572449,116.970993 521.898865,119.405159 523.974609,121.472260 
	C521.606934,125.074387 519.124390,128.371490 516.342041,131.823532 
	C512.805298,131.457779 511.648132,128.935608 510.702576,125.976379 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M163.293808,551.132446 
	C162.427643,550.010315 161.538422,550.023865 160.331314,550.002319 
	C158.757751,548.156189 160.265549,547.184204 161.561951,545.828613 
	C164.524200,544.913818 167.108185,545.843567 170.038834,546.055969 
	C170.813629,546.142212 171.310104,547.098389 171.476135,546.245239 
	C171.050140,546.252258 170.889587,546.131470 170.678680,545.709961 
	C170.696091,545.216675 170.763840,545.024170 171.064789,544.632812 
	C172.194611,543.961914 173.216385,543.895630 174.412506,543.424438 
	C174.971313,543.052490 175.264740,542.802490 175.772797,542.359253 
	C177.928604,542.216797 179.863770,542.260559 182.213074,542.306641 
	C183.555725,542.521851 184.493027,542.060486 185.726440,542.512939 
	C187.246582,545.164795 184.605789,546.249146 183.787567,548.293884 
	C182.917084,548.837463 182.285034,549.089539 181.295288,549.349121 
	C180.507446,549.383911 180.069275,549.289795 179.347382,548.974976 
	C178.274139,548.383179 177.433701,548.102600 176.568832,547.919556 
	C175.918777,547.781921 175.598984,548.018250 176.264725,547.997742 
	C176.323654,547.995911 176.390381,548.246826 176.492523,548.684509 
	C176.161087,551.354187 173.490433,550.647400 172.093765,552.231689 
	C171.046432,552.503784 170.319534,552.493896 169.291489,552.184082 
	C168.990616,551.968323 168.995743,552.007874 169.014053,552.000000 
	C167.315033,550.928833 165.384415,551.805359 163.293808,551.132446 
z"/>
<path fill="#61D6F8" opacity="1.000000" stroke="none" 
	d="
M555.581787,163.798538 
	C555.918945,164.035461 556.100708,164.367310 556.089233,164.556152 
	C556.448608,165.395294 556.418640,166.249191 557.351440,166.461090 
	C557.609558,166.176941 557.771484,166.383514 557.801514,166.511261 
	C557.440002,167.007477 557.353271,167.447815 557.513062,168.322708 
	C554.572571,171.736816 551.328674,174.372482 547.209412,176.343353 
	C543.519897,173.652206 540.753662,170.664108 540.841675,165.749329 
	C544.937378,162.814651 549.453003,163.566406 554.103943,163.092102 
	C554.747559,163.327301 554.996094,163.444458 555.581787,163.798538 
z"/>
<path fill="#37AFE9" opacity="1.000000" stroke="none" 
	d="
M571.125916,194.728210 
	C566.898438,194.970291 562.820190,194.727936 558.436890,195.968613 
	C555.925415,195.238174 555.176819,193.413055 554.423462,191.198029 
	C554.459656,190.579391 554.519714,190.335098 554.791138,189.776154 
	C558.075317,187.184052 561.264465,185.169815 565.620117,184.980774 
	C566.480469,185.192993 566.954407,185.378586 567.739502,185.792542 
	C568.057678,186.003067 568.244263,186.280518 568.176270,186.433258 
	C568.254822,187.037689 568.374817,187.496338 568.491211,188.317078 
	C569.225708,190.687317 571.057678,192.160629 571.125916,194.728210 
z"/>
<path fill="#A0F5FC" opacity="1.000000" stroke="none" 
	d="
M315.349609,43.171577 
	C315.024597,39.228737 315.014404,35.648804 315.004456,31.622662 
	C317.387207,31.154696 319.769653,31.132936 322.587585,31.213837 
	C325.509857,34.856655 325.959808,38.674095 324.268494,43.099579 
	C321.206604,44.863800 318.441620,44.864243 315.349609,43.171577 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M142.736420,502.114471 
	C144.746811,502.438171 145.727921,504.031525 146.929855,505.855164 
	C143.568939,508.168457 139.824524,506.480530 136.332870,507.751373 
	C137.430923,509.870911 139.523758,510.702209 141.094025,512.553101 
	C141.480728,513.299133 141.515625,513.771423 141.214691,514.544617 
	C135.475067,514.504639 133.085770,509.282043 128.464783,506.949036 
	C127.365685,506.631317 126.615868,506.370819 126.152359,505.259338 
	C125.448059,504.493500 124.901207,503.980530 124.151230,503.270081 
	C123.596222,502.672211 123.471428,502.210449 123.813568,501.398010 
	C124.715096,501.114044 125.608627,500.839630 126.003670,501.166901 
	C131.225662,505.493011 136.961548,502.694489 142.736420,502.114471 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M125.806084,85.277733 
	C126.055565,85.065712 126.516167,85.021431 126.746384,84.998428 
	C129.668060,82.966324 131.415115,79.467361 135.752655,79.829041 
	C136.041763,85.441002 130.634995,86.342751 127.832260,89.173088 
	C124.532707,92.505150 121.063019,95.857338 117.474236,98.985222 
	C116.245430,100.056213 115.104546,102.281708 113.033157,99.562592 
	C112.362259,95.555595 116.261734,94.957542 117.794617,92.311867 
	C118.529655,91.778931 119.004410,91.496101 119.729980,91.096619 
	C122.064362,89.378365 123.605263,87.225639 125.806084,85.277733 
z"/>
<path fill="#032B57" opacity="1.000000" stroke="none" 
	d="
M85.602959,458.467957 
	C79.200455,456.793945 73.433395,455.542755 67.295410,454.165955 
	C61.913879,454.099701 62.502949,449.748383 61.241573,446.622925 
	C70.275696,451.108032 79.458069,454.921173 89.687088,456.944519 
	C90.172943,457.201355 90.261948,457.441528 90.152077,458.012238 
	C88.807083,459.150146 87.547295,459.186859 85.602959,458.467957 
z"/>
<path fill="#033256" opacity="1.000000" stroke="none" 
	d="
M122.892197,480.741760 
	C124.509453,482.412018 125.814255,483.893829 127.271217,485.686920 
	C116.097542,487.113617 105.705612,482.806244 94.952904,480.496307 
	C103.801109,480.682159 112.517586,483.198547 121.709717,481.295471 
	C122.194031,480.849823 122.386887,480.701569 122.892197,480.741760 
z"/>
<path fill="#0A4271" opacity="1.000000" stroke="none" 
	d="
M100.506058,462.721039 
	C91.283127,462.602997 82.743393,460.483490 74.155746,458.051971 
	C77.456245,458.051971 80.756744,458.051971 84.512375,458.048584 
	C84.967514,458.045166 84.989738,458.016907 84.981079,458.018707 
	C86.347954,458.964752 87.897163,458.330017 89.735809,458.460632 
	C90.859734,458.166473 91.606796,458.108093 92.696266,458.583191 
	C95.121437,458.832092 97.206749,458.899963 99.644089,458.969604 
	C101.804688,458.158203 103.658333,458.742065 105.842621,458.821930 
	C106.798874,459.662720 107.407326,460.475372 108.064049,461.596619 
	C105.859932,463.905731 103.248100,461.814026 100.506058,462.721039 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M29.372524,309.381317 
	C32.191975,309.512146 33.091370,306.490051 35.620857,306.025452 
	C38.865520,310.594910 35.979984,315.227417 35.833000,320.264099 
	C34.174313,322.497864 32.286930,323.061157 29.690697,322.212708 
	C29.310595,317.896088 29.274727,313.865662 29.372524,309.381317 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M212.167099,568.644531 
	C211.694305,569.425415 211.376999,569.859863 211.039185,570.577026 
	C202.318802,569.544983 193.578705,568.436646 185.003723,565.462524 
	C185.058472,564.921936 185.240753,564.742981 185.789124,564.454346 
	C187.399979,564.567932 188.660034,564.490051 190.262421,564.637451 
	C191.718536,566.140076 193.644577,564.951599 194.811676,565.864868 
	C194.089676,564.915710 192.903610,565.753967 191.629105,565.333252 
	C190.302216,564.244934 189.036697,564.540588 187.486755,564.401428 
	C186.709015,564.037537 186.431610,563.641052 186.229828,562.789917 
	C186.232178,562.175171 186.274811,561.931152 186.492249,561.363037 
	C186.871780,560.908142 187.076492,560.777466 187.641571,560.621155 
	C189.535400,561.087097 190.993591,561.867188 193.012695,561.847168 
	C195.139862,562.270264 196.944504,562.614014 198.341064,564.398865 
	C198.394562,565.380493 198.141251,566.273865 199.688293,565.422607 
	C200.214676,565.225891 200.435074,565.160583 201.003723,565.037354 
	C204.787033,565.265198 208.186417,565.714966 211.666992,567.393188 
	C212.083618,567.851624 212.203094,568.074829 212.167099,568.644531 
z"/>
<path fill="#033B5F" opacity="1.000000" stroke="none" 
	d="
M128.945862,488.051300 
	C132.854980,491.511383 136.308029,494.957703 139.858749,498.726166 
	C136.352692,498.635590 132.748962,498.222870 128.730927,497.817383 
	C125.654373,495.048828 127.630936,493.623688 130.354141,492.143463 
	C127.474190,493.168915 125.015984,493.237762 122.397308,492.013916 
	C122.242569,491.692688 122.207794,491.318268 122.168121,491.134460 
	C121.766983,490.070099 121.445450,489.193817 122.700684,488.290222 
	C124.833794,488.097076 126.661812,488.067322 128.945862,488.051300 
z"/>
<path fill="#E6F1F4" opacity="1.000000" stroke="none" 
	d="
M358.194641,41.571491 
	C357.045197,43.038143 356.337952,42.759029 356.052246,41.440571 
	C355.639404,39.535763 355.350189,37.604168 355.009155,35.273907 
	C362.237244,35.140793 368.955872,37.951172 376.400330,39.135521 
	C376.968536,39.335243 377.148621,39.478718 377.201721,39.943375 
	C370.809387,40.002811 364.550842,39.877106 358.194641,41.571491 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M117.708939,92.035591 
	C118.654205,95.860260 114.400398,96.061646 113.104202,98.896317 
	C107.464798,104.617905 101.962173,109.999763 96.365662,115.681831 
	C95.779297,116.002258 95.286812,116.022469 94.428467,116.050034 
	C93.972076,113.691734 95.971306,112.699364 97.260170,111.265869 
	C102.345207,105.610237 108.536064,101.002296 112.993515,94.370651 
	C113.499222,93.012733 114.226379,92.305130 115.664467,92.017120 
	C116.438835,91.979660 116.900894,91.994537 117.708939,92.035591 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M356.420715,599.031189 
	C355.682678,592.700012 355.881561,592.190491 362.240784,593.142883 
	C366.415253,593.768005 370.759583,593.454651 375.242035,595.155029 
	C369.613678,597.515625 363.169464,598.002441 356.420715,599.031189 
z"/>
<path fill="#CFF3F8" opacity="1.000000" stroke="none" 
	d="
M334.584717,32.014561 
	C335.339386,35.689735 335.676361,39.249352 336.023254,43.224655 
	C335.408844,44.965675 334.191681,44.974400 332.536804,44.956154 
	C330.875122,44.617439 329.769165,44.117641 328.538971,42.933338 
	C327.191315,39.188618 326.939545,35.839924 328.734253,32.138611 
	C330.717010,31.798679 332.442017,31.848839 334.584717,32.014561 
z"/>
<path fill="#033E75" opacity="1.000000" stroke="none" 
	d="
M152.282822,527.569824 
	C141.774429,527.164307 131.656906,525.182312 121.230728,523.254333 
	C120.887260,522.725830 120.802849,522.494385 121.021057,522.051025 
	C131.290955,522.896301 141.258224,523.953613 151.665924,525.110657 
	C152.642838,525.819214 152.727020,526.513184 152.282822,527.569824 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M161.808868,545.845337 
	C161.382095,547.256592 160.734390,548.311401 160.043945,549.683105 
	C159.491486,549.737183 158.981735,549.474426 158.200256,549.118896 
	C156.917343,549.744995 155.776794,549.424194 154.323273,549.203857 
	C153.969589,548.977051 153.996216,549.007446 154.016113,549.010742 
	C153.333710,548.270020 152.364197,548.586121 151.256927,548.182617 
	C150.987930,547.983765 150.995956,548.007324 151.008057,548.004517 
	C149.007477,546.599304 146.161392,547.619080 144.091095,545.423706 
	C141.409515,544.344971 139.138214,543.209534 136.929504,541.307983 
	C136.956863,540.825989 137.169037,540.639587 137.779327,540.308228 
	C146.042526,541.667847 153.986420,542.825928 161.808868,545.845337 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M187.007309,534.793335 
	C187.369934,534.926880 187.667465,534.874451 187.760895,534.993164 
	C188.594269,535.868042 189.314346,536.659180 190.786255,536.772461 
	C191.065720,536.925903 191.065598,536.993652 191.077927,536.960999 
	C191.203995,537.541931 191.023315,538.051453 190.176514,538.674438 
	C183.769867,539.408813 177.983459,538.478088 172.266052,535.558472 
	C172.034836,534.103210 172.010025,533.023071 171.978729,531.537842 
	C176.477936,528.782410 180.101257,531.500305 184.260651,533.365234 
	C185.309280,533.876404 185.878983,534.442261 187.007309,534.793335 
z"/>
<path fill="#1391DB" opacity="1.000000" stroke="none" 
	d="
M566.437012,452.058655 
	C565.646484,451.288696 564.784302,451.003632 563.400391,451.028503 
	C562.252380,449.651215 562.992737,448.483337 563.631470,447.371246 
	C566.643494,442.126678 569.916992,437.036499 572.871765,431.756775 
	C573.442505,430.736908 574.257629,429.934113 575.851807,429.865295 
	C576.276367,430.239075 576.346619,430.481171 576.382324,431.099762 
	C573.528442,438.452759 570.338501,445.254211 566.437012,452.058655 
z"/>
<path fill="#055280" opacity="1.000000" stroke="none" 
	d="
M123.097168,480.619629 
	C123.004059,480.941498 122.803474,480.952789 122.302032,480.981079 
	C114.775726,478.939148 107.382652,477.809448 99.503021,476.977112 
	C98.743416,475.065338 100.274063,475.261841 101.666664,474.841553 
	C107.179871,475.140503 112.344856,475.516571 117.953659,475.827881 
	C119.928207,477.278442 121.458946,478.793732 123.097168,480.619629 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M328.656647,31.571827 
	C328.995514,35.177860 328.999023,38.607204 329.003906,42.496239 
	C327.713470,44.275024 326.244110,44.236244 324.361877,43.180450 
	C324.529205,39.191849 323.075836,35.727421 323.023743,31.723438 
	C324.789154,31.342710 326.555206,31.368925 328.656647,31.571827 
z"/>
<path fill="#0CA3DE" opacity="1.000000" stroke="none" 
	d="
M599.818970,330.406982 
	C593.736389,329.964813 589.315796,325.906403 588.833008,320.406250 
	C588.735474,319.783386 588.679871,319.559448 588.824951,319.053833 
	C589.249146,318.716492 589.472595,318.660828 590.033752,318.675110 
	C593.564270,321.185150 597.367615,322.901917 599.720215,326.815216 
	C599.883667,328.096283 599.900085,329.073730 599.818970,330.406982 
z"/>
<path fill="#040914" opacity="1.000000" stroke="none" 
	d="
M122.015839,491.998596 
	C125.161896,491.421204 128.054245,491.536926 131.408646,492.431641 
	C129.143951,493.419250 127.586830,494.656982 128.237793,497.466492 
	C126.662201,497.882233 125.005981,498.015808 123.353867,497.976532 
	C121.600166,497.934845 119.235146,498.628357 118.519218,496.491058 
	C117.690445,494.016876 120.090691,493.252197 122.015839,491.998596 
z"/>
<path fill="#248BBE" opacity="1.000000" stroke="none" 
	d="
M185.347351,534.411133 
	C181.139297,532.472839 176.974091,531.688843 172.373260,531.082153 
	C170.869675,530.903320 169.767105,530.673889 168.361771,530.292969 
	C167.296143,529.363953 166.044861,528.696289 167.755829,527.278564 
	C168.491394,527.066162 168.920349,527.006470 169.663422,526.863403 
	C170.612442,526.302185 171.321899,526.001465 172.383301,525.784851 
	C177.046448,528.268250 181.434464,530.850037 186.026871,533.718018 
	C186.052307,534.153198 185.873367,534.302368 185.347351,534.411133 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M186.863541,561.947449 
	C187.114075,562.637634 187.088745,563.004578 187.077515,563.647278 
	C186.968170,564.122498 186.844727,564.321960 186.404648,564.675049 
	C185.884354,564.866211 185.680679,564.903809 185.176605,565.021179 
	C184.876190,565.100891 184.924805,565.032104 184.957214,565.059021 
	C184.057587,564.060303 182.852264,564.622559 181.445938,564.670715 
	C174.962524,563.370483 168.988739,561.361877 163.119446,558.315857 
	C164.288834,556.651184 165.714478,557.337097 167.122299,557.754211 
	C171.086334,558.928467 175.125687,559.653992 179.678650,559.883484 
	C182.147171,560.955566 184.661911,560.137512 186.863541,561.947449 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M29.252466,322.357361 
	C30.977789,321.618073 32.609116,321.309631 34.609554,320.989624 
	C35.654816,321.644379 35.746929,322.435944 35.245888,323.656799 
	C35.008186,326.046570 35.002361,328.084595 34.996063,330.559387 
	C33.755299,332.143372 32.400452,332.948975 30.276075,332.243103 
	C29.600906,328.949799 28.689856,325.927307 29.252466,322.357361 
z"/>
<path fill="#032B57" opacity="1.000000" stroke="none" 
	d="
M101.709763,474.520874 
	C101.650620,476.063568 100.277832,475.828522 99.269989,476.690063 
	C92.666084,476.414062 86.389023,475.108795 80.130165,473.434753 
	C87.300980,471.056885 94.313126,474.100769 101.709763,474.520874 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M167.655304,527.034424 
	C167.554596,527.924927 167.245132,528.738770 167.967682,529.882080 
	C162.946762,529.781311 157.851456,529.297729 152.466156,527.963745 
	C152.066315,527.206421 152.060715,526.540161 152.080734,525.542236 
	C157.218323,525.222351 162.301025,525.490051 167.655304,527.034424 
z"/>
<path fill="#0A4271" opacity="1.000000" stroke="none" 
	d="
M599.949585,326.710449 
	C596.644836,324.621307 593.422424,322.123779 590.038269,319.324066 
	C589.133789,315.540192 591.027710,314.986328 593.690979,315.865112 
	C595.714783,316.532898 597.194885,318.184906 599.116699,319.804199 
	C600.701782,322.003326 599.921021,324.191467 599.949585,326.710449 
z"/>
<path fill="#050E18" opacity="1.000000" stroke="none" 
	d="
M106.088058,458.526733 
	C104.521591,460.979797 102.574013,459.904694 100.333046,459.150757 
	C99.996124,458.971313 100.009460,458.473938 100.015915,458.225220 
	C100.147598,457.883179 100.266609,457.779694 100.399185,457.698303 
	C100.929535,457.372742 101.635178,457.718994 102.130371,457.250793 
	C101.627693,457.628754 101.062416,457.414459 100.247559,457.217163 
	C99.974655,457.013397 100.000526,456.998779 99.994568,457.012329 
	C99.518303,456.414673 98.797256,456.092926 98.149635,455.284912 
	C98.744911,451.784271 95.627403,451.433929 94.041000,449.529175 
	C95.559135,447.744659 97.241318,449.474854 99.242546,449.160156 
	C100.653015,449.625061 101.130539,450.508331 101.772964,451.744812 
	C103.321289,454.102905 104.653496,456.153168 106.088058,458.526733 
z"/>
<path fill="#050E18" opacity="1.000000" stroke="none" 
	d="
M99.511543,465.047546 
	C102.550919,465.413147 105.141029,465.777435 107.731133,466.141693 
	C98.986755,467.564880 90.391464,466.362885 81.384415,464.953918 
	C80.976776,464.470764 80.988045,464.051483 80.999680,463.316864 
	C87.008408,463.792419 92.939461,465.266235 99.511543,465.047546 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M186.362610,543.501831 
	C185.111008,543.056885 184.173004,542.876282 182.931107,542.502319 
	C182.963623,542.067749 183.300034,541.826538 183.801483,541.323853 
	C188.812576,538.592224 193.508804,540.644714 198.653961,541.747559 
	C199.064392,541.959656 199.003738,541.992676 199.013977,541.959717 
	C199.440460,542.501709 200.108398,542.503906 201.010345,542.757080 
	C201.653549,542.844360 201.976074,542.915344 202.531158,543.072998 
	C203.622116,543.662903 205.191772,543.348572 204.838867,545.310730 
	C201.240173,546.999268 197.825546,546.394287 194.023926,546.170898 
	C191.341156,545.199463 188.631470,545.599976 186.362610,543.501831 
z"/>
<path fill="#021429" opacity="1.000000" stroke="none" 
	d="
M125.704231,505.306763 
	C126.598518,505.467560 127.202103,505.928680 127.970123,506.627960 
	C126.230240,508.172394 124.060791,507.996948 121.914032,508.004913 
	C114.856750,508.031067 107.905365,507.210052 101.047333,505.385498 
	C109.180717,505.692017 117.290787,506.705536 125.704231,505.306763 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M68.331406,421.333069 
	C66.193764,418.975952 63.523880,420.764435 61.264427,419.291931 
	C61.004692,419.016174 60.996960,418.518707 60.990448,418.270294 
	C63.389156,418.343964 65.794380,418.666016 68.613594,418.978455 
	C73.303162,417.105713 77.399422,418.863892 81.514946,419.678589 
	C82.658836,419.905060 84.374908,420.238434 83.891602,422.102814 
	C83.513611,423.560913 81.831894,424.516724 80.831665,423.989502 
	C76.957497,421.947571 72.473045,423.578369 68.331406,421.333069 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M136.279999,80.039612 
	C132.424271,80.256279 131.063324,84.317680 127.334732,84.956711 
	C127.303711,83.888939 127.630836,82.802460 127.997910,81.375580 
	C128.517975,80.759735 128.998077,80.484276 129.728241,80.088593 
	C130.970123,79.173615 131.502762,78.002182 132.572922,76.861588 
	C132.982712,76.525543 133.163895,76.412064 133.637939,76.167618 
	C135.706268,75.713707 136.752991,74.122940 138.687683,73.443710 
	C139.248245,73.428970 139.474197,73.465363 140.003708,73.670868 
	C140.456589,74.019836 140.605881,74.199707 140.915161,74.694176 
	C141.381958,75.958931 141.475128,76.866653 140.272552,77.773849 
	C139.979584,77.972420 139.996475,77.999390 139.984863,77.985870 
	C139.343613,78.891190 138.125427,78.813141 137.178711,79.753204 
	C136.991638,79.994652 136.516724,80.017647 136.279999,80.039612 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M198.949127,541.637146 
	C194.274078,542.362793 189.562973,541.577148 184.401855,541.037109 
	C183.540863,541.036804 183.115234,541.011169 182.369568,540.980896 
	C182.207397,538.148071 184.514816,539.382996 186.279114,538.844055 
	C187.545563,538.418518 188.518631,538.579590 189.731247,538.212036 
	C190.272400,537.779297 190.538071,537.567688 190.946991,537.142212 
	C194.100800,537.632507 196.344528,539.690369 198.949127,541.637146 
z"/>
<path fill="#022D4E" opacity="1.000000" stroke="none" 
	d="
M122.538574,488.083496 
	C122.823174,488.976593 122.640579,489.826355 122.293213,490.813385 
	C115.478561,490.221497 108.828682,489.492310 102.178795,488.763153 
	C102.185356,488.522156 102.191917,488.281158 102.198479,488.040161 
	C108.822777,488.040161 115.447083,488.040161 122.538574,488.083496 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M21.013063,342.444916 
	C21.915234,341.921967 22.698044,341.669800 22.958382,340.315186 
	C23.843060,340.138947 25.064861,340.553345 24.770855,341.316772 
	C23.109959,345.629486 25.387085,350.027069 24.140690,354.663818 
	C20.301804,351.628937 21.933201,346.941895 21.013063,342.444916 
z"/>
<path fill="#044371" opacity="1.000000" stroke="none" 
	d="
M189.570724,537.980347 
	C189.429626,538.934875 188.471970,538.993835 187.161423,539.099854 
	C181.606262,539.750732 176.471375,539.656250 171.208847,537.432556 
	C168.887527,536.732605 166.856674,536.357422 164.441605,535.933350 
	C163.677612,535.567749 163.533096,535.160645 163.837677,534.427673 
	C166.462616,534.493286 168.842636,534.806396 171.641144,535.151367 
	C177.686356,536.510254 183.325165,537.763062 189.570724,537.980347 
z"/>
<path fill="#021429" opacity="1.000000" stroke="none" 
	d="
M180.162003,560.712280 
	C174.606201,560.023071 169.203979,558.999939 163.390381,557.982544 
	C162.978989,557.988281 163.019897,557.990051 163.022675,558.010742 
	C162.304199,557.215576 161.269058,557.619873 160.110474,557.167542 
	C158.764923,556.781921 156.729156,557.625000 158.164795,554.967651 
	C164.096130,556.139282 169.725479,557.469238 175.753372,558.796997 
	C177.369965,558.326660 178.535309,558.436646 179.891510,559.389771 
	C180.194550,559.903503 180.255081,560.140930 180.162003,560.712280 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M156.861786,514.817749 
	C159.142654,515.958923 161.097412,517.118835 163.039795,518.626770 
	C158.169418,518.221680 153.311432,517.468506 148.195282,516.403564 
	C147.632095,515.705750 147.454422,515.270264 147.511841,514.426270 
	C147.986679,513.446777 148.564011,513.039307 149.524536,512.576599 
	C152.583237,511.820801 154.229904,514.251648 156.861786,514.817749 
z"/>
<path fill="#022D4E" opacity="1.000000" stroke="none" 
	d="
M138.368027,540.764709 
	C137.808975,541.002258 137.597427,541.017273 137.065277,541.022339 
	C135.062012,540.944824 134.639221,539.119202 133.152557,538.281982 
	C139.948318,537.522095 146.612640,539.684387 153.779877,540.486694 
	C154.215805,540.963928 154.323044,541.222046 154.248596,541.858276 
	C148.727036,543.689941 143.877014,540.704956 138.368027,540.764709 
z"/>
<path fill="#032B57" opacity="1.000000" stroke="none" 
	d="
M100.189560,449.740234 
	C98.239120,449.766083 96.478790,449.471252 94.335365,449.186188 
	C88.264145,447.811737 82.576012,446.427521 76.506821,444.998016 
	C79.087372,442.830170 81.840706,445.172699 84.619987,445.533478 
	C89.201347,446.128265 93.604561,447.885010 98.731308,448.007812 
	C100.137550,447.982361 100.401207,448.580566 100.189560,449.740234 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M599.453979,319.663391 
	C597.246948,320.060699 596.113159,318.145874 594.443298,317.196838 
	C592.620239,316.160736 590.775696,315.109192 589.945129,318.667603 
	C589.876587,319.021881 589.516296,319.019958 589.336182,319.024109 
	C587.050476,316.833618 587.330872,314.389160 588.750610,311.522522 
	C592.306213,313.417175 595.516785,315.650848 599.095581,317.958313 
	C599.450806,318.467316 599.437988,318.902496 599.453979,319.663391 
z"/>
<path fill="#197AAB" opacity="1.000000" stroke="none" 
	d="
M576.602051,431.222839 
	C576.276062,431.190948 576.204163,430.905579 576.059937,430.184753 
	C574.469604,427.482697 575.513672,425.866943 577.634460,424.201874 
	C578.961121,420.807098 580.213684,417.776978 582.798706,415.148987 
	C581.797974,420.640503 579.174011,425.744751 576.602051,431.222839 
z"/>
<path fill="#022D4E" opacity="1.000000" stroke="none" 
	d="
M163.653412,534.100098 
	C164.063797,534.558899 164.044998,534.937683 164.041779,535.600403 
	C158.369553,535.202759 152.681747,534.521057 146.993927,533.839417 
	C152.483749,532.664490 157.872009,532.886597 163.653412,534.100098 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M170.715149,537.345093 
	C175.940552,537.769226 180.962738,538.430664 186.394913,539.115356 
	C185.693512,540.674866 183.747940,539.446167 182.261932,540.710632 
	C181.567657,540.975403 181.085785,540.974426 180.244431,540.939453 
	C178.454941,539.338623 176.593201,539.403198 174.425858,539.731079 
	C172.065536,539.563965 169.992584,539.202576 167.850891,538.829163 
	C168.458008,537.487671 169.814896,538.312378 170.715149,537.345093 
z"/>
<path fill="#61D6F8" opacity="1.000000" stroke="none" 
	d="
M558.741577,168.972900 
	C562.008972,172.959137 564.489441,177.303558 565.955139,182.650360 
	C562.405212,182.566589 562.230042,179.173233 560.233398,176.915924 
	C559.163696,174.750580 558.002502,172.998184 557.599976,170.568848 
	C557.763916,169.762741 558.036560,169.389862 558.741577,168.972900 
z"/>
<path fill="#033256" opacity="1.000000" stroke="none" 
	d="
M29.924082,332.434998 
	C31.376684,331.683350 32.814590,331.345978 34.624039,331.002350 
	C34.857655,333.854614 36.128582,337.685150 30.432892,336.999146 
	C29.977892,335.615692 29.943638,334.232483 29.924082,332.434998 
z"/>
<path fill="#022D4E" opacity="1.000000" stroke="none" 
	d="
M200.867065,575.624390 
	C206.299057,575.650513 211.734604,575.940063 217.619385,576.357910 
	C218.166336,576.716125 218.264053,576.946106 218.197479,577.513062 
	C212.651764,577.554138 207.270370,577.258240 201.425079,576.949829 
	C200.931000,576.587524 200.900818,576.237671 200.867065,575.624390 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M527.518677,502.256134 
	C528.856812,502.063080 529.681641,502.089722 530.910645,502.206116 
	C529.186096,504.859955 527.057373,507.424103 524.648254,510.159729 
	C524.131409,510.225983 523.894836,510.120758 523.449585,509.686829 
	C522.795471,508.068359 522.796692,506.812988 523.782837,505.320984 
	C524.036194,505.028015 524.007996,504.998566 524.017334,505.014130 
	C524.370300,504.567078 524.640808,504.049713 525.294250,503.477966 
	C526.015076,503.024872 526.526978,502.780151 527.518677,502.256134 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M171.227570,544.793579 
	C171.002167,545.022156 171.022034,545.436279 171.035919,545.643127 
	C169.534729,547.168762 168.102158,545.752380 166.320877,545.503357 
	C166.219971,544.985779 165.601486,543.714294 165.212753,543.629089 
	C164.134293,543.392761 163.509796,542.787476 163.819031,541.339600 
	C166.905167,540.783875 169.765610,540.554688 172.774109,541.776855 
	C173.311493,542.790894 172.922867,543.298157 172.213318,543.973633 
	C171.784378,544.294189 171.618668,544.429565 171.227570,544.793579 
z"/>
<path fill="#032B57" opacity="1.000000" stroke="none" 
	d="
M163.589249,540.994629 
	C164.545425,544.253967 167.519226,542.254700 169.360748,543.548096 
	C168.191040,543.901978 167.325333,544.163879 166.251740,544.671631 
	C164.098419,546.226868 162.112259,545.074402 160.336990,544.660706 
	C157.324493,543.958618 160.105743,542.784668 160.345657,542.115540 
	C158.596451,543.048950 156.686310,543.660706 154.285278,542.223022 
	C154.017822,541.719421 154.027832,541.517273 154.073196,541.010498 
	C157.117813,540.778625 160.127045,540.851440 163.589249,540.994629 
z"/>
<path fill="#033B5F" opacity="1.000000" stroke="none" 
	d="
M123.593132,501.052948 
	C124.025101,501.544556 123.996918,501.980316 123.958420,502.744385 
	C119.641045,502.681396 115.333984,502.290161 110.595917,501.878357 
	C109.722771,501.570465 109.559906,501.161255 109.931396,500.433411 
	C114.467140,501.493683 118.828712,500.769928 123.593132,501.052948 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M571.102844,195.337463 
	C570.000183,193.257950 569.036255,191.467926 568.045349,189.336334 
	C568.288940,188.826355 568.559448,188.657928 569.283203,188.641327 
	C571.194885,191.851059 572.653320,194.908966 574.180420,198.311478 
	C571.542114,199.338730 572.444946,196.437180 571.102844,195.337463 
z"/>
<path fill="#021429" opacity="1.000000" stroke="none" 
	d="
M109.753067,500.144409 
	C110.186775,500.583282 110.147575,500.947144 110.136642,501.584412 
	C105.628883,500.310028 100.597443,501.960236 96.179314,499.290375 
	C100.535667,500.044586 104.908066,500.051666 109.753067,500.144409 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M607.705994,300.277832 
	C610.004883,302.503754 608.564758,305.436554 608.985840,308.580353 
	C605.265076,306.787567 607.351685,303.487701 607.705994,300.277832 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M226.974304,584.360718 
	C229.762512,583.672424 232.444824,584.431641 235.545898,585.048645 
	C236.309921,585.449890 236.476685,585.838440 236.163818,586.561096 
	C233.154312,586.400330 230.388016,585.999207 227.315063,585.377075 
	C227.003113,584.979248 226.997772,584.802368 226.974304,584.360718 
z"/>
<path fill="#0CA3DE" opacity="1.000000" stroke="none" 
	d="
M121.154785,521.500427 
	C121.226952,522.013428 121.130226,522.187744 121.002586,522.659668 
	C118.309761,523.553345 116.212914,522.547302 113.747856,520.099182 
	C116.686890,519.906494 118.890160,519.845215 121.154785,521.500427 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M147.889069,514.021973 
	C148.069000,514.794861 148.041962,515.166077 147.976013,515.814514 
	C145.896011,515.459473 143.598862,516.770752 141.333191,515.050781 
	C140.993164,514.473328 140.992569,514.111572 140.989334,513.478149 
	C143.335236,511.455933 145.512085,512.482666 147.889069,514.021973 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M403.019012,32.408451 
	C403.447662,32.086990 403.875214,32.088997 404.621277,32.124371 
	C405.106812,34.319122 407.251617,33.844814 408.685608,34.869976 
	C408.991547,35.182652 408.985077,35.359482 408.951996,35.801239 
	C407.016235,35.423313 404.672668,36.573746 403.037903,34.338978 
	C403.007080,33.596809 403.012512,33.164364 403.019012,32.408451 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M140.343445,77.982300 
	C140.103867,77.103027 140.228149,76.233627 140.363022,75.092178 
	C140.737411,74.336861 141.158981,73.918327 141.988159,73.543106 
	C142.475006,73.466049 142.674988,73.481003 143.053406,73.738159 
	C144.937897,76.920792 143.145599,77.659752 140.343445,77.982300 
z"/>
<path fill="#075479" opacity="1.000000" stroke="none" 
	d="
M249.693481,595.772827 
	C250.002029,596.018311 249.993179,596.462891 250.036804,596.680908 
	C247.549271,597.576355 245.326065,595.825867 242.457428,595.931152 
	C241.920944,595.732239 241.787918,595.585388 241.822723,595.193359 
	C244.455353,595.141235 246.920151,595.334290 249.693481,595.772827 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M143.793930,545.385132 
	C146.119568,545.900024 148.383881,546.651245 150.834183,547.702026 
	C149.934006,548.001770 148.847839,548.001892 147.353851,548.006958 
	C146.946030,548.011902 146.994247,547.992981 147.001068,548.018066 
	C146.584320,547.512024 145.937088,547.498047 145.096863,547.162109 
	C143.853424,547.031921 143.146866,546.846130 143.793930,545.385132 
z"/>
<path fill="#011B36" opacity="1.000000" stroke="none" 
	d="
M97.650154,455.019409 
	C98.916313,455.120758 99.691757,455.376587 99.957954,456.706970 
	C97.868217,457.201050 95.906792,456.690002 93.300880,455.282349 
	C95.086052,455.160278 96.181099,455.085419 97.650154,455.019409 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M396.003143,31.462406 
	C397.776733,31.406881 399.710907,31.492348 400.970398,33.625977 
	C399.238373,33.572186 397.291046,33.523552 396.003143,31.462406 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M441.066406,50.354263 
	C442.380310,50.165859 444.058075,49.429234 444.936707,51.641388 
	C443.624542,51.826168 441.941437,52.578903 441.066406,50.354263 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M174.507446,539.939514 
	C176.089767,538.687256 178.002991,538.213684 179.839172,540.556152 
	C178.215439,540.588135 176.545929,540.270874 174.507446,539.939514 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M22.364342,332.949432 
	C22.015081,331.943573 22.008146,330.868896 22.007175,329.391205 
	C24.732218,329.842377 24.649948,331.195709 22.364342,332.949432 
z"/>
<path fill="#0F62A1" opacity="1.000000" stroke="none" 
	d="
M171.345154,544.146118 
	C171.572601,543.425537 172.142563,542.985657 172.845535,542.309204 
	C173.734177,542.070129 174.489807,542.067749 175.619446,542.119202 
	C175.995712,542.579285 175.997986,542.985535 175.999969,543.696533 
	C174.632843,544.857849 173.134048,544.376770 171.345154,544.146118 
z"/>
<path fill="#065486" opacity="1.000000" stroke="none" 
	d="
M217.727646,572.721191 
	C216.184814,572.877502 214.396301,572.780029 212.327301,572.433777 
	C212.014023,572.007263 211.981247,571.829407 211.909668,571.383179 
	C213.741226,571.565613 215.611603,572.016541 217.727646,572.721191 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M137.347824,79.998260 
	C135.927750,77.207779 138.179260,78.226151 139.645737,77.969971 
	C139.954330,79.473457 139.082794,80.021255 137.347824,79.998260 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M172.464203,525.566406 
	C172.979370,527.617981 171.527756,526.763733 170.348434,526.850159 
	C169.972931,526.231567 169.968307,525.683167 169.997223,524.865112 
	C170.777161,524.879089 171.523575,525.162720 172.464203,525.566406 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M241.757385,594.699951 
	C241.990555,594.948120 242.010864,595.414917 242.032425,595.646973 
	C240.690353,595.544739 239.326721,595.210327 237.307159,594.715149 
	C239.116943,593.664368 240.314774,593.977234 241.757385,594.699951 
z"/>
<path fill="#5B595B" opacity="1.000000" stroke="none" 
	d="
M377.251892,40.543304 
	C376.959869,40.103676 376.845032,39.942795 376.759338,39.486843 
	C378.175720,39.525066 379.562958,39.858360 381.185760,40.248253 
	C379.844574,41.420540 378.632965,41.089447 377.251892,40.543304 
z"/>
<path fill="#05476E" opacity="1.000000" stroke="none" 
	d="
M293.965149,592.545898 
	C295.373779,592.532532 296.873718,592.742310 298.758270,592.963928 
	C299.256256,593.169434 299.369659,593.363037 299.208618,593.751587 
	C298.934174,593.946472 298.949280,593.970581 298.948059,593.953369 
	C297.871765,593.955261 296.796722,593.974365 295.322205,593.936646 
	C294.634033,593.509583 294.345276,593.139343 293.965149,592.545898 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M143.315033,73.770287 
	C142.982727,74.020836 142.733612,74.061310 142.114105,74.180084 
	C141.454300,74.444618 141.139359,74.512421 140.562561,74.394348 
	C140.326202,74.326897 140.158264,74.157784 140.074493,74.073036 
	C139.557663,73.272415 139.976700,72.821419 140.721527,72.182266 
	C140.958069,71.966362 140.976044,71.975487 140.983902,71.981773 
	C141.677155,71.422028 142.445602,71.267570 143.639725,71.752769 
	C143.982697,71.982674 144.016037,72.022591 144.032394,72.042816 
	C144.150284,72.224663 144.251816,72.386269 144.258148,72.817871 
	C143.861008,73.169243 143.606094,73.326691 143.315033,73.770287 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M469.649780,64.207733 
	C470.236450,64.463402 470.598206,64.915771 470.982819,65.672791 
	C470.641876,66.533730 470.106842,66.925987 469.537811,66.462372 
	C468.848358,65.900635 469.020477,65.118149 469.649780,64.207733 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M349.402679,600.051270 
	C350.571564,598.325867 352.590088,599.209900 354.841797,599.057739 
	C353.598267,600.254517 351.624695,599.784729 349.402679,600.051270 
z"/>
<path fill="#044166" opacity="1.000000" stroke="none" 
	d="
M212.025665,584.312927 
	C212.372528,584.772400 212.327103,585.068848 212.203522,585.581482 
	C210.839188,585.916504 209.680710,585.622620 208.738098,584.158325 
	C209.872437,584.158325 210.780609,584.158325 212.025665,584.312927 
z"/>
<path fill="#050E18" opacity="1.000000" stroke="none" 
	d="
M92.958206,458.448761 
	C92.311630,458.797119 91.587135,458.830078 90.480637,458.503723 
	C90.110847,457.947113 90.123077,457.749786 90.109627,457.256836 
	C91.144913,457.044464 92.341934,456.803223 92.958206,458.448761 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M384.010559,27.384663 
	C384.442719,27.067715 384.871796,27.072174 385.620392,27.108349 
	C385.954987,27.573978 385.970062,28.007893 385.981628,28.770657 
	C385.528412,29.797646 384.981293,30.020632 384.134979,29.221317 
	C384.001556,28.564125 384.004517,28.135099 384.010559,27.384663 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M548.124634,151.877991 
	C548.814331,152.614960 549.438965,153.414795 549.808472,154.782288 
	C547.610962,155.486526 547.224243,154.387497 547.713867,152.414581 
	C547.928894,152.065933 548.059631,151.940872 548.124634,151.877991 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M551.859985,158.079651 
	C552.746887,158.680450 553.364075,159.490112 553.789062,160.836227 
	C552.137634,161.677948 551.504700,160.903061 551.302063,159.257965 
	C551.414795,158.707962 551.502563,158.498245 551.859985,158.079651 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M524.237793,510.211578 
	C523.751343,511.125824 523.134827,511.920380 522.043579,512.556763 
	C521.403259,511.665833 521.587769,511.010620 522.264160,510.164185 
	C522.736877,509.832062 522.954590,509.743530 523.511230,509.752350 
	C523.850037,509.849731 524.107666,510.091919 524.237793,510.211578 
z"/>
<path fill="#05476E" opacity="1.000000" stroke="none" 
	d="
M290.147247,592.247803 
	C290.475525,591.395630 291.063324,591.307312 291.873108,591.903442 
	C291.543243,592.822510 290.959747,592.858398 290.147247,592.247803 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M181.521240,564.923706 
	C182.224030,563.715271 183.414551,563.880066 184.816589,564.811218 
	C183.947449,566.039001 182.935913,565.101318 181.521240,564.923706 
z"/>
<path fill="#021429" opacity="1.000000" stroke="none" 
	d="
M73.110123,435.248779 
	C73.718376,435.541260 75.370651,433.766205 75.249382,436.029663 
	C74.408730,435.889954 73.846634,435.693756 73.110123,435.248779 
z"/>
<path fill="#020711" opacity="1.000000" stroke="none" 
	d="
M59.998280,436.001831 
	C59.045250,436.003662 58.093914,436.003662 56.980957,436.003662 
	C57.823490,434.461609 58.724133,435.102264 59.798985,435.747009 
	C60.001854,435.997101 59.999973,436.000000 59.998280,436.001831 
z"/>
<path fill="#021429" opacity="1.000000" stroke="none" 
	d="
M68.381088,435.012604 
	C69.024857,433.698700 70.278419,433.814545 71.832901,434.755188 
	C70.965515,435.015778 69.877098,435.015564 68.381088,435.012604 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M603.037476,269.287689 
	C603.922546,269.182281 605.073669,269.159576 604.227173,270.828003 
	C603.685425,270.528809 603.368408,270.057617 603.037476,269.287689 
z"/>
<path fill="#61D6F8" opacity="1.000000" stroke="none" 
	d="
M568.046021,185.674683 
	C567.606567,186.005341 567.155457,186.007629 566.366333,185.989441 
	C565.426880,185.305328 565.283081,184.537521 565.745483,183.348755 
	C565.982422,183.011841 566.098328,182.902679 566.155029,182.846802 
	C566.819336,183.642715 567.426880,184.494492 568.046021,185.674683 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M604.031006,274.290588 
	C604.916565,274.182098 606.072449,274.152863 605.223267,275.828979 
	C604.680847,275.530212 604.364136,275.059448 604.031006,274.290588 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M605.770996,283.171631 
	C606.313354,283.473511 606.631348,283.948242 606.962097,284.724182 
	C606.080750,284.820251 604.924683,284.837677 605.770996,283.171631 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M391.975830,30.399122 
	C392.510345,30.269815 393.092072,30.419153 393.831726,30.838467 
	C393.082611,32.113441 392.458771,31.825201 391.975830,30.399122 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M451.041016,55.324318 
	C451.909576,55.050850 452.687286,55.295826 452.996521,56.629379 
	C452.115173,56.936844 451.328430,56.702602 451.041016,55.324318 
z"/>
<path fill="#70E1F9" opacity="1.000000" stroke="none" 
	d="
M559.051270,168.596191 
	C558.873657,169.156006 558.670959,169.452362 558.231201,169.881165 
	C557.649841,169.936035 557.371094,169.754028 557.078857,169.235565 
	C557.117798,168.435684 557.226013,167.883377 557.582886,166.985046 
	C558.229736,167.203583 558.627930,167.768158 559.051270,168.596191 
z"/>
<path fill="#011B36" opacity="1.000000" stroke="none" 
	d="
M99.983536,457.254333 
	C100.688141,457.147278 101.401627,457.281158 102.115105,457.415039 
	C101.618164,457.602478 101.121231,457.789856 100.323326,457.976898 
	C100.022362,457.976532 99.992409,457.495270 99.983536,457.254333 
z"/>
<path fill="#197AAB" opacity="1.000000" stroke="none" 
	d="
M583.328125,414.873749 
	C583.211853,414.188873 583.372192,413.298553 583.813354,412.206635 
	C583.931091,412.892792 583.767883,413.780548 583.328125,414.873749 
z"/>
<path fill="#011B36" opacity="1.000000" stroke="none" 
	d="
M86.745224,453.879395 
	C86.257027,453.778534 85.999672,453.638153 85.742310,453.497772 
	C85.999161,453.359009 86.264236,453.095306 86.510864,453.111572 
	C86.853546,453.134155 87.621544,453.098480 86.745224,453.879395 
z"/>
<path fill="#011B36" opacity="1.000000" stroke="none" 
	d="
M91.130806,454.698914 
	C90.547508,454.731812 90.134476,454.598785 89.721436,454.465759 
	C89.834793,454.355133 89.972237,454.134003 90.057442,454.152618 
	C90.479576,454.244598 90.887901,454.399933 91.130806,454.698914 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M160.057556,557.240356 
	C160.742554,557.144165 161.669632,557.310608 162.811096,557.754150 
	C162.116852,557.855225 161.208237,557.679077 160.057556,557.240356 
z"/>
<path fill="#70E1F9" opacity="1.000000" stroke="none" 
	d="
M557.502441,165.925354 
	C556.800903,166.573196 556.325195,166.281204 556.093628,165.098221 
	C556.516907,165.054581 556.956055,165.364182 557.502441,165.925354 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M550.119141,154.885468 
	C550.463501,155.315445 550.745544,155.805130 550.762634,156.740570 
	C549.775330,156.908325 549.507446,156.356415 549.741577,155.340424 
	C549.932007,155.064270 550.056885,154.945190 550.119141,154.885468 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M505.571503,529.286804 
	C505.295593,528.678345 505.640442,528.243286 506.587280,527.989563 
	C506.541107,528.371277 506.189941,528.787292 505.571503,529.286804 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M165.922394,521.360107 
	C166.681580,520.840088 167.189285,521.196533 167.539246,522.076294 
	C166.945419,522.153259 166.427078,521.906433 165.922394,521.360107 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M163.039841,519.304260 
	C163.821579,518.370911 164.287140,519.025696 164.844788,519.810791 
	C164.123871,520.504272 163.588333,520.093628 163.039841,519.304260 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M145.002899,547.278564 
	C145.444778,547.167847 146.052750,547.340576 146.834305,547.778198 
	C146.394928,547.882751 145.781952,547.722412 145.002899,547.278564 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M554.054077,160.950165 
	C554.458801,161.315063 554.823547,161.716934 555.256348,162.392456 
	C555.255920,162.888565 555.187561,163.110992 554.770691,163.325195 
	C553.683228,162.988022 553.465332,162.387390 553.739258,161.346893 
	C553.934753,161.061569 554.014160,160.987137 554.054077,160.950165 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M176.827393,568.254517 
	C177.104721,568.597900 177.105804,568.934998 177.098694,569.524658 
	C176.098129,569.554199 175.980560,569.022644 176.827393,568.254517 
z"/>
<path fill="#61D6F8" opacity="1.000000" stroke="none" 
	d="
M569.645752,188.449432 
	C569.450806,188.833130 569.165161,188.873123 568.448975,188.953949 
	C568.021423,188.458649 568.024414,187.922516 568.067871,186.986176 
	C568.590515,187.092560 569.072754,187.599136 569.645752,188.449432 
z"/>
<path fill="#197AAB" opacity="1.000000" stroke="none" 
	d="
M584.349487,411.960266 
	C584.238342,411.496002 584.423218,410.911530 584.882690,410.170135 
	C584.986694,410.622162 584.816101,411.231110 584.349487,411.960266 
z"/>
<path fill="#020711" opacity="1.000000" stroke="none" 
	d="
M59.269375,439.402222 
	C59.145847,439.557373 58.933125,439.579254 58.720402,439.601166 
	C58.873661,439.490448 59.026920,439.379700 59.269375,439.402222 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M519.521118,515.031250 
	C519.838196,515.287415 519.668091,515.568054 519.148682,515.694519 
	C518.877625,515.378723 518.955750,515.217224 519.521118,515.031250 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M520.443237,514.136719 
	C520.822021,514.271667 520.653015,514.553040 520.246216,514.920593 
	C520.008362,515.006775 519.960815,514.961121 519.937195,514.938171 
	C519.907532,514.704529 519.901550,514.493835 520.443237,514.136719 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M338.394592,601.324036 
	C338.438538,601.096924 338.660675,601.042175 339.069397,601.072021 
	C339.083679,601.351746 338.855927,601.464966 338.394592,601.324036 
z"/>
<path fill="#020711" opacity="1.000000" stroke="none" 
	d="
M62.452591,440.529846 
	C62.421284,440.476746 62.483902,440.582977 62.452591,440.529846 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M518.999756,516.001221 
	C518.858093,516.312561 518.690491,516.596802 518.165283,516.652344 
	C517.955200,516.255493 518.102661,516.087402 518.585693,515.919983 
	C518.921143,515.920654 518.973755,515.974121 518.999756,516.001221 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M144.351746,73.081039 
	C144.132553,72.917992 144.102158,72.748116 144.060257,72.320648 
	C144.358246,72.159485 144.600311,72.344269 144.846558,72.839966 
	C144.918182,73.062531 144.540543,73.074203 144.351746,73.081039 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M551.069153,156.933563 
	C551.404236,157.056274 551.705017,157.211716 552.067749,157.618988 
	C552.129639,157.870789 552.034668,157.961777 551.984009,158.003723 
	C551.484985,158.165573 551.131409,158.023193 550.911743,157.343781 
	C550.964905,157.030258 551.034851,156.966293 551.069153,156.933563 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M521.925659,512.944214 
	C521.798645,513.254700 521.629761,513.533630 521.225952,513.901428 
	C520.991028,513.990295 520.939331,513.939819 520.913452,513.914612 
	C520.800598,513.489441 520.925964,513.163452 521.515991,512.875122 
	C521.799866,512.849854 521.883850,512.912659 521.925659,512.944214 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M555.972351,163.759735 
	C555.918945,164.035461 555.452271,164.029343 555.218994,164.020447 
	C554.818359,163.850357 554.650879,163.689163 554.723877,163.275513 
	C554.964417,163.023087 555.146423,162.846603 555.235352,162.756363 
	C555.558167,162.938736 555.791931,163.211365 555.972351,163.759735 
z"/>
<path fill="#8CF2FB" opacity="1.000000" stroke="none" 
	d="
M541.066895,141.676270 
	C540.846619,141.722321 540.567871,141.495636 540.229370,140.998016 
	C540.449158,140.952560 540.728821,141.178055 541.066895,141.676270 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M168.816345,523.589783 
	C169.112442,523.378357 169.475922,523.451782 169.900177,523.819580 
	C169.601883,524.034180 169.242813,523.954407 168.816345,523.589783 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M511.252380,523.916992 
	C511.058441,523.629639 511.231567,523.361755 511.756622,523.091492 
	C511.825348,523.293884 511.662354,523.576355 511.252380,523.916992 
z"/>
<path fill="#022D4E" opacity="1.000000" stroke="none" 
	d="
M133.004593,537.996460 
	C132.890182,537.853821 132.770950,537.714844 132.651703,537.575867 
	C132.738281,537.625549 132.824844,537.675293 132.951508,537.867737 
	C132.991592,538.010498 132.999771,538.000061 133.004593,537.996460 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M167.803406,522.825684 
	C168.086960,522.628357 168.421951,522.667114 168.740662,522.998291 
	C168.724380,523.290649 168.244034,523.350037 168.244034,523.350037 
	C168.244034,523.350037 167.854858,523.061890 167.803406,522.825684 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M512.258606,522.924255 
	C512.062256,522.636658 512.237427,522.365295 512.771851,522.092773 
	C512.839783,522.294312 512.672791,522.577271 512.258606,522.924255 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M504.515808,530.244629 
	C504.431732,529.999268 504.603973,529.679321 505.064331,529.335938 
	C505.158997,529.598389 504.965546,529.884155 504.515808,530.244629 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M531.510437,502.237946 
	C531.392273,501.980133 531.551086,501.639771 531.995850,501.222839 
	C532.116943,501.482635 531.952209,501.819000 531.510437,502.237946 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M509.218597,525.862183 
	C509.038483,525.589417 509.209259,525.330139 509.720032,525.068298 
	C509.919586,525.343628 509.756073,525.613586 509.218597,525.862183 
z"/>
<path fill="#033B5F" opacity="1.000000" stroke="none" 
	d="
M140.012177,499.325867 
	C140.272980,499.208496 140.585052,499.365021 140.966431,499.790314 
	C140.711655,499.906006 140.387558,499.752899 140.012177,499.325867 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M507.203064,527.831787 
	C507.022858,527.560547 507.188965,527.307068 507.687988,527.051941 
	C507.893921,527.327148 507.736725,527.593567 507.203064,527.831787 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M532.432800,501.169128 
	C532.340210,500.925262 532.532715,500.580322 533.014038,500.130920 
	C533.107849,500.373657 532.912842,500.720886 532.432800,501.169128 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M508.209473,526.843567 
	C508.028900,526.575928 508.195740,526.318665 508.700134,526.058777 
	C508.903992,526.332825 508.743713,526.598755 508.209473,526.843567 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M510.235107,524.889221 
	C510.051514,524.607971 510.225891,524.345764 510.744751,524.082642 
	C510.952332,524.366760 510.786957,524.642334 510.235107,524.889221 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M503.393372,531.291687 
	C503.318878,531.056946 503.520142,530.711914 504.025269,530.300537 
	C504.109100,530.549988 503.889099,530.865723 503.393372,531.291687 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M515.264771,519.949768 
	C515.186035,519.736694 515.357666,519.459167 515.766235,519.099609 
	C515.840576,519.306763 515.677917,519.596069 515.264771,519.949768 
z"/>
<path fill="#03D1FB" opacity="1.000000" stroke="none" 
	d="
M468.270264,557.781738 
	C468.166901,557.505615 468.382111,557.294067 468.897156,557.104980 
	C469.033264,557.386841 468.830566,557.626465 468.270264,557.781738 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M517.252075,517.969666 
	C516.984314,517.861023 516.966309,517.683655 516.959900,517.239014 
	C517.110107,516.826172 517.248840,516.680542 517.641602,516.697876 
	C517.895569,516.860840 517.969055,516.956848 518.006348,517.004395 
	C517.862976,517.334900 517.682373,517.617920 517.252075,517.969666 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M516.263489,518.981995 
	C516.180603,518.760010 516.360168,518.464050 516.791138,518.079712 
	C516.870300,518.296814 516.698120,518.602417 516.263489,518.981995 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M514.263794,520.950562 
	C514.188904,520.740417 514.365417,520.464233 514.778076,520.101074 
	C514.847900,520.304260 514.681519,520.594360 514.263794,520.950562 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M513.263306,521.943848 
	C513.189087,521.732422 513.366699,521.457886 513.780518,521.097778 
	C513.849609,521.301758 513.682434,521.591248 513.263306,521.943848 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M164.846207,520.466553 
	C165.228928,520.255676 165.592850,520.358337 165.952576,520.765686 
	C165.574722,520.973633 165.201065,520.876831 164.846207,520.466553 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M167.842545,52.246006 
	C169.991241,51.995506 171.836807,51.714554 172.970551,49.412033 
	C173.040298,49.072662 173.038086,49.042950 173.047546,49.043724 
	C174.080032,48.213627 175.589279,48.468231 176.788803,47.271275 
	C177.452698,47.027416 177.870972,46.995266 178.601379,46.936066 
	C179.383591,46.937740 179.853622,46.966454 180.676361,47.011768 
	C177.330948,51.738953 171.383163,52.817413 166.325348,55.929962 
	C165.411148,55.270596 165.271576,54.516148 165.782104,53.359699 
	C166.569092,52.848099 167.114594,52.661671 167.842545,52.246006 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M158.409119,60.031830 
	C159.002472,58.920383 159.966492,57.799782 160.978790,56.360794 
	C161.027054,56.042408 161.020462,56.018978 161.026978,56.023972 
	C162.044708,55.303585 163.125183,54.979820 164.683182,55.739815 
	C164.050674,59.085762 161.277832,59.339832 158.409119,60.031830 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M183.304749,46.890526 
	C183.098724,44.389774 186.253998,44.772354 186.988205,42.433487 
	C187.516235,42.093002 187.974655,42.076500 188.772018,42.136246 
	C189.021484,45.777359 185.908081,45.824535 183.304749,46.890526 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M165.258575,56.006699 
	C163.957916,56.022766 162.893433,56.023994 161.431213,56.027092 
	C161.841232,54.131687 163.625626,53.652145 165.679779,53.049805 
	C166.008240,53.763088 165.992874,54.491650 165.971741,55.583588 
	C165.965958,55.946960 165.494766,55.991863 165.258575,56.006699 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M143.987289,71.611588 
	C143.236084,71.988197 142.489471,71.993721 141.367310,71.993652 
	C140.995895,71.243546 141.000031,70.499023 141.005798,69.382767 
	C141.007446,69.011032 141.498932,68.998245 141.744156,68.994354 
	C142.438461,68.993408 142.887558,68.996353 143.674286,69.005188 
	C144.005249,69.754227 143.998566,70.497360 143.987289,71.611588 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M156.303284,61.944294 
	C156.068802,61.057320 156.344818,60.285957 157.715576,60.070969 
	C157.941605,60.954796 157.652695,61.716194 156.303284,61.944294 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M153.292328,63.928673 
	C153.066086,63.039474 153.353622,62.273972 154.721130,62.064850 
	C154.938080,62.947979 154.649689,63.713730 153.292328,63.928673 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M150.279633,65.910156 
	C150.066772,65.024307 150.365692,64.269623 151.713348,64.056946 
	C151.935806,64.944229 151.647232,65.709923 150.279633,65.910156 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M145.301544,68.941681 
	C145.067474,68.050232 145.350815,67.280388 146.726517,67.070160 
	C146.938721,67.950043 146.648865,68.714760 145.301544,68.941681 
z"/>
<path fill="#959398" opacity="1.000000" stroke="none" 
	d="
M107.242630,94.839783 
	C107.051590,94.949814 107.032944,94.475197 107.017136,94.238251 
	C107.001328,94.001297 107.463806,94.021378 107.694321,94.016068 
	C107.837662,94.302742 107.673943,94.542404 107.242630,94.839783 
z"/>
<path fill="#6D676B" opacity="1.000000" stroke="none" 
	d="
M88.375000,117.008621 
	C88.039230,116.305168 88.033470,115.556923 88.034325,114.437042 
	C88.810074,113.712753 89.579216,113.360115 90.667580,113.001755 
	C92.804451,115.801315 90.043121,115.973335 88.375000,117.008621 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M132.709991,76.784622 
	C132.937881,78.572365 132.227173,79.603561 130.319229,79.948303 
	C129.991608,79.234993 130.004913,78.501617 130.021576,77.401962 
	C130.024948,77.035675 130.013229,77.011810 130.020157,77.017235 
	C130.728943,76.469765 131.499680,76.244362 132.709991,76.784622 
z"/>
<path fill="#514A4D" opacity="1.000000" stroke="none" 
	d="
M140.583466,71.968987 
	C140.708954,72.467880 140.459824,72.969406 140.100708,73.729607 
	C137.488342,73.674561 137.177124,77.248283 134.335907,76.967697 
	C133.414963,76.285919 133.273071,75.528900 133.785034,74.367538 
	C134.028442,74.041672 133.999832,74.005966 134.018585,74.018051 
	C135.020813,73.121773 136.389954,73.037689 137.732239,72.182251 
	C137.960541,71.956291 137.976318,71.963593 137.965500,71.953384 
	C138.706085,71.952644 139.457474,71.962128 140.583466,71.968987 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M137.592239,71.959732 
	C137.403320,73.458809 136.249191,74.025948 134.382935,74.024460 
	C134.288345,73.530708 134.539368,73.031281 134.901703,72.274475 
	C135.749985,71.999123 136.486969,71.981148 137.592239,71.959732 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M133.691925,74.024658 
	C134.013535,74.772141 133.998627,75.502609 133.979675,76.597961 
	C133.975632,76.962845 133.508804,77.004768 133.275604,77.022888 
	C132.287949,77.032669 131.533463,77.024338 130.403046,77.019333 
	C130.602203,76.202103 131.177307,75.381538 131.880707,74.286514 
	C132.457794,74.010590 132.906601,74.009117 133.691925,74.024658 
z"/>
<path fill="#625E60" opacity="1.000000" stroke="none" 
	d="
M176.698608,47.039455 
	C176.805161,49.116798 175.245804,48.987640 173.424530,49.038280 
	C173.604507,48.531273 174.152008,48.018044 174.859085,47.265965 
	C175.466690,47.024525 175.914734,47.021931 176.698608,47.039455 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M125.709213,85.038155 
	C125.216980,87.890518 123.763557,90.154076 120.336624,90.960457 
	C119.819084,89.178574 121.663284,88.304268 121.994064,86.371834 
	C122.515648,85.757164 122.996643,85.482407 123.726212,85.084167 
	C124.437477,84.977318 124.900177,84.993958 125.709213,85.038155 
z"/>
<path fill="#061426" opacity="1.000000" stroke="none" 
	d="
M470.130188,510.685486 
	C466.759247,513.432434 463.537079,515.897156 460.146729,518.648560 
	C457.654785,523.276184 453.237213,525.229858 449.460388,527.773315 
	C438.034760,535.467773 425.785614,541.735168 413.330048,547.575928 
	C410.665131,548.825562 407.870605,550.040405 404.396423,549.644775 
	C403.342102,549.103699 402.903412,548.495483 402.685974,547.342834 
	C406.151367,542.893250 411.525543,542.712219 416.211365,540.312317 
	C436.110962,531.020508 454.277466,519.744202 470.498047,505.371124 
	C476.991180,499.617554 483.461365,493.899384 489.009277,486.731171 
	C493.766968,482.254944 497.450043,477.318268 501.332489,472.551880 
	C502.470062,471.155273 503.306915,469.424988 505.531982,468.744690 
	C506.820526,469.232269 507.236572,470.091125 507.573669,471.399231 
	C507.560303,472.526001 507.238068,473.140137 506.300995,473.785156 
	C506.017303,474.005768 505.996796,474.000610 506.000732,474.010742 
	C505.840027,474.172363 505.675415,474.323822 505.327209,474.756073 
	C504.468658,475.757996 503.793762,476.479065 503.016693,477.481567 
	C502.775269,478.087952 502.585480,478.380096 502.135925,478.799316 
	C501.926697,478.959229 502.001343,478.989655 501.971436,478.962524 
	C501.148010,480.448975 500.383545,481.989441 498.375671,482.813354 
	C497.787811,483.403564 497.406677,483.752838 496.943970,484.353210 
	C496.795593,484.997223 496.619965,485.335632 496.087097,485.754822 
	C495.824036,485.882843 495.943878,485.930603 495.903809,485.880066 
	C495.755341,486.151520 495.578461,486.428619 495.108276,486.784607 
	C494.893860,486.915253 494.993988,486.994110 494.952240,486.945953 
	C494.780701,487.191681 494.590942,487.439667 494.159485,487.791992 
	C493.977692,487.942230 493.969818,487.971222 493.955994,487.977112 
	C493.795898,488.150269 493.649597,488.317505 493.266846,488.719604 
	C493.030365,488.954468 492.961212,488.964233 492.958374,488.999023 
	C492.804382,489.184509 492.653259,489.335205 492.291016,489.726562 
	C492.079926,489.967194 491.979309,489.980774 491.981995,490.031464 
	C491.563843,490.606781 491.156342,491.143646 490.383881,491.801636 
	C490.143463,492.036896 490.029846,492.036194 490.036255,492.092651 
	C489.484314,492.461578 489.496613,493.113312 488.908081,493.611633 
	C488.622803,493.645844 488.918182,494.021790 488.775574,493.831909 
	C488.738403,494.074219 488.600769,494.418488 487.949219,494.661713 
	C487.643494,494.635925 487.958771,495.008362 487.795593,494.826385 
	C487.740173,495.070038 487.607849,495.411011 486.964752,495.671661 
	C486.661896,495.664703 486.996338,495.995117 486.828674,495.829102 
	C486.739594,496.084656 486.596771,496.419922 485.966309,496.674316 
	C485.668243,496.667267 485.979523,497.006561 485.821167,496.838257 
	C485.741547,497.083252 485.602936,497.413055 484.985626,497.681580 
	C484.693237,497.691956 484.981689,498.005798 484.834778,497.850159 
	C484.736481,498.100403 484.589478,498.423523 483.986389,498.683411 
	C483.699463,498.691681 483.931763,498.944031 483.812683,498.815491 
	C483.634003,499.409729 483.036469,499.439636 482.384705,499.820526 
	C481.600861,500.567810 480.964020,501.083649 480.181854,501.873016 
	C478.781464,503.952759 477.635345,505.871979 475.072693,506.766479 
	C473.271637,508.064484 471.775299,509.233887 470.130188,510.685486 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M506.424805,474.010193 
	C506.293793,473.493195 506.570282,472.980621 506.906433,472.177460 
	C507.546936,470.798462 506.786591,469.536774 507.585938,468.138397 
	C509.631165,466.386963 510.613403,463.816803 513.688354,463.567566 
	C515.751221,465.190430 516.664978,467.221039 517.669189,469.604431 
	C517.689453,470.473236 517.581787,470.959259 517.202332,471.738617 
	C516.985352,472.043762 516.981689,471.983643 517.011353,471.978333 
	C516.873352,472.132385 516.705750,472.291748 516.282227,472.685425 
	C513.442749,477.324188 509.877228,473.483612 506.424805,474.010193 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M518.028442,516.665527 
	C517.895569,516.860840 517.437134,516.944214 517.204285,516.958008 
	C516.043579,515.520569 516.227051,514.304077 517.386414,512.954407 
	C518.318481,511.869324 518.886475,510.989136 516.887756,509.564301 
	C514.142517,507.607239 518.519592,507.768982 518.731689,506.187561 
	C520.288147,507.112671 521.883362,507.865662 522.994629,509.641174 
	C522.747131,510.698578 522.361084,511.464508 521.887451,512.540161 
	C521.528503,513.013184 521.298096,513.221680 520.998047,513.682373 
	C520.579895,514.015442 520.329285,514.213684 520.024719,514.699707 
	C519.605408,515.037415 519.351624,515.230896 519.036743,515.708130 
	C518.619385,516.036865 518.366150,516.220032 518.028442,516.665527 
z"/>
<path fill="#0CA3DE" opacity="1.000000" stroke="none" 
	d="
M523.312256,509.911499 
	C521.106812,509.701233 520.073364,508.214203 519.011047,506.372925 
	C520.408142,505.691742 521.849365,505.345551 523.663391,505.013702 
	C524.000488,506.371796 523.964722,507.715546 523.889526,509.454529 
	C523.850037,509.849731 523.491455,509.890381 523.312256,509.911499 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M498.521637,483.057953 
	C499.231812,481.764038 500.294647,480.473785 501.649536,479.059448 
	C501.053223,481.907196 504.315796,483.894989 503.864410,487.069977 
	C501.988678,485.764618 501.424561,483.096802 498.521637,483.057953 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M475.151428,506.922363 
	C476.322052,505.384918 477.876068,503.874695 479.733307,502.255524 
	C479.976654,505.097870 478.632690,506.845673 475.151428,506.922363 
z"/>
<path fill="#05476E" opacity="1.000000" stroke="none" 
	d="
M522.546509,501.549561 
	C521.524475,501.252502 520.852356,500.751953 521.238953,499.815735 
	C521.517700,499.140625 522.269653,498.956970 522.809204,499.367371 
	C523.581787,499.955017 523.336792,500.748444 522.546509,501.549561 
z"/>
<path fill="#0CA3DE" opacity="1.000000" stroke="none" 
	d="
M525.999268,503.876465 
	C525.320129,504.314819 524.911804,504.600189 524.265076,504.957642 
	C523.848938,502.895020 525.869385,502.072601 526.846863,500.236877 
	C527.319214,500.421143 527.649841,500.911499 528.006226,501.719177 
	C528.032043,502.036438 528.006531,502.011719 528.018677,502.012695 
	C527.465210,502.605530 527.087585,503.390930 525.999268,503.876465 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M524.218018,462.656494 
	C523.997070,462.984589 523.981445,463.467133 523.961426,463.707642 
	C523.941467,463.948120 523.978455,463.966736 523.968872,463.950134 
	C523.770996,464.191742 523.555176,464.424316 523.155640,464.811462 
	C522.999573,464.991608 522.579529,465.061279 522.075500,464.834656 
	C520.886353,462.786530 521.457397,461.513611 523.640869,460.811462 
	C524.375549,461.286987 524.510071,461.779633 524.218018,462.656494 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M517.275818,471.903076 
	C516.979370,471.598419 516.973389,471.153046 517.002869,470.375305 
	C517.220276,469.650879 517.466614,469.305847 518.390625,469.019470 
	C519.060242,470.219147 518.425659,471.049347 517.275818,471.903076 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M521.959473,464.977661 
	C521.658142,466.033844 521.154968,466.926575 520.133057,467.712036 
	C519.216736,466.347412 519.781372,465.467804 521.045410,464.615601 
	C521.487793,464.597504 521.622803,464.705902 521.959473,464.977661 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M490.446655,491.992523 
	C490.582245,491.449677 491.021057,490.862457 491.722290,490.178711 
	C491.973999,490.969452 491.656555,491.653778 490.446655,491.992523 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M482.523804,500.011688 
	C482.556671,499.650116 482.875641,499.248230 483.444092,498.766663 
	C483.399017,499.115082 483.104431,499.543243 482.523804,500.011688 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M488.923096,493.641449 
	C488.927734,493.210236 489.232635,492.774628 489.790131,492.244080 
	C489.769592,492.645111 489.496490,493.141083 488.923096,493.641449 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M505.347229,474.924927 
	C505.110687,474.675018 505.243195,474.390045 505.772858,474.101440 
	C505.953461,474.342255 505.802216,474.606293 505.347229,474.924927 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M502.176392,478.841125 
	C502.086182,478.635315 502.245697,478.311432 502.659882,477.875275 
	C502.751740,478.083008 502.588928,478.402985 502.176392,478.841125 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M519.970703,467.981506 
	C519.905823,468.390808 519.731323,468.705933 519.275146,469.022278 
	C518.993530,469.023499 519.021790,469.005188 519.029236,468.990417 
	C518.792969,468.614410 518.828857,468.271210 519.371643,467.822266 
	C519.639954,467.701080 519.861084,467.887329 519.970703,467.981506 
z"/>
<path fill="#03D7FC" opacity="1.000000" stroke="none" 
	d="
M523.224243,464.881744 
	C523.165222,464.704742 523.330811,464.417877 523.727783,464.032288 
	C523.789124,464.213013 523.619019,464.492432 523.224243,464.881744 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M516.254883,472.838135 
	C516.138367,472.607422 516.326904,472.351501 516.816406,472.062500 
	C516.935303,472.291229 516.749451,472.552399 516.254883,472.838135 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M487.929626,494.627502 
	C487.703796,494.289581 487.879700,494.018158 488.402069,493.731842 
	C488.493866,493.967682 488.354828,494.293365 487.929626,494.627502 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M486.946167,495.645264 
	C486.710419,495.313293 486.880005,495.035828 487.401489,494.738373 
	C487.498383,494.971527 487.364410,495.298645 486.946167,495.645264 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M485.951111,496.649292 
	C485.842133,496.390503 486.016022,496.113708 486.425446,495.750031 
	C486.518616,495.985840 486.376251,496.308563 485.951111,496.649292 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M484.972961,497.665161 
	C484.859253,497.410126 485.025238,497.128265 485.427002,496.758179 
	C485.526062,496.992737 485.389374,497.315552 484.972961,497.665161 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M483.977051,498.668335 
	C483.869080,498.411774 484.038757,498.131897 484.448151,497.773254 
	C484.543488,498.011383 484.399048,498.328217 483.977051,498.668335 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M496.101166,485.770905 
	C495.995819,485.543793 496.167633,485.204773 496.600922,484.734985 
	C496.701019,484.955841 496.539673,485.307434 496.101166,485.770905 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M492.290588,489.881866 
	C492.061951,489.615906 492.200409,489.344421 492.725403,489.093292 
	C492.915955,489.354736 492.764557,489.608948 492.290588,489.881866 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M495.140503,486.823242 
	C495.046600,486.605743 495.199402,486.296265 495.607971,485.908142 
	C495.704865,486.130096 495.546021,486.430664 495.140503,486.823242 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M494.209473,487.847656 
	C494.123047,487.642517 494.268433,487.342773 494.662109,486.970428 
	C494.754089,487.182892 494.597687,487.467987 494.209473,487.847656 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M493.251343,488.867767 
	C493.024689,488.595306 493.171509,488.316406 493.706482,488.050354 
	C493.905396,488.319641 493.748779,488.585663 493.251343,488.867767 
z"/>
<path fill="#70E9FC" opacity="1.000000" stroke="none" 
	d="
M375.752869,51.294754 
	C391.429047,54.538700 406.307953,59.757431 420.816467,65.986771 
	C444.758179,76.266312 467.311523,88.969505 487.905762,105.559509 
	C488.511108,106.993294 488.716553,108.455208 487.890137,109.179482 
	C483.783630,112.778557 483.745697,117.453789 483.992096,122.286491 
	C484.025604,122.943687 483.555481,123.524071 482.785706,124.235916 
	C480.215088,124.904198 478.642334,123.612541 477.106171,122.331818 
	C447.061584,97.283089 412.924652,80.401115 374.982117,71.091499 
	C373.224518,70.660255 371.361725,70.410606 369.760956,68.775497 
	C369.431549,65.054123 372.158508,64.012932 374.474060,62.951389 
	C377.440491,61.591476 378.051361,59.978363 376.295624,57.186516 
	C375.247009,55.519093 374.496490,53.600361 375.752869,51.294754 
z"/>
<path fill="#69DBF7" opacity="1.000000" stroke="none" 
	d="
M375.652374,50.865952 
	C375.755524,53.267494 376.233063,55.430817 377.611023,57.088196 
	C380.742859,60.855091 378.910156,62.561157 375.246948,63.925400 
	C373.257385,64.666359 371.308777,65.634460 370.032867,67.961655 
	C362.957977,69.375786 356.502991,67.655983 349.948303,64.629959 
	C350.523651,58.361786 353.028748,52.889740 354.821533,46.868523 
	C361.997772,47.324055 368.688446,48.840542 375.652374,50.865952 
z"/>
<path fill="#69E3FB" opacity="1.000000" stroke="none" 
	d="
M481.716309,124.468826 
	C483.841370,122.421539 483.350220,119.968346 482.736786,118.135765 
	C481.586121,114.698418 482.114960,112.352280 485.425690,110.744286 
	C487.170593,109.896828 486.847107,107.848869 487.930908,106.182709 
	C492.769165,109.624420 497.457794,113.406525 502.444946,117.371445 
	C503.464752,118.485893 504.186096,119.417534 505.052002,120.620033 
	C504.887482,122.511635 503.668610,123.434288 502.388489,124.130447 
	C498.390198,126.304794 495.793213,129.957352 492.350647,133.215729 
	C487.124023,132.277176 484.077362,128.956711 481.716309,124.468826 
z"/>
<path fill="#5CCBEF" opacity="1.000000" stroke="none" 
	d="
M354.820892,46.423637 
	C354.681641,52.708405 353.333954,58.542786 349.970520,64.181305 
	C345.992279,66.070152 342.146942,65.943718 338.083221,63.605770 
	C337.655853,57.101936 338.378906,50.989910 339.678650,44.574558 
	C341.423981,44.420952 342.866272,44.594742 344.670776,44.714714 
	C348.187683,45.186451 351.342316,45.712009 354.820892,46.423637 
z"/>
<path fill="#05B2F9" opacity="1.000000" stroke="none" 
	d="
M403.665527,549.084290 
	C414.351532,546.706787 423.297272,541.159729 432.533142,536.383057 
	C441.977966,531.498352 450.872620,525.629150 459.652527,519.036865 
	C460.142548,525.658569 455.487488,529.406738 451.049408,533.659912 
	C451.164948,533.981201 451.328552,533.955139 451.493195,533.942688 
	C453.854248,533.763550 457.115173,530.347290 458.060364,532.722290 
	C459.295288,535.825439 454.803101,536.429016 452.555267,537.668823 
	C447.227722,540.607361 446.825500,541.401123 450.186462,544.786804 
	C444.108826,548.393311 437.599854,549.564880 430.219116,548.884583 
	C429.161652,547.222961 428.268066,548.502380 427.251862,548.819092 
	C427.003265,549.039185 426.999573,549.000000 427.012024,549.015198 
	C426.806732,549.159607 426.588959,549.288879 425.994873,549.467285 
	C417.043030,551.659241 409.239868,555.945740 400.461121,558.283875 
	C400.065552,556.209534 400.006714,554.310547 399.917419,551.936340 
	C400.436768,549.826477 401.774078,549.313416 403.665527,549.084290 
z"/>
<path fill="#0ABEFA" opacity="1.000000" stroke="none" 
	d="
M394.421295,572.311157 
	C394.716675,567.824951 398.588593,567.184875 401.780182,565.265259 
	C404.368317,564.745178 406.319275,563.425110 408.289490,562.301331 
	C412.065643,560.147583 413.356293,561.412903 413.065552,565.790771 
	C413.129791,566.452271 413.168518,566.696838 412.959412,567.218628 
	C411.373016,568.158508 409.878296,568.297241 408.119080,568.852661 
	C403.516327,570.465271 399.385803,572.393860 394.421295,572.311157 
z"/>
<path fill="#071A2D" opacity="1.000000" stroke="none" 
	d="
M400.115112,558.075928 
	C408.434998,554.643372 416.608795,550.805664 425.875000,548.754028 
	C426.332275,548.927246 426.372253,549.153076 426.163116,549.616211 
	C418.166626,552.852173 410.419189,555.850891 402.323792,558.999878 
	C401.212738,559.553528 400.523224,559.521606 400.058502,558.438843 
	C400.167969,558.070129 400.105774,558.043213 400.115112,558.075928 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M445.603302,561.996582 
	C443.932007,566.455261 438.926514,564.354675 435.809418,566.475525 
	C438.106720,563.228271 441.759186,562.814636 445.603302,561.996582 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M403.944153,548.839355 
	C402.818451,549.780151 401.603943,550.458008 400.138184,551.298523 
	C399.277618,551.221985 398.668274,550.982849 397.963379,550.507202 
	C397.749878,550.061523 397.631958,549.852295 397.559845,549.283936 
	C397.936096,548.253235 398.457306,547.755066 399.370331,547.140137 
	C400.587708,546.533936 401.508606,546.259521 402.760040,546.882446 
	C403.295929,547.619446 403.575653,548.097839 403.944153,548.839355 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M412.754578,567.152649 
	C412.963257,566.826965 413.059296,566.523865 413.075195,566.365845 
	C415.515533,565.999573 417.939972,565.791382 420.813904,565.478149 
	C421.294891,565.644775 421.326385,565.916321 421.077301,566.486755 
	C418.440399,567.490112 416.084106,568.194519 413.356598,568.894409 
	C412.609436,568.490845 412.462982,568.020325 412.754578,567.152649 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M390.862976,553.610840 
	C388.657257,553.558167 387.238922,554.877441 385.314880,555.793579 
	C384.637115,555.439819 384.417267,555.018921 384.351715,554.168701 
	C384.780151,552.515076 385.822754,551.908264 387.292694,551.273865 
	C388.577972,550.918823 389.529999,550.908020 390.831085,551.143066 
	C391.379852,551.355469 391.585236,551.474121 391.978638,551.894775 
	C391.788574,552.592529 391.410461,552.988281 390.862976,553.610840 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M446.008484,562.005371 
	C447.983978,560.285645 450.112457,559.104858 453.577911,560.057678 
	C451.180420,561.770142 449.109222,562.299622 446.380310,562.015991 
	C445.979065,561.974976 446.001953,561.992859 446.008484,562.005371 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M396.452698,549.634827 
	C396.074524,551.575439 394.683228,552.302612 392.525818,552.227783 
	C392.069061,552.059998 391.971375,551.923279 391.745087,551.569580 
	C392.367310,549.328674 393.925507,548.901367 396.452698,549.634827 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M427.348450,549.078796 
	C427.485413,546.842468 429.336212,546.789978 430.778259,547.224182 
	C431.679138,547.495483 430.384369,547.979065 429.926361,548.611328 
	C429.062469,548.931580 428.378052,549.025024 427.348450,549.078796 
z"/>
<path fill="#05B2F9" opacity="1.000000" stroke="none" 
	d="
M399.874817,558.152588 
	C400.246399,558.811951 400.792725,558.961548 401.685608,559.094971 
	C401.065918,560.098328 399.890411,560.456482 398.877258,559.666382 
	C398.245758,559.173950 399.050629,558.590698 399.874817,558.152588 
z"/>
<path fill="#248BBE" opacity="1.000000" stroke="none" 
	d="
M421.130371,566.753967 
	C420.846832,566.542786 420.896942,566.299866 421.105225,565.715088 
	C422.311432,564.957031 423.355804,564.585205 424.140076,565.805420 
	C423.152496,566.232483 422.308258,566.477356 421.130371,566.753967 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M426.175171,549.849854 
	C425.949432,549.653870 425.984833,549.454285 426.156311,548.978027 
	C426.292328,548.701416 426.763519,548.631836 426.893982,548.831116 
	C426.828430,549.302368 426.632355,549.574341 426.175171,549.849854 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M397.753937,548.960754 
	C397.996826,549.295349 397.977783,549.491150 397.913269,549.978882 
	C397.867798,550.270813 397.458435,550.165588 397.254150,550.112915 
	C397.049896,550.060303 396.865082,549.835571 396.772583,549.723267 
	C396.836914,549.230835 397.107605,548.967896 397.753937,548.960754 
z"/>
<path fill="#0A0C12" opacity="1.000000" stroke="none" 
	d="
M154.237473,499.273315 
	C137.221237,484.558167 123.136002,467.545746 110.830002,449.011078 
	C110.282784,448.186920 109.653778,447.417053 108.887741,446.317261 
	C103.719299,441.668976 101.440315,435.563721 98.140335,429.693542 
	C94.439095,423.582611 92.362946,417.084503 88.984482,410.808960 
	C87.208191,406.388611 85.573441,402.304199 83.779610,397.885223 
	C82.754883,394.433929 81.360275,391.513702 80.194077,388.098145 
	C79.837852,386.691467 79.808624,385.648315 80.110046,384.213928 
	C82.444733,380.702545 85.572647,382.347260 88.752464,382.412537 
	C92.350014,386.343658 92.986565,391.067841 93.804466,396.076660 
	C93.130180,397.934143 91.968384,399.341370 93.125572,401.067566 
	C97.702286,407.894745 98.804756,416.170593 102.563110,423.403809 
	C107.147621,432.227020 111.501595,441.127716 117.881104,449.242615 
	C118.305206,449.594330 118.485329,449.718994 118.918030,450.044983 
	C119.330025,450.384766 119.489449,450.523224 120.090767,451.091064 
	C120.664963,451.670197 120.797272,451.819946 121.107956,452.203247 
	C121.390228,452.598145 121.494125,452.759552 121.739639,453.164917 
	C121.975304,453.567657 122.069359,453.726471 122.472412,454.333130 
	C122.888565,454.925232 122.995728,455.069519 123.254723,455.435059 
	C123.498344,455.808655 123.590134,455.960938 123.813995,456.343445 
	C124.038322,456.724640 124.130569,456.875641 124.539017,457.459595 
	C124.967392,458.035980 125.079559,458.179413 125.358795,458.545532 
	C125.639038,458.920013 125.752213,459.071747 126.046883,459.447235 
	C126.496956,459.970490 126.773796,460.262207 127.290733,460.773834 
	C135.956848,472.790771 145.276962,483.830811 155.518494,494.091156 
	C156.125168,494.698975 156.530289,495.400055 156.543030,496.632385 
	C156.130463,497.953583 155.459656,498.647614 154.237473,499.273315 
z"/>
<path fill="#DEF9F9" opacity="1.000000" stroke="none" 
	d="
M98.584854,428.787231 
	C102.156761,434.460327 105.369446,439.904510 108.647369,445.680664 
	C106.506729,447.797089 104.300842,449.581512 102.042030,451.709290 
	C101.426720,451.555084 100.864334,451.057495 100.150711,450.310394 
	C99.907333,449.466675 99.815201,448.872467 99.444458,448.130127 
	C98.701172,447.074524 98.236488,446.167023 97.514648,445.090332 
	C96.627029,444.666840 96.265434,444.184509 96.085609,443.228607 
	C94.973495,440.729187 93.865677,438.545502 92.497925,436.154175 
	C92.144798,435.559998 92.051590,435.173523 91.943878,434.487976 
	C92.136406,429.884796 93.281494,428.860779 98.584854,428.787231 
z"/>
<path fill="#1E2B39" opacity="1.000000" stroke="none" 
	d="
M154.003510,499.667053 
	C154.528366,498.603241 155.177948,497.833954 156.189926,496.930298 
	C158.555161,496.111389 159.715225,497.540680 160.810913,498.699768 
	C163.687393,501.742706 167.051941,504.205902 170.472412,507.149170 
	C174.041046,510.678589 178.788086,512.524536 180.641235,517.614258 
	C180.417252,518.709412 180.053009,519.342346 179.212479,520.074463 
	C170.043213,514.220032 162.053558,507.130035 154.003510,499.667053 
z"/>
<path fill="#1B2027" opacity="1.000000" stroke="none" 
	d="
M179.042664,520.549194 
	C179.132477,519.607727 179.372787,518.953674 179.912109,518.107300 
	C184.278610,517.962708 187.281204,520.481995 190.435684,522.497986 
	C197.703888,527.143188 204.679626,532.261108 212.904785,536.033630 
	C214.567703,536.952942 215.828232,537.785217 216.654495,539.585449 
	C216.828629,540.472961 216.781509,540.981384 216.427429,541.810547 
	C215.800110,542.439331 215.325378,542.599548 214.431503,542.567139 
	C205.951721,538.275330 198.132263,533.548889 190.218109,528.282593 
	C189.938019,528.054626 189.991180,527.999878 189.978226,528.035767 
	C189.589691,527.550354 188.985245,527.497681 188.219635,527.132751 
	C188.000473,526.939270 187.998993,526.999451 188.027618,526.990112 
	C186.771515,526.301941 185.826904,525.158752 184.299255,524.297424 
	C182.412170,523.053650 180.802673,521.945190 179.042664,520.549194 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M189.897827,528.404785 
	C198.318237,531.653320 205.678391,537.118103 214.102997,541.334351 
	C214.342667,541.786682 214.317886,542.023987 213.997223,542.463989 
	C213.252274,542.832214 212.790268,542.940613 211.958435,542.977173 
	C209.439392,542.566711 207.727905,541.451111 206.187088,539.436523 
	C200.199875,536.297180 194.760864,532.938538 189.897827,528.404785 
z"/>
<path fill="#CFF3F8" opacity="1.000000" stroke="none" 
	d="
M205.942139,539.556030 
	C208.110672,539.360291 209.379929,541.215942 211.549194,542.069763 
	C213.079956,543.228638 213.243668,544.584839 212.657028,546.465698 
	C209.798584,548.883362 207.681320,547.393616 205.355652,545.409180 
	C204.456635,544.573242 203.787201,544.097412 202.949005,543.353088 
	C204.676285,542.867493 205.991470,542.070007 205.942139,539.556030 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M157.005173,514.521729 
	C154.167587,517.583984 153.128296,513.053406 150.509506,513.118408 
	C148.372101,511.601440 146.498383,510.102020 146.621063,507.099915 
	C146.861847,506.632996 146.939697,506.483765 147.136993,506.112640 
	C150.445099,508.675323 153.633774,511.459839 157.005173,514.521729 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M100.438400,462.922394 
	C102.309593,461.133881 104.896584,462.439209 107.680283,461.933594 
	C108.602539,462.467712 109.092766,463.030212 109.667694,463.867920 
	C107.428009,463.759277 105.103630,463.375366 102.384811,463.012695 
	C101.576401,463.003571 101.162430,462.973206 100.438400,462.922394 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M184.147186,524.455811 
	C185.680817,524.240417 186.746780,525.385681 187.989975,526.656006 
	C186.306107,527.066101 185.449997,525.635498 184.147186,524.455811 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M190.922134,536.638184 
	C189.853058,537.095398 188.687027,537.139587 187.945343,535.455261 
	C188.829071,535.524658 189.803802,535.937561 190.922134,536.638184 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M188.082275,527.269653 
	C188.600861,527.102417 189.201233,527.265564 189.883453,527.750183 
	C189.218994,528.471680 188.683701,528.065857 188.082275,527.269653 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M185.239594,534.582397 
	C185.204544,534.308533 185.408829,534.246399 185.922180,534.094116 
	C186.540604,534.150452 186.849945,534.296814 187.264603,534.685059 
	C186.739594,534.882568 186.109253,534.838318 185.239594,534.582397 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M201.127289,542.578369 
	C200.679733,542.722900 200.044968,542.597290 199.217209,542.199158 
	C199.662842,542.053894 200.301468,542.181091 201.127289,542.578369 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M337.632263,62.708130 
	C341.679993,63.528500 345.356628,64.069496 349.481232,64.592949 
	C356.313507,65.767326 362.697876,66.959251 369.485046,68.221817 
	C399.454559,75.511513 427.487061,86.406700 453.140076,103.012810 
	C462.930359,109.350426 472.131012,116.474564 481.425110,123.999939 
	C484.908661,127.081764 488.076874,130.060989 491.557739,133.185028 
	C495.006073,133.713303 496.476898,136.287903 498.180054,138.384445 
	C500.049103,140.685150 501.999512,142.880280 504.391357,145.153778 
	C507.807343,148.384476 510.088257,152.153122 513.429321,155.451294 
	C516.402832,159.636917 519.282776,163.462738 522.481934,167.480774 
	C525.665710,171.845612 527.702148,176.561142 531.317871,180.647842 
	C534.009888,186.326431 537.387573,191.207199 540.554138,196.626007 
	C542.104065,200.818573 544.208984,204.374985 545.834229,208.542511 
	C549.212341,214.768082 551.112061,221.206360 553.776978,227.740051 
	C555.931030,234.184052 558.121338,240.220200 559.906128,246.798416 
	C561.315796,252.874603 562.865051,258.512238 564.287964,264.600647 
	C565.790710,271.508209 566.686157,278.117004 568.213867,285.046997 
	C568.336853,291.757965 569.914185,297.944397 569.474854,304.717102 
	C569.419678,309.206757 570.268738,313.301208 568.351807,317.603790 
	C567.404175,331.822845 565.173706,345.458588 562.802002,359.502075 
	C563.594299,362.118591 562.833252,364.205841 562.306946,366.292786 
	C558.545471,381.209961 552.791382,395.413757 546.641541,409.872009 
	C544.774536,414.786133 542.230286,418.964417 540.079834,423.725586 
	C538.462891,426.968872 536.526428,429.621979 534.968262,432.886566 
	C534.036987,434.613220 533.429443,436.106873 532.618958,437.888977 
	C528.830994,442.696350 526.410034,447.973206 522.913574,452.969971 
	C519.993835,456.720490 518.112854,460.837799 514.289185,463.791504 
	C511.600067,464.855927 510.703094,467.132202 509.082092,469.249695 
	C508.596497,469.332520 508.396362,469.184357 507.913605,468.791138 
	C506.524353,465.780640 508.273407,463.794830 509.654480,461.845459 
	C512.778442,457.435913 515.899109,453.028229 518.967712,448.149536 
	C522.947998,442.852417 525.846497,437.333130 528.811401,431.455078 
	C529.207825,430.763336 529.436340,430.370514 529.822998,429.677643 
	C530.091125,429.180328 530.201111,428.983124 530.485962,428.496643 
	C532.629089,425.450134 533.222717,422.020264 535.200073,418.879944 
	C538.057556,413.732452 539.791748,408.475403 542.075928,403.056519 
	C544.722595,397.523010 545.745117,391.813263 547.978882,386.122833 
	C550.398804,379.480957 552.290222,373.077362 553.966553,366.197235 
	C555.392395,360.627533 556.315369,355.345123 557.799988,349.767456 
	C559.867554,337.726807 561.233582,326.034668 561.459351,313.795593 
	C560.068848,306.639557 560.627563,299.685242 559.024597,292.556610 
	C557.392029,282.848297 557.157898,273.340088 554.255859,263.860413 
	C552.252991,253.130661 548.990906,243.199463 545.064453,233.068848 
	C542.125610,224.564346 538.379578,216.828247 534.436523,208.785004 
	C531.182251,201.858597 528.026672,195.290314 523.554138,189.053787 
	C522.033997,186.675598 520.955688,184.434311 519.345093,182.122086 
	C518.676575,181.096436 518.202637,180.343903 517.459473,179.370377 
	C515.955261,177.041626 514.655518,174.977814 512.851440,172.871735 
	C511.841644,171.386627 511.097351,170.109314 509.790588,168.863800 
	C509.285889,168.332596 509.017822,168.011642 508.578888,167.427032 
	C507.841248,166.301544 507.315033,165.410446 506.493561,164.338699 
	C505.317413,162.439896 504.032928,161.047318 502.359436,159.554321 
	C494.278046,149.988800 485.428070,141.625687 476.508728,132.847626 
	C464.795715,122.871521 453.151550,113.390060 439.600677,105.909424 
	C429.247833,100.167397 419.241577,94.531807 408.628998,90.124275 
	C396.477234,85.077507 384.100891,80.670517 370.775269,77.945465 
	C360.126862,74.710907 349.608459,72.987236 338.514862,72.121292 
	C333.767303,71.334953 329.449677,70.448250 324.600342,70.481544 
	C323.613068,70.447128 323.046143,70.431633 322.045410,70.476753 
	C318.966827,70.414490 316.279388,70.748810 313.337952,69.500198 
	C311.304840,67.205986 310.714264,64.927643 311.732788,61.987259 
	C315.104980,59.849102 318.407227,60.445034 321.643494,60.921593 
	C324.426392,61.331398 327.211334,61.418125 330.464966,61.516586 
	C333.083649,61.496002 335.271027,61.264362 337.632263,62.708130 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M545.539917,410.296539 
	C551.774475,393.814850 558.676636,377.721771 562.552979,360.216370 
	C566.068359,360.914764 565.951233,364.166412 566.937073,366.542938 
	C569.503601,372.730133 570.418396,373.007111 575.138306,368.389679 
	C576.402649,367.152679 577.395691,365.533875 579.634644,365.033844 
	C581.210938,366.258972 580.387634,368.418030 582.127075,369.821228 
	C582.302185,370.331573 582.306458,370.554962 582.141418,371.068298 
	C578.659119,372.927094 578.578125,376.146729 577.931274,379.436523 
	C576.956238,382.110901 575.455261,384.492035 578.321533,386.999939 
	C578.591492,387.787079 578.566895,388.261993 578.236084,389.046509 
	C576.942993,390.157501 575.689697,390.223389 574.050293,390.155151 
	C569.920410,389.111023 567.937744,385.948395 565.456421,383.366272 
	C564.343323,382.207947 563.593628,379.865662 561.085510,381.911682 
	C559.982117,385.016663 562.095703,386.294098 563.758057,387.781982 
	C565.204224,389.076294 566.733826,390.274994 568.360229,391.883667 
	C569.407288,394.471161 568.253296,396.379608 567.249084,398.230591 
	C564.892639,402.573975 562.970581,407.099426 561.071594,412.042114 
	C560.744873,412.556854 560.591309,412.747162 560.127502,413.124512 
	C559.579895,413.309326 559.342529,413.307129 558.803833,413.124481 
	C556.727600,409.479858 554.138733,409.102234 550.610840,411.038391 
	C548.733765,411.313263 547.228210,411.343353 545.539917,410.296539 
z"/>
<path fill="#074D75" opacity="1.000000" stroke="none" 
	d="
M568.470032,317.938904 
	C568.059509,313.961884 568.038757,309.935425 568.073730,305.447998 
	C572.724548,300.587463 578.153137,299.307739 584.685425,300.726013 
	C585.611572,300.893280 586.112427,301.078918 586.887817,301.601868 
	C587.817627,303.936005 587.289673,306.072021 587.743164,308.504791 
	C588.239014,309.423889 588.535950,310.002197 588.964233,310.882019 
	C589.084656,313.505707 589.073730,315.827881 589.109436,318.589172 
	C589.100647,319.193359 589.045227,319.358521 588.890381,319.765503 
	C582.747437,313.653290 575.762207,316.161072 568.470032,317.938904 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M586.459412,340.261597 
	C586.558167,341.668579 586.322571,342.984711 586.031494,344.641724 
	C585.817200,345.167664 585.658386,345.352783 585.197998,345.330841 
	C580.579712,345.903778 576.351318,345.967773 572.207886,343.297852 
	C577.186218,344.471954 581.825867,343.168732 586.459412,340.261597 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M585.755310,357.587891 
	C585.826111,358.496185 585.682434,359.062653 585.298462,359.806702 
	C584.488098,360.459869 584.494568,361.153046 584.173462,362.068787 
	C583.549377,362.517120 583.110840,362.558716 582.392639,362.275513 
	C579.773010,360.716888 582.366333,357.283752 579.239380,356.015625 
	C579.756409,353.395325 581.899536,354.210510 584.101013,354.239655 
	C585.705688,355.008881 585.393005,356.210663 585.755310,357.587891 
z"/>
<path fill="#061426" opacity="1.000000" stroke="none" 
	d="
M581.974976,362.336548 
	C582.498718,362.089355 582.871582,362.110657 583.524414,362.157288 
	C585.301208,365.000549 583.213928,367.416992 582.511597,370.105591 
	C578.241638,370.236145 579.223206,367.912201 579.943726,365.364990 
	C580.593384,364.199219 581.208740,363.402161 581.974976,362.336548 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M585.459961,354.580994 
	C583.252258,355.069672 581.364197,355.242157 579.170471,355.672546 
	C577.526855,355.921631 576.188965,355.912781 574.447021,355.917908 
	C573.901489,355.764191 573.760010,355.596466 573.894653,355.249512 
	C577.437744,354.302246 580.704773,353.534180 584.369019,352.723022 
	C585.001404,352.596497 585.236694,352.513062 585.642944,352.762756 
	C585.802429,353.485535 585.791016,353.875183 585.459961,354.580994 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M585.887817,352.647339 
	C585.634583,353.041412 585.455383,352.986908 585.021118,352.806152 
	C584.831543,350.443909 584.896851,348.207947 584.929321,345.547852 
	C585.075745,345.095734 585.255188,345.067719 585.705322,345.011108 
	C585.971313,347.387970 585.966553,349.793396 585.887817,352.647339 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M573.868042,355.072937 
	C574.170715,355.070282 574.072998,355.496643 574.057983,355.714294 
	C573.643311,356.498596 573.050720,357.079346 572.568970,356.274963 
	C572.118286,355.522430 572.888367,355.205902 573.868042,355.072937 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M570.873901,341.766266 
	C570.487122,341.977661 569.867371,342.220337 569.639832,341.458954 
	C570.007080,341.485931 570.374329,341.512909 570.873901,341.766266 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M572.004150,342.996643 
	C571.701660,342.835052 571.394775,342.677124 571.047058,342.255920 
	C571.006165,341.992676 571.000000,341.999878 570.997009,342.002380 
	C571.299805,342.164215 571.605652,342.323547 571.951294,342.746521 
	C571.991089,343.010193 571.999756,343.000336 572.004150,342.996643 
z"/>
<path fill="#CFF3F8" opacity="1.000000" stroke="none" 
	d="
M98.865799,428.665192 
	C95.764938,429.136658 93.477455,430.639252 91.987228,433.828094 
	C90.840271,432.240936 89.751175,430.292877 88.384323,428.155640 
	C84.951729,424.429596 82.918724,420.368805 82.222244,415.278564 
	C82.100365,414.930145 82.077599,414.938171 82.093155,414.929596 
	C82.064224,414.515564 82.019745,414.110138 81.978958,413.397583 
	C82.462036,408.994171 83.800064,408.311310 89.409775,409.752686 
	C92.793251,416.110107 95.790390,422.212189 98.865799,428.665192 
z"/>
<path fill="#AEF6FB" opacity="1.000000" stroke="none" 
	d="
M89.809883,409.648071 
	C87.071571,410.237000 83.920410,409.072021 82.056442,412.722290 
	C79.537331,408.195160 77.626556,403.086731 75.941544,397.511108 
	C75.040581,394.349609 76.772942,394.071259 78.711044,394.466797 
	C80.593727,394.851013 82.180977,396.115936 84.342133,396.900238 
	C86.394302,401.127960 88.108978,405.208038 89.809883,409.648071 
z"/>
<path fill="#A0F5FC" opacity="1.000000" stroke="none" 
	d="
M84.625824,396.701294 
	C82.822334,398.543365 81.375832,397.203430 79.903999,396.311615 
	C78.573456,395.505402 77.285263,393.931763 76.022842,396.781616 
	C73.922035,393.258301 73.069641,388.996857 71.869690,384.449036 
	C76.073418,381.966370 78.113396,385.412384 81.047035,387.682983 
	C82.468628,390.676208 83.520317,393.515442 84.625824,396.701294 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M81.375214,387.481659 
	C77.816811,388.108429 76.133545,383.947998 72.234543,384.041443 
	C70.045418,380.491211 69.357300,376.580627 68.314896,372.396667 
	C70.417725,370.369934 71.603943,372.068939 72.736511,373.395416 
	C74.550514,375.519989 76.352058,377.625763 79.107315,379.266754 
	C80.614952,380.622040 80.985428,382.000519 80.721619,383.959534 
	C80.991272,385.256531 81.162384,386.191437 81.375214,387.481659 
z"/>
<path fill="#69E3FB" opacity="1.000000" stroke="none" 
	d="
M79.146759,379.696167 
	C76.116501,379.449371 74.588707,377.351715 72.810852,375.441650 
	C71.668953,374.214813 71.235458,372.038605 68.633713,372.029724 
	C67.841209,370.593353 67.391884,369.166199 66.844414,367.375549 
	C66.791664,366.846069 66.837059,366.680054 66.934189,366.261047 
	C66.310265,364.730377 66.044174,363.393188 67.632408,362.723389 
	C68.683670,362.280060 69.530342,363.167236 69.945587,364.091431 
	C71.129860,366.727203 73.422859,367.913116 76.259171,369.098389 
	C79.015083,372.254730 79.758461,375.667389 79.146759,379.696167 
z"/>
<path fill="#02ECFE" opacity="1.000000" stroke="none" 
	d="
M331.298920,596.130859 
	C327.616943,595.462830 324.307434,594.687622 320.866089,594.977356 
	C318.465729,595.179504 316.846069,594.014038 316.292114,591.083984 
	C318.173737,589.613770 319.900909,590.971252 322.005310,590.249512 
	C322.229553,590.222656 321.422485,589.210327 321.626526,589.845032 
	C321.718994,590.132751 321.640320,590.232361 321.442261,590.298523 
	C319.679443,590.887878 318.017853,589.720215 315.891571,590.034058 
	C313.657318,590.450623 311.814026,590.481445 309.606323,589.799561 
	C306.029755,585.389587 306.348267,582.819458 310.408630,579.964417 
	C312.249054,578.670349 314.561035,578.052307 316.207703,575.802246 
	C318.310852,573.702087 320.815552,573.711975 323.460938,572.981079 
	C326.610260,572.445618 329.355774,571.870972 332.470825,571.206970 
	C334.316956,570.714783 335.826874,570.456055 337.664551,569.906860 
	C343.156128,568.936218 347.986511,566.665649 353.639893,566.832642 
	C358.774994,566.698425 363.607758,567.668030 368.350952,566.163635 
	C369.928223,565.663330 371.823456,565.766663 372.656677,567.664978 
	C373.531708,569.658447 372.551910,571.206299 370.959290,572.399414 
	C370.031860,573.094238 369.095154,573.818665 368.061768,574.323303 
	C359.481049,578.514282 354.182831,586.308167 347.710175,592.807129 
	C344.663116,595.866577 341.811554,599.697876 337.580566,594.214172 
	C337.488495,594.094849 336.715881,594.500610 336.045288,594.954956 
	C334.423767,595.555603 332.938904,595.538940 331.298920,596.130859 
z"/>
<path fill="#1D1B1E" opacity="1.000000" stroke="none" 
	d="
M384.484619,553.360107 
	C384.898682,554.065063 384.931976,554.561462 384.967133,555.430908 
	C383.443237,556.225525 381.917480,556.647034 380.106415,557.246948 
	C379.098846,557.594604 378.376556,557.763855 377.314697,558.085754 
	C376.781616,558.344604 376.588135,558.450806 376.076721,558.649597 
	C375.758789,558.742126 375.880280,558.686829 375.813690,558.691162 
	C375.106476,560.169617 373.821503,559.923828 372.248169,559.805786 
	C371.151886,559.839233 370.416382,559.938171 369.327179,560.151123 
	C368.618011,560.431458 368.273438,560.617859 367.647552,560.811584 
	C364.158966,561.231873 360.964233,561.667847 357.366638,562.213623 
	C356.606812,562.443420 356.273926,562.611755 355.680237,562.821289 
	C355.398895,562.821167 355.197113,562.681335 355.094788,562.749146 
	C350.673157,565.596619 345.738983,565.255249 340.480377,565.583191 
	C331.196014,567.472229 322.272949,566.334351 313.388855,566.408752 
	C310.584778,566.432251 307.778564,566.474243 304.523193,566.268860 
	C303.479126,566.075989 302.934021,565.835327 302.162659,565.140259 
	C301.767242,564.164062 301.968323,563.666077 302.867218,563.084534 
	C303.740082,562.630615 304.257629,562.418274 305.177399,562.109619 
	C308.230286,561.490173 310.900848,561.565186 313.965210,561.888550 
	C314.866638,562.044922 315.377808,562.145691 316.273254,562.290283 
	C318.777130,562.587097 320.787903,561.819641 323.276062,561.634705 
	C341.180359,561.185913 358.375488,558.669983 375.332336,554.390625 
	C378.194031,553.668457 381.021667,552.426575 384.484619,553.360107 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M339.722534,564.593262 
	C344.724976,563.827515 349.415710,563.291199 354.549438,562.785889 
	C354.685730,563.971436 354.378998,565.125916 354.034119,566.638977 
	C348.909851,568.319824 343.823761,569.642151 338.333374,570.955933 
	C336.315643,568.395935 337.691711,566.567749 339.722534,564.593262 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M372.101562,560.045715 
	C372.947113,559.391235 374.006775,559.042175 375.406769,558.694336 
	C375.749329,561.622742 374.145996,561.222168 372.101562,560.045715 
z"/>
<path fill="#1A6D97" opacity="1.000000" stroke="none" 
	d="
M330.956299,596.236572 
	C332.251282,595.237793 333.585785,594.703186 335.474731,595.192871 
	C334.447601,595.817871 333.065338,596.387207 331.347076,596.960449 
	C331.011108,596.964355 330.950439,596.480347 330.956299,596.236572 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M364.260315,586.810669 
	C363.724365,587.579590 363.193878,587.957947 362.584747,587.332031 
	C362.451019,587.194702 362.491547,586.658630 362.646667,586.510986 
	C363.174561,586.008850 363.777740,585.932983 364.260315,586.810669 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M379.734619,579.029846 
	C379.617462,579.441711 379.221161,579.869934 378.824890,580.298218 
	C378.679993,580.119812 378.535065,579.941345 378.390137,579.762939 
	C378.745239,579.524048 379.100342,579.285156 379.734619,579.029846 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M373.499512,583.523804 
	C373.091675,583.596375 372.840240,583.515259 372.588806,583.434143 
	C372.869843,583.159180 373.150848,582.884216 373.431885,582.609192 
	C373.506531,582.862854 373.581207,583.116516 373.499512,583.523804 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M385.341980,577.795532 
	C384.914734,578.316223 384.397797,578.650757 384.374512,577.857544 
	C384.359161,577.334961 384.897797,577.127380 385.341980,577.795532 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M367.906677,585.638855 
	C368.176392,585.364075 368.575409,585.251282 368.982269,585.194519 
	C369.051208,585.184998 369.153778,585.416443 369.240784,585.536560 
	C368.840057,585.630920 368.439362,585.725342 367.906677,585.638855 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M379.996277,578.994507 
	C380.341461,578.743774 380.689789,578.497192 381.051025,578.271240 
	C381.058685,578.266418 381.214996,578.499207 381.301941,578.621094 
	C381.030792,578.740723 380.759674,578.860291 380.251160,578.996704 
	C380.013794,579.013489 380.000977,579.001099 379.996277,578.994507 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M375.446045,581.535095 
	C375.409943,581.476257 375.482117,581.593933 375.446045,581.535095 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M367.652588,560.810486 
	C367.691193,560.597351 368.028748,560.398865 368.669891,560.232788 
	C368.632843,560.451782 368.292175,560.638428 367.652588,560.810486 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M375.995056,558.764160 
	C375.870789,558.383667 376.114380,558.196472 376.732330,558.209473 
	C376.810211,558.533691 376.562286,558.716248 375.995056,558.764160 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M355.685852,562.832458 
	C355.725708,562.628357 356.052521,562.435547 356.671509,562.283081 
	C356.633423,562.496826 356.303101,562.670288 355.685852,562.832458 
z"/>
<path fill="#30A0CE" opacity="1.000000" stroke="none" 
	d="
M393.902283,572.356689 
	C398.667267,571.702393 402.600708,569.228271 407.304871,567.985413 
	C408.519257,568.705017 407.894592,569.267578 407.184601,570.197998 
	C402.813751,573.361511 397.698456,572.357056 393.153015,573.782166 
	C392.690430,573.927246 393.416473,572.973450 393.902283,572.356689 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M407.389099,570.467346 
	C407.167999,569.892456 407.328430,569.233276 407.575562,568.243042 
	C408.884644,566.355469 410.748779,567.613281 412.561798,566.856628 
	C412.983826,567.285339 413.004395,567.743774 413.005157,568.546021 
	C411.247162,569.387634 409.508911,569.885315 407.389099,570.467346 
z"/>
<path fill="#075A81" opacity="1.000000" stroke="none" 
	d="
M113.657059,130.157013 
	C119.834488,121.882103 127.554146,115.490173 135.002197,108.362221 
	C148.273331,97.014847 161.955490,86.797165 177.571442,78.756432 
	C179.806625,84.456726 175.106979,94.251678 169.702881,96.338104 
	C164.769974,98.242607 159.783554,100.076523 155.174393,102.737877 
	C152.859619,104.074432 151.425522,105.963524 151.321823,108.734436 
	C151.203674,111.891243 149.350937,114.193985 147.745026,116.763435 
	C144.001770,122.752678 140.690659,129.017807 138.677368,136.192322 
	C138.690796,141.648499 134.231873,143.666702 131.376724,146.690308 
	C129.016968,149.189301 128.680023,151.045151 131.545334,153.536621 
	C131.787918,157.855240 128.758224,160.029572 126.333755,162.937805 
	C125.669777,163.684418 125.218933,164.168716 124.593384,164.930176 
	C123.637405,165.967422 123.075806,166.881378 122.409973,168.138702 
	C121.919418,168.791748 121.571106,169.109589 120.865265,169.572052 
	C120.070892,169.939957 119.586662,170.078705 118.704933,170.225586 
	C116.486732,170.390747 114.655891,170.457932 112.534592,169.681198 
	C110.313225,166.990082 112.283501,165.325150 113.774864,164.006882 
	C117.733276,160.507950 118.444130,155.691956 119.400307,151.018021 
	C120.184013,147.187149 118.503830,144.234161 115.123268,142.262894 
	C109.078857,138.738312 108.821999,137.450806 113.029984,131.841187 
	C113.332458,131.437943 113.580772,131.020203 113.657059,130.157013 
z"/>
<path fill="#0A5D87" opacity="1.000000" stroke="none" 
	d="
M138.338181,137.132675 
	C135.439285,133.702530 138.237228,131.220001 139.731903,129.050110 
	C143.341766,123.809456 143.722885,116.777824 149.111160,112.534065 
	C149.821625,111.974503 149.858109,110.398605 149.971863,109.269760 
	C150.466171,104.364082 154.076279,100.068497 158.917221,99.044609 
	C169.663239,96.771774 177.000107,91.253647 177.935760,79.065689 
	C179.534241,77.626747 181.151672,76.607498 182.976044,75.334091 
	C186.913986,73.591904 190.034836,70.810066 194.428040,69.906029 
	C198.248199,69.961906 198.893936,72.860115 199.766739,75.211906 
	C201.769775,80.609016 201.851776,85.963440 198.279449,91.319252 
	C197.034363,94.192719 194.607986,95.109360 192.143463,96.502747 
	C190.646805,97.115128 189.240662,96.505966 187.933380,97.640930 
	C187.556656,98.024315 187.401093,98.177513 186.977463,98.528442 
	C175.144943,105.761742 163.835358,113.136223 154.120911,123.198227 
	C153.615555,123.440079 153.399246,123.499878 152.852631,123.536453 
	C152.083588,123.351227 151.875320,123.054535 151.975586,122.577568 
	C151.719757,122.952034 151.707611,123.348564 151.899979,124.094772 
	C151.908142,124.886292 151.825195,125.333229 151.548294,126.090355 
	C147.012039,129.855057 143.727768,134.599655 138.338181,137.132675 
z"/>
<path fill="#033256" opacity="1.000000" stroke="none" 
	d="
M35.371719,324.043945 
	C35.007896,323.251129 35.001785,322.493683 34.987171,321.357178 
	C34.373634,316.204834 36.054199,311.596069 35.978725,306.422302 
	C36.093784,304.205170 35.723434,302.359558 36.835548,300.345093 
	C44.446453,296.632782 53.753281,300.338379 56.597439,307.815918 
	C59.024872,314.197815 60.312717,320.800781 60.466850,327.632935 
	C60.510315,329.559448 60.022110,331.675079 62.217270,333.443054 
	C65.352531,338.438171 64.023346,343.774323 64.838097,349.187805 
	C64.679024,349.884430 64.570854,350.151825 64.144913,350.712799 
	C62.637516,351.007965 61.478226,350.950470 60.862125,349.670349 
	C57.151814,341.961029 49.210297,337.647797 45.253567,330.034760 
	C43.432156,326.530212 39.225437,325.581146 35.371719,324.043945 
z"/>
<path fill="#55CFFB" opacity="1.000000" stroke="none" 
	d="
M63.923115,351.411560 
	C63.876122,350.840271 63.925106,350.674133 64.044388,350.257935 
	C65.659668,348.709808 67.155251,349.262085 68.950951,350.391724 
	C69.579002,351.083771 69.822838,351.551941 70.079224,352.434723 
	C70.265877,356.786743 70.494461,360.699921 75.207993,362.836609 
	C76.716797,365.014038 77.430054,367.014648 76.405792,369.619385 
	C72.736893,369.258484 69.680840,368.619080 68.601906,364.241547 
	C68.137711,362.358215 67.243675,364.313507 67.015686,365.661560 
	C65.218933,361.440277 65.019508,356.544739 63.923115,351.411560 
z"/>
<path fill="#12628E" opacity="1.000000" stroke="none" 
	d="
M197.325287,92.140640 
	C197.105576,91.170685 196.944290,90.179817 197.356339,89.588478 
	C202.254761,82.558937 199.594681,76.349632 195.095459,70.069099 
	C203.655350,65.120071 212.990128,61.542278 222.813370,58.292309 
	C223.516983,57.758602 223.976562,57.498043 224.703140,57.262962 
	C226.522675,63.880173 228.286819,70.443947 227.575272,77.707703 
	C225.111557,81.808922 220.631104,81.775070 216.901276,83.868431 
	C211.133469,85.872963 206.259125,88.906723 200.777893,91.502365 
	C199.561615,92.058212 198.645218,92.354218 197.325287,92.140640 
z"/>
<path fill="#1A6D97" opacity="1.000000" stroke="none" 
	d="
M227.395325,78.263504 
	C226.937469,71.318306 224.012070,64.893105 224.976929,57.673809 
	C231.052414,55.579399 237.134705,53.870358 243.598907,52.158596 
	C247.844864,57.991707 249.216125,64.230896 246.883942,71.429840 
	C245.495422,73.908882 243.307693,74.403442 240.847534,75.189285 
	C236.110794,75.956154 232.285706,78.714424 227.395325,78.263504 
z"/>
<path fill="#2478A2" opacity="1.000000" stroke="none" 
	d="
M246.303802,72.092438 
	C247.786514,65.249748 245.884171,59.093216 243.987396,52.545631 
	C250.244644,50.186848 256.622528,48.727882 263.557983,47.861816 
	C265.968842,50.940208 266.813049,54.498695 267.942841,57.913792 
	C269.045502,61.246796 267.308594,64.012802 265.234131,66.980721 
	C264.885559,67.568512 264.724182,67.790848 264.252869,68.285812 
	C258.230377,70.158775 252.684402,72.514442 246.303802,72.092438 
z"/>
<path fill="#2B82AB" opacity="1.000000" stroke="none" 
	d="
M264.514740,67.597488 
	C263.986725,66.137329 264.393219,65.118118 265.261658,64.257584 
	C267.774597,61.767509 267.411591,58.953625 266.033234,56.133709 
	C264.876770,53.767738 263.626465,51.465984 263.986145,48.275208 
	C267.382721,47.206150 270.784729,46.560532 274.592285,45.810692 
	C275.738373,45.726299 276.478912,45.746136 277.591614,45.758301 
	C281.134949,51.727127 282.898346,57.850937 279.658569,64.831741 
	C274.830566,67.562950 269.973450,68.321152 264.514740,67.597488 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M238.270996,45.120472 
	C238.124893,44.458141 238.117966,43.963280 238.771500,44.244816 
	C238.811676,44.262119 238.557449,44.962795 238.270996,45.120472 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M222.291641,53.347393 
	C222.080673,53.078625 222.199997,52.595417 222.683151,52.024239 
	C223.371536,52.500759 223.231171,52.900124 222.291641,53.347393 
z"/>
<path fill="#055280" opacity="1.000000" stroke="none" 
	d="
M585.432678,301.615662 
	C579.332764,300.602539 573.977661,302.156555 568.496460,304.984497 
	C567.661987,298.643585 567.194580,292.300110 566.727417,285.502502 
	C571.720825,279.586639 577.889832,278.345337 584.703735,281.748108 
	C585.960693,285.849823 586.918945,289.694733 587.870972,293.946838 
	C586.663635,296.539581 587.288818,299.305786 585.432678,301.615662 
z"/>
<path fill="#0A5D87" opacity="1.000000" stroke="none" 
	d="
M585.002441,281.562653 
	C578.801086,280.847015 572.735718,280.493744 567.106323,285.006073 
	C565.485718,278.631805 564.243652,272.215271 563.034790,265.392334 
	C568.907410,257.875732 575.272339,257.684387 581.729736,264.724091 
	C584.262939,270.150055 584.832825,275.598053 585.002441,281.562653 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M582.005737,264.612610 
	C579.431702,264.967224 578.339233,262.435852 576.182495,261.571869 
	C571.121521,259.544525 567.406555,261.945618 563.419922,264.947906 
	C561.641418,259.299133 560.214966,253.612289 558.718262,247.527771 
	C564.163879,240.755203 570.174072,239.829514 576.693481,244.696838 
	C577.096680,245.318390 577.284912,245.580368 577.772278,245.897552 
	C579.133362,250.832092 580.277893,255.652130 581.696472,260.733002 
	C581.980896,262.066010 581.991272,263.138153 582.005737,264.612610 
z"/>
<path fill="#1D98D1" opacity="1.000000" stroke="none" 
	d="
M585.505249,301.904541 
	C584.982178,299.205780 586.146179,296.940826 587.597656,294.517944 
	C587.937866,295.025665 588.010986,295.697327 588.158325,296.703003 
	C588.186951,298.413208 588.141357,299.789429 588.023010,301.573425 
	C587.791809,302.167633 587.633240,302.354034 587.190063,302.308746 
	C586.532166,302.026978 586.158997,301.976959 585.505249,301.904541 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M81.828354,415.219849 
	C84.064674,419.036591 86.028984,423.143005 88.049927,427.607971 
	C84.225578,427.303162 80.363853,426.471863 76.458153,426.024231 
	C72.624313,425.584869 75.403328,424.278198 75.886597,423.386658 
	C73.626190,420.980255 69.805870,427.018951 68.015518,421.406769 
	C75.309975,422.857513 80.249817,423.091125 83.343262,421.634277 
	C78.902672,419.840790 74.188484,420.330780 69.438721,418.984192 
	C68.997177,416.633240 66.265991,416.789490 65.223701,414.618225 
	C70.883049,413.738281 76.176941,416.474609 81.828354,415.219849 
z"/>
<path fill="#040E11" opacity="1.000000" stroke="none" 
	d="
M227.815796,577.574219 
	C230.355667,577.395325 232.729614,577.638306 235.550400,577.850037 
	C237.079422,577.891296 238.161606,577.963867 239.645996,577.963806 
	C247.723862,576.929626 255.223373,578.528076 263.181213,579.510864 
	C266.691711,579.906433 269.753174,580.497986 272.800659,581.113281 
	C274.481232,581.452576 276.489746,581.557129 276.994934,584.129272 
	C276.541321,584.970337 276.129578,585.314819 275.257446,585.722534 
	C267.870789,585.901794 260.846649,586.054688 253.443817,585.165405 
	C244.912842,583.350586 237.340958,579.394897 228.442398,578.893921 
	C227.902679,578.545410 227.776276,578.270813 227.815796,577.574219 
z"/>
<path fill="#071A2D" opacity="1.000000" stroke="none" 
	d="
M227.621155,577.057922 
	C227.994507,577.430054 228.007263,577.707886 228.024567,578.402832 
	C224.972565,578.544983 221.916046,578.269958 218.446350,577.922485 
	C218.015167,577.545959 218.024246,577.242798 218.064514,576.713257 
	C221.132599,576.645325 224.196594,576.804443 227.621155,577.057922 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M251.901611,587.218750 
	C255.174103,587.720459 258.696381,585.574829 261.638733,588.505127 
	C258.355682,588.416321 255.073883,587.953735 251.901611,587.218750 
z"/>
<path fill="#11547D" opacity="1.000000" stroke="none" 
	d="
M236.379669,586.821655 
	C235.940445,586.432556 235.960266,586.063599 235.960022,585.418213 
	C238.978073,585.442322 242.016205,585.742737 245.485260,586.068115 
	C246.113159,586.226562 246.310150,586.360229 246.241669,586.732666 
	C242.930374,586.928223 239.884537,586.885010 236.379669,586.821655 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M246.258118,587.110596 
	C245.976212,586.971436 245.981567,586.529297 245.948883,586.311157 
	C246.895874,586.188293 248.491608,585.471863 248.456894,587.119629 
	C248.435471,588.136597 247.233597,587.491943 246.258118,587.110596 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M266.218750,589.279968 
	C267.234344,589.135742 268.474152,589.296387 269.986633,589.730225 
	C268.987213,589.863892 267.715118,589.724365 266.218750,589.279968 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M265.229248,589.015259 
	C265.169403,588.664673 265.325470,588.209595 265.941345,588.802734 
	C265.848633,589.001343 265.671753,589.013062 265.229248,589.015259 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M270.953125,590.132446 
	C271.029785,589.960510 271.222321,589.968201 271.702911,589.999268 
	C271.787720,590.450684 271.543396,590.747864 270.953125,590.132446 
z"/>
<path fill="#0BC3FC" opacity="1.000000" stroke="none" 
	d="
M542.985840,466.646545 
	C542.761841,467.752869 542.522461,468.537262 542.138672,469.599915 
	C541.877380,470.027008 541.760437,470.175812 541.361572,470.291321 
	C534.925537,467.898651 534.918945,460.039490 529.027954,457.006866 
	C528.024353,453.787109 529.958435,452.132751 532.479248,450.506409 
	C536.045837,451.287323 538.684204,452.966125 540.610046,456.100006 
	C540.830933,458.318024 537.962769,460.295105 541.042786,462.335876 
	C540.374390,464.530182 542.835754,464.876709 542.985840,466.646545 
z"/>
<path fill="#061426" opacity="1.000000" stroke="none" 
	d="
M532.929871,450.716064 
	C531.364319,452.610138 530.141296,454.419525 528.809631,456.545227 
	C527.289124,458.753052 525.877319,460.644531 524.231323,462.760315 
	C523.970825,462.494476 523.944641,462.004333 523.876587,461.147949 
	C522.541504,458.943634 523.725037,457.536499 524.859070,455.791199 
	C528.419739,450.746857 531.451294,445.807739 533.979187,440.167847 
	C534.733826,438.548462 535.192749,437.173187 536.342896,435.756226 
	C538.074951,434.402466 539.332031,434.471313 540.329224,436.553864 
	C539.459656,439.608917 538.385376,442.242188 537.032288,445.142700 
	C535.586060,447.124939 535.099609,449.342529 532.929871,450.716064 
z"/>
<path fill="#071F39" opacity="1.000000" stroke="none" 
	d="
M542.790039,477.472168 
	C544.057495,477.320587 545.031616,476.894501 545.536987,478.158020 
	C546.295349,480.054047 545.099304,481.114868 543.546814,482.359558 
	C541.595337,483.494934 538.815430,483.370758 538.812561,482.167206 
	C538.808350,480.444702 539.319824,477.524200 542.790039,477.472168 
z"/>
<path fill="#033256" opacity="1.000000" stroke="none" 
	d="
M540.851440,470.483856 
	C541.242920,470.220825 541.406128,470.183594 541.781799,470.012299 
	C544.264221,471.217010 543.147827,472.766937 542.127319,474.647797 
	C540.950500,475.429718 539.945374,477.015717 538.964783,474.780762 
	C538.056091,472.709625 538.591614,471.465057 540.851440,470.483856 
z"/>
<path fill="#033B5F" opacity="1.000000" stroke="none" 
	d="
M535.618835,491.688751 
	C534.112000,491.449371 533.969543,490.680664 534.615479,489.671478 
	C535.011230,489.053162 535.588806,488.774048 536.147949,489.362671 
	C536.856567,490.108551 536.242554,490.830170 535.618835,491.688751 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M95.735321,442.935608 
	C96.435890,443.381470 96.790482,443.850098 97.201279,444.619934 
	C95.844681,444.571991 94.431877,444.222839 91.611916,443.525909 
	C93.782333,443.199829 94.585831,443.079102 95.735321,442.935608 
z"/>
<path fill="#021429" opacity="1.000000" stroke="none" 
	d="
M82.250061,436.047485 
	C81.715607,438.150665 80.270271,436.587494 78.879105,436.831238 
	C79.824104,435.477570 80.990105,436.221344 82.250061,436.047485 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M89.931030,442.344849 
	C89.053154,443.242767 87.990860,443.187286 86.885674,442.513031 
	C87.787605,441.706970 88.777214,442.061584 89.931030,442.344849 
z"/>
<path fill="#021429" opacity="1.000000" stroke="none" 
	d="
M56.932011,428.308411 
	C57.479031,428.277618 57.866699,428.404541 58.254368,428.531433 
	C58.148144,428.636810 58.018414,428.847382 57.939648,428.829803 
	C57.543331,428.741302 57.160332,428.593231 56.932011,428.308411 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M582.093018,370.370422 
	C582.694397,367.760529 583.290405,365.344696 583.845459,362.555786 
	C584.041748,361.574158 584.278992,360.965607 584.787231,360.170654 
	C585.043579,360.429291 585.028870,360.874359 585.033325,361.652588 
	C584.234680,367.148926 583.416931,372.312073 582.319092,377.741760 
	C581.787476,378.104675 581.535767,378.201050 580.968872,378.042450 
	C579.927734,375.574005 580.457031,373.535065 581.776733,371.259674 
	C582.035339,370.949280 582.087585,370.564484 582.093018,370.370422 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M585.098999,355.238403 
	C585.140320,354.897217 585.424072,354.883057 585.562500,354.863831 
	C585.787415,355.615875 585.873962,356.387146 585.965149,357.544067 
	C585.046448,357.386688 585.019531,356.495728 585.098999,355.238403 
z"/>
<path fill="#075479" opacity="1.000000" stroke="none" 
	d="
M113.355148,129.955200 
	C116.135735,131.584732 113.528862,132.423752 112.915665,133.657242 
	C111.462059,136.581223 109.259422,139.297836 114.953827,140.685760 
	C119.565720,141.809830 122.026863,146.600037 120.838089,151.323898 
	C119.551132,156.437897 119.229874,162.178284 114.032784,165.552094 
	C113.153336,166.123001 112.711418,167.367905 112.030205,168.646515 
	C108.849365,174.436768 104.772530,179.276169 101.549644,185.098679 
	C95.494087,193.035873 90.904144,201.442001 86.444984,209.929962 
	C85.617973,211.504166 85.312775,213.442993 83.123444,214.393021 
	C79.809723,207.183472 77.492996,199.715988 73.467766,192.886627 
	C72.200500,190.736526 74.687263,187.579941 74.350121,184.385712 
	C74.680450,183.191956 75.132980,182.355453 75.649719,181.239868 
	C79.523453,175.063141 83.332970,169.165482 87.227287,162.969910 
	C94.473770,153.331253 101.635452,143.990494 108.927895,134.336853 
	C110.206474,132.522110 111.252357,130.914978 113.355148,129.955200 
z"/>
<path fill="#03D1FB" opacity="1.000000" stroke="none" 
	d="
M466.777771,544.589355 
	C464.725403,544.221008 466.031555,543.653809 466.557648,543.328308 
	C467.053070,543.021790 467.807617,542.771118 468.100006,543.604797 
	C468.151611,543.751953 467.405060,544.179016 466.777771,544.589355 
z"/>
<path fill="#2A8AB5" opacity="1.000000" stroke="none" 
	d="
M279.379944,65.045471 
	C281.340668,58.600082 278.977722,52.655460 277.974274,46.192024 
	C281.550110,44.187054 285.544495,45.482899 289.569702,44.164742 
	C294.271851,49.846249 295.338593,56.026188 292.637634,63.096825 
	C288.481018,66.264427 284.065735,65.439880 279.379944,65.045471 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M292.354431,63.333981 
	C294.155792,56.682793 291.869202,50.824436 290.037231,44.544453 
	C292.773834,43.956940 295.572357,43.736832 298.686554,43.277458 
	C299.740662,43.064110 300.479156,43.090023 301.584839,43.156136 
	C305.606079,49.180706 304.977966,55.428501 302.868591,62.169350 
	C299.587433,65.299530 296.185547,64.819229 292.354431,63.333981 
z"/>
<path fill="#248BBE" opacity="1.000000" stroke="none" 
	d="
M308.699707,588.717773 
	C310.923187,589.057739 312.843689,589.148499 315.173279,589.229370 
	C316.210938,589.314941 316.488922,589.678345 316.185059,590.638916 
	C315.953979,590.967773 315.964203,590.986389 315.962952,590.973999 
	C311.690887,592.245728 307.364441,593.180725 302.426208,593.036255 
	C303.240753,590.849670 306.115143,592.995544 307.765015,590.708130 
	C305.531494,589.927673 303.490784,589.214661 301.215637,588.223022 
	C300.901276,587.694336 300.821320,587.444275 300.986938,586.885254 
	C304.161346,585.159729 306.240143,586.961426 308.699707,588.717773 
z"/>
<path fill="#01BEE9" opacity="1.000000" stroke="none" 
	d="
M299.273743,593.981079 
	C298.934174,593.946472 299.054260,593.464722 299.098572,593.220215 
	C299.852539,592.992859 300.562164,593.009949 301.626434,593.050293 
	C301.419830,593.960571 300.538208,594.042542 299.273743,593.981079 
z"/>
<path fill="#0F62A1" opacity="1.000000" stroke="none" 
	d="
M577.583740,423.929230 
	C577.284973,425.664185 576.635254,427.373047 575.986572,429.415588 
	C571.744141,436.623627 567.500793,443.497955 563.148376,450.699768 
	C562.125793,452.203461 561.212280,453.379669 560.180298,454.857178 
	C559.511292,455.308014 559.062988,455.156036 558.607422,454.332428 
	C557.752380,451.531494 559.220520,449.494446 559.786255,446.910095 
	C562.301636,439.369324 565.405090,432.417328 566.929138,424.557800 
	C567.849548,422.599213 568.437683,420.852814 570.532593,419.958984 
	C572.938538,421.433899 574.453979,423.690369 577.583740,423.929230 
z"/>
<path fill="#0DA5E9" opacity="1.000000" stroke="none" 
	d="
M541.582275,463.152710 
	C538.119202,461.884338 537.316101,460.028198 539.684814,457.034637 
	C540.112488,456.679504 540.315369,456.554901 540.843750,456.283539 
	C541.401733,456.090027 541.634277,456.043213 542.220093,455.976929 
	C544.055481,456.092194 545.497803,455.863403 546.955017,455.598602 
	C548.428406,455.330933 549.625183,455.631317 549.189514,457.864380 
	C548.977234,458.606110 548.960449,459.060760 548.912842,459.855255 
	C548.722290,460.323120 548.562561,460.451111 548.193848,460.804138 
	C547.984924,461.029114 547.989502,460.987305 548.010376,460.989807 
	C546.104187,462.037872 544.320435,463.466003 541.582275,463.152710 
z"/>
<path fill="#009AED" opacity="1.000000" stroke="none" 
	d="
M560.659546,446.760681 
	C560.266235,449.103119 559.600891,451.181458 558.820007,453.609436 
	C558.601746,454.155426 558.499084,454.351776 558.199707,454.280151 
	C556.291687,453.678925 554.580261,453.345642 552.236084,452.734772 
	C551.196472,449.639893 552.689148,447.670166 554.894043,445.707153 
	C557.048340,445.371155 558.784546,445.571503 560.659546,446.760681 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M549.300964,457.988892 
	C548.816528,456.509857 548.122253,455.628235 546.620483,456.976593 
	C545.223145,458.231110 543.978027,457.363678 542.310181,457.014282 
	C541.555176,456.411957 541.652283,455.803040 541.927795,454.892578 
	C542.134216,454.408813 542.230591,454.221008 542.503296,453.768982 
	C542.814514,453.340302 542.949341,453.175812 543.548462,452.567963 
	C544.528320,451.726532 545.091003,451.404816 545.955933,450.948517 
	C551.203430,448.056000 551.203430,448.056000 551.668945,452.575928 
	C551.808533,452.878571 551.963074,452.939667 552.039062,452.975159 
	C550.856018,454.395477 551.256836,456.644409 549.300964,457.988892 
z"/>
<path fill="#0F62A1" opacity="1.000000" stroke="none" 
	d="
M541.076294,463.281067 
	C543.252625,462.315613 545.271545,461.601990 547.660767,460.940369 
	C546.535583,462.864532 545.040039,464.736755 543.272827,466.788727 
	C542.268982,465.846405 540.154175,465.562347 541.076294,463.281067 
z"/>
<path fill="#044166" opacity="1.000000" stroke="none" 
	d="
M551.316223,467.885040 
	C550.350647,465.846863 552.209778,464.666077 553.277039,462.829224 
	C553.765686,462.566833 554.007751,462.546082 554.261597,462.889557 
	C553.378235,464.743683 552.483093,466.233582 551.316223,467.885040 
z"/>
<path fill="#1391DB" opacity="1.000000" stroke="none" 
	d="
M557.991333,454.359650 
	C558.003052,454.012207 558.355408,453.989929 558.529907,453.974487 
	C558.965271,454.276947 559.226135,454.594818 559.774414,455.035583 
	C559.521240,456.317352 558.980591,457.476257 558.151917,458.783691 
	C557.561768,458.475647 557.471680,457.980377 557.808411,457.119812 
	C558.008972,456.097748 557.994263,455.402435 557.991333,454.359650 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M546.318115,472.054993 
	C546.433960,471.166443 546.675659,470.061249 548.021851,470.522125 
	C548.259827,470.603577 548.569885,471.028778 548.538269,471.251434 
	C548.359985,472.506287 547.271301,471.836212 546.318115,472.054993 
z"/>
<path fill="#044166" opacity="1.000000" stroke="none" 
	d="
M553.711609,462.753540 
	C554.043213,461.727631 554.562744,460.867645 555.311890,459.805603 
	C555.781738,459.582581 556.021973,459.561584 556.268799,459.902283 
	C555.774048,461.142120 555.272705,462.020325 554.522339,463.076172 
	C554.148804,463.142395 554.024170,463.030945 553.711609,462.753540 
z"/>
<path fill="#044166" opacity="1.000000" stroke="none" 
	d="
M557.719727,456.911346 
	C558.016235,457.269501 558.008789,457.745911 557.932617,458.577301 
	C557.486755,459.290253 557.109619,459.648193 556.503906,460.135040 
	C556.275391,460.263916 555.911987,459.932465 555.726746,459.768005 
	C556.166260,458.745575 556.791077,457.887573 557.719727,456.911346 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M545.974060,471.974731 
	C545.898987,472.410919 545.850769,472.864349 545.769043,473.311707 
	C545.759766,473.362213 545.561157,473.378082 545.450317,473.409973 
	C545.472961,473.021149 545.495544,472.632385 545.773071,472.130432 
	C546.027893,472.017303 545.991028,471.990204 545.974060,471.974731 
z"/>
<path fill="#044166" opacity="1.000000" stroke="none" 
	d="
M550.998657,467.991028 
	C550.899353,467.875214 550.823181,468.711792 550.888062,468.010284 
	C551.044495,468.046600 551.012634,468.010559 550.998657,467.991028 
z"/>
<path fill="#0F62A1" opacity="1.000000" stroke="none" 
	d="
M548.179688,460.941589 
	C547.983276,460.688080 548.135376,460.442474 548.661621,460.243713 
	C548.802917,460.484192 548.633728,460.703827 548.179688,460.941589 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M63.970390,422.344849 
	C63.459179,423.134552 62.154720,423.107025 62.138401,422.646576 
	C62.099888,421.559814 63.173477,422.187439 63.970390,422.344849 
z"/>
<path fill="#2AD5F9" opacity="1.000000" stroke="none" 
	d="
M258.227325,575.327148 
	C256.171112,574.807312 254.311523,575.466858 252.650375,574.505920 
	C252.384933,571.404907 257.452606,571.739624 256.199829,568.189575 
	C251.214722,568.627441 246.764130,568.226135 242.664322,564.908447 
	C242.275757,564.062866 242.210236,563.544556 242.370651,562.642273 
	C243.192596,561.083618 244.520584,560.898865 245.933136,560.144348 
	C246.468307,559.838623 246.692154,559.733154 247.280914,559.559570 
	C253.948364,560.366455 259.770630,563.032471 266.253906,564.557922 
	C266.946594,564.962463 267.312103,565.227722 267.916870,565.706909 
	C268.667145,566.266968 269.177002,566.610718 270.032562,566.952759 
	C270.505615,567.120361 270.695007,567.186890 271.168671,567.350220 
	C271.837524,567.562256 272.226227,567.661377 272.922546,567.781067 
	C274.789886,567.706970 276.374695,568.961304 278.123779,567.494995 
	C279.303436,565.954163 279.639160,564.323181 280.852325,562.758057 
	C281.370667,562.408569 281.608276,562.309570 282.234192,562.145142 
	C285.003021,562.486206 287.560974,562.336670 289.659607,564.628052 
	C290.352020,566.369507 290.322540,567.747070 289.703491,569.494995 
	C288.563171,570.988342 287.264801,571.140503 285.549927,571.101685 
	C284.370575,570.940002 283.611481,570.574768 282.810394,570.413818 
	C282.170044,570.285217 281.763855,570.835632 282.388062,570.601562 
	C283.012207,570.367371 282.199280,571.585815 282.767395,571.297241 
	C283.483551,572.765076 284.740875,573.807251 283.545959,575.578979 
	C280.377197,576.822327 277.415680,576.329468 274.095306,576.408630 
	C272.376068,576.418457 271.044678,576.281433 269.364929,576.805298 
	C268.703491,576.936462 268.435120,576.974426 267.758606,577.027588 
	C264.452576,576.300476 261.345947,576.840820 258.227325,575.327148 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M242.663879,563.820312 
	C246.491913,566.903381 250.994995,566.839844 255.482056,568.060486 
	C246.272308,571.325562 236.937271,570.801147 227.553131,566.022705 
	C226.169037,565.288513 224.895477,565.143127 223.729126,564.037720 
	C223.401031,563.221802 223.416046,562.727417 223.798538,561.930176 
	C224.671982,561.186157 225.400558,561.011475 226.539429,560.972900 
	C228.548431,561.283691 230.166290,561.687317 232.125153,562.081055 
	C233.518387,562.692627 234.547852,563.611023 236.093475,562.407227 
	C237.044464,562.016724 237.724915,561.909180 238.786102,561.882080 
	C240.451157,562.020508 241.570404,562.507019 242.663879,563.820312 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M257.687805,575.316223 
	C261.041138,575.062744 264.203552,574.567688 267.599579,575.963745 
	C268.376190,578.699646 265.707581,578.955261 264.264099,580.619080 
	C256.304565,579.915466 248.585403,578.977112 240.457230,577.964966 
	C240.615204,577.010193 241.523224,577.017822 242.750793,576.959106 
	C245.068085,576.107361 247.132553,576.649902 249.552063,576.765076 
	C252.597900,577.329163 255.061920,576.666931 257.687805,575.316223 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M223.617645,563.760376 
	C225.140366,563.937439 226.031174,564.614075 227.061859,565.616943 
	C226.638428,565.966797 226.063293,566.017578 225.057831,566.115356 
	C219.321747,567.104492 214.055679,567.038513 208.429657,565.451904 
	C207.452713,565.236328 206.923737,565.029297 206.103180,564.459167 
	C205.518143,563.652954 205.435364,563.103027 205.736145,562.156250 
	C208.903107,560.801514 211.882584,561.986694 215.254944,561.769653 
	C217.450745,562.216248 219.222351,562.758423 221.484863,562.785034 
	C222.401077,562.966858 222.879776,563.187561 223.617645,563.760376 
z"/>
<path fill="#0DA5E9" opacity="1.000000" stroke="none" 
	d="
M212.373993,568.238403 
	C208.216385,567.325378 204.423386,566.614929 200.201965,565.894165 
	C201.874908,561.895386 204.788177,564.583862 207.853302,564.988037 
	C211.993820,565.346619 215.599945,566.377014 219.641266,566.885132 
	C219.061111,568.224182 217.821243,567.922363 216.320435,568.010620 
	C214.966095,568.753845 213.828735,568.416565 212.373993,568.238403 
z"/>
<path fill="#055280" opacity="1.000000" stroke="none" 
	d="
M220.330948,567.158569 
	C216.242386,566.760010 212.524033,566.345703 208.372406,565.873047 
	C207.626678,565.494568 207.495087,565.112183 207.740540,564.413635 
	C213.230484,564.770325 218.399277,566.380981 224.213348,566.152954 
	C223.549805,567.414795 222.043549,566.950562 220.330948,567.158569 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M224.651123,573.687378 
	C222.778427,573.870483 220.608032,574.368103 218.251709,573.271301 
	C220.117950,573.125854 222.255051,573.265137 224.651123,573.687378 
z"/>
<path fill="#197AAB" opacity="1.000000" stroke="none" 
	d="
M249.704956,576.678162 
	C247.942841,576.960938 245.940674,576.958984 243.512589,576.946167 
	C245.092453,575.338562 247.289658,575.995483 249.704956,576.678162 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M212.004440,568.274597 
	C213.064468,568.021790 214.119568,568.007751 215.569183,568.007019 
	C215.173553,569.278015 213.901321,568.967834 212.374847,569.001465 
	C212.011642,568.991028 211.999512,568.513428 212.004440,568.274597 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M586.942444,302.483398 
	C587.079407,302.059814 587.253540,302.042603 587.689087,302.003296 
	C587.966003,303.988617 587.981689,305.996002 587.969727,308.424500 
	C586.067749,307.111359 587.436584,304.853027 586.942444,302.483398 
z"/>
<path fill="#011B36" opacity="1.000000" stroke="none" 
	d="
M572.716919,389.281097 
	C574.384766,388.998627 575.745605,388.993073 577.512695,389.027771 
	C578.855408,389.681915 578.731873,390.604340 578.803284,391.814697 
	C578.821350,392.567383 578.668945,393.024994 578.359436,393.669525 
	C575.451477,401.572540 574.445862,409.913666 569.529175,416.991516 
	C567.378906,412.847229 566.600220,408.706909 568.777405,404.414490 
	C569.887024,402.226776 570.740601,399.912903 570.596191,396.977173 
	C570.686279,394.108154 570.785767,391.634735 572.716919,389.281097 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M568.621338,417.620453 
	C573.221924,410.004700 574.619507,401.838806 577.851868,394.035919 
	C578.141785,394.961609 578.081177,396.066772 578.017273,397.585266 
	C575.671204,405.073730 573.328430,412.148865 570.950684,419.611145 
	C570.153931,421.210785 569.392151,422.423340 568.392334,423.839172 
	C567.971741,424.177551 567.789246,424.312683 567.278809,424.353241 
	C566.809570,424.079681 566.668213,423.900726 566.433411,423.393066 
	C566.339417,422.837189 566.338867,422.609985 566.410034,422.050842 
	C566.971802,420.472809 567.522949,419.254333 568.621338,417.620453 
z"/>
<path fill="#010610" opacity="1.000000" stroke="none" 
	d="
M578.537598,387.320526 
	C572.567139,386.349335 575.301331,383.146454 576.671448,380.147125 
	C577.928528,379.758484 578.882751,379.706421 580.189575,379.990356 
	C580.983032,380.281097 581.375732,380.553619 581.840942,381.237915 
	C581.963989,381.576965 581.792603,381.615662 581.725464,381.672119 
	C581.463013,381.920105 581.350464,382.151886 581.369385,382.613281 
	C579.877380,383.878082 580.605957,386.244171 578.537598,387.320526 
z"/>
<path fill="#0E6CB9" opacity="1.000000" stroke="none" 
	d="
M578.128418,387.689117 
	C578.984741,385.801758 579.796265,384.189270 581.012939,382.689697 
	C580.760437,385.680450 581.312622,388.861603 579.119324,391.750336 
	C577.994629,391.582214 578.118958,390.618591 577.977539,389.402466 
	C577.973938,388.700012 578.028809,388.332031 578.128418,387.689117 
z"/>
<path fill="#074D75" opacity="1.000000" stroke="none" 
	d="
M74.018631,184.311371 
	C77.405106,185.110199 75.692612,187.227478 75.132500,188.913193 
	C73.901695,192.617371 74.634857,195.476212 77.600082,198.218338 
	C81.985916,202.274200 81.425331,208.164291 82.701004,213.721954 
	C83.451180,214.509720 83.832710,215.179993 83.547676,215.787888 
	C80.271904,222.774155 79.009949,230.573624 74.522324,237.343048 
	C71.533951,237.273880 71.068520,235.295731 70.766251,233.264771 
	C70.472328,231.289917 70.268013,229.296082 69.726845,227.372955 
	C68.377052,222.576233 65.351898,221.046402 60.713257,222.835327 
	C59.311241,223.375992 57.993771,224.148102 56.155087,223.213028 
	C56.282314,221.258286 56.686821,219.560684 57.124474,217.492371 
	C60.087021,210.990784 63.016434,204.859894 65.982651,198.369049 
	C68.616081,193.537506 71.212708,189.065887 74.018631,184.311371 
z"/>
<path fill="#05476E" opacity="1.000000" stroke="none" 
	d="
M55.635696,223.193420 
	C57.448189,223.140015 58.669052,222.471985 60.007435,221.674408 
	C64.945038,218.731888 69.630882,221.182434 71.132149,226.708664 
	C72.025627,229.997543 70.906181,233.713226 73.660362,236.810623 
	C75.448669,238.945602 74.260773,240.802841 73.718033,242.623230 
	C72.681496,246.099854 71.587730,249.553787 71.194016,253.589172 
	C69.700676,257.693085 69.766701,261.960602 66.588287,265.284088 
	C62.348415,263.907623 62.859394,260.004395 61.985542,257.072235 
	C59.045834,247.208191 59.199104,247.161942 49.722275,250.406876 
	C48.761665,250.735794 47.799637,250.902740 46.520950,250.258911 
	C48.157413,243.946198 50.091667,237.867630 52.037212,231.398346 
	C53.163532,228.482071 54.278561,225.956497 55.635696,223.193420 
z"/>
<path fill="#044166" opacity="1.000000" stroke="none" 
	d="
M46.152115,250.403900 
	C49.484680,250.352509 51.459709,247.547592 54.294395,246.720657 
	C59.456650,245.214783 61.123402,246.277802 62.081310,251.360825 
	C62.924198,255.833527 64.395134,260.187836 65.897141,264.813477 
	C68.356979,268.008606 66.742790,271.061676 66.346237,274.071075 
	C66.088768,276.024994 65.600197,277.947968 65.396286,280.335205 
	C65.016090,282.906342 64.600121,285.044067 63.701439,287.457825 
	C60.955334,289.441406 60.336773,287.472534 59.785336,285.703613 
	C59.094601,283.487793 58.779236,281.164032 58.036049,278.958466 
	C55.742023,272.150391 50.702148,270.417267 44.786381,274.399384 
	C43.808907,275.057373 42.857330,275.714081 41.292679,275.226746 
	C40.987064,274.547485 40.977936,274.096161 40.942497,273.306763 
	C42.227840,267.560181 43.539490,262.151703 44.856049,256.353760 
	C45.267654,254.237213 45.674362,252.510101 46.152115,250.403900 
z"/>
<path fill="#08BDF4" opacity="1.000000" stroke="none" 
	d="
M264.415344,580.955322 
	C263.314545,577.778625 266.725891,578.259644 267.842438,576.314880 
	C268.006195,576.010986 268.466705,575.999512 268.696899,576.007080 
	C270.215332,576.006897 271.503571,575.999756 273.180115,576.078247 
	C280.092041,576.520996 286.548218,577.692322 293.486877,577.807495 
	C294.925171,577.745422 295.961700,577.798584 297.308167,578.299194 
	C298.447113,581.490479 294.638672,582.571106 294.564575,585.639160 
	C294.140503,586.115784 293.922272,586.263123 293.306702,586.456726 
	C289.899200,587.309998 286.904694,586.154297 283.527466,586.244629 
	C282.726349,586.033691 282.296570,586.009033 281.543854,585.981812 
	C279.699921,586.010620 278.264130,585.371338 276.470764,585.146973 
	C276.810822,582.946716 275.574860,582.754883 274.131165,582.552246 
	C271.014465,582.115051 267.914032,581.562256 264.415344,580.955322 
z"/>
<path fill="#2478A2" opacity="1.000000" stroke="none" 
	d="
M283.395081,586.329956 
	C286.499115,586.055054 289.842102,586.051819 293.643372,586.118408 
	C294.144531,586.403015 294.187439,586.617859 293.944580,586.994995 
	C290.238617,588.390869 286.965057,586.977539 283.395081,586.329956 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M293.993042,587.407104 
	C293.748230,587.002747 293.837646,586.848328 294.014343,586.441040 
	C294.101654,586.188171 294.132965,586.023499 294.058319,585.985352 
	C296.239807,584.340088 298.335938,584.997864 300.633209,586.749573 
	C300.886841,587.100159 300.974609,587.517822 300.977905,587.731079 
	C298.763214,587.848633 296.545227,587.752808 293.993042,587.407104 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M275.944550,584.999390 
	C277.689514,585.078125 279.179657,585.272339 280.945374,585.722900 
	C279.379333,587.131409 277.483734,585.727112 275.257507,585.996887 
	C275.156158,585.635864 275.422913,585.375366 275.944550,584.999390 
z"/>
<path fill="#1174A3" opacity="1.000000" stroke="none" 
	d="
M576.985107,244.611053 
	C570.699829,241.860489 564.818542,242.311462 559.034790,247.066925 
	C556.743225,241.070435 554.838562,235.010773 552.922363,228.572037 
	C555.273071,220.628342 561.875793,217.750641 568.689575,221.736084 
	C570.473267,225.874649 571.951416,229.726395 573.707520,233.797684 
	C574.007751,237.705978 576.805176,240.580750 576.985107,244.611053 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M568.997803,221.764771 
	C562.011536,218.951385 557.356079,222.449890 553.096802,227.891861 
	C550.285767,222.048141 547.660583,215.903320 544.938354,209.409073 
	C548.900391,204.127869 553.723267,201.318344 560.674316,203.736694 
	C561.489014,204.259491 561.965759,204.529022 562.692871,204.911743 
	C563.139465,205.178238 563.335754,205.331558 563.274292,205.755356 
	C563.591431,207.471130 564.166443,208.916412 564.876465,210.668732 
	C566.245056,214.097595 567.478577,217.219467 568.856689,220.665833 
	C569.001038,221.162460 569.000793,221.334549 568.997803,221.764771 
z"/>
<path fill="#248BBE" opacity="1.000000" stroke="none" 
	d="
M561.005127,203.620331 
	C555.005188,202.980011 550.123047,205.462128 545.205322,209.011978 
	C543.131592,205.481232 541.421936,201.902817 539.757324,197.979630 
	C540.712036,191.125214 546.532166,188.242020 554.619019,190.748291 
	C555.900391,192.477737 556.826416,193.929810 557.885925,195.676285 
	C558.914612,198.437347 560.836731,200.483810 561.005127,203.620331 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M570.619629,204.003769 
	C569.878357,205.478683 568.246216,204.874023 566.379211,204.995148 
	C567.119995,203.516006 568.755188,204.133972 570.619629,204.003769 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M570.993042,203.988373 
	C571.625244,203.072189 572.529602,202.882812 573.535706,203.109329 
	C573.734741,203.154129 573.869812,203.483337 574.034363,203.681381 
	C573.256409,203.794708 572.478455,203.908051 571.365173,204.026062 
	C571.029846,204.030716 571.003906,204.003479 570.993042,203.988373 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M563.352661,206.020782 
	C563.004272,205.858932 562.992065,205.692032 562.961548,205.275009 
	C563.700134,205.008804 564.457214,204.992722 565.591003,204.971802 
	C565.967773,204.966980 565.994812,204.995209 566.006470,205.011108 
	C565.472595,205.900497 564.603760,206.012375 563.352661,206.020782 
z"/>
<path fill="#0E6CB9" opacity="1.000000" stroke="none" 
	d="
M581.983704,381.130768 
	C581.433105,381.613312 580.902222,381.649689 580.094360,381.377014 
	C579.376282,379.994354 579.849976,379.158600 580.846497,378.199982 
	C581.175110,378.026672 581.606689,378.017242 581.822876,378.012756 
	C582.027222,378.900360 582.015320,379.792480 581.983704,381.130768 
z"/>
<path fill="#42A7D0" opacity="1.000000" stroke="none" 
	d="
M302.434113,62.601540 
	C303.560974,56.223995 303.113190,50.124001 301.970093,43.611229 
	C306.004578,43.112015 310.057068,43.027695 314.572205,42.876026 
	C317.736847,42.864758 320.438873,42.920837 323.589233,42.908588 
	C325.417877,42.908222 326.798218,42.976185 328.591919,43.000034 
	C329.862366,43.106953 330.719452,43.257984 331.847717,43.589264 
	C334.311615,49.921707 334.518494,56.032112 331.383087,62.398651 
	C324.996948,62.572563 318.961273,62.427376 312.482544,62.373543 
	C309.028320,63.979530 305.941467,63.783127 302.434113,62.601540 
z"/>
<path fill="#39AEDD" opacity="1.000000" stroke="none" 
	d="
M530.864380,181.796219 
	C527.707397,177.754883 524.839478,173.493729 521.902954,168.915741 
	C522.645447,163.386002 527.652405,159.386292 534.831360,158.688232 
	C535.556458,158.969925 535.925720,159.064224 536.572083,159.230194 
	C538.867188,160.869522 539.825806,163.152008 540.948120,165.676804 
	C542.103210,169.612320 544.765686,172.273743 546.868408,175.673462 
	C547.794434,176.325607 548.200684,176.921021 548.006714,178.068695 
	C547.195496,178.686447 546.519592,179.031982 545.919250,178.809906 
	C540.429565,176.779312 535.754028,178.949387 530.864380,181.796219 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M535.103638,158.540100 
	C529.822327,160.428680 525.264587,163.158020 521.952698,168.237213 
	C518.825562,164.688019 515.816650,160.777130 512.673950,156.544556 
	C515.317688,150.391907 519.550781,146.643356 526.675903,146.785004 
	C527.475708,147.307632 527.951538,147.614075 528.668091,148.073883 
	C529.818054,152.243820 533.495483,154.564835 535.103638,158.540100 
z"/>
<path fill="#70E1F9" opacity="1.000000" stroke="none" 
	d="
M541.380371,165.958282 
	C538.958191,164.439560 537.650818,162.391418 536.879639,159.632355 
	C537.180664,158.548721 537.612366,157.823120 537.827698,157.038147 
	C539.625000,150.486588 540.594238,149.944595 547.541748,151.998444 
	C548.038330,153.175613 547.843994,154.427124 549.598022,154.994507 
	C550.115540,155.609116 550.299072,156.153961 550.723755,156.864532 
	C551.060486,157.351212 551.240540,157.614410 551.719177,157.932755 
	C552.042969,159.158981 551.836426,160.418549 553.599304,160.991974 
	C554.120239,161.602875 554.305725,162.144180 554.727783,162.854279 
	C554.964417,163.023087 554.982544,163.517014 554.984131,163.764282 
	C550.586670,164.642166 546.187561,165.272766 541.380371,165.958282 
z"/>
<path fill="#61D6F8" opacity="1.000000" stroke="none" 
	d="
M504.212158,146.236725 
	C499.974640,142.001373 496.049561,137.964767 491.997437,133.629013 
	C494.426849,127.540909 499.661438,124.552551 504.873932,121.047302 
	C506.878265,122.338829 508.559967,123.786774 510.527100,125.435913 
	C512.378723,127.623123 513.945007,129.609131 515.776733,131.786804 
	C516.358521,132.761063 516.674744,133.543671 517.030151,134.642807 
	C513.289856,137.797699 509.510223,140.606033 507.459991,145.120651 
	C506.983765,146.169296 505.826843,146.714966 504.212158,146.236725 
z"/>
<path fill="#51CAF4" opacity="1.000000" stroke="none" 
	d="
M504.008118,146.358414 
	C505.911285,146.016174 506.879913,144.660095 507.453339,143.032333 
	C508.970551,138.725525 512.088440,136.274139 516.705933,135.006348 
	C519.355896,135.248306 519.630371,137.788544 521.585083,138.935547 
	C522.834106,141.976028 525.270081,143.853699 526.868347,146.691895 
	C520.965332,147.741898 516.876160,151.489929 512.881836,156.067810 
	C509.732269,153.041534 506.924408,149.860199 504.008118,146.358414 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M206.010315,562.049255 
	C206.065994,562.598755 206.054810,562.939636 206.054932,563.536133 
	C201.981781,565.465576 198.281937,563.540894 194.092697,562.524292 
	C192.423264,562.503784 191.233658,562.007812 189.665253,561.678833 
	C189.164093,561.384277 188.984985,561.238892 188.702850,560.770813 
	C188.671936,560.096436 188.854919,559.836182 189.168060,559.718567 
	C189.304092,559.667480 189.533951,559.751587 189.608170,559.670593 
	C189.906876,559.344849 189.816498,559.275940 189.129944,559.530396 
	C188.674362,559.568726 188.486435,559.596191 188.007187,559.573303 
	C186.925934,559.290710 186.154114,559.010681 185.154846,558.460754 
	C184.796707,558.083740 184.696991,557.895020 184.660309,557.392456 
	C185.360291,555.952209 188.817184,554.577759 184.350281,553.945374 
	C181.127945,553.489197 177.948380,552.730896 174.345367,552.082764 
	C173.533722,552.372131 173.074005,552.477173 172.322220,552.127808 
	C172.024460,549.179443 175.298431,550.744324 175.963074,548.546936 
	C177.080673,547.056824 178.351898,547.581055 179.796890,548.134033 
	C180.173264,548.776855 180.380676,548.918945 180.840378,548.977539 
	C181.618637,548.439636 182.366257,548.536926 183.424133,548.401611 
	C185.412323,548.525818 187.047455,548.843079 189.045197,548.276001 
	C190.970474,548.158386 192.397324,548.568176 193.940125,549.731323 
	C193.756760,552.427856 191.993134,551.206360 190.715012,551.445862 
	C194.710785,551.144775 198.620026,552.143494 202.994873,552.212891 
	C203.925644,552.250916 204.426666,552.411926 205.129532,553.007080 
	C203.607468,558.625793 199.876892,554.786926 197.454330,555.471863 
	C199.722153,556.007874 202.532410,556.078430 205.279724,556.523376 
	C207.230545,556.839355 209.352371,556.949158 209.678009,559.947205 
	C209.054947,561.994568 207.633713,561.423401 206.453613,561.489136 
	C205.788132,561.526245 206.641983,561.355164 205.989334,561.469604 
	C205.517914,561.552368 205.516846,561.757080 206.010315,562.049255 
z"/>
<path fill="#0F62A1" opacity="1.000000" stroke="none" 
	d="
M188.965424,559.866028 
	C189.036682,560.133789 189.041336,560.488403 189.048126,560.665527 
	C188.838577,561.046936 188.622253,561.251160 188.021393,561.229004 
	C187.636856,561.002625 187.456863,561.086975 187.358704,561.071411 
	C185.074753,560.790100 182.809341,561.421082 180.367340,560.201416 
	C178.968887,559.609558 177.887360,559.288147 176.478882,558.880859 
	C176.714462,558.020386 177.552841,558.027283 178.697540,557.996460 
	C180.783249,556.786987 182.549484,557.382751 184.659668,558.191467 
	C185.783096,558.538025 186.577850,558.501160 187.698181,558.787720 
	C188.033035,558.997192 187.994217,559.008972 187.992035,558.988831 
	C188.269104,559.210388 188.569550,559.421692 188.965424,559.866028 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M180.387054,557.128418 
	C179.158539,556.426636 178.167557,555.999329 176.485229,555.273804 
	C178.800308,555.046448 180.464355,554.334290 181.842575,556.555481 
	C181.553070,557.313171 181.131683,557.466614 180.387054,557.128418 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M179.910492,556.991211 
	C180.533401,556.867615 180.917252,556.881226 181.588333,556.901978 
	C182.591583,556.955933 183.307632,557.002747 184.373505,557.064087 
	C184.723343,557.078613 184.909775,557.512634 184.959015,557.743591 
	C185.180908,558.118835 185.353546,558.263062 185.280640,558.638672 
	C183.363724,558.115112 181.594559,557.955994 179.401855,557.997314 
	C179.232605,557.699646 179.452042,557.414062 179.910492,556.991211 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M163.233719,551.183960 
	C164.831558,551.051453 166.670868,551.232422 168.771271,551.702759 
	C167.177490,551.855103 165.260895,552.411377 163.233719,551.183960 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M171.691589,551.901611 
	C172.490372,551.895935 172.905518,551.939209 173.630829,552.020386 
	C172.567734,553.460022 171.022842,553.132690 169.219345,552.236328 
	C169.763062,551.962402 170.535522,551.956482 171.691589,551.901611 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M154.188232,549.231995 
	C155.026611,548.989441 156.083649,549.001892 157.534607,549.020264 
	C156.920212,550.444885 155.682129,550.107971 154.188232,549.231995 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M151.170471,548.275879 
	C151.882339,548.131470 152.776764,548.279236 153.853592,548.720581 
	C153.141663,548.865417 152.247330,548.716675 151.170471,548.275879 
z"/>
<path fill="#54BDE4" opacity="1.000000" stroke="none" 
	d="
M331.462677,62.796677 
	C332.542236,56.792377 331.797302,50.741764 332.074951,44.257507 
	C333.165985,43.778679 334.213043,43.787849 335.646667,43.718685 
	C337.088257,43.787025 338.143311,43.933701 339.590027,44.163773 
	C339.847229,50.287193 340.831390,56.444698 338.049225,62.599495 
	C335.966461,62.950203 333.929626,62.912903 331.462677,62.796677 
z"/>
<path fill="#033B5F" opacity="1.000000" stroke="none" 
	d="
M40.837181,275.352600 
	C41.876621,274.612396 42.899582,274.399780 43.615376,273.812683 
	C50.588913,268.092834 56.762383,270.152496 59.554485,279.030853 
	C60.470024,281.942108 60.205837,285.186859 62.426739,287.915527 
	C63.264591,288.329407 63.588268,288.761963 63.815132,289.724243 
	C63.358089,294.693359 63.348419,299.287659 62.986149,304.271118 
	C62.431629,309.115265 62.403038,313.566864 62.482952,318.447144 
	C63.254498,323.428314 64.046753,327.984497 62.433601,333.290802 
	C58.823433,333.673401 58.956196,331.385437 59.006718,329.198486 
	C59.152393,322.892395 58.178688,316.789459 56.111755,310.813171 
	C53.404167,302.984497 50.146492,300.412659 41.840305,300.012543 
	C40.522911,299.949066 39.199986,300.000519 37.433792,299.996948 
	C36.589985,296.533875 37.567997,293.208710 37.980751,289.406921 
	C38.871449,284.558746 39.774807,280.132568 40.837181,275.352600 
z"/>
<path fill="#020711" opacity="1.000000" stroke="none" 
	d="
M153.594894,541.925293 
	C158.247711,541.097839 161.502319,544.016296 165.669144,544.905396 
	C167.468246,545.240479 168.892639,545.563416 170.683411,545.868164 
	C171.049789,545.849976 171.523895,546.006226 171.757874,546.093140 
	C172.089920,546.325134 172.188004,546.470154 172.147064,546.837952 
	C168.907822,547.219971 165.847305,546.960327 162.432434,546.196533 
	C154.233704,544.722778 146.374100,543.535217 138.399673,541.060913 
	C143.222763,538.911926 148.128845,541.604004 153.594894,541.925293 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M185.988678,543.518188 
	C188.247406,543.607849 190.445816,543.978088 192.820496,544.679932 
	C192.605621,548.709839 189.254517,547.484985 186.875031,548.578613 
	C186.024673,548.785767 185.529846,548.825928 184.669830,548.701416 
	C184.070557,548.552124 183.830963,548.492920 183.298615,548.207153 
	C184.222397,546.756042 184.051208,544.561707 185.988678,543.518188 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M179.919769,548.165771 
	C178.967010,548.424622 177.908463,548.301636 176.450256,548.200562 
	C175.774231,547.785767 173.920547,547.735901 175.278076,547.061401 
	C176.532776,546.437927 178.433014,546.673157 179.919769,548.165771 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M170.993622,544.154602 
	C172.390808,543.927734 173.778976,543.989990 175.583405,544.026855 
	C174.872406,545.514343 173.223450,544.835815 171.389435,545.014404 
	C170.996307,544.829346 170.990448,544.636597 170.993622,544.154602 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M182.704193,548.026001 
	C183.005875,547.980591 183.385742,548.107605 183.585495,548.121826 
	C183.980560,548.233704 184.175873,548.331238 184.176514,548.692139 
	C183.244354,548.952454 182.506836,548.949402 181.401154,548.963806 
	C181.216110,548.266418 181.775772,548.118408 182.704193,548.026001 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M172.256500,547.023315 
	C172.008026,547.060730 171.998199,546.620178 171.995026,546.400146 
	C172.394257,546.301331 173.168015,546.186096 172.256500,547.023315 
z"/>
<path fill="#51CAF4" opacity="1.000000" stroke="none" 
	d="
M547.827515,178.408310 
	C547.698792,177.521317 547.455505,177.013611 547.121765,176.237579 
	C550.217163,173.793549 552.527832,170.440796 556.660400,169.028320 
	C557.327209,169.102798 557.583374,169.298126 557.886108,169.793823 
	C558.903992,171.808792 559.813965,173.603958 560.848267,175.711121 
	C557.823059,178.477875 554.912598,181.349380 550.303467,181.854004 
	C548.548462,181.252151 547.859314,180.220169 547.827515,178.408310 
z"/>
<path fill="#30A0CE" opacity="1.000000" stroke="none" 
	d="
M547.553772,178.011932 
	C548.447021,178.915100 548.952026,179.801163 549.707886,180.860535 
	C552.897339,183.045441 554.466003,185.946045 555.192261,189.643768 
	C555.046570,190.155731 555.035461,190.329865 554.999390,190.764832 
	C549.047729,190.548325 543.424866,190.840927 539.940002,197.268539 
	C536.783386,192.625305 533.764465,187.615753 530.660400,182.311127 
	C534.908569,175.738037 540.796021,175.871857 547.553772,178.011932 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M555.413086,189.947449 
	C553.455750,187.205338 551.853943,184.429077 550.105408,181.343338 
	C554.178650,181.018707 556.293945,176.620834 560.618347,176.054199 
	C562.441772,178.254425 563.910828,180.485733 565.681152,182.864441 
	C565.993164,183.751541 566.003906,184.491241 566.021484,185.599945 
	C562.052673,185.838257 559.214111,188.665207 555.413086,189.947449 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M146.385681,506.542511 
	C146.625717,509.384430 150.411179,509.697845 150.109283,512.784424 
	C149.923141,513.817505 149.545654,514.320679 148.426910,514.379395 
	C145.988113,514.034668 143.880173,513.645691 141.379471,513.231689 
	C137.765121,511.844727 135.293396,509.612061 132.605835,506.242249 
	C137.582245,505.748627 141.769287,505.519318 146.385681,506.542511 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M89.670731,458.099060 
	C90.098625,458.144409 90.109642,458.449249 90.125305,458.598083 
	C88.575935,459.077118 87.015488,459.268066 85.227997,458.306946 
	C86.395889,458.031586 87.819359,458.042664 89.670731,458.099060 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M192.746674,562.276611 
	C197.080063,562.661682 201.155762,563.265747 205.648849,563.830750 
	C206.482300,563.870667 206.898392,563.949585 207.625549,564.094116 
	C207.944489,564.527588 207.952347,564.895386 207.949646,565.539001 
	C205.323624,565.793335 202.853806,564.076782 199.959106,565.514404 
	C199.773514,565.883789 199.479050,565.653381 199.080750,565.770142 
	C198.198074,562.919128 195.227203,564.305298 193.379333,563.001404 
	C192.833771,562.786011 192.661377,562.640747 192.746674,562.276611 
z"/>
<path fill="#032B57" opacity="1.000000" stroke="none" 
	d="
M180.039917,560.209717 
	C182.223679,560.150757 184.396942,560.370544 186.915375,560.823120 
	C187.239136,561.257141 187.217728,561.458435 187.167847,561.965210 
	C184.950089,562.046021 182.760788,561.821411 180.289948,561.321533 
	C180.015396,560.860413 180.022385,560.674500 180.039917,560.209717 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M192.682648,561.914673 
	C193.004349,562.057678 193.001007,562.494751 193.003586,562.713013 
	C191.227081,562.987610 189.396164,563.251038 187.830322,561.343018 
	C187.874817,560.991760 188.112793,560.980896 188.702850,560.906372 
	C190.228912,560.896179 191.408112,560.931091 192.682648,561.914673 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M186.491913,564.894775 
	C186.200897,564.527527 186.395782,564.295227 186.882156,564.027344 
	C188.254593,564.090942 189.417542,564.258972 190.793304,564.708496 
	C189.636002,564.980225 188.265900,564.970581 186.491913,564.894775 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M190.994232,565.005859 
	C192.354218,565.095459 193.791931,564.586914 195.180496,565.514648 
	C193.855774,566.363220 192.643356,566.036865 191.217606,565.270325 
	C191.006119,564.989929 190.999359,565.000732 190.994232,565.005859 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M198.381409,565.966187 
	C198.682434,565.886963 199.003143,565.826599 199.073303,565.822449 
	C199.773926,566.560303 199.219467,566.843445 198.626114,566.887146 
	C198.234741,566.916016 197.290787,566.946045 198.381409,565.966187 
z"/>
<path fill="#19BAF7" opacity="1.000000" stroke="none" 
	d="
M185.957214,548.412964 
	C187.871094,546.302979 190.815918,547.561157 192.793716,545.305481 
	C196.725845,545.025391 200.454910,545.039246 204.655029,545.051025 
	C207.160934,545.722717 209.195801,546.396423 211.600693,547.096680 
	C213.977844,546.838684 215.760590,547.775879 217.992188,548.304260 
	C219.289825,549.191833 220.744476,549.720947 219.295639,551.579712 
	C216.216782,552.102234 213.980820,553.661621 211.228348,554.962769 
	C208.962784,554.987061 207.171478,554.615540 205.234741,553.349609 
	C204.479141,553.108521 204.051697,553.094055 203.303497,553.077271 
	C200.581223,550.763489 196.761337,553.132996 194.231598,550.250977 
	C192.572876,549.692261 191.142197,549.374939 189.343201,549.044800 
	C187.910233,549.649353 186.881180,549.725647 185.957214,548.412964 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M140.301636,74.453705 
	C140.634369,74.226646 140.950363,74.181717 141.508972,74.225235 
	C141.417877,74.454361 141.092026,74.650337 140.569901,74.833221 
	C140.373611,74.820122 140.277054,74.580513 140.301636,74.453705 
z"/>
<path fill="#03D7FC" opacity="1.000000" stroke="none" 
	d="
M526.091125,504.025330 
	C526.303406,503.432037 526.878479,502.834656 527.742188,502.125458 
	C528.017029,503.084930 527.581238,503.824707 526.091125,504.025330 
z"/>
<path fill="#13C2F7" opacity="1.000000" stroke="none" 
	d="
M490.299255,486.852112 
	C470.267029,510.591278 445.674896,528.055664 417.383575,541.043823 
	C414.971191,540.139099 413.511230,538.640198 412.665466,536.156189 
	C413.085480,533.860168 414.849579,533.381470 416.609619,532.379089 
	C421.212952,530.872681 425.377136,529.267639 429.429443,526.560913 
	C436.307068,523.954468 441.823975,519.740234 447.798462,515.649414 
	C449.442719,514.435059 450.851013,513.458313 452.266479,511.994568 
	C453.417450,510.963287 454.502136,510.356293 455.640808,509.319824 
	C456.031769,508.994202 456.192719,508.869507 456.607086,508.575897 
	C457.207306,508.197815 457.552216,507.985596 458.139709,507.583069 
	C458.544586,507.261292 458.704987,507.126648 459.108582,506.784729 
	C460.118042,505.678711 461.770416,505.547028 461.668915,503.559235 
	C463.056793,499.609253 466.793884,498.587006 469.466827,496.500031 
	C474.450531,492.608856 478.194366,487.309113 484.162476,484.086945 
	C486.801575,483.929382 488.727325,484.610016 490.299255,486.852112 
z"/>
<path fill="#0ABEFA" opacity="1.000000" stroke="none" 
	d="
M490.748230,487.031372 
	C488.516235,486.471741 486.836334,484.976959 484.195496,484.957092 
	C483.701477,484.438385 483.629883,483.871429 483.918793,483.486847 
	C488.761627,477.039581 493.253754,470.287781 500.007446,465.049713 
	C502.762939,464.683563 505.174377,464.327911 507.099152,466.916809 
	C507.283173,467.848267 507.117279,468.335052 506.396667,468.950317 
	C501.038269,475.050934 496.026123,480.952087 490.748230,487.031372 
z"/>
<path fill="#18DBFB" opacity="1.000000" stroke="none" 
	d="
M412.661743,535.611938 
	C414.225342,537.386108 415.575104,538.893188 416.973389,540.740173 
	C412.564178,542.979126 408.106415,544.878113 403.332458,546.959106 
	C402.131165,547.004700 401.261292,546.925537 400.310120,547.783325 
	C398.519043,546.938416 398.098053,545.543762 398.031189,543.612061 
	C398.116791,543.011292 398.177734,542.776794 398.403320,542.221680 
	C400.005768,539.831665 404.208801,540.268127 403.702637,536.008240 
	C404.833069,534.129395 406.493042,533.885010 408.468384,533.541504 
	C410.283508,533.614807 411.334534,534.541504 412.661743,535.611938 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M506.081818,469.440857 
	C506.235443,468.781281 506.420441,468.412811 506.981445,467.717224 
	C507.621399,467.719971 507.885315,468.049835 508.472931,468.930206 
	C508.341278,470.187836 507.885925,470.894958 507.198303,471.744446 
	C506.681763,471.168549 506.397491,470.450256 506.081818,469.440857 
z"/>
<path fill="#08BDF4" opacity="1.000000" stroke="none" 
	d="
M526.221313,455.797852 
	C525.378967,457.490509 523.648560,458.250885 523.869629,460.446350 
	C523.109131,461.829529 522.383423,462.877319 521.505249,464.207123 
	C520.814331,465.368561 520.275818,466.247986 519.688599,467.414215 
	C519.419250,467.950226 519.198547,468.199402 519.007263,468.712097 
	C518.544067,469.255035 518.051392,469.534393 517.298523,469.928345 
	C515.990234,468.243195 514.448792,466.715363 513.984802,464.219879 
	C516.392456,460.294128 518.838989,456.720825 521.590332,452.986206 
	C523.863525,452.868286 525.452087,453.561737 526.221313,455.797852 
z"/>
<path fill="#03D1FB" opacity="1.000000" stroke="none" 
	d="
M451.000427,534.000488 
	C450.653900,534.246338 450.306915,534.491760 449.959961,534.737183 
	C449.874664,534.614319 449.789337,534.491516 449.704041,534.368652 
	C449.976898,534.252319 450.249725,534.135986 450.760681,534.009155 
	C450.998779,533.998718 451.000000,534.000000 451.000427,534.000488 
z"/>
<path fill="#31E7FE" opacity="1.000000" stroke="none" 
	d="
M398.668854,542.723511 
	C399.289459,544.324646 399.591675,545.706055 399.938110,547.440369 
	C399.507294,548.140259 399.032196,548.487366 398.286499,548.966919 
	C397.681488,549.138855 397.347137,549.178223 396.846436,549.414246 
	C395.187836,550.078552 393.695648,550.546143 391.909973,551.183228 
	C390.653687,551.584961 389.690857,551.817200 388.356445,552.060669 
	C386.515808,550.952881 385.324554,549.673157 385.545532,547.281860 
	C386.652069,545.651489 388.121704,545.117981 389.818207,544.236877 
	C392.861298,543.374878 395.350525,541.608582 398.668854,542.723511 
z"/>
<path fill="#45DAF8" opacity="1.000000" stroke="none" 
	d="
M385.702515,546.927124 
	C386.662689,548.556152 387.299530,549.972656 387.960571,551.730469 
	C387.094452,552.442627 386.204132,552.813293 385.089600,553.376343 
	C364.946045,559.269226 344.662842,562.675476 323.470551,563.150696 
	C321.735779,561.873840 320.853302,560.520630 321.378815,558.264343 
	C322.325653,556.613586 323.573822,556.067078 325.352966,555.665405 
	C331.169891,554.363037 336.662415,554.002686 342.584229,554.101868 
	C343.994476,553.797485 345.037567,553.719727 346.467957,553.646973 
	C348.863983,553.594604 350.884796,553.738770 353.236694,553.218506 
	C354.323914,552.979980 355.057251,552.884399 356.149170,552.729553 
	C357.225433,552.601074 357.938751,552.507446 358.972961,552.181885 
	C360.949402,551.715332 362.642822,551.744263 364.608093,551.203857 
	C366.125916,550.820679 367.318207,550.625366 368.825653,550.169189 
	C371.579071,549.486328 373.994812,548.966248 376.728943,548.159973 
	C379.852051,547.593140 382.483185,546.332458 385.702515,546.927124 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M170.247711,507.900330 
	C165.159683,505.025940 161.480042,500.644958 156.848358,496.911011 
	C145.699783,485.679932 135.041199,474.399963 126.241623,461.130585 
	C125.730614,460.726929 125.522285,460.485138 125.211113,460.025879 
	C125.076805,459.642273 125.048607,459.473328 124.827240,459.134888 
	C124.577850,458.791565 124.521622,458.617645 124.244614,458.281128 
	C124.023827,458.118591 124.047333,457.979126 123.979233,457.960052 
	C123.696259,457.712646 123.494942,457.472931 123.210556,457.007690 
	C123.087128,456.628357 123.060318,456.463135 122.843781,456.133423 
	C122.596153,455.800323 122.538246,455.631683 122.259193,455.312683 
	C122.038040,455.162292 122.066734,454.977081 121.976204,454.952881 
	C121.740387,454.757568 121.595108,454.586426 121.296257,454.115540 
	C121.114159,453.646576 121.085625,453.477264 120.866318,453.134949 
	C120.606201,452.789886 120.536850,452.617828 120.258514,452.261993 
	C120.049515,452.078247 120.060974,451.961487 120.004562,451.945374 
	C119.791222,451.772491 119.634285,451.615753 119.340332,451.155823 
	C119.203308,450.852661 119.169373,450.817413 119.166420,450.793152 
	C114.287537,445.114594 110.089584,439.080109 108.575714,431.279388 
	C111.554466,428.951752 113.273239,431.597626 115.744324,432.665344 
	C116.303635,432.900665 116.520065,433.008606 117.036171,433.316711 
	C119.687943,437.488953 122.487221,441.154968 125.336365,445.199127 
	C126.641052,447.398712 127.873291,449.239624 129.346375,451.313354 
	C130.414978,453.043091 131.303558,454.500519 132.498398,456.135132 
	C133.602844,457.533264 134.453430,458.725891 135.486755,460.171600 
	C136.596695,461.552368 137.437592,462.743835 138.480865,464.177795 
	C138.960220,464.744629 139.242310,465.064697 139.756042,465.617798 
	C141.986206,468.243835 143.722778,470.863983 146.354599,473.151978 
	C148.450302,475.326721 149.735138,477.738464 151.956299,479.798340 
	C152.492401,480.335144 152.788757,480.647003 153.299988,481.188629 
	C153.946960,481.857727 154.350586,482.323730 154.995590,482.973389 
	C155.491898,483.458862 155.775146,483.734161 156.287384,484.193176 
	C156.985092,484.734131 157.461594,485.081299 158.177948,485.618042 
	C158.554794,485.969360 158.695908,486.125488 159.037537,486.534058 
	C159.891113,487.707214 160.717819,488.447754 161.888885,489.305145 
	C162.592285,489.972198 162.950394,490.500946 163.518204,491.254181 
	C164.469986,492.449219 165.321991,493.318695 166.444229,494.353271 
	C167.531326,495.428558 168.422226,496.262665 169.675354,497.145905 
	C170.065384,497.472565 170.212143,497.613190 170.546539,497.991425 
	C171.183121,498.880371 171.600800,499.556458 172.444275,500.267883 
	C173.193237,500.803497 173.702988,501.155579 174.437500,501.746155 
	C175.085922,502.502533 175.326630,503.093994 175.107605,504.059998 
	C173.310013,505.268280 171.500473,505.958801 170.247711,507.900330 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M76.377350,370.229980 
	C75.750046,367.858551 75.351830,365.775055 75.037186,363.030151 
	C77.513321,360.286285 77.921356,355.191986 83.341927,357.343811 
	C86.508278,360.768646 85.887894,365.095001 87.273041,369.222656 
	C88.025337,373.885345 89.879944,377.960785 89.126404,382.710449 
	C86.474922,384.960571 83.627678,381.780243 81.037102,384.017853 
	C80.283295,383.083740 79.746422,381.845856 79.040657,380.309326 
	C78.116661,376.846375 77.361557,373.682159 76.377350,370.229980 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M108.701141,430.822815 
	C111.156471,437.996948 115.505074,443.829651 119.128769,450.426392 
	C114.700806,449.518860 113.094528,445.419128 111.155159,442.032410 
	C104.989296,431.264984 98.606804,420.567719 95.525162,408.323700 
	C94.979126,406.154205 93.179840,404.327301 92.184837,402.234955 
	C91.396523,400.577271 89.705688,398.694916 92.756546,397.038025 
	C93.630905,396.912201 94.087402,397.039703 94.706635,397.677155 
	C97.522888,403.945068 99.492195,410.178619 102.608871,416.325439 
	C104.533546,421.365662 108.000076,425.340515 108.701141,430.822815 
z"/>
<path fill="#62E4F9" opacity="1.000000" stroke="none" 
	d="
M94.412827,398.260315 
	C93.862938,397.768890 93.676613,397.508820 93.322662,397.096436 
	C91.800285,392.545166 90.483032,388.119415 89.006432,383.352295 
	C87.940727,378.937836 87.034363,374.864685 86.152481,370.398682 
	C87.257866,368.951050 88.551582,368.786591 90.328461,369.248474 
	C91.135109,369.678589 91.476326,370.049316 91.840820,370.852448 
	C92.370163,372.449219 92.097244,373.885651 93.148224,375.289703 
	C93.524704,375.924377 93.691093,376.306183 93.885071,376.998474 
	C94.015717,377.674774 94.066193,378.060272 94.162277,378.718201 
	C94.371414,379.525909 94.635292,380.002045 95.189087,380.645874 
	C95.478157,381.041840 95.578407,381.214935 95.789345,381.672913 
	C96.186470,382.972168 96.386253,384.012085 96.917404,385.308838 
	C98.151810,389.320801 99.709984,392.875519 100.471977,397.063843 
	C100.358719,397.697845 100.256760,397.942596 99.833298,398.431824 
	C97.896614,399.355835 96.301834,399.418427 94.412827,398.260315 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M122.070145,455.341248 
	C122.355774,455.131683 122.574455,455.264374 122.674072,455.764679 
	C122.401733,455.903351 122.217796,455.753754 122.070145,455.341248 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M125.145241,460.064484 
	C125.374313,460.017609 125.643623,460.223999 125.927567,460.698120 
	C125.689964,460.749817 125.437721,460.533752 125.145241,460.064484 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M124.051865,458.303986 
	C124.350441,458.100403 124.575211,458.242859 124.666100,458.755737 
	C124.372757,458.895844 124.188034,458.737152 124.051865,458.303986 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M123.146126,457.043823 
	C123.375992,457.001160 123.638039,457.208710 123.905617,457.678650 
	C123.666862,457.725342 123.422585,457.509705 123.146126,457.043823 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M120.072624,452.273315 
	C120.389847,452.058014 120.617500,452.208374 120.704010,452.745636 
	C120.398224,452.896149 120.204956,452.731628 120.072624,452.273315 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M119.215919,451.094360 
	C119.451721,451.042908 119.700134,451.233154 119.948357,451.676331 
	C119.600075,451.862762 119.360199,451.665009 119.215919,451.094360 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M121.161331,454.059387 
	C121.390152,454.018005 121.637604,454.220154 121.885361,454.675507 
	C121.540703,454.843811 121.305466,454.635223 121.161331,454.059387 
z"/>
<path fill="#DEF9F9" opacity="1.000000" stroke="none" 
	d="
M170.136902,508.372192 
	C169.777237,505.033844 171.251038,503.742950 174.618378,504.012329 
	C175.194260,503.875122 175.374741,503.741180 175.890060,503.646790 
	C177.993225,504.625702 179.422394,506.054047 181.395935,507.281158 
	C184.560165,509.523895 187.077484,512.058350 190.340195,514.176758 
	C194.295563,516.510620 197.199554,519.726746 201.203583,522.001282 
	C203.885773,523.946899 206.459061,525.425232 209.336884,527.077515 
	C213.599152,530.745483 219.229080,531.466675 223.144623,535.636047 
	C223.434128,537.105103 222.808319,537.832581 221.613708,538.582520 
	C220.789368,538.828491 220.302765,538.862305 219.460541,538.735352 
	C217.323776,537.663269 215.637024,536.238159 213.042221,537.240295 
	C206.296814,534.912598 201.022415,530.688049 195.326218,527.210938 
	C190.468781,524.245911 185.681564,521.165833 180.537201,518.025757 
	C177.908951,513.754272 173.468536,511.887390 170.136902,508.372192 
z"/>
<path fill="#44454A" opacity="1.000000" stroke="none" 
	d="
M215.782959,542.107788 
	C216.063736,541.393066 216.106857,540.855469 216.223648,539.920227 
	C216.944458,539.166138 217.639771,539.100647 218.705780,539.256409 
	C220.950546,540.216736 223.048141,540.819946 224.144470,543.248291 
	C223.956360,544.283264 223.459442,544.740173 222.553070,545.240356 
	C221.377136,545.603333 220.533752,545.403503 219.391479,545.129089 
	C218.900162,544.984863 218.707474,544.919189 218.236832,544.733887 
	C217.601547,544.435120 217.250107,544.244995 216.648117,543.894165 
	C216.237793,543.618958 216.083160,543.494934 215.765228,543.122986 
	C215.583054,542.678284 215.564194,542.481628 215.782959,542.107788 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M219.179657,540.061157 
	C218.282913,540.192017 217.628662,539.945129 216.635864,539.610352 
	C215.217163,538.901611 214.137009,538.280640 212.883942,537.396606 
	C214.815308,534.708679 216.827591,534.443542 218.856445,537.696777 
	C219.396378,538.503174 219.533783,539.062683 219.179657,540.061157 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M215.738007,541.901123 
	C216.020615,541.930603 216.148590,542.278809 216.157516,542.464111 
	C215.598984,543.550659 214.885773,543.475952 213.991119,542.561157 
	C213.876007,542.165283 214.120850,541.857605 214.244141,541.703491 
	C214.730087,541.656799 215.092758,541.764282 215.738007,541.901123 
z"/>
<path fill="#8CF2FB" opacity="1.000000" stroke="none" 
	d="
M213.546417,542.111694 
	C214.438690,542.396545 215.001373,542.627808 215.865265,542.754150 
	C216.166443,542.649353 216.156754,542.703186 216.147461,542.728943 
	C216.353546,543.483276 217.001511,543.488647 217.880829,543.643677 
	C218.184692,543.672119 218.183502,543.907593 218.205704,543.791992 
	C219.573837,545.138672 221.440170,545.393433 223.590820,545.941406 
	C225.160873,546.577271 226.460373,546.962891 227.085358,548.604370 
	C224.328003,551.390808 221.489288,550.064758 218.274933,549.293213 
	C215.886139,549.227051 214.046417,548.797607 212.178955,547.405884 
	C211.972214,545.730713 211.973709,544.338135 211.930527,542.533813 
	C212.329514,542.100647 212.773163,542.079346 213.546417,542.111694 
z"/>
<path fill="#09D3F7" opacity="1.000000" stroke="none" 
	d="
M371.223511,76.655853 
	C392.315338,81.316582 411.746552,89.230072 430.430542,99.138100 
	C433.555756,100.795418 436.012146,103.610474 439.859955,104.662720 
	C439.015656,109.385712 435.127472,108.565720 431.645569,109.256393 
	C424.525238,107.995117 419.265625,103.562531 413.203461,100.855911 
	C399.310272,94.652908 385.129700,89.439674 370.385986,85.725616 
	C368.614990,85.279488 366.789093,84.948395 365.047699,83.440262 
	C364.582184,78.914871 367.830963,77.897568 371.223511,76.655853 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M430.669067,108.520950 
	C433.735992,107.695061 437.037903,107.904160 439.783875,105.166077 
	C453.512146,112.056145 465.162628,121.607117 476.759949,131.735535 
	C476.669312,134.450974 476.038391,136.742828 474.358093,139.006516 
	C472.014343,139.567459 470.522919,138.338715 469.198547,137.148071 
	C458.245697,127.301552 445.977600,119.308014 433.495972,111.607452 
	C432.357361,110.904991 431.196106,110.234886 430.669067,108.520950 
z"/>
<path fill="#033E75" opacity="1.000000" stroke="none" 
	d="
M562.286987,312.665741 
	C563.290833,325.231628 561.388855,337.267426 559.156982,349.646545 
	C555.421326,352.019989 553.559448,348.653809 550.739624,347.170959 
	C550.918640,340.225861 548.948303,333.591187 551.087952,326.917450 
	C552.559387,322.327820 550.800171,317.272308 552.515503,312.212006 
	C555.902344,310.668304 558.941284,311.445282 562.286987,312.665741 
z"/>
<path fill="#19C7F4" opacity="1.000000" stroke="none" 
	d="
M473.880646,139.592560 
	C474.882996,137.015503 474.394196,134.287170 476.601776,132.205963 
	C486.650146,139.680084 494.451233,149.245239 502.962524,158.546265 
	C504.227753,160.652435 503.641754,162.495132 503.145020,164.681488 
	C502.994507,165.257370 502.924194,165.485718 502.717224,166.047089 
	C502.465546,166.591705 502.350464,166.803314 502.022766,167.307098 
	C501.633820,167.762543 501.457520,167.925781 500.939209,168.199081 
	C499.920074,168.220184 499.256378,168.000320 498.845245,167.466751 
	C491.831635,158.364471 483.278900,150.712387 475.345032,142.477646 
	C474.651215,141.757553 474.059723,140.955597 473.880646,139.592560 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M301.692078,62.515480 
	C305.080933,62.302109 308.116669,62.274097 311.595886,62.355492 
	C312.355988,64.298843 312.672546,66.132790 312.703491,68.703468 
	C306.827728,71.591866 301.004822,70.101547 294.864136,70.505127 
	C288.698578,70.853714 283.143311,72.669731 276.933319,72.473663 
	C272.951996,72.681046 269.507233,73.935349 265.498413,73.524811 
	C263.707275,72.129204 263.622559,70.502533 263.897308,68.395309 
	C263.985291,67.991653 264.094055,67.683937 264.117065,67.523392 
	C268.824707,66.577759 273.509277,65.792664 278.602936,64.908707 
	C283.082733,64.299225 287.153442,63.788605 291.611420,63.142792 
	C295.112061,62.905346 298.225494,62.803093 301.692078,62.515480 
z"/>
<path fill="#08BDF4" opacity="1.000000" stroke="none" 
	d="
M371.304077,76.433990 
	C369.735626,78.770187 366.668030,79.536285 365.162506,82.545883 
	C364.121735,83.857208 362.913513,83.875786 361.794098,83.634972 
	C351.125214,81.339836 340.256561,80.153801 329.241577,77.561081 
	C327.308838,74.324623 329.213776,73.107788 331.538574,72.102226 
	C333.385834,71.303223 335.526245,71.916664 337.704102,70.695435 
	C349.232483,71.327568 360.122925,73.668083 371.304077,76.433990 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M545.499939,231.773926 
	C550.198975,241.660568 553.121948,251.785248 555.392944,262.548523 
	C553.635010,264.918518 551.228027,265.507935 548.289795,265.747589 
	C546.508179,265.181793 545.743774,264.065948 545.442932,262.779694 
	C543.802368,255.764771 540.778931,249.115356 539.967529,241.479462 
	C540.613281,239.071503 541.435669,237.152985 541.811829,235.074554 
	C542.139465,233.264313 542.888428,231.647629 545.499939,231.773926 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M547.250061,265.642761 
	C549.837341,264.497803 552.213501,263.739502 555.026855,262.970734 
	C558.675903,272.062073 558.671875,281.723206 560.390503,291.527405 
	C557.834656,293.940338 555.262756,292.532410 552.292786,291.708191 
	C551.112244,290.839447 550.443054,290.023560 550.266724,289.049347 
	C548.885559,281.420074 546.890808,273.873291 547.250061,265.642761 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M545.831177,231.619934 
	C543.551941,232.236969 542.859131,233.770950 543.028687,235.791519 
	C543.194519,237.767151 542.284363,239.244308 541.000183,241.041275 
	C539.965027,241.261978 539.313110,240.733429 538.991455,239.958130 
	C535.415771,231.338196 531.419312,222.891724 528.350220,213.707550 
	C529.672668,210.721970 532.405090,209.763184 534.780823,207.885086 
	C539.425110,215.263855 542.561035,223.285782 545.831177,231.619934 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M551.593506,291.380676 
	C554.538574,290.566925 556.979126,291.705872 559.976807,291.965302 
	C562.138428,298.585907 561.613342,305.461121 562.655884,312.557739 
	C559.684875,312.904144 556.708130,313.453491 553.527100,312.044983 
	C550.673706,305.404602 550.106384,298.654297 551.593506,291.380676 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M545.097839,410.369080 
	C546.878723,410.023743 548.505005,410.008484 550.541809,409.989258 
	C553.464600,410.828949 556.179016,411.074158 558.757568,412.770447 
	C559.030396,413.011444 558.993469,413.007446 558.997070,412.989258 
	C558.372437,417.925598 555.383362,421.444580 551.521240,424.851654 
	C546.948853,426.064026 542.715454,428.008026 538.770996,424.161865 
	C540.892395,419.385773 542.917847,415.042480 545.097839,410.369080 
z"/>
<path fill="#08AFF3" opacity="1.000000" stroke="none" 
	d="
M507.521423,467.094604 
	C507.357452,467.390106 507.104462,467.445831 506.975220,467.455688 
	C505.133575,465.216644 502.624695,466.275024 500.046600,465.886139 
	C499.871918,460.564178 504.649017,457.995911 507.012421,453.558014 
	C508.983551,451.125549 510.281860,448.570465 513.210083,447.036560 
	C515.895508,446.774292 518.357910,445.167114 520.297729,447.978882 
	C516.793030,455.042084 511.704041,460.557709 507.521423,467.094604 
z"/>
<path fill="#02AEE7" opacity="1.000000" stroke="none" 
	d="
M337.721649,70.345284 
	C337.969177,73.095901 336.097076,72.944962 334.264862,73.019753 
	C332.020050,73.111382 329.572113,72.993645 329.023376,76.447945 
	C327.564392,78.631210 325.500763,78.582550 323.573456,78.323097 
	C319.823883,77.818314 316.030823,77.728951 311.886414,76.882690 
	C308.823120,73.975922 310.786987,71.870255 312.731567,69.405701 
	C313.045288,69.092010 313.030853,68.878059 312.985901,68.780754 
	C315.663666,68.791153 318.386383,68.898857 321.557495,69.077087 
	C322.463837,69.480103 322.975983,69.527046 323.752869,69.317184 
	C328.448120,69.532661 332.905212,69.865005 337.721649,70.345284 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M535.059937,207.425369 
	C534.441406,210.764511 531.605652,211.362640 529.184448,212.926620 
	C524.606140,211.026199 524.048462,206.828186 522.938660,202.578033 
	C522.908325,201.061295 523.873779,199.827576 523.051636,198.812302 
	C520.159180,195.240295 521.895203,191.927444 523.700745,188.325317 
	C528.753235,193.770554 531.683655,200.535202 535.059937,207.425369 
z"/>
<path fill="#0B5794" opacity="1.000000" stroke="none" 
	d="
M554.896240,365.681091 
	C554.132385,372.734131 551.810852,379.088104 549.561707,385.801697 
	C547.660645,387.183289 546.024658,386.971069 544.093140,385.634338 
	C541.965576,381.346436 544.734253,377.762329 544.886536,373.527985 
	C546.147400,369.560883 545.924194,365.650391 547.953491,361.966614 
	C551.450256,361.075317 552.650085,363.957214 554.896240,365.681091 
z"/>
<path fill="#009AED" opacity="1.000000" stroke="none" 
	d="
M520.470947,448.176056 
	C518.156921,446.110168 515.840393,448.861145 513.328247,447.988953 
	C512.198242,445.776581 513.886841,444.395844 514.906860,442.408081 
	C518.854736,437.528412 520.407471,431.475189 525.324585,427.289917 
	C527.689087,426.679688 529.478149,427.115417 531.285400,428.763245 
	C531.442749,429.275360 531.376587,429.438507 531.133179,429.797394 
	C530.682068,430.253418 530.445923,430.544403 530.205444,431.145264 
	C527.368835,437.135590 524.348511,442.718475 520.470947,448.176056 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M555.351929,365.734436 
	C552.006348,366.610413 551.554504,363.287659 549.233765,362.118896 
	C547.159607,357.818329 549.064026,353.864929 549.658264,349.426697 
	C549.911255,348.471436 550.162537,347.971283 550.847168,347.269653 
	C554.269043,346.287781 555.363464,350.268829 558.614502,349.997009 
	C557.854675,355.154877 556.728882,360.306152 555.351929,365.734436 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M538.619324,423.974976 
	C542.842834,426.729584 546.942993,424.153564 551.599548,424.280853 
	C551.819824,427.167267 549.935181,428.941620 548.385925,431.287903 
	C545.412292,433.205566 543.875610,436.493408 540.163330,437.065826 
	C539.287109,436.207581 538.968750,434.855713 537.452148,436.156982 
	C535.822998,435.769165 534.966431,434.642853 533.958679,433.194702 
	C535.325378,429.992767 536.848511,427.106812 538.619324,423.974976 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M543.265015,402.850037 
	C541.480286,408.626343 539.240173,413.772461 536.508911,419.063293 
	C534.205200,419.181915 532.338501,418.454346 530.186890,417.430359 
	C530.518127,410.581970 534.113708,405.263428 537.802490,399.642303 
	C540.679321,399.094086 542.438721,400.056213 543.265015,402.850037 
z"/>
<path fill="#0CA3DE" opacity="1.000000" stroke="none" 
	d="
M523.888550,187.746658 
	C521.540955,192.761230 524.753967,197.477280 523.743408,202.557755 
	C518.426086,198.968079 516.665466,192.767685 513.461548,187.109497 
	C513.296509,186.070450 513.409973,185.403381 513.845642,184.477905 
	C514.124084,184.022324 514.247498,183.851059 514.787598,183.230835 
	C515.348083,182.645142 515.491882,182.508423 516.065735,181.976196 
	C516.641113,181.453827 516.786377,181.326935 517.159912,181.023468 
	C517.554260,180.750702 517.720276,180.654495 518.162415,180.479828 
	C518.820496,180.425125 519.188782,180.508804 519.751160,180.845490 
	C521.241943,183.162933 522.524963,185.287781 523.888550,187.746658 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M543.412842,402.989807 
	C542.339355,401.324493 540.581421,400.696747 538.465942,400.056824 
	C536.282532,397.041290 538.998291,394.813080 539.469238,392.217590 
	C539.788208,390.459473 540.542480,388.775787 541.356201,386.760284 
	C541.623291,386.210663 541.744507,385.997375 542.096191,385.496216 
	C542.525574,385.063477 542.724304,384.918579 543.292053,384.774078 
	C545.270691,385.190826 546.880310,385.607117 548.914795,386.052246 
	C547.449829,391.631042 545.560059,397.180939 543.412842,402.989807 
z"/>
<path fill="#009AED" opacity="1.000000" stroke="none" 
	d="
M526.367859,455.962585 
	C524.816467,455.241150 523.544006,454.317139 522.083374,453.109009 
	C524.977722,447.731079 528.060303,442.637299 531.401978,437.284790 
	C532.914673,437.489594 533.917847,438.293427 534.934509,439.660706 
	C533.000427,445.645203 529.636292,450.601990 526.367859,455.962585 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M500.877319,168.488159 
	C500.971832,167.936478 500.985016,167.738815 501.019287,167.244720 
	C501.205322,166.791351 501.370178,166.634399 501.769348,166.229050 
	C502.003601,165.980637 502.001709,166.005005 501.990143,166.000916 
	C503.193146,164.775055 504.797424,164.361801 506.721069,163.860001 
	C507.774872,164.589294 508.476501,165.339020 509.318420,166.371811 
	C509.643372,167.155273 508.936707,167.845886 509.909180,168.059753 
	C511.577454,168.595718 512.623047,169.724960 513.039429,171.696091 
	C513.286926,174.829056 511.792328,176.635818 509.320190,178.225281 
	C504.725281,176.496170 502.521057,172.875214 500.877319,168.488159 
z"/>
<path fill="#0D89D9" opacity="1.000000" stroke="none" 
	d="
M529.971741,417.086182 
	C532.388794,416.816681 534.251221,417.244720 536.026855,418.998657 
	C534.816895,422.411377 533.389343,425.521881 531.735352,428.872314 
	C529.656128,428.746979 527.803406,428.381714 525.547852,428.023438 
	C524.154114,426.594025 525.255493,425.425385 525.777954,423.852356 
	C526.633545,422.128418 527.361267,420.721863 528.026489,418.903992 
	C528.502197,417.947083 528.968323,417.436127 529.971741,417.086182 
z"/>
<path fill="#02AEE7" opacity="1.000000" stroke="none" 
	d="
M508.771606,178.355225 
	C509.948242,176.046997 512.175842,174.842545 512.717041,172.237305 
	C515.228027,173.611893 516.407288,176.063126 518.131226,178.497070 
	C518.456726,179.306839 518.508057,179.826401 518.205078,180.678864 
	C517.973206,180.999619 518.005615,181.006271 518.005798,180.989731 
	C517.779663,181.207031 517.550903,181.438416 517.145752,181.838577 
	C516.971863,182.009811 517.010254,182.010284 517.010132,181.991043 
	C516.781860,182.205093 516.552002,182.436691 516.146057,182.838348 
	C515.971741,183.010147 516.010376,183.010269 516.010132,182.990936 
	C515.777466,183.197495 515.554321,183.432220 515.171875,183.850601 
	C514.755615,184.452896 514.508057,184.880341 514.147644,185.528595 
	C510.047638,185.060974 509.236053,181.907898 508.771606,178.355225 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M535.368896,439.830566 
	C533.564880,439.981018 532.526917,439.216278 531.786987,437.428650 
	C532.209290,435.764069 532.757507,434.502075 533.553955,433.059387 
	C535.450073,433.068085 536.656006,433.792847 537.125793,435.905182 
	C535.998779,437.068298 536.010620,438.450928 535.368896,439.830566 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M506.984863,163.528793 
	C506.262207,165.829407 504.590240,166.093048 502.359589,165.998627 
	C501.454468,163.742737 502.771027,161.786438 503.051849,159.252045 
	C504.364929,160.305435 505.630707,161.761719 506.984863,163.528793 
z"/>
<path fill="#1A6D97" opacity="1.000000" stroke="none" 
	d="
M510.049042,167.664551 
	C510.109955,169.138840 509.754791,170.098480 508.450409,170.517838 
	C507.983887,169.268219 509.077393,168.416275 509.340210,166.996613 
	C509.662109,166.907684 509.865540,167.160492 510.049042,167.664551 
z"/>
<path fill="#0A5D87" opacity="1.000000" stroke="none" 
	d="
M518.300415,181.066925 
	C518.040771,180.511490 518.108337,180.023361 518.229248,179.167328 
	C518.791626,179.360001 519.300598,179.920547 519.884277,180.759583 
	C519.515137,181.070129 519.071411,181.102188 518.300415,181.066925 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M323.665833,69.107780 
	C323.533966,69.821495 322.998657,70.056496 322.158539,69.344208 
	C322.450806,69.103500 322.895721,69.059372 323.665833,69.107780 
z"/>
<path fill="#0D89D9" opacity="1.000000" stroke="none" 
	d="
M530.408386,431.261719 
	C530.272766,431.063110 530.382507,430.701904 530.724121,430.166931 
	C530.855286,430.361816 530.754517,430.730499 530.408386,431.261719 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M572.724487,388.854065 
	C572.657715,391.342712 572.291443,393.681213 571.883789,396.416199 
	C569.714417,402.850586 567.532654,408.864197 563.601074,414.389893 
	C562.150208,414.689880 561.226257,414.309387 560.184021,413.297577 
	C560.794495,407.756958 563.180969,403.171722 565.682983,398.606873 
	C566.687927,396.773407 567.950562,394.973877 567.952393,392.349487 
	C565.280151,388.877991 562.346558,386.011688 560.182373,382.156555 
	C560.036682,380.655518 559.855164,379.458496 561.424194,379.098816 
	C563.104065,378.713806 564.349609,379.544159 565.174194,380.817474 
	C567.150391,383.869141 569.783142,386.283112 572.724487,388.854065 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M559.724365,412.996918 
	C560.806885,413.241730 561.647949,413.506500 562.800781,413.891327 
	C563.976868,414.963501 563.549988,416.013031 563.261047,417.346863 
	C563.115173,417.841705 563.049744,418.035797 562.864990,418.507507 
	C562.649841,418.957581 562.554138,419.130005 562.121338,419.764832 
	C561.557983,420.517670 561.338867,420.813385 560.995789,421.349792 
	C560.776062,421.740570 560.689514,421.897430 560.474182,422.289734 
	C560.177551,422.844147 560.012146,423.164398 559.729675,423.736206 
	C559.518127,424.150177 559.426086,424.313873 559.177795,424.715576 
	C558.687683,425.431396 558.338135,425.898010 557.806763,426.611481 
	C557.453857,426.983521 557.293579,427.116333 556.829956,427.338684 
	C556.315063,427.406250 556.103394,427.384247 555.598877,427.231018 
	C554.249207,426.359955 553.223572,425.585999 552.285156,424.249786 
	C552.093201,423.992096 551.956116,424.005157 551.885376,424.005798 
	C554.087708,420.523926 556.360840,417.041412 558.817261,413.265015 
	C559.000671,412.971069 559.482971,413.016876 559.724365,412.996918 
z"/>
<path fill="#011B36" opacity="1.000000" stroke="none" 
	d="
M581.176758,377.635132 
	C580.815674,378.836517 580.456177,379.646362 579.957031,380.762085 
	C578.994019,380.864319 578.170654,380.660645 577.161255,380.190063 
	C577.781250,376.640381 575.577209,371.936554 581.626648,370.942810 
	C582.155212,373.102600 581.936157,375.209778 581.176758,377.635132 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M559.876587,382.045471 
	C563.316223,384.500244 566.184326,387.422668 567.925537,391.624146 
	C564.425964,389.367157 558.921448,388.479645 559.876587,382.045471 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M558.991333,412.645142 
	C556.177612,413.102081 553.526306,412.536133 551.118652,410.309753 
	C555.861877,406.944458 556.565918,407.146332 558.991333,412.645142 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M301.285034,587.041992 
	C298.847473,586.746582 296.808105,586.392944 294.376221,585.993286 
	C293.908905,583.156982 293.597778,580.234619 297.761719,579.432007 
	C300.471313,576.724976 303.974152,577.299622 307.253906,576.015991 
	C309.226685,575.681091 310.761536,575.212219 312.731323,574.824463 
	C314.253082,574.706970 315.335815,574.833557 316.666443,575.610352 
	C316.911987,579.136047 314.010406,579.450073 311.972382,580.449158 
	C308.448212,582.176697 307.035980,584.488281 308.956299,588.595154 
	C306.153473,589.816833 304.553040,586.057800 301.285034,587.041992 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M339.621460,564.313232 
	C339.346771,566.321411 338.659302,568.278870 337.950500,570.591858 
	C336.707794,571.710571 335.381500,572.082886 333.584656,572.023315 
	C330.492584,571.686279 327.735413,571.502686 324.652618,571.002869 
	C321.926422,570.154663 319.350464,570.412537 316.628052,569.423584 
	C312.264130,567.999756 308.045166,567.795593 303.623779,566.659363 
	C303.105988,566.254944 302.940155,566.044250 302.904541,565.453125 
	C315.100769,565.160767 327.176788,565.696777 339.621460,564.313232 
z"/>
<path fill="#17283A" opacity="1.000000" stroke="none" 
	d="
M316.658234,568.467651 
	C319.432129,568.738586 321.899231,569.187866 324.732849,569.735718 
	C325.232178,570.153870 325.250580,570.693176 325.158203,570.692749 
	C321.691711,570.676208 324.865692,572.503052 324.208069,573.611084 
	C321.857544,574.428711 319.722534,574.941772 317.284760,575.667114 
	C315.940094,575.913574 314.898193,575.947815 313.464844,575.958618 
	C312.486572,575.449280 311.733948,575.513794 310.816772,575.057617 
	C310.080292,573.556091 310.474518,572.408203 311.067688,570.939331 
	C312.413879,568.598633 314.568665,569.106262 316.658234,568.467651 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M324.393860,573.916626 
	C323.928497,572.656311 321.753021,570.922913 324.945129,570.097168 
	C327.718811,570.352844 330.338257,570.871338 333.094482,571.708801 
	C330.596466,573.448914 327.564697,573.097778 324.393860,573.916626 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M316.368469,590.985352 
	C315.892975,590.574341 315.831940,590.180847 315.676666,589.503418 
	C317.924713,588.704712 319.902985,589.861511 321.974609,591.002930 
	C320.244049,591.002930 318.513489,591.002930 316.368469,590.985352 
z"/>
<path fill="#62E4F9" opacity="1.000000" stroke="none" 
	d="
M321.721252,557.691162 
	C322.322998,559.435852 322.628632,560.880920 322.973694,562.697021 
	C321.047028,563.214661 319.080841,563.361328 316.749695,563.544189 
	C316.384674,563.580322 315.905457,563.696899 315.905457,563.696899 
	C315.905457,563.696899 315.468231,563.468933 315.224121,563.498535 
	C311.968140,563.404663 308.956238,563.281128 305.492615,563.180908 
	C304.809143,563.285095 304.577423,563.365906 303.977997,563.464539 
	C302.624115,563.387390 301.664703,563.743286 300.333435,563.519287 
	C298.685089,562.152405 298.133789,560.509399 297.481750,558.531738 
	C297.510681,557.671692 297.689423,557.223633 298.283020,556.603455 
	C299.438629,555.925659 300.389374,555.748474 301.689362,555.493896 
	C302.768738,555.395813 303.483887,555.484375 304.561035,555.587280 
	C306.146118,555.678650 307.370026,555.697144 308.977051,555.649414 
	C310.404938,555.614014 311.450531,555.578491 312.904480,555.628906 
	C316.114075,555.768433 318.852631,556.197815 321.721252,557.691162 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M299.740173,562.552979 
	C301.085785,562.819702 302.145874,562.909363 303.601654,563.057068 
	C304.111969,563.244385 304.226532,563.373657 304.206299,563.724243 
	C303.523132,563.993164 302.974731,564.040771 302.015381,564.127502 
	C298.870483,566.209045 295.649780,564.887146 292.326782,565.521240 
	C291.699463,565.630310 291.447815,565.672913 290.813599,565.697876 
	C290.191437,565.592712 289.951874,565.505188 289.450562,565.138794 
	C287.331879,563.125549 284.735229,564.145874 282.322205,562.994507 
	C282.331116,560.604858 284.063629,561.150513 285.429840,561.353210 
	C287.412506,561.647461 289.378021,561.680725 291.716980,561.491699 
	C292.308044,561.397705 292.543884,561.367798 293.132568,561.338989 
	C294.392456,561.438110 295.273315,561.701965 296.520325,561.781616 
	C297.078613,561.809937 297.302185,561.823364 297.860199,561.877075 
	C298.636749,562.009583 299.057861,562.159241 299.740173,562.552979 
z"/>
<path fill="#1A6D97" opacity="1.000000" stroke="none" 
	d="
M291.116058,565.401489 
	C293.929840,562.835388 297.450745,564.693420 301.187744,564.195435 
	C301.929413,564.358032 302.254395,564.549377 302.807098,564.906677 
	C303.034790,565.072571 303.066193,565.433594 303.062012,565.614746 
	C299.172089,569.095398 295.327179,566.441772 291.116058,565.401489 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M315.195862,563.671387 
	C315.302490,563.455078 315.624939,563.382019 316.166016,563.444702 
	C316.060364,563.658447 315.736053,563.736511 315.195862,563.671387 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M304.265503,563.868530 
	C304.071503,563.945557 304.051025,563.528809 304.024200,563.321960 
	C304.175415,563.082336 304.353424,563.049622 304.786133,563.110596 
	C304.911377,563.463623 304.717560,563.659363 304.265503,563.868530 
z"/>
<path fill="#040E11" opacity="1.000000" stroke="none" 
	d="
M119.062943,169.257965 
	C119.695969,169.067322 119.971313,168.958405 120.770599,168.892258 
	C121.417274,169.228348 121.515297,169.459167 121.643967,170.063690 
	C121.156708,173.558609 118.612625,175.475769 117.158157,178.039932 
	C110.962097,188.963318 104.211685,199.606735 100.037262,211.961487 
	C97.919418,216.777100 97.096436,221.693619 94.587425,226.367340 
	C93.744881,229.175079 93.243256,231.717377 91.366684,234.093338 
	C88.782104,235.079102 87.543777,233.720032 86.314331,231.682648 
	C85.554482,228.028641 86.929672,225.105316 88.142410,222.276291 
	C92.490814,212.132507 97.037354,202.073425 102.813354,192.207672 
	C106.694839,185.858704 109.904335,179.528214 114.120522,173.826462 
	C115.391281,172.107941 116.920380,170.592270 119.062943,169.257965 
z"/>
<path fill="#010610" opacity="1.000000" stroke="none" 
	d="
M124.807816,163.266693 
	C127.013115,160.300552 129.020874,157.579819 131.076477,154.517197 
	C138.165085,146.278763 144.632477,137.825165 153.576447,131.338745 
	C154.181046,131.241394 154.429001,131.236374 155.042770,131.313324 
	C157.797195,133.064102 159.151413,135.368332 159.513184,138.585373 
	C154.504288,144.428619 148.904953,149.014084 142.294312,152.366486 
	C136.146317,155.484283 132.269638,160.896194 128.478668,166.399094 
	C127.463539,167.872620 126.685181,170.325439 123.741562,168.702667 
	C123.504898,168.185150 123.459137,167.960358 123.450119,167.397675 
	C123.722099,166.204041 124.484535,165.628952 124.696022,164.452225 
	C124.659775,163.929199 124.635025,163.720642 124.807816,163.266693 
z"/>
<path fill="#074D75" opacity="1.000000" stroke="none" 
	d="
M154.164230,131.647034 
	C147.654053,137.670654 141.754166,143.726471 136.200302,150.130692 
	C134.926392,151.599670 133.808716,153.359650 131.462616,154.114929 
	C126.166534,150.349777 126.242317,150.422089 130.766571,145.680756 
	C133.232452,143.096588 136.379211,141.098816 137.970901,137.348480 
	C142.477234,133.812744 145.516754,128.965912 150.729630,126.138603 
	C154.100815,126.551575 154.477676,128.809952 154.164230,131.647034 
z"/>
<path fill="#0A5C8E" opacity="1.000000" stroke="none" 
	d="
M118.923050,169.080170 
	C113.704826,176.135513 109.075905,183.853882 104.335419,191.889725 
	C101.400261,190.751221 101.350334,188.024551 100.825821,185.270386 
	C103.230774,178.898514 106.767708,173.733597 111.692764,169.142883 
	C114.145432,169.009949 116.297821,169.028275 118.923050,169.080170 
z"/>
<path fill="#040E11" opacity="1.000000" stroke="none" 
	d="
M121.677902,167.938889 
	C121.816605,166.524048 122.202362,165.569412 123.868118,165.234985 
	C124.517387,165.712219 124.513504,166.103668 124.217369,166.731079 
	C124.031303,166.966476 124.008125,167.004700 123.994827,167.022675 
	C123.704185,167.417679 123.415161,167.785538 122.783424,168.261368 
	C122.220772,168.345673 121.989311,168.312988 121.677902,167.938889 
z"/>
<path fill="#040E11" opacity="1.000000" stroke="none" 
	d="
M124.752380,163.175598 
	C125.005356,163.021286 125.006577,163.495819 125.006058,163.733093 
	C125.269112,164.442245 125.199623,164.841324 124.389160,165.089935 
	C124.032112,165.023422 123.983131,164.983398 123.958466,164.962097 
	C124.122337,164.403839 124.310875,163.866867 124.752380,163.175598 
z"/>
<path fill="#040E11" opacity="1.000000" stroke="none" 
	d="
M120.736481,168.737656 
	C120.809387,168.374237 121.002190,168.121796 121.412186,167.745422 
	C121.597961,167.597488 121.800377,167.796799 121.899948,167.898102 
	C122.169266,168.464584 122.056656,168.846542 121.331001,169.072754 
	C121.000305,169.000259 120.824974,168.824646 120.736481,168.737656 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M186.566071,98.272263 
	C186.811691,97.756950 186.871872,97.581169 186.971100,97.129440 
	C191.430862,97.346260 192.943558,101.602989 196.279694,104.057953 
	C197.906174,105.798065 199.393600,107.180664 201.302704,108.614662 
	C209.391357,117.433411 217.216324,126.030571 225.076355,134.582764 
	C233.166473,143.385330 240.818039,152.587921 249.418610,161.398926 
	C258.955963,174.619034 270.291229,185.912048 279.897766,198.622238 
	C280.996002,200.075272 282.088867,201.542297 283.497803,203.206390 
	C287.823822,209.578781 292.873322,214.993683 296.690186,221.711731 
	C296.776886,222.851944 296.556702,223.541901 295.664856,224.278519 
	C293.942932,224.679840 292.943481,223.913437 291.670532,222.900421 
	C280.354614,210.992630 266.725250,202.598648 253.958603,193.116409 
	C252.097290,191.733948 250.220947,190.357758 247.981049,188.896469 
	C240.188950,183.206100 232.537857,177.912201 224.999222,171.871140 
	C223.568878,170.778076 222.540024,169.783325 221.606354,168.234024 
	C222.680817,163.548874 221.152267,159.870682 218.712967,156.354736 
	C214.653885,150.504105 211.282043,144.183472 206.446136,138.430023 
	C201.822220,130.499649 196.561172,123.389801 192.219009,115.698296 
	C190.330673,112.353378 188.513596,109.001450 187.146423,105.004410 
	C186.612457,102.656898 185.740997,100.714890 186.566071,98.272263 
z"/>
<path fill="#05476E" opacity="1.000000" stroke="none" 
	d="
M186.403625,97.952530 
	C187.187424,100.024826 187.623322,102.116913 188.048737,104.611122 
	C185.647827,108.794899 181.388504,110.074974 177.703049,112.720337 
	C170.898392,117.069496 165.372147,122.669769 157.859604,125.959976 
	C155.519119,126.000290 153.741440,125.630905 153.100372,123.286407 
	C158.295166,115.410507 166.223053,111.282822 173.139832,106.051895 
	C177.165176,103.007660 181.175613,99.738434 186.403625,97.952530 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M196.798843,92.254425 
	C197.764114,91.651146 198.527740,91.326363 199.603455,90.968857 
	C203.096329,90.662796 205.648956,88.785728 208.467285,87.586884 
	C210.106720,86.889511 211.710373,86.018608 213.912415,86.717545 
	C215.024353,88.746140 213.919922,89.896400 212.550980,90.479225 
	C206.642563,92.994698 201.587433,97.003807 195.472168,99.843590 
	C193.147293,99.559349 191.533722,98.772072 190.541504,96.541840 
	C192.517303,94.943001 194.557236,93.737961 196.798843,92.254425 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M190.191818,96.089760 
	C191.710358,97.057465 192.943359,97.966888 194.477325,98.998642 
	C195.933151,99.769600 197.463913,99.791565 198.238617,101.494705 
	C197.942062,102.891029 197.236679,103.733284 196.285187,104.775848 
	C193.223099,102.351151 190.427704,99.739128 187.321228,96.990295 
	C187.318253,94.263771 188.730865,95.565483 190.191818,96.089760 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M154.176941,131.967712 
	C153.965179,129.747803 152.380478,128.240509 151.296265,126.203430 
	C151.059937,125.573235 151.084152,125.150177 151.082962,124.410263 
	C151.207031,123.923874 151.356491,123.754349 151.826874,123.690948 
	C153.715759,125.057297 155.438400,126.112114 157.175507,127.690674 
	C157.555603,128.374268 157.640976,128.809036 157.542862,129.584427 
	C157.028992,130.728836 156.297943,131.200378 155.244049,131.793777 
	C154.809631,131.992050 154.628754,131.987747 154.176941,131.967712 
z"/>
<path fill="#72C2DC" opacity="1.000000" stroke="none" 
	d="
M156.779251,128.244843 
	C155.030838,126.922127 153.668854,125.779015 152.136459,124.383255 
	C151.823288,123.895340 151.680527,123.660057 151.772369,123.085098 
	C152.234100,122.776802 152.461243,122.808159 153.025909,122.909836 
	C154.505859,123.785889 155.648285,124.591614 157.079971,125.259552 
	C158.773193,125.325684 159.167099,126.318840 159.041626,127.909943 
	C158.287354,128.529221 157.735764,128.579117 156.779251,128.244843 
z"/>
<path fill="#42A7D0" opacity="1.000000" stroke="none" 
	d="
M151.821243,122.604752 
	C152.002426,122.976280 151.997879,123.207130 151.979706,123.784294 
	C151.966049,124.130615 151.512161,124.086884 151.284851,124.090149 
	C151.229950,123.543106 150.737427,122.756943 151.821243,122.604752 
z"/>
<path fill="#45DAF8" opacity="1.000000" stroke="none" 
	d="
M69.292709,350.710266 
	C67.622757,350.687042 66.230232,350.352081 64.476196,350.012482 
	C63.445213,344.936035 62.775730,339.864288 62.008675,334.384033 
	C61.911098,333.975525 62.088173,334.081512 62.191086,334.089050 
	C63.913509,332.590363 65.412956,333.425903 67.214493,334.628662 
	C68.992149,337.119537 69.282639,339.622406 69.414299,342.585510 
	C69.404076,345.468964 70.607857,347.911469 69.292709,350.710266 
z"/>
<path fill="#51CAF4" opacity="1.000000" stroke="none" 
	d="
M74.800003,362.941010 
	C68.354904,362.649292 69.242447,357.881104 69.042435,353.372559 
	C70.223686,351.937683 71.223915,350.618805 73.326324,351.114197 
	C74.937523,354.926941 76.597900,358.400604 75.326492,362.693176 
	C75.102470,363.033600 74.907089,362.945435 74.800003,362.941010 
z"/>
<path fill="#37AFE9" opacity="1.000000" stroke="none" 
	d="
M73.154999,350.867004 
	C71.905121,351.867126 71.329185,353.256042 69.385529,352.959717 
	C69.048798,352.519470 69.038292,352.091644 69.021530,351.342896 
	C68.690483,348.608032 68.365677,346.194092 68.065834,343.370850 
	C68.903999,342.231903 69.851715,341.971100 71.283325,342.264984 
	C73.060913,343.182526 73.160072,344.836487 74.175247,346.333893 
	C74.441284,346.880981 74.522766,347.112061 74.642448,347.709747 
	C74.616386,349.103943 74.195618,349.968933 73.154999,350.867004 
z"/>
<path fill="#071A2D" opacity="1.000000" stroke="none" 
	d="
M226.855423,78.316277 
	C231.136627,76.716682 235.194412,75.397865 239.628998,74.070961 
	C240.803528,74.951950 241.128342,75.994057 240.920563,77.588730 
	C239.938477,80.098877 237.856369,80.297058 235.688934,81.103195 
	C230.819992,82.416153 226.388306,83.763298 221.989227,85.222977 
	C220.259613,85.796883 218.506485,86.351212 216.306442,85.488701 
	C215.621780,84.811287 215.491943,84.295486 215.793915,83.385956 
	C219.558762,81.561401 223.095383,80.079231 226.855423,78.316277 
z"/>
<path fill="#022D4E" opacity="1.000000" stroke="none" 
	d="
M215.659576,83.063461 
	C216.014999,83.554413 216.007874,84.065247 216.002563,84.959503 
	C216.024887,86.218880 215.566513,86.776016 214.426025,87.096855 
	C209.104263,87.356125 205.441193,91.617371 200.136185,91.195915 
	C204.809860,87.862495 210.036469,85.439682 215.659576,83.063461 
z"/>
<path fill="#061426" opacity="1.000000" stroke="none" 
	d="
M240.347534,78.411606 
	C240.017670,77.062660 240.009506,75.971123 240.003571,74.471222 
	C241.798691,73.421791 243.591599,72.780716 245.700836,71.969856 
	C251.732162,70.516647 257.447113,69.233223 263.573669,67.970726 
	C265.465698,69.061722 264.847595,70.659424 265.013794,72.435631 
	C262.415283,76.036682 258.378510,75.021088 254.666473,76.242271 
	C249.627151,76.506508 245.458755,79.380539 240.347534,78.411606 
z"/>
<path fill="#05B2F9" opacity="1.000000" stroke="none" 
	d="
M540.918945,456.865540 
	C540.648315,457.048431 540.279480,456.929962 540.094543,456.867004 
	C538.708069,453.720764 535.049438,453.505737 532.923950,450.954437 
	C533.548157,449.008392 534.508911,447.215973 535.726501,445.209625 
	C536.363892,444.677643 536.840088,444.325928 537.283691,444.430145 
	C542.732422,445.710205 546.236084,443.388031 548.746643,438.400085 
	C549.330811,438.258820 549.572815,438.241119 550.172607,438.292725 
	C551.240784,438.645874 551.697327,439.194214 552.210999,440.160339 
	C552.406616,440.716278 552.456055,440.947052 552.479431,441.529114 
	C552.299866,442.316040 552.096191,442.726135 551.624023,443.365295 
	C550.849060,444.260742 550.208374,444.823639 549.408752,445.646790 
	C548.945679,446.142792 548.698059,446.433136 548.339539,446.981750 
	C548.072632,447.566437 547.940735,447.909698 547.719971,448.518127 
	C547.539490,448.947784 547.454651,449.114838 547.209473,449.514099 
	C546.929810,449.892365 546.810547,450.038422 546.284119,450.577515 
	C545.209717,451.351166 544.666016,451.853119 544.131226,452.759003 
	C543.938721,452.965118 543.994385,453.000885 543.979248,452.971497 
	C543.774414,453.207214 543.558533,453.448822 543.129456,453.822693 
	C542.942505,453.978485 542.997681,453.999725 542.984131,453.973450 
	C542.377747,454.859589 541.786499,455.772980 540.918945,456.865540 
z"/>
<path fill="#009AED" opacity="1.000000" stroke="none" 
	d="
M550.277466,438.742950 
	C549.500061,439.257080 548.638245,439.394226 548.410034,439.849182 
	C545.006714,446.635193 543.914490,447.151245 536.384399,445.047089 
	C537.080261,442.416016 538.177246,439.836365 539.569885,437.070343 
	C543.047241,435.796722 544.218567,432.222839 547.557251,430.815918 
	C549.543396,430.791016 550.703491,431.774811 552.142822,433.775269 
	C552.435425,435.087250 552.332642,435.502411 552.057861,436.197205 
	C551.843933,436.678345 551.750671,436.866760 551.496094,437.325317 
	C551.082031,437.928833 550.799866,438.235077 550.277466,438.742950 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M100.637161,184.994781 
	C102.772194,186.719254 102.833023,189.265701 103.918762,191.772369 
	C98.040398,204.567017 91.133469,216.627258 86.800789,230.244614 
	C86.684975,234.425797 84.888733,237.822388 84.029053,241.834198 
	C83.062752,245.603088 81.443123,248.794815 80.966217,252.711792 
	C79.223869,257.752045 78.794868,262.733276 77.029816,267.773010 
	C76.600121,268.594849 76.239632,268.967377 75.410408,269.340393 
	C71.893784,268.214752 72.679192,265.446442 72.849220,263.199219 
	C73.095940,259.938293 72.453934,257.093231 70.171631,254.268723 
	C69.883698,248.232483 72.329536,243.098816 73.955673,237.376999 
	C77.499901,229.787216 79.002388,221.773483 82.945328,214.360413 
	C88.174103,204.009384 92.977089,193.786423 100.637161,184.994781 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M566.039673,423.938293 
	C566.676514,423.861725 566.971069,423.900177 567.709900,423.990540 
	C567.083069,431.860718 563.969360,439.048248 561.096924,446.693115 
	C559.208069,446.860931 557.402222,447.310089 555.446899,446.184418 
	C554.954895,445.843750 554.803650,445.653137 554.605469,445.100372 
	C556.918213,437.114594 560.823303,430.323090 566.039673,423.938293 
z"/>
<path fill="#022D4E" opacity="1.000000" stroke="none" 
	d="
M540.978516,457.053986 
	C541.205566,456.076569 541.762817,455.104706 542.645386,454.040039 
	C543.315369,454.943878 542.725891,455.639587 542.079712,456.666809 
	C541.745728,457.006165 541.527222,457.032837 540.978516,457.053986 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M554.786255,444.787292 
	C555.039856,445.043152 555.067322,445.538940 555.086792,445.786682 
	C554.066711,448.093201 553.027161,450.151978 551.898071,452.544678 
	C550.853821,448.346069 548.619568,450.848328 546.305786,451.953705 
	C545.599731,451.575470 545.464294,451.113586 545.758301,450.258423 
	C545.954102,449.933777 545.998474,449.995026 545.965576,449.976318 
	C546.215027,449.790283 546.462219,449.581390 546.814453,449.131714 
	C546.954590,448.932495 546.993225,448.996155 546.959473,448.980347 
	C547.546448,448.531219 547.494507,447.788269 547.969849,446.926666 
	C549.544189,445.770020 550.869446,444.826691 552.793396,444.273438 
	C553.629150,444.228851 554.091309,444.334320 554.786255,444.787292 
z"/>
<path fill="#022D4E" opacity="1.000000" stroke="none" 
	d="
M545.618286,450.003296 
	C545.968994,450.385925 545.983887,450.838104 545.984131,451.629395 
	C545.490295,452.310516 545.011108,452.652466 544.235352,452.979767 
	C543.419678,451.551788 544.595581,450.925903 545.618286,450.003296 
z"/>
<path fill="#022D4E" opacity="1.000000" stroke="none" 
	d="
M543.253601,454.004028 
	C543.074951,453.603668 543.207397,453.228882 543.651978,452.898132 
	C543.830933,453.304596 543.697815,453.667084 543.253601,454.004028 
z"/>
<path fill="#62E4F9" opacity="1.000000" stroke="none" 
	d="
M218.021515,549.327209 
	C220.689240,548.991150 223.516113,548.839905 226.655304,548.439758 
	C227.872055,547.074280 229.042480,547.304138 230.116882,547.720215 
	C235.157700,549.672424 240.428726,551.054382 245.447998,554.035950 
	C246.625473,555.878235 248.190689,557.200317 247.258057,559.635742 
	C246.965240,560.169189 246.912796,560.389526 246.797577,560.943787 
	C237.309326,560.058289 228.247589,556.972473 218.445862,555.620483 
	C216.956573,554.038391 217.393188,552.809875 218.710602,551.324707 
	C220.088730,549.772156 218.325378,550.083191 218.021515,549.327209 
z"/>
<path fill="#1B2027" opacity="1.000000" stroke="none" 
	d="
M245.259293,554.837769 
	C239.340729,552.322632 233.528549,550.205933 227.341995,548.140076 
	C225.961456,547.677612 224.561874,548.448181 223.489838,547.011841 
	C222.564972,546.579163 222.420364,545.964294 222.096832,545.155518 
	C222.559326,544.535950 223.070404,544.211731 224.212799,543.791565 
	C225.518982,543.821045 226.172470,544.027954 227.174774,544.318848 
	C238.527786,547.834839 249.276062,552.084900 260.909546,554.788208 
	C264.083008,555.595581 266.861511,556.396179 270.140503,556.831787 
	C277.819794,558.890320 285.587158,558.612793 292.793823,562.061890 
	C289.466125,563.990906 285.995941,562.146057 282.234619,562.635986 
	C281.954834,562.874512 281.487671,562.976562 281.256531,563.037720 
	C276.256195,564.654053 272.024536,561.899231 267.102386,561.362915 
	C259.554749,559.393799 252.012970,558.885010 245.259293,554.837769 
z"/>
<path fill="#46E7FA" opacity="1.000000" stroke="none" 
	d="
M245.144348,554.822388 
	C252.193008,556.228149 259.233093,558.016968 266.636383,559.951355 
	C268.408051,561.695496 268.478760,563.455017 267.314697,565.671997 
	C260.562378,564.105652 254.124084,562.192749 247.351746,560.114380 
	C247.524628,557.917725 245.349899,556.950500 245.144348,554.822388 
z"/>
<path fill="#0E151F" opacity="1.000000" stroke="none" 
	d="
M217.867218,555.463867 
	C227.683792,555.538574 237.137207,557.081116 246.364120,561.302612 
	C245.748459,561.562195 244.762100,561.846741 243.474030,562.212036 
	C242.237350,562.863403 241.249283,562.727722 239.882782,562.501160 
	C238.524612,562.500000 237.536911,562.440125 236.270721,562.806274 
	C235.575821,565.078064 234.736526,565.740295 233.048706,563.621826 
	C231.661713,560.930237 229.404373,561.801025 227.158798,561.862915 
	C226.258423,562.023254 225.630554,562.018127 224.688690,562.013855 
	C221.457993,561.413940 221.075729,557.915283 218.282806,556.654602 
	C217.946793,556.203857 217.851700,555.996094 217.867218,555.463867 
z"/>
<path fill="#3FDDF9" opacity="1.000000" stroke="none" 
	d="
M267.145142,566.255737 
	C267.001465,564.325989 267.002319,562.633484 267.001373,560.518921 
	C271.435150,560.981567 275.870728,561.866150 280.665863,562.924805 
	C281.070557,564.919128 280.515656,566.511719 278.914612,568.019409 
	C276.875092,569.512390 275.012573,568.094299 272.848083,568.483215 
	C272.190460,568.462708 271.927643,568.445007 271.337769,568.205627 
	C271.010681,567.983948 271.001221,568.000000 271.003693,567.992065 
	C270.357697,567.331116 269.497559,567.549316 268.468872,567.256348 
	C267.908539,566.887024 267.599091,566.690002 267.145142,566.255737 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M294.286865,578.807861 
	C287.203125,579.164917 280.526031,578.112366 273.458862,577.016296 
	C272.691315,576.605408 272.549561,576.237488 272.931885,575.604309 
	C276.487366,575.266113 279.762939,575.099060 283.485413,574.870972 
	C286.862366,572.778137 290.099915,573.606812 293.683685,573.920654 
	C294.913635,574.357727 295.527008,574.905151 296.067810,576.065125 
	C296.453949,577.753418 295.841583,578.405884 294.286865,578.807861 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M295.309082,574.661377 
	C291.864014,574.524902 288.364868,574.742493 284.398987,574.885010 
	C283.089661,573.878052 281.743561,573.249939 282.013702,571.309814 
	C282.393799,570.608765 282.854065,570.405334 283.767578,570.424805 
	C285.663727,570.535095 287.180481,570.518555 289.064087,570.429199 
	C290.680328,570.312622 291.847870,570.706238 293.365967,571.162170 
	C294.572754,571.759338 295.215790,572.474121 296.032593,573.511841 
	C296.256042,574.051025 296.287781,574.287476 296.139771,574.833069 
	C295.725067,575.099976 295.490051,575.057739 295.309082,574.661377 
z"/>
<path fill="#01BEE9" opacity="1.000000" stroke="none" 
	d="
M289.116394,565.266846 
	C289.376434,564.892639 289.564117,564.925476 290.036255,564.985474 
	C293.708405,566.620361 297.581024,566.827515 301.090637,569.013733 
	C301.239014,569.622070 301.183807,569.887817 300.808960,570.416870 
	C297.437012,572.073364 294.326904,570.877319 290.828125,570.781006 
	C290.140106,570.588074 289.867676,570.500671 289.281036,570.120911 
	C288.992554,568.443665 289.018250,567.058777 289.116394,565.266846 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M271.677002,568.113281 
	C273.745270,567.925415 275.752655,568.050781 278.179077,568.193665 
	C277.170685,572.122925 274.639099,567.959534 272.444641,568.938110 
	C271.918732,568.725342 271.767426,568.575928 271.677002,568.113281 
z"/>
<path fill="#075A81" opacity="1.000000" stroke="none" 
	d="
M272.843384,575.305176 
	C273.234070,575.761841 273.191467,576.081848 273.080750,576.636108 
	C271.845306,577.086548 270.636108,577.091736 269.212830,576.242310 
	C269.873047,574.732727 271.218628,575.143921 272.843384,575.305176 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M284.273438,570.527588 
	C283.593109,570.849060 283.139679,570.876221 282.346252,570.940430 
	C281.583496,570.672363 280.581451,570.793335 280.870758,569.962891 
	C281.370209,568.529236 282.576965,569.077576 283.834900,569.434265 
	C284.212341,569.830200 284.356323,570.031738 284.273438,570.527588 
z"/>
<path fill="#040E11" opacity="1.000000" stroke="none" 
	d="
M284.467468,570.896973 
	C284.057281,570.623108 284.067993,570.424377 284.073486,569.927124 
	C285.429901,569.720886 286.791473,569.813171 288.559937,569.867004 
	C289.126587,569.895691 289.286346,569.962830 289.699463,570.088135 
	C290.077698,570.339111 290.202637,570.532043 290.162964,571.027954 
	C288.295013,571.211365 286.591675,571.091736 284.467468,570.896973 
z"/>
<path fill="#2478A2" opacity="1.000000" stroke="none" 
	d="
M238.845169,562.330444 
	C240.245743,562.153137 241.316437,562.136292 242.779724,562.206177 
	C243.099060,562.693909 243.025803,563.095032 242.931458,563.801453 
	C241.887527,563.706604 240.864700,563.306396 239.515396,562.843750 
	C238.964386,562.684509 238.739838,562.587708 238.845169,562.330444 
z"/>
<path fill="#2A8AB5" opacity="1.000000" stroke="none" 
	d="
M268.382324,567.350220 
	C269.062592,567.182617 269.907227,567.281189 270.878998,567.681885 
	C270.186340,567.861511 269.366486,567.738892 268.382324,567.350220 
z"/>
<path fill="#2A8AB5" opacity="1.000000" stroke="none" 
	d="
M271.541779,567.789551 
	C271.804810,567.975769 271.871735,568.151428 272.004333,568.600952 
	C271.758789,568.747620 271.447540,568.620422 271.073486,568.238586 
	C271.010681,567.983948 271.345703,567.778992 271.541779,567.789551 
z"/>
<path fill="#1391DB" opacity="1.000000" stroke="none" 
	d="
M217.624298,555.084595 
	C220.929794,556.270325 222.633850,558.670471 224.206451,561.688232 
	C224.168716,562.448242 223.962738,562.881836 223.838562,563.666626 
	C223.464264,564.003601 223.008148,563.989197 222.209869,563.961304 
	C220.016312,563.265747 218.031174,563.113647 215.778381,562.497314 
	C213.377594,562.231934 211.197052,563.142273 209.183777,561.289551 
	C209.161819,558.807800 208.108917,558.207642 206.062408,557.937195 
	C202.680923,557.490417 199.366501,556.536194 195.481155,555.675598 
	C198.811539,553.973145 202.240982,556.399902 204.831116,553.494934 
	C206.808121,552.713257 208.561295,553.307861 210.697723,553.982971 
	C212.925766,555.764282 215.134552,555.257263 217.624298,555.084595 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M227.245987,562.184082 
	C229.636444,559.817444 231.503830,560.038940 233.208923,563.059937 
	C231.181763,562.988708 229.393723,562.664307 227.245987,562.184082 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M238.816681,562.104248 
	C239.175049,562.169983 239.144806,562.476990 239.166870,562.629150 
	C238.388626,562.846069 237.588318,562.910767 236.387451,563.007874 
	C236.519333,561.987488 237.478485,561.987488 238.816681,562.104248 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M208.621155,560.965698 
	C210.844513,562.333374 213.031784,561.819580 215.474792,562.433105 
	C212.834152,563.220520 209.828140,563.101624 206.472717,562.248169 
	C205.370316,562.005981 204.036041,561.668884 204.056824,561.515686 
	C204.210709,560.381287 205.197876,560.993774 205.840836,560.931580 
	C206.626251,560.855530 207.429932,560.968140 208.621155,560.965698 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M216.220932,562.984802 
	C215.873825,562.796875 215.891357,562.485718 215.878159,562.331177 
	C217.932327,561.660645 219.633484,562.830322 221.667053,563.670654 
	C220.083435,563.810547 218.206619,564.306152 216.220932,562.984802 
z"/>
<path fill="#033256" opacity="1.000000" stroke="none" 
	d="
M562.170166,418.387939 
	C562.252625,417.033630 562.599854,415.877045 563.029785,414.365936 
	C565.841309,408.424957 568.570129,402.838501 571.570740,397.032349 
	C571.821960,397.958710 572.204041,399.327026 571.714355,400.214142 
	C568.896790,405.318420 568.907288,410.825256 569.072144,416.778473 
	C569.108765,417.178070 569.044678,417.111023 569.068359,417.071167 
	C567.918701,418.128815 567.882202,419.945068 566.304077,421.135651 
	C564.145935,421.278381 563.505127,419.649078 562.170166,418.387939 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M561.918396,418.266266 
	C563.883484,417.829102 564.596741,419.337433 565.737549,420.799988 
	C566.354675,421.068481 566.645813,421.243896 566.942261,421.775696 
	C566.901001,422.303925 566.793091,422.577820 566.495972,423.250732 
	C564.149719,424.251007 563.278015,426.083405 562.451843,427.858490 
	C560.706299,431.609070 557.930908,434.705811 555.789673,438.607239 
	C554.883118,439.860992 553.902466,440.451050 552.433716,440.867249 
	C551.732178,440.517242 551.377869,440.134613 550.993225,439.485352 
	C550.598206,438.768188 550.465210,438.257385 550.758728,437.323914 
	C550.953857,436.961517 551.002930,436.989960 550.976013,436.983765 
	C551.444153,436.589111 551.503967,436.001648 551.801636,435.208893 
	C551.956421,434.965668 551.995911,435.005676 551.968628,434.998596 
	C551.941345,434.991516 552.271484,434.628967 552.424500,434.161804 
	C552.715881,433.396820 552.865112,433.104614 553.136353,432.597992 
	C553.247437,432.378021 553.492737,431.949707 553.633423,431.747253 
	C553.774048,431.544800 554.080261,431.158630 554.379761,430.767883 
	C554.860596,430.098145 555.024048,429.808960 555.274231,429.273682 
	C555.456177,428.881134 555.533569,428.724579 555.748413,428.342041 
	C556.111633,427.841766 556.357788,427.587402 556.808105,427.158936 
	C556.991943,426.965149 557.004089,427.003326 556.984436,426.999573 
	C557.798706,426.335388 558.212952,425.398285 558.811523,424.215515 
	C558.989685,423.965851 559.006042,424.003387 558.985596,424.004395 
	C559.441711,423.589355 559.504456,422.989136 559.834106,422.191803 
	C560.002991,421.951050 560.015442,422.010590 559.985718,422.016937 
	C560.430359,421.598999 560.504944,420.996429 560.836548,420.189087 
	C561.007507,419.945923 561.015137,420.012909 560.982056,420.019470 
	C561.274658,419.747009 561.561401,419.432495 561.910278,418.778320 
	C562.011414,418.474243 561.931335,418.342316 561.918396,418.266266 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M554.711060,439.177216 
	C557.119690,433.312775 561.067749,428.723633 563.964478,423.518951 
	C564.134033,423.214264 565.138184,423.374146 566.030396,423.483795 
	C566.306763,423.649750 566.445801,423.691925 566.413940,423.757568 
	C562.752502,430.719940 558.306274,437.187103 555.269287,444.779633 
	C554.520020,445.095215 554.000183,445.147308 553.090332,445.236603 
	C552.394226,444.919739 552.192627,444.515472 552.113159,443.710388 
	C552.172729,443.150452 552.232422,442.932587 552.427673,442.406982 
	C553.020935,441.072144 553.755676,440.247589 554.711060,439.177216 
z"/>
<path fill="#011B36" opacity="1.000000" stroke="none" 
	d="
M567.266174,421.801453 
	C566.734924,421.842377 566.460999,421.654694 566.094360,421.231445 
	C566.761536,419.697876 567.068787,418.104309 568.778809,417.126709 
	C569.239990,418.776855 568.266357,420.135010 567.266174,421.801453 
z"/>
<path fill="#1174A3" opacity="1.000000" stroke="none" 
	d="
M69.785797,254.317368 
	C74.409454,254.561020 74.432541,258.061829 74.310959,261.236176 
	C74.217346,263.680450 73.648796,266.090271 74.788040,268.763977 
	C75.620789,269.538849 75.788361,270.184784 75.724915,271.229523 
	C75.274071,272.577393 74.724182,273.559479 75.074142,275.069885 
	C75.067574,279.821136 74.779472,284.183533 72.839783,288.628357 
	C69.971642,290.541107 68.612473,288.665253 67.277382,286.938416 
	C66.046410,285.346252 65.602135,283.325409 64.319809,281.321655 
	C63.626961,275.831970 66.299011,271.054688 66.160492,265.461639 
	C68.214584,261.859741 67.998390,257.950745 69.785797,254.317368 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M63.986572,281.413391 
	C66.133438,281.075623 66.670341,282.498444 67.219925,284.185333 
	C67.880455,286.212769 68.862900,288.154907 71.486275,288.976135 
	C74.303001,292.100311 72.340683,295.182343 71.630371,298.638245 
	C70.504013,299.887115 69.404984,300.051666 67.826729,299.770569 
	C64.867737,297.199738 65.786209,293.196259 63.220669,290.330505 
	C62.970695,289.562103 62.924168,289.119965 62.828583,288.347656 
	C63.170799,285.946503 62.839806,283.744598 63.986572,281.413391 
z"/>
<path fill="#1E2B39" opacity="1.000000" stroke="none" 
	d="
M294.395386,579.091675 
	C294.530304,578.542786 295.070557,578.034302 295.932861,577.037109 
	C297.045135,575.927979 297.922913,575.421265 298.900269,574.527344 
	C299.354645,574.267334 299.553314,574.191467 300.068909,574.061157 
	C302.470428,574.322266 304.720032,573.220581 306.945892,574.919983 
	C307.576141,575.394470 307.853271,575.743958 308.026733,576.487793 
	C305.133148,578.353027 301.849304,578.177002 298.433746,579.150879 
	C296.952423,579.177002 295.876556,579.154541 294.395386,579.091675 
z"/>
<path fill="#1391DB" opacity="1.000000" stroke="none" 
	d="
M193.802826,550.265015 
	C197.082504,550.244446 200.034088,551.299683 203.210403,551.118408 
	C204.884201,551.022766 203.615494,552.020508 203.140305,552.811279 
	C198.779510,554.373962 195.017120,552.138306 189.929855,551.828186 
	C191.863419,551.139587 192.732742,550.829956 193.802826,550.265015 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M195.221222,560.260498 
	C197.060120,560.129883 198.692200,559.448547 200.336151,560.656799 
	C198.373810,561.184814 196.639236,561.280090 195.221222,560.260498 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M185.629028,548.009644 
	C186.777084,548.302917 187.555740,548.610718 188.654633,548.975281 
	C187.596390,550.491333 186.031982,550.189392 184.204895,549.233765 
	C183.981857,548.955505 183.927261,548.535217 183.856262,548.335632 
	C184.276718,548.098755 184.768188,548.061462 185.629028,548.009644 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M189.389771,560.116882 
	C188.765366,559.905212 188.494049,559.676636 188.106293,559.208374 
	C189.365921,558.968689 190.742004,558.968689 192.298843,558.968689 
	C191.610489,560.468933 190.568253,559.950195 189.389771,560.116882 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M185.408096,558.910950 
	C185.035095,558.870117 185.014008,558.422729 185.011139,558.198608 
	C185.905853,558.113953 186.803436,558.253418 187.867035,558.695007 
	C187.282394,558.982056 186.531738,558.966919 185.408096,558.910950 
z"/>
<path fill="#18A6E3" opacity="1.000000" stroke="none" 
	d="
M61.990639,319.371399 
	C60.762192,314.311859 60.981102,309.562744 61.834579,304.413391 
	C63.251644,302.679169 64.808441,302.717194 66.856911,303.537964 
	C69.359604,308.376740 68.593056,313.106537 67.814423,318.261139 
	C66.126045,320.442505 64.304871,320.380798 61.990639,319.371399 
z"/>
<path fill="#19C7F4" opacity="1.000000" stroke="none" 
	d="
M61.508862,319.468323 
	C63.141907,319.051300 64.665886,319.031372 66.579285,319.015076 
	C68.225174,320.085266 68.282608,321.581421 68.412338,323.489441 
	C68.442108,325.383392 68.492767,326.839081 68.424164,328.734863 
	C68.512459,330.967438 68.491776,332.744263 67.324921,334.718536 
	C65.675636,334.715790 64.332420,334.387085 62.641602,334.077454 
	C61.995926,329.352875 61.697861,324.609161 61.508862,319.468323 
z"/>
<path fill="#1D98D1" opacity="1.000000" stroke="none" 
	d="
M67.249771,303.693237 
	C65.537338,304.022278 64.145447,304.011780 62.334610,304.004578 
	C61.803780,299.570496 61.816128,295.140686 62.868988,290.384674 
	C67.598259,291.145477 66.802681,294.897827 66.987671,298.592438 
	C68.105309,300.334595 68.314972,301.780426 67.249771,303.693237 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M217.956329,555.124329 
	C215.619110,557.949890 213.023834,555.973633 210.512512,555.480835 
	C210.490417,555.476501 210.485992,555.187988 210.536972,555.056885 
	C210.594193,554.909790 210.723862,554.790894 210.952881,554.352112 
	C213.237976,552.538391 215.033096,550.185120 218.592896,551.024902 
	C218.682175,552.148987 218.364166,553.282410 218.011993,554.777588 
	C217.977814,555.139404 217.955246,555.146301 217.956329,555.124329 
z"/>
<path fill="#08346F" opacity="1.000000" stroke="none" 
	d="
M508.117004,453.679504 
	C505.330048,457.781860 502.608917,461.488586 499.763153,465.520630 
	C494.463257,472.006531 489.288055,478.167145 483.957031,484.630920 
	C476.924835,491.453888 470.364563,498.343781 462.010681,503.651001 
	C457.714142,502.794250 460.965820,506.793579 459.126892,507.628235 
	C458.881348,507.849884 458.952484,507.947968 458.901520,507.915222 
	C458.553070,508.459045 457.935638,508.461090 457.256683,508.889923 
	C457.079285,509.108643 457.007019,508.998779 457.045959,509.053070 
	C454.653656,510.401031 452.413849,510.074738 451.231262,507.566315 
	C449.612793,504.133331 448.182281,500.481262 452.200073,497.145020 
	C453.168732,496.798676 453.819305,496.813904 454.432068,496.658051 
	C454.500183,496.640747 454.233795,496.343048 453.484528,496.600708 
	C451.064270,496.163696 450.429352,494.601654 450.252686,492.345947 
	C450.397675,491.722748 450.496429,491.485260 450.847839,490.959167 
	C452.463318,489.770233 453.892426,489.765747 455.626526,490.517456 
	C456.300873,490.717926 455.883514,491.598389 456.474060,491.166443 
	C456.093231,489.987915 456.428009,489.145874 457.223877,488.129303 
	C458.141296,487.336182 458.972168,487.048187 460.093872,486.600311 
	C460.613678,486.406860 460.823944,486.336121 461.357391,486.186401 
	C462.565216,485.946655 463.449249,485.991516 464.665283,486.168640 
	C466.176514,486.561768 467.168365,486.325928 468.094513,485.015533 
	C469.299042,483.591217 469.790192,482.187164 470.332092,480.443451 
	C470.620514,479.982208 470.766083,479.817047 471.205933,479.500549 
	C472.486633,478.982086 473.448822,479.739777 474.419037,479.423157 
	C472.440735,479.486969 472.138000,478.070526 471.920593,476.236450 
	C472.932007,473.214691 471.554108,469.330200 475.969971,468.352509 
	C474.934906,467.715576 474.215790,468.164703 473.139313,468.558167 
	C471.502563,468.894653 470.307220,468.539368 468.796600,467.838623 
	C467.796539,467.109741 467.450256,466.426056 467.555725,465.182617 
	C468.439758,463.541901 469.668793,463.056824 471.423462,462.756042 
	C475.573730,463.013580 478.929779,462.468018 481.115967,458.837708 
	C481.693329,457.878998 482.877014,457.416199 484.468201,457.574341 
	C488.647247,459.241852 487.613190,461.817017 486.009460,464.712402 
	C483.898560,465.804535 483.323090,467.315033 483.497009,469.374878 
	C483.441956,469.890564 484.277466,469.109375 483.617279,469.202026 
	C483.489746,469.219910 483.483734,469.078491 483.487793,468.776306 
	C483.501068,467.786621 483.694855,466.861053 484.598389,465.865021 
	C488.147369,462.398987 488.383545,460.072266 485.315247,458.167786 
	C484.325409,456.269348 485.572998,455.231750 486.646118,453.790436 
	C489.926666,451.782867 492.771240,454.257538 496.102417,453.810425 
	C500.409027,454.184387 504.235565,452.263824 508.117004,453.679504 
z"/>
<path fill="#0E7EEA" opacity="1.000000" stroke="none" 
	d="
M413.081360,535.636597 
	C411.389648,536.197876 410.198242,535.887695 409.323486,534.125732 
	C407.603485,533.667847 406.872864,532.766418 406.909058,531.002930 
	C407.683319,530.191406 408.379700,529.933716 409.459900,529.665405 
	C413.907104,527.645203 416.722015,524.977600 416.889160,519.929382 
	C416.998688,516.620483 418.976654,513.629517 418.571106,509.970398 
	C418.325989,507.758789 421.106140,506.867249 423.693787,506.666565 
	C424.430023,507.057861 424.701385,507.467773 424.983337,507.879181 
	C426.070770,509.465729 425.486572,512.634888 428.820801,512.107117 
	C431.744690,511.644318 433.616089,509.992035 434.216797,506.677551 
	C433.965668,506.037689 435.806671,505.764343 434.486481,505.638000 
	C432.985199,505.494354 432.118042,504.917480 431.534180,503.275024 
	C431.648895,502.158295 432.117218,501.641876 433.091034,501.107910 
	C437.554718,500.009857 440.185425,496.627899 444.026672,494.510315 
	C444.905060,494.345642 445.403595,494.425964 446.170410,494.898407 
	C447.270050,496.718872 447.065948,498.193359 445.857452,499.879578 
	C444.929474,501.992432 442.680145,499.082306 442.152863,501.278381 
	C441.421265,504.325470 441.585846,507.215240 443.696960,509.769562 
	C445.384247,511.811066 448.108063,512.822021 449.154785,515.722229 
	C443.356201,520.293091 437.759277,524.707397 430.578644,527.141846 
	C425.868652,523.476135 419.789795,526.417175 417.248566,532.824951 
	C415.781311,533.862183 414.534241,534.628174 413.081360,535.636597 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M444.704956,500.347198 
	C445.742065,498.644257 446.201202,497.223053 445.930420,495.261749 
	C446.129913,492.079407 447.948456,491.389160 450.709015,491.771667 
	C451.335083,493.585693 451.480621,495.248688 453.629089,496.005005 
	C454.158112,496.197357 454.346344,496.346649 454.291229,496.761780 
	C450.632446,498.232819 450.415466,500.952484 451.149628,503.801422 
	C451.820251,506.403931 452.171753,509.647003 456.676392,509.075500 
	C456.366638,510.479126 455.309296,511.486084 453.564117,512.167847 
	C450.410156,513.646484 448.376953,512.747559 447.721069,509.771393 
	C447.017670,506.579834 442.438019,504.821136 444.704956,500.347198 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M444.606781,499.985718 
	C445.119110,502.186615 444.346283,504.696075 447.637756,505.574371 
	C449.065796,505.955444 449.071716,507.691772 448.982758,509.023163 
	C448.813080,511.563446 450.324524,512.111816 452.824158,512.171326 
	C452.681274,514.070312 450.799683,514.545166 449.347626,515.905029 
	C445.826050,512.813660 440.652588,510.998596 440.450684,505.526794 
	C440.364441,503.189667 439.063507,499.086792 444.606781,499.985718 
z"/>
<path fill="#0355A0" opacity="1.000000" stroke="none" 
	d="
M417.407837,533.049561 
	C417.491913,527.391113 423.643677,522.222961 428.590942,523.508850 
	C429.881348,523.844238 430.012909,525.210205 430.133057,526.781006 
	C426.626740,530.283142 422.343445,531.932800 417.407837,533.049561 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M459.202026,507.770172 
	C458.799713,506.700195 458.851501,505.519806 458.596130,504.410095 
	C458.373413,503.442413 456.859802,502.612854 458.755371,501.670929 
	C460.918274,500.596161 460.758698,502.526184 461.589722,503.708405 
	C462.497681,504.193695 464.342560,503.835815 462.779297,505.408813 
	C461.859650,506.334229 460.618988,506.940582 459.202026,507.770172 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M457.372559,509.081177 
	C457.476929,508.726593 457.874573,508.344574 458.561401,507.922485 
	C458.455658,508.272858 458.060760,508.663300 457.372559,509.081177 
z"/>
<path fill="#0BF0FA" opacity="1.000000" stroke="none" 
	d="
M407.329865,530.829468 
	C407.709259,531.917358 408.260254,532.664856 408.935822,533.662354 
	C407.950012,535.574402 405.777252,534.664551 404.113281,535.958130 
	C403.107513,536.560303 402.452820,536.459839 401.541748,535.838379 
	C398.718842,531.895996 395.967438,528.336670 392.610046,524.830566 
	C388.063416,519.366394 383.825165,514.082642 378.813599,509.014771 
	C378.235992,508.447418 377.918488,508.108521 377.374756,507.497253 
	C375.244812,503.912262 371.740387,501.834076 370.127197,497.877838 
	C370.031219,496.171844 370.333679,495.017120 372.150848,494.502869 
	C373.556061,494.713135 374.218628,495.481049 375.218384,496.383484 
	C382.303101,503.860779 387.105408,513.077698 396.434235,517.845764 
	C397.895752,518.592773 399.242859,519.561523 401.187683,520.158691 
	C404.578430,523.078186 406.939362,526.255798 407.329865,530.829468 
z"/>
<path fill="#2B82AB" opacity="1.000000" stroke="none" 
	d="
M399.016815,542.712280 
	C396.371857,543.618164 393.756439,544.293152 390.779175,544.981812 
	C387.920441,544.585449 387.218018,542.633728 386.687805,540.197144 
	C388.213776,537.605530 390.607422,537.324036 393.293091,536.807312 
	C393.943359,536.779968 394.203766,536.785095 394.850830,536.844482 
	C397.529114,537.473572 398.532715,539.225830 399.140015,541.638916 
	C399.054138,542.016052 399.046356,542.481445 399.016815,542.712280 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M399.409973,541.969727 
	C397.281128,541.233154 397.253387,539.030151 395.461151,537.892212 
	C394.891968,536.961853 395.435272,536.563782 396.301086,536.018311 
	C397.456604,535.546204 398.172180,534.979370 399.287781,534.426147 
	C400.344696,534.185120 400.997070,534.432251 401.939270,534.905884 
	C402.603821,535.369934 402.970764,535.646301 403.554443,536.012146 
	C408.212067,542.016052 400.823059,539.791626 399.409973,541.969727 
z"/>
<path fill="#A0F5FC" opacity="1.000000" stroke="none" 
	d="
M386.971497,539.681091 
	C387.994263,541.484192 389.015717,542.945374 390.227234,544.701050 
	C389.182404,545.658264 387.947449,546.321045 386.369202,547.061768 
	C383.332916,547.775085 380.639984,548.410461 377.556946,549.035400 
	C373.332489,547.383850 372.212799,543.690796 370.677551,539.984863 
	C372.093994,535.596619 370.375854,531.819702 369.814301,527.958191 
	C369.487976,525.714294 368.310547,523.509155 369.936401,520.981445 
	C372.284821,520.022705 373.452759,521.457947 374.970398,522.889038 
	C375.898926,524.059875 376.399384,525.097656 377.386780,526.194153 
	C378.808075,527.707397 379.746490,529.182800 381.074585,530.767517 
	C381.451477,531.168091 381.603607,531.328735 381.985046,531.732544 
	C384.102875,534.234375 386.213348,536.349609 386.971497,539.681091 
z"/>
<path fill="#0CD8FF" opacity="1.000000" stroke="none" 
	d="
M322.365204,557.835388 
	C319.159729,557.648926 316.302094,557.307068 313.013611,556.880066 
	C311.133026,553.318665 314.491455,551.205505 315.009827,547.951782 
	C315.007111,545.897583 316.324921,543.598022 312.819275,543.085815 
	C312.314636,542.780701 312.124634,542.636658 311.709595,542.210876 
	C311.018311,541.029968 310.959778,540.079529 311.242554,538.756042 
	C311.604645,537.989563 311.942810,537.664124 312.733582,537.373535 
	C313.314056,537.288391 313.548889,537.283508 314.131165,537.312683 
	C315.338959,537.547729 316.188538,537.498718 317.230957,537.170166 
	C317.432983,537.103699 317.175262,536.721619 316.917236,536.664795 
	C316.269531,536.481323 315.939087,536.258789 315.485291,535.663940 
	C316.281128,529.548462 320.769257,526.731140 327.660645,527.986511 
	C331.887115,530.690247 332.322815,534.397949 330.753632,538.209778 
	C329.285278,541.776672 328.773651,545.423523 328.306946,549.495178 
	C327.809631,550.898010 327.298340,551.902344 326.296692,552.969482 
	C325.962402,553.746704 325.063873,552.558289 325.418152,553.752808 
	C326.246338,554.557556 326.608490,555.277283 326.499329,556.450562 
	C325.168549,557.058594 323.940765,557.369324 322.365204,557.835388 
z"/>
<path fill="#11547D" opacity="1.000000" stroke="none" 
	d="
M325.185791,553.269592 
	C326.005341,552.423279 326.456970,551.622742 327.014648,550.561707 
	C328.862396,547.991028 331.806702,548.684570 334.399841,547.479004 
	C336.357178,547.423035 337.904053,547.657532 339.825684,548.066040 
	C342.632996,549.532898 343.274170,551.757385 343.175354,554.721497 
	C337.802612,555.676514 332.476044,556.232849 326.772919,556.768555 
	C326.011353,556.031982 325.626373,555.316162 325.151855,554.307861 
	C324.980835,553.782104 324.899353,553.548706 325.185791,553.269592 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M369.253052,551.095581 
	C367.975494,551.654114 366.846069,551.879272 365.365021,552.111938 
	C363.894073,550.815247 364.210632,548.839294 362.761719,547.329651 
	C362.375824,545.311218 362.483643,543.557495 362.216248,541.501038 
	C361.829834,538.801575 359.438416,536.046143 363.821014,534.396545 
	C364.642731,534.155823 365.133850,534.112244 366.010254,534.181030 
	C368.680573,535.206970 370.430542,536.622314 370.518005,539.699524 
	C370.022491,541.965149 370.907898,544.417786 368.147644,545.315491 
	C368.812134,545.714478 369.312500,545.118469 369.890808,545.035645 
	C371.388092,544.821289 373.180420,544.535339 373.838593,546.108337 
	C374.529419,547.759338 372.505981,548.031738 371.574219,548.771851 
	C370.796478,549.389648 370.020660,549.982544 369.253052,551.095581 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M343.528687,555.146362 
	C341.170380,553.628052 342.301727,550.541809 339.714142,549.046753 
	C339.354462,548.656799 339.350800,548.410461 339.457520,547.810669 
	C340.758331,545.614014 341.276825,543.255066 343.932190,542.135010 
	C345.366608,541.812683 346.408173,541.896179 347.779236,542.479248 
	C348.303375,542.899109 348.473816,543.113708 348.811584,543.705139 
	C349.373718,545.419983 349.346619,546.799622 349.372589,548.586304 
	C349.282684,550.955261 349.186157,552.905579 347.364197,554.702393 
	C346.033447,555.064331 344.980804,555.118469 343.528687,555.146362 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M369.500854,551.379150 
	C368.531952,548.328186 370.113281,546.887146 372.979706,546.170105 
	C371.100983,546.067383 369.222260,545.964661 366.349396,545.807556 
	C369.653168,544.611755 368.535797,541.952637 370.001892,540.018311 
	C370.312286,539.787415 370.746521,539.678711 370.908661,539.833008 
	C373.012512,542.782959 374.954193,545.578552 377.031311,548.699585 
	C375.047913,550.753662 372.374359,550.732361 369.500854,551.379150 
z"/>
<path fill="#0E6CB9" opacity="1.000000" stroke="none" 
	d="
M362.791901,546.717529 
	C365.134766,547.807983 366.439117,549.025940 365.025085,551.776001 
	C363.571075,553.424377 361.701721,552.834839 359.677734,553.261902 
	C358.665344,553.135925 358.147858,552.770630 357.391327,552.188110 
	C356.976807,551.856079 356.812561,551.720581 356.407043,551.374268 
	C355.850433,550.869263 355.546234,550.564148 355.033478,550.002319 
	C354.681427,549.578247 354.548920,549.399963 354.244202,548.933350 
	C353.655701,547.830750 353.338745,546.980591 353.098755,545.739990 
	C353.054901,544.428650 353.263062,543.542786 354.326904,542.720215 
	C357.790100,542.095459 357.208496,547.247498 360.870117,546.421082 
	C361.650024,546.308533 362.092255,546.366272 362.791901,546.717529 
z"/>
<path fill="#1391DB" opacity="1.000000" stroke="none" 
	d="
M348.345459,549.276306 
	C348.083099,547.649536 348.050171,546.254639 348.094574,544.445190 
	C350.055542,542.521179 351.331116,543.597595 352.678101,545.368286 
	C353.031677,546.861328 353.690277,547.763733 354.761627,548.800964 
	C354.988678,549.045410 355.005432,548.997986 354.980286,548.999268 
	C355.469757,549.573853 355.786499,550.337402 356.781128,550.854126 
	C357.006378,551.042480 357.002289,550.995361 356.982361,551.008057 
	C357.560883,551.640930 357.733734,552.370056 357.309692,553.534607 
	C356.327850,553.937561 355.556061,554.004150 354.397217,554.092896 
	C352.156891,552.628479 350.414154,551.011414 348.345459,549.276306 
z"/>
<path fill="#19BAF7" opacity="1.000000" stroke="none" 
	d="
M348.077606,549.424561 
	C350.724091,549.605347 353.054688,550.537964 353.978821,553.756104 
	C352.167999,555.711792 349.939301,554.712341 347.495911,555.017029 
	C347.403778,553.275024 347.721497,551.539856 348.077606,549.424561 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M357.396362,553.891235 
	C357.009003,553.157654 356.918335,552.444336 356.895020,551.375854 
	C358.028870,551.055847 358.819397,551.474487 359.210175,552.929993 
	C358.764038,553.494934 358.228516,553.703186 357.396362,553.891235 
z"/>
<path fill="#0C1929" opacity="1.000000" stroke="none" 
	d="
M125.044449,446.490967 
	C122.034363,442.590179 118.987137,439.051605 117.011581,434.422211 
	C117.179100,433.848145 117.386345,433.628906 117.995674,433.203217 
	C124.590240,432.486328 130.782318,431.990967 137.346405,433.511963 
	C139.680008,433.643951 141.603119,433.514801 143.853577,433.998810 
	C146.714828,437.798706 146.390747,438.950958 142.541382,439.686615 
	C141.411240,439.902588 139.945190,439.702301 139.294708,440.592499 
	C137.953400,442.428101 140.077469,441.359344 140.843964,441.803589 
	C142.693665,442.021057 144.097366,442.501190 145.756805,443.382324 
	C146.216278,443.814240 146.364594,444.022125 146.621231,444.596832 
	C146.302063,449.021942 141.874313,448.871490 139.630493,451.531891 
	C136.938126,452.153870 134.929031,451.064850 132.521179,450.143921 
	C131.764008,449.788361 131.339645,449.575317 130.599854,449.214172 
	C128.616669,448.304901 126.818733,447.804626 125.044449,446.490967 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M157.994934,487.178467 
	C157.662567,487.072418 157.451324,486.986145 157.388641,486.890839 
	C157.832016,486.139618 157.364838,485.634094 156.885254,484.834747 
	C156.590775,484.384216 156.475449,484.201691 156.250961,483.713745 
	C155.940643,482.591095 155.905457,481.751221 155.763870,480.655457 
	C155.725357,480.390289 155.672958,479.922760 155.663391,479.729248 
	C155.653824,479.535706 155.253006,479.568665 155.079361,479.698608 
	C154.905716,479.828522 154.555496,480.125153 154.365356,480.269958 
	C154.175217,480.414764 153.751892,480.664307 153.521057,480.760010 
	C152.962036,480.933258 152.629303,480.972321 152.038116,480.968323 
	C149.859619,478.899078 147.935104,476.834961 145.938354,474.440247 
	C146.607086,469.748505 149.255981,469.725769 152.401947,471.395935 
	C156.176697,473.399841 159.366898,476.404633 163.730911,478.137360 
	C165.782211,480.587616 168.363815,481.628296 171.006088,483.175598 
	C172.318710,485.326172 174.473541,486.450287 174.979630,488.975281 
	C174.549026,489.606842 174.228714,489.903137 173.590988,490.319733 
	C172.922241,490.649292 172.521149,490.783813 171.804871,490.943237 
	C170.904022,491.114716 170.305054,491.220123 169.455505,491.574310 
	C168.989044,491.802643 168.801331,491.897064 168.323364,492.126221 
	C166.569427,492.888885 165.091339,493.167816 163.270142,492.309784 
	C162.612579,491.782745 162.256821,491.390869 161.863937,490.729065 
	C161.250610,488.750214 159.797546,488.007935 157.994934,487.178467 
z"/>
<path fill="#0C1929" opacity="1.000000" stroke="none" 
	d="
M138.506882,465.088318 
	C137.183701,463.916626 136.225739,462.739044 135.153473,461.244385 
	C136.980728,456.882202 140.835358,459.389282 144.056641,458.290771 
	C145.220963,458.007690 146.007050,457.978546 147.170441,458.116638 
	C150.382019,459.438049 153.127991,460.910828 156.431564,461.997040 
	C157.439209,462.391327 158.074600,462.730865 158.992630,463.306793 
	C159.639206,463.844116 159.933090,464.216980 160.223923,464.985840 
	C158.329407,466.639374 156.605560,468.330627 153.920868,469.066650 
	C148.717880,467.585114 143.852737,466.122528 138.506882,465.088318 
z"/>
<path fill="#1391DB" opacity="1.000000" stroke="none" 
	d="
M147.827530,459.392639 
	C146.816803,459.226898 146.216873,459.122620 145.312500,458.997559 
	C140.993286,458.447266 137.087509,457.294434 132.733398,456.706543 
	C131.742416,454.877136 131.511780,452.884491 128.934235,452.341003 
	C127.363640,450.482605 126.120102,448.740173 124.800873,446.681274 
	C126.626923,446.506775 128.481567,446.832794 130.504242,447.914978 
	C131.010895,448.189117 131.195267,448.309845 131.675812,448.577332 
	C133.970047,449.489258 135.968094,450.254425 138.304306,451.126221 
	C142.983841,451.737427 147.115662,452.654510 149.640167,457.212158 
	C149.537811,458.500854 149.107635,459.149506 147.827530,459.392639 
z"/>
<path fill="#AEF6FB" opacity="1.000000" stroke="none" 
	d="
M108.989578,431.124969 
	C106.370872,426.747345 104.143127,422.324219 101.915176,417.542725 
	C101.886742,414.542969 103.908882,415.140686 105.829163,415.042664 
	C110.153923,417.595032 111.059471,422.077911 113.440071,426.012695 
	C114.400513,428.048218 115.539871,429.569061 116.466576,431.607330 
	C116.663452,432.413971 116.632896,432.880188 116.323860,433.643066 
	C113.360260,434.231506 112.331009,430.389526 108.989578,431.124969 
z"/>
<path fill="#071A2D" opacity="1.000000" stroke="none" 
	d="
M164.228394,479.073364 
	C160.033234,478.346375 157.138870,475.972168 154.030991,473.800171 
	C151.834656,472.265198 148.979858,469.007874 146.148163,473.910767 
	C143.086182,472.087891 141.102448,469.347198 139.028885,466.286896 
	C142.754684,464.328003 145.881287,466.873840 149.176346,467.845978 
	C151.187576,468.439331 153.166809,469.266296 155.612854,469.796997 
	C156.205750,469.961456 156.437576,470.040924 157.000336,470.273438 
	C160.255157,472.732361 164.264587,473.598236 166.257904,477.505737 
	C165.899780,478.534363 165.300659,478.880341 164.228394,479.073364 
z"/>
<path fill="#071A2D" opacity="1.000000" stroke="none" 
	d="
M173.976471,502.276245 
	C173.160812,501.958954 172.634827,501.764862 172.038788,501.290070 
	C171.457336,500.078094 171.623886,499.019775 171.390091,497.713928 
	C171.402435,496.718048 171.648346,496.124420 172.324615,495.372528 
	C173.720901,494.336182 175.027420,493.920685 176.713959,493.549744 
	C177.286285,493.544464 177.514038,493.581329 178.026489,493.813171 
	C178.804214,494.673187 178.744415,495.425262 178.653473,496.182220 
	C179.179977,495.642303 179.219254,494.864197 179.806152,493.982727 
	C180.425522,493.507629 180.858994,493.405182 181.641388,493.527527 
	C182.316559,493.911469 182.617172,494.239136 183.018982,494.909607 
	C183.605179,496.230865 184.467026,496.941010 185.263458,498.107666 
	C185.628830,499.439789 185.208984,500.134399 183.939636,500.629578 
	C182.147842,500.734314 180.988312,501.066498 181.304977,503.283447 
	C180.168060,505.125061 178.811478,504.566589 177.172241,503.973419 
	C175.807068,503.706207 175.851181,501.553192 173.976471,502.276245 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M131.868835,455.954773 
	C136.592239,455.272736 140.681915,456.438171 144.804779,458.675171 
	C142.153809,461.348297 138.607681,459.012024 135.321014,460.643188 
	C134.069519,459.847809 133.099869,458.768311 132.035034,457.388123 
	C131.816818,456.819031 131.693817,456.550659 131.868835,455.954773 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M157.048279,470.640320 
	C150.728928,470.927582 145.787521,466.554871 139.347946,465.958008 
	C138.640289,465.931000 138.408554,465.781250 138.200394,465.299194 
	C138.891220,463.954254 140.142334,463.647034 141.169327,464.124512 
	C144.970917,465.891998 149.390213,465.850616 153.354935,468.175964 
	C154.990143,468.683411 156.799072,468.360382 157.048279,470.640320 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M173.257355,495.584900 
	C172.718185,496.428741 172.362762,496.907257 171.709503,497.916382 
	C170.923187,498.566193 170.446701,498.535767 169.627136,498.242218 
	C168.245804,497.320923 167.221405,496.489746 166.107666,495.382202 
	C166.442596,493.507751 167.739258,493.110931 169.542770,492.811066 
	C170.791504,492.772003 171.598358,492.925232 172.720810,493.462341 
	C173.424805,494.140106 173.550003,494.651276 173.257355,495.584900 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M170.184402,493.821320 
	C168.839844,494.370667 167.741211,494.599854 166.330444,494.967407 
	C165.066422,494.323029 164.114532,493.540283 163.065491,492.466064 
	C164.714310,491.782867 166.460297,491.391144 168.591309,490.989075 
	C170.154755,491.419647 170.642471,492.258698 170.184402,493.821320 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M132.245026,455.362030 
	C132.123337,455.869812 132.079803,456.112366 131.988037,456.721161 
	C130.903610,455.672791 129.867371,454.258179 128.719147,452.534302 
	C130.293259,452.603333 133.919510,450.471100 132.245026,455.362030 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M157.805847,487.391418 
	C159.738892,486.846344 161.569214,487.030273 161.885147,490.050049 
	C159.951080,490.365570 159.179550,488.714294 157.805847,487.391418 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M116.344994,433.994446 
	C116.052750,433.554535 115.965744,433.164124 115.847763,432.474426 
	C116.739510,430.831573 118.152084,430.815430 119.971176,430.844574 
	C120.637711,430.982147 120.895355,431.068024 121.489220,431.376984 
	C122.324249,434.497986 119.995613,433.083832 118.523293,433.672211 
	C117.966217,433.873810 117.771210,433.931000 117.274033,434.027771 
	C116.971848,434.067383 116.550232,434.044006 116.344994,433.994446 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M173.813293,502.417908 
	C174.885422,501.379822 175.903931,501.416290 176.882721,502.958496 
	C177.152817,503.623688 176.939102,504.024414 176.177643,504.250519 
	C175.822830,504.172852 175.419846,504.082642 175.216812,504.045868 
	C174.655792,503.566986 174.297791,503.124878 173.813293,502.417908 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M171.999405,498.000397 
	C173.160583,498.725494 172.713593,499.600220 172.099319,500.743866 
	C171.378860,500.525543 170.788956,500.041718 170.119476,499.280182 
	C170.427444,498.489685 171.044632,498.540710 171.788116,498.188110 
	C172.001694,497.998779 172.000000,498.000000 171.999405,498.000397 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M155.106689,483.923767 
	C154.273209,483.730072 153.704269,483.307861 153.019501,482.639282 
	C152.674988,481.961029 152.676102,481.523804 153.163879,480.889954 
	C154.580994,480.678955 155.086960,481.430054 155.516754,482.673431 
	C155.495041,483.245880 155.433151,483.470551 155.106689,483.923767 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M156.701004,484.069916 
	C157.712830,484.525146 157.923828,485.228271 157.507874,486.437592 
	C156.871964,486.411835 156.417969,486.028168 155.835892,485.374603 
	C155.843155,484.714172 156.081238,484.398895 156.701004,484.069916 
z"/>
<path fill="#074D75" opacity="1.000000" stroke="none" 
	d="
M154.072906,480.598358 
	C153.660446,481.119598 153.405869,481.455688 153.027466,482.092346 
	C152.616486,482.104431 152.329330,481.816010 151.913147,481.245392 
	C152.311249,480.613739 152.838364,480.264252 153.690674,479.945740 
	C154.015839,479.976685 154.230804,480.413239 154.072906,480.598358 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M156.996765,483.995392 
	C156.739304,484.275787 156.484665,484.560303 155.968933,484.974792 
	C155.359940,485.086609 155.103760,484.923950 154.890717,484.384521 
	C154.842133,484.152283 154.943420,484.054321 154.992950,484.004211 
	C155.439682,483.623962 155.896881,483.502197 156.704773,483.782349 
	C157.003372,484.003326 156.999573,483.999512 156.996765,483.995392 
z"/>
<path fill="#071A2D" opacity="1.000000" stroke="none" 
	d="
M171.546982,498.006622 
	C171.543335,498.310059 171.084991,498.621368 170.333252,498.967529 
	C169.858521,498.908600 169.677185,498.814789 169.383026,498.436523 
	C169.877548,498.106201 170.484909,498.060333 171.546982,498.006622 
z"/>
<path fill="#050E18" opacity="1.000000" stroke="none" 
	d="
M72.914505,351.429443 
	C73.143906,350.227386 73.461357,349.421844 73.913925,348.311890 
	C74.305214,347.721466 74.430336,347.384064 74.398888,346.725189 
	C74.387680,346.263519 74.420609,346.079254 74.536926,345.627991 
	C74.740204,345.009338 74.859245,344.657410 75.056152,344.037842 
	C75.196053,343.594971 75.257347,343.419464 75.428688,342.988281 
	C75.698677,342.399841 75.859512,342.067444 76.128983,341.481476 
	C76.308487,341.058228 76.380157,340.888977 76.554245,340.464355 
	C76.783104,339.864105 76.903641,339.517181 77.093857,338.900635 
	C77.226707,338.456543 77.283958,338.280029 77.434280,337.842194 
	C77.702850,337.058807 77.844292,336.529510 77.849564,335.699066 
	C77.767334,334.873383 77.653313,334.338745 77.127380,333.677612 
	C75.121269,332.661835 73.055031,333.581665 71.010284,332.403168 
	C70.130760,331.432831 69.994209,330.536499 70.083794,329.258484 
	C70.287788,328.504578 70.500587,328.124786 71.064804,327.633301 
	C71.661308,327.255280 71.963989,327.005493 72.353210,326.469177 
	C72.588982,326.095520 72.697807,325.960938 73.195747,325.368927 
	C73.584854,324.911499 73.480988,325.393738 73.244644,325.481262 
	C72.723137,325.786346 72.512848,326.063690 72.211090,326.634216 
	C71.910141,327.011383 71.754814,327.138580 71.307831,327.373688 
	C70.566864,327.532532 70.161865,327.411621 69.589447,326.878662 
	C69.118721,325.905975 69.062607,325.192688 69.175232,324.093689 
	C70.633247,320.327026 68.940224,316.566376 70.736427,312.870575 
	C71.241119,312.412415 71.482574,312.270020 72.128769,311.990234 
	C74.589897,311.515259 76.627228,311.432373 78.952805,312.568085 
	C81.345505,316.388062 80.170364,320.295258 80.552750,324.461426 
	C80.631790,325.717255 80.535721,326.561493 80.905396,327.774597 
	C81.230377,329.261566 81.318169,330.361725 81.403343,331.873993 
	C81.269302,336.367981 82.744011,340.314240 82.438644,344.804016 
	C82.352257,347.002197 82.804695,348.728394 83.310608,350.829224 
	C83.539452,351.691711 83.662216,352.187988 83.870682,353.063538 
	C84.202637,354.749023 84.252167,356.045654 83.497597,357.623260 
	C80.960411,358.321320 77.218102,356.700684 78.472542,361.813660 
	C78.824165,363.246887 76.853951,362.815887 75.475273,363.024780 
	C74.402504,359.297729 73.702530,355.561829 72.914505,351.429443 
z"/>
<path fill="#46E7FA" opacity="1.000000" stroke="none" 
	d="
M82.216309,352.184753 
	C82.787155,350.102020 80.440659,348.615356 81.519905,346.366791 
	C83.674438,344.267761 85.109596,345.756470 86.884850,347.017639 
	C87.490608,347.530396 87.801361,347.855255 88.268082,348.478912 
	C88.725395,349.338348 88.844986,349.955872 88.773804,350.890411 
	C88.670723,351.659332 87.881416,351.912140 88.426399,352.781464 
	C88.614220,353.194672 88.679176,353.365692 88.813492,353.803406 
	C88.951347,354.432556 89.015312,354.795715 89.140724,355.430115 
	C89.310455,356.061768 89.423058,356.420227 89.641808,357.049438 
	C89.793030,357.510986 89.845306,357.699524 89.952881,358.178223 
	C90.129280,359.449341 90.192978,360.440216 90.609184,361.678131 
	C90.819038,362.368591 90.912666,362.772308 91.032860,363.494202 
	C91.103745,364.018311 91.125961,364.229309 91.174942,364.757874 
	C91.238846,365.501678 91.281410,365.927399 91.382401,366.674988 
	C91.600861,367.874542 91.736259,368.750824 91.087311,369.821045 
	C89.535355,370.022888 88.243614,370.012939 86.564423,370.004395 
	C85.352386,366.186981 84.527809,362.368164 83.481270,358.243408 
	C83.120239,356.534363 82.981155,355.131317 82.683167,353.335541 
	C82.492935,352.753967 82.461624,352.565125 82.216309,352.184753 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M107.136444,415.801697 
	C105.371620,416.107239 103.788574,415.597107 102.147446,416.882263 
	C98.393631,411.426605 96.567833,404.949829 94.091690,398.374451 
	C95.717911,398.004822 97.349060,398.007538 99.387619,398.015747 
	C102.787666,399.777405 102.827217,403.235718 104.455521,406.178528 
	C104.935265,407.345276 105.162186,408.232147 105.628418,409.391876 
	C106.037453,410.319702 106.304764,410.941711 106.767586,411.854065 
	C107.381554,413.250275 107.822525,414.340332 107.136444,415.801697 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M90.926422,370.303772 
	C90.663254,369.204773 90.499413,368.376740 90.304611,367.228638 
	C92.591988,364.506989 95.953972,364.770874 98.758064,363.603943 
	C100.694275,362.798126 102.791840,362.344940 104.660316,360.574554 
	C110.850021,357.426971 117.006615,358.235901 123.555191,359.062622 
	C125.493500,359.584076 127.141731,359.817810 128.537689,361.442383 
	C129.182465,362.856995 129.190628,363.960175 129.016632,365.489227 
	C128.633347,367.269836 128.268921,368.621368 127.293243,370.180664 
	C123.275787,373.080017 118.698914,371.986420 114.243347,373.344086 
	C109.484009,373.404785 105.152809,373.344727 100.438744,373.461304 
	C98.764397,370.306305 101.186195,370.004883 102.948723,369.525177 
	C106.736282,368.494263 110.668587,368.238068 114.891571,367.661224 
	C115.622307,367.502655 116.159920,367.851776 116.399391,367.264801 
	C115.912544,367.258545 115.425964,367.267059 114.589256,367.310333 
	C106.642174,366.602356 100.011780,370.002197 92.734657,372.344025 
	C92.093727,372.385254 91.835533,372.357178 91.332977,372.025665 
	C91.067665,371.339752 91.046715,370.957245 90.926422,370.303772 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M93.384979,380.278381 
	C93.143585,379.535187 93.131317,378.926147 93.267487,377.884216 
	C93.853668,377.321136 94.299408,377.273773 95.083405,377.399170 
	C97.041443,378.191162 98.710732,378.780884 100.788330,379.203857 
	C103.575310,380.417725 105.982239,381.648041 108.638840,383.116150 
	C109.425003,383.698975 109.870026,384.170593 110.617790,384.762512 
	C111.968163,385.593170 113.080093,385.907776 114.498367,384.901123 
	C117.115295,382.446777 119.476646,380.186096 123.417572,380.556519 
	C123.320305,383.805176 122.511559,386.915070 124.122452,390.099854 
	C121.949173,390.609833 120.051643,389.537720 118.315453,390.096802 
	C119.835106,389.747009 121.508667,390.255035 123.522087,390.616699 
	C124.678307,391.004089 125.366165,391.591583 126.495483,392.065369 
	C127.002289,392.320953 127.202034,392.433258 127.684601,392.747070 
	C129.807739,394.521729 131.174744,396.417053 132.010376,399.093079 
	C132.356171,401.149261 132.942200,402.826813 132.334167,404.908691 
	C131.518890,405.694550 130.811951,405.837738 129.706299,405.659363 
	C129.230072,405.459778 129.096802,405.363159 128.964340,405.265411 
	C127.648140,404.294098 128.920776,401.313812 126.663475,401.513763 
	C124.729530,401.685089 125.505211,404.315674 124.335876,405.877655 
	C122.301933,406.547302 121.418251,405.452148 120.646439,403.717102 
	C121.038551,401.515472 121.528839,399.668671 121.916504,397.798218 
	C120.776421,397.854767 120.376526,398.762573 119.822708,399.946198 
	C119.593697,400.458557 119.483498,400.656433 119.107147,401.068848 
	C117.881699,401.489349 117.046379,401.155243 115.981033,400.473663 
	C115.160156,399.570221 114.879089,398.723602 114.249741,397.704529 
	C112.510307,395.636871 111.144295,393.681763 109.352898,391.645813 
	C105.066422,387.391205 99.971245,384.808502 95.161949,381.253845 
	C94.897018,381.039856 94.977249,381.021851 94.981758,381.062714 
	C94.642395,380.647827 94.147110,380.492737 93.384979,380.278381 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M109.662521,390.935547 
	C111.600449,392.788208 113.191460,394.587646 114.953995,396.672119 
	C114.297050,400.369965 111.253799,399.866333 108.470261,400.459290 
	C105.817978,398.790497 103.007256,398.564178 100.242920,397.244324 
	C98.577057,393.282959 97.198143,389.557129 95.816666,385.442383 
	C98.705696,383.394592 100.745911,385.486450 102.730949,386.884186 
	C104.848679,388.375305 106.920975,389.874176 109.662521,390.935547 
z"/>
<path fill="#0D1D30" opacity="1.000000" stroke="none" 
	d="
M99.918304,397.262299 
	C102.779747,397.225250 105.991882,396.113892 108.026314,399.712402 
	C109.997894,401.151978 112.077408,401.942566 113.480438,404.200684 
	C113.626663,405.096985 113.518089,405.599640 112.983437,406.354126 
	C110.143906,407.814636 107.553596,408.678375 104.353714,407.541992 
	C102.696304,404.452911 101.397705,401.571686 99.947067,398.355896 
	C99.823586,397.852783 99.852119,397.684296 99.918304,397.262299 
z"/>
<path fill="#08101D" opacity="1.000000" stroke="none" 
	d="
M95.835052,377.905273 
	C95.004601,377.777344 94.550285,377.695923 93.755943,377.532898 
	C93.264275,377.131989 93.112633,376.812683 92.824249,376.263550 
	C92.445633,375.498810 92.393852,374.945923 92.753601,374.010101 
	C94.977226,372.383911 97.087379,371.719482 99.826225,372.662720 
	C104.397354,371.367981 108.740433,372.076874 113.489830,372.048004 
	C114.100410,372.268494 114.255928,372.476318 114.394684,373.072845 
	C113.174301,375.583038 111.046349,375.253937 109.150620,375.320587 
	C105.198708,375.459442 101.385246,376.231079 97.292320,377.598999 
	C96.694366,377.803864 96.452774,377.877838 95.835052,377.905273 
z"/>
<path fill="#071A2D" opacity="1.000000" stroke="none" 
	d="
M109.823303,390.712494 
	C107.589165,392.239624 105.700951,390.982025 104.087372,389.469543 
	C101.886711,387.406677 99.434135,385.904724 96.186295,385.055786 
	C95.342171,383.911713 94.870239,382.770020 94.647659,381.334106 
	C100.888603,382.480591 105.221825,386.522827 109.823303,390.712494 
z"/>
<path fill="#46E7FA" opacity="1.000000" stroke="none" 
	d="
M92.721603,373.804291 
	C92.676804,374.519867 92.706665,374.952179 92.712021,375.709106 
	C90.603668,375.566742 91.066689,373.909393 91.058968,372.104065 
	C91.088615,371.722260 91.474312,371.938507 91.661636,372.055908 
	C92.466171,372.410675 92.705070,372.913940 92.721603,373.804291 
z"/>
<path fill="#071A2D" opacity="1.000000" stroke="none" 
	d="
M93.258362,380.462982 
	C93.720718,380.269928 94.285576,380.395630 94.918350,380.812469 
	C94.255455,381.950867 93.885162,380.977386 93.258362,380.462982 
z"/>
<path fill="#0ABEFA" opacity="1.000000" stroke="none" 
	d="
M223.212341,536.278809 
	C218.532837,533.679626 214.115356,531.220703 209.483490,528.532593 
	C208.896011,526.852600 208.618927,525.399292 209.317413,523.596069 
	C209.646530,523.095947 209.816116,522.925049 210.332611,522.668640 
	C212.259705,522.767517 213.637650,523.820679 215.641022,523.631348 
	C216.920853,523.518250 217.815277,523.229309 219.085602,522.948364 
	C221.657471,522.586914 223.917465,522.690430 226.465302,521.998840 
	C227.596344,521.782227 228.363052,521.733459 229.516632,521.671631 
	C231.737122,521.755615 233.490906,521.221008 235.680969,520.961548 
	C239.539963,521.713379 241.970184,523.535522 242.444504,527.620300 
	C238.984756,530.169495 234.797272,530.179443 231.087982,532.393555 
	C230.174667,532.852112 230.784592,532.252991 230.326248,532.706604 
	C227.415863,535.587097 225.233627,534.576050 223.168213,531.516602 
	C222.947617,531.536133 222.720749,531.881226 222.823181,532.079102 
	C222.925629,532.276978 223.235046,532.644165 223.390930,532.846375 
	C223.636978,533.202393 223.727127,533.356201 223.932343,533.760864 
	C224.254990,534.553467 224.369949,535.109985 224.174377,535.954041 
	C223.846420,536.282837 223.660385,536.351013 223.212341,536.278809 
z"/>
<path fill="#BEDBE2" opacity="1.000000" stroke="none" 
	d="
M261.325287,555.629761 
	C249.259567,553.712463 238.048645,549.750366 226.760773,544.877319 
	C225.751511,544.693115 225.114151,544.496155 224.296967,544.032104 
	C224.121552,543.748108 224.168198,543.722412 224.170044,543.695679 
	C222.561859,542.746460 220.951843,541.823975 219.139496,540.670166 
	C218.957230,539.897827 218.977280,539.356750 219.003540,538.410278 
	C219.443512,538.012390 219.877258,538.019958 220.636322,538.037842 
	C223.508392,538.669556 225.729156,540.095337 228.174393,540.971191 
	C229.703445,541.518921 231.208481,542.347229 233.016418,540.748047 
	C239.482880,540.588257 244.412750,544.507141 250.508316,545.919128 
	C252.706192,546.753113 254.596985,547.344971 256.801453,548.189087 
	C258.470428,549.152344 259.930511,549.725159 261.402771,551.012329 
	C262.234894,552.673645 262.230011,554.004150 261.325287,555.629761 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M190.355865,515.096375 
	C187.100800,512.962769 184.234131,510.848969 181.224579,508.443939 
	C182.958618,506.040283 185.508896,506.683472 188.298187,506.525452 
	C190.475479,506.603027 192.230148,506.444855 194.294189,507.205261 
	C195.055191,507.700226 195.405533,508.044800 195.556091,508.541534 
	C196.177231,508.274658 194.460739,511.855438 196.770630,509.217255 
	C197.816696,508.022461 199.184784,509.498962 200.047668,510.481018 
	C200.898193,511.449066 202.472733,512.516541 201.876785,513.761536 
	C200.967438,515.661194 198.749527,515.207397 196.573227,515.362305 
	C194.365982,515.366882 192.542206,515.515076 190.355865,515.096375 
z"/>
<path fill="#0DA5E9" opacity="1.000000" stroke="none" 
	d="
M189.268494,507.722961 
	C186.657196,508.003571 184.307083,508.031708 181.519318,508.106262 
	C179.085403,507.530121 177.694458,506.028656 175.985001,504.463501 
	C176.145493,503.969055 176.468170,503.765289 176.967407,503.336304 
	C178.438232,502.952515 179.538315,504.473969 181.114197,503.276917 
	C181.418884,502.221161 181.886032,501.694458 182.887375,501.189758 
	C184.988068,500.763000 186.584457,499.947266 188.232483,499.342438 
	C190.663925,498.450043 192.281937,498.973816 193.481277,501.636108 
	C193.985077,505.101624 191.419357,506.035217 189.268494,507.722961 
z"/>
<path fill="#0D1D30" opacity="1.000000" stroke="none" 
	d="
M190.131119,515.367554 
	C191.417786,513.318665 193.423569,514.245056 195.594421,513.999512 
	C199.083435,516.135559 202.669891,516.627441 206.588837,517.312744 
	C207.592072,517.901672 208.058365,518.484497 208.301376,519.622681 
	C206.810547,522.536133 203.986710,522.331177 201.337158,523.120605 
	C197.017044,521.140320 193.757217,518.252380 190.131119,515.367554 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M232.940277,540.686035 
	C232.864578,542.399475 233.221481,544.451233 230.760132,543.306030 
	C227.576065,541.824585 223.927856,541.261780 221.131943,538.347961 
	C221.540192,537.579773 222.118729,537.111328 222.823792,536.390686 
	C223.125458,536.132202 223.300598,536.125854 223.729950,536.186340 
	C226.480301,535.502563 228.376694,537.048828 230.745087,538.112183 
	C231.826660,538.819153 232.470322,539.475586 232.940277,540.686035 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M201.153000,523.303833 
	C202.406311,520.567993 205.246048,521.391541 207.592865,520.146240 
	C209.188675,520.260803 209.664780,521.176514 209.765015,522.664429 
	C209.998962,524.559082 210.413940,526.129761 209.545929,528.015015 
	C206.623138,526.733154 203.977173,525.162842 201.153000,523.303833 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M221.715179,544.803894 
	C222.413361,545.311340 222.778488,545.762390 223.173203,546.511963 
	C221.598389,545.987854 219.993988,545.165161 218.308731,544.009399 
	C219.279297,544.033447 220.330704,544.390503 221.715179,544.803894 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M218.019043,543.421082 
	C217.578003,543.572510 216.971313,543.472839 216.251404,543.063965 
	C216.709900,542.893127 217.281647,543.031555 218.019043,543.421082 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M508.682037,177.934235 
	C509.841614,180.897781 511.860107,183.018738 513.786194,185.550293 
	C517.070679,191.282120 520.106628,196.814835 523.374512,202.647736 
	C525.187561,206.168213 526.768616,209.388519 528.603149,212.835388 
	C532.694458,222.314163 536.532410,231.566376 540.609253,241.112167 
	C542.958374,249.130219 545.068542,256.854675 547.319885,264.917633 
	C548.873901,273.584106 550.286743,281.912079 551.799927,290.628601 
	C552.277954,297.699738 552.655640,304.382355 553.084961,311.523315 
	C553.058350,315.968933 552.296875,320.099396 553.093811,323.903351 
	C553.894653,327.725616 549.294006,330.060059 551.665649,334.440613 
	C553.448242,337.733032 551.611938,342.234314 551.144348,346.600372 
	C551.115784,347.459534 551.039978,347.895569 550.901489,348.657867 
	C548.932434,350.407227 547.800964,349.293488 546.853882,347.730530 
	C545.993530,346.310822 545.541077,344.685089 544.440125,342.992676 
	C540.914062,341.734375 539.468750,339.575256 539.581909,336.090027 
	C539.710754,332.117981 539.532959,328.134613 539.627014,324.158722 
	C539.766663,318.253021 540.507141,317.551056 546.297913,317.445740 
	C543.526489,317.210632 536.804382,311.574005 536.426208,309.035339 
	C536.100769,306.850769 537.289734,305.582916 539.342957,305.136444 
	C540.889954,304.800049 542.548950,305.246246 544.320923,304.381927 
	C541.858948,305.365509 539.505310,304.712616 536.902100,305.256714 
	C536.028992,305.227417 535.539856,305.134552 534.723511,304.830109 
	C532.031189,302.141449 534.473694,300.304626 535.460571,297.924438 
	C535.688477,297.406281 535.776489,297.199646 536.024292,296.704346 
	C536.315125,296.245453 536.446228,296.075226 536.825317,295.714142 
	C537.514465,295.079407 539.185730,295.483276 538.023315,293.692627 
	C537.261719,289.171478 536.273010,285.010315 535.999146,280.388306 
	C536.102295,279.803680 536.165588,279.574982 536.380615,279.030823 
	C536.669434,278.532806 536.806580,278.350250 537.188904,277.937073 
	C538.120239,277.138031 538.980896,277.022339 540.074890,276.704468 
	C540.716980,276.564453 541.078430,276.493500 541.633545,276.238892 
	C541.607544,276.031769 541.672180,276.284973 541.273071,276.413513 
	C540.789551,276.494141 540.586914,276.508606 540.067017,276.540466 
	C539.299255,276.479187 538.927795,276.257843 538.475220,275.605591 
	C538.459229,270.564819 541.806824,273.174835 543.639465,272.401215 
	C543.328979,272.099731 542.537598,272.538422 541.883972,272.472900 
	C532.728577,271.554871 531.328369,269.937103 532.367004,260.317108 
	C532.536133,258.750732 532.122986,258.293640 530.816772,257.452698 
	C527.996887,251.526108 528.182678,245.193863 526.266846,239.024200 
	C527.860962,236.626968 529.048340,238.931152 530.071106,238.601166 
	C528.926453,238.043930 527.418274,237.286560 525.228882,237.943771 
	C524.586914,237.883591 524.329834,237.830826 523.700806,237.630676 
	C519.592590,234.911789 519.430359,231.185852 520.158630,226.860229 
	C520.580627,226.083740 520.941833,225.771942 521.725830,225.570084 
	C522.336304,225.483566 522.709106,225.753693 522.824463,225.695862 
	C523.201233,225.506989 523.100220,225.373428 522.347290,225.501251 
	C520.742981,225.548157 519.368713,226.028534 517.950684,224.716415 
	C516.813965,223.228882 516.655945,221.714142 516.151001,220.331558 
	C515.115967,217.497238 513.378235,215.897293 509.790161,216.715759 
	C508.906769,216.693680 508.428955,216.540787 507.745239,215.972595 
	C506.868500,211.321762 510.075470,211.969711 512.971863,211.775024 
	C514.029236,211.844757 514.544983,212.540131 515.100830,212.275116 
	C514.904114,212.228653 514.589417,211.861374 514.517090,211.598495 
	C514.426025,211.140320 514.407349,210.945007 514.384644,210.443481 
	C514.345093,208.155151 512.668762,207.439865 511.455780,206.378952 
	C510.455566,205.504105 508.701630,204.444122 508.979004,203.463959 
	C509.937164,200.078629 506.958099,199.897018 505.404633,198.146393 
	C505.302490,196.555405 505.719757,195.618423 507.150330,195.606613 
	C507.411499,195.604446 507.560760,195.931152 507.469177,195.613922 
	C506.645569,195.183990 505.701050,195.918991 504.396851,196.074280 
	C503.558899,196.061005 503.092255,195.961853 502.320496,195.640564 
	C499.208435,191.556351 497.305603,187.121140 494.796051,183.035873 
	C493.946594,181.653015 493.612152,179.841248 491.140167,179.752121 
	C490.571106,179.629272 490.348328,179.556488 489.830322,179.291656 
	C487.324219,176.364960 485.747192,173.233673 484.034790,170.194244 
	C482.678345,167.786575 482.437225,165.448395 485.502533,163.710327 
	C483.453552,162.914032 481.620789,163.504486 479.535522,163.094711 
	C478.966980,162.965363 478.744995,162.894653 478.215027,162.662521 
	C476.297607,161.055588 475.223572,159.290894 475.062592,157.118134 
	C474.942474,155.497543 474.492950,154.297501 472.326965,154.046692 
	C471.777069,153.891205 471.561432,153.811890 471.047546,153.557709 
	C467.344452,150.880692 467.023865,146.289429 463.709839,143.456329 
	C462.430084,143.367050 461.492096,143.310272 460.183838,143.323730 
	C458.041687,143.296661 456.325928,143.011230 454.422089,141.980469 
	C451.792297,139.381592 448.618378,138.340225 445.868530,136.622528 
	C444.019379,135.467422 442.776611,133.759628 441.502441,131.645599 
	C441.165833,131.211456 441.016357,131.051819 440.639282,130.661621 
	C439.178711,128.907257 437.281128,129.317245 435.381104,128.685333 
	C434.871704,128.430710 434.679626,128.301895 434.239624,127.925369 
	C427.963837,120.075691 420.790497,114.272430 410.730255,113.191566 
	C407.417328,112.835625 407.167084,110.434586 406.438690,107.957855 
	C405.781586,105.723618 406.984039,102.169289 402.574890,101.941803 
	C399.077332,102.933258 396.197754,104.414391 393.190552,106.453461 
	C391.967255,107.025162 391.023712,107.085167 389.724976,106.790771 
	C387.002869,105.332909 387.049835,101.981781 384.239502,100.682007 
	C383.770874,100.622681 383.582031,100.628159 382.876770,100.882004 
	C381.892883,101.533897 381.447571,101.962708 380.680878,102.524559 
	C379.975372,102.874527 379.540955,103.003220 378.749756,103.139374 
	C372.932251,102.562332 367.707306,101.003807 362.728088,98.716789 
	C360.567657,97.724480 357.254852,96.937210 357.771118,93.962692 
	C358.337830,90.697487 361.809113,92.222343 364.020508,91.610657 
	C360.369843,91.178055 358.089905,86.777878 353.442352,88.172455 
	C349.451843,89.627151 345.658661,90.326096 341.459106,91.019791 
	C340.285492,91.200340 339.498352,91.192955 338.326630,91.057739 
	C335.391663,89.733490 332.720673,89.120728 329.850739,89.317093 
	C327.024445,89.510490 324.151764,89.283745 321.596008,88.130646 
	C318.305481,86.646027 315.295197,85.842651 311.755646,87.591270 
	C309.577576,88.667282 307.337341,86.701523 305.062439,86.506638 
	C302.294098,86.269478 299.584991,85.149582 296.442444,86.107635 
	C295.385986,86.882759 294.640503,87.477470 293.603943,88.283539 
	C292.708466,88.893303 292.062592,89.216293 291.080231,89.682297 
	C289.362793,90.341560 287.967438,90.815849 286.126343,91.092331 
	C282.785156,91.130844 280.976166,89.450554 279.562134,86.625336 
	C279.067047,84.950851 279.395569,83.726448 280.071411,82.185020 
	C281.078888,80.612434 281.688477,79.239960 282.800232,77.739929 
	C284.416412,76.660042 285.950775,76.422707 287.811615,75.938568 
	C289.749786,75.626068 291.320068,75.653572 293.276947,75.598114 
	C294.183746,75.601387 294.700226,75.611420 295.599792,75.593544 
	C298.461060,75.780136 300.985565,74.349632 303.709167,76.006691 
	C304.863586,77.008560 304.639618,78.154060 304.924164,79.149200 
	C306.024048,78.689590 306.551758,77.710388 307.486664,76.643822 
	C308.500366,75.745377 309.338776,75.310326 310.700592,75.725716 
	C316.718018,76.262123 322.422485,76.602974 328.571228,76.885574 
	C340.831787,78.373718 352.632080,80.012894 364.613007,82.868980 
	C377.833130,86.077454 390.532959,89.670143 402.757111,94.835861 
	C412.069427,98.771103 421.218506,103.001511 430.301636,108.126343 
	C445.450531,117.611694 460.384399,126.885948 473.608398,139.100632 
	C482.948639,148.572678 492.789581,157.153473 500.647400,167.993439 
	C503.425354,171.364395 505.892059,174.594635 508.682037,177.934235 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M501.780945,166.070190 
	C501.920593,166.302856 501.744659,166.561981 501.258118,166.853149 
	C501.122772,166.626160 501.295410,166.363297 501.780945,166.070190 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M253.770264,75.512306 
	C257.453979,74.514824 260.844604,73.773537 264.627136,72.921127 
	C268.428619,72.296356 271.838165,71.782700 275.642822,71.332565 
	C278.149078,74.278671 275.700287,76.414673 274.594971,79.143723 
	C271.037445,82.300583 266.735992,81.757698 262.500305,82.890594 
	C261.055054,83.202332 259.985962,83.291695 258.518005,83.398735 
	C255.749268,83.560516 253.438522,84.602356 250.650574,83.718727 
	C248.050415,79.606850 252.095779,78.233086 253.770264,75.512306 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M304.359131,76.977814 
	C301.600128,76.671356 299.163391,76.750473 296.346375,76.784012 
	C295.536865,76.569557 295.093018,76.497696 294.324097,76.686073 
	C292.285248,76.980598 290.554657,77.126762 288.390259,77.242432 
	C286.632690,75.239090 288.236206,74.291725 289.427795,73.337143 
	C290.796173,72.240967 292.098846,71.070549 293.772095,69.791367 
	C300.063995,68.592072 306.101807,69.070633 312.580383,69.006462 
	C313.554108,71.518929 310.880066,72.884560 311.013428,75.553757 
	C310.177002,76.019707 309.340393,76.118141 308.198120,76.302383 
	C307.308105,78.313522 305.970642,77.759125 304.359131,76.977814 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M293.679382,69.496140 
	C294.078979,73.664780 289.114716,73.371666 288.005096,76.854767 
	C286.549103,77.491463 285.141693,77.770988 283.379517,78.138229 
	C282.162567,78.867249 281.270996,79.455322 279.837646,79.887138 
	C277.797607,80.327965 276.167816,80.406609 274.300262,79.344170 
	C273.391754,76.376938 276.483215,74.768440 276.031128,71.759094 
	C281.783630,70.723618 287.529297,70.051147 293.679382,69.496140 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M508.316589,453.881042 
	C504.316437,454.364624 500.652832,455.528870 496.405334,454.976807 
	C494.715973,453.612793 495.187683,452.183472 496.058624,450.989899 
	C497.975433,448.362854 498.199829,446.431641 494.509674,445.323639 
	C493.571198,445.041840 493.848267,444.017944 494.509277,443.013489 
	C496.766327,441.432983 500.049530,441.778564 500.564789,438.187744 
	C499.554260,437.067108 497.825165,438.368134 496.442749,437.123901 
	C494.963684,432.409973 495.007690,432.364410 502.110626,431.077789 
	C503.026367,430.991333 503.542725,431.018616 504.410583,431.216003 
	C508.583282,433.739166 505.874420,437.295654 506.313385,440.337982 
	C506.772095,439.644348 507.301208,439.090515 508.393738,438.727112 
	C511.068726,439.761108 513.525146,440.617706 515.669189,442.691010 
	C514.960205,444.443237 514.050598,445.904694 513.031006,447.674316 
	C511.474701,449.883942 510.028351,451.785431 508.316589,453.881042 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M535.170410,304.544067 
	C539.241516,303.587830 543.128052,304.513428 546.830933,303.059906 
	C545.207581,305.447083 542.903748,306.029968 540.332458,306.051819 
	C538.929504,306.063721 537.642090,306.397888 537.252136,307.990479 
	C536.850769,309.629242 538.333435,309.712921 539.222961,310.351318 
	C539.869507,310.815338 540.486145,311.513702 540.781006,312.243042 
	C542.437134,316.339142 545.523315,317.793884 550.061096,316.955963 
	C549.668823,317.546875 549.545654,317.894012 549.423279,317.893707 
	C540.772156,317.872559 540.927917,317.142609 540.989929,326.840607 
	C541.010071,329.995331 541.250793,333.176910 540.928345,336.298462 
	C540.534180,340.113556 541.917786,341.406769 545.781982,340.747345 
	C545.267151,342.097748 544.588562,343.246033 543.400330,343.928101 
	C541.531799,345.000671 541.156433,346.529694 541.716675,348.552307 
	C543.874634,356.343140 545.161255,364.296356 546.030090,372.694153 
	C546.371826,376.925751 544.761292,380.403870 543.738770,384.397461 
	C543.661011,384.774506 543.273987,384.880646 543.077393,384.920685 
	C542.627563,385.049286 542.374390,385.137848 541.789917,384.997162 
	C541.296875,384.553650 541.135254,384.339447 540.788940,383.768250 
	C538.871338,378.022583 538.593384,372.379547 537.955322,366.829041 
	C537.329346,361.383392 536.097107,356.112732 534.643921,350.475830 
	C534.337524,348.822418 534.578186,347.701355 535.958374,346.698730 
	C536.436218,346.244293 536.689880,346.153290 537.010925,346.295868 
	C536.785767,346.019623 536.546387,346.075806 535.984558,346.618469 
	C533.812195,347.905121 532.112122,349.826385 529.414795,347.690857 
	C527.794861,343.402588 529.214233,339.541199 529.563660,335.220917 
	C529.680115,330.567047 529.448914,326.333527 529.820923,321.728058 
	C530.442566,319.024017 533.186584,318.682220 534.191040,316.661469 
	C533.020935,315.984192 531.534546,317.127777 530.375183,315.582428 
	C529.549438,313.678253 529.622986,312.019409 529.613647,310.364807 
	C529.593872,306.856628 530.878967,304.579773 535.170410,304.544067 
z"/>
<path fill="#010610" opacity="1.000000" stroke="none" 
	d="
M546.395508,372.802856 
	C544.546631,372.348694 543.950562,371.098663 544.004578,369.451019 
	C544.213257,363.096191 542.860901,356.845703 540.786133,351.050598 
	C538.783630,345.457520 540.830750,343.125763 545.684814,341.144623 
	C546.662170,344.030762 546.638855,347.405151 550.478027,348.977722 
	C550.233643,353.041351 549.628418,357.098511 548.970825,361.561554 
	C548.177124,365.495026 547.435852,369.022614 546.395508,372.802856 
z"/>
<path fill="#063A70" opacity="1.000000" stroke="none" 
	d="
M516.106079,442.730286 
	C513.444458,442.262177 510.996490,441.589325 509.069092,439.379089 
	C508.062958,437.441223 508.310272,435.575043 509.093903,434.300018 
	C510.989227,431.216125 511.638062,427.670746 513.527283,424.298401 
	C515.065308,423.485291 516.139954,422.614288 517.540161,421.617737 
	C519.059448,420.912903 520.198486,420.350891 518.828857,418.466858 
	C518.642456,417.938721 518.609741,417.712341 518.665649,417.151733 
	C519.340759,415.841248 520.434875,415.182343 520.606323,413.543793 
	C520.776428,412.016144 520.976379,410.875275 521.636719,409.898132 
	C523.236145,407.531189 527.560181,406.110779 529.478821,407.504333 
	C532.002686,409.337524 531.282166,411.783112 530.331177,414.168121 
	C529.905212,415.236450 529.291992,416.220520 528.790710,417.661072 
	C528.218323,419.883026 525.657593,420.920593 526.697632,423.621765 
	C526.312561,425.079346 525.789246,426.240570 525.205444,427.716125 
	C522.210815,432.846527 519.276550,437.662689 516.106079,442.730286 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M552.120361,434.191040 
	C550.615906,433.084290 549.408142,432.191040 548.041138,431.000793 
	C548.616394,428.313263 550.399841,426.582886 551.916626,424.282806 
	C553.858887,424.062408 554.860962,425.242340 555.930237,426.838928 
	C556.375610,427.529846 556.473328,427.965759 556.175415,428.719971 
	C555.956116,428.994843 556.002319,429.002045 555.990479,428.981934 
	C555.568726,429.413269 555.494080,430.000458 555.144775,430.773712 
	C554.955261,430.994293 555.002808,431.001556 554.993164,430.979492 
	C554.776672,431.207397 554.555176,431.443573 554.138672,431.828796 
	C553.958313,431.991516 554.002319,432.002563 553.993286,431.981812 
	C553.569092,432.411743 553.494324,433.001404 553.145142,433.778931 
	C552.957031,434.002045 553.007202,434.003571 553.000488,433.979401 
	C552.801514,434.105011 552.609253,434.254791 552.120361,434.191040 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M528.146851,419.089325 
	C527.862122,416.927429 529.096680,415.413055 529.534790,413.678040 
	C530.020386,411.755432 531.340637,408.827423 528.356445,408.301575 
	C526.079407,407.900299 522.866333,408.262177 522.067688,411.696747 
	C521.884338,412.485291 522.031311,413.350586 522.019897,414.593323 
	C518.443604,415.985382 518.264709,413.250641 518.230652,411.124847 
	C518.180298,407.978516 519.792786,405.532318 522.966064,403.853210 
	C523.481384,403.566132 523.683655,403.454742 524.447632,402.996643 
	C525.180054,402.524475 525.350830,402.398987 525.995117,401.871307 
	C526.617371,401.328644 526.766174,401.188202 527.336792,400.604919 
	C527.887451,400.001740 528.016357,399.841400 528.482666,399.149475 
	C529.947510,396.474640 530.422913,394.020447 532.148743,391.797729 
	C534.538940,389.585144 536.029785,387.027527 538.396545,384.804626 
	C539.103271,384.449280 539.541138,384.357513 540.324829,384.425690 
	C541.251099,384.781830 541.689331,385.317627 542.582275,385.752258 
	C541.283691,390.388763 539.716736,394.836975 538.136841,399.654266 
	C535.536804,405.471649 532.949707,410.919922 530.343750,416.717163 
	C529.983154,417.537689 529.641357,418.009308 529.164001,418.737854 
	C528.820068,419.108765 528.611694,419.222748 528.146851,419.089325 
z"/>
<path fill="#0A5D87" opacity="1.000000" stroke="none" 
	d="
M517.258423,181.983246 
	C517.140015,181.704437 517.308105,181.399048 517.741089,181.033432 
	C517.852356,181.301025 517.698669,181.628845 517.258423,181.983246 
z"/>
<path fill="#0A5D87" opacity="1.000000" stroke="none" 
	d="
M516.256592,182.978409 
	C516.144653,182.710236 516.317505,182.410324 516.750244,182.041107 
	C516.853821,182.296753 516.697571,182.621719 516.256592,182.978409 
z"/>
<path fill="#0A5D87" opacity="1.000000" stroke="none" 
	d="
M515.277466,183.970642 
	C515.165039,183.720306 515.326843,183.415176 515.749268,183.040802 
	C515.857117,183.286331 515.704407,183.601074 515.277466,183.970642 
z"/>
<path fill="#021429" opacity="1.000000" stroke="none" 
	d="
M542.897400,385.696777 
	C542.338318,385.778412 541.826050,385.616302 541.318726,385.039368 
	C541.323608,384.624573 541.811951,384.628235 541.967041,384.816803 
	C542.122192,385.005371 542.501831,384.983002 542.691284,384.971863 
	C542.880737,384.960724 542.944214,385.453033 542.897400,385.696777 
z"/>
<path fill="#011B36" opacity="1.000000" stroke="none" 
	d="
M527.515381,418.889221 
	C528.079102,418.875397 528.267700,418.908905 528.742371,418.968597 
	C528.417480,420.441559 527.806458,421.888306 527.015625,423.626587 
	C523.681396,422.058655 523.891418,420.404785 527.515381,418.889221 
z"/>
<path fill="#033256" opacity="1.000000" stroke="none" 
	d="
M558.684631,424.074463 
	C559.168640,425.242859 559.005249,426.372467 557.323364,426.999207 
	C556.953369,425.815247 557.654541,424.993195 558.684631,424.074463 
z"/>
<path fill="#033256" opacity="1.000000" stroke="none" 
	d="
M559.743286,422.117401 
	C559.857483,422.559998 559.711975,423.168945 559.265808,423.891632 
	C559.137939,423.431488 559.310730,422.857635 559.743286,422.117401 
z"/>
<path fill="#033256" opacity="1.000000" stroke="none" 
	d="
M560.776855,420.142761 
	C560.847656,420.546906 560.687744,421.147888 560.241943,421.886078 
	C560.152710,421.462036 560.349426,420.900787 560.776855,420.142761 
z"/>
<path fill="#033256" opacity="1.000000" stroke="none" 
	d="
M556.266479,428.895935 
	C555.964417,428.582611 555.972656,428.170410 556.027466,427.451172 
	C556.074036,427.144196 556.530701,427.042725 556.761353,427.003937 
	C556.853577,427.575775 556.715149,428.186371 556.266479,428.895935 
z"/>
<path fill="#033256" opacity="1.000000" stroke="none" 
	d="
M561.769409,418.686066 
	C561.863647,418.897308 561.715942,419.320343 561.258606,419.884735 
	C561.141846,419.649994 561.334595,419.273956 561.769409,418.686066 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M308.358826,576.807251 
	C307.929779,576.567688 307.804932,576.343201 307.453796,576.050110 
	C307.095093,575.747314 306.901703,575.547119 306.932709,574.993164 
	C308.195251,573.983459 309.257965,573.961731 310.677002,574.770081 
	C311.564209,575.185547 312.117401,575.346863 312.872009,575.721680 
	C311.623596,576.219604 310.173828,576.503967 308.358826,576.807251 
z"/>
<path fill="#040E11" opacity="1.000000" stroke="none" 
	d="
M301.079468,569.392456 
	C297.142090,568.583801 293.654877,567.440308 290.346130,565.353882 
	C290.320740,565.012634 290.538483,565.085144 290.650757,565.085938 
	C294.572906,565.380981 298.382721,565.675293 302.625183,565.882751 
	C307.553497,565.876038 311.929504,566.661804 316.586182,568.157837 
	C316.476898,571.172119 313.759552,569.274353 312.197266,570.640869 
	C311.036255,572.034607 309.847809,571.535522 308.388641,571.401428 
	C306.719360,571.235840 305.382538,571.187744 303.718445,571.058594 
	C303.174133,570.962158 302.959839,570.906860 302.444550,570.712769 
	C301.777344,570.315613 301.510040,569.981262 301.079468,569.392456 
z"/>
<path fill="#1E2B39" opacity="1.000000" stroke="none" 
	d="
M307.676697,570.425537 
	C309.021912,570.388428 310.139984,570.613037 311.601440,570.862244 
	C311.652161,572.029541 311.359436,573.172241 311.038879,574.669617 
	C309.962524,575.028381 308.914062,575.032471 307.473389,575.062988 
	C306.711517,574.782837 306.482697,574.390625 306.366394,573.575073 
	C306.510895,572.287781 306.848206,571.430786 307.676697,570.425537 
z"/>
<path fill="#18DBFB" opacity="1.000000" stroke="none" 
	d="
M314.190796,537.677734 
	C313.540771,537.996277 313.105499,537.997742 312.343811,537.999634 
	C309.954559,538.859802 304.850830,536.610107 307.568665,542.693115 
	C306.956818,545.392334 303.872345,545.568726 303.123413,548.242554 
	C301.551453,550.995361 301.562317,554.044128 299.476654,556.566650 
	C298.916809,557.022583 298.600891,557.220459 298.123901,557.648193 
	C293.473663,559.464844 289.126801,559.010010 284.724579,556.601562 
	C284.558990,555.978760 284.559418,555.721375 284.724121,555.126953 
	C286.241333,553.676575 288.322388,553.468445 289.108368,551.183777 
	C290.001465,546.524658 289.599304,541.745483 294.016602,538.477661 
	C295.632385,537.627441 295.685089,536.483582 295.359985,534.886475 
	C295.347565,533.835022 295.590057,533.196350 296.310913,532.380615 
	C297.201935,531.678467 297.887878,531.362305 298.983765,531.016296 
	C301.718414,530.537476 304.025055,530.786194 306.673401,531.579529 
	C307.564941,531.753601 308.060791,531.901123 308.896423,532.251648 
	C311.088531,533.934326 314.419952,533.905823 314.190796,537.677734 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M284.531311,554.950317 
	C285.739380,557.671082 287.990784,556.765808 289.833130,557.003784 
	C292.266296,557.317871 294.703674,557.599548 297.551025,557.886597 
	C298.498657,559.338562 300.175720,560.245117 300.008392,562.392761 
	C299.547302,562.743347 299.068878,562.756592 298.242981,562.675537 
	C297.700226,562.557678 297.504974,562.534302 297.015106,562.500244 
	C296.132294,562.486877 295.544037,562.480286 294.677429,562.595215 
	C294.168915,562.582703 293.938934,562.478088 293.331787,562.413818 
	C285.539062,561.133240 278.123535,559.812378 270.396423,558.261963 
	C268.981750,556.932617 268.770905,555.613281 269.291931,553.773132 
	C269.768036,552.944458 270.167114,552.593384 271.024231,552.226196 
	C272.893219,551.831177 274.305511,552.367432 276.095154,552.630615 
	C276.883240,552.728027 277.327728,552.788025 278.090851,552.906982 
	C279.239838,553.111816 280.020020,553.414551 281.059448,553.875061 
	C281.493561,554.104614 281.658295,554.207031 282.026245,554.500793 
	C282.332397,555.178162 282.523956,555.128052 283.020996,554.657776 
	C283.664246,554.480591 284.034454,554.540588 284.531311,554.950317 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M309.229370,556.542236 
	C307.569733,556.854919 306.224365,556.902588 304.480957,556.879517 
	C303.357880,556.168213 303.110962,555.307495 302.966187,554.053223 
	C302.985992,553.481262 303.012299,553.252747 303.120453,552.688110 
	C303.423157,551.687500 303.737274,551.065369 304.248108,550.141113 
	C304.581757,549.641846 304.732880,549.451294 305.153320,549.007324 
	C306.941986,547.779541 308.457214,546.779785 310.548340,548.290833 
	C311.546356,551.362915 311.769531,554.016418 309.229370,556.542236 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M309.278595,556.902222 
	C310.043884,554.281006 310.224121,551.623230 309.965668,548.494751 
	C310.087524,547.933044 310.254089,547.787354 310.742981,547.564453 
	C312.579437,547.584839 314.104492,547.047241 315.858734,547.779419 
	C316.082031,551.140747 312.932068,552.998413 312.674622,556.441162 
	C311.602570,556.862305 310.622314,556.929749 309.278595,556.902222 
z"/>
<path fill="#2A3743" opacity="1.000000" stroke="none" 
	d="
M304.145447,551.943359 
	C303.983368,552.205444 303.991058,552.491943 303.999329,552.635010 
	C303.420074,553.659790 303.154816,554.721069 302.215759,555.742859 
	C301.246582,556.200195 300.527161,556.460693 299.520233,556.772949 
	C299.808319,554.094971 300.357544,551.356567 301.996185,548.620483 
	C303.705109,546.839966 304.797272,547.087463 305.206543,549.583008 
	C305.007477,549.993347 304.993134,549.994568 304.986633,549.998169 
	C304.502777,550.460205 304.495575,551.106934 304.145447,551.943359 
z"/>
<path fill="#32627C" opacity="1.000000" stroke="none" 
	d="
M302.233582,556.067444 
	C301.953949,554.740173 302.550751,553.862610 303.726257,552.960144 
	C304.022308,553.855652 304.037079,554.933289 304.067383,556.409851 
	C303.555664,556.604309 303.028381,556.399780 302.233582,556.067444 
z"/>
<path fill="#1B2027" opacity="1.000000" stroke="none" 
	d="
M294.630737,562.753357 
	C294.891388,562.647278 295.383881,562.607361 296.111389,562.467163 
	C296.563782,562.331055 296.781189,562.295288 296.920349,562.580566 
	C296.182312,562.874268 295.522430,562.846863 294.630737,562.753357 
z"/>
<path fill="#62E4F9" opacity="1.000000" stroke="none" 
	d="
M297.105743,562.822327 
	C296.842163,562.901672 296.561981,562.663086 296.454163,562.514954 
	C296.709717,562.334412 297.073059,562.302002 297.665955,562.425354 
	C297.720123,562.635071 297.544708,562.689026 297.105743,562.822327 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M121.021896,169.321381 
	C121.323639,168.899628 121.583862,168.711639 121.890244,168.217850 
	C122.485825,167.738693 122.972130,167.477997 123.719978,167.128967 
	C124.268211,167.954910 124.508331,169.349976 125.771843,168.062851 
	C126.906517,166.906982 127.720238,165.416687 128.583954,164.017380 
	C133.315826,156.351181 140.256897,151.459900 148.274719,147.672424 
	C152.291794,145.774826 154.177200,141.042130 158.655502,139.036057 
	C159.460770,138.826614 159.857727,138.909149 160.267029,139.622803 
	C159.410309,143.293686 156.974121,145.607147 154.507477,148.265381 
	C154.089539,148.575821 153.920959,148.692398 153.265274,149.141785 
	C152.628479,149.592880 152.478790,149.711197 151.945648,150.244965 
	C151.247345,151.152069 151.006607,151.679153 150.696945,152.519836 
	C150.097443,153.811615 149.338226,154.579483 148.248978,155.487793 
	C147.677765,155.978714 147.365402,156.271515 146.864532,156.827118 
	C145.739777,158.263748 144.756302,159.390427 143.217316,160.375458 
	C142.599579,160.691513 142.239517,160.838791 141.621735,161.064697 
	C141.214600,161.234283 141.056763,161.304352 140.677826,161.492493 
	C140.456711,161.610565 140.051651,161.883957 139.707657,162.212524 
	C139.169067,162.791397 138.997620,163.056656 138.742767,163.554611 
	C138.636261,163.772354 138.394211,164.198013 138.250336,164.398193 
	C138.106461,164.598373 137.789093,164.978821 137.453613,165.346634 
	C137.004654,165.836700 136.891144,165.958954 136.438507,166.453796 
	C135.988556,166.954849 135.877716,167.083328 135.609283,167.413422 
	C135.252884,167.899490 135.059464,168.187576 134.726196,168.706085 
	C134.471405,169.077255 134.360718,169.220871 134.063721,169.563889 
	C133.622711,170.024979 133.373230,170.291580 132.960037,170.784012 
	C132.680466,171.155472 132.569702,171.305923 132.292007,171.683014 
	C131.789474,172.365646 131.450943,172.819611 131.011795,173.554245 
	C130.764252,173.968231 130.661606,174.132294 130.394409,174.536194 
	C129.891312,175.248688 129.538864,175.711655 129.080002,176.458069 
	C128.824677,176.877502 128.719452,177.044022 128.447937,177.455200 
	C127.682014,178.496796 127.214203,179.365036 126.747299,180.587875 
	C126.510162,181.054138 126.399841,181.234863 126.090675,181.667160 
	C124.238670,183.207306 123.983139,186.065277 120.937866,185.880310 
	C119.019691,182.514709 123.095215,179.618256 120.888901,176.176331 
	C119.507660,174.106094 121.076057,172.585510 121.148712,170.601181 
	C121.081726,170.069962 121.062607,169.856247 121.021896,169.321381 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M120.942871,170.565887 
	C123.127480,172.038010 120.426666,173.586273 120.941811,175.892883 
	C120.977364,176.684677 120.954475,176.855728 120.853897,177.274780 
	C120.705956,177.681702 120.635689,177.840637 120.443634,178.230026 
	C120.156181,178.770569 119.994781,179.082886 119.722466,179.644577 
	C119.518326,180.054169 119.429123,180.216461 119.187363,180.614594 
	C118.814499,181.173553 118.600471,181.500778 118.241638,182.107880 
	C117.129486,184.432465 115.970444,186.365646 114.498230,188.449997 
	C114.218254,188.767593 114.146767,188.882416 114.233810,188.759888 
	C115.456558,187.522781 116.154739,185.675735 118.355827,187.345337 
	C119.297066,189.935837 117.795288,191.739014 117.067368,194.068146 
	C116.813713,194.595154 116.697960,194.797638 116.365547,195.271362 
	C113.406532,197.397339 112.912361,200.881271 110.393280,203.298431 
	C109.475960,203.793427 108.806084,203.881912 107.785690,203.708633 
	C107.276161,203.492767 107.091423,203.369141 106.784531,202.939316 
	C106.929863,202.057556 107.430031,201.599945 107.638611,200.649323 
	C108.084129,199.862381 108.491814,199.401413 108.696487,198.511963 
	C109.059631,197.969437 109.301903,197.696793 109.732193,197.269989 
	C109.899834,197.097412 110.178825,196.764069 110.293869,196.609268 
	C110.408913,196.454468 110.334122,196.145584 110.366348,196.307709 
	C110.398575,196.469849 110.137817,196.741974 110.027710,196.914429 
	C109.702080,197.292908 109.489716,197.502151 109.109543,197.896393 
	C108.566116,198.479401 108.485680,198.999847 108.194878,199.720352 
	C107.666626,200.379990 107.483482,200.899429 107.212555,201.688095 
	C106.805969,202.237671 106.654388,202.592056 106.615311,203.284851 
	C106.618462,203.796890 106.583290,204.003815 106.462357,204.518661 
	C106.248970,205.250900 106.120468,205.674942 105.894165,206.438416 
	C105.149368,208.631332 104.395027,210.452652 103.191177,212.005341 
	C101.998741,213.543320 100.587265,214.614868 98.885902,212.331787 
	C103.802864,196.963623 111.847885,183.669434 120.942871,170.565887 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M90.656990,234.242752 
	C91.684891,231.590820 92.497765,229.193970 93.465530,226.446564 
	C96.645416,224.613083 98.663872,222.400696 99.725632,219.067902 
	C100.283577,217.316574 101.073845,214.701904 104.311844,216.425842 
	C104.882423,218.895889 103.831017,220.740128 103.148163,223.047363 
	C99.993828,229.689835 97.806534,236.295074 95.545441,242.871841 
	C94.955650,244.587341 94.581253,246.398407 93.018181,248.010391 
	C90.875328,248.150131 90.017258,246.415955 88.253906,245.554840 
	C87.398064,244.481888 87.587822,243.547714 87.720390,242.284576 
	C87.839798,241.496918 87.932434,241.052963 88.127014,240.287689 
	C88.542816,238.905731 88.825218,237.835403 89.179863,236.437881 
	C89.534813,235.483109 89.971756,234.978531 90.656990,234.242752 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M104.402512,217.125626 
	C100.072372,216.519791 100.658028,220.104599 99.993523,222.019150 
	C98.971756,224.962997 97.584564,226.576416 93.986122,226.065918 
	C95.243561,221.559586 96.866707,217.023148 98.737961,212.227921 
	C100.530602,213.725922 101.532387,212.790405 102.332664,211.248047 
	C103.241760,209.496017 104.078438,207.706436 104.984337,205.585571 
	C105.195992,204.926392 105.401878,204.637573 105.834938,204.189606 
	C106.030159,204.007675 105.995239,204.004990 106.007103,204.018082 
	C106.219772,203.745346 106.405556,203.450058 106.836456,203.106995 
	C107.812447,203.047638 108.528587,203.026764 109.603012,203.008453 
	C111.589607,205.553467 108.542213,207.681702 109.322807,210.525803 
	C109.270538,211.657288 109.131691,212.395615 108.766670,213.464600 
	C107.580437,215.208786 106.352165,216.393387 104.402512,217.125626 
z"/>
<path fill="#08101D" opacity="1.000000" stroke="none" 
	d="
M88.981400,239.686646 
	C88.994423,240.463745 88.964752,240.915268 88.827576,241.689896 
	C87.128967,243.502029 85.363029,243.436890 83.172409,242.275284 
	C83.497955,238.202606 84.572319,234.585220 86.526474,230.892059 
	C87.525948,232.114410 88.479111,233.411972 90.535233,233.950684 
	C90.772263,234.544220 90.672516,235.100769 90.359192,235.851562 
	C88.872726,236.833969 88.361946,237.899567 88.981400,239.686646 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M159.867645,140.343597 
	C159.875687,139.681717 159.694107,139.422363 159.213776,139.111847 
	C158.556961,136.424408 156.533340,134.676102 155.262711,132.193390 
	C155.088974,131.034607 155.398941,130.233063 156.824066,129.974792 
	C160.981247,128.508728 161.823349,133.235550 165.064621,133.810120 
	C170.263535,141.243805 177.218765,146.558365 183.103363,152.878555 
	C185.257568,155.192215 187.549591,157.379471 190.057236,159.841949 
	C190.471237,160.255478 190.632858,160.425278 191.024475,160.861511 
	C191.398300,161.313171 191.542160,161.498428 191.886993,161.971649 
	C207.073685,179.410141 221.747589,196.873291 240.669678,210.027710 
	C243.533936,212.018906 246.366180,214.081039 249.106659,216.794708 
	C250.588211,218.077698 251.984512,218.916779 253.372467,220.325592 
	C254.065598,221.164642 254.381973,221.805374 254.493881,222.896790 
	C254.288086,223.724899 253.996735,224.101990 253.229370,224.477844 
	C247.430511,223.227631 243.748154,218.588104 238.191956,216.696655 
	C234.422440,213.264526 229.790787,212.290405 225.386749,210.192795 
	C228.912506,213.069687 232.702194,215.069000 236.307526,217.920135 
	C245.945145,224.828064 255.608780,231.095184 265.131348,238.189529 
	C271.264099,243.947678 278.083710,248.503998 282.608826,255.389175 
	C283.788177,257.183624 285.195831,258.866669 284.485596,261.566132 
	C281.908264,262.722717 281.300323,260.443909 280.121735,259.339478 
	C275.108368,254.641373 270.874939,249.031921 264.062897,245.954163 
	C260.373962,243.965958 256.939392,242.260605 252.899445,241.095001 
	C252.214218,240.822601 251.861832,240.640732 251.365540,240.285599 
	C251.188889,240.170792 250.971191,239.941925 251.023056,240.111420 
	C251.317535,240.456604 251.552582,240.641907 252.015076,241.008514 
	C256.847137,245.504074 261.297546,249.965958 265.449768,255.179703 
	C273.051880,263.644897 280.112244,272.139526 288.191284,280.167664 
	C289.262939,281.730347 290.101135,283.042938 291.525391,284.318359 
	C296.443787,289.818329 302.019287,294.120178 307.413025,299.118500 
	C314.189972,304.799103 320.272675,310.738434 326.840210,316.643555 
	C327.240540,317.035278 327.397552,317.193420 328.010742,317.829529 
	C328.617584,318.465942 328.768250,318.624359 329.379395,319.248657 
	C329.998718,319.867584 330.157532,320.020599 330.804565,320.638397 
	C335.935883,326.290588 342.272888,329.766571 346.335754,336.020203 
	C348.417755,338.419617 349.867310,340.896484 352.124695,343.134491 
	C352.834137,344.065460 353.235016,344.815369 353.909180,345.763306 
	C354.213226,346.194183 354.332062,346.369324 354.619751,346.814331 
	C355.121826,347.636627 355.447235,348.193970 356.033661,348.983154 
	C357.758698,351.599457 359.684814,353.746094 359.936768,357.082336 
	C359.720459,358.483673 359.200653,359.267059 357.819427,359.727478 
	C354.132385,359.655121 352.191162,357.253052 349.997498,355.242432 
	C326.687164,333.877106 301.719543,314.532623 276.745605,295.196381 
	C276.220612,294.789948 275.608765,294.507202 274.714600,294.023407 
	C274.217102,293.718964 274.026917,293.584808 273.587830,293.210022 
	C273.034851,292.629242 272.728973,292.290710 272.167328,291.729736 
	C264.788727,286.541077 258.042877,281.055786 250.563126,275.985168 
	C245.153427,272.655304 240.858429,268.449432 236.122375,264.815491 
	C216.885971,250.055695 197.535233,235.454620 177.811295,221.351257 
	C176.452362,220.379578 175.116425,219.395447 174.313568,217.456879 
	C173.967697,213.376663 176.446594,211.418671 179.198868,209.780869 
	C184.032104,206.904739 188.582977,203.626892 193.196030,200.425781 
	C196.505142,198.129501 196.870087,195.698563 194.542084,192.531708 
	C192.783127,190.138931 191.278290,187.563934 189.328918,184.867981 
	C179.734070,172.035583 171.204132,158.890350 162.221878,146.060776 
	C161.079437,144.428970 159.851761,142.811676 159.867645,140.343597 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M124.013458,165.347183 
	C124.349144,164.900513 124.603622,164.698715 124.900543,164.194183 
	C126.535393,165.146530 125.514633,165.932861 124.307304,166.849670 
	C124.019135,166.534637 124.006966,166.102783 124.013458,165.347183 
z"/>
<path fill="#F4FCFC" opacity="1.000000" stroke="none" 
	d="
M248.808975,162.228104 
	C232.534637,144.686783 216.593964,127.270927 200.481354,109.546791 
	C200.796631,107.945625 201.985916,107.439415 203.390137,106.642502 
	C207.884308,105.909065 209.808182,110.168114 213.681366,111.052246 
	C217.786224,113.162193 221.154572,115.798019 225.177032,118.034988 
	C231.086533,122.615013 237.281219,126.111542 243.631012,129.990417 
	C244.865784,130.745544 245.722336,131.456055 246.949158,132.204987 
	C248.435013,133.274460 249.495316,134.363205 251.082748,135.294403 
	C252.872711,136.679962 254.323044,137.979843 256.298584,139.122513 
	C258.941681,140.908859 261.302338,142.527664 264.024414,144.203690 
	C267.197876,146.807144 270.319946,148.904663 273.830109,151.033035 
	C274.508545,151.433823 274.888214,151.677460 275.541138,152.126251 
	C278.530060,154.743744 281.624878,156.651825 284.796692,159.020325 
	C285.814697,159.716476 286.497162,160.299927 287.542297,160.951569 
	C291.609589,163.507141 294.986816,166.448730 298.963318,169.132233 
	C300.852600,170.522949 302.530518,171.634811 304.393005,173.063995 
	C308.422516,175.721817 311.849152,178.656174 315.999847,181.142746 
	C319.025513,183.278259 321.789246,185.197983 324.942108,187.139801 
	C327.871338,189.628342 330.344940,192.154556 333.743561,194.036163 
	C334.901337,194.817810 335.732178,195.499008 336.925171,196.225296 
	C337.906616,196.894394 338.532440,197.493454 339.479004,198.216461 
	C340.997162,199.321472 342.289062,200.175110 343.899445,201.154022 
	C345.106934,201.955307 345.991638,202.636719 347.242493,203.387177 
	C351.404694,206.874756 355.966827,209.220535 360.181244,212.619751 
	C360.653717,212.906494 360.837128,213.026123 361.284851,213.332703 
	C362.056427,213.892090 362.547455,214.286682 363.330780,214.794678 
	C363.757080,215.064163 363.925171,215.173630 364.337067,215.455139 
	C365.052551,215.977066 365.509186,216.347366 366.247314,216.825531 
	C366.657990,217.086014 366.820831,217.192978 367.220276,217.472931 
	C367.608704,217.770126 367.760559,217.894287 368.358521,218.408051 
	C368.959137,218.925095 369.113586,219.052505 369.773071,219.531830 
	C370.460938,219.993637 370.643677,220.103531 371.108490,220.378052 
	C381.667694,226.724319 391.080902,233.979065 399.408417,243.134705 
	C405.473450,250.305405 411.103790,257.391418 417.394470,264.377563 
	C422.392822,270.615265 427.476868,276.326263 432.500549,282.548706 
	C434.560394,286.334320 437.050720,289.341522 439.887268,292.069946 
	C441.175934,293.309509 442.735809,294.351105 442.410950,296.816559 
	C441.415283,298.170776 440.275787,298.635498 438.621277,298.833923 
	C436.943787,298.684204 435.941559,297.954010 434.707214,296.910675 
	C424.265839,285.633484 414.876953,273.841492 403.178375,264.276367 
	C402.281677,263.543213 401.530334,262.653961 400.626129,261.465332 
	C400.300690,261.021545 400.175812,260.843689 399.685669,260.149475 
	C398.952301,259.146240 398.587067,258.657104 397.969299,257.991791 
	C397.491943,257.496338 397.223022,257.212158 396.750305,256.722412 
	C396.273834,256.247833 396.005829,255.974228 395.534485,255.501450 
	C395.059235,255.040024 394.792145,254.772980 394.324310,254.308121 
	C393.987732,253.980881 393.854797,253.848526 393.525208,253.515503 
	C393.197266,253.180984 393.065948,253.047134 392.537109,252.512115 
	C391.738831,251.704865 391.351624,251.285522 390.725525,250.690659 
	C390.223328,250.214111 389.940338,249.932297 389.444916,249.423889 
	C388.959167,248.874695 388.693176,248.545273 388.226807,247.955826 
	C386.391205,245.262100 384.109894,243.423767 381.943237,241.067032 
	C381.377380,240.677994 381.539490,240.057480 381.228119,240.037918 
	C380.953033,240.020615 381.015106,240.345459 381.648682,240.741165 
	C383.421295,244.118866 386.047180,246.378220 388.519165,249.192062 
	C388.763641,250.748276 388.449310,252.066162 387.550964,252.657364 
	C382.040802,256.283600 383.808777,260.869385 385.784943,265.858154 
	C386.911377,270.176697 388.244080,274.055969 389.279724,278.421753 
	C391.105927,285.666595 392.537811,292.600830 394.152252,299.896698 
	C394.377960,301.050201 394.487091,301.827332 394.898926,302.937317 
	C396.130188,307.661865 396.851562,312.100128 398.117004,316.829895 
	C398.554352,324.090149 401.047638,330.656769 400.884308,337.964569 
	C400.592529,338.581177 400.434631,338.805969 399.896545,339.186707 
	C397.285217,338.921265 396.764343,336.973175 395.780792,334.948090 
	C393.310974,329.225372 391.753632,323.594025 389.687103,317.739075 
	C386.392395,307.416901 384.119720,297.177734 380.165100,287.069031 
	C377.151611,277.344269 373.590942,268.187103 371.040924,258.705048 
	C370.237061,255.716019 368.554962,253.359955 366.113922,251.410278 
	C344.554779,234.191040 323.147278,216.781403 300.772430,200.607193 
	C293.233429,195.157471 285.333862,190.212708 277.776398,184.171082 
	C268.210632,176.530579 258.797058,169.284271 248.808975,162.228104 
z"/>
<path fill="#02F4FE" opacity="1.000000" stroke="none" 
	d="
M277.721130,183.084732 
	C303.055969,200.702072 328.189514,218.566528 351.844025,238.397476 
	C355.799957,241.713974 359.661896,245.225815 363.980957,248.004440 
	C369.104767,251.300858 371.705994,255.764877 373.273224,261.511383 
	C375.458344,269.523651 378.369507,277.337860 380.979614,285.615051 
	C380.203064,286.967133 379.106964,287.406281 377.626404,287.837006 
	C376.020264,288.307953 374.085907,287.134094 373.363464,289.674316 
	C368.573212,291.347931 364.679230,293.563629 362.562164,298.152130 
	C361.945984,299.487640 360.782562,300.512054 359.148071,301.438263 
	C356.940338,301.937408 355.624786,300.820679 354.316437,299.813202 
	C343.704224,291.641479 332.305420,284.821075 319.923950,279.672333 
	C318.834534,279.219330 317.888214,278.541290 316.921082,277.283081 
	C315.334229,273.843842 315.177612,270.692841 316.656616,267.199402 
	C318.632233,265.731476 319.940918,266.672058 321.333374,267.680511 
	C325.455688,270.666107 329.678009,273.515686 333.831848,277.025208 
	C334.452850,277.494141 334.778809,277.787018 335.308533,278.316772 
	C336.008942,278.349274 335.497162,279.370209 335.876770,278.830261 
	C335.348877,278.342529 335.056061,278.044189 334.516907,277.525330 
	C324.405426,267.833801 314.914612,257.986237 304.936829,248.142502 
	C303.757172,246.929535 302.879456,245.899399 301.566223,244.819824 
	C300.749634,244.159195 300.234528,243.679749 299.568237,242.842590 
	C299.044403,241.864319 298.881012,241.145889 298.730530,240.041092 
	C298.917908,236.706665 297.185791,233.829544 298.492950,230.523438 
	C299.053101,229.903839 299.470154,229.751114 300.233459,229.992310 
	C301.028625,230.530212 301.580231,230.835739 302.315247,231.369080 
	C302.755707,231.764908 302.868317,231.873749 302.868317,231.873749 
	C303.145630,232.406616 303.168610,232.420547 302.752075,231.740036 
	C302.178314,231.173828 301.749451,230.832077 301.045105,230.357315 
	C300.647858,230.053925 300.501923,229.912903 300.117798,229.573242 
	C299.715576,229.242661 299.551514,229.110703 299.190430,228.727478 
	C298.070435,226.553711 296.469391,224.926224 296.177521,222.429230 
	C291.656281,216.431839 287.400208,210.618973 283.048950,204.485138 
	C282.130859,200.907013 280.019684,198.287781 278.579773,195.336029 
	C276.709747,191.502533 275.711548,187.592773 277.721130,183.084732 
z"/>
<path fill="#0A0C12" opacity="1.000000" stroke="none" 
	d="
M158.763641,128.484314 
	C158.312836,127.369629 157.868607,126.590332 157.396820,125.466400 
	C163.165939,122.656967 167.541336,118.096001 172.715988,114.713623 
	C173.940079,113.913498 175.149475,113.090881 176.687256,112.166153 
	C177.699997,112.604782 178.199753,113.424057 178.024399,114.197319 
	C176.695053,120.060081 180.187775,122.727249 184.619751,125.386314 
	C189.112717,128.081970 192.997665,131.722702 197.729050,134.177765 
	C200.533813,135.633118 203.304535,136.976257 206.692993,137.827423 
	C213.977158,145.013458 218.399826,153.727325 223.211182,162.195862 
	C224.453415,164.382294 222.567627,165.541779 222.060394,167.511276 
	C219.086548,168.506027 217.189789,166.250580 214.548431,165.081360 
	C208.654373,159.913269 201.969833,156.564896 195.735489,152.552948 
	C193.942368,151.399017 192.130920,150.249222 190.031799,148.910583 
	C183.142563,143.620880 176.019699,139.354553 168.374908,135.292725 
	C167.834824,135.108582 167.621613,135.027924 167.096939,134.807724 
	C166.384155,134.456955 166.008835,134.207260 165.376190,133.741013 
	C162.378326,132.789642 160.706665,130.628616 158.763641,128.484314 
z"/>
<path fill="#0E0F13" opacity="1.000000" stroke="none" 
	d="
M206.962845,137.645050 
	C204.821793,139.492142 202.797638,138.248154 200.946213,137.398026 
	C192.812744,133.663269 186.148483,127.611618 178.595169,122.938347 
	C174.551529,120.436523 177.551849,116.246887 177.005798,112.464714 
	C180.470657,109.789856 183.932404,107.526024 187.716202,105.137726 
	C192.687485,114.847946 198.642914,123.909149 204.566925,132.991577 
	C205.457184,134.356461 206.144104,135.853958 206.962845,137.645050 
z"/>
<path fill="#2CF2F7" opacity="1.000000" stroke="none" 
	d="
M247.749207,187.933136 
	C263.228668,198.156509 278.482086,208.411072 291.984253,221.433929 
	C293.404602,224.342239 293.731567,227.078400 293.130157,230.309097 
	C290.994720,234.152542 289.318970,231.386078 288.041473,230.139526 
	C283.302216,225.515152 278.477753,220.997894 273.465088,216.668320 
	C267.206818,211.262939 260.968292,205.835358 254.356659,200.320526 
	C253.408844,199.571945 252.782791,198.967880 251.820419,198.291382 
	C251.395981,198.009048 251.229156,197.894333 250.822189,197.600342 
	C250.429413,197.296677 250.276764,197.172272 249.686798,196.667542 
	C248.818909,195.915894 248.386398,195.547012 247.656555,195.096146 
	C247.239975,194.853638 247.072311,194.755280 246.653381,194.502548 
	C246.063858,194.130081 245.737259,193.895660 245.195068,193.431519 
	C244.714890,192.872284 244.553329,192.487381 244.484604,191.747314 
	C245.015045,189.892212 246.265549,189.005600 247.749207,187.933136 
z"/>
<path fill="#16ECFA" opacity="1.000000" stroke="none" 
	d="
M277.816345,182.476685 
	C277.418732,188.528763 278.415649,193.916412 282.072845,198.594772 
	C283.212006,200.052002 282.948547,201.704926 282.969482,203.749603 
	C271.563232,190.360565 260.172668,176.556931 248.628723,162.427963 
	C251.486206,161.665924 253.397461,163.801727 255.443298,165.318542 
	C262.911591,170.855637 270.254303,176.562073 277.816345,182.476685 
z"/>
<path fill="#16ECFA" opacity="1.000000" stroke="none" 
	d="
M247.883942,187.520599 
	C248.171097,189.797958 246.124496,190.117310 245.136444,191.674164 
	C244.118774,192.398453 243.349686,192.088013 242.674393,191.589584 
	C236.543976,187.065048 230.629242,182.260406 224.589401,177.617874 
	C223.662735,176.905594 222.969772,175.960373 222.622345,174.430588 
	C222.892441,172.827438 223.552277,171.814636 224.809601,170.790497 
	C232.659775,176.151855 240.189484,181.693832 247.883942,187.520599 
z"/>
<path fill="#16ECFA" opacity="1.000000" stroke="none" 
	d="
M291.891846,232.425720 
	C292.006317,228.946472 292.025970,225.815079 292.076172,222.211212 
	C292.870575,222.412552 293.634460,223.086395 294.678223,223.891327 
	C297.298859,224.707077 298.335907,226.741638 299.826111,228.780304 
	C300.034302,229.038071 299.973511,229.020233 299.978210,228.988892 
	C300.135345,229.189621 300.287842,229.421692 300.061462,229.826843 
	C297.669556,233.240295 300.848633,236.354858 299.861206,240.008957 
	C295.909698,239.171982 293.608032,236.228851 291.891846,232.425720 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M224.981049,170.349274 
	C225.015060,171.933105 224.588211,173.085678 223.036972,173.976929 
	C217.648270,173.698227 215.052628,169.970764 212.291992,166.016602 
	C212.398163,164.479446 212.827698,163.598038 214.513641,163.816132 
	C217.012161,165.265671 219.178848,166.496109 221.680405,167.789474 
	C222.954178,168.597824 223.893097,169.343246 224.981049,170.349274 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M204.358185,105.964706 
	C203.770081,107.796913 202.748291,108.750038 200.743896,109.159698 
	C198.982864,107.993164 197.656311,106.747810 196.174133,105.232819 
	C196.132339,103.918518 195.606155,102.616676 197.475250,102.061050 
	C197.981689,101.831108 198.163086,101.686867 198.692932,101.524078 
	C201.246674,102.328232 203.319550,103.323250 204.358185,105.964706 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M300.308899,228.753082 
	C297.670776,228.400543 296.850403,226.058670 295.072205,224.335526 
	C295.258026,223.610153 295.557892,223.197906 295.885040,222.515198 
	C297.469391,224.319168 299.026428,226.393646 300.308899,228.753082 
z"/>
<path fill="#055280" opacity="1.000000" stroke="none" 
	d="
M199.187927,102.085045 
	C198.656693,102.163551 198.480057,102.158180 198.051849,102.064079 
	C196.902985,101.197716 196.005692,100.420067 194.943359,99.381683 
	C201.152008,95.325508 207.525711,91.530067 213.970200,87.396484 
	C214.607834,86.634361 215.174713,86.210381 215.872971,85.564667 
	C222.087448,83.598763 228.170532,81.854591 234.640533,80.108795 
	C236.275375,82.601715 234.260941,83.631477 232.830566,84.857994 
	C231.223389,86.236092 229.131348,87.063385 227.891876,89.392105 
	C224.759872,92.774826 220.431839,92.753380 216.586624,94.699509 
	C210.478912,96.764488 205.186981,99.793716 199.187927,102.085045 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M158.363220,128.133301 
	C160.863754,129.616165 162.970428,131.083420 165.317017,132.744202 
	C165.831223,133.163345 166.105545,133.388947 166.022736,134.007706 
	C165.313522,134.432053 164.961456,134.463226 164.248169,134.882507 
	C161.856903,133.538895 159.826859,131.807190 157.479065,130.002182 
	C157.017319,129.503220 156.873291,129.077545 156.561050,128.358551 
	C156.918335,128.082703 157.443848,128.100189 158.363220,128.133301 
z"/>
<path fill="#2EA1DD" opacity="1.000000" stroke="none" 
	d="
M70.753204,327.834259 
	C70.959358,329.114960 70.928749,330.173889 70.950699,331.627594 
	C71.364105,332.451843 71.676712,332.913971 72.068489,333.808228 
	C72.298340,336.947235 73.355904,339.655548 72.168640,342.721283 
	C70.863487,343.003723 69.853020,342.992188 68.466675,342.971130 
	C67.739655,340.586761 67.388527,338.211975 67.028122,335.440857 
	C67.022926,333.321442 67.027016,331.598358 67.038284,329.446136 
	C67.612656,328.315704 68.360878,327.915100 69.545883,327.665344 
	C70.083984,327.621063 70.300217,327.616791 70.753204,327.834259 
z"/>
<path fill="#08101D" opacity="1.000000" stroke="none" 
	d="
M71.962410,343.357666 
	C71.610306,340.349823 71.346657,337.684448 71.131699,334.616577 
	C72.970222,332.193695 75.373680,333.317841 77.910965,332.989594 
	C79.008904,333.823273 79.005203,334.785400 78.820435,336.133789 
	C78.522240,336.819031 78.382767,337.181396 78.150604,337.816864 
	C77.973900,338.056366 77.994019,337.998260 78.014877,337.975677 
	C77.268547,338.654572 77.585815,339.636841 77.184883,340.759735 
	C76.989311,341.035675 76.988350,340.992920 77.007812,340.984070 
	C76.568130,341.405060 76.494919,342.003448 76.156296,342.799255 
	C75.978752,343.035034 75.984123,342.990082 76.002403,342.976746 
	C75.264717,343.667511 75.588890,344.645996 75.185257,345.764374 
	C74.991310,346.039886 74.989746,345.998322 75.010399,345.995728 
	C74.905594,346.174042 74.780144,346.354889 74.327637,346.490662 
	C71.552727,346.807220 72.626488,344.668030 71.962410,343.357666 
z"/>
<path fill="#1174A3" opacity="1.000000" stroke="none" 
	d="
M73.974518,346.837280 
	C74.203094,346.185913 74.405647,345.926239 74.819626,345.829865 
	C74.872299,346.554993 74.713547,347.116821 74.301910,347.843079 
	C74.015518,347.747955 73.982002,347.488434 73.974518,346.837280 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M227.397675,89.625931 
	C226.741837,86.870644 228.904785,86.239174 230.406021,85.065567 
	C232.045700,83.783737 234.318069,83.155685 234.978210,80.445618 
	C236.532440,79.610619 238.037415,79.114082 239.784119,78.385880 
	C244.437561,77.153320 248.849304,76.152428 253.662201,75.203827 
	C254.514359,78.714088 250.429581,79.684944 249.950165,83.033020 
	C249.385910,84.522484 248.474960,85.282272 247.360382,85.599472 
	C240.918381,87.432755 234.536011,89.568146 227.397675,89.625931 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M552.699768,442.766235 
	C552.968750,443.493378 552.947266,444.005341 552.813110,444.895538 
	C551.452759,446.077484 550.347168,447.201904 548.371521,446.592041 
	C548.900269,445.179352 549.735840,444.228790 550.792480,443.047729 
	C551.455505,442.606140 551.920715,442.517487 552.699768,442.766235 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M554.609131,438.965118 
	C555.159485,440.028503 554.688782,440.876190 553.684082,441.800232 
	C553.235657,442.137482 553.024475,442.289398 552.542847,442.160156 
	C552.264343,441.711456 552.256409,441.543915 552.167419,441.138123 
	C552.489258,439.874451 553.184204,439.192596 554.609131,438.965118 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M550.617432,437.013367 
	C550.964233,437.461914 550.974609,437.962280 550.973877,438.840668 
	C550.962830,439.218658 550.524780,439.058533 550.296021,439.015320 
	C550.138489,438.336487 550.209717,437.700867 550.617432,437.013367 
z"/>
<path fill="#009AED" opacity="1.000000" stroke="none" 
	d="
M552.016785,441.971313 
	C552.468201,441.892761 552.664001,441.906525 553.153320,441.952942 
	C553.359375,442.146362 553.271973,442.307190 553.087402,442.724731 
	C552.551514,442.937653 552.112793,442.893860 551.343872,442.833649 
	C551.262817,442.566040 551.512024,442.314819 552.016785,441.971313 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M547.998779,446.999084 
	C547.825745,447.566132 547.653870,448.134125 547.203857,448.833313 
	C546.937866,448.531830 546.949890,448.099152 547.148010,447.380920 
	C547.425415,446.939636 547.516724,446.783936 547.804443,446.814758 
	C548.000732,447.001221 548.000000,447.000000 547.998779,446.999084 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M548.023254,446.783875 
	C548.000732,447.001221 547.668640,447.061371 547.501343,447.078369 
	C547.382812,446.810150 547.510742,446.566528 547.891235,446.247192 
	C548.064636,446.129913 548.045776,446.566498 548.023254,446.783875 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M546.645142,448.893860 
	C546.780518,449.223267 546.606445,449.514038 546.182556,449.881195 
	C546.067017,449.590118 546.201355,449.222656 546.645142,448.893860 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M551.645325,435.067352 
	C551.804688,435.541901 551.652893,436.118103 551.225098,436.835938 
	C551.077454,436.374695 551.205872,435.771881 551.645325,435.067352 
z"/>
<path fill="#033256" opacity="1.000000" stroke="none" 
	d="
M551.834717,434.233154 
	C552.017822,433.929932 552.211975,433.882294 552.699951,433.894928 
	C552.823486,434.266174 552.653198,434.577118 552.212158,434.939789 
	C551.909485,434.823975 551.877625,434.656403 551.834717,434.233154 
z"/>
<path fill="#0C1929" opacity="1.000000" stroke="none" 
	d="
M70.547394,299.372742 
	C71.155533,295.962006 71.521301,292.908295 71.856903,289.442505 
	C72.603279,284.331238 73.379829,279.632111 74.169945,274.503052 
	C74.095787,273.504272 74.152313,272.959290 74.595436,272.213989 
	C74.856041,271.239441 74.972816,270.505402 75.089996,269.399048 
	C75.410339,268.915619 75.643730,268.707489 75.917587,268.198425 
	C78.276619,266.394806 80.407387,267.436890 82.888443,268.493286 
	C85.077469,273.169983 82.990181,277.292816 82.098579,281.870239 
	C80.833786,284.340515 74.882103,284.796356 79.886864,289.188721 
	C80.266563,289.627808 80.400887,289.819336 80.673973,290.334900 
	C81.086021,291.579132 81.090179,292.520081 80.990189,293.819916 
	C80.907547,294.407745 80.863907,294.641754 80.743790,295.224396 
	C80.550255,296.042084 80.476036,296.517914 80.430580,297.373535 
	C80.227509,300.838654 80.778358,303.971619 79.727936,307.376160 
	C76.412216,308.329559 73.243820,309.432343 70.103058,306.821167 
	C69.462708,304.172333 69.302444,301.919586 70.547394,299.372742 
z"/>
<path fill="#08101D" opacity="1.000000" stroke="none" 
	d="
M83.214973,268.785034 
	C80.828545,268.665253 78.819862,268.339417 76.427872,268.004089 
	C77.104332,263.158936 78.164093,258.323334 79.440674,253.188324 
	C82.080627,251.671188 84.192955,252.417801 86.423599,254.288330 
	C87.181122,259.636169 86.285858,264.305695 83.214973,268.785034 
z"/>
<path fill="#040E11" opacity="1.000000" stroke="none" 
	d="
M86.244461,255.107224 
	C84.118195,254.234238 82.276352,253.620499 80.046005,252.947845 
	C80.547302,249.415161 81.437119,245.941391 82.580780,242.209564 
	C84.519638,241.970367 86.204636,241.989227 88.304855,242.010529 
	C88.551994,242.828995 88.383919,243.645004 88.243340,244.775604 
	C89.227722,246.727097 88.220993,248.385971 88.323151,250.399277 
	C88.314201,251.013489 88.308281,251.260818 88.279236,251.882141 
	C88.180252,253.017868 88.006035,253.754440 87.468452,254.768112 
	C87.005295,255.175919 86.767090,255.271194 86.244461,255.107224 
z"/>
<path fill="#AEF6FB" opacity="1.000000" stroke="none" 
	d="
M269.635590,552.530518 
	C270.083527,554.322815 270.063263,555.749146 270.063934,557.603882 
	C267.287872,557.453064 264.490906,556.873718 261.365082,556.111694 
	C261.027924,554.601440 261.019623,553.273865 261.012268,551.548157 
	C261.140228,550.972290 261.267242,550.794556 261.688965,550.474243 
	C263.086395,550.057068 264.115997,550.417969 265.457214,550.778809 
	C265.956238,550.923584 266.153198,550.985962 266.638306,551.154175 
	C267.670410,551.569092 268.418671,551.867432 269.635590,552.530518 
z"/>
<path fill="#2D2F36" opacity="1.000000" stroke="none" 
	d="
M224.273285,544.065674 
	C224.743942,543.935791 225.366318,544.123474 226.197876,544.565674 
	C225.746384,544.674561 225.085709,544.528870 224.273285,544.065674 
z"/>
<path fill="#1E2B39" opacity="1.000000" stroke="none" 
	d="
M295.272919,574.675903 
	C295.363159,574.307312 295.479828,574.277344 295.539856,574.282471 
	C296.186462,574.703430 296.475464,575.270813 296.269958,576.455688 
	C296.072906,576.921692 296.002045,576.990479 295.963806,577.023193 
	C295.677979,576.385437 295.430328,575.714966 295.272919,574.675903 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M290.280945,571.523987 
	C289.987000,571.133606 289.975647,570.936340 289.958557,570.442627 
	C293.232269,570.068787 296.511749,569.991333 300.225250,569.844177 
	C300.899658,569.709961 301.140076,569.645386 301.705200,569.765137 
	C302.029877,569.949524 302.042023,569.986816 302.048767,569.967407 
	C302.415833,570.476318 302.522797,571.052124 302.113983,572.048218 
	C299.527252,573.750305 297.157593,573.367981 294.384155,572.389893 
	C292.848297,572.011963 291.705933,571.864502 290.280945,571.523987 
z"/>
<path fill="#02AEE7" opacity="1.000000" stroke="none" 
	d="
M294.031982,572.437134 
	C296.363953,572.147339 298.737213,572.135254 301.552551,572.069580 
	C302.426422,573.077698 301.703827,573.557739 300.701843,574.191406 
	C300.242065,574.447632 300.057312,574.548096 299.557251,574.660156 
	C299.241974,574.671692 299.351746,574.371338 299.207306,574.302734 
	C298.323181,576.107727 297.324158,574.887573 296.033508,574.197754 
	C294.832947,573.934204 294.271637,573.562378 294.031982,572.437134 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M295.668091,574.027405 
	C296.597107,573.959656 297.518646,573.981873 298.751526,574.119141 
	C299.117401,575.778809 298.668182,576.907654 296.463531,576.915771 
	C295.983032,576.334473 295.893158,575.747253 295.701599,574.723816 
	C295.599884,574.287598 295.660645,574.117432 295.668091,574.027405 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M301.956818,569.672363 
	C301.799774,569.935608 301.569672,569.921692 300.999390,569.841187 
	C300.659271,569.774536 300.747467,569.506409 300.772858,569.367554 
	C301.160095,569.284241 301.521942,569.339722 301.956818,569.672363 
z"/>
<path fill="#033256" opacity="1.000000" stroke="none" 
	d="
M555.244751,430.864624 
	C555.093628,430.391907 555.231995,429.789551 555.674561,429.074524 
	C555.830505,429.552887 555.682312,430.143921 555.244751,430.864624 
z"/>
<path fill="#033256" opacity="1.000000" stroke="none" 
	d="
M553.238037,433.860748 
	C553.104675,433.407928 553.252319,432.813812 553.692078,432.090363 
	C553.829102,432.547180 553.674072,433.133301 553.238037,433.860748 
z"/>
<path fill="#033256" opacity="1.000000" stroke="none" 
	d="
M554.237671,431.959229 
	C554.107361,431.653137 554.256470,431.314789 554.694580,430.966949 
	C554.828064,431.280609 554.672546,431.603760 554.237671,431.959229 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M74.462532,272.029541 
	C74.687973,272.535553 74.636665,273.097656 74.384430,273.866455 
	C73.138474,273.409424 72.896515,272.746643 74.462532,272.029541 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M70.410461,299.012878 
	C70.762108,301.407074 70.734451,303.798492 70.599487,306.625000 
	C70.574883,308.070068 71.108856,308.988770 71.116653,310.317444 
	C71.186264,311.209747 71.206757,311.803955 71.135406,312.693237 
	C69.703384,316.422638 72.252945,320.051025 70.435425,323.776459 
	C69.496407,324.591217 68.673164,324.787384 67.415695,324.202637 
	C67.036720,322.573975 67.012024,321.205994 66.978012,319.428375 
	C66.966324,314.331635 66.963936,309.644562 66.945389,304.495117 
	C66.948540,302.636841 66.967850,301.240906 66.988602,299.427368 
	C68.003738,299.009857 69.017448,299.009949 70.410461,299.012878 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M299.614014,574.785828 
	C299.238037,574.441589 299.234131,574.211487 299.498840,573.764648 
	C302.100281,574.002075 303.848511,571.005798 306.675476,572.719360 
	C307.004517,573.468750 307.004303,573.932190 307.042603,574.742554 
	C307.081146,575.089417 307.141296,575.528503 307.214874,575.738037 
	C304.854340,575.598389 302.420197,575.249146 299.614014,574.785828 
z"/>
<path fill="#18A6E3" opacity="1.000000" stroke="none" 
	d="
M67.035019,324.365356 
	C67.863670,323.966583 68.665916,323.991241 69.869614,324.047394 
	C70.330391,324.672607 70.389725,325.266296 70.388741,326.153992 
	C70.411964,326.745880 70.495514,327.043854 70.287842,327.703247 
	C69.454720,328.921875 68.594353,329.003265 67.373718,329.011841 
	C67.033180,327.607605 67.020889,326.198181 67.035019,324.365356 
z"/>
<path fill="#0355A0" opacity="1.000000" stroke="none" 
	d="
M494.366089,442.545074 
	C494.868835,443.731598 494.163910,444.593262 495.473846,444.957886 
	C500.283752,446.296661 500.512970,446.941711 497.351196,451.164154 
	C496.634796,452.120911 495.959808,452.987213 495.976990,454.597473 
	C493.005096,457.098969 490.811279,452.665741 487.559814,454.045532 
	C486.887085,454.283661 486.586426,454.496979 486.020203,454.794769 
	C485.422089,454.982452 485.075073,455.059448 484.478912,455.197815 
	C484.074036,455.332214 483.915955,455.394531 483.532654,455.576416 
	C483.165039,455.790802 483.022614,455.885590 482.669739,456.135529 
	C482.317627,456.398499 482.176025,456.506287 481.824493,456.784668 
	C481.187958,457.333710 480.807617,457.753784 480.291199,458.476044 
	C478.082520,460.622559 476.170593,462.931976 472.858154,460.290894 
	C473.775604,455.983368 476.748383,453.220734 479.467041,449.894043 
	C480.168640,449.489227 480.611206,449.380127 481.402344,449.436523 
	C483.617981,450.655670 484.752319,450.133881 485.151154,447.615295 
	C485.411102,445.478210 486.394745,444.087311 487.912170,442.588318 
	C490.024567,441.579895 491.860077,441.592499 494.366089,442.545074 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M472.853455,467.811035 
	C477.029785,464.416840 477.196472,468.307495 478.581757,470.910492 
	C472.621948,467.742188 474.357635,473.133636 473.039307,475.636322 
	C472.151001,477.045990 472.470306,478.574310 471.254333,479.779053 
	C471.038544,480.023224 471.013977,480.000061 471.017120,480.015686 
	C469.788788,481.312469 470.147125,483.170288 469.193695,484.924133 
	C468.633820,487.305939 467.650055,488.446259 465.181915,487.290619 
	C464.024567,485.003326 462.688660,486.282837 461.224762,486.833710 
	C460.992004,487.034332 460.995361,486.992676 461.014801,487.000275 
	C460.696106,487.289459 460.307190,487.440857 459.546570,487.433289 
	C458.386871,487.101196 457.790894,486.458282 456.875488,485.695557 
	C456.297699,485.171051 456.010132,484.828278 455.606628,484.148560 
	C455.421692,483.610413 455.383423,483.383118 455.376282,482.810059 
	C456.762939,479.346191 459.337646,477.426117 462.373199,475.504028 
	C464.880341,474.363831 466.931580,473.170319 468.574768,470.878601 
	C469.881653,469.454376 471.416321,468.973328 472.853455,467.811035 
z"/>
<path fill="#05B2F9" opacity="1.000000" stroke="none" 
	d="
M463.356506,475.821289 
	C461.012360,478.190155 458.687042,480.309052 456.181702,482.704742 
	C455.864441,483.157806 455.727234,483.334076 455.362183,484.144165 
	C453.987946,486.434753 452.175201,487.534180 451.252686,489.695435 
	C451.268494,490.192474 451.304535,490.389160 451.381042,490.883057 
	C451.421448,491.180267 451.270569,491.617249 451.151245,491.815002 
	C449.157898,492.203552 447.626740,493.102417 446.068512,494.604370 
	C445.477386,494.925812 445.070892,494.969574 444.357544,495.032013 
	C443.581726,495.246765 443.163391,495.180634 442.659973,494.487640 
	C442.431885,492.119659 443.892334,490.793335 445.019104,488.945801 
	C446.798279,486.855347 448.084015,484.800446 449.954895,482.797485 
	C450.697937,481.850281 451.219849,481.146423 451.893555,480.136292 
	C452.228058,479.682953 452.369293,479.505951 452.738159,479.074554 
	C456.860291,475.187317 459.519226,470.609161 462.707123,465.998535 
	C463.240021,465.075165 463.679596,464.520386 464.499542,463.831604 
	C465.021912,463.561523 465.249695,463.494263 465.831848,463.443298 
	C466.630920,463.620331 467.006775,463.877472 467.381500,464.582336 
	C467.317657,466.429962 466.703369,467.874359 466.780304,469.745819 
	C466.867584,470.496765 466.889709,470.926544 466.847473,471.675507 
	C466.615753,472.826843 466.198914,473.521088 465.275818,474.204315 
	C464.887085,474.463226 464.730957,474.558624 464.337952,474.774078 
	C463.779694,475.034729 463.531982,475.254272 463.356506,475.821289 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M472.633301,459.860779 
	C476.000031,461.786896 477.756134,459.608551 479.809326,457.538666 
	C480.336700,456.685974 480.932739,456.530884 481.776428,456.193970 
	C482.018890,456.003082 481.997559,455.996490 481.997620,456.007660 
	C482.222870,455.790070 482.449249,455.562500 482.847870,455.166626 
	C483.018921,454.997223 482.996002,454.995178 482.995361,455.006714 
	C483.426819,454.580872 484.015991,454.527954 484.782776,454.188354 
	C485.482574,454.005035 485.964630,454.010071 486.811066,454.034119 
	C487.171936,455.549286 485.993835,456.352722 485.100464,457.683350 
	C483.319122,457.952606 481.937042,459.020569 481.461548,460.225861 
	C479.729736,464.615631 476.305389,464.282471 472.278076,463.779236 
	C471.501160,463.423004 471.194641,463.105865 470.762970,462.466248 
	C470.587067,461.942383 470.558136,461.719788 470.815796,460.900330 
	C471.461700,460.019501 471.868286,459.838348 472.633301,459.860779 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M470.747314,461.781342 
	C471.261871,462.388824 471.557709,462.790955 471.843567,463.453979 
	C470.755341,464.042175 469.677094,464.369415 468.321167,464.896912 
	C467.894836,465.249420 467.746216,465.401672 467.353943,465.347717 
	C466.864349,464.825867 466.618378,464.510193 466.110291,464.041840 
	C465.461853,458.914337 469.516052,456.311493 472.055115,452.493469 
	C472.924805,451.734009 473.602112,451.475128 474.721069,451.802460 
	C476.508362,455.949921 472.383759,457.490967 471.183350,460.689392 
	C470.955566,460.983521 471.003632,460.995667 470.988556,460.975952 
	C470.613007,461.480743 470.118805,461.489624 469.577850,461.318298 
	C469.869598,461.486389 470.186523,461.572296 470.747314,461.781342 
z"/>
<path fill="#0355A0" opacity="1.000000" stroke="none" 
	d="
M484.988190,458.005463 
	C486.178101,457.585632 487.381836,457.164246 489.683044,456.358612 
	C486.608154,459.502075 490.353302,463.981903 485.399811,465.958557 
	C484.869629,465.822144 484.740540,465.657593 484.799011,465.241486 
	C485.478546,462.862671 488.747620,460.897461 485.177551,458.261383 
	C484.992310,457.978851 485.002014,458.003876 484.988190,458.005463 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M484.624969,465.054565 
	C484.986572,464.989960 485.001831,465.488373 485.000305,465.737549 
	C484.039978,467.587311 483.994720,469.367706 483.912750,471.160126 
	C483.873718,472.014008 483.476318,472.825623 482.398743,472.432495 
	C481.537659,472.118317 480.978271,470.971741 481.653961,470.550354 
	C483.768768,469.231445 482.010437,466.225555 484.624969,465.054565 
z"/>
<path fill="#0778E5" opacity="1.000000" stroke="none" 
	d="
M456.275970,492.142334 
	C454.946014,490.520752 453.449554,491.297791 451.762512,491.200439 
	C451.421448,491.180267 451.178375,491.137726 451.063843,491.091919 
	C451.432953,487.743195 454.125061,487.628052 456.943237,487.224182 
	C457.541077,487.417297 457.763855,487.539612 458.134827,488.013214 
	C457.863312,489.356018 457.443604,490.347565 457.011444,491.670837 
	C456.830109,492.124115 456.661224,492.245697 456.275970,492.142334 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M466.956299,465.408783 
	C467.110321,465.141541 467.575531,465.096222 467.809479,465.096680 
	C468.229675,465.646118 468.415894,466.195099 468.848846,466.913452 
	C469.431152,467.538452 469.556976,468.046448 469.302979,468.975708 
	C468.324066,470.167664 467.368195,470.597626 465.833588,470.283081 
	C464.830505,468.300659 466.135681,467.084442 466.956299,465.408783 
z"/>
<path fill="#0778E5" opacity="1.000000" stroke="none" 
	d="
M461.394135,487.047852 
	C461.884460,485.121582 463.489929,484.227722 465.461853,484.593353 
	C466.242798,484.738159 465.892853,485.924072 465.256622,486.839294 
	C463.923859,487.041138 462.860046,487.051270 461.394135,487.047852 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M468.762634,469.232208 
	C468.989502,468.588531 469.012970,468.157166 469.066010,467.404297 
	C470.183502,467.297729 471.271454,467.512665 472.682190,467.621094 
	C472.717163,469.324402 471.504913,470.349945 469.633972,471.172729 
	C469.111542,471.202637 468.920349,471.157410 468.588562,470.852966 
	C468.376587,470.200165 468.413483,469.817047 468.762634,469.232208 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M471.398560,480.068115 
	C470.986481,478.609009 471.722626,477.500458 472.716736,476.200897 
	C473.053009,476.673462 472.863403,477.602448 473.228333,477.951263 
	C477.266296,481.811340 471.881927,479.167847 471.398560,480.068115 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M469.333466,485.018219 
	C469.018097,483.482117 468.508057,481.593903 470.682434,480.183594 
	C470.962524,481.737762 471.330841,483.567627 469.333466,485.018219 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M456.039490,492.262207 
	C456.059570,491.917419 456.529510,491.957703 456.764221,491.980103 
	C457.851746,492.682037 458.457428,493.812927 457.370453,494.317444 
	C455.903839,494.998260 456.205750,493.423218 456.039490,492.262207 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M465.630951,494.096008 
	C465.365234,493.830750 465.256104,493.434021 465.203461,493.029999 
	C465.194061,492.957825 465.418365,492.855194 465.534790,492.766632 
	C465.625458,493.165131 465.716156,493.563599 465.630951,494.096008 
z"/>
<path fill="#0778E5" opacity="1.000000" stroke="none" 
	d="
M458.751923,486.809296 
	C459.541260,486.869019 459.970154,486.885620 460.716614,486.955017 
	C460.617126,487.926117 459.736877,488.033447 458.593689,488.294434 
	C458.283020,488.364471 458.149017,488.180634 458.076477,488.093018 
	C457.854523,487.505249 457.970245,487.087921 458.751923,486.809296 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M454.299683,497.007507 
	C454.047852,497.027588 454.008392,496.537354 453.989136,496.292725 
	C454.418701,496.184296 454.867523,496.320557 455.316376,496.456787 
	C455.061401,496.633667 454.806458,496.810547 454.299683,497.007507 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M472.570679,485.447296 
	C472.604095,485.500305 472.537231,485.394287 472.570679,485.447296 
z"/>
<path fill="#0778E5" opacity="1.000000" stroke="none" 
	d="
M434.203979,501.796875 
	C433.381073,502.170868 432.852356,502.333221 432.162903,502.728577 
	C430.672089,504.545197 428.498199,504.772003 426.698090,506.250610 
	C426.185516,506.508331 425.969116,506.591522 425.406342,506.725616 
	C423.911865,506.399536 422.740417,506.829895 421.267456,506.534302 
	C419.460815,503.970093 417.206543,502.625183 414.249542,501.661469 
	C413.385345,501.009583 412.990906,500.414948 412.541260,499.424683 
	C412.378204,498.843658 412.343262,498.603912 412.341309,498.003296 
	C413.345428,494.771545 415.940735,494.980591 418.474182,494.396545 
	C418.883606,494.103851 419.026215,493.981079 419.366241,493.756226 
	C419.563690,493.654083 419.869934,493.631744 419.869934,493.631744 
	C419.869934,493.631744 419.876892,493.341431 419.789062,493.476227 
	C419.420105,493.672821 419.178619,493.807465 418.747559,494.181396 
	C418.321381,494.307129 418.124420,494.266449 417.687561,494.023743 
	C416.765320,492.955811 416.170746,492.027618 415.377502,490.815613 
	C414.873444,489.606689 414.782471,488.662842 414.689697,487.359070 
	C414.655273,485.824341 414.693329,484.644958 414.533386,483.122864 
	C414.205322,480.131531 411.297424,478.069427 412.996155,475.141449 
	C410.753693,474.219086 407.971924,477.569458 406.511322,473.538086 
	C407.240631,471.780701 408.396851,470.642578 409.122467,468.852234 
	C413.240540,468.537811 412.672638,465.728577 412.790955,462.925354 
	C414.232025,461.729736 415.721802,461.731445 417.511108,461.445160 
	C418.893524,461.382507 419.804230,461.710266 420.913635,462.488983 
	C420.019379,467.327881 420.019379,467.327881 421.788696,472.561859 
	C421.654602,473.365601 421.476532,473.793121 421.020996,474.467773 
	C420.046783,475.548157 419.179047,476.263489 418.148926,477.770508 
	C420.195496,477.128601 422.468872,478.449463 422.418854,475.015289 
	C422.145996,474.251251 422.078461,473.791534 422.085144,472.963226 
	C422.306824,471.239990 423.067688,470.436646 424.805420,470.297180 
	C427.361786,471.265503 426.485016,473.947601 428.112457,475.590942 
	C428.932037,476.259888 426.858215,477.833252 429.293884,477.737061 
	C432.450653,481.760315 433.782379,486.007874 432.892761,490.828064 
	C432.869019,490.956879 432.962921,491.184052 433.068237,491.239532 
	C433.184540,491.300812 433.377289,491.216949 433.852631,491.162537 
	C434.609650,491.141479 435.036407,491.229187 435.735657,491.565277 
	C434.329834,494.243835 437.457550,496.003387 436.948578,498.653168 
	C436.500244,500.242218 435.512543,500.926025 434.203979,501.796875 
z"/>
<path fill="#12A5FA" opacity="1.000000" stroke="none" 
	d="
M420.646606,505.814880 
	C422.396088,505.977020 423.786987,505.973877 425.595093,505.981598 
	C426.179688,507.028046 425.569244,507.354828 424.351929,507.245239 
	C421.288025,508.474701 416.997986,509.058868 420.681488,513.763550 
	C421.351379,514.619141 420.542206,515.604553 419.628296,516.192322 
	C418.397003,516.984253 417.816437,518.190735 418.036255,519.576111 
	C418.995544,525.622192 414.842499,528.255554 410.278198,530.870422 
	C408.859772,528.823914 409.138031,526.381470 407.748718,524.375305 
	C406.460419,522.514893 407.602020,520.676208 409.118195,518.854492 
	C406.106628,519.003723 403.677063,519.429260 400.854858,519.434448 
	C396.894928,515.608521 393.161987,511.885773 395.430481,505.599609 
	C401.862061,503.043762 407.966187,499.849426 414.458801,504.561371 
	C416.143616,505.784088 418.346130,505.250397 420.646606,505.814880 
z"/>
<path fill="#18C2FC" opacity="1.000000" stroke="none" 
	d="
M400.766602,519.381836 
	C403.627045,517.011719 407.062012,518.485596 409.890961,517.120117 
	C410.388977,516.879761 411.241608,517.097839 411.458771,517.901733 
	C411.732269,518.913940 410.980896,519.437927 410.282837,519.812134 
	C407.375397,521.370789 407.554382,523.236572 409.735168,525.228027 
	C411.482300,526.823425 410.762299,528.471985 409.990234,530.516724 
	C409.230316,530.924011 408.535583,530.984619 407.499512,531.107544 
	C405.880341,527.578491 403.585480,524.567017 401.317383,521.183472 
	C400.685150,520.622986 400.508240,520.194946 400.766602,519.381836 
z"/>
<path fill="#0778E5" opacity="1.000000" stroke="none" 
	d="
M424.014587,507.443329 
	C424.566132,506.862762 425.121826,506.674835 425.844910,506.239685 
	C426.012268,505.992462 425.998718,506.000946 425.992889,506.005005 
	C428.630493,504.304749 431.384552,504.624847 434.582642,505.797485 
	C434.898712,511.124786 432.879120,513.502991 427.889404,513.806458 
	C423.390839,514.080200 425.277435,509.861420 424.014587,507.443329 
z"/>
<path fill="#12A5FA" opacity="1.000000" stroke="none" 
	d="
M434.273010,501.979584 
	C434.523315,501.218964 435.136902,500.429413 435.889008,499.373535 
	C437.334686,496.433685 439.505859,494.755554 442.582886,493.777039 
	C443.141571,494.143097 443.351776,494.451569 443.806335,494.905396 
	C441.470306,498.111664 438.374146,500.468903 434.273010,501.979584 
z"/>
<path fill="#12A5FA" opacity="1.000000" stroke="none" 
	d="
M435.259888,505.989563 
	C432.291779,506.027008 429.590546,506.020844 426.438202,506.011841 
	C427.110779,503.882385 429.115997,503.297272 431.639465,502.972900 
	C432.641754,504.770508 434.188690,504.974091 435.781189,505.112000 
	C435.887360,505.121216 435.981995,505.263458 436.082031,505.343872 
	C435.896942,505.544586 435.711884,505.745239 435.259888,505.989563 
z"/>
<path fill="#02ECFE" opacity="1.000000" stroke="none" 
	d="
M400.705322,518.872925 
	C400.991577,519.503601 401.003357,519.924805 401.034058,520.661743 
	C396.104431,520.271240 392.009674,517.329224 388.917755,514.065918 
	C384.030853,508.908112 378.892853,503.818268 375.036499,497.347351 
	C372.703125,493.962494 371.943237,489.789001 367.937073,487.566895 
	C367.530884,487.098328 367.388123,486.889526 367.079437,486.331848 
	C366.157440,481.939148 363.716797,477.667084 368.862854,474.289764 
	C374.600952,476.119720 377.400360,480.974457 381.080231,484.759918 
	C382.679382,486.404938 383.787079,488.459473 386.562347,489.175781 
	C388.410278,490.208588 389.214417,491.716644 390.360901,493.388672 
	C390.958466,494.526703 391.213684,495.422119 391.655121,496.610596 
	C392.598145,499.726898 393.814911,502.338837 395.755829,505.349243 
	C394.044464,511.385193 398.847443,514.468689 400.705322,518.872925 
z"/>
<path fill="#050E18" opacity="1.000000" stroke="none" 
	d="
M370.775696,497.813263 
	C373.260315,500.856659 375.552185,503.599335 377.998596,506.645447 
	C377.592377,509.949707 373.899933,510.371857 372.914276,513.460205 
	C372.653595,513.984680 372.534424,514.188293 372.184296,514.663330 
	C371.767792,515.084717 371.582245,515.234863 371.076050,515.546631 
	C369.821991,516.027832 368.875153,516.037048 367.581421,515.709534 
	C367.045654,515.454041 366.847443,515.320251 366.412872,514.917908 
	C366.045776,514.450745 365.914978,514.252136 365.621033,513.739258 
	C365.372192,513.207275 365.286560,512.989624 365.108337,512.436279 
	C364.931946,508.315308 363.658600,505.124542 360.144592,502.710510 
	C358.845520,501.547455 358.036041,500.381927 356.684418,499.240234 
	C355.387177,497.451050 354.875153,495.892670 356.361877,493.956421 
	C358.302551,492.732452 359.896271,493.140106 361.183929,494.327637 
	C362.871216,495.883789 364.524811,495.224396 366.603027,494.564209 
	C368.929108,494.587036 369.894806,495.882263 370.775696,497.813263 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M370.985504,497.751648 
	C369.852661,497.135040 368.736847,496.156067 367.318420,495.072296 
	C362.863770,492.942230 360.054504,489.525330 357.464417,485.461334 
	C357.414886,484.362762 357.697754,483.719482 358.413757,482.901550 
	C359.080750,482.432861 359.511444,482.270020 360.307373,482.175293 
	C361.536957,482.237701 362.292511,482.641083 363.235901,483.342041 
	C363.614380,483.658203 363.757568,483.789185 364.098816,484.120972 
	C364.421783,484.454010 364.546783,484.586212 365.052551,485.075165 
	C365.711517,485.624329 366.002716,485.794128 366.548584,486.021576 
	C367.104919,486.232544 367.393036,486.406952 367.817535,486.822815 
	C367.983093,487.016113 368.000000,487.000000 367.991821,487.008148 
	C368.123932,487.122620 368.264191,487.228943 368.385864,487.595947 
	C368.178192,488.172760 367.910004,488.314758 367.752319,488.369812 
	C368.097595,488.611969 368.230530,488.716797 368.522583,489.018799 
	C368.777405,489.353760 368.873047,489.491516 369.117767,489.831848 
	C369.381683,490.157745 369.496552,490.281158 369.816101,490.557251 
	C370.333221,490.882721 370.654144,491.038361 371.246338,491.298889 
	C372.750916,492.048859 373.060364,493.221313 373.136353,494.728638 
	C371.495697,495.098083 370.950104,495.992950 370.985504,497.751648 
z"/>
<path fill="#040914" opacity="1.000000" stroke="none" 
	d="
M378.695312,508.062683 
	C384.213562,512.427673 388.141754,518.137024 392.932922,523.510315 
	C393.587219,524.604858 393.624878,525.388000 392.655029,526.385132 
	C391.544983,526.939453 390.751953,526.989075 389.589355,526.690857 
	C387.968567,526.166443 388.532318,523.490173 386.111420,524.290405 
	C384.787384,524.728027 384.011444,523.222412 383.941345,522.082092 
	C383.672424,517.706787 380.757019,515.442322 377.283325,513.093872 
	C376.825806,511.061432 377.245941,509.581299 378.695312,508.062683 
z"/>
<path fill="#0D1D30" opacity="1.000000" stroke="none" 
	d="
M391.589111,526.533691 
	C392.096741,525.697327 392.531891,525.119629 393.029877,524.172119 
	C396.032684,527.353821 398.972656,530.905334 402.074768,534.775146 
	C401.409515,535.093506 400.582123,535.093567 399.343262,535.117188 
	C398.728424,535.215149 398.525055,535.289490 398.022797,535.241821 
	C396.937012,534.389954 396.101135,533.789917 394.595215,534.118225 
	C393.779480,534.230835 393.300995,534.273315 392.434753,534.319336 
	C389.913330,534.131348 387.542694,534.282776 387.354126,530.837708 
	C387.884308,529.449524 388.825439,529.171204 390.067932,528.815125 
	C390.847687,528.548828 391.452240,528.533936 391.558716,527.592651 
	C391.533844,527.149902 391.525238,526.971069 391.589111,526.533691 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M378.984344,507.609131 
	C378.680084,509.322693 378.326385,510.809113 377.934540,512.678589 
	C376.808838,514.248230 375.168884,514.353271 373.549683,515.237122 
	C373.005676,515.373352 372.778717,515.392273 372.228851,515.292419 
	C371.795471,514.971802 371.684937,514.770020 371.787292,514.296570 
	C371.117737,509.551239 375.910217,509.717834 377.834717,507.113892 
	C378.497009,506.942963 378.757568,507.087311 378.984344,507.609131 
z"/>
<path fill="#0EE7FD" opacity="1.000000" stroke="none" 
	d="
M367.821655,488.273407 
	C367.979340,488.014740 367.982635,487.515320 367.983154,487.265808 
	C372.889374,488.146637 373.905731,492.195862 374.956421,496.624329 
	C374.095947,496.921600 373.308868,496.682159 373.043457,495.325745 
	C372.424225,493.959167 372.144287,492.695709 370.605957,492.093323 
	C369.980713,491.851532 369.671204,491.624847 369.175659,491.169800 
	C368.970306,490.967651 368.971405,491.024414 368.999451,491.028809 
	C368.591339,490.586609 368.529236,489.983459 368.176514,489.192932 
	C367.997467,488.958801 367.989288,489.007477 368.013977,489.007812 
	C367.913757,488.849487 367.788879,488.690796 367.821655,488.273407 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M387.765808,529.786987 
	C387.681549,533.696838 390.374359,532.862732 392.684814,533.190674 
	C393.543091,533.543274 393.842346,534.507446 394.752625,533.416992 
	C396.444611,532.283386 397.933502,531.407227 397.980774,534.726257 
	C398.478638,535.805786 397.973694,536.208008 397.228790,536.813843 
	C396.475891,537.140747 395.971832,537.266846 395.302246,537.589233 
	C394.950989,537.841492 394.765320,537.897400 394.288818,537.959473 
	C389.526978,536.872375 385.673828,534.400024 381.311249,532.202881 
	C381.019470,531.992249 381.011719,532.030334 380.992615,532.033936 
	C381.453949,527.058594 384.626892,528.712646 387.765808,529.786987 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M381.110107,532.316162 
	C386.007874,531.956055 389.469635,535.449463 393.792297,537.696716 
	C391.744812,538.081238 389.688904,538.880920 387.318909,539.907349 
	C385.048798,537.562073 383.124756,535.101135 381.110107,532.316162 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M397.292603,536.975830 
	C397.243744,536.535461 397.507538,536.056274 397.876160,535.326233 
	C397.980957,535.075378 398.459045,535.074036 398.695435,535.107422 
	C398.922607,536.059326 398.575897,536.728516 397.292603,536.975830 
z"/>
<path fill="#AEF6FB" opacity="1.000000" stroke="none" 
	d="
M366.811829,514.059326 
	C366.914429,514.314270 366.941742,514.607910 367.058777,514.697571 
	C367.871490,516.021057 369.486298,516.083984 370.493408,517.465698 
	C371.279510,518.479431 371.672852,519.294250 371.425293,520.587646 
	C369.439026,522.123291 370.194092,523.675232 370.583313,525.306274 
	C371.419098,528.808655 372.129028,532.343994 372.781952,535.885803 
	C373.039062,537.280640 373.568115,538.871277 371.439880,539.905945 
	C371.070801,539.987366 370.695892,539.872498 370.504089,539.829956 
	C369.144226,538.287842 367.976196,536.788330 366.554016,535.099487 
	C364.557892,534.002747 363.368530,532.494934 361.920105,530.812012 
	C361.141846,529.731323 360.658661,528.825073 359.753601,527.848755 
	C359.259552,527.336182 358.976349,527.042297 358.470947,526.531067 
	C357.367340,525.403076 356.476868,524.500854 355.445496,523.279663 
	C354.247955,521.510315 353.085968,520.142090 351.532043,518.656677 
	C351.126099,518.251221 350.966675,518.084961 350.578186,517.655762 
	C350.208160,517.204346 350.067230,517.015869 349.640808,516.171509 
	C349.340240,515.272095 349.325104,515.028564 349.376923,514.420776 
	C349.549408,513.830505 349.654999,513.604553 349.986206,513.076721 
	C354.062042,509.321350 358.460724,509.310242 363.454712,510.833130 
	C364.558380,511.239502 365.144012,511.713470 365.739441,512.734375 
	C365.929840,513.067444 366.005646,513.023682 365.964233,513.035767 
	C366.226868,513.256470 366.490967,513.506592 366.811829,514.059326 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M372.776184,515.314209 
	C373.779755,513.095215 375.403870,512.916443 377.535614,513.053772 
	C382.421173,513.800659 384.611786,516.564941 384.886536,521.043823 
	C384.942261,521.952759 384.602386,523.358582 385.968842,523.406616 
	C387.531555,523.461487 386.725403,521.450073 387.732086,520.802856 
	C389.711090,521.837830 388.606354,523.748474 388.983582,525.618286 
	C386.464355,528.115662 383.668854,527.263000 380.572784,526.635742 
	C379.649963,526.355896 379.060364,526.151306 378.181702,526.452759 
	C377.781799,526.718384 377.625061,526.830933 377.204681,527.062683 
	C376.313293,526.405640 375.685547,525.629333 374.945618,524.572632 
	C374.618835,521.249573 372.511108,518.702209 372.776184,515.314209 
z"/>
<path fill="#12628E" opacity="1.000000" stroke="none" 
	d="
M378.873108,525.196045 
	C382.085815,526.193970 385.119873,525.975342 388.559937,526.006226 
	C389.662231,526.065735 390.332520,526.127197 391.332214,526.231873 
	C391.661591,526.275085 391.787109,526.717834 391.846191,526.940186 
	C392.529999,527.765686 392.699554,528.484558 392.205811,529.618713 
	C390.933960,529.992798 389.907684,530.057861 388.498230,530.137329 
	C385.758698,530.287354 383.146179,528.827271 381.066681,531.652893 
	C379.703094,530.617859 378.432678,529.198120 377.051636,527.480225 
	C376.941040,527.181946 377.015320,526.937805 377.075714,526.825439 
	C377.633575,526.268311 378.016357,525.707642 378.873108,525.196045 
z"/>
<path fill="#29648A" opacity="1.000000" stroke="none" 
	d="
M372.733521,515.043213 
	C372.911987,518.042969 377.536041,519.954224 374.902710,523.914551 
	C373.828644,523.260925 372.823822,522.229675 371.548798,521.050049 
	C370.861725,520.169067 370.444855,519.436340 369.932190,518.400879 
	C369.934113,517.217834 369.893677,516.296387 370.844604,515.384216 
	C371.106079,515.175964 371.095276,515.116333 371.124390,515.107910 
	C371.276276,514.935303 371.399078,514.771240 371.734497,514.829163 
	C372.121918,515.050598 372.296661,515.049988 372.733521,515.043213 
z"/>
<path fill="#0BC3FC" opacity="1.000000" stroke="none" 
	d="
M335.216278,547.686768 
	C332.928619,549.711060 330.498077,550.196228 327.511047,550.220581 
	C327.033356,544.859863 328.449432,539.763245 330.448486,534.748596 
	C331.314148,532.577087 329.328522,531.199829 328.150116,529.301514 
	C326.126282,526.698914 323.678986,527.086060 321.235718,527.593628 
	C319.020386,528.053894 316.932465,529.284668 314.209290,528.481323 
	C312.937347,527.311707 312.856964,526.030029 312.631561,524.412659 
	C312.558655,523.303833 312.415863,522.578125 312.312927,521.479675 
	C312.356079,520.873840 312.405914,520.635071 312.634918,520.078613 
	C313.734039,518.929016 314.920898,518.658142 316.364990,518.107056 
	C317.365479,517.751099 318.045166,517.553040 319.056244,517.222046 
	C320.568115,516.838562 321.745087,516.807617 323.260071,517.129150 
	C325.000854,517.742615 325.835114,519.374084 327.893982,519.255310 
	C328.674988,519.231567 329.119141,519.282837 329.870483,519.526611 
	C331.241791,520.543701 332.111328,521.623352 333.446533,522.724976 
	C335.084320,524.719604 336.217377,526.560303 335.922241,529.283203 
	C335.663635,530.554321 335.341888,531.440918 335.112976,532.705627 
	C334.305237,535.420349 334.054901,537.889404 333.600159,540.659790 
	C332.998413,542.300171 331.374054,543.878601 334.627777,544.545593 
	C335.698395,545.502014 335.804138,546.408325 335.216278,547.686768 
z"/>
<path fill="#0FCFFB" opacity="1.000000" stroke="none" 
	d="
M313.664124,527.948303 
	C316.353210,528.089417 318.340576,526.796082 320.529846,526.344482 
	C323.233276,525.786743 326.013947,525.379211 327.934631,528.630371 
	C322.120026,527.770996 317.941376,529.976013 316.015686,535.697510 
	C316.435455,537.170288 315.818909,537.713318 314.592468,538.106384 
	C314.259003,538.104736 314.116302,538.053650 314.046173,538.024231 
	C314.313690,534.344788 309.913605,535.905090 309.012939,533.182983 
	C307.858368,531.133179 309.322327,530.256836 310.375244,528.926575 
	C311.444794,528.133179 312.341614,527.888550 313.664124,527.948303 
z"/>
<path fill="#0DA5E9" opacity="1.000000" stroke="none" 
	d="
M305.299744,549.826599 
	C305.045868,548.480774 304.332764,547.882324 302.504456,548.268799 
	C302.030182,545.242249 304.323059,544.417603 306.810059,543.304443 
	C308.115173,541.559875 309.474792,540.856384 311.665558,541.727478 
	C312.227509,542.000183 312.445526,542.046936 312.982910,542.192871 
	C313.545959,544.367126 312.912567,546.136475 311.109741,547.757812 
	C310.772736,547.899902 310.338257,547.947266 310.129639,548.013062 
	C308.205292,547.859131 306.958557,548.923462 305.299744,549.826599 
z"/>
<path fill="#0FCFFB" opacity="1.000000" stroke="none" 
	d="
M312.006470,541.558960 
	C310.593811,542.287903 309.178162,542.622375 307.400848,543.002686 
	C306.817383,542.619080 306.488586,542.211914 306.393921,541.756042 
	C306.112366,540.400269 303.671082,539.930359 304.715790,538.162231 
	C305.710602,536.478638 307.593811,537.066162 309.148163,537.020447 
	C309.922363,536.997620 310.705872,537.290100 311.751282,537.719971 
	C312.012726,539.054810 312.008087,540.109680 312.006470,541.558960 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M310.991302,548.194336 
	C311.494049,546.223145 312.215363,544.546387 313.119507,542.580811 
	C314.612000,543.356934 315.980896,542.720886 317.392303,542.070251 
	C317.656036,544.245911 315.432495,545.385254 316.079285,547.635986 
	C314.436371,547.786316 312.983917,549.726501 310.991302,548.194336 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M314.448425,538.341797 
	C314.763641,537.590210 315.268250,537.075684 315.895325,536.316772 
	C316.470367,536.024109 316.923035,535.975708 317.715637,535.895142 
	C318.638550,535.977295 319.154114,536.226135 319.772430,536.858887 
	C318.315155,538.059692 316.709808,539.150269 314.448425,538.341797 
z"/>
<path fill="#0FCFFB" opacity="1.000000" stroke="none" 
	d="
M319.944489,536.792297 
	C319.412903,536.856934 318.872375,536.627441 318.193726,536.130493 
	C319.103027,534.829346 319.632874,535.327576 319.944489,536.792297 
z"/>
<path fill="#0BC3FC" opacity="1.000000" stroke="none" 
	d="
M325.324585,553.198059 
	C325.553741,553.223877 325.365906,553.655640 325.214111,553.835571 
	C324.933807,553.783142 324.805298,553.550781 324.676758,553.318481 
	C324.816315,553.269775 324.955841,553.221008 325.324585,553.198059 
z"/>
<path fill="#1391DB" opacity="1.000000" stroke="none" 
	d="
M335.190857,548.237488 
	C334.760040,547.059326 334.546600,546.149414 334.050903,545.015991 
	C333.922272,543.776855 334.660553,543.354675 335.960754,542.984985 
	C339.104919,543.095825 341.008484,544.033264 340.244324,547.652222 
	C339.938049,548.194458 339.837402,548.347534 339.547455,548.701782 
	C338.006775,549.115906 336.665741,549.226257 335.190857,548.237488 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M363.974091,534.644531 
	C359.594025,536.636536 365.068329,538.866577 363.270264,540.827393 
	C362.092438,542.469788 361.220398,543.983459 358.793121,543.727661 
	C357.365509,543.352539 356.744598,542.212219 355.249084,542.019653 
	C353.311584,541.979919 352.096619,540.820557 350.264435,540.367676 
	C347.751801,538.701660 348.199646,536.906738 349.714233,534.767700 
	C350.454102,534.226562 350.938263,534.020630 351.841431,533.789673 
	C354.648987,533.448608 357.002319,532.759277 359.858795,532.665405 
	C361.711731,532.755188 363.131714,532.882324 363.974091,534.644531 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M357.996552,543.151001 
	C360.057556,543.322205 361.237579,542.312561 362.715240,541.160400 
	C363.016235,542.795227 364.754242,544.456970 363.192383,546.616028 
	C362.544861,546.946960 362.030579,546.965149 361.130890,546.988281 
	C358.348541,546.964233 357.474365,545.637878 357.996552,543.151001 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M364.298035,535.040039 
	C363.184967,533.896362 361.941284,534.094849 360.511047,533.846680 
	C358.804688,532.674011 359.961945,531.831604 360.739075,530.672119 
	C361.162201,530.292419 361.346771,530.158264 361.858826,529.924561 
	C363.495209,531.305359 364.804077,532.785767 366.206360,534.588196 
	C365.766205,534.944702 365.232544,534.979187 364.298035,535.040039 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M349.809052,534.866455 
	C349.961731,536.745361 348.223755,538.346985 350.612488,539.905396 
	C351.309723,541.997131 349.926727,542.651184 348.242096,543.174561 
	C346.864532,543.037354 345.823151,543.055176 344.392303,543.038574 
	C342.607574,541.791626 342.759338,539.979858 342.160278,538.006348 
	C342.029205,536.679565 342.184387,535.823853 342.968018,534.719055 
	C345.388031,533.429504 347.461975,533.362549 349.809052,534.866455 
z"/>
<path fill="#0F62A1" opacity="1.000000" stroke="none" 
	d="
M342.916199,537.808228 
	C344.462341,539.220215 343.851746,540.803345 344.001465,542.624390 
	C341.712189,543.761108 342.568787,546.734985 340.346741,547.899292 
	C340.119171,545.672058 339.412811,543.941467 336.269592,543.824036 
	C335.917633,543.286133 336.100616,542.868042 336.755737,542.344971 
	C339.814697,541.763245 340.295502,538.555786 342.916199,537.808228 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M347.961945,543.275024 
	C348.799377,542.207947 349.692871,541.396362 350.735809,540.325195 
	C352.573517,538.790283 353.271362,541.389160 355.050476,541.084961 
	C355.568207,541.565918 355.604767,542.017639 355.226013,542.738403 
	C354.100525,543.524048 353.991913,544.387024 353.997437,545.633179 
	C353.695587,546.544556 353.321045,547.046387 352.348267,547.153625 
	C351.887360,545.116272 350.905396,544.029480 348.525818,544.029907 
	C348.120575,543.863892 348.069275,543.697205 347.961945,543.275024 
z"/>
<path fill="#071F39" opacity="1.000000" stroke="none" 
	d="
M355.240356,543.218445 
	C355.055786,542.575806 355.123932,542.155273 355.285889,541.429199 
	C356.530579,540.922852 357.543579,541.025269 358.164368,542.615112 
	C357.897766,544.692078 359.175903,545.627869 360.474731,546.840942 
	C360.000793,548.136475 359.435913,550.157654 357.910614,547.598083 
	C357.089996,546.221008 356.298035,544.826904 355.240356,543.218445 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M352.145081,547.370667 
	C352.513672,546.756836 352.986633,546.448059 353.729340,546.053589 
	C354.332062,546.775024 354.665070,547.582153 354.993378,548.717407 
	C353.688965,549.362000 353.059387,548.338501 352.145081,547.370667 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M356.947632,550.738464 
	C355.900024,551.227295 355.259064,550.685669 354.930054,549.348389 
	C355.599701,549.478516 356.244293,549.956482 356.947632,550.738464 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M145.336395,435.401672 
	C142.963730,434.982635 140.942307,434.804565 138.512268,434.483948 
	C137.712967,433.850037 137.664062,433.327148 138.295105,432.514160 
	C144.629089,430.870667 150.725113,432.018097 157.145874,431.521484 
	C157.781250,431.438843 158.029510,431.388733 158.648956,431.318665 
	C160.208298,431.472565 161.368408,431.331360 162.865204,430.921631 
	C163.706406,430.795685 164.194412,430.753998 165.060455,430.707642 
	C165.949295,430.653229 166.462112,430.635193 167.371918,430.629608 
	C169.697983,430.650940 171.639206,430.512634 173.553635,430.728180 
	C175.050095,430.896698 176.959503,430.675873 176.905777,433.404724 
	C176.342484,434.571503 174.369598,434.242523 174.929474,436.213928 
	C173.458191,437.269409 172.098190,437.291351 170.341156,437.362366 
	C168.589111,437.356995 167.243958,437.444000 165.492371,437.454285 
	C159.989578,437.031830 154.934769,435.980591 149.362686,436.397827 
	C147.799896,436.402710 146.699020,436.218140 145.336395,435.401672 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M149.268433,457.113831 
	C145.800125,455.054352 142.493591,453.378418 138.914764,451.467651 
	C140.276138,448.352509 143.637192,447.719727 145.960800,445.308838 
	C147.019257,444.416901 147.867355,444.884552 148.996674,445.580566 
	C150.285309,446.860138 150.832932,448.209717 151.793213,449.730347 
	C153.057922,452.736237 156.234009,454.594788 154.887970,458.378510 
	C152.625778,459.324158 150.791351,459.485016 149.268433,457.113831 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M144.985153,435.525879 
	C146.054199,435.118958 147.123230,435.077209 148.587219,435.112946 
	C150.549927,436.597870 151.063232,438.668915 152.372986,440.628784 
	C152.788773,441.516724 152.977859,442.137695 153.295776,443.048096 
	C153.459991,443.547760 153.517456,443.749969 153.612610,444.264832 
	C153.623184,445.228729 153.399124,445.792664 152.636475,446.381470 
	C152.155975,446.553772 151.951630,446.584717 151.439423,446.580811 
	C150.735809,446.426025 150.353989,446.272095 149.722534,445.921570 
	C149.279129,445.658722 149.101639,445.552643 148.660858,445.279602 
	C148.045776,444.879974 147.720993,444.614471 147.226410,444.063477 
	C145.371475,442.536743 143.348587,442.923920 141.234695,442.798767 
	C139.228592,443.007446 137.472794,443.007446 134.832993,443.007446 
	C137.308090,439.838196 139.338516,437.711914 142.769974,438.442108 
	C145.408752,439.003632 144.827408,437.234161 144.985153,435.525879 
z"/>
<path fill="#1D98D1" opacity="1.000000" stroke="none" 
	d="
M138.199997,432.795532 
	C137.989304,433.401001 138.013977,433.670685 138.088135,434.139374 
	C131.759949,434.186310 125.416222,434.031158 118.616859,433.846313 
	C119.076630,432.665558 120.531731,433.285950 121.896118,432.571106 
	C122.207588,432.171631 122.259834,431.958740 122.610046,431.606384 
	C123.977516,431.279572 125.084648,431.487244 126.467247,431.065643 
	C128.637039,430.562775 130.444778,429.957214 132.734253,429.985840 
	C134.607452,430.275909 136.086334,430.623047 137.785812,431.513550 
	C138.198029,431.985992 138.299713,432.224457 138.199997,432.795532 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M141.340637,443.042816 
	C143.283783,441.467072 145.569077,441.300781 147.943787,443.431885 
	C147.698624,444.311493 147.207275,444.531708 146.209549,444.220398 
	C144.458847,443.688416 143.077866,443.383301 141.340637,443.042816 
z"/>
<path fill="#0B5794" opacity="1.000000" stroke="none" 
	d="
M145.890778,444.234497 
	C146.334015,443.967346 146.828201,443.941193 147.687744,443.850586 
	C148.353775,444.013000 148.654449,444.239807 149.122955,444.694122 
	C149.367477,445.082458 149.444168,445.243256 149.505829,445.671906 
	C149.399567,446.094421 149.308319,446.249023 148.954315,446.344635 
	C147.987381,445.917389 147.283234,445.549133 146.300995,445.071198 
	C146.022919,444.961487 145.941727,444.475525 145.890778,444.234497 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M131.826645,448.545898 
	C131.632477,448.792908 131.339188,448.705902 130.959320,448.265747 
	C131.148819,448.061554 131.433731,448.161316 131.826645,448.545898 
z"/>
<path fill="#08AFF3" opacity="1.000000" stroke="none" 
	d="
M170.387589,494.103058 
	C169.701752,493.293701 169.465012,492.445862 169.102295,491.288391 
	C168.976318,490.978760 168.970932,490.791748 168.965210,490.698364 
	C169.514175,490.592072 170.060074,490.520203 170.805130,490.184326 
	C171.468704,489.966461 171.920151,489.925598 172.691284,489.768860 
	C173.365952,489.552216 173.715652,489.435638 174.267151,489.487274 
	C176.038086,489.063416 175.484009,488.455841 174.492142,487.805359 
	C173.204376,486.960785 171.235718,486.870880 171.100708,484.407532 
	C171.963959,482.829742 172.493607,481.479187 173.034866,479.812256 
	C173.712540,479.445221 174.151428,479.411713 174.910400,479.606873 
	C177.053513,482.126068 179.766205,482.218872 182.759583,482.445557 
	C185.712570,481.698395 188.156052,482.281158 190.863007,483.542877 
	C191.993805,485.078918 191.629288,486.369751 190.987549,488.019501 
	C189.835220,489.862213 188.307922,490.137604 186.354553,490.272614 
	C184.623535,490.332855 183.311096,489.747070 182.133774,489.925354 
	C183.318680,490.176086 184.079147,490.680176 184.649475,491.904205 
	C184.776321,492.706512 184.706482,493.168396 184.346802,493.924408 
	C183.690063,494.490051 183.211411,494.593079 182.356598,494.380249 
	C181.641998,494.213745 181.269791,494.207581 180.618713,494.184021 
	C179.875336,494.471252 179.373215,494.557861 178.539307,494.160889 
	C178.025711,493.883698 177.806259,493.871979 177.260712,493.811829 
	C175.905624,493.970520 174.882660,494.054413 173.641815,493.419983 
	C172.544373,493.505615 171.690536,493.785126 170.387589,494.103058 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M173.214050,479.583984 
	C172.362900,481.233215 176.289978,484.097717 171.504089,484.108643 
	C168.717789,482.694855 165.308975,482.992126 163.946442,479.428040 
	C164.438080,478.716614 165.003555,478.348236 165.914856,477.943054 
	C168.829132,476.847382 171.111908,477.341827 173.214050,479.583984 
z"/>
<path fill="#071A2D" opacity="1.000000" stroke="none" 
	d="
M157.002609,483.603943 
	C156.567505,483.997192 156.131622,483.991058 155.369125,483.969513 
	C154.756241,483.107422 154.469986,482.260773 154.049377,481.098785 
	C153.915024,480.783478 153.951920,480.378296 153.983887,480.177490 
	C154.015839,479.976685 154.007141,480.019745 153.985184,480.021729 
	C154.220749,479.808838 154.460205,479.575317 154.855743,479.142242 
	C155.027451,478.958832 155.016891,479.019073 154.986374,479.016998 
	C155.089523,478.913879 155.223190,478.812805 155.577820,478.831543 
	C157.506058,479.999603 156.858673,481.713898 157.002609,483.603943 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M170.734680,489.983490 
	C170.525116,490.224030 170.032974,490.440765 169.250153,490.631256 
	C169.457001,490.389893 169.954544,490.174774 170.734680,489.983490 
z"/>
<path fill="#074D75" opacity="1.000000" stroke="none" 
	d="
M155.758347,478.758301 
	C155.798798,478.951324 155.375748,478.961060 155.165802,478.987976 
	C155.059692,478.610535 155.155380,478.192322 155.758347,478.758301 
z"/>
<path fill="#074D75" opacity="1.000000" stroke="none" 
	d="
M154.758499,479.029572 
	C154.823532,479.231262 154.619614,479.503723 154.189453,479.899933 
	C154.138657,479.715912 154.314102,479.408112 154.758499,479.029572 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M174.252731,489.489716 
	C174.149780,489.703461 173.825363,489.735626 173.255951,489.710388 
	C173.351074,489.538055 173.691177,489.423096 174.252731,489.489716 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M156.950409,470.985352 
	C157.114151,468.999329 155.051361,469.488403 154.009338,468.341156 
	C156.101089,468.369476 156.895462,464.893311 159.728149,465.588501 
	C160.019424,465.215027 160.067734,464.977051 160.454498,464.602234 
	C161.551239,464.392639 162.229019,464.633575 163.176300,465.199524 
	C165.236954,467.526978 168.613953,468.311462 168.695435,472.134216 
	C168.503418,472.715027 168.383514,472.933350 167.963715,473.379364 
	C167.428604,473.698303 167.193405,473.789551 166.584167,473.945740 
	C163.079468,474.010773 160.399872,472.510590 157.278931,471.218292 
	C156.961060,471.015533 156.969666,470.985565 156.950409,470.985352 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M161.051849,465.128387 
	C160.765121,465.394562 160.370483,465.456238 160.170807,465.454651 
	C159.793610,465.187805 159.561340,464.985382 159.101196,464.690186 
	C158.507690,463.494080 157.856598,462.641479 156.603149,461.874695 
	C155.566086,461.099182 155.134827,460.325745 155.146362,459.018188 
	C155.224396,455.315308 152.030716,453.644073 150.944397,450.461792 
	C150.525848,449.163452 151.076035,448.760681 152.244812,448.537048 
	C153.628479,448.956512 154.003769,449.898529 154.701508,451.035126 
	C157.091080,454.447327 159.831009,457.149414 161.862183,460.825195 
	C162.020767,461.432495 162.063232,461.682861 162.114990,462.318298 
	C162.057922,463.494141 161.838165,464.229095 161.051849,465.128387 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M154.791046,458.635315 
	C155.663559,459.398102 156.111984,460.116364 156.786987,460.963501 
	C157.370041,461.573730 157.502350,462.110352 157.140808,463.035492 
	C153.905807,462.180573 150.940567,460.992401 147.696030,459.567688 
	C147.931366,458.732300 148.445999,458.133423 149.033661,457.132416 
	C150.483353,458.415619 152.807312,457.422729 154.791046,458.635315 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M157.069870,463.595764 
	C156.907059,462.862274 156.943039,462.355774 156.996307,461.470825 
	C158.238739,461.582306 158.907120,462.468872 158.936646,464.169464 
	C158.374924,464.297333 157.821793,464.060059 157.069870,463.595764 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M106.967239,416.404510 
	C106.561790,414.956787 106.234772,413.860107 105.865417,412.415344 
	C106.481239,410.860748 107.584076,410.446594 109.219673,410.414734 
	C109.772751,410.582153 109.975632,410.692627 110.375397,411.079926 
	C110.724815,411.767273 110.831947,412.188629 110.917175,412.921112 
	C111.659172,414.872009 113.350662,414.416473 114.913239,415.011536 
	C115.444046,415.188202 115.652954,415.275238 116.154457,415.540955 
	C119.339622,418.995361 124.228699,419.950592 126.282364,424.538025 
	C125.658524,425.924103 124.568848,426.399902 123.363190,427.265198 
	C122.841858,427.501129 122.619751,427.564362 122.050743,427.637512 
	C118.994949,427.288757 116.573685,424.165497 113.249176,426.959106 
	C110.978477,423.664307 109.012070,420.209930 106.967239,416.404510 
z"/>
<path fill="#090A10" opacity="1.000000" stroke="none" 
	d="
M112.957275,427.454468 
	C112.898842,424.641357 113.920807,423.372772 116.472908,424.323761 
	C118.255859,424.988159 119.933594,425.934906 122.005478,426.905304 
	C122.782356,427.649384 122.901230,428.321533 122.780731,429.379303 
	C122.482109,430.399597 122.065613,430.943604 121.256577,431.620483 
	C119.560600,431.939606 118.120224,432.027252 116.248322,432.144958 
	C114.867744,430.713440 113.918709,429.251831 112.957275,427.454468 
z"/>
<path fill="#10B2F6" opacity="1.000000" stroke="none" 
	d="
M156.961456,471.375153 
	C160.302612,470.517365 163.091751,472.724487 166.639069,473.121399 
	C167.170670,473.353729 167.354691,473.385468 167.808746,473.342834 
	C168.078796,473.268463 168.091248,473.130554 168.159821,473.120972 
	C168.499588,472.734375 168.859207,472.500580 169.654755,472.462830 
	C171.204468,472.885559 172.263397,473.738525 173.935867,473.770325 
	C174.901703,473.836304 175.539413,473.931396 176.486237,474.123474 
	C178.387909,474.678650 179.908707,475.457367 181.955994,475.300476 
	C183.329819,475.252716 184.262726,475.797089 185.582428,475.948151 
	C186.895615,475.850281 187.842392,475.411255 189.177673,475.410248 
	C189.684540,475.534637 189.879852,475.620453 190.324966,475.906891 
	C193.498093,478.199738 196.203720,474.529510 199.331757,476.075195 
	C199.779312,476.841492 199.901260,477.340515 199.933777,478.266418 
	C199.793335,479.473907 199.614777,480.266022 199.474396,481.066437 
	C198.593323,486.089813 197.612549,486.640778 192.303772,484.730469 
	C190.888031,481.988647 191.972122,481.473938 193.028717,481.621307 
	C190.914352,482.040192 187.633957,482.833313 183.941833,482.133057 
	C180.761383,482.284271 178.123154,481.688965 175.283768,480.247681 
	C174.583771,479.993195 174.210861,479.991943 173.558609,479.992767 
	C171.466049,478.406738 168.718170,479.909485 166.617996,477.997437 
	C163.712662,475.017975 159.936005,473.980957 156.961456,471.375153 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M193.301086,502.040588 
	C189.849014,498.083130 186.852493,501.873627 183.406052,501.971252 
	C182.654739,501.614929 182.496521,501.194366 182.708862,500.379395 
	C183.769363,499.990356 184.607376,499.833099 184.941925,498.112366 
	C185.907898,495.702454 186.303070,493.621887 188.652313,492.530640 
	C189.403793,492.291870 189.849869,492.243561 190.633713,492.319458 
	C191.438400,492.536316 192.105896,492.682495 192.245651,493.068298 
	C193.133667,495.519836 193.717529,494.095306 194.628113,492.755676 
	C195.338165,492.400635 195.786591,492.342896 196.580353,492.468933 
	C197.523148,492.940491 197.966293,493.484192 198.652679,494.284119 
	C199.214691,494.902679 199.540237,495.258026 200.122040,495.887451 
	C203.261353,500.968994 202.806015,501.954102 197.482773,502.337219 
	C196.200333,502.429504 194.906372,502.606842 193.301086,502.040588 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M182.756607,499.780518 
	C182.880325,500.485809 182.886505,500.909393 182.955414,501.645691 
	C182.611069,502.269226 182.204010,502.580109 181.552032,502.948578 
	C180.234436,502.961945 179.160187,502.281708 179.520569,501.396332 
	C179.977097,500.274780 180.748764,498.699738 182.756607,499.780518 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M173.295380,493.675171 
	C174.465240,492.883911 175.525116,492.764038 176.748779,493.545807 
	C176.334824,495.196228 174.767654,495.080872 173.391220,495.864624 
	C173.113266,495.341553 173.152908,494.732880 173.295380,493.675171 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M178.146240,494.245453 
	C178.711990,493.941193 179.178802,493.986969 179.992737,494.099670 
	C181.291565,496.426147 178.454102,496.371155 178.515213,498.854675 
	C177.648804,496.761047 177.677963,495.681061 178.146240,494.245453 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M182.018066,494.493896 
	C182.436569,494.083221 182.858932,493.946472 183.614624,493.758179 
	C185.023849,493.745758 185.415054,494.394867 185.275986,495.772766 
	C184.349884,496.721771 183.529083,496.726013 182.345657,496.135712 
	C182.016891,495.498444 182.019394,495.133118 182.018066,494.493896 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M182.115295,496.178894 
	C182.736465,495.894257 183.458542,495.924744 184.541901,495.966980 
	C185.256317,496.239014 185.452820,496.591187 185.435852,497.327942 
	C185.356705,497.633728 185.126053,497.870331 185.009827,497.989746 
	C183.767212,497.958588 182.803558,497.538208 182.115295,496.178894 
z"/>
<path fill="#040914" opacity="1.000000" stroke="none" 
	d="
M121.301620,431.958984 
	C121.193573,431.328705 121.386177,430.805389 121.823822,430.132660 
	C123.104553,429.907166 123.408638,430.546295 123.288704,431.770050 
	C123.104378,432.120422 122.637054,432.277832 122.396202,432.331177 
	C121.970985,432.278320 121.786629,432.172119 121.301620,431.958984 
z"/>
<path fill="#19C7F4" opacity="1.000000" stroke="none" 
	d="
M78.704620,308.233154 
	C78.939919,304.266968 78.965218,300.580414 78.991211,296.431915 
	C79.145561,295.851013 79.299217,295.732056 79.404808,295.325562 
	C79.356743,295.038086 79.637108,294.995453 79.775620,294.965088 
	C82.278557,293.859863 83.091949,295.659454 83.072014,297.205475 
	C83.013725,301.726166 85.144409,305.650360 86.050896,310.276245 
	C85.960495,311.634064 85.620712,312.556213 85.479965,313.856567 
	C85.495811,314.418304 85.514938,314.641632 85.612076,315.192505 
	C85.742950,315.739136 85.795807,315.958191 85.917465,316.509521 
	C86.169983,317.964722 86.171562,319.100220 86.233444,320.572418 
	C86.255318,321.363373 86.255013,321.814453 86.249687,322.601379 
	C86.249931,323.601593 86.212685,324.265076 86.209030,325.255585 
	C86.206017,326.011047 86.195351,326.440094 86.176865,327.184143 
	C86.173180,327.707336 86.170479,327.915436 86.163376,328.432831 
	C86.156593,329.151489 86.166351,329.560608 86.241226,330.273956 
	C86.343880,330.781586 86.393852,330.984711 86.531815,331.497131 
	C86.671432,332.020325 86.723053,332.234192 86.811668,332.782349 
	C86.845055,333.827728 86.672096,334.488251 85.964180,335.282562 
	C83.313995,335.721252 81.182213,335.544464 80.328384,332.370361 
	C80.049202,330.917542 79.913193,329.804138 79.646454,328.290161 
	C79.546799,327.284149 79.524719,326.686707 79.186630,325.832397 
	C79.081909,321.684357 79.042694,317.830597 78.946442,313.526550 
	C78.756012,312.886475 78.622604,312.696716 78.324677,312.198608 
	C77.953812,311.208038 77.921211,310.512238 78.077560,309.466675 
	C78.269760,308.921234 78.382187,308.717010 78.704620,308.233154 
z"/>
<path fill="#2AD5F9" opacity="1.000000" stroke="none" 
	d="
M80.131958,332.460724 
	C81.316307,333.890015 83.347610,334.211487 85.477509,334.990692 
	C86.039688,335.228729 86.268433,335.410126 86.713730,335.972595 
	C87.149094,340.042755 88.862556,343.651886 87.203995,347.719666 
	C85.116447,347.940857 84.413681,345.454620 82.041916,346.019592 
	C81.172874,341.644653 80.625793,337.267578 80.131958,332.460724 
z"/>
<path fill="#0F62A1" opacity="1.000000" stroke="none" 
	d="
M78.408279,311.391510 
	C78.656693,311.915039 78.753326,312.135498 78.869690,312.716125 
	C76.841904,313.074432 74.794388,313.072571 72.305359,313.054199 
	C71.506760,312.466064 71.646332,311.545502 70.438782,311.285522 
	C70.161224,310.008698 70.148033,308.831970 70.313507,307.357697 
	C71.083511,307.745087 71.971275,308.216339 72.593269,307.527283 
	C74.777832,305.107208 76.451759,306.667419 78.559326,307.999329 
	C78.934212,308.168549 78.953789,308.383575 78.850906,308.898438 
	C78.298927,309.760376 78.086945,310.376801 78.408279,311.391510 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M78.217758,332.661621 
	C76.495811,334.832489 74.119194,333.774231 71.598862,334.197449 
	C71.114944,333.728180 71.049492,333.242310 70.993660,332.389374 
	C73.370811,332.123718 75.738350,332.225098 78.217758,332.661621 
z"/>
<path fill="#0C1929" opacity="1.000000" stroke="none" 
	d="
M70.179626,311.460968 
	C71.202606,310.798584 72.196556,309.271820 73.209389,310.176819 
	C74.221390,311.081085 72.541161,311.669525 72.016388,312.747192 
	C71.863838,313.037689 71.487053,313.024689 71.299652,313.006165 
	C70.803108,312.570618 70.493965,312.153595 70.179626,311.460968 
z"/>
<path fill="#1174A3" opacity="1.000000" stroke="none" 
	d="
M75.290405,345.849884 
	C74.535660,345.044861 74.946831,344.181000 75.711517,343.143616 
	C76.362038,343.939789 76.125122,344.823700 75.290405,345.849884 
z"/>
<path fill="#1174A3" opacity="1.000000" stroke="none" 
	d="
M77.318466,340.894775 
	C76.647644,340.041840 76.903351,339.130127 77.704208,338.100464 
	C77.906372,338.886688 77.777000,339.820312 77.318466,340.894775 
z"/>
<path fill="#1174A3" opacity="1.000000" stroke="none" 
	d="
M76.319794,342.986023 
	C76.104073,342.384857 76.229385,341.734711 76.690987,341.029846 
	C76.905128,341.629120 76.782982,342.283081 76.319794,342.986023 
z"/>
<path fill="#1174A3" opacity="1.000000" stroke="none" 
	d="
M78.126877,337.889221 
	C78.107437,337.615082 78.240967,337.173798 78.567314,336.614319 
	C78.600029,336.904755 78.439926,337.313385 78.126877,337.889221 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M74.187469,324.992249 
	C74.215324,325.500946 74.101318,325.717407 73.745026,325.959534 
	C73.321709,326.113831 73.074013,326.207306 72.448898,326.177246 
	C72.408325,325.631927 72.745171,325.210083 73.340607,324.684387 
	C73.770233,324.632050 73.941254,324.683563 74.187469,324.992249 
z"/>
<path fill="#08101D" opacity="1.000000" stroke="none" 
	d="
M79.090225,325.847839 
	C79.292839,326.122162 79.464554,326.706268 79.575989,327.589966 
	C79.363594,327.312256 79.211464,326.734924 79.090225,325.847839 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M70.244942,328.060669 
	C70.035583,327.792480 70.074539,327.520264 70.220963,326.847992 
	C70.667091,326.546539 71.005768,326.645142 71.791656,326.996399 
	C71.992424,327.476440 71.745964,327.703796 71.244736,327.993591 
	C70.989967,328.056030 70.493263,328.056641 70.244942,328.060669 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M71.971344,326.246887 
	C72.320984,326.050201 72.570488,326.046661 73.194702,326.031738 
	C73.313873,326.345123 73.058334,326.669922 72.520844,327.121887 
	C72.238892,327.249084 72.052658,327.058807 71.955559,326.966858 
	C71.858459,326.874939 71.871223,326.440033 71.971344,326.246887 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M75.084900,323.799866 
	C74.952713,323.569336 75.140511,323.400146 75.328308,323.230957 
	C75.353836,323.441071 75.379364,323.651154 75.084900,323.799866 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M73.762550,324.750244 
	C73.783630,324.301147 74.018265,324.073547 74.534012,323.818085 
	C74.764908,323.738495 74.914482,323.908173 74.991661,323.991608 
	C75.030609,324.414490 74.890839,324.705078 74.456100,325.098145 
	C74.262665,325.249420 73.925896,324.919983 73.762550,324.750244 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M82.029335,352.180420 
	C82.268333,352.102325 82.467834,352.284271 82.562538,352.740967 
	C82.293060,352.812256 82.137100,352.620483 82.029335,352.180420 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M124.174698,359.878845 
	C117.869438,359.937012 111.686005,358.948822 105.248703,361.184265 
	C103.508446,362.005737 102.184692,362.740204 100.276886,362.989319 
	C99.386604,363.073273 98.877518,363.058685 97.993851,362.916992 
	C95.162720,361.894714 92.592979,362.820038 89.775040,362.203613 
	C89.270729,360.923920 89.097496,359.829956 88.959412,358.400055 
	C91.081558,355.437653 95.225456,358.294830 97.151291,354.722351 
	C96.629105,352.227783 97.022766,350.423767 99.526443,349.153107 
	C106.585114,347.327515 113.231415,345.469971 120.329620,346.100677 
	C125.450600,346.555664 130.134933,349.189514 135.755112,348.879333 
	C136.882675,349.128632 137.588150,349.419678 138.629211,349.868103 
	C139.852448,350.419769 140.743103,350.811676 141.841721,351.565521 
	C142.553955,353.239960 141.504730,354.010437 140.457993,355.127014 
	C138.989075,355.914886 137.855484,355.580566 136.406128,355.022949 
	C135.455032,354.626648 134.820099,354.410034 133.772217,354.789001 
	C128.904037,354.466980 124.375069,354.527069 119.471245,354.108459 
	C115.739250,352.961670 112.300041,353.506226 108.537437,353.408447 
	C106.747284,353.574066 105.191422,353.358154 103.971405,355.035248 
	C106.338867,356.085815 108.556000,355.755219 111.129974,355.112122 
	C114.229370,354.461426 116.834015,355.359222 119.831345,355.955688 
	C120.403641,356.153229 120.625061,356.248993 121.151688,356.532410 
	C122.184128,357.310669 122.952873,357.844360 123.962944,358.628784 
	C124.244797,359.111237 124.287910,359.339386 124.174698,359.878845 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M86.998749,348.248352 
	C86.561462,344.338287 86.237976,340.661743 85.986572,336.561768 
	C86.868134,335.208588 87.893425,335.026917 89.404587,335.440552 
	C90.638626,336.285309 90.905090,337.232971 90.919304,338.607849 
	C90.855492,339.326202 90.531403,339.861176 90.872337,340.076599 
	C91.320763,340.359924 91.486229,339.770508 91.859970,339.196442 
	C93.366386,333.956360 96.721687,335.752747 100.103897,336.512543 
	C100.798012,336.235596 101.188293,336.059875 101.867432,335.739136 
	C102.356194,335.515198 102.554298,335.432251 103.056877,335.247925 
	C105.097855,334.913422 106.500542,334.041199 108.051407,332.728943 
	C110.062378,332.505798 111.561180,333.016052 113.088577,334.375061 
	C113.513031,335.055603 113.633850,335.489319 113.595924,336.273376 
	C113.035843,337.725281 111.937958,337.833557 110.664970,338.190460 
	C110.211838,338.318604 110.034393,338.370422 109.599106,338.503052 
	C109.011551,338.694122 108.684502,338.811676 108.141052,339.056335 
	C107.921158,339.173798 107.504440,339.440918 107.307648,339.591187 
	C107.110855,339.741455 106.735703,340.071960 106.375473,340.434631 
	C105.894745,340.925842 105.774246,341.054321 105.284050,341.587952 
	C104.785362,342.134766 104.656364,342.276428 104.107796,342.850739 
	C102.575836,344.318756 101.270775,345.077606 99.686333,346.042389 
	C95.798073,347.608856 92.586563,350.227081 88.034714,349.470032 
	C87.497879,349.050995 87.305222,348.766449 86.998749,348.248352 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M87.696228,349.671326 
	C91.499542,347.879944 95.308556,346.424316 99.473267,344.896179 
	C100.283226,344.634460 100.755470,344.534241 101.604858,344.614624 
	C102.108772,344.884644 102.256325,345.076904 102.468025,345.626404 
	C102.312271,347.925171 100.530434,348.540253 99.173828,349.981323 
	C98.362602,351.356842 96.728714,352.266541 98.192726,353.870697 
	C95.103188,355.970490 91.945732,354.524078 88.572037,354.430298 
	C88.151115,354.014496 88.058075,353.817291 87.877029,353.305084 
	C87.734337,352.830811 87.679649,352.671570 87.659088,352.262024 
	C87.696129,351.343506 87.699028,350.675262 87.696228,349.671326 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M88.260712,354.478088 
	C91.213913,352.852539 94.223869,353.668976 97.621826,354.023407 
	C99.440109,356.155548 99.418449,357.639099 96.317032,357.779785 
	C94.169884,357.877167 92.025681,358.039703 89.437355,358.118652 
	C88.948868,357.895996 88.903198,357.727844 88.796822,357.305481 
	C88.653091,356.850952 88.570068,356.650635 88.450546,356.127075 
	C88.368454,355.450714 88.322861,355.097626 88.260712,354.478088 
z"/>
<path fill="#0D1D30" opacity="1.000000" stroke="none" 
	d="
M99.876862,362.260498 
	C101.501198,361.847137 102.835548,361.569519 104.509819,361.304138 
	C101.328979,365.864349 95.755707,365.338348 90.651649,366.907654 
	C90.188171,366.513489 90.102684,366.118378 90.049301,365.418823 
	C90.536003,364.338654 91.300217,363.990753 92.374207,363.542633 
	C92.866714,363.346008 93.066711,363.273438 93.573875,363.111328 
	C95.741142,362.431610 97.672058,362.487335 99.876862,362.260498 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M89.451012,362.366333 
	C92.026207,361.195526 94.615685,360.452484 97.541595,361.623962 
	C96.555855,363.110199 94.972595,363.226288 93.243393,363.821503 
	C92.996895,364.042084 92.995850,363.996094 93.016769,364.005676 
	C92.324791,364.579773 91.492058,364.477905 90.318558,364.224609 
	C89.796761,363.577087 89.627411,363.145935 89.451012,362.366333 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M89.957588,364.288696 
	C90.734741,363.987732 91.503387,363.967194 92.654854,363.980957 
	C92.530403,364.944580 91.592636,364.881348 90.410233,365.063293 
	C90.037292,364.932648 89.993187,364.750885 89.957588,364.288696 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M88.331345,356.031616 
	C88.712555,355.984131 88.863342,356.248627 88.801270,356.824280 
	C88.422516,356.880341 88.260017,356.616364 88.331345,356.031616 
z"/>
<path fill="#2AD5F9" opacity="1.000000" stroke="none" 
	d="
M87.581360,352.121643 
	C87.742508,352.171600 87.791794,352.331451 87.815048,352.740692 
	C87.452469,352.816040 87.345963,352.563202 87.581360,352.121643 
z"/>
<path fill="#18A6E3" opacity="1.000000" stroke="none" 
	d="
M110.269791,412.444458 
	C109.965607,412.075073 109.978340,411.871307 110.046837,411.366394 
	C108.726837,409.504150 106.848579,411.774567 105.182083,410.245789 
	C104.594429,409.337128 104.265968,408.636536 103.966209,407.635071 
	C106.720856,406.884796 109.446800,406.435455 112.569092,405.872559 
	C113.952522,405.028351 115.071724,404.811981 116.580002,404.942383 
	C117.393867,405.041138 117.878967,405.260010 118.410767,404.956665 
	C118.253845,404.252625 118.122078,403.760773 118.023682,402.958374 
	C118.030014,402.251770 118.117119,401.855560 118.440994,401.218689 
	C118.626808,400.967316 118.821655,400.958618 118.912025,400.921967 
	C120.185150,400.556000 120.768761,401.249298 121.174881,402.538696 
	C121.580940,404.151184 122.379417,405.100250 123.882111,405.739929 
	C125.306465,404.590546 126.565384,403.877258 128.554474,404.643188 
	C129.694290,404.872101 130.521652,404.888885 131.760010,404.846375 
	C133.189835,403.249207 133.603287,400.037781 136.550156,403.539307 
	C138.670822,406.249359 141.051025,404.504456 143.570923,404.476868 
	C144.834824,404.407166 145.685501,404.693481 146.792862,405.277344 
	C147.597229,405.870178 148.040863,406.362366 148.748795,407.041565 
	C150.205826,408.596008 151.985001,408.722443 153.808502,409.533234 
	C155.010345,411.683838 156.854797,412.369385 158.695724,413.141327 
	C159.879974,413.637970 160.745071,414.454468 158.896484,415.790253 
	C156.393097,416.525238 154.224045,416.286011 151.713638,415.751648 
	C150.922318,415.543304 150.469193,415.454071 149.670746,415.395081 
	C148.665314,415.374847 147.999863,415.416077 147.005310,415.533844 
	C145.134338,415.541107 143.617844,415.113525 141.731949,415.346191 
	C140.946045,415.460785 140.492752,415.520691 139.685944,415.585571 
	C136.479355,415.406036 133.780594,414.369934 130.600342,413.969849 
	C129.336838,413.670074 128.443481,413.338501 127.124542,413.332367 
	C125.802406,413.293091 124.846680,413.180634 123.538406,412.967773 
	C122.256935,412.677704 121.352158,412.344818 120.022400,412.352570 
	C116.611504,411.510101 113.612015,412.489807 110.269791,412.444458 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M104.921371,410.331512 
	C106.967331,409.908142 109.035347,409.217163 111.025192,410.290741 
	C111.095070,410.328461 111.133850,410.566437 111.084206,410.649963 
	C111.007599,410.778900 110.841942,410.854919 110.408325,411.009308 
	C108.922531,411.373444 107.742477,411.681671 106.192749,412.028625 
	C105.522003,411.586670 105.220932,411.105988 104.921371,410.331512 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M135.763885,353.755005 
	C137.097260,354.177307 138.190994,354.471130 139.624329,354.765198 
	C146.244781,354.121796 150.683014,358.516998 156.274689,360.786957 
	C156.992233,361.208344 157.386353,361.472839 158.060547,361.955231 
	C158.934235,362.571350 159.511185,362.993958 160.405624,363.609772 
	C161.490936,364.507202 162.155228,365.262360 162.144653,366.726685 
	C160.142975,369.020416 157.710266,369.325348 155.245667,369.312592 
	C150.628204,369.288727 146.207336,370.262207 141.465408,371.824402 
	C139.146957,372.463989 137.280960,373.228210 134.821243,373.364746 
	C129.572739,373.441711 124.886513,374.989136 120.026390,374.508118 
	C118.218201,374.329132 116.360153,374.569092 114.345375,373.343658 
	C114.019234,373.024841 113.990440,372.541565 113.967667,372.301117 
	C118.045921,371.372589 122.146950,370.684509 126.662079,369.943634 
	C130.055573,367.678925 132.988083,369.287354 135.780533,369.367065 
	C133.421066,368.863525 130.458969,368.688324 128.276184,366.147034 
	C128.067978,364.791504 128.034317,363.772614 128.000092,362.371094 
	C130.130661,360.131226 132.574081,361.361816 133.709763,361.368317 
	C129.760910,362.500610 126.221581,358.048248 121.267166,357.379333 
	C117.911697,356.767822 114.860245,356.339203 111.394875,355.823792 
	C110.600571,355.285461 110.412376,354.764618 110.536484,353.766113 
	C112.939491,351.706207 115.548836,352.866394 118.403496,352.485718 
	C123.894714,353.403046 129.139069,352.358246 134.583176,353.790894 
	C135.175674,353.726074 135.349976,353.676300 135.763885,353.755005 
z"/>
<path fill="#0D1D30" opacity="1.000000" stroke="none" 
	d="
M93.077393,374.077759 
	C92.393425,373.631805 92.139908,373.176025 91.867676,372.446808 
	C98.680893,368.043091 105.987694,365.625000 114.519196,366.039490 
	C115.693352,366.823334 116.847145,367.162170 117.036125,368.619171 
	C111.312950,369.767151 105.506294,369.554565 100.220108,372.507141 
	C97.967819,373.268677 95.737831,373.668304 93.077393,374.077759 
z"/>
<path fill="#197AAB" opacity="1.000000" stroke="none" 
	d="
M120.985329,357.420349 
	C126.539520,356.471191 130.578842,361.131287 135.885513,361.937683 
	C133.547684,361.937683 131.209839,361.937683 128.435760,361.963104 
	C127.141251,360.687714 125.524399,361.409790 124.238754,360.425476 
	C124.011147,360.004669 124.003929,359.819244 123.991753,359.355530 
	C123.454407,358.048523 122.445755,358.667358 121.402191,358.247284 
	C121.114899,358.081421 121.007500,357.644318 120.985329,357.420349 
z"/>
<path fill="#12628E" opacity="1.000000" stroke="none" 
	d="
M127.821777,366.056213 
	C131.170898,366.921417 134.240158,368.032440 137.309433,369.143433 
	C137.230637,369.402100 137.151855,369.660797 137.073074,369.919464 
	C134.037369,369.919464 131.001663,369.919464 127.521065,369.905151 
	C127.231422,368.694580 127.386673,367.498291 127.821777,366.056213 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M117.273712,368.911560 
	C116.295616,368.166321 115.677338,367.415314 115.012772,366.366669 
	C116.533424,366.383392 118.674614,364.960541 119.538277,367.205200 
	C119.868660,368.063812 118.648872,368.729523 117.273712,368.911560 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M124.780663,390.143127 
	C124.405060,389.462463 124.459465,388.631866 124.281761,388.578827 
	C117.768311,386.634552 121.218719,384.121124 124.114838,381.019318 
	C126.816803,378.284180 130.147522,377.604980 132.749954,375.117493 
	C133.198181,374.770386 133.382996,374.639740 133.859039,374.337646 
	C135.982452,373.386627 137.676453,372.306458 139.900940,371.749481 
	C141.990768,373.163879 144.165756,373.997681 145.460861,376.346161 
	C145.610184,378.255402 144.712585,379.065277 142.980530,379.499756 
	C142.470551,379.825409 142.215393,379.878693 141.914307,379.735809 
	C142.114807,380.025787 142.342270,379.984070 142.907471,379.553406 
	C144.081772,379.377625 144.945679,379.073730 146.091705,379.706055 
	C147.271759,381.042084 147.485947,382.546295 148.593277,383.993744 
	C149.151611,385.310089 149.280884,386.337952 149.350555,387.783691 
	C149.426178,389.571045 149.312607,390.931946 148.641037,392.611542 
	C148.061859,393.384064 147.615051,393.693573 146.713470,394.018372 
	C139.498199,394.387787 133.234192,391.535370 126.247841,390.508423 
	C125.610611,390.434387 125.356522,390.395081 124.780663,390.143127 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M124.010147,380.994080 
	C120.375099,381.056488 117.785797,382.945984 115.455414,385.971893 
	C113.626678,385.920166 112.046059,386.069733 110.258316,385.804565 
	C109.597496,385.605804 109.213234,385.222961 108.756424,384.560547 
	C110.610420,382.151367 110.767982,380.675812 107.346848,380.246094 
	C105.791351,380.050751 103.929146,380.074524 103.716125,377.483521 
	C107.367508,374.358459 111.774094,375.288239 115.676140,374.912109 
	C120.514839,374.445740 125.449623,374.104584 130.732574,374.151550 
	C132.515900,375.234375 132.213867,376.076202 130.960159,376.873383 
	C128.883606,378.193787 126.487434,378.945251 124.259155,380.753235 
	C123.982544,381.019470 123.999924,381.001312 124.010147,380.994080 
z"/>
<path fill="#08101D" opacity="1.000000" stroke="none" 
	d="
M103.641449,377.804199 
	C105.475769,379.565216 107.386375,378.746643 109.102005,378.995331 
	C110.867699,379.251282 112.418854,380.097534 112.593613,381.854034 
	C112.794739,383.875610 110.859779,383.805328 109.070877,384.176941 
	C106.210030,383.116791 103.736191,381.952606 100.995590,380.572632 
	C100.480476,379.813965 100.387276,379.245636 100.631302,378.252899 
	C101.581764,377.278107 102.415939,377.209198 103.641449,377.804199 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M128.959839,404.520081 
	C127.536285,405.148041 126.205666,405.440735 124.537140,405.748718 
	C124.157127,404.779053 123.933418,403.759674 124.112297,402.816711 
	C124.441444,401.081604 124.727615,398.667236 127.156357,399.242310 
	C129.511765,399.800049 130.612198,401.692352 128.959839,404.520081 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M113.334602,404.070007 
	C111.453537,402.816376 109.121284,402.809784 108.152664,400.402893 
	C110.299622,399.222137 112.481445,398.361725 114.894394,397.229248 
	C115.451248,397.702454 115.776985,398.447754 116.173775,399.504303 
	C115.906654,400.828247 115.016388,401.555695 114.681824,402.937378 
	C114.359329,403.648224 114.048332,403.950836 113.334602,404.070007 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M121.424438,402.756256 
	C120.602600,402.317810 120.068428,401.738708 119.268326,401.022461 
	C117.080414,395.276184 121.903427,397.305878 124.245651,396.332275 
	C122.255188,398.048431 123.602470,400.954315 121.424438,402.756256 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M124.024368,389.904785 
	C124.458893,389.930481 124.433510,389.952728 124.436386,389.968231 
	C126.581429,389.484894 128.139481,390.265869 129.182251,392.564758 
	C128.751556,393.389496 128.252747,393.536316 127.339630,393.179138 
	C127.003761,392.941772 126.994942,392.997620 127.021622,392.988281 
	C126.318184,392.277344 125.343666,392.590515 124.244720,392.143341 
	C121.496109,389.915253 118.173477,391.879700 115.077950,390.074524 
	C118.193306,387.902008 120.912262,389.447754 124.024368,389.904785 
z"/>
<path fill="#18A6E3" opacity="1.000000" stroke="none" 
	d="
M127.116867,393.255188 
	C127.508316,393.001190 128.012863,393.060608 128.881683,393.235168 
	C130.073395,392.998474 130.888153,393.118591 131.965759,393.577820 
	C132.945953,394.468445 133.428192,395.413116 134.581726,396.165619 
	C134.996658,396.516724 135.153061,396.673401 135.469849,397.128082 
	C135.760712,397.873627 135.809204,398.330963 135.713547,399.146729 
	C135.513626,399.708130 135.393082,399.918701 134.973053,400.341309 
	C133.366913,400.983398 132.242447,400.808533 131.219589,399.278137 
	C130.347733,396.754791 128.668823,395.245422 127.116867,393.255188 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M130.994171,399.362610 
	C132.101929,399.352448 133.200500,399.726929 134.645020,400.175110 
	C136.670975,400.809509 136.949768,402.022247 136.276215,403.888489 
	C134.562378,401.332672 133.725174,403.704437 132.442734,404.697754 
	C131.568542,403.155884 130.573090,401.617126 130.994171,399.362610 
z"/>
<path fill="#11547D" opacity="1.000000" stroke="none" 
	d="
M114.335220,403.322174 
	C113.039932,401.269073 112.960846,399.952209 115.886017,399.875671 
	C116.885773,400.117157 117.526703,400.418823 118.397217,400.843872 
	C118.691544,401.438354 118.756287,401.909363 118.793533,402.736511 
	C117.526245,404.267242 116.125771,404.193176 114.335220,403.322174 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M100.769348,377.848022 
	C101.061790,378.693665 100.992447,379.172607 100.825958,380.004181 
	C98.925125,380.028809 97.138885,379.653442 95.552139,378.171204 
	C95.458923,377.858734 95.482574,377.908875 95.488327,377.935974 
	C97.062950,377.099213 98.679329,376.719879 100.769348,377.848022 
z"/>
<path fill="#061426" opacity="1.000000" stroke="none" 
	d="
M110.278458,386.194122 
	C111.434692,384.509430 113.045364,384.935028 114.919159,385.878601 
	C113.709061,387.670288 112.150780,387.198761 110.278458,386.194122 
z"/>
<path fill="#18A6E3" opacity="1.000000" stroke="none" 
	d="
M124.183052,392.210114 
	C124.872070,392.094269 125.753586,392.266876 126.841705,392.709229 
	C126.157379,392.818848 125.266464,392.658691 124.183052,392.210114 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M113.896751,403.231354 
	C115.332214,403.026154 116.655174,403.028778 118.372086,403.062012 
	C118.972305,403.655884 119.178558,404.219147 119.619904,404.972168 
	C120.161186,406.355530 119.340530,406.388245 118.151535,406.357300 
	C116.426117,406.167175 115.087486,406.059662 113.357147,405.855591 
	C112.978439,405.361633 112.991432,404.964264 113.009750,404.268066 
	C113.324249,403.869110 113.580635,403.692444 113.896751,403.231354 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M101.485466,378.174500 
	C99.566956,378.146057 98.002769,378.077362 95.966339,377.985901 
	C98.624924,373.985413 103.461845,375.064484 107.550880,373.985077 
	C109.407745,373.494904 111.438766,373.664459 113.705009,373.279785 
	C120.799698,373.291229 127.541809,372.763489 134.720795,372.110901 
	C135.796051,373.193878 135.406296,373.950043 134.273575,374.811462 
	C134.001465,375.038086 133.999207,374.991638 134.021271,374.998962 
	C134.043350,375.006256 133.672348,375.256439 133.465454,375.335876 
	C133.258575,375.415344 132.884003,375.192505 132.485413,375.127380 
	C122.903244,375.864288 113.719666,376.666321 104.259048,377.774048 
	C103.267937,378.097900 102.553864,378.116089 101.485466,378.174500 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M227.180206,522.655945 
	C224.697647,524.071472 222.212494,523.794373 219.407043,524.043579 
	C216.312286,522.690613 216.144638,520.083801 215.814270,517.639343 
	C215.503464,515.339783 215.554504,512.985107 214.362991,510.484375 
	C214.056305,509.926697 213.933044,509.702972 213.713425,509.110046 
	C213.663925,508.493225 213.710770,508.245636 214.029846,507.740051 
	C216.954498,506.844208 219.652512,507.629730 222.366898,507.105957 
	C224.103088,506.770966 225.832443,507.832184 226.668671,510.088867 
	C223.115585,514.183716 225.089066,517.613220 227.408646,521.365356 
	C227.469864,521.933899 227.442093,522.165222 227.180206,522.655945 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M229.767914,532.549316 
	C233.066055,529.235901 236.981140,528.339539 241.530350,528.071899 
	C242.284866,528.414368 242.504776,528.809509 242.603348,529.622131 
	C242.449249,531.099854 242.192703,532.208801 241.698273,533.604248 
	C240.959503,534.976562 241.066498,536.129333 241.076965,537.288696 
	C241.090347,538.770203 241.221344,540.523193 239.609711,541.195129 
	C237.551224,542.053345 236.810455,540.101990 235.629791,538.580994 
	C234.344070,537.005005 236.475510,533.072083 231.899017,534.436951 
	C230.443954,534.523804 229.685623,534.104675 229.767914,532.549316 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M213.887390,507.878204 
	C214.176422,508.187134 214.129990,508.608917 214.119141,508.820801 
	C214.178986,509.361572 214.219559,509.818359 214.623260,509.796234 
	C215.283157,509.760040 214.485504,510.065338 214.867538,509.218079 
	C218.276733,513.271606 215.794037,518.963867 218.849823,523.641113 
	C218.212372,524.320007 217.432938,524.645081 216.335846,524.989319 
	C212.762634,522.755615 213.404816,518.605469 211.199707,515.481079 
	C210.501556,514.969299 210.132767,514.632141 209.620041,513.903809 
	C209.064087,511.588684 209.555908,509.797546 210.848709,507.827637 
	C211.976547,507.180664 212.788910,507.185272 213.887390,507.878204 
z"/>
<path fill="#1174A3" opacity="1.000000" stroke="none" 
	d="
M229.672913,532.045166 
	C230.110611,533.183411 230.579498,533.886475 231.961777,534.121887 
	C233.400940,534.753296 233.832108,535.717834 233.860596,537.309814 
	C233.437592,538.910522 232.747040,539.644043 230.994293,539.247009 
	C228.535217,538.321899 226.463715,537.542480 224.188202,536.508179 
	C223.731735,535.714600 223.479263,535.176086 223.066559,534.382568 
	C223.255676,533.711731 223.638580,533.442871 224.173141,533.838623 
	C224.029373,533.523499 223.770920,533.372070 223.159698,533.213501 
	C222.921616,533.042725 222.985840,533.008606 222.979156,533.044312 
	C222.365204,532.419067 221.538940,532.056885 220.557053,531.348633 
	C223.656693,529.058472 226.005997,529.133118 226.120560,533.930420 
	C228.055450,534.578125 226.978363,530.419617 229.672913,532.045166 
z"/>
<path fill="#2AD5F9" opacity="1.000000" stroke="none" 
	d="
M241.949280,529.814819 
	C242.129486,529.160522 242.093170,528.852661 241.959488,528.321899 
	C241.643631,525.046509 239.194550,523.733521 236.822205,522.055054 
	C235.258133,521.242798 233.718277,520.779968 233.467712,518.641907 
	C233.757217,517.510498 234.287659,516.999634 235.340027,516.529297 
	C236.471069,516.372742 237.169586,516.601746 238.136902,517.165833 
	C240.834869,519.618835 243.393082,521.745300 244.563080,525.384521 
	C244.750107,525.947266 244.813889,526.176880 244.936646,526.760986 
	C245.057816,527.845398 244.983597,528.560608 244.595825,529.584351 
	C244.082031,530.268799 243.659424,530.487244 242.807785,530.549988 
	C242.231842,530.394165 242.019943,530.273315 241.949280,529.814819 
z"/>
<path fill="#063A70" opacity="1.000000" stroke="none" 
	d="
M211.747925,514.244812 
	C214.874084,516.822144 213.841766,521.139404 215.972672,524.635132 
	C214.246689,525.297852 212.533035,525.378784 211.138397,523.374878 
	C210.031631,521.876099 209.521362,520.497559 209.014282,518.729126 
	C208.962494,517.877136 209.010834,517.395203 209.244781,516.584045 
	C209.793533,515.314758 210.762375,515.039673 211.747925,514.244812 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M234.521118,517.578674 
	C235.172241,519.041748 235.748016,520.199951 236.416962,521.679932 
	C234.596252,522.400146 232.682419,522.798462 230.360352,523.121216 
	C229.666779,522.763611 229.484543,522.424255 229.416260,521.742004 
	C229.525330,521.271606 229.609253,521.094910 229.922729,520.738159 
	C230.479782,520.444885 230.996460,520.596436 231.131775,520.356934 
	C231.455032,519.784668 231.358841,520.509155 230.621613,519.937134 
	C230.370041,519.291870 230.359726,518.896301 230.541229,518.215210 
	C230.801132,517.781860 230.941788,517.631104 231.340363,517.306519 
	C231.969788,516.939392 232.358429,516.789795 233.075882,516.656250 
	C233.804535,516.744751 234.153351,516.962646 234.521118,517.578674 
z"/>
<path fill="#086AC0" opacity="1.000000" stroke="none" 
	d="
M209.661224,517.744019 
	C210.304153,519.408997 210.667496,520.853699 211.000061,522.673462 
	C210.757965,523.038330 210.546616,523.027954 210.017349,523.001465 
	C209.214172,522.153564 208.728912,521.321777 208.082581,520.237793 
	C207.688095,519.450745 207.454651,518.915894 207.268890,517.936951 
	C208.009445,517.201111 208.697891,517.204346 209.661224,517.744019 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M220.355423,531.488464 
	C221.452011,530.966064 222.252457,531.509033 222.907990,532.774597 
	C221.493561,533.906738 221.168182,532.452820 220.355423,531.488464 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M229.673920,520.842407 
	C230.003113,521.428040 230.008560,521.888245 229.983078,522.697083 
	C229.200348,523.026978 228.448563,523.008362 227.321411,522.952515 
	C226.946060,522.915405 226.974838,522.454102 226.987396,522.223328 
	C227.612747,521.253052 228.335480,520.716064 229.673920,520.842407 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M222.725647,533.311279 
	C223.341690,533.118958 223.761780,533.195129 224.181839,533.271301 
	C223.937088,533.513855 223.692352,533.756409 223.176971,534.063354 
	C222.780777,533.945068 222.655228,533.762451 222.725647,533.311279 
z"/>
<path fill="#15ABF3" opacity="1.000000" stroke="none" 
	d="
M243.739563,530.431519 
	C243.996918,529.346802 244.009613,528.552246 244.038483,527.360596 
	C246.241501,526.679993 246.623291,529.007141 248.365234,529.931824 
	C249.562454,530.709961 250.654388,530.874512 251.978668,531.383667 
	C253.481232,532.311157 254.357483,533.324463 254.596436,535.115723 
	C254.448547,536.062988 254.149521,536.622681 253.952454,537.508057 
	C253.995590,538.351746 254.148865,538.885132 254.518890,539.642578 
	C254.901855,540.395630 255.134918,540.910156 255.533386,541.664551 
	C255.940186,542.438721 256.187134,542.970520 256.603424,543.756836 
	C257.269501,545.158203 257.802338,546.288940 257.730652,547.894653 
	C257.584381,548.398987 257.490265,548.589478 257.133759,548.960938 
	C255.057526,548.646301 253.243637,548.150696 251.188202,547.405151 
	C250.418808,546.443420 249.822144,545.776062 249.368896,544.627319 
	C248.224518,541.960022 247.608109,539.343628 244.866074,537.699463 
	C244.242172,537.174011 243.930939,536.821655 243.472549,536.121460 
	C243.019974,535.101624 242.896194,534.370300 242.828186,533.246887 
	C242.867416,532.096863 243.062790,531.372009 243.739563,530.431519 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M243.609955,535.740601 
	C244.135757,536.192261 244.455978,536.429260 244.901672,536.942383 
	C245.579865,539.915466 246.598160,542.294067 249.574799,543.731323 
	C250.877274,544.465698 250.976135,545.417236 250.958344,546.786499 
	C244.938065,545.920288 239.570190,542.857239 233.370178,541.076111 
	C232.330017,540.554688 231.656158,540.080261 230.794525,539.353638 
	C231.896088,539.027832 232.902939,538.608032 233.094803,536.684143 
	C234.250061,536.082397 235.025665,536.560730 235.820190,537.745850 
	C237.006882,538.887695 237.962616,539.748169 239.007828,540.689270 
	C241.151886,538.447388 239.314270,536.065002 239.436539,533.814514 
	C239.439713,533.755859 239.719879,533.673645 239.871506,533.672241 
	C240.029526,533.670776 240.188293,533.754028 240.608826,533.918213 
	C241.875168,534.261047 242.680328,534.824463 243.609955,535.740601 
z"/>
<path fill="#15ABF3" opacity="1.000000" stroke="none" 
	d="
M262.308502,550.636353 
	C261.847229,550.955688 261.680786,550.996338 261.263794,551.093506 
	C259.664612,550.942749 258.181396,551.076172 257.086273,549.412720 
	C256.871399,549.141907 257.106110,548.903564 257.224792,548.785706 
	C259.034149,547.323181 259.933990,545.604309 259.870728,543.050049 
	C260.011597,542.198975 260.179871,541.732117 260.646820,540.981873 
	C261.128387,540.561768 261.363617,540.443359 261.992371,540.257690 
	C265.938934,540.756958 266.317200,543.033997 265.352875,545.895630 
	C264.788635,547.569946 264.054443,549.200806 262.308502,550.636353 
z"/>
<path fill="#0ABEFA" opacity="1.000000" stroke="none" 
	d="
M234.791595,517.735229 
	C234.262817,517.644592 233.929199,517.405579 233.299072,517.083252 
	C232.829132,517.133423 232.655685,517.266907 232.167389,517.309326 
	C230.646088,516.301025 229.977783,514.867126 228.484650,513.780151 
	C227.366638,512.900024 226.480743,512.237915 226.143387,510.756561 
	C224.363144,508.013763 221.919312,507.072357 219.463028,508.601013 
	C217.480316,509.834900 216.481308,507.091003 214.528412,508.155823 
	C213.360794,508.133392 212.545151,508.079651 211.322342,508.054626 
	C210.479614,508.454285 210.000183,508.755554 209.064697,509.102753 
	C207.233688,509.415466 205.803192,509.340759 203.947906,509.452057 
	C200.856873,509.840424 198.375977,508.525299 195.333527,508.491089 
	C193.224609,508.311768 191.521393,508.298248 189.412735,508.130066 
	C188.730530,505.024170 192.746613,505.169830 192.948273,502.187897 
	C195.406067,499.731293 198.331741,501.590790 201.057373,500.727753 
	C201.599518,498.962555 200.139816,497.984009 199.064850,496.487122 
	C198.776138,495.877258 198.584457,495.596344 198.136475,495.192230 
	C197.526367,494.629974 197.117874,494.228180 196.580750,493.564178 
	C196.665329,492.816101 197.027039,492.502930 197.907806,492.323212 
	C200.340042,492.549561 201.903748,493.725525 203.428391,495.023315 
	C203.538605,495.117065 203.481583,496.604767 204.162704,495.377045 
	C207.085983,490.107880 208.092560,494.213470 209.619461,496.747894 
	C209.818192,497.259155 209.890366,497.461670 210.070984,497.954834 
	C210.696625,499.881470 212.091919,499.192322 213.471924,499.456329 
	C213.963089,499.670135 214.141861,499.798431 214.485352,500.217834 
	C214.909515,501.495361 214.910370,502.438660 213.476303,504.090363 
	C215.703766,501.882935 217.512497,500.754364 218.257812,498.299377 
	C219.477158,495.975342 218.928040,493.369446 220.993683,491.366180 
	C223.697723,489.536621 226.465546,488.964020 229.239716,488.404785 
	C230.930420,488.063965 232.571365,487.855408 233.696350,490.094025 
	C233.914520,491.787079 233.507812,492.988678 232.828308,494.484375 
	C230.804459,496.675598 228.074951,497.666199 226.906097,500.662781 
	C225.495239,502.692047 225.195572,504.360443 227.335754,506.104126 
	C228.905640,507.768433 230.276779,509.175568 231.903015,510.784851 
	C232.430252,511.314392 232.721497,511.623016 233.223846,512.161255 
	C234.003265,512.984497 234.550156,513.598206 235.336731,514.410156 
	C235.934708,515.129150 236.222458,515.670715 236.315018,516.595276 
	C235.845840,517.130371 235.416290,517.358643 234.791595,517.735229 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M194.932068,508.636475 
	C197.634857,508.229401 200.341858,508.133484 203.498596,508.052673 
	C207.461502,510.212891 207.226639,513.913940 207.644897,517.670410 
	C207.513428,518.051514 207.150909,518.005005 206.968353,517.987549 
	C202.847473,518.150452 198.889603,518.395020 196.064209,514.361938 
	C197.653534,514.002441 199.304443,514.002441 200.955368,514.002441 
	C198.928818,513.029663 199.076736,507.933655 195.202286,510.899994 
	C195.113617,510.249207 195.024948,509.598419 194.932068,508.636475 
z"/>
<path fill="#0E151F" opacity="1.000000" stroke="none" 
	d="
M453.747253,140.762238 
	C455.742096,141.330200 457.481781,141.666168 459.608276,142.004272 
	C461.716614,144.044540 462.317230,146.741226 464.015411,148.803314 
	C465.049591,150.059128 465.738892,151.706680 468.101776,151.706406 
	C469.173004,151.867523 469.850372,152.094757 470.720337,152.771301 
	C470.995758,153.010376 471.485687,153.017319 471.730652,153.017426 
	C472.232849,153.242065 472.611145,153.618103 472.507080,153.799454 
	C469.172363,159.611664 473.507050,160.455795 477.742798,161.766815 
	C477.998779,161.998779 478.496948,162.002975 478.746033,162.003632 
	C479.860046,163.006195 479.490479,164.005310 478.558441,164.469131 
	C474.742340,166.368134 476.509674,168.412018 478.113190,170.723648 
	C479.763916,173.103287 483.134705,174.102280 483.354889,177.807373 
	C479.447479,179.888550 476.842438,177.247772 474.381470,175.356003 
	C469.097809,171.294327 465.201263,165.911011 461.553314,160.378311 
	C460.384369,158.605392 459.968262,156.803085 461.295929,154.968842 
	C460.672058,154.831329 460.313477,154.687149 459.684082,154.316528 
	C454.982910,146.659927 448.453156,142.414948 439.946838,140.798630 
	C436.885437,140.216904 433.838348,138.994141 431.282440,137.073441 
	C428.516998,134.995270 428.730621,133.138885 432.833832,131.106995 
	C425.033325,133.161301 420.029938,129.555191 415.129700,126.083794 
	C412.518829,124.234230 410.072357,122.481262 406.808777,121.868294 
	C403.939209,121.329330 401.625305,119.647545 400.514557,116.326050 
	C403.958984,112.674652 407.397552,112.207390 411.003418,115.006615 
	C413.554474,116.987000 416.082123,118.667297 419.361572,119.115204 
	C421.030121,119.343079 422.525360,120.277260 423.685089,121.481812 
	C426.664886,124.576797 430.332703,126.371330 434.693878,127.757561 
	C434.997559,128.003052 435.000000,128.000000 434.998718,128.001404 
	C436.481659,129.698105 438.786865,128.455566 440.725555,129.758362 
	C441.005219,129.991379 441.503845,129.995514 441.753143,129.997467 
	C439.314545,134.541962 439.318542,134.558731 444.846069,136.973083 
	C447.702423,138.220718 450.759125,138.982040 453.747253,140.762238 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M531.421021,319.744507 
	C531.095886,324.836975 530.993103,329.527588 530.760864,334.676086 
	C530.111633,335.410187 529.572815,335.455597 528.722046,334.970764 
	C527.352478,332.683258 527.533081,330.492828 527.577332,328.371338 
	C527.661804,324.322510 525.558899,323.142975 521.914673,323.692566 
	C519.298218,324.087158 516.723267,324.642426 514.199219,325.445312 
	C512.126282,326.104736 510.038757,326.593536 507.686829,325.052856 
	C506.090790,317.945374 504.795135,311.154388 506.163391,303.788635 
	C508.035522,301.332977 510.140442,302.268036 512.133972,302.614868 
	C514.017700,302.942535 515.815491,303.760315 518.194092,303.595215 
	C522.683350,303.271454 526.950073,304.686768 531.152405,302.100281 
	C532.896790,301.471008 533.384827,302.261230 533.773682,303.790527 
	C534.319458,304.203064 534.662109,304.281494 535.264404,304.349426 
	C529.846313,306.141266 531.109131,310.803955 531.170715,315.407471 
	C531.913818,316.943451 532.146667,318.095795 531.421021,319.744507 
z"/>
<path fill="#090A10" opacity="1.000000" stroke="none" 
	d="
M434.961853,127.652626 
	C433.193756,127.892090 430.626465,128.509201 429.711914,127.550201 
	C424.379547,121.958733 416.232513,121.220634 410.731171,116.169411 
	C407.669434,113.358147 404.623627,114.932793 401.246582,115.713455 
	C400.533844,116.571960 400.039368,117.128410 399.033020,117.659073 
	C397.722229,118.126671 396.723511,118.197845 395.341553,118.178581 
	C394.479187,118.079544 394.004486,117.953011 393.237732,117.580460 
	C391.593475,112.882629 392.664825,110.183311 396.933105,106.899323 
	C398.827728,105.441635 401.578644,104.706993 401.854004,101.320450 
	C404.515533,99.103081 405.951294,100.476128 406.890900,102.756783 
	C407.322357,103.803993 407.543457,105.022690 407.521698,106.157120 
	C407.426666,111.109352 409.830750,112.853165 414.557343,112.016251 
	C418.727173,111.277908 420.372742,115.408424 423.453064,116.876022 
	C428.221558,119.147934 432.947754,121.807869 434.961853,127.652626 
z"/>
<path fill="#020711" opacity="1.000000" stroke="none" 
	d="
M526.824341,237.823395 
	C529.047241,243.924957 530.135925,250.006607 531.001953,256.553955 
	C530.432617,257.793671 529.554565,257.916351 528.315674,257.930359 
	C527.358704,257.789459 526.764893,257.562775 525.909302,257.171692 
	C525.457642,256.955902 525.280701,256.866302 524.843567,256.641113 
	C524.062012,256.248932 523.533142,256.009583 522.719971,255.687805 
	C521.740845,255.165741 521.265381,254.536713 520.668518,253.614441 
	C520.210632,252.820892 519.953308,252.263489 519.541138,251.426849 
	C519.324524,250.938110 519.246277,250.736908 519.072754,250.223114 
	C518.679810,248.165527 517.887939,246.572388 517.411743,244.566742 
	C517.436890,243.897720 517.477722,243.538177 517.481323,243.020996 
	C517.458130,242.864792 517.374329,242.803665 517.425659,242.979492 
	C517.477051,243.155334 517.391541,243.608322 517.319702,243.860199 
	C516.781067,246.486633 515.115173,248.192459 513.676514,250.406662 
	C511.598022,252.338699 510.269501,254.719406 507.181641,255.053131 
	C505.479584,253.334106 505.816742,250.896622 503.987549,249.150009 
	C504.015533,245.458588 507.059814,244.542038 509.134644,242.929352 
	C511.526947,241.069946 513.597534,239.154526 514.384644,235.727585 
	C517.862549,233.099182 520.439758,236.147049 523.705383,236.771240 
	C524.043701,236.969681 524.511597,236.979141 524.745483,236.987244 
	C525.422791,237.480438 526.035217,237.505814 526.824341,237.823395 
z"/>
<path fill="#09070A" opacity="1.000000" stroke="none" 
	d="
M352.757172,87.304367 
	C355.241882,85.695107 357.267395,85.652283 359.260986,87.694923 
	C361.725891,90.220490 365.251831,90.691345 369.134369,91.829262 
	C366.772339,93.541428 364.735260,92.705956 362.912872,93.019348 
	C361.401733,93.279221 358.983398,92.041595 358.603394,94.146812 
	C358.273621,95.973778 360.773041,96.327827 362.180115,97.053497 
	C367.225739,99.655663 372.689880,100.961029 378.634644,102.016403 
	C379.438446,102.732605 379.246460,103.417145 378.775879,104.418625 
	C378.421051,104.924347 378.252960,105.109543 377.775269,105.514633 
	C377.234802,105.844719 377.003906,105.954903 376.404541,106.180229 
	C371.733185,107.292999 367.382568,106.866005 363.459747,105.260277 
	C357.966492,103.011703 352.313629,101.421974 346.313477,99.615585 
	C344.924194,98.587273 344.246643,97.473274 343.782623,96.240356 
	C342.498657,92.828598 343.487152,91.179054 347.201691,91.507843 
	C350.461914,91.796432 352.177856,90.844933 352.757172,87.304367 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M526.951416,256.853912 
	C528.233643,257.006195 529.245789,256.995361 530.638062,256.975952 
	C532.123840,257.874573 535.932312,256.339630 533.403015,260.594269 
	C532.148132,262.705200 533.785339,266.585907 534.252075,269.644897 
	C534.434875,270.842712 535.609863,270.850098 536.594727,270.982788 
	C539.328735,271.351105 542.057800,271.755920 545.162476,272.199738 
	C543.246216,274.090515 539.310608,271.259247 539.013672,275.750488 
	C539.378418,276.848633 538.975586,277.260956 538.238037,277.831512 
	C538.007080,278.027405 537.999146,277.998779 538.011841,278.006500 
	C537.746216,278.225525 537.440491,278.383789 536.890991,278.634949 
	C536.563171,278.916046 536.451599,279.051331 536.142578,279.362823 
	C535.642151,279.725861 535.332642,279.901093 534.778503,280.199554 
	C534.377014,280.423584 534.213684,280.512939 533.798218,280.732239 
	C533.194885,281.037201 532.841003,281.206665 532.194702,281.496002 
	C531.694763,281.678375 531.484802,281.735840 530.941589,281.827728 
	C529.894348,281.849304 529.228455,281.665680 528.333374,281.057861 
	C525.990479,277.724457 526.274231,273.981506 525.104309,270.235229 
	C524.376465,265.393982 521.692139,261.341217 522.554565,256.266846 
	C523.244751,255.617203 523.769165,255.503403 524.683777,255.786957 
	C525.034851,256.005219 524.991760,256.012024 524.985352,255.991180 
	C525.433472,256.477295 526.090637,256.505493 526.951416,256.853912 
z"/>
<path fill="#090A10" opacity="1.000000" stroke="none" 
	d="
M483.234222,178.320511 
	C482.290283,175.213028 479.508911,174.314407 477.821289,172.407944 
	C472.905701,166.854935 472.895233,166.199829 478.929626,162.358337 
	C481.492615,162.008835 483.990479,161.991943 486.487457,162.030411 
	C487.289093,162.042770 488.294678,161.988403 488.449249,163.073105 
	C488.587769,164.045166 487.813446,164.653885 487.000885,164.787369 
	C482.888092,165.463043 483.733276,167.457367 485.357666,170.019714 
	C487.038605,172.671295 488.419220,175.513260 489.970825,178.627472 
	C488.403870,180.557800 486.627380,179.950729 484.489319,179.233368 
	C483.907043,178.933533 483.689575,178.784821 483.234222,178.320511 
z"/>
<path fill="#02060A" opacity="1.000000" stroke="none" 
	d="
M294.869446,86.283096 
	C295.389008,83.498466 297.483704,83.605484 298.838593,84.122475 
	C302.236267,85.418930 306.203583,83.981300 309.307434,86.487083 
	C309.738159,86.834808 310.858032,87.020706 311.149780,86.744278 
	C315.090729,83.009964 318.751465,85.254700 322.538757,87.043991 
	C325.481079,88.434059 328.705627,88.036232 331.834656,87.975632 
	C333.886932,87.935867 335.805420,88.091248 337.677704,89.832855 
	C338.108521,91.616524 336.871368,91.730255 335.356934,92.019173 
	C327.043915,91.605171 319.169647,89.397293 311.243042,91.777359 
	C310.439819,92.018547 309.422607,92.312325 308.803558,91.894844 
	C304.619446,89.073196 299.836853,90.745392 295.044586,89.809174 
	C293.089417,88.612526 294.067657,87.618271 294.869446,86.283096 
z"/>
<path fill="#040914" opacity="1.000000" stroke="none" 
	d="
M536.832581,278.896759 
	C537.697754,284.147278 538.356750,289.074554 539.023743,294.427643 
	C538.730225,295.565887 538.018311,295.440796 537.217712,295.825134 
	C536.977661,296.025787 536.991699,295.990173 537.010803,295.990173 
	C536.685730,296.317871 536.347229,296.651367 535.729797,297.215393 
	C535.223938,297.543793 535.002747,297.647308 534.424255,297.843689 
	C533.057434,298.075562 532.083435,297.977905 530.880005,297.258911 
	C530.164246,296.390625 529.946289,295.683899 529.753052,294.587585 
	C529.532532,291.853699 528.842346,289.572601 528.370850,286.892151 
	C528.133850,285.846039 528.072327,285.137970 528.175049,284.071930 
	C528.328125,283.505341 528.419434,283.288361 528.735840,282.801636 
	C529.717834,281.976715 530.667053,281.857422 531.746460,281.213348 
	C532.016235,281.005096 531.998596,280.997559 531.998047,281.007019 
	C532.427551,280.579651 533.019165,280.529938 533.787720,280.185272 
	C534.013428,280.007172 533.999817,279.998779 534.000366,280.007019 
	C534.430664,279.576691 535.022400,279.529724 535.790222,279.187195 
	C536.013855,279.006622 535.999023,278.998779 535.999512,279.007324 
	C536.208862,278.868378 536.417664,278.720947 536.832581,278.896759 
z"/>
<path fill="#05476E" opacity="1.000000" stroke="none" 
	d="
M280.767883,81.770882 
	C280.680603,83.082893 280.336639,84.174690 279.941772,85.608391 
	C280.078552,87.732750 279.003326,88.939301 277.743256,90.418686 
	C277.171234,91.094109 276.608765,91.348053 276.447968,91.883698 
	C276.410736,92.007683 276.902222,92.111191 277.537476,91.917725 
	C279.597534,91.720947 281.319550,91.622299 283.024841,93.076782 
	C283.307800,94.266113 282.816132,94.831558 281.878967,95.527588 
	C281.317749,95.805710 281.083313,95.890305 280.488281,96.051849 
	C278.734436,96.325729 277.299744,96.153221 275.613220,96.723846 
	C273.788361,97.395508 272.313568,98.061584 270.321136,97.931702 
	C269.771149,97.837311 269.555573,97.782501 269.029297,97.629059 
	C265.772095,97.471184 264.453827,100.524612 261.520264,101.240112 
	C260.444153,101.474800 259.790436,101.248100 258.934753,100.571823 
	C258.287170,99.689514 258.144745,98.998741 258.234863,97.918167 
	C258.395752,97.357689 258.492920,97.145065 258.822052,96.672974 
	C259.936951,95.698479 261.012756,95.296730 262.197815,94.439880 
	C263.345795,93.557884 264.226105,92.874077 265.492004,92.160713 
	C268.177826,91.115654 269.640289,89.078049 271.675415,87.220276 
	C272.089966,86.850792 272.261353,86.710136 272.702209,86.377136 
	C274.929993,85.155907 276.341705,83.459671 278.278107,81.877808 
	C278.764343,81.607704 278.973206,81.525146 279.518707,81.413902 
	C280.073975,81.440361 280.292603,81.495522 280.767883,81.770882 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M515.140747,210.669907 
	C515.030457,211.003220 515.029053,211.489227 515.023560,211.732178 
	C512.309753,213.070999 509.852234,212.092514 507.605591,210.779984 
	C505.286194,209.424942 502.861267,208.555710 499.896667,207.978821 
	C497.871002,207.179825 497.034637,205.597275 495.558624,204.164124 
	C494.393188,203.044846 493.741364,202.000854 493.006104,200.557312 
	C492.560638,199.481888 492.408081,198.729309 492.595306,197.566681 
	C495.867126,194.194458 499.895935,196.575287 503.674622,195.221970 
	C505.268585,194.997818 506.535950,194.997818 508.239044,194.997818 
	C507.348511,195.995407 506.727844,196.690674 506.070007,197.706741 
	C504.240143,201.864059 504.829102,203.510712 508.867249,205.889252 
	C511.109039,207.209717 513.978149,207.626221 515.140747,210.669907 
z"/>
<path fill="#0E151F" opacity="1.000000" stroke="none" 
	d="
M401.635040,101.049202 
	C404.203552,102.734077 403.920471,103.877365 401.507263,105.358315 
	C397.453552,107.846016 392.877747,110.138977 393.023071,116.427124 
	C391.447235,118.720207 389.371307,118.367287 386.897217,117.923080 
	C384.837677,116.865417 384.282440,115.302444 383.983459,113.181175 
	C384.006012,112.528244 384.042847,112.273209 384.207916,111.662994 
	C386.513550,108.659042 389.912292,108.092705 392.806732,106.114677 
	C394.963806,102.894691 398.243652,102.215126 401.635040,101.049202 
z"/>
<path fill="#131418" opacity="1.000000" stroke="none" 
	d="
M352.602386,87.060135 
	C353.257355,89.964607 355.454590,93.779266 349.222748,93.090668 
	C343.675629,92.477745 343.636200,92.834625 345.715515,98.945663 
	C339.697601,102.105843 337.708435,101.213905 335.440430,94.715286 
	C336.539154,92.258125 339.080750,92.145927 340.737396,90.296997 
	C344.575592,88.487228 348.706512,88.971817 352.602386,87.060135 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M523.822632,236.683716 
	C521.157227,236.543610 518.270813,236.117538 515.154663,235.917236 
	C514.690063,236.205444 514.455017,236.267883 513.895142,236.160919 
	C512.050659,234.330902 511.411346,232.160141 510.090820,229.933029 
	C509.432220,228.273972 509.044281,226.967468 510.327423,225.435486 
	C513.941284,223.930023 517.108887,224.869629 520.657349,225.822937 
	C521.104492,229.707169 520.320618,233.558746 523.822632,236.683716 
z"/>
<path fill="#090A10" opacity="1.000000" stroke="none" 
	d="
M490.755310,179.324112 
	C492.987579,177.993973 494.349152,177.384766 495.197632,180.598862 
	C496.493774,185.508942 500.525513,189.214600 502.010376,194.510559 
	C501.303101,195.908844 500.241974,195.937027 498.761047,195.756073 
	C495.450104,193.450073 494.675140,189.483398 491.360443,187.073975 
	C489.809387,184.485245 489.194244,182.151947 490.755310,179.324112 
z"/>
<path fill="#020711" opacity="1.000000" stroke="none" 
	d="
M515.283936,210.787109 
	C513.380127,209.363449 511.418427,208.323700 509.221161,207.522400 
	C506.524200,206.538864 504.324768,204.633896 503.257477,201.985016 
	C502.631470,200.431152 502.380066,198.220917 505.644348,198.030487 
	C506.969696,199.347183 508.456421,198.759903 509.672058,199.112167 
	C510.243591,199.277756 510.713684,199.793274 511.229767,200.150223 
	C506.651978,205.200119 513.359131,204.850204 514.624146,207.081650 
	C515.276611,208.232498 516.400269,209.086166 515.283936,210.787109 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M521.357666,226.050110 
	C517.615051,226.052353 514.201172,226.035004 510.319794,226.023590 
	C508.751465,226.272461 508.280426,225.445755 507.533447,224.493134 
	C507.007538,223.628174 506.714478,223.018127 506.235657,222.114243 
	C505.460571,220.510895 504.981384,219.180008 505.088745,217.351593 
	C505.232574,216.760818 505.323090,216.532364 505.652863,216.021683 
	C506.351593,215.528549 506.831146,215.475311 507.622803,215.781540 
	C508.381989,215.992264 508.846222,215.978607 509.658630,215.955582 
	C513.884521,217.108948 513.544983,222.435562 517.750244,223.760132 
	C519.308289,224.753250 520.710632,225.099854 522.586426,225.025665 
	C523.094482,225.189072 523.233521,225.345291 523.188477,225.755478 
	C522.565002,226.016495 522.125732,226.023514 521.357666,226.050110 
z"/>
<path fill="#090A10" opacity="1.000000" stroke="none" 
	d="
M453.947937,140.650482 
	C449.367096,140.413193 445.151825,138.617630 441.037689,136.522659 
	C439.562653,135.771576 437.553711,135.070145 437.511108,133.383896 
	C437.451843,131.039581 440.183685,131.493500 441.785828,130.263657 
	C443.540924,133.699631 446.323883,136.021759 449.977509,137.543991 
	C451.430237,138.149246 453.199585,138.530945 453.947937,140.650482 
z"/>
<path fill="#0E151F" opacity="1.000000" stroke="none" 
	d="
M490.759949,178.992279 
	C490.961090,181.439697 490.821045,183.897141 491.953766,186.598572 
	C493.102844,188.251724 493.924438,189.607925 493.383118,191.744873 
	C492.030182,192.858185 490.770050,192.664429 490.068298,191.669708 
	C487.253418,187.679611 483.233337,184.260117 483.748779,178.362274 
	C485.723450,178.350616 487.476959,178.672272 489.620453,178.988464 
	C490.010468,178.983002 490.510101,178.990952 490.759949,178.992279 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M507.940155,215.604507 
	C507.521301,215.998337 507.124786,215.990738 506.429993,215.981964 
	C505.314789,215.816986 504.644989,215.333160 503.649780,214.810699 
	C501.754974,213.524445 500.911224,211.764832 499.616516,209.952789 
	C499.192993,209.318665 498.983795,208.935287 498.717346,208.216034 
	C498.669525,207.677704 498.707245,207.459778 499.046295,207.103119 
	C503.072815,206.833832 506.276184,207.910492 509.213989,210.365524 
	C510.468079,211.413544 512.544128,211.477997 514.632385,211.982269 
	C515.018066,211.975128 515.013062,211.991180 515.019287,211.986176 
	C515.183411,212.155411 515.341248,212.329636 515.234985,212.737579 
	C512.620667,213.671036 509.309204,211.352097 507.940155,215.604507 
z"/>
<path fill="#020711" opacity="1.000000" stroke="none" 
	d="
M477.955933,161.632065 
	C477.338867,162.000656 476.664551,161.914413 476.021423,162.019241 
	C472.747253,162.552948 470.597260,160.706772 469.002289,158.338287 
	C466.661041,154.861649 473.372833,156.869736 471.972473,153.387634 
	C474.499939,153.029297 477.690094,152.188889 476.104553,156.826904 
	C475.500458,158.594101 477.614258,159.646774 477.955933,161.632065 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M518.005493,223.598206 
	C515.179932,224.318909 513.270630,223.502747 512.561890,220.382370 
	C512.251709,219.016678 511.079803,217.846680 510.152985,216.267029 
	C515.088867,214.226776 516.926147,215.894394 518.005493,223.598206 
z"/>
<path fill="#09070A" opacity="1.000000" stroke="none" 
	d="
M382.874878,99.162857 
	C387.489380,98.782028 387.538177,102.667465 388.961060,105.666840 
	C388.204956,108.023216 386.615845,108.658577 384.253265,108.465973 
	C382.206879,106.890892 381.895660,104.864899 381.527161,102.475578 
	C381.499390,101.600128 381.530121,101.101181 381.798889,100.294151 
	C382.008850,99.984344 382.004883,99.997261 381.999023,99.998367 
	C382.225952,99.773750 382.463135,99.552765 382.874878,99.162857 
z"/>
<path fill="#090A10" opacity="1.000000" stroke="none" 
	d="
M468.219269,152.685593 
	C462.372192,151.905289 461.313171,147.242142 459.997131,142.392456 
	C461.062500,142.005219 462.129852,142.004013 463.597412,142.004547 
	C465.648834,145.389526 467.463409,148.702759 468.219269,152.685593 
z"/>
<path fill="#02060A" opacity="1.000000" stroke="none" 
	d="
M283.329956,94.081062 
	C281.573151,92.189919 279.547272,93.317047 277.386993,92.962456 
	C276.375580,92.287651 276.279663,91.543144 276.774200,90.387955 
	C277.789185,88.810242 278.592346,87.571777 279.643188,86.141800 
	C281.674591,87.317596 282.313538,90.212219 285.649231,90.001068 
	C286.275757,90.338684 286.348999,90.711296 286.150208,91.400307 
	C285.942444,91.854019 285.843262,92.027496 285.573914,92.446762 
	C285.281860,92.850037 285.159973,93.007523 284.837616,93.386780 
	C284.337463,93.878212 283.994568,94.070793 283.329956,94.081062 
z"/>
<path fill="#020711" opacity="1.000000" stroke="none" 
	d="
M468.370300,153.000626 
	C467.193298,149.386642 463.604340,146.866501 463.998840,142.396744 
	C465.216553,142.079742 466.588379,142.481415 466.654694,143.716278 
	C466.844910,147.256760 469.470062,149.463654 470.959534,152.655060 
	C470.245667,153.008224 469.495575,153.006088 468.370300,153.000626 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M383.812256,108.159866 
	C385.457489,107.380936 386.925507,106.854561 388.694641,106.178001 
	C390.052368,105.993599 391.108978,105.959381 392.557495,105.865585 
	C392.098145,109.761009 388.075500,109.251030 385.286316,111.007187 
	C384.374786,110.690392 384.037292,110.184662 383.683960,109.324188 
	C383.609314,108.822952 383.622192,108.617691 383.812256,108.159866 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M497.687531,194.632187 
	C499.098480,194.889755 500.161499,194.921249 501.622620,194.913727 
	C502.460144,194.912430 502.899597,194.950150 503.670135,194.992844 
	C501.266113,198.944275 496.912720,195.886551 493.319885,197.666199 
	C491.021698,198.253952 490.935394,196.773972 490.860291,195.072388 
	C491.466858,194.351028 491.950806,194.096146 492.890564,193.850067 
	C494.700592,193.628189 496.073425,193.680161 497.687531,194.632187 
z"/>
<path fill="#1D1B1E" opacity="1.000000" stroke="none" 
	d="
M340.609436,90.034874 
	C341.404510,93.349419 338.543365,93.062317 336.370819,93.974739 
	C335.566254,94.565758 335.194244,95.186424 334.085144,95.365677 
	C333.005920,95.176849 332.385040,94.820000 331.697083,93.964905 
	C331.385162,91.551979 332.649872,91.172783 334.674133,91.160782 
	C335.869476,90.849045 336.734039,90.688377 337.810211,90.269196 
	C338.761139,90.015175 339.500519,90.019653 340.609436,90.034874 
z"/>
<path fill="#040914" opacity="1.000000" stroke="none" 
	d="
M534.015503,303.764221 
	C533.482605,303.534729 532.988281,302.944824 532.294678,302.128601 
	C531.111084,301.150818 530.996887,300.125427 531.335205,298.637085 
	C532.247681,297.264740 533.395447,297.624115 534.705444,297.216248 
	C535.020813,296.988129 535.000000,297.000000 534.989868,297.006470 
	C535.397339,296.637177 535.884583,296.487457 536.737793,296.828857 
	C536.041016,299.197906 535.047546,301.300873 534.015503,303.764221 
z"/>
<path fill="#02060A" opacity="1.000000" stroke="none" 
	d="
M304.021912,76.973709 
	C305.066742,76.478355 306.096588,76.364464 307.509460,76.319382 
	C308.238190,79.989388 304.981781,80.185844 302.971313,82.059929 
	C302.060516,79.863464 304.755280,79.024635 304.021912,76.973709 
z"/>
<path fill="#090A10" opacity="1.000000" stroke="none" 
	d="
M440.924042,129.618042 
	C439.055786,129.577835 436.709045,131.037201 435.077209,128.376755 
	C436.944641,128.422806 439.292145,126.958511 440.924042,129.618042 
z"/>
<path fill="#050E18" opacity="1.000000" stroke="none" 
	d="
M281.320190,81.849571 
	C280.851227,81.993668 280.677856,81.996246 280.246155,81.968323 
	C279.380676,81.228142 279.226349,80.428368 279.724640,79.169441 
	C280.751801,78.571480 281.565460,78.345314 282.701965,78.172554 
	C283.043579,79.584282 282.887604,80.871902 281.320190,81.849571 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M285.282471,92.205612 
	C285.263763,91.459877 285.529694,90.984535 285.904175,90.258636 
	C287.411072,89.656128 288.809387,89.304184 290.708801,89.298401 
	C290.174774,92.274002 288.261444,93.153275 285.282471,92.205612 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M523.226807,226.269989 
	C523.004272,226.009460 522.987610,225.520462 522.971497,225.276672 
	C524.140259,225.378036 526.251038,224.104156 526.281189,226.269638 
	C526.295105,227.263245 524.500610,227.062012 523.226807,226.269989 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M527.338867,238.173737 
	C526.460510,237.861572 525.895081,237.675720 525.154419,237.242615 
	C527.156311,236.764496 529.141968,237.393204 531.136536,238.360535 
	C529.902954,239.589859 528.780029,238.757797 527.338867,238.173737 
z"/>
<path fill="#17283A" opacity="1.000000" stroke="none" 
	d="
M378.285339,104.495193 
	C378.367432,103.654579 378.584656,103.110718 378.922668,102.296005 
	C379.468689,102.000893 379.893890,101.976631 380.866699,102.187439 
	C381.795410,103.689186 381.179840,104.503242 379.866211,105.237457 
	C379.101959,105.306786 378.724365,105.126640 378.285339,104.495193 
z"/>
<path fill="#040914" opacity="1.000000" stroke="none" 
	d="
M543.417114,292.907837 
	C543.945374,292.074799 544.534912,291.897278 545.139221,292.407959 
	C545.254333,292.505280 545.183228,293.043762 545.023071,293.205261 
	C544.512451,293.720276 543.924866,293.932495 543.417114,292.907837 
z"/>
<path fill="#022D4E" opacity="1.000000" stroke="none" 
	d="
M538.328491,278.018616 
	C538.263245,277.562531 538.519409,277.097656 538.890930,276.393921 
	C539.460876,276.104340 539.915466,276.053589 540.712646,275.984528 
	C541.166138,276.144928 541.277100,276.323608 541.192383,276.749756 
	C540.214417,277.334747 539.432190,277.672272 538.328491,278.018616 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M294.725952,86.079048 
	C296.119598,86.913033 295.056824,87.292542 293.703156,87.858383 
	C293.431610,87.344772 293.948364,86.777489 294.725952,86.079048 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M537.267944,296.039154 
	C537.462219,295.685364 537.946716,295.344940 538.731506,294.928955 
	C539.630798,296.592743 538.179504,295.812653 537.267944,296.039154 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M541.768372,308.172913 
	C541.901550,308.768372 541.744324,309.490021 541.587036,310.211700 
	C540.672791,309.624268 541.088989,308.960938 541.768372,308.172913 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M515.277710,212.984039 
	C514.970886,212.971283 514.997681,212.476440 515.011597,212.228821 
	C515.730103,212.143738 516.434753,212.306290 517.139343,212.468826 
	C516.621094,212.644806 516.102783,212.820801 515.277710,212.984039 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M537.058228,296.818634 
	C536.577942,297.073608 536.121521,297.052307 535.322388,297.021942 
	C535.456604,296.682465 535.933533,296.352051 536.720215,296.005920 
	C537.047302,296.174286 537.064636,296.358337 537.058228,296.818634 
z"/>
<path fill="#17283A" opacity="1.000000" stroke="none" 
	d="
M381.769348,100.156761 
	C382.008667,100.432648 382.008484,100.880951 382.008331,101.665329 
	C381.839417,102.128258 381.670410,102.255119 381.249481,102.189590 
	C380.997559,101.997192 380.980499,101.980942 380.969604,101.970001 
	C381.149109,101.415771 381.339508,100.872475 381.769348,100.156761 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M290.960999,88.947121 
	C291.404633,88.606117 291.873138,88.300133 292.628235,87.953094 
	C292.914825,87.912048 292.971375,87.973473 292.998077,88.005577 
	C293.157562,89.044533 292.561401,89.358086 291.371338,89.237854 
	C291.037079,89.051025 290.985840,88.982140 290.960999,88.947121 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M542.192932,275.863647 
	C542.097168,275.521698 542.253784,275.106018 542.410400,274.690338 
	C543.039673,275.037231 542.747253,275.413452 542.192932,275.863647 
z"/>
<path fill="#022D4E" opacity="1.000000" stroke="none" 
	d="
M537.258484,279.064667 
	C536.866333,279.182739 536.693848,279.145477 536.260681,279.062012 
	C536.469116,278.679443 536.938293,278.343048 537.715942,278.010437 
	C537.842346,278.312592 537.660217,278.610962 537.258484,279.064667 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M294.341888,76.894722 
	C294.429108,76.221367 294.936462,75.942787 295.805115,76.557343 
	C295.533356,76.810623 295.100647,76.882820 294.341888,76.894722 
z"/>
<path fill="#020711" opacity="1.000000" stroke="none" 
	d="
M514.550415,202.468445 
	C514.583374,202.523529 514.517517,202.413376 514.550415,202.468445 
z"/>
<path fill="#020711" opacity="1.000000" stroke="none" 
	d="
M516.529846,203.548264 
	C516.476257,203.579666 516.583435,203.516861 516.529846,203.548264 
z"/>
<path fill="#0E151F" opacity="1.000000" stroke="none" 
	d="
M382.814331,99.093399 
	C382.846130,99.254784 382.647217,99.520370 382.220764,99.892715 
	C382.190002,99.732185 382.386810,99.464890 382.814331,99.093399 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M541.980469,307.972595 
	C542.088135,308.005463 542.118713,307.115692 542.193481,307.976410 
	C542.058777,308.046692 542.004395,307.999481 541.980469,307.972595 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M541.220276,276.900879 
	C541.007324,276.825562 541.017944,276.653931 541.041870,276.224243 
	C541.055176,275.966217 541.498657,275.952606 541.719604,275.944977 
	C541.940491,275.937347 541.991089,275.992126 542.015564,276.021210 
	C541.918640,276.362793 541.719910,276.614227 541.220276,276.900879 
z"/>
<path fill="#010610" opacity="1.000000" stroke="none" 
	d="
M226.771759,89.625549 
	C234.458633,87.523247 241.875214,85.622536 249.594696,83.563156 
	C252.327484,82.991615 254.757370,82.578735 257.585815,82.193970 
	C257.659973,86.872093 256.045441,92.221359 252.634491,93.985580 
	C249.307922,95.706169 244.282074,97.613693 240.041672,95.854080 
	C235.876938,94.125862 235.358414,95.545410 235.828659,99.086555 
	C235.893433,99.574364 235.758545,100.071053 235.443329,100.863586 
	C234.911362,101.505013 234.513107,101.772285 233.738678,102.113892 
	C229.702560,103.901772 226.062302,105.683327 222.056702,107.557907 
	C219.098557,108.535172 216.307983,108.650696 213.348358,109.672256 
	C210.848129,109.768036 208.810242,109.281746 208.571884,106.830238 
	C208.337418,104.418594 209.969238,102.893494 212.099670,101.992416 
	C216.158432,100.275711 220.460129,99.201996 225.172256,97.339554 
	C222.006439,95.462746 218.318344,97.304596 215.995850,94.267273 
	C219.111160,91.786621 222.983337,91.265465 226.771759,89.625549 
z"/>
<path fill="#050E18" opacity="1.000000" stroke="none" 
	d="
M234.889084,101.361191 
	C234.910034,100.195778 234.966339,99.322296 234.695984,98.565498 
	C234.059204,96.782852 233.360703,94.930664 235.238556,93.606812 
	C237.032211,92.342293 238.701401,93.155746 240.103012,94.595688 
	C242.843613,97.411232 244.429169,94.942635 246.234711,93.288757 
	C247.059692,92.533073 247.695618,91.134537 248.988052,91.439705 
	C250.806976,91.869179 248.258896,93.955658 250.298538,94.760048 
	C252.496140,92.863373 257.172699,91.932076 252.604095,87.523384 
	C254.739288,86.214226 257.864349,86.310608 257.980194,82.577393 
	C259.020172,82.063988 260.055939,81.905899 261.482635,81.701309 
	C264.538818,84.819717 263.356262,88.502029 263.165985,92.461388 
	C262.579559,94.721039 260.639191,95.146278 259.336487,96.764313 
	C259.062286,97.074936 259.007233,96.998459 259.042847,97.029518 
	C255.782730,100.190613 251.676895,101.315651 246.966583,101.746201 
	C242.795395,99.231773 241.841827,102.318039 240.339523,105.056488 
	C239.672226,105.515152 239.218475,105.608574 238.393204,105.523674 
	C236.633530,104.475067 235.293869,103.450150 234.889084,101.361191 
z"/>
<path fill="#02060A" opacity="1.000000" stroke="none" 
	d="
M261.923279,94.413437 
	C261.967896,90.235237 261.955444,86.433746 261.908264,82.143524 
	C265.687805,80.916382 269.502106,80.177971 273.655518,79.252457 
	C275.692566,78.968346 277.390503,78.871330 279.513275,78.785980 
	C279.954132,79.583580 279.970154,80.369514 279.987030,81.546631 
	C279.987885,81.937828 279.545044,82.044800 279.317261,82.047333 
	C276.762421,82.984138 275.135590,84.791847 273.255981,86.804031 
	C273.039917,87.054375 272.994293,87.017044 273.019531,87.028763 
	C270.285461,88.206711 268.511597,90.550117 266.233032,92.804680 
	C265.227570,93.685089 264.444611,94.317223 263.403381,95.110153 
	C262.593292,95.444565 262.167023,95.284302 261.923279,94.413437 
z"/>
<path fill="#086AC0" opacity="1.000000" stroke="none" 
	d="
M515.183716,424.605042 
	C514.497375,425.077881 513.627747,425.334595 513.643555,425.413544 
	C514.675720,430.555084 509.125549,433.504791 509.183533,438.693237 
	C506.865540,439.632843 507.401428,442.191193 505.692078,443.484985 
	C503.302551,439.885834 506.624634,436.142548 505.113983,432.339844 
	C504.330383,430.500000 505.503113,429.633942 506.183624,428.626953 
	C507.057648,427.333679 507.623291,426.101746 505.958374,424.562408 
	C505.646271,424.065491 505.551910,423.846619 505.512787,422.914001 
	C505.714417,422.003967 505.860840,421.807678 506.321167,421.416992 
	C508.534851,420.652039 510.453796,420.214233 512.814941,420.508240 
	C514.356873,421.590515 515.591187,422.516693 515.183716,424.605042 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M503.210754,431.639496 
	C501.535706,432.964844 499.927368,433.007263 498.282837,433.046234 
	C495.790558,433.105255 495.648193,434.428406 496.877655,436.603333 
	C497.395721,437.353760 497.549408,437.840607 497.377869,438.754395 
	C494.844818,440.839447 491.754181,440.356079 488.849518,441.739502 
	C487.961273,441.893433 487.453003,441.871857 486.602386,441.614655 
	C486.081787,441.295319 485.907471,441.121307 485.647125,440.592896 
	C485.777130,438.265778 486.849701,436.635162 488.465515,435.803497 
	C491.585510,434.197571 490.151093,432.849548 488.493896,430.969055 
	C488.647675,429.189240 489.301636,428.110413 491.083923,427.497192 
	C494.164551,427.784821 496.783051,427.322418 499.427979,427.085236 
	C502.314819,426.826355 504.522247,427.599915 503.210754,431.639496 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M503.282928,431.986145 
	C503.287567,428.875275 502.512604,427.250763 498.919189,428.494781 
	C496.467407,429.343628 493.869934,429.446075 491.051239,428.248901 
	C490.745026,427.708801 490.720795,427.483948 490.916595,427.005310 
	C491.878723,426.624451 492.592896,427.063354 493.338776,426.860382 
	C492.983521,426.332764 492.246826,426.619110 491.673828,425.861938 
	C491.455109,422.618988 492.815765,420.770477 496.103333,420.134033 
	C497.680542,420.280579 498.848999,420.623993 500.401428,420.766724 
	C502.999878,420.909088 504.100281,422.672852 505.759399,424.082458 
	C510.027313,426.185425 510.027313,426.185425 505.127380,431.702759 
	C504.509918,431.995605 504.063995,431.994415 503.282928,431.986145 
z"/>
<path fill="#0355A0" opacity="1.000000" stroke="none" 
	d="
M496.663605,439.263916 
	C496.989807,438.591766 497.003937,438.116333 497.036682,437.283295 
	C498.992096,437.354553 500.401550,436.062897 501.988068,435.008911 
	C502.266571,441.131927 501.031586,442.646942 495.416901,443.003540 
	C495.012085,443.012085 494.987000,442.986572 494.974640,442.973938 
	C493.785065,441.143433 495.025665,440.285095 496.663605,439.263916 
z"/>
<path fill="#021429" opacity="1.000000" stroke="none" 
	d="
M541.002441,384.997437 
	C540.560669,384.992340 540.115662,384.990387 539.337036,384.998505 
	C536.038513,385.191315 535.618896,382.852905 535.035034,380.839813 
	C534.527649,379.090332 534.354919,377.249237 534.018372,375.451630 
	C533.356567,371.916473 531.664001,369.645325 527.408203,369.601349 
	C524.425232,367.089600 525.921265,364.406250 526.523804,361.429199 
	C526.579407,360.821075 526.594910,360.577576 526.627441,359.968964 
	C526.705017,358.386993 526.772766,357.170746 527.052856,355.608093 
	C527.395447,354.306702 527.751343,353.397980 528.362732,352.200623 
	C530.194336,350.396820 532.044495,349.288086 534.570007,348.878937 
	C538.772400,356.166931 538.845276,364.184326 540.014099,371.964111 
	C540.577026,375.710876 541.268555,379.438263 541.955933,383.573303 
	C541.806946,384.223816 541.588135,384.461029 541.172852,384.844818 
	C540.992004,385.005890 540.999207,385.000610 541.002441,384.997437 
z"/>
<path fill="#1391DB" opacity="1.000000" stroke="none" 
	d="
M529.511292,351.800171 
	C529.176636,353.063385 529.013306,354.003113 528.685059,355.261230 
	C527.926636,355.489258 527.415222,355.234344 526.722534,354.468414 
	C525.221802,351.289795 526.660156,348.510132 526.663330,345.276733 
	C527.452332,341.838013 527.163086,338.623291 528.771729,335.424500 
	C529.430054,335.137573 529.773438,335.139099 530.374146,335.137268 
	C530.406006,339.126068 530.180542,343.118256 529.970886,347.558228 
	C530.732483,349.237183 530.226196,350.358612 529.511292,351.800171 
z"/>
<path fill="#033B5F" opacity="1.000000" stroke="none" 
	d="
M531.551270,320.086731 
	C531.157654,319.000366 531.116516,317.854370 531.135315,316.280945 
	C533.185913,316.385071 535.166626,312.417786 536.171082,314.712585 
	C536.992188,316.588470 535.107544,319.620972 531.551270,320.086731 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M529.653625,352.049896 
	C529.455627,350.965668 529.571228,349.807709 529.836792,348.327911 
	C532.504639,348.637695 533.892151,345.914459 536.620361,345.974731 
	C536.429321,346.837402 535.814941,347.638916 535.059631,348.712097 
	C533.268250,349.981262 531.617737,350.978729 529.653625,352.049896 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M541.274536,385.009949 
	C541.181763,384.737152 541.371460,384.468445 541.785645,384.085938 
	C542.024841,384.144684 542.039673,384.317230 542.088379,384.747559 
	C541.933838,385.008270 541.745483,385.011139 541.274536,385.009949 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M536.968262,345.962036 
	C537.082947,345.927032 537.118286,344.966949 537.200562,345.963562 
	C537.043762,346.035919 536.991821,345.988281 536.968262,345.962036 
z"/>
<path fill="#032B57" opacity="1.000000" stroke="none" 
	d="
M525.280762,403.693237 
	C518.710938,407.595825 517.681091,410.625305 521.660645,414.946594 
	C521.543335,416.069580 520.789673,416.785309 519.277588,417.001282 
	C515.996582,417.849152 512.941467,417.230804 509.606049,417.539795 
	C508.583618,416.935211 508.447937,416.266632 508.751190,415.193359 
	C509.450104,414.212372 510.142059,413.639343 510.429382,412.419128 
	C512.122131,408.838867 516.492004,406.811462 514.961670,401.771484 
	C516.291565,397.444336 517.401550,393.386841 520.761597,390.042755 
	C524.104248,388.567261 527.151184,388.174103 530.666138,389.406647 
	C532.952148,393.253845 529.360352,395.962860 529.214722,399.647339 
	C529.000000,400.013916 529.003723,399.990692 529.014526,399.985840 
	C528.786133,400.202393 528.552856,400.429810 528.157654,400.840820 
	C527.989868,401.018433 527.995911,400.995789 528.007202,400.992737 
	C527.781555,401.207245 527.550964,401.431335 527.161682,401.837830 
	C526.996643,402.013672 526.997559,401.997559 527.005615,401.997070 
	C526.776367,402.212402 526.546143,402.435455 526.157959,402.840759 
	C525.993042,403.015717 525.996033,402.996338 526.005676,402.994629 
	C525.852600,403.149139 525.689941,403.305389 525.280762,403.693237 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M508.878174,416.801483 
	C512.217712,416.117493 515.210022,415.403717 518.606812,416.858215 
	C518.967163,417.200623 518.982422,417.368805 519.027222,417.788513 
	C519.505310,419.259399 519.299866,420.375854 518.307251,421.682739 
	C517.238770,422.871857 516.390991,423.781464 515.248413,424.797607 
	C515.117615,423.370422 513.357849,422.932312 513.047729,421.317657 
	C511.401154,419.191101 508.815247,420.908173 506.941162,419.048828 
	C506.780426,417.574371 507.443939,416.932495 508.878174,416.801483 
z"/>
<path fill="#032B57" opacity="1.000000" stroke="none" 
	d="
M518.456909,421.973938 
	C517.932312,420.786072 518.022034,419.659271 518.905762,418.351410 
	C520.155579,418.805206 522.157043,418.895233 521.697937,420.893524 
	C521.362061,422.355560 519.890991,421.869751 518.456909,421.973938 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M531.225586,390.225922 
	C527.816711,390.002350 524.583496,389.708008 521.056274,390.914429 
	C519.935242,389.865967 520.047424,388.727386 520.353271,387.590363 
	C521.720947,382.506042 523.435852,377.505554 523.801636,372.188782 
	C523.893799,370.849304 524.469299,369.629486 526.210571,368.953674 
	C533.344116,368.338593 534.897766,369.723999 535.904114,377.906067 
	C536.213440,380.421387 536.291016,382.857788 538.682861,384.834473 
	C537.369568,387.363586 536.057495,389.977631 533.330322,391.840027 
	C532.219727,391.756622 531.918091,390.994904 531.225586,390.225922 
z"/>
<path fill="#033E75" opacity="1.000000" stroke="none" 
	d="
M531.008728,390.412659 
	C531.944275,390.058289 532.724487,390.293732 532.983521,391.670166 
	C531.874573,394.527527 530.714539,397.065857 529.277283,399.809052 
	C528.588196,396.710724 530.648376,393.942291 531.008728,390.412659 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M534.571411,400.972229 
	C533.917664,401.901794 533.226746,402.112030 532.562378,401.367218 
	C532.426575,401.214935 532.446289,400.715637 532.591675,400.556458 
	C533.261902,399.822327 533.948975,400.015106 534.571411,400.972229 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M526.239990,402.936218 
	C526.176453,402.739563 526.359924,402.463440 526.778503,402.091949 
	C526.838135,402.283325 526.662598,402.570038 526.239990,402.936218 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M525.261108,403.845276 
	C525.128662,403.611542 525.311157,403.362732 525.798523,403.085693 
	C525.965271,403.336395 525.789490,403.593964 525.261108,403.845276 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M527.242493,401.932465 
	C527.180542,401.737122 527.364441,401.460602 527.783447,401.086914 
	C527.841797,401.276886 527.665100,401.564056 527.242493,401.932465 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M528.229614,400.924164 
	C528.179443,400.742767 528.368958,400.467072 528.791870,400.086182 
	C528.839966,400.263977 528.654663,400.546936 528.229614,400.924164 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M307.248108,572.801758 
	C304.857666,573.269104 302.710571,573.532959 300.165466,573.672363 
	C300.409302,573.193298 301.051086,572.838745 301.843750,572.250000 
	C302.003296,571.556274 302.011993,571.096680 302.038116,570.292480 
	C303.728973,569.984802 305.402405,570.021606 307.489868,570.111145 
	C307.766388,570.975342 307.628906,571.786865 307.248108,572.801758 
z"/>
<path fill="#19BAF7" opacity="1.000000" stroke="none" 
	d="
M262.344635,551.024170 
	C262.801086,549.009216 263.541931,547.082397 264.388519,545.203247 
	C265.282349,543.219299 264.959961,541.800964 262.399170,541.049255 
	C261.694550,540.664062 261.494110,540.250732 261.566833,539.414978 
	C265.056885,538.618286 268.380188,536.770569 271.893860,538.791321 
	C273.234924,539.562561 274.460846,538.910217 275.387939,537.749878 
	C276.200195,536.733276 276.778015,535.400085 278.740967,535.595215 
	C280.300110,536.927734 280.706055,538.515747 281.036530,540.144897 
	C281.168854,540.797058 280.821381,540.037476 281.125244,540.620728 
	C281.255493,540.870789 281.545258,540.632446 281.644165,539.894714 
	C284.987885,537.434082 285.208588,534.133789 285.082886,530.360718 
	C285.087769,529.537781 285.169281,529.075317 285.482819,528.313354 
	C285.846375,527.866943 286.037079,527.730347 286.571350,527.529358 
	C290.181732,528.179626 289.597015,531.958191 292.036377,533.726440 
	C292.493195,534.026428 292.671417,534.152771 293.097717,534.491943 
	C293.797424,535.171692 294.206665,535.676208 294.845337,536.411865 
	C295.431091,537.223999 295.605652,537.829773 295.244629,538.758057 
	C292.217102,541.694519 290.283417,544.662476 291.601929,548.833801 
	C291.747375,549.294006 291.194855,549.974854 290.757721,550.764648 
	C289.449371,551.648071 288.343597,552.301941 286.624634,552.032166 
	C285.835419,551.774841 285.405762,551.556030 285.008667,551.274780 
	C284.464630,550.889526 285.295471,551.117310 284.658386,550.988403 
	C284.439880,550.944153 284.848694,551.215637 285.078857,551.575928 
	C285.966736,552.394897 286.280609,553.190369 286.392273,554.403748 
	C286.081573,554.815857 285.800781,554.892639 285.096069,555.086182 
	C284.337128,555.193420 284.002167,555.183777 283.416718,555.133057 
	C282.961609,555.176697 282.756958,555.261292 282.249695,555.209045 
	C281.947052,555.072205 281.703003,554.991333 281.634949,554.882324 
	C280.888000,553.861389 280.188141,552.962891 279.598785,551.666992 
	C277.960052,551.233276 278.351593,552.943054 277.276123,553.644043 
	C275.548126,553.639587 274.035126,553.390991 272.151855,553.027588 
	C271.319519,551.188599 273.123352,549.483459 271.637390,547.488159 
	C269.747223,545.016663 268.666107,545.361511 268.103516,548.343140 
	C268.008850,548.867065 267.960968,549.075439 267.807678,549.587952 
	C267.604919,550.083374 267.507538,550.274780 267.214417,550.721191 
	C266.856659,551.115723 266.694611,551.255249 266.294128,551.609253 
	C264.928986,551.593628 263.802277,551.363464 262.344635,551.024170 
z"/>
<path fill="#0FCFFB" opacity="1.000000" stroke="none" 
	d="
M307.339905,532.619995 
	C304.575256,532.598267 302.047760,532.257751 299.079956,531.872498 
	C298.190491,531.235535 298.055511,530.552124 298.101501,529.476562 
	C298.404999,527.935791 299.277710,527.074768 299.990234,525.717407 
	C300.332153,525.216492 300.486694,525.025818 300.940491,524.613708 
	C301.696655,524.170776 302.175476,524.017151 303.059937,523.889587 
	C305.314178,523.880066 307.058716,524.364929 308.984619,525.549255 
	C310.924438,528.554077 308.426605,530.210571 307.339905,532.619995 
z"/>
<path fill="#0F62A1" opacity="1.000000" stroke="none" 
	d="
M298.719849,528.812744 
	C298.809906,529.830688 298.791016,530.500366 298.705872,531.498901 
	C298.277008,532.143677 297.914398,532.459656 297.321808,532.852539 
	C295.388306,532.434387 294.147766,531.396057 293.277344,529.437561 
	C293.116425,528.851990 293.076263,528.610657 293.036865,528.000305 
	C293.202911,526.309753 293.820496,525.306824 295.435364,524.695190 
	C297.631561,525.259766 298.657898,526.467773 298.719849,528.812744 
z"/>
<path fill="#19BAF7" opacity="1.000000" stroke="none" 
	d="
M293.462341,528.776306 
	C294.795074,530.154358 295.765900,531.278564 296.914307,532.666016 
	C296.746826,533.414612 296.401825,533.899902 296.033386,534.695312 
	C295.697906,535.359009 295.309387,535.586609 294.510010,535.706299 
	C293.949951,535.623474 293.735321,535.540710 293.261597,535.230225 
	C293.002441,535.002441 293.000000,535.000000 292.998627,534.998779 
	C289.022461,531.508789 289.046051,530.029358 293.462341,528.776306 
z"/>
<path fill="#044166" opacity="1.000000" stroke="none" 
	d="
M284.755066,551.412842 
	C286.585022,551.214417 288.106079,551.043457 290.088257,550.924194 
	C290.188019,552.966736 289.678680,554.815979 286.705078,554.686890 
	C285.817535,554.057007 285.272644,553.374939 284.650146,552.370239 
	C284.530365,551.845215 284.488251,551.642822 284.755066,551.412842 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M307.410461,532.930786 
	C306.171417,530.391357 309.218658,529.105835 309.081451,526.428711 
	C309.314972,525.956055 309.516876,525.854797 310.031036,525.888306 
	C311.007416,526.702393 311.376678,527.503967 311.194946,528.765381 
	C310.383698,530.114258 309.734314,531.164734 309.015350,532.519104 
	C308.536560,532.856262 308.127350,532.889587 307.410461,532.930786 
z"/>
<path fill="#0FCFFB" opacity="1.000000" stroke="none" 
	d="
M293.779266,535.313843 
	C294.449432,535.002136 294.895172,535.001892 295.675446,535.003540 
	C297.316833,536.407104 297.598694,537.728821 295.373291,538.945435 
	C294.871552,538.455566 294.704529,537.901611 294.303375,537.169800 
	C293.662964,536.624756 293.491638,536.169128 293.779266,535.313843 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M271.671021,546.979126 
	C276.271332,548.620972 273.223633,550.517639 271.997162,552.625488 
	C271.408203,552.876709 271.034760,552.840698 270.382568,552.850586 
	C270.103790,552.896545 270.072662,552.915100 270.056793,552.922668 
	C269.322479,552.306946 268.427551,552.554993 267.307007,552.328125 
	C266.847992,552.155151 266.688690,552.091187 266.292542,551.925537 
	C266.055695,551.823792 266.071808,551.471680 266.077759,551.295532 
	C266.259521,550.847229 266.453674,550.588745 266.843994,550.179077 
	C267.021881,550.014160 266.999847,550.002441 267.010376,550.011780 
	C267.976013,548.324158 269.389069,547.271973 271.671021,546.979126 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M277.397888,553.938416 
	C276.623322,551.887451 277.502808,550.179932 278.776215,548.924133 
	C279.804688,547.909851 279.901886,549.301941 280.087341,550.310669 
	C280.607666,551.683411 280.075195,552.589844 279.370300,553.776611 
	C278.639648,554.023987 278.187164,554.006287 277.397888,553.938416 
z"/>
<path fill="#11547D" opacity="1.000000" stroke="none" 
	d="
M279.319275,554.184692 
	C279.346069,553.136841 279.599976,552.232056 279.960907,550.974304 
	C281.079773,551.573853 281.367310,552.843201 281.585999,554.453857 
	C280.893402,554.624756 280.219879,554.476257 279.319275,554.184692 
z"/>
<path fill="#18DBFB" opacity="1.000000" stroke="none" 
	d="
M282.062195,555.229736 
	C282.149963,555.060730 282.352905,555.049255 282.861053,555.064941 
	C282.836609,555.190430 282.506958,555.288818 282.062195,555.229736 
z"/>
<path fill="#32627C" opacity="1.000000" stroke="none" 
	d="
M304.220642,551.992920 
	C304.130768,551.581787 304.278198,550.958069 304.702881,550.168091 
	C304.806091,550.594666 304.632019,551.187500 304.220642,551.992920 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M159.710175,140.197296 
	C169.315964,154.852905 179.567123,169.083588 189.848892,183.698196 
	C190.471954,186.707092 188.205460,187.596222 186.699661,189.004166 
	C179.327026,195.897614 170.819977,201.473434 163.492401,208.972839 
	C161.631256,209.734711 160.398880,208.870331 158.814072,208.008072 
	C151.892654,202.648865 145.239365,197.524124 138.351822,192.155212 
	C136.660583,189.533813 134.560135,187.902847 131.801666,186.580139 
	C129.271423,186.667557 127.298126,185.641418 124.956787,184.985794 
	C124.104065,183.451691 124.866592,182.505020 125.771088,181.273865 
	C126.017082,181.015701 126.000000,181.000610 126.008972,181.006393 
	C126.875633,179.997330 127.036720,178.665070 127.811745,177.269989 
	C128.014359,177.019760 128.002121,177.000610 128.012634,177.005737 
	C128.794159,176.314224 129.222076,175.399551 129.827545,174.241104 
	C130.020325,174.007034 129.998779,174.000107 130.005798,174.009277 
	C130.790161,173.320480 131.220764,172.401398 131.828964,171.236603 
	C132.021729,171.000565 131.996857,170.998322 132.001678,171.009857 
	C132.530304,170.467957 133.079269,169.939362 133.818268,169.197006 
	C134.023941,168.998688 133.995605,168.995712 133.997955,169.009735 
	C134.251404,168.708923 134.460312,168.367859 134.828476,167.773315 
	C135.303101,167.244110 135.507294,166.900223 135.826569,166.271057 
	C136.005661,166.024734 136.008484,166.007309 136.015976,166.002655 
	C136.185593,165.832718 136.347702,165.667404 136.757965,165.259125 
	C137.006119,165.016159 137.001221,165.001831 137.008362,165.003616 
	C137.233322,164.780075 137.453644,164.557205 137.844833,164.172791 
	C138.013214,164.008789 138.000000,164.000610 138.006531,164.006348 
	C138.440491,163.580414 138.505356,162.998810 138.837555,162.230133 
	C139.017487,162.006912 139.000687,161.998489 139.004547,162.006317 
	C139.227402,161.785919 139.449509,161.560745 139.844742,161.173203 
	C140.014771,161.007797 139.998428,161.000259 140.002213,161.008942 
	C140.450882,160.552307 141.078979,160.528076 141.886414,160.169632 
	C143.329330,158.876007 144.524597,157.752106 145.856033,156.350266 
	C146.222366,155.824066 146.457352,155.580490 146.882111,155.167572 
	C147.954788,154.202515 148.843246,153.412125 149.865387,152.352448 
	C150.428253,151.627563 150.502701,151.029190 150.837463,150.229263 
	C151.022995,149.997604 150.996063,149.995148 150.998062,150.008514 
	C151.223587,149.789734 151.449966,149.560425 151.852020,149.164978 
	C152.024841,148.996033 151.994568,148.994400 151.995132,149.009552 
	C152.229431,148.779083 152.473587,148.544418 152.923553,148.157837 
	C155.956848,146.067810 157.268250,142.869186 159.710175,140.197296 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M125.675964,181.012695 
	C125.681168,182.107529 125.345245,183.199356 124.976700,184.969086 
	C124.646027,186.702164 124.171333,187.696182 123.773094,189.062622 
	C122.722382,191.403580 122.679451,193.545807 122.854736,196.050278 
	C122.663567,197.266708 122.331192,198.097488 121.868813,199.242645 
	C121.588242,199.737305 121.452530,199.922333 121.027138,200.296539 
	C120.513092,200.543106 120.288712,200.600479 119.716049,200.660751 
	C117.750114,200.353165 116.195137,199.907364 114.839539,198.345139 
	C114.422218,197.020950 114.861191,196.224731 115.737595,195.236328 
	C115.970413,194.976425 115.999390,194.999390 115.985764,194.988525 
	C117.627625,192.445267 118.542419,189.552292 120.454758,186.443008 
	C123.393639,185.166077 123.096184,181.986313 125.675964,181.012695 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M114.317200,188.961365 
	C114.468445,186.179764 116.171181,183.905853 117.626541,181.187653 
	C118.299408,181.016388 118.561333,180.827850 118.843941,180.197937 
	C118.998192,179.960297 119.013145,180.006989 118.989113,180.011871 
	C119.430542,179.596466 119.505180,179.004196 119.825706,178.206573 
	C119.995010,177.967514 120.008835,178.004883 119.989090,178.007538 
	C120.433662,177.593521 120.504601,177.003464 120.823792,176.210678 
	C120.990364,175.971939 121.000542,176.000504 120.985535,175.999359 
	C122.265289,175.488464 122.929741,175.513489 123.088272,177.312057 
	C123.350906,180.291702 121.139313,182.460068 120.957504,185.613464 
	C120.995850,186.004471 121.000343,185.999634 121.002487,185.996994 
	C120.310410,186.808655 119.870377,187.878189 118.418777,188.180786 
	C116.388153,186.001404 115.887512,189.082794 114.317200,188.961365 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M127.689011,177.144531 
	C128.351852,178.549118 127.758926,179.737228 126.334549,180.874344 
	C125.692101,179.486115 126.171104,178.249420 127.689011,177.144531 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M131.718201,171.121216 
	C132.196228,172.259689 132.054352,173.380508 130.366089,173.999115 
	C129.918701,172.809464 130.488861,171.935883 131.718201,171.121216 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M129.711700,174.117706 
	C130.197083,175.266068 130.070450,176.394775 128.378143,177.007126 
	C127.878128,175.783325 128.467529,174.920013 129.711700,174.117706 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M133.694260,169.009827 
	C133.974365,169.943832 133.615555,170.680099 132.334351,171.018097 
	C132.031937,170.064529 132.364304,169.316040 133.694260,169.009827 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M150.765564,150.168091 
	C150.843124,150.566589 150.663239,151.135590 150.241211,151.893875 
	C150.168762,151.501633 150.338440,150.920105 150.765564,150.168091 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M141.814941,160.006958 
	C141.632309,160.336731 141.130569,160.673553 140.317413,161.014008 
	C140.502609,160.683090 140.999207,160.348541 141.814941,160.006958 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M135.781860,166.081375 
	C135.844803,166.582413 135.683929,167.140076 135.284363,167.877197 
	C134.890228,167.860657 134.734772,167.664673 134.779739,167.151520 
	C135.078522,166.523956 135.271164,166.291855 135.781860,166.081375 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M134.731476,167.035339 
	C134.988129,167.038040 134.996094,167.241745 135.024872,167.751038 
	C134.929108,168.376495 134.733353,168.636810 134.229340,168.930664 
	C134.161118,168.427979 134.321945,167.832169 134.731476,167.035339 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M138.759735,162.164825 
	C138.853775,162.569412 138.690063,163.131897 138.269714,163.853241 
	C138.176041,163.448959 138.339020,162.885864 138.759735,162.164825 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M146.825684,155.103546 
	C146.856201,155.263214 146.646057,155.533493 146.214050,155.938049 
	C146.189819,155.786270 146.387421,155.500229 146.825684,155.103546 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M139.787613,161.108368 
	C139.838943,161.287033 139.663132,161.566269 139.247864,161.929825 
	C139.091827,161.676758 139.275848,161.408356 139.787613,161.108368 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M137.777557,164.094452 
	C137.939575,164.349136 137.759781,164.618668 137.244659,164.911392 
	C137.190964,164.730301 137.366425,164.455200 137.777557,164.094452 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M136.769440,165.094086 
	C136.955460,165.365463 136.785187,165.640778 136.259384,165.920059 
	C136.065216,165.643723 136.234970,165.368393 136.769440,165.094086 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M152.870331,148.092545 
	C152.902390,148.265289 152.687653,148.537430 152.234299,148.917114 
	C152.204971,148.747101 152.414261,148.469513 152.870331,148.092545 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M151.797119,149.103271 
	C151.839111,149.272247 151.653397,149.548462 151.233856,149.923279 
	C151.189850,149.751404 151.379623,149.480957 151.797119,149.103271 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M115.616104,194.933990 
	C115.740990,195.795685 115.511566,196.614929 115.192955,197.747101 
	C114.505180,203.097702 112.631531,207.517410 108.473518,210.891251 
	C107.288193,208.070328 108.748283,205.945724 109.937210,203.378372 
	C111.976974,200.466995 112.070061,196.667862 115.616104,194.933990 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M118.016754,188.459137 
	C118.869438,187.451324 119.638847,186.793076 120.706436,186.064590 
	C120.280754,189.277985 118.645073,192.103302 116.292953,194.853699 
	C115.261452,192.487518 117.382721,190.897766 118.016754,188.459137 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M113.997223,188.997253 
	C113.878021,189.906372 114.366814,190.998810 113.231422,191.599701 
	C113.138496,191.648880 112.950859,191.519089 112.807228,191.472473 
	C113.041428,190.756256 113.275627,190.040039 113.757324,189.163513 
	C114.004822,189.003189 113.999901,188.999924 113.997223,188.997253 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M118.744324,180.034210 
	C118.852585,180.472458 119.317482,181.343613 118.047691,181.129364 
	C118.084000,180.679916 118.287231,180.394012 118.744324,180.034210 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M107.072708,202.806793 
	C106.952576,203.374573 106.742455,203.624939 106.242455,203.925369 
	C106.170090,203.459244 106.321213,202.887299 106.750381,202.167664 
	C107.035324,202.195007 107.042221,202.370056 107.072708,202.806793 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M119.704376,178.093735 
	C119.824974,178.541626 119.654938,179.115723 119.224991,179.853302 
	C119.114632,179.417831 119.264175,178.818893 119.704376,178.093735 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M120.694702,176.091248 
	C120.825256,176.545700 120.660149,177.119476 120.232193,177.851715 
	C120.112579,177.410324 120.255806,176.810440 120.694702,176.091248 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M111.210342,194.869995 
	C111.083733,194.504288 111.252541,194.071777 111.421349,193.639252 
	C112.074051,193.981934 111.794891,194.392197 111.210342,194.869995 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M108.772057,198.177155 
	C108.889290,198.606216 108.718544,199.163269 108.249176,199.842468 
	C108.128403,199.411453 108.306236,198.858307 108.772057,198.177155 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M110.228607,196.831024 
	C110.102417,196.392014 110.275925,195.842224 110.682175,195.114624 
	C110.914925,194.936813 111.007469,195.011200 111.052673,195.052277 
	C110.908012,195.635651 110.718155,196.177948 110.228607,196.831024 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M108.031898,200.032471 
	C107.876465,200.601517 107.695213,201.146439 107.271194,201.855667 
	C107.028435,202.019974 106.997192,201.996643 106.982697,201.982513 
	C107.137329,201.416504 107.306442,200.864609 107.713058,200.138672 
	C107.950569,199.964615 108.006081,200.008347 108.031898,200.032471 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M110.024017,197.032227 
	C109.948250,197.381561 109.763184,197.641678 109.279175,197.947083 
	C109.060051,198.049179 109.007103,198.003143 108.982948,197.976562 
	C109.056862,197.630890 109.237061,197.368149 109.714157,197.051788 
	C109.928917,196.941803 109.994537,196.999832 110.024017,197.032227 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M105.776154,204.127808 
	C105.843994,204.312729 105.657829,204.617798 105.246872,205.080414 
	C105.188766,204.907974 105.355453,204.577957 105.776154,204.127808 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M91.929878,248.348938 
	C95.351761,239.992355 97.584633,231.482758 101.676743,223.313507 
	C102.220024,222.707947 102.611961,222.471634 103.391029,222.289093 
	C104.865990,222.680939 105.752220,222.611557 106.687660,221.578400 
	C107.992638,220.137146 109.629463,219.629425 111.482925,221.485992 
	C111.769691,222.257248 111.812477,222.724731 111.718132,223.546844 
	C110.739845,226.012222 108.632378,227.376129 108.014046,229.682358 
	C107.931221,229.991257 107.637642,230.475449 107.459969,230.449402 
	C101.112503,229.518753 103.173973,236.650711 99.496758,238.752151 
	C96.389336,243.621704 95.413414,248.715424 95.325874,254.042633 
	C95.285347,256.508514 95.204155,258.971069 94.437012,261.719666 
	C92.268631,263.161957 91.470955,261.775055 90.526154,260.020691 
	C90.012390,258.741455 89.797470,257.767029 89.472656,256.441498 
	C89.386406,255.834793 89.372841,255.589859 89.396317,254.980103 
	C90.055130,252.547073 90.396278,250.378510 91.929878,248.348938 
z"/>
<path fill="#059FE5" opacity="1.000000" stroke="none" 
	d="
M92.128998,247.831299 
	C91.671898,250.283493 91.096687,252.392105 90.281158,254.764008 
	C89.128601,255.677124 88.147408,255.791626 86.738281,255.036652 
	C86.499611,253.979965 86.624435,253.292465 86.904877,252.289093 
	C87.179787,251.831573 87.299080,251.689941 87.296562,251.298645 
	C87.480942,249.309814 87.787140,247.570648 88.182083,245.460831 
	C90.165459,244.878601 91.541565,245.475876 92.128998,247.831299 
z"/>
<path fill="#0D1D30" opacity="1.000000" stroke="none" 
	d="
M104.253113,222.782303 
	C103.530106,223.007828 103.060387,223.015671 102.237068,223.028671 
	C102.511551,221.263870 103.139626,219.493881 103.902344,217.402710 
	C105.286888,216.157806 105.585320,214.313614 107.551422,213.659454 
	C111.575256,215.589706 109.822952,218.003189 108.155167,220.187256 
	C107.287117,221.323990 105.564316,221.509399 104.253113,222.782303 
z"/>
<path fill="#040E11" opacity="1.000000" stroke="none" 
	d="
M89.243073,239.741150 
	C87.932709,239.474762 87.024078,238.738419 87.174500,237.399185 
	C87.319443,236.108795 88.397476,236.057938 89.776794,236.036224 
	C89.917763,237.187241 89.689911,238.328659 89.243073,239.741150 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M104.238831,223.135086 
	C104.436386,221.762314 103.824425,220.366318 106.364021,219.987076 
	C108.811768,219.621552 109.591202,216.767303 108.138412,213.832031 
	C107.922760,212.855469 107.977272,212.168274 108.074081,211.130280 
	C111.528580,207.399567 112.205055,202.519608 114.930519,198.364090 
	C116.515213,198.613129 117.926659,199.166229 119.638329,199.855988 
	C121.585632,202.685089 119.021240,204.488388 118.434502,206.687714 
	C117.938072,208.548538 117.080933,210.339111 116.325119,212.522003 
	C115.905266,213.756210 115.473656,214.593567 114.886803,215.735489 
	C113.831322,217.334991 113.202477,218.735855 112.978607,220.659760 
	C112.806122,221.206161 112.713669,221.418289 112.397308,221.898254 
	C111.950684,222.235291 111.727982,222.304443 111.263321,222.120987 
	C108.888519,219.963058 107.645859,221.773819 106.561775,223.135162 
	C105.733536,224.175247 105.264069,224.471161 104.238831,223.135086 
z"/>
<path fill="#F4FCFC" opacity="1.000000" stroke="none" 
	d="
M163.976105,135.547562 
	C164.166794,135.011078 164.446625,134.751556 165.259781,134.283844 
	C165.989532,133.918457 166.185974,133.761230 166.708893,133.793365 
	C167.035370,133.982742 166.996887,134.001892 167.000641,133.980713 
	C174.559296,138.593079 181.887878,143.580536 189.712463,148.443634 
	C195.995834,153.061554 202.426132,156.863235 208.304993,161.447952 
	C209.861420,162.661774 211.640274,163.654465 212.775299,165.815277 
	C216.003815,168.714096 219.046219,171.311356 222.391907,174.026276 
	C229.373001,180.671280 237.513977,185.382263 244.694717,191.805054 
	C245.139999,192.282959 245.301834,192.592972 245.718979,192.995300 
	C246.230057,193.277649 246.470947,193.484955 246.858597,193.884949 
	C247.020203,194.060379 247.013229,193.987335 246.976562,193.988144 
	C247.785400,194.572418 248.645493,195.133270 249.738541,195.884216 
	C249.948074,196.110611 249.990265,196.026230 249.949646,196.050217 
	C250.199051,196.221146 250.446198,196.421082 250.777878,196.877136 
	C250.905273,197.080276 250.967209,197.033691 250.932632,197.060883 
	C251.792664,197.735428 252.509293,198.570908 253.522766,199.581909 
	C255.243729,201.271271 256.671509,202.768738 257.834961,204.925446 
	C258.358215,209.682266 260.391815,212.838333 264.535645,214.826126 
	C267.244507,216.125565 269.627777,218.081635 267.627167,222.023163 
	C266.919495,222.513931 266.453613,222.658752 265.591461,222.661102 
	C262.266449,221.439377 260.336304,218.883881 257.576233,216.842834 
	C237.913284,200.132751 218.436508,183.755585 198.014038,168.547714 
	C195.592102,166.744171 193.679581,164.416824 191.058899,162.345734 
	C190.745331,162.184204 190.859726,162.149307 190.847107,162.207764 
	C190.788376,161.873215 190.598129,161.565262 190.020157,161.221436 
	C181.193497,152.682617 172.629379,144.253555 163.976105,135.547562 
z"/>
<path fill="#252326" opacity="1.000000" stroke="none" 
	d="
M359.201630,357.263489 
	C358.726837,353.941925 356.245697,352.006042 355.030701,349.031494 
	C354.659180,348.321716 354.479309,347.921814 354.178070,347.226746 
	C353.964722,346.971802 354.021362,346.988373 354.014587,347.017059 
	C353.188202,346.006195 352.756195,344.755280 351.899445,343.382324 
	C349.682251,341.416656 349.073608,338.689484 346.941467,336.667480 
	C345.764069,335.286072 345.221344,333.908722 344.489502,332.288086 
	C344.178406,331.437958 344.034241,330.855408 343.724731,330.017273 
	C343.531189,329.564819 343.450317,329.384460 343.240845,328.935089 
	C342.931274,328.302979 342.745300,327.942444 342.388733,327.310577 
	C342.112579,326.846771 342.001740,326.657013 341.728516,326.172028 
	C340.129822,321.473145 335.920715,318.079224 337.106018,312.588989 
	C343.759460,310.887360 349.529816,314.077179 355.996490,314.730530 
	C356.592957,314.866882 356.823425,314.939331 357.372284,315.156006 
	C358.097321,315.530579 358.535675,315.615723 359.356201,315.590607 
	C362.563232,316.401550 364.809235,318.156708 366.412842,320.528259 
	C370.610199,326.735504 374.101837,333.325378 376.394104,340.842072 
	C374.952728,343.380096 375.483643,345.910767 374.961243,348.618134 
	C374.220306,350.855591 374.403137,352.851654 374.024811,355.141235 
	C373.615356,356.673279 373.284760,357.846405 372.916595,359.388611 
	C372.580139,360.434204 372.281250,361.102600 371.882263,362.125854 
	C370.926208,364.217651 370.647278,366.310425 368.331665,367.400269 
	C365.656128,366.749756 366.435944,364.885315 366.512360,363.358032 
	C366.653503,360.536865 366.062164,357.890350 365.157349,355.255798 
	C363.181335,355.525787 363.484711,357.266022 362.716980,358.181610 
	C361.215179,359.972687 360.065247,360.040314 359.201630,357.263489 
z"/>
<path fill="#08BDF4" opacity="1.000000" stroke="none" 
	d="
M274.386108,292.630859 
	C283.550568,297.831512 291.045013,304.652802 298.947662,310.915131 
	C318.446503,326.366730 337.861115,341.927612 356.369202,359.045410 
	C361.478485,360.657349 363.599854,365.510712 367.956879,368.103302 
	C368.985962,368.821930 369.602905,369.500000 370.555359,370.323669 
	C372.514923,372.149414 374.865997,373.116119 375.743866,375.931488 
	C375.843658,377.346222 375.441711,378.222198 374.423096,379.187042 
	C371.534760,380.202454 370.129089,378.221680 368.491669,376.929352 
	C344.704041,358.154053 321.194672,339.032806 297.663300,319.938599 
	C288.739319,312.697357 279.684448,305.618134 270.768860,298.366272 
	C269.143738,297.044434 267.004242,295.914825 268.062378,292.866089 
	C270.208771,291.371033 272.085266,291.689240 274.386108,292.630859 
z"/>
<path fill="#17E2F8" opacity="1.000000" stroke="none" 
	d="
M190.845673,162.510223 
	C192.088287,161.901276 192.898788,162.820709 193.801208,163.535477 
	C213.998322,179.532166 234.641968,194.978561 253.803040,212.252609 
	C255.029282,213.358109 256.409027,214.293304 257.889618,215.591370 
	C259.156433,218.173233 257.511505,218.692017 255.886459,219.114243 
	C253.739594,219.672028 251.747528,219.008667 249.415771,217.974899 
	C226.649612,202.671066 208.128784,183.460449 190.845673,162.510223 
z"/>
<path fill="#09070A" opacity="1.000000" stroke="none" 
	d="
M162.731873,209.591644 
	C163.261948,206.271729 165.609802,204.799179 167.682205,203.182846 
	C175.261490,197.271515 182.629730,191.114349 189.850250,184.302673 
	C192.185089,187.081985 194.383362,190.155151 196.555756,193.246506 
	C198.716690,196.321487 197.968567,198.671387 194.910324,200.711304 
	C190.120331,203.906372 185.670563,207.589584 180.544754,210.312225 
	C177.936035,211.697891 175.392700,213.396454 174.863892,217.158600 
	C170.131744,217.412415 167.513519,213.321564 163.314896,211.517761 
	C162.746460,210.874481 162.600067,210.420883 162.731873,209.591644 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M163.172211,210.256241 
	C167.086487,212.577576 170.612564,214.924545 174.466370,217.409485 
	C197.262726,234.325348 219.712646,251.128464 242.223419,267.849640 
	C245.078735,269.970581 247.064621,273.214691 250.841156,274.656036 
	C250.896027,277.673065 248.572525,276.915192 246.697052,277.492828 
	C242.717560,276.822601 240.230621,274.258820 237.472229,272.155090 
	C214.180099,254.390976 192.024277,235.161835 168.034485,218.295929 
	C166.673965,217.339417 165.439651,216.209198 163.989456,214.778076 
	C163.091965,213.706329 162.692245,212.793350 162.506897,211.396225 
	C162.598938,210.766464 162.691467,210.524170 163.172211,210.256241 
z"/>
<path fill="#67F3F9" opacity="1.000000" stroke="none" 
	d="
M265.085693,221.798340 
	C265.862427,221.869751 266.185760,221.886047 266.744537,222.055023 
	C267.834076,222.091522 268.495728,222.488419 269.270935,223.255325 
	C269.706543,223.603333 269.839355,223.842529 269.966461,224.086227 
	C269.933380,223.797882 269.777527,223.575653 269.314697,223.172867 
	C268.411285,220.850998 268.454193,218.954788 270.737305,217.392426 
	C274.167145,217.199066 275.693848,219.343506 277.267700,221.896240 
	C277.614319,223.863922 276.285065,224.904434 275.767883,226.566528 
	C275.913635,227.683044 276.423187,228.306091 277.222961,229.122681 
	C277.607239,229.512131 277.759033,229.672226 278.129211,230.086395 
	C278.485474,230.519104 278.623352,230.697723 278.956604,231.155090 
	C281.434357,235.198380 285.681793,237.307510 287.609558,241.761978 
	C287.024506,244.862030 286.409729,247.624084 283.619568,249.577606 
	C283.071167,249.747498 282.844788,249.786499 281.948303,249.735565 
	C281.077209,249.548721 280.876190,249.451797 280.411530,249.154465 
	C279.996521,248.796555 279.845093,248.639053 279.501465,248.220032 
	C278.961792,247.419693 278.643616,246.862015 278.071533,246.085632 
	C276.533386,243.568970 274.385193,241.896088 273.138824,239.166672 
	C271.090302,230.544525 265.027802,226.812988 257.081909,224.785110 
	C255.737747,224.716599 254.865997,224.424362 254.235535,223.137802 
	C253.771484,222.383057 253.430695,221.965240 252.984802,221.293610 
	C256.966003,217.971649 260.751099,220.797165 265.085693,221.798340 
z"/>
<path fill="#67F3F9" opacity="1.000000" stroke="none" 
	d="
M263.780090,245.216446 
	C272.418823,248.331299 278.166809,254.808197 283.722107,261.993835 
	C285.609161,262.194275 287.197815,262.086517 288.905853,262.989685 
	C289.504028,263.338470 289.481445,263.954102 289.850098,263.946320 
	C290.157806,263.939819 290.079895,263.643402 289.566864,263.247498 
	C289.648163,262.275238 290.071350,261.865875 291.076874,261.744781 
	C293.797546,263.455719 296.228577,265.071960 296.491089,268.689117 
	C294.653046,271.583527 297.744415,275.232147 294.179016,277.548340 
	C290.749969,279.606354 288.696808,278.979248 286.812927,275.639435 
	C282.982880,268.849396 277.708405,263.079041 272.520386,256.837524 
	C269.568085,252.741653 264.336823,250.879257 263.780090,245.216446 
z"/>
<path fill="#3EE8F8" opacity="1.000000" stroke="none" 
	d="
M291.280670,261.684967 
	C290.740112,262.394440 290.424713,262.856628 290.012695,263.710083 
	C288.170776,262.844269 285.775360,264.344299 284.081970,262.419861 
	C284.648102,259.310120 283.033997,257.417297 281.381775,255.528137 
	C276.368683,249.796051 270.904816,244.532532 264.829346,239.424789 
	C264.973389,238.435501 265.557190,238.043213 266.560547,237.639099 
	C272.358917,238.136581 274.528961,243.072266 278.431824,246.287125 
	C279.081940,246.751282 279.386017,247.076920 279.824402,247.737442 
	C280.048340,247.990936 279.991364,248.005661 279.988373,247.976410 
	C280.204895,248.205139 280.436432,248.451889 280.866455,248.859589 
	C281.054474,249.030273 280.978302,249.026993 280.974884,248.989014 
	C281.140381,249.287613 281.405457,249.402786 281.935791,249.133026 
	C285.993103,248.518463 284.859680,244.424850 286.908539,242.208710 
	C290.742157,240.862091 291.991425,244.127502 294.206757,246.234344 
	C293.231201,249.456436 291.345886,251.917236 289.744812,254.855499 
	C289.360413,255.161255 289.195374,255.261017 288.761780,255.429733 
	C288.318573,255.481033 288.143829,255.463379 287.867340,255.215088 
	C287.765594,254.984467 287.816040,255.481827 288.038940,255.605896 
	C288.389252,255.846970 288.516632,255.963974 288.822693,256.271973 
	C289.252808,256.722473 289.515717,256.969879 290.015015,257.385803 
	C290.716827,257.948425 291.129608,258.388916 291.579376,259.205688 
	C291.838165,260.170135 291.778473,260.814636 291.280670,261.684967 
z"/>
<path fill="#46E7FA" opacity="1.000000" stroke="none" 
	d="
M272.568115,255.993866 
	C279.012146,261.915741 284.189575,268.542480 288.277405,275.881836 
	C289.888733,278.774872 290.940582,277.949249 292.827148,276.785156 
	C294.196259,278.385742 294.510162,280.033295 293.389099,281.474396 
	C291.903259,283.384430 290.095886,281.588989 288.064941,281.366577 
	C279.699738,273.470062 272.523926,264.980103 265.124268,256.276764 
	C267.406952,254.280090 269.805054,255.738434 272.568115,255.993866 
z"/>
<path fill="#0FCFFB" opacity="1.000000" stroke="none" 
	d="
M327.124084,318.169495 
	C320.401215,312.184784 313.859680,306.359283 307.159363,300.237457 
	C305.796661,298.179626 306.993896,297.124268 308.473877,295.879272 
	C310.883362,295.419342 311.982483,297.007111 313.362122,298.074402 
	C316.293854,300.342407 318.936005,303.072815 323.066101,304.129364 
	C328.368927,308.283020 331.468018,313.949585 335.932892,318.411133 
	C336.663849,319.141510 336.705353,320.221100 335.821655,321.441681 
	C333.872681,322.448273 332.293091,322.225494 330.395416,321.208496 
	C330.048004,320.979614 329.997803,320.998901 330.004883,320.972961 
	C329.841339,320.794128 329.670685,320.641235 329.260620,320.241821 
	C329.021240,319.995270 328.998871,320.002716 329.001404,319.991211 
	C328.778839,319.764557 328.556580,319.546478 328.168823,319.163635 
	C328.000458,319.001801 328.000000,319.000000 327.999084,318.999756 
	C327.784576,318.758026 327.553680,318.534424 327.124084,318.169495 
z"/>
<path fill="#26E5F5" opacity="1.000000" stroke="none" 
	d="
M267.169006,237.171082 
	C266.607697,238.005814 266.021759,238.490860 265.045593,239.051910 
	C255.114853,232.762985 246.141235,225.567169 236.081223,219.432526 
	C235.385971,217.619614 236.508987,216.916779 237.730942,215.955902 
	C243.764038,216.748077 247.514099,221.033829 252.379684,224.048569 
	C258.371063,227.398911 263.414337,231.360260 267.169006,237.171082 
z"/>
<path fill="#0BCEF8" opacity="1.000000" stroke="none" 
	d="
M245.901001,277.301819 
	C247.160858,275.317810 249.225433,276.538727 250.793625,275.226135 
	C258.197968,280.173676 265.376129,285.394012 272.759857,290.883057 
	C273.277283,291.265015 273.517120,291.464752 273.882324,291.883301 
	C274.250885,292.069885 274.422058,292.124084 274.703430,292.422119 
	C272.745056,293.387390 270.426422,292.412811 268.155212,293.953125 
	C267.038452,294.501923 266.152527,294.431183 265.513641,293.916168 
	C258.878876,288.567780 251.438690,284.192749 245.901001,277.301819 
z"/>
<path fill="#26E5F5" opacity="1.000000" stroke="none" 
	d="
M272.795410,255.747925 
	C270.541779,258.332520 268.180054,256.027344 265.409363,255.977341 
	C260.495972,251.121841 255.975357,246.286346 251.234924,241.201523 
	C250.812225,240.404541 250.945404,239.956543 251.801758,239.609497 
	C255.987274,241.197586 259.784760,242.784119 263.786621,244.645294 
	C265.318848,249.713028 270.041168,251.712692 272.795410,255.747925 
z"/>
<path fill="#0EE7FD" opacity="1.000000" stroke="none" 
	d="
M287.818665,281.502716 
	C289.409882,279.938751 294.116516,283.296814 293.020325,277.358704 
	C295.879822,276.576691 294.890533,274.491852 294.746460,272.841919 
	C294.634216,271.556458 293.048828,270.097137 295.918274,269.261841 
	C296.819946,269.648712 297.075714,269.977081 297.648438,270.867981 
	C298.099854,271.601959 298.210388,271.792267 298.489319,272.272125 
	C301.018555,276.294006 304.012604,279.624329 305.723572,283.770691 
	C306.575989,285.836426 307.393097,287.853821 304.348816,289.325073 
	C299.827789,288.302948 296.152985,285.691315 291.424744,285.093689 
	C290.048676,283.910522 288.991699,282.855560 287.818665,281.502716 
z"/>
<path fill="#0ABEFA" opacity="1.000000" stroke="none" 
	d="
M291.215088,285.277863 
	C295.951324,283.724762 299.690155,286.119324 303.682465,288.855103 
	C307.068665,290.016724 308.364746,292.508118 309.133392,295.665649 
	C308.358093,297.100891 307.713776,298.200714 307.035034,299.620819 
	C301.285339,295.692596 296.247833,290.703796 291.215088,285.277863 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M267.490723,237.696411 
	C262.469574,233.268204 257.745544,229.015671 252.855911,224.464355 
	C253.051849,223.905182 253.413376,223.644775 253.943588,223.092621 
	C254.760513,223.232712 255.408768,223.664551 256.331299,224.209137 
	C263.432343,227.814926 269.323029,232.415405 273.819275,239.129211 
	C275.568298,241.376617 277.216095,243.280258 278.987854,245.478577 
	C279.222412,246.076523 279.333008,246.379807 279.163208,247.077896 
	C275.184448,244.272491 271.486145,241.072281 267.490723,237.696411 
z"/>
<path fill="#141923" opacity="1.000000" stroke="none" 
	d="
M368.164001,368.842255 
	C363.664337,366.763763 360.839111,362.702026 356.874573,359.441956 
	C357.590302,358.954712 358.566467,358.831177 358.920746,357.346436 
	C360.046692,357.440674 361.304077,360.675934 362.060974,356.733398 
	C362.396210,354.987366 362.861542,352.454773 364.805145,352.617157 
	C367.190033,352.816467 366.516663,355.637024 367.139648,357.396362 
	C368.228577,360.471741 367.917633,363.466949 367.761963,366.765259 
	C368.403198,367.440308 368.528961,367.943024 368.164001,368.842255 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M330.180420,321.284668 
	C331.772095,320.984589 333.496185,320.989563 335.651611,320.992981 
	C339.940063,320.844910 340.612579,324.392456 342.732727,326.786560 
	C342.961853,327.046631 342.942047,326.993256 342.964233,326.975464 
	C343.403442,327.411407 343.470123,328.009735 343.853333,328.771423 
	C344.058319,328.980804 343.997284,328.987854 344.023193,328.971161 
	C344.473846,329.502655 344.472443,330.209381 344.872253,331.122803 
	C345.687317,332.668213 346.371704,333.906219 347.075745,335.460846 
	C347.363190,336.318634 347.249756,336.762299 346.364319,337.093475 
	C341.235046,331.428650 335.559448,326.726074 330.180420,321.284668 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M238.007782,215.474060 
	C238.069443,217.109512 237.198456,217.841461 236.111847,218.840118 
	C231.432892,215.909698 226.938492,212.692459 221.389481,208.720276 
	C228.193222,209.842178 233.293839,211.883011 238.007782,215.474060 
z"/>
<path fill="#31E7FE" opacity="1.000000" stroke="none" 
	d="
M265.305481,221.664551 
	C261.536224,222.615112 257.745361,220.641083 253.324219,221.035904 
	C251.709045,220.144196 250.538376,219.248596 249.195633,218.082047 
	C251.937347,217.119095 255.276840,219.644470 257.973175,216.256836 
	C260.400269,217.707672 262.738678,219.540359 265.305481,221.664551 
z"/>
<path fill="#39AEDD" opacity="1.000000" stroke="none" 
	d="
M346.097778,337.386444 
	C346.261475,336.819946 346.549255,336.561371 346.966187,336.040131 
	C349.828766,337.156281 350.004150,340.291595 351.802185,342.725037 
	C352.093445,343.310883 352.235626,343.586761 352.139374,344.262451 
	C350.007935,342.339661 348.114899,340.016998 346.097778,337.386444 
z"/>
<path fill="#1A6D97" opacity="1.000000" stroke="none" 
	d="
M351.917999,344.948700 
	C351.890625,344.390503 351.880310,344.118744 351.910614,343.441040 
	C352.624664,344.150299 353.298096,345.265533 353.989655,346.713257 
	C352.833374,346.995697 352.464905,346.023010 351.917999,344.948700 
z"/>
<path fill="#2478A2" opacity="1.000000" stroke="none" 
	d="
M252.002075,239.368866 
	C251.875626,239.869247 251.561478,240.127457 251.131210,240.668945 
	C250.391205,240.507675 249.767319,240.063126 249.026489,239.349701 
	C248.909546,239.080811 249.024963,238.657364 249.235107,238.594208 
	C250.234970,238.729584 251.024673,238.928131 252.002075,239.368866 
z"/>
<path fill="#1A6D97" opacity="1.000000" stroke="none" 
	d="
M353.971588,347.241119 
	C354.241364,347.379425 354.517975,347.787079 354.856323,348.440918 
	C354.604828,348.294891 354.291626,347.902649 353.971588,347.241119 
z"/>
<path fill="#17E2F8" opacity="1.000000" stroke="none" 
	d="
M189.831024,161.389160 
	C190.093460,161.296356 190.429306,161.481033 190.799820,161.965958 
	C190.524475,162.066360 190.214447,161.866516 189.831024,161.389160 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M327.034210,318.252472 
	C327.219147,318.190552 327.495514,318.370789 327.885010,318.775269 
	C327.707336,318.831238 327.416504,318.662933 327.034210,318.252472 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M328.075012,319.245453 
	C328.324219,319.094147 328.586670,319.275330 328.895874,319.762512 
	C328.719177,319.816193 328.434387,319.652649 328.075012,319.245453 
z"/>
<path fill="#20D3F5" opacity="1.000000" stroke="none" 
	d="
M329.100891,320.230225 
	C329.336151,320.088409 329.593262,320.265442 329.902283,320.736694 
	C329.652435,320.928558 329.375275,320.767944 329.100891,320.230225 
z"/>
<path fill="#2478A2" opacity="1.000000" stroke="none" 
	d="
M249.048416,238.948181 
	C248.681747,238.875427 248.453964,238.670044 248.226181,238.464661 
	C248.509537,238.382080 248.792892,238.299500 249.260742,238.373962 
	C249.445267,238.531021 249.187286,238.815536 249.048416,238.948181 
z"/>
<path fill="#08BDF4" opacity="1.000000" stroke="none" 
	d="
M273.976227,291.778992 
	C273.744690,291.961243 273.461517,291.809875 273.097778,291.356689 
	C273.267883,291.281891 273.570343,291.412079 273.976227,291.778992 
z"/>
<path fill="#4A4546" opacity="1.000000" stroke="none" 
	d="
M442.305389,297.254700 
	C439.476013,292.042175 434.282379,289.047699 431.792480,283.473785 
	C431.876617,281.132599 431.034119,279.270782 430.797058,277.317169 
	C430.074402,271.361969 431.077148,266.154572 436.520111,262.605560 
	C438.356628,261.408112 439.320557,259.399200 441.046265,257.526672 
	C446.664307,255.620270 451.843536,258.521545 457.547150,257.585968 
	C459.805450,257.641785 461.641663,257.497284 463.722046,258.547424 
	C466.443298,264.053558 465.470612,269.536591 465.073486,274.937500 
	C464.901337,277.278625 462.949402,278.084412 460.768494,278.314514 
	C458.461639,278.557831 456.106354,278.042297 453.554016,279.041046 
	C446.016632,289.434967 446.581146,295.296814 455.656372,303.933441 
	C456.384491,304.626343 457.096191,305.317200 457.460388,306.679749 
	C457.044952,308.944061 455.383667,309.085205 453.557373,309.619263 
	C452.129944,309.848846 451.166962,309.617371 450.023254,308.760986 
	C447.847046,304.483643 444.295380,301.575806 442.305389,297.254700 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M388.435181,279.223450 
	C386.964081,274.676880 385.721832,270.402405 384.301453,265.707336 
	C385.671112,264.830566 386.897308,265.612396 388.426178,266.525208 
	C389.066406,266.998840 389.410431,267.289459 389.988586,267.806213 
	C390.723572,268.423981 391.221558,268.817383 392.028076,269.315857 
	C392.809937,269.812531 393.300598,270.183472 394.065308,270.685242 
	C394.483978,270.955872 394.648987,271.066040 395.051514,271.351013 
	C395.439026,271.650024 395.589050,271.774231 396.165771,272.286377 
	C396.736725,272.800934 396.880951,272.927582 397.497803,273.395386 
	C398.492828,274.046600 399.022156,274.344299 399.841736,274.790405 
	C410.475800,281.744995 420.449310,289.094604 431.131836,296.013550 
	C435.352295,299.323425 439.341797,302.365997 443.752655,305.391174 
	C444.214539,305.678528 444.399597,305.789612 444.853516,306.073822 
	C445.477203,306.476685 445.832703,306.705353 446.459930,307.096863 
	C446.903625,307.384125 447.076416,307.507416 447.490417,307.843628 
	C447.889404,308.205872 448.047180,308.355164 448.448303,308.726074 
	C451.068237,311.073212 453.650879,312.945953 456.347656,315.236267 
	C457.386261,316.416321 457.998962,317.440277 458.308258,319.000763 
	C457.646698,320.880798 456.427673,320.619781 454.857422,320.209351 
	C447.284241,316.201050 440.880829,310.923889 433.054199,307.361298 
	C431.353851,306.819702 430.262604,305.930389 428.857056,304.891724 
	C425.686615,302.354919 422.163483,301.069366 418.830292,298.791382 
	C409.789215,292.751282 400.653412,287.522583 391.807953,281.831299 
	C390.702484,281.120056 389.505341,280.553986 388.435181,279.223450 
z"/>
<path fill="#606569" opacity="1.000000" stroke="none" 
	d="
M399.234741,243.760071 
	C390.854858,234.729111 380.560089,228.113190 370.317230,220.878204 
	C369.857391,220.585098 369.660492,220.520554 369.318909,220.180908 
	C369.174225,219.905807 369.086334,219.938187 369.080139,219.891754 
	C368.880768,219.725037 368.687653,219.604767 368.267303,219.229828 
	C368.040100,218.975159 368.000000,219.000717 368.011475,218.979904 
	C367.850037,218.803513 367.677124,218.647934 367.248413,218.255096 
	C366.992584,218.017853 366.998779,218.001221 366.990662,218.005402 
	C366.205353,217.385574 365.354797,216.873169 364.264893,216.184692 
	C364.035156,215.993988 363.997192,216.005981 363.999268,215.986191 
	C363.307831,215.201645 362.398987,214.776718 361.246887,214.177032 
	C361.014221,213.985535 361.000000,214.000000 361.006500,213.991791 
	C359.313599,212.424606 357.976044,210.377136 355.806610,209.446609 
	C351.982910,207.806503 350.274261,204.942184 350.368683,200.528244 
	C351.043640,198.734375 352.313751,197.912109 353.685913,196.710114 
	C361.738312,195.989670 364.937378,198.594910 366.204346,206.233444 
	C366.460846,207.780029 365.266632,210.794235 369.293701,209.919037 
	C370.442627,210.381714 371.075073,211.008224 371.988129,211.787033 
	C372.553802,212.249634 372.877441,212.508148 373.448975,212.941376 
	C373.850494,213.244370 374.006439,213.369781 374.378845,213.698700 
	C374.870605,214.179535 375.147980,214.454727 375.651489,214.912613 
	C376.027527,215.218658 376.179993,215.339478 376.563324,215.640152 
	C377.415314,216.309479 378.059692,216.763992 379.038483,217.276215 
	C379.497467,217.528854 379.680695,217.635681 380.136353,217.914581 
	C382.869232,219.948410 385.426086,219.925491 388.124207,218.596451 
	C389.846619,217.748047 391.584198,216.786880 393.973877,217.467850 
	C396.934662,220.528320 400.008667,223.166092 400.461914,227.754486 
	C395.999756,230.589813 396.338928,233.994354 398.319885,237.847031 
	C399.211548,239.581207 400.329803,241.367569 399.234741,243.760071 
z"/>
<path fill="#3A3639" opacity="1.000000" stroke="none" 
	d="
M397.339996,317.137268 
	C395.196503,312.734680 394.812775,308.219696 393.781616,303.460938 
	C397.005676,300.559814 400.316315,303.177582 403.963928,303.008179 
	C404.495331,303.211639 404.700531,303.253113 404.776794,303.375153 
	C410.632965,312.747894 419.227570,314.553009 429.325653,312.332214 
	C431.152191,311.930481 433.088135,311.897217 434.162933,313.813599 
	C435.288757,315.820923 433.853638,317.256287 432.657013,318.615051 
	C430.366882,321.215515 427.628845,323.403900 425.441162,326.586639 
	C424.946259,327.590973 424.519745,328.195679 423.766174,329.012512 
	C422.567566,330.036072 421.531769,330.656189 420.168762,331.434082 
	C419.373810,331.731079 418.898041,331.813049 418.050720,331.786255 
	C410.498108,327.645233 403.314178,323.531525 397.339996,317.137268 
z"/>
<path fill="#1B2027" opacity="1.000000" stroke="none" 
	d="
M245.608551,101.611893 
	C250.430130,100.692482 254.263184,98.531532 258.701141,97.077744 
	C259.076630,97.786652 259.074829,98.512726 259.070374,99.602448 
	C257.908966,101.699524 257.183289,103.538635 257.638977,106.030380 
	C257.308899,107.376266 256.701416,108.077766 255.360657,108.490425 
	C253.251373,109.373428 251.368896,109.620590 249.431168,109.621803 
	C248.813202,109.909523 249.478821,110.111610 249.538544,110.066223 
	C251.019394,108.940941 252.997772,109.800911 254.924088,108.784409 
	C256.810486,109.150887 256.914032,110.368050 256.788727,112.021927 
	C256.270081,113.500908 255.386383,114.373833 254.828064,115.835060 
	C254.371078,116.818062 254.002991,117.442078 253.429520,118.373909 
	C251.481323,121.117775 251.069519,124.108971 249.851837,126.757072 
	C248.774780,129.099396 247.797195,131.709381 244.038620,131.384232 
	C237.496948,127.459488 231.329468,123.584404 225.000641,119.408203 
	C227.025452,116.944557 229.688263,117.534515 232.677673,117.928322 
	C235.624634,120.874260 239.035278,119.808754 242.170883,120.014153 
	C240.111984,119.928268 238.046509,120.113853 235.668793,119.744728 
	C233.647400,118.049393 232.900436,115.855156 233.480927,113.866776 
	C234.515564,110.322838 232.891190,110.133217 230.159775,110.278984 
	C228.595444,110.362473 226.854767,110.259819 225.792328,108.278137 
	C226.102966,107.195511 226.656265,106.687798 227.674164,106.108315 
	C231.142303,105.454758 233.964294,103.104614 237.688644,104.739899 
	C238.452454,104.978851 238.890076,104.979973 239.655945,104.979179 
	C241.218109,103.839485 242.596481,103.105202 244.705521,103.580658 
	C245.972870,106.031105 245.424255,108.156494 244.524658,109.988846 
	C246.070724,107.723030 245.446884,104.968903 245.608551,101.611893 
z"/>
<path fill="#0BF0FA" opacity="1.000000" stroke="none" 
	d="
M431.215149,297.229980 
	C420.292969,289.954742 409.786194,282.893707 399.100616,275.556030 
	C398.652527,274.664978 398.093689,274.496490 397.291351,274.165283 
	C397.071045,273.966827 397.015564,274.001282 397.017334,273.968689 
	C396.764099,273.739929 396.523804,273.527130 396.089325,273.178101 
	C395.880371,273.058472 395.957886,273.038147 395.955872,273.078156 
	C395.768982,272.798492 395.538269,272.516418 394.987671,272.243011 
	C394.714172,272.213745 394.857605,272.169434 394.808228,272.225983 
	C391.570251,265.908661 391.930573,263.750183 397.318787,258.876282 
	C398.216705,258.450928 398.765106,258.421967 399.680786,258.787415 
	C400.038757,259.004669 399.990082,259.009735 399.990662,258.985291 
	C400.226227,259.216400 400.452484,259.479492 400.771240,259.989990 
	C411.183563,269.185852 420.344513,279.281677 429.609344,289.272125 
	C431.407074,291.210632 433.052795,293.290100 434.931396,295.598206 
	C434.795074,298.318024 433.172699,297.791595 431.215149,297.229980 
z"/>
<path fill="#5B5D62" opacity="1.000000" stroke="none" 
	d="
M399.110107,244.332672 
	C399.249420,240.691940 396.952698,238.250565 395.881378,235.399796 
	C394.429169,231.535583 395.039948,229.093903 399.633484,228.040161 
	C403.286682,227.318344 403.872131,231.811234 407.264954,231.624847 
	C408.840607,231.703613 410.064758,231.733780 411.554749,232.338440 
	C413.161316,233.770950 413.173309,235.459152 412.151794,236.521088 
	C407.909546,240.931091 409.263092,245.385040 411.708282,250.279083 
	C412.933136,252.428360 414.754639,251.503784 416.274536,251.593628 
	C422.335968,251.951935 428.442200,251.016785 434.819885,252.384018 
	C436.680634,254.977341 439.165375,254.475113 441.430176,254.623550 
	C444.580627,254.830063 447.659485,255.657028 451.225952,255.741486 
	C453.462891,256.169281 455.315735,256.500000 457.442078,257.350372 
	C457.952271,257.779114 458.111633,257.999481 458.130249,258.602722 
	C452.572571,259.630035 447.295349,257.916473 441.466980,258.037079 
	C439.331116,259.496643 437.336395,259.408142 435.341675,259.060150 
	C432.044586,258.484955 428.724365,258.482971 425.398407,258.491577 
	C418.858246,258.508545 418.858246,258.505127 417.156250,265.039764 
	C410.439148,258.879333 405.080566,251.551819 399.110107,244.332672 
z"/>
<path fill="#333237" opacity="1.000000" stroke="none" 
	d="
M325.149353,188.160370 
	C321.505493,187.105133 319.174316,184.443970 316.114624,182.365967 
	C314.998901,180.855347 315.463440,179.684921 316.257629,178.218292 
	C320.733551,174.593781 325.547729,172.200989 330.630432,169.957230 
	C329.594635,168.393448 327.769440,168.566193 326.725861,167.044617 
	C328.026794,161.339905 332.812775,160.688187 337.480072,159.438217 
	C340.140717,162.975220 343.370911,164.144867 347.698181,163.575012 
	C349.738495,166.514923 346.529419,167.976166 346.164185,170.568481 
	C345.724487,171.793610 345.190033,172.539917 344.212830,173.361542 
	C343.233521,174.020004 342.430969,174.352570 341.659790,175.266052 
	C341.180084,175.845078 340.895172,176.171021 340.375427,176.735062 
	C335.241486,180.652420 330.694305,184.800827 325.149353,188.160370 
z"/>
<path fill="#3A3639" opacity="1.000000" stroke="none" 
	d="
M388.175415,279.341705 
	C399.015900,284.056732 408.662170,291.098175 418.987244,297.614594 
	C417.555298,300.168762 415.039124,301.276154 412.421448,302.918518 
	C405.889923,303.403931 399.775055,303.524506 393.498535,301.255432 
	C391.487762,293.894073 389.816162,286.813080 388.175415,279.341705 
z"/>
<path fill="#534F51" opacity="1.000000" stroke="none" 
	d="
M416.958557,265.620178 
	C417.858887,262.719788 414.627472,259.620880 416.747253,257.802917 
	C419.145752,255.745911 422.798798,257.362396 425.874969,256.987549 
	C430.702515,256.399353 435.360992,258.011383 440.581818,258.026184 
	C441.304626,260.522156 439.879456,262.284210 438.016693,263.282593 
	C431.291931,266.886810 431.250519,272.684875 432.528687,278.967072 
	C432.795013,280.276215 433.254150,281.493225 431.982147,282.918762 
	C426.788788,277.408417 421.929504,271.668243 416.958557,265.620178 
z"/>
<path fill="#333237" opacity="1.000000" stroke="none" 
	d="
M299.237732,170.399292 
	C295.014801,167.610489 291.193329,164.913376 287.067505,162.035629 
	C285.976105,159.411301 287.974609,158.771545 289.439117,157.943634 
	C292.251892,156.353546 295.179626,154.972595 298.436340,153.432907 
	C300.552124,152.592255 302.655853,152.928665 304.527344,151.361526 
	C306.279022,150.382690 307.701385,149.581894 309.016235,148.582703 
	C310.662354,147.331787 312.408844,145.145630 314.562042,146.815796 
	C316.453766,148.283188 314.763672,150.432541 314.181732,152.601868 
	C313.533325,154.033249 313.291168,155.190170 313.186096,156.749817 
	C312.943665,158.876007 311.855194,160.257538 310.948242,162.124146 
	C309.448822,164.614563 308.699585,167.070221 307.024475,169.469818 
	C304.478180,171.066208 302.129883,171.445786 299.237732,170.399292 
z"/>
<path fill="#17E2F8" opacity="1.000000" stroke="none" 
	d="
M376.685852,287.291840 
	C378.048279,286.705505 379.162903,286.356049 380.633362,285.999908 
	C385.326843,295.736023 387.419556,306.197144 390.712341,316.653412 
	C388.566528,318.689758 386.244476,317.589203 384.280121,316.880768 
	C381.269623,315.795013 378.964661,316.493927 376.357544,318.428986 
	C373.558563,317.889862 372.564270,315.885315 371.502686,313.533142 
	C373.707672,309.768158 375.764801,306.242767 377.707001,302.287109 
	C378.323761,301.167145 378.878265,300.331024 378.037598,299.138916 
	C376.176239,298.245483 373.864319,298.262207 374.146851,295.183655 
	C374.131531,293.402588 377.653290,292.823914 375.003540,290.558136 
	C373.874329,289.592529 375.339478,288.285614 376.685852,287.291840 
z"/>
<path fill="#0ABEFA" opacity="1.000000" stroke="none" 
	d="
M396.392334,333.774750 
	C397.391144,335.499756 398.077576,336.967865 398.916779,338.747223 
	C399.834137,339.799988 400.559875,340.571838 401.171387,341.831390 
	C401.417023,342.301331 401.509674,342.492371 401.728088,342.975403 
	C402.161560,344.064575 402.520172,344.834351 403.250122,345.784851 
	C404.640656,348.373474 404.929749,350.964020 405.784973,353.757477 
	C406.058990,355.071503 406.063629,356.029022 405.578735,357.286560 
	C403.156891,359.027771 402.590271,356.825378 401.580597,355.754944 
	C399.170349,353.199707 396.570343,351.949951 392.907532,354.209747 
	C387.451752,348.512878 384.294189,341.763550 382.627380,333.983948 
	C387.187805,329.241821 391.630859,330.999664 396.392334,333.774750 
z"/>
<path fill="#29648A" opacity="1.000000" stroke="none" 
	d="
M397.063751,317.289734 
	C403.871948,321.426453 410.609955,326.004639 417.887695,331.223694 
	C418.353699,332.049408 418.279968,332.234222 418.029846,332.658264 
	C417.710510,333.032684 417.567566,333.167938 417.183594,333.469757 
	C416.608521,333.828094 416.270752,334.013092 415.678162,334.340332 
	C415.254578,334.595551 415.082001,334.701447 414.644257,334.973785 
	C413.838379,335.483337 413.312469,335.846893 412.599365,336.479950 
	C412.224030,336.833588 412.075714,336.972687 411.706421,337.312347 
	C411.337372,337.640747 411.189362,337.768616 410.816315,338.076843 
	C410.437836,338.367920 410.284393,338.478638 409.896545,338.742310 
	C409.352264,339.088226 409.043121,339.282318 408.521973,339.636353 
	C408.171539,339.903503 408.033783,340.011841 407.693909,340.284149 
	C407.358673,340.557312 407.225555,340.666504 406.891663,340.934662 
	C406.553009,341.191925 406.415131,341.290192 406.062378,341.519287 
	C405.847443,341.650085 405.412292,341.893250 405.196899,342.016022 
	C404.981476,342.138794 404.561096,342.400879 404.356995,342.543915 
	C404.018280,342.787415 403.883667,342.887848 403.539062,343.132904 
	C403.175079,343.353546 403.021149,343.429535 402.614929,343.564636 
	C402.010956,343.635040 401.680389,343.557098 401.209930,343.186462 
	C401.048859,342.983459 401.000092,343.002441 401.025726,343.007904 
	C400.293671,342.024323 400.336212,340.821716 400.217041,339.328644 
	C399.311951,331.876740 397.199890,324.951019 397.063751,317.289734 
z"/>
<path fill="#0FCFFB" opacity="1.000000" stroke="none" 
	d="
M396.645630,333.682739 
	C392.382324,333.858612 388.091888,330.107727 383.363617,333.959686 
	C381.475952,334.335388 380.776917,333.223846 380.420624,332.182190 
	C378.872803,327.656982 375.418610,323.837311 375.624634,318.402161 
	C378.177734,314.761902 380.863373,313.447418 384.783417,315.875183 
	C386.201599,316.753418 388.229614,316.646942 390.361145,317.006287 
	C392.690796,322.459808 394.638641,327.896820 396.645630,333.682739 
z"/>
<path fill="#72C2DC" opacity="1.000000" stroke="none" 
	d="
M324.963806,188.560989 
	C329.105499,183.496216 334.416046,179.993744 339.868073,176.154846 
	C340.597168,175.866898 340.955994,175.918167 341.398987,176.510101 
	C341.555847,176.978073 341.580200,177.175354 341.566925,177.665359 
	C341.368561,178.530441 341.148590,179.083572 340.891632,179.958191 
	C340.675568,180.648010 340.534119,181.027817 340.277130,181.649887 
	C340.177917,181.898254 339.995483,182.350311 339.959473,182.563965 
	C339.923492,182.777634 340.336914,182.993103 340.596954,182.952332 
	C343.662506,182.095459 346.790070,184.520599 349.724487,181.865692 
	C352.941711,181.735855 355.671753,180.359924 358.936951,180.708740 
	C360.694366,183.818344 358.844849,185.453247 356.807983,186.875870 
	C355.103882,188.066040 353.343140,189.224152 350.902283,189.809875 
	C350.272736,189.820129 350.024719,189.792084 349.430542,189.642975 
	C345.002686,187.632706 339.354645,189.627075 336.430054,194.212891 
	C335.672974,195.036209 335.041290,195.372162 333.908600,195.210052 
	C330.206512,193.734009 327.742126,191.182709 324.963806,188.560989 
z"/>
<path fill="#050E18" opacity="1.000000" stroke="none" 
	d="
M215.500061,93.950676 
	C218.631683,95.618988 221.706635,94.796829 224.653198,95.016312 
	C226.023819,95.118416 227.502274,95.278206 227.563614,97.028152 
	C227.614395,98.476860 226.281815,98.748154 225.152847,99.096664 
	C220.888321,100.413116 216.651291,101.823021 212.363983,103.059212 
	C210.656296,103.551582 209.865555,104.782700 209.516098,106.217949 
	C208.980133,108.419144 211.075317,108.303520 212.642517,108.960220 
	C213.896591,109.530846 214.223785,110.369987 214.091125,111.684250 
	C209.909119,111.923096 207.809601,108.653740 204.649475,106.456779 
	C202.619537,105.103760 200.916275,103.896271 199.023163,102.428856 
	C203.442245,97.796295 209.542923,96.389114 215.500061,93.950676 
z"/>
<path fill="#11141B" opacity="1.000000" stroke="none" 
	d="
M214.096466,112.303513 
	C213.636993,111.210854 213.341309,110.422081 213.019043,109.315445 
	C215.400543,107.032249 218.261566,106.918640 221.587402,106.996628 
	C223.295883,105.978416 224.507919,106.084908 225.821686,107.622269 
	C227.891571,109.817116 230.478439,109.350723 232.483704,109.104240 
	C235.701035,108.708778 236.834686,109.497795 235.092606,112.181656 
	C233.608551,114.468002 235.545120,116.292824 235.024231,118.686050 
	C235.032913,119.078987 234.694534,119.346016 234.489166,119.280640 
	C231.447769,119.152786 228.611740,119.090309 225.307495,119.067451 
	C221.312958,116.940521 217.786591,114.773964 214.096466,112.303513 
z"/>
<path fill="#252326" opacity="1.000000" stroke="none" 
	d="
M285.238037,159.809982 
	C281.653107,157.863632 278.391144,155.800140 274.922852,153.466446 
	C275.976959,147.356293 280.796814,149.143814 284.957642,148.597961 
	C285.658234,148.561676 285.936493,148.541687 286.628998,148.528900 
	C292.310150,149.550110 296.964325,146.580063 302.401855,146.373505 
	C303.490631,147.007339 303.807495,147.727631 303.976807,148.937683 
	C303.949982,149.587616 303.905914,149.843445 303.709259,150.453552 
	C302.952576,151.682999 302.000061,152.029022 300.757233,152.576324 
	C300.202484,152.788116 299.977020,152.857788 299.412354,153.013580 
	C294.792114,155.754410 289.748474,156.846298 285.238037,159.809982 
z"/>
<path fill="#46E7FA" opacity="1.000000" stroke="none" 
	d="
M389.252289,267.853271 
	C387.624207,267.232147 386.279175,266.348755 384.528717,265.376038 
	C383.535675,262.937592 382.872131,260.604095 382.384003,258.234467 
	C381.981018,256.278168 381.688446,254.440094 384.612457,253.871765 
	C386.420990,253.520233 387.199951,251.636627 387.749084,249.585434 
	C387.875916,249.033112 388.048737,248.828186 388.621460,248.581726 
	C389.281616,248.604340 389.541870,248.668488 390.185608,248.853241 
	C390.783752,248.880051 390.942871,248.938232 391.035461,249.288559 
	C391.225220,250.346146 391.625061,251.130920 392.772247,251.785019 
	C393.064636,251.957520 393.004211,251.996567 393.020355,251.964417 
	C393.208344,252.213928 393.419678,252.461960 393.868927,252.820419 
	C394.067322,252.964508 393.996948,252.988174 394.026245,252.965149 
	C394.360352,253.396164 394.520325,253.896301 394.415894,254.821915 
	C389.716553,258.179626 390.987396,263.408661 389.252289,267.853271 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M316.978271,177.733307 
	C316.642029,179.128418 316.371155,180.250397 316.033813,181.715302 
	C311.585052,180.350189 308.546906,176.637772 304.262421,174.185699 
	C302.745178,170.194092 306.571594,171.021194 308.285339,169.426178 
	C309.766754,168.647690 310.972015,168.220627 312.608582,167.892822 
	C315.050812,167.797226 317.052734,167.886230 317.904785,170.672485 
	C317.964630,171.238327 317.964996,171.461868 317.918823,172.007065 
	C317.732849,172.922256 317.533234,173.502487 317.484314,174.401154 
	C317.500977,174.878220 317.510925,175.068649 317.510925,175.544464 
	C317.435913,176.397797 317.297607,176.945206 316.978271,177.733307 
z"/>
<path fill="#606569" opacity="1.000000" stroke="none" 
	d="
M243.812805,131.617462 
	C248.187286,130.256210 248.671341,126.147438 249.974304,122.738121 
	C250.598770,121.104179 250.372528,119.118629 252.870667,117.977905 
	C256.438599,119.079903 259.620392,118.196999 262.826416,119.504494 
	C263.684418,120.343468 263.903168,121.081955 263.878479,122.276154 
	C263.673737,123.160957 263.405823,123.586365 262.666321,124.048965 
	C259.126099,123.532089 255.894989,122.277603 252.450577,124.915741 
	C254.409821,126.332489 256.577789,125.333206 258.544006,126.424774 
	C258.994049,126.814514 259.132538,127.016876 259.248810,127.590057 
	C258.015533,130.655762 255.281235,130.788162 252.646820,131.805695 
	C250.688324,132.503922 249.213272,133.508621 247.046432,133.503265 
	C245.773575,132.987595 244.867371,132.443970 243.812805,131.617462 
z"/>
<path fill="#272930" opacity="1.000000" stroke="none" 
	d="
M274.228699,152.333893 
	C270.721649,150.442932 267.462494,148.208755 264.004333,145.716370 
	C262.668610,142.942795 260.351044,140.742020 261.841309,137.194656 
	C262.117554,136.599579 262.254761,136.373718 262.679443,135.873016 
	C263.697235,135.216736 264.468903,135.128250 265.639526,135.414764 
	C269.007324,139.342957 270.940308,143.920792 274.787903,147.572845 
	C275.357697,149.360550 275.182281,150.706512 274.228699,152.333893 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M393.122681,301.260406 
	C399.387207,302.579468 405.750153,301.786560 412.521057,302.046448 
	C418.266327,301.063416 423.244751,302.700439 428.672302,303.798920 
	C430.119568,304.520630 431.179169,305.242798 432.561035,306.035889 
	C432.934814,307.787323 431.593353,308.018677 430.522522,307.949585 
	C422.943909,307.460297 415.386902,306.701538 407.845123,305.808472 
	C407.029785,305.711914 406.377625,305.074768 405.336975,304.338806 
	C401.538910,303.715057 398.094788,303.368011 394.216125,303.035431 
	C393.549713,302.548492 393.317841,302.047119 393.122681,301.260406 
z"/>
<path fill="#607584" opacity="1.000000" stroke="none" 
	d="
M333.736481,195.337112 
	C334.188019,194.799606 334.814667,194.526596 335.736267,194.080292 
	C339.503387,190.747787 343.792206,189.462738 348.615540,188.697311 
	C349.188141,188.861008 349.401520,188.907486 349.941864,188.974640 
	C350.572113,189.461319 350.762421,189.969803 350.834229,190.935303 
	C350.056580,194.148514 348.659180,196.484756 345.599854,198.032883 
	C342.542542,198.578491 339.949829,198.446167 337.059509,197.192169 
	C335.751007,196.526230 334.831299,196.063919 333.736481,195.337112 
z"/>
<path fill="#CFF3F8" opacity="1.000000" stroke="none" 
	d="
M441.935425,296.954712 
	C445.307983,300.078125 448.192474,303.337952 450.300110,307.624756 
	C450.075623,308.401642 449.624573,308.691589 448.669800,308.860535 
	C447.990051,308.854187 447.719116,308.821228 447.045685,308.713379 
	C446.643188,308.638489 446.565948,308.555267 446.509949,308.546082 
	C446.995575,307.391266 445.948578,307.616577 445.120789,307.247314 
	C444.794006,307.123932 444.906067,307.098328 444.898987,307.155365 
	C442.937897,304.020447 438.908386,302.569641 437.857300,298.367432 
	C439.159790,297.687805 440.360565,297.346283 441.935425,296.954712 
z"/>
<path fill="#77DCF6" opacity="1.000000" stroke="none" 
	d="
M345.771606,197.141602 
	C347.347992,195.165619 348.671967,193.432968 350.212616,191.444611 
	C351.992279,191.335892 351.827942,192.690460 352.250946,194.000031 
	C352.503052,195.161835 353.017212,195.818375 353.704712,196.737732 
	C353.844696,198.548248 352.755341,199.153168 351.287659,199.828857 
	C349.735565,201.235916 348.869629,202.858475 347.092834,204.053986 
	C345.882294,203.664749 344.987213,203.158676 343.943176,202.376572 
	C343.062286,200.944153 343.384613,199.834915 344.144958,198.444000 
	C344.696442,197.834564 345.087555,197.578690 345.771606,197.141602 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M346.984283,204.438309 
	C347.394348,202.309647 347.994720,200.434570 350.651764,199.984772 
	C351.721466,203.897263 352.583923,207.497070 357.165985,209.005035 
	C358.791992,209.540146 360.297852,211.325180 361.001556,213.633102 
	C356.013702,211.475052 351.659424,208.005554 346.984283,204.438309 
z"/>
<path fill="#3EE8F8" opacity="1.000000" stroke="none" 
	d="
M437.701721,297.871765 
	C439.685272,301.348938 443.509064,302.938934 444.917664,306.855835 
	C440.312897,304.012665 435.733917,300.812958 430.977356,297.314514 
	C432.064911,296.835663 433.330048,296.655518 434.844666,296.183624 
	C435.877594,296.499329 436.661041,297.106781 437.701721,297.871765 
z"/>
<path fill="#5CA0BC" opacity="1.000000" stroke="none" 
	d="
M284.957825,160.219910 
	C284.982452,157.889023 286.405548,157.467957 288.050171,156.854218 
	C291.549988,155.548172 294.914154,153.878586 298.679626,152.326828 
	C299.412262,152.745148 299.555176,153.262161 299.308228,154.240128 
	C294.989716,156.667007 290.489655,158.081482 286.813416,161.500763 
	C286.175629,161.407547 285.588104,160.960129 284.957825,160.219910 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M262.567291,136.572510 
	C261.406891,139.661880 263.934662,142.000885 263.857849,145.061676 
	C261.307037,143.831177 258.808777,142.204224 256.106384,140.307373 
	C255.434189,139.245773 255.464554,138.480408 256.336609,137.467529 
	C258.412537,136.282486 260.205261,135.568024 262.567291,136.572510 
z"/>
<path fill="#39AEDD" opacity="1.000000" stroke="none" 
	d="
M389.051819,248.726013 
	C388.530975,249.094894 388.365021,249.120804 387.951050,249.192383 
	C384.647736,246.979324 381.922729,244.453659 380.878052,240.339905 
	C384.720612,241.027466 386.324097,244.502441 389.005310,247.145874 
	C389.209259,247.755386 389.307983,248.069229 389.051819,248.726013 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M274.012024,152.858582 
	C273.891510,151.085754 273.802185,149.494431 273.591125,147.436325 
	C274.048645,145.692581 275.167542,145.102539 276.778503,144.600525 
	C277.397308,144.579712 277.642731,144.621948 278.188080,144.878754 
	C279.923889,148.491882 284.139587,146.850632 286.022217,149.637634 
	C282.297852,150.808212 277.921570,148.366516 274.860138,152.814667 
	C274.716522,153.196259 274.351227,153.241806 274.351227,153.241806 
	C274.351227,153.241806 274.043182,153.040085 274.012024,152.858582 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M257.092896,137.930389 
	C256.549866,138.681870 256.300659,139.119217 255.976822,139.797028 
	C254.264359,138.935303 252.626495,137.833115 250.796967,136.454407 
	C250.818878,134.979156 251.630646,134.201324 252.867279,133.233917 
	C254.924652,132.245590 256.758850,131.468582 258.188293,133.225067 
	C259.472412,134.802979 258.596863,136.318390 257.092896,137.930389 
z"/>
<path fill="#88A7B5" opacity="1.000000" stroke="none" 
	d="
M308.972656,169.469177 
	C307.930481,171.794205 305.060211,171.228378 304.045654,173.643982 
	C302.387054,172.944168 300.777618,171.904358 299.002197,170.586060 
	C301.193878,169.866852 303.551483,169.426132 306.284180,168.868103 
	C306.861938,168.663681 307.064606,168.576553 307.596741,168.455170 
	C308.367554,168.531982 308.718231,168.777573 308.972656,169.469177 
z"/>
<path fill="#54BDE4" opacity="1.000000" stroke="none" 
	d="
M253.208389,133.716461 
	C252.452881,134.661148 251.838196,135.285309 250.914398,136.043671 
	C249.440598,135.435318 248.275909,134.692764 246.895508,133.740692 
	C248.014648,132.355804 249.499557,131.463104 251.629868,131.094299 
	C252.901108,131.591995 253.270767,132.408432 253.208389,133.716461 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M344.923859,197.829605 
	C344.881134,199.184845 344.443512,200.296448 343.900024,201.754272 
	C342.318787,201.200821 340.843384,200.301132 339.138123,199.163086 
	C340.199646,196.034225 342.671204,198.098495 344.923859,197.829605 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M345.507935,197.929688 
	C343.372131,198.163605 341.425507,198.253998 339.193604,198.634567 
	C338.278137,198.451920 337.648010,197.979095 336.844299,197.247406 
	C339.481201,196.961136 342.291718,196.933731 345.563110,196.902313 
	C345.995361,197.223816 345.886414,197.519760 345.507935,197.929688 
z"/>
<path fill="#BEDBE2" opacity="1.000000" stroke="none" 
	d="
M399.971802,338.992645 
	C401.257538,339.900543 401.061249,341.159668 401.140442,342.663818 
	C399.483002,342.468628 399.664093,340.858734 399.061279,339.394836 
	C399.269897,339.040710 399.470184,339.022949 399.971802,338.992645 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M361.126648,214.284332 
	C362.222870,213.889938 363.397705,213.871872 363.978699,215.617188 
	C362.800629,216.064392 362.055847,215.251892 361.126648,214.284332 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M364.138367,216.294022 
	C365.283569,215.801880 366.127228,216.416382 366.889282,217.694489 
	C365.797577,218.063110 365.059143,217.251938 364.138367,216.294022 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M394.223633,255.155792 
	C393.918793,254.477631 393.850616,254.025208 393.919006,253.257446 
	C394.680298,253.387711 395.304993,253.833298 395.832947,254.813126 
	C395.314453,255.492218 394.889160,255.503571 394.223633,255.155792 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M393.016357,251.623352 
	C391.649445,252.262680 391.018402,251.558914 390.942932,249.836914 
	C391.672302,250.048859 392.320160,250.669006 393.016357,251.623352 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M399.969025,258.714233 
	C399.601410,258.988495 399.164062,258.972321 398.404572,258.876190 
	C397.941010,258.597168 397.799591,258.398071 397.887451,257.543213 
	C398.710907,257.399567 399.305115,257.911682 399.969025,258.714233 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M368.104156,219.222351 
	C368.386810,218.985504 368.663879,219.129654 368.972595,219.626480 
	C368.772003,219.720047 368.470123,219.594788 368.104156,219.222351 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M369.243591,220.106842 
	C369.458893,219.937027 369.690094,220.064941 369.961060,220.469604 
	C369.740082,220.681183 369.492981,220.567261 369.243591,220.106842 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M367.043152,218.277359 
	C367.286560,218.167389 367.580505,218.316940 367.948730,218.712799 
	C367.713196,218.818344 367.403442,218.677612 367.043152,218.277359 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M394.043304,252.676987 
	C393.713898,252.827347 393.360474,252.690186 393.021790,252.242630 
	C393.364105,252.084656 393.691681,252.237061 394.043304,252.676987 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M396.028809,254.979584 
	C396.422485,255.024734 396.695557,255.208939 396.777161,255.796021 
	C396.391815,256.113373 396.197906,256.027802 395.837708,255.671356 
	C395.671356,255.400452 395.908203,255.118622 396.028809,254.979584 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M397.011353,255.990601 
	C397.407562,256.050598 397.684174,256.228333 398.038757,256.646790 
	C398.116699,256.887482 397.852875,257.119446 397.719360,257.233582 
	C397.383484,257.224030 397.181122,257.100372 396.815918,256.660461 
	C396.653046,256.344238 396.891754,256.108307 397.011353,255.990601 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M400.894287,259.927551 
	C400.585785,259.994568 400.299164,259.759216 400.001862,259.242371 
	C400.299530,259.182312 400.607819,259.403778 400.894287,259.927551 
z"/>
<path fill="#39AEDD" opacity="1.000000" stroke="none" 
	d="
M381.027435,239.973328 
	C380.894623,239.862518 380.746796,239.767014 380.598969,239.671509 
	C380.689545,239.700073 380.780090,239.728653 380.928528,239.889648 
	C380.986359,240.022079 381.012421,239.988647 381.027435,239.973328 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M389.168152,249.107224 
	C388.784973,248.802811 388.872986,248.536667 389.035736,247.856049 
	C389.466980,247.753021 389.823486,248.064484 390.374542,248.674911 
	C390.259216,249.031082 389.949280,249.088287 389.168152,249.107224 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M375.562317,317.873383 
	C377.361847,323.511261 380.069031,328.457092 382.738647,333.766113 
	C386.122406,340.584808 389.251556,347.166168 392.649475,353.977051 
	C397.327759,358.595581 398.683228,364.727631 402.008484,370.157227 
	C403.919952,374.797211 406.908936,378.563080 407.763306,383.621399 
	C407.317474,385.348999 406.237732,385.910461 404.653900,386.369690 
	C401.301605,386.051208 400.574371,383.088928 398.407135,381.231628 
	C397.993683,380.818787 397.833282,380.648193 397.454102,380.202301 
	C392.804779,372.828674 388.226532,365.824432 383.562195,358.455872 
	C381.522583,352.782837 377.802307,348.349731 375.676575,342.718079 
	C375.575012,342.131622 375.572021,341.891388 375.753357,341.341522 
	C373.597412,336.298798 371.237457,331.575378 368.922607,326.829895 
	C366.781006,322.439545 363.937378,318.690521 359.247131,316.181702 
	C358.756439,316.158905 358.587921,316.238129 358.210327,316.132202 
	C358.001221,315.946991 357.998199,316.002899 358.024658,315.993713 
	C357.366455,315.438080 356.542542,315.145782 355.506836,314.555878 
	C354.037689,313.368988 352.694061,312.553711 351.328186,311.215881 
	C347.083252,306.841827 342.309570,303.644135 337.897949,300.008667 
	C335.367859,297.923706 332.310333,298.493225 329.118469,297.864227 
	C328.101501,297.409149 327.625122,296.892059 327.301453,295.840088 
	C327.729767,293.254578 330.976654,290.640411 326.098694,288.903137 
	C323.547058,286.933899 321.733154,284.569550 318.741455,283.144348 
	C318.265991,282.837189 318.082825,282.702850 317.652374,282.333801 
	C316.601013,280.974823 315.522430,280.133362 314.247253,278.979004 
	C313.460052,277.629456 313.120514,276.535919 314.414154,275.774445 
	C315.655334,275.043854 316.500824,276.078430 317.682861,276.918823 
	C332.012604,284.058472 346.083527,290.931244 358.519165,301.230164 
	C364.389526,303.524078 368.286621,307.633148 371.862305,312.605286 
	C373.106537,314.507050 374.204773,316.095520 375.562317,317.873383 
z"/>
<path fill="#040E11" opacity="1.000000" stroke="none" 
	d="
M293.997192,247.373779 
	C292.048523,245.122299 290.146912,243.248459 287.383423,241.951904 
	C284.023285,238.485229 280.999054,235.091782 277.961426,231.353851 
	C278.294403,230.672241 278.701874,230.452744 279.533417,230.381714 
	C283.050476,231.391373 285.160583,234.037155 288.271149,235.744705 
	C290.917023,237.538971 293.291443,239.133301 295.914612,240.928589 
	C296.979340,241.747894 297.744751,242.441299 298.988007,242.962982 
	C299.432434,243.200378 299.607300,243.299744 300.044861,243.544449 
	C300.475281,243.796844 300.642914,243.903870 301.261292,244.391174 
	C301.862549,244.894653 302.013062,245.017853 302.386292,245.326782 
	C303.192902,246.030319 303.891785,246.346313 304.840271,246.803375 
	C315.428070,256.664612 325.378540,266.760254 335.023132,277.568481 
	C335.064270,278.064178 335.017883,278.235016 334.725464,278.505768 
	C329.317078,274.745605 324.154694,270.885590 318.666809,266.932312 
	C312.905884,265.658600 309.882324,260.903015 305.213989,257.981750 
	C303.503815,256.722412 302.338898,255.365707 300.776306,253.950256 
	C300.360809,253.584229 300.193817,253.438049 299.505066,252.869370 
	C297.176147,251.046082 295.223358,249.796143 293.997192,247.373779 
z"/>
<path fill="#02ECFE" opacity="1.000000" stroke="none" 
	d="
M305.109772,256.756256 
	C309.663940,259.990387 313.815094,263.124847 318.153748,266.549164 
	C315.868286,269.873352 317.009644,273.155212 317.809021,276.803650 
	C316.560028,277.235443 315.493561,275.222656 314.083862,276.405304 
	C313.489044,276.904327 314.280975,277.803925 314.953979,278.707764 
	C315.724518,279.464600 316.282104,279.966553 316.538269,281.125061 
	C312.939240,286.932129 310.658813,287.026215 307.054077,281.874634 
	C305.819824,280.110748 304.658752,278.295807 303.146851,276.235901 
	C300.663727,272.238586 297.867767,268.824066 297.738007,264.200317 
	C297.601044,259.319519 299.664948,257.049103 305.109772,256.756256 
z"/>
<path fill="#02ECFE" opacity="1.000000" stroke="none" 
	d="
M372.219116,312.656860 
	C367.733063,309.249146 363.457794,305.579712 359.014526,301.630798 
	C362.430389,296.265228 364.945068,290.004547 372.693054,289.054810 
	C374.735992,290.451111 375.311798,292.212524 374.825745,294.680176 
	C374.255676,298.700378 377.690002,296.388458 378.880341,297.862610 
	C379.775848,299.138336 379.479797,300.178253 379.090027,301.533875 
	C376.750214,305.319916 376.936829,310.323364 372.219116,312.656860 
z"/>
<path fill="#0E151F" opacity="1.000000" stroke="none" 
	d="
M277.263733,223.238113 
	C275.562653,221.258499 273.870239,219.615326 271.891357,217.840240 
	C267.774719,217.512466 266.206787,214.163559 263.844421,211.998260 
	C261.537964,209.884186 259.125427,207.819382 257.268982,204.819611 
	C255.878265,203.177963 254.586044,201.880554 253.121948,200.310638 
	C252.753510,199.501236 252.891190,199.071365 253.735626,198.807648 
	C267.122284,209.174759 279.662567,220.018784 291.677368,231.942474 
	C294.395782,234.750229 296.804840,237.422623 299.510925,240.271912 
	C300.113739,240.930084 300.419617,241.411377 300.841125,242.157135 
	C300.897369,242.655838 300.837891,242.890060 300.445923,243.258118 
	C298.875244,243.364334 297.890411,242.790787 296.783020,241.722626 
	C293.871124,239.524323 291.178833,237.589523 288.705872,234.882202 
	C286.647827,232.781998 284.871124,230.865799 282.650421,228.932068 
	C280.502838,227.191376 278.231110,226.034790 277.263733,223.238113 
z"/>
<path fill="#3EE8F8" opacity="1.000000" stroke="none" 
	d="
M327.170227,253.144119 
	C328.064911,251.018448 327.987732,249.176285 328.043396,247.347977 
	C328.100830,245.462753 328.802887,244.009674 330.959259,244.122391 
	C333.602448,244.260498 333.065216,246.298187 332.787201,247.842087 
	C332.406799,249.954620 331.685608,252.004105 331.155579,254.092056 
	C330.835754,255.352097 330.904327,256.919708 328.987305,256.846893 
	C326.678680,256.759186 327.087128,255.021866 327.170227,253.144119 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M375.101624,294.746155 
	C373.424225,293.586456 374.079651,291.382843 373.089111,289.386200 
	C373.563812,287.411957 374.513031,286.527283 376.622803,287.036255 
	C377.160889,288.636810 374.480530,289.843781 376.615631,291.810974 
	C378.402618,293.457428 375.230713,293.308105 375.101624,294.746155 
z"/>
<path fill="#071A2D" opacity="1.000000" stroke="none" 
	d="
M304.972107,246.674683 
	C304.201874,246.831879 303.322723,246.703842 302.229370,246.316467 
	C301.779572,245.812790 301.553223,245.560150 301.143890,245.132629 
	C300.951599,244.966064 301.025818,244.975967 301.026031,245.013412 
	C300.890381,244.858856 300.754547,244.666870 300.767578,244.155182 
	C301.139496,243.760864 301.362640,243.686279 301.902405,243.767517 
	C303.100403,244.745377 303.981781,245.567398 304.972107,246.674683 
z"/>
<path fill="#1A6D97" opacity="1.000000" stroke="none" 
	d="
M302.820435,232.410156 
	C302.119110,232.179230 301.669495,231.847015 301.122772,231.248016 
	C300.889526,230.719330 300.753418,230.457458 301.030121,230.035645 
	C301.990845,230.334686 302.538788,230.793625 303.155975,231.520386 
	C303.174225,231.961746 303.123199,232.135300 302.820435,232.410156 
z"/>
<path fill="#0E151F" opacity="1.000000" stroke="none" 
	d="
M302.141052,243.681320 
	C301.997314,243.944733 301.775574,243.966095 301.221313,244.019913 
	C300.724243,244.147400 300.559692,244.242416 300.176941,244.154083 
	C299.958740,243.970764 300.020966,243.972794 300.024323,244.003738 
	C299.853363,243.897400 299.679077,243.760101 299.702393,243.355011 
	C300.068787,242.964890 300.237610,242.842545 300.681641,242.570923 
	C301.325562,242.760849 301.694336,243.100067 302.141052,243.681320 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M301.299377,229.525085 
	C301.339020,230.047058 301.235138,230.218384 301.078461,230.685455 
	C300.683472,230.823624 300.341248,230.666016 299.840820,230.254150 
	C299.696899,229.815857 299.711243,229.631836 299.854218,229.202698 
	C300.464600,228.539246 300.855804,228.610260 301.299377,229.525085 
z"/>
<path fill="#1A6D97" opacity="1.000000" stroke="none" 
	d="
M303.053650,231.962250 
	C303.377563,232.143311 303.529877,232.498428 303.682190,232.853561 
	C303.438263,232.873383 303.194305,232.893219 302.759552,232.712250 
	C302.568726,232.511459 302.882080,232.136307 303.053650,231.962250 
z"/>
<path fill="#1A6D97" opacity="1.000000" stroke="none" 
	d="
M304.613525,234.298645 
	C304.685242,234.404037 304.436615,234.481842 304.436615,234.481842 
	C304.436615,234.481842 304.541840,234.193237 304.613525,234.298645 
z"/>
<path fill="#040E11" opacity="1.000000" stroke="none" 
	d="
M336.167114,278.897888 
	C336.058990,278.921143 336.151459,279.106140 336.151459,279.106140 
	C336.151459,279.106140 336.275238,278.874634 336.167114,278.897888 
z"/>
<path fill="#040E11" opacity="1.000000" stroke="none" 
	d="
M336.135803,278.830200 
	C335.770721,278.854401 335.382263,278.910736 334.736633,278.786377 
	C334.479431,278.605652 334.782288,278.238190 334.946472,278.065735 
	C335.391357,278.069611 335.672028,278.245880 336.005859,278.671661 
	C336.058990,278.921143 336.112396,278.862335 336.135803,278.830200 
z"/>
<path fill="#02AEE7" opacity="1.000000" stroke="none" 
	d="
M213.000092,165.798615 
	C205.336914,160.802094 197.712402,155.487350 189.845367,149.961365 
	C189.580429,149.339035 189.558014,148.927963 189.815598,147.966492 
	C198.310410,152.733917 206.525238,158.051758 214.792755,163.702423 
	C213.925613,164.119888 213.201065,164.448700 213.000092,165.798615 
z"/>
<path fill="#1D98D1" opacity="1.000000" stroke="none" 
	d="
M189.885834,147.188095 
	C190.026596,147.807373 189.957596,148.198685 189.745728,149.170044 
	C181.874496,145.048584 174.269287,140.163361 167.042816,134.307617 
	C175.565842,136.541779 182.189438,142.503448 189.885834,147.188095 
z"/>
<path fill="#1D98D1" opacity="1.000000" stroke="none" 
	d="
M166.971191,133.633148 
	C166.831528,134.040421 166.627670,134.098099 166.108459,134.115723 
	C165.751434,133.886993 165.709778,133.698303 165.612503,133.223679 
	C166.006927,133.053024 166.456955,133.168289 166.971191,133.633148 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M253.941711,198.573471 
	C253.791977,199.077347 253.475815,199.287979 253.054871,199.768372 
	C252.106079,199.241104 251.262085,198.444046 250.658081,197.367554 
	C252.309784,196.392990 252.830078,197.849304 253.941711,198.573471 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M249.931305,195.755676 
	C248.352814,196.928162 248.076721,195.175354 247.048126,194.333405 
	C248.397781,193.476929 249.040482,194.682541 249.931305,195.755676 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M247.047577,193.754822 
	C246.723816,193.901108 246.427444,193.741837 246.052673,193.335098 
	C246.341171,193.208176 246.708054,193.328720 247.047577,193.754822 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M250.991913,196.755508 
	C250.378387,197.440628 249.947845,197.345139 249.759979,196.440445 
	C250.298874,196.193054 250.688721,196.311905 250.991913,196.755508 
z"/>
<path fill="#0ABEFA" opacity="1.000000" stroke="none" 
	d="
M86.274216,254.719757 
	C87.289925,254.774368 88.205055,254.881241 89.580521,255.007690 
	C90.060760,255.200378 90.080673,255.373505 90.151787,255.802963 
	C90.402512,256.514862 90.478317,256.991760 90.368896,257.848938 
	C90.151001,258.697510 90.086365,259.193573 90.063217,260.084808 
	C88.542023,266.351135 88.156723,272.394012 87.405228,278.787659 
	C87.379257,280.834167 87.372780,282.477325 87.136688,284.517700 
	C86.239090,288.319092 86.487061,291.785431 86.420769,295.597900 
	C86.370811,296.596832 86.449532,297.273987 86.228256,297.852692 
	C85.192932,300.560577 86.748291,299.705109 88.398056,299.281128 
	C89.180374,299.514008 89.582802,299.752014 90.213219,300.292114 
	C91.357582,301.682953 92.338089,302.739258 93.608459,304.043182 
	C97.032349,310.889709 96.209755,313.084076 90.160095,315.091400 
	C87.582932,315.946533 86.080673,315.248962 85.085907,312.450073 
	C83.573204,306.420868 82.136955,300.779053 80.307426,295.036011 
	C79.913376,293.874329 79.912605,292.813904 80.012680,291.366180 
	C80.873444,289.948914 79.821083,289.465424 79.335175,288.459656 
	C78.988342,286.471924 79.439316,284.963654 80.496063,283.264252 
	C81.441116,278.587982 82.201065,274.202789 82.899124,269.404358 
	C83.901299,264.554291 84.965378,260.117523 85.994751,255.264343 
	C85.960037,254.847977 86.173645,254.772034 86.274216,254.719757 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M80.291779,282.976807 
	C80.503990,284.742340 80.326797,286.511536 80.193779,288.661560 
	C80.307487,289.263763 80.377029,289.485138 80.134247,289.860107 
	C76.957253,289.505035 76.168121,287.275726 76.152130,284.921448 
	C76.134750,282.361542 78.419037,283.215851 80.291779,282.976807 
z"/>
<path fill="#19C7F4" opacity="1.000000" stroke="none" 
	d="
M79.891846,290.255859 
	C79.892235,289.852234 79.962563,289.690796 80.135422,289.285889 
	C80.836197,289.509583 81.061760,290.039307 80.314636,290.838654 
	C80.062935,290.818634 80.012367,290.658356 79.891846,290.255859 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M79.263290,295.179260 
	C79.591515,295.285004 79.581619,295.521820 79.159485,295.859222 
	C78.999069,295.739136 79.058380,295.522614 79.263290,295.179260 
z"/>
<path fill="#0ABEFA" opacity="1.000000" stroke="none" 
	d="
M87.094658,251.273682 
	C87.305962,251.218903 87.453239,251.379974 87.555344,251.565842 
	C87.576752,251.604813 87.431839,251.735138 87.212029,251.898285 
	C87.060493,251.973221 87.014565,251.498367 87.094658,251.273682 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M267.242706,552.446533 
	C267.877930,552.285522 268.748566,552.352051 269.830078,552.674377 
	C269.186676,552.844849 268.332397,552.759460 267.242706,552.446533 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M486.020935,441.054199 
	C486.660736,441.075531 486.984192,441.069580 487.549194,441.027527 
	C488.242798,441.257629 488.484711,441.640839 488.381653,442.496094 
	C487.523468,444.318695 486.800507,445.801727 486.033325,447.637756 
	C485.115356,449.020752 484.123779,449.887421 482.467682,450.263306 
	C481.661804,450.171417 481.187561,450.109039 480.355316,450.022522 
	C479.892822,449.850220 479.788269,449.702026 479.698730,449.282806 
	C479.844818,448.704193 480.304688,448.524658 480.265808,448.229248 
	C480.179474,447.573914 480.551758,448.309814 479.716309,448.001556 
	C479.491272,447.594055 479.440582,447.408417 479.398010,446.929291 
	C479.538727,446.039703 479.824280,445.515381 480.354675,444.773560 
	C480.685669,444.379456 480.827698,444.229126 481.201843,443.870361 
	C481.599060,443.534180 481.764160,443.406403 482.186707,443.099426 
	C483.538574,442.307373 484.443787,441.365906 486.020935,441.054199 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M479.808289,446.535187 
	C480.183777,446.802155 480.229675,447.027100 480.344788,447.589447 
	C480.400879,448.122009 480.387817,448.317169 480.325623,448.801514 
	C480.276428,449.090759 480.130219,449.542572 480.063782,449.770508 
	C478.053345,453.339722 476.066589,456.650360 473.111389,459.678925 
	C472.468262,460.265259 471.985443,460.554443 471.229095,460.913574 
	C470.789520,457.461090 474.091431,455.667450 475.145691,452.041138 
	C476.532257,449.648865 477.121185,447.296997 479.808289,446.535187 
z"/>
<path fill="#063A70" opacity="1.000000" stroke="none" 
	d="
M488.657104,442.889099 
	C488.138214,442.431458 488.029968,442.027191 487.856384,441.314941 
	C490.378845,439.500214 493.114929,438.628601 496.564819,439.060791 
	C496.320648,440.152283 495.665619,441.237335 494.986450,442.641846 
	C492.997437,442.955017 491.032623,442.948792 488.657104,442.889099 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M482.141174,450.498779 
	C483.206543,449.514313 484.277039,448.794830 485.668274,448.033051 
	C486.442841,451.319061 484.349121,451.117035 482.141174,450.498779 
z"/>
<path fill="#063A70" opacity="1.000000" stroke="none" 
	d="
M481.689941,456.013245 
	C481.539886,456.358032 481.060913,456.712982 480.282654,457.167725 
	C480.442596,456.852783 480.901794,456.438110 481.689941,456.013245 
z"/>
<path fill="#063A70" opacity="1.000000" stroke="none" 
	d="
M484.697449,454.011688 
	C484.534302,454.335907 484.068054,454.671814 483.298279,455.013000 
	C483.461304,454.686646 483.927856,454.355011 484.697449,454.011688 
z"/>
<path fill="#063A70" opacity="1.000000" stroke="none" 
	d="
M482.779114,455.088593 
	C482.840668,455.279541 482.662445,455.561890 482.240967,455.931519 
	C482.178253,455.739227 482.358795,455.459595 482.779114,455.088593 
z"/>
<path fill="#086AC0" opacity="1.000000" stroke="none" 
	d="
M459.045349,486.564240 
	C458.827271,487.076294 458.542145,487.300171 458.130493,487.764771 
	C455.419800,487.834778 453.441162,489.294525 451.153717,490.759705 
	C449.466766,490.862671 448.625549,490.234192 449.850922,488.840454 
	C451.269257,487.227264 452.863129,485.768402 454.686768,484.104858 
	C455.448425,484.427155 455.858459,484.960114 456.921539,484.920227 
	C458.072876,485.032898 458.731750,485.400604 459.045349,486.564240 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M463.661865,476.040741 
	C462.445007,475.781891 461.917755,475.310638 462.712128,474.143799 
	C463.237671,474.346283 463.577850,474.405334 464.255615,474.084839 
	C464.858826,473.498169 465.181915,473.028259 465.727844,472.536438 
	C466.387512,471.634827 467.034241,470.995972 468.355103,470.742737 
	C468.707672,470.759491 469.000610,471.003418 469.151672,471.125610 
	C468.461182,473.874298 466.272400,474.996735 463.661865,476.040741 
z"/>
<path fill="#009AED" opacity="1.000000" stroke="none" 
	d="
M457.095947,484.659119 
	C456.655609,485.641693 456.125732,486.899506 455.088043,486.614960 
	C453.951691,486.303406 455.090698,485.279480 454.998047,484.270020 
	C454.992706,483.967163 454.998871,484.000732 454.982788,483.997864 
	C455.142731,483.868439 455.318756,483.741913 455.772949,483.783783 
	C456.348907,484.117432 456.646698,484.282654 457.095947,484.659119 
z"/>
<path fill="#086AC0" opacity="1.000000" stroke="none" 
	d="
M456.039062,483.709534 
	C455.871216,483.980438 455.691345,484.008698 455.239105,484.015930 
	C455.152649,483.718109 455.338562,483.441254 455.763062,483.072968 
	C456.001678,482.981537 456.026978,483.466827 456.039062,483.709534 
z"/>
<path fill="#086AC0" opacity="1.000000" stroke="none" 
	d="
M443.087616,493.562286 
	C440.826050,495.484650 438.720703,497.134705 436.321472,498.945984 
	C435.879364,498.008118 436.123596,496.318390 435.514160,495.913513 
	C433.047394,494.274597 432.950470,494.420471 435.839355,492.281799 
	C435.549957,491.541962 435.026581,491.468262 434.242920,491.785767 
	C432.695129,492.553589 431.414154,493.518860 429.830902,492.608368 
	C432.528931,489.631470 432.194824,483.319824 429.038605,478.481262 
	C429.245392,477.426117 429.804840,476.976227 430.803986,476.497467 
	C432.592102,476.067139 433.995117,476.595612 435.788025,476.580322 
	C437.373413,476.451202 438.598938,476.096680 440.112213,476.830200 
	C441.156677,478.156616 441.201050,479.384521 441.042633,480.985657 
	C440.901459,481.968994 440.743866,482.815704 441.522003,482.961090 
	C443.634918,483.355865 445.442657,484.173553 445.459198,486.553894 
	C445.479065,489.421356 442.543976,488.440948 441.212280,489.415344 
	C442.621704,489.071716 444.079254,488.452332 445.922180,488.853943 
	C445.187653,490.498199 444.215729,491.894104 443.087616,493.562286 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M463.596893,465.690613 
	C460.990692,471.008850 457.984863,475.876495 453.355499,479.924377 
	C451.764282,479.013885 450.362305,478.131897 448.399902,477.619629 
	C445.897491,475.504791 450.397461,473.215820 447.544739,471.096313 
	C447.093689,470.796387 446.910156,470.677856 446.449158,470.381165 
	C444.631561,469.066132 442.700439,469.355682 440.678955,468.620239 
	C439.948151,468.126251 439.693146,467.705750 439.615021,466.807617 
	C440.299500,465.113800 441.568268,464.208649 442.784790,464.322571 
	C448.824951,464.888428 454.795807,462.889038 460.823578,463.954987 
	C461.815460,464.130371 462.676117,464.600769 463.596893,465.690613 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M463.965210,465.756653 
	C455.974365,463.701385 448.208130,465.976593 440.174316,466.778992 
	C439.554047,467.391052 439.105988,467.567566 438.234894,467.515076 
	C437.435364,467.205750 437.034821,466.924622 436.434906,466.315674 
	C433.768280,463.189423 430.147522,464.114410 426.752441,463.093628 
	C425.043884,462.550812 424.250732,461.675079 424.338440,459.819580 
	C425.007721,458.181458 426.200684,457.876404 427.733643,457.548462 
	C428.826843,457.486603 429.671692,457.853180 430.446869,456.785461 
	C431.672852,455.243622 432.731476,453.483643 434.561829,454.032928 
	C436.444550,454.597931 435.626068,456.519043 435.561066,457.946259 
	C435.516052,458.935364 435.973114,459.655975 436.943329,459.606323 
	C440.051422,459.447235 442.701813,461.179596 445.650299,461.591461 
	C450.863617,462.319641 451.940887,461.494110 455.098145,454.522949 
	C455.958618,453.183807 456.988373,452.558197 458.318237,451.741516 
	C459.104736,451.430176 459.578888,451.374725 460.402863,451.530548 
	C461.363892,452.088928 461.670563,452.710754 461.775391,453.802490 
	C461.719940,454.388184 461.667175,454.618713 461.465851,455.170654 
	C461.063965,455.888306 460.786621,456.266907 460.259216,456.893921 
	C459.593658,457.653015 459.087982,458.090118 458.686462,458.612091 
	C456.238770,461.793976 456.394196,462.226654 460.209503,462.715210 
	C461.672241,462.902527 463.197021,462.709534 464.786682,463.749451 
	C464.713379,464.501984 464.405090,464.997437 463.965210,465.756653 
z"/>
<path fill="#033E75" opacity="1.000000" stroke="none" 
	d="
M465.229065,463.982483 
	C461.581329,463.915039 458.050568,464.511200 454.747101,462.569214 
	C455.501648,460.007080 457.212006,458.069397 459.489197,456.163391 
	C460.081390,455.821411 460.370148,455.612579 460.816833,455.175049 
	C460.995056,454.974823 460.999115,455.006165 460.984436,455.000183 
	C462.314026,452.827209 463.517853,450.523071 466.532410,449.626434 
	C468.801544,450.287079 470.504272,451.393677 472.453247,452.690552 
	C470.442291,456.379395 468.226624,459.798676 465.929565,463.553589 
	C465.848175,463.889160 465.436432,463.958466 465.229065,463.982483 
z"/>
<path fill="#0355A0" opacity="1.000000" stroke="none" 
	d="
M447.713135,476.803558 
	C449.828339,477.416718 452.594879,475.791962 453.030701,479.693176 
	C453.062927,480.091522 453.024750,480.049622 453.051025,480.043518 
	C452.332092,480.843689 450.303101,480.520264 451.030396,482.800049 
	C449.676880,484.979065 448.195099,486.867371 446.436432,488.929016 
	C443.251068,488.869049 440.699066,491.967804 437.358917,490.284058 
	C438.423004,488.444244 440.269073,489.213867 441.403107,488.346619 
	C442.396515,487.586853 444.872284,488.716278 444.455383,486.266022 
	C444.113007,484.253540 442.751404,483.909851 440.728790,484.536102 
	C438.197205,485.319916 437.444702,484.469910 439.676239,482.130920 
	C441.325653,479.425629 444.936157,479.920319 446.510468,477.083130 
	C446.982452,476.767914 447.201691,476.690582 447.713135,476.803558 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M451.399292,482.904541 
	C450.212585,482.764679 448.413391,483.411743 448.539978,481.847839 
	C448.717010,479.660583 450.784515,480.135559 452.688263,480.024231 
	C452.598145,480.931061 452.119019,481.824707 451.399292,482.904541 
z"/>
<path fill="#08346F" opacity="1.000000" stroke="none" 
	d="
M468.789978,470.475708 
	C467.976349,471.231720 467.245056,471.704010 466.232239,472.345398 
	C465.755920,471.994720 465.561127,471.474945 465.418091,470.528687 
	C466.393860,469.766266 467.317902,469.430328 468.603943,469.057159 
	C468.934753,469.410583 468.903534,469.801270 468.789978,470.475708 
z"/>
<path fill="#08346F" opacity="1.000000" stroke="none" 
	d="
M464.142212,473.873840 
	C464.121429,474.070312 463.707092,474.172546 463.128723,474.127625 
	C463.225952,473.913513 463.487305,473.846558 464.142212,473.873840 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M470.986420,461.729187 
	C470.516174,461.879883 470.066284,461.773102 469.616394,461.666321 
	C469.876312,461.372345 470.136292,461.078369 470.684875,460.870331 
	C470.984558,461.128082 470.995667,461.299896 470.986420,461.729187 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M472.899719,452.704773 
	C470.505249,453.024719 468.742676,452.198975 467.155640,450.316650 
	C465.733948,448.059570 467.106110,446.957855 468.725861,445.617310 
	C471.363831,444.709381 473.449768,445.404785 475.844421,446.517090 
	C477.242981,448.491669 476.187500,449.908081 475.251953,451.701477 
	C475.000366,452.024323 474.994995,451.998962 475.007507,451.998962 
	C474.259613,451.589539 473.699310,452.014313 472.899719,452.704773 
z"/>
<path fill="#0D89D9" opacity="1.000000" stroke="none" 
	d="
M390.113495,494.178955 
	C388.378143,493.483337 387.976593,491.925781 387.105896,490.306091 
	C383.719055,487.746674 382.917328,484.286926 382.535400,480.313965 
	C385.104919,476.760712 387.813080,479.141449 390.800293,479.666382 
	C392.148346,480.075195 393.011444,480.542938 393.514038,481.901001 
	C393.498901,482.576660 393.421906,482.896973 393.330383,483.213257 
	C393.238281,483.531555 393.202881,483.855225 393.236816,484.187958 
	C393.694641,484.065186 393.275299,483.682770 393.552979,483.164551 
	C394.419800,480.749664 395.318451,478.843872 398.435730,479.939148 
	C399.480438,480.919617 399.380737,481.705078 398.498962,482.711426 
	C398.114044,483.056854 397.952972,483.183258 397.543213,483.478638 
	C396.778900,484.070312 397.365814,483.357971 396.982025,483.903107 
	C396.903564,484.014618 397.048645,484.010498 397.735870,483.963196 
	C399.448151,484.670624 400.371674,485.968506 401.964844,486.877319 
	C402.588013,487.359772 403.149872,487.301819 403.456482,487.718201 
	C403.545929,487.363129 403.365204,487.202484 402.708313,487.033264 
	C402.332672,486.455292 402.242676,486.060760 402.247650,485.327209 
	C403.049164,483.027924 404.547058,482.994904 406.167206,483.665314 
	C407.358368,484.158142 408.497772,484.650482 410.138733,484.219055 
	C410.686859,484.195618 410.906403,484.209717 411.442444,484.308228 
	C411.952972,484.487122 412.147003,484.581665 412.609253,484.849609 
	C413.677460,485.713196 414.783264,485.878143 415.787903,486.813416 
	C416.001831,488.123383 415.998108,489.210632 415.991760,490.705566 
	C414.927704,492.267090 413.447266,492.371307 411.706482,492.727051 
	C410.035370,493.217651 408.420227,491.411194 407.412720,493.565460 
	C408.175171,495.217590 408.315430,496.773346 409.263611,498.761261 
	C409.343048,499.657562 409.268341,499.881622 408.910767,500.323669 
	C407.146606,501.126770 405.816376,500.672394 404.246155,499.742462 
	C403.316254,498.897888 403.017242,498.067352 402.638245,496.949585 
	C402.516083,496.480255 402.481079,496.294342 402.449585,495.839111 
	C402.595673,495.268188 402.721039,494.959564 402.628784,494.781738 
	C401.999237,495.300293 401.493988,495.380829 400.682373,495.158112 
	C399.214844,494.511444 399.813721,492.077515 397.419769,492.564514 
	C396.889191,492.615601 396.671173,492.608002 396.134460,492.501221 
	C395.068146,492.003448 394.509094,491.297852 392.952393,491.461670 
	C392.131836,491.995728 392.012878,492.142426 391.721222,492.518372 
	C391.200623,493.220520 390.826080,493.669922 390.113495,494.178955 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M418.114227,461.827209 
	C416.847870,463.312286 415.273590,462.969391 413.418579,463.059570 
	C412.849426,463.182098 412.662292,463.324310 412.137268,463.567932 
	C407.958893,463.500641 410.753174,459.166534 408.185303,458.065430 
	C407.846161,460.605133 406.111389,462.024841 404.288330,460.138794 
	C402.082397,457.856598 399.521912,458.423492 396.747894,457.702057 
	C395.490082,456.924194 395.194794,456.022064 395.384216,454.589996 
	C397.305481,452.073273 399.878143,450.968079 402.473633,449.260376 
	C404.231659,448.583771 405.686188,448.217194 407.549255,447.998413 
	C410.272522,448.295624 412.243500,449.956482 415.032288,449.980530 
	C417.951508,451.385437 419.684998,446.695679 422.701050,449.234070 
	C423.524719,449.877960 423.893280,450.459381 424.311462,451.423645 
	C424.453918,451.991791 424.477661,452.226929 424.424866,452.808838 
	C424.116547,453.567047 423.829712,453.934509 423.185608,454.432068 
	C422.682343,454.692139 422.469910,454.769165 421.928467,454.900574 
	C420.066376,454.480316 420.105225,455.247833 420.447937,456.620239 
	C419.929291,457.850159 418.720520,458.120667 418.398193,459.476807 
	C418.300568,460.358398 418.246338,460.947998 418.114227,461.827209 
z"/>
<path fill="#086AC0" opacity="1.000000" stroke="none" 
	d="
M411.371216,484.655945 
	C408.402710,488.005646 406.078735,483.479004 403.242920,484.700531 
	C401.313568,485.550232 401.286499,483.945129 400.527893,482.800262 
	C400.327637,482.263885 400.259583,482.046295 400.132446,481.494812 
	C400.020416,480.722595 399.994629,480.282745 400.029022,479.527039 
	C400.101959,479.012726 400.144501,478.812531 400.265533,478.327728 
	C400.479858,477.449097 400.369263,476.906281 399.811615,476.157043 
	C398.986633,474.817139 398.920013,473.689850 399.538605,472.204590 
	C402.210052,471.015503 404.644073,470.590973 406.971954,472.884247 
	C408.995697,476.373444 410.875244,473.157074 412.777374,473.219269 
	C413.563873,473.244995 414.425293,473.123993 415.113770,473.407257 
	C415.823730,473.699432 415.787201,474.692596 415.254791,475.031067 
	C411.374847,477.497742 415.346741,479.321533 415.834534,481.746155 
	C414.794373,483.399597 412.760040,483.117096 411.371216,484.655945 
z"/>
<path fill="#086AC0" opacity="1.000000" stroke="none" 
	d="
M422.749207,454.173828 
	C423.074921,453.669220 423.264313,453.417847 423.750275,453.125061 
	C425.202087,453.841156 425.819000,455.172150 426.615692,456.331818 
	C427.902039,458.204346 426.450409,458.389709 424.967163,458.865387 
	C425.029205,460.245087 424.872925,461.509338 426.635071,461.995667 
	C428.550232,463.046875 428.505493,465.427246 430.901245,465.987549 
	C432.506287,466.363007 433.119904,468.459381 432.092834,470.108582 
	C431.189117,471.559723 430.944946,473.136353 430.314270,474.983765 
	C429.682617,475.498077 429.234253,475.620056 428.424377,475.489319 
	C426.752502,474.466217 427.084076,472.830292 426.279633,471.318542 
	C424.983551,471.068329 423.679932,470.711090 423.097961,472.581543 
	C422.669983,473.344604 422.205322,473.520386 421.327240,473.231812 
	C420.132935,470.039673 418.622772,467.402588 416.826599,465.019287 
	C417.646698,462.887970 420.129364,465.547913 421.001953,463.171570 
	C420.818176,462.108795 420.447113,461.393311 420.322937,460.297729 
	C420.315582,459.804688 420.333466,459.608398 420.431519,459.129791 
	C420.779358,458.141785 421.321106,457.551392 421.392090,456.476227 
	C421.412476,455.999084 421.430450,455.807556 421.734406,455.127441 
	C422.191101,454.548065 422.361816,454.457306 422.749207,454.173828 
z"/>
<path fill="#0E7EEA" opacity="1.000000" stroke="none" 
	d="
M403.646545,499.037781 
	C405.413025,499.342346 406.831116,499.667297 408.617493,499.997345 
	C410.493805,499.665710 411.968964,499.622681 413.636475,500.722321 
	C416.714294,501.664032 420.372528,500.927094 420.997131,505.600586 
	C418.854126,507.200714 416.276093,507.763885 414.497528,506.143524 
	C408.594025,500.765320 402.671631,504.882782 396.395508,505.796936 
	C396.043823,505.953735 396.017761,505.970978 396.023071,505.963531 
	C395.046326,504.387482 392.787140,503.335480 394.272766,500.675720 
	C397.487854,500.058411 400.603302,500.864502 403.646545,499.037781 
z"/>
<path fill="#086AC0" opacity="1.000000" stroke="none" 
	d="
M411.795288,463.201782 
	C412.157104,462.998596 412.333252,462.994202 412.772949,463.014862 
	C415.221252,464.911011 413.169403,467.606598 414.352234,469.831055 
	C414.855347,470.777161 413.363495,471.123779 412.431671,470.383850 
	C411.714172,469.814087 412.190430,467.768433 410.092651,468.917969 
	C406.707550,472.402710 403.157928,471.359924 399.243774,469.778137 
	C397.679352,468.271912 397.023224,466.810059 397.344421,464.662964 
	C400.377594,461.801880 404.882080,464.268646 407.670410,461.061554 
	C407.939819,460.751709 408.758636,462.032867 409.162109,463.076721 
	C409.513977,463.657532 409.798370,463.890686 410.428436,463.986755 
	C411.029938,463.820709 411.334900,463.635590 411.795288,463.201782 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M407.263977,494.333435 
	C406.009491,493.470551 403.805695,492.808105 404.762573,491.717285 
	C406.061493,490.236572 408.390900,490.956726 410.610870,491.817932 
	C411.700165,492.502777 412.075989,493.287079 412.417603,494.467773 
	C412.710876,495.662903 412.519196,496.561279 412.790527,497.747070 
	C412.911835,498.055969 412.947571,498.524231 412.960144,498.758698 
	C412.018921,499.970947 410.919495,500.011230 409.376099,499.238525 
	C409.018341,498.980774 409.000000,498.998779 409.009888,498.992859 
	C407.987183,497.670227 408.374603,495.887604 407.263977,494.333435 
z"/>
<path fill="#086AC0" opacity="1.000000" stroke="none" 
	d="
M422.681458,474.834839 
	C425.414215,475.601379 425.735687,476.856232 423.466827,477.916534 
	C421.658020,478.761810 419.522095,479.079529 417.500977,479.234314 
	C416.267639,479.328796 415.917755,478.284943 416.748138,477.240295 
	C417.558411,476.220947 418.446014,475.263123 419.579346,474.107147 
	C420.553284,474.690979 421.536194,474.450867 422.681458,474.834839 
z"/>
<path fill="#08346F" opacity="1.000000" stroke="none" 
	d="
M398.856628,469.618958 
	C402.502472,469.908691 405.815521,470.386261 409.535278,469.288940 
	C410.098602,470.988800 409.128693,472.100677 407.359619,473.080261 
	C405.222382,471.305603 402.618378,473.602966 400.348358,472.046692 
	C399.048523,471.727936 398.615540,471.056946 398.856628,469.618958 
z"/>
<path fill="#032B57" opacity="1.000000" stroke="none" 
	d="
M412.454468,495.380615 
	C411.143555,494.586639 410.937195,493.677673 410.952087,492.308228 
	C412.318542,491.310608 413.673462,490.665100 415.615509,491.103271 
	C417.292419,491.282806 417.981415,492.089905 418.374115,493.643341 
	C416.872711,495.483643 414.860748,495.575562 412.454468,495.380615 
z"/>
<path fill="#063A70" opacity="1.000000" stroke="none" 
	d="
M411.377747,484.877930 
	C410.617126,481.337311 413.170685,482.050690 415.554779,482.023132 
	C416.024750,483.449524 416.094849,484.832275 416.085266,486.625610 
	C414.834137,486.903046 413.662689,486.769897 412.272156,486.360168 
	C412.304169,485.675873 412.703796,485.543030 413.147675,485.492035 
	C412.921570,485.386200 412.670685,485.466736 412.243195,485.158997 
	C412.046722,484.920074 411.601532,484.873138 411.377747,484.877930 
z"/>
<path fill="#086AC0" opacity="1.000000" stroke="none" 
	d="
M411.944702,495.388489 
	C413.929688,494.797028 415.779510,494.431732 418.053345,494.020721 
	C418.477356,493.974976 418.678894,493.879303 418.888855,493.991028 
	C418.446198,497.460388 414.381958,494.832489 413.099701,497.735474 
	C412.087036,497.448700 410.913452,496.998932 411.944702,495.388489 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M420.596741,459.721100 
	C421.327118,460.798737 422.344360,461.483643 421.293396,462.724792 
	C420.256378,462.655182 419.467865,462.441895 418.379150,462.175201 
	C417.736145,461.615845 417.393311,461.109924 417.042480,460.286102 
	C418.007721,459.177002 419.069031,458.956879 420.596741,459.721100 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M425.969971,471.294556 
	C428.317200,471.265167 427.912384,472.983734 428.038635,474.793274 
	C428.132233,475.349121 428.215302,475.521179 428.085449,475.885040 
	C425.379700,475.400940 425.559448,473.507904 425.969971,471.294556 
z"/>
<path fill="#086AC0" opacity="1.000000" stroke="none" 
	d="
M409.009521,499.236176 
	C410.073029,498.983246 411.127747,498.985718 412.577576,498.990662 
	C413.290894,499.451141 413.609100,499.909119 413.929199,500.660400 
	C412.442810,500.879456 410.905273,501.362305 409.233582,500.281189 
	C408.990723,499.832153 408.995728,499.661865 409.009521,499.236176 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M427.816864,476.337067 
	C427.872528,476.076874 428.018555,475.636322 428.033844,475.406677 
	C428.479889,475.147003 428.910645,475.116943 429.665588,475.083374 
	C430.684174,475.265778 431.083466,475.735138 431.110413,476.697784 
	C430.477905,477.316772 430.002869,477.648804 429.240112,478.061066 
	C428.191650,477.907166 426.982819,478.018738 427.816864,476.337067 
z"/>
<path fill="#0355A0" opacity="1.000000" stroke="none" 
	d="
M419.753845,493.229492 
	C421.078583,491.800171 422.805511,491.291229 423.333282,492.940613 
	C423.742126,494.218353 421.717957,493.874359 420.329956,494.052429 
	C419.844147,493.858002 419.728119,493.683807 419.753845,493.229492 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M423.015076,474.656189 
	C421.931488,475.197540 420.673309,476.896973 419.921814,474.256317 
	C420.156311,473.776093 420.453552,473.616150 420.877930,473.232300 
	C421.457458,472.978821 421.909882,472.949310 422.702881,472.923798 
	C423.046753,473.389160 423.050018,473.850494 423.015076,474.656189 
z"/>
<path fill="#0355A0" opacity="1.000000" stroke="none" 
	d="
M434.358276,491.972595 
	C434.444855,491.276031 434.961975,490.984619 435.844086,491.750946 
	C435.554901,491.970398 435.119720,491.973663 434.358276,491.972595 
z"/>
<path fill="#086AC0" opacity="1.000000" stroke="none" 
	d="
M419.695984,493.066223 
	C419.915985,493.129181 419.936371,493.308960 419.958435,493.760437 
	C419.960144,494.032166 419.526428,494.042542 419.312622,494.072632 
	C419.098785,494.102753 418.999573,493.995880 418.950775,493.939148 
	C419.040863,493.598907 419.238983,493.365814 419.695984,493.066223 
z"/>
<path fill="#05E2FD" opacity="1.000000" stroke="none" 
	d="
M382.928864,479.585205 
	C384.200287,483.285065 385.475037,486.312134 386.860657,489.673676 
	C384.730988,490.172394 382.462372,489.945801 381.462097,487.677246 
	C379.125000,482.376831 373.483307,480.063049 370.302917,475.146606 
	C368.285492,473.139740 368.734650,470.947174 369.205688,468.854462 
	C369.970581,465.456451 369.153900,463.000275 365.711426,461.658508 
	C362.755951,460.506500 361.009674,458.067841 359.522278,455.420013 
	C358.639160,453.847931 358.118927,451.992096 355.858643,451.082092 
	C350.807556,445.395630 348.564728,438.667511 346.214661,431.629303 
	C348.254272,427.744019 350.168243,430.083466 351.671478,431.585846 
	C354.857880,434.770325 357.167297,438.692932 359.997284,442.185516 
	C362.614319,445.415344 365.120605,448.812561 369.724976,450.251099 
	C371.379852,451.252075 371.926117,452.622925 372.646027,454.300598 
	C373.650452,456.769196 374.777496,458.790009 375.823914,461.219055 
	C376.448578,462.978516 376.826599,464.464996 377.513977,466.184814 
	C377.884552,467.060974 378.116180,467.648987 378.531982,468.498291 
	C378.951691,469.340424 379.199280,469.916931 379.586853,470.776703 
	C380.014709,471.854919 380.233978,472.673645 380.722107,473.737915 
	C381.548370,475.659363 382.516663,477.168671 382.928864,479.585205 
z"/>
<path fill="#0EE7FD" opacity="1.000000" stroke="none" 
	d="
M355.502502,450.387482 
	C361.509644,453.851776 364.711914,460.297607 370.581055,464.255829 
	C372.836578,465.776978 369.383331,470.661682 370.000000,474.562531 
	C366.708557,475.310333 366.875824,477.766449 367.043091,480.027771 
	C367.195526,482.088623 367.663849,484.126099 367.988037,486.594971 
	C367.617493,487.011536 367.251923,487.006989 366.612793,487.023987 
	C366.000275,486.855377 365.682556,486.634918 365.189423,486.168274 
	C364.989349,485.957184 364.989929,486.010986 365.016663,486.008087 
	C364.799683,485.785706 364.564026,485.557922 364.170135,485.140747 
	C364.003845,484.959656 363.994843,485.005127 364.017700,485.001282 
	C363.233704,483.924835 362.556061,482.708984 360.820160,482.155640 
	C359.147064,479.008057 357.257019,476.364929 355.233643,473.381836 
	C352.667847,469.643616 351.258240,465.684570 349.086334,462.138153 
	C348.273285,460.810516 347.783966,459.413910 349.236328,457.799805 
	C353.080078,457.884705 353.413086,461.328186 355.422485,463.575439 
	C356.471222,464.806030 357.217316,465.866364 358.592529,466.744934 
	C359.813507,467.355133 360.375641,468.281097 361.480286,468.846497 
	C361.703430,468.885315 362.097900,468.787018 362.227539,468.626099 
	C362.357208,468.465179 362.351135,467.998596 362.263397,467.762268 
	C362.101227,467.369781 362.026764,467.213593 361.830353,466.825195 
	C361.626007,466.438110 361.543671,466.283203 361.343414,465.893341 
	C361.071228,465.340363 360.917480,465.022156 360.639404,464.461365 
	C360.438629,464.050110 360.362885,463.881042 360.188202,463.448547 
	C359.845551,462.451569 359.595062,461.720734 359.090729,460.757568 
	C357.931885,458.074158 357.075836,455.590668 355.428741,453.101562 
	C355.100800,452.083038 355.101685,451.385529 355.502502,450.387482 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M389.860687,494.601318 
	C390.023651,493.677795 390.208099,493.060822 390.630341,492.229431 
	C391.076813,491.876465 391.285431,491.737915 391.867065,491.545471 
	C393.591431,491.289551 394.705353,491.873291 396.095947,492.790436 
	C396.806183,493.719635 396.887817,494.467896 396.573792,495.609222 
	C395.536499,497.046783 394.277557,497.369720 392.615479,497.679810 
	C391.978271,497.635468 391.728271,497.571869 391.137756,497.324585 
	C390.492188,496.396576 390.187164,495.652222 389.860687,494.601318 
z"/>
<path fill="#12A5FA" opacity="1.000000" stroke="none" 
	d="
M390.858307,497.501648 
	C391.036163,497.116760 391.275116,497.092590 391.873901,497.052368 
	C393.292725,497.376465 394.453644,497.515045 395.338562,498.823120 
	C395.604706,499.573669 395.590546,500.021118 395.252930,500.735901 
	C392.841309,502.972351 396.247986,503.741272 395.994598,505.626984 
	C392.279846,504.549438 392.214294,500.817902 390.858307,497.501648 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M357.761414,485.000977 
	C360.802277,488.349823 363.764923,491.359344 366.871704,494.668182 
	C363.373138,499.987305 360.838715,494.310120 357.380066,493.999390 
	C355.536224,493.703278 354.116791,494.058105 352.375458,494.411865 
	C350.382935,494.408142 349.690186,492.681122 347.952332,492.110046 
	C347.048370,491.728943 346.461761,491.435669 345.586639,490.974182 
	C342.537476,488.568176 341.653381,484.660492 338.041534,482.723755 
	C337.616974,482.343231 337.456390,482.179718 337.076416,481.750671 
	C331.565582,474.766571 324.614990,469.763550 318.392975,464.037201 
	C313.641113,459.663849 309.345337,454.711273 303.639984,450.867706 
	C298.561279,444.417267 291.015198,441.194031 285.944611,434.753174 
	C283.658813,432.577484 281.693726,430.548309 279.276764,428.540283 
	C278.276581,427.617584 277.616760,426.798920 276.636475,425.868164 
	C276.323242,425.311981 275.987457,425.213318 275.839203,425.021820 
	C275.434479,424.499237 275.328613,425.583405 275.670410,425.011017 
	C275.671234,425.009552 275.816040,425.057373 276.278931,425.408875 
	C277.222931,426.651855 278.126923,427.521362 279.214355,428.640350 
	C281.778015,430.210785 282.880585,432.801056 285.271698,434.579529 
	C290.537598,440.765076 295.621765,446.664673 300.598846,453.098083 
	C305.547272,459.248138 310.250641,465.154327 315.177551,471.303711 
	C315.490601,471.750519 315.607971,471.931763 315.885193,472.386780 
	C316.142456,472.842957 316.239929,473.025452 316.472107,473.481384 
	C316.861511,474.290253 317.107300,474.830444 317.634094,475.546387 
	C318.345703,476.370300 318.873840,476.964844 319.577850,477.814392 
	C320.352600,478.921112 320.932343,479.789001 321.922180,480.752594 
	C322.317474,481.143433 322.475677,481.304016 322.865601,481.719238 
	C323.850861,482.911560 324.558746,483.868958 324.351074,485.514618 
	C322.237305,487.907776 320.023895,486.631348 317.517029,486.197083 
	C316.935120,486.004272 316.710602,485.908813 316.184021,485.613098 
	C314.192902,483.501465 314.297546,480.556885 311.873230,478.704224 
	C304.968414,476.993713 301.742798,470.994537 296.466248,467.163391 
	C295.916168,466.982239 295.698029,466.899506 295.169617,466.649628 
	C294.094086,465.919159 293.465607,465.214905 292.630493,464.224182 
	C291.752899,459.321442 287.942383,456.448029 285.930115,452.181580 
	C279.722565,444.384613 273.373077,437.172028 265.993164,430.468964 
	C265.341370,429.776398 264.909180,429.323975 264.205688,428.723938 
	C263.854645,428.380615 263.728058,428.232605 263.461823,427.833679 
	C263.180298,427.238922 263.046814,426.891876 262.813477,426.295959 
	C262.615173,425.894958 262.527771,425.738647 262.283173,425.361084 
	C262.006348,425.000458 261.886780,424.861053 261.372620,424.321198 
	C260.712036,423.655304 260.448303,423.387573 259.984344,422.924164 
	C259.520477,422.475006 259.257660,422.220795 258.786438,421.800537 
	C258.297394,421.424164 258.012360,421.219421 257.507172,420.875061 
	C257.155365,420.622833 257.020782,420.514282 256.715729,420.212097 
	C256.355621,419.737091 256.172241,419.451599 255.850494,418.957855 
	C255.599960,418.624176 255.495590,418.493805 255.225922,418.174683 
	C254.833038,417.736969 254.603302,417.489960 254.185638,417.064850 
	C253.875992,416.761993 253.752243,416.639130 253.441986,416.328369 
	C253.127945,416.014313 253.000412,415.888153 252.464081,415.390015 
	C251.905807,414.898956 251.756332,414.779877 251.107880,414.326752 
	C250.429138,413.880646 250.249359,413.768585 249.797852,413.474457 
	C232.005188,392.880981 213.464661,373.427429 194.320160,354.541748 
	C192.666748,352.910706 191.133240,351.140961 188.844208,349.694763 
	C184.519791,343.950958 178.588135,341.401001 172.072998,339.114716 
	C171.539993,338.853302 171.335709,338.730743 170.870148,338.364197 
	C169.308044,334.876587 167.502502,331.922180 165.569489,329.020569 
	C164.193604,326.955322 162.797821,324.761597 163.727188,322.093109 
	C164.369888,320.247711 163.071411,319.324188 162.148880,318.226379 
	C156.183655,311.127655 149.853409,304.344086 143.949310,297.192505 
	C137.827499,289.777252 132.173203,282.018494 127.049904,273.880676 
	C126.096176,272.365753 124.901985,270.869232 125.455559,268.532288 
	C128.071579,266.856445 129.524200,268.762543 131.111099,270.021606 
	C132.518784,271.138458 133.683746,272.547913 135.447906,273.776123 
	C136.076920,274.230316 136.419113,274.506134 136.989471,275.008270 
	C137.533325,275.508484 137.831924,275.802338 138.347061,276.312317 
	C139.013916,276.933716 139.460083,277.342804 140.220367,277.850159 
	C140.653580,278.126129 140.827042,278.238983 141.253998,278.535767 
	C141.835175,278.988525 142.147903,279.273712 142.673126,279.804718 
	C143.916107,281.191071 145.147308,282.110229 146.554108,283.342468 
	C162.056641,296.836700 177.459579,309.928070 192.697144,323.736389 
	C193.156464,324.093262 193.335297,324.242126 194.013733,324.876892 
	C194.668869,325.535217 194.824356,325.707642 195.202271,326.148254 
	C195.565613,326.601257 195.706543,326.786072 196.046234,327.256775 
	C213.599915,346.668304 230.103592,366.715729 253.124634,379.673889 
	C255.269180,380.881012 257.427887,382.192993 259.224121,384.449768 
	C262.810669,389.532410 268.023193,391.964233 273.076721,395.176086 
	C275.604034,397.102417 278.034668,398.637695 279.508270,401.583099 
	C279.532806,402.173920 279.493286,402.410370 279.254120,402.945618 
	C274.616882,403.767639 272.005890,399.941223 268.023804,398.516296 
	C267.407166,398.007538 267.064667,397.709686 266.452789,397.213074 
	C265.999786,396.887451 265.816315,396.760376 265.355133,396.445984 
	C261.122131,393.682068 256.904388,391.626587 252.195984,389.795013 
	C249.634689,388.216034 247.392822,386.755280 244.679352,385.545593 
	C244.047806,385.635651 243.920914,384.641052 243.585403,385.228699 
	C243.262466,385.794281 243.446442,384.944489 244.226654,385.478210 
	C246.545929,386.364716 248.375000,387.524902 250.371429,389.060181 
	C254.515457,392.006622 258.481049,394.630371 262.338562,397.975098 
	C269.714752,403.802002 276.198212,410.135162 283.368530,416.189148 
	C283.768555,416.578033 283.924530,416.734894 284.307251,417.127197 
	C284.683472,417.517090 284.832947,417.671509 285.438538,418.268250 
	C286.054108,418.848572 286.213593,418.986572 286.621826,419.320312 
	C288.229340,420.561981 289.725616,421.411285 291.328247,422.688293 
	C294.931030,426.999512 299.420105,429.861694 303.386810,433.784973 
	C309.319733,439.255890 315.328552,444.141510 321.039093,449.847717 
	C322.174896,451.022949 323.032074,452.003784 324.209076,453.121338 
	C325.040894,453.940155 325.604004,454.574890 326.478943,455.347900 
	C327.831024,456.587128 329.124847,457.374359 330.596008,458.486877 
	C337.516205,465.068268 344.368927,471.220917 351.286407,477.307159 
	C353.721283,479.449432 356.523743,481.369080 357.761414,485.000977 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M365.981873,512.638000 
	C365.495514,512.769592 365.061157,512.471680 364.373352,512.065674 
	C361.579926,511.009705 360.458740,508.535492 358.359131,506.583099 
	C357.147980,505.158508 356.140411,504.008514 356.938782,502.015198 
	C357.885925,501.294403 358.621216,501.236542 359.701813,501.749329 
	C365.451874,503.368652 366.123596,507.564789 365.981873,512.638000 
z"/>
<path fill="#071A2D" opacity="1.000000" stroke="none" 
	d="
M351.770203,494.288086 
	C353.572113,493.358124 354.898407,490.951813 356.963501,493.668182 
	C355.928314,495.419281 356.351257,496.869781 356.731873,498.853516 
	C354.606812,499.820648 354.153351,497.857178 352.644104,497.009460 
	C352.217041,496.675629 352.055603,496.528412 351.720215,496.101501 
	C351.426941,495.390076 351.430939,494.957855 351.770203,494.288086 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M370.711426,515.150024 
	C370.868927,516.022095 370.631775,516.868164 370.115479,517.906250 
	C368.999695,517.199463 368.163025,516.300781 367.251099,515.094727 
	C368.222809,514.899536 369.269775,515.011841 370.711426,515.150024 
z"/>
<path fill="#071A2D" opacity="1.000000" stroke="none" 
	d="
M359.978119,501.636414 
	C359.264465,501.965210 358.512451,501.957397 357.147217,501.737640 
	C356.239380,500.876190 356.229309,500.225708 356.738159,499.311218 
	C356.948792,499.048187 356.982117,499.016663 356.998962,499.000671 
	C358.531464,499.073090 359.591705,499.736664 359.978119,501.636414 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M371.968018,514.794983 
	C371.947174,515.051147 371.549316,515.075623 371.351410,515.087524 
	C371.280365,514.803833 371.407227,514.508240 371.767090,514.118774 
	C371.996338,514.196228 371.992584,514.367493 371.968018,514.794983 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M366.878052,514.019531 
	C366.603546,514.089294 366.292664,513.864319 365.952271,513.343628 
	C366.229095,513.273560 366.535370,513.499146 366.878052,514.019531 
z"/>
<path fill="#0FCFFB" opacity="1.000000" stroke="none" 
	d="
M357.962433,485.037598 
	C348.616669,476.861725 339.393738,468.383179 330.029480,459.611145 
	C329.563141,456.861938 329.859772,455.357941 333.029388,456.455353 
	C338.108734,458.213928 339.630157,456.852753 338.509430,451.429596 
	C337.909973,448.528870 338.866730,446.628540 341.394470,444.895050 
	C344.907928,444.963989 345.369049,448.059937 347.276489,450.130615 
	C348.083527,451.388245 348.626373,452.400726 349.508240,453.608093 
	C350.253143,454.931885 350.729706,455.987610 350.472656,457.529175 
	C349.089325,458.531097 348.635468,459.674194 349.518219,460.712494 
	C352.442108,464.151611 353.307343,468.695831 355.967438,472.629883 
	C354.782135,475.608612 354.086761,478.032257 357.669067,479.514374 
	C358.763580,479.967194 359.271790,481.140808 359.155945,482.699341 
	C358.696686,483.581085 358.390961,484.157990 357.962433,485.037598 
z"/>
<path fill="#13C2F7" opacity="1.000000" stroke="none" 
	d="
M359.370789,483.000977 
	C358.276215,481.503998 357.584412,480.195038 355.567810,479.846893 
	C353.484314,479.487213 353.198517,477.089447 352.730133,475.585968 
	C352.249512,474.043213 354.639618,474.284698 355.805725,473.244751 
	C357.972046,475.555786 360.738953,477.638611 361.034363,481.596405 
	C361.195709,482.103088 361.361359,482.240967 361.369354,482.661102 
	C360.720825,482.961487 360.230011,482.979645 359.370789,483.000977 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M361.469025,483.099548 
	C361.211670,482.943359 361.123840,482.454224 361.076935,482.209717 
	C362.801239,481.819946 363.666565,482.954498 364.202576,484.661438 
	C362.824493,485.007690 362.502075,483.830536 361.469025,483.099548 
z"/>
<path fill="#12628E" opacity="1.000000" stroke="none" 
	d="
M367.924652,489.275360 
	C368.393738,489.434845 368.789978,489.910889 369.106873,490.710083 
	C368.635620,490.552795 368.243713,490.072357 367.924652,489.275360 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M364.002625,485.267792 
	C364.387604,485.072510 364.771393,485.185364 365.099274,485.651672 
	C364.696075,485.862091 364.348724,485.719025 364.002625,485.267792 
z"/>
<path fill="#12628E" opacity="1.000000" stroke="none" 
	d="
M369.088806,491.250122 
	C369.333466,491.127930 369.696625,491.288177 370.183319,491.752075 
	C369.940338,491.881317 369.573822,491.706970 369.088806,491.250122 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M365.029327,486.302673 
	C365.368103,486.103912 365.746826,486.250641 366.232391,486.721497 
	C365.915924,486.913086 365.492615,486.780609 365.029327,486.302673 
z"/>
<path fill="#12628E" opacity="1.000000" stroke="none" 
	d="
M367.698822,488.071533 
	C368.009949,488.179108 368.040588,488.343475 368.054932,488.757996 
	C367.292542,489.095123 366.979034,488.877075 367.698822,488.071533 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M394.621643,533.190430 
	C394.581573,534.074890 396.470062,535.445557 394.466705,535.804871 
	C393.240356,536.024902 393.092010,534.856201 393.069824,533.568970 
	C393.496124,533.218811 393.905609,533.183411 394.621643,533.190430 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M392.264465,529.914185 
	C391.954773,529.235168 391.949310,528.542542 391.924561,527.506226 
	C392.926544,527.881348 395.086731,528.324219 392.264465,529.914185 
z"/>
<path fill="#0E6CB9" opacity="1.000000" stroke="none" 
	d="
M358.735657,525.811523 
	C359.264313,526.199707 359.540344,526.375854 359.873260,526.800232 
	C360.100098,527.529419 360.028961,527.961365 359.365417,528.517944 
	C355.619568,528.519653 353.045898,530.411377 350.164795,532.486938 
	C348.253052,533.338989 346.595581,533.737854 344.484955,533.543701 
	C343.210999,532.868591 342.810516,531.973938 342.524597,530.623230 
	C344.462433,524.485840 344.472961,524.462219 338.624695,521.857605 
	C336.024597,520.699646 334.600647,519.397522 337.941162,516.962036 
	C340.524109,517.167664 342.731567,517.810791 345.315399,518.181641 
	C346.333710,518.629822 347.114746,519.686157 347.873596,517.872437 
	C348.769073,517.384460 349.406525,517.458313 350.265839,518.049744 
	C350.904755,518.850281 351.183868,519.471436 351.635681,520.373901 
	C352.403839,521.867188 353.393799,522.637634 354.909302,523.293091 
	C356.229523,524.262573 357.213196,525.149414 358.735657,525.811523 
z"/>
<path fill="#A0F5FC" opacity="1.000000" stroke="none" 
	d="
M358.982941,505.770752 
	C360.875305,507.721588 362.398895,509.524872 364.021179,511.642822 
	C359.386658,511.041992 354.648987,510.092682 350.173035,513.891113 
	C347.079590,514.148193 345.933350,512.115601 344.673096,509.796265 
	C344.742981,509.170502 344.851013,508.932159 345.270020,508.450043 
	C349.878296,507.107666 353.922424,504.731628 358.982941,505.770752 
z"/>
<path fill="#0C1929" opacity="1.000000" stroke="none" 
	d="
M344.843628,509.745361 
	C346.544586,511.183868 347.905487,512.477844 349.550598,513.909302 
	C349.834808,514.046753 349.875183,514.529724 349.822327,514.766235 
	C349.723694,515.194153 349.677917,515.385681 349.859375,515.765747 
	C350.086639,515.954407 350.018341,515.988586 350.027100,515.951416 
	C350.199463,516.204895 350.409821,516.456421 350.880859,516.792236 
	C351.094727,516.915771 351.048248,517.007446 351.058044,516.957275 
	C351.304871,517.266724 351.455750,517.659546 351.460083,518.399231 
	C351.246704,518.860962 351.093567,519.008911 350.650452,519.023010 
	C349.719116,518.558777 349.077759,518.228394 348.067627,517.896240 
	C347.404816,518.284729 347.019043,518.495422 346.195312,518.386475 
	C344.610107,515.798340 340.807587,514.902588 341.666443,510.921204 
	C342.606110,509.935913 343.471558,509.551483 344.843628,509.745361 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M350.772614,519.299072 
	C351.007782,518.505066 351.019470,518.048279 351.049500,517.249268 
	C353.532196,517.999207 354.739716,520.304749 356.406555,522.623657 
	C356.324615,523.341248 356.024658,523.654907 355.328918,523.967651 
	C353.152283,524.294006 351.544403,524.091797 350.947144,521.543945 
	C350.624268,520.704590 350.504913,520.189392 350.772614,519.299072 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M355.155457,524.340637 
	C355.302032,523.722778 355.599121,523.411743 356.218872,523.025391 
	C357.298706,523.790161 358.055817,524.630310 358.900604,525.746948 
	C357.579498,526.050171 356.200592,525.996765 355.155457,524.340637 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M358.698578,528.324707 
	C359.163300,527.796143 359.445374,527.653870 359.817444,527.257568 
	C360.618164,527.781555 361.306183,528.514709 362.090271,529.536377 
	C362.186340,529.824951 362.074524,529.929626 362.018616,529.981934 
	C360.321533,530.947144 359.037079,530.904297 358.698578,528.324707 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M350.039734,515.705688 
	C349.887909,515.722595 349.689209,515.490723 349.629974,515.130798 
	C349.843933,515.154114 349.918396,515.305481 350.039734,515.705688 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M351.016266,516.660278 
	C350.807404,516.741333 350.520081,516.566833 350.134338,516.153320 
	C350.336517,516.077820 350.637146,516.241333 351.016266,516.660278 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M378.993835,524.827637 
	C378.954681,525.881287 378.881378,526.806946 377.440918,526.795044 
	C377.186859,525.608154 376.438568,523.883179 378.993835,524.827637 
z"/>
<path fill="#0D89D9" opacity="1.000000" stroke="none" 
	d="
M338.273804,516.482117 
	C336.504211,519.198303 336.675690,520.398193 340.292389,521.125671 
	C345.858368,522.245300 346.675201,524.899292 343.262024,529.829224 
	C341.269226,531.490662 339.775452,533.219116 337.514221,534.521729 
	C336.951294,534.582275 336.723083,534.564575 336.183044,534.407104 
	C335.723389,534.096313 335.575623,533.925171 335.289001,533.447632 
	C335.001343,532.273010 334.890564,531.397522 334.798645,530.256287 
	C335.505615,527.538208 334.105316,525.708557 332.992615,523.412292 
	C332.402802,521.915283 332.150208,520.534180 330.245026,520.206787 
	C329.525238,520.034729 329.093597,520.027344 328.338318,520.012024 
	C327.108582,519.287109 326.953979,518.271912 326.938843,516.831665 
	C327.037750,516.206238 327.105804,515.962830 327.357971,515.391602 
	C327.901917,514.723206 328.315735,514.478271 329.148560,514.328796 
	C330.397369,514.368530 331.255707,514.662354 332.465393,514.805664 
	C333.201050,514.894531 333.615173,514.965759 334.324341,515.128357 
	C335.385284,515.441406 336.129272,515.741028 337.199371,515.994995 
	C337.671478,516.145752 337.855316,516.221802 338.273804,516.482117 
z"/>
<path fill="#14A4F1" opacity="1.000000" stroke="none" 
	d="
M303.220703,524.751587 
	C302.577637,525.012939 302.175934,525.033691 301.473145,525.072876 
	C299.013794,523.907959 297.933746,522.045959 297.872192,519.288391 
	C299.157715,517.622070 301.201294,517.941956 302.588684,516.330688 
	C304.994354,513.435303 306.436676,509.697937 311.378113,510.891541 
	C311.985504,511.049957 312.219940,511.138153 312.762329,511.436523 
	C313.506317,514.256775 316.293762,516.740601 313.259430,519.793945 
	C313.031830,520.230652 313.038025,520.397766 313.038879,520.815674 
	C310.015564,522.693909 305.572021,520.360046 303.220703,524.751587 
z"/>
<path fill="#1391DB" opacity="1.000000" stroke="none" 
	d="
M343.130432,537.622681 
	C340.757599,539.021423 341.829132,543.909302 337.261841,543.029419 
	C335.819092,542.224365 334.576904,541.839539 333.167358,541.090454 
	C332.337616,538.361694 332.992371,535.995422 333.863403,533.307739 
	C334.149170,532.845886 334.286133,532.712708 334.707825,532.615479 
	C335.280365,532.908936 335.502869,533.213989 335.834747,533.792969 
	C336.010010,534.018921 336.000824,533.998047 335.989868,533.994995 
	C338.236084,535.414734 340.118958,532.624084 342.662720,533.586060 
	C343.125061,533.963501 343.245911,534.183350 343.168640,534.723267 
	C342.999207,535.781860 343.027954,536.520386 343.130432,537.622681 
z"/>
<path fill="#0D89D9" opacity="1.000000" stroke="none" 
	d="
M313.374329,520.067749 
	C314.657928,517.582092 312.481354,515.148621 312.955414,512.368469 
	C312.860321,511.840759 312.742706,511.626648 312.799744,511.091125 
	C313.401459,510.537048 313.855927,510.407043 314.686340,510.470764 
	C319.482208,509.995239 322.940308,511.946075 326.141907,515.235229 
	C326.271088,516.659546 325.568390,517.282898 324.350281,517.877563 
	C322.606049,517.953369 321.220428,517.947083 319.419464,517.924316 
	C318.406586,517.976685 317.859711,518.172729 317.156372,518.738037 
	C315.942596,519.540222 314.985107,520.230957 313.374329,520.067749 
z"/>
<path fill="#18C2FC" opacity="1.000000" stroke="none" 
	d="
M303.370178,525.002808 
	C304.549042,519.697266 305.389252,519.334839 312.628632,521.035645 
	C313.288788,521.535767 313.543976,522.004944 313.905334,522.721191 
	C312.992737,524.068787 311.730774,524.874512 310.277985,525.934265 
	C309.983948,526.063110 309.547729,526.058838 309.330383,526.058044 
	C307.329041,525.709290 305.545044,525.361328 303.370178,525.002808 
z"/>
<path fill="#14A4F1" opacity="1.000000" stroke="none" 
	d="
M310.011414,526.382080 
	C310.087280,523.974670 311.221558,522.992615 313.643127,522.982422 
	C314.008759,524.364380 314.005951,525.760437 314.008301,527.574097 
	C313.486664,528.880432 312.613617,528.994934 311.367950,529.044312 
	C310.701691,528.276184 310.370270,527.488647 310.011414,526.382080 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M332.714966,541.086426 
	C334.512115,540.707092 336.200958,540.267090 336.880920,542.701782 
	C336.578949,543.068848 336.334259,543.209412 336.008423,543.600342 
	C335.317078,543.969543 334.751465,544.165955 333.977295,544.577393 
	C332.797638,544.613220 331.410553,545.393311 330.986206,543.951660 
	C330.633423,542.752991 331.617188,541.983398 332.714966,541.086426 
z"/>
<path fill="#14A4F1" opacity="1.000000" stroke="none" 
	d="
M324.124115,518.270081 
	C324.494934,517.372009 324.998230,516.784363 325.768799,516.069824 
	C326.441162,515.583679 326.907166,515.466248 327.713745,515.846802 
	C328.000641,517.143188 328.007843,518.183472 328.014862,519.613953 
	C325.742828,522.219910 325.159149,519.979431 324.124115,518.270081 
z"/>
<path fill="#14A4F1" opacity="1.000000" stroke="none" 
	d="
M330.003052,520.374878 
	C331.125702,519.626038 332.292236,518.345276 333.526367,519.683105 
	C334.318665,520.542053 333.705536,521.536621 333.083923,522.734131 
	C331.452576,522.904175 330.397125,522.240051 330.003052,520.374878 
z"/>
<path fill="#0E6CB9" opacity="1.000000" stroke="none" 
	d="
M335.267792,533.210449 
	C335.006287,533.034180 334.508972,533.010315 334.260559,532.994751 
	C334.138275,532.103638 334.264404,531.228088 334.668945,530.159058 
	C335.288269,530.752319 335.629211,531.539124 335.986755,532.648315 
	C335.845337,533.109375 335.687317,533.248047 335.267792,533.210449 
z"/>
<path fill="#14A4F1" opacity="1.000000" stroke="none" 
	d="
M317.240784,518.926453 
	C317.146820,518.023438 317.211151,516.937561 318.824005,517.695435 
	C318.521027,518.248352 318.037994,518.588806 317.240784,518.926453 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M358.506622,527.899780 
	C358.995941,529.336487 359.800812,530.040833 361.600830,530.039307 
	C362.154907,531.526794 360.496765,531.983582 360.178955,533.502869 
	C357.706268,534.204712 355.246490,534.601501 352.373932,534.982300 
	C351.242615,534.231445 349.550201,534.637390 349.799133,532.680176 
	C351.747650,529.155640 353.946686,526.697083 358.506622,527.899780 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M349.598938,532.295532 
	C349.964813,533.538574 350.954468,533.891052 351.804260,534.723633 
	C351.546234,535.013550 351.131317,535.060913 350.408875,535.168213 
	C348.021027,535.156128 345.940674,535.084106 343.415405,535.027710 
	C342.970490,535.043274 342.893524,534.558899 342.884796,534.313843 
	C342.741028,533.570496 342.895813,533.174988 343.652008,532.926270 
	C345.743103,532.723511 347.484253,532.463318 349.598938,532.295532 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M160.346542,431.307495 
	C159.897858,431.603577 159.750793,431.747864 159.349991,432.068604 
	C156.469254,432.753326 153.806931,432.273682 151.177841,432.505707 
	C146.110077,432.953003 142.474045,431.115295 140.448242,425.839294 
	C139.928513,424.387512 139.853790,423.304596 140.206894,421.834595 
	C141.227219,420.273163 142.559891,418.385468 143.730682,419.204468 
	C146.124008,420.878632 144.710190,423.744171 144.804504,425.901093 
	C145.611282,423.581268 144.065430,420.591858 146.393585,418.008331 
	C149.837631,416.855682 152.843079,417.894714 156.217224,418.596893 
	C156.767883,418.760559 156.983643,418.833374 157.509735,419.037292 
	C158.217438,419.359497 158.610336,419.559326 159.289017,419.909790 
	C159.769012,420.152679 159.959229,420.252838 160.429626,420.514038 
	C160.892136,420.791840 161.074417,420.908630 161.517303,421.223083 
	C161.932480,421.576782 162.087051,421.732819 162.422455,422.166260 
	C162.779205,422.852661 162.907578,423.276093 163.025635,424.046082 
	C163.108688,425.973999 162.582642,427.449951 161.992264,429.252808 
	C161.593506,430.196320 161.198105,430.735748 160.346542,431.307495 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M152.102722,441.961487 
	C150.493759,439.980103 149.131973,438.236938 148.987915,435.532288 
	C154.119095,434.733978 159.209854,435.045502 164.601791,436.101990 
	C166.675858,438.185699 165.173767,439.752686 164.048065,441.330688 
	C162.802200,443.077240 160.987167,444.300354 159.338242,446.217957 
	C157.817154,447.180054 156.516830,447.265045 154.794342,446.813782 
	C153.616882,446.217621 153.521942,445.429474 153.211960,444.315369 
	C152.972946,444.000824 153.002502,443.996185 152.997803,444.010315 
	C152.533707,443.518188 152.527618,442.828186 152.102722,441.961487 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M162.259369,424.401978 
	C162.019775,423.698364 161.981812,423.251923 162.098389,422.214203 
	C162.625168,421.424530 163.018433,421.293793 163.729675,421.274323 
	C166.109772,421.859497 164.617279,419.729614 165.681412,419.107666 
	C168.479568,418.416138 169.473145,420.576935 171.163574,422.237305 
	C171.784470,423.107697 172.123703,423.735931 172.672699,424.661224 
	C173.448059,426.057526 174.170593,427.072113 174.672592,428.624390 
	C173.744415,433.724731 169.926453,430.505768 167.234131,431.654175 
	C166.500488,431.780273 166.145782,431.785370 165.525299,431.778259 
	C164.554749,431.624756 164.375839,431.097168 164.385468,430.208130 
	C164.140182,429.527283 165.362457,429.645264 164.626129,429.386322 
	C164.276413,429.955902 163.955643,430.158600 163.271576,430.240631 
	C162.811462,430.051666 162.660370,429.903229 162.369537,429.464935 
	C161.843933,427.646057 162.823166,426.186951 162.259369,424.401978 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M169.791626,436.190247 
	C171.306686,435.935944 172.608200,435.878998 174.300644,435.813477 
	C176.507385,435.069305 178.308899,435.635986 180.489929,435.975037 
	C184.048080,437.917023 181.858231,440.014740 180.974243,442.352844 
	C178.631424,444.662140 175.643448,445.710144 173.968140,448.761353 
	C173.472015,449.398804 173.140152,449.718140 172.466339,450.163452 
	C171.930740,450.352875 171.701431,450.379364 171.145462,450.292236 
	C170.488953,449.861633 170.200989,449.510834 169.802856,448.826416 
	C167.602570,446.229675 170.707352,444.055603 169.732788,441.469513 
	C169.506088,440.306213 169.785263,439.499542 169.901077,438.384277 
	C169.824539,437.905212 169.765717,437.719147 169.631104,437.250854 
	C169.562927,436.775024 169.570526,436.581329 169.791626,436.190247 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M170.002472,436.752350 
	C173.730881,437.898773 170.607056,439.267365 170.100983,440.724792 
	C168.604263,443.666992 165.574371,444.977661 164.213684,448.070923 
	C162.167175,448.620941 160.551834,448.331390 159.132416,446.708984 
	C158.191345,443.622894 161.120804,443.380280 161.981705,441.820007 
	C162.922684,440.114655 165.128510,439.164795 164.961731,436.458496 
	C166.354370,436.020691 167.760513,435.946716 169.585907,435.932800 
	C170.005157,435.992859 169.992813,436.492401 170.002472,436.752350 
z"/>
<path fill="#1174A3" opacity="1.000000" stroke="none" 
	d="
M140.789841,424.721985 
	C144.229218,433.345428 151.544098,431.935059 158.629639,432.214996 
	C152.438690,434.124817 145.630539,432.163818 138.466034,433.081848 
	C137.998596,433.128174 137.958511,432.741211 137.976776,432.547546 
	C139.729431,428.964966 139.729431,428.964966 137.518997,424.649811 
	C137.500259,423.836121 137.672806,423.416656 138.273087,422.885681 
	C139.716293,422.762756 140.120041,423.635132 140.789841,424.721985 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M167.298492,431.869934 
	C168.697159,429.648315 172.859222,433.315552 174.010864,428.358185 
	C174.893478,427.658691 175.481964,427.914612 176.273941,428.518768 
	C176.971863,429.200714 177.410767,429.681580 178.209015,430.262268 
	C179.083420,430.807648 179.662140,431.192688 180.465454,431.893188 
	C181.176041,432.825439 181.413956,433.516296 180.635254,434.511902 
	C178.942642,435.252960 177.622711,435.206146 176.101974,434.119537 
	C176.513977,432.728851 176.516647,432.012878 174.976013,432.012665 
	C172.564606,432.012299 170.153183,431.982178 167.298492,431.869934 
z"/>
<path fill="#0A4271" opacity="1.000000" stroke="none" 
	d="
M175.606186,433.841583 
	C177.288834,433.813446 178.728714,433.836365 180.590271,433.766693 
	C181.466721,433.438843 181.947983,433.371124 182.784271,433.619446 
	C183.880463,435.230133 183.420639,436.162170 181.569397,436.771729 
	C179.249741,436.995087 177.266434,437.298340 175.074280,435.989868 
	C174.517365,435.027588 174.083817,434.159149 175.606186,433.841583 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M160.145172,431.706177 
	C160.186935,431.059235 160.328934,430.659180 160.660477,430.142456 
	C161.185532,429.668396 161.601837,429.489349 162.413025,429.605621 
	C162.737900,429.746521 163.005432,429.990112 163.140732,430.110168 
	C163.473907,430.639191 163.508057,431.061340 163.101257,431.675659 
	C161.966278,431.931000 161.130081,432.577179 160.145172,431.706177 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M163.230988,431.871704 
	C162.919327,431.491760 163.014435,431.128937 163.192795,430.498169 
	C163.663895,429.861633 164.051758,429.492981 164.783386,429.123016 
	C165.149017,429.783722 165.170898,430.445770 165.226166,431.436920 
	C164.718964,431.806946 164.178360,431.847870 163.230988,431.871704 
z"/>
<path fill="#0B5794" opacity="1.000000" stroke="none" 
	d="
M153.341156,449.315979 
	C152.437195,449.437042 151.830734,449.522888 151.031265,449.864868 
	C150.182526,449.043640 149.526825,447.966248 148.781342,446.587219 
	C148.691544,446.285614 148.920456,446.061096 149.027771,445.941986 
	C149.265976,445.688843 149.396866,445.554810 149.648895,445.167206 
	C150.097931,445.018829 150.425827,445.124023 150.888672,445.455383 
	C151.129318,445.840851 151.235031,446.000153 151.578827,446.322693 
	C151.997238,446.558624 152.177567,446.631317 152.626984,446.823822 
	C153.658173,447.559204 154.655640,448.099945 153.341156,449.315979 
z"/>
<path fill="#0B5794" opacity="1.000000" stroke="none" 
	d="
M152.913971,444.299438 
	C153.334900,444.344635 153.696854,444.688446 154.061615,445.307556 
	C154.597977,446.837524 153.906845,447.262726 152.403442,447.205627 
	C151.986755,446.991241 151.999954,447.000000 152.004669,447.006348 
	C151.898285,446.859741 151.787170,446.706726 151.816986,446.307617 
	C152.256943,445.573669 152.555969,445.085846 152.913971,444.299438 
z"/>
<path fill="#0B5794" opacity="1.000000" stroke="none" 
	d="
M151.951874,442.031433 
	C152.293274,442.236755 152.651215,442.790619 153.001129,443.684479 
	C152.651566,443.476318 152.309998,442.928162 151.951874,442.031433 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M151.728119,445.957214 
	C151.957916,446.061462 151.971970,446.537567 151.990677,446.775146 
	C151.737473,446.755402 151.465546,446.498108 151.108612,445.961182 
	C151.181854,445.738708 151.340088,445.795837 151.728119,445.957214 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M149.650330,444.921814 
	C149.805252,445.206665 149.711365,445.449524 149.311722,445.732544 
	C149.135101,445.822876 149.150177,445.362793 149.220490,445.142212 
	C149.290787,444.921631 149.530609,444.929993 149.650330,444.921814 
z"/>
<path fill="#011B36" opacity="1.000000" stroke="none" 
	d="
M137.796631,423.731262 
	C139.579514,426.429626 141.235565,428.799042 142.836075,431.088989 
	C141.349442,433.079895 139.632996,430.546509 138.123627,432.033295 
	C136.577362,432.210541 135.159683,432.067200 133.455688,431.709656 
	C132.933762,431.063751 132.680283,430.642883 132.327179,429.876892 
	C132.231812,428.784271 132.451691,428.119385 133.083328,427.262207 
	C133.487610,426.894135 133.668762,426.776031 134.121567,426.592285 
	C134.746704,426.529938 135.003876,426.683044 135.183350,426.794495 
	C134.979202,426.417603 134.741501,426.253815 134.271942,425.980957 
	C133.926544,425.733063 133.798050,425.615936 133.493317,425.301453 
	C133.087418,424.832550 132.852798,424.565399 132.411682,424.119110 
	C132.072311,423.814606 131.933762,423.694183 131.584061,423.391479 
	C131.231400,423.083832 131.089890,422.958466 130.518616,422.441345 
	C129.941544,421.913605 129.794220,421.777618 129.203827,421.202911 
	C128.323593,420.270844 127.969498,419.726379 127.737320,418.762390 
	C128.046494,417.731354 128.616272,417.365448 129.664703,417.098816 
	C131.256363,416.996246 132.374451,417.412994 133.778656,418.110779 
	C135.847351,419.596863 137.205963,421.187012 137.796631,423.731262 
z"/>
<path fill="#040914" opacity="1.000000" stroke="none" 
	d="
M132.797119,428.727600 
	C133.036713,429.527130 133.061691,430.086884 133.128021,431.071045 
	C131.043076,431.716644 128.916779,431.937836 126.388550,432.154175 
	C124.411118,431.065277 123.794243,429.354462 123.018120,427.375153 
	C123.024445,425.550873 123.908897,424.989380 125.651962,424.978149 
	C127.498123,424.333160 128.461975,425.503784 129.900131,426.175964 
	C131.065964,426.962616 131.955307,427.578430 132.797119,428.727600 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M122.804489,427.064819 
	C125.086067,427.740601 125.237640,429.771851 125.953865,431.796906 
	C125.283989,433.152191 124.421951,432.761261 123.335335,432.273254 
	C122.930725,431.524750 122.757080,430.929047 122.326157,430.158295 
	C122.078293,429.241241 122.087708,428.499268 122.224884,427.406158 
	C122.352638,427.055023 122.654312,427.085602 122.804489,427.064819 
z"/>
<path fill="#18C2FC" opacity="1.000000" stroke="none" 
	d="
M233.404266,491.466492 
	C232.827164,489.081970 231.679977,488.911560 229.896103,489.511322 
	C227.235168,490.405914 224.511185,491.112885 221.438873,491.942902 
	C219.293137,493.530548 217.142624,493.529755 214.527374,493.463043 
	C209.335693,493.322449 204.599243,493.129242 199.411652,493.016235 
	C198.402664,493.047302 197.842209,493.086700 196.866943,493.214050 
	C196.452118,493.301971 196.087860,493.399231 196.087860,493.399231 
	C196.087860,493.399231 195.717621,493.327759 195.543777,493.252441 
	C194.114182,493.721649 192.814072,493.581848 191.036804,493.313721 
	C190.212189,493.143646 189.863739,493.087097 189.255035,492.975281 
	C187.521042,492.936279 185.998276,493.473511 184.317719,492.281982 
	C183.521698,490.939606 182.304626,491.140106 181.234772,490.454315 
	C181.609253,489.096100 182.689743,489.616913 183.945465,489.512482 
	C186.252396,489.209747 188.371628,490.223572 190.088104,488.448364 
	C190.306641,486.991913 190.615967,485.856445 190.967255,484.367432 
	C191.009247,484.013855 191.347473,483.678375 191.562866,483.780090 
	C197.715179,486.977509 198.131821,482.722961 198.864578,478.316345 
	C200.246017,477.446320 200.812012,478.303986 201.497559,479.352783 
	C201.662216,479.932037 201.614441,480.239868 201.621582,480.631897 
	C201.798264,480.736328 201.909607,480.288483 201.965027,480.045776 
	C202.087662,479.440887 202.196915,479.091156 202.483154,478.475403 
	C203.381424,477.238983 204.466171,476.994354 205.933563,476.778137 
	C207.480560,476.676788 208.674423,476.714844 210.220154,476.882874 
	C210.798965,477.012512 211.024124,477.084900 211.556519,477.325134 
	C212.697556,478.371155 213.644104,478.665527 214.922638,478.754395 
	C220.095627,479.113953 220.483109,480.059631 217.541504,485.107117 
	C216.899979,485.736481 215.987411,485.968933 216.072495,486.428772 
	C216.200348,487.119843 217.007919,486.627045 217.843842,486.670044 
	C221.576126,486.600281 223.239746,482.067688 227.422302,483.317749 
	C227.939499,483.597412 228.123672,483.745789 228.481262,484.199646 
	C229.087585,485.323151 228.594910,486.531830 229.730301,487.053314 
	C229.583023,486.288177 229.378555,485.519348 230.177765,484.589905 
	C232.582092,483.687469 234.534653,484.658386 236.936279,485.073029 
	C238.964722,486.149902 239.731873,487.559204 239.474182,489.861450 
	C237.844238,492.176636 235.931381,492.450165 233.404266,491.466492 
z"/>
<path fill="#0B5794" opacity="1.000000" stroke="none" 
	d="
M191.893936,483.561890 
	C191.778244,483.881805 191.383911,483.891052 191.196579,483.952454 
	C188.512009,485.003754 186.156708,482.227875 183.279633,483.803223 
	C181.253845,482.741516 181.284607,481.918213 183.629929,481.294373 
	C187.579697,481.709564 191.272736,480.165039 194.975342,481.264801 
	C194.512329,482.699951 192.371002,481.673981 191.893936,483.561890 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M183.506256,481.056519 
	C183.905823,482.048401 181.893616,482.024200 182.880295,483.631165 
	C180.345047,482.514801 176.206039,485.335388 174.883850,480.413422 
	C177.759308,479.616638 180.381485,480.721252 183.506256,481.056519 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M184.005371,492.330902 
	C185.512405,492.158600 187.006287,492.261261 188.747482,492.641968 
	C187.182098,493.966797 187.317596,496.277374 185.653503,497.623413 
	C185.245483,497.269562 185.134262,496.905426 184.963104,496.259979 
	C185.187195,495.267761 185.053101,494.649384 184.220428,493.916016 
	C183.962708,493.339722 183.977463,492.972778 184.005371,492.330902 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M189.720978,488.382477 
	C190.634201,488.589630 192.303101,489.112640 190.487137,489.816284 
	C189.085541,490.359344 187.313202,489.945526 185.300491,489.901733 
	C184.764023,489.733917 184.632767,489.621490 184.682297,489.323212 
	C186.390274,488.970795 187.917465,488.804199 189.720978,488.382477 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M184.529236,489.113831 
	C184.863098,489.137390 184.924255,489.490021 184.909775,489.668213 
	C183.856216,489.933746 182.817154,490.021118 181.393158,490.179932 
	C180.577072,490.097931 179.951157,490.072357 179.750977,489.767334 
	C179.126663,488.816254 180.314255,488.711700 180.596756,488.713989 
	C181.797211,488.723602 182.995972,488.945740 184.529236,489.113831 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M176.562103,488.794556 
	C176.305084,488.783386 176.249237,488.583588 176.193390,488.383820 
	C176.383362,488.457855 176.573334,488.531891 176.562103,488.794556 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M160.986389,465.535400 
	C160.859222,464.551605 160.953308,463.708649 161.089813,462.447266 
	C161.460205,461.686279 161.845779,461.434235 162.646347,461.253418 
	C164.642334,461.363159 166.000198,462.293060 167.796631,462.991699 
	C169.882553,463.935211 171.462357,463.145477 173.388062,462.440582 
	C173.938477,462.384399 174.161545,462.396118 174.699036,462.525482 
	C175.356110,462.931946 175.651413,463.262329 176.059692,463.925751 
	C176.603409,464.996063 177.181412,465.693146 177.179657,466.911011 
	C176.133850,468.099670 174.820572,468.448334 173.702087,469.630463 
	C173.283417,469.958588 173.102814,470.072052 172.613708,470.258240 
	C172.101456,470.285919 171.897720,470.240814 171.427673,470.044250 
	C171.006622,469.767548 170.851868,469.642334 170.486206,469.316345 
	C170.002533,468.858612 169.718887,468.614288 169.188339,468.251770 
	C168.793442,468.041504 168.633377,467.963501 168.233398,467.772156 
	C167.680679,467.505188 167.370407,467.346649 166.834595,467.068970 
	C166.456070,466.880249 166.306229,466.804565 165.930984,466.627014 
	C165.393341,466.408600 165.070541,466.351257 164.482788,466.370178 
	C163.883499,466.391815 163.541092,466.364227 162.950928,466.234009 
	C162.203293,465.997559 161.705475,465.836884 160.986389,465.535400 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M162.909393,466.436279 
	C163.268799,465.856323 163.836487,465.554474 164.698456,465.124329 
	C165.201859,465.244720 165.429703,465.474823 165.851898,465.854431 
	C166.027512,466.022522 165.986725,466.017273 165.978195,465.998566 
	C166.479813,466.542755 167.240372,466.505524 168.204010,466.892822 
	C168.534729,467.011383 168.491455,467.016235 168.481262,466.997009 
	C169.344818,467.255737 170.120010,467.671814 170.813232,468.759277 
	C171.024475,469.019897 170.984619,469.013702 170.983429,468.993591 
	C171.203247,469.219452 171.435486,469.454315 171.855133,469.852417 
	C172.031296,470.026733 171.991394,470.016968 171.982712,469.998352 
	C173.098846,471.575134 172.082840,472.315460 170.399414,472.978699 
	C169.613495,473.033203 169.217804,473.054108 168.525269,473.093170 
	C168.403946,469.477753 164.923386,468.765106 162.909393,466.436279 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M167.805542,473.277466 
	C167.783707,473.389557 167.488617,473.510620 167.090088,473.476868 
	C167.168549,473.310150 167.350433,473.298309 167.805542,473.277466 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M168.284180,463.765198 
	C166.640442,463.353271 165.282043,462.744141 163.631378,462.001404 
	C162.662537,461.608948 161.924820,461.512848 161.182556,460.760681 
	C158.787857,457.804810 156.515244,455.192108 154.097046,452.275482 
	C154.054626,451.524292 154.262848,451.132874 154.855316,450.607269 
	C155.977707,450.044434 156.859329,449.998779 158.073547,450.181946 
	C158.578949,450.348389 158.769943,450.439667 159.197479,450.734863 
	C159.957458,451.531494 160.298996,452.283417 161.247482,452.879700 
	C161.668625,453.139252 161.838913,453.242645 162.260666,453.513428 
	C162.673080,453.804443 162.834030,453.928131 163.447083,454.466309 
	C164.608215,455.627899 165.229614,456.437103 165.781982,457.650818 
	C166.194824,458.611328 166.357941,459.393372 167.448883,459.827423 
	C168.116425,460.101196 168.482346,460.303558 169.050064,460.787781 
	C169.509262,462.012390 169.150970,462.821014 168.284180,463.765198 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M155.234756,450.784485 
	C154.854797,451.305756 154.642426,451.545868 154.163513,451.854675 
	C153.195923,451.492859 153.017639,450.753693 153.036652,449.639954 
	C154.068726,448.185364 152.773804,447.974304 152.122452,447.216919 
	C152.603256,446.747650 153.219757,446.504059 153.950348,445.921692 
	C155.458481,445.762421 156.852524,445.941986 158.662231,446.233490 
	C160.522064,446.767548 161.966232,447.189667 163.743591,447.673950 
	C166.047714,446.081451 168.108093,447.126190 170.590149,447.633606 
	C171.202911,448.239624 171.372925,448.747070 171.478485,449.653687 
	C168.047882,452.465668 164.540710,449.793732 160.756226,450.307251 
	C158.736908,450.215179 157.007233,448.777069 155.234756,450.784485 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M161.069427,460.820770 
	C161.690033,460.705200 162.319595,460.992859 163.144135,461.574158 
	C162.847763,461.909546 162.356430,461.951294 161.498657,462.010986 
	C161.114288,461.760590 161.096344,461.492279 161.069427,460.820770 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M130.287598,426.928528 
	C128.556931,427.063690 127.641159,426.041565 126.302345,425.111450 
	C123.650513,421.084198 118.735718,420.312103 116.016006,416.455750 
	C116.114006,414.781738 116.984993,414.083984 118.540718,413.706848 
	C119.288475,413.946136 119.648575,414.227020 120.184525,414.818237 
	C122.252319,416.394623 124.604836,416.665039 126.723679,418.186005 
	C127.652283,419.322174 128.469315,420.075195 129.759277,420.798035 
	C130.037079,420.986694 129.998489,421.003845 130.001984,420.983032 
	C130.208374,421.217651 130.429428,421.456238 130.853241,421.837738 
	C131.037872,421.997467 130.994644,422.005524 130.998154,421.983795 
	C131.205841,422.215424 131.427094,422.452881 131.851562,422.831512 
	C132.037659,422.988647 131.995590,422.993591 132.010986,422.978882 
	C132.159943,423.133545 132.293518,423.302917 132.409241,423.796387 
	C132.000931,425.152527 131.341171,425.999390 130.287598,426.928528 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M109.995514,412.548645 
	C112.857735,410.988525 115.737381,409.501099 119.391266,411.168274 
	C119.837349,414.268677 116.847542,413.628143 114.997147,414.888702 
	C113.237671,415.094269 111.963821,414.573151 110.328293,414.163574 
	C110.022324,413.547394 110.030243,413.182922 109.995514,412.548645 
z"/>
<path fill="#0A5C8E" opacity="1.000000" stroke="none" 
	d="
M114.793442,414.354614 
	C116.380783,413.064392 118.357887,413.249451 119.611145,411.481384 
	C120.750443,411.023407 121.703629,411.017700 122.760094,411.949738 
	C122.785545,414.249481 121.371902,414.532104 119.437775,414.379761 
	C118.235451,414.743011 117.364510,415.278931 116.217361,415.970856 
	C115.941162,416.126862 115.479668,416.050323 115.248001,416.018066 
	C114.665260,415.608124 114.505974,415.166046 114.793442,414.354614 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M114.601501,414.053589 
	C115.013573,414.487457 115.007835,414.915527 115.009216,415.664673 
	C113.082939,416.039062 111.331268,415.496887 109.884689,414.145935 
	C111.404175,413.957123 112.793938,414.002441 114.601501,414.053589 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M170.133209,473.318787 
	C170.433273,471.990967 172.425262,472.363861 172.033264,470.324646 
	C173.349289,468.948334 173.563232,466.280548 176.543457,466.950500 
	C180.540741,465.322784 184.283279,464.119385 188.550415,463.530884 
	C189.083786,463.391205 189.293564,463.326202 189.821228,463.184937 
	C191.563416,462.811615 193.109955,462.936188 194.584518,461.715088 
	C195.234940,461.333435 195.634628,461.169342 196.364044,460.952393 
	C197.317551,460.708130 197.966095,460.594879 198.918579,460.312866 
	C200.135544,460.020020 201.028961,459.962708 202.214813,460.401917 
	C202.672043,460.719910 202.835068,460.872620 203.154800,461.319702 
	C203.022537,461.940796 202.725647,462.260162 202.199524,462.799988 
	C201.232788,463.739166 200.508896,464.472260 199.579193,465.418579 
	C198.812988,466.160583 198.452698,466.860321 197.655258,467.532166 
	C197.143967,467.889740 196.875061,468.114319 196.453537,468.542969 
	C196.050491,468.946838 195.822235,469.172821 195.434692,469.560486 
	C195.275467,469.722260 194.964798,470.039337 194.790222,470.169250 
	C194.615646,470.299194 194.745682,470.713440 194.703003,470.495117 
	C194.660309,470.276794 195.018204,469.993896 195.179642,469.826538 
	C195.574509,469.435120 195.803741,469.206879 196.210785,468.791809 
	C196.646164,468.357727 196.908127,468.115509 197.405029,467.715027 
	C198.135345,467.238037 198.511047,466.808990 198.985001,466.066864 
	C199.884354,465.147156 200.576263,464.437408 201.478516,463.525726 
	C201.956055,463.047180 202.229034,462.776367 202.694336,462.297119 
	C203.452499,461.673096 203.571640,461.266022 202.696869,460.627228 
	C202.477463,459.960693 202.548248,459.563324 202.929688,458.939514 
	C204.865173,457.817932 207.112869,458.413330 208.871857,456.590027 
	C209.650757,456.251556 210.134552,456.176300 211.012146,456.228241 
	C211.634598,456.395386 211.874405,456.501160 212.411057,456.870392 
	C214.621780,459.704773 214.364395,462.668457 214.187347,465.999329 
	C213.966415,467.161041 213.657043,467.870209 212.975555,468.814148 
	C212.370316,469.440430 211.978531,469.740082 211.242859,470.171082 
	C210.718109,470.441254 210.504913,470.537170 209.964508,470.744293 
	C207.017929,471.315491 204.510269,472.137909 201.749588,473.278381 
	C201.203522,473.396820 200.980316,473.423920 200.418884,473.467163 
	C199.168533,473.495331 198.259232,473.461121 197.621841,473.503723 
	C198.173889,473.750397 199.056213,473.377594 200.247818,473.548523 
	C200.800171,473.700867 201.001526,473.825989 201.293640,474.298492 
	C201.297363,475.130981 201.082901,475.553986 200.460526,476.133484 
	C199.919418,476.381592 199.678665,476.420715 199.117828,476.282532 
	C195.861191,476.504272 193.102173,479.820312 190.010223,476.354126 
	C190.236435,475.797699 190.433502,475.558380 190.817535,475.183838 
	C190.971390,475.021393 191.224686,474.667480 191.379578,474.522461 
	C191.534470,474.377472 191.188431,474.128174 191.283188,474.326904 
	C191.377945,474.525665 191.081833,474.866730 190.933167,475.042694 
	C190.565964,475.448181 190.315399,475.634766 189.807312,475.696777 
	C188.586288,476.108093 187.590775,476.600983 186.263885,477.154602 
	C185.192627,475.884216 184.221603,474.874695 182.367889,474.734497 
	C182.159302,474.665955 181.922852,474.435577 181.922852,474.435577 
	C181.922852,474.435577 181.685272,474.659027 181.859924,474.678833 
	C182.411407,474.967529 182.656219,475.326691 182.736115,476.036011 
	C180.613297,477.938873 178.997116,475.512177 176.787491,475.413391 
	C176.419617,474.782440 176.202866,474.538574 175.522217,474.505005 
	C175.263611,474.497040 174.785889,474.536743 174.785889,474.536743 
	C174.785889,474.536743 174.631729,474.089722 174.417297,474.169495 
	C174.202850,474.249237 174.267914,474.707794 174.056244,474.801697 
	C172.430283,475.089233 171.215088,474.720612 170.133209,473.318787 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M198.808243,476.415833 
	C198.797775,476.105286 199.196091,476.006348 199.401184,476.013031 
	C200.818481,475.534760 202.002014,474.969513 203.612122,474.623840 
	C204.147675,474.495758 204.363129,474.446045 204.909973,474.358276 
	C205.691940,474.329620 206.122971,474.428406 206.785721,474.828857 
	C207.428207,476.006073 207.099701,476.781128 206.184357,477.686523 
	C204.828415,478.132599 203.586578,477.761627 202.662354,479.020813 
	C202.804245,479.834534 202.691315,480.234802 202.050781,480.673004 
	C201.727676,480.762909 201.830688,480.560455 201.728226,480.511444 
	C201.487976,480.666504 201.350189,480.870544 201.304688,480.716980 
	C201.886429,478.799805 200.903427,478.335480 199.351181,478.002258 
	C198.954819,477.544861 198.886765,477.135620 198.808243,476.415833 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M181.185242,474.305908 
	C182.678253,474.911957 186.290009,471.902466 186.029999,476.883484 
	C184.404861,478.849854 184.156708,476.434479 182.937683,476.320496 
	C182.261169,475.728882 181.821121,475.160583 181.185242,474.305908 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M174.176926,474.935425 
	C173.844559,474.895630 173.827530,474.525146 174.051544,474.121460 
	C174.999466,474.008270 175.723358,474.298737 176.469101,474.885071 
	C175.830383,475.112366 175.169846,475.043793 174.176926,474.935425 
z"/>
<path fill="#0DA5E9" opacity="1.000000" stroke="none" 
	d="
M190.766327,493.439209 
	C191.844528,493.149872 193.128418,493.099548 194.891129,493.113190 
	C194.215500,496.078888 192.602097,494.951599 190.766327,493.439209 
z"/>
<path fill="#0DA5E9" opacity="1.000000" stroke="none" 
	d="
M198.005615,495.291595 
	C198.213013,495.246429 198.491150,495.461090 198.841187,495.935669 
	C198.634186,495.980835 198.355270,495.766144 198.005615,495.291595 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M84.754425,312.249573 
	C87.492241,315.852325 90.765709,313.925446 93.162605,312.528290 
	C96.977165,310.304779 93.229691,307.504913 92.930748,304.566833 
	C93.086311,304.009430 93.248634,303.823944 93.764404,303.529297 
	C96.138611,303.452911 97.835999,304.483398 99.939560,305.386353 
	C100.897202,306.043640 101.486382,306.614197 102.228546,306.957520 
	C107.667824,309.473694 107.668671,309.471863 103.454170,313.789917 
	C102.192131,314.919250 101.164536,314.577576 99.928047,313.806152 
	C101.529694,315.225708 103.365227,314.954437 105.351105,315.394135 
	C113.921875,318.620209 122.714027,320.606812 129.781738,326.998505 
	C130.120255,327.482483 130.226913,327.693817 130.351349,328.257751 
	C130.191330,329.049500 129.905197,329.393616 129.167084,329.729553 
	C128.418610,329.914551 127.984001,329.947845 127.233795,329.892975 
	C126.721779,329.807281 126.521812,329.757904 126.035339,329.606323 
	C125.193962,329.286652 124.637451,329.073975 123.765388,328.871460 
	C123.281357,328.758453 123.088104,328.709045 122.606018,328.578674 
	C121.543121,328.272705 120.758820,328.087006 119.687706,327.787903 
	C119.217636,327.590149 119.037872,327.492432 118.617493,327.207794 
	C118.063789,326.763611 117.736153,326.526428 117.107254,326.187653 
	C116.618530,325.997986 116.416428,325.930176 115.901886,325.767059 
	C110.011513,323.592468 104.605682,321.082489 98.688354,318.939636 
	C96.356590,318.087891 94.925110,316.078583 92.233505,316.286926 
	C89.829727,317.818848 87.715790,318.158173 85.326553,316.240570 
	C85.073013,316.004883 84.930000,316.010468 84.864418,315.981812 
	C84.681351,315.773193 84.563873,315.593201 84.247543,315.159485 
	C84.198921,314.082611 84.349159,313.259552 84.754425,312.249573 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M85.050522,316.431549 
	C87.146172,315.728455 89.500244,317.901123 91.588783,315.114166 
	C93.626610,316.482452 93.507751,319.741272 96.901505,320.211182 
	C97.966476,320.704681 98.662926,321.145905 99.337585,321.617920 
	C100.408020,322.366791 101.987114,323.005554 101.957191,324.360535 
	C101.921364,325.982513 100.135231,326.014832 98.901932,326.286896 
	C97.232437,326.655182 96.425751,327.780701 95.701897,329.559784 
	C95.184700,330.263611 94.775490,330.536591 93.931305,330.783447 
	C93.309074,330.831970 93.058891,330.815277 92.452187,330.683105 
	C91.434944,330.186890 90.995964,329.623718 90.693863,328.572632 
	C90.884041,327.220398 91.430946,326.242889 90.830391,324.885895 
	C89.542213,322.764496 88.236992,321.177429 85.473854,321.293091 
	C85.151375,319.688080 85.089706,318.273132 85.050522,316.431549 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M91.297577,323.616760 
	C92.168175,325.123718 94.288177,326.561035 91.235977,327.975098 
	C88.748077,329.313629 87.300430,327.923096 85.567230,326.464722 
	C85.310951,325.362335 85.288239,324.530975 85.304947,323.283630 
	C87.452591,320.970703 89.102654,323.001648 91.297577,323.616760 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M91.487572,329.809814 
	C92.037025,329.916718 92.226372,329.938324 92.700768,329.981323 
	C93.134514,330.160889 93.283195,330.319031 93.517487,330.792786 
	C93.566132,332.493469 92.862030,333.597534 91.881409,334.924500 
	C91.489357,335.307434 91.315498,335.442932 90.506058,335.689331 
	C88.854546,335.888062 87.838600,335.975861 86.440651,336.100983 
	C86.018860,335.956177 85.979065,335.774048 85.875107,335.319611 
	C85.861740,334.300873 85.912552,333.554382 85.970505,332.433624 
	C87.200363,330.191681 89.054192,329.716125 91.487572,329.809814 
z"/>
<path fill="#050E18" opacity="1.000000" stroke="none" 
	d="
M91.770775,329.642242 
	C90.124443,330.584503 88.401207,331.273895 86.327812,332.011292 
	C85.977661,332.059326 86.074226,332.023468 86.069534,331.972198 
	C85.884781,331.786865 85.704712,331.652771 85.540161,331.182312 
	C85.504669,330.467743 85.453659,330.089569 85.399445,329.424866 
	C85.406273,328.925140 85.416313,328.711975 85.374496,328.182983 
	C85.301857,327.494324 85.281090,327.121582 85.296997,326.471252 
	C86.965164,326.771790 88.596657,327.349854 90.553421,327.981506 
	C91.150414,328.486511 91.422134,328.937927 91.770775,329.642242 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M91.481361,323.475098 
	C89.658852,324.437897 88.006485,322.710175 85.710114,322.886597 
	C85.266701,322.477203 85.189026,322.086731 85.162201,321.399597 
	C88.046600,319.515900 90.058151,320.273560 91.481361,323.475098 
z"/>
<path fill="#0C1929" opacity="1.000000" stroke="none" 
	d="
M78.575172,311.382568 
	C76.458466,311.186005 76.480217,310.317749 78.430695,309.185730 
	C78.682404,309.822357 78.636353,310.446472 78.575172,311.382568 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M85.247475,328.190308 
	C85.442314,328.200775 85.562004,328.534454 85.538963,329.003235 
	C85.321594,328.930084 85.246964,328.721832 85.247475,328.190308 
z"/>
<path fill="#0ABEFA" opacity="1.000000" stroke="none" 
	d="
M84.110397,315.121826 
	C84.331139,315.039490 84.547722,315.243225 84.748642,315.735046 
	C84.519249,315.820129 84.310341,315.615051 84.110397,315.121826 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M85.464035,331.079407 
	C85.810463,330.997314 85.959755,331.219574 86.034195,331.716797 
	C85.834030,331.718262 85.603218,331.515564 85.464035,331.079407 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M99.393585,350.247253 
	C98.750053,348.292938 100.368538,347.521240 101.680794,346.147217 
	C105.356949,343.751648 109.555008,343.745911 113.513046,341.902832 
	C120.403091,341.072357 126.466774,343.293213 133.917740,344.785187 
	C126.561615,342.803833 120.393333,341.221161 113.542130,341.789459 
	C110.384537,343.003143 107.525040,343.961487 104.170013,344.276917 
	C103.522156,343.661926 103.443863,343.166565 103.788300,342.307739 
	C103.999443,341.977997 104.004524,342.003693 103.991394,342.003510 
	C104.221039,341.789703 104.454315,341.566193 104.842728,341.154907 
	C105.007339,340.977020 105.007713,341.007477 104.992462,341.007751 
	C105.219589,340.791412 105.453568,340.566040 105.845535,340.153931 
	C106.011917,339.975922 106.010628,340.010590 105.993286,340.011353 
	C106.219635,339.791718 106.455627,339.563354 106.851883,339.146851 
	C107.019836,338.966644 107.007591,339.007965 106.986115,339.009705 
	C107.416267,338.591827 108.013985,338.529297 108.790100,338.167664 
	C109.013802,337.979309 109.005997,338.010040 108.990570,338.006378 
	C110.942146,336.853638 113.188789,338.029846 114.801743,337.463013 
	C114.616707,337.561279 114.008080,337.469330 113.188980,337.111328 
	C112.986771,336.443359 112.994270,336.029449 113.001709,335.304993 
	C116.697006,332.361084 120.905792,334.117981 125.262032,333.611084 
	C127.509201,333.608917 129.311569,333.996490 131.516937,334.089996 
	C133.119308,334.274170 134.281494,334.651733 135.717834,335.307800 
	C137.108978,336.117279 137.535721,338.117371 139.568146,336.767273 
	C140.792252,335.954102 142.010162,337.097168 143.276031,338.165131 
	C144.588577,339.610199 145.349213,341.038147 146.501572,342.616028 
	C148.245697,345.782288 149.639740,348.742645 151.486847,351.868622 
	C151.824051,352.929688 151.809967,353.649750 151.364807,354.672363 
	C149.401962,356.217407 147.967484,355.190155 146.250473,354.085388 
	C145.097137,352.959167 144.533020,351.747070 143.123077,350.918335 
	C142.322601,350.462830 141.787048,350.165649 140.925140,349.846313 
	C139.604813,349.369720 138.613678,349.616699 137.317017,349.978912 
	C133.140976,349.617462 129.369507,349.420166 125.446648,348.401154 
	C119.452026,346.843964 112.781204,346.312317 106.596489,348.810364 
	C104.376976,349.706818 102.162338,350.148743 99.393585,350.247253 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M145.680603,352.534546 
	C147.399857,353.394775 148.810760,354.209381 150.876923,355.076508 
	C151.720871,355.210907 151.909561,355.292755 152.596497,355.739227 
	C153.248611,356.241516 153.402451,356.379150 153.782379,356.728516 
	C154.604034,357.514832 155.196960,358.092438 156.105255,358.793457 
	C156.847595,359.416992 157.245361,359.912872 157.506775,360.852875 
	C157.476105,361.381073 157.413666,361.587372 157.091492,361.986145 
	C151.469055,359.738647 146.402954,356.617157 140.295502,354.946106 
	C139.981232,353.683197 140.732712,353.161316 141.740814,352.486847 
	C143.160934,350.975922 144.232010,352.315338 145.680603,352.534546 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M110.555298,353.678040 
	C110.884293,354.246765 110.932304,354.672394 110.980637,355.417480 
	C109.955772,357.317078 108.331253,356.673035 106.942650,356.765228 
	C104.854843,356.903839 101.874054,357.372162 101.545837,354.893158 
	C101.226410,352.480469 104.446228,353.037079 106.446701,352.208496 
	C107.829788,352.911987 109.076828,353.161438 110.555298,353.678040 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M111.155380,353.567749 
	C109.102089,355.006409 107.970345,354.163269 106.908081,352.416290 
	C110.581741,352.127991 114.373222,352.112854 118.494568,352.279663 
	C116.374443,352.745850 113.924454,353.030090 111.155380,353.567749 
z"/>
<path fill="#044166" opacity="1.000000" stroke="none" 
	d="
M145.953979,352.290100 
	C144.725769,354.311523 143.676376,352.434784 142.226044,352.329742 
	C141.041367,352.051666 140.150024,351.818481 139.040100,351.314117 
	C138.720825,350.065857 139.289963,349.618225 140.527832,349.423035 
	C141.454193,349.493713 141.983047,349.539124 142.851868,349.801819 
	C144.543106,350.067444 145.475769,350.698914 145.953979,352.290100 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M141.221069,349.621826 
	C140.327057,350.027618 139.759155,350.275330 139.006378,350.782990 
	C138.314499,350.859650 137.807480,350.676361 137.153931,350.258911 
	C137.685043,348.300476 138.797928,347.575714 140.822113,348.703766 
	C141.205383,349.122284 141.376282,349.293060 141.221069,349.621826 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M93.383942,364.084839 
	C93.853432,362.381805 95.500359,362.242157 97.395744,361.940857 
	C98.276131,361.970490 98.818962,361.990356 99.764328,362.067505 
	C98.247414,363.471008 96.004448,363.784088 93.383942,364.084839 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M121.296249,358.341553 
	C122.137695,358.414368 123.412758,357.278992 124.124405,358.849670 
	C123.150398,358.918732 122.313995,358.760193 121.296249,358.341553 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M135.916138,353.737976 
	C135.832672,353.901031 135.661804,353.918579 135.246155,353.856018 
	C135.277161,353.714752 135.552948,353.653595 135.916138,353.737976 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M127.100281,334.530396 
	C122.617729,334.910492 118.274002,334.952911 113.465950,334.994904 
	C111.569206,334.432465 110.136772,333.870422 108.384468,333.225464 
	C106.769562,333.290253 105.464218,333.327209 103.826797,333.514374 
	C101.258591,333.123901 99.481239,331.987701 97.939911,329.905762 
	C98.199486,327.698914 99.476822,327.135345 101.131371,327.591125 
	C106.594368,329.095947 111.474358,326.742584 116.803497,325.188812 
	C117.094200,324.971893 117.475288,324.954498 117.665787,324.964142 
	C118.120476,325.214233 118.386612,325.452515 118.841705,325.880524 
	C119.028740,326.072388 119.046310,326.393250 119.046585,326.553955 
	C119.935455,328.174774 121.451881,327.182190 122.962784,327.776672 
	C123.324524,327.928955 123.431885,327.923248 123.481163,327.944733 
	C124.153999,328.248657 124.782242,328.517151 125.749367,328.809509 
	C126.031105,329.003998 125.993202,329.014435 125.987900,328.995483 
	C126.429153,329.455017 127.013046,329.517029 127.915863,329.529175 
	C128.552032,328.684967 129.415649,331.596100 129.781097,329.154785 
	C130.001419,328.954865 129.990158,328.544159 129.986313,328.338806 
	C130.525024,327.619690 131.122131,327.800903 132.009949,328.113831 
	C132.685944,328.392578 133.077454,328.541229 133.785278,328.757324 
	C134.738663,329.001251 135.355362,329.227234 136.152023,329.827026 
	C136.551147,330.503723 136.620819,330.945282 136.450363,331.720062 
	C134.882706,333.554382 132.884918,332.598022 130.901489,333.267700 
	C129.640808,333.484192 128.728745,333.363098 127.483139,333.087158 
	C123.874123,332.217346 120.546677,332.352234 116.163338,332.386505 
	C120.192879,332.936676 123.275833,332.208405 126.510719,333.404785 
	C126.959694,333.794159 127.099403,333.993439 127.100281,334.530396 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M97.329613,330.289886 
	C99.719574,330.996521 101.509872,331.937988 103.611526,333.019226 
	C104.746368,334.101868 104.452736,334.882294 103.292267,335.804413 
	C103.013367,336.031647 102.997528,336.001160 103.011543,336.010559 
	C102.540665,336.448975 101.861664,336.460632 101.145401,337.052856 
	C100.001938,338.468140 98.514511,339.944031 97.491646,338.250824 
	C94.394463,333.123718 94.342125,337.817993 93.128708,339.695129 
	C92.243385,340.529816 91.459206,340.753906 90.261765,340.157745 
	C89.943443,338.791779 89.944839,337.704315 89.908356,336.208557 
	C89.870483,335.800262 89.947372,335.863159 89.933853,335.910950 
	C90.099838,335.823059 90.279327,335.687378 90.729286,335.349854 
	C91.572472,333.967987 92.145195,332.787994 92.882217,331.323792 
	C94.226868,330.528320 95.615425,331.506775 97.329613,330.289886 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M103.391037,336.077423 
	C103.285316,335.273285 103.557266,334.514893 103.876053,333.457764 
	C104.958015,331.659943 106.256157,331.790741 107.860672,332.849487 
	C107.980186,336.078217 105.664932,335.798737 103.391037,336.077423 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M89.639473,339.968201 
	C90.701469,339.920715 91.460899,339.962158 92.599487,340.013000 
	C92.166176,341.766083 90.741280,342.446442 89.030190,341.719574 
	C87.868660,341.226196 88.546143,340.499420 89.639473,339.968201 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M112.612740,336.898682 
	C113.904587,337.004211 114.829918,337.151154 115.755249,337.298065 
	C115.756172,337.463745 115.757095,337.629456 115.758018,337.795135 
	C113.778542,337.890411 111.799057,337.985718 109.397369,338.041870 
	C109.745033,336.661987 111.092010,337.097748 112.612740,336.898682 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M103.693596,342.076874 
	C103.949944,342.449036 103.900436,342.920105 103.747040,343.734741 
	C103.509804,344.793640 103.035416,345.186951 102.112045,345.229553 
	C101.392494,345.013214 100.944214,344.979736 100.162460,344.884979 
	C101.015236,343.941040 102.201492,343.058411 103.693596,342.076874 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M108.706467,337.980652 
	C108.542213,338.325165 108.070633,338.671051 107.281853,339.014160 
	C107.442810,338.668304 107.920975,338.325195 108.706467,337.980652 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M94.726669,342.340668 
	C95.040787,342.357208 95.207695,342.504395 95.374588,342.651611 
	C95.109543,342.591522 94.844498,342.531433 94.726669,342.340668 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M98.325264,341.406189 
	C98.099510,341.940277 97.777145,341.948578 97.491302,341.488831 
	C97.727509,341.408783 97.963707,341.328735 98.325264,341.406189 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M101.276749,337.229187 
	C101.113983,336.542114 101.580963,336.095184 102.680756,335.980530 
	C102.550430,336.399231 102.075287,336.778473 101.276749,337.229187 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M106.774063,339.058289 
	C106.849106,339.272919 106.678383,339.579163 106.241806,339.948792 
	C106.160065,339.724731 106.344177,339.437317 106.774063,339.058289 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M105.765778,340.062683 
	C105.844467,340.282043 105.677025,340.588165 105.243401,340.951172 
	C105.158028,340.721832 105.338844,340.435608 105.765778,340.062683 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M104.751541,341.048096 
	C104.846611,341.289581 104.685875,341.602173 104.251709,341.959045 
	C104.150764,341.708618 104.323250,341.413910 104.751541,341.048096 
z"/>
<path fill="#055280" opacity="1.000000" stroke="none" 
	d="
M101.852402,345.252411 
	C102.294449,344.799255 102.748131,344.551819 103.422485,344.191345 
	C106.546974,343.094360 109.450806,342.110443 112.726349,341.125488 
	C113.288559,341.232697 113.479050,341.340973 113.840454,341.729980 
	C113.336174,345.289276 110.570732,343.571503 108.784966,344.160919 
	C106.780533,344.822449 104.713753,345.295105 102.271988,345.860107 
	C101.869888,345.870270 101.864029,345.458160 101.852402,345.252411 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M145.722229,393.588226 
	C146.140320,393.177765 146.671722,393.104156 147.605469,393.011749 
	C149.057037,392.037567 150.277725,391.798065 151.977417,392.263184 
	C153.324448,392.915741 152.880722,394.383392 154.772003,394.745941 
	C158.483017,395.457367 162.548157,396.025116 165.427414,399.575256 
	C165.322723,402.605927 163.328171,403.635437 160.900208,404.677612 
	C158.035934,405.015564 155.312759,403.848022 152.762085,406.010315 
	C152.295151,406.268250 152.098221,406.350403 151.586426,406.475525 
	C150.045135,406.383423 148.821548,406.226868 147.301208,405.981384 
	C146.214249,405.650238 145.429138,405.369568 144.346939,404.976471 
	C141.057007,404.015259 138.799530,402.062164 136.503967,399.629517 
	C136.243378,398.877991 136.201233,398.431030 136.332855,397.663635 
	C136.539780,397.173981 136.656845,396.997894 137.037674,396.662537 
	C137.395126,396.086060 138.381454,397.264313 138.005112,396.121918 
	C137.936920,395.914856 137.553284,395.738342 137.515594,395.051636 
	C140.006546,391.187683 142.929276,394.844452 145.600876,394.248199 
	C146.152298,394.125122 146.773956,394.834808 147.344971,394.194275 
	C146.746078,394.641388 146.302368,394.218414 145.722229,393.588226 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M151.032867,406.028625 
	C151.425095,406.028503 151.535324,406.059082 151.592514,406.058319 
	C153.764664,404.602509 156.196823,404.585114 159.015320,404.516479 
	C162.385544,404.294220 164.557953,402.070679 167.705429,401.240601 
	C170.770065,400.653290 172.708115,401.339111 173.152924,404.751648 
	C173.180130,405.355225 173.175690,405.593750 173.128967,406.177582 
	C173.033707,406.742004 172.980728,406.961182 172.809296,407.485779 
	C172.584564,407.974304 172.478302,408.157410 172.180817,408.579956 
	C171.850067,408.958740 171.710510,409.098053 171.352158,409.423248 
	C170.847198,409.841522 170.565186,410.078888 170.109589,410.517456 
	C169.816360,410.845642 169.702103,410.979004 169.416565,411.312500 
	C169.127899,411.644104 169.010498,411.775574 168.532928,412.300018 
	C168.055557,412.830963 167.938309,412.968964 167.503448,413.566498 
	C166.988159,414.363312 166.784653,414.697052 166.394760,415.280151 
	C165.917038,415.842224 165.578995,416.097656 164.233978,416.300232 
	C160.557785,413.992584 157.537079,412.199066 154.128387,410.416199 
	C152.270233,409.222382 149.759567,410.974304 148.364563,408.212097 
	C147.851471,405.888672 149.442368,406.216797 151.032867,406.028625 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M141.004700,424.598022 
	C140.406128,424.523865 139.805542,424.054535 139.055695,423.337708 
	C137.435501,422.005035 136.957245,420.023285 135.015991,418.935425 
	C133.354996,418.116638 132.185562,416.981140 130.191101,417.000580 
	C128.707291,416.954498 127.525513,417.149261 126.220085,416.229889 
	C125.893806,415.751282 125.822975,415.522400 125.896690,414.962402 
	C126.918159,413.723663 127.976318,413.202026 129.605225,413.149231 
	C133.200150,413.091675 136.359940,413.395233 139.629669,415.123535 
	C141.486298,416.687805 141.344223,418.482849 141.076111,420.664917 
	C141.000916,422.094482 141.001801,423.148651 141.004700,424.598022 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M136.664124,398.801453 
	C139.220184,400.784119 141.477921,402.536102 143.892761,404.576080 
	C141.372986,405.525970 138.719482,408.908142 136.011871,404.575378 
	C136.119415,403.027283 136.274963,401.824768 135.146881,400.556274 
	C134.988281,400.041443 134.985626,399.834045 134.991425,399.315674 
	C135.380081,398.623596 135.835403,398.479004 136.664124,398.801453 
z"/>
<path fill="#0A5C8E" opacity="1.000000" stroke="none" 
	d="
M158.116653,419.705322 
	C154.607101,419.406616 151.244080,418.797455 147.217911,417.920410 
	C146.219772,416.948090 146.207199,416.237274 146.757111,415.244812 
	C147.349121,414.315338 147.913925,414.113251 148.918701,414.313171 
	C149.614197,414.633087 149.766388,415.504486 150.624878,414.644958 
	C153.219055,414.637665 155.643494,414.857391 158.486389,415.109100 
	C159.033707,415.317963 159.162582,415.494904 159.184570,415.983368 
	C158.329529,417.203003 158.224594,418.280090 158.116653,419.705322 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M141.273376,421.084351 
	C139.244247,419.677551 140.289459,417.686340 139.930176,415.648743 
	C140.124985,414.900482 140.263931,414.526306 140.703735,414.083282 
	C142.355103,415.857483 144.409836,416.616638 146.632812,417.716309 
	C146.886215,417.925720 147.003204,418.025482 147.050980,418.088348 
	C144.884811,420.684265 147.112366,424.462158 143.977722,427.721680 
	C143.977722,425.303467 143.856232,423.623535 144.002167,421.967224 
	C144.341202,418.119141 142.058929,422.273438 141.273376,421.084351 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M159.267914,416.398376 
	C158.893295,416.110565 158.930817,415.625275 158.917831,415.383179 
	C158.170380,412.453461 153.250076,414.750153 153.772690,410.445099 
	C158.208374,409.982452 160.472992,413.573517 163.845337,415.731049 
	C162.724075,417.299591 161.228867,417.292114 159.267914,416.398376 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M146.918365,417.557831 
	C144.429810,417.809021 141.317154,418.926147 141.000748,414.403870 
	C142.779251,414.127533 144.601669,413.918335 146.632370,414.881897 
	C146.984573,415.709595 146.967545,416.449768 146.918365,417.557831 
z"/>
<path fill="#071F39" opacity="1.000000" stroke="none" 
	d="
M119.074127,414.502319 
	C120.242188,413.695374 121.377983,413.183716 122.737869,412.461365 
	C124.000168,412.248108 125.038391,412.245514 126.456039,412.332092 
	C127.931000,413.316223 127.235558,413.954163 126.251068,414.795532 
	C125.977905,415.001221 126.001778,415.001709 125.995293,414.991821 
	C124.182343,416.713501 121.864182,416.224396 119.353836,416.209106 
	C119.015068,415.591583 119.028465,415.194611 119.074127,414.502319 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M151.187317,405.744171 
	C150.418411,406.485077 149.411728,406.941650 148.248383,407.682983 
	C147.750519,407.496643 147.409302,407.025574 147.033722,406.242676 
	C148.197952,404.783386 149.535934,404.804535 151.187317,405.744171 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M150.533081,414.380493 
	C150.835236,415.482941 152.508163,416.862823 151.208694,417.426727 
	C149.600967,418.124390 149.205627,416.433868 149.172806,414.745361 
	C149.572327,414.402557 149.921936,414.372833 150.533081,414.380493 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M126.305069,414.984192 
	C126.253044,414.324524 126.528198,413.647797 126.819412,412.696167 
	C127.769424,412.087738 128.680450,412.108704 129.763702,412.884460 
	C128.854874,413.769989 127.743553,414.368591 126.305069,414.984192 
z"/>
<path fill="#11547D" opacity="1.000000" stroke="none" 
	d="
M118.025047,406.441467 
	C118.339714,406.066223 118.914680,405.857727 119.672318,405.405579 
	C120.603935,405.363342 120.891060,405.940918 120.435928,406.482330 
	C119.867126,407.159058 119.025673,406.855408 118.025047,406.441467 
z"/>
<path fill="#075479" opacity="1.000000" stroke="none" 
	d="
M141.162125,371.142517 
	C144.938339,368.658173 149.355087,368.198700 153.783539,368.019653 
	C156.449066,367.911835 159.055756,367.789581 162.463043,366.328003 
	C164.662567,367.221649 164.298218,368.339172 162.837677,369.604248 
	C160.963882,370.372711 159.361450,370.316437 157.379150,370.389526 
	C152.264053,370.735535 147.658173,372.053833 142.506561,371.945251 
	C141.878952,371.719482 141.641953,371.592163 141.162125,371.142517 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M134.358841,375.052307 
	C134.331329,374.280487 134.661194,373.522888 135.078918,372.470154 
	C136.835571,371.741516 138.504333,371.308014 140.546204,370.847351 
	C140.919296,370.820221 141.082428,371.013672 141.202301,371.054169 
	C141.288040,371.553955 141.085648,371.920349 140.384521,372.201447 
	C137.833252,372.336975 137.046158,375.142731 134.358841,375.052307 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M163.246613,365.568237 
	C162.896896,365.931244 162.710251,365.959259 162.241455,366.012634 
	C161.347656,365.597443 160.736038,365.156860 159.947296,364.494446 
	C159.902725,364.062592 160.035263,363.852570 160.508835,363.490723 
	C162.264313,363.212006 163.338470,363.544922 163.246613,365.568237 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M158.233704,363.232330 
	C157.620178,362.963531 157.342285,362.806824 156.969177,362.376923 
	C156.956207,362.050629 157.080688,361.922638 157.392380,361.603210 
	C158.329880,361.432312 158.899399,361.743286 159.194824,362.784424 
	C158.949051,363.226501 158.738083,363.322906 158.233704,363.232330 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M158.112122,363.269806 
	C158.218903,363.021912 158.497528,362.998474 159.194107,362.940521 
	C159.775726,362.957733 159.939392,363.009460 160.274536,363.253174 
	C160.333679,363.582794 160.221298,363.720428 159.939545,364.065369 
	C159.274765,364.013214 158.779358,363.753754 158.112122,363.269806 
z"/>
<path fill="#1B222E" opacity="1.000000" stroke="none" 
	d="
M140.099991,372.520966 
	C140.361053,371.988861 140.668213,371.768738 141.148773,371.321625 
	C146.276291,370.427216 151.230423,369.759796 156.604340,369.137085 
	C159.949539,373.102600 162.129089,377.714630 167.121780,379.694641 
	C168.022659,380.051910 168.492889,381.087769 168.308411,382.549194 
	C164.191483,385.590271 159.907684,384.201141 155.346527,383.723969 
	C153.262360,383.470795 151.503845,382.404694 149.545151,383.965027 
	C149.058136,384.236664 148.842728,384.306671 148.334915,384.203674 
	C145.791245,383.800171 146.041245,382.060394 145.897247,380.140472 
	C145.654236,378.949005 145.766220,378.084900 145.166992,377.079163 
	C144.084213,374.632629 141.123138,374.937408 140.099991,372.520966 
z"/>
<path fill="#059FE5" opacity="1.000000" stroke="none" 
	d="
M138.141174,396.691345 
	C137.785583,396.800354 137.399002,396.888489 137.213470,396.958374 
	C136.619766,397.394012 136.145645,397.529999 135.291962,397.209778 
	C134.978302,396.983307 135.004517,396.994751 135.007629,397.008728 
	C134.387024,395.873352 133.267120,395.229431 132.094269,394.189606 
	C131.106949,393.897949 130.359589,393.811707 129.429092,393.537903 
	C128.504684,391.499176 126.704796,390.986023 124.807648,390.056946 
	C125.227028,388.221039 126.469757,389.034302 127.715034,389.325653 
	C133.413116,390.658752 139.127151,391.923676 145.222198,393.232239 
	C146.473679,393.615875 147.338440,393.980377 148.467789,394.456360 
	C144.976990,396.298492 141.263351,392.661469 138.078461,395.601227 
	C138.209808,396.177856 138.353302,396.380066 138.141174,396.691345 
z"/>
<path fill="#1B2532" opacity="1.000000" stroke="none" 
	d="
M153.631683,392.600220 
	C151.602173,393.014679 150.219681,393.006409 148.422516,392.995544 
	C148.005096,391.652588 148.002380,390.312195 147.995926,388.569702 
	C149.035141,386.792389 150.443176,386.249603 152.514633,386.463318 
	C154.093552,387.367615 154.580566,388.569336 154.823975,390.310699 
	C154.753723,391.237915 154.570572,391.728027 153.631683,392.600220 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M132.675720,374.796509 
	C133.120087,374.921143 133.304749,374.938110 133.766373,374.980652 
	C131.781723,378.329712 128.105240,379.461426 124.346817,381.024963 
	C125.347092,377.517273 129.238739,377.604065 131.875992,375.336121 
	C132.086823,375.062256 132.037003,375.022980 132.025024,375.051941 
	C132.147369,374.950165 132.281708,374.819458 132.675720,374.796509 
z"/>
<path fill="#074D75" opacity="1.000000" stroke="none" 
	d="
M153.396118,387.130676 
	C151.588333,387.464539 150.158981,387.768707 148.360901,388.120209 
	C148.002563,387.062561 148.012924,385.957550 148.032898,384.441650 
	C148.042496,384.030731 148.423859,383.981049 148.615997,383.973145 
	C149.005707,383.825256 149.203278,383.685242 149.763000,383.495300 
	C151.112732,383.539734 152.057022,383.807129 153.309525,384.341980 
	C154.496674,385.340271 154.730942,386.189362 153.396118,387.130676 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M144.870056,377.124054 
	C145.557129,377.607910 149.307495,376.749207 146.084625,379.559967 
	C144.827957,379.852234 143.795395,379.959717 142.388580,380.039124 
	C142.925980,379.149170 143.837616,378.287323 144.870056,377.124054 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M141.991791,379.990356 
	C141.891861,380.026672 141.798813,380.071075 141.860046,380.063232 
	C142.014328,380.010986 141.998688,379.998474 141.991791,379.990356 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M131.898499,394.363892 
	C133.212845,394.465637 135.813309,393.227417 135.114578,396.718201 
	C133.129700,397.418488 132.059372,396.722961 131.898499,394.363892 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M134.907852,397.317139 
	C135.434540,396.971100 135.890762,396.958893 136.687469,396.987457 
	C137.017883,397.473480 137.007812,397.918701 136.980087,398.698029 
	C136.526459,399.018646 136.090485,399.005219 135.327209,398.998230 
	C134.945724,398.553467 134.891571,398.102203 134.907852,397.317139 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M132.840012,374.747925 
	C132.935425,374.904205 132.484344,375.044037 132.248688,375.062469 
	C132.256882,374.917816 132.500732,374.754730 132.840012,374.747925 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M225.917938,510.783447 
	C226.908844,511.126312 227.745392,511.817383 228.801346,512.751465 
	C230.163971,516.397156 227.196991,515.649719 225.756165,516.305908 
	C227.458466,515.862427 229.136414,516.025208 230.778198,517.685120 
	C230.982941,518.350403 230.980103,518.689453 230.969208,519.283020 
	C231.090637,520.011841 230.954102,520.371521 230.236176,520.793945 
	C229.967529,520.991455 230.000320,521.001343 229.998993,520.984619 
	C229.212921,521.299988 228.428177,521.632141 227.321686,521.978455 
	C224.272552,520.073242 223.823853,516.860413 222.673019,514.098267 
	C221.355331,510.935638 225.308792,512.750061 225.917938,510.783447 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M214.843307,509.017944 
	C215.031418,510.298706 215.152664,512.370117 213.790237,512.237305 
	C212.177063,512.080078 213.393723,510.536133 213.923676,509.310852 
	C214.108276,509.032684 214.598221,509.018158 214.843307,509.017944 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M236.089462,537.670715 
	C235.268387,537.581787 234.485611,537.136353 233.427704,536.470337 
	C232.942932,535.695374 232.733261,535.140991 232.411346,534.386230 
	C231.955429,532.574036 232.761124,532.157471 234.219864,532.159485 
	C235.476105,532.161255 236.150330,532.803284 236.261688,533.879333 
	C236.378464,535.007568 236.185410,536.167908 236.089462,537.670715 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M243.884674,535.599243 
	C242.737335,535.885620 241.456573,536.254028 240.970947,534.361206 
	C241.017426,532.711853 240.623001,531.291443 241.829651,529.793213 
	C242.090485,529.477234 242.363800,529.531555 242.487213,529.596191 
	C242.464706,530.771667 243.791824,531.384277 243.738312,532.794434 
	C243.917542,533.794739 243.935669,534.518921 243.884674,535.599243 
z"/>
<path fill="#033E75" opacity="1.000000" stroke="none" 
	d="
M208.795425,508.317047 
	C209.562653,508.136749 209.948608,508.106903 210.624863,508.080200 
	C211.608475,509.887665 210.632278,511.488678 210.366028,513.532104 
	C210.446381,514.480896 210.210739,514.939270 209.332397,515.366638 
	C206.049271,513.330994 204.802322,511.079712 208.795425,508.317047 
z"/>
<path fill="#086AC0" opacity="1.000000" stroke="none" 
	d="
M209.000885,515.407349 
	C209.326126,514.751770 209.654831,514.527405 210.209839,514.099792 
	C210.780838,513.932068 211.125519,513.967529 211.732758,514.003540 
	C211.952682,514.796204 211.792664,515.528931 210.731140,516.020264 
	C209.886490,516.477722 209.403976,516.392639 209.000885,515.407349 
z"/>
<path fill="#15ABF3" opacity="1.000000" stroke="none" 
	d="
M244.312653,526.229126 
	C242.680054,523.126587 240.510071,520.872559 238.140991,518.357117 
	C237.987991,517.093567 238.336914,516.300232 239.481735,515.617249 
	C242.695145,515.372009 242.698151,513.093567 243.211166,510.754211 
	C243.481888,510.199341 243.624405,509.991455 244.084412,509.567444 
	C245.419983,508.936310 246.445282,508.937317 247.822296,509.501709 
	C248.712234,510.318329 248.991898,511.056580 249.243958,512.220276 
	C249.435059,515.739136 250.882355,518.146973 253.170975,520.250671 
	C254.591583,521.556458 255.364288,523.225342 253.263809,524.775757 
	C251.931290,525.759399 251.253738,527.233398 251.498093,528.606934 
	C250.975830,529.290405 250.545959,529.510925 249.681824,529.554382 
	C247.524750,528.829834 246.354889,527.181152 244.312653,526.229126 
z"/>
<path fill="#063A70" opacity="1.000000" stroke="none" 
	d="
M240.278778,516.127136 
	C239.468887,516.793518 238.980988,517.301819 238.238647,517.936462 
	C237.569977,517.750793 237.155777,517.438660 236.508484,517.014343 
	C235.938492,516.448120 235.601593,515.994202 235.104889,515.304321 
	C234.538742,514.415955 234.223709,513.682678 233.199219,513.198853 
	C232.639587,512.926453 232.381805,512.735962 232.082764,512.240356 
	C231.670105,509.435516 233.326202,508.416260 235.425415,508.213196 
	C237.541931,508.008514 239.043243,508.875549 238.292236,511.425781 
	C238.161301,511.870331 237.999847,512.018005 238.273376,511.968781 
	C238.595627,511.910767 238.920731,511.624512 239.189529,511.658569 
	C242.648773,512.096558 242.237152,513.839966 240.278778,516.127136 
z"/>
<path fill="#0D89D9" opacity="1.000000" stroke="none" 
	d="
M244.030060,526.253906 
	C245.977997,526.040344 247.816040,526.297363 248.942719,528.582947 
	C249.527863,529.662231 249.135071,530.212341 248.309219,530.876709 
	C246.335114,530.268433 245.449844,528.804199 244.302551,527.158447 
	C244.054672,526.963623 244.027451,526.490723 244.030060,526.253906 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M243.949936,532.705444 
	C243.408096,532.146667 242.916763,531.222778 242.518036,529.979858 
	C242.929733,529.718384 243.236923,529.814148 243.758240,530.044800 
	C243.989639,530.874390 243.995041,531.607361 243.949936,532.705444 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M208.735199,514.770142 
	C209.278549,515.281433 209.559647,515.586670 210.146286,515.993164 
	C210.319733,516.505737 210.187653,516.917053 209.998199,517.646362 
	C209.330963,517.976074 208.721115,517.987793 207.812347,518.025513 
	C205.602020,515.220825 205.770660,511.683441 204.140808,508.379700 
	C205.400497,508.065338 206.852661,508.062897 208.740768,508.113525 
	C206.724777,510.055176 206.785172,512.220093 208.735199,514.770142 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M231.217743,518.014099 
	C229.304825,517.561707 227.623871,517.112122 225.885864,516.647278 
	C225.753845,514.467346 228.763748,515.488281 228.967682,513.328186 
	C230.097260,514.041016 231.173767,515.087524 232.415741,516.417358 
	C232.526337,516.951050 232.471466,517.201416 232.164993,517.742554 
	C231.913391,518.033325 231.449707,518.016907 231.217743,518.014099 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M230.264664,521.054932 
	C230.160995,520.652283 230.354446,520.313171 230.754532,519.755737 
	C231.853256,520.323425 231.633026,520.828430 230.264664,521.054932 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M232.180603,517.973938 
	C231.997131,517.798157 232.080856,517.563049 232.372894,517.014282 
	C232.581223,516.700623 232.822678,516.806946 232.912628,516.903442 
	C232.817673,517.304871 232.632751,517.609741 232.180603,517.973938 
z"/>
<path fill="#0D89D9" opacity="1.000000" stroke="none" 
	d="
M250.774231,529.273376 
	C251.131058,527.100647 248.599274,524.620544 252.787628,523.693054 
	C254.771225,523.253784 253.143692,521.372070 252.191788,520.854065 
	C249.203598,519.227905 248.269257,516.631592 248.177612,513.125977 
	C249.614655,511.667542 251.121902,511.889893 252.424805,512.643555 
	C257.972717,515.852783 262.851868,513.796753 267.936371,510.649841 
	C268.965668,509.746460 269.729767,509.100616 271.012756,508.565796 
	C273.741913,508.599518 273.484283,510.225189 272.964417,511.632843 
	C271.727417,514.982422 271.025970,518.574219 268.462738,521.695679 
	C265.667908,522.976501 262.610626,523.920898 267.272430,526.895264 
	C267.756348,530.052002 266.205902,532.112915 264.176239,534.268799 
	C262.966156,534.764893 261.759430,534.848206 262.298096,536.698486 
	C262.010529,537.673828 261.506714,538.098328 259.934753,538.484070 
	C258.747009,538.440796 258.543884,538.355469 258.051208,538.119080 
	C257.379456,537.767700 256.992249,537.577637 256.289673,537.303833 
	C255.351624,537.012634 254.751617,536.758606 254.076599,536.058228 
	C254.036942,534.308350 252.886215,533.499207 252.087708,532.148865 
	C250.989441,531.400635 250.291885,530.780334 250.774231,529.273376 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M260.592377,542.792114 
	C260.697937,545.409851 261.727325,548.312134 257.681793,548.754883 
	C256.903961,547.337341 256.464447,546.006836 255.906311,544.340332 
	C255.938126,539.524475 258.162842,541.127380 260.592377,542.792114 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M249.786560,543.604980 
	C245.952927,543.720215 243.427200,542.357666 244.863022,537.520996 
	C249.244064,537.160278 248.663651,540.857666 249.786560,543.604980 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M260.933258,542.806030 
	C259.246460,543.223511 257.495361,540.733582 255.874039,543.665771 
	C255.526443,543.548340 255.265182,543.092468 254.997681,542.363159 
	C253.765488,541.955505 256.735260,540.025635 254.048462,540.208740 
	C253.551071,539.535950 253.281647,539.073425 252.992676,538.330078 
	C253.613358,537.111694 254.597137,537.065857 255.953354,537.050659 
	C256.557495,537.094116 256.797455,537.128418 257.381042,537.279541 
	C257.956268,537.465820 258.187897,537.535156 258.721863,537.805054 
	C259.024139,538.005493 258.993134,538.008484 258.991394,537.993042 
	C259.142853,538.102356 259.296082,538.227112 259.715515,538.484802 
	C260.141693,538.736328 260.301727,538.854980 260.621643,539.226501 
	C260.904510,539.859253 260.988373,540.247314 261.052551,540.941650 
	C261.045532,541.656982 261.012421,542.075562 260.933258,542.806030 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M257.141479,537.507080 
	C255.835251,537.811890 254.797241,537.915588 253.366180,538.034302 
	C252.082611,537.163391 251.919449,536.402710 253.633759,535.839722 
	C254.676697,535.845520 255.426437,535.926270 256.543365,536.094177 
	C257.297546,536.458313 257.474884,536.828369 257.141479,537.507080 
z"/>
<path fill="#0F62A1" opacity="1.000000" stroke="none" 
	d="
M250.662537,528.958984 
	C251.228790,529.751343 251.463776,530.527466 251.826874,531.580139 
	C250.760132,532.077759 249.564590,532.307129 248.218430,531.288452 
	C248.261917,530.501160 248.537537,529.988586 248.909668,529.199890 
	C249.447891,528.930115 249.889587,528.936401 250.662537,528.958984 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M253.890289,540.302124 
	C255.042480,539.921631 256.264465,539.844666 257.544220,539.764038 
	C257.378784,541.354675 255.899124,540.835510 255.160858,541.830200 
	C254.647659,541.595032 254.303879,541.100403 253.890289,540.302124 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M261.319580,541.177979 
	C260.729950,540.694946 260.381256,540.151611 260.028076,539.276367 
	C260.386322,538.650879 260.799255,538.532715 261.479675,538.847717 
	C261.789948,539.525940 261.882996,539.946289 262.010590,540.687622 
	C262.045135,541.008667 261.560516,541.117676 261.319580,541.177979 
z"/>
<path fill="#063A70" opacity="1.000000" stroke="none" 
	d="
M244.523773,509.666565 
	C244.330933,510.176910 244.254303,510.335327 244.070984,510.735229 
	C243.043945,511.961151 241.360886,512.307617 240.911697,511.434174 
	C238.797226,507.322540 235.496597,508.536621 232.202164,508.947968 
	C230.530762,509.156677 229.146805,507.821381 227.272491,507.214539 
	C226.014679,505.229492 221.647476,504.413422 225.676758,501.118530 
	C226.413330,500.772614 226.826202,500.812317 227.422379,501.320007 
	C227.914062,501.830750 228.064789,502.560852 228.491760,502.289032 
	C228.939529,502.003906 228.635086,501.180054 229.285507,500.484802 
	C231.603317,499.368683 233.748840,498.895264 236.346756,498.778778 
	C237.196045,498.843567 237.665680,498.941620 238.435364,499.238037 
	C239.309494,499.772766 239.649139,500.335846 240.117249,501.180786 
	C240.775925,501.976532 241.338638,501.806610 242.232040,501.499878 
	C243.028000,501.376343 243.479324,501.457764 244.187897,501.864258 
	C245.655014,504.476746 245.222107,506.893829 244.523773,509.666565 
z"/>
<path fill="#0355A0" opacity="1.000000" stroke="none" 
	d="
M227.130463,507.298706 
	C231.290375,507.517273 235.530502,508.700714 239.923782,507.166473 
	C241.331131,506.675018 241.871780,507.713806 241.171661,509.296906 
	C239.950119,512.058960 242.449554,510.560852 243.622162,510.981323 
	C244.059067,513.686646 244.392761,516.543030 240.188019,516.522034 
	C242.684708,511.570831 239.162476,512.449951 236.501373,512.829895 
	C236.437912,511.368134 239.338364,510.594788 237.147751,509.354492 
	C234.943390,508.106384 233.565491,509.835602 232.144501,511.704559 
	C230.408493,510.544128 228.838165,509.068298 227.130463,507.298706 
z"/>
<path fill="#0DA5E9" opacity="1.000000" stroke="none" 
	d="
M199.160919,493.270142 
	C203.552811,490.919952 208.402237,492.516602 213.570831,492.030853 
	C214.545868,492.606873 214.764297,493.260162 214.589706,494.345154 
	C212.735641,495.672272 211.278641,497.063965 209.318649,498.103271 
	C208.330444,496.679901 207.666153,495.363220 206.733292,493.514160 
	C204.077301,498.795624 201.806564,494.910889 199.160919,493.270142 
z"/>
<path fill="#0DA5E9" opacity="1.000000" stroke="none" 
	d="
M214.000443,500.356567 
	C212.373672,499.614838 210.579025,502.427948 209.029236,499.389923 
	C210.595276,498.252197 211.499542,496.514008 213.523163,495.729553 
	C216.310730,494.345245 217.278030,496.639435 218.933792,497.981720 
	C219.698792,502.707794 214.378860,502.994659 213.717667,507.212494 
	C211.588181,504.260132 214.554977,502.671661 214.000443,500.356567 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M232.891525,491.502106 
	C234.811279,490.916595 236.573563,490.633789 238.680908,490.189087 
	C239.992401,488.971466 241.284271,488.633118 242.547501,488.999023 
	C243.607620,489.306061 246.830460,489.167389 243.567215,491.445190 
	C244.056229,491.719116 244.754044,491.577362 245.128693,492.548859 
	C242.247849,495.396149 238.254242,495.222534 234.653534,497.075897 
	C233.109329,497.488464 232.385056,496.924438 232.051056,495.487396 
	C232.093384,493.969879 231.929428,492.801361 232.891525,491.502106 
z"/>
<path fill="#059FE5" opacity="1.000000" stroke="none" 
	d="
M231.764587,495.090637 
	C232.597244,495.667755 233.048889,496.216949 233.749908,496.884155 
	C234.398087,497.026428 234.773697,497.134583 235.384094,497.467407 
	C236.286835,498.088257 236.916443,498.572540 237.059937,499.640350 
	C234.576645,500.267059 232.223740,500.625427 229.482651,501.067932 
	C228.759003,501.751495 228.266693,502.141998 227.296570,502.134186 
	C226.888443,501.657379 226.681671,501.402344 226.179886,501.076294 
	C225.940643,497.283417 228.428268,495.957611 231.764587,495.090637 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M219.396912,498.165619 
	C216.092606,500.540161 216.810791,495.530975 214.296478,495.736877 
	C213.918839,494.603424 213.961365,493.751862 214.021042,492.475464 
	C216.084579,492.030731 218.130981,492.010895 220.620544,491.988586 
	C220.606277,494.013641 220.148834,496.041138 219.396912,498.165619 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M213.607910,495.253815 
	C213.876312,495.454956 213.906677,495.774872 214.005035,495.902252 
	C212.726532,497.175568 211.928955,499.158813 209.339081,499.062408 
	C208.969910,498.874115 208.963043,498.698395 208.975449,498.259644 
	C210.987656,497.819153 209.634415,492.703217 213.607910,495.253815 
z"/>
<path fill="#0355A0" opacity="1.000000" stroke="none" 
	d="
M233.080231,513.299622 
	C233.916763,513.048157 234.727295,513.270142 234.918274,514.735596 
	C234.363525,514.567932 233.781967,514.067566 233.080231,513.299622 
z"/>
<path fill="#1B2532" opacity="1.000000" stroke="none" 
	d="
M398.767181,117.232315 
	C399.463379,116.619263 399.938263,116.323082 400.706146,116.005630 
	C402.956635,119.165565 405.605835,121.161316 409.532227,121.023186 
	C412.695312,120.911903 413.784790,123.915688 415.938141,125.320824 
	C421.118164,128.701004 426.481537,131.606873 433.147522,131.013596 
	C432.403137,132.542252 429.648926,131.663010 430.222321,133.982544 
	C430.610352,135.552277 431.806030,136.409561 433.299011,136.957993 
	C437.338470,138.441879 441.241364,140.339325 445.528839,141.068756 
	C452.763885,142.299652 456.546417,147.558350 459.942322,153.663483 
	C455.376434,155.403549 451.520477,154.420746 448.370056,150.161285 
	C447.170197,147.147705 445.451721,145.582886 442.447235,145.038025 
	C438.387543,144.301819 434.773346,141.941254 430.260254,141.292236 
	C426.350006,140.437027 423.498962,138.457336 420.720184,135.686752 
	C419.692108,134.216522 419.420410,132.667770 417.614349,132.260590 
	C412.607971,131.131866 408.406616,128.657089 405.292236,124.471382 
	C404.884674,123.923645 404.099915,123.978722 403.077545,123.943298 
	C402.226227,123.886520 401.751648,123.765633 400.972076,123.379898 
	C399.494659,121.468231 398.262054,119.792938 398.767181,117.232315 
z"/>
<path fill="#1B2532" opacity="1.000000" stroke="none" 
	d="
M493.284668,194.590790 
	C492.612030,194.954437 492.154388,194.975815 491.353699,195.017731 
	C490.833862,195.163452 490.657043,195.288605 490.157684,195.377808 
	C488.259705,194.582748 487.223969,193.209930 485.840027,191.773590 
	C485.149933,190.919571 484.665680,190.292084 483.791138,189.631241 
	C483.392853,189.339661 483.234131,189.220917 482.607361,188.729034 
	C481.228210,187.520218 480.063293,187.109146 478.775970,186.290009 
	C477.602600,184.899933 476.883545,183.553253 475.581970,182.219055 
	C470.543427,174.819275 464.821320,168.500488 458.233307,162.955414 
	C455.736389,160.853790 452.882568,159.055176 451.834900,155.380692 
	C454.863556,152.685593 458.073975,155.260925 461.436371,154.293716 
	C463.048920,154.065277 464.360931,153.740433 466.050964,155.196503 
	C458.620544,156.239059 462.136963,158.937622 464.245697,161.940063 
	C469.015045,168.730728 473.729889,175.458786 482.621735,178.001434 
	C482.996338,178.004929 483.483521,178.015564 483.726746,178.022278 
	C485.226227,183.571182 488.164551,188.107407 492.636505,191.979065 
	C493.613159,192.659439 493.727905,193.414398 493.284668,194.590790 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M461.489807,154.105133 
	C458.932373,155.966690 455.612122,154.284637 452.335632,155.558594 
	C451.843506,155.966125 451.661072,156.129120 451.110962,156.290802 
	C446.268707,153.454041 441.443665,151.048141 438.557709,145.938828 
	C442.940582,142.924347 445.586395,146.000763 448.677673,148.756683 
	C451.008942,153.457306 455.431183,153.054184 459.572174,154.023697 
	C460.373566,154.038361 460.780182,154.063538 461.489807,154.105133 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M507.193146,302.618073 
	C507.310577,310.003784 507.581573,317.052155 507.890747,324.556549 
	C509.933746,327.220612 509.767456,329.974365 509.412628,332.543945 
	C508.641876,338.125122 508.678925,343.740540 508.234497,349.784821 
	C507.772583,351.984680 507.337128,353.721558 505.806396,355.422302 
	C503.616974,356.502991 501.744720,357.166473 499.306274,356.524323 
	C496.607941,350.145630 496.999329,344.202271 500.847595,338.288391 
	C501.421204,337.523071 501.856781,337.123260 502.378418,336.818542 
	C502.220459,336.582672 502.064606,336.676453 501.632385,337.286560 
	C501.124451,337.501068 500.894958,337.528839 500.319031,337.465820 
	C499.774658,337.230225 499.576721,337.085480 499.141541,336.650757 
	C496.796753,332.516327 498.051422,328.270447 497.362946,323.875122 
	C497.050018,322.223145 497.313049,321.001892 497.851898,319.457001 
	C498.196167,318.444397 498.513031,317.802246 498.584839,316.735107 
	C498.144073,312.481171 497.345795,308.613861 498.308594,304.637512 
	C498.833954,302.467773 498.085999,300.408234 496.450195,298.366638 
	C496.099457,297.885162 495.969696,297.684235 495.724487,296.786194 
	C495.774719,295.647522 496.001587,295.241211 496.548645,294.646118 
	C497.744598,293.663147 498.823212,293.080872 499.724609,292.265991 
	C500.217377,291.820526 500.260010,291.300598 499.866302,291.838165 
	C499.860229,291.846497 499.625244,291.687164 499.235291,291.455200 
	C496.329529,288.834381 496.454102,285.111115 494.689880,281.861450 
	C494.267700,280.893524 494.139099,280.211334 494.195374,279.162109 
	C494.330841,278.612244 494.416534,278.403442 494.722046,277.943604 
	C495.323029,277.487091 495.722107,277.330353 496.432098,277.192566 
	C497.736023,275.182007 494.308105,274.679047 495.295258,272.380249 
	C495.822205,269.278870 494.342407,266.902222 493.925415,264.335083 
	C493.531006,261.907074 493.239960,259.423309 495.013000,256.937592 
	C496.940918,256.283844 497.601532,257.404144 498.425964,258.860168 
	C498.895599,259.849762 499.150696,260.529297 499.571625,261.524536 
	C500.043060,262.733124 500.295715,263.641846 500.735779,264.864990 
	C500.914276,265.436035 500.976410,265.668518 501.107147,266.257263 
	C501.358856,268.558411 501.686707,270.476471 502.317383,272.721680 
	C503.797729,279.107422 505.185883,285.127258 506.207214,291.611267 
	C506.365906,292.729431 506.406189,293.481567 506.745941,294.558716 
	C506.904938,295.158508 506.962158,295.400085 507.083313,296.008453 
	C507.240417,298.342834 507.572876,300.302368 507.193146,302.618073 
z"/>
<path fill="#0A5C8E" opacity="1.000000" stroke="none" 
	d="
M506.920166,351.186646 
	C507.032257,342.616394 507.426849,334.270660 507.875183,325.468719 
	C512.082581,325.714050 515.586060,323.251160 519.480835,322.570709 
	C528.233582,321.041565 528.991272,321.415161 528.996033,330.196533 
	C528.996765,331.526733 529.010437,332.856903 529.052368,334.661591 
	C529.017639,338.184448 529.365784,341.275726 528.067505,344.604004 
	C527.231140,345.663055 526.325500,345.648956 525.756897,344.979858 
	C522.068420,340.639496 518.835938,343.154053 515.300476,345.341980 
	C512.399353,347.137360 511.318695,351.310181 506.920166,351.186646 
z"/>
<path fill="#2EA1DD" opacity="1.000000" stroke="none" 
	d="
M507.436279,302.984985 
	C506.061401,301.024170 505.932281,298.944580 506.019135,296.438782 
	C507.161163,295.599060 507.688812,296.479553 508.607300,297.248779 
	C510.468079,299.080414 512.513123,299.977814 514.832031,301.075378 
	C516.342957,301.882294 517.596436,302.457031 518.952148,303.526764 
	C519.263489,304.001190 519.332825,304.223541 519.205444,304.734680 
	C515.094971,305.402740 511.575684,303.587524 507.436279,302.984985 
z"/>
<path fill="#1D98D1" opacity="1.000000" stroke="none" 
	d="
M519.464355,305.031311 
	C519.008789,305.023438 519.000916,304.539246 518.991943,304.297302 
	C519.606262,303.181427 520.571167,302.761383 521.525208,302.822998 
	C527.149048,303.186188 528.922363,299.893738 529.301270,294.678711 
	C529.676819,294.160797 529.872620,293.988678 530.442749,293.929535 
	C530.924255,294.757019 531.031372,295.471497 531.250977,296.529419 
	C531.354980,297.270966 531.546509,297.507202 532.075867,297.788391 
	C532.161987,299.035767 532.110168,300.076263 532.076904,301.509521 
	C531.301880,305.072296 528.689331,304.937622 526.272827,305.034058 
	C524.158508,305.118408 522.037781,305.043671 519.464355,305.031311 
z"/>
<path fill="#607584" opacity="1.000000" stroke="none" 
	d="
M400.760498,122.731873 
	C401.455078,122.979652 401.892426,123.012405 402.658508,123.027725 
	C403.883118,123.984962 403.470612,124.897644 402.572144,126.054527 
	C399.154388,127.328056 396.606476,125.512314 393.564331,124.404190 
	C392.453827,123.781898 391.664276,123.308723 390.464600,122.887680 
	C389.931702,122.666565 389.721527,122.568245 389.207123,122.297928 
	C386.488403,119.888527 382.423218,120.445793 380.631866,116.849716 
	C382.174164,114.491211 383.809387,115.577934 385.767639,116.456589 
	C388.126984,116.751053 390.146820,116.867485 392.595093,116.895226 
	C393.428162,116.900970 393.832794,116.995415 394.549469,117.110123 
	C396.754456,118.912941 397.744751,121.640930 400.760498,122.731873 
z"/>
<path fill="#2A3743" opacity="1.000000" stroke="none" 
	d="
M401.014191,122.585236 
	C396.913635,123.746246 395.498047,121.296844 394.874695,117.502281 
	C395.962402,117.064095 397.063263,116.997787 398.576294,116.923462 
	C399.662537,118.684807 400.336609,120.454185 401.014191,122.585236 
z"/>
<path fill="#248BBE" opacity="1.000000" stroke="none" 
	d="
M501.487732,273.191528 
	C500.680328,270.966309 500.167755,268.946869 499.640503,266.532288 
	C500.174713,265.770782 500.653839,265.295013 501.300964,265.083099 
	C503.301392,264.428070 505.306305,265.003784 507.309296,265.057648 
	C505.310150,262.870056 507.631775,261.586151 508.504456,259.660950 
	C508.731018,259.147888 508.826172,258.945557 509.101593,258.465912 
	C509.427979,258.028503 509.574127,257.868408 509.977936,257.519409 
	C510.936157,256.913574 511.671387,256.542572 512.345825,255.606781 
	C513.199280,254.259567 513.916504,253.200333 515.270752,252.282776 
	C516.882996,251.564468 518.423706,251.555481 519.906860,250.677963 
	C520.211731,250.769958 520.195923,250.885117 520.137817,250.882660 
	C520.390930,251.410599 520.467651,252.026855 520.941772,252.773056 
	C521.585938,253.575348 521.992432,254.189194 522.624390,254.975952 
	C523.070862,255.246399 523.291809,255.343918 523.313293,255.743866 
	C524.105713,260.394806 525.097656,264.743317 526.094971,269.488678 
	C525.237427,273.586945 521.920776,271.963898 519.372070,272.827698 
	C517.410339,272.807617 515.826416,271.925964 513.923096,272.969849 
	C512.981750,273.451477 512.315369,273.660583 511.250793,273.715820 
	C508.350708,273.169342 505.783447,273.204865 502.852295,273.459412 
	C502.257721,273.460266 502.020111,273.428772 501.487732,273.191528 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M513.800659,235.874573 
	C514.160461,235.865784 514.539062,236.015259 514.732056,236.079132 
	C515.562500,238.959579 514.283936,240.820786 512.048096,242.377426 
	C509.353119,244.253738 506.781952,246.307800 503.761536,248.826691 
	C503.139862,249.408096 502.913849,249.447739 502.349182,249.412155 
	C501.354950,249.024368 500.849304,248.557220 500.449768,247.550186 
	C502.700104,241.086990 507.717255,238.077271 513.800659,235.874573 
z"/>
<path fill="#54BDE4" opacity="1.000000" stroke="none" 
	d="
M516.245239,252.619705 
	C514.753662,253.472855 514.265869,254.687393 513.303467,255.876709 
	C512.469849,256.538666 511.931976,257.064026 511.206970,257.801392 
	C511.013794,258.006836 510.539307,258.046967 510.301575,258.059937 
	C509.013641,258.937836 507.862915,259.136780 506.304443,258.382172 
	C505.526886,257.559418 505.426331,256.884125 505.851013,255.861038 
	C506.233398,255.442139 506.424316,255.313354 506.959534,255.213287 
	C508.945770,253.559082 510.587738,251.876144 512.515869,250.046860 
	C515.072510,249.006760 516.187256,249.927124 516.245239,252.619705 
z"/>
<path fill="#42A7D0" opacity="1.000000" stroke="none" 
	d="
M516.312256,252.933640 
	C515.914734,251.426407 515.187439,250.318466 513.157959,249.954468 
	C514.166565,247.841980 515.531128,245.783432 516.962280,243.394196 
	C517.215149,242.936096 517.401550,242.808716 517.743652,242.982025 
	C518.660461,245.540070 519.421570,247.797424 520.197144,250.412354 
	C519.219849,251.853561 518.083801,252.683487 516.312256,252.933640 
z"/>
<path fill="#16202D" opacity="1.000000" stroke="none" 
	d="
M503.878662,248.921417 
	C507.441193,249.271561 506.887909,252.073486 507.203979,254.832748 
	C507.303772,255.241989 507.263000,255.220474 507.246216,255.204773 
	C506.411926,255.444855 505.609039,255.784164 504.319702,255.462036 
	C503.259186,254.659882 502.987457,253.842667 502.789856,252.538513 
	C502.769836,251.218323 502.959808,250.381195 503.707092,249.279114 
	C503.955811,248.925919 503.897827,248.945206 503.878662,248.921417 
z"/>
<path fill="#42A7D0" opacity="1.000000" stroke="none" 
	d="
M521.136841,252.648972 
	C520.818665,252.482620 520.457764,252.003738 520.088379,251.202545 
	C520.417908,251.365631 520.756042,251.851028 521.136841,252.648972 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M527.023804,256.754211 
	C526.579773,256.864044 525.937927,256.711029 525.137512,256.264160 
	C525.594604,256.144012 526.210266,256.317719 527.023804,256.754211 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M523.433838,256.043518 
	C523.113770,256.046295 522.934448,255.611267 522.892151,255.380066 
	C523.449036,255.267548 524.048157,255.386215 524.841064,255.755051 
	C524.607910,256.017090 524.180908,256.028931 523.433838,256.043518 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M516.917480,241.881805 
	C516.816772,241.904648 516.717346,241.727890 516.617859,241.551147 
	C516.718140,241.594833 516.818420,241.638535 516.917480,241.881805 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M517.849731,243.012695 
	C517.899414,243.282730 517.467712,243.158173 517.248291,243.110825 
	C517.028809,243.063477 516.976501,242.571411 516.946411,242.326401 
	C516.916260,242.081390 516.986389,242.016586 517.023926,241.986603 
	C517.307617,242.218643 517.553833,242.480667 517.849731,243.012695 
z"/>
<path fill="#131418" opacity="1.000000" stroke="none" 
	d="
M346.001831,98.998642 
	C350.900879,99.464928 355.702759,100.263336 360.150848,102.564377 
	C365.223724,105.188644 370.631012,105.821739 376.631927,105.018433 
	C377.443878,105.625854 377.326691,106.263405 377.011139,107.208328 
	C376.765442,107.697510 376.648743,107.883682 376.315308,108.317581 
	C375.781372,108.871574 375.458038,109.171135 374.878998,109.690201 
	C374.450073,110.056770 374.269714,110.196144 373.787109,110.503647 
	C373.044464,110.841011 372.590485,110.959686 371.764709,111.068542 
	C370.661041,111.101326 369.935638,110.977898 368.857269,110.684792 
	C364.566345,110.115051 360.661774,109.733788 357.183014,107.442039 
	C355.275421,106.185341 352.985504,107.068291 350.854492,107.179604 
	C348.080475,107.324493 345.413757,107.192207 344.754333,103.220367 
	C344.673676,101.693932 344.855255,100.624908 345.742737,99.336136 
	C345.995117,99.004578 346.000000,99.000336 346.001831,98.998642 
z"/>
<path fill="#32627C" opacity="1.000000" stroke="none" 
	d="
M376.339569,108.070465 
	C375.487213,106.927742 376.291321,106.330704 376.889282,105.323456 
	C377.188293,105.014046 377.354919,105.005852 377.983154,105.291214 
	C378.655579,106.999008 377.974609,107.806107 376.339569,108.070465 
z"/>
<path fill="#32627C" opacity="1.000000" stroke="none" 
	d="
M378.098511,104.401512 
	C378.417236,104.274300 378.631287,104.425285 378.894562,104.824280 
	C378.821014,105.129410 378.645233,105.261673 378.218384,105.179855 
	C377.967316,104.965775 377.994232,104.993958 378.007843,105.008423 
	C378.021454,105.022896 378.046783,104.604576 378.098511,104.401512 
z"/>
<path fill="#197AAB" opacity="1.000000" stroke="none" 
	d="
M517.594116,271.776733 
	C520.512573,271.478546 523.045349,270.971283 525.839233,270.174774 
	C526.979858,273.349823 527.859375,276.814117 528.906494,280.626099 
	C529.406738,281.386688 529.581604,281.858154 529.487854,282.757202 
	C529.376709,283.126343 529.147095,283.215942 529.079285,283.113037 
	C528.115051,284.099823 527.780579,285.621979 526.118164,286.531433 
	C518.296448,287.577728 514.102417,293.571716 508.394775,297.827271 
	C507.545380,297.379944 507.038452,296.863434 506.299957,296.194336 
	C505.984589,295.894165 505.900787,295.746582 505.789948,295.345825 
	C505.900848,294.511963 505.858856,293.958618 505.338562,293.222717 
	C503.845367,286.585938 502.526672,280.177979 501.200470,273.377930 
	C501.192932,272.985779 501.606293,272.981506 501.812988,272.982361 
	C504.702606,272.053650 507.464386,272.681702 510.594971,272.784973 
	C511.549591,272.852661 512.097961,272.705292 512.820801,272.326630 
	C514.289185,271.037018 515.795410,271.673981 517.594116,271.776733 
z"/>
<path fill="#022D4E" opacity="1.000000" stroke="none" 
	d="
M529.662842,283.055115 
	C529.267883,282.652161 529.159058,282.178009 529.062256,281.338806 
	C529.809753,280.969360 530.545349,280.964905 531.648560,280.982788 
	C531.649597,282.001587 530.884705,282.581940 529.662842,283.055115 
z"/>
<path fill="#022D4E" opacity="1.000000" stroke="none" 
	d="
M533.705200,280.004517 
	C533.544800,280.340515 533.076233,280.673859 532.302551,281.011841 
	C532.463989,280.678253 532.930542,280.340057 533.705200,280.004517 
z"/>
<path fill="#022D4E" opacity="1.000000" stroke="none" 
	d="
M535.705505,279.003815 
	C535.546631,279.341858 535.079346,279.677124 534.306519,280.013855 
	C534.466309,279.677185 534.931702,279.339081 535.705505,279.003815 
z"/>
<path fill="#0E0F13" opacity="1.000000" stroke="none" 
	d="
M290.861328,89.348557 
	C291.581787,88.868202 292.126465,88.685371 292.847961,88.270111 
	C293.191498,88.030899 293.358246,88.024109 293.775604,88.019836 
	C295.153687,89.416962 296.743317,89.029816 298.164825,88.971077 
	C301.623810,88.828156 305.266937,87.162804 308.175140,90.701569 
	C308.520538,91.121864 310.091339,90.799431 310.967896,90.477554 
	C318.764435,87.614609 326.494598,90.109421 334.625854,90.840652 
	C334.420898,92.267349 332.430695,91.715561 332.034302,93.600662 
	C327.216614,97.488693 321.540924,98.966675 315.674469,100.859276 
	C310.213593,98.449898 309.602356,97.089104 312.418121,93.527122 
	C309.124023,95.109909 306.584534,96.333229 303.017944,93.818741 
	C299.755798,91.518867 297.052582,95.061333 294.731171,97.429550 
	C290.471649,101.774979 286.213928,102.174538 282.018524,98.628395 
	C281.103333,97.854828 280.347717,96.989883 280.801636,95.386131 
	C281.512115,94.789841 281.997803,94.462273 282.767578,94.055428 
	C283.350586,93.857018 283.603424,93.674179 283.942383,93.231346 
	C284.210785,92.867210 284.346985,92.699348 284.703430,92.293518 
	C284.923676,92.055542 284.954559,91.991936 284.976196,91.963577 
	C287.286224,92.147385 289.132019,91.259789 290.861328,89.348557 
z"/>
<path fill="#1174A3" opacity="1.000000" stroke="none" 
	d="
M508.193817,298.209106 
	C512.680664,292.328125 517.082520,286.432526 525.675049,285.973083 
	C526.878479,285.461609 527.701904,285.190857 529.015625,285.756531 
	C529.917603,288.413361 530.432617,290.846832 530.882446,293.661377 
	C530.817139,294.042511 530.456116,294.043579 530.275635,294.039185 
	C524.263306,294.800140 519.094849,296.812469 515.217468,301.986389 
	C512.455811,301.453094 510.144684,300.439972 508.193817,298.209106 
z"/>
<path fill="#54BDE4" opacity="1.000000" stroke="none" 
	d="
M529.363647,285.607025 
	C528.574707,285.978790 527.746765,285.977692 526.506226,285.968628 
	C526.865356,285.028870 527.637207,284.097107 528.710205,283.087708 
	C529.115906,283.751465 529.220337,284.492828 529.363647,285.607025 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M532.534363,298.028290 
	C531.924500,297.801056 531.635254,297.606812 531.354736,297.142700 
	C532.338196,296.897736 533.312866,296.922668 534.654175,296.967865 
	C534.563293,297.879486 533.742126,298.036957 532.534363,298.028290 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M280.804901,95.091370 
	C284.094482,100.628418 289.206635,101.535683 293.247101,97.221672 
	C295.145264,95.195000 296.648193,92.621452 299.631592,92.085571 
	C301.631439,91.726357 304.171204,89.954224 305.175995,93.723877 
	C305.649231,95.499146 307.049805,94.281006 308.064545,94.100433 
	C310.207306,93.719154 312.129181,92.200539 315.842896,92.836441 
	C308.921417,95.128281 311.408173,97.428764 314.755798,99.880310 
	C314.653351,102.977928 311.842712,102.739616 310.012573,103.723549 
	C308.331207,104.627457 306.354797,104.948540 304.465332,106.327820 
	C303.452576,106.813766 302.730713,106.902412 301.640472,106.700470 
	C299.909180,105.814827 299.531158,104.399696 299.040985,103.041557 
	C297.967285,100.066795 296.868317,101.802368 295.580750,103.314789 
	C295.238922,103.764145 295.096222,103.939056 294.720673,104.358032 
	C294.318176,104.748245 294.148560,104.894394 293.703064,105.228729 
	C293.229889,105.516716 293.032562,105.616524 292.527588,105.834229 
	C291.599518,106.157402 290.968567,106.327858 290.028290,106.604309 
	C289.278687,106.752136 288.843170,106.772690 288.081055,106.713043 
	C286.391418,106.236809 285.209625,106.647079 283.790253,107.595642 
	C282.744080,107.910110 282.023987,107.886497 280.948303,107.586266 
	C280.161285,107.212547 279.760651,106.880630 279.301483,106.728104 
	C273.762756,104.888351 273.760406,104.895439 274.802338,98.811760 
	C275.230652,97.445122 275.783508,96.624886 277.085114,96.000610 
	C278.099365,95.564537 278.830963,95.534012 279.840271,95.209976 
	C280.139984,95.015266 280.583344,95.065315 280.804901,95.091370 
z"/>
<path fill="#272930" opacity="1.000000" stroke="none" 
	d="
M275.613770,97.709686 
	C274.935608,102.224449 275.408112,105.628479 280.936890,106.437439 
	C279.469910,108.820549 277.265198,108.268028 275.231781,108.073036 
	C273.636871,107.920105 272.084106,107.245132 270.122864,107.955994 
	C268.908661,108.278450 267.965729,108.302498 266.892700,109.054512 
	C266.401337,109.403046 266.196991,109.538002 265.661194,109.846939 
	C259.324921,111.742195 258.479980,111.397110 257.132080,106.363785 
	C255.968903,103.687645 254.894455,101.365265 258.703949,100.016281 
	C259.558380,100.235054 260.048981,100.504013 260.816711,100.816879 
	C265.739899,99.406815 270.409088,98.049995 275.613770,97.709686 
z"/>
<path fill="#2478A2" opacity="1.000000" stroke="none" 
	d="
M276.118103,97.658691 
	C271.346405,99.228714 266.891876,101.268456 261.511322,100.899277 
	C263.656586,99.328041 265.086487,95.878723 268.824188,96.582504 
	C268.777618,97.034264 268.712494,97.205849 268.905090,97.280594 
	C270.852570,96.809319 272.542358,96.434875 274.600769,96.008575 
	C275.790955,95.380150 276.712097,95.530441 277.999817,95.850250 
	C277.677795,96.534431 276.977264,96.961914 276.118103,97.658691 
z"/>
<path fill="#050E18" opacity="1.000000" stroke="none" 
	d="
M266.353821,93.019241 
	C266.905273,89.785599 268.860962,87.623581 272.674652,87.026093 
	C271.367584,89.490555 269.449280,91.683197 266.353821,93.019241 
z"/>
<path fill="#050E18" opacity="1.000000" stroke="none" 
	d="
M273.378052,87.023911 
	C273.559021,84.062851 275.344513,82.402626 278.714355,82.031738 
	C277.683838,84.116661 276.047882,85.933136 273.378052,87.023911 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M276.699554,90.179062 
	C276.989349,90.771027 276.992706,91.493355 276.987610,92.576050 
	C275.977081,93.414734 275.077942,94.368462 273.741547,93.607651 
	C274.005463,91.989258 275.474609,91.357750 276.699554,90.179062 
z"/>
<path fill="#1B2027" opacity="1.000000" stroke="none" 
	d="
M261.638458,94.059799 
	C262.210327,94.336632 262.440338,94.636551 262.907715,95.103706 
	C262.000702,95.844620 260.856323,96.418289 259.387085,97.033447 
	C259.030975,95.498055 259.678223,94.427879 261.638458,94.059799 
z"/>
<path fill="#12628E" opacity="1.000000" stroke="none" 
	d="
M278.646973,96.072510 
	C277.525055,96.070198 276.671783,96.033447 275.393921,95.976707 
	C276.190308,94.566376 277.831085,95.083229 279.739319,95.005135 
	C279.731873,95.356209 279.323730,95.697144 278.646973,96.072510 
z"/>
<path fill="#69E3FB" opacity="1.000000" stroke="none" 
	d="
M499.135498,206.705078 
	C499.347626,206.964355 499.293610,207.378418 499.276703,207.586517 
	C496.426880,210.712280 492.975708,212.675339 488.987671,214.392578 
	C488.346375,214.749832 488.016479,214.999725 487.503479,215.494812 
	C487.020874,215.975571 486.748444,216.246017 486.284912,216.712860 
	C485.825104,217.144409 485.525513,217.325867 484.936035,217.476135 
	C484.662903,217.681763 484.638428,217.847656 484.711304,217.780319 
	C485.155792,217.492020 485.474640,217.363358 485.977753,216.999069 
	C486.450897,216.556305 486.716370,216.290405 487.189209,215.813812 
	C487.685272,215.315796 487.990997,215.047775 488.592987,214.645569 
	C489.517792,214.249832 490.154968,214.264481 491.046661,214.752945 
	C492.174774,216.969894 490.684174,218.328445 489.980194,219.906357 
	C489.079681,221.924850 487.420074,223.802155 488.891846,226.562836 
	C489.416901,228.951141 488.279572,229.850449 486.128265,230.022766 
	C485.582214,229.675858 485.898834,229.242157 485.440552,229.456055 
	C485.204529,229.934036 485.029663,230.079880 484.511963,230.188904 
	C480.077759,224.798492 476.685791,219.006256 473.413391,212.752563 
	C473.315765,211.127686 473.945129,210.164261 475.078705,209.099854 
	C475.552185,208.794907 475.756073,208.701462 476.290283,208.580292 
	C477.032166,208.651459 477.409729,208.820847 477.927185,209.307220 
	C478.266876,209.836533 478.363922,210.162613 478.321167,210.719482 
	C478.290802,210.924240 478.730011,211.007828 478.942322,210.862335 
	C484.531219,208.290283 489.202209,204.325012 495.575317,203.247879 
	C497.664673,203.565353 497.824280,205.435638 499.135498,206.705078 
z"/>
<path fill="#62E4F9" opacity="1.000000" stroke="none" 
	d="
M478.415405,210.164520 
	C477.801147,209.846802 477.522766,209.655380 477.119476,209.240219 
	C477.578491,205.401917 478.686371,202.003296 481.343262,198.884918 
	C484.227448,197.396347 486.775818,196.016251 489.878845,195.029877 
	C490.239502,194.994858 490.625671,194.999924 490.818207,195.019104 
	C491.502045,195.912445 491.993347,196.786606 492.754761,197.797821 
	C493.316315,198.451294 493.607758,198.967728 493.871490,199.783325 
	C489.726349,204.835709 484.466095,207.899261 478.415405,210.164520 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M477.956390,210.288513 
	C483.129517,206.802551 488.179535,203.566864 493.536682,200.206848 
	C494.369263,200.971466 494.894745,201.860428 495.665344,202.952209 
	C490.006561,206.370697 484.280182,209.943146 477.387634,212.027939 
	C477.217163,211.461044 477.525238,210.999908 477.956390,210.288513 
z"/>
<path fill="#607584" opacity="1.000000" stroke="none" 
	d="
M383.557953,108.724640 
	C384.211792,109.432571 384.532654,109.922913 384.887848,110.718681 
	C384.922180,111.024109 384.782288,111.314720 384.745239,111.471672 
	C383.328552,114.213379 379.769226,114.432388 378.339539,117.511215 
	C376.153931,118.942085 374.695618,118.916084 374.277161,115.918839 
	C374.632812,114.359550 375.560852,113.429512 375.809021,111.815643 
	C376.042633,110.961716 376.254181,110.500931 376.801788,109.788391 
	C379.023529,108.548004 381.057434,108.117287 383.557953,108.724640 
z"/>
<path fill="#27303B" opacity="1.000000" stroke="none" 
	d="
M378.397034,117.015488 
	C378.656738,113.313217 381.529877,112.751427 384.367065,111.684341 
	C385.112122,113.067184 385.516052,114.505753 386.013580,116.289467 
	C384.556183,116.593590 383.005219,116.552551 381.227081,116.739029 
	C380.310272,117.650085 379.516571,117.699448 378.397034,117.015488 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M345.605255,99.010406 
	C345.996979,100.069710 345.998840,101.134850 346.000977,102.599503 
	C344.234314,105.938164 342.108154,108.428230 338.235382,107.884628 
	C334.290436,107.330894 333.083191,104.226097 332.275757,100.915154 
	C331.952637,99.590187 331.454712,98.430542 330.074402,97.321732 
	C329.885651,94.791435 331.684021,94.905769 333.501526,94.755356 
	C334.385803,94.703461 334.921661,94.470200 335.730927,94.129242 
	C337.264923,99.024017 340.065125,101.187073 345.605255,99.010406 
z"/>
<path fill="#37AFE9" opacity="1.000000" stroke="none" 
	d="
M514.077271,235.538437 
	C509.875031,239.710632 503.624023,241.315796 501.150574,247.596130 
	C499.766876,249.982712 497.909149,251.436600 495.359192,252.546341 
	C494.758209,252.544174 494.519409,252.495789 493.980469,252.238373 
	C493.263855,251.401367 493.125519,250.701385 493.192505,249.609451 
	C493.444427,248.496429 493.851013,247.817856 494.137451,247.093353 
	C494.880707,245.213455 493.452972,246.704971 492.780334,246.430695 
	C490.934357,245.642319 490.363037,244.369095 490.493286,242.399506 
	C497.107697,237.691162 502.804108,232.040726 510.847290,229.778229 
	C512.119080,231.697021 513.056580,233.454056 514.077271,235.538437 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M511.133667,229.594818 
	C504.067535,232.983047 498.736237,238.928116 491.252808,241.994659 
	C488.635345,242.024002 488.554443,240.167282 487.994751,238.346405 
	C487.931641,237.574387 487.941559,237.137436 488.039093,236.394791 
	C488.151978,235.895874 488.213837,235.703705 488.419891,235.252167 
	C488.823242,234.712662 489.109680,234.464844 489.655731,234.116638 
	C490.023315,233.878571 490.168030,233.784454 490.520660,233.544449 
	C490.861694,233.297440 490.994812,233.196335 491.325806,232.944443 
	C491.523712,232.793640 491.930847,232.512772 492.142334,232.385620 
	C492.353790,232.258453 492.780609,232.010941 492.992157,231.880417 
	C493.341675,231.654388 493.479614,231.558899 493.820374,231.306595 
	C494.158936,231.040451 494.294617,230.931107 494.640564,230.658112 
	C494.997894,230.389999 495.144928,230.285538 495.518127,230.028198 
	C496.049133,229.669388 496.352051,229.460602 496.876099,229.075226 
	C497.250671,228.786118 497.402222,228.670853 497.782806,228.382599 
	C498.472168,227.849457 498.918091,227.472794 499.556854,226.848969 
	C499.954437,226.520706 500.127106,226.402847 500.581848,226.139648 
	C503.173462,225.494583 504.839325,223.269348 507.698395,223.738892 
	C508.423737,224.534821 508.887787,225.134171 509.602051,225.881531 
	C510.263428,227.102905 510.674591,228.176285 511.133667,229.594818 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M493.481323,194.942245 
	C493.044037,194.205811 493.018402,193.478546 492.989380,192.387024 
	C492.660950,190.593689 492.335876,189.164642 492.007141,187.364929 
	C495.697632,187.973877 496.459747,191.370850 497.983032,194.520844 
	C496.654602,194.889313 495.273804,194.920380 493.481323,194.942245 
z"/>
<path fill="#51CAF4" opacity="1.000000" stroke="none" 
	d="
M485.616669,228.865570 
	C487.574768,230.144226 487.899994,228.283325 489.010010,227.081223 
	C489.233551,226.587372 489.592651,226.247284 489.786987,226.098587 
	C489.981354,225.949890 490.374207,225.667633 490.566345,225.524933 
	C490.758514,225.382233 491.126404,225.081635 491.472504,224.759979 
	C491.818604,224.438324 492.152679,224.104797 492.486755,223.770370 
	C492.820831,223.435944 493.165466,223.111313 493.345490,222.957764 
	C493.525513,222.804199 493.908142,222.527893 494.109009,222.406250 
	C494.309906,222.284622 494.716187,222.054520 494.916931,221.936707 
	C495.117645,221.818909 495.507629,221.565491 495.694519,221.425659 
	C495.881378,221.285843 496.238281,220.978745 496.582764,220.646835 
	C496.927216,220.314926 497.277466,219.979019 497.458069,219.814301 
	C497.638672,219.649597 498.008148,219.326065 498.191376,219.160278 
	C498.374603,218.994507 498.729034,218.644424 498.900024,218.458633 
	C499.183167,218.143768 499.295258,218.014709 499.578186,217.688324 
	C499.868134,217.358932 499.987213,217.226883 500.493286,216.702209 
	C501.024445,216.185455 501.168610,216.061310 501.553467,215.771698 
	C501.975372,215.524796 502.156555,215.443344 502.632080,215.293152 
	C503.337189,215.190048 503.744202,215.218063 504.439270,215.412369 
	C505.257843,215.908524 505.579956,216.436951 505.846985,217.343338 
	C505.340942,219.163742 506.726746,220.047165 507.080017,221.601639 
	C505.066925,223.692200 502.886139,225.253311 500.278687,226.794098 
	C500.019287,227.010178 500.001221,227.002396 500.004761,227.011658 
	C499.460815,227.534653 498.927277,228.062500 498.211670,228.806396 
	C498.017944,229.010635 498.002258,229.001709 498.003967,229.010330 
	C497.219849,229.657104 496.165924,229.851883 495.223328,230.794312 
	C495.015076,231.013382 495.001221,231.000000 495.005676,231.006927 
	C494.770081,231.219513 494.541199,231.436905 494.164001,231.841156 
	C494.004578,232.016296 494.000000,231.999313 494.007385,232.004242 
	C493.570526,232.417160 492.984589,232.470474 492.228577,232.824982 
	C492.013336,233.013107 492.000000,233.000000 492.004517,233.007660 
	C491.769836,233.219742 491.541901,233.436066 491.167206,233.839172 
	C491.009125,234.014084 491.000000,234.000000 491.006012,234.006348 
	C490.569611,234.416992 489.988190,234.470566 489.236206,234.819580 
	C489.022858,235.007111 489.004272,235.005707 489.005157,235.015152 
	C488.788818,235.167511 488.571625,235.310410 487.963928,235.480652 
	C485.297638,234.667694 484.288330,233.036301 484.758667,230.311722 
	C484.986084,229.826218 484.979309,229.655960 484.998840,229.231445 
	C485.025177,228.977188 485.432922,228.702103 485.616669,228.865570 
z"/>
<path fill="#8FD2E7" opacity="1.000000" stroke="none" 
	d="
M500.389038,227.060867 
	C501.596680,224.651077 503.231842,222.365021 506.739502,221.956665 
	C507.382690,222.410110 507.659943,222.890213 507.948456,223.652893 
	C505.278229,224.356750 503.649109,227.163879 500.389038,227.060867 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M505.926453,217.234344 
	C505.425903,217.215851 504.968964,216.775818 504.240356,216.139435 
	C503.834381,215.806274 503.699982,215.669449 503.493805,215.253845 
	C503.464417,214.787888 503.506775,214.600723 503.756226,214.213623 
	C504.850922,214.130005 505.723358,214.269577 506.061920,215.658203 
	C506.077789,216.258133 506.023895,216.535477 505.926453,217.234344 
z"/>
<path fill="#55CFFB" opacity="1.000000" stroke="none" 
	d="
M503.690369,213.840820 
	C503.963318,214.013687 503.849396,214.482239 503.786957,214.715103 
	C503.411194,215.301193 503.020996,215.511948 502.282104,215.790176 
	C502.010529,216.000702 502.001221,216.001831 501.999512,216.006027 
	C501.767761,216.220657 501.544189,216.437775 501.167023,216.831940 
	C501.006927,217.002289 501.000000,217.000000 501.001099,217.003448 
	C500.769714,217.218811 500.544037,217.437729 500.163574,217.835419 
	C500.001984,218.007202 500.000000,217.999390 500.003845,218.001526 
	C499.464539,218.532791 498.923431,219.063934 498.194580,219.809555 
	C497.995056,220.012115 497.998627,219.997772 498.005554,219.995178 
	C497.776611,220.211700 497.546295,220.436493 497.155212,220.841888 
	C496.988892,221.016830 496.997559,220.997772 497.007080,220.993347 
	C496.778656,221.209732 496.546326,221.436371 496.151947,221.845245 
	C495.984192,222.021652 495.998322,221.998871 496.010986,221.994324 
	C495.578918,222.412796 494.984222,222.470474 494.213074,222.827209 
	C493.990112,223.013092 493.997559,222.996796 494.006165,222.994324 
	C493.777802,223.210617 493.546875,223.435532 493.155640,223.842102 
	C492.989319,224.017593 492.994781,224.008896 492.988708,224.017715 
	C492.819977,224.182297 492.657257,224.338043 492.260773,224.737640 
	C492.026978,224.981522 492.006683,225.006775 491.994080,225.016937 
	C491.818512,225.183304 491.655548,225.339523 491.258270,225.740158 
	C491.023926,225.984558 491.005249,226.004974 490.993591,226.012405 
	C490.552307,226.431503 489.978241,226.471802 489.237030,226.804108 
	C489.028839,226.990555 489.010345,227.004456 489.003967,227.014984 
	C486.933655,227.059860 485.988007,226.628693 486.769379,224.104599 
	C487.723083,221.023941 489.666260,218.528412 490.942993,215.294647 
	C493.034210,211.854309 496.256134,210.335754 499.720520,208.860718 
	C501.167816,210.564407 502.292603,212.116180 503.690369,213.840820 
z"/>
<path fill="#AEF6FB" opacity="1.000000" stroke="none" 
	d="
M500.000092,208.760010 
	C497.223724,210.892776 494.404480,212.772934 491.275116,214.793732 
	C490.238892,214.984848 489.512726,215.035355 488.369659,215.023224 
	C491.081421,212.025604 494.567932,209.628464 498.889832,207.862823 
	C499.492249,208.032196 499.724731,208.269806 500.000092,208.760010 
z"/>
<path fill="#0E151F" opacity="1.000000" stroke="none" 
	d="
M383.918640,108.683792 
	C382.005646,109.423569 380.120331,109.904900 377.862244,110.372231 
	C377.028564,110.442574 376.571350,110.543472 375.770325,110.603981 
	C375.224579,110.422157 375.026215,110.297050 374.713776,109.839523 
	C374.741119,109.047264 375.007782,108.682999 375.698303,108.216888 
	C375.975494,108.003098 375.992126,107.977997 375.999939,107.964661 
	C377.317810,107.732162 377.751740,106.755157 377.991211,105.298180 
	C378.138367,104.988548 378.309387,105.011330 378.738586,105.015625 
	C380.074036,104.565117 380.755005,103.804115 380.974915,102.319366 
	C381.165985,101.997383 381.334442,101.997581 381.755615,101.999588 
	C383.541534,103.404434 382.907593,105.601295 383.950684,107.552673 
	C383.975067,108.079994 383.960663,108.252678 383.918640,108.683792 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M284.707245,92.143097 
	C284.865570,92.365166 284.711182,92.615349 284.267578,92.920570 
	C284.077087,92.696373 284.215820,92.428230 284.707245,92.143097 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M333.705383,94.699860 
	C332.646912,95.427399 331.443817,95.918076 330.036987,96.671440 
	C328.738068,97.329948 328.826721,98.081177 329.067047,99.216415 
	C327.682434,100.707542 326.006714,101.024017 324.214905,101.915604 
	C318.806854,104.475937 313.152161,104.822342 307.515320,106.681496 
	C306.614716,106.892021 306.087036,106.920036 305.162598,106.783340 
	C304.539459,106.549423 304.309113,106.409012 304.000977,105.871536 
	C306.935608,102.666222 311.151184,102.461014 314.820343,100.289528 
	C320.451477,98.028160 325.840485,96.026917 331.606750,93.973862 
	C332.509613,94.102371 333.035187,94.282692 333.705383,94.699860 
z"/>
<path fill="#050E18" opacity="1.000000" stroke="none" 
	d="
M226.256638,107.888390 
	C224.899704,107.664307 223.801834,107.334763 222.354568,107.000519 
	C224.587753,103.553040 229.295547,103.806984 232.647858,101.046867 
	C234.437668,105.200592 230.597733,105.122566 228.278107,106.750809 
	C227.502686,107.259995 227.009186,107.521461 226.256638,107.888390 
z"/>
<path fill="#11141B" opacity="1.000000" stroke="none" 
	d="
M228.389069,106.993561 
	C228.423279,104.103195 232.746292,104.841934 232.964722,101.362968 
	C233.448471,101.010422 233.892334,101.009651 234.669189,101.012558 
	C235.974350,102.124283 236.946518,103.232330 237.966751,104.659058 
	C234.710068,104.605141 231.936600,106.671951 228.389069,106.993561 
z"/>
<path fill="#11141B" opacity="1.000000" stroke="none" 
	d="
M245.182526,103.739502 
	C243.545288,104.312653 242.133057,104.649506 240.352478,104.981812 
	C241.038406,99.208916 241.969864,98.463554 245.934967,100.618866 
	C246.004181,100.966972 245.995010,101.015617 245.990250,101.039902 
	C245.230911,101.744026 245.596298,102.689270 245.182526,103.739502 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M475.342041,451.994080 
	C474.248413,450.377686 475.449036,449.155945 476.029999,447.418274 
	C476.663177,443.512756 478.794891,440.654144 480.364990,437.586182 
	C483.779297,430.914551 486.766632,424.093262 488.975677,416.543396 
	C489.580139,415.078857 490.137421,413.991943 490.604187,412.465942 
	C491.002991,410.833008 491.499268,409.666931 492.878235,408.619690 
	C493.885620,408.421539 493.039185,408.274567 493.702179,408.327209 
	C501.091736,408.914124 508.677917,410.075134 513.234497,401.441895 
	C514.147461,401.239410 514.670776,401.296936 515.507935,401.716797 
	C517.392090,406.754486 514.786682,409.738068 511.170074,412.665131 
	C510.996033,413.597931 510.802155,414.143707 510.253937,414.857178 
	C509.809448,415.536835 509.541687,415.981018 509.251526,416.689270 
	C508.567474,417.441132 507.905853,417.928925 507.112762,418.699432 
	C507.615204,419.982208 507.135498,420.755859 506.217896,421.738251 
	C505.964813,421.984589 505.995697,422.005280 505.990540,421.987610 
	C505.859314,422.125275 505.733246,422.280548 505.797241,422.667999 
	C505.999084,423.098206 506.010864,423.296265 506.045013,423.791656 
	C505.711212,424.790955 505.466217,425.987396 504.976898,426.097504 
	C503.760284,426.371063 504.094788,425.108490 503.949463,424.433594 
	C503.682159,423.192322 503.000763,422.401489 501.437836,422.015717 
	C500.531525,420.269165 501.991852,419.612579 502.870667,418.802673 
	C504.557281,417.248352 504.955933,415.664429 503.938751,413.544769 
	C503.433533,412.491821 502.868195,412.548920 502.031342,412.782043 
	C499.930206,413.367371 497.833984,413.944519 497.445709,416.595398 
	C497.253296,417.909119 497.634338,419.224548 497.251953,420.846741 
	C493.791382,420.568634 493.170929,423.240387 491.976685,425.660187 
	C491.808655,426.229004 491.716797,426.445007 491.331543,426.855713 
	C491.038147,427.050385 490.924438,427.497925 490.846832,427.715790 
	C490.256531,428.788666 489.743866,429.643646 489.121307,430.783234 
	C487.344330,433.733582 486.570007,436.809540 485.013763,439.897461 
	C484.521576,441.635193 483.412048,442.514099 482.215088,443.754730 
	C481.964935,443.994843 482.005768,444.006531 482.005280,443.985291 
	C481.748962,444.223389 481.504639,444.493164 481.100403,444.985809 
	C480.715088,445.539886 480.499481,445.880005 480.210876,446.398682 
	C478.653168,448.372772 477.168457,450.168274 475.342041,451.994080 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M506.369141,421.993225 
	C506.195190,421.173004 506.425629,420.361450 506.818665,419.266022 
	C508.996552,419.713257 511.690308,417.411194 513.103088,420.684265 
	C510.924500,421.329895 508.848999,421.665894 506.369141,421.993225 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M505.985962,422.667603 
	C505.559448,422.763306 505.217407,422.585510 505.787415,422.018372 
	C505.985352,421.969971 505.984619,422.435059 505.985962,422.667603 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M484.476440,440.259308 
	C485.150940,436.905762 485.556641,433.485321 488.661316,431.113220 
	C490.155792,432.633575 492.252045,431.342896 493.727417,432.739990 
	C492.443665,436.117035 487.650055,435.988800 486.364258,439.787476 
	C485.742371,440.359833 485.293701,440.499512 484.476440,440.259308 
z"/>
<path fill="#032B57" opacity="1.000000" stroke="none" 
	d="
M483.967896,440.333435 
	C484.600647,440.040070 485.033783,440.022949 485.794220,440.009430 
	C486.155212,440.188782 486.188904,440.364563 486.279785,440.803162 
	C485.103546,442.102570 483.870117,443.139160 482.300812,444.085297 
	C481.537933,442.318726 482.766418,441.524567 483.967896,440.333435 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M497.334747,421.406708 
	C494.531525,414.710876 496.677429,411.310303 503.512024,410.989319 
	C505.161804,410.911835 506.985718,415.209808 506.050659,417.055359 
	C505.039398,419.051239 503.285950,420.287445 501.262878,421.679321 
	C499.922638,421.858093 498.748383,421.756836 497.334747,421.406708 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M491.377747,427.171082 
	C491.077240,426.718353 491.224579,426.444641 491.690369,426.121094 
	C493.397858,426.583893 494.270203,424.002777 495.778503,425.207581 
	C496.070007,425.440369 495.995178,426.604004 495.678772,427.040741 
	C494.531372,428.624268 493.090210,427.911774 491.377747,427.171082 
z"/>
<path fill="#10B2F6" opacity="1.000000" stroke="none" 
	d="
M515.969238,401.612427 
	C515.326538,401.962799 514.817078,401.976654 513.925354,401.999573 
	C513.184143,396.428345 516.311462,391.764435 517.681885,386.248962 
	C518.593933,383.563477 519.472900,381.261566 520.017700,378.475281 
	C520.782837,376.065369 521.527344,374.030457 522.014648,371.545654 
	C522.338867,370.272797 522.601074,369.354736 522.767944,368.045441 
	C523.969177,363.239716 524.210571,358.541962 526.792664,354.222351 
	C527.444702,354.366241 527.774353,354.687347 528.312073,355.294006 
	C528.363159,356.805145 528.206116,358.030701 527.956665,359.621643 
	C527.768127,360.150146 527.672058,360.313202 527.666992,360.745117 
	C527.730042,363.488525 525.948547,365.664703 526.562378,368.575439 
	C523.921936,370.423126 524.793701,373.491730 524.546265,375.497772 
	C523.915588,380.611511 522.064758,385.288269 520.715027,390.546997 
	C519.118164,394.378632 517.610352,397.827271 515.969238,401.612427 
z"/>
<path fill="#1391DB" opacity="1.000000" stroke="none" 
	d="
M527.853394,360.764404 
	C527.634033,360.830627 527.487488,360.657135 527.399292,360.457855 
	C527.372131,360.396515 527.504150,360.264709 527.713745,360.076111 
	C527.892395,360.162964 527.920593,360.338867 527.853394,360.764404 
z"/>
<path fill="#065486" opacity="1.000000" stroke="none" 
	d="
M527.068237,353.631348 
	C526.069458,358.451569 525.023804,362.858002 523.890991,367.646362 
	C522.946106,368.909576 521.838867,369.345490 520.674377,369.280365 
	C514.577209,368.939392 508.956055,370.540131 503.192780,373.172974 
	C500.384338,368.627075 503.099152,364.368896 503.334503,359.619415 
	C503.666107,358.130585 503.809601,357.017090 504.778778,355.797913 
	C506.176788,354.396881 505.839630,352.853210 506.449554,351.246826 
	C510.480804,349.625092 512.113708,345.674042 515.475342,343.630768 
	C521.647278,339.879333 522.707153,339.793488 527.626831,344.940369 
	C527.661072,347.740143 527.341187,350.478882 527.068237,353.631348 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M510.363373,415.049591 
	C510.223267,414.503906 510.369293,413.915100 510.782532,413.162506 
	C512.138184,413.911530 511.779694,414.535919 510.363373,415.049591 
z"/>
<path fill="#15ABF3" opacity="1.000000" stroke="none" 
	d="
M262.070007,539.077515 
	C261.326660,539.006531 260.956421,538.907349 260.304871,538.876343 
	C260.023590,538.944519 259.998566,538.985046 260.022095,538.986572 
	C259.932343,538.776123 259.819092,538.564209 260.016754,538.170105 
	C260.758179,537.677551 261.188721,537.367249 261.857666,536.940125 
	C262.439270,536.065979 262.030121,535.202698 262.633240,534.224365 
	C265.505890,532.645203 265.509979,529.657349 266.802185,527.116943 
	C265.382324,525.002258 265.782104,523.232361 267.111938,521.223755 
	C269.801086,517.328979 271.679932,513.525818 271.411163,509.015442 
	C269.459808,507.343475 270.378937,505.630432 271.103271,503.601074 
	C274.663910,498.183167 278.412689,500.411377 282.477112,502.908508 
	C283.186493,503.358246 283.551239,503.669312 284.098450,504.310181 
	C284.404755,504.824768 284.495758,505.048096 284.561615,505.982056 
	C284.427582,506.900909 284.318756,507.109161 283.971558,507.570496 
	C280.993591,509.428070 280.707642,512.538696 279.211548,515.267944 
	C278.751831,516.273987 278.519043,517.014099 278.753357,518.111328 
	C279.128754,519.540710 279.090271,520.781494 279.994019,522.050354 
	C280.313049,522.460510 280.439392,522.627869 280.742554,523.058594 
	C281.545471,524.441223 282.247528,525.506165 283.346436,526.684204 
	C284.186340,527.789062 284.623718,528.791748 285.708191,529.701782 
	C286.743256,533.822693 287.212891,537.630432 282.465820,539.974854 
	C280.673279,539.054443 281.823120,536.412598 279.193115,536.016602 
	C277.011505,536.022583 277.200043,537.754700 276.504913,538.760376 
	C275.654724,539.990479 274.529694,541.512695 272.908295,540.474060 
	C269.569641,538.335449 265.795349,540.414001 262.070007,539.077515 
z"/>
<path fill="#15ABF3" opacity="1.000000" stroke="none" 
	d="
M293.879578,528.785461 
	C288.801880,529.810486 291.397034,532.227112 292.838104,534.679565 
	C288.244537,535.231018 289.659241,530.366882 287.274628,528.199951 
	C285.607422,525.358765 282.410370,525.336975 280.247314,523.238281 
	C280.003662,523.002441 280.000000,523.000000 279.998169,522.997681 
	C278.863983,519.752747 276.952606,516.354370 282.125458,514.263794 
	C283.024689,514.286682 283.498779,514.445496 284.197021,514.963562 
	C285.594757,516.590820 285.531067,518.674744 287.425232,519.957275 
	C290.147186,522.203003 292.708496,524.170471 293.777222,527.766235 
	C293.967621,528.207825 293.951263,528.374329 293.879578,528.785461 
z"/>
<path fill="#14A4F1" opacity="1.000000" stroke="none" 
	d="
M280.035492,523.344849 
	C282.167419,524.676147 286.964081,521.954163 286.994751,527.588745 
	C286.820465,527.993164 286.645844,527.998596 286.209167,528.010376 
	C284.929565,528.831360 284.120483,528.488708 283.175537,527.273560 
	C280.906616,526.818115 280.575348,525.175842 280.035492,523.344849 
z"/>
<path fill="#0DA5E9" opacity="1.000000" stroke="none" 
	d="
M271.994965,546.603516 
	C270.552246,547.920654 269.091217,548.844238 267.325562,549.894470 
	C267.158325,548.242432 266.231659,546.002197 267.644470,544.801636 
	C269.197205,543.482178 271.391235,543.109802 271.994965,546.603516 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M278.908569,536.396973 
	C279.178223,534.833435 279.549042,533.806335 281.117371,534.744385 
	C283.114258,535.938721 282.710236,537.605530 282.104370,539.682983 
	C282.012909,540.646667 282.132904,541.478577 281.776764,541.836426 
	C280.951111,542.665833 280.779449,541.506531 280.614990,541.136230 
	C279.982208,539.711426 279.488892,538.224792 278.908569,536.396973 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M285.008789,551.016846 
	C285.063995,551.385315 284.918060,551.788940 284.745300,551.918335 
	C283.295013,550.801453 282.442902,549.376343 282.329468,547.341248 
	C284.528503,547.745972 284.446625,549.411743 285.008789,551.016846 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M282.955414,527.356079 
	C283.726929,527.306152 284.519653,527.626099 285.629730,527.981384 
	C285.947418,528.438904 285.947723,528.861023 285.948364,529.598389 
	C284.320892,530.050049 282.974243,529.804504 282.955414,527.356079 
z"/>
<path fill="#15ABF3" opacity="1.000000" stroke="none" 
	d="
M293.753357,535.002197 
	C294.017426,535.444519 294.031189,535.886658 294.057129,536.660278 
	C293.725769,536.531250 293.382294,536.070557 293.020630,535.306152 
	C293.169312,535.002319 293.336182,535.002197 293.753357,535.002197 
z"/>
<path fill="#0DA5E9" opacity="1.000000" stroke="none" 
	d="
M266.792725,550.127441 
	C266.948822,550.354309 266.776520,550.633240 266.294342,550.985107 
	C266.243652,550.826538 266.403595,550.533691 266.792725,550.127441 
z"/>
<path fill="#14A4F1" opacity="1.000000" stroke="none" 
	d="
M299.026642,528.888062 
	C297.972351,527.964966 297.115875,526.768860 296.078308,525.309448 
	C294.304230,524.340637 293.245087,523.244934 293.284668,521.048462 
	C293.453400,520.502747 293.562225,520.298523 293.963989,519.906860 
	C295.543457,519.662231 296.400635,520.457947 297.508179,521.480103 
	C298.804962,522.913574 299.531647,524.342712 300.793488,525.793274 
	C301.103088,527.362122 300.049103,527.908325 299.026642,528.888062 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M301.062134,525.794312 
	C298.780090,525.965332 298.131165,524.144165 297.125427,522.259216 
	C296.494049,521.452759 296.359528,520.813477 296.348541,519.826294 
	C296.533691,519.315247 296.652832,519.129089 297.384033,518.964844 
	C298.990479,520.793701 299.984924,522.600708 301.075684,524.749512 
	C301.172028,525.091248 301.089752,525.558655 301.062134,525.794312 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M293.768311,519.609192 
	C293.466797,521.844543 294.538849,523.127136 295.756958,524.726868 
	C294.863068,525.505798 294.228455,526.277161 294.019409,527.724731 
	C291.886902,525.803467 289.789856,523.565552 287.424316,521.131897 
	C285.330811,517.854309 287.215668,517.188843 289.724640,517.192139 
	C291.256348,517.194214 292.361237,518.346497 293.768311,519.609192 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M121.815628,197.137924 
	C121.625275,194.369186 120.935806,191.875763 122.609032,189.256195 
	C123.778610,188.028915 123.718437,186.540009 124.797333,185.253235 
	C124.986847,184.980423 124.995872,184.999573 124.984627,184.992188 
	C127.134819,184.989578 129.296249,184.994339 131.787964,185.044800 
	C132.488663,185.755020 132.789017,186.448578 133.024536,187.559052 
	C130.600342,194.562805 128.012466,201.130798 123.404907,207.015121 
	C122.638313,207.616440 121.927521,206.404892 121.354965,207.692352 
	C120.555046,208.469254 119.892403,208.556503 118.932434,208.008072 
	C118.324997,205.089539 120.288635,203.060623 120.774734,200.277603 
	C120.986160,199.966171 121.007797,199.996780 120.989365,200.000244 
	C121.773857,199.294586 121.389908,198.281723 121.815628,197.137924 
z"/>
<path fill="#69E3FB" opacity="1.000000" stroke="none" 
	d="
M138.480255,190.855133 
	C145.371750,196.276138 151.973587,201.452957 158.797897,206.885529 
	C159.532867,208.218262 160.903336,208.474121 161.354645,209.953629 
	C160.941818,211.562912 160.170776,212.430664 158.481049,212.753082 
	C157.264282,212.671387 156.444016,212.397202 155.852539,211.805954 
	C150.086823,206.042496 143.791687,200.847321 137.989502,195.125076 
	C137.276306,194.421722 136.733307,193.571701 136.520508,192.185104 
	C136.797546,191.017883 137.318451,190.570709 138.480255,190.855133 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M138.717804,190.776291 
	C138.270264,191.253326 137.770599,191.407349 137.115112,191.786606 
	C136.088455,192.520401 135.415909,191.991257 134.479385,191.401886 
	C134.089615,191.086502 133.940536,190.953232 133.585419,190.604919 
	C133.258835,190.234024 133.138260,190.078171 132.884079,189.661423 
	C132.600998,189.042542 132.454453,188.683350 132.171829,188.069946 
	C132.020370,187.133499 132.008484,186.449844 132.057404,185.428345 
	C134.300720,186.878098 136.483200,188.665680 138.717804,190.776291 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M160.879852,210.514618 
	C160.277512,209.353256 159.697693,208.547302 159.069122,207.441315 
	C160.104660,207.781631 161.188934,208.421982 162.578735,209.160583 
	C162.892731,209.558060 163.026993,209.781784 163.423721,210.080292 
	C163.441238,210.399521 163.322052,210.568466 163.007721,210.978455 
	C162.088470,211.580673 161.453217,211.456039 160.879852,210.514618 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M120.723938,199.960129 
	C121.297523,202.620529 120.225250,204.961395 119.165802,207.678741 
	C119.162186,208.204681 119.308472,208.391022 119.528099,208.926743 
	C119.426346,211.113770 118.423401,212.362701 116.482193,213.301636 
	C115.904892,213.429611 115.666656,213.441483 115.102104,213.306580 
	C116.471870,209.010101 118.167953,204.860382 119.901291,200.351654 
	C120.112938,199.979767 120.287331,199.966919 120.723938,199.960129 
z"/>
<path fill="#0F0D0F" opacity="1.000000" stroke="none" 
	d="
M124.671494,185.122894 
	C125.108826,186.476410 124.280235,187.582718 123.160637,188.860474 
	C122.963631,187.616257 123.116150,186.224091 124.671494,185.122894 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M121.743057,197.082291 
	C121.846573,197.763321 121.691856,198.679352 121.254036,199.799530 
	C121.142235,199.108231 121.313538,198.212753 121.743057,197.082291 
z"/>
<path fill="#0C1929" opacity="1.000000" stroke="none" 
	d="
M98.825821,238.029556 
	C100.888519,236.077881 101.245560,233.704712 102.105682,231.626083 
	C102.938286,229.613968 103.681824,228.110428 106.102959,229.716049 
	C106.316841,229.857910 106.575188,229.932724 106.812881,230.038681 
	C106.948380,229.568893 107.141785,229.107285 107.209351,228.627914 
	C107.501732,226.553894 109.132767,225.519730 111.023148,224.455048 
	C112.350365,227.877258 110.940025,230.798920 109.977852,233.718781 
	C107.657036,240.761658 105.559189,247.853363 104.077972,255.527267 
	C103.153610,258.658325 102.392586,261.422028 101.990341,264.677917 
	C100.556000,269.138336 100.126778,273.509796 97.550873,277.506073 
	C96.371216,278.004150 95.547470,278.001801 94.349739,277.560791 
	C92.447952,275.605774 93.381775,273.740417 93.846191,271.526520 
	C95.741997,266.687347 95.851311,261.398285 98.129150,257.500885 
	C101.095314,252.425812 99.556969,248.438034 97.976837,243.569412 
	C97.698990,241.520676 97.900208,239.908630 98.825821,238.029556 
z"/>
<path fill="#071F39" opacity="1.000000" stroke="none" 
	d="
M86.574417,279.213013 
	C86.203514,272.457336 87.226456,266.174652 89.060028,259.603088 
	C89.204445,259.020355 89.315849,258.833466 89.498138,258.328003 
	C89.700363,257.573181 89.831696,257.136902 90.083008,256.379944 
	C90.994057,256.691315 91.010971,257.594238 91.077370,258.824493 
	C92.295151,262.373260 91.564346,265.654938 91.431320,269.317566 
	C91.360924,271.304779 91.372780,272.891785 91.127327,274.845917 
	C90.577446,276.862335 90.254829,278.535187 90.003906,280.585815 
	C89.824783,281.148346 89.728897,281.363464 89.404709,281.844055 
	C87.080589,282.452759 87.267059,280.639221 86.574417,279.213013 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M98.731201,237.848450 
	C99.012962,239.493698 98.946053,241.291656 98.862038,243.529175 
	C99.284081,250.288742 97.418121,256.226807 95.574265,262.537109 
	C94.807549,263.233459 94.329666,263.186737 93.869217,262.314270 
	C93.846581,253.649719 93.432510,245.316391 98.731201,237.848450 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M93.544060,261.875977 
	C93.989723,262.206818 94.187424,262.468567 94.659973,262.796814 
	C97.492546,265.300232 94.604782,267.788452 95.001511,270.610840 
	C94.707359,272.719177 94.415024,274.438385 94.135262,276.533875 
	C95.682709,279.061310 95.209785,281.244141 94.043427,283.802246 
	C92.214233,285.932648 91.576431,284.646088 90.886925,282.867676 
	C90.410736,278.859467 92.446541,275.354401 91.176651,271.383545 
	C90.851868,270.897583 90.702042,270.717224 90.301781,270.289856 
	C89.419243,266.590027 91.124039,263.373444 91.085236,259.569763 
	C92.318588,259.655304 91.724075,261.592926 93.544060,261.875977 
z"/>
<path fill="#0C1929" opacity="1.000000" stroke="none" 
	d="
M111.014053,222.226074 
	C111.021378,221.868362 111.520844,221.861755 111.770111,221.877182 
	C112.526115,222.642532 112.484390,223.344559 111.441849,224.013474 
	C111.047775,224.033340 111.030098,224.020966 111.021851,224.016113 
	C111.011314,223.535431 111.009026,223.059616 111.014053,222.226074 
z"/>
<path fill="#0A4271" opacity="1.000000" stroke="none" 
	d="
M111.042480,224.429749 
	C111.352852,223.527710 111.657921,223.022079 111.991196,222.204529 
	C112.019386,221.892609 111.984230,221.535507 111.976471,221.356262 
	C112.547859,220.267761 113.087662,219.332565 113.919441,218.217377 
	C114.504555,217.261093 114.881287,216.547989 115.160400,215.466156 
	C115.386322,214.807510 115.558228,214.451050 115.907188,213.543304 
	C116.961334,211.832153 117.871193,210.688095 118.883514,209.238983 
	C122.950104,208.215698 121.562920,210.891418 121.100800,212.555511 
	C120.029541,216.413025 117.999695,219.888184 116.316689,223.500504 
	C112.373421,231.964157 109.671028,240.859665 107.185944,249.830002 
	C106.653893,251.750549 106.180664,253.695786 104.721886,255.648285 
	C104.202637,256.047546 103.960144,256.158447 103.341362,256.133820 
	C103.930557,245.160843 108.740753,235.318970 111.042480,224.429749 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M114.929611,217.456909 
	C115.032173,219.675766 113.590477,220.075562 112.259018,220.999115 
	C111.894844,219.410675 111.771317,217.631729 113.767715,216.120422 
	C114.554848,216.267197 114.739159,216.577103 114.929611,217.456909 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M116.225449,214.437546 
	C115.868286,215.649902 115.710655,216.594818 115.271439,217.767181 
	C114.989853,217.994629 115.003204,218.004654 115.007660,218.011017 
	C114.644852,217.606293 114.525101,217.098511 114.283020,216.369873 
	C114.117668,216.165802 113.968391,215.983429 113.885696,215.895416 
	C114.040489,215.089355 114.277985,214.371323 114.645630,213.406540 
	C114.987648,213.124954 115.199501,213.090118 115.731415,213.015747 
	C116.051476,212.976212 116.009163,212.994400 116.008919,212.972992 
	C116.302902,213.304657 116.441673,213.710831 116.225449,214.437546 
z"/>
<path fill="#CFF3F8" opacity="1.000000" stroke="none" 
	d="
M257.129578,204.911957 
	C261.842102,208.707748 266.513733,212.940109 271.395111,217.440399 
	C268.961426,218.926468 269.530640,220.982147 270.037109,223.608978 
	C269.001984,223.648590 268.137787,223.145233 267.129395,222.373474 
	C268.559906,218.600220 266.508148,216.992996 263.687164,215.764313 
	C259.142090,213.784744 256.505859,210.582947 257.129578,204.911957 
z"/>
<path fill="#69E3FB" opacity="1.000000" stroke="none" 
	d="
M327.506805,294.402283 
	C327.796814,295.380646 328.099060,295.990601 328.671936,296.809998 
	C331.960419,299.954803 333.155762,304.039703 335.645874,307.704712 
	C336.083405,308.606689 336.322754,309.227142 336.669403,310.156494 
	C336.953918,311.095581 337.041290,311.735657 336.935394,312.709381 
	C338.180634,317.776886 340.987457,321.844391 342.919739,326.685760 
	C340.009521,326.057800 339.122253,322.816589 336.377563,321.135712 
	C331.902405,315.794434 327.721863,310.597382 323.276123,305.203857 
	C321.902527,304.284180 320.949860,303.452057 320.225739,302.283966 
	C316.335876,296.009277 317.441376,293.576904 324.939270,292.781982 
	C326.412079,292.521057 327.259583,292.793243 327.506805,294.402283 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M337.328278,313.017456 
	C336.578400,312.551758 336.269409,312.076050 335.955627,311.304688 
	C342.697113,309.527893 348.962341,311.709686 355.649200,313.758972 
	C356.616699,314.465363 357.207886,314.959229 357.925079,315.718811 
	C351.122559,316.135864 344.701660,312.828949 337.328278,313.017456 
z"/>
<path fill="#27303B" opacity="1.000000" stroke="none" 
	d="
M368.041565,369.435791 
	C367.951141,368.692169 367.974365,368.209320 368.010132,367.363892 
	C369.610107,365.882904 369.662659,363.942047 371.013214,362.474152 
	C372.716370,365.128174 371.678589,367.531433 370.411865,370.524353 
	C369.326447,370.626099 368.740845,370.161346 368.041565,369.435791 
z"/>
<path fill="#27303B" opacity="1.000000" stroke="none" 
	d="
M375.558899,341.110291 
	C375.937683,341.031860 376.009186,341.495758 376.023834,341.729980 
	C376.252808,344.230804 376.675659,346.518372 374.681122,348.814209 
	C374.554779,346.419037 372.755371,343.483154 375.558899,341.110291 
z"/>
<path fill="#27303B" opacity="1.000000" stroke="none" 
	d="
M373.746582,355.714935 
	C373.164825,353.848785 372.587402,351.648285 373.711304,349.269226 
	C373.994385,348.996552 374.000214,349.000000 374.003052,349.001831 
	C375.741821,351.026337 375.524872,353.197205 373.746582,355.714935 
z"/>
<path fill="#27303B" opacity="1.000000" stroke="none" 
	d="
M372.692902,359.789917 
	C372.152344,358.821625 372.303436,357.642273 372.727142,356.231445 
	C372.999756,356.000000 373.000000,356.000000 373.000122,356.000000 
	C374.046326,357.094391 374.091644,358.296204 372.692902,359.789917 
z"/>
<path fill="#27303B" opacity="1.000000" stroke="none" 
	d="
M370.999390,361.999390 
	C371.168213,361.442871 371.337646,360.886932 371.754150,360.166016 
	C372.001221,360.000977 372.000000,360.000000 371.999390,359.999664 
	C372.599548,360.747742 372.454285,361.419037 371.394745,362.018585 
	C371.001221,362.000641 371.000000,362.000000 370.999390,361.999390 
z"/>
<path fill="#72C2DC" opacity="1.000000" stroke="none" 
	d="
M345.088806,331.055786 
	C344.645172,330.838440 344.287445,330.246704 343.989441,329.304688 
	C344.950928,329.186890 345.106812,329.905487 345.088806,331.055786 
z"/>
<path fill="#72C2DC" opacity="1.000000" stroke="none" 
	d="
M344.062622,328.678894 
	C343.703949,328.517212 343.349579,328.053619 342.990845,327.273804 
	C343.346619,327.430756 343.706787,327.903870 344.062622,328.678894 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M358.069611,316.118378 
	C358.001221,315.946991 358.463470,316.015259 358.694214,316.047455 
	C358.738434,316.433594 358.532867,316.716187 358.069611,316.118378 
z"/>
<path fill="#F6FCFD" opacity="1.000000" stroke="none" 
	d="
M245.694992,276.844666 
	C253.091217,282.642487 260.172485,288.329407 267.568268,294.157562 
	C282.230103,305.905640 296.556396,317.538696 310.929810,329.113190 
	C331.666504,345.811798 352.437439,362.467896 373.510742,379.285828 
	C377.931549,379.989288 378.843384,383.300415 379.994019,386.857544 
	C380.278168,388.518829 380.260071,389.790436 379.665222,391.370026 
	C375.243347,392.363190 372.011353,389.923950 368.773193,387.908478 
	C363.307495,384.506531 358.265289,380.485565 353.044739,376.135010 
	C350.949005,374.152344 349.159973,372.356232 346.692810,370.831848 
	C340.391968,365.759369 334.193939,361.117279 327.718079,356.280945 
	C325.612915,354.778137 323.960205,353.233154 321.717590,351.917664 
	C318.240387,349.562988 315.474945,346.819641 311.877686,344.612518 
	C305.639252,338.857147 299.094513,334.043030 292.265869,329.036682 
	C290.894196,328.045715 289.989410,327.039795 288.700317,325.969971 
	C287.230316,324.812103 285.942505,323.960327 284.515656,322.744202 
	C280.916382,319.948486 277.683960,317.213013 273.721558,314.897644 
	C256.416321,301.554504 240.418579,287.096680 222.662354,274.879181 
	C221.151291,273.839478 219.930527,272.471649 218.245209,271.117981 
	C216.455719,269.630676 215.035141,268.216522 212.879471,267.242676 
	C212.382477,266.977203 212.186310,266.863708 211.707336,266.558105 
	C211.060303,266.084930 210.706207,265.791687 210.101410,265.253723 
	C195.394745,250.039810 179.558167,236.480972 165.213791,221.397690 
	C163.554672,219.653091 161.148865,218.270142 161.685410,214.946136 
	C162.339783,214.079498 162.930588,213.675262 163.944473,213.276276 
	C179.147659,224.808487 194.009155,236.440750 208.862930,248.082870 
	C221.040085,257.627106 233.208023,267.183075 245.694992,276.844666 
z"/>
<path fill="#1E2B39" opacity="1.000000" stroke="none" 
	d="
M383.776733,357.854736 
	C389.386139,364.503082 393.491455,371.973511 398.102234,379.509094 
	C397.397644,381.173706 395.965973,380.974945 394.460876,381.386230 
	C393.959808,381.515533 393.761993,381.572235 393.268616,381.708252 
	C392.390564,381.937500 391.801666,382.063293 390.949127,382.353210 
	C390.482025,382.525696 390.294403,382.594147 389.821716,382.756897 
	C388.957703,383.027710 388.372589,383.184174 387.200439,383.575775 
	C386.386810,383.796173 386.174103,383.826569 385.635864,383.854736 
	C383.712402,383.662262 382.517944,382.627014 380.902588,381.705444 
	C378.876282,379.850342 376.447449,378.878967 375.219421,376.198730 
	C373.424500,374.504089 371.815765,373.086700 370.059509,371.380096 
	C369.912048,371.090881 370.049316,370.964203 370.115662,370.898499 
	C374.460266,366.384460 378.566406,361.759521 383.776733,357.854736 
z"/>
<path fill="#0DA5E9" opacity="1.000000" stroke="none" 
	d="
M374.989075,376.291992 
	C376.963287,377.395996 378.893341,378.870483 381.012207,380.619598 
	C381.407928,382.587738 381.313965,384.263275 380.755066,386.255890 
	C380.448364,386.775391 380.286743,386.958618 379.761078,387.184723 
	C378.175385,384.437897 376.660126,381.859222 374.005127,379.700836 
	C374.200104,378.507172 374.572510,377.584839 374.989075,376.291992 
z"/>
<path fill="#CFF3F8" opacity="1.000000" stroke="none" 
	d="
M164.173859,212.955032 
	C163.893570,214.136978 163.200821,214.779037 161.730392,215.220963 
	C159.287750,215.563004 158.316925,214.442581 157.871796,212.411316 
	C159.199585,212.170883 159.744736,211.284531 160.581619,210.290039 
	C161.319473,210.473785 161.781647,210.788345 162.528198,211.161194 
	C163.227798,211.725708 163.642990,212.231903 164.173859,212.955032 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M273.952240,239.051880 
	C268.286560,234.606735 262.652618,229.740509 256.812134,224.598053 
	C256.981934,224.007675 257.363861,223.413483 257.733734,223.420883 
	C264.308197,223.552856 273.396393,232.098984 273.952240,239.051880 
z"/>
<path fill="#3EE8F8" opacity="1.000000" stroke="none" 
	d="
M276.954041,223.080322 
	C279.053711,224.447754 280.852356,225.993820 282.811462,227.825806 
	C283.405548,229.941147 282.299347,230.671783 280.474426,231.044067 
	C279.587555,230.741135 279.042084,230.527298 278.222321,230.661423 
	C277.947998,231.009384 278.008118,230.998764 277.999268,231.028320 
	C277.617950,230.568161 277.487823,229.931473 276.808228,229.279160 
	C275.987762,228.478470 275.398895,227.885452 274.387268,227.319199 
	C273.939911,225.213043 275.849548,224.595459 276.954041,223.080322 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M274.220276,227.452667 
	C275.281128,226.882767 276.034943,227.612350 276.914246,228.582001 
	C277.159180,229.109573 277.299377,229.346756 277.151733,229.880539 
	C276.021057,229.360138 275.178223,228.543152 274.220276,227.452667 
z"/>
<path fill="#040E11" opacity="1.000000" stroke="none" 
	d="
M276.963593,230.429749 
	C276.898041,229.960678 276.932159,229.744217 276.992645,229.200073 
	C277.544525,229.426468 278.070007,229.980560 278.292969,230.796265 
	C277.681366,230.932709 277.372314,230.807541 276.963593,230.429749 
z"/>
<path fill="#17283A" opacity="1.000000" stroke="none" 
	d="
M279.002014,247.699127 
	C278.921173,247.189468 278.959534,246.906265 279.054840,246.198151 
	C279.609558,246.331818 280.107300,246.890396 280.326691,247.719955 
	C279.739319,247.969147 279.430267,247.947357 279.002014,247.699127 
z"/>
<path fill="#CFF3F8" opacity="1.000000" stroke="none" 
	d="
M270.154602,223.857605 
	C270.400787,223.959686 270.548615,224.157684 270.696411,224.355682 
	C270.494293,224.391235 270.292175,224.426788 269.978088,224.307129 
	C269.866150,224.151932 270.056244,223.953522 270.154602,223.857605 
z"/>
<path fill="#17283A" opacity="1.000000" stroke="none" 
	d="
M281.170471,248.636414 
	C280.691833,248.880219 280.329163,248.730179 279.975952,248.263641 
	C280.532166,247.547577 280.966278,247.644165 281.170471,248.636414 
z"/>
<path fill="#17283A" opacity="1.000000" stroke="none" 
	d="
M281.825195,248.737091 
	C281.883240,249.452393 281.829163,250.251663 280.978973,249.256348 
	C281.162842,248.802277 281.354187,248.653503 281.825195,248.737091 
z"/>
<path fill="#16ECFA" opacity="1.000000" stroke="none" 
	d="
M305.337036,256.567322 
	C298.640594,258.875732 296.967804,263.255066 300.599335,269.906647 
	C301.608307,271.754700 302.812286,273.496307 303.965759,275.641449 
	C300.878479,277.464172 300.104279,274.692688 298.461304,272.813080 
	C297.877472,272.272064 297.603485,271.918182 297.189575,271.245972 
	C296.979248,270.982117 297.007202,270.996033 297.008545,271.011597 
	C296.585663,270.577240 296.527374,269.980927 296.176636,269.204712 
	C295.984344,268.984802 296.004608,268.992310 296.008270,269.002258 
	C295.630524,266.006653 292.752747,264.800201 291.199707,262.233673 
	C291.030212,261.199554 291.004913,260.466827 290.969025,259.366791 
	C292.617493,253.071213 294.140991,251.714264 299.609070,251.807220 
	C299.924194,252.039169 299.987518,252.007385 299.981140,252.042236 
	C300.227112,252.263550 300.468567,252.463104 300.872498,252.834473 
	C302.417633,254.088364 303.789429,255.183533 305.337036,256.567322 
z"/>
<path fill="#3EE8F8" opacity="1.000000" stroke="none" 
	d="
M290.051208,263.961182 
	C290.207794,264.111481 290.316528,264.305695 290.425262,264.499878 
	C290.312256,264.461456 290.199280,264.423004 290.001160,264.242950 
	C289.916077,264.101349 290.003296,264.005096 290.051208,263.961182 
z"/>
<path fill="#26E5F5" opacity="1.000000" stroke="none" 
	d="
M299.775269,251.747375 
	C295.074493,251.657074 293.566345,255.468323 291.271393,258.842163 
	C290.454468,258.716980 289.950470,258.434540 289.181091,258.034973 
	C288.540985,257.483185 288.529785,256.907715 288.155914,256.194305 
	C287.981903,255.983337 287.999542,255.997559 288.003296,256.008240 
	C287.884155,255.864227 287.761292,255.709534 287.779907,255.294434 
	C290.976196,253.351532 290.136475,248.937943 293.616150,247.189606 
	C295.820221,248.509811 297.723267,249.982697 299.775269,251.747375 
z"/>
<path fill="#39AEDD" opacity="1.000000" stroke="none" 
	d="
M288.010284,256.267395 
	C288.284485,256.439728 288.587036,256.896118 288.902649,257.635193 
	C288.623352,257.462433 288.331024,257.006927 288.010284,256.267395 
z"/>
<path fill="#39AEDD" opacity="1.000000" stroke="none" 
	d="
M286.921204,254.824799 
	C286.729095,254.936218 286.528961,254.787125 286.328796,254.638062 
	C286.523560,254.613464 286.718353,254.588882 286.921204,254.824799 
z"/>
<path fill="#39AEDD" opacity="1.000000" stroke="none" 
	d="
M287.708099,255.012482 
	C287.921356,255.034042 287.979431,255.524918 287.993225,255.771912 
	C287.658783,255.967804 287.377136,255.802963 287.045685,255.304840 
	C286.929260,255.085297 286.997040,255.006104 287.033875,254.967300 
	C287.070740,254.928497 287.494843,254.990936 287.708099,255.012482 
z"/>
<path fill="#21E8FF" opacity="1.000000" stroke="none" 
	d="
M297.953949,271.825714 
	C300.644775,272.438324 300.811035,275.703949 303.667114,275.963745 
	C306.040894,277.049225 306.733368,279.202820 307.918396,280.918579 
	C311.287018,285.795807 311.313599,285.842682 315.915649,281.210358 
	C316.818909,280.599854 317.299011,281.028839 318.068848,281.424194 
	C318.381622,281.327881 318.560059,281.422211 318.629211,281.495728 
	C319.609558,284.507690 322.197723,286.108734 324.310516,288.539795 
	C325.453888,289.942108 326.340057,291.097107 326.328430,292.968018 
	C325.254669,294.235718 324.301453,295.245758 322.812134,294.767853 
	C317.989594,293.220398 318.608124,295.759247 319.897003,298.672577 
	C320.752655,300.606750 321.794098,302.458771 322.881653,304.677490 
	C316.994751,304.482117 313.799042,299.617706 309.302795,296.146545 
	C307.434021,293.866028 305.865601,291.730988 304.144958,289.302856 
	C305.740387,287.705231 305.719879,286.357086 304.789001,284.355682 
	C302.801758,280.083130 299.599884,276.653015 297.126709,272.332153 
	C297.204437,271.890717 297.418488,271.761810 297.953949,271.825714 
z"/>
<path fill="#67F3F9" opacity="1.000000" stroke="none" 
	d="
M295.971497,269.295593 
	C296.328278,269.458923 296.672211,269.933014 297.013062,270.717133 
	C296.659485,270.553558 296.309052,270.079956 295.971497,269.295593 
z"/>
<path fill="#67F3F9" opacity="1.000000" stroke="none" 
	d="
M298.100281,271.793030 
	C298.061218,272.021637 297.847107,272.024811 297.311676,272.023804 
	C296.984802,271.846741 296.979248,271.673889 296.976440,271.241577 
	C297.294556,271.177277 297.609863,271.372437 298.100281,271.793030 
z"/>
<path fill="#413C3F" opacity="1.000000" stroke="none" 
	d="
M457.440002,307.657318 
	C455.762817,304.474030 452.243988,303.675140 450.568695,300.965118 
	C446.465515,294.327850 444.285461,286.801392 451.860046,279.261230 
	C455.815216,277.032227 459.896545,278.462646 464.218414,278.007599 
	C466.896606,280.321442 470.012909,281.033295 473.084839,282.604462 
	C475.005798,285.957672 475.299316,289.500610 476.582428,293.109558 
	C476.640472,294.526031 476.100525,295.309082 475.148438,296.251648 
	C473.192474,297.887573 471.563385,299.348297 470.634460,301.807434 
	C470.214722,302.475098 469.918243,302.815643 469.316376,303.337891 
	C468.066406,304.152985 467.032867,304.671967 465.839172,305.610443 
	C463.038116,306.831207 460.712341,308.517120 457.440002,307.657318 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M466.260864,279.302856 
	C461.607513,279.013214 457.270844,278.993927 452.470856,278.961792 
	C451.043152,275.975922 453.428467,277.092438 454.521240,277.040192 
	C464.014038,276.586304 464.015472,276.614655 464.013611,267.308777 
	C464.013123,264.849396 464.011749,262.389984 464.266846,259.197327 
	C465.662903,257.843781 466.892181,257.839325 468.501892,258.008667 
	C469.096558,258.169434 469.326080,258.261780 469.843445,258.585754 
	C470.199677,259.052582 470.268036,259.287872 470.226135,259.870483 
	C469.946960,260.388306 469.778076,260.558716 469.316772,260.929596 
	C465.736328,263.330017 468.549438,266.186066 468.225739,268.707581 
	C467.713470,272.698242 469.194336,275.687286 473.148926,277.728241 
	C473.415985,278.288727 473.464203,278.542633 473.432251,279.184570 
	C471.094147,281.977448 468.835815,280.481445 466.260864,279.302856 
z"/>
<path fill="#8FD2E7" opacity="1.000000" stroke="none" 
	d="
M447.557037,308.459473 
	C448.350952,308.245880 448.944916,308.166595 449.985260,308.025665 
	C451.122009,308.273010 451.812378,308.582062 452.792816,308.949280 
	C453.663849,309.320190 454.087616,309.808350 454.739807,310.531342 
	C455.967377,311.964325 457.219910,312.994080 457.479492,314.997620 
	C457.254639,315.776611 456.939972,316.095764 456.191864,316.205505 
	C453.047821,313.896271 450.233185,311.697723 447.228271,309.226990 
	C447.037964,308.954834 447.357056,308.593842 447.557037,308.459473 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M454.098633,310.865906 
	C453.491058,310.417206 453.252930,309.974731 453.048859,309.269836 
	C453.831238,307.463104 455.416870,308.266754 456.825806,307.625000 
	C459.717407,306.588074 462.323547,305.700592 465.289246,304.739746 
	C465.849579,304.811218 466.050385,304.956116 466.253204,305.472961 
	C463.464203,310.189056 458.658508,309.809387 454.098633,310.865906 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M458.419342,258.991333 
	C457.989471,258.985596 457.993225,258.500122 457.992065,258.257385 
	C458.791595,257.047821 459.901337,256.869568 461.483948,256.843750 
	C462.770264,257.049377 463.529114,257.391510 464.011475,258.584656 
	C463.994934,259.007568 463.999542,259.000549 464.003174,258.996948 
	C462.287598,258.994568 460.568390,258.995819 458.419342,258.991333 
z"/>
<path fill="#3A3639" opacity="1.000000" stroke="none" 
	d="
M454.620789,319.292877 
	C455.884216,319.217987 456.645660,320.217133 457.829895,319.359619 
	C458.906158,318.478485 459.457428,319.164490 460.223022,319.915955 
	C460.430176,320.508820 460.570465,320.638031 460.815277,320.523468 
	C460.887817,320.489532 460.921600,320.451904 460.916412,320.410095 
	C460.834686,319.748444 461.180420,320.463684 460.382202,320.131470 
	C459.207123,318.256042 457.401306,317.050171 457.601837,314.450470 
	C459.832123,310.691315 462.856995,312.014435 466.113159,312.739807 
	C468.062378,313.475830 469.783325,312.869019 471.715576,313.487305 
	C472.357452,313.996582 472.596863,314.392944 472.771454,315.190613 
	C472.698883,317.543274 471.105591,318.501312 469.643860,319.926819 
	C469.317627,320.314667 469.195007,320.473358 468.884674,320.859497 
	C468.569946,321.231964 468.442993,321.376984 467.924377,321.927399 
	C467.398438,322.458466 467.264160,322.584198 466.922455,322.887512 
	C466.570038,323.172394 466.425049,323.279633 466.052429,323.527649 
	C465.517365,323.845978 465.217102,324.034882 464.726471,324.419312 
	C464.408203,324.742065 464.287598,324.880798 463.993896,325.243774 
	C463.704651,325.623047 463.588501,325.778137 463.288239,326.165314 
	C462.432892,327.162018 461.710175,327.869873 460.597961,328.582825 
	C460.163147,328.816528 459.987671,328.901550 459.305115,329.235992 
	C458.640564,329.578644 458.483093,329.671844 458.099823,329.911896 
	C457.725525,330.153534 457.577026,330.248322 457.203094,330.471893 
	C456.681732,330.752502 456.390686,330.913269 455.924744,331.234589 
	C455.744873,331.386200 455.476624,331.764374 455.423523,331.989441 
	C455.408966,332.554382 455.523956,332.869171 455.832581,333.425537 
	C457.044617,335.968231 458.710663,336.652008 461.075317,335.674988 
	C462.424255,335.117615 463.827515,334.808838 465.568970,335.514893 
	C466.005646,335.850952 466.152313,336.017242 466.414429,336.489716 
	C466.531891,337.010132 466.533966,337.224426 466.431152,337.738159 
	C466.060730,338.352844 465.761139,338.630524 465.173645,339.018738 
	C464.767395,339.277130 464.605255,339.376617 464.209717,339.628845 
	C463.528442,340.117126 463.157715,340.513092 462.936218,341.355225 
	C462.690918,344.331604 464.755707,346.818848 463.347015,349.861816 
	C459.805817,350.252472 457.865692,347.765991 455.734192,345.909332 
	C453.889191,344.302185 455.000977,343.056671 457.337097,342.367737 
	C458.161438,342.024506 458.534149,341.268799 459.226501,341.857513 
	C458.554413,341.205994 458.191498,341.997223 457.377899,342.327759 
	C453.501831,342.755585 450.448242,341.130127 446.983643,339.696045 
	C443.348022,335.727356 438.589203,334.573853 434.246429,332.662292 
	C431.860962,331.612305 429.174255,331.075836 427.419739,328.376068 
	C428.519928,323.261383 435.188171,318.541901 440.587555,318.061035 
	C445.289032,317.642334 449.718597,318.943695 454.620789,319.292877 
z"/>
<path fill="#413C3F" opacity="1.000000" stroke="none" 
	d="
M454.674011,318.967224 
	C454.727783,320.968811 453.443359,321.255188 452.068542,320.811432 
	C448.800598,319.756500 445.564545,319.657471 442.112579,319.539429 
	C435.379547,319.309204 431.810211,323.178619 428.001465,327.769714 
	C427.630127,328.430969 427.240295,328.599487 426.470642,328.621887 
	C425.501129,328.410706 424.942261,328.083893 424.252625,327.370483 
	C425.027222,322.674408 429.348267,320.970551 431.780884,317.713379 
	C432.602661,316.613037 434.525970,315.847656 433.256439,314.034088 
	C432.322021,312.699280 430.977966,313.425476 429.646484,313.564514 
	C423.021790,314.256378 416.288055,316.068756 410.216156,311.206146 
	C407.939056,309.382538 405.915497,307.607300 405.027283,304.409058 
	C414.114807,304.921234 423.246613,305.780334 432.630798,306.373138 
	C440.758484,309.128845 447.271118,314.461426 454.674011,318.967224 
z"/>
<path fill="#16ECFA" opacity="1.000000" stroke="none" 
	d="
M396.467743,256.210083 
	C396.809509,256.611481 397.003662,256.847748 397.410706,257.200378 
	C397.716400,257.663635 397.846893,257.979523 398.029907,258.545837 
	C394.762512,262.442200 392.747528,266.417511 394.824646,271.862427 
	C393.904663,271.797729 393.050415,271.312927 392.048401,270.567932 
	C391.657837,269.675140 391.109833,269.497070 390.305664,269.176941 
	C389.782440,268.846008 389.473907,268.718842 389.067322,268.353638 
	C389.006897,265.530060 388.806519,262.912292 389.151123,260.368347 
	C389.475708,257.972473 390.261871,255.566010 393.616730,254.988464 
	C394.366119,255.023697 394.745331,255.117340 395.397949,255.305725 
	C395.846130,255.651779 396.049805,255.876953 396.467743,256.210083 
z"/>
<path fill="#413C3F" opacity="1.000000" stroke="none" 
	d="
M428.881134,303.519409 
	C427.735779,305.870209 426.163208,304.300812 424.681671,304.099915 
	C420.974091,303.597015 417.265625,303.100311 413.272766,302.326996 
	C414.090057,299.731323 416.149078,298.706696 418.818176,297.958160 
	C422.354248,299.678864 425.528290,301.459625 428.881134,303.519409 
z"/>
<path fill="#7AAABF" opacity="1.000000" stroke="none" 
	d="
M461.379395,321.513397 
	C460.486877,320.950195 459.594208,320.107300 458.343201,319.192413 
	C457.354218,318.310760 456.723480,317.501099 455.977631,316.393127 
	C456.185364,315.851410 456.508240,315.608002 456.975494,315.094666 
	C457.288361,314.724274 457.456879,314.623810 457.820068,314.744019 
	C459.168518,316.932861 460.322266,318.901031 461.640320,321.233093 
	C461.662842,321.475922 461.521057,321.354828 461.379395,321.513397 
z"/>
<path fill="#3EE8F8" opacity="1.000000" stroke="none" 
	d="
M444.879669,307.398499 
	C445.538910,306.973389 446.141571,307.162109 446.493835,308.195007 
	C445.957733,308.248901 445.461548,307.960968 444.879669,307.398499 
z"/>
<path fill="#16ECFA" opacity="1.000000" stroke="none" 
	d="
M397.220398,274.221375 
	C397.614716,274.211853 398.158356,274.456909 398.811951,274.990662 
	C398.404480,275.011536 397.887115,274.743713 397.220398,274.221375 
z"/>
<path fill="#46E7FA" opacity="1.000000" stroke="none" 
	d="
M390.235901,269.226624 
	C390.625366,269.226044 391.159729,269.478943 391.797363,270.019775 
	C391.393982,270.031860 390.887390,269.755951 390.235901,269.226624 
z"/>
<path fill="#3EE8F8" opacity="1.000000" stroke="none" 
	d="
M447.459167,308.334564 
	C447.673920,308.536346 447.537048,308.703644 447.192200,308.890930 
	C447.037964,308.954834 446.746887,308.915314 446.695038,308.776917 
	C446.815887,308.540314 446.988617,308.442169 447.459167,308.334564 
z"/>
<path fill="#16ECFA" opacity="1.000000" stroke="none" 
	d="
M394.827637,272.467072 
	C395.045776,272.349152 395.377350,272.484589 395.831390,272.869080 
	C395.616241,272.985565 395.278687,272.852997 394.827637,272.467072 
z"/>
<path fill="#16ECFA" opacity="1.000000" stroke="none" 
	d="
M395.981995,273.301331 
	C396.225708,273.105621 396.516632,273.257172 396.886169,273.724579 
	C396.707306,273.805420 396.395477,273.674805 395.981995,273.301331 
z"/>
<path fill="#636061" opacity="1.000000" stroke="none" 
	d="
M372.097168,213.143036 
	C371.322998,212.519302 370.802856,212.071915 370.159973,211.394531 
	C367.247620,207.612442 363.628265,204.327652 366.430237,198.786453 
	C369.622101,196.889069 372.672363,196.337555 376.286560,197.339493 
	C376.883820,197.550201 377.117462,197.641235 377.686462,197.890106 
	C380.671326,199.623535 383.525299,200.838074 386.369843,202.800262 
	C387.274170,203.418350 387.808746,203.913300 388.494812,204.778122 
	C392.622894,210.478897 389.322388,214.268082 385.574860,218.300293 
	C383.364502,220.485184 381.501617,219.137054 379.301941,218.201599 
	C378.983551,217.982895 378.994965,218.005463 379.007385,218.007675 
	C378.329041,217.208740 377.396149,216.782562 376.220276,216.168182 
	C375.978485,215.978241 375.994476,216.005432 376.009460,216.010345 
	C375.475159,215.476425 374.939301,214.924194 374.187195,214.180237 
	C373.984802,213.974625 373.998199,214.004654 374.014160,214.008545 
	C373.571838,213.535889 372.934021,213.494171 372.097168,213.143036 
z"/>
<path fill="#74909F" opacity="1.000000" stroke="none" 
	d="
M388.250305,205.278030 
	C387.500977,204.771637 387.025116,204.478104 386.286438,204.088196 
	C386.187408,201.575394 388.184052,201.756577 389.677521,201.677811 
	C395.294525,201.381607 400.761627,200.186600 406.645538,199.250061 
	C410.260132,200.777664 407.148865,203.558502 408.471924,205.842361 
	C412.102814,205.001984 415.634613,203.605972 419.539337,202.199585 
	C421.053741,201.618286 422.233551,201.182480 423.870819,201.655884 
	C424.712769,202.487061 424.869781,203.230667 424.725647,204.412003 
	C423.943481,206.301865 422.551849,207.008820 420.880157,207.949295 
	C417.437653,209.474960 414.128998,210.312790 410.726837,211.907654 
	C407.505676,213.069046 404.668121,214.224045 401.531982,215.583588 
	C398.924591,216.283752 397.021851,217.815079 394.356384,218.207825 
	C392.047302,217.723099 390.405396,218.662552 388.844452,219.560226 
	C385.394348,221.544357 382.241150,221.493118 379.150208,218.301697 
	C380.810028,217.429092 382.504669,219.533768 384.678101,218.105652 
	C388.136230,215.920441 390.346527,212.661453 393.842712,211.090332 
	C395.181702,210.488617 396.136902,209.664368 395.901550,208.126221 
	C395.636230,206.392303 394.137115,206.428589 392.832214,206.303833 
	C391.369720,206.164017 389.847565,206.360397 388.250305,205.278030 
z"/>
<path fill="#74909F" opacity="1.000000" stroke="none" 
	d="
M367.255310,198.951553 
	C364.606934,203.894485 368.709656,206.776886 370.016083,210.784821 
	C367.086426,209.069748 368.556030,213.116089 366.477325,213.293365 
	C364.226624,206.869247 365.742340,197.069565 354.260803,196.998535 
	C352.876099,196.917480 351.714081,197.347000 351.081543,195.768677 
	C353.186737,188.956223 358.211670,185.108887 364.063477,181.969696 
	C364.863434,187.021988 364.021179,192.125305 367.408875,196.750854 
	C367.664215,197.620682 367.632965,198.126541 367.255310,198.951553 
z"/>
<path fill="#6D676B" opacity="1.000000" stroke="none" 
	d="
M394.157104,218.430756 
	C395.945953,216.802246 397.697296,215.109802 400.596191,214.931885 
	C402.125793,221.864868 408.786011,224.463104 412.516418,229.795044 
	C411.864044,233.055725 409.449554,232.306259 407.206909,232.802460 
	C403.180450,233.615082 402.950958,229.554733 400.303894,228.155151 
	C399.253571,224.201004 395.784851,222.073349 394.157104,218.430756 
z"/>
<path fill="#74909F" opacity="1.000000" stroke="none" 
	d="
M376.120514,216.269958 
	C377.156189,215.993011 378.370270,215.928024 378.970154,217.664612 
	C377.855194,217.994583 376.946625,217.491852 376.120514,216.269958 
z"/>
<path fill="#74909F" opacity="1.000000" stroke="none" 
	d="
M374.024078,214.297592 
	C374.894409,214.080200 375.653137,214.396866 375.982483,215.694016 
	C375.108643,215.918854 374.343018,215.611359 374.024078,214.297592 
z"/>
<path fill="#74909F" opacity="1.000000" stroke="none" 
	d="
M372.056549,213.202454 
	C372.450928,213.138947 373.058716,213.311218 373.848328,213.747955 
	C373.443420,213.821030 372.856659,213.629623 372.056549,213.202454 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M419.766418,330.934265 
	C420.570099,330.040100 421.444305,329.500366 422.955231,329.104797 
	C424.105591,329.833771 424.337646,330.455811 423.556641,331.390961 
	C422.582825,331.904938 421.869659,331.975708 420.787231,331.786682 
	C420.238281,331.555267 420.037598,331.421967 419.766418,330.934265 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M423.913483,327.359406 
	C424.561005,327.276611 425.080597,327.430786 425.786499,327.792969 
	C426.021332,329.761780 424.886536,329.638245 423.338623,329.206604 
	C422.979004,328.983795 422.972046,328.961578 422.958862,328.950195 
	C423.225616,328.491302 423.505585,328.043823 423.913483,327.359406 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M418.402954,332.280396 
	C418.037659,331.935547 418.007385,331.730652 417.950806,331.215576 
	C418.321533,330.842529 418.718536,330.779663 419.405731,330.648315 
	C419.695892,330.579865 419.893585,330.860992 419.996552,330.998566 
	C420.102600,332.048676 419.557648,332.380188 418.402954,332.280396 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M234.312134,119.586212 
	C234.283813,119.215271 234.656860,119.140106 234.844879,119.109543 
	C239.176208,119.165009 243.384125,118.421654 247.422897,120.189461 
	C243.047348,120.717361 238.683670,121.888069 234.312134,119.586212 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M256.863403,106.258934 
	C258.423370,110.606674 261.662903,110.274101 265.631012,109.022278 
	C266.147736,109.240318 266.272552,109.460304 266.388885,110.059814 
	C264.031433,113.506226 260.163727,111.644745 256.636871,113.069046 
	C255.795349,111.756378 255.672195,110.595169 255.271805,109.219124 
	C254.866302,108.838249 254.738037,108.672218 254.781128,108.242218 
	C255.545044,107.491646 256.137604,107.005035 256.863403,106.258934 
z"/>
<path fill="#2D2F36" opacity="1.000000" stroke="none" 
	d="
M244.971069,104.366730 
	C245.124222,103.131058 245.290939,102.286308 245.721558,101.252869 
	C245.537704,104.123184 247.083893,107.463181 244.739166,110.582939 
	C243.465027,108.347237 245.592880,106.625526 244.971069,104.366730 
z"/>
<path fill="#2D2F36" opacity="1.000000" stroke="none" 
	d="
M254.582001,108.028572 
	C254.960739,108.149193 254.969009,108.320137 254.985931,108.747681 
	C253.207031,110.721855 251.122314,109.870369 247.834686,109.785339 
	C250.765137,109.001144 252.488327,108.540016 254.582001,108.028572 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M254.475708,115.962273 
	C253.923203,114.710304 253.931396,113.522964 255.587234,112.967697 
	C255.918503,112.917580 255.972900,112.971535 256.001465,112.997086 
	C257.060059,114.421440 256.286743,115.306084 254.475708,115.962273 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M252.895416,117.850616 
	C253.015274,117.238853 253.194321,116.721657 253.584473,116.020111 
	C253.795609,115.835762 253.972946,115.976501 254.061920,116.046509 
	C254.576233,116.833275 254.455078,117.463394 253.492004,118.047028 
	C253.134384,118.077324 252.954605,117.945183 252.895416,117.850616 
z"/>
<path fill="#2D2F36" opacity="1.000000" stroke="none" 
	d="
M242.137543,113.945068 
	C242.091904,113.963554 242.183197,113.926575 242.137543,113.945068 
z"/>
<path fill="#2D2F36" opacity="1.000000" stroke="none" 
	d="
M241.999695,113.999695 
	C241.906952,114.033852 241.814499,114.068314 241.861328,114.051651 
	C242.000610,114.000526 242.000000,114.000000 241.999695,113.999695 
z"/>
<path fill="#5B595B" opacity="1.000000" stroke="none" 
	d="
M411.363861,251.295319 
	C410.820343,250.366470 410.820862,249.571533 410.425476,249.136047 
	C406.240875,244.526978 407.095795,240.300720 411.179321,236.165222 
	C411.691498,235.646484 411.735352,234.665314 412.005859,233.540253 
	C414.078308,230.918488 416.740326,231.690735 419.665009,231.820236 
	C423.398224,233.043106 426.520142,235.223526 430.734009,233.968750 
	C431.664490,234.018585 432.174957,234.160934 432.981934,234.635605 
	C433.363647,240.123276 433.453033,245.362427 434.173309,250.890320 
	C426.538788,252.700378 419.129517,252.027695 411.363861,251.295319 
z"/>
<path fill="#4A4546" opacity="1.000000" stroke="none" 
	d="
M462.242859,257.702148 
	C460.939758,257.994110 459.867676,257.998901 458.393250,258.009155 
	C456.212616,257.892609 454.357880,258.338989 452.352356,257.149109 
	C450.995850,255.846924 450.722687,254.517502 451.153931,252.661087 
	C452.330444,250.400894 454.268555,250.492859 456.099731,250.394638 
	C453.837158,250.370834 451.748901,251.420258 449.138062,250.582336 
	C444.245270,245.761597 442.791565,240.035736 443.033081,233.348251 
	C444.113556,230.902405 446.047485,230.417984 448.395782,229.878357 
	C449.636200,229.781143 450.442719,229.891418 451.581512,230.319351 
	C454.237701,232.920456 454.167358,236.239441 455.171021,239.155289 
	C456.359100,242.606903 457.433014,246.130051 461.589020,247.217392 
	C462.847321,247.546585 463.891266,248.373886 463.353760,249.663193 
	C462.293762,252.205963 463.604187,254.938171 462.242859,257.702148 
z"/>
<path fill="#606569" opacity="1.000000" stroke="none" 
	d="
M410.638519,251.005463 
	C418.468689,250.770203 425.950745,251.480103 433.701782,250.294769 
	C438.367126,247.463104 442.929626,248.804474 447.806213,249.587097 
	C448.449677,250.389618 448.539398,250.962677 448.212555,251.958725 
	C444.051422,254.181198 440.036926,255.241333 435.389008,253.298599 
	C426.954559,253.012436 418.880829,253.015671 410.807312,252.972107 
	C409.935394,252.967407 408.660095,253.278915 408.679108,251.793976 
	C408.682526,251.528046 409.715668,251.275284 410.638519,251.005463 
z"/>
<path fill="#74909F" opacity="1.000000" stroke="none" 
	d="
M421.348114,232.801804 
	C418.259552,232.889709 415.580536,232.968460 412.458557,233.114639 
	C410.596039,233.137787 409.176514,233.093491 407.326599,233.041809 
	C408.067993,231.372513 410.617920,232.536758 411.871582,230.391006 
	C415.692108,227.292709 420.253540,227.939270 424.742767,226.781403 
	C425.654816,226.697403 426.174805,226.671066 427.077515,226.632477 
	C428.226379,226.581818 428.981903,226.485596 430.089417,226.133789 
	C431.246063,225.848572 432.036926,225.749069 433.246338,225.682739 
	C435.565338,225.844131 437.732758,225.497025 438.396423,228.456223 
	C433.122192,231.527725 427.295044,231.548584 421.348114,232.801804 
z"/>
<path fill="#534F51" opacity="1.000000" stroke="none" 
	d="
M435.034576,253.431030 
	C439.137726,253.572479 443.079407,252.166245 447.555542,251.977173 
	C448.991730,251.170044 450.092255,250.946564 451.650177,251.711472 
	C451.994629,253.383194 451.996613,254.772369 452.000458,256.578064 
	C447.078125,256.648193 442.155151,256.281738 437.228821,255.968094 
	C435.828369,255.878922 435.104950,255.233002 435.034576,253.431030 
z"/>
<path fill="#2D2F36" opacity="1.000000" stroke="none" 
	d="
M348.309204,163.886917 
	C344.060089,164.897278 339.756531,166.956818 338.054962,160.444870 
	C337.246857,159.216354 336.871033,158.214737 336.998596,156.651428 
	C338.491028,152.786453 341.960602,152.433350 345.188416,151.016174 
	C347.540253,150.487335 349.278931,149.081238 351.785645,149.594635 
	C353.464966,151.836823 353.621826,154.705978 356.394958,156.290604 
	C356.719513,157.067780 356.764801,157.544693 356.626465,158.376526 
	C356.387634,158.917587 356.250732,159.112289 355.823669,159.508255 
	C352.784943,160.305969 350.832367,162.254211 348.309204,163.886917 
z"/>
<path fill="#4D4E51" opacity="1.000000" stroke="none" 
	d="
M337.504791,155.509766 
	C337.901428,156.867554 337.985077,158.032455 338.041595,159.637787 
	C333.839813,161.226959 329.971619,162.914032 327.009277,166.646606 
	C324.683990,170.659225 322.372925,174.277100 317.499969,175.299866 
	C317.186523,175.122604 317.062866,175.018036 316.997284,174.970551 
	C316.629761,174.515137 316.528839,174.058258 316.815857,173.264130 
	C317.031952,172.968719 316.983551,172.990829 316.985596,173.017365 
	C317.684631,168.540009 321.006989,165.817398 324.165894,162.562073 
	C327.294678,159.429565 330.668182,157.270889 334.682861,155.427322 
	C335.747528,155.111862 336.470520,155.109146 337.504791,155.509766 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M317.038635,175.370636 
	C321.312683,173.683853 323.061157,169.551773 326.614319,167.038513 
	C329.129608,167.496582 331.315308,168.006836 334.912872,168.846680 
	C328.406494,172.299637 323.039795,175.147751 317.292969,178.001160 
	C315.835510,177.220459 316.331696,176.419846 317.038635,175.370636 
z"/>
<path fill="#8EC1D2" opacity="1.000000" stroke="none" 
	d="
M342.735565,173.244904 
	C343.540558,172.489090 344.144592,172.003967 344.868896,171.248260 
	C346.304077,169.150833 347.788483,167.474564 349.764160,165.821014 
	C351.716858,165.794174 353.029358,166.776367 354.772400,167.550476 
	C355.775574,170.173004 353.722382,170.922684 352.173706,172.338989 
	C351.021637,173.199875 350.188568,173.916885 348.860107,175.063751 
	C348.139374,175.556503 347.942413,175.653244 347.436218,175.861877 
	C346.494415,176.163879 345.849274,176.297470 344.864838,176.426025 
	C344.312347,176.403198 344.093048,176.358032 343.590515,176.129974 
	C342.987549,175.624130 342.737488,175.253265 342.480896,174.510315 
	C342.454773,173.957977 342.494690,173.736786 342.735565,173.244904 
z"/>
<path fill="#44454A" opacity="1.000000" stroke="none" 
	d="
M350.375854,165.886627 
	C348.991669,168.016663 347.790161,169.863739 345.313477,170.905182 
	C344.330872,168.122437 347.348846,166.984024 347.954773,164.350464 
	C349.200714,161.284821 351.312408,159.684631 354.523804,158.997437 
	C355.164581,162.283417 352.792999,163.921158 350.375854,165.886627 
z"/>
<path fill="#8EC1D2" opacity="1.000000" stroke="none" 
	d="
M341.437439,178.134033 
	C340.936188,177.487457 340.784088,176.948029 340.414368,176.228363 
	C340.356140,175.751083 340.515503,175.454025 340.819275,174.944519 
	C341.143707,174.652817 341.323700,174.573593 341.793610,174.548019 
	C342.518982,174.995758 342.966888,175.372299 343.739197,175.796936 
	C343.969788,175.976593 344.001373,176.004730 344.016479,176.019562 
	C344.257965,177.761551 343.000519,177.979202 341.437439,178.134033 
z"/>
<path fill="#44454A" opacity="1.000000" stroke="none" 
	d="
M342.137390,174.835449 
	C341.870331,174.824066 341.414368,174.805344 341.189056,174.768707 
	C341.048248,173.863174 341.428864,173.232849 342.636780,173.000900 
	C342.936523,172.974228 342.975525,173.457825 342.971283,173.700378 
	C342.807129,174.261414 342.620758,174.563446 342.137390,174.835449 
z"/>
<path fill="#88A7B5" opacity="1.000000" stroke="none" 
	d="
M313.090393,153.399719 
	C313.460022,151.159744 313.872223,149.303329 314.357422,147.118149 
	C310.355804,147.158386 309.094116,151.517792 305.370178,152.044464 
	C304.375580,151.526993 304.120850,150.840073 304.067932,149.681061 
	C304.073883,149.061462 304.087433,148.815140 304.161285,148.206268 
	C305.050507,144.890457 306.614288,142.605560 309.248657,140.796600 
	C313.154205,138.114777 315.478424,134.136673 316.961914,129.279907 
	C317.272400,128.238190 317.628662,127.619942 318.335938,126.811127 
	C319.582458,125.744934 320.801147,125.404137 322.080200,124.980423 
	C320.672668,125.059479 319.393005,125.778648 317.786591,124.973495 
	C317.190002,124.027969 317.149292,123.307480 317.505249,122.220604 
	C318.611053,120.892235 319.875397,120.553070 321.468445,120.017410 
	C323.873108,119.608437 325.813080,118.757561 328.301819,118.934601 
	C328.931061,119.068153 329.175690,119.150505 329.743408,119.445107 
	C330.972778,120.819252 330.635223,122.063660 330.196350,123.661835 
	C329.639008,125.163750 328.903503,126.122971 327.891663,127.314590 
	C326.547974,128.901138 324.736847,130.030746 326.260254,132.140030 
	C327.592590,133.984680 328.757202,132.832748 330.165558,131.639801 
	C332.117889,130.186234 333.752686,128.873444 335.903564,127.701370 
	C336.496155,127.656418 336.736816,127.703445 337.238800,128.013489 
	C338.991669,131.749420 336.280640,133.752533 334.720734,136.138489 
	C333.172241,138.507050 330.800659,140.095490 328.624207,142.394196 
	C326.508118,144.131012 324.458832,145.005219 321.696899,144.662292 
	C319.318268,141.482178 321.464508,140.396988 324.273376,138.690063 
	C320.626038,139.834900 318.174225,140.959732 318.659851,145.164642 
	C318.743805,148.797501 317.436920,151.699188 315.740601,154.814301 
	C314.157593,155.573059 313.560364,154.832443 313.090393,153.399719 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M308.258362,168.848724 
	C307.743195,168.968948 307.525116,168.933945 306.983215,168.824875 
	C307.584320,166.637436 308.509308,164.524063 309.693298,162.192551 
	C310.284210,161.647232 310.685944,161.472015 311.478577,161.503479 
	C312.444092,161.971008 312.696381,162.585007 312.818359,163.621750 
	C312.789795,164.187210 312.752655,164.411575 312.603638,164.957977 
	C312.293274,165.688599 312.068176,166.081970 311.614471,166.732758 
	C310.636597,167.866714 309.708405,168.470322 308.258362,168.848724 
z"/>
<path fill="#7AAABF" opacity="1.000000" stroke="none" 
	d="
M304.511719,148.654541 
	C304.879211,149.477417 304.937805,150.328888 305.003235,151.607544 
	C303.806335,153.880798 301.759979,154.007553 299.535889,154.584061 
	C299.118622,154.114059 299.075226,153.594467 299.028564,152.685272 
	C299.179688,152.229004 299.334045,152.162354 299.735748,152.046173 
	C300.708191,151.285736 301.708344,151.656219 302.731506,151.072937 
	C302.927307,150.798431 302.984955,150.459732 303.035095,150.295425 
	C303.364227,149.576279 303.655060,149.030579 304.511719,148.654541 
z"/>
<path fill="#88A7B5" opacity="1.000000" stroke="none" 
	d="
M312.373230,161.862305 
	C311.541718,161.978668 311.087646,161.984695 310.292938,161.982574 
	C310.563293,160.529572 311.174286,159.084732 311.930298,157.334442 
	C312.677338,156.441513 313.398163,156.229294 314.583282,156.508377 
	C316.401215,159.306671 314.304504,160.412308 312.373230,161.862305 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M315.092346,156.776123 
	C314.148102,157.039413 313.456879,157.025696 312.420471,157.020493 
	C312.228729,155.856796 312.382141,154.684586 312.791687,153.264267 
	C313.552399,153.615128 314.056976,154.214081 314.829895,154.942963 
	C315.386444,155.512634 315.468781,155.988037 315.092346,156.776123 
z"/>
<path fill="#18A6E3" opacity="1.000000" stroke="none" 
	d="
M382.567383,305.536743 
	C383.896423,305.401581 383.929169,306.145325 383.740936,306.944153 
	C383.707214,307.087280 383.216156,307.280334 383.043884,307.204803 
	C382.421448,306.931976 382.163239,306.410767 382.567383,305.536743 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M379.301208,301.680115 
	C379.014740,300.797150 379.012390,299.745331 379.039856,298.411102 
	C380.724701,299.030060 380.226501,300.259766 379.301208,301.680115 
z"/>
<path fill="#333237" opacity="1.000000" stroke="none" 
	d="
M418.038147,332.112274 
	C418.628174,331.967773 419.188354,331.795135 419.924042,331.379333 
	C420.772888,331.146027 421.446289,331.155914 422.455261,331.205048 
	C430.498718,335.014618 438.882538,337.272034 446.599182,341.881958 
	C452.436798,344.346558 457.727417,347.074677 462.817017,350.832764 
	C463.339661,351.005066 463.547913,351.070496 464.042603,351.285797 
	C464.855408,351.777100 465.344696,352.170593 466.112091,352.690308 
	C466.528534,352.963074 466.692780,353.073212 467.094299,353.354401 
	C467.484192,353.641876 467.636780,353.758270 468.252258,354.195526 
	C469.039429,354.693878 469.368561,354.861725 469.957489,355.126770 
	C470.537018,355.401520 470.842804,355.597870 471.311218,356.020020 
	C471.607941,356.343536 471.717926,356.478210 472.153412,357.002197 
	C472.723022,357.621155 472.983002,357.831116 473.482117,358.149231 
	C473.854980,358.367004 474.004272,358.457428 474.369873,358.703491 
	C474.725616,358.975098 474.865051,359.091034 475.406372,359.597748 
	C475.931702,360.136261 476.055176,360.284027 476.340210,360.678894 
	C476.584320,361.108826 476.666901,361.291718 476.840271,361.765625 
	C477.149750,363.078918 477.386902,364.097198 477.609680,365.455994 
	C477.386017,367.468475 476.088806,367.968475 474.375000,368.449341 
	C473.791229,368.476898 473.557587,368.449615 473.014252,368.256165 
	C470.498444,365.025726 468.595642,361.405182 463.474609,363.435333 
	C462.924347,364.072266 462.658875,364.497253 462.558472,364.977234 
	C461.275085,371.113983 461.278595,371.114716 454.619324,371.380676 
	C450.305908,371.243652 446.551880,370.187256 442.409698,369.187805 
	C441.601349,368.913666 441.170349,368.703491 440.490479,368.242523 
	C439.735321,367.596588 439.344055,367.072998 438.483673,366.139771 
	C437.906738,365.548096 437.766235,365.395142 437.442810,364.988647 
	C437.039856,364.375549 436.835724,364.007233 436.505981,363.337921 
	C436.286621,362.839325 436.208069,362.633209 436.030518,362.107666 
	C435.287689,358.114319 431.396973,357.914795 429.353882,355.697174 
	C427.715118,353.918427 425.589874,352.597351 423.161987,351.226074 
	C422.655914,350.983307 422.460297,350.875580 421.993347,350.577332 
	C421.071106,349.827118 420.476807,349.194214 419.389221,348.684601 
	C412.679810,346.457214 411.404480,346.950256 407.585114,353.196991 
	C406.821014,353.985992 406.193054,354.319153 405.100769,354.256836 
	C403.991791,351.628906 403.224030,349.138916 402.279144,346.344910 
	C401.118042,345.035065 401.646606,344.217072 402.748962,343.223602 
	C403.071533,343.016907 403.012726,342.993378 403.009949,343.024933 
	C403.215210,342.800446 403.439819,342.559906 403.867798,342.173157 
	C404.054504,342.011505 403.998047,341.997375 404.000336,342.026367 
	C404.419647,341.578857 405.026733,341.530426 405.818573,341.188080 
	C406.059265,341.020172 406.000671,341.000458 406.001953,341.031311 
	C406.211456,340.804413 406.436737,340.562561 406.865906,340.173462 
	C407.052734,340.010254 406.995331,340.002319 407.002533,340.030396 
	C407.785095,339.388672 408.691223,338.915619 409.802185,338.198181 
	C410.054810,338.025665 410.002167,338.000183 410.006226,338.029114 
	C410.214569,337.801453 410.436920,337.561646 410.863220,337.178284 
	C411.049042,337.017914 410.996857,337.002960 411.006470,337.028351 
	C412.234131,336.229340 413.273102,335.168976 414.785583,334.210815 
	C415.045959,334.032257 415.007141,333.996399 415.008698,334.022736 
	C415.424713,333.574860 416.029327,333.530670 416.814636,333.188263 
	C417.052826,333.019989 416.999573,332.998993 417.002197,333.027496 
	C417.208435,332.796783 417.436859,332.561707 417.868652,332.181335 
	C418.047241,332.011932 418.008301,332.084137 418.038147,332.112274 
z"/>
<path fill="#2D2F36" opacity="1.000000" stroke="none" 
	d="
M404.758728,354.507507 
	C405.419281,353.769104 406.079010,353.419281 407.080170,352.918121 
	C411.346954,346.663116 412.689606,346.116669 419.275757,348.236389 
	C420.278870,348.694366 420.924011,349.036255 421.749329,349.767944 
	C422.012054,350.019470 422.000580,349.998077 421.988861,349.994690 
	C427.246094,353.689728 432.837708,357.010956 436.800781,362.760315 
	C437.016876,363.032318 437.001526,362.998962 436.989380,362.985229 
	C437.411835,363.417236 437.470428,364.020325 437.831451,364.803162 
	C438.015167,365.032623 438.001984,365.002258 437.988708,364.992371 
	C438.149475,365.215546 438.323547,365.448578 438.677307,366.079193 
	C440.036926,374.111694 438.866364,375.657745 431.415436,375.323212 
	C424.799225,375.026123 418.281342,373.751587 411.342773,372.724792 
	C410.648743,372.835510 410.369324,372.861450 409.675293,372.866943 
	C408.996399,372.782532 408.732117,372.718567 408.112183,372.466736 
	C405.012360,369.410370 406.013428,365.522919 404.954590,361.822510 
	C404.822540,360.759827 404.808563,360.053131 404.905273,358.666382 
	C404.914764,356.956787 404.836304,355.926422 404.758728,354.507507 
z"/>
<path fill="#05B2F9" opacity="1.000000" stroke="none" 
	d="
M405.545074,359.545715 
	C407.548279,363.375183 406.057892,367.721497 408.573181,371.494873 
	C408.732452,372.339111 408.938934,372.692261 409.513306,373.257202 
	C409.858704,374.296234 409.808990,375.001099 409.293884,375.973145 
	C405.049530,377.016998 404.841217,371.968475 401.395935,371.201416 
	C398.397156,365.626404 395.686493,360.268158 392.947021,354.558228 
	C395.144836,350.783783 399.880188,351.009552 402.648865,354.781067 
	C403.298584,355.666107 403.296844,357.000275 404.685150,357.831055 
	C404.993195,357.987152 405.010223,358.004944 405.007019,358.016113 
	C405.296417,358.371124 405.462830,358.767822 405.545074,359.545715 
z"/>
<path fill="#72C2DC" opacity="1.000000" stroke="none" 
	d="
M402.729950,343.011688 
	C402.768341,343.807068 402.465149,344.597229 402.132019,345.714172 
	C401.125671,345.545532 400.914642,344.651428 400.958435,343.327576 
	C401.495361,342.991150 401.941864,342.998810 402.729950,343.011688 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M414.710388,334.038147 
	C414.615234,335.803589 413.094269,336.387634 411.356812,337.080383 
	C411.659454,335.519104 412.796875,334.535797 414.710388,334.038147 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M409.722534,338.028625 
	C409.634644,339.146240 408.697723,339.657867 407.336609,340.056671 
	C407.386047,338.892914 408.205383,338.247620 409.722534,338.028625 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M405.747925,341.026733 
	C405.582642,341.385254 405.106049,341.750305 404.316040,342.085388 
	C404.480591,341.714661 404.958557,341.373962 405.747925,341.026733 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M416.740967,333.021759 
	C416.579956,333.393921 416.107056,333.767853 415.322205,334.095428 
	C415.483215,333.707214 415.956177,333.365356 416.740967,333.021759 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M406.803162,340.100098 
	C406.880646,340.314087 406.708588,340.617889 406.269897,340.991943 
	C406.186737,340.771454 406.370178,340.480682 406.803162,340.100098 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M403.808655,342.103790 
	C403.892212,342.324554 403.729919,342.637573 403.287415,343.003540 
	C403.192413,342.769684 403.377625,342.482880 403.808655,342.103790 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M417.797485,332.099274 
	C417.877686,332.314362 417.708099,332.616791 417.271729,332.987610 
	C417.185822,332.766205 417.366760,332.476410 417.797485,332.099274 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M410.796021,337.098572 
	C410.890472,337.332397 410.731903,337.646881 410.291809,338.009705 
	C410.187805,337.765137 410.365387,337.472198 410.796021,337.098572 
z"/>
<path fill="#BEDBE2" opacity="1.000000" stroke="none" 
	d="
M364.491302,182.394272 
	C359.521057,186.080734 354.923492,189.895706 351.287170,195.199722 
	C350.944305,194.240173 350.863922,193.018265 350.606384,191.492630 
	C350.406982,190.703140 350.384674,190.217361 350.315613,189.363464 
	C353.474030,186.841675 358.206787,186.502762 359.068207,181.197510 
	C358.385590,178.909958 359.433594,177.506607 360.727112,175.868439 
	C361.736969,175.392426 362.415588,175.471390 363.257355,176.181137 
	C364.012665,179.654373 366.069458,176.164703 367.411560,177.376312 
	C367.908844,177.628586 368.083618,177.770645 368.384521,178.223526 
	C368.630066,179.515747 368.121368,180.206650 367.210175,181.030869 
	C366.635437,181.497086 366.292389,181.741318 365.667755,182.126190 
	C365.196838,182.339661 364.997070,182.397766 364.491302,182.394272 
z"/>
<path fill="#607584" opacity="1.000000" stroke="none" 
	d="
M361.288116,175.702698 
	C360.962128,177.652832 360.311462,179.019547 359.223877,180.547546 
	C356.228302,180.892975 353.902588,184.781403 350.117432,181.414124 
	C349.451294,180.677872 349.354858,180.447189 349.217010,179.846588 
	C350.502563,175.081772 354.030853,175.215881 357.583435,175.375702 
	C358.247711,175.405579 357.315613,175.385193 357.954041,175.230225 
	C358.252747,175.157715 358.102875,174.797943 357.579895,174.320831 
	C357.984741,172.327042 359.166199,172.162567 360.926941,172.693237 
	C361.762360,173.685242 361.813995,174.493164 361.288116,175.702698 
z"/>
<path fill="#88A7B5" opacity="1.000000" stroke="none" 
	d="
M357.415192,174.354156 
	C358.054871,175.007080 360.367584,175.163162 357.950378,175.933350 
	C355.210144,176.806473 351.696899,175.853622 349.982666,179.659805 
	C349.741608,180.171295 349.556488,180.305511 349.047852,180.554352 
	C345.649109,181.043610 343.134705,184.182114 339.370361,182.304565 
	C339.321320,181.585754 339.546326,181.074066 339.895294,180.308823 
	C340.434204,179.614456 340.502960,179.036194 340.832703,178.271500 
	C341.023163,178.057053 341.050201,178.034363 341.069275,178.030640 
	C341.955536,177.528000 342.822754,177.029083 343.860748,176.282272 
	C344.831879,175.706863 345.632202,175.379364 346.759338,175.046722 
	C347.248444,175.155685 347.410736,175.269760 347.784851,175.174896 
	C347.996704,174.965942 347.999542,175.004211 347.983459,174.993759 
	C348.686615,174.515060 349.470032,174.191284 350.705078,173.846405 
	C353.122162,173.488754 355.110077,173.466888 357.415192,174.354156 
z"/>
<path fill="#8FD2E7" opacity="1.000000" stroke="none" 
	d="
M348.973694,188.470978 
	C344.901581,190.497528 340.828400,192.180511 336.393219,193.885239 
	C335.715424,191.651184 336.348236,190.180252 338.822021,189.509460 
	C341.525787,188.776352 344.122406,187.635300 346.743591,186.615143 
	C348.294586,186.011505 348.915070,186.613342 348.973694,188.470978 
z"/>
<path fill="#74909F" opacity="1.000000" stroke="none" 
	d="
M339.067322,182.313416 
	C342.840759,183.262619 345.197845,179.044617 349.000427,179.870895 
	C349.450745,180.384018 349.654022,180.651215 349.951782,181.160629 
	C350.073639,181.381775 350.102417,181.402115 350.104706,181.410522 
	C350.051270,183.935074 349.381622,185.778152 346.295319,184.618286 
	C344.216064,183.836868 342.062775,184.095261 339.501526,183.948914 
	C338.930054,183.778885 338.791504,183.625381 338.831268,183.218079 
	C339.009552,182.964279 339.038330,182.529388 339.067322,182.313416 
z"/>
<path fill="#8EC1D2" opacity="1.000000" stroke="none" 
	d="
M340.768188,178.212708 
	C340.848846,178.606613 340.674530,179.156174 340.259735,179.880493 
	C340.183929,179.492966 340.348572,178.930664 340.768188,178.212708 
z"/>
<path fill="#88A7B5" opacity="1.000000" stroke="none" 
	d="
M338.844299,183.062622 
	C339.009552,182.964279 339.038025,183.448959 339.053284,183.690674 
	C338.668549,183.811691 338.323517,183.663223 338.844299,183.062622 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M286.268982,149.975037 
	C284.466400,148.540771 282.588989,149.112442 280.899658,149.121811 
	C278.588501,149.134613 277.689056,148.122253 277.814636,145.520615 
	C277.644470,140.981323 277.094666,136.847626 278.323120,132.365021 
	C283.298950,128.640457 288.858734,128.950500 294.661011,128.566010 
	C300.020721,130.242767 305.582733,131.197281 306.385010,138.317291 
	C307.029846,140.477631 306.379578,142.003479 305.035583,143.662689 
	C304.174042,144.350220 303.519897,144.424927 302.539551,144.003418 
	C301.960724,143.532349 301.710663,143.193832 301.362457,142.554077 
	C300.963409,141.983368 300.702393,141.688599 300.216339,141.212799 
	C299.746857,140.741623 299.479309,140.472183 299.038513,140.035797 
	C298.866852,139.867264 298.673584,139.623779 298.692993,139.591003 
	C298.712372,139.558243 298.834717,139.897949 299.003845,140.031128 
	C299.402313,140.408585 299.637787,140.646790 300.089600,141.092880 
	C300.598572,141.602432 300.879944,141.914062 301.307190,142.536133 
	C301.514740,143.060791 301.563690,143.286575 301.602661,143.865143 
	C298.159119,148.926193 292.459259,147.789917 287.561890,149.715332 
	C287.029785,149.918945 286.812988,149.943542 286.268982,149.975037 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M287.660919,149.856903 
	C290.953491,145.825089 297.265991,148.001755 301.146423,143.784866 
	C301.289001,143.146179 301.341766,142.855835 301.691010,142.894165 
	C302.490814,143.475647 302.994141,143.728455 303.775269,144.030029 
	C304.718506,144.278198 305.119537,144.735382 305.290253,145.702423 
	C304.858032,146.577728 304.294495,146.847610 303.319183,146.936005 
	C298.069244,148.111572 293.394257,150.618332 287.660919,149.856903 
z"/>
<path fill="#3A424A" opacity="1.000000" stroke="none" 
	d="
M302.997559,147.314896 
	C303.464142,146.605606 303.929352,146.299149 304.686340,146.006256 
	C305.358276,146.405792 305.506561,146.866547 305.199005,147.709641 
	C304.974396,148.017456 304.828430,148.305954 304.824524,148.465942 
	C304.425995,149.059967 304.031311,149.494003 303.360962,150.029572 
	C303.055542,149.326645 303.025879,148.522186 302.997559,147.314896 
z"/>
<path fill="#5CA0BC" opacity="1.000000" stroke="none" 
	d="
M302.587982,150.831970 
	C302.530548,151.858063 301.624969,151.965698 300.331543,151.998108 
	C300.372192,150.886383 301.412292,151.079971 302.587982,150.831970 
z"/>
<path fill="#A2CEDF" opacity="1.000000" stroke="none" 
	d="
M308.177307,169.067459 
	C308.906952,168.156296 309.852631,167.308609 310.917297,166.160522 
	C311.215088,165.721970 311.393890,165.583786 311.820282,165.214081 
	C312.067841,164.982529 311.994659,165.005280 312.005737,165.041962 
	C318.149841,160.288712 322.952850,154.080170 329.361938,149.076996 
	C333.932404,149.055481 335.868683,151.160858 335.259216,155.705933 
	C331.932343,158.329819 328.258698,159.783493 325.322266,162.859924 
	C321.664459,165.854156 317.593414,167.156342 313.185669,168.535828 
	C311.809357,169.058487 310.724304,169.405518 309.296814,169.776093 
	C308.873383,169.487823 308.686401,169.264923 308.177307,169.067459 
z"/>
<path fill="#88A7B5" opacity="1.000000" stroke="none" 
	d="
M313.278198,168.835571 
	C315.489502,164.400681 320.884430,165.681183 324.661560,163.010468 
	C322.673096,166.341476 319.087463,168.705841 317.262146,172.848129 
	C316.894806,170.855408 316.746002,168.712509 313.278198,168.835571 
z"/>
<path fill="#88A7B5" opacity="1.000000" stroke="none" 
	d="
M316.766846,173.075623 
	C317.000183,173.403015 316.968414,173.837296 316.934143,174.597336 
	C316.005737,174.536240 315.938538,173.937256 316.766846,173.075623 
z"/>
<path fill="#2C2528" opacity="1.000000" stroke="none" 
	d="
M253.182495,118.472557 
	C253.438416,117.611748 253.742462,117.146179 254.098694,116.398560 
	C255.088989,115.540848 255.731674,114.748077 255.996002,113.337433 
	C258.601227,109.980392 262.435028,111.672852 265.752319,110.190170 
	C267.559875,108.833580 269.020599,108.762955 270.446289,110.689743 
	C270.442566,114.224037 268.244812,116.568413 267.106995,119.732925 
	C266.115692,121.358177 265.033356,121.537193 263.432007,120.612122 
	C259.928955,119.233810 256.202576,121.475555 253.182495,118.472557 
z"/>
<path fill="#5CA0BC" opacity="1.000000" stroke="none" 
	d="
M253.426620,133.986420 
	C252.721802,133.265106 252.376038,132.493195 252.012756,131.405884 
	C254.056046,130.113556 256.116882,129.136658 258.777893,128.079483 
	C260.677734,130.082993 262.922882,128.698883 264.873077,129.606964 
	C266.854065,132.619476 262.335297,133.009018 262.989075,135.741898 
	C263.026825,136.073364 262.967651,136.441879 262.938293,136.625519 
	C261.144562,137.270020 259.380219,137.730865 257.207458,138.218124 
	C256.800385,136.656418 258.729919,135.183273 257.424225,133.621048 
	C256.327209,132.308456 255.011993,133.777512 253.426620,133.986420 
z"/>
<path fill="#333237" opacity="1.000000" stroke="none" 
	d="
M259.094727,126.917267 
	C257.147858,126.918953 255.497314,127.106850 253.886383,126.931252 
	C252.826431,126.815720 250.870422,127.957573 250.884888,125.785965 
	C250.893951,124.427536 251.582092,122.444542 253.100174,122.300446 
	C256.008209,122.024414 259.145599,120.877220 261.916687,123.896317 
	C261.910583,125.033569 261.767120,125.432472 261.364441,126.059631 
	C260.646393,126.706589 260.062195,126.924255 259.094727,126.917267 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M263.092926,120.734978 
	C263.937958,120.336456 264.751862,120.265984 265.747681,120.036606 
	C266.329071,119.606636 266.767426,119.450775 267.596313,119.512032 
	C269.632019,120.508530 270.328735,122.415955 272.040222,123.805809 
	C272.024170,126.003113 270.440063,126.176994 268.716095,126.664238 
	C268.123230,126.674706 267.889526,126.646812 267.338104,126.480148 
	C266.169434,124.987717 265.736542,123.142067 263.254272,123.217651 
	C263.003571,122.392067 263.032654,121.727539 263.092926,120.734978 
z"/>
<path fill="#44454A" opacity="1.000000" stroke="none" 
	d="
M262.889099,123.284317 
	C264.340546,122.311668 265.765686,121.246269 267.283508,122.418800 
	C268.256378,123.170364 267.204041,124.097130 266.893799,125.256920 
	C266.726044,125.831299 266.630524,126.081284 266.193665,126.545731 
	C265.070374,127.040810 264.270477,127.078896 263.071167,126.809402 
	C261.897064,126.251030 261.557800,125.567871 261.769135,124.342560 
	C261.975555,123.994469 261.994324,123.994202 261.986694,123.984497 
	C262.330841,123.957512 262.605743,123.803268 262.889099,123.284317 
z"/>
<path fill="#5CA0BC" opacity="1.000000" stroke="none" 
	d="
M258.819794,127.110939 
	C259.315247,126.582504 259.848877,126.279549 260.690430,125.915955 
	C261.657990,126.130539 262.295410,126.472733 263.390808,126.592842 
	C263.914581,126.847290 264.075409,127.037521 264.141663,127.594666 
	C262.781433,129.265167 261.315521,129.242966 259.445190,128.372650 
	C259.133148,128.135880 258.954926,127.959915 258.862366,127.872574 
	C258.769775,127.785225 258.858002,127.336426 258.819794,127.110939 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M277.304871,144.826569 
	C276.117462,145.740479 275.149658,146.302002 273.825623,146.916550 
	C269.099304,144.604492 267.548431,140.299408 265.902161,135.624664 
	C267.179077,132.177185 270.137207,132.870163 272.934845,132.309082 
	C273.595917,132.410965 273.855896,132.488937 274.465332,132.782867 
	C278.343658,136.203934 278.460693,140.214706 277.304871,144.826569 
z"/>
<path fill="#7AAABF" opacity="1.000000" stroke="none" 
	d="
M273.228424,132.485306 
	C270.823608,133.484161 268.618408,134.174957 266.137329,135.041534 
	C265.162445,135.469330 264.463379,135.721344 263.395569,136.023346 
	C260.954010,135.097168 259.271606,134.117386 262.724304,132.617905 
	C263.581879,132.245468 264.549072,131.876740 264.922913,130.487823 
	C265.419159,128.910141 266.487244,128.281494 267.867737,127.476395 
	C268.948547,127.133110 269.681335,127.162186 270.733398,127.576294 
	C272.202179,129.039902 273.388184,130.301575 273.228424,132.485306 
z"/>
<path fill="#3A424A" opacity="1.000000" stroke="none" 
	d="
M277.262177,145.154022 
	C277.040039,141.127869 277.232697,137.015259 274.063721,133.399780 
	C274.916382,130.984375 276.498932,130.799316 278.706390,131.798645 
	C278.678040,136.245193 279.589630,140.440491 278.123413,144.823257 
	C277.795563,145.104736 277.439087,145.129089 277.262177,145.154022 
z"/>
<path fill="#1B222E" opacity="1.000000" stroke="none" 
	d="
M379.272125,387.594818 
	C379.397064,387.227570 379.768768,387.178711 379.898590,387.043488 
	C381.327698,385.618073 382.518707,384.168823 384.817047,383.774811 
	C385.579071,383.580750 386.019073,383.495819 386.729553,383.226471 
	C386.996979,383.026215 387.006683,383.010742 387.015442,383.008331 
	C387.728882,382.304352 388.678040,382.621765 389.757385,382.209473 
	C390.014130,382.007141 389.999084,381.998779 389.999695,382.007263 
	C390.710297,381.307098 391.666473,381.619354 392.756348,381.208954 
	C393.014984,381.004425 392.998779,380.997559 392.997803,381.006165 
	C394.686707,379.988953 396.565674,380.786438 398.649902,380.241760 
	C400.469604,381.906891 401.967743,383.792236 403.723572,385.885559 
	C405.633423,387.388092 405.978668,389.507721 407.147675,391.116943 
	C408.222931,392.597046 409.004547,394.376373 411.634521,394.116943 
	C412.191376,394.104462 412.413910,394.112457 412.961182,394.185913 
	C413.485321,394.340759 413.684723,394.430176 414.126953,394.735626 
	C414.852509,395.658569 415.060486,396.484375 415.483643,397.548767 
	C415.658051,398.022919 415.720154,398.213959 415.852844,398.694824 
	C416.035980,399.556274 416.112885,400.134857 416.346313,400.971161 
	C416.492981,401.422546 416.552490,401.602600 416.694885,402.054169 
	C416.929016,402.869904 417.056580,403.420929 417.352692,404.221252 
	C417.530884,404.669617 417.601624,404.851196 417.768860,405.312073 
	C418.048676,406.169220 418.218384,406.751465 418.545837,407.622894 
	C418.720795,408.140228 418.781647,408.354095 418.895203,408.904541 
	C418.983795,410.467682 418.797729,411.602325 417.313599,412.439606 
	C416.724030,412.512207 416.483917,412.489441 415.917297,412.312714 
	C409.584137,405.533783 402.419495,402.702301 393.231476,405.523071 
	C391.873260,406.001373 390.856506,406.418762 389.758026,407.379333 
	C389.149811,407.890808 388.788177,408.172485 388.130524,408.653076 
	C386.573059,409.566528 385.411682,410.594513 383.461426,410.004944 
	C380.286438,404.394196 379.282654,398.498993 378.667908,392.175629 
	C378.928040,390.528259 379.037598,389.245178 379.272125,387.594818 
z"/>
<path fill="#252326" opacity="1.000000" stroke="none" 
	d="
M384.085327,357.434448 
	C380.152496,362.617737 375.931244,367.183716 370.507935,370.846008 
	C369.483673,368.065674 371.529419,365.581543 371.004150,362.416626 
	C371.320465,361.532318 371.639679,361.063965 371.978851,360.297485 
	C373.210632,359.179260 372.957794,357.909698 373.000977,356.365601 
	C374.820465,354.189240 373.679932,351.894226 374.006836,349.421509 
	C375.997650,347.272797 374.218872,344.525146 375.877441,342.312622 
	C378.869171,346.918121 382.317627,351.544434 384.085327,357.434448 
z"/>
<path fill="#242022" opacity="1.000000" stroke="none" 
	d="
M335.439880,309.228210 
	C333.049805,305.244781 331.033691,301.491516 328.980042,297.378845 
	C336.970306,295.151611 341.334869,301.345428 346.580627,305.307373 
	C348.463654,306.729584 351.026978,307.721466 351.971893,310.650208 
	C346.415924,312.598969 341.201355,310.116180 335.439880,309.228210 
z"/>
<path fill="#0DA5E9" opacity="1.000000" stroke="none" 
	d="
M401.149567,371.331970 
	C405.478607,369.760590 405.860291,374.470001 408.795837,375.959686 
	C411.706696,377.382507 411.593292,380.206482 412.739410,382.775208 
	C413.082489,384.181519 413.089142,385.213715 412.595642,386.595459 
	C412.219482,387.132477 412.021423,387.312042 411.449219,387.639374 
	C408.701324,387.898193 407.747650,386.457977 407.304810,383.997223 
	C405.225891,379.627869 403.208618,375.653625 401.149567,371.331970 
z"/>
<path fill="#0E151F" opacity="1.000000" stroke="none" 
	d="
M407.052094,383.901978 
	C408.133545,384.932800 409.023895,386.263519 410.100830,387.883057 
	C413.579071,389.053284 412.883240,391.999359 413.225220,394.640442 
	C408.173157,396.204773 406.317352,394.520294 403.988647,386.458374 
	C404.941193,385.463043 405.901093,384.832458 407.052094,383.901978 
z"/>
<path fill="#252326" opacity="1.000000" stroke="none" 
	d="
M335.063660,309.285645 
	C340.580109,308.543610 345.886719,309.777649 351.607544,310.987793 
	C353.259888,311.795380 354.501831,312.596283 355.884644,313.684326 
	C349.605164,313.017273 343.184814,312.063080 336.357666,311.058960 
	C335.654358,310.530396 335.357880,310.051788 335.063660,309.285645 
z"/>
<path fill="#88A7B5" opacity="1.000000" stroke="none" 
	d="
M326.370728,293.402710 
	C325.474182,292.184723 324.756378,291.062622 323.948425,289.629395 
	C324.075714,288.307831 324.752014,287.794647 326.161743,287.705200 
	C328.865326,288.804535 330.445465,290.608307 332.441895,292.633453 
	C330.919495,293.743042 328.609741,291.935211 327.627258,294.388184 
	C327.179504,294.346680 326.864471,293.922638 326.370728,293.402710 
z"/>
<path fill="#77DCF6" opacity="1.000000" stroke="none" 
	d="
M326.397400,287.528473 
	C325.916199,288.183594 325.230255,288.555817 324.201294,289.123138 
	C320.944183,287.774628 319.230682,285.282318 318.471771,281.892029 
	C321.196442,283.461365 323.694519,285.353485 326.397400,287.528473 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M398.774963,379.972412 
	C397.508606,381.704742 395.537872,380.742401 393.400391,381.014221 
	C394.168854,379.484619 395.883575,380.186340 397.774963,379.902100 
	C398.179413,379.852905 398.578430,379.923248 398.774963,379.972412 
z"/>
<path fill="#77DCF6" opacity="1.000000" stroke="none" 
	d="
M318.281067,281.051453 
	C317.762817,281.871948 317.202667,281.582642 316.359558,281.053589 
	C315.776337,280.459717 315.482178,280.018158 315.120544,279.319946 
	C316.382050,279.110474 317.352722,279.812256 318.281067,281.051453 
z"/>
<path fill="#26E5F5" opacity="1.000000" stroke="none" 
	d="
M280.308289,231.230713 
	C280.992371,230.181519 281.851776,229.408051 282.841522,228.373138 
	C284.935211,229.856537 286.898529,231.601364 289.016907,233.641266 
	C289.079468,234.816208 289.129517,235.733826 288.257996,236.701141 
	C285.504852,235.122620 282.994202,233.314545 280.308289,231.230713 
z"/>
<path fill="#0CD6F6" opacity="1.000000" stroke="none" 
	d="
M288.284058,237.132446 
	C288.213409,236.061142 288.411346,235.191574 288.890625,234.129181 
	C291.646423,236.142609 294.120850,238.348877 296.791565,240.824524 
	C297.101135,241.586258 296.960205,241.989822 296.221619,242.225739 
	C293.436432,240.542694 290.994568,238.938446 288.284058,237.132446 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M296.071228,242.452057 
	C296.163147,241.948441 296.447968,241.749939 296.860321,241.322662 
	C297.774261,241.681580 298.560669,242.269257 299.623535,242.972076 
	C299.899963,243.087219 300.003387,243.555695 300.015533,243.795197 
	C298.242676,245.171585 297.513123,243.199219 296.071228,242.452057 
z"/>
<path fill="#26E5F5" opacity="1.000000" stroke="none" 
	d="
M300.951965,252.755844 
	C300.713531,252.923828 300.437897,252.759476 300.096863,252.288605 
	C300.269226,252.224228 300.563690,252.371368 300.951965,252.755844 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M299.813232,244.321213 
	C299.958740,243.970764 300.426697,243.977402 300.657715,244.014893 
	C300.924042,244.217072 300.959351,244.381775 301.010468,244.798676 
	C300.573395,244.924469 300.120575,244.798065 299.813232,244.321213 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M300.924805,245.277557 
	C301.274384,245.141937 301.597198,245.317795 301.967590,245.775375 
	C301.642761,245.901077 301.270386,245.745071 300.924805,245.277557 
z"/>
<path fill="#009AED" opacity="1.000000" stroke="none" 
	d="
M91.742661,281.745178 
	C92.238350,282.794556 91.611855,283.850647 92.838013,284.279541 
	C93.361893,283.687927 93.787018,283.437073 94.674149,283.341858 
	C95.531265,283.508759 95.950249,283.760651 96.461876,284.454712 
	C97.245369,287.383667 94.979927,288.424988 93.656708,290.354126 
	C93.289574,291.750366 93.166580,292.855743 92.880699,294.270386 
	C92.639877,295.007294 92.456390,295.408813 92.088516,296.083496 
	C91.492844,297.126007 91.253731,297.948273 91.061813,299.134155 
	C90.867584,299.892334 90.672752,300.292816 90.143021,300.857788 
	C89.581306,300.943604 89.349823,300.769714 89.077957,300.327942 
	C88.242805,298.890533 86.900490,298.463318 85.501282,297.542480 
	C84.916061,293.423889 84.768707,289.515961 85.632004,285.312469 
	C86.822426,284.191315 86.437202,282.122986 88.781647,282.284180 
	C89.106308,282.189056 89.017517,282.082642 89.075890,282.119995 
	C89.369812,281.752716 89.715752,281.485077 90.495712,281.321289 
	C91.049919,281.382599 91.264137,281.456848 91.742661,281.745178 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M89.907875,301.393250 
	C89.910904,300.592163 89.957558,300.135345 90.046310,299.335876 
	C90.428246,298.426453 90.792603,297.885406 91.801804,297.693604 
	C92.533920,297.906281 92.892555,298.158813 93.391891,298.750916 
	C93.979332,299.808838 94.205727,300.657440 94.549294,301.811768 
	C94.668571,302.573547 94.620552,303.005493 94.264435,303.672943 
	C93.856155,303.952393 93.666290,303.986328 93.200211,304.107574 
	C91.851761,303.474243 90.089378,303.588409 89.907875,301.393250 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M85.162064,297.657043 
	C86.805763,297.439484 89.135277,296.098785 89.025345,299.734314 
	C87.970963,298.898285 83.998802,303.031586 85.162064,297.657043 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M88.851036,281.985229 
	C88.246376,283.069458 87.386436,283.949860 86.220490,284.919983 
	C85.987999,283.254486 86.061516,281.499268 86.279770,279.327637 
	C88.116211,279.135681 87.779694,280.894501 88.851036,281.985229 
z"/>
<path fill="#059FE5" opacity="1.000000" stroke="none" 
	d="
M89.403702,258.166901 
	C89.675850,258.327515 89.633255,258.624115 89.267136,259.053253 
	C89.015785,258.892212 89.064232,258.597931 89.403702,258.166901 
z"/>
<path fill="#032B57" opacity="1.000000" stroke="none" 
	d="
M481.223083,445.102051 
	C481.104309,444.850830 481.277863,444.501892 481.728119,444.058533 
	C481.841675,444.310852 481.678558,444.657623 481.223083,445.102051 
z"/>
<path fill="#0355A0" opacity="1.000000" stroke="none" 
	d="
M480.409454,448.975403 
	C480.266479,448.892975 480.256531,448.695160 480.330261,448.212097 
	C480.507477,448.133240 480.625214,448.333191 480.682587,448.549225 
	C480.705170,448.634460 480.593170,448.755402 480.409454,448.975403 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M448.056030,476.656555 
	C447.832764,477.004974 447.660217,477.016083 447.228760,477.042999 
	C445.011810,478.614624 442.926819,478.666901 440.364685,477.303284 
	C438.918579,477.293762 437.853882,477.565033 436.457550,477.847809 
	C433.900909,475.256744 435.564026,472.638367 436.288940,469.662018 
	C437.457031,468.053467 438.789764,468.043823 440.566101,468.125305 
	C442.918823,468.411346 445.265656,466.953064 446.920410,469.624786 
	C451.656982,471.385651 451.811188,472.269196 448.056030,476.656555 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M436.746368,468.611420 
	C436.693787,471.699921 436.371094,474.383087 436.087158,477.462799 
	C434.535767,478.244904 433.149353,477.493835 431.328857,477.025909 
	C430.694275,476.517242 430.435608,476.049744 430.083344,475.331055 
	C430.407593,473.637238 429.154877,472.272797 429.922882,470.751038 
	C431.362671,467.898132 431.201721,468.144653 428.180054,467.103394 
	C426.376495,466.481842 428.422546,463.964355 427.004974,462.386963 
	C430.320190,463.025604 434.507202,461.315735 436.964233,465.569183 
	C436.746155,466.303711 436.504730,466.628296 436.135315,467.148804 
	C436.090668,467.702637 436.234222,467.979828 436.746368,468.611420 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M439.987915,477.435150 
	C442.022491,477.024597 444.061676,477.026642 446.535400,477.043762 
	C447.178162,481.747101 442.870117,480.297974 440.314087,481.838074 
	C439.975525,480.599121 439.984009,479.223450 439.987915,477.435150 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M440.742432,467.914856 
	C440.149323,469.228119 438.887695,468.936401 437.376862,469.012604 
	C437.016479,469.016754 436.990082,468.989746 436.977051,468.976379 
	C436.834412,468.818298 436.704742,468.673645 436.617004,468.239197 
	C436.864746,467.608856 437.143585,467.342773 437.775360,467.098480 
	C438.483490,467.050964 438.900970,467.045227 439.630371,467.051270 
	C440.073151,467.362061 440.269287,467.609253 440.742432,467.914856 
z"/>
<path fill="#063A70" opacity="1.000000" stroke="none" 
	d="
M425.206604,459.124512 
	C426.731354,457.020050 423.709930,455.612000 423.991058,453.363770 
	C423.982666,452.855743 423.998779,452.688324 424.018127,452.268677 
	C423.364075,451.196472 424.038147,450.562469 424.500183,449.646667 
	C424.815186,449.287231 424.950684,449.154907 425.308411,448.853027 
	C425.840454,448.496948 426.157623,448.324005 426.710571,448.043884 
	C427.082458,447.830292 427.228027,447.741486 427.583252,447.506165 
	C427.928864,447.255005 428.064850,447.150330 428.409241,446.887207 
	C428.765900,446.630524 428.914154,446.532318 429.297913,446.301514 
	C429.863129,445.996185 430.195648,445.829041 430.801453,445.546356 
	C431.266876,445.369995 431.462006,445.315125 431.965637,445.229187 
	C432.703033,445.216827 433.119934,445.299805 433.821564,445.582397 
	C434.796539,446.181488 435.476532,446.772369 436.348755,446.260071 
	C439.666656,444.311615 440.904968,445.748383 440.902985,449.076233 
	C440.902100,450.578674 440.645569,452.182617 442.421295,452.859436 
	C444.469666,453.640137 446.392670,453.100830 447.878662,451.595032 
	C451.513306,447.911957 455.621460,446.264252 460.985718,448.406006 
	C461.693298,449.284668 461.836609,449.992584 461.406372,451.397034 
	C460.601410,452.031342 460.153900,452.021240 459.370544,452.011536 
	C457.764648,452.542145 456.326782,452.523468 455.113037,453.222748 
	C455.077209,453.243408 455.127899,453.531219 455.214813,453.616364 
	C455.308838,453.708405 455.492798,453.708649 455.858154,453.907867 
	C454.157196,463.343292 450.216431,465.356018 441.441437,461.565704 
	C440.850952,461.310699 440.202026,461.151672 439.564026,461.052338 
	C433.988617,460.184296 433.987518,460.191345 434.574463,454.711029 
	C432.934570,455.032318 432.213348,456.405884 431.124329,457.798401 
	C430.613312,458.397186 430.183960,458.518982 429.408081,458.313293 
	C427.931183,458.452942 426.754333,458.767761 425.206604,459.124512 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M468.428925,445.601379 
	C468.358459,447.126801 467.707245,448.243896 467.028015,449.688416 
	C465.192535,451.590576 463.385040,453.165283 461.273621,454.867065 
	C460.994354,454.255920 461.018951,453.517609 461.046265,452.410400 
	C461.048950,452.041473 461.018127,452.020020 461.021057,452.030579 
	C462.179504,449.956177 462.368866,447.338776 464.768188,445.589905 
	C465.966034,445.012329 466.897369,444.972870 468.428925,445.601379 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M456.392395,454.023560 
	C455.004700,454.235413 454.109283,455.449890 452.553101,454.427399 
	C453.991180,452.259491 455.561798,450.761749 458.725311,451.881287 
	C458.553589,453.017181 457.849335,453.758484 456.392395,454.023560 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M437.939117,466.823730 
	C437.850220,467.319763 437.634369,467.582794 437.190613,467.966064 
	C436.593475,468.386322 436.170502,468.496094 435.399200,468.281616 
	C434.406158,467.852020 433.111877,467.966125 433.591766,466.761963 
	C434.021057,465.684845 435.308655,466.110077 436.609131,465.975220 
	C437.250305,466.173523 437.531219,466.382111 437.939117,466.823730 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M429.124084,458.419434 
	C429.525452,458.116058 429.942841,458.093994 430.674377,458.084961 
	C430.891876,458.722717 430.847504,459.472260 430.066986,459.533966 
	C429.781799,459.556519 429.450439,458.995544 429.124084,458.419434 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M460.740479,455.073456 
	C460.767975,455.260834 460.540894,455.546814 460.041412,455.915039 
	C460.007996,455.722229 460.246979,455.447144 460.740479,455.073456 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M490.132568,415.670746 
	C487.568451,427.007080 482.240692,436.907806 476.429108,446.892029 
	C474.025726,446.711029 471.916290,446.362030 469.408264,446.011353 
	C469.009705,446.009705 468.980865,445.980774 468.966553,445.966370 
	C467.195526,442.754578 469.635162,442.353760 471.974792,441.639832 
	C472.191589,441.537872 472.430664,441.165833 472.475586,440.964844 
	C472.520477,440.763885 472.595032,440.403015 472.649017,440.242859 
	C472.703003,440.082703 472.309662,440.111877 472.156494,440.288452 
	C470.702728,441.067352 469.323883,442.142670 468.519104,439.549316 
	C468.673615,438.784698 468.851532,438.375641 469.252319,437.704681 
	C470.481415,436.211060 470.860779,434.720032 471.266174,432.869446 
	C472.263702,429.329742 473.694214,426.302673 474.640137,422.723633 
	C475.215851,419.541168 476.728760,417.727966 480.061340,417.477844 
	C481.227631,418.121857 481.829346,418.825867 481.874725,419.958282 
	C482.006165,418.807190 481.173187,418.246307 480.494843,417.186798 
	C480.528839,413.683594 482.893921,413.877045 485.476624,413.797302 
	C487.312103,414.084076 488.662384,414.506531 490.132568,415.670746 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M400.789276,478.851868 
	C400.996613,479.549164 401.017334,479.940521 401.048157,480.625763 
	C400.703522,481.342285 400.252686,481.516693 399.392334,481.221436 
	C396.925110,479.696960 395.542328,480.521088 394.410950,482.853943 
	C393.920746,483.189026 393.639893,483.286194 392.991455,483.131256 
	C392.823608,481.908020 392.648315,481.145721 391.202393,480.851776 
	C389.915802,479.216187 386.533264,480.049774 387.337341,476.772949 
	C387.809784,476.509003 388.019257,476.447632 388.551575,476.372620 
	C390.102417,476.598480 391.330139,476.515167 392.846436,476.377106 
	C393.530090,476.409241 393.549194,477.018433 393.801636,476.960571 
	C394.043701,476.905090 393.929596,476.550598 393.533508,476.076202 
	C393.905914,474.280487 395.079956,473.744720 396.782471,473.433777 
	C399.414795,474.376801 399.767914,476.624878 400.789276,478.851868 
z"/>
<path fill="#0778E5" opacity="1.000000" stroke="none" 
	d="
M395.414154,501.048645 
	C395.041809,500.490356 395.037811,499.973816 395.047394,499.070190 
	C395.578796,497.525604 396.630585,496.984985 397.989380,496.280060 
	C399.662231,495.639374 401.073029,495.577667 402.759033,495.782166 
	C403.908539,496.557373 403.994507,497.432434 403.994324,498.680389 
	C401.871857,502.142365 399.059021,502.534882 395.414154,501.048645 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M400.965454,481.777344 
	C401.712433,482.865173 402.112946,483.760223 402.775879,484.802002 
	C403.102264,485.396210 403.166199,485.843719 403.285645,486.625336 
	C403.113861,487.285431 402.814178,487.511871 402.178894,487.767822 
	C399.328644,488.295593 399.127869,485.390228 397.188843,484.339355 
	C396.881317,483.892639 396.769684,483.705444 396.812286,483.229919 
	C396.966522,482.941650 397.005920,482.987030 396.976868,482.979431 
	C398.126984,482.391449 399.444580,482.177460 400.965454,481.777344 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M388.104156,476.636108 
	C387.045715,479.758392 390.954987,478.227905 390.855164,480.487366 
	C388.379700,481.329620 386.217773,478.375305 383.265961,480.176270 
	C382.925568,480.258026 382.912842,480.165710 382.899078,480.121216 
	C382.103973,475.339874 384.894409,475.505402 388.104156,476.636108 
z"/>
<path fill="#0A4271" opacity="1.000000" stroke="none" 
	d="
M396.690460,492.201599 
	C401.088379,487.939545 399.919525,492.782471 400.851990,494.695374 
	C400.313446,495.840698 399.418762,496.094421 398.145630,496.020935 
	C397.261658,494.808044 398.474609,493.113708 396.690460,492.201599 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M396.247131,492.786072 
	C394.728729,493.311554 393.544342,493.153381 392.128662,492.250671 
	C391.744354,491.912903 391.699860,491.717285 391.764343,491.241180 
	C391.873322,490.960693 391.929291,490.944702 391.930542,490.915649 
	C392.084778,490.746460 392.237732,490.606323 392.214935,490.209442 
	C394.429016,487.182678 394.722626,490.861145 396.275696,491.554901 
	C396.481232,492.077148 396.491364,492.310791 396.247131,492.786072 
z"/>
<path fill="#086AC0" opacity="1.000000" stroke="none" 
	d="
M406.983887,494.520691 
	C409.423462,494.695709 409.848785,496.230591 409.043213,498.676086 
	C407.051025,498.255646 406.925140,496.613373 406.983887,494.520691 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M395.981720,493.336548 
	C396.044708,492.819580 396.096649,492.611511 396.309875,492.123474 
	C396.471130,491.843506 396.615417,491.844757 396.683746,491.853363 
	C397.491486,492.924316 399.132843,493.656433 397.729553,495.913574 
	C396.921661,496.527222 396.451416,496.450470 395.972961,495.866394 
	C395.953003,494.881958 395.961823,494.263702 395.981720,493.336548 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M398.008606,495.993347 
	C398.769928,495.682648 399.536224,495.364929 400.612640,495.022766 
	C401.435120,494.752869 401.947449,494.507416 402.720703,494.149048 
	C403.166840,494.195862 403.352081,494.355652 403.294678,494.790710 
	C403.052094,495.065979 403.045959,495.538239 403.037476,495.774353 
	C401.631287,496.347778 400.233521,496.685028 398.473541,497.040710 
	C397.956512,496.889252 397.801727,496.719330 397.836609,496.261505 
	C398.026306,495.973602 398.013550,495.986359 398.008606,495.993347 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M392.433685,483.117126 
	C392.886383,482.914276 393.148895,482.949371 393.806519,483.038177 
	C393.575348,484.189087 395.797729,485.309570 394.728210,485.734253 
	C393.173096,486.351746 392.203400,485.088043 392.433685,483.117126 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M401.248718,481.707458 
	C400.107788,482.300781 398.903625,482.631409 397.323669,482.966980 
	C397.100159,481.939209 398.178436,482.043579 398.909180,481.256348 
	C399.518646,480.989899 399.958435,480.979950 400.728271,480.944824 
	C401.100708,481.094696 401.143127,481.269745 401.248718,481.707458 
z"/>
<path fill="#086AC0" opacity="1.000000" stroke="none" 
	d="
M402.264343,487.944519 
	C402.208252,487.651947 402.488647,487.390289 403.055084,487.044037 
	C403.898651,487.126007 404.456116,487.292572 405.013580,487.459167 
	C404.417297,488.603149 403.401001,487.784241 402.264343,487.944519 
z"/>
<path fill="#086AC0" opacity="1.000000" stroke="none" 
	d="
M412.036133,485.210999 
	C412.433380,485.035797 412.820038,485.151489 413.206726,485.267212 
	C412.992767,485.516266 412.778809,485.765320 412.308929,486.048950 
	C412.043854,485.889648 412.034698,485.695801 412.036133,485.210999 
z"/>
<path fill="#086AC0" opacity="1.000000" stroke="none" 
	d="
M403.303650,495.036560 
	C403.037476,494.894379 403.022888,494.722809 402.994934,494.293640 
	C403.428131,494.180634 403.874634,494.325195 404.321136,494.469788 
	C404.065826,494.648895 403.810547,494.828033 403.303650,495.036560 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M396.688751,482.960266 
	C396.978546,483.131073 396.990570,483.320465 396.997772,483.794861 
	C396.456573,483.893860 395.940277,483.697235 396.688751,482.960266 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M391.991577,490.183746 
	C392.210052,490.137695 392.396454,490.312042 392.537262,490.517609 
	C392.562408,490.554291 392.398773,490.720306 392.127075,490.856598 
	C391.931824,490.886566 391.943909,490.414825 391.991577,490.183746 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M391.650177,491.074097 
	C391.887421,491.153687 391.901520,491.346680 391.852234,491.824097 
	C391.788849,492.108490 391.327667,492.081604 391.097900,492.048309 
	C391.054443,491.739166 391.240753,491.463318 391.650177,491.074097 
z"/>
<path fill="#0ABEFA" opacity="1.000000" stroke="none" 
	d="
M398.561676,463.337585 
	C397.900177,465.337280 398.527100,466.835419 399.068726,468.739716 
	C399.198334,469.120056 399.112640,469.119019 399.089355,469.083069 
	C398.493469,469.522736 397.856720,469.853668 396.743103,469.897858 
	C395.676483,469.723480 395.087280,469.373077 394.464294,468.521271 
	C394.070099,467.639099 393.942108,467.015625 393.679962,466.120544 
	C393.510437,465.654938 393.438080,465.471527 393.247162,465.018982 
	C392.963684,464.393219 392.796570,464.037628 392.482605,463.420044 
	C392.237427,462.980072 392.136597,462.803314 391.874878,462.362610 
	C391.479156,461.739868 391.236084,461.386719 390.781311,460.763123 
	C383.289764,446.691284 376.062256,432.863190 368.674835,419.119568 
	C367.892578,417.664276 367.117584,416.162292 367.536865,414.045410 
	C369.252045,411.680145 371.584473,411.498444 374.213593,411.173889 
	C374.733856,411.239777 375.021820,411.271698 375.028076,411.332489 
	C375.522552,416.155701 380.555420,417.724060 382.548218,421.857300 
	C384.297424,423.825562 385.313110,421.714233 386.965210,421.554138 
	C388.618805,421.961639 389.027008,423.119202 389.663971,424.536743 
	C389.951416,425.340546 390.087036,425.810333 390.298676,426.642883 
	C390.851898,429.193054 391.667908,431.287018 392.252686,433.841187 
	C393.296326,440.646912 396.168671,446.677277 396.163147,453.633423 
	C396.091522,454.854919 396.185791,455.720184 396.522339,456.807068 
	C398.673492,458.592651 398.972046,460.692963 398.561676,463.337585 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M408.255096,448.684570 
	C406.588623,449.341614 405.166473,449.678802 403.375671,449.999207 
	C399.913605,446.402863 400.691406,441.588196 398.938110,437.240967 
	C398.771454,436.734192 398.706757,436.535004 398.547668,436.044617 
	C398.333221,435.379456 398.208466,435.007111 397.958130,434.383911 
	C397.746765,433.970276 397.655579,433.809265 397.410706,433.416687 
	C397.148865,433.032928 397.040710,432.880768 396.775543,432.490845 
	C396.529510,432.081268 396.440460,431.909393 396.243164,431.464233 
	C395.936371,430.617126 395.753326,430.037903 395.427063,429.158203 
	C395.271881,428.621674 395.225891,428.397430 395.170288,427.820312 
	C395.247040,426.706207 395.531189,426.041199 396.450806,425.321259 
	C400.925049,423.744141 404.868164,425.710663 409.322754,425.874573 
	C411.802887,426.770569 414.045013,426.520569 416.581421,427.063416 
	C417.907379,427.553802 418.836212,428.016296 419.384552,428.839447 
	C420.807587,430.975616 423.153564,433.073273 422.117157,435.819977 
	C421.208008,438.229462 418.400848,438.205200 416.120880,438.450226 
	C414.794525,438.592743 413.544739,438.926514 411.916626,439.491882 
	C407.296265,438.048645 408.973724,434.590515 408.527435,431.499298 
	C408.113068,437.241730 410.935333,442.869019 408.255096,448.684570 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M423.227478,449.854248 
	C421.177521,449.804291 419.071869,448.495850 418.516663,451.721832 
	C418.304596,452.954193 416.999298,452.382965 416.154663,451.258820 
	C414.988434,449.909088 415.117035,448.693146 415.766296,447.101227 
	C417.321747,444.658051 419.802521,443.939575 421.839508,442.091400 
	C423.941589,439.963715 424.999390,436.908661 428.837524,437.513428 
	C429.488220,437.344116 429.898346,437.825409 430.213043,437.400604 
	C429.848175,437.183533 429.542511,437.695770 428.839172,437.485474 
	C426.471680,437.220490 423.541718,438.861053 423.286499,434.585693 
	C425.106445,430.769470 427.889923,430.462524 431.522827,431.741943 
	C433.412659,432.632172 433.976105,434.063019 434.661072,435.833923 
	C436.706390,438.818451 433.724091,440.972504 433.887451,443.770782 
	C433.195251,444.868439 432.319611,445.169434 431.249329,445.787292 
	C430.979523,445.994293 431.002075,446.004181 431.003296,445.992004 
	C430.571564,446.423157 429.970947,446.469757 429.196106,446.825317 
	C428.966736,447.003784 429.009155,447.011261 429.011108,446.989807 
	C428.782745,447.204193 428.550598,447.438232 428.140869,447.844360 
	C427.965118,448.018188 428.011139,448.014313 428.017029,447.992004 
	C427.583191,448.412872 426.980042,448.470215 426.195374,448.826385 
	C425.963837,449.007019 426.009003,449.013367 426.013214,448.990967 
	C425.312531,449.579620 424.479034,449.850220 423.227478,449.854248 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M398.758148,435.203003 
	C401.797607,439.307007 401.634186,444.453735 402.995056,449.579346 
	C401.159698,451.705078 399.224365,453.289764 396.361328,453.990479 
	C393.696655,447.751923 392.559662,441.217285 391.131165,434.369171 
	C393.029358,432.713379 394.223541,434.323792 395.642883,434.998108 
	C396.548218,435.428162 397.305511,437.015869 398.758148,435.203003 
z"/>
<path fill="#032B57" opacity="1.000000" stroke="none" 
	d="
M398.749786,463.805237 
	C397.862305,461.738220 397.344421,459.770233 396.795563,457.415466 
	C400.592682,456.080017 404.019196,456.625122 406.649231,460.310425 
	C406.449158,458.616455 403.929016,458.100769 405.695587,456.524475 
	C406.790802,455.547272 408.101807,456.244476 409.334351,456.893341 
	C411.961273,458.276367 410.130493,461.080292 411.686951,462.931152 
	C411.776764,463.576874 411.572571,464.150726 411.133789,464.933929 
	C410.543762,465.376465 410.153931,465.478760 409.438446,465.341492 
	C407.974213,465.272583 408.416046,460.132507 405.639740,464.381744 
	C404.293365,466.442383 401.368378,463.916748 398.749786,463.805237 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M416.735992,446.781189 
	C416.668671,448.120789 416.348816,449.208313 416.022888,450.642334 
	C413.404114,451.110138 410.786591,451.250549 408.375854,449.072357 
	C408.010773,442.733307 408.010773,436.462189 408.010773,428.697418 
	C409.625397,432.966095 408.183289,436.690582 411.758545,439.265137 
	C412.199066,440.135895 412.081909,440.583099 411.756317,441.328827 
	C410.597504,444.360413 410.352600,446.605743 414.769867,446.170593 
	C415.602783,446.183807 416.054688,446.315247 416.735992,446.781189 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M421.838013,455.616516 
	C423.347107,456.913208 422.616028,457.844910 421.526855,458.914124 
	C420.045197,459.685913 419.791229,458.876160 419.806702,457.557739 
	C420.412994,455.373169 418.379486,455.397217 417.627502,453.964783 
	C418.989258,453.964783 420.116943,453.964783 421.614563,453.984375 
	C422.103333,454.166016 422.222107,454.328003 422.185242,454.748047 
	C422.029572,455.006042 421.997162,454.999451 422.005798,455.013611 
	C421.883331,455.163483 421.752228,455.299133 421.838013,455.616516 
z"/>
<path fill="#071A2D" opacity="1.000000" stroke="none" 
	d="
M419.638672,457.203857 
	C420.233002,457.710602 420.470428,458.252686 420.987793,458.927673 
	C421.267731,459.060547 421.112915,459.516205 421.031250,459.742493 
	C419.905334,459.982635 418.861023,459.996429 417.425598,459.989197 
	C416.716766,458.180023 417.413330,457.227112 419.638672,457.203857 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M422.940582,450.136780 
	C423.529083,449.014343 424.436310,448.989594 425.678040,448.959778 
	C425.435486,449.798370 424.853546,450.628235 424.146484,451.737244 
	C423.676575,451.498108 423.331757,450.979767 422.940582,450.136780 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M422.242157,454.893250 
	C422.021027,454.839050 422.012512,454.672089 421.994293,454.254578 
	C421.984558,454.003998 422.475616,453.993896 422.720764,453.987488 
	C422.887878,454.306671 422.717499,454.573120 422.242157,454.893250 
z"/>
<path fill="#1391DB" opacity="1.000000" stroke="none" 
	d="
M395.633636,469.371277 
	C396.674438,469.037079 397.471252,469.033661 398.667084,469.038666 
	C399.324799,469.824799 399.583466,470.602478 399.926453,471.676025 
	C400.163940,473.171997 400.317078,474.372131 400.752502,475.800781 
	C401.363159,476.412140 401.502136,476.854492 401.243164,477.654968 
	C401.028046,478.153992 401.021515,478.354431 400.995453,478.856354 
	C398.831238,478.273651 398.730682,475.941193 397.298431,474.177277 
	C395.540100,472.922455 394.907837,471.523987 395.633636,469.371277 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M409.440247,479.319916 
	C410.460052,479.275726 410.861755,479.689789 410.448517,480.373474 
	C410.276703,480.657806 409.586456,480.875763 409.248749,480.765625 
	C408.313507,480.460663 408.795563,479.909637 409.440247,479.319916 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M401.344482,477.953796 
	C401.017731,477.525757 401.000916,477.097931 401.009460,476.349731 
	C401.570831,476.265320 402.371429,476.363831 402.582031,476.768982 
	C402.913116,477.405945 402.330200,477.829834 401.344482,477.953796 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M422.042847,455.605743 
	C421.713654,455.717468 421.242126,455.715210 421.844727,455.097839 
	C422.014404,455.027802 422.030762,455.413239 422.042847,455.605743 
z"/>
<path fill="#08346F" opacity="1.000000" stroke="none" 
	d="
M404.384949,466.688354 
	C404.547729,466.825439 404.569763,467.075439 404.591827,467.325409 
	C404.475952,467.150696 404.360077,466.975952 404.384949,466.688354 
z"/>
<path fill="#0778E5" opacity="1.000000" stroke="none" 
	d="
M409.282227,465.418671 
	C409.535553,465.181335 409.924011,465.130005 410.605835,465.110992 
	C410.551514,465.766754 410.102905,466.066162 409.282227,465.418671 
z"/>
<path fill="#03D7FC" opacity="1.000000" stroke="none" 
	d="
M370.172913,450.722717 
	C364.317169,451.319733 362.235199,446.558807 359.267090,443.311310 
	C356.521881,440.307800 354.509003,436.644806 351.868683,433.530853 
	C350.754669,432.217041 349.894806,429.904083 347.142120,430.851501 
	C342.408539,427.120789 340.306213,422.009796 340.112976,415.675049 
	C344.235474,411.449982 347.647156,406.784637 353.816223,405.303467 
	C354.698029,405.557800 355.116455,405.857971 355.655090,406.601685 
	C358.617767,417.795105 362.948486,428.112671 366.903442,438.955658 
	C367.961029,442.354370 369.325531,445.238556 370.471558,448.601379 
	C370.636780,449.467041 370.587952,449.959320 370.172913,450.722717 
z"/>
<path fill="#040E11" opacity="1.000000" stroke="none" 
	d="
M339.925171,415.165863 
	C341.885712,420.437195 344.146149,425.543427 346.680847,430.878174 
	C349.039581,437.576111 352.333832,443.507721 355.444214,449.859283 
	C355.920837,450.795227 356.145416,451.505066 356.507477,452.561707 
	C356.311554,453.333984 355.878754,453.591827 354.960083,453.672241 
	C350.042755,450.867706 349.095245,445.627594 346.520264,441.530304 
	C343.722595,437.078522 341.244995,432.400024 338.299133,427.578979 
	C330.652802,415.650726 326.602997,402.517700 321.217255,389.571289 
	C320.173126,386.113770 318.066040,383.359680 318.436951,379.564423 
	C318.774384,379.048645 318.962738,378.881775 319.524841,378.672913 
	C322.024323,379.301727 322.889648,381.177795 323.881744,382.888336 
	C328.640961,391.093994 333.116058,399.454163 337.552002,408.240906 
	C338.521362,410.717529 340.081757,412.583893 339.925171,415.165863 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M375.309875,462.164551 
	C374.049011,459.890594 373.092560,457.780731 372.094543,455.321594 
	C372.722504,452.778839 375.147125,453.005920 376.815033,451.590027 
	C377.444824,451.334106 377.895325,451.136078 378.061310,451.290558 
	C380.249634,453.327240 382.198212,455.548645 382.979156,458.750000 
	C380.673553,460.746582 378.922607,463.237610 375.309875,462.164551 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M388.387817,477.033966 
	C385.675446,476.342560 383.883911,477.007721 382.901764,479.755188 
	C381.930695,478.286163 380.976105,476.495605 380.018066,474.353149 
	C380.658569,472.299713 384.101044,474.113739 383.926331,470.804993 
	C385.119263,469.983765 386.112793,469.966217 387.477234,470.491943 
	C388.868561,471.137329 386.938568,474.046570 389.871857,473.080353 
	C390.660889,472.820465 391.921539,473.364777 392.031036,474.594116 
	C392.150909,475.940247 391.227081,476.641785 389.669067,477.102722 
	C389.078308,477.115295 388.881500,477.087799 388.387817,477.033966 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M375.016418,462.345215 
	C377.362885,461.445160 379.447815,460.297821 381.809052,458.999268 
	C383.251434,458.185730 383.983215,458.718658 384.708588,460.013153 
	C385.464600,463.188477 381.661194,463.360443 381.370514,466.049500 
	C380.134155,467.112549 378.983856,467.432861 377.370392,467.138794 
	C376.365234,465.549896 375.696289,464.119904 375.016418,462.345215 
z"/>
<path fill="#032B57" opacity="1.000000" stroke="none" 
	d="
M377.267883,451.527893 
	C377.047394,455.016876 373.975922,453.476257 372.389435,454.833038 
	C371.500885,453.805359 370.948853,452.638397 370.161346,451.238525 
	C369.927948,450.560730 369.930023,450.115875 370.246429,449.134399 
	C371.014954,448.511078 371.448914,448.562683 372.073242,449.028381 
	C372.533508,449.611755 372.826202,449.930664 372.828247,450.389587 
	C372.940002,449.734528 372.353333,449.452179 371.923401,448.690918 
	C372.145813,446.941406 373.155518,446.363525 374.970428,446.430054 
	C377.398682,447.469727 378.351135,448.923035 377.267883,451.527893 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M377.035400,467.287476 
	C378.147095,466.622131 379.260040,466.264374 380.728638,465.884155 
	C381.932983,465.147034 382.908630,464.964478 384.335480,465.306824 
	C384.888184,465.604584 385.082642,465.766998 385.423706,466.277344 
	C385.788361,468.601746 384.735748,469.868500 382.906281,471.063568 
	C382.388794,471.333435 382.166626,471.406067 381.597412,471.477844 
	C380.079285,471.196625 379.440277,470.200500 378.358337,469.254578 
	C377.766724,468.540741 377.401703,468.067902 377.035400,467.287476 
z"/>
<path fill="#059FE5" opacity="1.000000" stroke="none" 
	d="
M380.496216,470.738098 
	C381.081268,470.911133 381.270599,470.917419 381.742859,470.949646 
	C382.444122,470.604492 382.924316,470.487396 383.644592,470.971985 
	C385.412994,475.252014 382.143280,473.537689 380.372589,473.991089 
	C379.208466,473.620636 379.054962,472.872803 378.950317,471.809692 
	C379.047455,470.853088 379.429230,470.537354 380.496216,470.738098 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M380.811523,470.610474 
	C380.476746,471.103607 380.061523,471.302368 379.300842,471.510040 
	C378.645966,470.914795 378.336517,470.310608 378.079407,469.360046 
	C379.179016,469.086914 380.161041,469.290436 380.811523,470.610474 
z"/>
<path fill="#11547D" opacity="1.000000" stroke="none" 
	d="
M350.557159,458.097595 
	C349.868713,456.921783 349.401825,455.992859 348.909668,454.751526 
	C348.648804,454.003845 348.626556,453.563934 349.125519,452.894806 
	C353.334015,452.393250 353.458923,456.491669 355.916168,458.411133 
	C356.566742,459.142700 357.012268,459.614105 357.752808,460.251862 
	C358.129395,460.644165 358.262390,460.818726 358.497864,461.307922 
	C358.629547,462.071106 358.554230,462.502777 358.179443,463.179382 
	C357.249207,464.014435 356.384644,464.220734 355.208435,464.537231 
	C353.529144,462.559235 352.153931,460.451874 350.557159,458.097595 
z"/>
<path fill="#1E2B39" opacity="1.000000" stroke="none" 
	d="
M353.933777,453.281921 
	C354.677765,452.987762 355.240234,452.982086 356.223816,452.942505 
	C357.754883,455.344818 358.864807,457.781097 360.052460,460.564453 
	C360.228058,461.118103 360.325867,461.324646 360.287170,461.845154 
	C359.390961,462.408966 358.844818,462.090424 358.208069,461.220703 
	C358.015930,460.939941 358.002014,460.998871 358.030518,460.988770 
	C357.552521,460.542419 357.105896,460.048981 356.479218,459.265991 
	C355.545532,457.137024 353.552734,455.863953 353.933777,453.281921 
z"/>
<path fill="#19C7F4" opacity="1.000000" stroke="none" 
	d="
M357.953247,461.282867 
	C358.482025,461.360809 358.948151,461.781677 359.638611,462.441040 
	C360.258698,462.839661 360.522156,463.118317 360.836792,463.761047 
	C361.043030,463.986176 361.001404,464.003174 361.013000,463.983948 
	C361.419250,464.430878 361.468933,465.032196 361.848694,465.799866 
	C362.040161,466.020508 361.985504,466.008514 361.992981,465.981567 
	C362.409912,466.418732 362.470734,467.023254 362.844482,467.804199 
	C363.034607,468.030060 362.978333,468.014862 362.983948,467.986267 
	C363.268524,468.264221 363.437592,468.624207 363.482483,469.333740 
	C361.257202,471.025055 359.975708,469.538177 358.344238,468.060364 
	C357.537048,466.544403 358.342224,465.089966 358.084473,463.314514 
	C358.053101,462.540924 357.971802,462.083374 357.953247,461.282867 
z"/>
<path fill="#197AAB" opacity="1.000000" stroke="none" 
	d="
M357.782776,463.031586 
	C359.049438,464.445709 361.207001,465.836670 358.175476,467.729919 
	C356.371948,467.704773 356.140503,466.193542 355.192078,464.858643 
	C355.046326,463.028015 356.231934,463.035614 357.782776,463.031586 
z"/>
<path fill="#32627C" opacity="1.000000" stroke="none" 
	d="
M363.697449,469.661438 
	C363.306152,469.273621 363.158813,468.910309 363.000519,468.252319 
	C364.308258,467.982269 364.737640,468.496582 363.697449,469.661438 
z"/>
<path fill="#32627C" opacity="1.000000" stroke="none" 
	d="
M361.234894,463.676453 
	C360.666992,463.716431 360.290924,463.446686 359.888916,462.928223 
	C359.901306,462.383789 359.939636,462.088013 360.054077,461.351929 
	C361.038361,461.478607 361.235962,462.420868 361.234894,463.676453 
z"/>
<path fill="#32627C" opacity="1.000000" stroke="none" 
	d="
M363.170959,467.686523 
	C362.670563,467.547882 362.306519,467.065704 361.971436,466.269073 
	C363.021667,465.866150 363.111725,466.654236 363.170959,467.686523 
z"/>
<path fill="#32627C" opacity="1.000000" stroke="none" 
	d="
M362.155212,465.670776 
	C361.668030,465.546722 361.295898,465.072968 360.974182,464.281952 
	C362.108612,463.802643 362.095520,464.648102 362.155212,465.670776 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M397.675598,495.912048 
	C398.054382,496.153381 398.082458,496.333130 398.110962,496.786011 
	C397.263611,497.510895 396.415894,497.962677 395.314575,498.548767 
	C394.183319,498.312531 393.305664,497.941956 392.330872,497.303833 
	C393.251190,496.588715 394.268646,496.141144 395.615112,495.596893 
	C396.404388,495.617004 396.864624,495.733765 397.675598,495.912048 
z"/>
<path fill="#F4FCFC" opacity="1.000000" stroke="none" 
	d="
M192.747574,325.112854 
	C177.046417,311.573486 161.672058,298.113983 146.136124,284.364380 
	C145.501907,283.407928 145.293045,282.667175 145.485794,281.486450 
	C145.977737,280.724426 146.417130,280.488770 147.317825,280.453217 
	C153.075607,283.926086 158.712845,286.972168 164.147156,290.989960 
	C171.512375,296.336395 178.436966,301.687775 185.839340,306.974365 
	C186.736206,307.512024 187.304688,307.915802 188.150482,308.533142 
	C197.538025,316.312469 207.475296,322.742126 217.396545,329.786926 
	C231.525223,339.561462 244.952835,349.681396 258.082336,360.755432 
	C261.203247,363.082611 263.720673,365.636078 267.360535,367.835999 
	C268.089813,368.367401 268.259979,368.517853 268.659119,368.920959 
	C270.821228,371.999084 274.004700,373.696777 275.806824,377.076111 
	C276.129578,378.962463 275.706238,380.342163 274.603760,381.887177 
	C271.515228,383.513641 269.605713,381.467529 267.583344,380.182465 
	C249.302917,368.566498 232.308365,355.157684 214.978912,342.222656 
	C208.455536,337.353455 201.370667,333.218170 195.202133,327.279785 
	C194.926804,327.046173 194.990448,327.007416 194.978973,327.042847 
	C194.771866,326.788544 194.544586,326.526215 194.037643,326.209045 
	C193.789734,326.126709 193.902939,326.052917 193.929626,326.114990 
	C193.748779,325.771484 193.454849,325.443298 192.747574,325.112854 
z"/>
<path fill="#0BCEF8" opacity="1.000000" stroke="none" 
	d="
M194.888840,327.393311 
	C201.280884,329.973541 206.507446,334.588287 212.079269,338.658356 
	C230.833099,352.357513 249.078110,366.759277 268.565430,379.442047 
	C270.085602,380.431396 271.675659,381.313446 273.566711,382.391541 
	C276.546234,382.259003 278.359222,384.243988 280.921295,385.153503 
	C282.208099,385.812958 283.146881,386.406952 284.338013,387.226440 
	C287.068207,389.297668 289.847656,390.747009 292.323425,393.169983 
	C294.402374,394.789032 296.975922,395.962463 294.147949,399.035278 
	C293.461456,399.440735 293.038910,399.593170 292.269928,399.688507 
	C291.741425,399.657745 291.535675,399.616058 291.052216,399.440002 
	C290.460083,399.065582 290.159088,398.809906 289.670135,398.348083 
	C289.329681,398.042419 289.195190,397.921936 288.863281,397.624207 
	C288.536804,397.330017 288.407837,397.213074 287.888184,396.763733 
	C287.218109,396.234436 286.930206,396.050934 286.399231,395.761841 
	C286.009888,395.555420 285.855286,395.467529 285.476929,395.230774 
	C284.956055,394.871826 284.655426,394.666870 284.104431,394.335114 
	C282.983612,393.743317 282.041748,393.574371 280.743958,393.517975 
	C278.166565,392.867767 276.514343,391.106567 274.052734,390.169922 
	C273.543030,389.958588 273.344360,389.867401 272.865601,389.615051 
	C271.547791,388.765686 270.663971,387.849640 269.261230,387.196472 
	C268.801086,386.858093 268.421814,386.490082 268.378326,386.525146 
	C268.030487,386.805450 268.116699,386.883759 268.766998,386.820740 
	C269.443756,387.341858 269.959900,387.623505 270.698792,388.157532 
	C271.886627,389.325531 273.136963,390.056854 273.170258,391.915863 
	C272.854706,392.385529 272.661652,392.523773 272.129517,392.778137 
	C266.831329,392.583191 263.760132,389.145233 260.394623,385.710449 
	C240.701050,374.090454 223.050949,360.459686 208.579666,342.894653 
	C204.250351,337.639801 199.440552,332.780792 194.888840,327.393311 
z"/>
<path fill="#040914" opacity="1.000000" stroke="none" 
	d="
M188.807495,349.269897 
	C191.325439,349.084869 192.408401,350.952820 193.782639,352.317657 
	C206.364471,364.813660 219.268570,377.032227 230.792007,390.510620 
	C237.207382,398.014343 245.217102,404.101166 250.687927,412.840454 
	C251.199783,413.243469 251.426010,413.471649 251.848175,413.844910 
	C252.025009,414.009003 251.995331,414.004578 251.992920,413.989807 
	C252.206924,414.217865 252.432327,414.452057 252.845734,414.843079 
	C253.024796,415.008575 252.995178,415.004761 252.993195,414.989990 
	C253.206970,415.217804 253.431839,415.451630 253.844788,415.841583 
	C254.023727,416.006500 253.994858,416.003815 253.997055,415.989502 
	C254.458344,416.588745 254.783981,417.325775 255.787201,417.825653 
	C256.022461,417.997681 255.997391,418.002625 256.000336,417.990234 
	C256.413940,418.425018 256.470581,419.014496 256.826965,419.777161 
	C257.015076,419.995178 256.998779,420.000000 257.002747,419.992126 
	C257.347595,420.270203 257.704041,420.535400 258.222107,421.085205 
	C258.420654,423.621338 256.833405,425.083313 255.599136,427.088684 
	C255.058975,427.706360 254.693024,427.998871 253.949402,428.352722 
	C246.709641,427.277374 242.177933,423.601379 241.091537,416.412384 
	C240.874268,414.974579 240.221085,413.915710 239.077744,413.154266 
	C234.213394,409.914825 230.489243,405.387085 225.774475,401.431396 
	C223.141739,398.427704 220.568161,395.905457 217.762711,393.574310 
	C214.793167,391.106781 212.267502,388.245544 213.299957,383.544312 
	C214.030746,382.695953 214.556198,381.952026 215.539108,382.792084 
	C214.620819,381.770935 213.346619,382.251709 212.081299,381.543640 
	C206.391602,375.506195 200.897247,369.740326 194.584747,364.277222 
	C192.112091,359.317017 189.155792,354.914551 188.807495,349.269897 
z"/>
<path fill="#090A10" opacity="1.000000" stroke="none" 
	d="
M126.126968,267.108459 
	C126.712578,274.252991 131.777756,278.518951 135.219879,283.645905 
	C143.843277,296.490295 154.754211,307.461853 164.732178,319.196716 
	C165.834579,320.493225 167.207428,321.177002 164.683044,322.806885 
	C163.613007,323.497742 165.237198,326.031342 166.077332,327.644562 
	C167.730133,330.818298 171.088150,333.119537 170.326477,337.779663 
	C166.631363,337.413910 163.531891,336.741211 160.197906,335.567322 
	C159.696472,335.202332 159.519745,335.024475 159.131561,334.535645 
	C156.980789,330.556183 154.432800,327.236450 152.749863,323.418945 
	C152.277710,322.348022 151.603638,321.424713 150.589752,320.748871 
	C138.308197,312.562347 132.604095,300.539612 130.703369,286.365356 
	C130.444122,284.432068 129.880493,282.817505 128.363297,281.620361 
	C122.939034,277.340424 121.245316,271.066864 119.462769,264.518219 
	C119.825218,263.680237 120.213104,263.366882 121.108315,263.168152 
	C123.731781,263.425690 125.169418,264.744659 126.126968,267.108459 
z"/>
<path fill="#061426" opacity="1.000000" stroke="none" 
	d="
M159.637207,333.838989 
	C159.997375,334.003662 159.998566,334.474609 159.997040,334.710083 
	C162.980896,336.325592 166.166611,336.994415 169.693207,337.791138 
	C170.012634,337.995148 169.998886,338.001221 169.999329,337.993713 
	C170.433762,338.455994 170.969009,338.530853 171.776001,338.196686 
	C178.393631,340.132935 185.042023,341.860352 188.892761,348.665039 
	C191.004303,353.733978 192.967407,358.494507 194.975311,363.619751 
	C197.401993,366.122345 197.223419,368.601196 195.785156,371.540833 
	C194.507599,372.947327 192.695969,373.305267 192.080978,372.281403 
	C189.466187,367.928040 184.592911,369.242004 180.684937,367.288879 
	C176.407425,364.681976 171.594604,363.672058 168.181213,359.689392 
	C167.350037,357.661224 166.184296,356.211273 165.472260,354.522339 
	C163.583023,350.041290 163.992859,349.101562 169.207199,347.067993 
	C166.934387,345.892914 164.737274,346.523956 162.443100,345.888123 
	C161.374496,345.541595 160.725632,345.167480 159.842072,344.440308 
	C158.150848,341.126648 155.924026,338.213959 158.298920,334.314056 
	C158.801956,333.904785 159.039505,333.789551 159.637207,333.838989 
z"/>
<path fill="#18DBFB" opacity="1.000000" stroke="none" 
	d="
M280.752197,393.312805 
	C282.446808,391.257385 283.481812,393.005585 284.849487,393.766846 
	C285.189758,394.190918 285.348938,394.354858 285.754761,394.756714 
	C286.001434,394.994690 286.000000,395.000000 286.002655,394.998474 
	C286.421478,395.446747 287.005005,395.504700 287.776062,395.829895 
	C288.003601,396.003571 288.000000,396.000000 287.997864,395.998291 
	C288.213348,396.225250 288.434662,396.450317 288.829407,396.836853 
	C288.999146,397.001892 289.000000,397.000000 288.998901,397.000793 
	C289.531097,397.531647 290.054993,398.071167 290.791260,398.797119 
	C290.989960,398.997192 290.998779,399.001648 291.002502,399.005249 
	C291.006195,399.008881 291.336700,399.286285 291.537750,399.359100 
	C291.738800,399.431915 292.144104,399.548187 292.344635,399.599609 
	C292.545166,399.651001 292.649994,399.248169 292.818298,399.125732 
	C295.633606,397.109894 294.626160,395.724457 292.178711,394.251770 
	C292.016541,392.543427 292.722534,391.662109 294.520874,391.384399 
	C299.044800,392.867462 302.526672,395.295471 305.395264,399.066620 
	C305.568909,400.055420 305.420227,400.656494 304.716187,401.307739 
	C304.479889,401.457520 303.988831,401.551544 303.988831,401.551544 
	C303.988831,401.551544 303.504944,401.434723 303.381012,401.608795 
	C303.257080,401.782867 303.684509,401.983582 303.895752,402.126038 
	C304.248505,402.381378 304.390045,402.494232 304.970673,402.987427 
	C306.162048,404.071259 306.899170,404.792236 308.003632,405.563843 
	C308.437775,405.852509 308.609344,405.969940 309.029724,406.272827 
	C309.595306,406.718079 309.902557,406.988617 310.426636,407.470215 
	C310.800415,407.806396 310.948914,407.941223 311.547699,408.471924 
	C312.154724,408.992737 312.311401,409.117737 312.713196,409.418121 
	C313.799377,410.175293 314.716431,410.621063 315.897430,411.238098 
	C317.396240,412.239319 318.377533,413.328735 319.446899,414.758728 
	C319.740997,415.174927 319.854950,415.341980 320.318481,415.990845 
	C320.793976,416.622742 320.919891,416.772766 321.443970,417.349365 
	C322.112457,418.051971 322.383026,418.327789 322.866272,418.799713 
	C323.220978,419.126465 323.363190,419.256958 323.722656,419.578400 
	C324.531982,420.283386 325.186707,420.699005 326.179291,421.156433 
	C326.817169,421.520142 327.145905,421.786530 327.660431,422.339539 
	C328.126587,422.966461 328.349976,423.357178 328.678040,424.085327 
	C328.940338,424.861053 329.038849,425.321228 329.139160,426.147583 
	C329.200592,427.490845 329.066345,428.451721 328.617584,429.730286 
	C327.597321,431.302002 327.189697,432.743256 326.482910,434.475952 
	C324.553040,438.630127 325.819031,442.658569 325.446289,446.565765 
	C325.213257,449.008606 326.011597,451.533020 324.463440,453.967316 
	C323.077240,453.234009 322.093811,452.437897 320.978943,451.350525 
	C319.969086,446.564575 319.521057,442.007996 319.125000,437.458130 
	C318.925018,435.160583 318.215698,433.352509 316.084900,431.787994 
	C314.239685,429.461731 314.520508,426.940582 314.088379,424.555481 
	C313.376556,420.626465 313.109985,416.243256 307.831116,414.730591 
	C307.096039,414.107483 306.666199,413.652466 306.417908,412.723572 
	C306.198669,412.074646 305.891510,412.127289 305.770111,412.044739 
	C305.223267,411.672852 305.781616,412.798004 305.633270,412.148041 
	C305.632568,412.145020 305.769623,412.097504 306.200500,412.264038 
	C306.515259,413.133698 306.697479,413.733276 307.411804,414.430206 
	C309.857452,418.457703 309.676727,418.786896 304.479828,419.726562 
	C301.553925,418.033844 299.378052,415.980316 297.381775,413.321899 
	C297.254700,412.832642 297.230011,412.637390 297.225891,412.165222 
	C297.296112,411.721222 297.345734,411.554108 297.528198,411.178650 
	C297.661011,410.970306 298.086884,410.769379 298.295319,410.849487 
	C298.503754,410.929596 298.230835,410.581024 297.834412,410.377502 
	C297.437988,410.173950 297.090576,409.878815 296.757080,409.558472 
	C296.423584,409.238098 296.091156,408.906067 295.756592,408.566223 
	C295.421997,408.226379 295.092773,407.873871 294.801270,407.489197 
	C294.509796,407.104553 294.244568,406.703644 294.180176,406.941833 
	C293.957458,407.241638 293.799164,407.303284 293.379639,407.346497 
	C292.950592,407.267883 292.782745,407.207642 292.379272,407.011078 
	C291.997253,406.763489 291.850830,406.652191 291.496552,406.354736 
	C291.152008,406.038818 291.015381,405.909058 290.458801,405.385071 
	C289.893585,404.858459 289.748383,404.726074 289.157501,404.187561 
	C287.683014,402.762390 286.635223,401.765808 285.135162,400.810059 
	C284.513489,400.379669 284.171295,400.111938 283.588928,399.612061 
	C282.197021,398.284851 281.271729,397.023315 280.517456,395.239685 
	C280.347229,394.457153 280.385162,394.007935 280.752197,393.312805 
z"/>
<path fill="#02E6FD" opacity="1.000000" stroke="none" 
	d="
M315.402100,473.285156 
	C310.213440,466.895691 305.178131,460.769012 300.078156,454.308838 
	C299.078857,450.859406 300.651733,449.710114 303.889435,449.717773 
	C315.486572,460.026123 326.679108,470.165894 337.928345,480.639191 
	C337.637726,481.146240 337.500549,481.422424 337.786987,481.895752 
	C342.446167,482.669037 343.185425,486.914520 345.708740,489.912048 
	C346.952454,493.075409 344.647369,493.010956 343.001221,493.019897 
	C339.968384,493.036377 337.219666,491.904999 334.592743,490.369232 
	C330.447296,487.945557 326.702057,484.932495 322.263916,482.241272 
	C321.914337,482.050079 321.990265,482.013550 321.969360,482.050110 
	C321.274384,480.756256 320.623383,479.409851 319.192505,478.223145 
	C318.356873,477.524902 317.754333,477.045410 317.084564,476.275482 
	C316.544189,475.580963 316.533722,474.984924 316.219177,474.213623 
	C316.058655,473.978821 315.996765,473.987976 316.011658,473.960480 
	C315.869507,473.804657 315.712463,473.676300 315.402100,473.285156 
z"/>
<path fill="#061426" opacity="1.000000" stroke="none" 
	d="
M294.733154,465.759705 
	C295.009918,465.989166 295.501312,465.996124 295.747009,466.000641 
	C296.026794,468.736237 296.822601,471.131165 298.760651,473.169922 
	C299.850464,474.316467 301.322327,475.555084 299.545715,477.640198 
	C297.436951,478.511871 295.567108,478.430023 293.290588,478.425781 
	C290.330536,478.481995 287.785492,478.479767 284.809875,478.398254 
	C283.509216,478.322906 282.650452,478.212189 281.451721,477.685425 
	C280.874725,477.276062 280.678009,477.070923 280.286438,476.491821 
	C279.480347,474.287323 279.653015,472.388916 279.607788,470.137024 
	C279.933044,467.096954 279.224396,465.245117 276.119476,465.083893 
	C274.581451,465.004028 273.377563,464.066376 272.205719,463.157990 
	C270.717102,462.004028 269.242188,461.900055 267.443115,463.325684 
	C266.659241,463.644073 266.179840,463.703400 265.327209,463.608276 
	C263.282288,462.669983 262.326630,461.315979 262.173370,459.066467 
	C262.464203,457.382416 263.115417,456.261047 264.203705,455.164307 
	C264.361633,455.037384 264.618835,454.811188 264.432983,454.898987 
	C263.393127,455.466034 262.862061,456.284119 261.947571,457.186462 
	C261.535614,457.568268 261.362732,457.714417 260.585724,458.185730 
	C259.751526,458.539215 259.521454,458.567596 258.948944,458.528259 
	C258.185730,458.233978 257.875244,457.901276 257.612457,457.130737 
	C257.705139,455.157379 258.064362,453.594025 259.086731,451.884460 
	C260.861145,448.701874 264.067017,447.054352 265.376770,443.532227 
	C269.051910,440.372192 269.609589,440.409393 270.551971,444.309753 
	C271.286713,447.350739 273.270111,448.201508 275.946869,448.261047 
	C277.254456,448.290161 278.555420,447.772461 279.875000,448.015991 
	C282.114014,448.429291 283.580261,449.884033 281.676208,451.672638 
	C279.015411,454.172180 279.513336,455.542542 282.315857,457.110962 
	C283.009613,457.499146 283.216675,458.459473 283.670410,459.523376 
	C284.202271,462.085938 285.909851,462.822021 288.151917,463.436981 
	C290.210297,464.996948 292.583435,464.496826 294.733154,465.759705 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M283.388123,460.039856 
	C281.730225,459.305847 282.030426,457.396484 280.121674,456.934662 
	C275.652679,455.853424 276.739532,453.850281 279.715088,451.988068 
	C280.546906,451.467377 281.783325,451.191986 281.461853,450.009338 
	C281.044647,448.474304 279.359558,448.749725 278.549103,449.145050 
	C275.132294,450.811615 272.524994,449.335815 269.989075,447.343567 
	C269.115234,446.657074 268.010468,445.951630 268.997101,444.526947 
	C269.544128,443.737030 270.347198,442.777802 268.823334,442.212341 
	C267.735443,441.808655 266.972076,442.578766 266.154633,443.649933 
	C265.229126,444.805725 264.216217,445.130707 262.711121,445.273926 
	C261.518951,445.286591 260.743439,445.174377 259.648743,444.762512 
	C257.403717,442.671204 259.050964,441.074066 259.996948,439.125366 
	C260.489441,438.539978 260.784790,438.228333 261.297821,437.712769 
	C261.338562,437.017334 262.374023,437.499115 261.851807,437.093506 
	C261.404572,437.590302 261.126129,437.861206 260.608124,438.320190 
	C259.786255,438.803558 259.169189,438.839081 258.220459,438.684021 
	C257.285828,438.373566 256.726227,438.038574 255.999619,437.373138 
	C255.387146,435.660187 256.348236,434.678284 257.227386,433.353271 
	C258.100830,432.355042 258.975189,431.834381 259.946838,430.977905 
	C260.304901,430.654205 260.448303,430.525909 260.811890,430.213867 
	C261.185669,429.918243 261.339294,429.806366 261.735901,429.548706 
	C262.312592,429.231537 262.650879,429.069855 263.251404,428.811401 
	C263.688751,428.663330 263.869415,428.623657 264.325195,428.556030 
	C264.970947,428.519684 265.331390,428.576080 265.912231,428.847565 
	C273.777496,435.382324 279.691284,443.420654 286.851562,450.698944 
	C284.722687,453.601501 286.433838,457.619293 283.388123,460.039856 
z"/>
<path fill="#16ECFA" opacity="1.000000" stroke="none" 
	d="
M322.011536,482.334900 
	C327.588470,482.359955 330.812164,487.261261 335.553436,489.338196 
	C338.866791,490.789642 341.957214,493.354065 345.906525,490.474213 
	C346.436554,490.349915 346.885895,490.586914 347.580109,490.951111 
	C349.507233,492.205261 350.478638,493.934479 351.738953,495.832214 
	C351.876343,496.129028 351.959045,495.986237 351.908630,496.052185 
	C352.690308,496.740173 353.432831,497.432861 353.783936,498.861145 
	C353.263489,503.524384 350.287689,504.332916 346.686462,504.058075 
	C343.832458,503.840302 341.399323,502.435577 338.702393,500.817261 
	C338.197693,500.535156 337.998657,500.424988 337.514099,500.142212 
	C336.869354,499.735413 336.514709,499.494568 335.914001,499.072510 
	C335.345734,498.659637 335.048035,498.398346 334.591431,497.893921 
	C334.301697,497.526520 334.194214,497.376007 333.935425,496.999084 
	C333.684113,496.624847 333.584076,496.477081 333.323120,496.121124 
	C332.920471,495.656067 332.655640,495.425690 332.125732,495.095398 
	C331.542480,494.806549 331.210571,494.627228 330.646179,494.259125 
	C329.798981,493.550140 329.234985,492.968842 328.388428,492.230286 
	C328.013733,491.862732 327.871399,491.706970 327.543396,491.293396 
	C326.920258,490.310608 326.586090,489.529785 325.977722,488.534973 
	C325.238251,487.355774 324.541260,486.512360 324.233948,485.108154 
	C323.456238,484.074036 322.782471,483.346893 322.011536,482.334900 
z"/>
<path fill="#05E2FD" opacity="1.000000" stroke="none" 
	d="
M315.744446,431.218933 
	C319.121521,431.914948 320.594086,433.308197 320.377686,437.213867 
	C320.135376,441.587219 321.686951,446.050598 321.151825,450.815857 
	C315.032257,445.778564 309.216980,440.497772 303.195801,434.936157 
	C300.772095,430.984985 302.204254,426.510345 300.508911,422.410339 
	C301.002930,421.711151 301.415436,421.459839 302.260254,421.305359 
	C305.245697,421.573212 306.741608,423.094147 307.471954,425.578094 
	C308.032257,427.483551 308.854675,429.303955 309.574890,431.155518 
	C310.162506,432.666290 310.531769,434.729309 312.404907,434.889069 
	C314.480652,435.066132 314.389130,432.564819 315.744446,431.218933 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M315.655701,484.756470 
	C315.991821,485.016296 316.454193,485.085541 316.686829,485.108459 
	C319.268188,486.521515 320.477600,488.648132 321.788452,491.048157 
	C323.664948,494.483826 326.533417,497.378479 328.478668,500.878326 
	C329.130920,502.051788 329.983704,503.030487 329.476624,504.814575 
	C328.640228,505.967743 327.730164,506.387390 326.358154,506.713684 
	C324.017426,506.594391 322.039948,506.468628 320.087463,505.093323 
	C319.607941,504.121307 320.309357,503.173859 319.079712,502.458435 
	C318.602234,501.933197 318.427765,501.571747 318.310486,500.893219 
	C318.241943,499.145752 317.648071,500.053680 316.910675,500.535492 
	C316.408478,500.789551 316.189606,500.869812 315.614746,501.016724 
	C310.647614,500.086151 307.891571,496.758728 308.409149,492.433777 
	C308.684509,490.133209 308.957886,487.816803 309.600525,485.173065 
	C310.011597,484.645233 310.232056,484.478851 310.839478,484.153198 
	C312.652191,483.661713 314.032745,483.697662 315.655701,484.756470 
z"/>
<path fill="#3EE8F8" opacity="1.000000" stroke="none" 
	d="
M267.617249,396.739929 
	C271.241913,399.030243 274.743073,401.084717 278.591522,403.249329 
	C281.922089,403.780121 283.327515,406.066467 284.918793,408.686584 
	C285.506989,411.875336 285.822113,414.668671 284.306519,417.681793 
	C276.823486,411.783325 269.638062,405.581146 262.254272,399.107666 
	C261.875549,396.410797 263.611908,396.123169 265.736328,395.817810 
	C266.274414,395.813232 266.448944,395.853638 266.824463,396.072449 
	C267.181580,396.335266 267.337677,396.419678 267.617249,396.739929 
z"/>
<path fill="#26E5F5" opacity="1.000000" stroke="none" 
	d="
M301.137878,421.653595 
	C303.600098,425.567413 302.918823,429.747650 302.991638,434.227783 
	C298.813965,431.098541 294.638031,427.541809 290.266479,423.689728 
	C291.023956,419.613464 286.504578,417.119415 287.922974,413.030945 
	C289.015778,412.274078 289.887146,412.442413 291.056488,412.883087 
	C291.527954,413.140961 291.703125,413.262177 292.084961,413.618530 
	C292.314758,414.202057 292.454590,414.480957 292.711090,414.690308 
	C292.775940,414.382599 292.621765,414.028961 293.186890,413.618408 
	C296.375977,413.304688 297.591003,415.630249 299.397034,417.633484 
	C299.825500,418.263855 300.056885,418.631439 300.457214,419.275757 
	C300.969879,420.110687 301.222778,420.703247 301.137878,421.653595 
z"/>
<path fill="#21E8FF" opacity="1.000000" stroke="none" 
	d="
M342.152222,444.562622 
	C340.643738,447.247284 337.649414,448.930878 340.361572,452.536011 
	C341.300446,453.784027 340.563171,456.889313 338.841461,458.241211 
	C337.103149,459.606140 334.463470,459.752655 332.971069,458.107086 
	C331.159271,456.109283 330.810638,457.312775 330.002686,459.010620 
	C328.732269,458.329620 327.576294,457.341553 326.252930,456.073792 
	C325.590851,454.122101 326.621613,453.058044 327.925171,451.814331 
	C328.625549,451.299438 329.862030,451.918060 329.459991,451.472046 
	C326.828735,448.553467 327.743469,444.871216 327.036621,441.568207 
	C326.841583,440.656769 327.151642,439.393463 328.296661,439.133636 
	C329.542786,438.850830 330.059631,440.055267 330.272491,440.933044 
	C331.190491,444.718719 333.398834,447.775879 336.002655,451.763397 
	C335.826965,447.240082 333.050720,442.827118 338.659790,440.463776 
	C341.137695,440.788239 342.071716,442.173248 342.152222,444.562622 
z"/>
<path fill="#09D3F7" opacity="1.000000" stroke="none" 
	d="
M304.147095,449.575867 
	C302.173645,450.117615 300.724060,451.178589 300.060852,453.622986 
	C295.023743,447.977295 290.033966,441.979309 284.894379,435.687927 
	C284.582153,434.681061 284.805084,434.121002 285.905579,433.742798 
	C292.265198,438.935974 298.132629,444.100677 304.147095,449.575867 
z"/>
<path fill="#071A2D" opacity="1.000000" stroke="none" 
	d="
M329.160492,505.317749 
	C326.468292,501.655975 325.999817,497.183868 322.006409,494.482941 
	C319.414246,492.729828 319.940094,488.079163 316.989594,485.474609 
	C319.206207,484.421143 321.354767,487.019745 323.904480,485.107483 
	C324.989807,485.675415 325.849670,486.549652 326.787506,487.723999 
	C326.199829,488.897461 326.348572,489.899933 326.460907,491.198486 
	C327.509155,496.413300 332.458130,499.189880 333.448669,504.499451 
	C333.663391,505.317383 333.659058,505.799988 333.408447,506.621155 
	C331.501373,507.838348 330.341370,506.914185 329.160492,505.317749 
z"/>
<path fill="#040914" opacity="1.000000" stroke="none" 
	d="
M283.007202,460.401855 
	C285.376373,457.513428 282.382538,453.059784 286.629761,451.065277 
	C287.451080,453.510284 289.015228,455.441071 290.716888,457.109802 
	C292.513885,458.872009 293.276794,460.778290 293.004761,463.597198 
	C291.717773,465.223053 290.258057,465.065643 288.374695,464.260803 
	C285.773499,463.813293 282.704376,464.943909 283.007202,460.401855 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M300.202454,477.347870 
	C298.465607,474.926178 296.878448,472.866089 295.442017,470.705780 
	C294.541534,469.351562 293.402527,467.823486 295.809875,466.270355 
	C297.256866,466.141235 298.943451,465.474121 299.632202,466.889557 
	C302.207184,472.181763 306.571899,475.243073 311.716675,477.868469 
	C310.035675,479.466461 308.390289,478.373932 306.481628,478.853271 
	C304.046814,479.324280 302.088623,479.132690 300.202454,477.347870 
z"/>
<path fill="#31E7FE" opacity="1.000000" stroke="none" 
	d="
M289.179474,412.728882 
	C287.082458,415.104767 289.768585,416.331177 290.025604,418.027588 
	C290.281464,419.715912 292.858856,421.055359 290.424408,423.244507 
	C288.826416,422.390839 287.581940,421.387360 286.185364,420.115051 
	C285.851501,419.723541 285.669708,419.600800 285.276672,419.225800 
	C285.065430,418.973541 285.006744,418.998840 285.015015,418.967957 
	C284.848419,418.786896 284.673553,418.636688 284.257141,418.239105 
	C284.015564,417.991699 284.001007,418.000214 284.004944,417.992859 
	C284.005524,414.967041 284.002136,411.948578 283.997528,408.477997 
	C284.380066,407.480438 284.941223,407.284271 285.875580,407.248779 
	C286.370392,407.335297 286.561768,407.398590 286.998352,407.633118 
	C287.357300,407.964844 287.471008,408.125305 287.704712,408.550720 
	C288.021362,409.347809 288.197632,409.888245 288.610443,410.633606 
	C289.047119,411.371918 289.266449,411.893280 289.179474,412.728882 
z"/>
<path fill="#26E5F5" opacity="1.000000" stroke="none" 
	d="
M265.914307,395.491150 
	C264.862640,396.603180 263.625336,397.433533 262.221985,398.550110 
	C258.208282,396.008972 254.360672,393.181519 250.279419,390.112305 
	C249.978516,388.855774 250.537628,388.506561 251.804138,388.726654 
	C257.379059,389.495789 261.270996,392.962585 265.914307,395.491150 
z"/>
<path fill="#09D3F7" opacity="1.000000" stroke="none" 
	d="
M328.250458,451.588409 
	C328.098083,453.374176 327.190186,454.284363 326.239929,455.522461 
	C325.470398,455.382629 324.855286,454.971161 324.150391,454.294891 
	C324.041077,448.921021 323.962433,443.811096 324.037628,438.703369 
	C324.060364,437.158447 323.298859,435.299286 325.590637,434.101959 
	C327.507019,435.330261 327.835876,437.053589 327.608856,438.938782 
	C327.109863,443.082367 328.324768,447.102448 328.250458,451.588409 
z"/>
<path fill="#54BDE4" opacity="1.000000" stroke="none" 
	d="
M126.470543,267.660767 
	C124.963402,266.260559 123.757996,265.033783 122.363510,263.534515 
	C121.462646,262.507629 121.952614,262.007324 122.882919,261.409637 
	C127.334877,261.722260 129.576447,265.303680 133.228119,267.231750 
	C135.361282,268.783997 137.448212,269.903595 137.989716,272.802521 
	C137.944168,273.723175 137.786087,274.221283 137.252716,274.971039 
	C136.709076,275.265900 136.444763,275.278778 135.803162,275.168243 
	C132.541351,272.641296 129.656815,270.237762 126.470543,267.660767 
z"/>
<path fill="#72C2DC" opacity="1.000000" stroke="none" 
	d="
M279.287781,402.055695 
	C277.172852,400.118805 275.238312,398.483490 273.119904,396.581604 
	C272.421112,395.723389 272.338623,395.061768 272.833130,394.059998 
	C273.442841,393.511444 273.870300,393.325592 274.685913,393.227417 
	C275.259338,393.263245 275.485046,393.307556 276.024963,393.485596 
	C276.528412,393.739929 276.717621,393.860535 277.412598,394.402618 
	C278.969543,395.866272 279.974457,396.960999 281.523926,397.917084 
	C281.979950,398.206696 282.158417,398.331451 282.583862,398.673767 
	C284.252411,400.323395 285.748840,401.698792 286.543213,404.008301 
	C286.659607,404.814911 286.582153,405.269135 286.175873,405.967865 
	C283.015961,406.214081 281.625641,403.644501 279.287781,402.055695 
z"/>
<path fill="#8EC1D2" opacity="1.000000" stroke="none" 
	d="
M274.122528,393.646179 
	C273.715668,394.533142 273.368195,395.085693 272.978394,395.976654 
	C268.197906,393.241760 262.532257,391.328644 260.040863,385.573059 
	C263.813721,387.777618 267.036560,390.650635 271.562653,392.003845 
	C272.568420,392.648621 273.769440,392.288605 274.122528,393.646179 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M315.990540,484.633423 
	C314.619476,484.993073 313.247162,484.969818 311.463684,484.920227 
	C309.587646,483.790802 307.256561,483.303162 307.611908,480.810028 
	C307.916077,478.676239 310.194977,479.343781 311.715332,478.246368 
	C311.998566,478.001221 312.013245,477.987030 312.023010,477.977539 
	C315.756104,478.547974 315.148102,481.855591 315.990540,484.633423 
z"/>
<path fill="#010610" opacity="1.000000" stroke="none" 
	d="
M263.826355,426.818451 
	C264.013824,427.045685 264.005249,427.470581 263.996704,427.682892 
	C264.170044,428.079895 264.351929,428.264587 264.258667,428.724030 
	C263.983521,428.998779 264.003632,429.001801 264.006836,428.992126 
	C263.577911,429.414185 262.990265,429.470520 262.221375,429.809845 
	C261.997162,429.989044 262.000000,430.000000 261.995056,429.996399 
	C261.538330,430.418182 260.886749,430.534943 260.227600,431.204193 
	C259.471527,431.770203 258.886993,432.006348 257.983887,432.307983 
	C256.988983,432.186829 256.612427,431.706787 256.443787,430.709808 
	C256.551178,429.741028 256.793335,429.141418 257.188965,428.256500 
	C257.600494,427.385468 257.909698,426.822021 258.335632,425.952057 
	C258.793732,425.073395 259.170715,424.532349 259.903778,423.854614 
	C260.610077,423.513763 261.049011,423.485382 261.759888,423.800262 
	C262.024994,424.008301 261.997375,424.001831 261.991272,423.989014 
	C262.205475,424.216736 262.432617,424.450623 262.844116,424.846100 
	C263.021729,425.014252 262.998047,425.001984 262.994568,424.989136 
	C263.421326,425.428589 263.472565,426.032990 263.826355,426.818451 
z"/>
<path fill="#252326" opacity="1.000000" stroke="none" 
	d="
M279.071228,402.156128 
	C282.056030,401.803070 283.291260,404.431915 285.617981,406.031372 
	C286.641693,406.287109 287.040680,406.737366 287.173553,407.712585 
	C286.577606,409.470215 285.732941,408.989777 284.433136,408.212952 
	C282.411346,406.649841 280.826416,405.273773 279.090149,403.628601 
	C278.970917,403.092377 279.003021,402.825226 279.071228,402.156128 
z"/>
<path fill="#0CA3DE" opacity="1.000000" stroke="none" 
	d="
M286.244507,433.466705 
	C285.985260,434.089478 285.572784,434.407623 284.952454,435.060150 
	C282.902618,433.498962 281.060669,431.603363 279.053223,429.423248 
	C278.799957,428.820404 278.712128,428.502106 278.878479,427.758667 
	C281.452179,429.276398 283.771759,431.219269 286.244507,433.466705 
z"/>
<path fill="#01BEE9" opacity="1.000000" stroke="none" 
	d="
M252.027008,388.573242 
	C251.573761,389.071777 250.997406,389.231689 250.233429,389.631104 
	C248.216492,388.679840 246.387207,387.489105 244.285095,386.112244 
	C243.889481,385.641663 243.766678,385.357178 243.796432,384.633728 
	C246.628677,385.486115 249.629013,386.146118 252.027008,388.573242 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M288.082520,464.380554 
	C289.389801,464.000366 290.780853,463.999512 292.589478,463.997498 
	C293.908691,464.075745 294.694763,464.317993 294.963959,465.671082 
	C292.738983,465.522217 290.098175,467.114258 288.082520,464.380554 
z"/>
<path fill="#BEDBE2" opacity="1.000000" stroke="none" 
	d="
M145.884628,280.759583 
	C145.962860,281.887024 145.972198,282.615936 145.978043,283.709595 
	C144.693192,283.043610 143.411804,282.012909 142.003357,280.702087 
	C141.787430,280.169098 141.698578,279.916229 141.717331,279.275208 
	C143.713821,277.865997 144.861740,278.851044 145.884628,280.759583 
z"/>
<path fill="#08101D" opacity="1.000000" stroke="none" 
	d="
M255.544266,427.320038 
	C255.050964,424.918213 256.996765,423.634705 257.828674,421.400787 
	C258.151123,420.920715 258.331238,420.746277 258.825806,420.778259 
	C259.423462,421.084930 259.651062,421.258240 259.915527,421.701294 
	C260.145752,422.080414 260.283508,422.262848 260.331421,422.775879 
	C258.543121,424.257507 258.471680,426.906464 255.544266,427.320038 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M351.926392,495.784668 
	C350.032257,495.144226 349.133087,493.317291 347.892395,491.406464 
	C349.882416,490.749573 350.500702,492.431000 351.719299,493.858276 
	C351.991913,494.514160 351.984192,494.977234 351.926392,495.784668 
z"/>
<path fill="#16ECFA" opacity="1.000000" stroke="none" 
	d="
M319.059082,478.320251 
	C321.065948,478.122833 322.017944,479.284821 321.963074,481.715210 
	C320.636749,481.245148 319.494263,480.266815 319.059082,478.320251 
z"/>
<path fill="#1174A3" opacity="1.000000" stroke="none" 
	d="
M278.998352,427.085754 
	C279.088104,427.633942 279.043610,427.934296 278.943420,428.686676 
	C277.521240,428.390442 276.534882,427.273010 275.904327,425.447571 
	C276.976288,425.586456 277.920166,426.212189 278.998352,427.085754 
z"/>
<path fill="#1174A3" opacity="1.000000" stroke="none" 
	d="
M243.725372,384.018433 
	C243.964920,384.483154 243.980850,384.771606 244.004517,385.493073 
	C242.786957,385.209686 241.561630,384.493256 240.252411,383.727753 
	C241.603241,382.365173 242.507202,383.577454 243.725372,384.018433 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M338.052094,481.735046 
	C337.740570,482.975037 337.307404,483.770203 336.089325,483.427368 
	C335.828796,483.354065 335.476501,483.011261 335.458496,482.770752 
	C335.357269,481.419189 336.773621,481.707581 337.678101,481.031067 
	C338.024628,481.141785 338.064178,481.310791 338.052094,481.735046 
z"/>
<path fill="#071F39" opacity="1.000000" stroke="none" 
	d="
M260.308411,423.507446 
	C259.960449,422.833740 259.967712,422.646912 259.991516,422.179047 
	C260.594513,422.422424 261.181030,422.946869 261.896271,423.739807 
	C261.571198,424.003662 261.117432,423.999023 260.308411,423.507446 
z"/>
<path fill="#071F39" opacity="1.000000" stroke="none" 
	d="
M255.901337,417.728851 
	C255.070053,417.972229 254.295975,417.690369 254.030151,416.304260 
	C254.592896,416.470123 255.186554,416.965088 255.901337,417.728851 
z"/>
<path fill="#A2CEDF" opacity="1.000000" stroke="none" 
	d="
M140.223938,278.579712 
	C139.396423,278.431061 138.771927,278.024139 138.254303,277.125977 
	C139.043945,276.429535 139.642029,276.572418 140.294586,277.367676 
	C140.432709,277.883453 140.429840,278.102448 140.223938,278.579712 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M171.746170,337.994507 
	C171.564728,338.709961 171.036133,339.009766 170.143524,338.211731 
	C170.168442,337.987366 170.337082,337.988525 170.758133,337.970459 
	C171.010529,337.951233 171.500839,337.982147 171.746170,337.994507 
z"/>
<path fill="#090A10" opacity="1.000000" stroke="none" 
	d="
M179.012741,335.237732 
	C179.412643,335.346710 180.272827,335.581543 179.383209,336.305939 
	C179.259613,336.034760 179.136002,335.763611 179.012741,335.237732 
z"/>
<path fill="#071F39" opacity="1.000000" stroke="none" 
	d="
M263.988831,426.740479 
	C263.688416,426.558746 263.363037,426.071808 263.014343,425.280579 
	C263.315308,425.462616 263.639557,425.948944 263.988831,426.740479 
z"/>
<path fill="#071F39" opacity="1.000000" stroke="none" 
	d="
M264.342407,429.000732 
	C263.980804,428.815216 263.978058,428.631622 263.981750,428.171631 
	C264.575256,428.095490 265.162354,428.295776 265.946167,428.746826 
	C265.662354,428.999268 265.181854,429.000977 264.342407,429.000732 
z"/>
<path fill="#071F39" opacity="1.000000" stroke="none" 
	d="
M257.020477,419.690674 
	C256.680328,419.525970 256.345612,419.056763 256.007080,418.282684 
	C256.344116,418.447266 256.684998,418.916718 257.020477,419.690674 
z"/>
<path fill="#071F39" opacity="1.000000" stroke="none" 
	d="
M258.942871,420.741730 
	C258.945404,421.002350 258.750580,421.020050 258.263367,421.066406 
	C257.715759,420.879547 257.460571,420.663971 257.106049,420.216309 
	C257.586334,420.155731 258.165924,420.327271 258.942871,420.741730 
z"/>
<path fill="#16ECFA" opacity="1.000000" stroke="none" 
	d="
M316.081970,474.286865 
	C316.362213,474.452118 316.665771,474.925385 316.993347,475.691833 
	C316.284882,475.802734 316.130157,475.241425 316.081970,474.286865 
z"/>
<path fill="#16ECFA" opacity="1.000000" stroke="none" 
	d="
M315.282166,473.239441 
	C315.496552,473.150665 315.696167,473.332001 315.937103,473.749664 
	C315.716583,473.883087 315.479584,473.724274 315.282166,473.239441 
z"/>
<path fill="#26E5F5" opacity="1.000000" stroke="none" 
	d="
M267.745056,396.767029 
	C267.509857,396.899658 267.322998,396.763245 267.102783,396.408691 
	C267.340057,396.180725 267.581360,396.283203 267.745056,396.767029 
z"/>
<path fill="#0BCEF8" opacity="1.000000" stroke="none" 
	d="
M192.570557,325.357056 
	C192.831940,325.210144 193.243088,325.387268 193.805267,325.870728 
	C193.544296,326.011749 193.132294,325.846405 192.570557,325.357056 
z"/>
<path fill="#0BCEF8" opacity="1.000000" stroke="none" 
	d="
M193.824371,326.447449 
	C194.162811,326.239380 194.535889,326.352081 194.938232,326.771545 
	C194.598007,326.974945 194.228500,326.871552 193.824371,326.447449 
z"/>
<path fill="#071F39" opacity="1.000000" stroke="none" 
	d="
M253.913300,415.779419 
	C253.747818,415.818726 253.471909,415.630920 253.093628,415.209167 
	C253.261780,415.167603 253.532333,415.359955 253.913300,415.779419 
z"/>
<path fill="#090A10" opacity="1.000000" stroke="none" 
	d="
M173.449066,328.534149 
	C173.415970,328.478668 173.482178,328.589630 173.449066,328.534149 
z"/>
<path fill="#071F39" opacity="1.000000" stroke="none" 
	d="
M252.914108,414.781036 
	C252.749634,414.819305 252.474472,414.630005 252.094910,414.207886 
	C252.261475,414.167847 252.532455,414.360687 252.914108,414.781036 
z"/>
<path fill="#071F39" opacity="1.000000" stroke="none" 
	d="
M251.915909,413.782715 
	C251.752182,413.823334 251.479340,413.637634 251.099594,413.224152 
	C251.264053,413.183044 251.535431,413.369720 251.915909,413.782715 
z"/>
<path fill="#3EE8F8" opacity="1.000000" stroke="none" 
	d="
M285.140625,419.200195 
	C285.354645,419.071320 285.598236,419.236389 285.914734,419.657532 
	C285.681244,419.861481 285.408752,419.721710 285.140625,419.200195 
z"/>
<path fill="#3EE8F8" opacity="1.000000" stroke="none" 
	d="
M284.093414,418.231079 
	C284.328644,418.088715 284.586975,418.265625 284.906921,418.729797 
	C284.739288,418.781555 284.455292,418.626007 284.093414,418.231079 
z"/>
<path fill="#090A10" opacity="1.000000" stroke="none" 
	d="
M175.450348,331.531342 
	C175.417221,331.475616 175.483490,331.587067 175.450348,331.531342 
z"/>
<path fill="#090A10" opacity="1.000000" stroke="none" 
	d="
M178.990753,335.007050 
	C178.865143,334.867096 178.748184,334.720154 178.631226,334.573242 
	C178.719070,334.619781 178.806915,334.666321 178.953918,334.847961 
	C179.013092,334.983002 178.999420,335.000092 178.990753,335.007050 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M141.825180,278.754669 
	C142.068863,279.133240 142.029495,279.390808 141.933197,280.035187 
	C141.566589,280.224670 141.256912,280.027374 140.941284,279.283875 
	C141.137573,278.703003 141.339844,278.668335 141.825180,278.754669 
z"/>
<path fill="#1174A3" opacity="1.000000" stroke="none" 
	d="
M275.812500,425.201355 
	C275.589691,425.089661 275.439819,424.897369 275.289948,424.705109 
	C275.479584,424.671936 275.669220,424.638763 275.945618,424.783142 
	C276.032410,424.960693 275.885406,425.120789 275.812500,425.201355 
z"/>
<path fill="#071F39" opacity="1.000000" stroke="none" 
	d="
M262.906586,424.789368 
	C262.746857,424.823181 262.471985,424.632080 262.091125,424.208618 
	C262.253906,424.172333 262.522675,424.368408 262.906586,424.789368 
z"/>
<path fill="#A2CEDF" opacity="1.000000" stroke="none" 
	d="
M135.590973,275.309601 
	C135.679199,275.004852 135.932526,274.964844 136.561813,274.843262 
	C137.061539,274.915100 137.185318,275.068481 137.063507,275.699799 
	C136.463974,275.976593 136.110031,275.775482 135.590973,275.309601 
z"/>
<path fill="#A2CEDF" opacity="1.000000" stroke="none" 
	d="
M138.028290,276.955444 
	C137.605148,276.951965 137.307999,276.802094 136.914368,276.414978 
	C136.817917,276.177704 137.078339,275.937775 137.210403,275.819824 
	C137.555496,275.789642 137.768539,275.877411 138.192108,276.239227 
	C138.402664,276.513306 138.154251,276.809052 138.028290,276.955444 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M140.155930,279.020447 
	C140.020905,278.838013 140.083969,278.395905 140.082901,278.172638 
	C140.439209,277.781677 140.769760,277.832977 141.210281,278.311005 
	C141.343170,278.550690 141.038315,278.935638 140.884216,279.126770 
	C140.730103,279.317932 140.290955,279.202911 140.155930,279.020447 
z"/>
<path fill="#3EE8F8" opacity="1.000000" stroke="none" 
	d="
M336.678040,499.540100 
	C340.079285,498.915100 341.950958,501.929199 344.896698,502.522003 
	C348.357483,503.218414 351.497955,503.732544 353.070862,499.110168 
	C354.927032,498.828735 355.788849,500.102203 356.784424,501.730225 
	C356.995636,501.987854 356.997192,502.000183 357.003906,502.002472 
	C357.051697,503.526917 358.404449,504.196014 359.243042,505.594269 
	C354.668213,506.261047 350.490631,508.867188 345.337311,508.969604 
	C344.725952,509.111389 344.528198,509.241882 343.996552,509.248840 
	C341.436554,505.918579 337.346039,504.147522 336.678040,499.540100 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M357.024841,501.620392 
	C355.434509,501.513885 354.812531,499.998871 353.419189,498.871948 
	C352.740173,498.048065 352.348328,497.372833 351.907349,496.407837 
	C354.514923,495.157532 354.750916,498.033508 356.603577,498.971313 
	C356.983887,499.783112 357.018951,500.518005 357.024841,501.620392 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M342.313416,445.107849 
	C341.281158,443.717438 340.529938,442.498535 339.530182,441.097137 
	C338.428101,440.521362 338.327698,439.794128 338.590515,438.630798 
	C339.505737,437.623169 340.422455,437.731384 340.955414,438.328064 
	C344.282043,442.052429 348.192688,445.401886 349.090088,450.960022 
	C348.410919,451.529480 347.915131,451.598175 347.049591,451.320496 
	C345.334381,449.193939 343.964417,447.236633 342.313416,445.107849 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M346.801697,451.468933 
	C347.227814,451.113861 347.751282,451.076447 348.667725,451.017609 
	C350.024353,450.824219 350.403229,451.408508 350.579834,452.579987 
	C350.105560,453.221069 349.671600,453.484344 349.061005,454.093353 
	C348.222626,453.554932 347.560852,452.670776 346.801697,451.468933 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M341.873413,510.625061 
	C342.103027,512.064758 341.773407,513.707764 343.236176,513.733887 
	C346.002380,513.783264 345.424744,515.843567 345.986267,517.876953 
	C343.661865,518.407349 340.912323,520.358887 338.718872,516.985962 
	C338.508514,516.666382 338.391296,516.592346 338.325409,516.570801 
	C337.369476,516.152954 336.389709,515.929138 335.485809,514.874451 
	C334.719910,512.607483 335.194153,511.023773 337.218292,509.658875 
	C338.284454,509.172119 339.043610,509.075195 340.201843,509.221924 
	C341.063446,509.509918 341.456055,509.827393 341.873413,510.625061 
z"/>
<path fill="#0F62A1" opacity="1.000000" stroke="none" 
	d="
M343.972321,532.668945 
	C343.732788,533.204529 343.463654,533.425354 343.035278,533.857483 
	C340.734100,534.162354 338.712219,535.880554 336.221680,534.267212 
	C339.143219,534.353394 338.963715,529.446838 342.623444,530.018677 
	C343.308868,530.804016 343.625793,531.579041 343.972321,532.668945 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M346.157166,518.777344 
	C346.112793,518.405579 346.118317,518.133911 346.154877,518.001343 
	C346.527252,517.885071 346.863098,517.901367 347.448853,517.906128 
	C347.293396,519.127563 350.040039,520.413818 347.924042,521.362915 
	C346.786285,521.873291 346.275269,520.319946 346.157166,518.777344 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M350.837646,518.939758 
	C350.985077,519.455200 350.974060,519.948547 350.935272,520.811768 
	C350.673767,520.628662 350.440094,520.075562 350.283447,519.205811 
	C350.360474,518.889160 350.679199,518.917603 350.837646,518.939758 
z"/>
<path fill="#08346F" opacity="1.000000" stroke="none" 
	d="
M342.333801,510.970398 
	C341.708649,510.768188 341.425720,510.546600 341.007782,510.088989 
	C340.654938,507.300018 341.602844,506.896515 343.861176,508.684265 
	C344.144897,508.982513 344.534668,508.969604 344.729187,508.975250 
	C344.923706,508.980896 345.068329,509.431152 345.126007,509.660522 
	C344.347809,510.243622 343.511932,510.597351 342.333801,510.970398 
z"/>
<path fill="#0E6CB9" opacity="1.000000" stroke="none" 
	d="
M319.647827,503.730743 
	C321.207397,506.084564 323.744202,504.304565 325.571503,505.908386 
	C326.277924,506.400574 326.497955,506.797028 326.417297,507.634277 
	C325.896973,508.494904 325.322632,508.781158 324.409485,509.002686 
	C323.819000,509.032288 323.555786,509.142487 323.461578,509.558899 
	C323.802307,509.952087 324.029510,510.176056 324.456970,510.607300 
	C325.109650,511.237244 325.586823,511.619934 326.508240,511.907715 
	C327.244781,512.167542 327.638428,512.375366 328.210907,512.901550 
	C328.553040,513.609680 328.553955,514.052307 328.219452,514.755615 
	C328.005341,515.195496 328.011017,515.376648 328.005066,515.830383 
	C327.558197,516.069031 327.122925,516.035217 326.361877,515.972107 
	C324.621857,514.569275 321.945557,515.117615 321.213470,512.433777 
	C320.984131,511.593018 319.218933,510.175507 317.896271,512.554932 
	C316.895844,514.354736 315.862061,512.809448 315.022644,511.540985 
	C314.098022,510.037079 314.614716,508.365509 313.457458,506.915192 
	C313.131012,505.921051 313.144653,505.234680 313.515381,504.225159 
	C314.055206,503.557861 314.477234,503.302795 315.310760,503.022888 
	C316.181396,502.848785 316.687988,502.819183 317.578796,502.872742 
	C318.464600,503.013336 318.940216,503.194031 319.647827,503.730743 
z"/>
<path fill="#08346F" opacity="1.000000" stroke="none" 
	d="
M328.343658,515.026489 
	C327.979706,514.641541 327.959747,514.268799 327.935120,513.615784 
	C327.514008,512.799683 327.163025,511.923370 327.654541,511.615173 
	C329.918610,510.195312 329.599945,509.599518 327.122711,509.347717 
	C326.673065,509.302002 326.325287,508.848511 325.928680,508.149048 
	C325.855560,507.441620 325.877869,507.054749 325.895630,506.378357 
	C326.716980,505.735443 327.542816,505.382111 328.704834,504.990234 
	C330.163788,505.550140 331.286560,506.148529 332.704041,506.867218 
	C334.099335,507.571594 333.286682,511.030212 336.461639,509.094269 
	C337.057343,509.232758 337.286469,509.325348 337.786713,509.670746 
	C336.959259,511.125458 335.613892,512.208984 336.035980,514.501099 
	C336.016388,515.274231 335.860748,515.629944 335.321899,516.073547 
	C334.630402,516.147156 334.206482,516.084778 333.468323,515.951172 
	C332.424377,515.343506 331.649353,514.952148 330.375854,515.172913 
	C329.595917,515.168396 329.141785,515.103577 328.343658,515.026489 
z"/>
<path fill="#0E6CB9" opacity="1.000000" stroke="none" 
	d="
M335.304199,516.441040 
	C335.229645,515.876892 335.404938,515.544312 335.808411,515.036987 
	C336.719666,515.241577 337.402771,515.620850 338.172699,516.274658 
	C337.375183,516.973389 336.476715,517.087769 335.304199,516.441040 
z"/>
<path fill="#0E6CB9" opacity="1.000000" stroke="none" 
	d="
M330.279724,515.470215 
	C331.032593,513.669373 332.022308,513.458130 333.088257,515.548706 
	C332.272522,515.822388 331.390991,515.764832 330.279724,515.470215 
z"/>
<path fill="#0F62A1" opacity="1.000000" stroke="none" 
	d="
M335.117645,533.249207 
	C335.006287,533.034180 335.504852,533.004089 335.754089,532.987427 
	C336.013000,533.145325 336.022705,533.319885 336.021179,533.756714 
	C335.691772,533.915466 335.431427,533.730591 335.117645,533.249207 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M313.699829,503.774841 
	C313.966949,504.789459 313.971375,505.495728 313.963837,506.554932 
	C313.804260,508.038177 313.865479,509.198090 313.260498,510.565002 
	C313.038727,511.039581 313.027618,511.242462 312.997223,511.750122 
	C312.977936,512.054871 312.492065,512.020264 312.248901,512.006897 
	C310.707336,510.759430 308.941864,511.195007 307.140869,510.528900 
	C305.920990,509.367950 306.014069,507.887604 305.168762,506.873474 
	C305.917267,507.993835 305.976685,509.346558 306.283295,510.908386 
	C305.428345,511.819000 304.681244,512.388489 303.374664,512.563721 
	C300.304596,512.011719 301.434387,508.624756 299.060852,507.516632 
	C296.803497,507.109100 295.483765,507.924072 294.418365,509.909546 
	C293.942291,510.218872 293.715057,510.285706 293.138672,510.259033 
	C291.992126,509.512878 291.573700,508.622925 291.143433,507.313538 
	C290.944366,506.174530 291.008209,505.417969 291.386902,504.324829 
	C292.023773,503.356567 292.650757,502.930878 293.682007,502.437195 
	C296.521088,501.480865 298.744263,503.297638 301.547821,502.967651 
	C304.197632,502.564453 306.498505,502.654602 309.186188,502.628784 
	C310.106079,502.648926 310.633087,502.679230 311.557983,502.781006 
	C312.486481,502.961060 312.979858,503.171387 313.699829,503.774841 
z"/>
<path fill="#0E6CB9" opacity="1.000000" stroke="none" 
	d="
M298.786926,506.220459 
	C302.828979,506.177155 301.527344,509.521301 302.681671,511.763947 
	C304.347076,513.496094 302.616791,514.905884 302.859619,516.688477 
	C302.550751,519.859619 300.500885,519.046875 298.392029,518.967041 
	C297.996063,518.986694 297.999054,519.003296 298.007629,519.002502 
	C297.538696,518.504700 296.990784,518.086426 296.256165,517.362732 
	C295.119659,514.785095 292.712555,513.253296 292.786865,510.237976 
	C292.980011,509.951508 293.452332,509.966400 293.688171,509.980530 
	C295.199921,508.461731 297.178467,507.848511 298.786926,506.220459 
z"/>
<path fill="#0D89D9" opacity="1.000000" stroke="none" 
	d="
M303.258545,516.968933 
	C298.575684,515.586426 302.787811,514.132874 302.902618,512.353149 
	C303.753082,511.685272 304.563568,511.354614 305.700714,510.987061 
	C306.144348,510.744995 306.261353,510.539856 306.687927,510.162598 
	C308.666626,510.058990 310.476746,509.647186 311.834290,511.677002 
	C307.149017,510.123840 306.299500,515.055725 303.258545,516.968933 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M313.370239,510.897766 
	C313.508545,509.596954 310.813629,508.133636 313.635498,506.973450 
	C316.363861,507.429657 316.148865,508.863068 315.090637,510.890198 
	C314.541382,511.142456 314.115967,511.050659 313.370239,510.897766 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M158.556580,416.116241 
	C160.338089,416.198059 161.782883,416.285553 163.625427,416.196106 
	C164.023178,416.019135 163.992020,416.010223 163.992462,415.993469 
	C165.053070,417.053741 165.130249,418.362823 164.766083,420.133972 
	C164.210312,421.330017 163.426315,421.459290 162.299957,421.781250 
	C161.978470,422.015137 161.928131,422.076874 161.900085,422.107056 
	C161.872055,422.137207 161.540268,422.073761 161.371582,422.065186 
	C160.927307,421.835602 160.655441,421.610138 160.191696,421.201447 
	C159.995483,421.023438 159.996414,421.003662 159.987396,421.008057 
	C159.577896,420.550507 158.999908,420.495941 158.229935,420.187805 
	C157.998672,420.024384 157.991379,420.007019 157.980743,420.011414 
	C158.336990,418.736023 153.522919,417.123962 158.556580,416.116241 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M162.787537,429.376984 
	C162.323853,429.841736 161.909805,429.936951 161.172882,430.028961 
	C161.239105,428.312500 161.628204,426.599213 162.037506,424.515381 
	C163.710068,425.542511 162.827347,427.346497 162.787537,429.376984 
z"/>
<path fill="#0A5C8E" opacity="1.000000" stroke="none" 
	d="
M158.118469,420.313354 
	C158.581818,420.159393 159.164963,420.294403 159.863235,420.720917 
	C159.398331,420.875732 158.818298,420.739044 158.118469,420.313354 
z"/>
<path fill="#0A5C8E" opacity="1.000000" stroke="none" 
	d="
M160.060852,421.314758 
	C160.313324,421.198090 160.631149,421.372742 161.075928,421.802002 
	C160.844009,421.906403 160.485107,421.756226 160.060852,421.314758 
z"/>
<path fill="#0B5794" opacity="1.000000" stroke="none" 
	d="
M156.278442,443.014954 
	C156.428040,442.910645 156.578995,442.962311 156.729950,443.014008 
	C156.579910,443.066345 156.429871,443.118652 156.278442,443.014954 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M171.664246,422.964417 
	C169.548645,421.777405 168.088531,420.563629 166.335022,419.227203 
	C165.940048,418.869781 165.838501,418.635040 165.911606,418.058044 
	C170.964096,416.397217 174.829010,419.521545 179.477173,420.868500 
	C181.107071,421.878937 182.196289,422.920166 183.196533,424.552429 
	C183.349762,425.149109 183.352448,425.399597 183.164764,425.972595 
	C182.340576,426.733582 181.631378,426.870117 180.527130,426.749451 
	C177.554184,425.442688 175.285583,423.457977 171.664246,422.964417 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M166.402969,417.209167 
	C166.253265,417.809357 166.201141,418.066559 166.095306,418.714142 
	C165.371323,420.116669 167.467331,422.496643 164.222992,422.154724 
	C163.816971,421.765717 163.628098,421.565338 163.611420,420.989502 
	C163.720963,419.300140 163.658295,417.986176 163.794281,416.324463 
	C164.250854,415.847931 164.508789,415.719208 165.114746,415.333862 
	C166.012421,415.555359 166.450226,416.098328 166.402969,417.209167 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M173.876114,428.108948 
	C173.175613,427.357727 172.594086,426.506012 172.304321,425.212036 
	C173.876053,425.068848 174.530457,425.864899 174.376648,427.499695 
	C174.234528,427.809326 173.995087,428.008484 173.876114,428.108948 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M163.513977,420.739685 
	C163.830490,420.837830 163.877365,421.061615 163.965042,421.625793 
	C163.555588,421.989288 163.105316,422.012451 162.316742,422.025391 
	C162.400406,421.631836 162.822357,421.248535 163.513977,420.739685 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M171.981720,425.013367 
	C171.644089,424.548431 171.321136,424.072601 171.003479,423.294006 
	C171.008759,422.991180 170.996552,423.002228 170.990448,423.006226 
	C172.038528,422.798950 172.339722,423.424957 172.221085,424.639801 
	C172.024536,424.980377 171.996414,425.002533 171.981720,425.013367 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M164.987808,428.982056 
	C165.104340,428.743896 165.266174,428.553436 165.428009,428.362976 
	C165.453812,428.577515 165.479599,428.792053 165.316269,429.064148 
	C165.127151,429.121674 165.033112,429.029724 164.987808,428.982056 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M171.392761,450.395386 
	C171.621521,449.531036 171.901138,449.034454 172.534882,448.280151 
	C175.736633,447.874207 177.959900,446.722595 179.539169,443.880249 
	C180.468109,443.382538 181.127518,443.178375 182.182495,443.369415 
	C182.904648,443.725891 183.216843,444.048676 183.505798,444.777466 
	C183.564240,445.303345 183.550446,445.512146 183.453461,446.008972 
	C183.230225,446.804382 182.957687,447.320343 183.707886,447.934906 
	C185.081711,448.605621 186.273148,448.807556 187.831573,448.701416 
	C188.361328,448.623077 188.573486,448.585297 189.106827,448.481506 
	C189.646484,448.376312 189.864960,448.337067 190.419098,448.270935 
	C192.139313,448.294525 193.448563,448.728088 195.119354,449.161560 
	C195.658890,449.422455 195.861679,449.557404 196.262939,450.003967 
	C196.574966,450.811035 196.548843,451.301514 196.176788,452.090973 
	C195.045395,452.993652 194.038345,453.072845 192.623856,452.953918 
	C191.277313,452.704529 190.336609,452.340424 188.953049,452.373779 
	C185.869156,452.394135 183.150543,452.214050 180.078613,452.622864 
	C179.466385,452.689606 179.220871,452.706635 178.607651,452.712189 
	C176.808105,452.469971 175.375259,452.246826 173.565903,452.065063 
	C172.969788,451.923065 172.736389,451.843353 172.189484,451.565186 
	C171.731842,451.165558 171.587738,450.964325 171.392761,450.395386 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M183.523865,443.645142 
	C182.359955,444.048248 181.625885,444.049286 180.524658,444.063995 
	C179.987137,443.919312 179.816757,443.760986 179.767883,443.275574 
	C180.471283,441.081512 181.053146,439.214478 181.422791,437.111755 
	C181.834366,436.088257 182.458176,435.300446 183.169083,434.210693 
	C183.474243,433.848297 183.692291,433.787811 184.235504,433.823059 
	C187.288544,435.881836 190.406204,435.754700 193.866425,435.710968 
	C194.368103,436.006348 194.533981,436.182190 194.873856,436.681458 
	C195.736115,440.337585 193.298615,439.887817 191.014099,440.005737 
	C189.434296,439.812134 188.119751,438.943542 186.881378,440.637970 
	C186.533447,441.033234 186.387085,441.182831 185.994308,441.519409 
	C185.075470,442.131775 184.410370,442.565765 183.523865,443.645142 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M171.361816,450.028564 
	C171.531387,450.144318 171.720901,450.261017 172.074219,450.668579 
	C172.238037,450.959473 172.132584,451.442841 172.003082,451.653076 
	C171.873596,451.863281 171.555420,452.238159 171.382019,452.410767 
	C171.208618,452.583374 170.854385,452.919830 170.503510,453.262695 
	C170.152618,453.605591 169.802444,453.961029 169.446625,454.329956 
	C168.967728,454.827179 168.844681,454.955444 168.320557,455.471924 
	C167.764664,455.978302 167.609833,456.096497 167.188934,456.353943 
	C166.723663,456.540131 166.524445,456.587067 166.013824,456.624512 
	C164.876572,456.370087 164.263733,455.747162 163.245880,455.195618 
	C162.984100,455.012848 163.000000,455.000000 162.994934,455.008392 
	C162.775818,454.776367 162.558746,454.538666 162.156693,454.145142 
	C161.974686,453.986572 162.004135,453.992065 161.998291,454.005859 
	C161.587738,452.719177 160.492279,452.096893 159.211761,451.210022 
	C158.977463,450.993744 159.006485,450.993774 159.005585,451.008240 
	C158.625397,450.631622 158.474030,450.166412 158.782669,449.320984 
	C162.916885,448.500671 166.675888,449.624695 170.956390,450.035431 
	C171.414062,450.052887 171.381729,450.029541 171.361816,450.028564 
z"/>
<path fill="#0A4271" opacity="1.000000" stroke="none" 
	d="
M170.853912,447.537201 
	C168.999924,447.781036 166.966965,447.829895 164.505402,447.807434 
	C163.892197,444.006927 166.866074,442.847717 169.640762,441.142517 
	C172.683029,441.265045 171.056595,442.957825 171.157257,444.231262 
	C171.248001,445.379333 168.419052,446.003387 170.853912,447.537201 
z"/>
<path fill="#0A4271" opacity="1.000000" stroke="none" 
	d="
M179.539459,442.975464 
	C179.929321,443.137634 179.969238,443.326782 180.083344,443.796783 
	C179.258118,447.537415 177.431870,449.576813 173.201950,448.217407 
	C174.651978,445.925903 176.034348,443.351654 179.539459,442.975464 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M170.006470,437.006531 
	C169.760880,437.535889 169.509659,438.059509 169.258423,438.583069 
	C169.049332,438.468781 168.840225,438.354492 168.631134,438.240234 
	C168.916840,437.891998 169.202560,437.543732 169.738922,437.093750 
	C169.989563,436.992065 170.000824,437.000763 170.006470,437.006531 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M134.740662,418.182800 
	C137.673218,418.218872 138.297592,420.284607 138.905334,422.728333 
	C138.581116,423.171661 138.326172,423.352386 138.032532,423.846313 
	C136.694885,422.590942 135.466309,421.121643 134.058380,419.382507 
	C133.944016,418.734161 134.146667,418.465790 134.740662,418.182800 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M184.352020,434.174438 
	C184.031570,434.019073 183.642044,433.960052 183.449127,433.934387 
	C182.755966,433.865875 182.255753,433.822998 181.383728,433.727112 
	C180.734161,433.269867 180.456375,432.865631 180.288193,431.984863 
	C181.118286,431.030487 181.560776,430.415283 181.373413,429.170135 
	C181.417358,427.917542 181.822403,427.162262 182.719666,426.300110 
	C182.937836,425.845367 182.931519,425.630035 182.898102,425.092651 
	C182.418137,423.913818 182.666382,423.222961 183.753296,422.506165 
	C187.165924,422.435272 187.027954,424.774048 187.341034,427.152771 
	C187.495026,428.255188 187.388824,429.175781 188.858612,429.156158 
	C189.567307,429.003204 189.977127,428.905273 190.713089,428.735291 
	C193.657898,428.174225 195.999817,429.297943 198.745743,430.056885 
	C201.041168,432.472534 204.398041,433.423065 205.598755,436.946472 
	C206.248260,437.789429 206.528244,438.422852 206.454727,439.503540 
	C206.211563,440.033600 206.054977,440.215302 205.572662,440.551086 
	C204.774689,440.800507 204.299622,440.822968 203.481339,440.658142 
	C202.937683,440.439911 202.733948,440.323822 202.255737,439.993866 
	C200.292740,438.165344 198.036804,437.581329 195.759918,436.315186 
	C192.264343,433.153290 188.277267,434.896606 184.352020,434.174438 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M172.335037,425.059998 
	C171.862823,424.409393 171.701096,423.838409 171.261871,423.138794 
	C171.052734,421.398865 171.777496,420.970551 173.241257,421.693542 
	C175.462677,422.790771 177.890381,423.520386 179.802155,425.690918 
	C179.904678,426.179688 179.883133,426.351929 179.734634,426.750793 
	C179.491074,427.104279 179.374496,427.231110 179.057449,427.517761 
	C178.582260,427.877045 178.309326,428.078949 177.842377,428.446625 
	C177.373611,428.821838 177.069626,428.972961 176.510498,428.955963 
	C175.767426,428.585907 175.253433,428.333008 174.486984,427.944702 
	C173.704865,426.919434 173.175201,426.029510 172.335037,425.059998 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M176.214264,429.175232 
	C176.498428,428.771484 176.670547,428.643616 176.883636,428.312469 
	C177.366714,427.649292 177.964661,427.528809 178.775009,427.179138 
	C179.002731,426.980469 178.996582,427.002716 178.989471,426.993164 
	C180.967407,427.653809 181.009125,428.087341 178.649536,430.714233 
	C177.069122,430.871094 176.145065,430.768616 176.214264,429.175232 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M180.001526,431.998779 
	C179.442169,431.825867 178.881287,431.654205 178.152161,431.233826 
	C177.983902,430.985138 177.952225,430.917755 177.951111,430.880554 
	C178.384399,430.621979 178.845016,430.497589 179.667328,430.605713 
	C180.120590,430.952332 180.238266,431.163025 180.176544,431.688049 
	C179.997147,432.002441 180.000000,432.000000 180.001526,431.998779 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M119.233475,416.260315 
	C121.065483,415.641205 123.129295,415.293823 125.590958,414.964172 
	C126.790703,416.248108 128.061996,415.989136 129.621826,415.990326 
	C130.336777,416.318787 130.500168,416.718994 130.299103,417.484253 
	C129.537796,417.990845 128.957184,418.207489 128.211945,418.687988 
	C127.883095,419.124512 127.718895,419.297150 127.284424,419.235931 
	C124.497856,418.178741 121.981567,417.355377 119.233475,416.260315 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M130.148438,427.366852 
	C129.969940,425.996704 130.329468,425.082703 131.466827,424.238892 
	C132.388107,424.031433 133.006851,424.155792 133.789459,424.777679 
	C134.026398,424.997772 133.995987,425.003662 133.999420,424.988525 
	C134.339722,425.347382 134.496719,425.781830 134.240479,426.587891 
	C133.771057,427.404205 133.505157,427.919373 133.125488,428.700989 
	C131.873413,429.003510 130.971100,428.553741 130.148438,427.366852 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M130.444977,417.848511 
	C130.067520,417.380096 130.016663,416.986023 129.977600,416.292847 
	C131.833847,415.537292 133.209229,416.333862 134.682648,417.841370 
	C134.768311,418.321564 134.564285,418.602661 134.119629,418.998230 
	C132.843201,418.716064 131.807388,418.319458 130.444977,417.848511 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M135.628357,426.765198 
	C136.431442,427.214264 136.986862,427.438660 137.486450,427.752014 
	C137.555588,427.795410 137.420425,428.464874 137.257660,428.527679 
	C136.346725,428.878998 135.818558,428.234192 135.143127,427.374573 
	C135.113831,426.931671 135.238403,426.750153 135.628357,426.765198 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M134.016479,424.665344 
	C133.304184,425.355103 132.696198,425.091797 131.923187,424.361694 
	C131.776566,423.891266 131.828293,423.706329 131.953201,423.242737 
	C133.119324,422.794159 133.622955,423.476746 134.016479,424.665344 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M127.134811,419.304138 
	C127.186844,419.005554 127.359528,419.009003 127.789764,418.982117 
	C128.675720,419.430878 129.304138,419.909912 129.984802,420.687805 
	C128.812363,421.126007 127.983345,420.468018 127.134811,419.304138 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M135.825531,426.677094 
	C135.893723,426.961700 135.436584,427.007385 135.212921,427.060303 
	C134.989258,427.113190 134.518265,426.978943 134.277618,426.933990 
	C133.953751,426.458282 133.870544,426.027557 133.895111,425.285095 
	C134.587677,425.446381 135.172501,425.919434 135.825531,426.677094 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M132.016144,422.703430 
	C131.733383,422.821564 131.429108,422.654449 131.063248,422.224731 
	C131.332657,422.114105 131.663651,422.266144 132.016144,422.703430 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M130.995392,421.721069 
	C130.727554,421.831970 130.417221,421.666504 130.056198,421.231628 
	C130.321304,421.123016 130.637115,421.283844 130.995392,421.721069 
z"/>
<path fill="#10B2F6" opacity="1.000000" stroke="none" 
	d="
M228.364792,484.156006 
	C225.729843,483.732208 223.800583,484.328674 222.281387,486.179779 
	C221.303040,487.371918 220.066376,488.182190 218.002106,487.813477 
	C216.446136,487.054626 219.091400,486.110321 217.229919,485.260956 
	C216.438278,483.245209 219.795120,482.071716 218.096680,480.379456 
	C216.746017,479.033722 214.976639,479.871094 213.211533,480.665131 
	C211.392441,481.483459 210.969315,480.145935 211.865906,478.221863 
	C211.658264,477.660156 211.475586,477.330414 211.440735,476.641602 
	C211.562485,476.171509 211.649673,475.994568 211.950897,475.613190 
	C212.651093,475.070251 213.178894,474.810669 214.005280,474.502930 
	C214.672195,474.381470 215.053375,474.407440 215.673431,474.651428 
	C216.040115,474.929962 216.161682,475.068695 216.421005,475.434143 
	C216.795273,475.940979 217.099655,476.106964 217.749146,476.205963 
	C220.317062,477.048309 222.242599,475.388397 224.725250,475.389343 
	C228.473801,476.816193 232.146301,475.877930 235.947296,476.781799 
	C236.539368,477.353546 236.714645,477.800903 236.817398,478.656677 
	C236.702652,480.068115 236.254013,480.961823 235.352051,482.041840 
	C233.132523,483.531952 230.885071,483.803009 228.364792,484.156006 
z"/>
<path fill="#14A4F1" opacity="1.000000" stroke="none" 
	d="
M244.806519,493.497925 
	C244.148712,491.237885 242.209320,492.496796 241.032990,491.644135 
	C241.691345,490.317413 243.549973,491.756592 244.228928,490.015686 
	C242.679520,490.015686 241.246750,490.015686 239.419983,490.021484 
	C238.970078,488.610748 238.312805,487.447479 237.200012,486.177612 
	C236.811096,485.445374 236.962143,484.977997 237.704834,484.393158 
	C240.938873,482.841278 244.607010,484.906616 247.486115,481.893494 
	C248.220688,481.387939 248.696320,481.214783 249.579895,481.093567 
	C254.067261,481.832336 258.196381,482.295837 262.740356,481.899719 
	C264.477570,482.285034 265.874725,482.246094 267.636902,482.156158 
	C268.233490,482.253754 268.468506,482.323639 269.018433,482.591187 
	C270.054810,483.546204 270.442108,484.457245 270.544128,485.867950 
	C270.349304,486.748505 270.057495,487.156158 269.294189,487.636719 
	C267.424774,488.258057 265.974274,487.739136 264.141663,487.434753 
	C262.347443,487.297150 260.904755,487.327789 259.160278,486.928772 
	C258.287994,486.847900 258.185852,485.546143 257.095764,486.506622 
	C256.173676,486.926178 255.512360,487.052246 254.506516,487.187378 
	C252.146866,487.495819 250.091461,487.719574 250.029358,490.824890 
	C250.032791,491.641357 249.987106,492.108459 249.803986,492.919434 
	C249.474869,493.707367 249.166656,494.081696 248.457413,494.571411 
	C247.387039,494.963409 246.646011,494.963806 245.563324,494.609406 
	C245.064102,494.253693 244.903885,494.061066 244.806519,493.497925 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M206.343124,477.932190 
	C206.247208,477.132568 206.565948,476.366974 207.068817,475.086792 
	C207.329971,474.168884 207.117920,473.997192 206.709686,473.652466 
	C206.730545,473.152863 206.794632,472.948822 207.050766,472.467224 
	C208.718933,470.870026 210.324677,470.751617 212.300262,471.972046 
	C213.055328,473.308838 213.072845,474.340515 212.302521,475.707153 
	C212.078278,476.047791 212.037750,476.003632 212.043945,476.032837 
	C211.557053,476.421783 211.492416,476.980835 211.138977,477.662323 
	C209.521652,477.861847 208.139709,477.914062 206.343124,477.932190 
z"/>
<path fill="#2AD5F9" opacity="1.000000" stroke="none" 
	d="
M238.155273,484.712158 
	C237.656845,485.134521 237.398911,485.340424 237.030090,485.771851 
	C234.840485,485.678894 232.761765,485.360352 230.283112,485.062073 
	C229.524734,485.392151 229.106873,485.518860 228.340973,485.316742 
	C228.039551,484.957703 228.034607,484.768585 228.025574,484.295898 
	C229.992004,483.049530 231.843292,481.726410 234.878922,482.019012 
	C236.124481,482.227905 236.708130,482.359070 237.570099,482.640900 
	C238.357178,483.247498 238.539261,483.820068 238.155273,484.712158 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M216.622864,485.086670 
	C219.356293,484.982086 219.030945,485.940552 217.728882,487.490082 
	C216.326660,487.813446 215.040024,487.881958 213.689606,487.953888 
	C213.449188,485.866699 214.124817,484.817841 216.622864,485.086670 
z"/>
<path fill="#10B2F6" opacity="1.000000" stroke="none" 
	d="
M206.791107,480.796204 
	C207.651840,480.450897 208.704529,480.053436 208.802597,480.219574 
	C209.762253,481.844940 207.992310,482.233215 207.299149,483.079437 
	C206.769882,483.725586 205.776093,484.100220 205.468277,482.995697 
	C205.322479,482.472565 206.152283,481.677490 206.791107,480.796204 
z"/>
<path fill="#1391DB" opacity="1.000000" stroke="none" 
	d="
M228.015472,485.455322 
	C228.453506,485.121857 228.862488,485.096863 229.577316,485.077087 
	C230.284027,485.941223 230.684906,486.800110 231.085800,487.658997 
	C230.293243,487.763062 229.488297,488.009735 228.710648,487.942169 
	C226.959274,487.789978 227.954636,486.588593 228.015472,485.455322 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M211.169067,477.859375 
	C211.121292,477.312561 211.339005,476.815491 211.803421,476.190186 
	C212.031708,476.473572 212.013275,476.885132 211.984802,477.604370 
	C211.794678,477.911072 211.614609,477.910095 211.169067,477.859375 
z"/>
<path fill="#10B2F6" opacity="1.000000" stroke="none" 
	d="
M201.322296,480.587708 
	C201.396957,480.359375 201.520752,480.411560 201.573257,480.437012 
	C201.604492,480.692352 202.078003,481.451324 201.322296,480.587708 
z"/>
<path fill="#10B2F6" opacity="1.000000" stroke="none" 
	d="
M202.042694,480.674377 
	C201.845154,480.375214 201.962616,479.987488 202.380554,479.487030 
	C202.573242,479.778137 202.465469,480.182007 202.042694,480.674377 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M168.165146,464.278076 
	C168.248322,463.170319 168.497818,462.378204 168.869705,461.293427 
	C169.858780,458.313660 171.559402,456.905182 174.850739,457.621216 
	C176.116852,459.524017 175.574005,460.963531 174.130005,462.560333 
	C172.277390,464.298889 170.808807,466.004242 168.165146,464.278076 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M189.697815,463.677551 
	C186.053619,465.760406 181.767532,466.173584 177.245544,466.952759 
	C176.347488,466.458466 175.786331,466.011902 175.088287,465.321045 
	C175.155624,464.896423 175.359848,464.716064 175.914856,464.322906 
	C177.310699,463.718262 178.405411,463.647766 179.918488,463.587341 
	C183.346985,463.251801 186.340744,461.862366 189.697815,463.677551 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M174.073425,462.885376 
	C174.189270,461.446014 174.560120,460.074768 174.939941,458.343292 
	C174.731644,455.782104 175.307007,453.953979 177.738953,452.931519 
	C181.210327,456.745575 177.866150,459.492279 176.442657,462.856323 
	C175.967484,463.239227 175.730576,463.327240 175.173553,463.212158 
	C174.678436,462.990570 174.503448,462.972015 174.073425,462.885376 
z"/>
<path fill="#063A70" opacity="1.000000" stroke="none" 
	d="
M171.071106,468.620514 
	C170.290802,468.530975 169.557129,468.042023 168.647263,467.265411 
	C169.555252,466.962341 170.661728,466.899445 171.071106,468.620514 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M174.845978,463.354797 
	C175.011887,462.921143 175.170334,462.833191 175.574310,462.628540 
	C176.292007,462.974030 176.500610,463.534332 176.224091,464.604797 
	C175.827789,465.033203 175.653030,465.049622 175.214844,465.071411 
	C174.913788,464.618011 174.876160,464.159241 174.845978,463.354797 
z"/>
<path fill="#063A70" opacity="1.000000" stroke="none" 
	d="
M168.323242,466.701233 
	C167.817413,466.875427 167.100098,466.739502 166.176208,466.291687 
	C166.683701,466.116943 167.397736,466.254028 168.323242,466.701233 
z"/>
<path fill="#063A70" opacity="1.000000" stroke="none" 
	d="
M171.985352,469.737854 
	C171.722977,469.853790 171.414658,469.680847 171.044296,469.240662 
	C171.301315,469.131958 171.620361,469.290497 171.985352,469.737854 
z"/>
<path fill="#063A70" opacity="1.000000" stroke="none" 
	d="
M166.005188,465.740356 
	C165.717087,465.858459 165.406662,465.694366 165.044495,465.263184 
	C165.322800,465.150116 165.652832,465.304138 166.005188,465.740356 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M177.757950,452.196594 
	C176.222824,453.991394 176.274323,456.011810 175.204620,457.768555 
	C172.502960,457.580505 171.209412,459.443604 169.299698,460.850403 
	C168.561096,461.004974 168.130081,461.009216 167.375748,461.017517 
	C166.503204,460.539276 166.174835,459.938660 166.064758,458.859985 
	C166.054901,458.273834 166.063004,458.039215 166.135315,457.458191 
	C166.313385,456.906494 166.427277,456.701202 166.781418,456.238525 
	C167.021683,455.981110 166.997849,456.003418 166.986542,456.015198 
	C167.211731,455.800171 167.445023,455.570160 167.846100,455.160431 
	C168.017090,454.983948 168.000000,455.000000 167.991959,455.008484 
	C168.218857,454.793060 168.450165,454.565430 168.847076,454.159180 
	C169.016342,453.984253 169.000000,454.000000 168.992065,454.008179 
	C169.220001,453.791931 169.452087,453.563629 169.850021,453.155884 
	C170.019669,452.980255 170.000000,453.000000 169.990036,453.009735 
	C170.217926,452.794006 170.451645,452.564362 170.851562,452.153290 
	C171.021881,451.976105 170.999542,451.997925 170.986969,452.007172 
	C171.418381,451.589844 172.011246,451.528198 172.764984,451.158142 
	C174.486084,451.104706 176.006088,451.261108 177.757950,452.196594 
z"/>
<path fill="#0B5794" opacity="1.000000" stroke="none" 
	d="
M158.987976,451.369751 
	C159.934601,451.022614 160.892151,451.041504 161.848785,451.082153 
	C165.000793,451.216095 163.648727,452.344696 162.180756,453.737091 
	C160.343506,454.118744 158.929871,453.908020 158.987976,451.369751 
z"/>
<path fill="#0B5794" opacity="1.000000" stroke="none" 
	d="
M158.690887,448.867493 
	C159.033600,449.461639 159.052399,449.908325 159.037933,450.688873 
	C157.940323,451.006653 156.875961,450.990601 155.412140,450.996002 
	C154.850220,448.382019 155.826797,447.409576 158.690887,448.867493 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M166.670807,455.946930 
	C167.021683,455.981110 166.988022,456.425842 166.973907,456.648376 
	C166.855530,457.034973 166.751282,457.198975 166.530579,457.630585 
	C166.253326,458.007843 166.092514,458.117493 165.678329,458.082062 
	C164.659729,457.173889 163.894516,456.410767 163.056702,455.330231 
	C164.096039,455.312836 165.207977,455.612793 166.670807,455.946930 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M165.351898,458.302979 
	C165.424957,457.937012 165.466797,457.964813 165.485138,457.981934 
	C165.767914,457.872833 166.032349,457.746552 166.609528,457.929138 
	C166.976151,458.933136 167.030014,459.628296 167.068161,460.672546 
	C165.397003,461.039673 164.861694,460.213318 165.351898,458.302979 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M162.026337,454.253967 
	C162.286835,454.149750 162.598999,454.312927 162.950531,454.746460 
	C162.685913,454.851654 162.381943,454.686493 162.026337,454.253967 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M190.001038,463.990082 
	C186.896530,463.728973 183.853714,464.089233 180.455215,464.916443 
	C178.752182,462.234192 181.012009,462.152039 182.447449,461.884644 
	C184.941605,461.419952 185.777283,460.041595 185.421967,457.345947 
	C185.431427,456.773682 185.454865,456.545898 185.752258,455.699463 
	C186.161041,454.902649 186.295853,454.724518 186.889542,454.071869 
	C187.512894,453.454895 187.677338,453.312500 188.101440,452.976501 
	C188.545944,452.674347 188.730774,452.565735 189.212006,452.337524 
	C190.124863,452.060974 190.754242,452.033478 191.697693,452.033569 
	C193.070511,452.039581 194.131729,452.042786 195.588989,452.005615 
	C198.194214,451.700684 200.123489,452.880402 202.550217,453.341614 
	C203.483902,454.000580 203.740814,454.664276 203.783844,455.776337 
	C203.679337,456.354279 203.602158,456.575195 203.317078,457.071960 
	C201.746277,458.369659 199.849640,458.612549 198.710724,460.495850 
	C198.262238,461.105011 197.938431,461.378693 197.302399,461.781982 
	C196.541260,462.018463 196.030380,462.051971 195.138763,462.136353 
	C194.527863,462.201263 194.297699,462.215363 193.818115,461.990814 
	C192.877594,460.463684 193.805496,459.267700 193.585434,458.477844 
	C193.276001,459.424225 193.133347,460.915436 192.602448,462.654846 
	C191.881912,463.456024 191.175293,463.468079 190.228867,463.792114 
	C189.957275,464.006042 189.998642,464.010895 190.001038,463.990082 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M203.202057,454.129517 
	C200.912582,453.311218 198.371979,454.505188 196.271606,452.193329 
	C195.970551,451.560852 195.956085,451.156464 195.923035,450.449036 
	C196.042343,449.952698 196.180283,449.759460 196.621826,449.383270 
	C198.577606,448.642853 200.280975,448.603607 201.691757,449.620728 
	C204.180069,451.414764 206.654434,450.937653 209.469055,449.759552 
	C209.892868,449.380066 210.056702,449.219086 210.494614,448.843201 
	C211.183929,448.406403 211.625046,448.260406 212.438782,448.174255 
	C213.016327,448.222412 213.243073,448.274719 213.772079,448.498810 
	C214.364426,449.029907 214.567139,449.431427 214.680176,450.216797 
	C214.655563,451.194702 214.539780,451.834625 214.529510,452.801208 
	C214.465271,453.961853 214.417389,454.805908 214.292999,455.962463 
	C213.813187,456.835236 213.289139,457.198914 212.306000,457.284485 
	C211.816116,457.170227 211.646713,457.133606 211.225159,457.033569 
	C210.420135,456.444641 209.856277,456.432983 209.154755,457.234009 
	C208.065750,460.522095 205.761902,459.136963 203.559326,459.160583 
	C203.064621,459.140076 202.886612,459.073425 202.581329,458.751343 
	C202.399368,458.112732 202.447433,457.744537 202.846893,457.229553 
	C203.078873,457.065338 203.002502,457.002441 203.033752,457.040741 
	C203.915878,456.261566 203.890411,455.354858 203.202057,454.129517 
z"/>
<path fill="#063A70" opacity="1.000000" stroke="none" 
	d="
M212.054764,457.595428 
	C212.476501,456.947083 212.967468,456.687317 213.692780,456.279694 
	C216.109390,454.354736 218.045441,454.374847 219.716766,457.318054 
	C219.862503,458.805603 219.477158,459.801453 219.081848,461.172913 
	C218.635025,462.438995 218.265427,463.335632 217.776718,464.569916 
	C217.397690,465.316223 217.128418,465.710907 216.575409,466.341309 
	C215.566208,467.234711 214.736664,467.674438 213.387466,467.363770 
	C212.754288,464.121704 213.579956,460.935150 212.054764,457.595428 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M212.954041,467.422913 
	C213.808685,466.839691 214.543777,466.489258 215.845016,466.189667 
	C217.381958,467.902832 216.868652,469.519836 216.126190,471.461731 
	C215.589706,472.632812 215.185684,473.474274 214.330582,474.437805 
	C213.628571,475.099152 213.173340,475.518433 212.398193,475.992737 
	C212.038498,474.930542 211.998734,473.813293 211.933548,472.278381 
	C211.713013,471.480072 211.579468,471.079559 211.485519,470.343140 
	C211.480804,469.824921 211.509583,469.618988 211.740173,469.175232 
	C212.239502,468.510193 212.536987,468.082947 212.954041,467.422913 
z"/>
<path fill="#08346F" opacity="1.000000" stroke="none" 
	d="
M211.779877,469.607544 
	C212.912567,470.263489 212.624481,470.838226 212.033844,471.636902 
	C210.301407,472.134338 208.515656,471.869080 207.168274,473.702332 
	C206.605576,474.535889 205.959885,474.453583 205.192886,474.830872 
	C204.962021,475.013092 205.011703,475.022125 205.022171,474.999146 
	C203.990463,475.801117 202.793579,475.413910 201.312531,475.121216 
	C200.979660,474.834015 200.993958,474.458435 201.001770,474.270691 
	C200.828537,473.896637 200.647476,473.710358 200.740906,473.247498 
	C201.015427,472.970947 200.999161,473.004578 200.980942,473.008728 
	C203.818939,472.270996 206.406525,470.645599 209.721237,470.212982 
	C210.016769,469.986328 210.004349,470.007446 209.992096,470.007385 
	C210.387146,469.650787 210.860886,469.490295 211.779877,469.607544 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M209.621796,469.932343 
	C207.461563,471.549530 204.818985,472.879150 201.357910,473.044891 
	C203.324356,470.931732 206.178146,470.148132 209.621796,469.932343 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M201.657654,463.035492 
	C202.042389,464.531921 201.070267,465.361298 199.359680,465.952179 
	C199.060669,464.392273 199.788437,463.374786 201.657654,463.035492 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M200.621063,472.991516 
	C201.032730,473.156158 201.050049,473.341400 201.038483,473.804779 
	C199.384415,473.646698 197.593201,474.489410 195.230453,473.012054 
	C197.437698,473.012054 198.832184,473.012054 200.621063,472.991516 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M193.739807,462.181580 
	C194.015305,462.240112 194.387909,462.203735 194.572968,462.195435 
	C194.444534,465.044373 192.186356,463.652069 190.347153,464.016663 
	C190.427292,463.662903 190.897308,463.319763 191.653183,462.880798 
	C192.420715,462.502747 192.874069,462.155212 193.739807,462.181580 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M202.946793,460.686646 
	C201.929901,461.032715 200.855850,461.083588 199.280640,460.733521 
	C199.419449,458.876190 200.650879,458.445801 202.427841,458.543640 
	C202.744705,458.675171 202.982407,458.948303 203.112518,459.077515 
	C203.124954,459.601624 203.007294,459.996490 202.946793,460.686646 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M200.720322,474.994080 
	C202.061432,474.852112 203.143219,474.870178 204.628815,474.932190 
	C203.767349,476.442474 202.035690,475.861603 200.038818,476.017517 
	C199.891174,475.731171 200.176071,475.442627 200.720322,474.994080 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M199.127274,466.115112 
	C198.782211,466.833832 198.350159,467.475677 197.632095,468.225006 
	C197.346085,468.332458 196.885620,468.254242 196.836273,468.026001 
	C197.310471,467.246094 197.834015,466.694458 198.612076,466.013550 
	C198.866592,465.884247 199.040298,466.038269 199.127274,466.115112 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M181.019806,473.983124 
	C180.618393,473.844452 180.204712,473.716431 179.791046,473.588379 
	C180.133484,472.993073 180.471039,473.252716 180.898743,473.806885 
	C180.989395,474.019531 181.007553,473.993774 181.019806,473.983124 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M212.112061,469.499146 
	C211.677704,469.786774 211.196701,469.884308 210.347778,469.994598 
	C210.429947,469.660980 210.880051,469.314636 211.636078,468.952881 
	C211.942017,468.937439 212.065399,469.309021 212.112061,469.499146 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M209.344482,457.413513 
	C209.240021,456.696106 209.554703,456.016846 210.797943,456.735535 
	C210.535645,457.077820 210.098282,457.185455 209.344482,457.413513 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M191.276398,474.191650 
	C191.461105,473.463409 191.787735,472.011353 192.437561,473.851929 
	C192.012848,474.156067 191.796631,474.287476 191.276398,474.191650 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M197.353241,461.957581 
	C197.128601,461.658905 197.307449,461.404999 197.790436,461.096497 
	C198.168655,460.806427 198.345139,460.643036 198.764984,460.745972 
	C199.008331,461.012299 198.998779,460.998566 198.992554,460.990234 
	C198.833298,461.706635 198.268158,461.852631 197.353241,461.957581 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M202.992432,461.004272 
	C203.424606,461.225372 203.868027,461.446503 204.311432,461.667603 
	C204.049179,461.786255 203.786926,461.904907 203.276169,462.020996 
	C203.042587,461.845154 203.057510,461.671936 203.038177,461.240295 
	C203.003937,460.981873 203.003693,461.004242 202.992432,461.004272 
z"/>
<path fill="#10B2F6" opacity="1.000000" stroke="none" 
	d="
M190.871033,474.196411 
	C191.181427,473.976440 191.390427,473.988464 191.914246,474.012573 
	C192.002411,474.309845 191.775757,474.595062 191.235168,474.895905 
	C190.870728,474.750458 190.820190,474.589417 190.871033,474.196411 
z"/>
<path fill="#10B2F6" opacity="1.000000" stroke="none" 
	d="
M189.704025,475.727905 
	C189.846405,475.369507 190.111038,475.123871 190.648468,474.894897 
	C190.921249,474.911530 190.968872,474.966095 190.993134,474.993103 
	C190.862335,475.310028 190.707291,475.599915 190.312347,475.977051 
	C190.072464,476.064270 189.826263,475.840668 189.704025,475.727905 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M195.827469,469.023865 
	C195.909912,468.487976 196.109772,468.240173 196.581268,467.921692 
	C196.786926,467.797729 197.063431,468.062988 197.204758,468.197723 
	C197.196014,468.619690 197.002716,468.874115 196.559250,469.219604 
	C196.352295,469.343475 195.878906,469.258759 195.827469,469.023865 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M196.208496,469.204559 
	C196.189865,469.626007 195.984375,469.872650 195.287903,469.969116 
	C194.948654,469.542511 195.128510,469.278717 195.577805,468.926208 
	C195.776031,468.788971 196.064713,469.065643 196.208496,469.204559 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M202.007355,463.012390 
	C202.104034,462.689667 202.289322,462.421661 202.800842,462.120361 
	C203.027664,462.018372 202.998688,461.996704 202.986908,461.982666 
	C202.811417,462.263153 202.647705,462.557739 202.226547,462.914032 
	C201.969101,462.975769 201.996567,462.998383 202.007355,463.012390 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M193.890533,471.200806 
	C194.067764,471.480682 193.845093,471.670166 193.622406,471.859619 
	C193.578491,471.609894 193.534561,471.360168 193.890533,471.200806 
z"/>
<path fill="#0589D6" opacity="1.000000" stroke="none" 
	d="
M173.943436,474.046021 
	C173.637344,473.921875 173.443085,473.689453 173.248825,473.457092 
	C173.499161,473.414062 173.749481,473.371063 174.137695,473.522949 
	C174.275574,473.717804 174.055267,473.937744 173.943436,474.046021 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M195.189606,470.192444 
	C195.142609,470.583893 194.935928,470.823944 194.487808,471.158630 
	C194.290421,471.291168 194.078766,471.074738 193.973053,470.964752 
	C193.991165,470.554626 194.180557,470.304077 194.637756,469.978973 
	C194.840012,469.854858 195.073959,470.079010 195.189606,470.192444 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M205.302826,474.999603 
	C205.436935,474.683014 205.911835,474.352966 206.700897,474.021484 
	C207.015030,474.020111 207.000748,473.988220 206.984009,473.984741 
	C207.144363,474.149994 207.321472,474.318787 207.237823,474.745850 
	C206.977051,475.004059 207.001846,475.006439 207.003998,474.994507 
	C206.551987,474.983765 206.097824,474.984955 205.302826,474.999603 
z"/>
<path fill="#16202D" opacity="1.000000" stroke="none" 
	d="
M132.158600,329.138397 
	C131.518631,328.664825 131.034439,328.379303 130.266357,328.113586 
	C122.798645,322.243134 113.678749,320.298248 105.322205,315.979980 
	C104.430702,315.465485 103.909935,315.060852 103.288574,314.297180 
	C100.975769,310.443726 104.594368,311.050385 106.798119,309.908630 
	C104.226341,308.711151 101.379242,309.085419 100.589821,306.217651 
	C100.935417,304.638092 101.623810,303.793243 103.236679,303.418915 
	C106.400642,304.064606 108.516190,306.147278 111.584633,307.218994 
	C108.440605,305.787048 105.887070,304.122223 102.931160,302.460297 
	C102.399155,301.807465 102.208237,301.364136 102.026917,300.528198 
	C101.969772,299.671600 102.018845,299.185516 102.237862,298.359680 
	C103.420982,296.142944 105.061844,294.730682 106.602150,292.789581 
	C107.881699,291.814056 109.104836,291.435242 110.515724,290.458649 
	C109.522408,289.717499 108.137947,289.708649 107.450439,288.318665 
	C107.224274,287.474213 107.241028,286.974213 107.508774,286.116943 
	C107.953522,285.313416 108.319283,284.943176 109.126450,284.504028 
	C110.676704,284.137573 111.799187,284.549347 112.949326,284.679016 
	C116.918770,285.126434 119.855972,284.122009 120.450935,279.539734 
	C120.616417,278.265228 120.943710,276.901123 122.230614,276.127441 
	C125.084328,279.290283 125.089722,281.530548 122.257301,300.197754 
	C121.295502,304.052948 121.168335,307.810303 118.300224,310.597900 
	C116.717903,312.135773 117.934204,313.225616 119.299538,314.143127 
	C123.270317,316.811554 126.063599,315.899872 129.753265,310.848145 
	C130.458694,311.218994 130.720596,311.620300 131.013794,312.419769 
	C131.232819,313.413025 131.271454,314.062195 131.286179,314.714508 
	C131.465286,322.651001 131.469269,322.655579 139.440475,325.654358 
	C140.031342,325.901123 140.263077,326.018829 140.810303,326.378845 
	C141.282349,326.840546 141.438873,327.059906 141.730209,327.665100 
	C141.776688,332.436554 139.537048,332.483459 136.042206,330.574097 
	C135.015823,330.262695 134.363266,330.129974 133.377228,329.986389 
	C132.809967,329.748688 132.566833,329.532349 132.158600,329.138397 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M116.731293,324.906921 
	C117.415337,326.111542 116.969772,327.288055 115.937119,327.298737 
	C110.715622,327.352600 105.805359,331.929169 100.297066,328.402100 
	C99.967758,328.191284 98.941551,329.068817 98.084450,329.747498 
	C97.929268,330.055054 97.979958,330.041687 97.976730,330.015961 
	C97.294922,330.600922 96.519028,330.766632 95.311882,330.250000 
	C94.146568,325.063477 97.346878,324.743683 101.063568,324.980316 
	C100.481697,322.794342 97.824799,323.250732 97.094139,321.136963 
	C96.146805,319.692261 96.673943,318.839325 97.878845,317.886230 
	C104.286964,320.101227 110.327675,322.471588 116.731293,324.906921 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M102.908699,297.997131 
	C103.049660,298.758301 103.014038,299.162415 102.939217,299.868286 
	C102.346596,300.885468 102.018204,301.612640 103.022476,302.616943 
	C103.303032,303.050446 103.344398,303.264130 103.189110,303.738342 
	C102.410805,304.617401 101.829170,305.235901 101.008926,305.890930 
	C98.550064,306.114899 96.507050,305.621613 94.357742,304.128815 
	C94.027702,303.491821 94.009384,303.065216 93.995247,302.318176 
	C94.024857,301.515961 94.094734,301.039001 94.305191,300.602966 
	C94.682945,299.820282 95.471924,299.654572 96.191582,299.391235 
	C95.409073,299.517151 94.647659,299.832611 93.544945,299.473755 
	C92.921616,299.037292 92.584595,298.781006 92.079933,298.253052 
	C91.842392,297.731750 91.772499,297.482117 91.920837,296.908325 
	C92.363426,296.449554 92.587791,296.314911 93.186920,296.059692 
	C94.871666,295.688507 96.178825,295.796265 97.875824,296.032776 
	C99.798172,296.485138 101.402954,296.664093 102.908699,297.997131 
z"/>
<path fill="#08101D" opacity="1.000000" stroke="none" 
	d="
M98.065735,317.456116 
	C97.841141,318.533173 97.436012,319.335449 97.026047,320.466248 
	C92.817177,321.670624 91.359428,319.756744 91.900871,315.360474 
	C94.536095,313.917419 95.882492,316.429138 98.065735,317.456116 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M102.758614,314.005341 
	C103.965935,314.067474 104.633011,314.370483 104.983078,315.491333 
	C101.598602,316.497589 98.951347,314.537476 94.732391,313.029755 
	C98.486290,311.290283 100.290756,313.743347 102.758614,314.005341 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M123.045273,327.660950 
	C121.980927,328.005005 120.601494,328.378723 119.212631,327.084229 
	C120.286583,326.940704 121.526306,327.166809 123.045273,327.660950 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M129.656250,328.970825 
	C129.958878,329.978119 129.772141,330.811340 128.185760,330.039185 
	C127.786583,329.796143 127.643837,329.651855 127.716629,329.292542 
	C128.391800,329.047302 128.851456,329.017059 129.656250,328.970825 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M127.608910,329.037659 
	C127.932159,329.077545 127.952614,329.509552 127.940964,329.724976 
	C127.387527,329.781006 126.845734,329.621582 126.143265,329.219360 
	C126.416954,328.983612 126.851311,328.990662 127.608910,329.037659 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M125.872574,328.668030 
	C125.357544,328.838135 124.683990,328.672272 123.770439,328.236328 
	C124.258308,328.088165 124.986176,328.210083 125.872574,328.668030 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M118.912201,325.815552 
	C118.726982,325.868469 118.425224,325.664551 117.989883,325.217224 
	C118.169411,325.168762 118.482544,325.363739 118.912201,325.815552 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M94.644073,329.993927 
	C95.725143,329.990265 96.474831,329.979187 97.599014,329.979187 
	C97.308258,333.106018 95.699196,333.009827 93.327286,331.156250 
	C93.033791,330.866913 93.021042,330.694244 92.997055,330.262146 
	C93.428108,329.997345 93.870399,329.991913 94.644073,329.993927 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M90.728485,335.140717 
	C90.855637,335.434601 90.642860,335.654938 90.140900,335.883881 
	C90.099304,335.683655 90.278252,335.408569 90.728485,335.140717 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M114.433884,342.003082 
	C113.723320,341.915253 113.480682,341.752258 113.190750,341.323059 
	C118.901085,339.548737 124.586159,342.485809 130.507248,341.582703 
	C132.201981,341.324188 134.443878,344.653107 136.298569,346.792480 
	C129.283829,344.430023 122.028984,343.411041 114.433884,342.003082 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M131.426941,333.451660 
	C131.900009,329.969788 134.121384,332.881134 135.867523,331.988617 
	C138.033890,331.483307 139.649216,332.246490 141.664124,332.871643 
	C142.743774,333.408905 143.316025,333.946320 143.849640,335.056641 
	C144.235611,336.573517 144.128632,337.658813 143.288055,338.989624 
	C141.918030,340.003784 140.677429,333.896149 139.380722,339.426788 
	C139.189835,340.240967 136.982986,338.038422 135.891083,336.527283 
	C135.013107,334.534821 133.023880,334.919922 131.426941,333.451660 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M151.280212,351.621155 
	C148.329437,349.906372 147.512482,346.669159 146.099899,343.254028 
	C148.626740,342.003479 150.010529,343.782043 152.023529,345.487793 
	C152.402466,346.273651 152.419388,346.495209 152.364777,347.037811 
	C151.698120,348.553314 151.988480,349.892181 151.280212,351.621155 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M143.115936,339.561096 
	C142.994614,338.155121 142.994263,337.019287 142.983337,335.461975 
	C145.971329,334.532257 146.917603,336.894836 148.276520,339.109497 
	C148.213150,340.578888 147.399734,341.332855 146.567963,342.430084 
	C146.359634,342.665009 146.080643,342.922241 145.939209,343.051514 
	C144.944183,342.064270 144.090561,340.947754 143.115936,339.561096 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M156.312256,359.635895 
	C155.158157,359.240692 154.241013,358.556274 153.162766,357.628662 
	C152.863144,357.021057 152.666092,356.691559 152.187897,356.210632 
	C151.965210,356.024261 152.003815,356.007568 151.987549,356.022522 
	C151.780609,355.781708 151.572174,355.541351 151.155182,355.172852 
	C150.964386,355.029297 150.954697,355.071564 150.936249,355.084869 
	C150.937149,354.349518 150.956528,353.600861 150.929398,352.480804 
	C150.882889,352.109406 151.119186,351.890472 151.237305,351.780945 
	C152.876465,351.205658 153.628113,352.253510 154.631088,353.533447 
	C155.684311,355.591064 157.268890,357.112335 156.312256,359.635895 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M127.764519,332.447754 
	C128.657379,332.351013 129.513992,332.546417 130.684021,332.869080 
	C130.997421,332.996338 131.000000,333.000000 131.001740,333.001221 
	C131.528580,333.414703 132.096695,333.788910 132.149109,334.773590 
	C130.508789,335.962830 129.082230,334.785095 127.290993,334.911621 
	C126.961464,334.868073 126.972542,334.485809 126.970924,334.294617 
	C126.645164,333.327667 129.070755,334.082520 127.764519,332.447754 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M132.276733,335.245056 
	C131.729492,334.558563 131.469635,334.048035 131.106613,333.269958 
	C133.023621,333.399231 134.964844,333.941101 135.983322,336.017822 
	C134.712631,335.951935 133.638367,335.686462 132.276733,335.245056 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M141.271225,349.863831 
	C140.894943,349.779877 140.970001,349.366913 141.002243,349.159241 
	C141.616150,349.142731 142.197830,349.333954 142.986176,349.766205 
	C142.677734,349.987427 142.162613,349.967621 141.271225,349.863831 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M141.098419,342.226990 
	C141.336304,342.067841 141.617386,342.233490 141.901428,342.772522 
	C141.646561,342.925690 141.392288,342.727631 141.098419,342.226990 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M141.005524,341.995911 
	C140.893066,341.931549 140.774872,341.871643 140.656662,341.811737 
	C140.739685,341.778351 140.822708,341.744965 140.948029,341.861938 
	C140.990326,342.012268 140.999756,342.000336 141.005524,341.995911 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M142.023529,342.979614 
	C142.333359,343.113983 142.623871,343.265900 142.895721,343.780090 
	C142.550537,344.021240 142.300339,343.809784 142.047882,343.271973 
	C141.969299,343.035828 142.004227,342.997131 142.023529,342.979614 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M143.090759,343.924683 
	C143.264587,344.083191 143.364151,344.311218 143.463730,344.539246 
	C143.336090,344.504822 143.208466,344.470398 142.978943,344.289185 
	C142.877075,344.142395 143.016510,343.994232 143.090759,343.924683 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M156.304443,360.063965 
	C156.278885,357.849640 154.687485,356.482422 153.970184,354.396484 
	C159.310104,353.659058 164.128387,355.189362 168.700287,358.737183 
	C172.044357,362.474335 176.637527,363.343475 180.651093,365.871399 
	C180.478516,368.804810 178.153976,368.114197 176.392426,368.347107 
	C173.948608,368.670258 171.545425,367.853821 168.690720,367.911804 
	C166.603546,367.874512 165.115509,367.242157 163.358047,366.193726 
	C163.029510,365.958984 163.062943,365.941071 163.073242,365.922180 
	C163.070770,364.537109 162.063141,364.122498 160.732056,363.594452 
	C160.267578,363.308319 160.086975,363.174316 159.758148,362.974579 
	C159.103653,362.527344 158.595215,362.148743 157.833191,361.590942 
	C157.230942,361.008789 156.882263,360.605804 156.304443,360.063965 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M150.991760,355.315338 
	C151.264938,355.188232 151.565475,355.347198 151.918640,355.771851 
	C151.653885,355.892120 151.336502,355.746765 150.991760,355.315338 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M152.003174,356.326599 
	C152.266739,356.274414 152.568283,356.524567 152.935760,357.080139 
	C152.681503,357.133331 152.361328,356.881134 152.003174,356.326599 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M127.404236,332.068542 
	C128.138443,332.833130 129.496841,333.655060 127.253998,334.055542 
	C123.146416,334.043213 119.323318,333.993256 115.500778,333.915619 
	C114.528191,333.895905 113.278374,334.006348 113.168610,332.686188 
	C113.061256,331.394989 114.242226,331.166901 115.241844,331.086304 
	C119.207344,330.766663 123.204414,330.136169 127.404236,332.068542 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M141.515045,333.687317 
	C139.739258,333.295624 138.288925,332.752777 136.536987,332.095398 
	C136.104614,331.628540 135.973816,331.276276 135.755707,330.659729 
	C137.374115,329.391907 141.455658,333.152679 140.979095,327.360138 
	C143.734833,327.182098 143.882690,330.292938 146.071411,331.644714 
	C146.290756,332.179352 146.312607,332.417389 146.166473,332.974060 
	C144.673965,334.424133 143.231598,333.542328 141.515045,333.687317 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M132.091858,329.195496 
	C132.262360,329.148895 132.521881,329.347504 132.912582,329.760803 
	C132.756134,329.797241 132.468506,329.618958 132.091858,329.195496 
z"/>
<path fill="#1B222E" opacity="1.000000" stroke="none" 
	d="
M153.051636,387.490112 
	C153.701889,386.662628 154.081619,386.088257 153.259155,385.108337 
	C152.830124,383.951935 153.459396,383.545013 154.629395,383.207275 
	C157.277039,383.830597 159.693649,383.135284 162.304871,384.074127 
	C162.912949,384.278046 163.144211,384.392426 163.672424,384.749481 
	C164.133850,385.183411 164.298340,385.374695 164.658203,385.884735 
	C166.970627,391.193146 169.693985,395.572418 175.452148,397.011902 
	C176.632538,397.306976 177.545181,397.991638 177.380142,399.751099 
	C176.398743,401.014954 175.198486,401.188263 173.730103,401.594574 
	C172.264328,401.822296 171.169571,401.366364 169.718048,401.486969 
	C169.178314,401.484558 168.963470,401.482269 168.429138,401.453308 
	C167.686035,401.382385 167.268738,401.304565 166.558487,401.090973 
	C165.871948,400.817841 165.530411,400.581940 165.119904,399.982666 
	C161.392365,397.315948 157.080978,396.784058 153.163971,395.213959 
	C151.901764,394.707977 151.477036,394.461609 152.853149,393.272034 
	C152.984650,393.022980 153.006485,393.006195 153.016174,392.996826 
	C153.428711,392.657166 153.900803,392.432007 154.505341,392.005524 
	C154.686584,391.878296 155.027145,391.681885 154.831299,391.611572 
	C154.635437,391.541229 154.243011,391.368469 154.122803,391.190948 
	C153.696915,389.948914 153.391235,388.884369 153.051636,387.490112 
z"/>
<path fill="#2478A2" opacity="1.000000" stroke="none" 
	d="
M160.260635,404.671143 
	C157.585831,405.666321 155.125214,406.223724 152.102234,406.085693 
	C153.539093,403.043091 156.125488,402.514343 159.625305,403.984070 
	C160.167114,404.180817 160.339294,404.318329 160.260635,404.671143 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M160.375122,404.870636 
	C160.009811,404.886444 160.000885,404.464630 159.997925,404.253967 
	C161.571640,402.788696 163.834137,402.434692 164.899734,400.038910 
	C165.440979,399.765289 165.885376,399.834595 166.661957,399.964905 
	C167.208466,400.254669 167.433838,400.471954 167.849014,400.830200 
	C168.027771,400.982574 167.997665,400.989075 168.011658,400.978821 
	C168.193176,401.139893 168.360718,401.311249 168.235382,401.691040 
	C165.908783,403.778870 163.118454,403.814484 160.375122,404.870636 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M138.043198,396.855835 
	C137.785583,396.800354 137.882874,396.373444 137.974609,396.174561 
	C138.424927,396.121887 138.783524,396.268158 139.142120,396.414429 
	C138.861694,396.580048 138.581253,396.745697 138.043198,396.855835 
z"/>
<path fill="#17283A" opacity="1.000000" stroke="none" 
	d="
M172.804749,401.056458 
	C173.919769,399.747345 175.173080,400.052856 176.677673,399.935120 
	C179.590363,397.994476 182.369736,398.329834 185.596664,399.328430 
	C188.346771,403.728882 187.590149,408.055389 186.387466,412.694824 
	C185.944672,413.108002 185.735504,413.218475 185.240143,413.386353 
	C184.953934,413.443695 184.604187,413.485962 184.604187,413.485962 
	C184.604187,413.485962 184.295868,413.371613 184.360504,413.477417 
	C184.425156,413.583221 184.783813,413.525330 185.004684,413.529358 
	C185.578690,413.542938 185.897903,413.660461 186.355591,414.103882 
	C186.616119,414.788757 186.619278,415.211151 186.408112,415.941467 
	C184.229630,418.008087 182.314896,419.896301 180.245987,422.088562 
	C175.632156,420.759918 171.321655,419.277344 166.658279,417.673462 
	C166.166840,416.902252 166.028259,416.252319 165.676224,415.339813 
	C165.462769,415.077240 165.483093,415.068939 165.483154,415.047577 
	C166.183197,414.770813 166.513535,414.233795 166.824661,413.260986 
	C167.025528,412.992828 166.992386,412.994446 166.995621,413.010681 
	C167.221680,412.791840 167.448608,412.560760 167.854004,412.164612 
	C168.028397,411.995514 167.995163,411.991577 167.995621,412.008301 
	C168.222076,411.791290 168.450562,411.560059 168.854996,411.159912 
	C169.028442,410.988556 168.987534,410.991272 168.989777,411.011658 
	C169.464218,410.418854 169.834061,409.710083 170.801514,409.164459 
	C171.033264,408.985840 170.985733,408.984039 170.983932,409.007751 
	C171.214417,408.798187 171.447098,408.565277 171.855713,408.159119 
	C172.031265,407.985474 171.988586,407.989746 171.992081,408.010925 
	C172.251663,407.710114 172.473190,407.366241 172.828766,406.751770 
	C174.134537,404.665344 171.635208,403.118835 172.804749,401.056458 
z"/>
<path fill="#0A5C8E" opacity="1.000000" stroke="none" 
	d="
M172.612305,400.844849 
	C173.149429,402.424286 172.904953,404.059082 174.928497,404.947693 
	C176.393158,405.590942 176.285904,405.835144 173.682770,407.033783 
	C173.100067,407.168701 172.853516,407.275940 172.266220,407.167480 
	C171.881210,404.648071 172.851929,401.698090 168.349274,401.936829 
	C167.942505,401.899475 167.965134,401.432526 167.995392,401.200531 
	C169.415253,400.935059 170.804871,400.901581 172.612305,400.844849 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M170.689911,408.983612 
	C170.548447,409.614014 170.063629,410.242188 169.285400,410.951172 
	C168.802185,409.924835 169.390686,409.331787 170.689911,408.983612 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M166.714203,413.118835 
	C167.256485,413.864868 167.048279,414.585846 165.888702,415.072632 
	C165.789749,414.432404 166.096298,413.838623 166.714203,413.118835 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M171.742279,408.014404 
	C171.861755,408.294708 171.692245,408.603943 171.252441,408.972321 
	C171.139206,408.702118 171.296249,408.372742 171.742279,408.014404 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M171.877991,407.226074 
	C172.162201,406.964050 172.398926,406.976318 172.991150,407.025024 
	C173.090164,407.351440 172.833710,407.641418 172.286423,407.981750 
	C171.940552,407.854828 171.885529,407.677582 171.877991,407.226074 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M168.734558,411.003052 
	C168.871353,411.311127 168.714279,411.633698 168.276642,411.990662 
	C168.144287,411.689178 168.292480,411.353363 168.734558,411.003052 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M167.736542,412.005554 
	C167.883743,412.345245 167.739105,412.695007 167.296661,413.035828 
	C167.147461,412.689850 167.296066,412.352722 167.736542,412.005554 
z"/>
<path fill="#141923" opacity="1.000000" stroke="none" 
	d="
M186.458939,400.353333 
	C183.403885,400.043549 180.670975,399.996338 177.486740,399.932465 
	C176.845169,398.854645 176.328857,398.207062 175.161194,398.020905 
	C168.687393,396.988922 165.834167,392.352509 164.027771,386.332275 
	C166.055832,384.031219 168.818542,383.639862 171.497589,382.321136 
	C172.293106,381.756836 172.820679,381.420685 173.495590,381.786499 
	C172.819656,381.401672 172.289810,381.728882 171.487122,382.311829 
	C170.317932,382.862183 169.433243,383.004486 168.268280,382.316772 
	C165.426712,379.230347 161.003494,378.684326 159.176407,374.770050 
	C158.423813,373.157806 157.122650,371.803284 157.022263,369.537903 
	C158.763092,369.110107 160.502075,369.038422 162.672180,368.903381 
	C164.921967,367.664520 166.778381,368.102264 168.971313,368.810486 
	C170.355042,369.299438 171.398453,369.713257 172.831650,369.997559 
	C173.367523,370.144531 173.578583,370.215149 174.091431,370.427551 
	C174.776306,370.791595 175.152664,371.024780 175.808975,371.432922 
	C179.542038,373.076447 182.871750,374.841034 186.828644,375.956543 
	C191.221222,377.921814 195.397186,379.541748 199.883636,381.309753 
	C200.950256,381.540619 201.598618,381.862000 202.479401,382.546051 
	C203.282394,383.388794 203.671722,384.059082 204.140686,385.143127 
	C204.516037,386.850189 205.328629,387.903992 205.948395,389.058380 
	C209.036575,394.810638 205.702850,400.904449 199.156326,401.283508 
	C195.556274,401.491913 191.933762,401.487854 187.922318,401.098724 
	C187.273071,400.870789 187.027069,400.743347 186.458939,400.353333 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M170.176727,369.827301 
	C167.963333,369.716675 165.921707,369.327240 163.491699,368.888916 
	C163.470444,368.055786 163.796799,367.270355 163.101273,366.208069 
	C164.507080,365.698914 165.814896,366.217102 167.428436,366.967621 
	C168.577484,367.367523 169.442383,367.562897 170.156097,368.607300 
	C170.325302,369.112518 170.336899,369.330536 170.176727,369.827301 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M171.606033,381.989655 
	C170.199127,384.429749 167.645294,385.502991 164.400970,385.970825 
	C164.032303,385.956909 164.009094,385.985962 164.020905,385.986267 
	C163.819672,385.756927 163.589157,385.546387 163.176483,385.188171 
	C160.669525,384.367767 158.326614,383.718567 155.436096,383.989746 
	C154.737473,383.749146 154.424469,383.557922 153.876221,383.227600 
	C153.634811,382.859222 153.599716,382.677216 153.743225,382.282166 
	C158.369736,383.261658 162.861740,383.380249 167.695755,382.355225 
	C169.060928,382.040863 170.120102,381.993622 171.606033,381.989655 
z"/>
<path fill="#12628E" opacity="1.000000" stroke="none" 
	d="
M153.562256,382.037598 
	C153.921860,382.069092 153.966431,382.513580 153.963898,382.736938 
	C153.028275,383.858673 151.846420,383.949371 150.289871,383.980896 
	C149.746109,383.983887 149.558914,383.987274 149.089905,383.977966 
	C148.734711,379.861786 151.473541,382.066315 153.562256,382.037598 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M155.714325,391.047546 
	C155.571030,392.114716 154.801498,392.804596 153.344788,392.987305 
	C153.274765,392.498199 153.523682,392.008942 153.887604,391.266571 
	C154.424728,390.982147 154.846878,390.950867 155.714325,391.047546 
z"/>
<path fill="#1B2532" opacity="1.000000" stroke="none" 
	d="
M150.133148,384.267029 
	C150.759109,382.733154 152.078735,383.141876 153.597260,382.978394 
	C154.231628,383.156799 154.501892,383.353302 154.896637,383.769104 
	C154.470078,384.151154 153.919052,384.313843 153.196350,384.711517 
	C152.127441,384.815491 151.230225,384.684509 150.133148,384.267029 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M268.987122,510.843201 
	C263.695221,515.577332 257.984009,517.896362 251.360474,513.393677 
	C250.737640,512.970337 249.773010,513.049683 248.605377,512.813110 
	C248.240814,512.041199 248.237976,511.351837 248.180389,510.318970 
	C246.182220,507.805359 247.717361,506.196045 249.252075,504.324951 
	C249.681091,503.975922 249.858856,503.848053 250.314911,503.561890 
	C250.959518,503.300323 251.097412,503.151520 251.016739,502.953156 
	C250.929047,502.737549 250.840652,502.627899 250.758698,502.290161 
	C253.788055,498.195618 257.190460,495.009918 262.554077,494.233887 
	C263.635193,494.520355 264.275452,494.885498 265.096497,495.644470 
	C266.039703,500.140808 261.785675,500.680084 259.756012,503.296600 
	C258.540009,504.194641 257.402985,504.535889 256.485992,505.307983 
	C259.422546,508.747559 263.646484,508.974640 267.936768,509.965179 
	C268.439301,510.256836 268.625946,510.397827 268.987122,510.843201 
z"/>
<path fill="#0DA5E9" opacity="1.000000" stroke="none" 
	d="
M250.819122,503.772308 
	C249.603912,505.493866 247.929153,506.865417 248.126831,509.618378 
	C247.130051,509.987823 246.134430,510.000214 244.773193,510.015564 
	C242.990814,507.630829 244.614655,505.174774 244.161835,502.370331 
	C243.934006,501.789978 243.788788,501.602875 243.789398,501.092773 
	C244.517380,500.325317 245.183182,500.182953 246.222961,500.297974 
	C246.734375,500.471619 246.923065,500.572937 247.326508,500.900940 
	C247.882645,501.602631 248.185242,502.108826 248.885742,502.626770 
	C249.650970,502.987366 250.171295,503.212158 250.819122,503.772308 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M272.430969,502.891174 
	C271.854065,504.899170 271.442932,506.561157 271.074921,508.591217 
	C270.636414,509.585083 270.154724,510.210907 269.417358,510.992126 
	C269.161652,511.147552 269.018768,511.012726 268.948242,510.944366 
	C267.911774,508.890076 266.194763,508.381287 264.134247,507.987305 
	C261.149597,507.416565 260.605499,505.809723 263.424774,503.531830 
	C265.631287,502.502930 268.383789,503.282196 269.089539,500.084106 
	C269.332367,498.983612 270.992462,499.154114 272.330566,500.047424 
	C272.849823,501.069611 272.863464,501.804962 272.430969,502.891174 
z"/>
<path fill="#0B5794" opacity="1.000000" stroke="none" 
	d="
M267.136169,521.058472 
	C267.305359,522.642517 267.090332,524.293945 266.820831,526.348145 
	C264.891418,526.646179 262.470276,526.056274 262.378784,524.396606 
	C262.257111,522.189514 265.160309,522.126587 267.136169,521.058472 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M256.300049,527.116821 
	C256.808197,526.449890 257.545044,525.803162 258.382111,525.335938 
	C259.056091,524.959778 260.254120,524.477051 260.406342,525.484009 
	C260.529846,526.300903 261.793335,527.144653 260.741943,528.010986 
	C260.141357,528.505920 259.370392,529.063171 258.510498,528.600220 
	C257.816772,528.226746 257.214752,527.682922 256.300049,527.116821 
z"/>
<path fill="#0F62A1" opacity="1.000000" stroke="none" 
	d="
M262.555542,533.864197 
	C262.764191,534.823547 262.691925,535.651611 262.357849,536.651489 
	C261.421814,535.846497 259.664703,535.403564 260.290466,533.805054 
	C260.707275,532.740295 261.588257,533.374756 262.555542,533.864197 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M252.945419,528.847290 
	C252.188843,528.516602 252.037231,528.098328 252.453583,527.684204 
	C252.567444,527.570923 253.051147,527.671631 253.241257,527.826355 
	C253.612686,528.128601 253.903320,528.538330 252.945419,528.847290 
z"/>
<path fill="#0F62A1" opacity="1.000000" stroke="none" 
	d="
M257.178345,537.740784 
	C256.892456,537.369324 256.911652,537.030457 256.920715,536.436462 
	C257.193512,536.424744 257.476440,536.668152 257.928162,537.348572 
	C257.892456,537.781494 257.687958,537.777466 257.178345,537.740784 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M259.993469,537.948242 
	C260.315765,538.164490 260.303864,538.341064 260.168793,538.752808 
	C259.740540,538.823364 259.435425,538.658752 259.059998,538.235840 
	C259.212830,537.954651 259.436035,537.931702 259.993469,537.948242 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M258.321960,537.869019 
	C258.096924,537.785583 258.068909,537.594238 258.048401,537.502380 
	C258.351868,537.229126 258.632599,537.281128 258.947113,537.786011 
	C259.024139,538.005493 258.547028,537.952454 258.321960,537.869019 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M255.981247,526.978638 
	C255.889603,527.022156 255.812302,527.080688 255.881531,527.079163 
	C256.028046,527.019043 255.995575,526.993591 255.981247,526.978638 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M247.306122,500.907959 
	C246.288528,501.039978 245.655487,501.043701 244.705811,501.042664 
	C242.627487,501.708435 241.260101,500.171112 239.304932,500.132233 
	C238.533630,500.061920 238.073013,500.044769 237.270966,499.968140 
	C236.383392,499.437347 235.837219,498.966034 235.141541,498.261902 
	C234.687149,495.884521 236.420654,496.216370 237.575699,495.988678 
	C239.838730,495.542542 242.132492,495.244080 244.616913,494.120056 
	C245.707657,493.974915 246.426620,493.945404 247.505493,493.921783 
	C250.593643,496.282715 250.101547,498.555664 247.306122,500.907959 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M238.994873,500.424866 
	C240.860657,498.138794 242.321259,499.204712 244.055374,500.877563 
	C244.389175,501.037903 244.218475,501.502594 244.148865,501.739868 
	C243.605179,501.988098 243.131104,501.999084 242.302307,502.027466 
	C241.388657,502.948456 240.683441,503.584381 239.247681,503.112183 
	C238.984955,502.157196 238.990234,501.463959 238.994873,500.424866 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M227.000580,502.325592 
	C227.512222,501.727936 228.018738,501.470917 228.809875,501.182983 
	C229.038376,502.200714 231.740967,502.970154 229.392044,504.259033 
	C227.536957,505.276917 227.027481,504.350220 227.000580,502.325592 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M239.138947,503.152527 
	C239.771606,502.642456 240.563522,502.434448 241.651505,502.135620 
	C241.840179,503.972656 240.936707,504.404327 239.138947,503.152527 
z"/>
<path fill="#0355A0" opacity="1.000000" stroke="none" 
	d="
M236.450363,506.439270 
	C236.519180,506.395691 236.381546,506.482880 236.450363,506.439270 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M236.468658,502.455383 
	C236.520889,502.426208 236.416412,502.484528 236.468658,502.455383 
z"/>
<path fill="#0ABEFA" opacity="1.000000" stroke="none" 
	d="
M213.998016,499.997559 
	C214.090714,499.962921 214.185379,499.930695 214.142456,499.951202 
	C214.004883,500.003906 214.000000,500.000000 213.998016,499.997559 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M244.960114,493.785034 
	C243.285706,499.119354 238.567688,495.976471 235.264587,497.742249 
	C234.650421,497.946503 234.389679,497.754211 234.104553,497.227234 
	C236.479111,493.431396 240.577164,493.983795 244.479126,493.084839 
	C244.869354,493.127411 244.931519,493.565582 244.960114,493.785034 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M392.790161,122.797295 
	C395.748627,124.020805 398.425903,125.052841 401.463776,126.131302 
	C402.814056,125.997307 403.870941,125.746178 404.775421,126.233345 
	C410.013672,129.054611 415.657257,131.115662 420.741516,134.926178 
	C423.649475,136.824173 426.349091,138.411407 429.381775,140.065048 
	C432.876831,141.581955 436.455200,142.352493 438.751709,145.832092 
	C442.925812,149.189926 446.900360,152.258133 451.053345,155.619232 
	C450.761749,157.156250 449.736176,157.857498 448.400757,158.644424 
	C447.567810,158.938248 446.992828,159.039291 446.164551,159.269257 
	C445.728363,159.418030 445.556183,159.480835 445.130280,159.644318 
	C444.543060,159.883728 444.210724,160.025253 443.637939,160.288803 
	C443.232330,160.480499 443.068481,160.553116 442.653107,160.717560 
	C442.064178,160.916397 441.726257,161.021622 441.141357,161.217957 
	C440.731720,161.375931 440.568420,161.440765 440.161316,161.605499 
	C439.592102,161.842361 439.269287,161.985214 438.712036,162.264587 
	C438.315491,162.484863 438.155884,162.574432 437.753479,162.797455 
	C437.014038,163.201630 436.516663,163.471069 435.842407,164.011200 
	C434.445740,165.192947 434.203217,166.728394 433.158325,168.166534 
	C430.557159,169.132462 429.160309,167.396896 427.629578,166.245346 
	C421.379761,161.543747 415.061523,156.947876 408.087769,152.656738 
	C407.667297,152.223633 407.523499,152.028351 407.224182,151.505798 
	C405.106323,141.361069 399.721405,134.006653 390.779358,128.783539 
	C389.250122,127.603577 387.887207,126.766449 387.193542,124.814606 
	C387.164124,122.931694 387.423462,121.604019 389.722046,121.666412 
	C390.121643,121.791969 390.032227,121.853951 390.075470,121.831291 
	C390.650970,122.867477 391.703400,122.366631 392.790161,122.797295 
z"/>
<path fill="#2A3743" opacity="1.000000" stroke="none" 
	d="
M420.959686,134.833496 
	C414.726562,132.402206 408.503326,129.567474 402.052216,126.455246 
	C402.187561,125.348129 402.550720,124.518524 402.950562,123.349609 
	C404.278625,122.538872 405.979584,121.058342 406.740692,123.150940 
	C408.650482,128.401779 413.151001,129.763260 417.743103,130.908524 
	C419.827759,131.428436 421.031403,132.205276 420.959686,134.833496 
z"/>
<path fill="#2A3743" opacity="1.000000" stroke="none" 
	d="
M439.160034,145.843903 
	C435.999512,144.317642 433.047729,142.513565 429.905396,140.420471 
	C436.410095,142.161438 444.118591,141.812943 448.928528,148.671356 
	C445.487701,148.611481 443.429962,144.322388 439.160034,145.843903 
z"/>
<path fill="#AEF6FB" opacity="1.000000" stroke="none" 
	d="
M446.783447,158.188202 
	C448.634064,158.152664 449.112976,156.241547 450.884888,155.968475 
	C451.231750,155.912109 451.632843,155.885605 451.829376,155.844360 
	C459.485107,162.174149 466.515442,168.982544 473.015900,176.334869 
	C474.333099,177.824707 475.798157,179.201340 476.220947,181.609467 
	C475.422211,183.202179 474.266846,183.633545 472.532410,183.563766 
	C469.693665,181.562256 467.806244,179.030411 465.216522,177.187851 
	C458.403625,172.340485 454.483276,172.092621 447.547852,176.488525 
	C446.710815,177.019073 445.899109,177.590073 444.686829,178.182098 
	C439.328979,177.477615 436.572723,173.387466 432.860352,170.098618 
	C432.642029,169.553741 432.603577,169.318207 432.687134,168.746185 
	C433.220825,166.494705 432.387421,164.040085 435.474121,163.067581 
	C436.341248,162.605118 436.960663,162.531235 437.779846,162.171478 
	C438.012024,161.971573 438.006317,162.009583 437.987915,162.004074 
	C438.423370,161.586395 439.020874,161.529587 439.790039,161.161438 
	C440.010559,160.970963 440.006134,161.008179 439.988251,161.002563 
	C440.702667,160.322220 441.660095,160.615875 442.753784,160.193008 
	C443.006531,159.977432 443.002380,160.005493 442.989502,159.999695 
	C443.428162,159.582489 444.024200,159.529663 444.790131,159.163177 
	C445.010315,158.974335 445.004547,159.008789 444.987976,159.003235 
	C445.423492,158.588043 446.011230,158.526810 446.783447,158.188202 
z"/>
<path fill="#8CF2FB" opacity="1.000000" stroke="none" 
	d="
M476.224731,208.782990 
	C475.413422,209.857895 474.799530,210.696152 474.066406,211.823761 
	C473.613800,212.202225 473.181488,212.311661 472.988281,212.112885 
	C467.816925,206.792953 462.843719,201.317505 459.699341,194.158768 
	C462.580627,190.895477 465.063446,187.633163 469.334473,185.926529 
	C472.656647,185.701279 475.521454,184.363739 478.910095,185.404068 
	C480.467529,186.127335 481.642242,186.710449 482.979462,187.580200 
	C478.418579,189.799561 475.779541,193.203827 475.702393,198.732025 
	C475.744080,199.464722 475.768280,199.878769 475.776245,200.588943 
	C475.743988,201.073578 475.714813,201.262817 475.596161,201.715271 
	C475.417816,202.133011 475.329010,202.287521 474.896423,202.810242 
	C474.552643,203.178452 474.146240,203.421341 473.931152,203.487747 
	C473.716064,203.554153 474.078094,203.846237 474.313110,203.928375 
	C474.690033,204.115967 474.831879,204.221436 475.171936,204.520569 
	C476.371735,205.812912 477.030090,207.005814 476.224731,208.782990 
z"/>
<path fill="#70E9FC" opacity="1.000000" stroke="none" 
	d="
M475.259552,200.247406 
	C473.354431,194.199066 476.837067,188.378860 482.728027,187.914017 
	C483.141937,187.866806 483.078644,187.921448 483.054901,187.887024 
	C483.233612,188.234573 483.520569,188.538727 484.190552,188.851715 
	C484.987366,189.278870 485.474487,189.629623 486.015930,190.206696 
	C486.110474,190.635727 486.150726,190.838455 486.313812,191.325775 
	C486.328003,192.244598 485.929016,192.705933 485.316345,193.372955 
	C484.980743,193.720734 484.843658,193.853760 484.489197,194.166016 
	C483.969849,194.547211 483.662231,194.740112 483.133423,195.064957 
	C482.784088,195.309616 482.648529,195.410385 482.319885,195.669861 
	C482.126770,195.828583 481.754517,196.154449 481.573425,196.320068 
	C481.392303,196.485687 481.037506,196.820831 480.686310,197.156204 
	C480.335114,197.491577 479.985626,197.828415 479.636353,198.168518 
	C479.287048,198.508606 478.936401,198.855072 478.578491,199.206116 
	C478.094360,199.671799 477.968109,199.786469 477.637238,200.060364 
	C477.280029,200.304443 477.127441,200.389313 476.721069,200.545425 
	C476.110931,200.642380 475.769592,200.582458 475.259552,200.247406 
z"/>
<path fill="#A0F5FC" opacity="1.000000" stroke="none" 
	d="
M485.788147,192.200073 
	C486.005035,191.739090 486.022308,191.478378 486.054932,190.825317 
	C487.363953,191.740509 488.657684,193.048004 490.095459,194.675186 
	C488.351746,197.468781 485.655670,198.430801 482.374939,198.997208 
	C481.210327,198.718567 480.678558,198.141479 480.122162,197.191986 
	C479.977051,196.640030 480.052002,196.402328 480.396851,196.087540 
	C480.940033,195.867264 481.288849,195.687012 481.788208,195.196182 
	C481.984009,194.970840 481.989746,194.999741 481.981018,194.984833 
	C482.432404,194.582886 483.021759,194.529556 483.774139,194.157669 
	C483.984741,193.961945 483.986237,194.005402 483.973267,193.987564 
	C484.531250,193.475845 485.062988,192.941330 485.788147,192.200073 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M479.197083,185.240540 
	C476.067017,186.094864 472.841278,186.645523 469.165466,187.150024 
	C467.858307,184.657227 469.601501,183.964020 471.699097,183.255096 
	C473.204956,182.835800 474.325806,182.411530 475.808899,181.980835 
	C478.062500,182.057251 478.099426,183.974335 479.197083,185.240540 
z"/>
<path fill="#8CF2FB" opacity="1.000000" stroke="none" 
	d="
M484.335205,188.651733 
	C484.114105,188.757065 483.727997,188.586014 483.186523,188.133789 
	C483.410858,188.026871 483.790527,188.201111 484.335205,188.651733 
z"/>
<path fill="#131418" opacity="1.000000" stroke="none" 
	d="
M459.721130,193.750641 
	C464.275269,199.983780 468.827362,205.867584 473.663330,211.932251 
	C477.455963,217.926193 480.964722,223.739288 484.733154,229.774445 
	C485.709259,231.569489 486.425659,233.142471 487.357819,234.956650 
	C488.525116,235.300400 488.447296,236.122635 488.691711,237.095428 
	C489.285492,238.835175 489.842896,240.224548 490.645386,241.821686 
	C491.352448,243.332718 491.814514,244.635956 492.533875,246.174652 
	C493.748108,246.725998 493.877838,247.520004 493.904419,248.671112 
	C493.994171,249.641205 494.100220,250.304413 494.154663,251.300507 
	C494.278290,252.071365 494.582306,252.392380 495.274414,252.820770 
	C496.294830,253.981842 496.737885,255.033112 496.450867,256.588318 
	C493.953674,259.809174 494.529755,263.093781 495.813446,265.990845 
	C496.801025,268.219635 497.337158,270.181824 496.299164,272.736023 
	C494.789581,274.509521 495.319000,276.825104 493.382538,278.374207 
	C490.333374,280.311920 489.039368,278.344330 487.531311,276.119385 
	C486.766785,274.300873 486.956177,272.820953 487.495728,270.992310 
	C488.688934,267.851410 487.836792,265.359589 487.146240,262.529846 
	C485.248169,254.752197 482.383636,247.421860 479.048126,240.197479 
	C477.862793,237.630157 476.735901,235.061539 475.150055,232.717621 
	C473.497375,230.274841 471.385406,228.102951 472.748688,224.611298 
	C473.446808,222.823105 471.653473,222.582748 469.945618,222.393707 
	C468.599976,222.331543 467.636078,222.177719 466.387634,221.657898 
	C463.732697,218.532059 465.254974,216.346863 467.851593,214.215073 
	C464.146301,212.008820 461.613159,208.970062 459.500458,205.543915 
	C458.888672,204.551804 458.283234,203.045151 457.227386,203.014099 
	C449.961243,202.800461 449.205078,195.427109 444.745605,191.715729 
	C444.461456,190.764862 444.561371,189.790604 443.969025,189.606400 
	C435.321106,186.917130 433.163483,178.779984 429.202209,171.801117 
	C429.317596,170.424820 429.855560,169.679581 431.054932,169.022339 
	C431.618805,168.835159 431.849701,168.778214 432.406860,168.865616 
	C436.263306,171.969406 439.793518,174.928833 443.640076,178.010818 
	C450.325806,182.071350 455.081207,187.675674 459.721130,193.750641 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M473.785553,368.325836 
	C474.592255,366.794281 476.595062,367.238892 476.931274,365.316223 
	C477.061371,364.534119 477.252563,364.126953 477.819519,363.559326 
	C479.952698,362.617584 481.185669,360.823212 483.508972,360.265625 
	C486.270172,360.260834 488.630676,359.736053 491.329315,359.276978 
	C493.558441,359.350403 494.855835,358.317474 496.226318,356.720703 
	C497.031311,356.057831 497.649017,355.767151 498.684448,355.791931 
	C500.788727,355.719177 502.561951,355.531006 504.714355,355.434021 
	C505.056335,356.466339 505.019043,357.407501 504.966187,358.709351 
	C501.995758,360.130005 498.190247,360.047119 497.548401,364.745514 
	C497.198273,365.189758 497.022919,365.338013 496.529419,365.618530 
	C493.304779,365.872772 490.395752,365.961121 487.206818,366.453583 
	C486.675110,366.827545 486.322723,366.654510 486.030670,366.718750 
	C486.191681,367.035980 486.392090,366.994293 486.942535,366.548065 
	C490.422668,366.806671 489.819458,368.423553 488.350006,370.037476 
	C486.700897,371.848785 484.581238,373.236359 483.400848,375.874573 
	C483.193756,376.662354 483.047668,377.107574 482.734100,377.875610 
	C481.789124,379.431488 481.045044,380.716095 479.152466,380.985168 
	C478.304871,380.283447 478.055756,379.610046 477.857300,378.540802 
	C477.234436,375.501740 479.341003,373.035522 478.208130,370.437317 
	C477.155090,370.896149 476.324951,371.004517 475.127686,370.856171 
	C474.577820,370.684479 474.367249,370.583679 473.910461,370.230652 
	C473.489471,369.529358 473.462097,369.069122 473.785553,368.325836 
z"/>
<path fill="#0C1929" opacity="1.000000" stroke="none" 
	d="
M496.155640,296.844543 
	C500.039978,298.193481 500.370605,301.672119 499.747681,304.175293 
	C498.709503,308.347076 499.403748,312.192200 500.000305,316.594910 
	C499.111176,317.767761 498.103088,318.148834 496.534119,318.031067 
	C492.450439,316.673431 491.991211,313.453369 491.493469,309.869080 
	C491.548553,307.931824 492.595062,307.456360 493.896606,306.872498 
	C495.462769,306.169922 493.561249,306.193146 493.493042,306.139526 
	C492.415741,305.292480 491.798218,304.172699 491.268127,302.600830 
	C491.163513,302.058441 491.141968,301.840118 491.216614,300.990479 
	C491.397247,300.169952 491.481720,299.980743 491.924957,299.309204 
	C492.418091,298.685944 492.552460,298.545013 493.098877,298.007812 
	C493.651337,297.486053 493.791779,297.360626 494.153687,297.061523 
	C494.537781,296.795227 494.700378,296.702606 495.135803,296.548248 
	C495.583405,296.549927 495.758148,296.613403 496.155640,296.844543 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M497.067200,356.689819 
	C495.545410,358.106049 495.701630,361.453278 492.294556,360.165558 
	C489.879578,357.656342 490.699463,354.714539 490.499908,351.968231 
	C490.107422,346.567352 491.512146,341.012238 488.992004,335.387512 
	C489.399963,332.601379 491.651123,332.079498 493.651184,330.984253 
	C495.265076,333.460449 496.399872,335.971863 499.759491,336.732178 
	C500.196411,336.950775 500.363220,336.954865 500.779907,336.971893 
	C495.276489,342.529449 498.273071,349.857727 497.067200,356.689819 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M499.695648,291.167358 
	C501.657562,292.234924 501.580353,292.395416 497.806519,294.977448 
	C497.095917,295.110291 496.737610,295.298218 496.215607,295.796448 
	C496.011200,296.026886 496.013275,295.990570 496.027191,296.002380 
	C495.820679,296.247742 495.595215,296.476349 495.185852,296.861267 
	C495.006958,297.022491 494.996704,297.000946 495.007935,297.003845 
	C494.775818,297.213928 494.544189,297.433472 494.164001,297.843262 
	C494.003754,298.021179 493.997559,297.997620 494.009277,298.000549 
	C493.776917,298.212616 493.544220,298.433746 493.161713,298.845795 
	C493.000519,299.024750 492.995453,298.996460 493.009705,298.998138 
	C492.777161,299.212280 492.541595,299.436493 492.153748,299.853638 
	C491.990265,300.034760 491.988556,299.988556 492.011658,299.989258 
	C491.710846,300.378296 491.423431,300.792023 490.843811,301.426575 
	C488.484619,302.162720 487.062653,301.213623 485.686462,299.386810 
	C485.420532,298.732849 485.232422,298.259003 485.395203,298.103027 
	C487.949310,295.655548 487.639282,292.429352 488.011475,289.012024 
	C488.470825,288.282684 488.819641,287.944641 489.588379,287.584503 
	C493.052643,288.853699 495.708832,291.349152 499.695648,291.167358 
z"/>
<path fill="#1D98D1" opacity="1.000000" stroke="none" 
	d="
M496.549286,257.092957 
	C495.875977,255.827850 495.451721,254.750534 494.956268,253.320663 
	C494.796143,252.792419 494.707214,252.616745 494.813782,252.219696 
	C497.143738,251.121902 498.028748,248.541138 500.774902,247.979980 
	C501.457062,248.226532 501.792267,248.518906 502.311584,248.945206 
	C503.982910,249.460571 503.235748,250.830521 503.782898,252.057556 
	C504.006500,253.075394 504.096588,253.722626 504.179291,254.697235 
	C503.530121,258.005981 501.144745,259.168549 498.352814,260.156616 
	C497.602814,259.122528 497.200562,258.201599 496.549286,257.092957 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M499.722229,290.790283 
	C495.973846,293.351044 492.983276,292.048279 490.368683,288.174194 
	C488.549347,286.201813 489.990631,284.824799 490.944946,283.052673 
	C492.001160,281.840607 492.906372,281.031036 494.541443,280.891785 
	C498.406982,283.233154 496.950287,287.838562 499.722229,290.790283 
z"/>
<path fill="#061426" opacity="1.000000" stroke="none" 
	d="
M497.306396,356.927185 
	C494.997589,354.603241 496.268982,351.723633 496.068634,349.051819 
	C495.943512,347.382965 497.136658,345.822144 495.745636,343.986053 
	C494.000153,341.682007 495.335876,340.034637 497.773834,339.229858 
	C498.864197,338.869843 499.999725,338.671936 500.858124,337.300720 
	C501.029785,336.984833 501.512146,336.988312 501.760345,336.998413 
	C503.707764,339.685150 500.358521,340.324615 499.844299,342.222931 
	C498.689941,346.484222 499.160004,350.741211 499.011536,355.455139 
	C498.531708,356.207520 498.047852,356.507660 497.306396,356.927185 
z"/>
<path fill="#061426" opacity="1.000000" stroke="none" 
	d="
M499.963745,336.541321 
	C496.202728,337.409912 493.022369,337.107819 493.987976,331.144104 
	C493.943756,329.825043 494.048248,329.242188 494.249084,328.367218 
	C494.394196,327.879303 494.463348,327.685944 494.654694,327.207153 
	C495.640625,325.515320 495.705170,323.600433 497.729309,322.870117 
	C500.469299,327.116211 497.670319,331.984436 499.963745,336.541321 
z"/>
<path fill="#30A0CE" opacity="1.000000" stroke="none" 
	d="
M509.746338,258.796875 
	C510.607971,261.525787 505.975311,262.243530 507.910370,265.414825 
	C508.313782,266.075928 506.668091,265.932037 505.971680,265.973938 
	C504.173431,266.082001 502.366882,266.051910 500.094757,266.107117 
	C499.625885,266.137207 499.599884,265.860962 499.672180,265.742554 
	C499.608337,264.661011 499.830017,263.739929 500.200562,262.482666 
	C500.465454,261.944641 500.603607,261.745361 501.005463,261.294098 
	C503.600739,258.896606 506.583862,258.910065 509.746338,258.796875 
z"/>
<path fill="#044166" opacity="1.000000" stroke="none" 
	d="
M495.722778,317.215851 
	C497.102936,317.061554 498.152924,317.043823 499.596619,317.022278 
	C499.814148,317.562073 499.638031,318.105621 499.220825,318.812347 
	C497.196808,320.951447 494.686371,322.113342 492.811584,324.496338 
	C489.864899,325.615479 487.268097,324.124420 484.313782,324.174561 
	C483.510345,322.532471 484.428955,321.688141 485.601532,320.618683 
	C489.168182,319.705353 491.960144,317.536255 495.722778,317.215851 
z"/>
<path fill="#020711" opacity="1.000000" stroke="none" 
	d="
M498.038940,260.358948 
	C499.877380,258.497955 501.749725,256.952515 503.896973,255.215836 
	C504.937622,255.030914 505.703369,255.037216 506.849243,255.116287 
	C506.853119,255.587524 506.476807,255.986008 506.027405,256.655792 
	C505.170227,259.178650 503.156464,260.248199 501.147888,261.750336 
	C500.845703,261.887451 500.957031,261.925995 500.921387,261.879089 
	C500.644623,262.259094 500.278870,262.467010 499.496704,262.274048 
	C498.827362,261.619354 498.450073,261.146912 498.038940,260.358948 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M492.417603,324.364075 
	C493.337219,321.295868 495.642181,319.961212 498.631348,319.002502 
	C498.683289,320.085297 498.386841,321.195007 498.057312,322.650208 
	C497.198853,324.534821 496.373444,326.073975 495.275726,327.806366 
	C493.876129,327.119873 493.454285,325.733307 492.417603,324.364075 
z"/>
<path fill="#0B1821" opacity="1.000000" stroke="none" 
	d="
M493.164124,278.101532 
	C494.097931,276.496674 493.710876,274.329773 495.723633,273.146973 
	C495.966431,274.789062 497.674133,274.652618 498.558533,275.431488 
	C500.518677,277.157776 500.175018,278.370514 497.218750,278.323242 
	C496.641144,277.459747 496.091766,277.405182 495.228821,277.819580 
	C494.997681,278.019531 494.997742,277.996246 495.008850,278.000122 
	C494.867859,278.145447 494.715820,278.286865 494.256470,278.480713 
	C493.750458,278.471924 493.551727,278.410767 493.164124,278.101532 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M493.675598,278.262207 
	C494.155731,278.043213 494.327820,278.022308 494.759888,278.002716 
	C495.011841,278.749451 495.003784,279.494873 494.945679,280.611206 
	C494.146149,281.596497 493.396667,282.210876 492.393250,282.976013 
	C491.723846,282.837433 491.448212,282.446014 491.258728,281.598389 
	C491.335846,279.840027 492.201843,279.034210 493.675598,278.262207 
z"/>
<path fill="#42A7D0" opacity="1.000000" stroke="none" 
	d="
M499.164276,262.467407 
	C499.579987,262.044373 499.955292,261.996979 500.608185,261.890869 
	C500.606049,262.844818 500.326324,263.857452 499.895538,265.247131 
	C498.729614,264.877441 499.159851,263.808228 499.164276,262.467407 
z"/>
<path fill="#1174A3" opacity="1.000000" stroke="none" 
	d="
M505.125000,293.280548 
	C506.136688,293.225586 507.220642,293.388611 506.020874,294.946960 
	C505.537262,294.584198 505.311615,294.075714 505.125000,293.280548 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M495.331970,278.058716 
	C495.534027,277.363037 495.770325,275.475739 496.991028,277.817139 
	C496.563721,278.096222 496.114990,278.097046 495.331970,278.058716 
z"/>
<path fill="#0C1929" opacity="1.000000" stroke="none" 
	d="
M504.231384,313.978333 
	C504.329102,313.545410 504.590485,312.733246 505.301849,313.602386 
	C505.034973,313.733429 504.768097,313.864471 504.231384,313.978333 
z"/>
<path fill="#0C1929" opacity="1.000000" stroke="none" 
	d="
M504.009918,314.015259 
	C503.578369,314.353577 503.131958,314.672760 502.319672,314.941956 
	C502.429779,314.597748 502.905792,314.303497 503.671692,313.985168 
	C503.961578,313.961090 503.995056,313.996124 504.009918,314.015259 
z"/>
<path fill="#061426" opacity="1.000000" stroke="none" 
	d="
M501.997437,336.996399 
	C502.341370,336.746704 502.686981,336.498901 503.045288,336.271088 
	C503.052094,336.266754 503.209229,336.498718 503.296234,336.620483 
	C503.025360,336.740082 502.754486,336.859650 502.246094,336.993866 
	C502.008545,337.008514 502.000366,337.000366 501.997437,336.996399 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M502.067871,315.015350 
	C501.960754,315.045807 501.846252,315.952667 501.805054,314.979950 
	C501.953796,314.891998 502.022217,314.982056 502.067871,315.015350 
z"/>
<path fill="#05476E" opacity="1.000000" stroke="none" 
	d="
M496.321594,295.973267 
	C496.294708,295.726196 496.578186,295.425446 497.181580,295.070007 
	C497.211670,295.316772 496.921814,295.618225 496.321594,295.973267 
z"/>
<path fill="#05476E" opacity="1.000000" stroke="none" 
	d="
M495.350098,297.055542 
	C495.190186,296.743286 495.373383,296.464050 495.798859,296.099548 
	C496.108002,296.176697 496.174896,296.339172 496.310059,296.756958 
	C496.149994,297.037720 495.921600,297.063171 495.350098,297.055542 
z"/>
<path fill="#1A6D97" opacity="1.000000" stroke="none" 
	d="
M515.146118,302.412354 
	C516.018311,297.130707 523.888245,292.540466 529.745178,293.886475 
	C529.924133,304.003967 529.841858,304.084320 519.425293,304.041504 
	C517.776794,303.586273 516.570679,303.117218 515.146118,302.412354 
z"/>
<path fill="#8FD2E7" opacity="1.000000" stroke="none" 
	d="
M389.957581,121.488251 
	C388.649963,122.093369 387.851044,122.952621 387.843079,124.887657 
	C387.248627,125.767830 386.574310,125.934036 385.509644,125.961578 
	C383.825500,125.738426 382.586914,125.244080 381.128113,124.449417 
	C380.373932,123.921127 379.908600,123.529587 379.095520,123.136230 
	C378.640778,122.952995 378.457092,122.882942 377.996765,122.709290 
	C376.787598,122.228386 375.805176,122.051277 374.512878,121.806137 
	C374.005096,121.651237 373.805206,121.572166 373.323120,121.328949 
	C371.084656,118.949173 371.735352,116.339775 372.244934,113.637680 
	C373.627869,113.272919 374.473389,113.685165 375.372253,114.758911 
	C374.918793,117.087128 374.940857,118.421814 377.857361,116.885895 
	C378.851349,116.761581 379.566162,116.843056 380.640472,116.945526 
	C383.602417,119.057800 387.333160,118.796906 389.957581,121.488251 
z"/>
<path fill="#8FD2E7" opacity="1.000000" stroke="none" 
	d="
M392.855560,122.732079 
	C392.196045,122.797401 391.320770,122.606049 390.282104,122.111664 
	C390.959076,122.030884 391.799408,122.253143 392.855560,122.732079 
z"/>
<path fill="#42A7D0" opacity="1.000000" stroke="none" 
	d="
M501.222778,261.887695 
	C502.365387,260.351776 503.885040,258.816101 505.679504,257.103760 
	C506.762238,258.236237 508.086914,257.964172 509.683838,258.047363 
	C510.063843,258.072876 510.047882,258.547943 510.040070,258.785736 
	C507.078796,259.558380 504.234161,260.413513 501.222778,261.887695 
z"/>
<path fill="#30A0CE" opacity="1.000000" stroke="none" 
	d="
M510.727478,272.712860 
	C508.305573,273.010223 505.609894,273.020447 502.466949,273.006958 
	C504.724731,271.189606 507.601929,271.999969 510.727478,272.712860 
z"/>
<path fill="#30A0CE" opacity="1.000000" stroke="none" 
	d="
M517.751465,271.715271 
	C516.595459,272.005737 515.211182,272.025665 513.411072,272.070435 
	C514.299805,270.453339 515.901123,270.877350 517.751465,271.715271 
z"/>
<path fill="#42A7D0" opacity="1.000000" stroke="none" 
	d="
M511.332245,257.972290 
	C511.067627,257.074951 511.336395,256.298981 512.725525,256.080109 
	C512.947021,256.957367 512.668518,257.723846 511.332245,257.972290 
z"/>
<path fill="#020711" opacity="1.000000" stroke="none" 
	d="
M503.937805,251.989532 
	C502.945251,251.825851 502.779144,250.823853 502.558105,249.448608 
	C502.738434,249.047638 502.981171,249.016174 503.589844,248.955322 
	C503.956940,249.800919 503.958069,250.675903 503.937805,251.989532 
z"/>
<path fill="#30A0CE" opacity="1.000000" stroke="none" 
	d="
M518.528809,249.550690 
	C518.476379,249.581390 518.581177,249.519989 518.528809,249.550690 
z"/>
<path fill="#1D1B1E" opacity="1.000000" stroke="none" 
	d="
M328.978699,99.152740 
	C328.863373,98.176544 327.528809,98.211258 327.972626,97.209450 
	C328.080017,96.967163 328.829865,97.009514 329.558746,96.927551 
	C330.966949,97.537064 333.162933,95.680054 333.272614,98.854599 
	C333.377563,101.892288 333.882690,105.221916 337.365417,106.592392 
	C341.088531,108.057480 342.926575,104.886559 345.655396,103.054108 
	C346.096741,107.646309 349.734863,106.273697 351.741547,105.712143 
	C354.988892,104.803398 357.664062,105.099030 359.904236,107.382797 
	C362.565521,110.095810 366.102020,107.732513 368.950195,109.626610 
	C368.424347,111.038048 367.294037,111.510971 366.123932,112.460587 
	C364.921112,113.023476 363.982605,113.083473 362.680847,112.961716 
	C359.560242,112.556152 356.801331,110.965363 353.764099,113.050446 
	C353.032654,113.777771 352.457153,114.128517 351.448730,114.334099 
	C349.702545,113.700691 348.239410,113.212563 346.449280,112.668884 
	C345.817108,112.244537 345.562805,111.908142 345.426025,111.188362 
	C345.563965,110.513306 345.483795,110.300323 345.191223,110.247414 
	C345.105591,110.231934 345.049744,110.247688 345.024567,110.289116 
	C344.678558,110.858963 344.885162,110.105301 345.202637,110.858574 
	C344.715149,111.466515 344.330353,111.709335 343.552429,112.002647 
	C333.136383,112.758713 329.548737,110.829544 326.355469,102.715759 
	C326.316528,100.642899 327.519531,99.991043 328.978699,99.152740 
z"/>
<path fill="#7AAABF" opacity="1.000000" stroke="none" 
	d="
M375.859741,114.979233 
	C374.586884,114.764526 373.631042,114.434929 372.302612,114.097534 
	C371.308563,114.606377 370.677979,114.521713 369.835724,113.843338 
	C369.404602,112.877640 369.513702,112.224976 370.060608,111.335403 
	C370.630402,110.816666 371.015228,110.601608 371.653992,110.198044 
	C372.224731,109.843620 372.568024,109.725693 373.174377,109.529694 
	C373.622772,109.453888 373.808136,109.456154 374.170959,109.660126 
	C374.401123,110.027725 374.453796,110.193619 374.503418,110.605316 
	C374.500427,110.851128 374.519958,111.294571 374.755585,111.250809 
	C375.509796,111.135735 376.011078,111.193466 376.726013,111.537888 
	C376.995453,112.805664 377.407928,114.036545 375.859741,114.979233 
z"/>
<path fill="#202731" opacity="1.000000" stroke="none" 
	d="
M371.523285,109.953461 
	C371.707916,110.236031 371.534393,110.510521 371.126373,110.879463 
	C369.566376,111.830727 368.338226,112.982788 366.240356,112.145172 
	C366.099365,110.454185 367.004608,109.967529 368.666931,109.980194 
	C369.731903,109.957657 370.448486,109.951515 371.523285,109.953461 
z"/>
<path fill="#32627C" opacity="1.000000" stroke="none" 
	d="
M375.674805,107.838135 
	C376.191528,108.296875 376.176697,108.578514 375.725922,108.948746 
	C375.206879,109.218422 374.892944,109.387398 374.191895,109.187332 
	C374.327881,108.436600 374.850983,108.054886 375.674805,107.838135 
z"/>
<path fill="#7AAABF" opacity="1.000000" stroke="none" 
	d="
M373.685547,108.960762 
	C374.089539,108.864716 374.374268,108.911095 375.089905,109.003464 
	C375.438385,109.199738 375.355927,109.350006 375.233551,109.754272 
	C375.047882,110.120117 374.902130,110.231964 374.488647,110.278305 
	C374.088196,110.089127 373.955444,109.965454 373.630066,109.646706 
	C373.437439,109.451630 373.566284,109.103195 373.685547,108.960762 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M303.560669,105.557938 
	C304.100830,105.591301 304.278503,105.708122 304.733826,105.981987 
	C300.810272,111.430725 294.956543,113.863899 288.330750,115.433784 
	C287.603149,114.921066 287.359467,114.480072 287.213806,113.585167 
	C287.343903,111.596649 288.291595,110.381569 289.448120,108.861778 
	C291.092285,107.459595 292.696503,106.753227 294.720154,106.058510 
	C296.806702,105.705467 298.533997,105.544876 300.637115,105.895966 
	C301.733765,105.858559 302.465973,105.749977 303.560669,105.557938 
z"/>
<path fill="#29648A" opacity="1.000000" stroke="none" 
	d="
M270.350098,112.203476 
	C270.042847,109.599236 268.304688,109.925674 266.389526,109.900345 
	C266.000885,109.884026 266.033875,109.452538 266.028412,109.236435 
	C266.022949,109.020332 266.071014,108.566971 266.086853,108.339569 
	C266.717346,107.239960 267.691376,107.635521 268.780029,107.272942 
	C272.737885,104.595451 276.503448,108.378189 280.621460,106.870422 
	C281.774231,106.779747 282.498627,106.768860 283.577148,106.675491 
	C284.160187,106.571556 284.389130,106.550102 284.894470,106.737396 
	C285.441559,108.008408 284.744080,108.686592 283.955017,109.682953 
	C283.543457,110.096863 283.365784,110.249039 282.879456,110.567192 
	C279.161804,111.951927 275.179199,109.526123 271.682068,112.459167 
	C271.101074,112.489380 270.867523,112.452682 270.350098,112.203476 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M300.938965,105.586136 
	C299.428925,107.629791 297.412292,106.890884 295.124084,106.953064 
	C294.231567,106.204475 294.274475,105.357048 294.064514,104.254608 
	C294.289764,103.374306 294.543640,102.764496 294.892456,102.214928 
	C295.778778,100.818459 296.725098,99.048538 298.532928,99.279961 
	C300.938934,99.587944 299.431915,102.043137 300.174866,103.362099 
	C300.493866,103.928474 300.647552,104.587959 300.938965,105.586136 
z"/>
<path fill="#45BEEC" opacity="1.000000" stroke="none" 
	d="
M293.991455,103.980186 
	C296.123840,104.045868 295.396027,105.258934 294.819885,106.647987 
	C293.329346,107.604050 291.958405,108.277489 290.260315,109.026939 
	C288.006256,110.573181 285.967468,110.613228 283.490601,109.281967 
	C283.655029,108.485344 284.173492,107.986237 284.889709,107.287231 
	C285.596375,106.188904 286.460693,106.072281 287.698120,106.058792 
	C288.453278,105.995369 288.878418,105.923584 289.613953,105.760910 
	C290.472839,105.562714 291.034424,105.526176 291.769409,105.165985 
	C291.965820,104.967010 292.452393,104.872711 292.673553,104.760895 
	C293.104706,104.595894 293.314728,104.542702 293.734741,104.241562 
	C293.944794,103.993599 293.990265,104.003685 293.991455,103.980186 
z"/>
<path fill="#272930" opacity="1.000000" stroke="none" 
	d="
M287.831390,105.795532 
	C287.635498,107.217316 286.606964,106.934471 285.426147,107.079391 
	C284.898712,106.996101 284.709930,106.904854 284.226166,106.703308 
	C284.685791,104.574188 286.080750,104.773781 287.831390,105.795532 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M291.678223,104.916733 
	C291.479065,105.250031 290.992310,105.533051 290.214935,105.743042 
	C290.413086,105.402153 290.901855,105.134300 291.678223,104.916733 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M293.716797,103.996147 
	C293.957672,104.389717 293.772064,104.636536 293.141327,104.691559 
	C292.975159,104.324860 293.173187,104.108063 293.716797,103.996147 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M268.717224,107.083084 
	C268.496094,107.922043 267.641846,108.031326 266.427979,108.084427 
	C266.494293,106.978699 267.455261,107.065475 268.717224,107.083084 
z"/>
<path fill="#05476E" opacity="1.000000" stroke="none" 
	d="
M269.085022,97.101212 
	C268.929810,97.322983 268.594818,98.013351 268.702301,96.967583 
	C268.842712,96.862679 269.007324,97.018654 269.085022,97.101212 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M480.010681,196.931351 
	C480.851837,197.129059 481.726868,197.291977 481.959778,198.675476 
	C479.858887,201.833710 480.368866,205.996765 477.154175,208.697876 
	C476.994537,209.016479 476.510620,209.012894 476.268982,209.016266 
	C476.456635,207.098022 474.798340,206.098785 474.049194,204.326248 
	C473.853516,203.812805 473.715210,203.645569 473.795868,203.237473 
	C474.014801,202.996613 473.996765,202.996674 473.996582,203.005707 
	C474.223633,202.789017 474.450348,202.562775 474.846008,202.165756 
	C475.015442,201.995483 474.996338,201.997513 474.998230,202.006836 
	C475.468872,201.417389 475.828674,200.716919 476.769409,200.167694 
	C476.988037,199.980789 477.001221,199.999146 476.992737,199.993073 
	C477.225189,199.784851 477.453583,199.569397 477.825684,199.164307 
	C477.981964,198.987976 477.999298,198.999390 477.993652,198.990692 
	C478.229279,198.780762 478.457611,198.565781 478.829346,198.161163 
	C478.985657,197.985275 479.000000,198.000000 478.992737,197.992813 
	C479.223602,197.777161 479.457428,197.564011 479.839233,197.164185 
	C479.991486,196.982178 480.004822,196.948914 480.010681,196.931351 
z"/>
<path fill="#AEF6FB" opacity="1.000000" stroke="none" 
	d="
M485.699066,217.006866 
	C485.537628,217.332977 485.066467,217.658951 484.301941,217.995819 
	C484.468842,217.673370 484.929108,217.340042 485.699066,217.006866 
z"/>
<path fill="#55CFFB" opacity="1.000000" stroke="none" 
	d="
M485.768646,228.862579 
	C485.800415,229.029053 485.412292,229.005081 485.218750,228.991135 
	C485.262421,228.883499 485.499634,228.789795 485.768646,228.862579 
z"/>
<path fill="#AEF6FB" opacity="1.000000" stroke="none" 
	d="
M488.032715,215.038925 
	C487.996887,215.417297 487.816101,215.687668 487.230774,215.916672 
	C487.017670,215.611526 487.202362,215.346436 487.726501,215.060425 
	C487.952728,214.960602 488.007721,215.011154 488.032715,215.038925 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M477.067932,212.078369 
	C476.928406,212.302124 476.695007,213.044281 476.749207,212.007477 
	C476.909088,211.922180 477.017242,212.024063 477.067932,212.078369 
z"/>
<path fill="#AEF6FB" opacity="1.000000" stroke="none" 
	d="
M487.023499,216.030182 
	C486.959442,216.393036 486.767242,216.651718 486.239807,216.919952 
	C486.008789,217.007004 485.999817,216.999786 485.995728,216.994751 
	C486.030151,216.635269 486.198212,216.359894 486.721039,216.059570 
	C486.946228,215.955521 486.999573,216.003464 487.023499,216.030182 
z"/>
<path fill="#AEF6FB" opacity="1.000000" stroke="none" 
	d="
M483.996033,217.995087 
	C483.892822,218.031296 483.793457,218.072220 483.851318,218.059921 
	C484.008606,218.006699 483.999847,217.999786 483.996033,217.995087 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M482.525635,203.544678 
	C482.471161,203.576141 482.580109,203.513199 482.525635,203.544678 
z"/>
<path fill="#17283A" opacity="1.000000" stroke="none" 
	d="
M374.197205,110.433472 
	C374.220947,110.212799 374.706299,110.106880 374.949982,110.057571 
	C375.708405,110.045914 376.223114,110.083565 377.113647,110.239716 
	C377.349487,110.643646 377.199982,110.923988 377.000824,111.433342 
	C376.209625,111.789932 375.458557,111.912430 374.329742,112.082489 
	C373.826324,111.947273 373.700592,111.764503 373.777252,111.317596 
	C373.979614,111.053459 374.173492,110.654152 374.197205,110.433472 
z"/>
<path fill="#8FD2E7" opacity="1.000000" stroke="none" 
	d="
M494.212646,248.838837 
	C493.550201,248.306412 493.212219,247.634842 492.832703,246.686691 
	C493.578308,245.460083 494.365479,244.510056 495.468658,243.178604 
	C496.387543,245.579178 495.500458,247.145462 494.212646,248.838837 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M494.785034,251.901306 
	C495.009247,251.998291 495.006653,252.490952 494.945862,252.729523 
	C494.655273,252.701019 494.425476,252.433929 494.149353,251.900116 
	C494.103027,251.633377 494.560791,251.804337 494.785034,251.901306 
z"/>
<path fill="#8FD2E7" opacity="1.000000" stroke="none" 
	d="
M495.339783,231.012451 
	C495.041138,229.513626 495.938721,228.978775 497.650940,228.986023 
	C497.628082,230.156372 496.789307,230.751984 495.339783,231.012451 
z"/>
<path fill="#8FD2E7" opacity="1.000000" stroke="none" 
	d="
M498.347290,228.993500 
	C497.977783,228.028458 498.348450,227.329178 499.681885,227.044525 
	C500.092316,228.032227 499.677338,228.703720 498.347290,228.993500 
z"/>
<path fill="#8FD2E7" opacity="1.000000" stroke="none" 
	d="
M488.819611,237.047134 
	C488.398895,236.905121 488.069733,236.364426 487.657074,235.510788 
	C487.810059,235.150223 488.046509,235.102615 488.644531,235.039795 
	C488.974426,235.565872 488.942780,236.107162 488.819611,237.047134 
z"/>
<path fill="#8FD2E7" opacity="1.000000" stroke="none" 
	d="
M489.329041,235.036728 
	C489.483337,234.671158 489.943817,234.335175 490.708160,234.005951 
	C490.553101,234.363907 490.094177,234.715118 489.329041,235.036728 
z"/>
<path fill="#8FD2E7" opacity="1.000000" stroke="none" 
	d="
M492.318054,233.026123 
	C492.475220,232.671234 492.937073,232.329330 493.706848,231.998291 
	C493.550720,232.352478 493.086731,232.695801 492.318054,233.026123 
z"/>
<path fill="#8FD2E7" opacity="1.000000" stroke="none" 
	d="
M494.247803,231.936584 
	C494.175964,231.733154 494.347382,231.449997 494.764404,231.090347 
	C494.837067,231.294861 494.664032,231.575882 494.247803,231.936584 
z"/>
<path fill="#8FD2E7" opacity="1.000000" stroke="none" 
	d="
M491.256104,233.941223 
	C491.180084,233.732742 491.351044,233.451370 491.765503,233.092651 
	C491.840363,233.299652 491.671722,233.584000 491.256104,233.941223 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M498.314758,219.967773 
	C498.021912,219.064407 498.325684,218.309937 499.681702,218.032959 
	C499.972229,218.945648 499.616821,219.658768 498.314758,219.967773 
z"/>
<path fill="#69E3FB" opacity="1.000000" stroke="none" 
	d="
M489.323639,226.987549 
	C489.482635,226.667191 489.936432,226.343811 490.686035,226.020126 
	C490.527405,226.341400 490.072937,226.662964 489.323639,226.987549 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M494.293762,223.004242 
	C494.462555,222.675797 494.934998,222.338516 495.715546,221.995514 
	C495.548218,222.324982 495.072815,222.660187 494.293762,223.004242 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M502.337097,216.025726 
	C502.403809,215.681488 502.797119,215.362289 503.457458,214.995514 
	C503.808289,215.103500 503.892029,215.259018 503.972260,215.678818 
	C503.533722,215.978973 503.098663,216.014862 502.337097,216.025726 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M497.219788,220.913666 
	C497.170166,220.736298 497.351471,220.455780 497.772583,220.083923 
	C497.825195,220.265228 497.637970,220.537872 497.219788,220.913666 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M496.211731,221.911163 
	C496.168182,221.740112 496.352173,221.458557 496.776398,221.082947 
	C496.824158,221.259491 496.631683,221.530090 496.211731,221.911163 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M493.227600,223.922958 
	C493.174377,223.740997 493.359406,223.464401 493.779602,223.089844 
	C493.831818,223.270706 493.648865,223.549515 493.227600,223.922958 
z"/>
<path fill="#69E3FB" opacity="1.000000" stroke="none" 
	d="
M492.248596,224.893539 
	C492.084900,224.647583 492.255005,224.386841 492.759949,224.112900 
	C492.922424,224.358963 492.751617,224.618637 492.248596,224.893539 
z"/>
<path fill="#69E3FB" opacity="1.000000" stroke="none" 
	d="
M491.244873,225.894958 
	C491.079407,225.648285 491.249115,225.385880 491.757233,225.112228 
	C491.916382,225.357269 491.744507,225.616699 491.244873,225.894958 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M501.247833,216.925232 
	C501.068268,216.656570 501.244324,216.385300 501.766449,216.099365 
	C501.828125,216.289566 501.658447,216.568878 501.247833,216.925232 
z"/>
<path fill="#85EBFA" opacity="1.000000" stroke="none" 
	d="
M500.241272,217.924164 
	C500.179657,217.733871 500.357330,217.460526 500.768585,217.097046 
	C500.828308,217.284973 500.654419,217.563049 500.241272,217.924164 
z"/>
<path fill="#8FD2E7" opacity="1.000000" stroke="none" 
	d="
M287.734985,115.176422 
	C293.963104,113.076500 299.056854,109.423332 304.814026,106.407471 
	C305.391449,106.059441 305.771423,105.979851 306.442017,105.896698 
	C308.605011,105.503662 310.464203,104.928192 312.706238,105.756149 
	C313.563843,108.349274 311.618073,108.770935 310.233978,109.407875 
	C307.083832,110.857529 304.063324,112.581573 300.491119,113.969238 
	C299.847351,114.186050 299.513336,114.211014 299.226898,114.336548 
	C298.562500,114.627686 296.445923,114.011948 297.988068,116.175308 
	C291.061798,118.732491 285.534851,123.208626 279.079254,126.697586 
	C277.656738,127.814224 276.310516,128.102325 274.561249,128.194458 
	C274.006897,128.218903 273.786682,128.224319 273.239349,128.231995 
	C272.695740,128.226944 272.479248,128.219620 271.624054,128.113907 
	C270.254272,128.054764 269.523193,128.094025 268.428711,128.178970 
	C267.671967,127.773926 267.518433,127.252579 267.872559,126.331528 
	C269.309601,125.496689 270.478577,124.990974 271.852142,124.242767 
	C274.555084,120.714493 278.689972,119.978020 282.149170,117.554535 
	C284.123474,116.702965 285.649689,115.691887 287.734985,115.176422 
z"/>
<path fill="#72C2DC" opacity="1.000000" stroke="none" 
	d="
M313.262573,107.028839 
	C311.352234,105.354057 309.373444,106.223808 307.150879,105.930107 
	C311.780731,102.841354 318.032990,103.702827 323.526245,100.818146 
	C324.437683,100.645004 324.858002,100.805984 325.235443,101.601997 
	C324.674469,103.528687 323.262604,104.119804 321.575928,104.937164 
	C318.675659,105.810165 316.403442,107.555840 313.262573,107.028839 
z"/>
<path fill="#7AAABF" opacity="1.000000" stroke="none" 
	d="
M325.210999,102.035210 
	C324.745178,101.594002 324.536713,101.334419 324.120117,100.933533 
	C325.405701,100.189308 326.899414,99.586388 328.743713,98.912628 
	C330.391541,100.876556 327.781494,100.050728 327.282227,101.111923 
	C326.546173,101.649635 326.173553,102.203979 325.210999,102.035210 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M518.629456,385.754883 
	C517.237732,391.084961 515.541809,396.179779 513.694458,401.641632 
	C513.073303,402.466156 512.633240,402.959808 512.128662,403.374939 
	C509.974487,405.147461 510.931396,409.486938 507.532867,409.871674 
	C503.011597,410.383514 498.364502,410.745178 493.477814,409.132751 
	C491.569519,406.902191 492.643158,404.992859 493.950928,402.822510 
	C497.610321,400.794128 501.952820,402.708557 505.361176,399.575195 
	C503.270660,397.696594 496.792419,400.622406 499.408447,393.946045 
	C503.139435,391.925812 505.972015,389.144684 509.816925,387.254395 
	C512.822021,386.270111 515.408997,385.039429 518.629456,385.754883 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M495.273987,402.760864 
	C493.576111,404.489716 493.908234,406.632385 493.059937,408.698669 
	C492.723785,410.133820 492.377625,411.195831 491.917511,412.576416 
	C487.160767,413.620514 485.814453,412.498016 486.735504,408.246277 
	C487.588257,404.309784 488.627319,400.411835 489.603516,396.504913 
	C488.157898,401.473328 487.617493,406.677887 484.973877,411.477417 
	C482.785858,411.173096 482.108429,409.799591 481.574768,407.886230 
	C483.366486,403.339935 484.804413,399.046844 485.215271,394.130127 
	C485.210175,393.575470 485.202179,393.353729 485.193970,392.798889 
	C485.272614,390.865509 486.069824,389.518494 486.873016,387.823364 
	C487.339966,386.934692 487.712158,386.376617 488.247498,385.517944 
	C489.648621,383.522278 490.191254,381.402069 492.027100,379.703125 
	C492.604401,379.517731 492.853424,379.501129 493.461914,379.603088 
	C496.736511,382.794800 495.916046,386.951660 497.009033,390.932861 
	C494.993256,394.817352 497.555298,398.975433 495.273987,402.760864 
z"/>
<path fill="#044371" opacity="1.000000" stroke="none" 
	d="
M483.861816,411.132874 
	C486.672577,410.666534 485.742767,408.515686 486.128601,407.086517 
	C487.197784,403.125885 488.235382,399.156799 489.637756,393.860565 
	C490.571747,399.388000 488.762604,403.288879 487.638123,407.046600 
	C486.489288,410.885803 487.716064,412.218170 491.444641,412.858887 
	C491.466766,413.793518 491.129913,414.692047 490.601654,415.794739 
	C489.165070,415.766144 487.919922,415.533386 486.330933,415.141785 
	C485.852020,414.845825 485.716858,414.708710 485.354919,414.390228 
	C484.427185,413.806030 483.868134,413.272125 483.520538,412.210815 
	C483.534912,411.720001 483.586792,411.526764 483.861816,411.132874 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M519.125305,385.664917 
	C516.218140,386.656250 513.502686,387.322388 510.397034,387.999451 
	C508.421417,387.039764 507.867676,385.304840 506.808838,383.573639 
	C504.772186,381.184113 502.752289,385.117126 500.610168,382.920807 
	C499.726562,381.234802 499.790436,379.824890 500.626953,378.117432 
	C501.195129,377.488464 501.605774,377.252930 502.049164,377.054474 
	C502.361603,376.914642 502.783173,377.097778 503.006500,376.720306 
	C502.694336,376.650665 502.390869,376.549744 501.838257,376.156342 
	C501.150116,374.913391 501.171539,373.990021 502.291687,373.067413 
	C508.521149,367.712708 515.691528,367.760345 523.358032,368.020996 
	C523.709045,368.878906 523.614258,369.729523 523.277832,370.801758 
	C519.146423,374.294617 514.129761,373.624542 510.113403,374.504517 
	C513.687378,374.630127 517.155945,376.949219 521.321106,377.648193 
	C520.837708,380.391235 520.077332,382.865479 519.125305,385.664917 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M521.752930,377.626282 
	C516.726379,379.133270 512.916138,376.500793 508.919617,374.338409 
	C513.173035,372.511383 517.778687,372.095001 522.628540,371.031219 
	C523.425720,373.264282 522.113831,375.201080 521.752930,377.626282 
z"/>
<path fill="#071A2D" opacity="1.000000" stroke="none" 
	d="
M502.734741,372.546265 
	C502.448517,373.782227 502.247406,374.592010 502.072754,375.730743 
	C502.418243,376.527496 502.487213,377.029816 501.964386,377.770691 
	C500.610840,379.219971 501.089020,380.739746 500.850525,382.491089 
	C501.195587,383.083038 501.440247,383.397461 501.612244,384.091797 
	C501.581696,384.602570 501.536072,384.804443 501.357910,385.287109 
	C501.010254,385.923615 500.789581,386.275818 500.412842,386.900513 
	C499.346985,388.656067 499.321625,390.484009 498.133850,392.174377 
	C497.439972,392.539551 496.997345,392.551941 496.277679,392.242767 
	C495.197815,388.196106 494.389984,384.355347 493.307678,380.256653 
	C492.501434,376.494293 496.448975,373.913147 495.141418,369.897491 
	C495.341949,369.362488 495.448090,369.159241 495.784485,368.702362 
	C496.917847,367.677673 498.072052,367.324677 499.253448,366.601837 
	C497.998932,366.793304 497.154205,366.548401 496.702881,365.219849 
	C497.306122,359.565613 498.599365,358.518250 504.643066,358.908325 
	C504.240326,363.420044 503.530090,367.770081 502.734741,372.546265 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M272.589417,503.183228 
	C272.199432,502.453644 272.133636,501.670105 272.082672,500.494385 
	C271.961060,499.353943 271.843719,498.602905 271.682495,497.577515 
	C271.367065,496.713013 270.892090,496.454590 269.962494,496.351166 
	C268.210327,496.222717 266.752228,496.280060 265.142059,495.267212 
	C264.017303,494.252075 263.694000,493.249603 263.673218,491.741638 
	C267.219971,488.664246 271.458618,489.271545 275.405060,488.659149 
	C277.312744,488.363098 279.368286,488.988800 281.484589,487.509644 
	C284.025513,486.480286 286.254456,486.564301 288.891418,487.025574 
	C289.785980,487.402618 290.171204,487.769409 290.510437,488.643921 
	C290.548737,489.272156 290.510956,489.519592 290.289032,490.082855 
	C288.747528,491.733215 286.991730,491.982483 285.220917,492.201416 
	C283.615814,492.399902 282.259949,492.809296 283.242096,495.206970 
	C283.932251,496.445557 284.399597,497.438416 285.207764,498.628662 
	C285.423096,499.153748 285.474609,499.378784 285.515961,499.952972 
	C285.195251,501.702240 284.806580,503.058777 283.160645,504.009155 
	C281.751465,503.671448 280.491608,503.451385 279.643707,502.740173 
	C277.192810,500.684357 275.038300,500.951752 272.589417,503.183228 
z"/>
<path fill="#14A4F1" opacity="1.000000" stroke="none" 
	d="
M294.020874,519.977966 
	C292.635284,520.279663 291.739746,519.633118 290.646515,518.772583 
	C289.083923,517.542725 287.294769,517.250000 287.121399,520.558350 
	C284.323425,520.781921 284.935577,518.179138 284.065735,516.245789 
	C284.415802,515.618713 284.853882,515.316833 284.682922,514.832581 
	C284.495453,514.301636 284.013763,514.403015 283.343811,514.790527 
	C277.805481,515.566101 280.416260,519.540344 279.998962,522.609131 
	C277.269348,522.633179 278.211578,520.483215 278.002197,518.508911 
	C277.638550,517.685974 277.492889,517.185547 277.787598,516.279907 
	C279.792969,513.009460 278.633545,508.340790 283.606628,507.034302 
	C285.179230,507.573944 285.714203,508.886871 287.071228,509.773682 
	C287.511566,510.075684 287.684723,510.200928 288.094849,510.541870 
	C288.598572,511.087433 288.845215,511.431549 289.236938,512.056152 
	C289.518280,512.494263 289.630524,512.669067 289.917877,513.099304 
	C290.539093,514.079712 291.180756,514.580750 292.209198,515.121765 
	C292.847504,515.539917 293.165710,515.838684 293.619720,516.464478 
	C294.163696,517.582642 294.388336,518.444519 294.179596,519.666992 
	C294.029510,519.969482 294.019806,519.979553 294.020874,519.977966 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M282.975647,504.317627 
	C283.303528,502.911316 283.783936,501.706787 284.441467,500.232544 
	C284.867157,499.748810 285.243500,499.683105 285.437164,499.475769 
	C285.888580,498.992371 285.541870,498.391876 285.544739,499.058533 
	C285.547607,499.725189 284.586426,498.699188 284.858154,499.115906 
	C283.328247,498.890930 283.011627,497.952759 282.884766,496.537231 
	C284.291992,493.463196 288.605011,494.186096 289.739014,490.501404 
	C289.979675,490.249969 289.965454,490.101227 289.970032,490.026672 
	C291.059082,489.157410 292.013885,489.533722 293.174561,490.597900 
	C293.695801,495.094574 293.521545,499.227722 292.090210,503.621399 
	C291.995178,504.748169 292.003510,505.499542 292.006287,506.626770 
	C291.224609,507.807526 290.260071,508.019287 288.829712,507.802551 
	C287.394440,507.218903 286.512299,506.374939 286.278778,505.303589 
	C285.747131,502.864288 285.150604,505.512634 284.300537,505.144043 
	C283.686127,504.889404 283.407135,504.704376 282.975647,504.317627 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M283.973816,505.310181 
	C286.342468,502.382538 287.171539,504.249054 287.947693,506.734009 
	C288.843170,508.046417 289.042084,509.143494 288.252991,510.692322 
	C285.490387,511.299225 284.604584,509.706116 284.018005,507.349487 
	C283.972565,506.990845 283.998108,506.993378 283.994476,506.984528 
	C284.127655,506.816254 284.264496,506.656830 284.196930,506.257507 
	C283.992523,506.017609 283.982513,505.545898 283.973816,505.310181 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M278.519287,531.397644 
	C278.273529,530.574402 278.557343,530.284546 279.194489,530.417603 
	C279.327423,530.445435 279.504425,530.628174 279.526031,530.761475 
	C279.629486,531.400391 279.330383,531.676270 278.519287,531.397644 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M277.750610,516.082764 
	C278.015320,516.423279 278.023193,516.907715 278.018280,517.756958 
	C277.241089,517.650452 276.872711,517.072083 277.750610,516.082764 
z"/>
<path fill="#14A4F1" opacity="1.000000" stroke="none" 
	d="
M283.992828,506.257141 
	C284.322266,506.192566 284.716278,506.340363 284.160645,506.896606 
	C283.990845,506.975677 283.993134,506.496643 283.992828,506.257141 
z"/>
<path fill="#0D89D9" opacity="1.000000" stroke="none" 
	d="
M274.443054,508.531494 
	C274.408875,508.476166 274.477264,508.586823 274.443054,508.531494 
z"/>
<path fill="#0F62A1" opacity="1.000000" stroke="none" 
	d="
M283.304810,515.063354 
	C283.323578,514.029541 282.349030,512.258789 284.051208,512.373413 
	C285.651245,512.481140 286.942169,513.904419 286.742615,515.734253 
	C286.566528,517.349121 285.466705,516.578125 284.341431,516.026062 
	C283.949890,515.575378 283.771149,515.336975 283.304810,515.063354 
z"/>
<path fill="#0B5794" opacity="1.000000" stroke="none" 
	d="
M294.308167,520.087463 
	C293.681854,519.187378 293.334229,518.405212 292.984680,517.298706 
	C293.633545,515.776672 294.488281,515.375549 295.916260,516.514282 
	C296.506744,517.304016 296.830261,517.875488 296.905487,518.876953 
	C296.933441,519.890015 296.966156,520.575012 296.998322,521.602417 
	C296.194122,521.364990 295.390442,520.785217 294.308167,520.087463 
z"/>
<path fill="#14A4F1" opacity="1.000000" stroke="none" 
	d="
M297.177887,519.144958 
	C296.574310,518.684021 296.247925,518.163086 295.853210,517.333984 
	C295.987061,516.868225 296.189270,516.710632 296.732025,516.731689 
	C297.397369,517.403381 297.722168,517.896362 298.031616,518.695557 
	C297.829132,519.029480 297.642090,519.057190 297.177887,519.144958 
z"/>
<path fill="#151215" opacity="1.000000" stroke="none" 
	d="
M133.111557,268.406250 
	C129.789200,266.490356 126.781174,264.327850 123.464828,262.029297 
	C121.658951,261.549316 120.387787,260.680939 118.714973,259.973236 
	C118.096703,259.671936 117.773705,259.468872 117.293358,259.053925 
	C117.112106,258.879059 116.870697,258.478638 116.807503,258.271973 
	C116.744308,258.065338 116.346390,257.953156 116.544800,257.888428 
	C116.743202,257.823669 116.540169,258.207153 116.562668,258.436096 
	C116.585175,258.665009 116.482430,259.134369 116.394516,259.364990 
	C116.168404,259.903595 116.024666,260.208984 115.767296,260.749695 
	C115.512581,261.306671 115.379288,261.631226 115.195374,262.222107 
	C115.028992,263.020813 114.935226,263.560059 114.795364,264.380219 
	C114.690834,264.845337 114.640549,265.030945 114.507629,265.495117 
	C114.123619,266.733612 114.059456,267.730499 113.914986,269.043884 
	C113.803284,269.579468 113.742264,269.793884 113.544571,270.321381 
	C112.937431,271.474243 112.334068,272.186096 111.127335,272.779724 
	C109.801598,273.160645 108.826797,273.113098 107.525162,272.671021 
	C106.814438,272.190125 106.540642,271.798859 106.347763,270.968475 
	C106.329887,270.147430 106.384491,269.685272 106.533218,268.897949 
	C106.656532,267.532104 106.988304,266.442902 105.717484,265.442719 
	C104.160683,264.616211 102.901154,263.947845 102.227440,262.151672 
	C102.197548,259.969543 102.896149,258.316132 103.684082,256.312286 
	C107.864525,241.079971 112.963547,226.583313 119.640480,212.648178 
	C120.122696,211.641769 122.102951,210.198105 119.334274,208.955856 
	C118.985985,208.933960 119.007278,208.476059 119.011597,208.247192 
	C119.559319,207.928024 120.102730,207.837723 120.828033,207.532669 
	C121.164932,207.099533 121.319946,206.881149 121.817093,206.873260 
	C126.862267,201.671219 128.334045,194.545853 132.002792,188.193298 
	C132.393921,187.775269 132.677734,187.904419 132.984756,188.426758 
	C133.192490,189.029739 133.375961,189.367554 133.900574,189.805359 
	C134.152115,189.955505 134.061096,189.903778 134.095993,189.864746 
	C137.517700,195.305176 141.115387,200.641937 145.081482,205.719421 
	C146.302170,207.282181 147.799240,208.651978 147.895218,211.205719 
	C145.555344,217.546188 144.429367,223.922653 141.392456,229.639389 
	C139.358429,233.468277 138.392456,237.695374 137.537857,241.918106 
	C137.010742,244.522644 136.456650,247.127838 135.392441,249.552429 
	C133.220795,254.500076 131.502426,259.415314 133.894958,264.823151 
	C134.359741,265.873718 134.074982,267.114349 133.111557,268.406250 
z"/>
<path fill="#0A4271" opacity="1.000000" stroke="none" 
	d="
M122.016693,206.906967 
	C121.966614,207.115921 121.774002,207.148087 121.295654,207.249084 
	C121.150078,206.904480 121.193680,206.349091 122.016693,206.906967 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M147.153152,211.321564 
	C143.594299,206.064896 140.104874,201.186493 136.808960,196.180679 
	C135.677795,194.462646 133.868729,192.989548 134.087143,190.209152 
	C134.897171,190.460175 135.663437,191.094635 136.694489,191.870453 
	C143.744675,198.628326 150.530106,205.244827 157.639008,211.970612 
	C158.889435,213.073349 159.816376,214.066788 161.000458,215.206436 
	C177.179184,232.419403 194.565826,248.005280 211.262253,264.794708 
	C211.570328,265.240601 211.611450,265.450439 211.961105,265.748016 
	C212.269623,265.835754 212.127075,265.837128 212.154678,265.771423 
	C212.993866,267.097961 214.546005,267.703522 215.814911,269.103302 
	C216.223541,269.491638 216.375061,269.659729 216.722137,270.104797 
	C217.169556,270.759521 217.432693,271.129211 217.913727,271.765869 
	C230.151108,287.676300 243.061981,302.603424 255.439072,318.412292 
	C264.777710,330.364227 273.320984,342.469788 282.357788,354.648621 
	C282.599304,355.459503 282.586700,355.936768 282.276764,356.718140 
	C278.938232,358.428406 277.101379,356.143707 275.238892,354.403381 
	C265.762238,345.548035 255.326462,337.919037 244.547974,330.171509 
	C243.390488,329.324493 242.623810,328.540253 241.527039,327.659485 
	C240.945099,327.223297 240.661957,326.931335 240.258621,326.346313 
	C239.817902,325.822937 239.551193,325.541931 239.063110,325.086487 
	C238.599442,324.690216 238.315552,324.552612 237.984192,324.522308 
	C237.996048,325.188873 237.735001,324.477692 238.619873,324.749329 
	C239.134552,325.147980 239.406830,325.405426 239.864899,325.884979 
	C240.428833,326.548706 240.571182,327.154358 241.298279,327.703918 
	C242.279404,328.320557 242.863434,328.932953 243.724289,329.734619 
	C251.221848,334.750092 256.623016,341.598450 263.083588,347.283600 
	C271.406677,354.607758 279.951111,361.671906 288.483215,369.295288 
	C289.912567,371.352203 291.631317,372.897217 291.270966,375.655823 
	C288.737488,377.420563 287.451660,375.407379 285.959320,374.300018 
	C277.471680,368.001953 268.970947,361.726501 259.546387,356.172913 
	C258.813965,355.795044 258.400024,355.571198 257.673828,355.181885 
	C257.152527,354.906738 256.945740,354.792847 256.435089,354.496582 
	C245.802765,347.472839 234.347076,342.496460 224.357361,335.087616 
	C222.370651,333.614227 220.283478,332.274933 218.075195,330.491028 
	C217.226959,329.781006 216.895630,329.145813 216.658325,328.078064 
	C217.681717,324.926514 220.587158,324.988373 222.679443,323.792053 
	C224.068954,322.997528 226.444870,323.058502 226.579514,321.163422 
	C226.729782,319.048431 224.336624,319.061523 222.898163,318.464355 
	C219.907684,317.222809 217.360138,315.369995 215.209122,313.020416 
	C212.638000,310.211975 212.873260,308.937561 216.569717,307.923889 
	C219.419724,307.142334 219.287613,306.076904 217.785721,304.217926 
	C212.250305,297.366455 207.573654,289.823853 201.015472,283.327118 
	C199.438583,280.320038 197.141434,278.765656 194.223190,278.575623 
	C189.668182,278.279053 185.193771,277.105438 180.198074,277.371582 
	C178.707764,277.388275 177.648148,277.215607 176.277863,276.601440 
	C173.980164,273.490387 173.388626,270.064301 173.739349,266.843567 
	C175.269363,252.794159 170.626450,241.035309 160.988403,230.569489 
	C156.087296,224.197128 151.509445,218.055756 147.153152,211.321564 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M134.067368,189.672363 
	C133.850159,189.712051 133.548218,189.468597 133.166016,188.937042 
	C133.384720,188.895706 133.683670,189.142456 134.067368,189.672363 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M95.278473,270.769043 
	C92.543114,268.589783 95.665031,266.139954 94.914459,263.310699 
	C96.033401,256.779480 97.185890,250.654968 98.591660,244.249588 
	C104.664406,249.640549 99.784203,255.184418 98.550964,260.715302 
	C97.808205,264.046448 96.571815,267.267548 95.278473,270.769043 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M96.804306,277.391602 
	C98.196167,273.204285 99.327400,269.351379 101.024597,265.550964 
	C102.823242,270.735535 101.401138,275.421906 98.814316,280.187012 
	C98.169807,280.420288 97.888878,280.440308 97.217766,280.296356 
	C96.281769,279.383484 96.220154,278.577454 96.804306,277.391602 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M96.698227,277.038971 
	C97.058922,277.821259 97.052917,278.585327 97.075531,279.731201 
	C97.230942,280.294769 97.357742,280.476501 97.542465,280.986694 
	C97.561409,281.534790 97.522438,281.754395 97.324883,282.269287 
	C96.730164,283.096680 96.196472,283.475098 95.194962,283.715820 
	C94.468575,283.900787 94.058647,283.985046 93.334961,284.075623 
	C93.366982,281.966278 93.712761,279.850616 94.103188,277.322601 
	C94.875740,276.947083 95.603630,276.983917 96.698227,277.038971 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M103.670074,255.997131 
	C103.595551,257.722809 103.286026,259.449982 102.955597,261.556976 
	C102.377075,262.945740 103.137093,264.459869 101.350922,265.065186 
	C100.993340,264.995483 100.999634,264.999756 101.003113,265.003174 
	C100.658142,262.039398 101.753136,259.315277 102.700119,256.259979 
	C102.965065,255.998322 103.435081,255.998642 103.670074,255.997131 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M91.198486,281.773865 
	C90.549644,282.159119 90.145638,282.182068 89.437943,282.181183 
	C88.985306,280.286804 88.708908,278.411438 89.607437,276.281982 
	C90.141457,275.889832 90.413948,275.786377 91.027298,275.957245 
	C91.991737,277.949554 91.275070,279.686981 91.198486,281.773865 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M91.270714,275.623169 
	C90.784264,275.972351 90.601791,275.979828 90.144150,275.990295 
	C89.912811,274.291901 89.956650,272.590515 90.025917,270.465973 
	C90.233917,270.032715 90.416489,270.022583 90.873352,270.013855 
	C92.218872,271.695404 92.131096,273.469452 91.270714,275.623169 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M90.976089,276.404419 
	C91.009567,274.264526 91.052399,272.564209 91.121429,270.439606 
	C94.239944,270.960510 92.836113,273.526428 92.884506,275.383392 
	C92.934113,277.287018 92.308662,279.208191 91.992813,281.540466 
	C91.838638,282.031342 91.670319,282.103485 91.227814,282.155884 
	C90.964241,280.372101 90.974838,278.608063 90.976089,276.404419 
z"/>
<path fill="#050F20" opacity="1.000000" stroke="none" 
	d="
M116.233063,214.613129 
	C116.032906,214.316696 116.039902,213.928421 116.027786,213.245865 
	C116.531433,213.370667 116.915817,213.827759 116.233063,214.613129 
z"/>
<path fill="#0A4271" opacity="1.000000" stroke="none" 
	d="
M114.124786,216.439514 
	C114.397644,216.598755 114.677612,217.031708 114.984848,217.741028 
	C114.718712,217.582672 114.425308,217.147934 114.124786,216.439514 
z"/>
<path fill="#03D1FB" opacity="1.000000" stroke="none" 
	d="
M255.040039,319.328796 
	C242.141373,303.710876 229.630692,288.300110 217.009644,272.577515 
	C216.772522,271.913544 216.592148,271.591400 216.128448,271.141052 
	C215.741699,270.901215 215.584625,270.819550 215.335083,270.488953 
	C215.806976,269.701019 216.477463,269.470154 217.785980,269.709595 
	C236.960983,282.871002 253.927505,298.019257 271.983887,311.771179 
	C272.601440,312.241516 272.945923,313.070374 273.717010,313.899780 
	C274.401123,314.562286 274.524200,315.115631 274.151489,316.103821 
	C268.141388,319.847626 262.107330,321.643982 255.040039,319.328796 
z"/>
<path fill="#0BC3FC" opacity="1.000000" stroke="none" 
	d="
M340.062225,415.242676 
	C338.650269,413.490936 337.675262,411.650909 336.592285,409.484375 
	C339.963043,404.811279 339.133545,398.495575 334.331482,393.311279 
	C332.540131,391.377350 330.345459,389.790894 329.123657,387.374908 
	C327.889648,384.934723 326.858704,382.462708 330.090027,380.268188 
	C331.727905,380.064148 333.053955,380.033478 333.120514,378.209869 
	C333.199249,376.052368 334.551361,374.357635 335.482269,372.152954 
	C336.930969,370.911346 338.223114,371.030823 339.787140,371.907471 
	C340.389984,372.298981 340.430267,372.833405 340.888000,372.910278 
	C340.997009,372.928619 341.064972,372.806671 341.067169,372.692078 
	C341.079803,372.025543 341.241486,372.827240 340.389954,372.382935 
	C337.978027,370.674744 335.085266,369.988312 334.546173,366.641663 
	C332.371338,368.313202 334.196777,370.306854 333.109131,372.090820 
	C327.306915,371.477814 324.630249,368.035431 325.792877,362.908417 
	C326.335999,360.513275 325.649811,357.833984 327.699890,355.476654 
	C334.586884,359.512665 340.678467,364.441071 346.933167,369.669983 
	C347.259735,374.567566 347.957611,379.108734 348.660828,384.001892 
	C347.341614,386.916107 345.602509,384.288513 344.128265,384.717712 
	C344.091156,386.395264 345.450989,387.224457 346.338928,388.711304 
	C347.026550,393.529205 347.986450,394.048035 353.100098,392.220947 
	C354.611542,390.823944 355.844696,389.615723 357.226898,388.099518 
	C357.876404,387.697449 358.293579,387.610962 359.045685,387.724762 
	C359.550598,387.903503 359.744202,387.996307 360.212250,388.255829 
	C360.846069,388.658386 361.197540,388.905518 361.793945,389.370209 
	C362.174683,389.755463 362.303986,389.932587 362.528351,390.426636 
	C362.648132,391.191772 362.588562,391.629456 362.316925,392.362976 
	C360.958740,394.520691 360.615143,396.963379 358.128265,398.287354 
	C355.004242,397.752319 352.761505,397.652496 354.326111,401.681915 
	C354.792847,402.883972 355.080078,404.167603 354.322296,405.722260 
	C350.558502,406.774170 348.169495,409.257904 345.801025,411.724976 
	C344.288300,413.300659 342.518250,414.400665 340.062225,415.242676 
z"/>
<path fill="#0BCCFD" opacity="1.000000" stroke="none" 
	d="
M357.820312,398.623047 
	C359.027222,396.210327 360.157990,394.169525 361.638123,392.063782 
	C361.987549,391.998779 362.243042,391.662659 362.443848,391.604919 
	C362.644623,391.547211 362.574493,391.130737 362.494995,390.932831 
	C362.415527,390.734924 362.283813,390.327362 362.140503,390.168243 
	C361.997223,390.009125 362.000000,390.000061 361.995453,390.001251 
	C361.576202,389.549896 360.991089,389.495544 360.219421,389.170380 
	C359.990601,388.998352 360.000000,389.000000 360.001221,389.004578 
	C359.486908,388.269958 359.000946,387.493317 357.636658,387.299042 
	C355.539917,385.908508 353.333649,385.414368 351.459473,383.663330 
	C350.858185,380.537628 351.353912,377.895050 352.762878,375.063629 
	C357.396271,378.031921 361.774750,381.212250 366.034027,384.544891 
	C369.792175,387.485382 374.022095,389.496094 378.599213,391.558655 
	C380.442047,397.641541 382.065643,403.471741 383.852905,409.643555 
	C384.800385,410.632568 385.250854,411.500275 385.764771,412.760315 
	C386.434082,414.745911 387.038574,416.373718 386.907257,418.507812 
	C386.144592,420.908081 384.150635,421.548340 382.325378,422.866211 
	C380.394501,421.327057 380.425140,418.610138 376.570801,418.518280 
	C373.008301,418.433411 376.329407,414.503754 375.242462,412.225891 
	C371.967621,408.849274 371.815613,404.490082 370.208496,401.125763 
	C370.056885,404.328888 371.388580,408.622559 365.653625,409.792053 
	C361.196167,407.291779 359.397583,403.194153 357.820312,398.623047 
z"/>
<path fill="#0CD8FF" opacity="1.000000" stroke="none" 
	d="
M292.030701,327.722595 
	C299.216675,332.598816 305.945709,337.493256 312.067932,343.600342 
	C311.738586,345.842499 311.064972,347.730255 311.303802,349.710144 
	C311.740417,353.329773 310.172394,355.566132 306.499969,356.866455 
	C305.522827,357.435822 304.846222,357.282074 303.878998,356.773895 
	C301.354492,351.820312 297.117340,354.332153 293.359894,353.737793 
	C291.593384,352.913696 290.730988,351.696228 289.852631,349.998413 
	C289.289093,348.461334 288.461700,347.374451 289.038208,345.723083 
	C293.235565,342.720490 293.514282,340.728455 290.970245,335.388123 
	C289.699921,332.721588 287.111145,329.796692 292.030701,327.722595 
z"/>
<path fill="#03DBFB" opacity="1.000000" stroke="none" 
	d="
M327.779236,354.988770 
	C327.022583,358.395447 327.618103,361.686371 326.534546,365.029297 
	C325.509705,368.190979 329.549347,370.235657 332.689636,371.933350 
	C333.727173,371.408356 334.490845,371.273315 335.643188,371.792206 
	C336.659912,375.069336 333.270294,377.312439 334.600586,380.757446 
	C335.158600,382.202484 332.842163,381.795776 331.323364,381.137695 
	C327.777039,379.432434 324.555939,377.877808 320.490662,378.084259 
	C319.931305,378.001007 319.705963,377.976166 319.143524,377.895142 
	C318.596100,377.748810 318.385834,377.658600 317.902985,377.358276 
	C317.335907,376.794128 317.070282,376.419800 316.667969,375.718750 
	C316.398163,375.203522 316.298065,374.991669 316.067078,374.450470 
	C315.563263,372.968658 315.178314,371.819489 314.927551,370.239838 
	C314.877319,368.670013 315.071228,367.475891 315.857727,366.597290 
	C318.433197,363.720154 318.500275,360.453491 317.978455,356.843994 
	C317.584747,354.120667 317.281738,350.947052 321.859070,350.750397 
	C324.001007,352.190308 325.778564,353.464752 327.779236,354.988770 
z"/>
<path fill="#0EE7FD" opacity="1.000000" stroke="none" 
	d="
M273.726746,316.354370 
	C273.990448,315.583099 273.998230,315.150085 274.011169,314.392242 
	C278.158508,315.642670 281.128845,318.931091 284.851074,321.651581 
	C286.248688,323.693054 286.289764,325.958649 287.663452,328.101685 
	C288.084900,333.310760 287.464111,338.088379 286.846375,343.280579 
	C286.230438,344.496613 285.503326,344.959717 284.237549,345.365479 
	C281.099121,345.078339 279.358093,343.200012 278.022400,341.157410 
	C273.126495,333.670349 271.282806,325.536285 273.726746,316.354370 
z"/>
<path fill="#0BCCFD" opacity="1.000000" stroke="none" 
	d="
M322.021118,350.632385 
	C319.343872,351.151001 318.506042,353.172211 319.095428,355.436462 
	C320.369202,360.330048 320.558655,364.766876 316.210022,368.357574 
	C315.855591,368.650238 316.056030,369.614838 315.990112,370.654816 
	C314.074554,371.682922 313.313171,370.070129 312.005066,368.872803 
	C311.674377,368.440186 311.550598,368.260437 311.259521,367.798950 
	C310.883392,367.131683 310.687927,366.739441 310.374756,366.037964 
	C310.173187,365.527893 310.102692,365.320435 309.946167,364.797333 
	C309.261353,362.485413 309.253235,360.216614 306.981293,358.711121 
	C306.317322,358.336456 306.027252,358.026245 305.901337,357.330017 
	C306.475525,355.720490 304.698059,352.495575 308.722809,354.234161 
	C310.273102,354.903809 309.762390,352.771484 309.990356,351.822235 
	C310.599579,349.285095 308.664795,346.298828 311.750397,344.030945 
	C316.439117,344.467651 318.090271,348.974030 322.021118,350.632385 
z"/>
<path fill="#0EE7FD" opacity="1.000000" stroke="none" 
	d="
M352.918640,374.501709 
	C353.193848,377.617584 352.823639,380.385559 351.964600,383.500183 
	C352.521698,386.474365 354.500366,388.597412 354.169373,391.698700 
	C352.932495,394.976288 349.042480,395.919495 345.395203,393.830139 
	C342.700348,392.286407 346.129456,391.280487 346.028931,389.565674 
	C346.335052,387.912231 346.679413,386.640076 347.729797,385.307312 
	C347.058533,380.248901 344.846252,375.572479 346.796204,370.236237 
	C348.990784,371.380981 350.879211,372.799500 352.918640,374.501709 
z"/>
<path fill="#0BCCFD" opacity="1.000000" stroke="none" 
	d="
M285.785278,344.234070 
	C285.980347,338.932404 285.733093,333.849640 286.982941,328.437561 
	C286.367981,326.577942 287.016174,325.631592 288.552490,324.958801 
	C289.958160,325.782440 290.997375,326.533356 292.208801,327.562012 
	C288.797943,329.417175 290.037231,331.852905 291.610260,333.877533 
	C293.587738,336.422699 293.980560,339.162689 294.078644,342.241974 
	C294.183197,345.524811 292.643951,346.307159 289.421661,346.006165 
	C288.436554,346.473541 287.827393,346.336792 286.924561,346.041290 
	C286.458832,345.800293 286.283722,345.683228 285.905029,345.325256 
	C285.659393,344.878937 285.617340,344.673553 285.785278,344.234070 
z"/>
<path fill="#0CD8FF" opacity="1.000000" stroke="none" 
	d="
M288.767639,324.756378 
	C288.355347,325.839600 287.791718,326.647675 287.105774,327.733185 
	C283.752838,327.232056 285.442505,324.599152 285.012665,322.352966 
	C286.217438,322.786346 287.416840,323.633759 288.767639,324.756378 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M218.131592,269.585876 
	C217.633942,269.949554 216.949905,270.027222 215.754257,270.172424 
	C214.256516,268.941437 213.270416,267.642883 212.233292,266.024994 
	C214.464340,266.324768 216.101242,267.978333 218.131592,269.585876 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M212.275635,265.610229 
	C211.974396,265.815796 211.758408,265.674835 211.575439,265.221802 
	C211.867401,264.961975 212.118210,265.079956 212.275635,265.610229 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M386.101685,383.698547 
	C384.133362,384.878326 382.404419,385.844177 380.351929,386.859131 
	C380.162170,385.065369 379.584717,383.150330 380.894348,381.144897 
	C382.520142,381.615448 383.839233,382.336700 385.486053,383.088104 
	C385.989563,383.240387 386.165344,383.362518 386.101685,383.698547 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M392.673950,381.004639 
	C392.482361,381.910004 391.598480,382.003265 390.339722,382.015137 
	C390.518768,381.080933 391.410950,381.008545 392.673950,381.004639 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M389.674683,382.003510 
	C389.489532,382.909515 388.614655,383.014130 387.361206,383.014954 
	C387.527405,382.056854 388.421143,382.004974 389.674683,382.003510 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M386.119751,383.868408 
	C385.862274,383.912445 385.889984,383.511749 385.851868,383.315002 
	C386.009827,383.087891 386.205872,383.057495 386.699463,383.026642 
	C386.790405,383.292297 386.583801,383.558350 386.119751,383.868408 
z"/>
<path fill="#2D2F36" opacity="1.000000" stroke="none" 
	d="
M468.755981,260.323547 
	C468.997375,259.983734 469.473328,259.967987 469.711426,259.969177 
	C470.876831,259.049500 472.094177,258.720032 473.641998,258.221741 
	C474.241638,258.048798 474.483459,257.989014 475.092102,257.865601 
	C476.284821,257.703827 477.118622,257.643677 477.942871,257.727173 
	C479.386444,257.873444 481.401581,257.578156 481.759949,259.282349 
	C482.122894,261.008148 480.093384,260.928619 478.948517,261.293060 
	C477.312988,261.813660 476.918610,262.827972 477.375519,264.346710 
	C477.949219,266.253754 478.082153,268.708435 479.487213,269.853943 
	C483.495605,273.121857 484.290863,277.957153 486.533020,282.516846 
	C487.001404,283.610168 487.158691,284.390015 487.280701,285.597778 
	C487.364166,286.854156 487.283722,287.689941 487.085449,288.945190 
	C484.404327,294.898468 483.043121,295.647888 476.496124,294.731750 
	C474.509705,291.117279 473.252014,287.613098 473.002899,283.407104 
	C474.335663,281.312653 476.757019,282.179962 478.587402,280.578156 
	C476.846680,279.602295 474.870117,280.554840 473.289246,279.158691 
	C473.086365,278.893951 473.043427,278.446014 473.016846,278.222595 
	C469.543060,272.725372 468.161011,266.918427 468.755981,260.323547 
z"/>
<path fill="#2478A2" opacity="1.000000" stroke="none" 
	d="
M475.898743,294.659058 
	C479.794281,293.857239 484.274475,294.795166 485.874054,289.375244 
	C486.667328,288.430634 487.422455,288.293976 488.571838,288.811401 
	C488.160034,292.227081 488.949860,295.843170 485.978516,298.644531 
	C486.323242,301.206573 485.655243,303.291504 484.523438,305.044647 
	C482.916138,307.534332 483.980927,308.854980 486.171448,310.370087 
	C486.184021,311.453827 485.743622,312.006958 484.951782,312.748596 
	C480.398315,316.018036 475.796387,318.548401 471.076080,321.568604 
	C469.978943,321.871002 469.245605,321.822662 468.254608,321.260529 
	C467.792877,318.305786 470.570831,318.268036 471.951935,316.527344 
	C472.901733,315.070984 473.590179,313.810699 475.220612,313.458557 
	C474.249817,313.163086 473.537720,314.104492 472.314087,313.822510 
	C470.487640,313.974518 468.999664,314.195801 467.285400,314.204987 
	C466.744843,311.449432 469.058441,311.270538 470.451141,310.463593 
	C474.212280,308.284424 477.495026,305.575409 480.315887,302.301483 
	C481.255615,301.210846 482.679321,299.988281 481.800629,298.441193 
	C480.963715,296.967651 479.410309,298.113922 478.179321,298.223389 
	C477.361542,298.296082 476.554047,298.495361 475.370667,298.414581 
	C474.337311,297.978668 473.926849,297.411194 473.874268,296.305664 
	C474.546326,295.568909 475.113220,295.183655 475.898743,294.659058 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M472.847900,279.176819 
	C474.550385,278.830902 476.071442,278.993927 477.462799,278.642883 
	C478.929260,278.272858 480.163269,278.155365 480.676880,279.754456 
	C481.335205,281.804047 479.578766,282.333832 478.227295,282.677704 
	C476.829590,283.033295 475.309906,282.909241 473.423004,282.996887 
	C470.402740,282.274078 467.115753,283.013458 465.859741,279.319397 
	C468.222626,278.290588 470.311829,280.501038 472.847900,279.176819 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M473.668640,296.077820 
	C474.228271,296.414124 474.477142,296.874084 474.837402,297.571228 
	C474.661224,300.121979 472.993042,301.267303 470.790619,302.359100 
	C470.164124,302.390442 469.913208,302.341064 469.580322,301.916901 
	C470.177612,299.323120 471.637726,297.668365 473.668640,296.077820 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M465.771790,304.789124 
	C466.412872,303.999329 467.176971,303.332336 468.244812,302.582001 
	C468.799530,302.527283 469.050507,302.555908 469.363434,302.957520 
	C469.102875,304.723328 468.276672,305.505707 466.463867,305.333160 
	C466.129272,305.168549 465.894806,304.911896 465.771790,304.789124 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M468.697144,302.672058 
	C468.673920,302.210388 468.861084,301.970337 469.304230,301.660339 
	C469.498352,301.542145 469.846802,301.845428 470.010986,302.007843 
	C470.203339,302.573792 470.048676,302.894806 469.449890,303.158386 
	C469.164337,303.172577 468.845673,302.845490 468.697144,302.672058 
z"/>
<path fill="#3C3A3D" opacity="1.000000" stroke="none" 
	d="
M462.307861,258.015747 
	C462.685547,255.046387 459.226837,251.887573 462.664551,249.124664 
	C453.171753,246.846405 454.155151,238.383560 452.015015,231.410538 
	C453.339478,228.370285 455.808075,228.408356 458.606140,228.497345 
	C461.291840,231.897797 461.545319,235.968201 463.203247,239.511246 
	C464.521484,242.328400 466.125854,244.584641 469.644806,245.462769 
	C470.066711,245.880936 470.184631,246.092010 470.263763,246.659515 
	C467.708069,248.602722 467.445618,250.722778 468.535248,253.338043 
	C469.206268,254.948456 470.290863,256.566071 469.223145,258.736206 
	C467.611572,258.993530 466.220642,258.992035 464.412323,258.999084 
	C463.531250,258.685760 463.067596,258.363983 462.307861,258.015747 
z"/>
<path fill="#3C3A3D" opacity="1.000000" stroke="none" 
	d="
M468.595703,259.994629 
	C469.712280,265.867889 471.482910,271.507751 472.986938,277.604614 
	C468.646881,277.309174 466.266876,275.223785 466.893250,270.375641 
	C467.133881,268.513214 466.257660,266.533020 466.170929,264.593933 
	C466.091705,262.822571 465.051758,260.430634 468.595703,259.994629 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M469.244873,259.004944 
	C468.122589,256.209656 467.254395,253.420532 466.359314,250.640045 
	C465.517365,248.024612 466.495178,246.853271 469.587524,246.998596 
	C474.656158,249.399918 474.307098,254.228348 475.242035,258.660828 
	C474.847565,258.995087 474.674866,258.997528 474.243073,259.002991 
	C472.973572,259.766327 471.814484,259.410858 470.339661,259.230194 
	C469.972290,259.017731 469.487183,259.014862 469.244873,259.004944 
z"/>
<path fill="#3C3A3D" opacity="1.000000" stroke="none" 
	d="
M469.972412,259.255981 
	C471.042725,259.012939 472.113129,259.008179 473.583801,259.004730 
	C473.153625,260.226257 471.875061,259.954651 470.319946,259.982971 
	C469.949493,259.970337 469.972565,259.494293 469.972412,259.255981 
z"/>
<path fill="#3A424A" opacity="1.000000" stroke="none" 
	d="
M468.988647,303.432220 
	C469.480377,303.058350 469.739502,302.867035 470.058411,302.384430 
	C471.585419,300.839996 472.995667,299.509735 474.677338,297.993927 
	C476.554077,297.400208 478.154755,296.972839 479.766022,296.589783 
	C481.156006,296.259308 482.809357,295.260590 483.779694,296.983582 
	C484.586700,298.416534 483.683319,299.959320 482.869568,301.184265 
	C479.059143,306.920258 473.353058,310.320740 467.252319,313.719849 
	C464.174133,314.352081 461.157410,311.244415 458.195251,314.643738 
	C458.014740,314.964691 457.567322,314.893921 457.343567,314.859314 
	C456.140717,313.671722 455.161591,312.518707 453.955872,311.112701 
	C457.203583,307.929871 462.376801,308.968140 465.923615,305.447845 
	C467.023865,304.676331 467.918427,304.184082 468.988647,303.432220 
z"/>
<path fill="#272930" opacity="1.000000" stroke="none" 
	d="
M484.194885,360.810303 
	C481.710236,361.157684 481.349335,364.612610 478.368347,364.001251 
	C476.958618,363.461212 477.120331,362.193359 476.225586,361.224731 
	C476.010742,361.008057 476.000244,360.998108 475.995056,360.992889 
	C475.828583,360.823212 475.667236,360.658783 475.259155,360.252350 
	C475.012421,360.010376 475.001221,359.998779 474.995361,359.993195 
	C474.828522,359.823395 474.667511,359.659149 474.260559,359.253052 
	C474.014587,359.011200 474.001465,358.998871 473.994263,358.993530 
	C473.574921,358.553436 473.005798,358.494843 472.249695,358.182495 
	C472.028931,358.009735 472.005280,357.992279 471.994080,357.982727 
	C471.755280,357.756226 471.539612,357.527985 471.180267,357.111603 
	C470.921570,356.641205 470.745575,356.401154 470.296021,356.110657 
	C469.636841,355.580170 469.040680,355.496826 468.232239,355.173340 
	C467.996399,354.991943 467.998779,355.001221 468.003754,355.001801 
	C467.788544,354.776520 467.566589,354.552429 467.175171,354.163239 
	C467.007538,353.996338 467.000000,354.000000 467.002625,353.995697 
	C466.319244,353.204742 465.400848,352.780151 464.237823,352.177490 
	C464.000580,351.987915 464.000000,352.001221 464.006317,351.998474 
	C463.568756,351.590576 463.186371,351.144470 463.026733,350.242249 
	C463.735870,346.737396 460.680511,344.075104 461.851746,340.527588 
	C462.356934,339.658295 462.950989,339.530945 463.773010,339.199799 
	C464.011169,339.014435 464.000000,339.000000 464.004456,339.008026 
	C464.433624,338.573212 465.026917,338.530365 465.792358,338.183167 
	C466.018311,338.006470 465.997925,338.000214 466.002899,338.009949 
	C466.109222,337.883392 466.210602,337.747101 466.416748,337.377960 
	C466.603790,336.995667 466.686066,336.846161 466.964783,336.532837 
	C467.304626,336.277985 467.447998,336.186920 467.809326,335.964722 
	C468.170227,335.742126 468.313232,335.650696 468.664551,335.409729 
	C469.008667,335.153351 469.144409,335.046509 469.484680,334.773651 
	C469.828033,334.495514 469.966888,334.383331 470.313721,334.097717 
	C470.800751,333.678986 471.076172,333.429688 471.558899,332.973816 
	C472.682281,331.966278 473.796204,331.467590 475.041992,330.602966 
	C475.465729,330.298615 475.637054,330.176788 476.069885,329.885803 
	C476.510132,329.622742 476.688965,329.528870 477.145752,329.335144 
	C477.952087,329.110168 478.486420,329.066345 479.231995,329.157288 
	C479.436279,329.197357 479.752869,329.364197 479.808685,329.186157 
	C479.864502,329.008087 479.685089,328.635101 479.680725,328.406677 
	C479.676392,328.178253 479.858276,327.717133 480.018494,327.510864 
	C480.558838,326.881927 480.956360,326.475739 481.595154,325.851959 
	C482.037140,325.529388 482.235504,325.422089 482.768250,325.217834 
	C483.584991,325.055511 484.066772,325.065765 484.917206,325.238281 
	C487.523132,326.739044 487.317078,328.842499 486.783325,331.365295 
	C486.497253,331.944763 486.354004,332.158478 485.941010,332.638245 
	C482.436096,334.984192 483.124847,338.546875 482.905396,341.460052 
	C482.508270,346.732483 480.679962,352.090973 483.242706,357.620178 
	C483.676910,358.050995 483.845673,358.230927 484.212952,358.726807 
	C484.544800,359.532196 484.549561,360.023041 484.194885,360.810303 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M476.164612,330.860474 
	C474.791748,331.843048 473.583069,332.655304 472.190552,333.723450 
	C471.574158,334.411255 470.985138,334.470917 470.221130,334.823059 
	C470.001221,335.008606 470.000000,335.000000 470.004089,335.001038 
	C469.773865,335.214966 469.546600,335.435059 469.164062,335.835510 
	C469.001770,336.008636 469.000000,336.000000 469.004089,336.002014 
	C468.569092,336.419647 467.982483,336.470276 467.224945,336.821442 
	C467.007294,337.006409 467.000000,337.000000 467.002014,337.004822 
	C466.820618,337.119476 466.637207,337.229279 466.224457,337.114990 
	C464.337616,335.274811 462.688324,336.150421 461.097809,336.971161 
	C457.433014,338.862244 455.621094,337.406372 454.976166,333.314026 
	C454.630920,332.540649 454.510193,332.087372 454.792664,331.289001 
	C455.016113,330.995819 454.996338,330.995605 454.995178,331.005402 
	C455.426056,330.581573 456.016785,330.529755 456.785431,330.185547 
	C457.010529,330.006683 457.000000,330.000000 457.001831,330.005737 
	C457.224060,329.788574 457.445343,329.566620 457.834473,329.179993 
	C458.001343,329.014435 458.002441,329.002441 458.008484,329.001862 
	C458.251556,328.753906 458.501099,328.519897 458.965240,328.140900 
	C460.854828,327.958496 461.316101,326.150330 462.838348,325.356201 
	C463.217926,324.855743 463.416504,324.609802 463.803314,324.213074 
	C463.973389,324.047668 464.018036,324.026428 464.033569,324.007202 
	C464.458344,323.557068 465.033783,323.531036 465.770660,323.198853 
	C465.987396,323.027374 466.010132,323.011383 466.019470,323.001099 
	C466.185913,322.830994 466.342957,322.671204 466.739563,322.275604 
	C466.979095,322.039825 466.997223,322.024933 467.001343,322.013947 
	C467.231964,321.769958 467.466614,321.545471 467.871521,321.147766 
	C468.033661,320.966034 467.996216,320.976013 467.985321,320.991882 
	C468.699524,321.000458 469.424591,320.993225 470.512573,320.948059 
	C474.530518,318.888000 478.389801,317.997559 482.982483,318.894653 
	C484.267944,319.239105 485.015442,319.679535 485.893738,320.670654 
	C485.503113,321.841553 484.873413,322.646240 484.041718,324.016541 
	C483.485138,325.076508 482.961945,325.349426 482.223694,325.823853 
	C481.995880,326.008606 481.991547,326.006775 481.987457,326.012756 
	C481.482697,326.507233 480.989746,327.003448 480.252197,327.749603 
	C480.007050,327.999023 480.000000,328.000000 480.000854,328.003296 
	C479.384064,328.890686 478.349701,329.119537 477.249451,329.803406 
	C477.017517,329.997284 477.001373,330.002655 476.996704,330.009705 
	C476.752594,330.223083 476.531494,330.447571 476.164612,330.860474 
z"/>
<path fill="#32627C" opacity="1.000000" stroke="none" 
	d="
M447.323547,342.922058 
	C439.265564,338.810303 430.329193,337.088745 422.909241,331.558868 
	C423.509369,330.775513 423.557404,330.175354 423.057434,329.233521 
	C423.845032,328.834747 424.711029,328.685699 425.774963,328.268860 
	C426.414795,328.020874 426.856750,328.040710 427.628418,328.093140 
	C432.528229,331.377380 438.157867,332.316589 442.980927,335.010406 
	C444.490692,335.853638 446.500824,336.104980 447.037964,338.581543 
	C448.027802,340.096100 448.959686,341.257996 447.323547,342.922058 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M447.236328,343.343079 
	C447.778625,341.924042 447.361084,340.740784 447.064148,339.247711 
	C450.458771,339.942596 453.837646,340.948608 457.618835,341.987915 
	C455.669495,343.576202 455.059723,344.974915 458.116699,346.541321 
	C459.672211,347.338379 460.979645,348.619659 462.705017,349.813599 
	C463.342926,350.426331 463.675049,350.907532 464.009918,351.692200 
	C458.498016,349.195099 452.983398,346.394501 447.236328,343.343079 
z"/>
<path fill="#3A424A" opacity="1.000000" stroke="none" 
	d="
M471.988831,314.170807 
	C473.435883,312.647980 475.003876,311.865906 477.946594,312.181305 
	C475.858185,313.740875 474.322601,314.887604 472.464844,316.143921 
	C472.095795,315.698456 472.048920,315.143402 471.988831,314.170807 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M454.761505,331.100159 
	C455.013489,331.427185 455.010864,331.858582 454.983856,332.611938 
	C454.541992,332.820496 454.124573,332.707031 453.707092,332.593597 
	C453.973694,332.130554 454.240295,331.667511 454.761505,331.100159 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M463.689026,339.024048 
	C463.542755,339.364624 463.074341,339.714844 462.307220,340.147339 
	C462.461304,339.830963 462.914093,339.432312 463.689026,339.024048 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M457.993073,341.990143 
	C458.342926,341.511322 458.610962,340.714539 459.341614,341.607544 
	C459.064240,341.736237 458.786865,341.864899 458.265320,342.007385 
	C458.021179,342.021179 458.001343,342.001282 457.993073,341.990143 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M465.713257,338.013611 
	C465.549591,338.337341 465.080872,338.668213 464.310516,339.007568 
	C464.475311,338.684265 464.941742,338.352509 465.713257,338.013611 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M456.706329,330.007385 
	C456.541748,330.343994 456.072998,330.681305 455.299133,331.016907 
	C455.463379,330.679504 455.932739,330.343811 456.706329,330.007385 
z"/>
<path fill="#3A424A" opacity="1.000000" stroke="none" 
	d="
M465.693695,323.030304 
	C465.536804,323.348145 465.086182,323.668884 464.342346,323.988831 
	C464.499390,323.669739 464.949677,323.351471 465.693695,323.030304 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M458.898499,328.054810 
	C458.952881,328.265411 458.738525,328.548401 458.269348,328.916321 
	C458.219604,328.709900 458.424683,328.418518 458.898499,328.054810 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M457.759979,329.092865 
	C457.825897,329.289215 457.650421,329.563965 457.239319,329.925110 
	C457.175323,329.731415 457.346954,329.451324 457.759979,329.092865 
z"/>
<path fill="#3A424A" opacity="1.000000" stroke="none" 
	d="
M461.624268,321.485443 
	C461.804626,321.597015 461.460876,321.798737 461.420227,321.795898 
	C461.379547,321.793091 461.443939,321.373871 461.624268,321.485443 
z"/>
<path fill="#2478A2" opacity="1.000000" stroke="none" 
	d="
M467.816681,321.088989 
	C467.848541,321.242188 467.663391,321.518311 467.241821,321.898682 
	C467.137024,321.689331 467.335114,321.425659 467.816681,321.088989 
z"/>
<path fill="#3A424A" opacity="1.000000" stroke="none" 
	d="
M466.760620,322.129883 
	C466.919983,322.371002 466.749451,322.628326 466.248169,322.901276 
	C466.096588,322.665009 466.267700,322.408051 466.760620,322.129883 
z"/>
<path fill="#3A424A" opacity="1.000000" stroke="none" 
	d="
M463.740845,324.146576 
	C463.925720,324.395905 463.757080,324.669617 463.252441,324.992554 
	C463.194427,324.826019 463.351379,324.535767 463.740845,324.146576 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M465.981506,337.173248 
	C466.163513,336.908630 466.331909,336.926392 466.752197,336.976929 
	C466.828369,337.284637 466.652679,337.559631 466.242432,337.927155 
	C465.994537,337.831635 465.981232,337.643616 465.981506,337.173248 
z"/>
<path fill="#606569" opacity="1.000000" stroke="none" 
	d="
M408.743958,199.933167 
	C401.033752,202.172806 393.828064,202.923477 386.300842,203.693359 
	C383.480103,202.507019 380.936554,201.022247 378.197510,199.263428 
	C377.944366,198.133499 378.225586,197.393173 379.109802,196.510284 
	C380.480896,195.812576 381.575439,195.673904 383.109863,195.618683 
	C390.193207,194.298462 397.026917,194.992203 403.705017,193.885056 
	C406.079742,193.491348 408.287750,194.171555 410.906281,194.919662 
	C411.776367,195.341339 412.154907,195.715912 412.499603,196.584442 
	C412.380798,198.829102 410.860046,199.278732 408.743958,199.933167 
z"/>
<path fill="#88A7B5" opacity="1.000000" stroke="none" 
	d="
M383.304626,196.612640 
	C381.877655,196.878098 380.822083,196.923203 379.370178,196.974899 
	C378.529938,197.471771 378.035400,197.901199 377.171692,198.389282 
	C373.774200,197.266602 370.792999,198.058411 367.437805,199.181870 
	C367.041168,198.883209 367.032623,198.487045 367.031494,197.794800 
	C368.019653,194.935516 370.604797,194.742157 372.637238,193.827682 
	C379.819275,190.596146 387.565887,189.372696 395.193481,187.764404 
	C396.977081,187.388336 398.840179,187.525833 400.922821,188.562973 
	C402.957397,192.551620 400.983215,194.081375 397.651184,194.328903 
	C392.932739,194.679443 388.275482,195.303772 383.304626,196.612640 
z"/>
<path fill="#6D676B" opacity="1.000000" stroke="none" 
	d="
M387.985718,205.431671 
	C389.624969,205.048798 391.277191,204.952362 392.920227,205.036469 
	C394.940460,205.139893 397.920013,204.471344 397.642059,207.683655 
	C397.476959,209.592087 397.676453,212.225861 393.742493,212.754425 
	C391.084595,213.111542 389.205475,217.284683 385.351501,217.942795 
	C385.272308,217.215973 385.334229,216.153397 385.874725,215.775818 
	C389.746582,213.070908 390.020569,209.703018 387.985718,205.431671 
z"/>
<path fill="#74909F" opacity="1.000000" stroke="none" 
	d="
M377.147217,198.684875 
	C377.073242,197.729614 377.507080,197.156754 378.678650,197.001907 
	C378.808105,197.534698 378.642395,198.087921 378.239319,198.815277 
	C377.806305,198.936081 377.610626,198.882736 377.147217,198.684875 
z"/>
<path fill="#4D4E51" opacity="1.000000" stroke="none" 
	d="
M459.346802,229.153992 
	C456.893829,229.574188 454.785248,230.144440 452.343323,230.863403 
	C451.232574,231.003555 450.455139,230.995026 449.289398,230.971710 
	C445.478973,226.403519 440.923492,224.705719 435.007111,225.445862 
	C430.736847,222.706482 426.071228,221.145554 423.032440,217.274841 
	C420.826233,214.464569 418.233643,211.750778 419.787506,207.333252 
	C421.135010,206.416733 422.270813,205.815231 423.703735,205.091309 
	C424.819244,204.226654 425.383881,203.448914 424.098083,202.282745 
	C422.781219,202.394409 421.719879,202.671295 420.327545,202.968262 
	C417.525299,202.884445 414.965759,202.922134 414.662292,199.199890 
	C418.273132,197.033371 421.943146,195.879745 426.171936,195.420547 
	C428.513702,196.648438 430.111420,198.324921 432.290955,199.265244 
	C435.710449,200.740509 432.414856,204.818024 434.878448,206.891556 
	C435.045929,207.032532 433.703430,207.756332 432.538879,207.700836 
	C431.509949,207.439087 430.780792,207.557251 429.968689,207.388351 
	C430.613800,207.726547 431.230804,207.410324 432.088806,207.801102 
	C438.083984,216.484756 446.091522,221.730408 455.809021,224.540558 
	C457.865540,225.135254 460.196136,225.288940 460.397766,228.490448 
	C460.089661,229.000748 459.890381,229.152420 459.346802,229.153992 
z"/>
<path fill="#5B595B" opacity="1.000000" stroke="none" 
	d="
M419.653320,207.119720 
	C420.223907,214.664185 425.315979,218.658432 431.298340,221.903122 
	C432.571198,222.593475 434.181885,222.682510 434.963318,224.568573 
	C434.810791,225.773575 434.004822,226.071304 433.198334,226.785156 
	C432.253967,227.038223 431.520386,227.080658 430.419373,227.129486 
	C429.474182,227.057892 428.930939,227.139618 428.217377,227.652328 
	C427.549988,227.853958 427.109650,227.886826 426.338257,227.902802 
	C422.623901,225.745850 418.496460,225.688629 414.968414,223.860519 
	C409.929749,221.249680 408.161591,217.582260 409.756470,211.380844 
	C413.109985,209.785889 416.208740,208.503540 419.653320,207.119720 
z"/>
<path fill="#636061" opacity="1.000000" stroke="none" 
	d="
M409.648926,211.092285 
	C409.775299,222.519714 413.476715,221.851913 421.963043,224.894012 
	C423.487701,225.440567 425.312469,225.104507 425.950806,227.525528 
	C421.633911,228.613983 417.260590,229.342056 412.465027,230.080231 
	C410.412231,227.752945 407.908569,226.458557 405.678040,224.862396 
	C402.510620,222.595779 400.629730,219.762207 400.971985,215.317596 
	C403.383789,212.873306 406.556824,212.482086 409.648926,211.092285 
z"/>
<path fill="#636061" opacity="1.000000" stroke="none" 
	d="
M414.723877,198.743591 
	C415.296753,201.771210 417.920013,201.474976 419.780914,202.725464 
	C416.948456,205.000031 413.339111,205.562302 409.986084,206.771072 
	C408.905365,207.160675 407.506104,208.432785 406.406433,207.116989 
	C405.462952,205.988052 406.253479,204.636139 406.811249,203.439636 
	C407.225647,202.550720 407.594482,201.640549 407.998047,200.366287 
	C408.012543,199.992737 407.993591,199.996124 407.990631,200.005524 
	C409.291412,199.213150 410.891571,199.276276 412.580505,198.423019 
	C413.452606,198.226730 413.952148,198.296417 414.723877,198.743591 
z"/>
<path fill="#636061" opacity="1.000000" stroke="none" 
	d="
M423.893036,202.470886 
	C424.884979,202.135590 426.322998,201.507477 426.567139,203.130188 
	C426.729401,204.208496 425.673370,204.686981 424.345215,204.947418 
	C423.981750,204.254013 423.962646,203.539139 423.893036,202.470886 
z"/>
<path fill="#5B595B" opacity="1.000000" stroke="none" 
	d="
M401.248291,189.485321 
	C390.619415,188.629791 381.319519,192.408630 371.897919,195.615311 
	C370.501862,196.090469 369.139923,196.665817 367.400574,197.346771 
	C362.786682,193.366699 362.217529,188.482651 364.141968,182.715485 
	C364.185333,182.332657 364.482880,182.050919 364.656921,181.942810 
	C365.168213,181.772568 365.440582,181.605011 365.787689,181.131409 
	C366.510590,180.440796 367.093872,179.950775 367.846741,179.229431 
	C368.563599,177.983978 369.305511,177.211212 370.804993,176.914948 
	C371.942078,176.674210 372.667114,176.336655 373.386536,175.380081 
	C373.937714,174.830429 374.324188,174.606888 375.098145,174.387817 
	C376.662964,174.370224 377.855316,174.689636 379.460876,174.596161 
	C382.476044,174.640671 385.123322,174.385529 388.110840,175.053925 
	C392.882141,178.585999 396.960510,182.426819 402.016174,184.929001 
	C403.540710,185.683533 404.831207,186.706924 404.149841,189.059753 
	C403.184784,189.798355 402.415283,189.876205 401.248291,189.485321 
z"/>
<path fill="#606569" opacity="1.000000" stroke="none" 
	d="
M359.025757,192.276550 
	C359.494873,189.739120 360.655457,189.818985 361.504517,191.449493 
	C362.313721,193.003433 363.219452,194.718109 362.843597,196.615585 
	C362.677216,197.455750 361.968384,197.336075 361.296082,197.090347 
	C359.153992,196.307434 358.923248,194.566055 359.025757,192.276550 
z"/>
<path fill="#534F51" opacity="1.000000" stroke="none" 
	d="
M448.246246,250.218842 
	C443.613434,250.034851 439.249390,250.018707 434.442688,250.002808 
	C431.092316,245.444809 431.143127,240.675217 432.990784,235.383087 
	C435.896851,232.020081 439.421692,231.480408 443.629456,232.619354 
	C444.014374,238.846420 445.571503,244.332245 448.964264,249.630203 
	C448.842682,250.120010 448.678833,250.253342 448.246246,250.218842 
z"/>
<path fill="#607584" opacity="1.000000" stroke="none" 
	d="
M444.185333,232.663406 
	C440.409424,232.801483 437.124664,234.023407 433.384949,234.943481 
	C432.566864,234.974426 432.135895,234.960403 431.381592,234.942535 
	C428.496002,233.083374 427.679077,231.639313 431.789215,230.880630 
	C433.692932,230.529236 435.672089,230.344406 437.723328,229.202637 
	C437.531189,226.221115 435.356873,227.269333 433.380127,227.008698 
	C433.061462,226.063507 433.347412,225.284729 434.714630,224.982300 
	C437.000519,224.709625 438.870941,223.570236 440.909454,224.200912 
	C444.294281,225.248108 448.216248,225.678711 448.754150,230.697571 
	C447.406372,231.444794 445.911621,231.932648 444.185333,232.663406 
z"/>
<path fill="#606569" opacity="1.000000" stroke="none" 
	d="
M437.557373,228.946045 
	C436.882996,232.218872 433.960663,231.821060 431.480591,231.955490 
	C427.992554,232.144501 431.293640,233.592926 430.997925,234.632111 
	C427.480591,236.608612 424.282776,235.819077 421.134766,233.123718 
	C425.872864,229.590134 431.612640,229.746613 437.557373,228.946045 
z"/>
<path fill="#5B5D62" opacity="1.000000" stroke="none" 
	d="
M447.983704,250.370667 
	C448.148834,250.038574 448.320221,250.026154 448.749084,250.000183 
	C451.625427,249.986664 454.244263,249.986664 456.863129,249.986664 
	C456.895935,250.152145 456.928772,250.317627 456.961578,250.483109 
	C455.529266,250.891052 454.096954,251.299011 452.328674,251.850479 
	C450.924255,251.992020 449.855865,251.990067 448.386200,251.978897 
	C447.986603,251.543243 447.988281,251.116806 447.983704,250.370667 
z"/>
<path fill="#636061" opacity="1.000000" stroke="none" 
	d="
M428.280151,227.858124 
	C428.206085,226.879471 428.351166,225.832718 429.898010,226.889130 
	C429.557983,227.388962 429.063965,227.642059 428.280151,227.858124 
z"/>
<path fill="#8EC1D2" opacity="1.000000" stroke="none" 
	d="
M335.381836,156.055450 
	C334.762970,152.542831 333.469696,149.965698 329.006470,149.869965 
	C327.866974,147.251266 329.514832,145.654343 331.275269,143.749603 
	C332.161438,143.087051 332.816528,142.753540 333.801392,142.263809 
	C335.180115,141.632248 336.186615,141.079910 337.194733,140.520096 
	C341.861023,137.928925 342.970520,138.512924 343.728027,144.223007 
	C343.685974,146.386841 342.408966,147.530685 341.415863,148.835373 
	C341.372162,148.892776 341.495209,149.162155 341.604065,149.228119 
	C341.727539,149.302963 341.922546,149.259842 342.390472,149.270630 
	C343.949829,149.497910 345.235626,149.198151 346.774170,149.657196 
	C347.454926,150.536148 347.155060,151.074173 346.340393,151.736618 
	C343.469818,153.014694 340.878448,154.108200 338.052429,155.452179 
	C337.123352,155.819092 336.428864,155.935516 335.381836,156.055450 
z"/>
<path fill="#44454A" opacity="1.000000" stroke="none" 
	d="
M356.457489,157.188812 
	C353.272766,156.086411 351.220886,154.496002 351.957581,150.594849 
	C352.236176,148.445404 353.643829,147.785599 355.024902,147.282394 
	C360.041718,145.454544 364.317810,142.247025 369.379517,139.734970 
	C370.183960,139.437164 370.664764,139.372696 371.501343,139.513214 
	C372.014008,139.793274 372.182556,139.961884 372.461548,140.467377 
	C372.646851,142.523453 371.468140,143.765137 370.719543,145.520203 
	C370.060608,146.518173 369.420410,147.098022 368.617554,147.953445 
	C367.812469,148.767471 367.207306,149.338608 366.481628,150.234039 
	C365.978821,150.790695 365.656525,151.075821 365.034424,151.511932 
	C361.304535,152.400909 360.003296,156.199417 356.457489,157.188812 
z"/>
<path fill="#5CA0BC" opacity="1.000000" stroke="none" 
	d="
M369.526978,139.652542 
	C364.884583,144.482117 358.819733,147.314545 352.247681,149.987610 
	C350.209290,150.766937 348.479279,151.346710 346.405243,151.923843 
	C346.295502,151.461899 346.529785,151.002594 346.829346,150.292511 
	C347.000885,149.094223 347.605896,148.464386 348.538757,147.690094 
	C349.544525,147.107941 350.356323,146.893402 351.422668,146.503174 
	C352.445099,146.143723 353.212280,145.974350 354.213135,145.590454 
	C354.653870,145.399353 354.828857,145.319611 355.261841,145.107086 
	C355.688538,144.873825 355.857269,144.773361 356.515930,144.315948 
	C357.339081,143.697891 357.676727,143.442657 358.288635,142.994110 
	C361.758301,140.811157 364.914978,138.702332 369.526978,139.652542 
z"/>
<path fill="#7AAABF" opacity="1.000000" stroke="none" 
	d="
M350.358215,166.265503 
	C351.600739,163.901825 353.142944,161.758362 354.783752,159.304764 
	C354.882355,158.994614 355.275940,158.835464 355.475281,158.762543 
	C357.437714,158.350723 357.645874,159.692291 358.051208,161.209503 
	C358.067749,161.791260 358.050415,162.020874 357.939209,162.574982 
	C357.620361,163.258316 357.357880,163.585388 357.046143,163.874100 
	C356.964111,163.950089 356.925049,164.093216 356.870483,164.254395 
	C356.815399,164.417145 356.872620,164.300720 357.305237,163.712219 
	C357.926331,163.289902 358.333862,163.153534 359.103973,163.077942 
	C359.903412,163.133942 360.340332,163.272476 361.024506,163.708710 
	C361.371094,164.169220 361.451355,164.394516 361.518280,164.981277 
	C360.388397,167.552780 358.441345,168.333359 355.789795,168.313751 
	C353.770294,167.853210 351.772461,168.438370 350.358215,166.265503 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M357.375549,163.120392 
	C356.917206,161.730194 357.335388,160.323990 355.996063,158.935944 
	C355.777008,158.343460 355.879425,157.997330 356.056213,157.390808 
	C359.226562,155.599396 359.903595,151.102936 364.310608,150.715240 
	C364.879120,150.791245 365.094330,150.897995 365.442078,151.340149 
	C364.389801,156.493301 361.087341,159.868546 357.375549,163.120392 
z"/>
<path fill="#44454A" opacity="1.000000" stroke="none" 
	d="
M355.242615,168.413879 
	C357.179169,167.305466 358.899445,166.454300 360.841370,165.365219 
	C365.046570,167.232376 363.121094,169.913559 361.421356,172.801834 
	C359.979767,173.134781 358.808136,172.904968 357.917175,174.299881 
	C355.850220,174.649185 353.924744,174.711395 351.583801,174.754761 
	C350.416199,174.201843 350.324677,173.472961 350.734253,172.297791 
	C352.285828,170.854279 353.656097,169.762711 355.242615,168.413879 
z"/>
<path fill="#607584" opacity="1.000000" stroke="none" 
	d="
M350.625305,172.057312 
	C350.970459,172.646454 351.025360,173.347061 351.124268,174.391785 
	C350.369354,174.840515 349.570435,174.945129 348.369446,175.016510 
	C348.756592,174.045135 349.545837,173.106964 350.625305,172.057312 
z"/>
<path fill="#72C2DC" opacity="1.000000" stroke="none" 
	d="
M342.042419,175.094269 
	C342.073853,174.570374 342.277374,174.316681 342.723969,174.002960 
	C343.231659,174.445358 343.496277,174.947784 343.865356,175.713409 
	C343.384674,175.772552 342.799591,175.568497 342.042419,175.094269 
z"/>
<path fill="#607584" opacity="1.000000" stroke="none" 
	d="
M347.768250,174.975189 
	C347.751373,175.093399 347.506042,175.220840 347.173431,175.194946 
	C347.086151,175.041611 347.539825,174.984451 347.768250,174.975189 
z"/>
<path fill="#A2CEDF" opacity="1.000000" stroke="none" 
	d="
M343.477722,145.493927 
	C342.847931,144.769806 342.361115,144.159882 342.364166,143.552429 
	C342.390198,138.384949 340.259247,139.424622 337.622711,141.859192 
	C336.857330,142.565948 336.012390,143.008575 334.588959,142.921432 
	C333.514465,142.954544 332.796814,142.984543 331.717590,143.056961 
	C330.352051,143.203171 329.398438,143.049026 328.251251,142.286652 
	C329.851990,138.588928 333.474518,136.663345 335.406982,133.218597 
	C336.222412,131.765060 337.144684,130.513458 337.026428,128.403381 
	C336.233887,126.849777 337.029785,125.972252 337.775024,124.798721 
	C338.279388,124.242065 338.581360,123.938446 339.110413,123.409676 
	C339.642853,122.880157 339.971130,122.601776 340.583618,122.154167 
	C341.623627,121.517250 342.294586,120.917046 343.404480,120.356400 
	C345.941101,119.886528 348.032837,120.757957 350.565430,120.909637 
	C357.698883,124.723343 365.071198,127.527519 370.411652,133.891327 
	C368.749542,137.186783 365.321289,136.168716 362.629150,137.732147 
	C360.599884,138.382751 358.933624,138.929337 356.815155,139.092041 
	C350.332733,136.570724 350.128021,136.636475 347.955872,142.135406 
	C347.004883,144.156357 345.902863,145.490723 343.477722,145.493927 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M278.450012,126.158691 
	C284.519897,122.622292 289.718262,117.112587 297.599487,116.036377 
	C306.282654,115.397789 314.559753,113.338112 323.249023,116.011955 
	C325.385254,118.112450 324.238312,119.296890 322.304016,120.638527 
	C320.908203,121.284325 319.849304,121.666000 318.450317,122.057907 
	C316.987000,123.015343 315.725128,123.760742 314.171631,124.752197 
	C311.978577,125.885429 310.256744,127.179718 307.649445,127.364403 
	C298.570068,128.999985 289.903809,128.788467 280.799133,127.333748 
	C279.774872,127.103416 279.239868,126.848839 278.450012,126.158691 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M327.688232,142.230331 
	C328.993713,142.093872 329.995544,142.165558 331.373688,142.214478 
	C332.214935,142.419128 332.483948,142.789017 332.460938,143.655792 
	C331.170074,145.722427 329.975464,147.434586 328.690674,149.485474 
	C324.148132,155.752838 319.544006,161.522217 312.366791,165.018509 
	C312.014008,164.303299 312.011230,163.527954 312.002106,162.362625 
	C312.912140,160.539337 313.828461,159.106049 314.792084,157.362946 
	C314.945374,156.617615 315.051392,156.182098 315.127838,155.409729 
	C316.304108,152.091141 316.282745,148.719666 318.087769,145.534775 
	C318.509857,144.193832 319.304626,143.828201 320.561798,143.690125 
	C323.226257,144.140594 325.284485,143.185654 327.688232,142.230331 
z"/>
<path fill="#7AAABF" opacity="1.000000" stroke="none" 
	d="
M305.245483,147.797699 
	C304.968475,147.573563 304.962555,147.129684 304.967346,146.352814 
	C304.748627,145.535797 304.519165,145.051788 304.171387,144.323273 
	C304.691650,142.615845 305.330170,141.152893 305.989044,139.347107 
	C305.792847,136.417221 306.613037,134.296982 309.132019,132.663361 
	C312.745209,132.700150 314.434631,129.555573 317.592072,128.858521 
	C317.674133,134.540817 314.261627,138.488937 310.294403,141.615631 
	C308.089294,143.353516 306.300995,144.926300 305.245483,147.797699 
z"/>
<path fill="#5B5D62" opacity="1.000000" stroke="none" 
	d="
M351.170959,121.746445 
	C348.583069,121.782967 346.239716,121.536018 343.511475,121.324059 
	C342.518433,121.674309 341.912384,121.994026 340.950928,122.362083 
	C339.239166,122.984650 337.922974,122.783989 336.372192,121.921051 
	C335.258331,121.346451 334.619202,120.291588 333.259888,121.201813 
	C332.917725,121.570717 332.776855,121.717964 332.389160,122.052597 
	C331.939545,122.286903 331.736786,122.333824 331.232483,122.295403 
	C330.436462,121.725609 330.548798,121.053688 330.228577,120.198059 
	C329.882599,119.867882 329.699799,119.804665 329.250916,119.625793 
	C328.338409,118.793266 328.302948,117.986588 328.922302,116.809784 
	C331.041595,115.412804 333.029999,115.691071 335.409607,115.883492 
	C338.652130,116.916855 341.628479,116.462349 344.912476,116.868439 
	C346.548981,117.222183 347.756165,117.660645 349.340820,118.155411 
	C350.366974,118.713028 350.815918,119.314293 351.285156,120.359467 
	C351.410431,120.963867 351.412933,121.213425 351.170959,121.746445 
z"/>
<path fill="#54BDE4" opacity="1.000000" stroke="none" 
	d="
M318.044556,128.704895 
	C315.247955,130.161118 314.141998,134.205032 310.065491,132.928711 
	C309.050507,131.381638 311.333893,129.884323 309.297913,128.558868 
	C308.398743,128.065186 308.035645,127.529984 307.973755,126.519653 
	C309.802765,125.412048 311.543396,124.631310 313.640289,123.728043 
	C315.002441,123.414543 316.017456,123.090813 317.155273,124.129944 
	C315.959473,126.203255 317.131165,126.474449 318.826508,126.848724 
	C318.768005,127.563957 318.467194,128.013351 318.044556,128.704895 
z"/>
<path fill="#4A4546" opacity="1.000000" stroke="none" 
	d="
M336.024628,127.513535 
	C335.070557,129.774277 333.245026,130.639862 331.392517,131.940521 
	C326.929199,133.442535 325.773102,131.606232 326.703033,127.320396 
	C327.499268,126.128006 328.111420,125.373047 328.907593,124.390549 
	C329.374695,123.743065 329.770935,123.494492 330.629578,123.401199 
	C333.057678,124.175858 335.211639,124.812553 336.024628,127.513535 
z"/>
<path fill="#BEDBE2" opacity="1.000000" stroke="none" 
	d="
M320.956055,143.418396 
	C320.183960,144.160919 319.471832,144.576813 318.462524,145.079346 
	C316.465820,143.457230 318.083496,139.151749 320.916199,138.303009 
	C322.203827,137.917191 323.667786,138.119858 325.251678,138.046310 
	C323.682617,139.915344 322.349335,141.503555 320.956055,143.418396 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M336.205444,127.904800 
	C335.060303,125.835304 332.736572,125.755959 331.144531,124.173645 
	C330.599304,123.499748 330.481293,123.037224 330.891602,122.257828 
	C331.171997,122.004288 331.641022,121.972900 331.875397,121.954971 
	C334.595093,120.606049 336.675720,122.274742 339.130981,123.181152 
	C339.386353,123.773392 339.414124,124.038040 339.279724,124.667397 
	C338.509277,125.845222 337.900970,126.658333 337.153503,127.746002 
	C336.834686,127.994194 336.654999,127.967827 336.205444,127.904800 
z"/>
<path fill="#606569" opacity="1.000000" stroke="none" 
	d="
M326.589600,127.058922 
	C327.010590,129.270248 326.713501,131.937973 330.703735,132.050186 
	C329.675354,133.833099 328.315308,136.486725 325.713684,133.947861 
	C323.481323,131.769302 323.595612,129.258850 326.589600,127.058922 
z"/>
<path fill="#A0F5FC" opacity="1.000000" stroke="none" 
	d="
M319.436951,127.047562 
	C318.534363,126.210365 315.846954,128.506973 316.852173,125.279633 
	C317.137390,124.847176 317.279053,124.662178 317.686707,124.703995 
	C320.440857,124.345375 322.929047,123.759933 325.920898,123.055984 
	C324.845856,126.863647 321.584564,125.661835 319.436951,127.047562 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M328.662018,116.804520 
	C328.986877,117.738464 328.985474,118.336082 328.984436,119.221909 
	C326.909637,120.003685 324.834503,120.497238 322.363220,120.946724 
	C322.616791,119.813972 323.266479,118.725288 323.960999,117.311035 
	C325.319183,115.725098 326.786072,115.750092 328.662018,116.804520 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M317.937378,124.571762 
	C317.952667,124.930809 317.483398,125.068016 317.239563,125.050095 
	C316.600464,123.916252 315.602203,123.926018 314.338715,123.698837 
	C314.819550,122.384102 315.990967,121.904388 317.769775,122.030495 
	C318.047516,122.782997 317.984802,123.497856 317.937378,124.571762 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M331.093109,121.703781 
	C331.117889,122.425140 331.063812,122.846001 330.987610,123.582870 
	C330.550018,123.964371 330.134491,124.029854 329.405273,124.129166 
	C329.372711,122.992317 329.653839,121.821625 330.000214,120.291023 
	C330.381714,120.421829 330.697968,120.912560 331.093109,121.703781 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M311.854309,165.073517 
	C311.974091,165.308914 311.790161,165.572327 311.276184,165.816467 
	C311.182037,165.579819 311.383514,165.347931 311.854309,165.073517 
z"/>
<path fill="#12628E" opacity="1.000000" stroke="none" 
	d="
M473.758026,368.046875 
	C474.007660,368.470337 474.004730,368.888428 474.002563,369.620361 
	C473.076111,371.040009 471.874176,371.857178 470.757355,373.018219 
	C471.808380,372.118561 472.716309,371.322388 473.820770,370.229919 
	C475.105225,370.005280 476.135040,370.013000 477.550720,370.036194 
	C479.965332,372.672943 477.529755,374.868286 477.075439,377.611298 
	C476.240448,379.036957 475.478424,380.040344 474.209869,381.084045 
	C471.702515,381.065857 469.679474,380.068207 467.108185,379.897522 
	C462.580170,378.782715 458.218903,378.484680 454.048706,376.222046 
	C453.013123,374.297119 453.222656,372.586487 453.702972,370.569946 
	C461.006378,372.060211 460.637970,365.976074 462.785126,361.972229 
	C463.380493,361.982269 463.701050,362.237732 463.711121,362.537689 
	C463.876221,367.448029 466.574951,368.659851 470.924561,367.559723 
	C471.394867,367.440765 471.912933,367.574127 472.700287,367.850677 
	C473.169128,368.023804 473.337311,368.032654 473.758026,368.046875 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M410.202606,372.379395 
	C411.147125,370.506104 412.562836,371.239075 414.034515,371.479156 
	C419.567352,372.381775 425.097778,373.460815 430.674164,373.894806 
	C438.000122,374.464935 438.018433,374.229614 438.001526,366.520874 
	C438.184235,365.790344 438.407562,365.539551 438.863342,365.161316 
	C439.366211,365.337311 439.670898,365.670929 439.992767,366.238098 
	C440.087738,366.690857 440.165497,366.910095 440.329681,367.467590 
	C440.445618,373.160828 440.445618,373.160828 448.408020,372.709656 
	C449.443359,373.445496 449.522308,374.188293 448.952942,375.322266 
	C444.041077,378.176819 438.964996,377.727203 434.072876,377.418732 
	C426.029694,376.911591 417.891296,376.490814 410.202606,372.379395 
z"/>
<path fill="#2A3743" opacity="1.000000" stroke="none" 
	d="
M472.995911,367.640564 
	C470.716125,369.691986 467.682007,369.560120 465.431458,369.395264 
	C461.355072,369.096619 463.472687,365.122223 463.087769,362.213074 
	C468.292999,360.624786 471.131073,362.209473 472.995911,367.640564 
z"/>
<path fill="#197AAB" opacity="1.000000" stroke="none" 
	d="
M449.407471,375.208832 
	C448.842194,374.369507 448.600250,373.861176 448.078308,373.278809 
	C444.412628,373.590210 442.610046,371.315186 441.003448,368.414062 
	C445.171997,368.558197 449.142456,369.331940 453.512665,370.186615 
	C454.066467,371.643005 455.479828,372.914154 454.125854,374.696350 
	C452.711029,376.227905 451.272034,376.279663 449.407471,375.208832 
z"/>
<path fill="#197AAB" opacity="1.000000" stroke="none" 
	d="
M437.070984,362.617310 
	C432.078156,358.898376 427.139435,354.764465 422.088928,350.310944 
	C427.183594,350.780243 429.760437,355.940247 434.290527,357.541901 
	C437.091675,358.532288 437.222473,360.020538 437.070984,362.617310 
z"/>
<path fill="#2B82AB" opacity="1.000000" stroke="none" 
	d="
M420.168457,348.858459 
	C414.863007,346.455139 411.038788,348.187592 407.705231,352.684082 
	C409.400604,346.187714 412.121429,344.996002 419.745117,347.728455 
	C420.138275,348.169128 420.255707,348.371338 420.168457,348.858459 
z"/>
<path fill="#2A3743" opacity="1.000000" stroke="none" 
	d="
M476.003815,361.371002 
	C477.471588,361.071198 478.031250,361.918762 477.998199,363.638031 
	C477.888733,364.312653 477.692810,364.574005 477.190979,364.881104 
	C475.780304,364.160889 476.047485,362.900055 476.003815,361.371002 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M464.135010,352.281250 
	C465.184631,351.953552 466.404785,351.838745 466.962646,353.643921 
	C465.835510,354.016937 464.936279,353.520172 464.135010,352.281250 
z"/>
<path fill="#197AAB" opacity="1.000000" stroke="none" 
	d="
M420.154938,349.369873 
	C419.974884,348.947357 419.986023,348.751373 420.009033,348.261169 
	C420.973480,348.062561 421.698608,348.505829 422.082703,349.690918 
	C421.456726,349.878418 420.901428,349.737396 420.154938,349.369873 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M468.172546,355.245056 
	C468.570404,355.166626 469.144440,355.341309 469.906952,355.761383 
	C469.513214,355.837250 468.930939,355.667694 468.172546,355.245056 
z"/>
<path fill="#2A3743" opacity="1.000000" stroke="none" 
	d="
M472.185150,358.257599 
	C472.574677,358.172943 473.120422,358.336151 473.826599,358.743774 
	C473.438477,358.827301 472.889923,358.666382 472.185150,358.257599 
z"/>
<path fill="#197AAB" opacity="1.000000" stroke="none" 
	d="
M439.396790,356.366516 
	C439.173218,356.889648 438.827637,357.150970 438.513153,356.515015 
	C438.766144,356.404388 439.019135,356.293732 439.396790,356.366516 
z"/>
<path fill="#197AAB" opacity="1.000000" stroke="none" 
	d="
M438.051819,364.703735 
	C437.668243,364.553894 437.321350,364.075134 436.975830,363.283936 
	C437.771667,363.103485 437.974640,363.703888 438.051819,364.703735 
z"/>
<path fill="#197AAB" opacity="1.000000" stroke="none" 
	d="
M438.791534,364.920349 
	C438.872223,365.295776 438.682892,365.587830 438.246948,365.977844 
	C437.972565,365.894104 437.944794,365.712402 437.946198,365.256592 
	C438.157471,364.933960 438.339508,364.885437 438.791534,364.920349 
z"/>
<path fill="#197AAB" opacity="1.000000" stroke="none" 
	d="
M440.229187,368.131531 
	C440.001556,367.697632 439.995087,367.452820 439.999268,366.839844 
	C440.311951,366.734924 440.613922,366.998230 441.058716,367.522980 
	C441.201508,367.784454 441.080658,367.914093 441.022491,367.980957 
	C440.792999,368.138733 440.621674,368.229675 440.229187,368.131531 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M467.101746,354.226990 
	C467.284607,354.173218 467.561707,354.350067 467.923767,354.764648 
	C467.668060,354.924805 467.397125,354.743225 467.101746,354.226990 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M444.573334,352.584473 
	C444.481049,352.646423 444.437958,352.408173 444.437958,352.408173 
	C444.437958,352.408173 444.665619,352.522552 444.573334,352.584473 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M446.420837,351.551208 
	C446.363953,351.472534 446.584473,351.446777 446.584473,351.446777 
	C446.584473,351.446777 446.477753,351.629852 446.420837,351.551208 
z"/>
<path fill="#2A3743" opacity="1.000000" stroke="none" 
	d="
M474.113586,359.230042 
	C474.336639,359.099884 474.594513,359.280334 474.888855,359.770050 
	C474.666443,359.900452 474.407471,359.720886 474.113586,359.230042 
z"/>
<path fill="#2A3743" opacity="1.000000" stroke="none" 
	d="
M475.112701,360.228943 
	C475.335358,360.098663 475.593964,360.279083 475.889099,360.769653 
	C475.666473,360.900269 475.407501,360.720215 475.112701,360.228943 
z"/>
<path fill="#2A3743" opacity="1.000000" stroke="none" 
	d="
M471.111938,357.167053 
	C471.335907,357.059082 471.590851,357.256195 471.886169,357.749695 
	C471.646637,357.884399 471.385437,357.693146 471.111938,357.167053 
z"/>
<path fill="#27303B" opacity="1.000000" stroke="none" 
	d="
M448.652039,374.940063 
	C450.448059,374.910583 451.811920,374.943329 453.586243,374.982483 
	C457.914124,377.028748 462.312286,377.327545 466.672302,379.006042 
	C466.755188,379.738281 466.652405,379.901733 466.350494,380.278259 
	C466.003479,380.619659 465.855591,380.747986 465.480835,381.064575 
	C464.433777,381.857452 463.889374,382.742859 462.806763,383.522888 
	C461.867310,383.874390 461.206940,383.889435 460.211182,383.665100 
	C458.033691,382.100403 456.261047,380.522766 453.801575,379.598938 
	C455.090942,381.130554 457.253754,381.029694 458.352356,382.969604 
	C458.549866,383.484924 458.594666,383.700684 458.620789,384.239563 
	C458.537811,384.762573 458.473541,384.962463 458.072021,385.660065 
	C457.604706,386.297577 457.474640,386.437408 456.951630,386.955688 
	C456.432465,387.453400 456.306244,387.572601 455.832336,388.053040 
	C455.275787,388.665619 455.089508,388.932648 454.815002,389.432678 
	C454.704132,389.649963 454.463593,390.077179 454.321136,390.277527 
	C454.178680,390.477905 453.852295,390.846344 453.673004,391.016296 
	C453.493713,391.186249 453.108307,391.497650 452.912415,391.648315 
	C452.458771,392.013977 452.218506,392.247223 451.484039,393.154602 
	C450.831573,393.950348 450.687103,394.086273 450.293518,394.404236 
	C449.859650,394.691193 449.674835,394.796143 449.195801,395.041626 
	C447.213989,395.674286 445.729523,397.290283 443.519958,395.827576 
	C442.515472,393.460052 442.273224,391.252380 441.743958,388.747040 
	C441.843231,386.125519 440.951874,384.013733 440.736694,382.621185 
	C440.698578,381.137451 440.060272,381.785370 440.160400,381.926392 
	C440.827393,382.865997 440.923035,383.963562 440.047852,385.288879 
	C434.892487,386.488159 430.192566,385.454010 425.722504,383.718658 
	C421.190308,381.959137 416.830566,381.138458 411.923157,383.551025 
	C410.884949,381.283966 410.234863,378.935120 409.369141,376.296387 
	C409.092010,375.265137 409.030518,374.523773 408.960449,373.410095 
	C408.860565,372.807587 408.769196,372.577362 409.004395,372.170013 
	C409.330933,371.992859 409.641388,371.996826 409.795959,372.003021 
	C422.555695,374.941193 435.171692,377.734741 448.652039,374.940063 
z"/>
<path fill="#0ABEFA" opacity="1.000000" stroke="none" 
	d="
M405.616516,359.623169 
	C405.401978,359.424896 405.216400,358.975952 405.017303,358.277161 
	C405.217682,358.475708 405.431580,358.924133 405.616516,359.623169 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M409.201569,371.943970 
	C409.265198,372.166168 409.199463,372.339447 409.042816,372.775269 
	C408.686371,372.837982 408.556061,372.571991 408.680420,372.043457 
	C408.799835,371.847137 409.072205,371.895050 409.201569,371.943970 
z"/>
<path fill="#88A7B5" opacity="1.000000" stroke="none" 
	d="
M361.046448,173.442657 
	C361.619171,170.600830 362.323792,168.146286 361.349945,165.355621 
	C361.056305,164.948547 361.049652,164.769806 361.041321,164.322754 
	C361.873718,163.423935 362.639832,163.579758 363.595795,164.618484 
	C364.643921,167.714996 364.737915,170.420044 363.613678,172.978455 
	C365.372650,171.447845 367.515839,171.504868 370.121552,172.188599 
	C371.822357,173.348175 371.052856,174.234222 370.052490,175.365143 
	C367.853638,176.403168 365.882141,176.895370 363.517792,177.190292 
	C362.666687,176.742935 362.180908,176.397400 361.383453,176.060959 
	C361.059692,175.319672 361.047668,174.569290 361.046448,173.442657 
z"/>
<path fill="#A2CEDF" opacity="1.000000" stroke="none" 
	d="
M368.801819,175.241165 
	C369.631073,174.537842 370.212830,174.072067 370.916077,173.350372 
	C371.450562,171.813522 372.391235,171.315216 374.090759,171.430206 
	C375.655151,172.258072 375.912537,173.310196 375.410797,174.921753 
	C374.888855,175.423462 374.615417,175.575760 374.182312,175.906464 
	C373.427917,176.562195 372.879303,177.097076 372.031250,177.707520 
	C370.729675,178.152267 369.688995,178.477615 368.332306,178.900528 
	C367.992828,178.721970 367.969421,178.445847 367.911682,177.755493 
	C367.816193,176.616165 368.041626,175.995239 368.801819,175.241165 
z"/>
<path fill="#607584" opacity="1.000000" stroke="none" 
	d="
M368.685181,174.998535 
	C368.777039,175.651855 368.504761,176.300079 368.054871,177.144806 
	C366.509827,178.098450 365.222473,179.187103 363.757538,179.541245 
	C361.015686,180.204071 363.399536,178.269150 363.065216,177.391495 
	C364.825531,176.267334 366.241486,174.811874 368.685181,174.998535 
z"/>
<path fill="#74909F" opacity="1.000000" stroke="none" 
	d="
M365.684082,180.996979 
	C365.733459,181.204910 365.539642,181.478989 365.088379,181.793884 
	C365.034271,181.577499 365.237549,181.320328 365.684082,180.996979 
z"/>
<path fill="#72C2DC" opacity="1.000000" stroke="none" 
	d="
M350.060730,181.042999 
	C349.847015,181.124725 349.620392,180.867661 349.304688,180.375977 
	C349.215607,180.141357 349.568878,180.068848 349.747803,180.052948 
	C349.967133,180.259445 350.007477,180.481827 350.060730,181.042999 
z"/>
<path fill="#8EC1D2" opacity="1.000000" stroke="none" 
	d="
M307.634766,126.143845 
	C308.320831,126.592384 308.579498,126.991982 308.956482,127.600571 
	C305.283539,131.277496 300.816284,129.886230 296.084198,129.714325 
	C290.283539,129.751785 285.037415,130.782791 279.407166,131.967285 
	C277.570007,132.316727 276.118530,132.526016 274.332153,132.889923 
	C273.836578,133.000076 273.675873,132.955612 273.272034,132.852234 
	C273.005371,131.112534 270.664978,130.572739 271.000916,128.361359 
	C270.985321,128.015503 271.002350,127.988503 271.016235,127.981155 
	C271.172546,127.835846 271.315033,127.697876 271.674713,127.356567 
	C272.082977,127.136253 272.274078,127.119286 272.752869,127.092987 
	C275.255066,127.902237 277.402496,127.757256 279.762268,126.443581 
	C289.101776,126.931396 298.161316,127.676193 307.634766,126.143845 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M296.060760,129.922821 
	C299.853821,129.248459 304.036316,128.627701 308.646790,127.908264 
	C310.162384,127.635620 311.250000,127.461670 312.522766,127.258118 
	C312.273224,129.300125 311.078522,130.626602 310.031433,132.370392 
	C307.944489,134.144012 307.444122,136.470947 306.251343,138.771088 
	C304.669189,138.380920 304.068268,137.335388 303.999084,135.853180 
	C303.915588,134.063919 304.754852,131.605499 301.027283,133.388504 
	C298.931213,134.391098 299.390839,129.361374 296.060760,129.922821 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M297.942566,138.678528 
	C297.064758,138.846436 295.831116,139.374222 295.513794,137.986038 
	C295.468262,137.786850 295.778076,137.351746 296.009125,137.270996 
	C296.968231,136.935776 297.578369,137.408112 297.942566,138.678528 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M298.897491,139.788513 
	C298.649445,139.936859 298.392609,139.748688 298.066956,139.279083 
	C297.943481,139.072311 298.006897,139.000885 298.043457,138.968887 
	C298.383270,139.067169 298.634583,139.263748 298.897491,139.788513 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M299.030914,139.977829 
	C299.365967,140.077377 299.619354,140.272018 299.895569,140.786316 
	C299.659515,140.923798 299.401245,140.736404 299.080383,140.260529 
	C298.960999,140.050385 299.005432,139.999817 299.030914,139.977829 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M300.018433,140.986328 
	C300.351532,141.083878 300.608612,141.275146 300.891113,141.785675 
	C300.658112,141.919113 300.399872,141.731201 300.088013,141.246964 
	C299.974640,141.032837 300.001984,141.000000 300.018433,140.986328 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M301.909515,142.958359 
	C301.987518,143.222824 301.604767,143.306503 301.420471,143.371521 
	C301.181396,143.203262 301.126617,142.969986 301.024017,142.380798 
	C300.976166,142.024857 300.998413,142.002090 301.010986,141.992111 
	C301.292908,142.219376 301.562195,142.456635 301.909515,142.958359 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M269.777832,112.178513 
	C270.066193,111.990959 270.527008,111.979340 270.757446,111.983185 
	C272.544037,114.936203 270.641449,117.082947 268.630676,119.688576 
	C267.526398,119.995232 267.070007,119.968193 266.271606,119.909424 
	C266.532288,117.097069 268.164398,114.804321 269.777832,112.178513 
z"/>
<path fill="#5CCBEF" opacity="1.000000" stroke="none" 
	d="
M267.797760,125.938057 
	C268.097443,126.494492 268.054321,126.986588 268.038208,127.851669 
	C267.475189,129.139954 266.716888,129.825668 265.291382,130.097641 
	C263.195679,128.833954 260.112274,133.381973 259.084656,128.494568 
	C260.598724,127.946671 262.064331,127.757454 263.804932,127.321503 
	C264.386963,126.447792 265.049896,126.552521 265.741760,126.121826 
	C265.918915,125.891190 266.364990,125.722389 266.593262,125.651848 
	C267.032684,125.678772 267.243805,125.776245 267.797760,125.938057 
z"/>
<path fill="#606569" opacity="1.000000" stroke="none" 
	d="
M263.176819,126.739853 
	C262.326569,126.735901 261.764069,126.583801 261.099976,126.143509 
	C261.162720,125.334221 261.327057,124.813118 261.733490,124.143250 
	C262.171661,124.570236 262.367767,125.145996 262.815125,125.901566 
	C263.199097,126.251480 263.331848,126.421600 263.176819,126.739853 
z"/>
<path fill="#5B5D62" opacity="1.000000" stroke="none" 
	d="
M283.209229,117.616348 
	C279.807434,120.336708 276.430328,122.351654 272.387024,123.886826 
	C269.308441,124.581276 268.992584,122.407425 268.135681,120.347740 
	C267.982819,120.022278 268.074341,119.870079 268.129944,119.800842 
	C272.766632,118.601128 277.602936,118.101730 281.572418,114.539726 
	C283.026337,115.178459 283.570129,116.038544 283.209229,117.616348 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M263.186523,126.936325 
	C262.889038,126.888008 262.996124,126.488144 263.031250,126.284760 
	C263.778839,126.008232 264.491364,125.935097 265.561401,125.876572 
	C265.503296,126.253624 265.087677,126.616051 264.376038,127.026619 
	C263.881317,127.044724 263.682648,127.014679 263.186523,126.936325 
z"/>
<path fill="#202731" opacity="1.000000" stroke="none" 
	d="
M411.548645,383.961548 
	C414.845215,379.331146 419.281708,379.463928 423.458557,381.430206 
	C428.504669,383.805634 433.885468,383.970123 439.563934,384.999634 
	C441.166656,385.500641 441.695190,386.544403 442.298767,387.954102 
	C441.794434,390.609924 442.952942,392.795807 442.988892,395.421387 
	C443.045807,396.466431 443.109283,397.164307 442.893890,398.198608 
	C442.713959,398.748749 442.620758,398.960541 442.331177,399.451721 
	C441.975830,399.887543 441.816864,400.044006 441.387329,400.387390 
	C440.377594,400.965668 439.570404,401.204590 438.586761,401.759125 
	C438.186249,402.038483 438.029266,402.152557 437.642365,402.441650 
	C437.110474,402.848114 436.802643,403.071503 436.256927,403.443298 
	C435.710907,403.793030 435.395477,403.983948 434.854248,404.328064 
	C434.483398,404.592133 434.336853,404.700470 433.969299,404.971466 
	C433.595520,405.236053 433.442749,405.337921 433.050262,405.575958 
	C432.483002,405.880219 432.153595,406.044495 431.576416,406.336426 
	C431.163879,406.553131 430.997223,406.638458 430.579163,406.850830 
	C429.825623,407.249084 429.317444,407.511078 428.679077,408.120239 
	C428.299927,408.463745 428.143127,408.600586 427.737762,408.935730 
	C423.402039,411.760315 427.902222,413.239105 428.432312,415.583496 
	C428.668793,416.345520 428.724091,416.796021 428.676880,417.590942 
	C428.140259,419.419128 427.440521,420.824615 426.667664,422.562988 
	C426.312256,422.997711 426.137268,423.143555 425.625366,423.346619 
	C425.068420,423.345459 424.848450,423.287048 424.342529,423.047485 
	C423.896423,422.710999 423.736328,422.555725 423.382019,422.132324 
	C422.396332,420.637909 422.238495,419.017487 420.602478,417.962219 
	C420.156586,417.634613 419.983795,417.491425 419.597107,417.081970 
	C418.903168,416.009247 418.616913,415.124786 418.267761,413.884979 
	C418.260437,411.869659 418.751190,410.224396 418.207001,408.258484 
	C417.983734,407.976746 418.001221,407.999115 418.006348,408.012360 
	C417.314728,407.301117 417.618256,406.338074 417.196655,405.240784 
	C416.984619,404.984161 417.001221,404.999298 417.003998,405.010193 
	C416.315460,404.296509 416.618256,403.336334 416.196838,402.241882 
	C415.985016,401.986176 416.001221,401.999146 416.003174,402.009338 
	C415.296295,401.264587 415.642609,400.252960 415.176025,399.104034 
	C414.985992,398.815216 414.983459,398.529907 414.985840,398.387238 
	C414.400635,397.438934 414.569275,396.477570 414.225586,395.306458 
	C414.012054,395.035187 414.000000,394.998779 414.012848,395.013123 
	C413.076447,392.646271 411.909973,390.333252 411.784607,387.326172 
	C411.748596,386.057587 411.655426,385.173950 411.548645,383.961548 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M392.597046,405.456055 
	C400.998688,401.136902 409.584198,403.099396 415.977661,411.401062 
	C418.347351,414.560760 417.310028,416.297089 413.824158,417.377258 
	C412.450348,417.184631 411.785248,416.468689 410.853973,415.544617 
	C410.096619,414.543793 409.809204,413.671112 409.114288,412.648102 
	C406.128174,408.411041 401.801880,407.356720 397.107788,406.327118 
	C395.557648,406.262726 394.352417,406.240051 392.597046,405.456055 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M412.563568,416.994385 
	C414.934021,416.093750 417.352112,415.543732 416.037445,412.076965 
	C416.182434,411.800415 416.336792,411.870178 416.728455,412.030884 
	C417.712006,412.382294 418.290558,412.844177 418.891541,413.724243 
	C420.010071,414.471436 419.971802,415.420044 420.155640,416.638489 
	C419.571625,418.057373 418.455872,418.552032 417.095825,419.305603 
	C414.945404,419.192383 412.576691,420.024170 412.563568,416.994385 
z"/>
<path fill="#197AAB" opacity="1.000000" stroke="none" 
	d="
M411.416901,387.203033 
	C413.034393,389.236237 413.794647,391.660614 414.026306,394.635254 
	C413.853088,395.047638 413.680511,395.067780 413.251770,395.039825 
	C412.133606,392.918518 411.271667,390.845306 410.348572,388.471985 
	C410.522278,387.936218 410.757141,387.700562 411.416901,387.203033 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M385.268372,413.019470 
	C384.601349,412.274902 384.287628,411.462677 383.995239,410.317841 
	C385.095062,409.312592 386.173553,408.639984 387.818756,408.184814 
	C388.826752,410.746429 387.279633,411.882782 385.268372,413.019470 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M419.087463,413.510010 
	C418.483704,413.482269 417.856140,413.058960 417.097137,412.378723 
	C418.191284,411.255096 417.925171,409.944336 417.979858,408.352325 
	C419.688782,409.406586 418.753754,411.391357 419.087463,413.510010 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M389.551788,407.290497 
	C389.392334,405.873138 390.194763,405.244934 391.682434,405.044342 
	C392.006500,405.028717 392.003510,404.993744 391.986694,404.992981 
	C392.470276,405.626373 392.187042,406.201538 391.601318,407.003967 
	C390.977112,407.452606 390.561310,407.575836 389.551788,407.290497 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M414.985809,399.175598 
	C415.899445,399.412018 416.009857,400.339081 416.008728,401.665039 
	C415.098755,401.424255 414.994720,400.499603 414.985809,399.175598 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M413.975464,395.385864 
	C415.045349,395.574036 415.013214,396.549225 415.006287,397.875671 
	C414.149292,397.613220 413.933929,396.720978 413.975464,395.385864 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M416.986206,405.327087 
	C417.963226,405.490173 417.982910,406.414368 418.010773,407.680481 
	C417.086090,407.494293 417.000671,406.597931 416.986206,405.327087 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M415.986938,402.326965 
	C416.971588,402.485260 416.993134,403.408051 417.010651,404.675995 
	C416.122498,404.472351 415.995422,403.596130 415.986938,402.326965 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M387.940369,407.935242 
	C387.997986,407.553009 388.204102,407.299896 388.748657,407.058838 
	C388.988892,406.990936 389.000824,407.001099 389.004700,407.006042 
	C389.202179,407.445221 389.098755,407.805725 388.416748,408.090179 
	C388.095795,408.078064 387.990723,407.984436 387.940369,407.935242 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M98.269249,297.116394 
	C96.626572,297.183411 95.251701,297.041565 93.465561,296.845032 
	C92.541489,296.454742 92.148041,296.026337 91.940857,295.122498 
	C91.968430,293.417603 92.041954,292.007568 92.164696,290.176636 
	C94.251411,289.028015 96.297150,288.316284 98.194046,286.601410 
	C98.999367,285.986725 99.586998,285.656067 100.543312,285.300842 
	C101.321884,285.146423 101.772331,285.139435 102.546585,285.275391 
	C104.047920,285.879639 105.112892,286.642975 106.661743,287.138245 
	C107.124268,287.404999 107.291504,287.540527 107.566322,287.980469 
	C109.304657,289.869019 111.488838,288.588745 113.629395,289.517670 
	C111.779533,291.092834 110.239677,292.753296 107.432892,293.115601 
	C103.858749,293.569611 100.182755,292.930084 98.269249,297.116394 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M99.066010,286.828430 
	C97.527245,289.090576 95.474945,290.065430 92.567780,289.838074 
	C92.890663,287.869080 95.606133,287.885010 96.053902,285.398895 
	C96.282814,284.936981 96.440132,284.794037 96.914551,284.693054 
	C98.028465,285.122162 98.616066,285.715485 99.066010,286.828430 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M97.189346,284.621887 
	C96.921768,284.939545 96.523796,285.012909 96.324646,285.046448 
	C95.876076,284.770630 95.626656,284.461273 95.127869,283.984253 
	C95.412369,283.273438 95.946220,282.730347 96.751884,282.090210 
	C97.630013,282.676910 97.722733,283.456970 97.189346,284.621887 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M91.708710,294.951447 
	C92.251144,295.285522 92.607376,295.743439 93.008942,296.495850 
	C92.880630,296.838013 92.706985,296.885620 92.264862,296.962708 
	C91.402489,297.184937 90.934288,297.019135 90.773567,296.127838 
	C91.085197,295.479340 91.273727,295.252289 91.708710,294.951447 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M90.665497,295.976074 
	C91.153740,296.063019 91.350548,296.369629 91.771881,296.834167 
	C91.996399,296.992157 91.966438,297.487762 91.939362,297.734558 
	C91.463615,298.248657 91.014931,298.515900 90.327332,298.888184 
	C89.870354,298.028748 89.756241,297.074890 90.665497,295.976074 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M93.178818,299.592957 
	C94.271202,299.359039 95.485779,298.446686 96.185783,299.574677 
	C96.338608,299.820984 95.105110,300.927582 94.254761,301.817871 
	C93.145622,301.532745 92.948952,300.786713 93.178818,299.592957 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M447.002411,470.003052 
	C446.910156,470.039215 446.815491,470.072266 446.857361,470.050354 
	C446.993896,469.995361 447.000000,470.000000 447.002411,470.003052 
z"/>
<path fill="#086AC0" opacity="1.000000" stroke="none" 
	d="
M435.254425,468.341431 
	C435.511383,468.096375 435.925781,468.072021 436.651428,468.066986 
	C436.962738,468.086304 436.978302,468.525116 436.971191,468.744049 
	C436.446655,468.829346 435.929230,468.695709 435.254425,468.341431 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M461.397278,449.055817 
	C455.974701,448.125275 451.611603,448.443085 448.201294,453.309631 
	C447.185394,454.759308 443.927155,455.563232 441.298981,454.173004 
	C438.980286,452.946503 438.841187,451.408966 439.732666,449.221039 
	C440.145538,448.207672 440.377380,446.672180 438.818848,446.319519 
	C436.237976,445.735504 437.766022,449.212189 435.903931,449.516235 
	C434.545227,448.925079 434.421906,447.400970 433.328186,446.210754 
	C432.909760,445.834442 432.752472,445.659943 432.716919,445.155884 
	C436.682190,443.203949 437.464142,438.744690 440.896210,436.263672 
	C446.418121,433.972412 446.192474,438.051880 446.876434,441.421417 
	C446.806213,442.327515 446.333221,442.787048 446.681580,443.366028 
	C447.289856,443.362122 447.630127,443.465240 448.169281,443.826294 
	C448.567383,444.395874 448.678284,444.783966 448.741028,445.495239 
	C449.848297,448.633911 450.187592,445.597961 451.141357,445.255280 
	C451.561005,444.835144 451.746979,444.683105 452.261536,444.375488 
	C453.551331,443.913635 454.527252,443.945190 455.874573,444.167786 
	C458.136597,444.901428 460.113007,445.356720 462.083130,446.757355 
	C462.591858,447.852356 462.516205,448.567871 461.397278,449.055817 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M461.005280,449.383575 
	C461.322510,448.527740 461.635284,448.051361 461.951904,447.275513 
	C461.944214,446.029144 462.378601,445.332214 463.477539,444.765686 
	C464.219208,444.828735 464.570831,445.063385 464.954376,445.712616 
	C463.898804,448.014038 462.739471,450.008545 461.302063,452.022095 
	C461.016235,451.281769 461.008514,450.522369 461.005280,449.383575 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M433.250488,444.737183 
	C433.057190,445.061707 433.038452,445.535431 433.052734,445.772186 
	C432.602692,446.016235 432.138306,446.023560 431.326721,446.012573 
	C431.468964,445.364960 431.958405,444.735657 432.717285,443.958740 
	C433.139038,444.011627 433.291412,444.212128 433.250488,444.737183 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M429.277191,447.002655 
	C429.440674,446.657776 429.914612,446.311768 430.696533,445.972778 
	C430.532227,446.320374 430.059937,446.660950 429.277191,447.002655 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M426.270691,448.984894 
	C426.444427,448.674866 426.925018,448.342743 427.714233,447.990112 
	C427.541077,448.300690 427.059296,448.631714 426.270691,448.984894 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M428.207214,447.917542 
	C428.152893,447.734558 428.340668,447.450958 428.770752,447.067871 
	C428.825134,447.251221 428.637207,447.534027 428.207214,447.917542 
z"/>
<path fill="#033E75" opacity="1.000000" stroke="none" 
	d="
M465.447632,446.010986 
	C464.775787,445.802612 464.493439,445.585724 464.101898,445.121643 
	C463.780548,442.033813 466.118286,440.816956 468.349152,439.069885 
	C470.469147,442.238647 471.893585,438.462097 473.671722,439.020874 
	C473.737122,439.492462 473.459137,439.973022 473.112732,440.753815 
	C475.281677,441.718048 475.203888,442.460693 473.012939,442.926361 
	C471.388977,443.271484 469.209595,442.404846 468.966431,445.565918 
	C467.913849,445.968781 466.875458,445.985596 465.447632,446.010986 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M485.663483,413.778748 
	C485.991699,414.144562 485.991943,414.312286 485.989655,414.731476 
	C484.174225,415.374695 481.408142,413.647308 481.015686,417.597046 
	C478.659912,418.605621 476.146881,419.040222 476.010376,422.627075 
	C474.498810,423.301697 473.691040,424.726318 472.012634,425.123230 
	C470.882568,424.142120 470.590668,423.027008 470.144165,421.610474 
	C469.782959,420.343536 469.987823,419.293823 469.186829,418.180634 
	C467.213776,418.712250 466.844604,421.111664 464.864990,422.080139 
	C463.391113,422.146790 462.558319,422.348358 463.457703,424.098206 
	C463.966553,425.831146 463.612244,427.087769 462.334686,427.790619 
	C458.418335,429.945160 458.372284,432.944855 460.395691,436.777405 
	C460.875641,439.122498 459.883575,440.339142 457.793030,441.149109 
	C455.553802,439.251251 453.889343,441.239716 451.800903,441.425446 
	C450.181152,440.289673 450.262177,438.564148 449.424927,436.911621 
	C449.327637,436.122223 449.395447,435.677185 449.760742,434.976501 
	C451.235748,433.747986 452.922668,435.059143 454.222534,433.924713 
	C453.947876,431.655884 451.343506,430.729279 451.062134,428.134277 
	C451.064026,427.326813 451.153534,426.876831 451.481659,426.144226 
	C451.987640,425.516144 452.383972,425.273224 452.783905,425.027313 
	C453.400330,424.648254 454.203583,424.718262 454.749817,424.186035 
	C454.010712,424.024292 453.237427,424.005707 452.259399,423.461792 
	C451.871979,423.057098 451.767426,422.850006 451.695984,422.294250 
	C454.207886,419.153198 457.405182,417.422821 460.751465,415.955231 
	C468.137451,412.716003 468.147736,412.739441 467.485291,404.311584 
	C467.729614,402.330566 467.494385,400.404846 470.101990,400.191284 
	C470.870880,400.953461 471.177826,401.600311 471.562683,402.602448 
	C472.080841,403.881348 471.680817,405.200012 473.269501,405.892365 
	C475.739777,407.388916 478.977356,408.052032 476.708862,411.937256 
	C476.290741,412.653442 477.536560,412.183533 478.372864,412.172760 
	C481.042511,412.083649 483.110779,413.186401 485.663483,413.778748 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M471.731934,425.299866 
	C473.986206,425.375214 471.444275,419.216400 475.732300,422.817261 
	C474.851685,426.188812 473.712250,429.383850 471.982300,432.476013 
	C470.383423,430.113251 470.385254,427.857727 471.731934,425.299866 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M480.991150,418.003967 
	C485.071503,419.817413 482.705658,421.714203 481.337128,424.577759 
	C479.751190,421.982941 481.481689,420.367859 481.033081,418.364532 
	C481.007660,417.978821 481.002930,418.002441 480.991150,418.003967 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M480.282959,432.796600 
	C479.832520,432.446869 479.665039,431.893738 479.243225,431.165955 
	C479.082764,429.486206 479.714142,428.303192 481.128571,427.155640 
	C482.616180,429.394379 481.532715,430.988159 480.282959,432.796600 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M471.997559,432.998322 
	C472.068695,434.706268 472.257416,436.447510 470.072327,437.556885 
	C468.876801,435.472076 469.475861,433.955261 471.608032,432.932343 
	C471.985779,432.990448 471.995087,432.996643 471.997559,432.998322 
z"/>
<path fill="#044371" opacity="1.000000" stroke="none" 
	d="
M479.789062,433.118256 
	C479.872833,433.433655 479.745697,433.867310 479.618561,434.300964 
	C478.913452,433.972412 479.294495,433.602600 479.789062,433.118256 
z"/>
<path fill="#033E75" opacity="1.000000" stroke="none" 
	d="
M473.992981,438.991333 
	C474.128113,439.082672 473.993927,438.199432 474.158875,438.953247 
	C474.015106,439.011902 473.999451,438.999359 473.992981,438.991333 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M469.998108,438.001587 
	C469.927612,438.349274 469.747223,438.619476 469.251404,438.934143 
	C469.028107,439.040100 468.984772,439.004120 468.958282,438.994537 
	C468.803650,438.532562 468.925934,438.162964 469.621002,437.915649 
	C469.943573,437.955170 469.980316,437.985657 469.998108,438.001587 
z"/>
<path fill="#044371" opacity="1.000000" stroke="none" 
	d="
M476.452515,436.546509 
	C476.413452,436.484100 476.491577,436.608887 476.452515,436.546509 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M476.448547,432.535583 
	C476.411102,432.475464 476.485992,432.595703 476.448547,432.535583 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M479.004150,431.005493 
	C478.906128,431.040253 478.804016,431.069550 478.845398,431.045074 
	C478.988861,430.991302 479.000000,431.000000 479.004150,431.005493 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M385.379822,467.175110 
	C385.196442,466.711700 385.172577,466.504974 385.097412,465.990417 
	C384.971069,465.463654 384.896057,465.244720 385.016968,464.738556 
	C385.929169,463.818787 386.770477,463.490875 388.050171,463.465210 
	C389.980652,464.483582 391.305939,466.003632 393.692505,466.136383 
	C394.179413,466.371887 394.359161,466.495789 394.738159,466.879578 
	C395.124878,467.643707 395.312378,468.147919 395.688751,468.846313 
	C396.260162,470.447388 396.642670,471.854279 397.023865,473.629486 
	C395.843994,474.526337 394.457916,474.794830 394.038452,476.677063 
	C392.517029,477.092072 391.220093,478.396210 389.453217,477.386017 
	C390.333344,476.001251 393.992950,474.546478 388.933197,474.123383 
	C386.661957,473.933441 388.308228,472.528961 388.234070,471.186340 
	C388.352173,470.260742 388.144684,470.072449 387.517700,469.932556 
	C386.714661,468.983307 386.081604,468.242310 385.379822,467.175110 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M394.005249,476.996002 
	C394.129944,477.054260 394.248352,477.117676 394.366730,477.181091 
	C394.262482,477.229248 394.158264,477.277405 394.020477,477.170471 
	C393.986938,477.015381 393.998932,477.001190 394.005249,476.996002 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M394.232819,466.683289 
	C391.858765,466.905273 389.318420,467.635864 388.309387,464.235229 
	C387.244049,463.278961 385.968842,463.441895 385.123199,462.229736 
	C384.845612,461.776489 384.740387,461.591858 384.491150,461.122864 
	C384.047821,460.039673 383.711426,459.273712 382.453735,459.012115 
	C382.313690,458.337250 382.483368,457.699127 382.653046,457.061005 
	C378.851288,457.451324 380.058777,452.943878 377.340393,451.909302 
	C377.063141,450.187012 377.416687,448.396576 375.150543,447.235962 
	C374.798035,446.799011 374.655426,446.653320 374.294342,446.288086 
	C373.946289,445.903992 373.816711,445.739380 373.525330,445.299957 
	C373.271637,444.830292 373.179779,444.635468 372.967285,444.137939 
	C372.152740,441.199646 371.108978,438.864410 367.842438,437.988159 
	C366.865295,430.375366 363.241272,424.118164 359.765533,417.876648 
	C357.907867,414.540833 356.541168,411.094666 355.207214,407.222992 
	C354.811920,406.712280 354.639191,406.470398 354.287689,406.102448 
	C353.658722,404.216553 353.207550,402.452789 352.779144,400.683502 
	C352.405029,399.138611 350.926971,397.171356 352.505951,396.114227 
	C354.195099,394.983307 355.931854,396.480835 357.561401,398.071960 
	C359.872314,401.836395 362.884613,404.793060 364.566254,408.898590 
	C366.681000,409.919556 367.734344,411.329346 367.953430,413.680237 
	C370.677704,421.159485 374.787598,427.601471 378.205322,434.391205 
	C382.594818,443.111450 387.128143,451.759338 391.815308,460.715576 
	C392.310394,461.273895 392.549957,461.585571 392.739471,462.223602 
	C392.728973,462.519562 392.748962,462.799194 392.860382,462.884277 
	C393.440887,463.396698 393.466919,464.007111 393.797699,464.801544 
	C393.966003,465.041931 394.003235,465.006012 393.978088,465.011749 
	C394.343658,465.386353 394.507782,465.837738 394.232819,466.683289 
z"/>
<path fill="#16202D" opacity="1.000000" stroke="none" 
	d="
M388.046143,408.407257 
	C388.413666,407.960388 388.662415,407.757843 388.925293,407.240692 
	C389.433441,406.982452 389.858307,406.953918 390.601685,406.897186 
	C392.768890,406.309082 394.726990,406.183960 396.766296,405.229858 
	C401.769684,406.058258 406.658020,406.881012 409.845367,411.697021 
	C407.848450,415.651093 404.142517,413.822296 400.797668,414.610474 
	C399.971069,415.294250 399.112915,415.190094 398.605804,415.715332 
	C399.226074,415.246582 400.052734,415.162018 401.016296,414.573547 
	C404.370087,414.889465 407.346558,413.225769 410.674377,414.721252 
	C411.885406,415.071991 412.693878,415.266449 412.917023,416.618256 
	C413.231873,419.043121 415.580902,417.647858 416.662415,419.063385 
	C418.364014,421.683228 416.095306,421.922791 414.776001,422.745667 
	C414.132233,422.907898 415.134674,423.525452 414.803955,422.946594 
	C414.668793,422.710022 414.738953,422.556580 415.018829,422.522705 
	C415.952606,422.409698 416.890472,422.091583 418.107941,422.810242 
	C418.652191,423.533752 418.782684,424.038910 418.739380,424.980988 
	C416.487213,429.124359 413.332062,427.032318 410.069855,426.629578 
	C403.003693,425.469788 396.329773,424.663513 389.164551,425.371094 
	C387.621796,424.635376 388.112335,423.289673 387.279236,422.204651 
	C386.688843,421.691010 386.466095,421.322601 386.488800,420.529358 
	C386.823059,419.837982 387.145386,419.545563 387.807556,419.149658 
	C388.772736,418.348206 389.684448,418.620941 390.710571,418.216248 
	C391.351990,417.678558 391.867126,417.552887 392.501434,417.317291 
	C392.631287,417.231110 392.716675,417.153534 392.596252,417.252136 
	C392.076019,417.522736 391.625427,417.554810 391.022003,417.963470 
	C390.107178,418.650879 389.259491,418.389343 388.267944,418.797058 
	C387.853851,419.108551 387.681915,419.226288 387.201111,419.402100 
	C386.690704,419.400299 386.489166,419.340424 386.238892,418.969025 
	C385.783295,417.040070 385.376434,415.422668 384.942291,413.446167 
	C385.942169,411.636871 386.969330,410.186676 388.046143,408.407257 
z"/>
<path fill="#10B2F6" opacity="1.000000" stroke="none" 
	d="
M368.282898,413.877045 
	C366.996216,412.575470 366.047699,411.125427 364.986084,409.364899 
	C368.219025,408.757904 369.309601,406.828766 369.038727,403.647003 
	C368.849426,401.423126 369.002197,399.170166 370.141144,396.702271 
	C371.729156,401.547150 373.317169,406.391998 374.946472,411.617004 
	C372.865540,412.574310 370.743317,413.151428 368.282898,413.877045 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M399.001953,434.995300 
	C398.917084,436.079346 398.830261,437.168915 398.727844,438.454376 
	C396.226166,436.861450 394.033722,435.465454 391.505188,434.020508 
	C390.460632,431.903412 389.752167,429.835205 389.065948,427.402649 
	C390.109863,424.874146 391.991974,424.933502 394.311005,425.308411 
	C395.729431,426.193481 395.382812,427.346802 395.773590,428.665771 
	C396.001404,428.983459 396.003662,428.997375 396.009186,429.001831 
	C396.677460,429.720886 396.388489,430.652771 396.787048,431.723206 
	C396.995697,431.971100 397.011200,431.992584 397.019287,432.003052 
	C397.185577,432.180206 397.343719,432.346893 397.751648,432.751099 
	C398.001404,432.988617 398.001221,432.998779 398.006378,432.999329 
	C398.428375,433.441223 398.471954,434.029358 398.819794,434.786469 
	C399.009735,435.000427 399.000000,435.000824 399.001953,434.995300 
z"/>
<path fill="#065486" opacity="1.000000" stroke="none" 
	d="
M395.240540,426.319672 
	C393.185638,425.982880 391.397461,425.703522 389.424377,426.870361 
	C389.005524,426.644348 388.922821,426.250458 388.798462,425.557526 
	C395.669678,422.229858 402.363342,425.254608 409.551178,426.024902 
	C410.096985,426.209717 410.231262,426.366119 410.186584,426.774658 
	C405.625977,426.664886 401.244324,426.302917 396.413300,425.948425 
	C395.818573,426.154266 395.673218,426.352631 395.240540,426.319672 
z"/>
<path fill="#10B2F6" opacity="1.000000" stroke="none" 
	d="
M385.989838,418.960388 
	C386.190186,418.657471 386.620667,418.776764 386.822998,418.871338 
	C387.164307,419.134521 387.303284,419.303101 387.301422,419.767609 
	C387.140381,420.487793 387.120148,420.912048 387.078613,421.655945 
	C385.444733,422.655182 385.066193,426.952362 382.043243,423.330200 
	C381.885742,420.355652 384.333618,420.315216 385.989838,418.960388 
z"/>
<path fill="#0BCCFD" opacity="1.000000" stroke="none" 
	d="
M377.955414,422.598816 
	C377.223114,422.199860 377.214203,421.796967 377.735718,421.439941 
	C377.845032,421.365173 378.098114,421.367126 378.204742,421.444366 
	C378.715515,421.814606 378.696411,422.217346 377.955414,422.598816 
z"/>
<path fill="#1391DB" opacity="1.000000" stroke="none" 
	d="
M394.248901,467.032562 
	C393.978271,466.555908 393.936890,466.116699 393.924194,465.347473 
	C394.299805,465.510162 394.646637,466.002838 394.965454,466.817505 
	C394.937408,467.139496 394.478119,467.069977 394.248901,467.032562 
z"/>
<path fill="#1391DB" opacity="1.000000" stroke="none" 
	d="
M393.991669,464.730194 
	C393.628845,464.559082 393.291718,464.076263 392.963196,463.281372 
	C393.320312,463.452362 393.668823,463.935394 393.991669,464.730194 
z"/>
<path fill="#1391DB" opacity="1.000000" stroke="none" 
	d="
M392.746094,462.217896 
	C392.495422,462.211212 392.261871,461.902893 392.029724,461.293671 
	C392.275116,461.300598 392.519165,461.608398 392.746094,462.217896 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M430.254456,437.710144 
	C426.286530,437.272705 424.877289,439.830688 423.322601,442.768829 
	C421.291077,440.376526 419.109772,441.545166 416.646423,442.378174 
	C415.877075,442.448761 415.448730,442.374817 414.768738,442.019165 
	C413.723694,441.110382 412.970886,440.363861 412.189026,439.223206 
	C411.987091,438.982605 411.998810,438.998352 412.005066,439.007355 
	C412.795074,437.190765 414.401245,437.135468 416.072845,436.991791 
	C422.164886,436.467926 422.244995,436.332764 419.481476,431.095276 
	C418.976257,430.137726 418.057617,429.398315 417.117981,428.281342 
	C417.274658,427.628876 417.710297,427.363892 418.594116,427.160492 
	C421.928162,427.659760 424.895844,427.609131 428.225891,427.402466 
	C428.783386,427.618469 428.984131,427.749817 429.326782,428.205444 
	C429.545288,430.161163 428.500427,430.713501 427.133667,430.941071 
	C425.687683,431.181885 424.298859,431.485992 424.058197,433.621063 
	C423.765381,438.287781 427.082092,436.638733 429.585205,437.039154 
	C430.170624,437.193329 430.334686,437.340424 430.254456,437.710144 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M419.354858,427.479736 
	C418.643341,427.842529 418.149658,427.906830 417.281067,427.987793 
	C414.789093,427.862122 412.672028,427.719757 410.281311,427.302094 
	C410.007660,427.026825 409.997253,426.539093 409.979980,426.296204 
	C412.504669,425.498993 415.255615,428.592987 417.839630,425.298279 
	C418.242371,424.880341 418.464111,424.776581 418.999146,424.866150 
	C419.722961,425.727081 419.786743,426.437134 419.354858,427.479736 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M394.964050,426.417267 
	C395.120239,426.054413 395.287231,426.020477 395.709106,425.971222 
	C395.981384,426.713196 395.998779,427.470459 396.008789,428.605591 
	C395.060425,428.512451 395.000885,427.637024 394.964050,426.417267 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M397.011841,431.636169 
	C396.056458,431.472748 395.979675,430.594604 396.000671,429.342926 
	C396.920929,429.520233 397.025757,430.388092 397.011841,431.636169 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M398.990265,434.702698 
	C398.683777,434.534271 398.357819,434.068115 398.021698,433.300903 
	C398.331268,433.468262 398.651031,433.936646 398.990265,434.702698 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M397.909698,432.763092 
	C397.662781,432.926086 397.398010,432.751556 397.117249,432.239288 
	C397.370636,432.067993 397.634186,432.242676 397.909698,432.763092 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M429.196228,429.168091 
	C429.001434,428.915802 429.024292,428.542603 429.032379,428.355804 
	C430.754272,425.738525 428.225098,423.050476 429.724365,420.336365 
	C434.666077,423.667267 439.913910,425.784576 446.228333,425.734802 
	C447.003754,425.563202 447.465973,425.545624 447.917572,425.450104 
	C447.751190,425.171753 447.387421,425.375061 447.035400,424.860229 
	C449.077637,420.586700 447.916412,415.563568 444.023071,412.456207 
	C443.261841,411.848663 442.211975,411.598633 441.789093,410.258301 
	C444.353729,407.894104 442.826874,404.993408 443.570251,402.239746 
	C443.950928,401.813568 444.154663,401.690887 444.717712,401.534027 
	C448.043671,402.723358 447.263367,406.248077 449.347778,408.455688 
	C449.649078,409.007629 449.753998,409.237854 449.976257,409.830444 
	C450.214203,414.018585 453.131165,417.221710 452.329041,421.520142 
	C452.129333,422.075836 452.146057,422.316132 452.217743,422.913483 
	C452.742157,423.972809 452.770782,424.711456 452.210114,425.780060 
	C451.968109,426.562622 451.971222,427.043671 451.957458,427.885162 
	C450.459229,430.067932 449.982391,432.220581 449.917084,434.833801 
	C449.966309,435.581909 449.983032,435.994080 450.009521,436.715515 
	C451.275909,438.988312 449.984161,440.794098 449.577576,442.976501 
	C449.300476,443.702148 449.013977,444.023041 448.310486,444.246277 
	C447.538818,444.177582 447.095306,444.129364 446.318054,444.055542 
	C445.857422,443.870605 445.730530,443.711304 445.727051,443.272522 
	C444.682556,440.826630 447.459839,435.986664 441.374664,436.967896 
	C440.132965,437.360657 439.732910,436.803650 439.319641,435.803528 
	C439.254944,434.105530 440.081970,432.543152 438.072540,431.382935 
	C437.558197,430.597046 437.749542,429.887695 437.338562,429.401093 
	C437.134552,429.159515 436.773041,429.309998 436.586365,429.643066 
	C436.066925,430.569824 436.916260,431.056915 437.417725,432.032043 
	C437.901184,433.928406 437.416626,435.327850 436.417847,436.961609 
	C435.686676,437.505798 435.189667,437.564026 434.349670,437.205994 
	C432.627289,436.186523 433.301880,434.507843 432.284729,433.215820 
	C430.927582,431.970612 430.360199,430.546600 429.196228,429.168091 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M439.644714,434.835266 
	C440.155457,435.534424 440.339478,436.101837 440.771667,436.846558 
	C439.832397,439.019470 437.803375,440.392639 437.790436,443.231995 
	C437.776428,446.309723 434.591125,442.907776 433.357849,444.908081 
	C433.041260,444.854156 433.025330,444.646637 432.998047,444.125122 
	C431.849609,441.408722 433.614227,439.598114 434.145782,437.273560 
	C434.473236,436.990601 434.916565,436.993744 435.692627,436.993713 
	C436.784576,435.741150 437.692505,434.705780 439.644714,434.835266 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M415.485565,442.015686 
	C417.074371,441.101471 418.462860,440.628296 419.685303,439.882812 
	C422.692047,438.049133 423.005524,439.890686 423.055481,442.599976 
	C421.160797,444.152191 419.262512,445.319580 417.176392,446.760101 
	C416.553741,447.013947 416.118988,446.994629 415.358459,446.953064 
	C413.678589,445.343781 414.163483,443.827484 415.485565,442.015686 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M428.761230,429.197449 
	C431.352142,428.772400 432.334045,429.910309 432.059387,432.598267 
	C429.522461,432.460541 426.925171,431.003571 424.377258,433.793762 
	C422.355377,432.998138 420.954895,431.897186 423.766022,430.672394 
	C425.243805,430.028534 426.929321,429.861481 428.761230,429.197449 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M430.267029,437.956543 
	C430.010132,437.932770 430.006134,437.488953 430.006348,437.267578 
	C430.486633,437.101593 431.132843,436.861603 431.205780,437.645050 
	C431.214172,437.734863 430.762390,437.867554 430.267029,437.956543 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M415.612122,441.646362 
	C415.515503,443.193268 415.269592,444.688049 415.028198,446.556824 
	C413.603699,447.637085 411.661804,448.937073 410.711060,447.357452 
	C409.729889,445.727356 408.129456,443.434692 410.641357,441.126343 
	C412.130707,440.952240 413.370148,441.756622 414.795776,440.920349 
	C415.173340,441.276733 415.302673,441.447174 415.612122,441.646362 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M414.947510,440.771118 
	C413.887054,442.096741 412.693512,443.048279 411.096436,441.190765 
	C411.223480,440.465668 411.514832,439.989136 411.896637,439.247620 
	C413.199005,438.961517 414.125397,439.488251 414.947510,440.771118 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M354.952209,407.352997 
	C359.691345,415.695404 366.057526,423.641968 367.722351,433.854279 
	C367.918915,435.059784 369.455780,436.070312 367.986664,437.709473 
	C368.002228,438.989319 367.614929,439.717957 366.396362,440.059692 
	C361.512024,429.529144 358.185852,418.652557 354.952209,407.352997 
z"/>
<path fill="#0A4271" opacity="1.000000" stroke="none" 
	d="
M366.093628,440.341400 
	C366.556854,439.426025 367.037262,438.875427 367.748566,438.170898 
	C371.673920,437.016968 373.276733,438.918365 373.418213,444.985779 
	C372.875549,446.908295 371.539429,447.629913 370.230469,448.795593 
	C370.019409,449.025146 370.005951,449.018127 370.005890,449.012817 
	C367.950378,446.595642 367.533356,443.414978 366.093628,440.341400 
z"/>
<path fill="#0BCEF8" opacity="1.000000" stroke="none" 
	d="
M321.765564,389.007751 
	C327.230347,399.136444 329.840698,410.549377 335.873749,420.473541 
	C336.985107,422.301636 337.950714,424.218353 339.055359,426.431458 
	C339.373962,427.204041 339.373169,427.630432 338.787354,428.234741 
	C337.223450,428.739685 336.285217,428.084320 335.126587,427.135681 
	C334.432129,426.451050 334.054962,425.931610 333.538452,425.132996 
	C333.174377,424.520447 332.979797,424.165100 332.642273,423.544800 
	C332.396759,423.106201 332.300385,422.929199 332.058899,422.483643 
	C331.813324,422.035309 331.712891,421.855499 331.453430,421.403137 
	C331.185516,420.944702 331.076599,420.758850 330.805176,420.287384 
	C326.630951,412.935913 320.492157,407.755280 314.819580,402.162994 
	C313.659149,401.019012 312.005493,400.298950 311.786346,398.105682 
	C313.534302,396.082855 315.437042,395.737213 317.834167,396.911224 
	C318.435760,397.299683 318.417633,397.826904 318.832520,397.955231 
	C318.930847,397.985687 319.012177,397.850708 319.023071,397.723389 
	C319.079651,397.059143 319.120728,397.960144 318.460327,397.266724 
	C317.926697,394.869934 319.496674,393.348480 320.156799,391.187622 
	C320.580566,390.241180 320.964722,389.671356 321.765564,389.007751 
z"/>
<path fill="#0BCEF8" opacity="1.000000" stroke="none" 
	d="
M318.955261,377.209778 
	C323.390747,376.825317 327.593170,376.710083 330.833923,380.682190 
	C327.950165,381.760742 328.752167,384.003784 329.554047,385.701050 
	C330.378754,387.446686 331.558594,389.396637 333.132568,390.349335 
	C338.821991,393.792877 339.142395,399.845428 340.791321,405.209747 
	C341.606903,407.863037 339.233490,408.444397 336.892487,409.096954 
	C331.233093,399.238007 326.465332,389.052765 320.120148,379.345581 
	C319.446503,378.599609 318.812805,378.247925 318.955261,377.209778 
z"/>
<path fill="#05E2FD" opacity="1.000000" stroke="none" 
	d="
M322.048950,388.471191 
	C321.881592,389.432892 321.693878,390.030334 321.254639,390.820007 
	C318.564056,390.491852 317.220154,388.493805 315.696594,386.858429 
	C312.741241,383.686157 309.384857,381.193085 305.023865,379.487549 
	C303.100464,377.390076 303.434937,374.260315 300.502319,372.783264 
	C299.648224,372.046844 299.274841,371.409698 298.944946,370.317261 
	C298.716125,368.920105 298.797516,367.914764 299.280334,366.598389 
	C302.866455,364.136627 304.199554,367.137970 305.743561,369.037903 
	C307.512817,371.214996 309.042236,373.392242 312.620911,371.541199 
	C315.298218,371.010925 315.792053,372.847534 316.760590,374.662354 
	C316.969757,374.965302 317.000000,375.000000 316.986145,374.982117 
	C317.408264,375.412872 317.470642,376.018280 317.831757,376.807190 
	C318.015106,377.039062 318.012024,376.994446 317.990173,376.989685 
	C318.441833,377.360901 318.551544,377.935913 318.805115,378.733063 
	C319.902710,382.045593 320.965668,385.076294 322.048950,388.471191 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M337.731903,428.296722 
	C338.269012,427.797729 338.563477,427.545593 338.992554,427.031128 
	C344.744537,434.884460 349.061523,443.752472 354.010437,452.654480 
	C355.055084,454.726166 355.994873,456.458923 356.999969,458.518616 
	C357.353577,459.432892 357.222443,459.903351 356.262848,460.159851 
	C354.231537,457.832001 352.609283,455.601196 350.763306,453.164124 
	C350.223083,452.414764 349.906616,451.871704 349.325439,451.162415 
	C345.903748,446.670258 342.746826,442.344330 338.984406,437.837097 
	C338.239471,437.500397 338.100067,437.344940 337.770386,436.937744 
	C336.961151,435.796936 336.379425,434.890137 336.173279,433.455933 
	C336.314148,431.512268 336.602600,429.940216 337.731903,428.296722 
z"/>
<path fill="#12628E" opacity="1.000000" stroke="none" 
	d="
M319.119995,379.010498 
	C318.520233,378.541107 318.200653,378.067291 317.924713,377.289185 
	C318.169220,376.914429 318.370117,376.843994 318.878235,376.862061 
	C319.425354,377.458984 319.665314,377.967346 319.932312,378.760803 
	C319.773010,379.032654 319.586639,379.019379 319.119995,379.010498 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M385.050781,467.209900 
	C386.707703,467.032745 388.172150,467.174072 387.986633,469.628235 
	C388.173035,470.162781 388.346680,470.334900 388.269287,470.774323 
	C388.018280,471.041656 388.007751,471.006836 388.024506,471.016296 
	C386.909943,471.049072 385.778595,471.072418 384.235016,471.207703 
	C383.416534,471.273621 383.010284,471.227631 382.314941,471.078583 
	C382.977631,469.817474 383.929443,468.659424 385.050781,467.209900 
z"/>
<path fill="#071A2D" opacity="1.000000" stroke="none" 
	d="
M384.218506,461.108154 
	C384.347137,460.838470 384.464386,460.878418 384.517487,460.910278 
	C385.984283,461.789215 385.566101,463.115997 385.212982,464.768860 
	C384.960388,465.178131 384.978577,465.435944 385.012329,465.559265 
	C383.990326,465.752167 382.934601,465.821747 381.481567,465.876526 
	C380.955139,463.608978 380.260345,460.977112 384.218506,461.108154 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M372.007385,449.352814 
	C372.425293,449.111908 373.105621,449.088196 373.309753,449.388336 
	C373.942688,450.318848 375.741211,450.640533 375.053589,452.231659 
	C374.886292,452.618835 373.907349,452.947632 373.397614,452.841644 
	C371.599243,452.467712 372.127747,450.931000 372.007385,449.352814 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M370.348450,449.019165 
	C370.009918,447.078949 371.758240,446.568848 373.090576,445.457336 
	C373.312531,445.377136 373.608368,445.282166 373.763489,445.290619 
	C374.122070,445.381561 374.325500,445.464020 374.775452,445.764832 
	C375.053894,446.147278 375.085815,446.311401 375.029175,446.710114 
	C373.763336,446.917999 372.870728,447.416992 372.102966,448.696442 
	C371.962799,448.987488 372.006866,448.996948 371.999695,448.974762 
	C371.554138,448.972778 371.115814,448.993011 370.348450,449.019165 
z"/>
<path fill="#19C7F4" opacity="1.000000" stroke="none" 
	d="
M356.027222,460.351807 
	C356.167145,459.831604 356.480499,459.600403 356.929565,459.107361 
	C357.396118,459.350403 357.726929,459.855286 358.058411,460.669403 
	C357.439606,460.866028 356.820129,460.753418 356.027222,460.351807 
z"/>
<path fill="#040E11" opacity="1.000000" stroke="none" 
	d="
M312.050629,397.630981 
	C317.578796,403.953674 324.042633,408.947906 329.035492,415.358490 
	C330.243103,416.909058 331.164703,418.682434 332.179382,420.720154 
	C329.756989,422.415100 328.379791,420.583008 327.079071,419.244690 
	C324.065948,416.144409 320.667542,413.552612 316.889832,410.845703 
	C313.309967,406.779877 308.876862,404.182526 305.249847,400.195648 
	C302.362427,396.719238 299.199677,394.152557 295.108032,392.267761 
	C292.381195,390.704926 290.074158,389.092163 287.597870,387.142761 
	C285.876892,385.995300 284.652405,384.716034 282.783417,383.767517 
	C279.661041,382.059631 277.088165,380.221985 275.272888,377.045593 
	C272.072449,374.976807 270.148712,372.031952 267.759918,369.377747 
	C270.834930,367.428009 272.907257,369.591675 274.993927,370.910004 
	C280.967773,374.684113 286.809052,378.667633 293.491913,381.949158 
	C295.539917,382.899475 297.095795,383.983032 299.004578,385.162354 
	C303.422516,389.439117 308.639893,392.361359 312.050629,397.630981 
z"/>
<path fill="#09D3F7" opacity="1.000000" stroke="none" 
	d="
M294.227417,383.201263 
	C288.772827,381.810364 284.640442,378.416656 280.151367,375.670959 
	C276.343903,373.342163 272.947632,370.320282 268.254730,368.955505 
	C267.889160,369.037659 267.996582,369.001953 268.014648,369.055603 
	C267.841309,368.765381 267.545654,368.626068 266.893311,368.718323 
	C263.881195,366.659790 261.135315,364.547150 258.213074,362.151581 
	C256.467865,359.535858 254.909195,357.200958 256.794403,353.909363 
	C257.302338,353.648468 257.473175,353.702362 257.833374,353.946808 
	C258.265747,354.350250 258.522766,354.544556 259.014404,354.819336 
	C270.519379,360.607910 280.123016,368.754242 290.907806,376.145203 
	C291.747589,376.253174 291.929138,376.352234 292.346375,376.651855 
	C293.020172,377.287109 293.442871,377.737732 294.156433,378.340881 
	C294.552826,378.692017 294.705719,378.841553 295.197632,379.545685 
	C295.576691,380.317322 295.616730,380.534393 295.632904,381.083557 
	C295.430786,382.081757 295.076508,382.630646 294.227417,383.201263 
z"/>
<path fill="#0BCEF8" opacity="1.000000" stroke="none" 
	d="
M256.918945,353.345520 
	C256.607178,356.175171 257.409424,358.602966 258.013885,361.462433 
	C244.573517,351.581116 231.527466,340.741180 217.242523,330.976959 
	C217.002106,330.237244 217.209290,329.872070 217.910553,329.745697 
	C230.460556,338.596313 243.800659,345.486267 256.918945,353.345520 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M218.098938,329.652832 
	C217.902359,329.993561 217.610962,330.148132 217.178040,330.533478 
	C207.028687,324.229675 197.440521,317.186829 187.706421,309.787720 
	C187.449585,309.299286 187.424927,309.045990 187.734299,308.611023 
	C189.363785,308.088806 190.521210,308.544647 191.990875,309.215424 
	C197.779190,312.839569 202.721161,317.038849 208.398712,320.804565 
	C211.327621,323.255707 214.608994,324.756897 216.725784,328.061310 
	C217.191605,328.741974 217.585495,329.081024 218.098938,329.652832 
z"/>
<path fill="#0CA3DE" opacity="1.000000" stroke="none" 
	d="
M186.066254,308.248596 
	C178.591049,302.960510 171.464798,297.812744 164.147934,292.393982 
	C163.632950,291.716187 163.474564,291.252838 163.618011,290.382263 
	C165.343582,289.126801 166.665085,290.014099 167.861557,290.822205 
	C174.565964,295.350403 180.759949,300.556458 187.149841,305.502319 
	C187.814911,306.017090 188.190796,306.768585 188.078156,307.964661 
	C187.410629,308.445648 186.916840,308.477600 186.066254,308.248596 
z"/>
<path fill="#DEF9F9" opacity="1.000000" stroke="none" 
	d="
M275.065247,377.172028 
	C277.998657,378.053253 279.477448,381.329987 282.874939,382.493958 
	C283.981262,384.395264 283.383942,385.448334 281.389282,386.079193 
	C278.759033,385.009918 276.550110,383.997101 274.120728,382.760986 
	C274.277954,380.888763 274.655670,379.239807 275.065247,377.172028 
z"/>
<path fill="#19C7F4" opacity="1.000000" stroke="none" 
	d="
M164.004211,289.543640 
	C164.011948,290.386292 163.995560,290.882355 163.968246,291.750702 
	C158.612762,288.718445 153.268204,285.313934 147.805344,281.574036 
	C147.757492,280.763519 147.962021,280.352600 148.566193,279.790771 
	C149.072647,279.514465 149.294724,279.444275 149.864655,279.365356 
	C152.087891,279.710449 153.252823,281.293243 155.193176,282.216919 
	C158.457245,284.483276 162.145798,285.687500 164.004211,289.543640 
z"/>
<path fill="#2CF2F7" opacity="1.000000" stroke="none" 
	d="
M149.098907,279.569397 
	C148.760696,280.271027 148.503922,280.602997 147.967087,281.086853 
	C147.302887,281.194824 146.918716,281.150940 146.244049,281.132568 
	C144.884384,280.432465 143.815247,279.706818 142.427170,278.928406 
	C142.108246,278.875641 141.734924,278.687653 141.539047,278.619171 
	C141.117157,278.319153 140.849518,278.155914 140.311035,278.005157 
	C139.684784,277.564423 139.287735,277.179504 138.646667,276.653931 
	C138.190979,276.302307 137.962372,276.111572 137.529663,275.821503 
	C137.278564,275.544464 137.214661,275.386993 137.044266,274.995605 
	C137.002182,274.191284 137.066605,273.620911 137.210388,272.625854 
	C142.005295,273.256378 146.102097,275.362793 149.098907,279.569397 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M185.866760,308.359131 
	C186.186600,308.086395 186.655899,308.064453 187.477417,308.034851 
	C187.829651,308.027191 188.269623,308.058136 188.393921,308.240295 
	C188.346405,308.612366 188.174591,308.802246 187.738525,309.272339 
	C186.988251,309.238373 186.502243,308.924133 185.866760,308.359131 
z"/>
<path fill="#040E11" opacity="1.000000" stroke="none" 
	d="
M266.941223,369.012329 
	C267.033112,368.753479 267.439148,368.734528 267.938965,368.912415 
	C267.773590,369.156921 267.514435,369.204590 266.941223,369.012329 
z"/>
<path fill="#3EE8F8" opacity="1.000000" stroke="none" 
	d="
M287.592926,386.285004 
	C290.215881,387.921356 292.518829,389.620605 294.867157,391.649231 
	C293.706421,391.950195 293.125153,392.825745 292.249451,393.816711 
	C289.426361,392.207001 286.857819,390.424103 284.126495,388.343323 
	C284.702637,386.769806 285.856934,386.303833 287.592926,386.285004 
z"/>
<path fill="#A0F5FC" opacity="1.000000" stroke="none" 
	d="
M287.687653,385.978821 
	C286.807709,386.795685 285.702454,387.369263 284.280457,387.994141 
	C283.079254,387.539856 282.194794,387.034210 281.139160,386.275635 
	C282.060852,385.499420 282.838318,384.726959 283.030334,383.118896 
	C284.533783,383.762939 285.998047,384.749237 287.687653,385.978821 
z"/>
<path fill="#5CCBEF" opacity="1.000000" stroke="none" 
	d="
M280.676239,392.900208 
	C280.976227,393.533508 280.972076,394.008698 280.950806,394.840332 
	C280.513550,395.445648 280.059387,395.566620 279.224945,395.467743 
	C276.964172,393.346924 274.002441,392.443481 272.872375,389.353119 
	C276.203979,388.753510 278.013000,391.293610 280.676239,392.900208 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M272.990723,389.009460 
	C274.975647,390.692230 276.969604,392.366364 279.188904,394.279053 
	C279.450073,394.749359 279.485901,394.981110 279.210022,395.374146 
	C278.430145,395.580322 277.970398,395.539734 277.264648,395.162903 
	C277.008759,394.926727 277.008240,394.994354 277.040466,394.984131 
	C276.803345,394.783539 276.557678,394.566345 276.164703,394.145142 
	C275.993744,393.967926 275.995575,394.007416 276.014221,394.000916 
	C275.320404,393.445068 274.514557,393.025146 273.657837,392.135071 
	C272.552277,391.132812 271.633820,390.411804 270.518738,389.478088 
	C270.773071,388.397034 271.508240,388.357727 272.660217,388.799438 
	C272.988617,389.022552 272.999756,389.000824 272.990723,389.009460 
z"/>
<path fill="#5CCBEF" opacity="1.000000" stroke="none" 
	d="
M272.896545,388.689178 
	C272.309631,389.010010 271.630676,388.997437 270.636902,389.125122 
	C269.957397,388.759949 269.592712,388.254547 269.182739,387.358093 
	C270.640106,386.689758 271.887238,387.087189 272.896545,388.689178 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M268.989258,387.097595 
	C267.404388,387.517609 266.178314,387.089874 265.382477,385.470001 
	C266.852509,384.741516 267.756165,386.078491 269.021667,386.643646 
	C269.137451,386.967072 268.991913,387.020172 268.989258,387.097595 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M273.084717,391.894836 
	C274.261810,392.381866 275.052826,392.909943 275.938385,393.716248 
	C275.595520,394.004150 275.158112,394.013885 274.391937,394.002136 
	C273.464203,393.488342 272.865295,392.996063 272.096924,392.265076 
	C272.184509,391.996185 272.441589,391.966034 273.084717,391.894836 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M290.955811,398.676331 
	C290.074799,398.935822 289.312073,398.659210 289.036316,397.321167 
	C289.907898,397.070831 290.690063,397.321960 290.955811,398.676331 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M292.656525,398.998077 
	C292.986572,399.003296 293.016388,399.486877 292.992004,399.763794 
	C292.419067,399.862579 291.870514,399.684448 291.164093,399.257599 
	C291.446289,399.003540 291.886383,398.998199 292.656525,398.998077 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M287.835938,395.758728 
	C287.450623,395.830109 286.897614,395.656647 286.174988,395.240051 
	C286.559662,395.169281 287.113983,395.341614 287.835938,395.758728 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M285.895752,394.782410 
	C285.688629,394.895844 285.434204,394.714905 285.134399,394.239441 
	C285.344055,394.123718 285.597229,394.304749 285.895752,394.782410 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M288.890625,396.781921 
	C288.669006,396.908691 288.404297,396.722473 288.100403,396.219910 
	C288.318726,396.100311 288.580841,396.288788 288.890625,396.781921 
z"/>
<path fill="#08101D" opacity="1.000000" stroke="none" 
	d="
M225.566360,401.567200 
	C232.286438,404.114685 235.903610,410.579102 242.089523,413.834717 
	C242.418976,414.008148 242.696274,414.702332 242.646835,415.111694 
	C241.674393,423.166016 247.779602,425.188568 253.635437,427.848083 
	C254.733582,430.127380 253.602081,431.347198 251.529114,432.350677 
	C249.509979,432.099426 247.989349,431.261688 245.917419,431.160522 
	C241.934265,429.935638 239.030014,428.124603 237.889496,424.077301 
	C237.025833,421.012482 233.201309,421.138824 231.481140,418.933990 
	C229.744339,416.707886 223.858643,416.462372 227.727463,411.389130 
	C227.918991,411.137970 227.112122,411.088318 226.821945,410.857971 
	C223.772064,408.436768 224.741257,405.232849 225.566360,401.567200 
z"/>
<path fill="#08101D" opacity="1.000000" stroke="none" 
	d="
M203.190125,385.162903 
	C202.724808,384.406952 202.465683,383.950256 202.105835,383.250793 
	C202.025955,381.064545 203.554733,381.031372 204.747192,381.199158 
	C207.612793,381.602417 210.581802,381.315552 213.678726,382.714935 
	C213.586975,387.573303 215.782806,390.655273 219.331360,393.244690 
	C221.936111,395.145355 224.505295,397.231415 225.969864,400.647766 
	C226.007690,400.991455 225.998505,401.002502 225.995422,401.007935 
	C224.883865,403.550446 225.776047,406.218506 225.463593,409.198364 
	C221.603470,412.150421 219.437012,408.912292 217.086182,406.971832 
	C215.340637,405.530975 214.414963,403.215607 212.137558,401.679962 
	C209.587570,395.817780 207.139908,390.296906 203.190125,385.162903 
z"/>
<path fill="#08101D" opacity="1.000000" stroke="none" 
	d="
M194.947266,372.390442 
	C194.927383,369.582428 196.696594,367.177917 195.054352,364.356995 
	C201.921738,368.110657 206.917130,374.213318 211.971436,380.638306 
	C208.526154,382.656891 206.071259,380.576660 203.611389,378.635956 
	C201.431641,376.916290 199.635254,374.627838 196.327576,373.957153 
	C195.513733,373.574280 195.156082,373.224548 194.947266,372.390442 
z"/>
<path fill="#061426" opacity="1.000000" stroke="none" 
	d="
M195.749115,373.330414 
	C198.526550,372.627289 200.406860,373.672119 202.086349,375.539917 
	C204.549667,378.279419 207.496231,380.323730 211.634171,380.944580 
	C213.111359,381.219421 214.228760,381.403503 215.302551,381.730774 
	C215.597443,381.820648 215.761902,382.338593 215.986206,382.660095 
	C215.532425,382.775757 215.078613,382.891418 214.317932,383.012512 
	C210.174576,382.829132 206.338120,382.640381 202.253387,382.729828 
	C201.522781,382.749023 201.040466,382.490021 200.308289,382.117889 
	C196.321365,380.427887 195.492065,377.270325 195.749115,373.330414 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M250.664490,432.122437 
	C252.604736,431.416229 252.935989,429.814331 253.848450,428.295746 
	C254.095154,427.729828 254.280991,427.504059 254.709030,427.220886 
	C254.905121,427.125549 254.937668,427.095398 254.930191,427.077332 
	C256.235016,428.274292 255.809158,429.621185 255.033356,431.263550 
	C252.533295,432.526001 255.517059,432.570038 255.182709,433.538269 
	C255.095963,434.052521 254.966354,434.236053 254.556381,434.610962 
	C253.659470,435.111877 253.008057,435.325958 251.999573,435.567902 
	C250.911102,435.639801 250.271088,435.409027 249.648651,434.496460 
	C249.469177,433.393005 249.772629,432.774078 250.664490,432.122437 
z"/>
<path fill="#11141B" opacity="1.000000" stroke="none" 
	d="
M115.813644,259.228882 
	C115.996597,259.003326 115.988640,258.567261 115.985161,258.349213 
	C116.136375,257.939850 116.291061,257.748566 116.738861,257.781433 
	C117.347565,258.114594 117.602486,258.304840 117.902580,258.793701 
	C119.200569,259.920319 120.876518,260.342255 121.112999,262.479065 
	C121.126297,269.445343 123.295380,275.325775 128.328506,279.675842 
	C131.105316,282.075806 132.531586,284.512634 132.021011,288.162354 
	C131.323730,293.146698 134.613663,296.967041 136.207855,301.247711 
	C138.128281,306.404419 141.873978,310.581696 144.810898,315.193604 
	C145.335693,316.017700 146.059235,317.068115 146.886520,317.292145 
	C155.110977,319.519287 155.519470,328.029388 159.960846,333.651794 
	C159.827103,334.005707 159.656845,334.007721 159.231201,334.014404 
	C158.549667,334.371948 158.086426,334.666504 157.185089,335.003052 
	C153.289536,334.669525 149.691605,334.646637 146.305817,332.279663 
	C143.002060,331.873077 142.412598,329.482361 141.289871,327.138672 
	C140.989410,326.967987 140.993347,327.008636 141.013702,327.009003 
	C140.074402,326.185577 139.773468,325.019714 139.304535,323.552673 
	C138.813019,320.651276 137.560165,318.790466 135.128906,317.638397 
	C133.214935,316.731445 131.758499,315.176666 130.255585,313.232605 
	C130.017624,312.545105 130.015121,312.102417 130.012665,311.327698 
	C131.455521,303.968109 124.696159,304.332336 121.234726,301.256500 
	C121.739006,293.031067 122.476578,285.063354 123.287354,276.304840 
	C120.543709,279.604340 123.040588,284.580688 119.066269,285.628754 
	C116.273132,286.365387 112.735481,287.675995 109.487671,285.021423 
	C108.206970,283.848480 108.831512,282.483276 108.567612,280.928223 
	C108.683563,280.158722 108.850189,279.744171 109.243042,279.057037 
	C110.824829,276.115112 111.591309,273.219055 112.816589,270.133606 
	C113.000565,269.838318 112.987762,269.488922 112.985413,269.314117 
	C113.884422,268.078125 113.330505,266.765961 113.800522,265.288147 
	C114.006653,264.981476 114.001518,265.000763 113.994133,265.007446 
	C114.719292,264.288055 114.489891,263.391479 114.216568,262.269592 
	C114.094749,261.696564 114.270035,261.436279 114.742508,261.123260 
	C115.412292,260.594421 115.508675,260.018860 115.813644,259.228882 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M169.789017,337.709229 
	C166.541275,338.234894 163.353394,337.361420 160.200134,335.247009 
	C163.356155,335.112213 166.592255,335.759949 169.789017,337.709229 
z"/>
<path fill="#3694BC" opacity="1.000000" stroke="none" 
	d="
M121.219818,262.922424 
	C120.062698,261.731171 119.073441,260.657227 118.046295,259.297119 
	C120.290192,258.338715 121.297775,260.341339 122.980606,261.594482 
	C122.850395,262.197388 122.544289,262.501495 122.206306,263.033813 
	C121.894745,263.249542 121.632484,263.175446 121.219818,262.922424 
z"/>
<path fill="#071F39" opacity="1.000000" stroke="none" 
	d="
M195.766846,372.900391 
	C196.710342,376.036072 197.538651,379.015625 199.888550,381.698608 
	C195.409424,381.835205 191.686401,379.191895 187.350250,377.197052 
	C184.026306,374.343262 179.989410,373.806702 176.201813,371.944885 
	C175.439606,371.668091 175.001556,371.515137 174.263626,371.192627 
	C173.971451,371.001221 174.005173,370.989807 174.009216,371.007141 
	C172.979721,370.167450 171.452637,370.433319 170.225159,369.244141 
	C169.363739,368.537140 168.744736,368.052032 167.942078,367.327820 
	C171.924164,365.638855 176.246231,368.132111 180.688416,366.300232 
	C183.136398,366.667511 184.974747,369.181763 187.671310,366.633270 
	C188.700867,365.660309 189.575348,367.306854 190.130737,368.309540 
	C191.077377,370.018677 191.658646,372.130219 194.623413,372.001923 
	C195.096527,372.329834 195.282425,372.589172 195.766846,372.900391 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M168.950134,358.655884 
	C164.212143,357.372711 159.441727,355.729462 154.289963,354.066589 
	C153.225571,353.348907 152.542542,352.650818 151.607452,351.812073 
	C151.741196,350.186157 148.962143,348.855865 151.454651,347.265564 
	C151.955765,347.301849 152.142731,347.355316 152.247147,347.129059 
	C152.164581,346.849304 152.090652,346.418976 152.048798,346.204712 
	C152.141373,343.304291 154.148834,344.107483 155.589264,344.197540 
	C157.520401,344.318329 159.342987,345.250031 161.678070,345.058685 
	C164.508087,345.020447 166.994583,344.992279 169.472412,345.125488 
	C170.732483,345.193207 171.656250,345.928284 171.764420,347.298462 
	C171.843781,348.303955 171.152359,348.661285 170.283005,348.936401 
	C168.677063,349.444611 165.954956,347.879028 165.583725,350.230560 
	C165.246155,352.369110 166.538025,354.679932 168.019394,356.558044 
	C168.415894,357.060730 168.623413,357.712494 168.950134,358.655884 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M156.609543,334.252563 
	C157.377045,334.032867 157.834045,334.021027 158.633423,334.014099 
	C156.895050,337.355194 159.585739,340.163666 160.003204,343.604401 
	C155.469528,345.486542 152.319931,342.290924 148.482605,340.323059 
	C146.696075,338.435303 145.141144,336.857574 143.279495,335.160187 
	C142.547287,334.707489 142.121796,334.374481 141.442947,333.939941 
	C142.344772,332.502197 143.881744,333.287109 145.617249,333.113678 
	C149.526642,332.791107 152.806091,334.446014 156.609543,334.252563 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M147.896896,340.041077 
	C152.307632,340.233398 155.357910,343.292145 159.641327,343.952087 
	C160.566895,344.157043 161.121246,344.329834 161.850372,344.742249 
	C161.845963,346.479218 161.171219,346.676117 159.655243,346.440704 
	C157.282532,346.072266 155.073288,344.299622 152.253021,345.718506 
	C150.313995,344.976288 148.621048,343.962158 146.643860,342.806519 
	C146.114456,341.508240 145.875061,340.354065 147.896896,340.041077 
z"/>
<path fill="#31E7FE" opacity="1.000000" stroke="none" 
	d="
M316.000092,430.630646 
	C316.007324,431.337341 315.976013,431.672302 316.001129,432.003021 
	C316.183685,434.408386 314.321259,437.132233 313.171600,437.172852 
	C311.046143,437.247955 309.731689,434.921661 308.647827,432.684753 
	C307.005280,429.294800 307.659882,424.657593 303.232788,422.329285 
	C301.453033,420.873260 301.383514,419.844116 303.681061,419.005981 
	C307.020142,418.933655 309.541382,418.565948 307.048157,414.308838 
	C311.951538,414.300476 315.734833,419.145477 315.506378,425.495483 
	C315.445465,427.189392 316.087006,428.655518 316.000092,430.630646 
z"/>
<path fill="#3EE8F8" opacity="1.000000" stroke="none" 
	d="
M338.919617,438.004028 
	C337.937347,438.787354 338.900574,439.435181 339.153625,440.526459 
	C335.235077,442.610352 335.814606,445.579559 337.059448,448.792633 
	C337.704681,450.458130 338.814941,452.427979 336.152924,453.330231 
	C333.048950,454.382294 334.524567,451.274506 333.612671,450.302032 
	C330.880005,447.387848 329.649048,443.714386 328.505646,439.975098 
	C327.890289,445.295441 329.117157,450.029022 334.208832,454.301331 
	C330.847992,454.569305 330.072296,452.654449 328.330536,452.124573 
	C327.360229,446.272400 326.683105,440.567017 325.995575,434.436310 
	C326.230927,432.695251 325.450256,431.085968 327.727753,430.259644 
	C329.332611,432.077637 330.196350,433.959625 333.104187,433.058899 
	C333.658691,433.003815 333.881042,432.996002 334.748810,433.108124 
	C335.582062,433.332001 335.769928,433.435944 336.146423,433.795105 
	C336.620087,435.045258 337.011932,435.984070 337.954071,436.960358 
	C338.297424,437.323425 338.435181,437.468018 338.769958,437.838287 
	C338.967041,438.063934 338.953674,437.994507 338.919617,438.004028 
z"/>
<path fill="#46E7FA" opacity="1.000000" stroke="none" 
	d="
M316.693085,409.910156 
	C322.709473,412.618744 326.851837,417.161194 331.782715,421.120422 
	C332.140930,421.086975 332.086182,421.026123 332.052582,421.049500 
	C332.328949,421.332001 332.594879,421.630402 332.911346,422.254150 
	C333.005707,422.540466 333.022675,422.488495 332.997253,422.478455 
	C333.074707,422.852631 333.254028,423.198120 333.726807,423.698608 
	C334.228455,424.402527 334.503143,424.917755 334.900452,425.699432 
	C336.107452,427.748779 335.728394,429.053131 333.360168,429.908630 
	C332.696747,429.973328 332.430328,429.966187 331.776733,429.871033 
	C329.774872,429.212067 329.021698,427.865021 328.148438,426.115356 
	C327.926331,425.417084 327.923645,425.031952 327.938354,424.358368 
	C327.764679,423.816345 327.566895,423.568085 327.187622,423.163574 
	C326.893433,422.679688 326.693939,422.418579 326.190247,422.109070 
	C325.199860,421.357086 324.332520,420.868164 323.251587,420.164734 
	C323.026031,419.968445 323.000000,420.000000 323.015442,419.986267 
	C322.522308,419.422272 322.223602,418.669312 321.249878,418.173187 
	C321.030029,417.990448 321.009064,417.990356 321.006165,417.980316 
	C320.838501,417.812775 320.673767,417.655243 320.271820,417.251465 
	C320.034637,417.005249 320.021118,416.977997 320.007294,416.971680 
	C319.751373,416.751465 319.527130,416.520172 319.157043,416.093628 
	C318.082794,414.795135 317.172211,413.674530 316.125458,412.274353 
	C315.384369,411.191071 315.557831,410.494904 316.693085,409.910156 
z"/>
<path fill="#46E7FA" opacity="1.000000" stroke="none" 
	d="
M303.868073,418.683960 
	C303.785339,419.903870 301.887451,420.058838 302.911926,421.804382 
	C302.550812,422.046204 302.104645,422.027435 301.324829,421.975677 
	C300.732269,421.461548 300.473389,420.980408 300.103577,420.247803 
	C299.747559,419.781250 299.526978,419.543365 299.162933,419.106384 
	C297.498077,416.920197 296.083099,414.817078 293.116272,414.092865 
	C292.607452,414.212585 292.451019,414.320282 292.144409,414.185974 
	C291.994232,413.943909 291.989136,414.005432 292.019989,414.006958 
	C291.329132,413.335846 290.654724,412.614929 289.727356,411.749817 
	C289.361938,411.461060 289.207947,411.358887 288.795410,411.165222 
	C288.355865,411.056885 288.174774,411.039978 287.721008,411.016815 
	C287.302551,410.635803 287.156799,410.261017 287.005127,409.682892 
	C287.162415,409.121735 287.291016,408.752075 287.178528,408.154114 
	C286.977325,407.939484 287.043549,407.976501 287.071899,408.001617 
	C286.781555,407.584412 286.462830,407.142059 286.033325,406.443298 
	C285.913483,405.698822 285.904449,405.210815 285.867981,404.357422 
	C286.029480,403.814148 286.218414,403.636261 286.771729,403.320496 
	C287.936737,403.048340 288.671844,403.286377 289.711853,403.805725 
	C290.026459,404.031494 290.020416,403.976868 289.992920,403.976562 
	C290.199219,404.211487 290.433380,404.446411 290.842377,404.858276 
	C291.016815,405.035614 291.015289,404.984344 290.989624,404.984436 
	C291.201111,405.214081 291.435669,405.446228 291.839966,405.858704 
	C292.012238,406.036438 292.012878,405.987427 291.988373,405.988098 
	C292.474762,406.595886 292.823059,407.389679 294.032654,407.636841 
	C295.677673,408.791931 296.939087,409.919983 297.773834,411.831055 
	C299.031128,414.962311 302.252808,415.865448 303.868073,418.683960 
z"/>
<path fill="#2AD5F9" opacity="1.000000" stroke="none" 
	d="
M317.013794,409.617432 
	C316.753418,410.422333 316.402771,410.899109 316.020691,411.685364 
	C314.798248,411.520721 313.607239,411.046692 312.219940,410.316528 
	C312.014374,409.656036 311.803162,409.412109 311.196594,409.144104 
	C310.971222,408.984955 311.000275,408.997864 311.008575,409.011414 
	C310.771667,408.705414 310.574036,408.359253 310.216217,407.774658 
	C309.816040,407.488800 309.632446,407.409760 309.204651,407.156860 
	C308.960419,406.982971 309.007263,406.992584 309.015442,407.015076 
	C307.532715,405.783020 306.089966,404.468903 304.215210,403.171661 
	C303.953308,402.977966 304.002136,402.998444 304.015991,403.020996 
	C303.798309,402.797272 303.567688,402.550171 303.149231,402.132996 
	C302.960510,401.963776 303.003296,401.998718 303.017395,402.022461 
	C302.933502,401.899689 302.835541,401.753143 302.802979,401.350464 
	C303.471466,400.880005 304.074493,400.665680 304.863190,400.184021 
	C309.804382,402.030731 313.385162,405.633209 317.013794,409.617432 
z"/>
<path fill="#AEF6FB" opacity="1.000000" stroke="none" 
	d="
M327.896912,426.228149 
	C328.889069,426.663025 329.849091,427.523834 330.960968,428.666809 
	C331.097412,430.657501 329.977875,430.640289 328.402893,430.210571 
	C328.052643,429.962494 327.902771,429.969818 327.835754,430.005798 
	C327.800751,428.912537 327.832733,427.783356 327.896912,426.228149 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M279.243011,394.715179 
	C279.745697,394.683960 280.077148,394.850372 280.671143,395.106781 
	C281.956146,396.215088 282.978607,397.233337 284.167389,398.516205 
	C284.262482,398.963074 284.191254,399.145355 283.852203,399.448059 
	C283.190247,399.564453 282.809753,399.492249 282.236053,399.135620 
	C282.026917,398.930817 282.001984,398.994598 282.030762,398.976074 
	C280.764496,398.178558 279.562744,397.298248 278.761780,395.629669 
	C278.844849,395.177429 278.958313,395.045105 279.243011,394.715179 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M304.076996,403.289734 
	C306.481659,402.863129 307.682098,404.810089 309.090637,406.683685 
	C306.812744,406.738861 305.726898,404.861145 304.076996,403.289734 
z"/>
<path fill="#0B5794" opacity="1.000000" stroke="none" 
	d="
M289.931549,403.716980 
	C289.311584,404.031006 288.596741,404.030518 287.512451,403.984131 
	C286.032104,403.162384 285.499786,401.920502 284.618286,400.570557 
	C284.601440,400.024506 284.661255,399.805969 285.060852,399.592743 
	C286.879333,400.866211 288.357971,402.134308 289.931549,403.716980 
z"/>
<path fill="#14A4F1" opacity="1.000000" stroke="none" 
	d="
M297.969788,411.826904 
	C296.729248,411.077423 295.524170,410.046631 294.152100,408.771912 
	C293.832642,408.291748 293.680176,408.055481 293.722046,407.444885 
	C293.916412,407.070526 293.960632,406.911072 294.010956,406.845398 
	C294.231903,406.763336 294.402496,406.746979 294.781494,406.881195 
	C294.989899,407.031738 295.005554,407.002350 294.989197,407.005066 
	C295.194733,407.240662 295.425781,407.464020 295.831909,407.852844 
	C295.997742,408.027832 296.004028,407.996033 295.988129,407.999146 
	C296.208008,408.221680 296.438385,408.446716 296.828674,408.853394 
	C296.994080,409.029419 297.003021,408.997162 296.986877,409.001556 
	C297.208496,409.222443 297.439240,409.446228 297.827271,409.853638 
	C297.991638,410.030029 297.997711,409.993622 297.981079,410.001648 
	C298.113495,410.159851 298.262604,410.309998 298.229584,410.720093 
	C298.033417,411.168518 298.019379,411.357025 297.969788,411.826904 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M323.152069,420.263092 
	C324.214233,419.905792 325.043701,420.504242 325.833588,421.709717 
	C324.821777,421.982025 323.905731,421.538757 323.152069,420.263092 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M321.129028,418.268005 
	C321.993164,417.979065 322.689362,418.357666 323.006317,419.649414 
	C322.429932,419.496918 321.828979,419.021240 321.129028,418.268005 
z"/>
<path fill="#0B5794" opacity="1.000000" stroke="none" 
	d="
M293.676636,406.909912 
	C293.922363,407.313202 293.928284,407.555847 293.959686,408.163208 
	C293.264557,407.915314 292.543976,407.302643 291.893616,406.339355 
	C292.454865,406.242249 292.945862,406.495758 293.676636,406.909912 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M309.824188,407.265900 
	C310.395355,407.458527 310.756683,407.932831 311.067444,408.716034 
	C310.669098,409.009766 310.386505,408.866272 310.079712,408.367676 
	C309.864990,407.943085 309.739685,407.745300 309.824188,407.265900 
z"/>
<path fill="#1B81B1" opacity="1.000000" stroke="none" 
	d="
M311.111938,409.195404 
	C311.538757,409.032806 312.287384,408.750397 312.182251,409.898132 
	C311.766663,409.842224 311.509674,409.624023 311.111938,409.195404 
z"/>
<path fill="#3FDDF9" opacity="1.000000" stroke="none" 
	d="
M299.124084,411.202942 
	C299.446014,411.107269 299.872009,411.240295 300.298035,411.373352 
	C299.977692,412.057983 299.600739,411.704285 299.124084,411.202942 
z"/>
<path fill="#31E7FE" opacity="1.000000" stroke="none" 
	d="
M306.977661,414.013794 
	C306.639679,413.557953 306.332367,413.077637 306.013184,412.297424 
	C306.330383,412.450623 306.659485,412.903687 307.027039,413.646210 
	C307.065460,413.935669 307.008270,413.989319 306.977661,414.013794 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M320.115967,417.235168 
	C320.316925,417.163757 320.599243,417.322296 320.942383,417.725525 
	C320.658600,417.923035 320.389954,417.754608 320.115967,417.235168 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M319.075623,416.161438 
	C319.281372,416.098572 319.569427,416.281433 319.925476,416.714844 
	C319.714935,416.779327 319.436401,416.593231 319.075623,416.161438 
z"/>
<path fill="#3FDDF9" opacity="1.000000" stroke="none" 
	d="
M296.897583,408.794006 
	C296.721832,408.841278 296.449554,408.653137 296.074768,408.233612 
	C296.248535,408.187683 296.524811,408.373138 296.897583,408.794006 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M309.765717,406.878510 
	C310.030212,407.176941 310.026428,407.369629 310.006470,407.851624 
	C309.674347,407.943146 309.358398,407.745422 309.001404,407.265320 
	C309.139435,406.912903 309.318451,406.842834 309.765717,406.878510 
z"/>
<path fill="#3FDDF9" opacity="1.000000" stroke="none" 
	d="
M295.899750,407.793579 
	C295.722595,407.842712 295.447449,407.657623 295.072571,407.240143 
	C295.249176,407.191589 295.525482,407.375458 295.899750,407.793579 
z"/>
<path fill="#3FDDF9" opacity="1.000000" stroke="none" 
	d="
M294.934387,406.859680 
	C294.989899,407.031738 294.509125,406.965790 294.285217,406.872742 
	C294.333801,406.748993 294.606354,406.718292 294.934387,406.859680 
z"/>
<path fill="#0B5794" opacity="1.000000" stroke="none" 
	d="
M291.987732,405.744080 
	C291.627533,405.910004 291.242798,405.783539 290.911041,405.320801 
	C291.297089,405.140259 291.630157,405.295990 291.987732,405.744080 
z"/>
<path fill="#31E7FE" opacity="1.000000" stroke="none" 
	d="
M305.998779,412.000671 
	C305.876312,411.862183 305.755066,411.722992 305.633789,411.583832 
	C305.719116,411.631317 305.804474,411.678802 305.945557,411.861908 
	C306.001282,411.997559 306.000000,412.000000 305.998779,412.000671 
z"/>
<path fill="#3FDDF9" opacity="1.000000" stroke="none" 
	d="
M298.279358,410.993927 
	C298.047485,410.980042 297.982300,410.496979 297.973358,410.253357 
	C298.242920,410.181732 298.521393,410.353760 298.909943,410.750000 
	C299.019989,410.974213 298.999390,411.000153 298.987488,411.012390 
	C298.975586,411.024628 298.511261,411.007812 298.279358,410.993927 
z"/>
<path fill="#0B5794" opacity="1.000000" stroke="none" 
	d="
M290.973541,404.756622 
	C290.620636,404.907440 290.224487,404.779266 289.896881,404.313660 
	C290.287048,404.143372 290.608673,404.310486 290.973541,404.756622 
z"/>
<path fill="#3FDDF9" opacity="1.000000" stroke="none" 
	d="
M297.896484,409.794189 
	C297.718658,409.843292 297.445709,409.656555 297.071716,409.237885 
	C297.247559,409.190063 297.524445,409.374176 297.896484,409.794189 
z"/>
<path fill="#0B5794" opacity="1.000000" stroke="none" 
	d="
M284.181091,398.932007 
	C284.662933,398.811005 284.934296,398.952332 285.274231,399.401459 
	C285.400665,399.598083 285.057373,399.949402 284.885376,400.124695 
	C284.515900,400.223846 284.318390,400.147675 283.998901,399.778351 
	C283.876923,399.485199 284.028473,399.083160 284.181091,398.932007 
z"/>
<path fill="#3EE8F8" opacity="1.000000" stroke="none" 
	d="
M327.116028,423.222961 
	C327.340820,423.110840 327.597809,423.310913 327.869751,423.836121 
	C327.652496,423.929169 327.406982,423.720490 327.116028,423.222961 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M303.028259,402.233643 
	C303.326202,402.118134 303.691864,402.272522 304.043701,402.735229 
	C303.718536,402.863556 303.407257,402.683533 303.028259,402.233643 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M293.017914,399.987061 
	C293.153687,400.134705 293.270905,400.298462 293.388153,400.462250 
	C293.289734,400.417023 293.191284,400.371796 293.030212,400.183655 
	C292.967590,400.040710 292.999390,400.003204 293.017914,399.987061 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M302.714661,401.188019 
	C302.868439,401.094330 302.961884,401.568146 302.996704,401.807190 
	C302.874603,401.791382 302.717743,401.536530 302.714661,401.188019 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M264.639893,462.983154 
	C265.441498,463.028351 265.887390,463.023224 266.667664,463.016235 
	C267.661285,462.979584 268.306183,462.699951 268.953766,462.755066 
	C270.685303,462.902435 273.086761,462.497803 273.227783,464.936676 
	C273.354370,467.126495 271.073883,467.099762 269.510468,467.227875 
	C266.875824,467.443848 266.467163,468.584320 267.573334,470.795288 
	C268.297729,472.243225 269.528046,473.490509 269.400696,475.610291 
	C268.792999,476.546173 268.123779,476.769165 267.024139,476.806030 
	C265.571167,476.517456 264.237488,475.269470 263.398865,477.636292 
	C259.388641,477.983246 255.752914,477.114990 251.679626,477.419006 
	C250.212158,477.379395 249.142807,477.408417 247.680511,477.276001 
	C246.504120,477.087097 245.783600,476.804626 244.933914,476.008453 
	C244.334061,472.104065 248.523178,471.925873 249.591095,469.005951 
	C249.805801,468.240601 249.944626,467.809235 250.223312,467.068848 
	C251.562790,463.487976 255.656433,464.934570 257.676819,462.322571 
	C260.197815,461.526306 262.243958,462.204926 264.639893,462.983154 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M257.807739,438.340790 
	C258.835266,438.246063 259.535858,438.119049 260.671692,438.043579 
	C261.463531,440.291443 259.696594,441.564545 258.758179,443.588348 
	C258.745972,444.312927 258.758270,444.698456 258.708466,445.384033 
	C259.527893,447.477936 259.944885,449.363892 260.010345,451.664062 
	C259.496460,453.456055 258.965942,454.916962 258.181976,456.579041 
	C257.151672,457.495209 256.943695,458.695007 255.574646,459.231628 
	C254.407913,459.052734 253.852295,458.387054 252.959961,457.661316 
	C252.425247,457.173553 252.158997,456.862610 251.815765,456.243408 
	C251.668732,455.149231 252.163391,454.528992 252.616699,453.609070 
	C252.848114,453.231720 252.956680,453.092682 253.246216,452.768127 
	C253.505066,452.434662 253.582977,452.286743 253.540741,452.375549 
	C253.138000,452.854401 252.878265,453.119385 252.384964,453.565155 
	C251.529114,453.936890 250.906952,453.963257 249.949158,453.826599 
	C248.238861,453.231995 247.381577,452.193481 246.699249,450.557861 
	C246.468185,447.786499 249.103729,446.045380 248.294052,443.098999 
	C248.244690,442.302856 248.290817,441.848083 248.501816,441.066711 
	C249.999847,438.870270 250.921204,436.574402 253.695892,435.742004 
	C254.382675,436.113464 254.643784,436.486328 254.876526,437.254639 
	C254.958282,438.027283 254.913513,438.463104 254.642090,439.169617 
	C254.325989,439.768372 254.087646,439.932465 253.774033,439.939667 
	C253.456955,439.946991 253.560242,439.962006 254.303619,439.756897 
	C255.365601,438.773193 256.374359,438.422424 257.807739,438.340790 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M265.720215,476.098572 
	C266.737091,476.170563 267.470245,476.221039 268.569031,476.230408 
	C269.858368,474.976501 271.200623,474.764465 272.982605,474.657532 
	C274.136322,474.669586 274.888855,474.745819 275.965027,475.017395 
	C277.639130,475.757233 278.812775,476.798767 280.723816,476.853668 
	C281.743835,476.967041 282.450409,477.041595 283.508728,477.165955 
	C284.553345,477.751282 284.728668,478.478607 284.491760,479.667267 
	C284.002014,480.407867 283.591553,480.694214 282.764648,480.983032 
	C279.473602,481.517487 276.574524,480.667480 273.635284,480.791290 
	C271.800507,480.868561 270.057526,481.062775 268.401245,482.613647 
	C266.916382,483.096191 265.671082,483.342468 264.210327,483.355347 
	C259.816437,479.723999 255.012787,481.976685 250.194061,481.842621 
	C249.464996,482.065430 249.038864,482.073944 248.292999,482.088135 
	C246.390091,483.360748 244.756607,483.019958 242.797958,482.047119 
	C242.314667,481.672485 242.142975,481.496643 241.860046,480.970276 
	C241.955521,479.844330 242.517593,479.423096 243.562042,479.044617 
	C246.232391,478.803711 248.351044,478.044769 250.570862,476.566772 
	C254.931519,475.782593 258.981445,476.242676 263.429749,476.668823 
	C264.364502,476.432465 264.853607,476.113617 265.720215,476.098572 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M274.267151,475.942383 
	C272.662689,476.238525 271.229523,476.242676 269.365509,476.218079 
	C268.438904,473.564209 266.442566,471.696838 265.350128,469.340454 
	C263.964813,466.352478 264.673004,465.967072 267.390625,465.968658 
	C269.075317,465.969635 270.897980,466.371979 272.638031,465.268616 
	C271.155945,463.121704 268.943970,464.654877 267.260132,463.289429 
	C268.116516,459.914093 269.773438,459.317780 272.383667,461.628418 
	C273.792358,462.875397 275.175079,464.354370 277.460999,464.012909 
	C280.790131,463.515717 281.258820,465.583252 280.943359,468.631470 
	C277.807953,470.322601 276.500366,473.357147 274.267151,475.942383 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M281.754883,480.351227 
	C282.376343,479.921844 282.772644,479.869263 283.467957,479.793091 
	C286.321533,477.700836 289.878571,479.566925 292.717041,477.287964 
	C295.028778,477.028717 297.071838,477.039337 299.552002,477.039307 
	C302.059998,477.349609 304.130920,477.670563 306.604065,477.988586 
	C308.094971,480.826080 305.828735,481.021545 304.176208,481.202942 
	C301.680145,481.476990 299.651978,482.156708 298.427185,485.012268 
	C297.209167,486.022156 296.105774,486.240875 294.534302,486.348267 
	C290.708771,485.873291 287.318939,485.361877 283.519897,484.746155 
	C281.866425,483.585785 281.241638,482.346344 281.754883,480.351227 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M274.423340,476.270599 
	C275.093170,472.991058 274.909149,468.761230 280.514465,469.044159 
	C280.950684,471.075134 280.984528,473.092072 281.021820,475.542969 
	C280.005157,476.840820 278.854950,477.041962 277.162292,476.481018 
	C276.074280,476.309174 275.412567,476.308014 274.423340,476.270599 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M260.328369,451.850372 
	C257.510864,450.325623 258.111328,447.423370 257.600037,445.027039 
	C259.058228,444.304626 260.466217,445.497986 261.813110,444.259857 
	C263.109558,444.029999 264.159607,444.006378 265.602905,443.961609 
	C266.644806,448.213318 261.506012,448.486572 260.328369,451.850372 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M292.534424,476.986511 
	C293.162872,479.084930 292.304321,480.099335 290.142517,479.986664 
	C288.332092,479.892334 286.514313,479.940002 284.233337,479.847137 
	C283.805908,479.131592 283.844910,478.493652 283.872192,477.535736 
	C286.601349,477.128815 289.342285,477.041870 292.534424,476.986511 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M264.848114,462.720490 
	C262.824554,465.149902 260.688019,462.249146 258.121735,462.982605 
	C257.388123,462.168945 257.636932,461.386261 257.903320,460.311096 
	C258.065491,459.836151 258.142883,459.650848 258.384460,459.213898 
	C258.864563,458.718628 259.201050,458.508240 259.789459,458.147461 
	C260.017334,457.958130 260.010864,458.015167 259.982422,458.011353 
	C260.319122,457.715912 260.735077,457.541107 261.536255,457.417084 
	C262.098541,457.430695 262.319550,457.494537 262.788025,457.798889 
	C262.736481,459.820953 263.599548,461.159607 264.848114,462.720490 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M254.682205,459.207275 
	C256.241425,458.555756 256.032471,456.651642 257.737732,456.635559 
	C258.132751,457.095093 258.336914,457.410034 258.783234,457.870300 
	C259.126831,458.189850 259.228333,458.364075 259.156738,458.786377 
	C258.983643,459.034424 258.978760,458.983643 259.003784,458.978760 
	C258.298462,460.052765 257.566833,461.209961 256.159180,461.392822 
	C254.764374,461.573975 253.317184,461.560516 254.682205,459.207275 
z"/>
<path fill="#033B5F" opacity="1.000000" stroke="none" 
	d="
M263.277252,457.840668 
	C262.836456,458.022797 262.637360,458.006256 262.140594,457.955292 
	C261.629608,457.656860 261.362183,457.470337 260.993286,457.117737 
	C261.940216,455.243958 263.221802,454.035492 265.654419,453.988647 
	C265.206238,455.241272 264.362610,456.441650 263.277252,457.840668 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M276.879639,476.610474 
	C277.879669,476.202637 279.023376,476.094971 280.596191,475.982117 
	C281.025269,475.976959 281.076782,476.434540 281.057007,476.663513 
	C279.706085,478.407471 278.367706,478.327087 276.879639,476.610474 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M260.732727,457.020691 
	C261.217010,457.040283 261.453674,457.246002 261.749390,457.706116 
	C261.423523,457.978729 261.004150,458.036560 260.269379,458.050964 
	C260.142517,457.727417 260.331024,457.447327 260.732727,457.020691 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M259.271851,458.994812 
	C258.990204,458.864441 258.996735,458.694458 259.014313,458.270081 
	C259.025360,458.015656 259.520569,457.975250 259.768951,457.966675 
	C259.864899,458.290497 259.712463,458.622864 259.271851,458.994812 
z"/>
<path fill="#033B5F" opacity="1.000000" stroke="none" 
	d="
M268.449768,452.447968 
	C268.506531,452.414886 268.392975,452.481049 268.449768,452.447968 
z"/>
<path fill="#033B5F" opacity="1.000000" stroke="none" 
	d="
M265.976013,453.969421 
	C266.090637,453.981689 266.129669,453.020905 266.200134,453.972809 
	C266.049866,454.040924 265.998840,453.995026 265.976013,453.969421 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M254.365952,438.174347 
	C254.045425,437.617340 254.027298,437.144104 254.001709,436.315674 
	C253.608597,435.553009 253.480835,435.076385 253.897308,434.263977 
	C254.183456,433.997375 254.519592,434.020905 254.688019,434.025177 
	C255.382339,433.266052 255.876358,432.459076 257.544556,432.799988 
	C258.097137,434.579651 256.928802,435.366211 256.046082,436.694855 
	C255.746567,437.657898 255.302475,438.049408 254.365952,438.174347 
z"/>
<path fill="#061426" opacity="1.000000" stroke="none" 
	d="
M254.015198,438.379211 
	C254.511292,437.793610 254.959045,437.496643 255.651154,437.091064 
	C256.530609,437.234039 257.165710,437.485657 257.967773,438.055176 
	C257.318420,439.546906 256.163666,440.060303 254.305450,439.964844 
	C253.885590,439.442688 253.926208,439.055267 254.015198,438.379211 
z"/>
<path fill="#061426" opacity="1.000000" stroke="none" 
	d="
M261.635742,444.032562 
	C261.610229,446.578888 260.140015,446.060730 258.235474,445.098999 
	C257.945068,444.664612 258.071289,444.399689 258.467163,444.054047 
	C259.502991,443.957977 260.357513,443.984772 261.635742,444.032562 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M257.691254,432.185669 
	C258.397766,431.598450 258.889496,431.311737 259.677429,430.989807 
	C260.161194,430.827820 260.348755,430.701111 260.805176,430.781647 
	C260.558624,431.970093 259.835724,432.713196 258.425415,433.073151 
	C258.113708,433.121155 258.059052,433.062042 258.031372,433.032837 
	C257.827911,432.831146 257.652191,432.658661 257.691254,432.185669 
z"/>
<path fill="#061426" opacity="1.000000" stroke="none" 
	d="
M264.236908,432.734985 
	C265.076904,433.266479 264.995667,433.873505 264.462067,434.385315 
	C264.306915,434.534180 263.763062,434.549255 263.635590,434.409058 
	C263.052582,433.767822 263.441772,433.243286 264.236908,432.734985 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M262.300751,429.984436 
	C262.465973,429.661804 262.934753,429.334564 263.706787,428.994873 
	C263.541473,429.314911 263.072906,429.647400 262.300751,429.984436 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M261.293365,430.893250 
	C260.890533,430.991150 260.706940,430.993347 260.248505,430.975098 
	C260.446594,430.636566 260.919525,430.318542 261.691284,429.996643 
	C261.950012,430.331757 261.790833,430.600006 261.293365,430.893250 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M260.985168,437.978455 
	C261.144073,437.677734 261.341797,437.417694 261.753540,437.066437 
	C261.835022,437.279938 261.702454,437.584656 261.338440,437.992249 
	C261.106964,438.095154 261.023987,438.019165 260.985168,437.978455 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M262.011536,437.016388 
	C262.109894,436.988098 262.195312,436.944336 262.124146,436.937897 
	C261.967560,436.975220 261.998627,437.000885 262.011536,437.016388 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M338.410492,509.912598 
	C338.057831,509.923553 337.590149,509.892914 337.355835,509.891418 
	C335.346802,508.864929 334.898804,506.743561 333.220856,505.222168 
	C330.477875,500.507050 326.704041,496.769562 325.052612,491.368225 
	C325.772888,490.374756 326.633209,490.052826 328.093994,490.118134 
	C328.564514,490.117188 328.735413,490.304901 328.783875,490.422241 
	C327.810120,492.744354 329.933289,492.811859 331.302124,493.735962 
	C331.893280,493.829346 332.077026,493.917297 332.372009,494.124176 
	C333.258728,494.291138 333.450409,494.864014 333.824524,495.680176 
	C334.057800,495.882629 334.033478,495.958466 334.073303,495.957520 
	C334.244659,496.145355 334.376251,496.334137 334.757568,496.761108 
	C335.002014,497.348694 335.133667,497.635071 335.629150,497.945862 
	C336.158051,498.231598 336.429626,498.464996 336.770966,498.987732 
	C336.876282,499.236298 336.871490,499.169922 336.850708,499.196106 
	C339.216644,502.247406 341.603394,505.272491 344.067505,508.640015 
	C343.094879,508.916351 341.903839,507.348419 340.956787,509.563477 
	C340.169556,509.869202 339.466370,509.885437 338.410492,509.912598 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M328.441345,489.876953 
	C327.691345,490.402313 326.818207,490.687469 325.478455,490.982971 
	C325.071808,489.903656 324.718567,488.641785 326.532471,488.084229 
	C327.349701,488.561646 327.833923,489.099182 328.441345,489.876953 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M331.527710,493.539429 
	C329.901459,493.872742 327.772430,494.397369 328.588013,490.936401 
	C329.684753,491.441711 330.537170,492.343872 331.527710,493.539429 
z"/>
<path fill="#3EE8F8" opacity="1.000000" stroke="none" 
	d="
M333.991089,495.568909 
	C333.629211,495.486145 333.200623,495.089661 332.649536,494.422424 
	C332.992798,494.519531 333.458588,494.887360 333.991089,495.568909 
z"/>
<path fill="#3EE8F8" opacity="1.000000" stroke="none" 
	d="
M334.911072,496.784424 
	C334.660278,496.932037 334.398071,496.745544 334.166870,496.198212 
	C334.406433,496.092926 334.640350,496.297211 334.911072,496.784424 
z"/>
<path fill="#3EE8F8" opacity="1.000000" stroke="none" 
	d="
M336.803192,498.965057 
	C336.585205,499.016876 336.294128,498.797485 335.929504,498.305664 
	C336.147339,498.253418 336.438721,498.473633 336.803192,498.965057 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M293.738464,485.206146 
	C295.148041,484.955536 296.256927,484.929932 297.778137,484.848999 
	C301.808624,482.705139 305.515656,483.145020 309.583923,484.750732 
	C311.101379,487.464111 310.231140,489.811615 309.826447,492.154694 
	C309.067108,496.551117 311.310669,498.845520 315.624725,500.008057 
	C316.801788,500.992035 317.025665,502.043976 316.218964,503.544952 
	C315.509186,503.917175 315.066498,503.953979 314.293182,504.036987 
	C313.535980,504.031677 313.109406,503.980103 312.363647,503.882721 
	C311.543488,503.436676 311.034973,503.045288 310.376709,502.344971 
	C309.174774,500.579224 307.455261,500.210938 305.706177,499.269714 
	C304.534790,498.100342 303.761719,497.319122 302.098480,497.895020 
	C295.832062,500.064850 294.003967,498.541748 294.113281,491.123047 
	C294.263275,490.542572 294.360443,490.318695 294.696472,489.812683 
	C296.984283,488.116333 299.568848,488.855225 300.997406,488.477905 
	C300.003052,488.888641 297.949371,488.105530 295.806244,488.909424 
	C294.921448,488.983276 294.417572,488.947906 293.569366,488.687256 
	C292.797699,488.209625 292.535706,487.789337 292.452820,486.889404 
	C292.624268,485.999573 292.946198,485.639282 293.738464,485.206146 
z"/>
<path fill="#071A2D" opacity="1.000000" stroke="none" 
	d="
M310.200073,485.044220 
	C306.300629,485.017090 302.684937,484.937500 298.629852,484.825806 
	C297.358154,481.221222 298.544800,479.562500 302.422363,479.922729 
	C303.893738,480.059387 305.763794,480.640533 306.914429,478.372925 
	C308.445404,477.032104 309.876251,478.461121 311.656097,478.000916 
	C311.840179,478.461731 311.759277,479.276398 311.511993,479.330475 
	C306.541321,480.417358 309.036774,482.365204 310.979614,484.572388 
	C310.862976,484.926544 310.673401,484.959137 310.200073,485.044220 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M316.288635,503.928894 
	C315.970337,502.852875 315.988800,501.825348 316.009705,500.411041 
	C316.012177,500.024231 316.476532,499.981201 316.709320,499.967529 
	C317.381378,499.598633 317.878967,499.471588 318.775299,499.784271 
	C319.107239,500.420990 319.098694,500.846008 319.093018,501.589783 
	C319.518829,502.685547 319.071106,503.158783 318.245941,503.807129 
	C317.530609,504.007294 317.077972,503.992371 316.288635,503.928894 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M318.304504,504.032349 
	C318.265900,503.498199 318.548553,502.974152 318.963562,502.179321 
	C320.205383,502.291351 321.944214,501.259308 322.380615,502.964447 
	C322.645203,503.998199 321.349335,503.840729 320.265869,503.999298 
	C319.480927,504.021698 319.053345,504.032074 318.304504,504.032349 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M319.347626,499.791260 
	C318.632599,499.993347 318.149384,499.990662 317.304138,499.970947 
	C317.104919,498.776794 317.411499,497.454254 318.776276,497.449005 
	C320.266174,497.443329 319.930298,498.626251 319.347626,499.791260 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M311.448303,494.535614 
	C311.417511,494.482727 311.479065,494.588501 311.448303,494.535614 
z"/>
<path fill="#202731" opacity="1.000000" stroke="none" 
	d="
M288.855072,410.112549 
	C290.024078,411.032715 291.014893,412.190857 292.028259,413.678772 
	C290.803467,415.312836 290.480560,413.586212 289.382812,413.140076 
	C288.667511,412.474457 288.288452,411.966034 287.678833,411.234131 
	C287.448273,411.010590 287.493866,410.855377 287.572571,410.836731 
	C288.064362,410.818420 288.406219,410.662476 288.855072,410.112549 
z"/>
<path fill="#202731" opacity="1.000000" stroke="none" 
	d="
M291.742615,414.159973 
	C291.994232,413.943909 292.376190,414.037903 292.570007,414.071411 
	C292.727631,414.524048 292.820038,415.228973 292.633057,415.313171 
	C291.791901,415.691772 291.807678,414.789062 291.742615,414.159973 
z"/>
<path fill="#05E2FD" opacity="1.000000" stroke="none" 
	d="
M299.095520,419.163239 
	C299.256897,419.134033 299.518829,419.338074 299.886719,419.769226 
	C299.727142,419.796387 299.461639,419.596436 299.095520,419.163239 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M332.993652,505.328003 
	C336.295349,504.514740 335.992462,507.449738 337.039246,509.537231 
	C335.471924,509.680481 332.558929,511.847900 333.000671,507.343994 
	C332.998077,506.545013 332.997375,506.102539 332.993652,505.328003 
z"/>
<path fill="#252326" opacity="1.000000" stroke="none" 
	d="
M286.666443,408.328979 
	C287.744659,408.224457 288.247253,408.636566 287.370605,409.505981 
	C286.784637,409.225861 286.570099,408.972198 286.666443,408.328979 
z"/>
<path fill="#100D10" opacity="1.000000" stroke="none" 
	d="
M149.264664,279.939026 
	C145.333359,277.462769 141.649231,274.986450 137.627441,272.355652 
	C135.924652,271.158325 134.559540,270.115479 132.995819,268.862793 
	C132.850937,267.826019 133.116165,266.946960 132.927063,266.179962 
	C129.385849,251.817581 137.301407,239.906830 141.300888,227.182388 
	C142.940918,221.964569 144.185013,216.587875 146.858429,211.331909 
	C152.919464,215.733505 155.947678,222.742508 160.849976,228.697174 
	C162.547607,231.211639 161.943771,233.478516 161.008972,235.647064 
	C156.581604,245.917572 154.476166,256.897980 151.121613,267.492706 
	C149.856689,271.487762 151.703827,275.429626 150.278351,279.617249 
	C150.006027,279.925476 149.511841,279.938965 149.264664,279.939026 
z"/>
<path fill="#19C7F4" opacity="1.000000" stroke="none" 
	d="
M283.589081,399.320740 
	C283.941345,399.765869 284.099182,399.976624 284.531921,400.208710 
	C285.370331,401.387848 286.847870,401.843170 287.084473,403.619202 
	C286.926544,403.949707 286.710052,403.961121 286.167023,403.982300 
	C284.622070,402.517212 283.403625,401.042358 282.106049,399.249146 
	C282.451691,399.005951 282.876465,399.081116 283.589081,399.320740 
z"/>
<path fill="#19C7F4" opacity="1.000000" stroke="none" 
	d="
M278.445679,395.226471 
	C279.795746,396.318329 280.860077,397.326935 281.992004,398.646545 
	C279.699158,398.895874 278.636810,396.991180 277.123962,395.244629 
	C277.392487,394.998871 277.776245,395.071014 278.445679,395.226471 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M276.071777,394.224121 
	C276.325287,394.117584 276.656860,394.267212 277.030579,394.695374 
	C276.765045,394.809357 276.457428,394.644806 276.071777,394.224121 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M257.677368,431.736847 
	C257.929352,432.070984 257.952667,432.256775 257.989807,432.723114 
	C257.170227,433.278381 256.336761,433.553101 255.179871,433.928619 
	C254.423355,433.468170 253.990265,432.906891 253.698288,432.176453 
	C254.539719,431.408081 254.933273,430.517181 256.384552,430.019348 
	C257.172394,430.545776 257.310547,431.067139 257.677368,431.736847 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M259.991425,423.993713 
	C259.826019,424.554810 259.668823,425.120148 259.037079,425.583801 
	C258.476013,424.736084 258.665375,424.117126 259.686951,423.873169 
	C260.006104,424.011810 259.999634,423.997955 259.991425,423.993713 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M259.007294,426.007141 
	C258.858185,426.580048 258.703644,427.147430 258.062897,427.623901 
	C257.466187,426.791931 257.627502,426.168854 258.665955,425.890198 
	C258.995789,425.997040 259.001831,426.001678 259.007294,426.007141 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M258.028870,428.028259 
	C257.874390,428.596985 257.702820,429.149658 257.282745,429.863342 
	C257.034241,430.024414 257.005005,430.003571 256.991119,429.993042 
	C256.404663,429.230530 256.536987,428.551666 257.583008,427.954773 
	C257.975586,427.982727 258.011810,428.012177 258.028870,428.028259 
z"/>
<path fill="#040914" opacity="1.000000" stroke="none" 
	d="
M257.998901,427.685608 
	C257.656097,428.451294 257.336609,428.919861 256.997192,429.685486 
	C256.132721,430.588623 255.288193,431.194733 254.141541,431.904053 
	C254.202774,430.600647 254.566147,429.194092 254.926117,427.423401 
	C257.571014,427.065338 257.206848,423.740417 259.618622,423.067749 
	C259.953217,423.020538 259.993225,423.515381 259.999664,423.763611 
	C259.684845,424.476624 259.363617,424.941406 259.019073,425.701630 
	C258.671265,426.460846 258.346741,426.924683 257.998901,427.685608 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M325.484863,507.836426 
	C327.428436,509.456177 329.230530,508.100006 330.960602,508.095215 
	C331.716919,510.838623 329.199310,511.368866 327.962524,513.040039 
	C327.529419,513.220764 327.128357,513.106018 326.431702,512.889771 
	C325.630127,512.177124 324.903839,511.871429 324.004150,511.317688 
	C323.437988,511.103851 323.193451,510.930939 322.902039,510.473633 
	C322.531525,509.804779 322.455078,509.308838 322.819641,508.489960 
	C323.759949,508.078888 324.448181,507.961639 325.484863,507.836426 
z"/>
<path fill="#08346F" opacity="1.000000" stroke="none" 
	d="
M323.861511,511.490295 
	C324.686707,511.323151 326.223175,510.016815 326.219849,512.518616 
	C325.235535,512.846802 324.418243,512.726257 323.861511,511.490295 
z"/>
<path fill="#08346F" opacity="1.000000" stroke="none" 
	d="
M322.760254,508.135803 
	C323.028748,508.657684 322.985779,509.119232 322.869873,509.926178 
	C321.925873,509.909485 320.782837,509.795288 320.800629,508.541351 
	C320.802948,508.378265 321.873169,508.230377 322.760254,508.135803 
z"/>
<path fill="#0F62A1" opacity="1.000000" stroke="none" 
	d="
M294.556610,490.759338 
	C295.058380,492.576385 294.959839,494.324371 295.567719,495.776703 
	C296.701172,498.484772 298.883118,499.853516 301.099182,497.112396 
	C303.896637,493.652222 304.904266,495.398743 306.008118,498.576263 
	C305.395111,500.960358 303.498718,501.216095 301.492920,501.937561 
	C298.958252,502.585266 296.723511,502.375122 294.261932,502.842468 
	C293.522400,503.383881 293.044800,503.669189 292.277039,503.975647 
	C291.318298,499.858429 291.858063,495.811340 292.960754,491.398346 
	C293.378723,490.688751 293.796661,490.535522 294.556610,490.759338 
z"/>
<path fill="#1391DB" opacity="1.000000" stroke="none" 
	d="
M296.913818,516.600281 
	C296.858795,516.933411 296.645020,516.956482 296.108032,517.002686 
	C295.049072,516.612671 294.330475,516.013428 293.232849,516.893982 
	C292.874664,516.667236 292.689178,516.417786 292.217407,516.115417 
	C291.161255,515.144470 290.309998,514.287964 289.212433,513.251526 
	C288.987762,513.049866 288.962891,513.026306 288.958618,513.009766 
	C288.564972,512.544250 288.528229,511.962891 288.171722,511.224487 
	C287.976562,511.020660 287.988464,511.007751 287.975861,511.017944 
	C287.974976,509.968384 287.986694,508.908569 287.996796,507.452942 
	C289.064301,507.069122 290.133484,507.081177 291.601685,507.047913 
	C292.312988,507.777161 292.625214,508.551697 292.958740,509.638855 
	C293.621674,512.431702 296.577118,513.533875 296.913818,516.600281 
z"/>
<path fill="#0E6CB9" opacity="1.000000" stroke="none" 
	d="
M300.754211,501.347839 
	C302.469238,500.413757 303.952820,499.825073 305.749786,499.082581 
	C308.031738,498.985626 310.160248,498.711273 310.963257,501.637329 
	C310.979706,502.583588 310.803497,503.111145 310.233246,503.770721 
	C307.322540,503.988922 304.608307,504.002167 301.442139,504.007507 
	C300.378906,503.323151 300.261566,502.546570 300.754211,501.347839 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M300.597351,501.005432 
	C300.990448,501.751740 300.995209,502.501007 300.995087,503.624969 
	C298.727264,504.890137 296.873047,502.959351 294.360016,503.094910 
	C295.739624,501.421417 297.917358,501.045715 300.597351,501.005432 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M298.619507,505.961395 
	C299.496765,509.419861 296.518372,509.048737 294.302368,509.962952 
	C293.847687,507.041962 295.239624,505.644684 298.619507,505.961395 
z"/>
<path fill="#0E6CB9" opacity="1.000000" stroke="none" 
	d="
M306.966949,509.667725 
	C306.899384,510.303040 306.718384,510.556396 306.240967,510.850342 
	C305.434265,509.694366 304.557220,508.491241 305.302612,506.918762 
	C306.607758,507.238739 306.590607,508.418457 306.966949,509.667725 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M310.372742,503.981964 
	C310.193726,503.422302 310.350647,502.868866 310.757507,502.158325 
	C311.328735,502.429565 311.649963,502.857910 312.007812,503.561584 
	C311.599182,503.887329 311.153961,503.937775 310.372742,503.981964 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M180.086243,422.483887 
	C180.426880,419.094208 182.706482,417.482330 185.562012,416.030273 
	C187.456329,418.592896 185.746048,420.425659 184.072449,422.567444 
	C183.482849,423.266846 183.218384,423.742798 182.912476,424.494690 
	C181.990631,424.088837 181.110245,423.407043 180.086243,422.483887 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M180.289307,430.964050 
	C179.541183,431.007446 179.084946,430.978577 178.289368,430.896545 
	C178.357651,429.629822 180.395416,429.116272 179.221313,427.154907 
	C179.033096,426.645599 179.201050,426.382416 179.706223,426.100769 
	C180.681915,426.012939 181.437592,426.018463 182.568726,426.042358 
	C182.718170,426.859070 182.492172,427.657379 182.161789,428.754425 
	C181.594498,429.689423 181.352737,430.503296 180.289307,430.964050 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M186.303696,455.701477 
	C187.920990,461.980927 187.789017,462.167206 181.737106,463.097412 
	C181.183487,463.182495 180.708771,463.781006 180.122101,464.514862 
	C178.968124,464.931824 177.889481,464.974976 176.406677,465.017456 
	C175.981216,464.462311 175.959915,463.907837 175.879211,462.932587 
	C175.541397,459.323029 179.320251,457.149292 178.006439,453.340637 
	C177.989822,452.975677 178.000549,453.002045 177.986267,453.000610 
	C178.207275,452.790619 178.413666,452.556549 178.739594,452.115326 
	C181.764709,449.798645 185.015869,451.679932 188.476868,451.106293 
	C189.314209,451.476715 189.475967,451.914642 189.215363,452.734955 
	C188.996429,453.036621 188.987015,452.989807 189.010681,452.986664 
	C188.790741,453.199066 188.556030,453.423859 188.161758,453.834229 
	C187.993301,454.010498 188.003036,453.989105 188.014389,453.992249 
	C187.781128,454.208221 187.546906,454.431915 187.160065,454.846680 
	C186.997040,455.026825 186.997238,454.994049 187.012695,454.999512 
	C186.872696,455.110901 186.717239,455.216827 186.303696,455.701477 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M197.395782,449.682373 
	C196.903824,449.952301 196.702530,449.981415 196.202835,450.078217 
	C195.904419,450.145935 195.465408,450.097260 195.246964,450.064789 
	C194.033859,449.111450 192.699402,448.957642 191.199097,448.346741 
	C190.755920,448.032471 190.624664,447.845642 190.420959,447.317841 
	C190.373779,446.741913 190.399033,446.506989 190.568863,445.943604 
	C191.153824,445.015533 191.727631,444.573730 192.705719,444.052399 
	C194.460175,443.355164 195.898239,442.941833 197.802353,443.349487 
	C201.469803,446.845612 201.440475,447.213013 197.395782,449.682373 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M193.148682,444.627594 
	C192.571640,445.243591 192.021194,445.531982 191.188202,445.951324 
	C190.812866,446.269073 190.720062,446.455841 190.817566,446.890869 
	C191.007889,447.139099 190.982971,447.524628 190.976318,447.717651 
	C190.936478,448.282104 190.757370,448.549011 190.214996,448.871002 
	C190.021530,449.047699 189.991348,449.012817 190.013580,449.018219 
	C189.868164,449.167633 189.700531,449.311676 189.302002,449.693573 
	C187.171463,449.904205 185.185760,450.402649 183.151871,448.814850 
	C182.308975,447.973419 182.250702,447.282349 182.746719,446.252869 
	C182.963699,445.958038 183.000671,445.998444 182.975677,445.987396 
	C183.366394,445.583618 183.625778,445.042023 184.414581,444.682739 
	C185.073441,444.697449 185.425095,444.828400 185.966217,445.203522 
	C186.458252,445.606201 186.744812,445.824066 187.108093,445.748596 
	C187.294815,445.325195 187.420151,445.174927 187.779144,444.831024 
	C189.682663,443.745117 191.309982,442.201904 193.148682,444.627594 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M190.370239,449.167023 
	C190.190125,448.757202 190.358734,448.466675 190.748505,448.043457 
	C192.352020,448.084778 193.858948,447.940918 194.885284,449.710632 
	C193.591995,449.783661 192.155487,449.535004 190.370239,449.167023 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M182.648254,446.012390 
	C182.944489,446.625610 182.925278,447.293152 182.850906,448.284973 
	C182.141998,448.778259 181.422211,448.848358 181.228867,448.051178 
	C181.010361,447.150238 181.634094,446.547882 182.648254,446.012390 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M189.336624,453.064697 
	C188.991913,452.612213 188.987396,452.187775 188.950439,451.447571 
	C189.817612,451.243805 190.717255,451.355804 191.813095,451.752075 
	C191.499527,452.979675 190.579788,453.017670 189.336624,453.064697 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M185.186356,444.699890 
	C184.496292,445.275482 184.003281,445.564484 183.230469,445.914917 
	C182.960815,445.546692 182.970947,445.117065 183.037567,444.367310 
	C183.094040,444.047211 183.046539,444.012634 183.035721,444.039246 
	C183.284912,443.680450 183.540710,443.292236 184.134109,442.829285 
	C185.225891,443.064148 185.484375,443.640228 185.186356,444.699890 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M172.783646,450.922760 
	C172.509445,451.310394 172.052795,451.672455 171.285278,452.025452 
	C171.209854,451.721771 171.445282,451.427094 171.959381,451.045959 
	C172.238037,450.959473 172.601196,450.897186 172.783646,450.922760 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M189.324631,449.883087 
	C189.117828,449.593506 189.288147,449.338013 189.808929,449.094238 
	C189.883240,449.293976 189.730713,449.564362 189.324631,449.883087 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M178.644806,451.965607 
	C178.743683,452.232300 178.599396,452.530914 178.213562,452.914368 
	C177.972000,452.999207 177.832626,452.538422 177.874207,452.301971 
	C177.915802,452.065521 178.401611,451.997559 178.644806,451.965607 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M193.467987,444.930603 
	C190.798172,442.462128 189.524506,445.767792 187.332428,445.966064 
	C186.011520,445.005707 186.131592,443.892975 186.759003,442.430847 
	C187.259476,441.534790 187.653015,440.978577 188.225800,440.137604 
	C188.723053,439.527252 189.074280,439.254944 189.798157,438.960632 
	C191.417648,438.353210 193.579330,440.384705 194.040619,437.229675 
	C194.282074,436.675476 194.574265,436.429474 195.431000,436.103699 
	C198.694397,435.446747 200.534073,437.367432 202.843903,438.666504 
	C202.603394,439.382965 202.459259,439.904236 202.092407,440.602783 
	C201.813293,440.936554 201.689270,441.057343 201.356934,441.326965 
	C200.861938,441.640961 200.571625,441.799408 200.081360,442.082489 
	C199.885071,442.213806 199.526627,442.512299 199.368713,442.683044 
	C199.210785,442.853821 198.928406,443.226898 198.789001,443.417389 
	C198.649582,443.607880 198.325363,443.955414 198.100418,444.032043 
	C196.389618,443.702118 195.156693,444.583923 193.467987,444.930603 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M184.082306,434.390015 
	C188.075577,433.074036 192.199402,431.406006 195.849487,435.663025 
	C195.990570,436.018097 196.003937,435.999634 196.014130,435.994385 
	C195.642349,436.316833 195.197128,436.462921 194.371552,436.287262 
	C190.509598,437.358368 187.117020,437.546387 184.082306,434.390015 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M189.844849,438.645355 
	C189.907791,439.158905 189.694611,439.443451 189.249359,439.861206 
	C188.794312,440.268188 188.605850,440.564240 188.266190,441.074280 
	C187.925064,441.345734 187.764603,441.422150 187.337311,441.513306 
	C186.906555,441.457611 186.742676,441.387238 186.455872,441.079163 
	C185.668655,437.707703 187.315857,437.657990 189.844849,438.645355 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M184.279327,442.917358 
	C183.943100,443.424957 183.745453,443.676056 183.245575,443.964417 
	C183.040024,442.912781 182.779846,441.642548 184.623199,441.063568 
	C185.115967,441.134857 185.263458,441.262787 185.383774,441.683075 
	C185.155731,442.322327 184.874481,442.577240 184.279327,442.917358 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M194.028351,436.324219 
	C194.485596,436.030212 194.925095,435.937225 195.694473,435.916687 
	C195.547577,436.296082 195.070816,436.603027 194.294891,436.919220 
	C193.995743,436.928467 194.010620,436.525208 194.028351,436.324219 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M185.275787,442.210236 
	C184.883209,441.989075 184.918579,441.497253 184.943512,441.252075 
	C185.195740,440.988770 185.423035,440.970642 185.991638,440.897034 
	C186.332977,440.841522 186.667389,440.767181 186.837601,440.786377 
	C187.475113,442.100372 186.675568,442.351410 185.275787,442.210236 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M167.757553,455.055115 
	C167.833130,455.269379 167.649155,455.554810 167.220200,455.933594 
	C167.149475,455.726715 167.323746,455.426483 167.757553,455.055115 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M170.781097,452.075165 
	C170.842590,452.267609 170.663300,452.559143 170.232056,452.935059 
	C170.166824,452.737732 170.353577,452.455963 170.781097,452.075165 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M168.756195,454.050659 
	C168.839798,454.275238 168.663269,454.566254 168.235321,454.937134 
	C168.154633,454.717010 168.325348,454.417023 168.756195,454.050659 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M169.767426,453.060852 
	C169.841629,453.271118 169.663589,453.562012 169.234863,453.934631 
	C169.161179,453.724731 169.338181,453.433105 169.767426,453.060852 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M198.044220,444.391693 
	C197.905823,443.930389 197.936157,443.752106 197.979797,443.302826 
	C198.235306,442.811707 198.464279,442.578522 198.857971,442.163696 
	C199.035950,441.994995 198.990204,441.989990 198.990417,442.013000 
	C199.418350,441.585419 200.014862,441.529846 200.795654,441.188141 
	C201.027237,441.012726 200.995407,440.999847 201.000305,441.016357 
	C201.407166,440.618713 201.948822,440.447021 202.721924,440.142700 
	C203.404861,440.087585 203.813843,440.091370 204.528198,440.125244 
	C206.090805,440.514862 206.997055,441.368042 208.063080,442.528076 
	C208.679153,443.244934 209.001602,443.783325 209.436340,444.618835 
	C209.892639,445.664032 210.110474,446.462524 210.447495,447.545654 
	C210.652283,448.444977 210.491165,449.065948 210.749878,449.953339 
	C208.376480,453.565002 204.895996,452.326752 202.321304,451.192474 
	C200.790421,450.518066 199.369904,450.346924 197.491165,449.970825 
	C196.774200,448.025879 202.054047,447.312897 198.044220,444.391693 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M199.316254,430.717896 
	C196.342468,431.574432 194.278137,428.886292 191.354370,429.863586 
	C185.289139,428.038269 186.978149,423.316467 187.167328,418.839233 
	C189.366196,416.374420 190.671280,418.060577 191.606110,419.542938 
	C193.570892,422.658417 196.365189,424.441467 200.098297,425.712372 
	C201.261826,427.673798 201.237717,429.227356 199.316254,430.717896 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M199.140213,431.100708 
	C199.783569,429.661377 200.095551,428.275604 200.134827,426.444092 
	C199.893738,425.810760 199.811356,425.543579 199.897736,425.280212 
	C199.983841,425.017639 200.072021,424.886902 200.470993,424.744781 
	C204.199066,424.842010 201.610870,428.466370 203.870789,429.598877 
	C206.288834,430.295258 208.419464,430.010010 210.838318,429.983063 
	C211.579407,432.052917 213.364487,431.940460 214.944580,432.765839 
	C214.935898,435.395142 212.849411,434.933716 211.069397,435.573944 
	C210.511765,435.743958 210.287369,435.804047 209.725800,435.940765 
	C208.015594,436.188141 206.809113,436.770752 205.380173,437.696716 
	C204.122528,434.860443 199.860443,434.730103 199.140213,431.100708 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M188.447968,417.653137 
	C188.415222,421.872925 186.156448,426.305420 190.835114,429.650940 
	C190.610519,429.989288 190.176361,430.019867 189.416199,430.034332 
	C188.088501,430.660797 187.366302,429.937622 186.323730,429.273926 
	C185.542557,427.038696 187.119980,424.504822 184.144196,422.906189 
	C184.462830,420.764465 185.178345,418.738007 185.897644,416.349609 
	C185.949646,415.543091 185.997849,415.098572 186.048203,414.317932 
	C186.229950,413.565460 186.497833,413.214752 187.160858,412.810303 
	C187.701874,412.751953 187.922791,412.803192 188.363037,413.116638 
	C188.777344,413.795013 188.912125,414.230347 189.027740,415.024597 
	C189.064301,416.064484 188.941956,416.734894 188.447968,417.653137 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M205.320984,438.076477 
	C205.127106,435.739258 206.446625,435.043610 208.694031,434.980408 
	C209.524368,435.508179 209.847702,436.105438 209.928894,437.164246 
	C209.840073,438.209381 209.592102,438.847992 208.978058,439.691864 
	C208.566910,440.080994 208.380325,440.211334 207.863922,440.423828 
	C207.311203,440.468933 207.088333,440.431824 206.624985,440.155945 
	C206.106995,439.371521 205.829483,438.825928 205.320984,438.076477 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M179.996368,431.277832 
	C180.497253,430.440430 180.997070,429.844604 181.777161,429.150940 
	C183.436401,430.906494 184.045792,432.396912 180.331085,432.003937 
	C179.997147,432.002441 179.995331,431.519348 179.996368,431.277832 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M205.996643,439.975769 
	C206.561829,439.932953 206.739136,439.948761 207.180206,440.006226 
	C208.072357,440.626465 208.628281,441.245575 208.585098,442.487976 
	C208.433441,442.988007 208.328705,443.173431 207.905258,443.337585 
	C206.276520,442.898407 205.891220,441.621552 204.987350,440.419373 
	C205.091965,440.114960 205.350357,440.074677 205.996643,439.975769 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M186.081482,429.370117 
	C186.865524,429.298889 187.668152,429.555450 188.780457,429.915131 
	C187.959229,431.164124 186.911926,431.529572 186.081482,429.370117 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M202.989319,439.809906 
	C202.529388,440.400482 202.062912,440.717133 201.300842,441.033325 
	C201.485519,440.432678 201.965805,439.832458 202.716553,439.110168 
	C202.985611,439.170685 202.984207,439.353333 202.989319,439.809906 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M178.681519,426.994781 
	C178.524368,427.324860 178.046021,427.669281 177.268585,428.091705 
	C177.433105,427.782837 177.896713,427.395966 178.681519,426.994781 
z"/>
<path fill="#059FE5" opacity="1.000000" stroke="none" 
	d="
M236.261902,477.241211 
	C232.406860,477.764160 228.871277,477.994141 225.196777,476.511414 
	C223.994415,474.654816 225.408829,473.656738 226.070740,472.147888 
	C227.190735,470.555939 228.136017,469.263458 229.227051,467.645782 
	C230.502731,466.095703 231.375473,464.659058 232.980255,463.382446 
	C235.652161,462.268890 238.007660,461.220032 240.735138,463.140442 
	C241.593903,464.428925 241.040710,465.258636 240.379425,466.400269 
	C240.047287,466.865967 239.888260,467.030365 239.417664,467.318970 
	C238.646790,467.736725 237.782990,466.888184 237.634186,467.860535 
	C237.537231,468.494019 237.467911,467.590088 238.357071,467.792023 
	C239.032608,467.562653 239.404755,467.377747 239.993683,466.924438 
	C240.904205,465.744507 241.406921,464.702728 242.269287,463.496338 
	C243.866104,462.897644 245.058136,463.015228 246.324341,464.233978 
	C246.914017,465.524994 246.789001,466.489716 246.330078,467.770660 
	C245.063324,469.660797 244.006866,471.253387 244.482407,473.661224 
	C243.893768,474.781067 243.090317,475.185577 242.011597,475.776123 
	C241.311859,476.134521 240.904938,476.325012 240.182602,476.638519 
	C238.801987,477.141815 237.728271,477.493103 236.261902,477.241211 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M227.028381,471.805786 
	C226.555756,473.277130 225.892044,474.424042 225.123474,475.893555 
	C222.556900,476.296265 220.432785,479.116730 217.360718,477.178040 
	C216.484299,477.322968 216.068344,477.141144 215.744064,476.362610 
	C215.835312,475.832916 215.926300,475.672638 216.107132,474.949615 
	C216.322220,474.231781 216.447464,474.076691 217.119354,473.693970 
	C217.866684,473.454529 218.067413,473.442657 218.567261,473.421814 
	C220.484131,473.107208 220.879242,471.370544 222.439880,470.478973 
	C224.328751,469.959045 225.667145,470.422241 227.028381,471.805786 
z"/>
<path fill="#14A4F1" opacity="1.000000" stroke="none" 
	d="
M235.970642,477.414856 
	C237.064117,476.735321 238.173767,476.371002 239.638351,476.003357 
	C240.190598,475.862091 240.387894,475.724152 240.915253,475.734558 
	C241.354889,476.098633 241.464478,476.314392 241.613434,476.892395 
	C241.604752,477.493805 241.556702,477.732941 241.331848,478.293640 
	C240.987625,478.794464 240.820251,478.973724 240.348206,479.359619 
	C239.815002,479.655457 239.586502,479.744629 238.996628,479.901978 
	C237.887360,480.016602 237.178894,479.887268 236.266327,479.246552 
	C235.998260,478.573425 235.992523,478.151733 235.970642,477.414856 
z"/>
<path fill="#2AD5F9" opacity="1.000000" stroke="none" 
	d="
M235.880890,479.289856 
	C236.764801,478.988495 237.525620,478.981873 238.666931,478.976685 
	C240.024796,480.498932 239.116623,481.334076 237.559326,482.182983 
	C236.700348,482.450592 236.196655,482.500793 235.361511,482.244568 
	C235.040100,482.039001 235.004623,482.004364 234.986542,481.986511 
	C235.231583,481.173981 235.494690,480.379303 235.880890,479.289856 
z"/>
<path fill="#033E75" opacity="1.000000" stroke="none" 
	d="
M214.420166,474.677551 
	C214.199615,473.893494 214.315414,473.107147 214.672241,472.126099 
	C215.349625,471.593903 215.842529,471.450195 216.754333,471.661926 
	C217.420197,472.285065 217.526505,472.787720 217.206757,473.656372 
	C216.978073,473.980652 216.998169,474.000854 216.991119,473.989990 
	C216.779510,474.215729 216.558853,474.436218 216.156281,474.805817 
	C215.990448,474.971008 216.017776,474.993591 216.024292,474.976624 
	C215.606049,474.864868 215.181274,474.770081 214.420166,474.677551 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M215.555420,476.173248 
	C215.975876,476.325562 216.207397,476.657990 216.722839,477.115234 
	C216.573334,477.715393 216.026199,478.025543 215.505417,477.529327 
	C215.285355,477.319672 215.402557,476.756073 215.555420,476.173248 
z"/>
<path fill="#08346F" opacity="1.000000" stroke="none" 
	d="
M263.682220,491.592865 
	C265.015350,492.411438 264.931763,493.374359 264.746704,494.866455 
	C264.212433,495.466370 263.840576,495.457855 263.255280,495.202515 
	C257.912964,495.530457 255.051132,499.671356 251.131561,502.655884 
	C251.102615,503.137085 251.222366,503.316589 251.153732,503.759216 
	C250.965347,504.022339 251.008392,504.020081 251.012299,503.999451 
	C250.235901,504.086426 249.455597,504.194061 248.286270,504.226440 
	C247.674072,503.630890 247.513779,503.093201 247.345535,502.267273 
	C247.184982,501.845093 247.127823,501.684753 246.996109,501.280334 
	C247.690094,498.969116 249.691193,497.108673 247.930786,494.278015 
	C248.166550,493.781128 248.467728,493.634583 248.903534,493.271118 
	C250.594940,491.479553 252.606339,491.660004 254.971191,491.616455 
	C256.715820,491.566589 258.069031,491.721893 259.758667,491.148193 
	C261.249390,490.863586 262.327209,490.885284 263.682220,491.592865 
z"/>
<path fill="#1391DB" opacity="1.000000" stroke="none" 
	d="
M256.337585,492.624451 
	C253.969910,492.840424 251.939240,492.953857 249.473358,493.060730 
	C249.030548,492.588135 249.022964,492.122070 249.026291,491.306641 
	C250.026962,488.758698 251.893814,489.065948 253.720474,489.352264 
	C256.086914,489.723267 258.351990,489.725800 260.536591,487.700195 
	C261.552582,487.162476 262.300232,487.085907 263.441589,487.123352 
	C265.493988,487.635406 267.142181,488.385437 269.306732,487.551392 
	C271.650391,486.494293 273.773193,486.673157 276.267426,486.619598 
	C277.752594,486.579163 278.826874,486.676697 280.287659,486.987427 
	C280.921265,487.237000 281.160339,487.371521 281.649872,487.832397 
	C281.629364,490.301208 279.952148,490.096863 278.556000,489.983215 
	C273.812073,489.597107 269.270355,491.055267 264.301910,491.613647 
	C262.966370,491.939941 261.937561,492.021606 260.522217,492.114685 
	C259.035370,492.724792 257.826782,492.376892 256.337585,492.624451 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M281.580414,479.963928 
	C282.308502,481.065765 282.636993,482.157074 283.011902,483.589081 
	C282.878265,484.078857 282.698151,484.227966 282.171692,484.432007 
	C280.123413,483.821655 278.500977,483.743286 276.702087,484.441864 
	C274.212677,485.408508 271.652588,485.560608 269.188904,483.310913 
	C268.915009,483.101746 268.532745,482.990112 268.347198,482.920013 
	C267.689026,479.641968 270.144989,479.423737 272.149933,479.379517 
	C275.154541,479.313263 278.169983,479.737671 281.580414,479.963928 
z"/>
<path fill="#10B2F6" opacity="1.000000" stroke="none" 
	d="
M236.731506,482.219971 
	C237.642395,481.173065 238.297073,480.389038 238.999588,479.291565 
	C239.240540,478.960571 239.433655,478.942993 239.915283,478.888733 
	C240.337952,478.703522 240.472107,478.554932 240.817932,478.193329 
	C241.029587,477.980347 240.997253,477.994049 240.992523,478.010925 
	C241.649185,477.437714 242.417725,477.226013 243.663422,477.558044 
	C244.383484,478.205475 244.518814,478.725739 244.223175,479.653015 
	C243.438110,480.166656 242.873505,480.327972 242.154526,480.744629 
	C243.735794,481.341309 245.471436,481.682648 247.590195,482.058899 
	C248.128113,484.127441 247.246887,485.089264 245.149445,485.006561 
	C243.048096,484.923737 240.941376,484.976532 238.375885,484.949280 
	C237.768219,484.393036 237.621674,483.857483 237.237564,483.159180 
	C236.825104,482.825256 236.650208,482.654053 236.731506,482.219971 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M268.963623,483.420898 
	C272.270294,483.897919 275.674622,484.606354 278.712341,482.305145 
	C280.791962,480.729828 280.598816,483.147461 281.720947,483.858704 
	C282.530396,484.557220 282.769531,485.196930 282.659546,486.291809 
	C282.334839,487.059235 281.999969,487.376892 281.270935,487.786469 
	C279.926575,488.003876 278.864960,488.007660 277.405304,488.006531 
	C275.164978,486.344666 272.677277,487.511688 270.393402,486.315918 
	C269.745239,485.298309 269.378723,484.519165 268.963623,483.420898 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M250.260513,482.181274 
	C252.947083,478.849335 261.753906,478.969727 264.021179,482.686188 
	C259.540955,482.831573 255.025085,483.556396 250.260513,482.181274 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M260.846130,487.879089 
	C259.788483,491.396179 257.033661,491.069061 254.424622,490.837952 
	C252.850433,490.698486 251.337677,489.506256 249.375931,490.811096 
	C247.740112,486.972412 250.597107,486.542603 253.660004,485.996338 
	C255.906769,487.863556 258.597748,486.287140 260.846130,487.879089 
z"/>
<path fill="#08346F" opacity="1.000000" stroke="none" 
	d="
M261.440308,488.142822 
	C258.868713,487.224487 256.096130,489.017242 254.086517,486.393463 
	C254.750397,485.937714 255.478394,485.861572 256.569855,485.741425 
	C257.122375,485.672852 257.311401,485.648254 257.784302,485.658386 
	C259.728119,485.793884 261.388092,485.894684 263.459534,486.057770 
	C264.317963,486.440979 264.494720,486.872559 264.206818,487.736755 
	C263.276489,488.070343 262.540680,488.082001 261.440308,488.142822 
z"/>
<path fill="#045CAD" opacity="1.000000" stroke="none" 
	d="
M269.967590,486.281219 
	C272.331879,486.288177 274.799713,485.217010 276.828766,487.671143 
	C274.634369,488.019958 272.261475,488.038300 269.445557,488.019348 
	C268.881897,487.827637 268.761292,487.673218 268.834290,487.297668 
	C269.339264,486.941406 269.604431,486.744232 269.967590,486.281219 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M268.649658,487.045898 
	C269.027924,487.076508 269.014893,487.529480 269.008728,487.755768 
	C267.660492,489.439026 266.082611,489.098511 264.246521,488.317047 
	C263.987366,487.626953 263.962433,487.195190 263.904266,486.441742 
	C265.337830,486.418457 266.804596,486.716858 268.649658,487.045898 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M257.946899,485.569122 
	C257.879211,485.733551 257.690308,485.774017 257.217346,485.755920 
	C257.230774,485.613342 257.528229,485.529236 257.946899,485.569122 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M207.233612,475.004272 
	C206.980011,474.833588 206.982971,474.663116 206.976593,474.236938 
	C207.378738,474.196045 207.790222,474.410828 208.201691,474.625610 
	C207.964523,474.751923 207.727356,474.878235 207.233612,475.004272 
z"/>
<path fill="#14A4F1" opacity="1.000000" stroke="none" 
	d="
M236.662811,481.968597 
	C236.990448,482.130341 236.993149,482.303558 236.997925,482.736603 
	C236.283524,483.150726 235.395416,484.055420 235.049072,482.295593 
	C235.472687,482.019348 235.905289,481.999725 236.662811,481.968597 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M166.944427,457.896545 
	C166.687363,458.192841 166.452438,458.147705 165.860504,458.050812 
	C165.810196,457.724182 166.116898,457.449310 166.691711,457.022675 
	C166.962036,457.098999 166.964294,457.327087 166.944427,457.896545 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M199.176743,460.733337 
	C198.838776,461.010223 198.669220,461.008118 198.245911,460.987915 
	C197.843704,457.918091 199.817764,457.186890 202.694000,457.043304 
	C203.017349,457.427979 202.955795,457.790619 202.819489,458.414215 
	C201.611526,459.268250 200.478333,459.861328 199.176743,460.733337 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M194.010071,461.851196 
	C193.514618,462.440399 193.013916,462.640686 192.226151,462.812988 
	C192.319061,461.211884 192.699051,459.638733 193.112427,457.927399 
	C194.664749,459.015076 193.699707,460.368530 194.010071,461.851196 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M203.044952,454.266724 
	C203.870895,454.792145 206.204407,455.414948 203.378510,457.041687 
	C203.051392,456.275696 203.037781,455.472321 203.044952,454.266724 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M186.255371,455.946320 
	C185.874771,456.068390 185.703934,456.056671 185.254745,456.013062 
	C185.457977,455.664917 185.939560,455.348602 186.724640,455.018616 
	C186.918900,455.328857 186.731216,455.598022 186.255371,455.946320 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M187.223511,454.916321 
	C187.187988,454.756104 187.378937,454.485413 187.797821,454.105042 
	C187.833817,454.265564 187.641907,454.535706 187.223511,454.916321 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M188.227936,453.904999 
	C188.192383,453.746582 188.391464,453.482666 188.812454,453.101135 
	C188.843765,453.255524 188.653168,453.527527 188.227936,453.904999 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M214.220917,451.224854 
	C213.962814,450.552734 213.958633,450.171570 213.940140,449.504700 
	C215.293732,447.286560 217.158539,448.259003 218.880188,448.364716 
	C223.174484,448.628418 225.851135,446.699066 227.279205,441.947510 
	C224.670013,440.519440 222.164978,439.790436 219.140900,440.092072 
	C218.501785,440.208374 218.279282,440.378540 218.251419,440.664215 
	C218.186722,441.327515 218.828766,441.153137 218.253891,440.815552 
	C218.247604,440.811890 218.309448,440.680237 218.738922,440.292603 
	C219.973099,440.016968 220.890030,440.025330 222.035339,440.721344 
	C222.537857,441.431976 222.616501,441.919037 222.411865,442.783264 
	C221.133926,444.283295 219.641235,444.609741 217.772522,444.966614 
	C214.704544,444.897003 213.035904,442.962646 210.902771,441.179016 
	C210.618439,440.646729 210.546204,440.413696 210.497513,439.820679 
	C210.628433,439.250702 210.735825,439.040741 211.141876,438.652008 
	C212.431458,437.731903 214.733398,439.499847 214.782288,436.443542 
	C215.330841,435.507446 215.967499,435.213623 217.048218,435.008057 
	C218.079620,434.972382 218.725220,435.110443 219.379120,435.211365 
	C224.335678,435.976624 224.487320,435.848755 224.610291,431.000793 
	C224.648041,429.511810 224.579071,428.022278 224.608322,426.147186 
	C224.549438,424.428528 224.668259,423.121216 225.388367,421.541504 
	C227.270035,420.254120 227.585587,421.673309 227.966217,422.672852 
	C228.554504,424.217682 228.779861,425.879059 229.033112,427.502197 
	C229.637619,431.376770 231.548386,433.058868 235.536636,431.873993 
	C236.474289,431.595428 237.506943,431.739594 238.822266,432.062744 
	C240.913116,433.107849 240.133575,434.189026 239.346848,435.286407 
	C238.734314,436.140839 237.458450,436.660858 238.086060,438.328156 
	C239.461029,440.237091 242.232590,439.348328 242.938049,441.887421 
	C241.824692,443.081573 240.609268,443.154663 239.051971,443.292999 
	C238.465469,443.319489 238.234146,443.322968 237.663483,443.327393 
	C235.713333,443.416595 233.837585,443.079712 233.744995,445.891968 
	C233.770538,446.646729 233.722046,447.074890 233.484985,447.794189 
	C232.506989,449.036316 231.260773,449.632385 230.745026,451.286621 
	C230.253311,452.510223 229.840668,453.387085 228.870178,454.362061 
	C226.186234,455.645752 223.838882,455.454559 221.159286,454.257599 
	C219.088409,452.250244 216.477844,452.635834 214.220917,451.224854 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M227.362671,441.035980 
	C231.163528,441.303162 229.129913,443.342560 228.780075,444.188110 
	C227.225952,447.944122 221.898621,450.303925 217.701035,449.429932 
	C216.737717,449.229370 215.736359,449.211487 214.339172,449.164246 
	C213.925827,449.219025 213.467697,449.082703 213.232056,449.042786 
	C212.852737,448.836212 212.709091,448.669525 212.529663,448.174286 
	C213.109924,445.883759 215.051849,445.627441 216.775085,444.561279 
	C218.439331,443.918610 219.826416,443.447906 221.582550,442.951080 
	C223.299881,441.688629 225.093307,441.606567 227.362671,441.035980 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M220.602951,452.747864 
	C223.180344,454.321838 225.698090,453.947601 228.903931,454.125061 
	C229.985428,454.619629 230.216293,455.018555 230.332123,455.820984 
	C229.135025,458.117371 228.080582,460.173096 225.496002,461.097107 
	C224.383698,460.467285 224.415970,459.585785 224.276566,458.463318 
	C223.261993,456.971619 222.257431,457.307037 221.012848,458.319519 
	C220.613220,458.674622 220.440887,458.805786 219.647247,458.975372 
	C219.262650,455.622009 217.092117,455.741089 214.345184,456.111481 
	C213.760483,455.292633 213.129639,454.476959 213.913727,453.354523 
	C216.011383,451.734863 218.191620,452.601105 220.602951,452.747864 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M220.763336,452.595978 
	C218.878983,453.558563 216.857254,454.586395 214.392014,453.123169 
	C213.401382,452.623657 212.825943,452.118561 213.727173,451.093689 
	C216.218918,451.191772 218.694000,450.329834 220.763336,452.595978 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M207.240494,453.981628 
	C207.324738,453.480988 207.657684,452.738312 208.353043,453.593597 
	C208.088196,453.744141 207.823349,453.894653 207.240494,453.981628 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M210.902863,449.939514 
	C210.539703,449.736633 210.229263,449.232513 210.090927,448.217407 
	C210.456848,447.708099 210.650665,447.709808 211.072708,447.892120 
	C211.346024,448.261566 211.391083,448.450378 211.219604,448.833862 
	C210.987259,449.231812 210.971420,449.435059 210.902863,449.939514 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M211.335388,449.031738 
	C211.003098,449.028534 210.994110,448.532440 210.991333,448.284363 
	C211.382492,447.672211 211.846909,447.511200 212.701538,447.762695 
	C213.024017,448.144379 213.026657,448.316254 213.012848,448.745544 
	C212.553497,449.013580 212.110596,449.024231 211.335388,449.031738 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M206.040680,454.160034 
	C205.949081,453.986053 206.436691,453.951874 206.679596,453.934967 
	C206.922501,453.918060 206.997971,454.000854 207.034943,454.044952 
	C206.832397,454.453430 206.584244,454.784607 206.040680,454.160034 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M205.993835,453.974976 
	C205.866837,453.834442 205.747955,453.720184 205.629059,453.605927 
	C205.699463,453.652496 205.769867,453.699066 205.894669,453.865845 
	C205.949081,453.986053 206.001953,454.001312 205.993835,453.974976 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M216.754456,464.979462 
	C216.947083,463.893036 217.207794,463.108124 217.962662,462.378693 
	C218.741928,463.011841 218.796616,463.618317 218.567520,464.534790 
	C218.308884,464.973755 218.165833,465.123718 217.722748,465.351593 
	C217.222687,465.380035 217.022629,465.330536 216.754456,464.979462 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M217.998596,462.001221 
	C218.167053,461.141785 218.326309,460.275085 218.755737,459.211121 
	C219.025925,459.013824 218.996826,458.996826 218.983185,458.987183 
	C219.839035,460.026398 219.826279,461.034515 218.400085,461.989655 
	C217.970215,461.982147 217.989395,461.993988 217.998596,462.001221 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M215.895844,465.895996 
	C215.910706,465.502747 216.069809,465.218323 216.488525,464.823181 
	C216.686386,464.677917 216.868881,464.868408 216.959473,464.964264 
	C217.201187,465.479034 217.090088,465.823608 216.449921,466.110168 
	C216.145859,466.115967 215.978348,465.970276 215.895844,465.895996 
z"/>
<path fill="#0355A0" opacity="1.000000" stroke="none" 
	d="
M216.134445,466.487640 
	C216.487228,466.035400 216.736237,465.838165 216.971466,465.292236 
	C217.050079,465.060120 217.506866,465.030579 217.735001,465.012207 
	C218.906418,464.072693 219.866165,463.187408 221.704651,463.595093 
	C223.475555,466.145111 221.947449,468.182159 221.108551,470.675537 
	C220.730774,471.501801 220.415665,471.903809 219.664368,472.407227 
	C218.803253,472.692902 218.297592,472.662872 217.494629,472.255035 
	C216.683182,472.007111 216.177689,471.992188 215.292725,471.954346 
	C215.316528,470.240692 215.719788,468.550018 216.134445,466.487640 
z"/>
<path fill="#141923" opacity="1.000000" stroke="none" 
	d="
M120.847946,301.347107 
	C124.133614,300.897675 126.774521,302.768707 129.662186,303.548676 
	C132.312576,304.264618 130.919205,307.962189 130.297821,310.713074 
	C127.704201,312.316467 130.666794,316.366760 126.964714,316.935516 
	C123.167877,317.518890 119.718536,316.507477 116.787262,314.127319 
	C115.179085,312.821533 113.650848,311.236145 117.024391,309.832947 
	C120.639465,308.329254 119.388550,304.382507 120.847946,301.347107 
z"/>
<path fill="#141923" opacity="1.000000" stroke="none" 
	d="
M130.013916,313.439148 
	C133.402603,316.020081 139.593430,316.027313 140.008301,322.649689 
	C140.762863,324.015198 140.411255,325.140320 140.278046,326.589447 
	C130.281647,324.427338 130.002686,324.066345 130.013916,313.439148 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M98.291763,297.549622 
	C98.415520,292.420227 100.129021,291.461914 106.820000,292.844177 
	C106.754555,295.347748 104.929390,296.445526 103.350342,298.134308 
	C101.584221,298.160797 100.083160,297.967377 98.291763,297.549622 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M103.312401,304.145142 
	C102.992455,303.998901 102.956955,303.595123 102.958359,303.392487 
	C102.837669,302.903870 102.715569,302.617920 102.926361,302.005249 
	C106.989754,303.713837 110.720261,305.749146 115.578964,308.399963 
	C110.278290,308.196808 107.087128,305.858215 103.312401,304.145142 
z"/>
<path fill="#0A4271" opacity="1.000000" stroke="none" 
	d="
M108.722504,281.038422 
	C110.604820,281.885193 109.829491,283.116699 109.223709,284.647156 
	C108.922890,285.240601 108.703224,285.513397 108.004082,285.661194 
	C107.214256,284.913452 107.150131,284.254059 107.310242,283.245667 
	C107.625641,282.281616 107.977867,281.715485 108.722504,281.038422 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M103.214760,301.423889 
	C103.195946,301.927277 103.132637,302.176056 103.014557,302.807312 
	C102.490929,302.292053 98.369202,302.163849 102.628334,300.248657 
	C102.990105,300.503174 103.080185,300.836212 103.214760,301.423889 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M140.342834,326.973724 
	C140.077209,325.919128 140.042175,324.872345 140.008789,323.433228 
	C141.227707,323.840637 140.964661,325.118469 141.045532,326.645447 
	C141.034042,327.009369 140.573425,326.981537 140.342834,326.973724 
z"/>
<path fill="#0A4271" opacity="1.000000" stroke="none" 
	d="
M107.793900,287.916077 
	C107.673897,288.284943 107.327660,288.186646 107.168274,288.103088 
	C106.389252,287.272125 106.541344,286.597839 107.598984,285.984222 
	C107.995140,285.996674 107.999809,286.000000 108.002289,286.002441 
	C107.974472,286.518982 107.944191,287.033081 107.793900,287.916077 
z"/>
<path fill="#044166" opacity="1.000000" stroke="none" 
	d="
M156.525574,334.023254 
	C153.367767,336.365631 150.031464,333.283844 146.273636,333.374695 
	C145.992233,332.935181 145.995285,332.751526 145.995972,332.292419 
	C149.372772,332.678589 152.751938,333.340179 156.525574,334.023254 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M159.635559,388.744873 
	C159.619812,388.995056 159.487610,389.130737 159.355408,389.266418 
	C159.409973,389.054413 159.464539,388.842377 159.635559,388.744873 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M155.965744,390.950836 
	C156.344788,390.440826 156.722717,389.699921 157.435181,390.553101 
	C157.170700,390.722626 156.906219,390.892151 156.400696,391.118622 
	C156.159653,391.175568 156.029053,391.026886 155.965744,390.950836 
z"/>
<path fill="#141923" opacity="1.000000" stroke="none" 
	d="
M163.123291,385.237366 
	C163.341461,385.103088 163.610107,385.278320 163.925232,385.766846 
	C163.706604,385.898834 163.440628,385.721100 163.123291,385.237366 
z"/>
<path fill="#0A5C8E" opacity="1.000000" stroke="none" 
	d="
M167.951096,400.737244 
	C167.694260,400.907532 167.429947,400.729675 167.114502,400.237457 
	C167.287552,400.181244 167.580978,400.336578 167.951096,400.737244 
z"/>
<path fill="#0A5C8E" opacity="1.000000" stroke="none" 
	d="
M188.274689,412.701416 
	C187.494553,413.261444 187.021439,413.519165 186.299332,413.879364 
	C185.606873,413.974945 185.163406,413.968048 184.387726,413.971375 
	C183.907684,413.823029 183.759857,413.664459 183.831512,413.266022 
	C186.583130,412.750397 185.906067,410.798584 185.944794,409.290955 
	C186.015808,406.525635 185.991837,403.757874 186.072144,400.540955 
	C186.136810,400.090729 186.511047,400.104401 186.698059,400.113281 
	C187.082626,400.329865 187.280167,400.537567 187.710144,401.108459 
	C188.771255,405.078094 190.162033,408.651733 188.274689,412.701416 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M179.017883,411.755554 
	C178.908310,411.589722 178.962021,411.422272 179.015747,411.254791 
	C179.070892,411.421173 179.126053,411.587555 179.017883,411.755554 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M182.870956,412.798584 
	C182.539764,412.901367 182.113297,412.758087 181.686844,412.614838 
	C182.012634,411.944885 182.395737,412.276031 182.870956,412.798584 
z"/>
<path fill="#0A5C8E" opacity="1.000000" stroke="none" 
	d="
M178.512817,404.660797 
	C178.755035,404.047882 179.143265,403.955048 179.506851,404.520447 
	C179.228363,404.628387 178.949875,404.736328 178.512817,404.660797 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M183.800446,413.006531 
	C184.051010,413.026123 184.031342,413.504028 184.043427,413.742798 
	C183.716049,413.911041 183.437103,413.741180 183.092438,413.258301 
	C182.966217,413.044617 183.005142,412.996765 183.026840,412.973724 
	C183.215652,412.962769 183.382767,412.974854 183.800446,413.006531 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M187.404007,401.278748 
	C187.108521,401.043884 186.998047,400.582031 186.941559,400.352112 
	C189.851242,400.083954 192.935181,399.508209 195.757431,400.126648 
	C200.649734,401.198761 203.107697,398.073883 205.993256,395.353027 
	C207.353455,394.070465 206.337280,392.991150 205.921707,391.792816 
	C205.171051,389.628235 203.006104,388.143677 202.988083,385.250153 
	C208.074921,388.752106 210.898010,393.974091 211.984650,400.597534 
	C211.515015,401.553009 210.886093,401.762909 209.888184,401.931274 
	C207.492340,402.503052 208.415237,404.375641 207.945923,405.613647 
	C207.188736,407.611084 206.266907,409.214020 203.553452,407.666718 
	C203.662537,403.381561 201.570740,402.301544 197.933121,402.362549 
	C194.524475,402.419800 190.995438,403.106537 187.404007,401.278748 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M175.758087,371.195007 
	C179.628510,372.761139 184.205215,372.609619 186.989197,376.665833 
	C182.758133,376.632935 179.329651,373.976227 175.174561,372.362610 
	C175.007309,371.737366 175.205139,371.484772 175.758087,371.195007 
z"/>
<path fill="#074D75" opacity="1.000000" stroke="none" 
	d="
M169.990143,369.293152 
	C171.425232,368.944214 172.540543,369.694244 173.829529,370.747070 
	C172.836380,370.893341 171.659500,370.762207 170.243774,370.368591 
	C170.002472,369.925415 170.000000,369.744751 169.990143,369.293152 
z"/>
<path fill="#074D75" opacity="1.000000" stroke="none" 
	d="
M175.626587,371.014587 
	C175.766113,371.299652 175.574982,371.571838 175.162994,371.972412 
	C174.656189,371.904877 174.370239,371.708954 174.027863,371.257141 
	C174.412949,371.001373 174.854446,371.001556 175.626587,371.014587 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M171.987701,381.982544 
	C172.321320,381.463379 172.609512,380.744965 173.325928,381.595642 
	C173.055252,381.729248 172.784576,381.862854 172.273346,382.014648 
	C172.032806,382.032898 172.001511,382.000366 171.987701,381.982544 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M264.988403,495.001709 
	C266.685089,494.988373 268.388336,494.957977 270.510773,495.005951 
	C271.535126,495.534546 272.045013,496.085449 272.731445,496.853455 
	C272.796478,497.937500 272.692139,498.796875 272.342651,499.879211 
	C271.319305,500.207184 270.541168,500.312225 269.763000,500.417236 
	C270.872009,505.414032 267.111084,503.713959 264.405701,504.013153 
	C262.380676,503.899597 260.603882,505.551727 259.033386,503.269165 
	C260.036591,500.032654 263.859100,499.605652 264.838745,496.204834 
	C264.739319,495.682770 264.640717,495.508759 264.786926,495.161316 
	C265.031769,494.987915 264.994995,494.984619 264.988403,495.001709 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M258.577820,503.006500 
	C260.347382,504.344299 262.092529,503.084930 263.817749,503.766602 
	C261.700806,506.154846 262.161407,507.069519 265.266815,507.003845 
	C267.358337,506.959625 270.249756,506.191315 268.924194,510.524719 
	C263.289703,511.345978 258.749023,508.209534 253.797989,506.201111 
	C254.432220,504.261261 256.430511,503.781891 258.577820,503.006500 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M264.699615,494.963806 
	C265.031769,494.987915 264.970703,495.431091 264.904297,495.643921 
	C264.339813,495.724396 263.841736,495.592010 263.191711,495.240967 
	C263.482330,494.994781 263.924896,494.967224 264.699615,494.963806 
z"/>
<path fill="#0DA5E9" opacity="1.000000" stroke="none" 
	d="
M251.147400,503.935364 
	C250.933350,503.844360 250.901367,503.666382 250.926117,503.222992 
	C251.292068,503.179169 251.759888,503.339020 251.147400,503.935364 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M247.189407,502.304321 
	C247.475082,502.521210 247.708023,503.036987 247.919098,503.851990 
	C247.643707,503.635223 247.390182,503.119202 247.189407,502.304321 
z"/>
<path fill="#201B1D" opacity="1.000000" stroke="none" 
	d="
M429.745117,170.754578 
	C432.153748,177.084152 436.461395,181.828476 440.126862,186.974213 
	C441.290100,188.607269 443.132080,187.870499 444.695740,187.974945 
	C447.657166,188.172806 445.744507,189.449753 445.139099,190.708801 
	C444.655457,192.266861 445.082062,193.210464 446.183624,193.893677 
	C449.208008,195.769424 449.900665,198.581833 449.128876,202.144257 
	C447.547363,203.072922 445.811127,203.029465 445.390839,201.785583 
	C444.255371,198.425339 441.029449,196.536499 439.803345,192.939865 
	C439.659943,190.480072 438.143982,190.330246 436.214233,190.269623 
	C435.175293,190.220032 434.493896,190.094223 433.505798,189.748749 
	C429.229767,185.204147 424.637817,181.391220 421.054749,176.642548 
	C420.194458,175.502319 419.121948,174.899277 417.407379,174.650208 
	C416.641296,174.361496 416.241974,174.117325 415.606537,173.592987 
	C412.376404,170.462372 408.389038,169.106964 405.155579,166.600464 
	C403.214630,165.095856 401.145569,163.760971 399.770264,161.244125 
	C399.630859,159.671509 400.828491,159.740524 401.667480,159.093796 
	C400.561462,159.676865 399.594147,159.794128 398.270081,159.582321 
	C396.494568,158.330597 394.849823,157.419357 393.633881,155.554993 
	C394.118927,151.583389 399.267059,152.804703 399.892273,148.902283 
	C398.350159,143.024063 394.850830,138.533279 391.950867,133.725159 
	C391.101715,132.317230 389.835236,131.151138 389.525970,129.082352 
	C389.741150,128.247528 390.068268,127.900993 390.869202,127.748795 
	C400.190125,132.781006 405.939697,140.136078 408.056580,150.614105 
	C407.479492,151.609528 406.782074,151.734482 405.983734,151.542450 
	C405.769684,151.490952 405.600708,151.252655 405.344177,151.377579 
	C405.509003,151.618896 405.758026,151.757034 406.328857,152.031158 
	C407.078400,155.304398 408.965027,157.090042 411.719635,157.724182 
	C412.529144,160.081345 408.784515,159.777771 409.734222,161.741623 
	C410.454834,163.231827 412.113495,163.938843 413.406647,164.928055 
	C415.891296,166.828720 418.939209,167.768921 421.721863,169.805695 
	C422.735413,170.736572 423.567474,171.336090 424.904480,171.654480 
	C425.540222,171.983337 425.623291,172.617630 426.222992,172.232574 
	C426.264252,171.836166 426.305573,171.668289 426.476929,171.248444 
	C426.750122,170.855270 426.893250,170.714035 427.322083,170.443176 
	C428.264374,170.162796 428.897766,170.224014 429.745117,170.754578 
z"/>
<path fill="#191619" opacity="1.000000" stroke="none" 
	d="
M422.366760,171.239532 
	C417.876465,168.885086 413.576538,167.108078 409.996399,164.034729 
	C408.746704,162.961914 406.952881,162.251572 407.258270,160.281479 
	C407.577301,158.223053 409.941132,159.652390 411.239594,158.168640 
	C407.056702,158.540604 405.293243,156.773239 406.001770,152.430832 
	C406.513824,151.634460 407.082581,151.487488 408.151672,151.660461 
	C417.000305,156.440399 424.603607,162.271194 432.474243,168.304230 
	C432.809174,168.409668 432.764801,168.709015 432.748962,168.859497 
	C432.733093,169.009979 432.429871,169.037033 432.278015,169.047607 
	C430.585236,169.522400 429.132965,170.255234 427.268738,170.784332 
	C426.994537,170.998215 427.000000,171.000000 426.998840,170.996826 
	C425.669525,171.956116 424.189453,171.591949 422.366760,171.239532 
z"/>
<path fill="#44454A" opacity="1.000000" stroke="none" 
	d="
M391.074463,127.568985 
	C390.897095,128.064117 390.565369,128.288681 390.096436,128.783417 
	C387.393951,129.315155 386.115204,127.578430 384.929504,125.424927 
	C385.691254,125.093651 386.399109,125.118340 387.457306,125.210602 
	C388.845154,125.951591 389.882629,126.625015 391.074463,127.568985 
z"/>
<path fill="#252326" opacity="1.000000" stroke="none" 
	d="
M408.526978,151.523544 
	C408.019989,151.828308 407.445282,151.898041 406.436493,151.985565 
	C405.659058,151.813141 405.315704,151.622925 404.972321,151.432724 
	C405.659729,150.587143 406.602478,151.194214 407.733521,151.004166 
	C408.061737,151.003220 408.459229,151.288498 408.526978,151.523544 
z"/>
<path fill="#67F3F9" opacity="1.000000" stroke="none" 
	d="
M442.662598,159.932465 
	C442.484650,160.908813 441.602264,161.040939 440.314331,161.016785 
	C440.482178,160.053604 441.369537,159.905151 442.662598,159.932465 
z"/>
<path fill="#67F3F9" opacity="1.000000" stroke="none" 
	d="
M439.701111,160.975662 
	C439.540009,161.312683 439.069458,161.654404 438.284241,161.997345 
	C438.443542,161.659164 438.917572,161.319778 439.701111,160.975662 
z"/>
<path fill="#67F3F9" opacity="1.000000" stroke="none" 
	d="
M446.688660,157.989288 
	C446.529388,158.327713 446.056488,158.656204 445.277527,158.991211 
	C445.439301,158.658264 445.907166,158.318802 446.688660,157.989288 
z"/>
<path fill="#67F3F9" opacity="1.000000" stroke="none" 
	d="
M444.689331,158.958084 
	C444.536774,159.310593 444.063232,159.646820 443.283142,159.988495 
	C443.140259,159.246048 443.700714,159.023071 444.689331,158.958084 
z"/>
<path fill="#67F3F9" opacity="1.000000" stroke="none" 
	d="
M437.690125,161.974457 
	C437.509979,162.314621 437.007965,162.657684 436.176758,163.006592 
	C436.354431,162.667419 436.861328,162.322388 437.690125,161.974457 
z"/>
<path fill="#A0F5FC" opacity="1.000000" stroke="none" 
	d="
M460.086151,194.048798 
	C454.552979,188.980576 449.382751,183.861176 444.084473,178.437576 
	C452.515503,168.508362 463.184448,170.418350 472.033447,182.892242 
	C471.029602,184.328949 469.975098,185.397812 468.817993,186.785278 
	C465.483551,188.830536 463.947662,192.590790 460.086151,194.048798 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M476.669037,199.938354 
	C476.507996,200.583344 476.027954,201.185898 475.274017,201.902298 
	C475.004822,201.580307 475.009521,201.144470 475.045044,200.383301 
	C475.500580,200.003967 475.925293,199.949951 476.669037,199.938354 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M474.771729,202.079285 
	C474.830017,202.268539 474.644562,202.541595 474.227753,202.914703 
	C474.173584,202.730865 474.350800,202.446976 474.771729,202.079285 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M472.848480,204.050476 
	C472.901611,203.996643 472.893036,204.830948 472.848480,204.050476 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M470.482300,205.452759 
	C470.533752,205.424469 470.430847,205.481049 470.482300,205.452759 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M473.773529,203.073822 
	C474.014801,202.996613 474.011841,203.488724 474.001831,203.734375 
	C473.991791,203.980026 473.509125,204.011475 473.267761,204.019012 
	C473.026367,204.026566 472.999817,203.999237 472.987183,203.984100 
	C473.160431,203.696304 473.346344,203.423660 473.773529,203.073822 
z"/>
<path fill="#CFF3F8" opacity="1.000000" stroke="none" 
	d="
M485.657532,192.035248 
	C485.902802,192.908188 485.639526,193.686844 484.281677,193.936325 
	C483.898682,192.964371 484.229340,192.241379 485.657532,192.035248 
z"/>
<path fill="#CFF3F8" opacity="1.000000" stroke="none" 
	d="
M483.674500,193.933578 
	C483.517365,194.299042 483.049988,194.636124 482.277466,194.971558 
	C482.436279,194.615005 482.900238,194.260101 483.674500,193.933578 
z"/>
<path fill="#CFF3F8" opacity="1.000000" stroke="none" 
	d="
M481.698914,195.056854 
	C481.715149,195.267471 481.446289,195.564102 480.864899,195.917557 
	C480.839508,195.697205 481.126648,195.420029 481.698914,195.056854 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M477.720276,199.037292 
	C477.810516,199.268433 477.639069,199.548889 477.225891,199.908173 
	C477.142334,199.686874 477.300476,199.386749 477.720276,199.037292 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M479.735657,197.044739 
	C479.819305,197.265945 479.647156,197.549744 479.230286,197.909576 
	C479.150269,197.692856 479.315033,197.400085 479.735657,197.044739 
z"/>
<path fill="#C6F5FA" opacity="1.000000" stroke="none" 
	d="
M478.726074,198.038666 
	C478.815338,198.267456 478.645020,198.549637 478.231323,198.906891 
	C478.147461,198.685333 478.306976,198.388702 478.726074,198.038666 
z"/>
<path fill="#252326" opacity="1.000000" stroke="none" 
	d="
M475.432434,258.992889 
	C473.533020,255.138321 472.045807,251.283966 470.272705,247.213318 
	C469.986786,246.997025 469.996490,246.502136 469.993713,246.254669 
	C465.938324,241.118561 464.156616,235.190491 462.370728,228.935242 
	C463.225464,227.152557 464.511200,225.869171 463.930969,223.627167 
	C464.063629,222.308472 464.352783,221.422073 465.637360,220.943817 
	C467.065826,221.001099 468.130402,221.003433 469.594208,221.006836 
	C471.998413,222.744629 473.783508,224.507187 471.218597,227.173019 
	C469.734192,228.715820 470.569397,230.300201 471.357330,231.754227 
	C476.169067,240.633484 478.827423,250.599731 485.040161,258.776642 
	C486.187378,260.286591 486.207642,262.198425 486.307465,264.029633 
	C486.435913,266.385925 486.850677,268.647095 488.738586,270.748779 
	C488.286774,272.307190 487.851807,273.683167 488.015686,275.567352 
	C488.456909,278.425995 488.909760,280.918610 486.450623,283.015442 
	C485.749817,282.852783 485.251709,282.717987 485.213867,282.502350 
	C484.126740,276.309967 478.372314,272.680450 476.715820,266.716064 
	C474.926544,260.273529 474.673309,260.343872 480.885162,258.993103 
	C479.204987,258.993103 477.524841,258.993103 475.432434,258.992889 
z"/>
<path fill="#1D1B1E" opacity="1.000000" stroke="none" 
	d="
M489.047607,270.611084 
	C486.142914,271.410828 485.179016,269.030518 485.401001,267.341400 
	C486.299652,260.503387 481.132599,256.258453 478.822205,250.839615 
	C475.781433,243.707794 472.251099,236.783905 468.893768,229.788605 
	C468.259674,228.467468 467.788605,226.937454 469.464264,226.455505 
	C473.722046,225.230835 470.222229,223.309814 470.032410,221.354034 
	C474.669861,221.971115 474.597443,221.947525 473.304993,225.914871 
	C472.725555,227.693527 474.087006,228.989777 474.927673,230.388565 
	C480.343750,239.400055 485.486664,248.515686 487.066193,259.165039 
	C487.615601,262.869141 491.870056,265.896027 489.047607,270.611084 
z"/>
<path fill="#1D1B1E" opacity="1.000000" stroke="none" 
	d="
M466.001343,220.580017 
	C465.107849,221.533020 464.996643,222.405060 464.996460,223.663147 
	C464.873322,224.138992 464.750275,224.276749 464.350891,224.418152 
	C463.577606,224.323349 463.103088,223.878677 462.273499,224.338165 
	C461.123016,224.208420 460.380371,223.838074 459.530212,222.995667 
	C459.085205,217.039948 455.403961,213.463989 451.724152,209.717392 
	C449.875824,207.835541 447.078003,205.682571 449.226257,202.130585 
	C448.353516,198.677338 447.795959,195.381180 444.255188,193.613022 
	C443.295532,193.133820 442.581451,191.861099 444.679932,191.046570 
	C447.334564,193.620209 451.197083,195.025055 451.393738,199.373947 
	C451.437439,200.339951 452.704285,201.122162 453.689178,200.887741 
	C458.291046,199.792480 459.603149,203.367538 461.512299,206.159485 
	C463.559509,209.153473 465.468414,212.309799 469.457611,213.102386 
	C470.112457,213.232498 470.713776,213.558319 470.742889,214.378891 
	C470.780334,215.434616 470.071167,215.953308 469.209137,215.912582 
	C465.983337,215.760254 465.848022,217.826370 466.001343,220.580017 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M486.031799,283.416351 
	C487.930084,281.154114 486.241791,278.496979 487.742920,276.207245 
	C489.923950,275.609406 489.846313,279.552460 492.661133,277.900726 
	C493.140625,277.901459 493.306091,277.949463 493.727539,278.030762 
	C493.403809,278.860565 492.824036,279.657013 492.119690,280.724884 
	C490.451019,283.003265 490.394867,286.410461 486.491730,286.325500 
	C486.122620,285.368988 486.076416,284.588196 486.031799,283.416351 
z"/>
<path fill="#252326" opacity="1.000000" stroke="none" 
	d="
M427.368591,170.998123 
	C428.128998,169.607315 429.637817,169.051147 431.756073,169.043457 
	C431.520416,169.540222 430.914673,170.022263 430.146973,170.746033 
	C429.237518,170.991180 428.490051,170.994614 427.368591,170.998123 
z"/>
<path fill="#1E2B39" opacity="1.000000" stroke="none" 
	d="
M449.207184,409.468689 
	C445.767578,408.032684 446.707062,404.733490 445.248901,402.248138 
	C443.023987,397.469910 446.957611,396.389496 449.715851,394.215759 
	C450.026855,393.990723 449.996735,393.997223 449.991028,394.011536 
	C450.217987,393.794586 450.450104,393.562836 450.854919,393.155914 
	C451.028076,392.981201 450.998474,392.996460 450.994141,393.012512 
	C451.209686,392.782837 451.380096,392.506592 451.651703,392.006714 
	C452.039551,391.581421 452.313904,391.407990 452.820068,391.145538 
	C453.014801,390.997864 452.998535,390.997559 452.996948,391.005554 
	C453.225769,390.786865 453.454895,390.558838 453.852509,390.156342 
	C454.022308,389.983246 453.998138,389.998566 453.993652,390.012207 
	C454.433105,389.590790 454.505432,388.997772 454.839661,388.207336 
	C455.016266,387.973724 454.994202,387.995605 454.985901,388.008728 
	C455.216003,387.795837 455.450348,387.565613 455.851868,387.154114 
	C456.023193,386.977020 455.996582,386.996674 455.986877,387.010071 
	C456.215363,386.796570 456.449829,386.565857 456.852509,386.154449 
	C457.024445,385.977509 457.000427,385.994171 456.992432,386.006409 
	C457.219177,385.792908 457.450958,385.564148 457.850342,385.157532 
	C458.020935,384.982697 457.999146,384.998322 457.993896,385.010681 
	C458.529297,384.446655 458.731598,383.610809 459.712891,383.074280 
	C460.729553,383.000610 461.457581,383.003662 462.549622,383.011414 
	C463.314484,382.670624 463.744629,382.366547 464.575806,381.977600 
	C467.724457,381.428894 470.556885,381.793549 473.633179,381.038147 
	C473.961212,379.699036 474.413940,378.817627 475.640930,378.075226 
	C476.628967,377.420929 477.397034,377.269897 478.555481,377.817261 
	C478.895020,378.816742 478.918335,379.552734 478.984100,380.928436 
	C479.032349,381.935760 479.006042,382.301056 478.898865,382.939209 
	C478.802460,383.396729 478.755646,383.579163 478.620361,384.031860 
	C478.265350,385.025543 478.020752,385.755707 477.790344,386.808868 
	C477.672516,387.308929 477.621613,387.510773 477.487732,388.018616 
	C476.690460,390.876190 476.249817,393.477783 475.913330,396.445984 
	C475.594147,397.671936 475.313873,398.554138 474.947083,399.784424 
	C474.604248,400.558075 474.311798,400.940247 473.643799,401.467529 
	C472.857391,401.813232 472.374908,401.897400 471.515015,401.833679 
	C470.935883,401.649597 470.720428,401.531067 470.270569,401.127655 
	C468.085754,400.767639 469.313934,402.925720 467.908051,403.958374 
	C467.273865,404.691223 466.924622,404.881073 466.290466,405.149780 
	C465.849243,405.337402 465.673767,405.410339 465.238159,405.590759 
	C464.636688,405.840302 464.296112,405.984131 463.710693,406.250458 
	C463.298340,406.445557 463.131653,406.520081 462.707642,406.687805 
	C461.927368,406.943787 461.396881,407.082825 460.624817,407.391144 
	C460.186249,407.574554 460.007721,407.646759 459.553223,407.817657 
	C458.704468,408.106689 458.127441,408.284515 457.263489,408.619019 
	C456.753357,408.803253 456.543701,408.870575 456.007996,409.018738 
	C453.620178,409.191742 451.645844,410.299103 449.207184,409.468689 
z"/>
<path fill="#1B2027" opacity="1.000000" stroke="none" 
	d="
M484.184448,361.367554 
	C483.976837,360.638428 483.990723,360.171448 483.999542,359.348694 
	C480.820374,359.144409 479.936615,357.064331 480.135498,354.534729 
	C480.634705,348.185394 481.403595,341.857758 481.987335,335.514313 
	C482.134674,333.913055 482.457001,332.587097 484.604614,332.075043 
	C485.248169,332.269470 485.555115,332.404175 486.163055,332.411865 
	C486.593628,332.407990 486.765625,332.438965 487.179962,332.570984 
	C487.732758,332.835724 488.032288,333.017548 488.661865,333.608063 
	C491.564758,335.542175 492.157959,337.819458 492.062256,340.720734 
	C491.860413,346.840454 492.004089,352.971527 492.006042,359.571472 
	C489.592865,361.149414 486.975891,361.276794 484.184448,361.367554 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M477.820984,384.143372 
	C478.011414,383.855652 477.988983,383.516235 477.983002,383.346252 
	C478.379181,382.682434 478.504974,382.081085 478.818604,381.234558 
	C479.001190,380.987335 478.998352,381.008362 478.989014,381.016357 
	C479.780182,380.091766 480.580658,379.159210 481.653442,378.070557 
	C483.473663,376.754089 485.273712,376.680481 486.775177,376.500305 
	C485.627472,376.005890 484.025696,377.481934 482.311157,376.210022 
	C482.521271,372.620087 485.409607,371.201172 487.557526,369.229858 
	C489.478394,367.466919 488.402924,367.180481 486.337433,367.018860 
	C488.734894,364.684143 491.798767,363.847443 495.653412,364.938751 
	C496.701752,366.000977 497.052673,367.080078 496.249695,368.655701 
	C496.002441,369.020874 495.997467,368.997559 496.009094,368.999451 
	C493.412750,371.482269 492.813324,374.840546 491.958466,378.451782 
	C491.085510,381.132050 489.527802,383.161041 488.994995,385.962830 
	C488.740906,386.640564 488.494080,386.979706 488.144440,387.501770 
	C484.163818,391.024231 481.922485,395.809662 477.684448,399.296448 
	C476.559784,400.012604 475.668976,400.339905 474.341919,400.169373 
	C474.144501,399.169159 474.279022,398.313629 474.659729,397.241272 
	C475.740875,393.952820 476.438202,390.856598 476.793213,387.319214 
	C477.010193,386.977844 477.002380,387.001221 476.994141,387.010376 
	C477.761322,386.296326 477.394287,385.288574 477.820984,384.143372 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M478.905212,377.664490 
	C478.136383,378.053436 477.401062,378.026062 476.295471,377.973572 
	C476.604309,375.567261 477.283478,373.186066 477.949646,370.428223 
	C478.242523,368.806732 478.423920,367.020172 480.162659,367.617401 
	C481.591644,368.108215 480.483276,369.549164 480.270660,370.582458 
	C479.813995,372.801758 479.381226,375.026001 478.905212,377.664490 
z"/>
<path fill="#033256" opacity="1.000000" stroke="none" 
	d="
M496.362000,369.008484 
	C496.007324,367.941132 496.012207,366.861389 496.016418,365.376038 
	C496.015778,364.970459 496.385529,364.937012 496.567444,364.913696 
	C497.768005,366.592499 499.724884,365.605499 501.241791,366.456909 
	C499.550201,367.153656 498.712738,369.037445 496.362000,369.008484 
z"/>
<path fill="#033256" opacity="1.000000" stroke="none" 
	d="
M482.024109,376.299316 
	C483.993652,375.975830 485.939087,375.975830 487.884491,375.975830 
	C487.922485,376.208557 487.960449,376.441315 487.998444,376.674042 
	C486.234161,377.101349 484.469910,377.528656 482.315674,377.935242 
	C481.950470,377.483948 481.975250,377.053375 482.024109,376.299316 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M485.997253,366.996521 
	C485.900909,367.031738 485.807312,367.070435 485.860046,367.056976 
	C486.006348,367.004822 486.000000,367.000000 485.997253,366.996521 
z"/>
<path fill="#1E2B39" opacity="1.000000" stroke="none" 
	d="
M486.510376,321.040985 
	C485.542236,320.860931 484.951721,320.685028 484.177551,320.257599 
	C482.203552,317.766418 482.309021,315.396332 483.763489,312.558167 
	C484.488678,311.839844 484.958954,311.514252 485.696533,311.087097 
	C487.354462,309.274780 489.044403,308.220551 491.664185,308.762909 
	C493.827606,311.256317 492.527374,314.922455 495.736115,316.898132 
	C493.282043,319.057831 490.430450,320.849854 486.510376,321.040985 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M492.185760,308.745728 
	C490.207855,309.643738 488.442352,310.288940 486.320374,310.959839 
	C480.688202,310.154663 480.917542,307.686859 483.704254,304.078613 
	C484.662933,302.837311 484.887421,301.028900 485.696533,299.234406 
	C487.415466,299.645294 488.441895,301.272858 490.695862,300.992859 
	C491.208771,300.866150 491.364288,300.740112 491.753784,300.802246 
	C492.320038,303.625671 493.472809,305.631561 496.250824,306.365356 
	C495.308685,307.855927 493.626190,307.754608 492.185760,308.745728 
z"/>
<path fill="#05476E" opacity="1.000000" stroke="none" 
	d="
M492.019897,300.741272 
	C491.987732,300.990417 491.519897,300.985931 491.286591,300.989075 
	C491.124298,300.654449 491.303619,300.390167 491.812988,300.094635 
	C492.040527,300.157288 492.046265,300.324677 492.019897,300.741272 
z"/>
<path fill="#05476E" opacity="1.000000" stroke="none" 
	d="
M494.262024,297.959778 
	C494.185486,297.745300 494.367249,297.469452 494.784119,297.100159 
	C494.852905,297.303955 494.686615,297.601166 494.262024,297.959778 
z"/>
<path fill="#05476E" opacity="1.000000" stroke="none" 
	d="
M493.259583,298.961670 
	C493.183838,298.748077 493.367157,298.471405 493.785767,298.099121 
	C493.853577,298.301849 493.686127,298.600250 493.259583,298.961670 
z"/>
<path fill="#05476E" opacity="1.000000" stroke="none" 
	d="
M492.242584,299.954498 
	C492.179443,299.758820 492.368591,299.482910 492.790833,299.103394 
	C492.847565,299.291290 492.671234,299.582764 492.242584,299.954498 
z"/>
<path fill="#1B2027" opacity="1.000000" stroke="none" 
	d="
M486.219055,332.283020 
	C485.547699,330.046631 487.066711,327.660919 484.340393,326.063324 
	C483.608704,325.586121 483.477539,325.125092 483.794006,324.297821 
	C484.017731,323.995361 483.999176,323.996674 484.000488,324.006073 
	C486.630402,323.232025 489.262421,322.388550 491.981018,324.263977 
	C494.722198,323.761108 495.101776,325.284180 494.994934,327.618622 
	C495.003418,327.999603 495.000000,328.000000 494.999878,328.001892 
	C494.243378,328.686279 494.597015,329.645325 494.197998,330.733307 
	C494.009186,331.002716 494.000641,331.000244 494.003540,331.003723 
	C492.827087,332.343292 492.348633,334.675903 489.377197,333.999878 
	C489.001221,334.001221 489.000000,334.000000 488.999390,333.999390 
	C488.590881,333.536407 488.004028,333.498871 487.236450,333.179260 
	C487.009674,333.006500 487.000000,333.000000 486.995422,332.996582 
	C486.797607,332.856110 486.604309,332.719086 486.219055,332.283020 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M486.124908,286.509399 
	C489.081024,285.802979 489.593628,282.853210 491.702637,281.157135 
	C492.013062,281.470184 492.031006,281.944061 492.094116,282.772339 
	C491.472168,284.528900 490.804993,285.931030 490.099823,287.666199 
	C489.774506,288.212555 489.487213,288.425812 489.039154,288.859558 
	C488.164978,289.061005 487.451599,289.041992 486.380493,289.038025 
	C486.042236,288.325104 486.061615,287.597076 486.124908,286.509399 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M494.272705,330.798279 
	C494.162537,330.138153 494.315887,329.273621 494.734497,328.206421 
	C494.845215,328.867126 494.690704,329.730469 494.272705,330.798279 
z"/>
<path fill="#CFF3F8" opacity="1.000000" stroke="none" 
	d="
M384.681763,124.928291 
	C386.438385,126.315674 387.893341,127.562370 389.653748,128.931305 
	C394.303497,135.020691 399.044769,140.760849 400.856812,148.529053 
	C394.162415,146.419617 388.023865,142.884171 381.518768,139.260330 
	C375.288696,135.269821 368.742462,132.323013 364.084167,126.233429 
	C364.420135,119.881119 366.338165,118.787537 373.583740,120.792137 
	C373.976288,121.014175 373.994934,121.003838 373.997101,121.014091 
	C375.031677,121.900780 376.306854,121.315872 377.722900,121.814445 
	C378.007416,122.033173 378.460907,122.096336 378.688477,122.121353 
	C379.413086,122.439468 379.985718,122.502876 380.683563,122.908730 
	C382.023102,123.690765 383.201599,124.239189 384.681763,124.928291 
z"/>
<path fill="#BEDBE2" opacity="1.000000" stroke="none" 
	d="
M373.836975,120.773026 
	C372.677155,121.019920 371.367035,121.137062 370.080963,121.010345 
	C366.352692,120.643059 364.485016,122.074974 365.010925,126.398201 
	C361.210205,127.102112 358.624847,125.122383 356.552429,121.818611 
	C359.211517,117.857208 362.703888,120.090385 365.411377,119.698990 
	C363.625854,119.024239 361.253601,119.644196 358.945618,119.508003 
	C357.267670,119.408974 356.247192,119.069107 357.853424,116.966484 
	C358.587738,116.431580 359.050934,116.215851 359.897705,115.971130 
	C361.390137,115.673462 362.567047,115.576462 363.765228,114.531342 
	C365.760773,113.578217 367.396942,112.630417 369.620117,112.560333 
	C370.397186,113.116379 370.854004,113.521217 371.620422,114.007904 
	C373.939392,115.847450 373.004883,118.412910 373.836975,120.773026 
z"/>
<path fill="#BEDBE2" opacity="1.000000" stroke="none" 
	d="
M377.773499,121.759491 
	C376.827484,121.876328 375.647583,121.719475 374.233459,121.293488 
	C375.179382,121.178169 376.359497,121.331985 377.773499,121.759491 
z"/>
<path fill="#BEDBE2" opacity="1.000000" stroke="none" 
	d="
M380.724792,122.864243 
	C380.321625,122.954201 379.798676,122.766075 379.095886,122.362160 
	C379.479034,122.292969 380.042023,122.439560 380.724792,122.864243 
z"/>
<path fill="#252326" opacity="1.000000" stroke="none" 
	d="
M324.662750,102.001175 
	C325.460327,101.662277 325.967041,101.470978 326.747711,101.271263 
	C330.166443,109.880783 331.973297,110.972816 343.592896,111.015930 
	C345.280060,113.960808 342.894928,114.499596 340.753784,115.579414 
	C339.384491,116.017967 338.359314,116.086975 336.942200,115.907013 
	C336.325531,115.750084 336.085815,115.664566 335.511292,115.401924 
	C330.860535,113.937233 327.401154,110.877777 323.105591,109.468163 
	C321.175140,108.834679 319.802094,107.177567 320.797668,104.458603 
	C322.155304,103.502701 323.263580,102.825737 324.662750,102.001175 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M370.013733,112.469376 
	C368.251892,113.607910 366.563446,114.504280 364.558472,115.569992 
	C363.253235,115.941978 362.218719,115.949951 361.008484,116.533005 
	C360.334930,116.660622 359.948761,116.687927 359.274994,116.755661 
	C356.648438,117.589088 354.353394,118.597298 351.408936,118.242958 
	C350.297760,118.033401 349.540466,117.962440 348.462891,117.615051 
	C347.961884,117.238029 347.799774,117.039894 347.564545,116.464188 
	C347.731323,114.512962 348.879272,114.066330 350.616669,113.912933 
	C351.488251,113.690514 351.977478,113.431938 352.718445,113.055534 
	C355.709564,112.290512 358.506439,112.155151 361.653076,111.996292 
	C363.055664,111.975479 364.106476,111.959610 365.548523,111.912766 
	C367.349365,111.582779 368.758881,111.283775 370.530151,110.979340 
	C370.623596,111.391678 370.355347,111.809433 370.013733,112.469376 
z"/>
<path fill="#202731" opacity="1.000000" stroke="none" 
	d="
M361.739441,111.712769 
	C359.360321,113.326668 356.721191,114.697571 353.311890,113.103882 
	C352.995697,111.081696 353.302063,109.675819 355.790802,110.373810 
	C357.638977,110.892143 359.576355,111.092308 361.739441,111.712769 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M340.046326,115.491074 
	C340.978546,113.520012 343.722229,114.112686 343.996155,111.367630 
	C344.352356,110.906288 344.604248,110.710358 344.897034,110.215683 
	C345.167114,109.899178 345.335022,109.802597 345.745483,109.865952 
	C345.996216,110.461121 346.004395,110.896370 346.027405,111.657791 
	C346.885162,113.036964 347.102081,114.201302 346.413574,115.875198 
	C344.083679,117.233009 342.041718,117.484314 340.046326,115.491074 
z"/>
<path fill="#252326" opacity="1.000000" stroke="none" 
	d="
M346.319824,116.037216 
	C346.045197,114.746178 346.031128,113.742043 346.029633,112.360931 
	C347.662872,112.330017 349.677124,111.152618 350.925232,113.587723 
	C350.121948,114.463631 349.244843,114.978165 348.183594,115.748230 
	C347.588684,116.386246 347.115662,116.493004 346.319824,116.037216 
z"/>
<path fill="#252326" opacity="1.000000" stroke="none" 
	d="
M345.907227,109.853180 
	C345.988037,110.025879 345.493652,110.009750 345.246429,110.002762 
	C345.183075,109.649628 345.361206,109.288353 345.907227,109.853180 
z"/>
<path fill="#607584" opacity="1.000000" stroke="none" 
	d="
M373.769897,111.146271 
	C373.992676,111.233192 374.005737,111.412918 373.985413,111.861343 
	C373.723267,112.222801 373.494507,112.315559 373.265747,112.408318 
	C373.363861,112.018570 373.462006,111.628822 373.769897,111.146271 
z"/>
<path fill="#607584" opacity="1.000000" stroke="none" 
	d="
M283.317291,117.948547 
	C282.694305,117.131241 282.407776,116.300476 281.985291,115.162834 
	C282.234833,113.510338 283.300842,112.688126 284.491119,111.550766 
	C286.150970,110.584984 287.359558,110.321220 287.824341,112.738052 
	C288.014740,113.499947 288.021973,113.980759 288.052063,114.823517 
	C286.919464,116.613731 285.279022,117.262192 283.317291,117.948547 
z"/>
<path fill="#5B5D62" opacity="1.000000" stroke="none" 
	d="
M288.143494,112.727463 
	C287.060883,112.748100 286.868866,110.900414 285.109314,111.810684 
	C284.158020,111.589119 283.635986,111.123779 283.085754,110.206299 
	C282.959808,109.874451 283.031250,109.426369 283.083923,109.205414 
	C285.118011,109.000893 287.099426,109.017326 289.506989,109.068359 
	C290.086060,110.563255 288.972961,111.395416 288.143494,112.727463 
z"/>
<path fill="#3A3639" opacity="1.000000" stroke="none" 
	d="
M282.544678,109.885536 
	C283.761078,110.083252 284.598663,110.243378 284.820862,111.555328 
	C284.028137,112.768021 283.217987,113.676399 282.128601,114.720367 
	C278.882202,119.863243 274.196472,120.489487 268.606812,119.808510 
	C269.099365,117.390648 270.013245,115.049698 270.957489,112.347885 
	C274.030609,107.713173 278.324982,110.110191 282.544678,109.885536 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M320.686401,104.145477 
	C320.788422,106.464355 321.862976,108.510147 323.901062,108.689743 
	C328.634308,109.106842 331.433594,113.360558 335.973846,114.478241 
	C332.177673,117.569153 327.969849,115.432648 323.971375,115.352211 
	C318.155823,115.235222 312.368988,114.796577 306.548004,115.432571 
	C304.082367,115.701958 301.553650,115.533661 299.214508,113.680374 
	C303.523254,111.189110 307.929749,109.169006 312.654022,106.976318 
	C315.423126,105.906250 317.874451,105.008759 320.686401,104.145477 
z"/>
<path fill="#5CA0BC" opacity="1.000000" stroke="none" 
	d="
M298.833496,113.229782 
	C301.872498,114.890846 304.927551,114.034821 307.827728,114.093819 
	C316.949921,114.279419 326.085632,113.920647 335.629059,114.877380 
	C336.074982,114.826050 336.032318,114.994148 335.986328,115.067657 
	C336.322662,115.493645 336.465149,115.930832 336.199585,116.750565 
	C333.954315,117.067444 331.909058,117.075241 329.426056,117.111938 
	C327.603668,117.060722 326.219055,116.980598 324.420135,116.942970 
	C315.670654,114.768974 307.173523,117.629288 298.403503,116.089157 
	C296.065002,114.652496 296.863007,113.861259 298.833496,113.229782 
z"/>
<path fill="#7AAABF" opacity="1.000000" stroke="none" 
	d="
M279.746765,126.104767 
	C278.232788,129.106689 275.628937,128.145020 273.085510,127.386948 
	C274.571320,126.850182 276.213806,127.397469 277.891510,126.128471 
	C278.579559,125.873001 279.015198,125.915215 279.746765,126.104767 
z"/>
<path fill="#7AAABF" opacity="1.000000" stroke="none" 
	d="
M271.699219,127.230377 
	C271.819916,127.435844 271.660797,127.655243 271.222290,127.892624 
	C271.104828,127.691498 271.263641,127.469398 271.699219,127.230377 
z"/>
<path fill="#0A4271" opacity="1.000000" stroke="none" 
	d="
M495.983093,392.384857 
	C496.404236,391.982941 496.802795,391.929016 497.499634,391.829224 
	C498.475037,391.930145 498.958679,392.367401 499.709473,393.433472 
	C498.444092,397.497742 499.902405,398.381409 503.099426,397.421631 
	C505.147675,396.806732 506.904327,396.846924 507.440979,399.179108 
	C508.008423,401.644989 505.622345,401.414154 504.260986,402.062622 
	C501.591614,403.334045 498.731018,402.951111 495.486481,403.025085 
	C494.634857,401.108429 496.876556,398.844696 493.610138,397.109589 
	C492.453766,396.495331 495.864838,394.667114 495.983093,392.384857 
z"/>
<path fill="#0A4271" opacity="1.000000" stroke="none" 
	d="
M506.688843,382.759247 
	C508.836731,383.834656 509.354919,385.602234 509.972778,387.667694 
	C506.968292,390.083313 504.497650,393.034698 500.376770,394.005127 
	C500.010864,394.010895 499.998810,393.998108 499.994690,393.992035 
	C499.375946,392.657806 500.214142,391.681091 501.020874,390.966980 
	C503.019989,389.197266 502.741241,387.301331 501.841156,384.929291 
	C503.346497,383.678864 504.522705,382.356750 506.688843,382.759247 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M476.762756,399.231323 
	C480.596619,395.400818 482.478424,390.246429 487.676666,387.757812 
	C487.368622,389.222992 486.695618,390.761353 486.009888,392.648010 
	C486.353241,397.904266 485.692566,402.564056 482.365967,406.836975 
	C480.063202,404.638794 475.353912,404.240234 476.762756,399.231323 
z"/>
<path fill="#0355A0" opacity="1.000000" stroke="none" 
	d="
M476.675415,399.007507 
	C477.392548,400.356476 475.865143,402.767273 479.313110,402.501160 
	C482.311005,402.269806 480.156860,405.502777 481.784973,406.791077 
	C482.639130,408.144165 483.211823,409.260620 483.934723,410.654633 
	C484.057098,411.100616 484.029266,411.269073 483.996765,411.693542 
	C482.329956,413.865326 480.153961,410.902985 478.226837,412.766907 
	C476.927856,413.557922 476.423981,415.652954 474.856598,414.628967 
	C473.515472,413.752777 474.680145,412.427124 475.269806,411.638367 
	C477.024780,409.290863 477.528503,407.871155 473.647797,408.475769 
	C473.535248,408.493256 473.243805,407.362427 473.032928,406.427979 
	C472.836334,405.232574 472.385986,404.454224 472.235657,403.242432 
	C472.238342,402.459503 472.354065,402.032990 472.807007,401.401123 
	C473.294525,400.939209 473.541016,400.709839 473.898743,400.252563 
	C474.793732,399.703400 475.577484,399.382111 476.675415,399.007507 
z"/>
<path fill="#033256" opacity="1.000000" stroke="none" 
	d="
M491.223450,379.370728 
	C491.650055,375.392395 490.726471,371.073853 495.654449,369.040985 
	C496.136414,372.744171 497.433105,376.819031 493.076813,379.657776 
	C492.861816,379.999023 492.690430,379.999268 492.261963,380.000732 
	C491.800659,379.892731 491.596405,379.783600 491.223450,379.370728 
z"/>
<path fill="#044371" opacity="1.000000" stroke="none" 
	d="
M490.897522,379.367126 
	C491.365723,379.150177 491.612762,379.324127 491.900391,379.795410 
	C491.701599,382.160034 490.534973,383.942535 489.239685,386.040070 
	C487.170135,383.455536 490.237091,381.900024 490.897522,379.367126 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M478.387054,413.059265 
	C478.419708,406.515503 481.675293,412.934723 483.638458,411.895752 
	C484.552856,412.463562 485.113556,412.977539 485.832886,413.734161 
	C483.538879,414.104645 481.096588,414.146240 478.387054,413.059265 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M507.155823,382.739685 
	C505.568451,383.641296 504.162994,384.296692 502.424377,385.014099 
	C501.860596,385.159332 501.630005,385.242523 501.129761,385.075684 
	C500.812653,384.389557 500.765167,383.953461 500.781555,383.185669 
	C503.260040,382.930847 504.982269,381.172882 507.110992,380.496887 
	C507.714508,380.305237 508.562866,380.098297 508.491364,381.090149 
	C508.455780,381.583069 507.743774,382.027222 507.155823,382.739685 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M501.922485,377.919189 
	C501.724030,377.547913 501.826233,377.120941 502.013794,376.376831 
	C502.519684,376.222137 503.244324,376.311981 503.303650,376.560608 
	C503.481567,377.306091 502.796356,377.592346 501.922485,377.919189 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M505.532837,375.553497 
	C505.473175,375.587158 505.592468,375.519836 505.532837,375.553497 
z"/>
<path fill="#065486" opacity="1.000000" stroke="none" 
	d="
M500.871643,384.866272 
	C501.063629,384.873596 501.267151,384.921570 501.780945,385.022858 
	C507.973236,389.257141 501.426208,390.736206 500.137207,393.688049 
	C498.998718,393.903503 498.221893,393.539093 497.893738,392.121887 
	C497.905792,389.899750 498.272827,388.088959 499.538818,386.219330 
	C500.093018,385.805817 500.381531,385.605957 500.803528,385.162598 
	C500.957001,384.947876 500.883148,384.906891 500.871643,384.866272 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M500.662720,384.961334 
	C500.740326,385.230865 500.523651,385.513824 500.045807,385.886902 
	C499.979248,385.642914 500.173828,385.308838 500.662720,384.961334 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M289.580200,490.241425 
	C291.320190,495.961548 286.263031,494.647827 283.247406,496.120789 
	C280.512329,495.704956 280.887878,493.899536 281.181702,492.346619 
	C281.519196,490.562775 283.142212,491.052521 284.370361,490.896973 
	C285.976074,490.693604 287.577484,490.455841 289.580200,490.241425 
z"/>
<path fill="#0B5794" opacity="1.000000" stroke="none" 
	d="
M281.217499,488.032410 
	C281.091278,487.678436 281.274536,487.411865 281.752075,487.080658 
	C285.160217,484.436249 288.743530,484.851929 292.731506,485.856018 
	C293.094147,486.508270 293.093994,486.887939 293.099670,487.552246 
	C292.472595,488.627930 291.653198,488.744324 290.353302,488.268890 
	C287.583954,488.051483 285.193451,488.058197 282.351685,488.111847 
	C281.900360,488.158813 281.446838,488.064728 281.217499,488.032410 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M289.983582,488.362732 
	C290.757599,488.010193 291.540741,487.975586 292.714691,487.888977 
	C293.528229,487.874237 293.950958,487.911530 294.692596,487.960876 
	C295.383606,488.370636 295.527893,488.838623 295.225647,489.692749 
	C295.006836,490.008667 294.936615,490.487732 294.887390,490.724792 
	C294.433197,490.970795 294.028229,490.979736 293.318329,490.991272 
	C292.214783,490.676514 291.416199,490.359161 290.296143,489.996948 
	C289.980652,489.528290 289.986694,489.104462 289.983582,488.362732 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M284.613281,499.344910 
	C285.744659,498.083557 287.014282,497.493195 288.429108,498.569244 
	C288.957092,498.970795 289.035400,499.746216 288.512329,500.252472 
	C287.443970,501.286469 286.453979,499.932129 285.007965,500.004150 
	C284.618622,499.962891 284.635071,499.550232 284.613281,499.344910 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M272.891998,496.746399 
	C272.017090,496.976501 271.231476,496.739716 270.974854,495.398376 
	C271.875916,495.094879 272.688049,495.301880 272.891998,496.746399 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M289.015869,513.388306 
	C290.582977,513.011719 291.593658,513.733887 291.974304,515.662476 
	C290.471283,515.960083 289.421234,515.281128 289.015869,513.388306 
z"/>
<path fill="#0C86CA" opacity="1.000000" stroke="none" 
	d="
M287.979889,511.319214 
	C288.303650,511.479248 288.630737,511.937866 288.956085,512.694824 
	C288.630646,512.534668 288.306946,512.076233 287.979889,511.319214 
z"/>
<path fill="#0C1929" opacity="1.000000" stroke="none" 
	d="
M109.116493,280.686218 
	C108.846008,281.451691 108.687309,282.044037 108.284866,282.827026 
	C107.279808,283.775391 106.459541,283.579407 105.384903,282.981323 
	C104.908752,282.518036 104.727966,282.213196 104.524162,282.051147 
	C104.299706,282.420135 104.220894,282.585052 103.992020,283.001099 
	C103.236145,284.185059 102.537216,285.025574 101.271286,285.790588 
	C100.551056,286.318848 100.101784,286.629242 99.397232,287.038605 
	C98.501442,286.592499 97.860931,286.047394 97.071091,285.220917 
	C97.008186,284.200470 97.094604,283.461365 97.102356,282.357727 
	C97.023697,281.993134 96.985725,282.000000 96.990036,282.019287 
	C97.462204,281.595184 97.504433,280.980743 97.871635,280.205444 
	C100.058846,275.493652 100.761337,270.722748 101.007317,265.427856 
	C102.194717,264.510468 101.843079,263.161957 102.698563,262.145050 
	C103.605820,263.398315 104.763962,264.062378 106.708878,264.042908 
	C107.882782,265.427521 107.276222,266.950989 107.765289,268.671814 
	C107.915001,269.289703 107.752518,269.555573 107.285782,269.873291 
	C106.441200,270.535675 106.474915,271.271027 106.785545,271.995239 
	C108.106430,271.989777 109.164024,271.999146 110.618225,272.012329 
	C112.551727,274.600220 110.571556,276.895325 110.137070,279.663116 
	C109.614197,280.118622 109.403244,280.294281 109.116493,280.686218 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M110.192955,279.812012 
	C110.242485,277.599976 110.623840,275.213776 111.010010,272.421875 
	C111.515244,271.411713 112.015671,270.807281 112.758331,270.020599 
	C112.913338,273.291321 112.303741,276.612335 110.192955,279.812012 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M107.983459,268.587830 
	C106.535820,267.839844 107.183395,266.240540 107.057541,264.439972 
	C108.463615,265.203247 107.824097,266.794312 107.983459,268.587830 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M113.735023,265.228394 
	C113.846107,266.195679 113.685555,267.409851 113.254036,268.881683 
	C113.143173,267.917999 113.303284,266.696655 113.735023,265.228394 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M107.037102,271.647522 
	C106.859657,272.348907 106.670486,272.717407 106.481316,273.085876 
	C105.519096,272.146423 106.080246,271.251068 106.817642,270.167786 
	C107.058411,270.426361 107.041893,270.870514 107.037102,271.647522 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M114.005386,262.389160 
	C115.074303,262.726440 115.168297,263.619354 114.240990,264.834412 
	C113.993057,264.263977 113.999359,263.513885 114.005386,262.389160 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M115.747894,259.168396 
	C115.817863,259.563843 115.639130,260.124359 115.207214,260.848877 
	C115.135750,260.453064 115.317474,259.893280 115.747894,259.168396 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M115.959305,256.763794 
	C115.439667,256.675079 114.689224,256.321503 115.567116,255.605331 
	C115.718109,255.881546 115.869102,256.157776 115.959305,256.763794 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M116.940041,257.774170 
	C116.856491,258.021637 116.680992,258.037628 116.243584,258.092407 
	C115.964844,257.958069 115.947998,257.784973 115.914841,257.352722 
	C115.898521,257.093597 115.987022,257.013641 116.033173,256.973969 
	C116.403587,257.051178 116.659851,257.253998 116.940041,257.774170 
z"/>
<path fill="#09070A" opacity="1.000000" stroke="none" 
	d="
M150.203720,280.193848 
	C146.989136,269.282501 152.465149,259.905548 154.532623,250.035080 
	C155.987656,243.088531 159.762787,236.843460 160.999130,229.400314 
	C169.768204,238.387863 176.678345,248.551498 175.005692,262.333435 
	C174.481171,266.655212 175.698151,270.854034 176.002411,275.551819 
	C174.738525,278.083374 172.468689,278.225739 170.442871,278.778992 
	C165.520737,280.123169 160.473572,281.015442 155.330444,283.011169 
	C153.442932,282.246124 151.922165,281.354187 150.203720,280.193848 
z"/>
<path fill="#010610" opacity="1.000000" stroke="none" 
	d="
M216.999634,328.075378 
	C214.000092,326.422119 211.202438,324.441345 208.203796,322.186340 
	C206.435150,318.653687 203.231628,317.136475 200.630249,314.976318 
	C198.914688,313.551758 196.660461,312.562103 196.520508,309.538727 
	C196.752258,308.978577 196.902679,308.779907 197.374725,308.386108 
	C199.382294,307.559387 201.150269,307.717621 203.254028,307.650085 
	C205.554565,307.013733 209.098312,309.236389 209.272614,306.143066 
	C209.426178,303.417664 206.533737,301.514801 203.357437,301.339264 
	C202.702301,301.303040 202.046295,301.304382 201.031128,301.285431 
	C199.933151,301.218414 199.220795,301.049713 198.210434,300.583069 
	C196.044083,298.010803 195.108246,295.247375 194.764420,292.312439 
	C194.275406,288.138458 192.296722,286.057373 187.515686,287.067810 
	C184.527527,287.508942 181.937653,287.662903 178.942932,286.815674 
	C176.293198,284.399353 176.266113,282.264923 179.239624,280.076447 
	C186.867798,280.893402 194.393570,278.950348 201.646576,282.706421 
	C207.309875,287.545349 211.354721,293.168884 215.033707,299.003601 
	C216.362961,301.111725 218.199631,302.803986 219.714050,304.574219 
	C222.825790,308.211609 220.730133,308.436066 217.912659,308.976593 
	C216.829773,309.184357 215.571518,308.614014 214.430298,309.991882 
	C217.064987,313.845459 220.537384,316.568298 225.119553,317.918518 
	C226.832291,318.423187 228.965912,318.686951 228.860611,321.158936 
	C228.769974,323.286835 226.776169,323.379913 225.310608,324.078796 
	C222.630768,325.356628 219.580811,325.816589 216.999634,328.075378 
z"/>
<path fill="#061426" opacity="1.000000" stroke="none" 
	d="
M180.250519,280.607178 
	C177.086273,281.694489 177.957886,283.677307 178.718506,285.773499 
	C181.481583,288.082245 182.156555,291.102692 182.748337,293.990479 
	C183.435074,297.341431 185.015411,299.041534 188.904663,298.627258 
	C190.644180,298.580109 191.975525,298.699524 193.640945,299.317261 
	C196.117493,302.069397 198.684006,304.457550 197.246063,308.662201 
	C196.998169,308.998779 197.000000,309.000000 197.000000,309.000000 
	C195.762299,310.201324 194.249969,310.406799 192.237183,310.246155 
	C190.924759,309.768616 190.000870,309.251251 188.797577,308.578186 
	C188.518204,308.422485 188.225983,308.134674 188.027817,308.080933 
	C180.485580,301.566986 172.537506,295.884216 164.364563,289.974182 
	C161.119476,287.831604 158.210602,285.772980 155.132721,283.426208 
	C155.298080,280.404419 157.746857,280.616028 159.478271,280.127594 
	C164.693558,278.656342 169.975235,277.420532 175.617340,276.039124 
	C177.069305,275.989014 178.134949,275.992706 179.600311,275.998627 
	C181.078812,277.302643 181.318253,278.707886 180.250519,280.607178 
z"/>
<path fill="#0ABEFA" opacity="1.000000" stroke="none" 
	d="
M273.593933,316.017914 
	C274.312317,320.747894 273.657623,325.469757 274.776215,330.242279 
	C276.147888,336.094391 278.554993,341.054291 283.708954,344.841217 
	C284.404419,344.626862 284.863464,344.484406 285.687561,344.784119 
	C285.986145,345.012421 286.000000,345.000000 285.994080,345.006622 
	C286.695099,345.773468 287.460754,346.492798 287.812439,347.934570 
	C287.450409,351.742401 285.964111,354.345856 282.083374,355.258179 
	C272.771851,343.337982 263.831146,331.558105 254.771255,319.449951 
	C261.069397,319.480927 267.240143,318.365173 273.593933,316.017914 
z"/>
<path fill="#02AEE7" opacity="1.000000" stroke="none" 
	d="
M243.903656,328.678284 
	C255.352066,336.084686 265.746185,344.304138 275.678314,353.126678 
	C277.524353,354.766541 279.576691,356.174164 282.028870,357.513428 
	C282.647247,357.468475 282.770538,357.599091 283.067139,357.935883 
	C283.477997,358.418121 283.724579,358.685791 284.198151,359.128113 
	C284.567993,359.431946 284.720612,359.552063 285.112244,359.854919 
	C285.514221,360.165833 285.677124,360.294006 286.080322,360.631378 
	C287.882111,362.952728 290.453125,364.404694 290.549591,367.766357 
	C290.058533,369.000214 289.418030,369.669830 288.189850,370.216248 
	C272.739929,357.392090 257.628052,344.438660 243.297668,330.126099 
	C242.974274,329.350311 243.138748,328.932251 243.903656,328.678284 
z"/>
<path fill="#0BCCFD" opacity="1.000000" stroke="none" 
	d="
M290.021423,368.387115 
	C289.748322,364.943878 286.500702,363.902283 285.245880,361.160736 
	C284.765869,360.731537 284.545288,360.500153 284.131042,360.121826 
	C283.960480,359.952850 283.970428,360.028259 284.008453,360.029297 
	C283.675873,359.643036 283.497162,359.128387 283.004578,358.504944 
	C282.623749,358.014130 282.455017,357.705048 282.178528,357.154236 
	C282.025421,356.937317 281.999786,357.013672 282.036133,357.030548 
	C282.001648,356.616913 281.930817,356.186432 281.786255,355.436890 
	C284.401276,353.735809 286.101440,351.552155 286.980530,348.315918 
	C288.408234,346.807831 289.340729,348.065002 290.703766,348.844391 
	C290.936371,350.547028 292.024933,351.411621 292.882751,352.761414 
	C292.112732,358.504059 292.042511,363.880646 294.326874,369.434021 
	C293.973785,370.258423 293.561432,370.544220 292.651855,370.697327 
	C291.114838,370.538788 290.402008,369.863617 290.021423,368.387115 
z"/>
<path fill="#050E18" opacity="1.000000" stroke="none" 
	d="
M180.409149,280.984009 
	C179.985336,279.592682 179.992279,278.211731 179.999619,276.415833 
	C185.142014,275.390656 190.102432,277.131775 195.226212,277.168549 
	C198.318375,277.190765 200.662155,279.306000 201.961578,282.646606 
	C195.074493,280.978302 187.764984,283.014404 180.409149,280.984009 
z"/>
<path fill="#0DA5E9" opacity="1.000000" stroke="none" 
	d="
M289.699097,368.145996 
	C290.495117,368.564514 290.999329,369.130646 291.747009,369.852661 
	C296.771851,373.132019 299.045349,378.168732 301.705933,382.881592 
	C302.916718,385.026367 301.569550,385.873474 299.227905,386.188324 
	C297.361176,385.436340 295.857422,384.630005 294.142944,383.589844 
	C294.219910,382.741394 294.507599,382.126740 294.932037,381.200012 
	C295.170624,380.726135 295.272430,380.564331 295.165436,380.205963 
	C294.956635,380.009399 295.001740,379.999756 294.989105,380.019073 
	C294.767822,379.799347 294.641510,379.525726 294.569397,379.224304 
	C294.480469,378.852539 294.381012,378.640564 294.294220,378.582825 
	C294.298767,378.583649 294.297272,378.737518 293.996582,379.041077 
	C292.884949,378.922577 292.229706,378.602142 292.027710,377.416443 
	C291.802490,376.856140 291.578613,376.588623 291.141724,376.168457 
	C290.930237,376.014496 290.997559,376.028992 290.974182,376.054474 
	C291.721313,373.431976 288.962189,372.728546 287.993408,370.652161 
	C288.372620,369.658966 288.889984,368.976257 289.699097,368.145996 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M244.081970,328.455750 
	C243.964081,328.967438 243.664246,329.178955 243.225708,329.629333 
	C242.486130,329.420624 241.885284,328.973083 241.111511,328.296234 
	C240.835037,327.746735 240.731537,327.426514 240.819336,326.639191 
	C241.973816,326.833252 242.936920,327.494415 244.081970,328.455750 
z"/>
<path fill="#074D75" opacity="1.000000" stroke="none" 
	d="
M238.813370,325.334717 
	C237.911591,324.791382 237.237350,324.194946 236.563110,323.598511 
	C237.696487,322.718353 238.130234,323.967194 239.011246,324.591614 
	C239.173782,324.833649 239.040909,325.281647 238.813370,325.334717 
z"/>
<path fill="#074D75" opacity="1.000000" stroke="none" 
	d="
M240.929230,326.048584 
	C240.997025,326.487793 240.983322,326.803528 240.954102,327.593079 
	C240.537308,327.695587 240.136017,327.324249 239.636093,326.690887 
	C239.606888,326.243317 239.676331,326.057770 240.027313,325.777069 
	C240.508789,325.718018 240.688416,325.799072 240.929230,326.048584 
z"/>
<path fill="#074D75" opacity="1.000000" stroke="none" 
	d="
M239.733978,326.245911 
	C239.261841,326.262177 239.027023,326.050232 238.709412,325.590454 
	C238.585831,325.387817 238.879379,325.111389 239.026581,324.972534 
	C239.494583,324.914581 239.772705,325.071289 240.158493,325.492798 
	C240.182724,325.808929 240.056595,325.935944 239.733978,326.245911 
z"/>
<path fill="#0BCEF8" opacity="1.000000" stroke="none" 
	d="
M259.104980,354.691956 
	C258.929901,354.793213 258.624817,354.667999 258.171265,354.340088 
	C258.340179,354.246735 258.657593,354.356110 259.104980,354.691956 
z"/>
<path fill="#010610" opacity="1.000000" stroke="none" 
	d="
M223.943512,309.864197 
	C223.867386,309.869263 223.749954,309.718903 223.632507,309.568512 
	C223.722412,309.615234 223.812317,309.661957 223.943512,309.864197 
z"/>
<path fill="#010610" opacity="1.000000" stroke="none" 
	d="
M224.010315,309.992126 
	C224.136200,310.132355 224.252243,310.280487 224.368301,310.428619 
	C224.280243,310.382172 224.192184,310.335724 224.044464,310.154480 
	C223.984818,310.019653 224.000488,310.000000 224.010315,309.992126 
z"/>
<path fill="#16BEE7" opacity="1.000000" stroke="none" 
	d="
M215.956543,271.269196 
	C216.189377,271.222870 216.479996,271.462860 216.834961,271.984253 
	C216.604309,272.028961 216.309311,271.792267 215.956543,271.269196 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M97.844772,280.018005 
	C97.932053,280.617767 97.770592,281.232452 97.301743,281.942841 
	C97.009041,281.609558 97.023735,281.180542 97.071289,280.432251 
	C97.104134,280.113007 97.596031,280.032867 97.844772,280.018005 
z"/>
<path fill="#15ABF3" opacity="1.000000" stroke="none" 
	d="
M336.330444,372.037659 
	C335.228912,372.027740 334.498688,372.004822 333.403748,371.968140 
	C332.644165,371.062256 332.284241,370.152527 331.847748,369.281189 
	C330.612671,366.815582 332.933411,365.033264 334.008575,364.539215 
	C336.254150,363.507263 335.949982,365.999542 335.998810,367.307251 
	C336.120483,370.563873 340.548767,369.361694 340.952759,372.641785 
	C339.545807,372.701904 338.123779,372.363281 336.330444,372.037659 
z"/>
<path fill="#10B2F6" opacity="1.000000" stroke="none" 
	d="
M354.346191,391.958374 
	C353.579102,389.312408 350.704346,387.458282 351.690125,384.145416 
	C354.236969,383.833649 356.361542,384.166473 357.847534,386.686066 
	C358.182251,387.167816 358.353882,387.333160 358.267334,387.745819 
	C357.112793,389.484222 356.823059,391.488800 354.346191,391.958374 
z"/>
<path fill="#1391DB" opacity="1.000000" stroke="none" 
	d="
M347.605713,384.985596 
	C347.870544,386.455383 348.671356,388.110321 346.445984,389.102386 
	C345.681000,388.956696 345.258606,388.698151 344.851166,388.417908 
	C342.776428,386.990875 341.183380,384.434143 342.712372,382.742035 
	C344.693481,380.549591 345.538300,384.438477 347.605713,384.985596 
z"/>
<path fill="#2AD5F9" opacity="1.000000" stroke="none" 
	d="
M358.267090,388.102844 
	C358.009125,387.993103 358.003998,387.497742 358.007294,387.250092 
	C358.922516,387.073120 359.711731,387.316803 359.966614,388.686768 
	C359.509979,388.743622 359.017517,388.478088 358.267090,388.102844 
z"/>
<path fill="#2AD5F9" opacity="1.000000" stroke="none" 
	d="
M360.156433,389.246826 
	C360.550140,389.164978 361.109711,389.331604 361.830078,389.750336 
	C361.434692,389.833374 360.878510,389.664307 360.156433,389.246826 
z"/>
<path fill="#2AD5F9" opacity="1.000000" stroke="none" 
	d="
M362.985107,391.703308 
	C362.985168,392.018982 362.486481,392.010071 362.237000,392.004425 
	C361.982788,391.556519 361.978058,391.114288 361.985291,390.340576 
	C362.326508,390.468628 362.655762,390.928131 362.985107,391.703308 
z"/>
<path fill="#15ABF3" opacity="1.000000" stroke="none" 
	d="
M341.019012,372.986145 
	C341.150879,373.129272 341.263916,373.288757 341.376953,373.448242 
	C341.283112,373.403534 341.189270,373.358826 341.031647,373.177307 
	C340.967865,373.040558 341.000183,373.002533 341.019012,372.986145 
z"/>
<path fill="#2AD5F9" opacity="1.000000" stroke="none" 
	d="
M363.010986,391.991333 
	C363.141296,392.133087 363.261627,392.282867 363.381958,392.432648 
	C363.290039,392.386932 363.198120,392.341217 363.045685,392.157257 
	C362.985168,392.018982 363.001007,391.999390 363.010986,391.991333 
z"/>
<path fill="#46E7FA" opacity="1.000000" stroke="none" 
	d="
M294.012451,370.402344 
	C291.162781,364.766632 289.045227,359.469910 292.823761,353.381714 
	C294.472046,352.826813 295.971039,352.752747 297.367615,352.335632 
	C300.394958,351.431458 302.517670,352.233063 303.865234,355.545898 
	C304.163635,356.042542 304.295898,356.224915 304.340485,356.732635 
	C302.673798,358.219879 301.359589,356.708984 299.581055,356.661987 
	C297.213715,357.703247 296.121338,359.304779 297.066437,361.503021 
	C298.181671,364.096832 298.121552,367.019012 299.757690,369.754456 
	C300.171783,370.555756 300.346832,371.104980 300.757507,371.829865 
	C301.775330,372.870544 302.058960,373.869171 301.642090,375.386230 
	C296.632904,377.661621 295.951508,373.327148 294.012451,370.402344 
z"/>
<path fill="#37AFE9" opacity="1.000000" stroke="none" 
	d="
M303.500610,357.472229 
	C303.752075,356.926331 303.811737,356.714722 303.951385,356.181641 
	C304.510071,356.170593 304.988739,356.481018 305.728455,356.904236 
	C306.087799,357.340515 306.272705,357.602966 306.761902,357.915161 
	C308.786591,359.188171 309.081116,361.146484 309.514404,363.352478 
	C309.282104,363.910278 309.127869,364.106262 308.617493,364.427643 
	C304.683624,363.718719 303.380432,361.214691 303.500610,357.472229 
z"/>
<path fill="#21E8FF" opacity="1.000000" stroke="none" 
	d="
M290.887573,348.796570 
	C289.901001,348.742371 288.803833,348.397430 287.363586,348.007019 
	C286.682190,347.190857 286.343842,346.420135 285.996826,345.331360 
	C286.793335,345.259705 287.598511,345.506165 288.698181,345.880554 
	C289.587402,346.840912 290.182159,347.673340 290.887573,348.796570 
z"/>
<path fill="#37AFE9" opacity="1.000000" stroke="none" 
	d="
M317.000336,374.620972 
	C315.888336,373.972382 314.806915,372.979462 313.415161,371.897888 
	C311.960144,371.298492 311.554840,370.322174 311.715424,368.585876 
	C313.132690,368.926270 314.273499,369.844452 315.697937,370.902527 
	C316.331390,372.120514 316.681152,373.198578 317.000336,374.620972 
z"/>
<path fill="#12628E" opacity="1.000000" stroke="none" 
	d="
M318.060547,376.715027 
	C317.669128,376.559326 317.323151,376.079620 316.974731,375.282043 
	C317.350189,375.439819 317.728088,375.915375 318.060547,376.715027 
z"/>
<path fill="#21E8FF" opacity="1.000000" stroke="none" 
	d="
M285.995361,344.759399 
	C285.547211,345.016602 285.108246,345.020782 284.340698,345.004456 
	C284.476410,344.669189 284.940765,344.354462 285.700195,344.019867 
	C285.998383,344.168793 286.001495,344.337555 285.995361,344.759399 
z"/>
<path fill="#0CD8FF" opacity="1.000000" stroke="none" 
	d="
M309.153687,364.269897 
	C308.384094,362.216034 307.721863,360.470306 307.019592,358.375244 
	C311.414856,358.158508 309.725403,362.173401 310.968872,364.712860 
	C310.251343,365.400543 309.727142,365.084412 309.153687,364.269897 
z"/>
<path fill="#37AFE9" opacity="1.000000" stroke="none" 
	d="
M309.021240,363.983887 
	C309.520691,364.253326 309.995056,364.544891 310.716949,364.967896 
	C310.964447,365.099274 310.991669,365.556976 310.919250,366.401520 
	C309.262360,367.147400 308.509277,366.290405 308.744049,364.384766 
	C308.947266,364.051697 308.996155,364.006042 309.021240,363.983887 
z"/>
<path fill="#37AFE9" opacity="1.000000" stroke="none" 
	d="
M311.748230,366.827148 
	C311.997559,367.163025 311.998108,367.332031 311.995300,367.754578 
	C311.991882,368.008118 311.999603,368.000397 312.002441,367.998108 
	C311.541534,368.178894 311.162109,368.069458 310.932373,367.334869 
	C310.997650,367.002258 311.000000,367.000000 311.001831,366.998169 
	C311.168945,366.884338 311.334229,366.772278 311.748230,366.827148 
z"/>
<path fill="#0CD8FF" opacity="1.000000" stroke="none" 
	d="
M311.893005,366.782043 
	C311.996979,366.994049 311.500244,366.986206 311.251953,366.991272 
	C311.003662,366.996368 311.023743,366.504242 311.033752,366.258392 
	C311.352081,366.118347 311.600464,366.304169 311.893005,366.782043 
z"/>
<path fill="#2A3743" opacity="1.000000" stroke="none" 
	d="
M483.700562,312.264771 
	C484.011200,314.485687 484.003967,316.805908 483.995331,319.566132 
	C479.884918,320.028198 475.746277,319.667786 471.305420,320.933167 
	C474.496918,317.260071 479.392670,315.474915 483.700562,312.264771 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M462.699646,227.878052 
	C465.341400,233.768555 467.664276,239.511887 469.989044,245.631210 
	C466.326843,246.590332 464.113953,245.103912 462.739166,241.604965 
	C461.221741,237.742935 459.368805,234.023193 459.001465,229.406601 
	C459.002441,229.003937 459.486267,228.985443 459.728302,228.980728 
	C460.655823,228.332550 461.331024,227.669159 462.699646,227.878052 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M477.415649,330.020233 
	C477.446930,328.924591 478.223541,328.269714 479.681580,328.028137 
	C480.259094,328.501953 480.516418,328.997314 480.889343,329.742737 
	C479.941223,330.009583 478.877502,330.026398 477.415649,330.020233 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M480.329407,327.969116 
	C480.036224,327.068481 480.338257,326.326843 481.662689,326.044952 
	C481.996307,326.975647 481.663116,327.692535 480.329407,327.969116 
z"/>
<path fill="#044166" opacity="1.000000" stroke="none" 
	d="
M483.742554,324.105103 
	C484.021301,324.437439 484.024872,324.879486 483.996338,325.652405 
	C483.526947,326.002289 483.089630,326.021301 482.324097,326.024475 
	C482.486359,325.410675 482.976837,324.812775 483.742554,324.105103 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M480.996124,330.003784 
	C481.422485,330.126373 481.852539,330.245453 482.282593,330.364502 
	C481.963043,331.060913 481.597107,330.684296 481.120239,330.201294 
	C481.004944,329.992798 480.999817,330.000214 480.996124,330.003784 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M485.768005,331.994202 
	C486.338959,332.097260 486.592224,332.288300 486.888855,332.775085 
	C486.439697,332.828979 485.888519,332.664825 485.164062,332.263733 
	C485.163483,332.019379 485.336182,332.011932 485.768005,331.994202 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M470.307495,335.008301 
	C470.467499,334.678528 470.933807,334.348480 471.703430,333.998871 
	C471.542389,334.322266 471.078094,334.665161 470.307495,335.008301 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M467.312042,337.010376 
	C467.470764,336.670654 467.934204,336.334869 468.702942,336.001526 
	C468.544373,336.340759 468.080566,336.677521 467.312042,337.010376 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M476.226135,330.926849 
	C476.081757,330.694550 476.262085,330.424438 476.766724,330.118591 
	C476.927399,330.362762 476.747345,330.631500 476.226135,330.926849 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M469.241333,335.922546 
	C469.178253,335.731110 469.354767,335.453613 469.769714,335.089111 
	C469.832397,335.280212 469.656616,335.558319 469.241333,335.922546 
z"/>
<path fill="#74909F" opacity="1.000000" stroke="none" 
	d="
M400.917480,189.696793 
	C401.670380,189.203629 402.453644,189.097244 403.629059,188.943558 
	C405.281189,187.768875 406.916290,187.652405 408.844543,187.180603 
	C410.066376,187.025635 410.863281,187.127563 411.937866,187.719452 
	C411.829620,193.016556 408.355316,191.184235 406.052979,191.364975 
	C409.192841,192.797531 413.723724,191.366913 417.125519,194.581345 
	C416.038361,196.532898 414.566833,197.116531 412.328003,196.286835 
	C402.522186,194.638306 393.182098,196.354294 383.369934,196.894470 
	C387.029449,193.284134 392.257111,193.878006 397.076080,193.075912 
	C399.068909,192.744202 401.252411,193.176682 400.917480,189.696793 
z"/>
<path fill="#607584" opacity="1.000000" stroke="none" 
	d="
M411.975586,196.369751 
	C413.382324,195.733231 414.802643,195.405624 416.586121,195.029327 
	C418.201965,194.537781 419.398956,193.969116 420.891052,193.208801 
	C422.525421,192.419861 423.886261,191.943817 425.756744,192.176849 
	C427.182190,192.707123 427.691711,193.508682 427.322998,195.315491 
	C423.150055,196.612106 419.810486,199.016861 415.414459,198.999176 
	C414.561554,198.990967 414.109589,198.986511 413.318787,198.977478 
	C412.683075,198.785614 412.382141,198.605026 412.017334,198.173233 
	C411.967621,197.503830 411.978394,197.091263 411.975586,196.369751 
z"/>
<path fill="#74909F" opacity="1.000000" stroke="none" 
	d="
M411.629211,197.975494 
	C412.227936,198.115021 412.498993,198.313629 412.875031,198.742569 
	C411.653778,199.685211 410.262878,200.145355 408.360199,200.038879 
	C408.753448,198.787781 410.069550,198.481522 411.629211,197.975494 
z"/>
<path fill="#3C3A3D" opacity="1.000000" stroke="none" 
	d="
M463.363800,228.011459 
	C462.218262,228.332108 461.417969,228.638992 460.294006,228.960938 
	C459.854126,226.587418 458.229919,226.353500 456.273285,225.926590 
	C446.641785,223.825104 439.003784,218.422165 432.703247,211.008957 
	C432.225006,210.446243 432.218292,209.482803 431.981201,208.338501 
	C431.809753,207.787888 431.649475,207.604446 431.792786,207.217682 
	C432.582275,206.980804 433.099213,207.039185 433.545410,206.888336 
	C434.011566,206.730743 434.412354,206.242447 433.594482,206.057693 
	C428.002350,204.794418 432.623322,202.912094 433.394379,201.000076 
	C431.404633,199.486801 427.709106,200.167404 427.019287,196.338959 
	C426.969971,195.979736 426.955933,195.979294 426.954407,195.969330 
	C429.346710,193.193115 432.391205,191.276459 435.751099,189.214523 
	C437.840820,189.371384 440.563660,187.709671 440.995483,191.605576 
	C436.718170,194.681992 439.564575,196.790833 441.544800,199.306839 
	C441.363525,200.921173 438.162018,202.316818 441.936127,203.671875 
	C442.240448,204.116455 442.295135,204.336456 442.246368,204.883698 
	C439.965363,206.679413 439.287140,208.564255 441.286774,210.522659 
	C445.693909,214.838928 449.128906,220.498962 456.329102,221.621277 
	C457.657410,221.759567 458.611633,221.930893 459.734344,222.725800 
	C460.821899,223.204071 461.615540,223.460251 462.701904,223.836868 
	C463.164368,223.846130 463.334106,223.734940 463.751678,223.800430 
	C463.999512,223.977127 464.497925,223.991623 464.747131,223.996429 
	C464.640350,225.356918 467.425537,227.724396 463.363800,228.011459 
z"/>
<path fill="#606569" opacity="1.000000" stroke="none" 
	d="
M431.680878,207.008942 
	C432.096436,207.014389 432.035278,207.493393 432.002655,207.732361 
	C430.133423,207.538910 428.392670,209.535858 426.294678,208.345947 
	C427.696381,206.165863 429.669769,207.342606 431.680878,207.008942 
z"/>
<path fill="#4D4E51" opacity="1.000000" stroke="none" 
	d="
M409.265717,187.935181 
	C407.782349,189.399445 406.228882,188.887604 404.397156,188.933563 
	C403.894073,186.891571 402.371124,186.528809 400.855988,185.755234 
	C396.414429,183.487564 392.363464,180.598618 389.061951,176.404053 
	C391.887054,173.735153 395.443756,174.859558 399.016327,174.206146 
	C402.646454,178.821976 407.075989,182.442230 409.265717,187.935181 
z"/>
<path fill="#607584" opacity="1.000000" stroke="none" 
	d="
M400.424225,175.404190 
	C396.672363,175.429855 393.289490,175.726395 389.468628,176.041687 
	C385.910004,176.000137 382.789276,175.939804 379.205139,175.792664 
	C375.353973,172.412003 375.637695,171.300720 380.725067,169.500916 
	C383.754639,171.660629 386.857269,172.369598 390.519073,172.552246 
	C393.947937,172.536072 396.983856,172.481659 400.448425,172.575073 
	C402.647156,172.513351 404.411438,172.496826 406.473846,173.423187 
	C406.990601,173.935791 407.127930,174.204636 407.082275,174.889877 
	C404.935852,176.619751 402.891052,176.586823 400.424225,175.404190 
z"/>
<path fill="#88A7B5" opacity="1.000000" stroke="none" 
	d="
M381.294250,169.982880 
	C377.900208,170.699799 376.270630,172.037430 378.749054,175.414276 
	C377.738495,175.639160 376.735291,175.572418 375.451111,175.395432 
	C374.891510,174.225708 374.612854,173.166245 373.998413,171.866272 
	C376.155090,166.384171 381.531464,165.399460 386.463013,163.234131 
	C387.320129,163.402817 387.748352,163.641098 388.269562,164.327377 
	C388.462769,165.157196 388.379120,165.628906 387.924744,166.350494 
	C385.754150,167.888794 383.960205,169.416229 381.294250,169.982880 
z"/>
<path fill="#607584" opacity="1.000000" stroke="none" 
	d="
M372.113831,177.871277 
	C372.097443,177.046616 372.481598,176.319092 373.702271,176.073578 
	C373.951324,177.070480 373.644348,177.864563 372.113831,177.871277 
z"/>
<path fill="#607584" opacity="1.000000" stroke="none" 
	d="
M379.011658,179.764038 
	C378.890747,179.586868 378.949432,179.408432 379.008118,179.229980 
	C379.069153,179.407562 379.130188,179.585144 379.011658,179.764038 
z"/>
<path fill="#607584" opacity="1.000000" stroke="none" 
	d="
M375.697144,178.601547 
	C375.834595,178.430115 376.078735,178.405045 376.322845,178.379944 
	C376.149811,178.502609 375.976807,178.625259 375.697144,178.601547 
z"/>
<path fill="#607584" opacity="1.000000" stroke="none" 
	d="
M382.003845,180.754303 
	C381.889648,180.586060 381.945465,180.417053 382.001312,180.248047 
	C382.058838,180.416534 382.116364,180.585037 382.003845,180.754303 
z"/>
<path fill="#2C2528" opacity="1.000000" stroke="none" 
	d="
M342.957336,145.656189 
	C344.323303,144.529739 345.538971,143.680862 346.948669,142.581329 
	C348.191040,140.365204 349.609375,138.993408 352.416565,139.401886 
	C353.205780,139.843079 353.488220,140.251572 353.662231,141.134872 
	C353.666687,142.247864 353.505188,142.969376 353.319214,144.054596 
	C353.125458,145.133514 352.897247,145.816376 352.199615,146.668381 
	C351.221649,147.289932 350.497711,147.655334 349.471985,148.118546 
	C347.328735,148.855042 345.480499,149.473999 343.298340,150.245926 
	C341.516907,149.967499 340.419403,151.998154 338.294434,150.540314 
	C339.839569,148.962997 341.323303,147.448380 342.957336,145.656189 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M343.184509,150.550262 
	C344.264313,148.416595 346.384644,148.383591 348.779510,148.145920 
	C348.583710,148.724274 347.997253,149.232178 347.152710,149.890900 
	C345.734650,150.271576 344.574707,150.501404 343.184509,150.550262 
z"/>
<path fill="#88A7B5" opacity="1.000000" stroke="none" 
	d="
M332.644836,143.980606 
	C332.237488,143.602905 332.110291,143.195541 331.866577,142.489944 
	C332.418304,142.257904 333.086578,142.324097 333.992920,142.646973 
	C333.795624,143.252747 333.360291,143.601837 332.644836,143.980606 
z"/>
<path fill="#5CA0BC" opacity="1.000000" stroke="none" 
	d="
M362.113892,137.204498 
	C364.122437,135.184860 366.955963,135.385071 369.685791,134.279465 
	C371.991425,133.153442 373.197784,134.388367 374.417572,136.235168 
	C374.650116,138.038940 373.941132,138.982681 372.324707,139.639709 
	C371.537506,139.785065 371.125183,139.891159 370.396484,140.038849 
	C370.080109,140.080429 369.729126,139.735107 369.553436,139.562622 
	C367.339691,137.607086 364.459320,138.914246 362.113892,137.204498 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M371.964539,140.010437 
	C372.547028,138.958771 373.144257,138.238571 373.871002,137.264191 
	C377.028137,136.552261 377.979584,138.063507 377.320465,140.751923 
	C376.890625,142.505234 376.280579,144.265106 374.346802,145.553940 
	C373.758484,145.709427 373.518616,145.730057 372.933960,145.680756 
	C370.486694,144.357132 372.816345,142.865616 372.184021,141.264160 
	C371.991943,140.784119 371.985626,140.563019 371.964539,140.010437 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M371.836914,141.290771 
	C376.113464,141.801697 372.385681,143.269257 372.167206,144.726654 
	C371.862732,145.483948 371.566040,145.849136 370.828064,146.249237 
	C370.250305,146.320450 370.014343,146.278351 369.688507,145.888123 
	C369.589081,143.850952 370.567474,142.679642 371.836914,141.290771 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M367.845276,147.941589 
	C368.140686,147.009918 368.595337,146.385620 369.324341,145.650635 
	C369.598663,145.539963 369.931763,145.905014 370.098022,146.087784 
	C370.272400,147.025330 369.913513,147.586075 369.014496,148.164703 
	C368.464844,148.282501 368.234680,148.265717 367.845276,147.941589 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M365.874451,149.980774 
	C365.855164,148.833572 366.327576,148.216644 367.405273,147.743530 
	C367.686035,147.634216 367.956421,147.940247 368.096069,148.089188 
	C368.277344,148.988907 367.932098,149.549850 367.056519,150.146332 
	C366.515259,150.282700 366.286621,150.276688 365.874451,149.980774 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M364.819824,150.827118 
	C364.818970,150.395782 365.027344,150.152832 365.489990,149.823273 
	C365.690918,149.690872 365.979156,149.978714 366.124146,150.121735 
	C366.165588,150.488800 366.062012,150.712875 365.623657,151.095184 
	C365.288879,151.253403 364.975739,150.969711 364.819824,150.827118 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M361.535095,136.988968 
	C363.836487,136.897430 365.774200,136.838074 367.712311,136.818100 
	C368.968719,136.805145 370.036743,137.045349 369.534271,139.056732 
	C365.849609,140.911865 362.321472,142.433578 358.440369,144.016907 
	C357.898376,144.211441 357.709351,144.344376 357.276337,144.723541 
	C357.032318,144.969742 357.024780,145.026733 356.996033,145.027664 
	C356.837402,145.162155 356.707458,145.295700 356.299652,145.458923 
	C355.819763,145.559814 355.617737,145.631042 355.111145,145.804657 
	C353.173859,147.046310 352.740051,145.974197 352.239532,144.335663 
	C352.173981,143.477402 352.322021,142.914642 352.712341,142.179047 
	C353.487335,141.538116 353.512665,140.908554 353.510193,139.947937 
	C353.804810,138.566772 354.711823,138.529724 355.832031,138.220673 
	C357.793091,137.710068 359.482361,137.373962 361.535095,136.988968 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M352.006348,144.400833 
	C352.762329,144.636536 353.498688,145.232880 354.520813,145.868134 
	C354.378601,146.886200 353.440948,146.838745 352.276062,146.961945 
	C351.959290,146.203522 351.973053,145.482513 352.006348,144.400833 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M357.262268,144.897858 
	C357.090179,144.613800 357.279297,144.353043 357.843536,144.132980 
	C357.957794,144.382462 357.759399,144.631638 357.262268,144.897858 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M356.224091,145.548737 
	C356.175232,145.292969 356.370117,145.156311 356.786835,145.053604 
	C356.929626,145.355240 356.749329,145.548676 356.224091,145.548737 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M365.156616,151.564774 
	C365.569641,151.103256 365.809540,150.903931 366.138855,150.460083 
	C366.826813,149.752167 367.384460,149.239578 368.088928,148.482559 
	C368.804810,147.739273 369.373871,147.240402 370.103607,146.506042 
	C370.697388,145.942078 371.130463,145.613586 371.803528,145.156219 
	C372.219299,145.040482 372.395142,145.053619 372.833252,145.100876 
	C374.786896,147.876251 372.918335,149.812805 371.446259,151.687714 
	C369.207794,154.538681 367.279999,157.535004 365.843933,161.244720 
	C363.929535,163.134628 361.525085,162.748215 359.320740,163.841980 
	C358.627747,164.173706 358.137421,164.248810 357.326050,164.163757 
	C357.004974,164.003616 356.983704,163.520416 357.005798,163.279724 
	C359.693390,159.318054 362.358856,155.597107 365.156616,151.564774 
z"/>
<path fill="#607584" opacity="1.000000" stroke="none" 
	d="
M359.438263,164.096497 
	C360.762573,163.081680 361.667480,160.354675 364.703552,161.888824 
	C366.695374,160.019073 368.773285,158.971344 371.775818,159.126953 
	C373.638306,159.759842 375.985626,159.638809 375.903107,161.707169 
	C375.842194,163.232834 373.805664,163.672455 372.372406,164.007156 
	C369.656769,164.641342 367.099243,166.113922 363.809265,165.448700 
	C362.892365,164.847412 362.330261,164.446167 361.403870,164.049683 
	C360.612579,164.067780 360.185516,164.081085 359.438263,164.096497 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M356.989899,163.991257 
	C356.939667,164.213486 356.896606,164.441910 356.853577,164.670319 
	C356.785736,164.507721 356.717896,164.345108 356.827515,164.093063 
	C357.004974,164.003616 356.997101,163.997437 356.989899,163.991257 
z"/>
<path fill="#252326" opacity="1.000000" stroke="none" 
	d="
M372.360992,159.990387 
	C369.687439,159.960693 367.850464,161.397583 365.385925,161.959320 
	C364.764923,157.666138 367.524475,154.745316 369.870880,151.726212 
	C371.283783,149.908218 372.798676,148.255020 373.062805,145.491516 
	C376.530029,142.324875 377.093140,139.414246 374.305328,137.158142 
	C372.845062,136.064026 371.689606,135.118011 370.215210,134.076630 
	C363.797791,130.072281 357.699249,126.163300 351.263611,122.142120 
	C350.928558,121.862289 350.930634,121.694649 350.980652,121.280121 
	C352.926636,119.394775 354.769745,119.585632 356.781952,121.588684 
	C359.162506,123.993111 362.372681,124.409775 364.675537,126.780975 
	C370.510864,130.457901 375.997559,134.108337 381.746155,138.000809 
	C383.261871,139.984970 382.320648,141.691010 381.170044,142.595505 
	C377.645538,145.366196 379.304169,147.253967 381.973511,149.520905 
	C382.688629,151.477173 381.391571,154.066345 384.752258,154.469696 
	C387.875824,154.389679 390.652466,152.968826 393.707275,154.740509 
	C394.897675,156.573456 397.274933,156.385880 397.956909,158.603241 
	C397.551910,160.687546 395.962463,161.001831 394.232727,161.722565 
	C393.378723,161.981979 392.878082,162.075836 391.987549,162.148697 
	C387.668182,161.160278 384.158966,158.577591 379.815308,159.012573 
	C379.202179,159.073990 379.969299,159.132675 379.335907,158.929977 
	C377.907715,158.472900 377.185822,157.468613 376.978058,156.032410 
	C376.168610,156.155563 376.283875,157.024948 375.828003,157.466949 
	C374.874207,158.391739 374.005005,159.395584 372.360992,159.990387 
z"/>
<path fill="#8EC1D2" opacity="1.000000" stroke="none" 
	d="
M355.801514,137.994446 
	C355.447876,138.428070 354.791901,138.809998 353.870239,139.312439 
	C353.658752,139.690994 353.712952,139.949020 353.526733,139.893021 
	C351.094788,139.593445 349.631866,141.187164 347.495850,142.209106 
	C346.950470,139.700775 347.391205,137.227066 350.144684,136.218231 
	C352.165344,135.477875 354.208252,135.837784 355.801514,137.994446 
z"/>
<path fill="#2A3743" opacity="1.000000" stroke="none" 
	d="
M339.255127,124.188583 
	C337.292816,122.319244 334.698608,123.347816 332.474609,122.003601 
	C332.084351,121.745872 332.058960,121.554688 332.025696,121.074295 
	C332.926819,120.159081 333.919617,119.976250 335.350677,120.380959 
	C337.198792,121.005707 338.689728,121.471581 340.572449,121.954155 
	C341.100159,122.128746 341.236023,122.286629 341.228577,122.722137 
	C340.808594,123.198112 340.531982,123.396454 340.118591,123.812943 
	C339.820709,124.133972 339.659668,124.236862 339.255127,124.188583 
z"/>
<path fill="#88A7B5" opacity="1.000000" stroke="none" 
	d="
M341.382233,122.991699 
	C341.061279,122.828880 341.037354,122.657982 340.988861,122.228973 
	C341.489563,121.687256 342.014862,121.403664 342.833374,121.239555 
	C342.978088,122.198082 342.564606,122.801041 341.382233,122.991699 
z"/>
<path fill="#88A7B5" opacity="1.000000" stroke="none" 
	d="
M339.016876,124.288353 
	C339.011566,124.037422 339.496735,123.993080 339.739258,124.012085 
	C339.934448,124.353386 339.781982,124.614220 339.320984,124.922852 
	C339.085754,124.867836 339.053955,124.703560 339.016876,124.288353 
z"/>
<path fill="#959398" opacity="1.000000" stroke="none" 
	d="
M357.183105,121.642456 
	C355.460541,120.635498 353.619476,120.897789 351.420410,121.008507 
	C350.730011,120.541290 350.431458,120.049316 350.075562,119.261124 
	C349.562134,118.251175 349.987732,117.812698 350.760712,117.211365 
	C353.502838,116.794991 355.990021,116.570343 358.732300,116.570900 
	C359.273773,117.511833 356.401062,118.660538 359.192719,118.956100 
	C361.399963,119.189796 363.651764,119.003105 367.296814,119.003105 
	C363.170959,120.804283 359.824799,118.855484 357.183105,121.642456 
z"/>
<path fill="#74909F" opacity="1.000000" stroke="none" 
	d="
M336.300171,117.315445 
	C335.993134,116.632858 335.986725,116.206070 335.960327,115.460228 
	C337.022797,115.120659 338.105286,115.100151 339.593872,115.054901 
	C341.600922,116.295547 343.512299,115.521057 345.658997,115.790359 
	C346.486389,115.842751 346.913452,115.935188 347.669983,116.015686 
	C347.999451,116.003761 348.057983,116.397499 348.117737,116.587341 
	C347.839478,117.556793 347.189331,117.890991 346.020081,118.077820 
	C342.628265,117.944870 339.614532,117.758064 336.300171,117.315445 
z"/>
<path fill="#A2CEDF" opacity="1.000000" stroke="none" 
	d="
M345.965240,118.331879 
	C346.254150,117.757919 346.866333,117.384132 347.828003,116.893761 
	C348.888611,116.819595 349.599670,116.862007 350.663208,116.962029 
	C350.769379,117.506569 350.523102,117.993500 350.147552,118.722656 
	C348.774994,118.820610 347.531769,118.676331 345.965240,118.331879 
z"/>
<path fill="#5E889D" opacity="1.000000" stroke="none" 
	d="
M335.689453,120.245316 
	C334.726135,120.611877 333.744415,120.683929 332.390289,120.770538 
	C332.756195,118.407700 334.083984,118.611572 335.689453,120.245316 
z"/>
<path fill="#27303B" opacity="1.000000" stroke="none" 
	d="
M473.636597,380.621460 
	C472.232452,385.244843 468.476196,382.035309 465.387360,382.978271 
	C464.408081,381.968170 464.917969,381.215057 465.769348,380.238464 
	C466.009033,379.990723 465.990295,380.009521 465.980774,380.018799 
	C466.205170,379.797028 466.443542,379.570679 466.851318,379.165771 
	C467.016266,378.982513 467.001923,378.997589 466.994141,379.004639 
	C469.080658,379.579315 471.708374,377.757141 473.636597,380.621460 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M474.044922,369.995911 
	C473.573273,372.851898 471.794464,374.354034 468.643219,375.123932 
	C469.294495,372.168945 470.843536,370.685974 473.649811,369.975281 
	C474.003296,369.934204 474.014404,369.994232 474.044922,369.995911 
z"/>
<path fill="#197AAB" opacity="1.000000" stroke="none" 
	d="
M458.251007,373.630432 
	C458.004913,373.615417 457.871796,373.486115 457.738678,373.356781 
	C457.947113,373.409912 458.155518,373.463043 458.251007,373.630432 
z"/>
<path fill="#2A3743" opacity="1.000000" stroke="none" 
	d="
M439.713562,368.212891 
	C440.008057,367.942413 440.482269,368.033997 440.723297,368.040894 
	C442.758331,370.040588 444.850708,371.661346 447.477905,373.109680 
	C447.080200,374.099487 446.034973,373.891785 445.078583,374.055176 
	C438.528503,375.174438 438.471924,375.129242 439.713562,368.212891 
z"/>
<path fill="#12628E" opacity="1.000000" stroke="none" 
	d="
M459.852905,382.693481 
	C459.510529,383.597076 459.019562,384.196625 458.258606,384.909607 
	C457.913849,382.310699 455.720520,382.463837 453.952362,381.695679 
	C452.686707,381.145813 450.609711,379.668121 451.450287,378.097626 
	C452.404816,376.314301 454.030579,378.070526 455.121979,378.777710 
	C456.747192,379.830780 458.186157,381.171234 459.852905,382.693481 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M449.682922,393.839233 
	C449.227203,397.020477 444.870941,397.594666 444.996704,401.632324 
	C444.990601,401.997101 444.519379,401.988739 444.283813,401.982483 
	C443.190033,401.749359 442.589508,401.156403 441.842224,400.268127 
	C441.647980,399.788666 441.617798,399.580048 441.626678,399.057739 
	C441.843933,398.086243 442.022156,397.428497 442.242767,396.431091 
	C442.594116,395.695984 442.999054,395.513367 443.798431,395.739197 
	C446.322632,396.301849 447.315155,393.791748 449.682922,393.839233 
z"/>
<path fill="#1A6D97" opacity="1.000000" stroke="none" 
	d="
M444.058716,395.530487 
	C443.693481,395.970520 443.290100,396.006409 442.585938,396.066864 
	C441.703644,393.650909 440.810577,391.236542 441.608154,388.310333 
	C441.802429,387.835052 442.050323,387.724945 442.665497,387.789856 
	C443.362061,390.352020 443.691315,392.739166 444.058716,395.530487 
z"/>
<path fill="#324B5D" opacity="1.000000" stroke="none" 
	d="
M443.030945,387.580627 
	C442.787720,387.964539 442.542664,387.964233 441.926025,387.954529 
	C440.705780,387.383423 440.219879,386.590668 440.020477,385.296997 
	C439.984436,383.709656 439.984436,382.417847 439.984436,380.279572 
	C441.692108,382.913605 443.269806,384.635925 443.030945,387.580627 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M465.670837,380.037231 
	C465.745209,380.790741 465.481415,381.590790 465.078186,382.679871 
	C464.489777,382.981842 464.040741,382.994720 463.252686,383.011871 
	C463.087341,381.516785 463.778992,380.444733 465.670837,380.037231 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M454.726074,388.114075 
	C454.867798,388.565826 454.719330,389.157898 454.280029,389.887909 
	C454.138062,389.435364 454.286957,388.844910 454.726074,388.114075 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M452.703003,390.913025 
	C453.123840,391.319183 453.058838,391.600250 452.625366,391.957153 
	C452.167419,392.174591 451.903870,392.275909 451.272705,392.166962 
	C451.400452,391.580566 451.895813,391.204376 452.703003,390.913025 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M450.700470,392.953308 
	C450.868408,393.303467 450.708740,393.625763 450.267242,393.986938 
	C450.114532,393.659027 450.243683,393.292236 450.700470,392.953308 
z"/>
<path fill="#12628E" opacity="1.000000" stroke="none" 
	d="
M466.768555,379.070740 
	C466.838776,379.276978 466.661316,379.571411 466.227539,379.946960 
	C466.154419,379.738373 466.337616,379.448669 466.768555,379.070740 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M453.727264,389.994568 
	C453.862152,390.298096 453.701996,390.612976 453.268585,390.970703 
	C453.140961,390.677704 453.286591,390.341797 453.727264,389.994568 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M456.756287,386.035431 
	C456.857697,386.293610 456.690948,386.609711 456.250671,386.974640 
	C456.147491,386.713440 456.317841,386.403412 456.756287,386.035431 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M455.761230,387.044739 
	C455.865051,387.307465 455.706909,387.637939 455.263184,387.995117 
	C455.151489,387.718750 455.325378,387.415588 455.761230,387.044739 
z"/>
<path fill="#0A7EBE" opacity="1.000000" stroke="none" 
	d="
M450.805634,392.234222 
	C451.158508,391.977234 451.411896,391.997742 452.048096,392.045776 
	C452.149536,392.360992 451.868103,392.648682 451.288239,392.982483 
	C450.895264,392.856293 450.800720,392.683990 450.805634,392.234222 
z"/>
<path fill="#12628E" opacity="1.000000" stroke="none" 
	d="
M457.751953,385.033997 
	C457.846375,385.280945 457.671783,385.579193 457.240814,385.948059 
	C457.150635,385.707550 457.316803,385.396423 457.751953,385.033997 
z"/>
<path fill="#44454A" opacity="1.000000" stroke="none" 
	d="
M372.210999,160.315552 
	C373.204193,157.868484 375.179138,156.377518 376.976624,154.682175 
	C380.156494,160.501755 387.610535,156.325623 391.625488,160.995270 
	C391.703552,163.890762 389.676056,163.816727 387.256287,163.811279 
	C382.252045,165.649689 378.109375,168.273773 373.865814,171.354263 
	C372.958344,172.008545 372.254089,172.391342 371.293701,172.934296 
	C370.707062,173.090363 370.376068,173.072327 370.046143,173.084198 
	C362.847290,173.343536 362.847321,173.344193 363.341431,165.657394 
	C367.353912,164.084656 371.253357,162.920639 375.878693,161.539932 
	C374.240417,161.070007 373.334503,160.810165 372.210999,160.315552 
z"/>
<path fill="#343033" opacity="1.000000" stroke="none" 
	d="
M301.469025,130.452606 
	C301.523804,130.420593 301.414246,130.484604 301.469025,130.452606 
z"/>
<path fill="#1E2B39" opacity="1.000000" stroke="none" 
	d="
M441.785400,399.707581 
	C443.029694,399.922180 443.570099,400.509033 443.959869,401.672089 
	C444.335846,403.529236 444.663177,405.076202 444.900360,406.636871 
	C445.151520,408.289734 445.316376,409.955261 442.476074,410.025940 
	C439.485687,412.335632 436.220947,412.202332 432.640442,412.496338 
	C429.489594,412.662628 426.404968,413.303802 427.735229,408.354919 
	C427.980927,407.988007 427.998779,407.998779 427.994141,407.989746 
	C428.686096,407.195435 429.658051,406.846191 430.781738,406.171814 
	C431.016571,405.978180 431.008606,406.013000 430.990906,406.010437 
	C431.423767,405.583771 432.026367,405.529633 432.804016,405.163544 
	C433.031219,404.978424 433.011627,405.016052 432.991211,405.021912 
	C433.241211,404.777985 433.493286,404.510925 433.886658,404.001648 
	C434.437103,403.532166 434.827850,403.287537 435.461029,403.045715 
	C436.033966,402.857544 436.342896,402.636383 436.826233,402.177063 
	C437.022339,401.969269 437.007660,402.007233 436.987427,402.009430 
	C438.002716,401.164703 439.360870,401.028564 440.745239,400.196289 
	C440.991119,399.984070 441.000000,400.000000 440.992828,399.993195 
	C441.152893,399.863495 441.320129,399.740631 441.785400,399.707581 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M429.944458,419.414886 
	C429.502716,422.033234 430.452606,423.776642 431.254425,425.523560 
	C432.021118,427.193970 431.472778,427.940216 429.390350,428.104858 
	C425.963165,428.447815 422.889435,430.093506 419.471771,427.985626 
	C419.091797,427.091980 419.046509,426.405731 419.011658,425.372650 
	C420.505371,421.953766 423.008911,422.954285 425.700562,423.184174 
	C425.825714,421.248230 426.480438,419.817078 427.625977,418.237976 
	C427.999725,417.871490 428.119171,417.724396 428.523804,417.583252 
	C428.972961,417.686584 429.136902,417.784058 429.477539,418.106750 
	C429.735168,418.504730 429.816162,418.677399 429.944458,419.414886 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M427.631104,407.917786 
	C427.979523,410.048279 427.282349,412.759888 431.399231,411.206970 
	C432.284058,412.938751 432.284058,412.938751 429.135986,415.364075 
	C428.734314,415.727142 428.563660,415.861908 428.080872,416.091309 
	C427.339630,415.492706 427.077087,414.482849 426.455383,414.155762 
	C420.903870,411.235260 424.986908,409.674652 427.631104,407.917786 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M418.148987,423.194946 
	C416.585999,423.020874 415.283478,423.020874 413.666260,423.020874 
	C414.722687,421.545532 416.776245,421.660034 416.904175,419.504517 
	C416.986694,417.547119 417.938171,416.967896 419.832275,416.997986 
	C420.220184,416.972626 420.611145,416.969269 420.806183,416.982361 
	C421.305023,417.259583 421.510406,417.587494 421.651367,418.264893 
	C421.620728,419.146729 421.511139,419.726807 421.475037,420.616028 
	C421.438477,421.117950 421.409119,421.319366 421.250488,421.800964 
	C420.420685,422.938721 419.543640,423.424561 418.148987,423.194946 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M417.896271,423.348877 
	C418.815033,422.519653 419.741577,422.018402 420.830444,421.249603 
	C421.979706,420.432465 422.761108,420.896851 423.785034,421.712097 
	C424.054413,421.930603 424.127228,421.953247 424.164124,421.962921 
	C424.288483,422.140869 424.375916,422.309143 424.717468,422.605042 
	C425.145508,422.770447 425.319336,422.808167 425.756348,422.890747 
	C424.390961,425.204010 421.557739,423.207947 419.368347,424.871277 
	C418.855194,425.015686 418.688385,425.005493 418.271118,424.989685 
	C417.981812,424.548370 417.942932,424.112640 417.896271,423.348877 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M424.009216,421.578735 
	C423.238037,421.687897 422.421631,421.445160 421.299011,421.092255 
	C420.992737,420.982056 420.999878,421.003204 421.007996,421.009399 
	C420.634796,420.603851 420.489227,420.120941 420.799896,419.238861 
	C421.016327,418.485107 421.011719,418.059540 421.004150,417.314697 
	C423.606110,417.273560 423.036011,419.774658 424.009216,421.578735 
z"/>
<path fill="#0A5C8E" opacity="1.000000" stroke="none" 
	d="
M440.646851,399.920746 
	C440.414917,401.523102 439.152100,401.967468 437.319733,402.038757 
	C437.683289,400.680878 438.834961,400.024536 440.646851,399.920746 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M430.654968,405.919617 
	C430.631836,407.130188 429.709198,407.655457 428.316711,407.997620 
	C427.838287,406.275085 429.037018,406.036743 430.654968,405.919617 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M432.705078,404.948364 
	C432.550934,405.324280 432.070648,405.670135 431.281799,406.011902 
	C431.126678,405.238098 431.706482,405.018433 432.705078,404.948364 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M429.198456,417.685303 
	C428.826538,418.043762 428.637634,418.074738 428.164520,418.062134 
	C427.865662,417.609894 427.851074,417.201233 427.802612,416.489258 
	C427.768738,416.185913 427.948090,416.047729 428.038147,415.979126 
	C429.081573,415.929169 429.391174,416.505310 429.198456,417.685303 
z"/>
<path fill="#0A5C8E" opacity="1.000000" stroke="none" 
	d="
M436.744690,402.066437 
	C436.786865,402.281189 436.551392,402.593109 436.009644,402.976746 
	C435.957977,402.753540 436.212524,402.458588 436.744690,402.066437 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M433.786865,403.917633 
	C433.867340,404.115631 433.688324,404.454468 433.240051,404.910553 
	C433.156342,404.704651 433.341888,404.381561 433.786865,403.917633 
z"/>
<path fill="#0A5C8E" opacity="1.000000" stroke="none" 
	d="
M442.001770,399.525024 
	C441.907867,399.871918 441.732330,399.946442 441.271210,400.003662 
	C441.069763,399.669922 441.153900,399.353485 441.451874,398.890503 
	C441.750519,398.913544 441.835297,399.083099 442.001770,399.525024 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M424.874146,422.577362 
	C424.661224,422.767700 424.427002,422.650543 424.234985,422.176880 
	C424.423492,422.083252 424.615356,422.233063 424.874146,422.577362 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M400.453186,415.000122 
	C402.910889,413.231140 406.369598,413.558289 409.748169,412.283264 
	C410.892456,412.522614 410.998230,413.386597 411.010742,414.627197 
	C407.655029,414.981140 404.292023,415.002319 400.453186,415.000122 
z"/>
<path fill="#1B222E" opacity="1.000000" stroke="none" 
	d="
M396.580383,404.987823 
	C396.109680,408.137817 393.412354,407.032959 391.134033,407.140625 
	C391.210938,406.414215 391.501709,405.959442 391.881226,405.248444 
	C393.367279,404.985870 394.764648,404.979553 396.580383,404.987823 
z"/>
<path fill="#16202D" opacity="1.000000" stroke="none" 
	d="
M104.756180,281.734253 
	C105.803246,282.319397 106.599075,282.638336 107.718018,282.987427 
	C108.015350,283.762329 107.989571,284.507050 107.979469,285.624207 
	C107.665924,286.466614 107.336708,286.936523 107.008194,287.713013 
	C105.578682,288.113708 104.230011,287.909668 102.879639,286.669189 
	C102.324883,284.991211 103.152931,283.874451 103.780914,282.327515 
	C103.992256,281.996429 104.000000,282.000000 103.997078,281.996216 
	C104.164421,281.817688 104.334679,281.642883 104.756180,281.734253 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M103.694305,282.117889 
	C104.129723,283.340942 103.856659,284.582581 102.868057,286.042480 
	C102.303352,286.289154 101.935974,286.187653 101.284454,286.047302 
	C101.799004,284.752075 102.597687,283.495728 103.694305,282.117889 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M469.942993,437.602905 
	C469.673248,438.142700 469.402924,438.330261 469.032166,438.751343 
	C467.384766,440.760559 465.837769,442.536194 464.141724,444.593140 
	C463.481049,445.469360 462.969360,446.064178 462.206665,446.817566 
	C459.949463,447.099854 458.206268,446.231903 456.196777,445.237335 
	C455.516022,444.584869 455.268402,444.097076 455.217987,443.225647 
	C455.268768,442.755005 455.311707,442.569275 455.479126,442.125366 
	C455.729828,441.723297 455.855988,441.579468 456.507812,441.237854 
	C458.531738,440.355316 459.500763,439.210999 460.030579,437.313141 
	C462.905273,431.235748 464.683472,424.828918 470.601624,420.929871 
	C471.293030,422.132660 471.639923,423.216553 472.014954,424.646759 
	C472.027710,427.363281 472.012360,429.733521 471.991394,432.547089 
	C470.658234,434.100464 470.099060,435.579010 469.942993,437.602905 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M447.986023,444.515076 
	C448.250580,443.983978 448.518860,443.742157 448.892578,443.250153 
	C448.998016,443.000000 449.234924,442.585785 449.399963,442.413757 
	C449.796936,442.022186 450.014618,441.789337 450.616821,441.283264 
	C452.456329,441.039398 453.184235,440.048096 454.075134,439.097870 
	C455.903717,437.147583 456.722778,438.193146 457.007111,440.675781 
	C457.033447,441.040039 457.007965,441.018646 457.015839,441.017212 
	C456.761047,441.199280 456.528931,441.415558 456.171082,441.844849 
	C456.014832,442.025146 456.018463,441.998688 456.026123,442.011841 
	C455.037933,443.130066 453.925781,444.075256 452.260956,444.794556 
	C452.019287,444.996368 452.005615,445.005402 452.000244,445.011627 
	C451.034180,445.885132 450.103821,446.825256 448.304047,446.196899 
	C447.991730,445.579590 447.990723,445.191925 447.986023,444.515076 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M447.742554,446.194641 
	C449.096130,445.661835 450.199554,445.356476 451.648926,445.034485 
	C451.834015,447.222351 450.581818,448.700470 448.488037,448.841736 
	C447.002747,448.941925 446.883881,447.634766 447.742554,446.194641 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M452.414001,445.025940 
	C452.704102,443.523987 453.748962,442.461273 455.701233,442.038757 
	C456.011230,442.760284 455.988647,443.495636 455.967529,444.598267 
	C454.915588,444.995544 453.862152,445.025513 452.414001,445.025940 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M445.582458,443.037384 
	C445.882599,443.164520 445.914642,443.335968 445.965515,443.768677 
	C445.599060,444.573181 445.044250,445.023438 444.561646,444.347626 
	C444.091003,443.688477 444.680664,443.285828 445.582458,443.037384 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M473.023010,441.029785 
	C472.910492,441.002899 472.898224,441.923309 472.810608,441.031891 
	C472.953369,440.962616 473.001648,441.005554 473.023010,441.029785 
z"/>
<path fill="#17283A" opacity="1.000000" stroke="none" 
	d="
M452.451172,421.829712 
	C451.822510,417.898071 448.762024,414.764099 448.913269,410.298157 
	C451.437073,409.454498 453.854767,408.618408 456.708984,408.218079 
	C457.017181,407.991241 457.000000,408.000000 456.991699,408.004822 
	C457.705536,407.312378 458.667694,407.619995 459.763306,407.197632 
	C460.021118,406.988129 460.000153,407.000366 459.989441,407.006073 
	C460.702881,406.311981 461.669128,406.621094 462.768250,406.194733 
	C463.027313,405.984924 463.000702,406.001617 462.987122,406.009491 
	C463.419708,405.586609 464.021393,405.529694 464.800018,405.166931 
	C465.027161,404.981781 464.998138,405.001312 464.982941,405.009949 
	C465.698425,404.311615 466.669800,404.617584 467.777222,404.196228 
	C468.034760,403.980194 468.013885,403.993652 468.002869,403.998932 
	C471.033112,411.545837 470.582916,413.196838 463.692810,416.012878 
	C459.828735,417.592163 456.431152,419.905426 452.451172,421.829712 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M470.958008,420.655975 
	C466.423218,424.167938 465.892303,429.890015 462.621582,433.831848 
	C461.889740,434.713867 461.320068,435.730377 460.377136,436.833801 
	C456.672607,434.127258 456.536102,430.300537 459.697693,427.845734 
	C460.890442,426.919647 463.168030,427.103058 462.999329,424.064453 
	C463.066772,423.214966 463.126770,423.027710 463.589813,422.423889 
	C464.795715,421.012115 465.599396,420.017517 466.401245,419.021423 
	C467.427063,417.747192 467.682983,415.087738 469.925751,415.860565 
	C471.681763,416.465637 470.829315,418.710388 470.958008,420.655975 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M450.335876,435.142212 
	C446.752655,432.171509 449.390839,430.258423 451.593140,428.222656 
	C452.098541,429.349457 453.103516,429.756958 453.713593,430.492371 
	C454.920654,431.947418 457.266022,433.691895 456.214417,435.342133 
	C455.076874,437.127258 452.596405,435.556641 450.335876,435.142212 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M452.357208,426.053650 
	C452.026276,425.373413 452.087585,424.665253 452.210815,423.613831 
	C454.313995,423.209808 456.422577,422.400574 459.548706,424.216278 
	C456.623383,424.994781 454.686401,425.510254 452.357208,426.053650 
z"/>
<path fill="#0B345D" opacity="1.000000" stroke="none" 
	d="
M463.004089,423.996887 
	C461.170502,423.889160 460.594452,422.914215 461.477631,421.364746 
	C462.117401,420.242340 463.088196,419.446869 463.949982,421.677673 
	C463.992828,422.007355 464.001404,421.997803 464.004547,421.992584 
	C463.538544,422.403351 463.499695,423.003540 463.163513,423.783508 
	C462.988861,424.015747 462.997925,424.002960 463.004089,423.996887 
z"/>
<path fill="#0A4377" opacity="1.000000" stroke="none" 
	d="
M450.206421,442.716583 
	C449.865326,442.949829 449.691925,442.960754 449.258270,442.985840 
	C447.956268,440.978943 450.429077,439.618011 450.005371,437.367615 
	C451.159271,437.918610 451.875519,438.958221 451.110626,440.748932 
	C451.015594,441.023315 451.005157,441.000610 451.013702,441.005066 
	C450.553436,441.394104 450.497284,441.958801 450.206421,442.716583 
z"/>
<path fill="#11273E" opacity="1.000000" stroke="none" 
	d="
M472.753418,402.921753 
	C473.309052,403.976593 474.251373,404.636353 473.237061,405.894257 
	C470.210022,407.136658 471.164856,404.957550 471.238159,403.176575 
	C471.858582,402.496887 472.249634,402.502106 472.753418,402.921753 
z"/>
<path fill="#0355A0" opacity="1.000000" stroke="none" 
	d="
M470.044891,401.168335 
	C470.036163,400.842804 470.503326,400.968506 470.734070,401.041077 
	C471.332825,401.477203 471.494293,401.916656 471.245728,402.741791 
	C471.041992,403.051605 471.024017,403.043121 471.034912,403.052124 
	C470.715057,402.538727 470.384338,402.016296 470.044891,401.168335 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M473.452301,418.531250 
	C473.421295,418.478271 473.483307,418.584198 473.452301,418.531250 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M385.288696,465.116333 
	C384.920013,464.035919 384.879669,462.893707 384.704956,461.346802 
	C385.996826,461.389435 387.156921,462.206543 388.034027,463.710571 
	C387.233948,464.346558 386.425476,464.700562 385.288696,465.116333 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M391.550690,469.409851 
	C391.433868,468.102081 392.157990,468.024475 392.970703,468.223511 
	C393.117218,468.259369 393.312439,468.757080 393.234924,468.928497 
	C392.954315,469.549347 392.416565,469.786346 391.550690,469.409851 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M388.276306,471.175720 
	C387.994965,470.866882 387.971680,470.692078 387.973907,470.253998 
	C388.905884,470.188171 390.351196,470.178619 390.294128,471.194916 
	C390.231934,472.302338 389.182617,471.683167 388.276306,471.175720 
z"/>
<path fill="#0A4271" opacity="1.000000" stroke="none" 
	d="
M374.945496,445.722687 
	C374.726349,445.924316 374.459686,445.802246 374.070312,445.458008 
	C374.235413,445.353455 374.552246,445.407837 374.945496,445.722687 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M390.665619,417.981323 
	C390.557648,418.971191 389.664520,419.039124 388.343292,419.010559 
	C388.483246,418.046082 389.375000,417.957581 390.665619,417.981323 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M393.304993,417.003540 
	C393.437408,416.247375 394.078369,415.942505 394.915588,416.175903 
	C394.981079,416.194153 394.989288,416.771393 394.942535,416.783875 
	C394.509430,416.899811 394.058319,416.948639 393.304993,417.003540 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M400.006042,415.009399 
	C399.558228,415.750305 398.916016,416.065674 398.075806,415.819946 
	C398.005219,415.799286 397.995728,415.222504 398.039764,415.210724 
	C398.474701,415.094543 398.927002,415.043182 399.675842,414.975128 
	C399.977356,414.976776 399.997681,414.997803 400.006042,415.009399 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M390.982147,417.975128 
	C391.438934,417.637726 391.915558,417.325195 392.694885,417.001404 
	C392.997559,416.990143 392.999420,417.000427 393.004333,417.001434 
	C392.553955,417.339417 392.098724,417.676392 391.344299,418.030090 
	C391.045135,418.046783 391.001984,418.000000 390.982147,417.975128 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M387.374725,419.967194 
	C387.117462,419.883209 387.074280,419.702850 387.028198,419.244232 
	C387.025330,418.965942 387.466614,418.911194 387.687683,418.905884 
	C387.908783,418.900543 388.008087,419.008850 388.059631,419.065002 
	C388.048309,419.448517 387.874207,419.698425 387.374725,419.967194 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M429.011292,418.000366 
	C428.883301,417.430542 428.751160,416.848328 428.373596,416.088348 
	C427.137451,412.609589 430.978180,413.566071 431.738495,411.472137 
	C434.898682,410.757355 438.061554,410.380859 441.652771,410.018768 
	C448.001709,411.550507 448.352600,417.078430 450.173492,421.467529 
	C451.213654,423.974823 448.521820,423.663361 447.085693,424.919586 
	C446.794708,425.342896 446.527435,425.586121 446.773987,425.803406 
	C446.481293,426.585846 446.015320,427.534058 445.390778,427.653503 
	C441.489105,428.399933 432.760651,424.015594 430.278198,420.168457 
	C429.991760,419.979675 430.012024,419.997223 430.009735,420.010742 
	C429.587860,419.571991 429.526489,418.976471 429.173767,418.200592 
	C428.981445,417.980652 429.007172,417.988007 429.011292,418.000366 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M440.134796,434.667114 
	C438.850983,435.561310 437.730560,436.155670 436.317780,436.870300 
	C436.352783,435.486877 436.680206,433.983215 437.033203,432.090271 
	C437.091431,431.504089 437.124023,431.307159 437.454346,431.078461 
	C438.970245,431.176880 440.485107,430.486847 441.338806,431.556824 
	C442.242401,432.689331 440.798370,433.466370 440.134796,434.667114 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M437.956543,430.754456 
	C437.532837,431.111969 437.352753,431.234650 437.135315,431.557861 
	C435.270996,431.884888 433.702820,431.239502 434.592651,429.339203 
	C435.319153,427.787781 437.436035,426.356415 439.123871,427.373962 
	C440.910461,428.451019 438.638428,429.432129 437.956543,430.754456 
z"/>
<path fill="#075479" opacity="1.000000" stroke="none" 
	d="
M456.602234,407.965393 
	C454.898560,409.747894 452.389801,410.097687 449.349915,409.946899 
	C448.941711,409.889465 448.926941,409.595093 448.911377,409.451111 
	C451.338043,408.913940 453.626556,407.701233 456.602234,407.965393 
z"/>
<path fill="#142D45" opacity="1.000000" stroke="none" 
	d="
M446.989075,425.009644 
	C447.427063,425.176910 447.878021,425.332092 448.328949,425.487274 
	C448.062073,425.657257 447.795197,425.827209 447.274445,426.008942 
	C447.020569,426.020721 447.001617,426.001556 446.993286,425.992859 
	C446.825073,425.808655 446.665222,425.633179 446.766235,425.215363 
	C447.027100,424.973022 447.002045,424.997589 446.989075,425.009644 
z"/>
<path fill="#0ABEFA" opacity="1.000000" stroke="none" 
	d="
M293.633057,370.004272 
	C296.047852,372.044128 297.490265,374.753387 300.613983,376.144287 
	C302.430817,376.600922 303.556091,377.521301 304.807312,378.809021 
	C312.545227,379.667786 315.978058,385.935242 320.856567,390.712097 
	C321.607697,393.482758 318.866058,394.892456 319.002319,397.630920 
	C316.937042,397.558289 314.915009,396.520508 312.487854,397.939026 
	C307.824829,394.249908 303.514984,390.527740 299.035034,386.524139 
	C299.974548,385.070160 301.930206,384.832520 299.978210,382.042725 
	C297.363525,378.305786 294.737671,374.503113 292.141174,370.311829 
	C292.428558,370.006042 292.866669,370.003510 293.633057,370.004272 
z"/>
<path fill="#31E7FE" opacity="1.000000" stroke="none" 
	d="
M331.893341,429.351624 
	C333.625427,429.053009 335.035919,428.823792 335.006836,426.339600 
	C335.826447,426.569336 336.629883,427.172760 337.703918,427.913025 
	C338.270355,429.907440 337.723907,431.621185 337.035156,433.701904 
	C336.804779,434.229187 336.614410,434.372009 336.199921,434.237000 
	C335.975769,433.959167 336.003937,433.998566 336.025238,434.010040 
	C336.046539,434.021515 335.692657,433.672089 335.692657,433.672089 
	C335.692657,433.672089 335.195801,433.693237 335.009888,433.859009 
	C334.823975,434.024750 334.363861,433.992798 334.133606,433.980469 
	C332.717285,432.777008 331.654663,431.524597 331.893341,429.351624 
z"/>
<path fill="#0ABEFA" opacity="1.000000" stroke="none" 
	d="
M319.019287,397.986023 
	C319.150665,398.127167 319.264038,398.283569 319.377380,398.440002 
	C319.285217,398.395447 319.193024,398.350922 319.035950,398.171875 
	C318.971039,398.037384 319.001312,398.001282 319.019287,397.986023 
z"/>
<path fill="#1A6D97" opacity="1.000000" stroke="none" 
	d="
M333.023102,422.174530 
	C332.638336,422.280518 332.270966,422.020538 331.961304,421.416718 
	C332.359497,421.318085 332.699982,421.563324 333.023102,422.174530 
z"/>
<path fill="#1A6D97" opacity="1.000000" stroke="none" 
	d="
M333.831665,423.624146 
	C333.672852,423.611359 333.391937,423.335419 333.041443,422.763947 
	C333.217712,422.765930 333.463623,423.063446 333.831665,423.624146 
z"/>
<path fill="#0CD8FF" opacity="1.000000" stroke="none" 
	d="
M310.705872,366.869507 
	C311.077545,367.340759 311.260437,367.609100 311.775787,367.901550 
	C312.333496,369.051239 312.661652,370.106659 313.047302,371.485687 
	C310.684601,375.214600 308.382019,374.828156 306.098450,371.638458 
	C304.579742,369.517120 303.503510,366.945587 300.343567,366.036194 
	C296.829071,362.995850 297.131439,359.493683 298.780090,355.444031 
	C300.896667,354.548157 301.844299,356.055176 303.389709,357.028595 
	C304.386169,359.966614 305.644562,362.416779 308.604919,364.003571 
	C308.960388,365.206665 309.475708,366.087250 310.705872,366.869507 
z"/>
<path fill="#21E8FF" opacity="1.000000" stroke="none" 
	d="
M298.707581,355.195099 
	C299.138123,358.446899 298.453735,361.906830 299.940552,365.593445 
	C300.000793,367.068329 300.006470,368.136688 300.004456,369.605774 
	C294.824982,366.173065 294.083984,359.405731 298.707581,355.195099 
z"/>
<path fill="#21E8FF" opacity="1.000000" stroke="none" 
	d="
M305.016418,378.648010 
	C303.397278,378.882050 301.973572,378.361359 301.022522,376.543610 
	C300.962524,375.102509 300.976044,373.973053 300.991364,372.424561 
	C304.811035,372.500641 304.134735,375.878448 305.016418,378.648010 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M335.837646,434.289398 
	C336.148254,433.959137 336.320770,433.959076 336.744232,434.022675 
	C337.565857,434.887634 338.136597,435.688965 338.812897,436.768860 
	C338.737946,437.315491 338.521301,437.550232 338.099243,437.921906 
	C336.793152,437.187195 336.040527,436.035583 335.837646,434.289398 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M338.194702,438.290771 
	C338.105042,437.809479 338.280243,437.526855 338.686951,437.145813 
	C338.994781,437.213593 339.071075,437.379730 339.057220,437.804932 
	C338.797882,438.205750 338.628754,438.347595 338.194702,438.290771 
z"/>
<path fill="#065486" opacity="1.000000" stroke="none" 
	d="
M293.820007,379.311035 
	C294.496765,378.311432 294.969940,378.588409 295.104462,379.781982 
	C294.629822,379.887024 294.283203,379.735657 293.820007,379.311035 
z"/>
<path fill="#065486" opacity="1.000000" stroke="none" 
	d="
M294.964142,380.231659 
	C295.512939,379.969727 295.913422,380.047333 295.285767,380.811584 
	C295.068787,380.887970 294.971649,380.453918 294.964142,380.231659 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M290.908081,376.335388 
	C291.425232,375.733246 291.775940,375.839172 291.991272,376.761353 
	C291.644989,376.968903 291.265472,376.812592 290.908081,376.335388 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M192.044403,310.552551 
	C192.902481,308.537262 194.649429,309.120483 196.593124,308.998413 
	C197.678513,312.989014 201.640549,313.703461 204.044312,315.956238 
	C205.696503,317.504639 207.875443,318.526581 207.998657,321.550385 
	C202.748566,318.214478 197.494354,314.516785 192.044403,310.552551 
z"/>
<path fill="#0D1D30" opacity="1.000000" stroke="none" 
	d="
M240.297409,433.233978 
	C239.111389,433.071503 238.283737,433.066406 237.456619,433.084961 
	C228.189789,433.292938 228.083084,433.189117 226.922943,423.505676 
	C226.826599,422.701538 226.538544,421.920380 226.042633,420.827057 
	C222.370926,417.646118 223.428360,414.165405 224.670593,410.328888 
	C225.219849,407.173370 224.518845,404.326080 225.704391,401.292480 
	C226.739548,404.434204 225.649246,407.614075 228.489777,411.386047 
	C232.550140,416.777802 231.392639,417.655212 238.258636,421.029633 
	C238.847107,421.318817 239.787506,421.463165 239.556976,422.216522 
	C237.954330,427.453705 242.549667,427.982117 245.647537,429.958069 
	C246.874283,431.167847 246.281891,431.965729 244.955627,432.835724 
	C243.302658,433.371368 241.997635,433.566284 240.297409,433.233978 
z"/>
<path fill="#071A2D" opacity="1.000000" stroke="none" 
	d="
M243.960754,432.448608 
	C244.917679,431.922607 245.699860,431.675812 245.957855,430.316772 
	C247.671844,430.036346 249.470139,429.637329 250.827087,431.660980 
	C250.734161,432.482208 250.474350,432.986298 250.111801,433.755249 
	C247.595810,435.720184 245.516266,435.600800 243.960754,432.448608 
z"/>
<path fill="#0D1D30" opacity="1.000000" stroke="none" 
	d="
M235.467728,413.453247 
	C235.521027,413.422272 235.414429,413.484253 235.467728,413.453247 
z"/>
<path fill="#141923" opacity="1.000000" stroke="none" 
	d="
M224.579208,409.935974 
	C225.286697,413.260681 224.419174,416.623596 225.601929,420.205200 
	C225.747513,422.044983 225.749313,423.564362 225.662521,425.518738 
	C225.104874,426.584412 224.439941,426.797089 223.339844,426.793152 
	C221.037125,426.249786 220.583176,423.980927 218.507812,423.106018 
	C212.920441,421.870209 209.954636,417.765533 206.447937,413.789734 
	C205.857819,409.247437 207.908539,405.538940 208.914795,401.329346 
	C209.931015,401.061310 210.609192,401.026581 211.626038,400.990784 
	C213.949203,400.670166 215.098434,401.832367 215.878006,403.379517 
	C217.646591,406.889374 220.658356,408.740234 224.579208,409.935974 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M243.654434,432.002747 
	C245.104935,434.329651 247.219742,434.046875 249.619370,434.026459 
	C250.446472,434.332916 250.883896,434.645660 251.602570,434.989136 
	C252.348099,436.959473 250.808685,437.937408 249.522476,439.277100 
	C248.707962,439.224854 248.280045,439.028839 247.633820,438.512207 
	C246.634125,437.822998 246.279236,436.079407 245.312881,436.837128 
	C242.967239,438.676178 240.051147,437.990723 237.240997,439.055969 
	C234.219131,435.439850 238.744949,435.467651 239.793350,433.361816 
	C241.058304,432.713684 242.177826,432.361694 243.654434,432.002747 
z"/>
<path fill="#04203D" opacity="1.000000" stroke="none" 
	d="
M248.888611,439.267487 
	C249.956024,437.923004 250.797485,436.753601 251.761368,435.302063 
	C252.425125,434.685822 252.966461,434.351776 253.845627,434.007568 
	C254.131729,434.433136 254.079971,434.868927 254.011246,435.632629 
	C252.518829,437.533386 251.043396,439.106232 249.089569,440.617981 
	C248.512207,440.180054 248.529465,439.808655 248.888611,439.267487 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M155.281647,348.369751 
	C155.047806,348.928436 154.718979,348.924042 154.429062,348.450531 
	C154.670517,348.369568 154.911987,348.288605 155.281647,348.369751 
z"/>
<path fill="#04558C" opacity="1.000000" stroke="none" 
	d="
M152.064224,346.947662 
	C152.377106,347.048584 152.589630,347.247864 152.802155,347.447144 
	C152.552811,347.497375 152.303467,347.547638 151.911469,347.423126 
	C151.768814,347.248383 151.963867,347.046021 152.064224,346.947662 
z"/>
<path fill="#18DBFB" opacity="1.000000" stroke="none" 
	d="
M310.457153,419.453827 
	C310.513763,419.420319 310.400543,419.487335 310.457153,419.453827 
z"/>
<path fill="#70E9FC" opacity="1.000000" stroke="none" 
	d="
M331.786377,429.004333 
	C332.631256,430.446625 333.251343,431.874268 333.887390,433.635010 
	C330.778229,435.021759 327.718964,435.954742 328.029663,430.357117 
	C328.929993,429.804413 329.807343,429.646332 330.898743,429.218567 
	C331.112823,428.948914 331.561554,428.989746 331.786377,429.004333 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M335.129944,434.149811 
	C335.017731,433.500610 335.195770,432.945038 335.982178,433.749817 
	C335.843018,434.105957 335.639465,434.190430 335.129944,434.149811 
z"/>
<path fill="#252326" opacity="1.000000" stroke="none" 
	d="
M288.658569,409.683533 
	C288.773407,410.163605 288.513580,410.452637 287.952515,410.779907 
	C287.469757,410.188934 287.685150,409.749237 288.658569,409.683533 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M246.371796,465.352020 
	C245.455521,463.905762 244.276108,464.004761 242.785431,463.991150 
	C242.213913,464.148773 241.988052,464.329620 241.408478,464.258911 
	C238.697205,462.241272 236.356750,463.442322 233.643036,464.076904 
	C231.955582,462.376312 233.721817,461.177277 234.186798,459.429016 
	C234.837952,458.387543 235.498001,457.793304 236.319748,456.912598 
	C237.501419,455.839233 238.376678,454.921722 239.320679,453.615662 
	C241.144943,451.724792 242.717468,450.060486 243.907425,447.682861 
	C244.294876,447.033417 244.533340,446.679596 244.962585,446.085297 
	C245.369431,445.504333 245.598511,445.172668 245.982086,444.583679 
	C246.251251,444.161682 246.363678,443.995422 246.669998,443.597351 
	C247.014389,443.230804 247.164902,443.096039 248.124725,442.934692 
	C250.895172,445.811096 248.832352,447.600433 246.976959,449.776917 
	C247.179138,451.852203 246.636169,453.474121 245.753357,455.325439 
	C245.194962,456.341217 244.465576,456.729614 243.614151,457.411682 
	C243.126266,457.871246 242.855759,458.139191 242.391037,458.605713 
	C241.984818,458.984741 241.801010,459.188995 241.644974,459.416656 
	C241.492371,459.639374 241.549500,459.564636 242.012238,458.992126 
	C242.479843,458.525970 242.749451,458.258026 243.226196,457.783386 
	C244.175858,456.921204 245.194748,456.610229 245.969177,455.500183 
	C247.229233,454.551025 248.331528,453.934113 249.749603,453.236450 
	C250.731689,452.978088 251.459625,452.910400 252.631302,452.953979 
	C253.860107,454.177948 253.501968,454.942719 252.206345,455.684937 
	C252.169876,456.082062 252.272064,456.258575 252.270996,456.695740 
	C252.037247,457.294373 251.361496,457.328003 251.748444,457.740356 
	C251.853622,457.584625 252.205887,457.365784 252.600647,457.193634 
	C253.900696,457.083099 254.775406,457.189514 254.970856,458.672882 
	C254.845032,459.589203 254.493958,460.674286 254.546432,460.694153 
	C256.248627,461.339020 257.077026,459.640350 258.714417,459.079773 
	C259.346924,460.285065 258.654602,461.290619 257.867920,462.644775 
	C257.402557,467.150604 252.981308,464.366760 251.248352,466.779053 
	C250.310379,466.806793 249.702423,466.541504 248.754639,466.280151 
	C247.802597,466.074982 247.186417,465.888855 246.371796,465.352020 
z"/>
<path fill="#14A4F1" opacity="1.000000" stroke="none" 
	d="
M243.899384,474.447449 
	C243.191513,472.162201 241.665039,470.052765 244.853363,468.320984 
	C245.383911,467.696991 245.823700,467.455902 246.681213,467.205078 
	C248.415741,467.005951 249.542725,467.494568 250.738937,468.754150 
	C250.592880,472.290405 247.280212,472.689270 245.188110,474.763123 
	C244.517059,475.133331 244.179062,475.080963 243.899384,474.447449 
z"/>
<path fill="#14A4F1" opacity="1.000000" stroke="none" 
	d="
M244.385742,480.008362 
	C244.001495,479.567200 244.000290,479.129059 243.997223,478.362366 
	C244.297104,476.730957 245.286743,476.492371 246.728851,476.422668 
	C248.059998,476.332458 249.078064,476.288910 250.473541,476.308167 
	C250.135193,479.775848 247.364670,479.747742 244.385742,480.008362 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M246.713348,476.266846 
	C246.202530,476.841034 245.363144,477.306091 244.259552,477.902466 
	C243.243195,478.051270 242.491043,478.068756 241.363327,478.057007 
	C241.020096,477.587646 241.052429,477.147491 241.088745,476.376465 
	C240.931961,475.868408 240.771164,475.691193 240.864807,475.260803 
	C241.851196,474.717834 242.583145,474.428040 243.608368,474.145142 
	C244.032852,474.424561 244.233688,474.628479 244.703674,474.852020 
	C245.092255,475.717010 245.659439,476.033569 246.713348,476.266846 
z"/>
<path fill="#059FE5" opacity="1.000000" stroke="none" 
	d="
M251.028992,468.668274 
	C249.880692,468.693512 248.746231,468.371246 247.258118,468.004639 
	C246.480759,466.423584 247.633194,465.926575 248.940094,465.153320 
	C250.034256,465.141174 250.759323,465.388153 250.923340,466.641907 
	C250.988297,467.395905 251.015564,467.858368 251.028992,468.668274 
z"/>
<path fill="#0B5186" opacity="1.000000" stroke="none" 
	d="
M265.901184,475.852234 
	C265.475586,476.345276 264.947235,476.570435 264.123840,476.703308 
	C264.180664,475.684296 263.820648,473.391846 265.901184,475.852234 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M245.194229,456.123993 
	C245.441681,454.035767 245.901688,452.275360 246.600952,450.291870 
	C247.704529,450.963928 248.568848,451.859100 249.718475,452.900024 
	C249.833420,455.057495 248.207596,455.413391 246.380524,455.960663 
	C245.827728,456.144958 245.617249,456.298401 245.194229,456.123993 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M254.254395,451.977081 
	C254.308548,451.395050 254.636246,450.769165 255.340103,451.567352 
	C255.077179,451.718781 254.814240,451.870178 254.254395,451.977081 
z"/>
<path fill="#061426" opacity="1.000000" stroke="none" 
	d="
M254.033585,440.045898 
	C253.700577,440.581726 253.325562,441.137604 252.680847,440.417908 
	C252.920486,440.251770 253.160110,440.085663 253.622345,439.874817 
	C253.844955,439.830109 253.971893,439.972961 254.033585,440.045898 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M248.957855,442.588562 
	C248.934067,442.908051 248.485580,443.029480 248.254639,443.054749 
	C247.492416,442.320892 247.531540,441.614349 248.618362,440.987762 
	C249.018356,441.008026 249.001419,441.002869 248.995636,440.993896 
	C248.987122,441.412964 248.984375,441.841034 248.957855,442.588562 
z"/>
<path fill="#061426" opacity="1.000000" stroke="none" 
	d="
M256.317963,441.383087 
	C256.182129,441.551910 255.940552,441.577240 255.698975,441.602570 
	C255.870056,441.481567 256.041138,441.360596 256.317963,441.383087 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M252.480011,456.975952 
	C251.974182,456.785126 251.989182,456.609161 252.035919,456.169373 
	C252.325317,456.116699 252.582962,456.327911 252.917999,456.780273 
	C252.995392,457.021484 253.000854,456.990845 252.480011,456.975952 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M252.954742,452.948273 
	C253.105087,452.639191 253.293457,452.371246 253.719650,452.017944 
	C253.957489,451.932556 254.001144,451.996613 254.034485,452.019653 
	C253.890045,452.317871 253.712280,452.593018 253.304779,452.966736 
	C253.075058,453.065308 252.992752,452.989380 252.954742,452.948273 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M293.298798,485.980011 
	C289.588440,485.455475 286.236359,486.632019 282.390930,486.971893 
	C281.975647,486.233276 281.985077,485.505646 281.979553,484.414978 
	C282.147247,484.036591 282.329895,484.021210 282.785461,483.967804 
	C286.458984,484.079712 289.889954,483.915039 293.624237,484.944641 
	C293.860535,485.264526 293.681915,485.547974 293.298798,485.980011 
z"/>
<path fill="#0F62A1" opacity="1.000000" stroke="none" 
	d="
M295.392944,489.961853 
	C295.006104,489.556458 295.005402,489.104279 295.008057,488.312500 
	C297.271484,487.972900 299.531494,487.972900 301.791504,487.972900 
	C301.816467,488.161926 301.841431,488.350952 301.866394,488.539978 
	C299.837311,488.998322 297.808197,489.456665 295.392944,489.961853 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M185.009949,456.012817 
	C184.884933,455.947723 184.970581,456.819763 184.831665,456.041687 
	C184.976410,455.981262 185.000137,456.000885 185.009949,456.012817 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M191.001602,446.873047 
	C190.868515,446.852966 190.729141,446.566864 190.747711,446.181519 
	C190.935547,446.257172 190.965424,446.432068 191.001602,446.873047 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M184.681732,442.122437 
	C185.488968,441.790649 186.094742,441.592255 186.854156,441.099731 
	C187.007812,440.805603 187.462128,440.678894 187.696747,440.655029 
	C188.101074,440.859375 188.270782,441.087616 188.250519,441.697906 
	C187.686646,443.153473 187.312759,444.227020 186.960175,445.646240 
	C186.981506,445.991913 187.000793,446.000427 186.999374,445.990417 
	C186.820435,446.101562 186.642914,446.222717 186.200470,446.160217 
	C185.624985,445.872009 185.377457,445.684387 185.091110,445.200073 
	C184.846817,444.449219 184.704346,443.911896 184.310516,443.242126 
	C184.087555,442.769806 184.227921,442.485168 184.681732,442.122437 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M186.037659,446.158813 
	C186.112625,445.959259 186.289749,445.941986 186.732422,445.952545 
	C186.836548,446.397125 186.660706,446.779572 186.037659,446.158813 
z"/>
<path fill="#0C6AA2" opacity="1.000000" stroke="none" 
	d="
M188.292419,441.887329 
	C188.037445,441.839661 188.014359,441.599365 187.961334,440.995117 
	C188.090500,440.376740 188.312637,440.202606 188.807510,440.051575 
	C188.852951,440.561188 188.688614,441.127960 188.292419,441.887329 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M200.721039,441.020874 
	C200.555435,441.358948 200.083633,441.705139 199.301239,442.043671 
	C199.465378,441.700317 199.940109,441.364685 200.721039,441.020874 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M198.802460,442.100525 
	C198.856140,442.284241 198.676331,442.573517 198.244812,442.947327 
	C198.185043,442.756592 198.376999,442.481323 198.802460,442.100525 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M209.939301,448.049255 
	C209.497437,447.382751 209.135391,446.641754 209.024811,445.337708 
	C210.571136,445.101776 210.738846,446.046600 210.381500,447.494690 
	C210.175903,447.822906 210.019104,447.974792 209.939301,448.049255 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M208.824036,445.152252 
	C208.379318,444.794586 208.075668,444.323120 207.679291,443.583984 
	C207.586548,443.316345 207.899826,443.081268 208.054932,442.961670 
	C209.037872,442.894226 209.393311,443.398621 209.363312,444.489807 
	C209.250732,444.815369 208.965073,445.038452 208.824036,445.152252 
z"/>
<path fill="#17283A" opacity="1.000000" stroke="none" 
	d="
M187.088470,401.466614 
	C191.260254,401.025879 195.412033,400.984772 199.563690,400.995392 
	C205.523849,401.010651 205.713531,401.290253 204.137589,407.749603 
	C204.881104,408.978729 205.043427,409.969025 204.924103,411.409210 
	C204.782944,412.295410 204.657974,412.792053 204.446320,413.661438 
	C203.572983,417.543945 203.707199,421.307648 201.246033,424.701172 
	C200.721176,425.168091 200.517700,425.400818 200.245377,425.872375 
	C193.794617,427.089722 191.994598,421.678223 188.575043,418.025818 
	C188.213577,417.218628 188.165421,416.496765 188.134995,415.412964 
	C188.574112,414.577362 188.969223,414.097290 188.345581,413.175049 
	C188.140121,412.931366 188.052200,412.963196 188.009933,412.983459 
	C188.488724,409.232544 187.030670,405.621460 187.088470,401.466614 
z"/>
<path fill="#1B2532" opacity="1.000000" stroke="none" 
	d="
M206.734344,414.200623 
	C208.548264,414.039734 209.738571,414.787872 210.286484,415.965393 
	C211.911285,419.457275 215.079193,420.611603 218.667175,421.849854 
	C219.532150,422.435272 219.579865,423.003265 219.254669,423.888458 
	C218.976028,424.294434 218.844467,424.439697 218.273560,424.947357 
	C217.687698,425.420715 217.541183,425.531677 217.178406,425.803345 
	C216.817383,426.063354 216.672607,426.162659 216.305115,426.392761 
	C215.785278,426.674530 215.488083,426.825378 214.990723,427.106445 
	C214.790649,427.236847 214.414505,427.523895 214.235352,427.676819 
	C214.056183,427.829712 213.706726,428.144226 213.534515,428.304504 
	C213.362289,428.464813 213.019897,428.790314 212.665802,429.109314 
	C212.311707,429.428314 211.922974,429.711792 211.467667,429.847931 
	C209.157364,431.489960 207.167480,432.090698 204.563278,430.889465 
	C202.357040,425.062836 203.774063,419.666107 206.734344,414.200623 
z"/>
<path fill="#0A5C8E" opacity="1.000000" stroke="none" 
	d="
M207.096649,413.574402 
	C205.568817,419.245331 204.861862,424.667267 204.154022,430.481323 
	C198.416840,431.477539 203.101440,426.898010 201.238037,425.188416 
	C201.655167,421.298431 202.350784,417.631012 203.058777,413.560608 
	C203.523499,412.709869 203.888947,412.885651 204.245834,413.299957 
	C204.335495,413.404053 204.114410,413.723999 204.462830,413.415100 
	C204.452362,413.203735 204.601547,412.832825 204.579742,412.642670 
	C204.557953,412.452515 204.179352,412.353455 204.091827,412.178467 
	C204.037201,410.975494 204.070084,409.947510 204.120346,408.538361 
	C207.764252,407.510406 207.103271,404.676575 206.931488,402.308655 
	C206.810486,400.640564 206.600220,399.504211 209.014557,400.860107 
	C208.529037,405.120209 207.805237,409.144318 207.096649,413.574402 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M217.833649,424.179871 
	C218.312469,423.529633 218.631454,423.058777 218.971237,422.289215 
	C221.341736,422.048859 221.350037,424.362793 222.737488,425.800476 
	C223.372299,426.456635 223.611771,426.976013 223.727417,427.991638 
	C222.585617,435.510101 221.396774,436.278107 215.155487,433.451782 
	C213.762756,432.084900 210.134888,434.821808 211.076904,430.305908 
	C211.012360,429.984070 211.001831,430.008392 210.988770,430.011749 
	C211.233185,429.810638 211.467697,429.582581 211.848648,429.152954 
	C212.018066,428.975006 212.004303,429.003723 211.988815,429.007416 
	C212.134644,428.895081 212.295959,428.779053 212.731293,428.547455 
	C213.319992,428.176758 213.534134,427.852905 213.835419,427.226837 
	C214.007965,426.983063 214.001556,427.002289 213.991699,427.004730 
	C214.426514,426.581512 215.025177,426.529816 215.796738,426.167603 
	C216.021423,425.982849 216.004166,426.006042 215.991211,426.012482 
	C216.217148,425.794525 216.451233,425.565277 216.850464,425.153564 
	C217.020416,424.976044 217.004211,425.004242 216.990082,425.012329 
	C217.205643,424.796906 217.438248,424.576538 217.833649,424.179871 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M214.643478,433.373474 
	C221.525375,434.444153 221.525375,434.444153 222.690765,428.322632 
	C224.775055,429.994232 224.705414,432.228424 223.575562,434.331512 
	C222.268723,436.764008 219.930542,435.699982 217.497284,435.760010 
	C216.529892,436.116272 215.979721,436.271637 215.251099,436.653687 
	C214.709808,437.155701 214.310364,437.243927 213.567810,436.996094 
	C212.338608,436.339264 211.267181,436.102814 210.164856,435.250671 
	C211.060135,433.296783 213.045853,434.455292 214.643478,433.373474 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M209.733170,434.997437 
	C211.186600,435.094208 212.480621,434.768738 213.799332,435.886902 
	C213.332657,437.154938 212.240402,437.657928 211.233032,438.761414 
	C210.992371,439.007111 210.935516,439.049622 210.907288,439.071136 
	C210.204636,439.336914 209.721695,439.046814 209.164032,438.271362 
	C209.006714,437.251587 209.004089,436.493988 209.029144,435.357819 
	C209.056824,434.979279 209.507721,434.991455 209.733170,434.997437 
z"/>
<path fill="#173853" opacity="1.000000" stroke="none" 
	d="
M188.102051,413.284668 
	C189.244431,413.324585 191.183640,412.244751 191.329758,414.132233 
	C191.415573,415.240906 189.773651,414.860901 188.506973,415.031372 
	C188.123154,414.580017 188.093567,414.109009 188.102051,413.284668 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M209.472046,445.056824 
	C209.044006,444.287292 208.837296,443.759216 208.420288,443.036621 
	C207.953400,442.105164 207.696777,441.368256 207.442047,440.339600 
	C207.443970,440.047882 207.683868,440.073883 207.803467,440.058105 
	C208.621140,439.410522 209.431366,439.352600 210.638809,439.828064 
	C212.785767,441.420319 214.590942,442.762878 216.724182,444.247375 
	C216.826538,446.573486 214.928894,446.788605 213.223618,447.720459 
	C212.569885,447.991608 212.118378,448.010712 211.327698,448.033081 
	C210.988541,448.036285 210.591949,447.884399 210.383926,447.853638 
	C210.015060,446.981354 209.854202,446.139801 209.472046,445.056824 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M210.965363,439.830444 
	C210.217316,440.056763 209.454025,440.035797 208.306915,440.028564 
	C208.206192,439.539948 208.489273,439.037567 208.890839,438.272217 
	C209.478088,438.277679 209.946838,438.546112 210.647308,438.953613 
	C210.879044,439.092651 210.950150,439.583099 210.965363,439.830444 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M235.258667,459.052460 
	C235.158936,460.939209 234.322083,462.219971 233.336029,463.786255 
	C232.402603,465.333374 231.531982,466.561005 230.392517,467.967285 
	C228.954834,468.096222 227.769836,468.268616 226.282074,467.779724 
	C223.248123,466.527435 223.339584,464.455505 224.539108,461.588867 
	C227.362930,460.248779 227.328796,457.392944 229.460449,455.998260 
	C230.571030,455.086731 231.501053,455.137329 232.754333,455.678680 
	C233.666245,456.502258 233.371704,458.014648 235.120087,457.993042 
	C235.397476,458.406311 235.435837,458.613647 235.258667,459.052460 
z"/>
<path fill="#093764" opacity="1.000000" stroke="none" 
	d="
M225.546936,466.892090 
	C227.144241,467.161652 228.387314,467.362244 229.877014,467.854370 
	C229.330276,469.362946 228.536926,470.579956 227.481506,471.963623 
	C225.727097,471.761963 224.234741,471.393646 222.151062,470.724152 
	C221.430038,467.869965 223.106216,467.139465 225.546936,466.892090 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M239.220215,467.837463 
	C238.275452,469.361298 237.194427,470.317200 235.842636,469.780243 
	C234.536987,469.261597 235.463394,468.136536 235.832520,467.334015 
	C236.388641,466.124908 236.986572,464.708710 238.649384,466.804932 
	C239.082657,467.121765 239.259750,467.315338 239.220215,467.837463 
z"/>
<path fill="#032B57" opacity="1.000000" stroke="none" 
	d="
M248.849014,464.961487 
	C248.577774,465.789276 247.913483,466.604156 247.076828,467.689697 
	C246.480240,467.989044 246.056015,468.017731 245.312820,468.037567 
	C245.329941,467.277161 245.666016,466.525635 246.058411,465.467407 
	C246.895142,465.089966 247.675552,465.019287 248.849014,464.961487 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M234.449036,474.781891 
	C233.572250,475.342255 232.832458,475.814026 232.086136,475.824615 
	C231.501068,475.832947 231.582764,475.138306 231.977982,474.795227 
	C232.756058,474.119720 233.605377,473.631409 234.449036,474.781891 
z"/>
<path fill="#022D4E" opacity="1.000000" stroke="none" 
	d="
M240.932892,464.269958 
	C241.284866,464.005005 241.514938,464.002625 242.092407,463.984070 
	C242.232285,465.141693 241.672836,466.112061 240.444519,467.011200 
	C239.946671,467.113342 239.762924,467.081696 239.592377,466.770630 
	C240.007416,465.838348 240.409210,465.185425 240.932892,464.269958 
z"/>
<path fill="#10B2F6" opacity="1.000000" stroke="none" 
	d="
M240.876007,475.102875 
	C241.114838,475.180481 241.110382,475.353271 241.099335,475.785828 
	C240.909653,476.035065 240.726547,476.024567 240.268372,476.007019 
	C240.206436,475.732697 240.419586,475.465393 240.876007,475.102875 
z"/>
<path fill="#022D4E" opacity="1.000000" stroke="none" 
	d="
M239.242798,468.055786 
	C238.985718,467.959808 238.967896,467.753662 238.927826,467.237885 
	C238.905563,466.928223 239.239777,466.681610 239.422699,466.586426 
	C239.605606,466.491241 239.865631,466.819580 239.998016,466.982239 
	C239.914276,467.411804 239.698166,467.678680 239.242798,468.055786 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M237.380249,472.572388 
	C237.298981,472.476379 237.589401,472.432953 237.589401,472.432953 
	C237.589401,472.432953 237.461533,472.668396 237.380249,472.572388 
z"/>
<path fill="#032B57" opacity="1.000000" stroke="none" 
	d="
M219.188354,472.134125 
	C219.552063,472.019684 219.971497,471.800171 219.996002,471.679260 
	C220.096420,470.859344 220.485184,470.528259 221.584717,470.768097 
	C221.981934,470.970306 221.979370,470.992249 221.976837,471.003662 
	C221.473923,472.898346 221.673096,475.486206 218.201096,474.295166 
	C217.557663,473.096680 218.130157,472.644531 219.188354,472.134125 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M219.159149,471.961456 
	C219.142517,472.503784 218.732986,472.987915 218.166046,473.746155 
	C217.835861,474.040955 217.663040,474.061646 217.234161,474.031494 
	C216.968384,473.542328 216.958679,473.103973 217.068832,472.343872 
	C217.714523,471.982452 218.240387,471.942841 219.159149,471.961456 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M216.264038,474.948334 
	C216.116196,474.620850 216.241974,474.270691 216.675919,473.949829 
	C216.835266,474.294647 216.686462,474.610168 216.264038,474.948334 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M240.842545,478.078033 
	C240.960693,478.265381 240.808823,478.495605 240.388901,478.761536 
	C240.251434,478.557953 240.401993,478.332520 240.842545,478.078033 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M256.355865,492.811066 
	C256.988922,491.786102 258.219086,492.018860 259.769226,492.076050 
	C259.142731,493.043976 257.923004,492.951996 256.355865,492.811066 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M242.000061,481.000000 
	C241.904999,481.031433 241.809875,481.062866 241.857086,481.047180 
	C241.999451,481.000000 242.000000,481.000000 242.000061,481.000000 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M237.013885,439.421692 
	C237.085068,438.794250 237.258499,438.513641 237.449600,438.245667 
	C239.339493,435.595184 243.409439,438.450043 245.272568,435.123779 
	C245.593475,434.550812 247.642227,435.700134 247.953400,437.617981 
	C248.032181,439.672577 247.263336,441.009644 245.825775,442.359070 
	C245.092865,442.680145 244.641800,442.729675 243.601944,442.360779 
	C241.623672,439.785126 238.449188,442.206421 237.013885,439.421692 
z"/>
<path fill="#0D1D30" opacity="1.000000" stroke="none" 
	d="
M217.478882,436.007141 
	C220.989975,435.249725 224.459763,434.169800 222.967896,428.496796 
	C222.978989,427.601959 222.989792,427.143372 223.001526,426.341187 
	C223.648071,425.991241 224.293716,425.984924 225.256622,425.966187 
	C225.691238,427.437775 225.886047,428.920380 225.912750,430.406067 
	C226.043625,437.688293 225.311142,438.191467 217.478882,436.007141 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M233.117310,448.191528 
	C232.917419,447.553680 232.908585,447.182617 232.884674,446.533447 
	C233.775024,444.715820 235.584061,444.063202 236.729950,442.297272 
	C237.140137,442.056732 237.331543,442.063873 237.808182,442.105225 
	C239.053543,443.182281 239.721924,444.528595 241.434143,445.251282 
	C242.325043,445.904266 242.395142,446.534790 242.072357,447.555542 
	C241.806870,448.071777 241.679367,448.267456 241.321747,448.728210 
	C240.414093,449.653290 239.656967,450.190552 238.417343,450.569580 
	C237.850311,450.614227 237.622986,450.597046 237.074371,450.472839 
	C235.682602,449.589539 234.398392,449.199280 233.117310,448.191528 
z"/>
<path fill="#0D1D30" opacity="1.000000" stroke="none" 
	d="
M236.564529,442.010376 
	C237.384918,444.635803 236.633499,446.251251 233.270294,446.157227 
	C230.660492,442.267212 233.433456,442.129303 236.564529,442.010376 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M242.374527,445.829712 
	C239.822189,446.069489 237.613937,446.169739 238.057312,442.523071 
	C239.461197,442.100433 240.828979,442.061462 242.609772,442.022430 
	C243.022781,442.022339 243.005096,442.005310 243.011307,442.011780 
	C244.017654,443.312347 243.893173,444.522308 242.374527,445.829712 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M232.560120,447.958008 
	C234.281509,448.233154 236.059830,447.259338 236.917297,449.591980 
	C236.603409,450.702209 235.993179,451.188293 234.916199,451.722198 
	C233.215393,452.218842 231.912170,452.227844 230.387680,451.264343 
	C229.954407,449.389526 229.987259,447.931946 232.560120,447.958008 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M211.349182,439.070801 
	C210.992645,437.449066 211.012711,435.906525 213.633331,436.152954 
	C214.118469,436.492737 214.325226,436.699097 214.848633,436.846497 
	C216.011490,437.154114 217.272995,437.396118 216.493530,438.736115 
	C215.178299,440.997253 213.354462,439.527588 211.349182,439.070801 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M222.278534,441.454102 
	C220.804733,441.200195 219.747925,441.140381 218.294128,441.061646 
	C217.817642,440.864777 217.738113,440.686798 217.736572,440.227051 
	C221.165756,437.811981 224.353607,439.321442 227.784515,440.683838 
	C228.007462,440.985260 228.014481,440.992493 228.019974,440.988251 
	C226.321747,441.790619 224.564789,442.169891 222.278534,441.454102 
z"/>
<path fill="#053D6C" opacity="1.000000" stroke="none" 
	d="
M229.828064,451.172241 
	C231.457733,450.973999 232.805817,450.969635 234.560760,450.970734 
	C235.307419,451.309631 235.487503,451.717438 235.455383,452.526062 
	C235.234467,453.043762 235.090210,453.223755 234.648010,453.578796 
	C232.811478,454.219818 231.252289,454.484131 229.324310,454.111664 
	C229.007950,453.988892 229.001190,453.998962 229.004929,453.994324 
	C229.187943,453.115173 229.367218,452.240631 229.828064,451.172241 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M221.894730,441.535706 
	C223.623566,441.172638 225.385590,441.085236 227.586548,440.990906 
	C226.635498,442.661011 224.753021,443.030670 222.332840,442.954956 
	C221.943726,442.553741 221.935822,442.182556 221.894730,441.535706 
z"/>
<path fill="#0D2D4D" opacity="1.000000" stroke="none" 
	d="
M231.274277,435.147461 
	C232.442642,435.325439 233.292847,435.709808 232.316330,436.597504 
	C231.590042,437.257782 230.562057,437.181976 229.721344,436.489044 
	C230.130905,436.054840 230.540466,435.620636 231.274277,435.147461 
z"/>
<path fill="#054479" opacity="1.000000" stroke="none" 
	d="
M217.669266,440.062500 
	C217.844391,440.126892 217.874207,440.308533 217.900604,440.766449 
	C217.772766,440.755066 217.648376,440.467407 217.669266,440.062500 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M222.449951,464.131958 
	C220.965576,464.359467 219.821960,464.648315 218.320740,464.965515 
	C217.997040,464.240021 218.030945,463.486145 218.017548,462.357239 
	C219.028183,461.524323 218.919052,460.557312 218.975327,459.321259 
	C219.253693,458.781067 219.537827,458.584625 219.966980,458.162750 
	C221.651520,456.750732 223.336624,456.892700 225.411957,457.650665 
	C225.500412,458.725952 225.238113,459.545715 224.978714,460.691162 
	C224.981628,461.016846 224.999512,460.997864 225.006042,460.986694 
	C224.150681,461.964355 224.550812,463.824646 222.449951,464.131958 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M229.083008,454.230499 
	C230.669708,453.046417 232.470627,452.908508 234.717545,453.123108 
	C236.013260,454.950867 235.301559,456.185547 233.395630,457.079285 
	C232.454041,455.975189 231.449326,455.997803 230.113739,455.881592 
	C229.548981,455.379272 229.353531,454.925690 229.083008,454.230499 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M225.826828,457.526093 
	C224.147766,457.939392 222.532806,457.972565 220.514923,457.971558 
	C221.637436,454.746307 223.681259,455.340454 225.826828,457.526093 
z"/>
<path fill="#0796D7" opacity="1.000000" stroke="none" 
	d="
M222.026276,464.440613 
	C222.894150,463.135223 223.679108,462.199829 224.738327,461.119995 
	C225.978882,462.688721 223.296295,464.847412 225.787277,466.674744 
	C224.331192,467.740631 222.545700,468.273224 222.025360,470.637817 
	C221.532990,471.062592 221.084061,471.154907 220.327820,471.402771 
	C219.871552,469.083984 221.419235,467.093109 222.026276,464.440613 
z"/>
<path fill="#1D1B1E" opacity="1.000000" stroke="none" 
	d="
M381.241760,150.252136 
	C380.850037,149.550369 380.795166,148.783340 380.522858,148.696259 
	C375.600922,147.122635 375.650391,147.189713 379.388580,143.039474 
	C380.448761,141.862457 381.085754,140.304245 381.962402,138.581848 
	C387.958679,141.916534 394.649353,144.288071 400.532379,148.749939 
	C402.594635,150.267639 401.439209,151.192734 400.234131,151.829727 
	C398.361481,152.819626 396.377228,153.598343 394.220123,154.733276 
	C390.856689,154.514709 387.905701,155.804184 384.417542,155.992188 
	C382.004120,154.692825 382.274231,152.352905 381.241760,150.252136 
z"/>
<path fill="#2C2528" opacity="1.000000" stroke="none" 
	d="
M441.972900,205.351654 
	C441.997253,204.831665 441.999420,204.664368 442.000793,204.246094 
	C441.075897,203.085632 440.729095,201.992645 440.982849,200.359009 
	C440.728546,199.446625 440.589691,198.609589 440.144897,198.388824 
	C438.653595,197.648514 436.197052,198.065399 436.187225,195.593491 
	C436.177429,193.116333 438.517822,192.812180 440.630371,192.037292 
	C441.036652,193.158249 440.801086,194.702011 441.970459,195.164963 
	C444.492096,196.163269 446.203125,197.215561 445.507111,200.472305 
	C445.278290,201.542984 447.035919,201.977081 448.632996,201.990051 
	C449.640808,202.083740 450.282806,202.174652 450.924835,202.265579 
	C447.995453,206.497284 452.033417,208.301071 454.084564,210.445435 
	C457.330536,213.838943 461.215454,216.699234 460.016937,222.598267 
	C458.957489,222.961639 457.886780,222.975403 456.415009,222.985397 
	C452.628754,218.786438 448.782990,215.021317 445.030701,211.166580 
	C443.539581,209.634811 442.344940,207.881165 441.972900,205.351654 
z"/>
<path fill="#252326" opacity="1.000000" stroke="none" 
	d="
M416.724243,173.797577 
	C419.202820,173.260818 420.689331,173.239487 422.055847,175.812424 
	C424.668274,180.731216 430.142090,183.327759 432.971497,188.557800 
	C432.401855,190.920624 430.789307,191.473999 428.572510,191.611282 
	C426.406006,190.774429 425.863495,188.646851 423.866394,187.552277 
	C420.207428,184.728714 417.865509,181.156448 414.963745,178.106766 
	C413.953461,177.044998 413.091766,175.819534 413.904205,173.897827 
	C414.902161,173.263168 415.649597,173.372757 416.724243,173.797577 
z"/>
<path fill="#252326" opacity="1.000000" stroke="none" 
	d="
M399.582458,160.733276 
	C404.707001,165.478073 410.733337,168.253006 415.959167,172.591034 
	C413.961639,173.825333 411.865448,174.534683 409.166992,174.041901 
	C404.541473,170.297928 398.383179,168.678909 396.660767,162.006866 
	C397.166168,160.396057 398.103394,160.187668 399.582458,160.733276 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M427.677002,191.051804 
	C429.474579,190.445007 430.947449,189.848434 432.716797,189.073669 
	C433.763885,188.921127 434.514496,188.946762 435.640900,188.988342 
	C434.013702,192.247086 430.997864,194.224548 427.280396,195.846985 
	C426.792542,195.075348 426.632202,194.191315 426.204926,193.090332 
	C425.730103,191.739197 426.503723,191.371353 427.677002,191.051804 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M407.673401,172.913895 
	C410.383026,172.982269 412.757080,172.979309 415.576904,172.952820 
	C416.288177,173.136246 416.553619,173.343231 416.934631,173.777649 
	C416.293976,174.009979 415.537720,174.014847 414.404175,174.022919 
	C412.688629,175.561569 411.018005,176.276825 408.575867,175.990509 
	C407.931641,175.790131 407.686646,175.672409 407.165833,175.254395 
	C406.890015,174.954102 406.969269,174.479965 406.982788,174.239990 
	C406.820709,173.528824 406.934570,173.143021 407.673401,172.913895 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M400.107971,160.734375 
	C399.044495,161.133377 398.186005,161.296188 397.097260,161.700012 
	C396.537964,162.293457 396.129547,162.483704 395.308838,162.465729 
	C394.559357,162.147263 394.232788,161.821823 393.948730,161.059357 
	C395.074219,160.213028 396.248566,159.714340 397.716583,159.071259 
	C398.841187,158.947174 399.685333,158.885880 400.498169,159.017654 
	C401.003998,159.099640 402.002991,158.498001 401.911621,159.578186 
	C401.882050,159.927429 400.873627,160.193863 400.107971,160.734375 
z"/>
<path fill="#1D1B1E" opacity="1.000000" stroke="none" 
	d="
M426.686188,171.772980 
	C426.717163,173.187668 428.330963,174.285599 427.190826,175.579483 
	C425.623993,175.216827 425.499939,173.837296 425.033630,172.349701 
	C425.386536,171.642075 425.845337,171.490295 426.686188,171.772980 
z"/>
<path fill="#252326" opacity="1.000000" stroke="none" 
	d="
M426.996826,171.741089 
	C426.552643,171.994675 426.109039,171.999100 425.332733,172.007721 
	C423.969574,172.261154 422.776764,173.680862 422.031982,171.301453 
	C423.384827,170.995010 424.774536,170.992432 426.580933,170.991760 
	C426.997650,170.993637 426.997406,171.491943 426.996826,171.741089 
z"/>
<path fill="#1D1B1E" opacity="1.000000" stroke="none" 
	d="
M428.402466,177.954529 
	C428.800903,177.222107 429.203278,177.215698 429.559784,177.735275 
	C429.634521,177.844223 429.632385,178.097107 429.555176,178.203598 
	C429.185425,178.713669 428.783295,178.694824 428.402466,177.954529 
z"/>
<path fill="#2C2528" opacity="1.000000" stroke="none" 
	d="
M463.911377,223.813431 
	C463.831879,223.980637 463.664276,223.984146 463.245636,223.972488 
	C463.270844,223.854782 463.547058,223.752258 463.911377,223.813431 
z"/>
<path fill="#044166" opacity="1.000000" stroke="none" 
	d="
M476.725739,387.230957 
	C477.291077,390.290771 476.565704,393.447784 475.215851,396.790253 
	C474.749023,393.736725 475.457031,390.588165 476.725739,387.230957 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M471.347961,403.057251 
	C471.024841,402.620209 471.007690,402.188812 470.977661,401.435547 
	C471.428253,401.106171 471.891754,401.098663 472.701630,401.129883 
	C473.017487,401.619446 472.986938,402.070343 472.912170,402.861206 
	C472.463257,403.155121 472.058594,403.109009 471.347961,403.057251 
z"/>
<path fill="#044166" opacity="1.000000" stroke="none" 
	d="
M477.747589,384.086426 
	C477.849335,384.764252 477.687256,385.672882 477.255493,386.800537 
	C477.151825,386.118774 477.317810,385.218018 477.747589,384.086426 
z"/>
<path fill="#075479" opacity="1.000000" stroke="none" 
	d="
M459.673096,406.964569 
	C459.527649,407.978546 458.607056,408.029114 457.329224,408.031982 
	C457.453094,406.972107 458.392853,406.964783 459.673096,406.964569 
z"/>
<path fill="#075479" opacity="1.000000" stroke="none" 
	d="
M462.679993,405.970642 
	C462.481415,406.878723 461.602325,407.021515 460.321899,407.022430 
	C460.472473,406.011078 461.401672,405.981720 462.679993,405.970642 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M467.687714,403.973267 
	C467.491791,404.896240 466.594269,405.001740 465.313080,405.019104 
	C465.487549,404.056335 466.409851,404.001740 467.687714,403.973267 
z"/>
<path fill="#044166" opacity="1.000000" stroke="none" 
	d="
M478.727722,381.157074 
	C478.826141,381.582092 478.651062,382.176849 478.226501,382.973938 
	C478.136108,382.559784 478.295197,381.943298 478.727722,381.157074 
z"/>
<path fill="#075479" opacity="1.000000" stroke="none" 
	d="
M464.713684,404.993347 
	C464.549103,405.317322 464.071045,405.652863 463.283264,406.002899 
	C463.449097,405.679901 463.924652,405.342438 464.713684,404.993347 
z"/>
<path fill="#0A2139" opacity="1.000000" stroke="none" 
	d="
M487.177673,333.248169 
	C487.561615,333.174805 488.113525,333.343140 488.832123,333.755127 
	C488.447754,333.829132 487.896698,333.659454 487.177673,333.248169 
z"/>
<path fill="#272930" opacity="1.000000" stroke="none" 
	d="
M483.997223,358.996460 
	C484.088745,358.960297 484.183044,358.927704 484.142334,358.950378 
	C484.007324,359.005585 484.000000,359.000000 483.997223,358.996460 
z"/>
<path fill="#959398" opacity="1.000000" stroke="none" 
	d="
M361.040710,116.750015 
	C361.231842,115.177094 362.306305,114.979149 363.934601,115.535385 
	C363.572906,116.860123 362.518188,116.995232 361.040710,116.750015 
z"/>
<path fill="#022543" opacity="1.000000" stroke="none" 
	d="
M485.998596,392.998169 
	C485.862396,392.918457 485.988159,393.774445 485.843079,393.043823 
	C486.003662,393.003448 486.000000,393.000000 485.998596,392.998169 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M105.888397,276.723633 
	C105.139389,277.610687 105.124710,276.887726 105.101944,276.515137 
	C105.086555,276.263489 105.347664,275.994934 105.485092,275.733948 
	C105.632164,275.986572 105.779236,276.239227 105.888397,276.723633 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M105.008224,281.689087 
	C104.838524,282.003357 104.669617,282.006317 104.247429,282.000885 
	C104.145020,281.264709 104.295876,280.536957 104.446732,279.809204 
	C104.634163,280.332062 104.821602,280.854889 105.008224,281.689087 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M194.362915,300.254211 
	C192.608597,300.001068 191.220901,299.999695 189.416901,299.996704 
	C185.284027,295.958008 186.148621,291.377960 187.715012,286.373596 
	C191.896500,284.743774 195.721069,286.254333 195.788559,289.668976 
	C195.856628,293.114136 197.363037,296.015686 197.995300,299.603577 
	C197.037003,300.970093 195.927689,301.023987 194.362915,300.254211 
z"/>
<path fill="#050E18" opacity="1.000000" stroke="none" 
	d="
M187.549255,285.998779 
	C188.311783,290.388489 187.222519,294.873199 188.946457,299.583008 
	C184.611465,300.592712 181.689728,299.653076 181.479736,294.301605 
	C181.380081,291.761810 179.925110,289.275177 179.035706,286.389313 
	C181.691238,286.009033 184.395172,286.003906 187.549255,285.998779 
z"/>
<path fill="#050D16" opacity="1.000000" stroke="none" 
	d="
M200.773743,300.315918 
	C204.662903,299.644287 208.037186,300.091797 209.865677,303.826660 
	C210.544006,305.212189 212.637405,306.281555 211.504868,308.149048 
	C210.588547,309.660004 208.778290,308.830902 207.360519,308.982971 
	C206.541214,309.070862 205.704803,308.999420 204.438049,308.999237 
	C202.101959,306.517670 200.409653,303.951660 200.773743,300.315918 
z"/>
<path fill="#050E18" opacity="1.000000" stroke="none" 
	d="
M200.625412,300.000488 
	C201.250183,303.020599 203.905472,305.168274 203.994507,308.623413 
	C201.957870,308.999786 199.915726,309.000793 197.435883,309.000305 
	C197.785583,305.619446 194.718948,303.601349 194.036469,300.364716 
	C195.064880,300.001343 196.133499,300.000244 197.602875,299.998352 
	C198.752716,299.998291 199.501770,299.999023 200.625412,300.000488 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M282.783508,357.795837 
	C283.622314,358.479401 284.092010,358.991119 284.304077,359.766571 
	C283.378265,359.585815 282.710022,359.141357 281.912720,358.417969 
	C281.993896,357.967377 282.204163,357.795685 282.783508,357.795837 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M284.059937,360.184113 
	C284.283875,360.074341 284.607239,360.195831 284.947021,360.651123 
	C284.695374,360.795044 284.427368,360.605194 284.059937,360.184113 
z"/>
<path fill="#020406" opacity="1.000000" stroke="none" 
	d="
M283.045044,357.717163 
	C282.924500,357.996063 282.696350,358.024445 282.125916,358.095947 
	C281.666168,357.907043 281.548676,357.675049 281.728271,357.190186 
	C282.329437,357.113770 282.633423,357.290222 283.045044,357.717163 
z"/>
<path fill="#413C3F" opacity="1.000000" stroke="none" 
	d="
M406.465179,174.945221 
	C407.086029,174.970032 407.282013,174.985962 407.772278,175.022125 
	C410.750671,177.868744 413.076355,181.023575 416.168060,183.481812 
	C417.673401,184.678741 418.322021,186.346893 416.820984,188.479965 
	C415.132019,189.299149 413.787079,189.310028 412.082214,188.436768 
	C411.045959,188.240692 410.385040,188.235855 409.394989,188.248703 
	C406.510223,185.141449 403.979279,181.995758 401.383698,178.904312 
	C400.614624,177.988281 399.952118,177.096161 400.045166,175.485809 
	C402.050293,175.067673 404.045319,175.001999 406.465179,174.945221 
z"/>
<path fill="#5B595B" opacity="1.000000" stroke="none" 
	d="
M411.682190,188.573639 
	C413.195099,188.144958 414.683289,188.044388 416.611694,187.909576 
	C418.165527,186.949005 419.433258,186.765106 421.148956,187.233093 
	C421.923248,187.649521 422.357269,188.195999 422.101837,188.537201 
	C420.317993,190.920227 420.225372,191.360916 421.231140,193.955139 
	C419.927643,195.044937 418.913483,196.124741 417.132019,195.215088 
	C413.172821,193.003372 408.387451,194.463058 405.042725,191.372314 
	C407.014679,190.207077 409.792328,190.762329 411.682190,188.573639 
z"/>
<path fill="#413C3F" opacity="1.000000" stroke="none" 
	d="
M421.380859,194.121033 
	C420.994995,192.189651 419.650421,191.954178 418.049164,191.956253 
	C416.856079,191.957809 415.510406,191.588943 415.532562,190.261322 
	C415.560028,188.616501 417.168182,189.177383 418.189362,189.012909 
	C419.290619,188.835541 420.397034,188.690338 421.756531,188.241272 
	C421.868927,186.917435 422.493439,186.628677 423.681152,186.777557 
	C426.727295,186.491547 426.977631,188.705948 427.863770,190.707825 
	C427.431427,191.506836 426.861145,191.972076 426.114410,192.655334 
	C424.537720,193.258362 423.137421,193.643356 421.380859,194.121033 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M441.619995,205.004883 
	C444.669769,209.681519 448.692169,213.189072 452.446472,216.922134 
	C454.007233,218.474075 455.373291,220.102509 455.973633,222.631714 
	C448.194641,221.329880 443.779907,215.334213 439.171997,209.652039 
	C437.041687,207.025116 438.050598,205.441956 441.619995,205.004883 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M440.686890,200.138153 
	C442.209808,200.824265 441.954163,202.091248 442.000916,203.630478 
	C440.331299,203.818649 438.003693,204.640106 437.530975,202.278168 
	C437.188538,200.567291 439.545380,201.180710 440.686890,200.138153 
z"/>
<path fill="#393C40" opacity="1.000000" stroke="none" 
	d="
M386.822266,166.558838 
	C387.309204,166.040421 387.551331,165.813782 387.944336,165.390564 
	C389.423859,163.496658 391.236603,162.707733 393.671448,162.536316 
	C395.299530,167.015991 400.018097,168.950943 401.237488,173.509277 
	C397.691803,173.828949 394.350433,173.841293 390.559570,173.806396 
	C387.737335,172.065994 385.759857,170.170624 386.822266,166.558838 
z"/>
<path fill="#2D2F36" opacity="1.000000" stroke="none" 
	d="
M401.455902,173.871704 
	C400.957733,171.794968 399.169922,171.326935 397.941162,170.298447 
	C395.798279,168.504822 393.546265,166.696640 393.863525,162.998932 
	C393.929413,162.372437 394.043610,162.151306 394.531067,161.935913 
	C395.341278,161.949432 395.778229,161.957199 396.541077,161.953003 
	C399.165283,166.864197 404.527985,168.527390 407.953552,172.647766 
	C407.687958,173.097229 407.424377,173.288452 407.107300,173.779449 
	C405.290436,173.975601 403.584534,173.951187 401.455902,173.871704 
z"/>
<path fill="#534F51" opacity="1.000000" stroke="none" 
	d="
M386.741608,166.316620 
	C386.719666,169.104797 388.893463,170.873413 390.033813,173.434814 
	C387.022858,172.968262 383.179016,174.425400 381.010254,170.340866 
	C382.768982,168.763565 384.590912,167.563126 386.741608,166.316620 
z"/>
<path fill="#7AAABF" opacity="1.000000" stroke="none" 
	d="
M394.807953,161.688232 
	C394.623474,162.015640 394.359894,162.129639 393.964417,162.438599 
	C392.133057,163.401627 390.450928,164.209717 388.430359,165.104156 
	C387.871155,164.877594 387.650330,164.564697 387.174347,164.112701 
	C388.494019,163.179413 390.068878,162.385178 391.827942,161.318665 
	C392.433350,160.981003 392.854553,160.915634 393.587830,160.780975 
	C394.170471,160.952728 394.441010,161.193771 394.807953,161.688232 
z"/>
<path fill="#455662" opacity="1.000000" stroke="none" 
	d="
M353.195526,139.979248 
	C353.286316,139.578979 353.432922,139.476532 353.518738,139.454742 
	C353.571320,140.134140 353.538147,140.835312 353.229797,141.771362 
	C353.004639,141.464005 353.054688,140.921753 353.195526,139.979248 
z"/>
<path fill="#201B1D" opacity="1.000000" stroke="none" 
	d="
M381.004272,150.399887 
	C384.125824,150.559647 382.617401,153.682373 383.957092,155.621124 
	C380.539307,155.681259 381.059174,153.073654 381.004272,150.399887 
z"/>
<path fill="#44454A" opacity="1.000000" stroke="none" 
	d="
M378.446655,152.539520 
	C378.412231,152.480560 378.481110,152.598465 378.446655,152.539520 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M428.956848,418.303040 
	C429.324005,418.454895 429.666595,418.929138 430.008301,419.713806 
	C429.261353,419.855988 429.029205,419.292694 428.956848,418.303040 
z"/>
<path fill="#094C8C" opacity="1.000000" stroke="none" 
	d="
M420.789734,419.066528 
	C421.024628,419.378723 421.028320,419.846771 421.024048,420.665222 
	C420.306000,420.560120 419.984131,420.005554 420.789734,419.066528 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M456.262360,441.950745 
	C456.195099,441.750366 456.375366,441.475616 456.789673,441.108337 
	C456.852448,441.302673 456.681183,441.589508 456.262360,441.950745 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M450.279907,442.782593 
	C450.202850,442.399536 450.366913,441.860138 450.776611,441.165161 
	C450.855194,441.548431 450.688141,442.087341 450.279907,442.782593 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M463.247864,423.855408 
	C463.167480,423.456146 463.346130,422.896545 463.766235,422.162170 
	C463.840759,422.556610 463.673798,423.125824 463.247864,423.855408 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M446.713928,424.976624 
	C447.024261,425.141785 447.021393,425.310547 447.001740,425.731689 
	C446.253296,425.832672 445.521698,425.681213 444.790070,425.529724 
	C445.326996,425.346588 445.863892,425.163422 446.713928,424.976624 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M244.755005,442.394836 
	C245.788666,440.837738 246.621902,439.596436 247.713226,438.162781 
	C248.261917,438.184296 248.552551,438.398102 248.978882,438.852112 
	C249.084488,439.517456 249.054413,439.942505 249.021332,440.687805 
	C248.656235,441.485443 248.294128,441.962860 247.977875,442.760132 
	C248.023697,443.079987 247.992584,443.033295 248.019180,443.024902 
	C247.768127,443.193390 247.527390,443.411072 247.168610,443.858521 
	C247.013702,444.047455 247.009125,443.994598 247.030243,444.010681 
	C246.844666,444.165680 246.637970,444.304596 246.057312,444.440308 
	C244.905533,444.124146 244.532806,443.546356 244.755005,442.394836 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M245.137070,446.982819 
	C244.474976,449.987366 242.683289,451.976135 240.309830,453.928101 
	C236.093552,451.865784 240.621567,450.474030 240.784668,448.292480 
	C240.994843,447.961456 241.004654,448.004425 240.982971,448.000488 
	C241.893921,447.470917 242.672302,446.676331 244.073822,446.411957 
	C244.600662,446.512024 244.800781,446.598694 245.137070,446.982819 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M240.725128,448.104187 
	C241.868790,450.217407 238.786087,451.452148 239.772797,453.888977 
	C239.320923,455.037323 238.617111,455.968872 237.625244,456.977966 
	C237.109787,456.949066 236.882416,456.842682 236.454803,456.416931 
	C235.979584,455.376312 236.018143,454.625153 236.067963,453.503662 
	C236.213455,452.093781 236.723618,451.271820 237.767273,450.344055 
	C238.841965,449.476227 239.648697,448.861572 240.725128,448.104187 
z"/>
<path fill="#0B71BE" opacity="1.000000" stroke="none" 
	d="
M252.179047,457.830383 
	C251.877899,459.282166 251.588165,460.373260 250.169724,460.583313 
	C249.933365,460.618378 249.422272,460.313690 249.416443,460.152344 
	C249.365265,458.734680 249.951401,457.660980 251.634277,457.025513 
	C251.959167,456.961090 251.997177,456.997772 252.015961,457.016327 
	C252.147415,457.215454 252.260056,457.395996 252.179047,457.830383 
z"/>
<path fill="#072B4E" opacity="1.000000" stroke="none" 
	d="
M236.651001,455.953552 
	C237.012589,456.275452 237.050858,456.441406 237.213150,456.831421 
	C237.054932,457.946838 236.627167,458.719360 235.365616,459.179047 
	C234.990662,459.046448 234.938187,458.808960 234.835098,458.210175 
	C234.656815,456.682098 235.302521,456.097107 236.651001,455.953552 
z"/>
<path fill="#033B5F" opacity="1.000000" stroke="none" 
	d="
M244.685394,455.893555 
	C245.155762,455.839081 245.329865,455.881989 245.771088,455.958191 
	C245.309250,456.689209 244.580276,457.386841 243.553436,458.175293 
	C243.090485,458.227295 242.925415,458.188477 242.702652,457.901917 
	C243.226364,457.099762 243.807739,456.545349 244.685394,455.893555 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M245.821289,444.188263 
	C246.217651,444.012756 246.384460,444.007812 246.801331,444.014832 
	C246.896820,444.644073 246.742279,445.261383 246.345917,446.099609 
	C245.944839,446.214172 245.785583,446.107880 245.517212,445.735718 
	C245.370026,445.083099 245.425842,444.711884 245.821289,444.188263 
z"/>
<path fill="#0B2743" opacity="1.000000" stroke="none" 
	d="
M247.294571,444.025604 
	C247.175888,443.730164 247.338058,443.412842 247.773010,443.056030 
	C247.889008,443.345612 247.732224,443.674683 247.294571,444.025604 
z"/>
<path fill="#054D89" opacity="1.000000" stroke="none" 
	d="
M246.040283,446.218567 
	C246.016861,446.604523 245.859314,446.841949 245.452377,447.156525 
	C245.273254,447.280273 245.076965,447.070892 244.980103,446.965027 
	C244.941956,446.635376 245.000671,446.411621 245.400681,446.125336 
	C245.741989,446.062805 245.976440,446.116608 246.040283,446.218567 
z"/>
<path fill="#033B5F" opacity="1.000000" stroke="none" 
	d="
M241.821045,459.018951 
	C241.876816,458.929688 241.828857,459.999084 241.821045,459.018951 
z"/>
<path fill="#033B5F" opacity="1.000000" stroke="none" 
	d="
M241.994049,458.994019 
	C242.077698,458.662262 242.166382,458.335663 242.450012,457.831604 
	C242.644974,457.654175 242.950882,457.957031 243.103241,458.111603 
	C243.004654,458.483521 242.753738,458.700897 242.254684,458.961975 
	C242.006561,459.005707 241.999084,458.999146 241.994049,458.994019 
z"/>
<path fill="#054881" opacity="1.000000" stroke="none" 
	d="
M252.234268,457.981079 
	C251.990494,457.909027 251.995621,457.733856 252.017761,457.296783 
	C252.034760,457.034882 252.532211,457.002930 252.781525,456.994080 
	C252.848282,457.282806 252.665726,457.580414 252.234268,457.981079 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M204.749573,411.991028 
	C204.993073,413.244110 204.993073,414.492859 204.993073,415.795197 
	C203.443100,415.553864 204.326294,414.067352 203.319199,413.337891 
	C203.226898,412.852509 203.382629,412.547424 203.771332,412.122894 
	C204.171555,411.997864 204.338821,411.992249 204.749573,411.991028 
z"/>
<path fill="#14476E" opacity="1.000000" stroke="none" 
	d="
M195.845398,405.838531 
	C195.283890,406.692963 194.636459,406.807343 194.353043,406.122772 
	C194.179581,405.703827 194.418442,404.721222 194.740051,404.572998 
	C195.384918,404.275665 195.787308,404.874847 195.845398,405.838531 
z"/>
<path fill="#11547D" opacity="1.000000" stroke="none" 
	d="
M213.781494,427.031982 
	C213.852142,427.554901 213.696304,428.126770 213.283173,428.871063 
	C212.889206,428.835846 212.752518,428.628204 212.785522,428.088501 
	C213.052368,427.440033 213.252304,427.214844 213.781494,427.031982 
z"/>
<path fill="#11547D" opacity="1.000000" stroke="none" 
	d="
M215.709534,425.965729 
	C215.547806,426.338440 215.074173,426.694000 214.291199,427.028381 
	C214.453766,426.654327 214.925705,426.301453 215.709534,425.965729 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M211.753220,429.038300 
	C211.865616,429.310822 211.713135,429.646637 211.268173,429.998779 
	C211.146591,429.710602 211.317474,429.406097 211.753220,429.038300 
z"/>
<path fill="#0A669C" opacity="1.000000" stroke="none" 
	d="
M212.721741,427.908142 
	C212.968536,427.970795 212.981903,428.185089 213.010559,428.721466 
	C212.849060,429.083649 212.672241,429.123810 212.234375,429.087524 
	C212.144989,428.694031 212.316650,428.376923 212.721741,427.908142 
z"/>
<path fill="#11547D" opacity="1.000000" stroke="none" 
	d="
M216.759613,425.048706 
	C216.831329,425.256134 216.642242,425.536224 216.215714,425.917603 
	C216.151779,425.719757 216.325302,425.420563 216.759613,425.048706 
z"/>
<path fill="#11547D" opacity="1.000000" stroke="none" 
	d="
M217.745667,424.080444 
	C217.810013,424.275146 217.626526,424.549835 217.209503,424.922455 
	C217.149948,424.733734 217.323898,424.447052 217.745667,424.080444 
z"/>
<path fill="#0A3252" opacity="1.000000" stroke="none" 
	d="
M205.004013,412.004028 
	C205.112701,411.547150 205.217697,411.086517 205.322693,410.625885 
	C206.047241,410.935974 205.708542,411.344849 205.210037,411.871887 
	C204.993073,411.995361 205.000305,412.000244 205.004013,412.004028 
z"/>
<path fill="#067DC6" opacity="1.000000" stroke="none" 
	d="
M236.987122,455.712280 
	C236.352966,456.529816 235.731598,456.950134 234.947357,457.609680 
	C233.970093,458.064697 234.144547,459.934601 232.771713,459.122772 
	C232.074707,458.710571 232.382736,458.044006 232.877136,457.248505 
	C233.669769,455.937897 234.331314,454.867645 235.052353,453.487061 
	C235.111847,453.176727 235.134903,453.140228 235.149750,453.125122 
	C235.477310,452.703583 235.894791,452.522552 236.705627,452.734680 
	C237.006073,453.728119 237.002975,454.521576 236.987122,455.712280 
z"/>
<path fill="#0B75AF" opacity="1.000000" stroke="none" 
	d="
M228.964722,462.687134 
	C228.090363,462.065765 228.269104,461.514771 228.931885,461.243225 
	C229.271622,461.104034 230.057785,461.231903 230.141785,461.440552 
	C230.430084,462.156677 229.810913,462.461853 228.964722,462.687134 
z"/>
<path fill="#0866AF" opacity="1.000000" stroke="none" 
	d="
M245.820068,445.725494 
	C245.452271,446.102264 245.232391,446.247528 244.982803,446.678894 
	C243.806427,447.226593 242.729584,447.594025 241.307037,447.979004 
	C241.240875,447.507538 241.520447,447.018524 241.901825,446.266602 
	C242.743835,445.034790 243.159058,443.959686 243.046722,442.370026 
	C243.447845,442.053864 243.878159,442.089417 244.631958,442.102020 
	C245.157913,442.614960 245.360413,443.150818 245.806885,443.852173 
	C245.999939,444.474518 245.949051,444.931335 245.820068,445.725494 
z"/>
<path fill="#065B9B" opacity="1.000000" stroke="none" 
	d="
M237.131653,452.654419 
	C236.598511,452.981140 236.187851,453.027679 235.470917,453.092102 
	C235.116501,452.636047 235.068405,452.162048 234.993958,451.332153 
	C235.440826,450.669861 235.914047,450.363495 236.676788,450.007935 
	C237.144669,449.978088 237.323013,449.997498 237.768280,450.053894 
	C237.774857,450.851990 237.514511,451.613129 237.131653,452.654419 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M444.747253,203.359833 
	C444.990692,203.374527 445.123260,203.505081 445.255829,203.635620 
	C445.049347,203.582321 444.842834,203.529022 444.747253,203.359833 
z"/>
<path fill="#352F31" opacity="1.000000" stroke="none" 
	d="
M423.954041,186.651001 
	C423.457214,187.150787 422.906219,187.315704 422.183533,187.716034 
	C420.632355,187.946396 419.252838,187.941345 417.462585,187.905807 
	C417.192139,185.821518 416.030151,184.758972 414.445312,183.583435 
	C411.710876,181.555145 409.021576,179.309631 408.078735,175.391144 
	C409.799438,174.725098 411.532318,174.407852 413.646057,174.058380 
	C416.231201,178.995758 420.644684,182.190674 423.954041,186.651001 
z"/>
</svg>`;
